/*!
  * Bootstrap v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).bootstrap=e()}(this,(function(){"use strict";const t="transitionend",e=t=>{let e=t.getAttribute("data-bs-target");if(!e||"#"===e){let i=t.getAttribute("href");if(!i||!i.includes("#")&&!i.startsWith("."))return null;i.includes("#")&&!i.startsWith("#")&&(i=`#${i.split("#")[1]}`),e=i&&"#"!==i?i.trim():null}return e},i=t=>{const i=e(t);return i&&document.querySelector(i)?i:null},n=t=>{const i=e(t);return i?document.querySelector(i):null},s=e=>{e.dispatchEvent(new Event(t))},o=t=>!(!t||"object"!=typeof t)&&(void 0!==t.jquery&&(t=t[0]),void 0!==t.nodeType),r=t=>o(t)?t.jquery?t[0]:t:"string"==typeof t&&t.length>0?document.querySelector(t):null,a=(t,e,i)=>{Object.keys(i).forEach((n=>{const s=i[n],r=e[n],a=r&&o(r)?"element":null==(l=r)?`${l}`:{}.toString.call(l).match(/\s([a-z]+)/i)[1].toLowerCase();var l;if(!new RegExp(s).test(a))throw new TypeError(`${t.toUpperCase()}: Option "${n}" provided type "${a}" but expected type "${s}".`)}))},l=t=>!(!o(t)||0===t.getClientRects().length)&&"visible"===getComputedStyle(t).getPropertyValue("visibility"),c=t=>!t||t.nodeType!==Node.ELEMENT_NODE||!!t.classList.contains("disabled")||(void 0!==t.disabled?t.disabled:t.hasAttribute("disabled")&&"false"!==t.getAttribute("disabled")),h=t=>{if(!document.documentElement.attachShadow)return null;if("function"==typeof t.getRootNode){const e=t.getRootNode();return e instanceof ShadowRoot?e:null}return t instanceof ShadowRoot?t:t.parentNode?h(t.parentNode):null},d=()=>{},u=t=>{t.offsetHeight},f=()=>{const{jQuery:t}=window;return t&&!document.body.hasAttribute("data-bs-no-jquery")?t:null},p=[],m=()=>"rtl"===document.documentElement.dir,g=t=>{var e;e=()=>{const e=f();if(e){const i=t.NAME,n=e.fn[i];e.fn[i]=t.jQueryInterface,e.fn[i].Constructor=t,e.fn[i].noConflict=()=>(e.fn[i]=n,t.jQueryInterface)}},"loading"===document.readyState?(p.length||document.addEventListener("DOMContentLoaded",(()=>{p.forEach((t=>t()))})),p.push(e)):e()},_=t=>{"function"==typeof t&&t()},b=(e,i,n=!0)=>{if(!n)return void _(e);const o=(t=>{if(!t)return 0;let{transitionDuration:e,transitionDelay:i}=window.getComputedStyle(t);const n=Number.parseFloat(e),s=Number.parseFloat(i);return n||s?(e=e.split(",")[0],i=i.split(",")[0],1e3*(Number.parseFloat(e)+Number.parseFloat(i))):0})(i)+5;let r=!1;const a=({target:n})=>{n===i&&(r=!0,i.removeEventListener(t,a),_(e))};i.addEventListener(t,a),setTimeout((()=>{r||s(i)}),o)},v=(t,e,i,n)=>{let s=t.indexOf(e);if(-1===s)return t[!i&&n?t.length-1:0];const o=t.length;return s+=i?1:-1,n&&(s=(s+o)%o),t[Math.max(0,Math.min(s,o-1))]},y=/[^.]*(?=\..*)\.|.*/,w=/\..*/,E=/::\d+$/,A={};let T=1;const O={mouseenter:"mouseover",mouseleave:"mouseout"},C=/^(mouseenter|mouseleave)/i,k=new Set(["click","dblclick","mouseup","mousedown","contextmenu","mousewheel","DOMMouseScroll","mouseover","mouseout","mousemove","selectstart","selectend","keydown","keypress","keyup","orientationchange","touchstart","touchmove","touchend","touchcancel","pointerdown","pointermove","pointerup","pointerleave","pointercancel","gesturestart","gesturechange","gestureend","focus","blur","change","reset","select","submit","focusin","focusout","load","unload","beforeunload","resize","move","DOMContentLoaded","readystatechange","error","abort","scroll"]);function L(t,e){return e&&`${e}::${T++}`||t.uidEvent||T++}function x(t){const e=L(t);return t.uidEvent=e,A[e]=A[e]||{},A[e]}function D(t,e,i=null){const n=Object.keys(t);for(let s=0,o=n.length;s<o;s++){const o=t[n[s]];if(o.originalHandler===e&&o.delegationSelector===i)return o}return null}function S(t,e,i){const n="string"==typeof e,s=n?i:e;let o=P(t);return k.has(o)||(o=t),[n,s,o]}function N(t,e,i,n,s){if("string"!=typeof e||!t)return;if(i||(i=n,n=null),C.test(e)){const t=t=>function(e){if(!e.relatedTarget||e.relatedTarget!==e.delegateTarget&&!e.delegateTarget.contains(e.relatedTarget))return t.call(this,e)};n?n=t(n):i=t(i)}const[o,r,a]=S(e,i,n),l=x(t),c=l[a]||(l[a]={}),h=D(c,r,o?i:null);if(h)return void(h.oneOff=h.oneOff&&s);const d=L(r,e.replace(y,"")),u=o?function(t,e,i){return function n(s){const o=t.querySelectorAll(e);for(let{target:r}=s;r&&r!==this;r=r.parentNode)for(let a=o.length;a--;)if(o[a]===r)return s.delegateTarget=r,n.oneOff&&j.off(t,s.type,e,i),i.apply(r,[s]);return null}}(t,i,n):function(t,e){return function i(n){return n.delegateTarget=t,i.oneOff&&j.off(t,n.type,e),e.apply(t,[n])}}(t,i);u.delegationSelector=o?i:null,u.originalHandler=r,u.oneOff=s,u.uidEvent=d,c[d]=u,t.addEventListener(a,u,o)}function I(t,e,i,n,s){const o=D(e[i],n,s);o&&(t.removeEventListener(i,o,Boolean(s)),delete e[i][o.uidEvent])}function P(t){return t=t.replace(w,""),O[t]||t}const j={on(t,e,i,n){N(t,e,i,n,!1)},one(t,e,i,n){N(t,e,i,n,!0)},off(t,e,i,n){if("string"!=typeof e||!t)return;const[s,o,r]=S(e,i,n),a=r!==e,l=x(t),c=e.startsWith(".");if(void 0!==o){if(!l||!l[r])return;return void I(t,l,r,o,s?i:null)}c&&Object.keys(l).forEach((i=>{!function(t,e,i,n){const s=e[i]||{};Object.keys(s).forEach((o=>{if(o.includes(n)){const n=s[o];I(t,e,i,n.originalHandler,n.delegationSelector)}}))}(t,l,i,e.slice(1))}));const h=l[r]||{};Object.keys(h).forEach((i=>{const n=i.replace(E,"");if(!a||e.includes(n)){const e=h[i];I(t,l,r,e.originalHandler,e.delegationSelector)}}))},trigger(t,e,i){if("string"!=typeof e||!t)return null;const n=f(),s=P(e),o=e!==s,r=k.has(s);let a,l=!0,c=!0,h=!1,d=null;return o&&n&&(a=n.Event(e,i),n(t).trigger(a),l=!a.isPropagationStopped(),c=!a.isImmediatePropagationStopped(),h=a.isDefaultPrevented()),r?(d=document.createEvent("HTMLEvents"),d.initEvent(s,l,!0)):d=new CustomEvent(e,{bubbles:l,cancelable:!0}),void 0!==i&&Object.keys(i).forEach((t=>{Object.defineProperty(d,t,{get:()=>i[t]})})),h&&d.preventDefault(),c&&t.dispatchEvent(d),d.defaultPrevented&&void 0!==a&&a.preventDefault(),d}},M=new Map,H={set(t,e,i){M.has(t)||M.set(t,new Map);const n=M.get(t);n.has(e)||0===n.size?n.set(e,i):console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(n.keys())[0]}.`)},get:(t,e)=>M.has(t)&&M.get(t).get(e)||null,remove(t,e){if(!M.has(t))return;const i=M.get(t);i.delete(e),0===i.size&&M.delete(t)}};class B{constructor(t){(t=r(t))&&(this._element=t,H.set(this._element,this.constructor.DATA_KEY,this))}dispose(){H.remove(this._element,this.constructor.DATA_KEY),j.off(this._element,this.constructor.EVENT_KEY),Object.getOwnPropertyNames(this).forEach((t=>{this[t]=null}))}_queueCallback(t,e,i=!0){b(t,e,i)}static getInstance(t){return H.get(r(t),this.DATA_KEY)}static getOrCreateInstance(t,e={}){return this.getInstance(t)||new this(t,"object"==typeof e?e:null)}static get VERSION(){return"5.1.3"}static get NAME(){throw new Error('You have to implement the static method "NAME", for each component!')}static get DATA_KEY(){return`bs.${this.NAME}`}static get EVENT_KEY(){return`.${this.DATA_KEY}`}}const R=(t,e="hide")=>{const i=`click.dismiss${t.EVENT_KEY}`,s=t.NAME;j.on(document,i,`[data-bs-dismiss="${s}"]`,(function(i){if(["A","AREA"].includes(this.tagName)&&i.preventDefault(),c(this))return;const o=n(this)||this.closest(`.${s}`);t.getOrCreateInstance(o)[e]()}))};class W extends B{static get NAME(){return"alert"}close(){if(j.trigger(this._element,"close.bs.alert").defaultPrevented)return;this._element.classList.remove("show");const t=this._element.classList.contains("fade");this._queueCallback((()=>this._destroyElement()),this._element,t)}_destroyElement(){this._element.remove(),j.trigger(this._element,"closed.bs.alert"),this.dispose()}static jQueryInterface(t){return this.each((function(){const e=W.getOrCreateInstance(this);if("string"==typeof t){if(void 0===e[t]||t.startsWith("_")||"constructor"===t)throw new TypeError(`No method named "${t}"`);e[t](this)}}))}}R(W,"close"),g(W);const $='[data-bs-toggle="button"]';class z extends B{static get NAME(){return"button"}toggle(){this._element.setAttribute("aria-pressed",this._element.classList.toggle("active"))}static jQueryInterface(t){return this.each((function(){const e=z.getOrCreateInstance(this);"toggle"===t&&e[t]()}))}}function q(t){return"true"===t||"false"!==t&&(t===Number(t).toString()?Number(t):""===t||"null"===t?null:t)}function F(t){return t.replace(/[A-Z]/g,(t=>`-${t.toLowerCase()}`))}j.on(document,"click.bs.button.data-api",$,(t=>{t.preventDefault();const e=t.target.closest($);z.getOrCreateInstance(e).toggle()})),g(z);const U={setDataAttribute(t,e,i){t.setAttribute(`data-bs-${F(e)}`,i)},removeDataAttribute(t,e){t.removeAttribute(`data-bs-${F(e)}`)},getDataAttributes(t){if(!t)return{};const e={};return Object.keys(t.dataset).filter((t=>t.startsWith("bs"))).forEach((i=>{let n=i.replace(/^bs/,"");n=n.charAt(0).toLowerCase()+n.slice(1,n.length),e[n]=q(t.dataset[i])})),e},getDataAttribute:(t,e)=>q(t.getAttribute(`data-bs-${F(e)}`)),offset(t){const e=t.getBoundingClientRect();return{top:e.top+window.pageYOffset,left:e.left+window.pageXOffset}},position:t=>({top:t.offsetTop,left:t.offsetLeft})},V={find:(t,e=document.documentElement)=>[].concat(...Element.prototype.querySelectorAll.call(e,t)),findOne:(t,e=document.documentElement)=>Element.prototype.querySelector.call(e,t),children:(t,e)=>[].concat(...t.children).filter((t=>t.matches(e))),parents(t,e){const i=[];let n=t.parentNode;for(;n&&n.nodeType===Node.ELEMENT_NODE&&3!==n.nodeType;)n.matches(e)&&i.push(n),n=n.parentNode;return i},prev(t,e){let i=t.previousElementSibling;for(;i;){if(i.matches(e))return[i];i=i.previousElementSibling}return[]},next(t,e){let i=t.nextElementSibling;for(;i;){if(i.matches(e))return[i];i=i.nextElementSibling}return[]},focusableChildren(t){const e=["a","button","input","textarea","select","details","[tabindex]",'[contenteditable="true"]'].map((t=>`${t}:not([tabindex^="-"])`)).join(", ");return this.find(e,t).filter((t=>!c(t)&&l(t)))}},K="carousel",X={interval:5e3,keyboard:!0,slide:!1,pause:"hover",wrap:!0,touch:!0},Y={interval:"(number|boolean)",keyboard:"boolean",slide:"(boolean|string)",pause:"(string|boolean)",wrap:"boolean",touch:"boolean"},Q="next",G="prev",Z="left",J="right",tt={ArrowLeft:J,ArrowRight:Z},et="slid.bs.carousel",it="active",nt=".active.carousel-item";class st extends B{constructor(t,e){super(t),this._items=null,this._interval=null,this._activeElement=null,this._isPaused=!1,this._isSliding=!1,this.touchTimeout=null,this.touchStartX=0,this.touchDeltaX=0,this._config=this._getConfig(e),this._indicatorsElement=V.findOne(".carousel-indicators",this._element),this._touchSupported="ontouchstart"in document.documentElement||navigator.maxTouchPoints>0,this._pointerEvent=Boolean(window.PointerEvent),this._addEventListeners()}static get Default(){return X}static get NAME(){return K}next(){this._slide(Q)}nextWhenVisible(){!document.hidden&&l(this._element)&&this.next()}prev(){this._slide(G)}pause(t){t||(this._isPaused=!0),V.findOne(".carousel-item-next, .carousel-item-prev",this._element)&&(s(this._element),this.cycle(!0)),clearInterval(this._interval),this._interval=null}cycle(t){t||(this._isPaused=!1),this._interval&&(clearInterval(this._interval),this._interval=null),this._config&&this._config.interval&&!this._isPaused&&(this._updateInterval(),this._interval=setInterval((document.visibilityState?this.nextWhenVisible:this.next).bind(this),this._config.interval))}to(t){this._activeElement=V.findOne(nt,this._element);const e=this._getItemIndex(this._activeElement);if(t>this._items.length-1||t<0)return;if(this._isSliding)return void j.one(this._element,et,(()=>this.to(t)));if(e===t)return this.pause(),void this.cycle();const i=t>e?Q:G;this._slide(i,this._items[t])}_getConfig(t){return t={...X,...U.getDataAttributes(this._element),..."object"==typeof t?t:{}},a(K,t,Y),t}_handleSwipe(){const t=Math.abs(this.touchDeltaX);if(t<=40)return;const e=t/this.touchDeltaX;this.touchDeltaX=0,e&&this._slide(e>0?J:Z)}_addEventListeners(){this._config.keyboard&&j.on(this._element,"keydown.bs.carousel",(t=>this._keydown(t))),"hover"===this._config.pause&&(j.on(this._element,"mouseenter.bs.carousel",(t=>this.pause(t))),j.on(this._element,"mouseleave.bs.carousel",(t=>this.cycle(t)))),this._config.touch&&this._touchSupported&&this._addTouchEventListeners()}_addTouchEventListeners(){const t=t=>this._pointerEvent&&("pen"===t.pointerType||"touch"===t.pointerType),e=e=>{t(e)?this.touchStartX=e.clientX:this._pointerEvent||(this.touchStartX=e.touches[0].clientX)},i=t=>{this.touchDeltaX=t.touches&&t.touches.length>1?0:t.touches[0].clientX-this.touchStartX},n=e=>{t(e)&&(this.touchDeltaX=e.clientX-this.touchStartX),this._handleSwipe(),"hover"===this._config.pause&&(this.pause(),this.touchTimeout&&clearTimeout(this.touchTimeout),this.touchTimeout=setTimeout((t=>this.cycle(t)),500+this._config.interval))};V.find(".carousel-item img",this._element).forEach((t=>{j.on(t,"dragstart.bs.carousel",(t=>t.preventDefault()))})),this._pointerEvent?(j.on(this._element,"pointerdown.bs.carousel",(t=>e(t))),j.on(this._element,"pointerup.bs.carousel",(t=>n(t))),this._element.classList.add("pointer-event")):(j.on(this._element,"touchstart.bs.carousel",(t=>e(t))),j.on(this._element,"touchmove.bs.carousel",(t=>i(t))),j.on(this._element,"touchend.bs.carousel",(t=>n(t))))}_keydown(t){if(/input|textarea/i.test(t.target.tagName))return;const e=tt[t.key];e&&(t.preventDefault(),this._slide(e))}_getItemIndex(t){return this._items=t&&t.parentNode?V.find(".carousel-item",t.parentNode):[],this._items.indexOf(t)}_getItemByOrder(t,e){const i=t===Q;return v(this._items,e,i,this._config.wrap)}_triggerSlideEvent(t,e){const i=this._getItemIndex(t),n=this._getItemIndex(V.findOne(nt,this._element));return j.trigger(this._element,"slide.bs.carousel",{relatedTarget:t,direction:e,from:n,to:i})}_setActiveIndicatorElement(t){if(this._indicatorsElement){const e=V.findOne(".active",this._indicatorsElement);e.classList.remove(it),e.removeAttribute("aria-current");const i=V.find("[data-bs-target]",this._indicatorsElement);for(let e=0;e<i.length;e++)if(Number.parseInt(i[e].getAttribute("data-bs-slide-to"),10)===this._getItemIndex(t)){i[e].classList.add(it),i[e].setAttribute("aria-current","true");break}}}_updateInterval(){const t=this._activeElement||V.findOne(nt,this._element);if(!t)return;const e=Number.parseInt(t.getAttribute("data-bs-interval"),10);e?(this._config.defaultInterval=this._config.defaultInterval||this._config.interval,this._config.interval=e):this._config.interval=this._config.defaultInterval||this._config.interval}_slide(t,e){const i=this._directionToOrder(t),n=V.findOne(nt,this._element),s=this._getItemIndex(n),o=e||this._getItemByOrder(i,n),r=this._getItemIndex(o),a=Boolean(this._interval),l=i===Q,c=l?"carousel-item-start":"carousel-item-end",h=l?"carousel-item-next":"carousel-item-prev",d=this._orderToDirection(i);if(o&&o.classList.contains(it))return void(this._isSliding=!1);if(this._isSliding)return;if(this._triggerSlideEvent(o,d).defaultPrevented)return;if(!n||!o)return;this._isSliding=!0,a&&this.pause(),this._setActiveIndicatorElement(o),this._activeElement=o;const f=()=>{j.trigger(this._element,et,{relatedTarget:o,direction:d,from:s,to:r})};if(this._element.classList.contains("slide")){o.classList.add(h),u(o),n.classList.add(c),o.classList.add(c);const t=()=>{o.classList.remove(c,h),o.classList.add(it),n.classList.remove(it,h,c),this._isSliding=!1,setTimeout(f,0)};this._queueCallback(t,n,!0)}else n.classList.remove(it),o.classList.add(it),this._isSliding=!1,f();a&&this.cycle()}_directionToOrder(t){return[J,Z].includes(t)?m()?t===Z?G:Q:t===Z?Q:G:t}_orderToDirection(t){return[Q,G].includes(t)?m()?t===G?Z:J:t===G?J:Z:t}static carouselInterface(t,e){const i=st.getOrCreateInstance(t,e);let{_config:n}=i;"object"==typeof e&&(n={...n,...e});const s="string"==typeof e?e:n.slide;if("number"==typeof e)i.to(e);else if("string"==typeof s){if(void 0===i[s])throw new TypeError(`No method named "${s}"`);i[s]()}else n.interval&&n.ride&&(i.pause(),i.cycle())}static jQueryInterface(t){return this.each((function(){st.carouselInterface(this,t)}))}static dataApiClickHandler(t){const e=n(this);if(!e||!e.classList.contains("carousel"))return;const i={...U.getDataAttributes(e),...U.getDataAttributes(this)},s=this.getAttribute("data-bs-slide-to");s&&(i.interval=!1),st.carouselInterface(e,i),s&&st.getInstance(e).to(s),t.preventDefault()}}j.on(document,"click.bs.carousel.data-api","[data-bs-slide], [data-bs-slide-to]",st.dataApiClickHandler),j.on(window,"load.bs.carousel.data-api",(()=>{const t=V.find('[data-bs-ride="carousel"]');for(let e=0,i=t.length;e<i;e++)st.carouselInterface(t[e],st.getInstance(t[e]))})),g(st);const ot="collapse",rt={toggle:!0,parent:null},at={toggle:"boolean",parent:"(null|element)"},lt="show",ct="collapse",ht="collapsing",dt="collapsed",ut=":scope .collapse .collapse",ft='[data-bs-toggle="collapse"]';class pt extends B{constructor(t,e){super(t),this._isTransitioning=!1,this._config=this._getConfig(e),this._triggerArray=[];const n=V.find(ft);for(let t=0,e=n.length;t<e;t++){const e=n[t],s=i(e),o=V.find(s).filter((t=>t===this._element));null!==s&&o.length&&(this._selector=s,this._triggerArray.push(e))}this._initializeChildren(),this._config.parent||this._addAriaAndCollapsedClass(this._triggerArray,this._isShown()),this._config.toggle&&this.toggle()}static get Default(){return rt}static get NAME(){return ot}toggle(){this._isShown()?this.hide():this.show()}show(){if(this._isTransitioning||this._isShown())return;let t,e=[];if(this._config.parent){const t=V.find(ut,this._config.parent);e=V.find(".collapse.show, .collapse.collapsing",this._config.parent).filter((e=>!t.includes(e)))}const i=V.findOne(this._selector);if(e.length){const n=e.find((t=>i!==t));if(t=n?pt.getInstance(n):null,t&&t._isTransitioning)return}if(j.trigger(this._element,"show.bs.collapse").defaultPrevented)return;e.forEach((e=>{i!==e&&pt.getOrCreateInstance(e,{toggle:!1}).hide(),t||H.set(e,"bs.collapse",null)}));const n=this._getDimension();this._element.classList.remove(ct),this._element.classList.add(ht),this._element.style[n]=0,this._addAriaAndCollapsedClass(this._triggerArray,!0),this._isTransitioning=!0;const s=`scroll${n[0].toUpperCase()+n.slice(1)}`;this._queueCallback((()=>{this._isTransitioning=!1,this._element.classList.remove(ht),this._element.classList.add(ct,lt),this._element.style[n]="",j.trigger(this._element,"shown.bs.collapse")}),this._element,!0),this._element.style[n]=`${this._element[s]}px`}hide(){if(this._isTransitioning||!this._isShown())return;if(j.trigger(this._element,"hide.bs.collapse").defaultPrevented)return;const t=this._getDimension();this._element.style[t]=`${this._element.getBoundingClientRect()[t]}px`,u(this._element),this._element.classList.add(ht),this._element.classList.remove(ct,lt);const e=this._triggerArray.length;for(let t=0;t<e;t++){const e=this._triggerArray[t],i=n(e);i&&!this._isShown(i)&&this._addAriaAndCollapsedClass([e],!1)}this._isTransitioning=!0,this._element.style[t]="",this._queueCallback((()=>{this._isTransitioning=!1,this._element.classList.remove(ht),this._element.classList.add(ct),j.trigger(this._element,"hidden.bs.collapse")}),this._element,!0)}_isShown(t=this._element){return t.classList.contains(lt)}_getConfig(t){return(t={...rt,...U.getDataAttributes(this._element),...t}).toggle=Boolean(t.toggle),t.parent=r(t.parent),a(ot,t,at),t}_getDimension(){return this._element.classList.contains("collapse-horizontal")?"width":"height"}_initializeChildren(){if(!this._config.parent)return;const t=V.find(ut,this._config.parent);V.find(ft,this._config.parent).filter((e=>!t.includes(e))).forEach((t=>{const e=n(t);e&&this._addAriaAndCollapsedClass([t],this._isShown(e))}))}_addAriaAndCollapsedClass(t,e){t.length&&t.forEach((t=>{e?t.classList.remove(dt):t.classList.add(dt),t.setAttribute("aria-expanded",e)}))}static jQueryInterface(t){return this.each((function(){const e={};"string"==typeof t&&/show|hide/.test(t)&&(e.toggle=!1);const i=pt.getOrCreateInstance(this,e);if("string"==typeof t){if(void 0===i[t])throw new TypeError(`No method named "${t}"`);i[t]()}}))}}j.on(document,"click.bs.collapse.data-api",ft,(function(t){("A"===t.target.tagName||t.delegateTarget&&"A"===t.delegateTarget.tagName)&&t.preventDefault();const e=i(this);V.find(e).forEach((t=>{pt.getOrCreateInstance(t,{toggle:!1}).toggle()}))})),g(pt);var mt="top",gt="bottom",_t="right",bt="left",vt="auto",yt=[mt,gt,_t,bt],wt="start",Et="end",At="clippingParents",Tt="viewport",Ot="popper",Ct="reference",kt=yt.reduce((function(t,e){return t.concat([e+"-"+wt,e+"-"+Et])}),[]),Lt=[].concat(yt,[vt]).reduce((function(t,e){return t.concat([e,e+"-"+wt,e+"-"+Et])}),[]),xt="beforeRead",Dt="read",St="afterRead",Nt="beforeMain",It="main",Pt="afterMain",jt="beforeWrite",Mt="write",Ht="afterWrite",Bt=[xt,Dt,St,Nt,It,Pt,jt,Mt,Ht];function Rt(t){return t?(t.nodeName||"").toLowerCase():null}function Wt(t){if(null==t)return window;if("[object Window]"!==t.toString()){var e=t.ownerDocument;return e&&e.defaultView||window}return t}function $t(t){return t instanceof Wt(t).Element||t instanceof Element}function zt(t){return t instanceof Wt(t).HTMLElement||t instanceof HTMLElement}function qt(t){return"undefined"!=typeof ShadowRoot&&(t instanceof Wt(t).ShadowRoot||t instanceof ShadowRoot)}const Ft={name:"applyStyles",enabled:!0,phase:"write",fn:function(t){var e=t.state;Object.keys(e.elements).forEach((function(t){var i=e.styles[t]||{},n=e.attributes[t]||{},s=e.elements[t];zt(s)&&Rt(s)&&(Object.assign(s.style,i),Object.keys(n).forEach((function(t){var e=n[t];!1===e?s.removeAttribute(t):s.setAttribute(t,!0===e?"":e)})))}))},effect:function(t){var e=t.state,i={popper:{position:e.options.strategy,left:"0",top:"0",margin:"0"},arrow:{position:"absolute"},reference:{}};return Object.assign(e.elements.popper.style,i.popper),e.styles=i,e.elements.arrow&&Object.assign(e.elements.arrow.style,i.arrow),function(){Object.keys(e.elements).forEach((function(t){var n=e.elements[t],s=e.attributes[t]||{},o=Object.keys(e.styles.hasOwnProperty(t)?e.styles[t]:i[t]).reduce((function(t,e){return t[e]="",t}),{});zt(n)&&Rt(n)&&(Object.assign(n.style,o),Object.keys(s).forEach((function(t){n.removeAttribute(t)})))}))}},requires:["computeStyles"]};function Ut(t){return t.split("-")[0]}function Vt(t,e){var i=t.getBoundingClientRect();return{width:i.width/1,height:i.height/1,top:i.top/1,right:i.right/1,bottom:i.bottom/1,left:i.left/1,x:i.left/1,y:i.top/1}}function Kt(t){var e=Vt(t),i=t.offsetWidth,n=t.offsetHeight;return Math.abs(e.width-i)<=1&&(i=e.width),Math.abs(e.height-n)<=1&&(n=e.height),{x:t.offsetLeft,y:t.offsetTop,width:i,height:n}}function Xt(t,e){var i=e.getRootNode&&e.getRootNode();if(t.contains(e))return!0;if(i&&qt(i)){var n=e;do{if(n&&t.isSameNode(n))return!0;n=n.parentNode||n.host}while(n)}return!1}function Yt(t){return Wt(t).getComputedStyle(t)}function Qt(t){return["table","td","th"].indexOf(Rt(t))>=0}function Gt(t){return(($t(t)?t.ownerDocument:t.document)||window.document).documentElement}function Zt(t){return"html"===Rt(t)?t:t.assignedSlot||t.parentNode||(qt(t)?t.host:null)||Gt(t)}function Jt(t){return zt(t)&&"fixed"!==Yt(t).position?t.offsetParent:null}function te(t){for(var e=Wt(t),i=Jt(t);i&&Qt(i)&&"static"===Yt(i).position;)i=Jt(i);return i&&("html"===Rt(i)||"body"===Rt(i)&&"static"===Yt(i).position)?e:i||function(t){var e=-1!==navigator.userAgent.toLowerCase().indexOf("firefox");if(-1!==navigator.userAgent.indexOf("Trident")&&zt(t)&&"fixed"===Yt(t).position)return null;for(var i=Zt(t);zt(i)&&["html","body"].indexOf(Rt(i))<0;){var n=Yt(i);if("none"!==n.transform||"none"!==n.perspective||"paint"===n.contain||-1!==["transform","perspective"].indexOf(n.willChange)||e&&"filter"===n.willChange||e&&n.filter&&"none"!==n.filter)return i;i=i.parentNode}return null}(t)||e}function ee(t){return["top","bottom"].indexOf(t)>=0?"x":"y"}var ie=Math.max,ne=Math.min,se=Math.round;function oe(t,e,i){return ie(t,ne(e,i))}function re(t){return Object.assign({},{top:0,right:0,bottom:0,left:0},t)}function ae(t,e){return e.reduce((function(e,i){return e[i]=t,e}),{})}const le={name:"arrow",enabled:!0,phase:"main",fn:function(t){var e,i=t.state,n=t.name,s=t.options,o=i.elements.arrow,r=i.modifiersData.popperOffsets,a=Ut(i.placement),l=ee(a),c=[bt,_t].indexOf(a)>=0?"height":"width";if(o&&r){var h=function(t,e){return re("number"!=typeof(t="function"==typeof t?t(Object.assign({},e.rects,{placement:e.placement})):t)?t:ae(t,yt))}(s.padding,i),d=Kt(o),u="y"===l?mt:bt,f="y"===l?gt:_t,p=i.rects.reference[c]+i.rects.reference[l]-r[l]-i.rects.popper[c],m=r[l]-i.rects.reference[l],g=te(o),_=g?"y"===l?g.clientHeight||0:g.clientWidth||0:0,b=p/2-m/2,v=h[u],y=_-d[c]-h[f],w=_/2-d[c]/2+b,E=oe(v,w,y),A=l;i.modifiersData[n]=((e={})[A]=E,e.centerOffset=E-w,e)}},effect:function(t){var e=t.state,i=t.options.element,n=void 0===i?"[data-popper-arrow]":i;null!=n&&("string"!=typeof n||(n=e.elements.popper.querySelector(n)))&&Xt(e.elements.popper,n)&&(e.elements.arrow=n)},requires:["popperOffsets"],requiresIfExists:["preventOverflow"]};function ce(t){return t.split("-")[1]}var he={top:"auto",right:"auto",bottom:"auto",left:"auto"};function de(t){var e,i=t.popper,n=t.popperRect,s=t.placement,o=t.variation,r=t.offsets,a=t.position,l=t.gpuAcceleration,c=t.adaptive,h=t.roundOffsets,d=!0===h?function(t){var e=t.x,i=t.y,n=window.devicePixelRatio||1;return{x:se(se(e*n)/n)||0,y:se(se(i*n)/n)||0}}(r):"function"==typeof h?h(r):r,u=d.x,f=void 0===u?0:u,p=d.y,m=void 0===p?0:p,g=r.hasOwnProperty("x"),_=r.hasOwnProperty("y"),b=bt,v=mt,y=window;if(c){var w=te(i),E="clientHeight",A="clientWidth";w===Wt(i)&&"static"!==Yt(w=Gt(i)).position&&"absolute"===a&&(E="scrollHeight",A="scrollWidth"),w=w,s!==mt&&(s!==bt&&s!==_t||o!==Et)||(v=gt,m-=w[E]-n.height,m*=l?1:-1),s!==bt&&(s!==mt&&s!==gt||o!==Et)||(b=_t,f-=w[A]-n.width,f*=l?1:-1)}var T,O=Object.assign({position:a},c&&he);return l?Object.assign({},O,((T={})[v]=_?"0":"",T[b]=g?"0":"",T.transform=(y.devicePixelRatio||1)<=1?"translate("+f+"px, "+m+"px)":"translate3d("+f+"px, "+m+"px, 0)",T)):Object.assign({},O,((e={})[v]=_?m+"px":"",e[b]=g?f+"px":"",e.transform="",e))}const ue={name:"computeStyles",enabled:!0,phase:"beforeWrite",fn:function(t){var e=t.state,i=t.options,n=i.gpuAcceleration,s=void 0===n||n,o=i.adaptive,r=void 0===o||o,a=i.roundOffsets,l=void 0===a||a,c={placement:Ut(e.placement),variation:ce(e.placement),popper:e.elements.popper,popperRect:e.rects.popper,gpuAcceleration:s};null!=e.modifiersData.popperOffsets&&(e.styles.popper=Object.assign({},e.styles.popper,de(Object.assign({},c,{offsets:e.modifiersData.popperOffsets,position:e.options.strategy,adaptive:r,roundOffsets:l})))),null!=e.modifiersData.arrow&&(e.styles.arrow=Object.assign({},e.styles.arrow,de(Object.assign({},c,{offsets:e.modifiersData.arrow,position:"absolute",adaptive:!1,roundOffsets:l})))),e.attributes.popper=Object.assign({},e.attributes.popper,{"data-popper-placement":e.placement})},data:{}};var fe={passive:!0};const pe={name:"eventListeners",enabled:!0,phase:"write",fn:function(){},effect:function(t){var e=t.state,i=t.instance,n=t.options,s=n.scroll,o=void 0===s||s,r=n.resize,a=void 0===r||r,l=Wt(e.elements.popper),c=[].concat(e.scrollParents.reference,e.scrollParents.popper);return o&&c.forEach((function(t){t.addEventListener("scroll",i.update,fe)})),a&&l.addEventListener("resize",i.update,fe),function(){o&&c.forEach((function(t){t.removeEventListener("scroll",i.update,fe)})),a&&l.removeEventListener("resize",i.update,fe)}},data:{}};var me={left:"right",right:"left",bottom:"top",top:"bottom"};function ge(t){return t.replace(/left|right|bottom|top/g,(function(t){return me[t]}))}var _e={start:"end",end:"start"};function be(t){return t.replace(/start|end/g,(function(t){return _e[t]}))}function ve(t){var e=Wt(t);return{scrollLeft:e.pageXOffset,scrollTop:e.pageYOffset}}function ye(t){return Vt(Gt(t)).left+ve(t).scrollLeft}function we(t){var e=Yt(t),i=e.overflow,n=e.overflowX,s=e.overflowY;return/auto|scroll|overlay|hidden/.test(i+s+n)}function Ee(t){return["html","body","#document"].indexOf(Rt(t))>=0?t.ownerDocument.body:zt(t)&&we(t)?t:Ee(Zt(t))}function Ae(t,e){var i;void 0===e&&(e=[]);var n=Ee(t),s=n===(null==(i=t.ownerDocument)?void 0:i.body),o=Wt(n),r=s?[o].concat(o.visualViewport||[],we(n)?n:[]):n,a=e.concat(r);return s?a:a.concat(Ae(Zt(r)))}function Te(t){return Object.assign({},t,{left:t.x,top:t.y,right:t.x+t.width,bottom:t.y+t.height})}function Oe(t,e){return e===Tt?Te(function(t){var e=Wt(t),i=Gt(t),n=e.visualViewport,s=i.clientWidth,o=i.clientHeight,r=0,a=0;return n&&(s=n.width,o=n.height,/^((?!chrome|android).)*safari/i.test(navigator.userAgent)||(r=n.offsetLeft,a=n.offsetTop)),{width:s,height:o,x:r+ye(t),y:a}}(t)):zt(e)?function(t){var e=Vt(t);return e.top=e.top+t.clientTop,e.left=e.left+t.clientLeft,e.bottom=e.top+t.clientHeight,e.right=e.left+t.clientWidth,e.width=t.clientWidth,e.height=t.clientHeight,e.x=e.left,e.y=e.top,e}(e):Te(function(t){var e,i=Gt(t),n=ve(t),s=null==(e=t.ownerDocument)?void 0:e.body,o=ie(i.scrollWidth,i.clientWidth,s?s.scrollWidth:0,s?s.clientWidth:0),r=ie(i.scrollHeight,i.clientHeight,s?s.scrollHeight:0,s?s.clientHeight:0),a=-n.scrollLeft+ye(t),l=-n.scrollTop;return"rtl"===Yt(s||i).direction&&(a+=ie(i.clientWidth,s?s.clientWidth:0)-o),{width:o,height:r,x:a,y:l}}(Gt(t)))}function Ce(t){var e,i=t.reference,n=t.element,s=t.placement,o=s?Ut(s):null,r=s?ce(s):null,a=i.x+i.width/2-n.width/2,l=i.y+i.height/2-n.height/2;switch(o){case mt:e={x:a,y:i.y-n.height};break;case gt:e={x:a,y:i.y+i.height};break;case _t:e={x:i.x+i.width,y:l};break;case bt:e={x:i.x-n.width,y:l};break;default:e={x:i.x,y:i.y}}var c=o?ee(o):null;if(null!=c){var h="y"===c?"height":"width";switch(r){case wt:e[c]=e[c]-(i[h]/2-n[h]/2);break;case Et:e[c]=e[c]+(i[h]/2-n[h]/2)}}return e}function ke(t,e){void 0===e&&(e={});var i=e,n=i.placement,s=void 0===n?t.placement:n,o=i.boundary,r=void 0===o?At:o,a=i.rootBoundary,l=void 0===a?Tt:a,c=i.elementContext,h=void 0===c?Ot:c,d=i.altBoundary,u=void 0!==d&&d,f=i.padding,p=void 0===f?0:f,m=re("number"!=typeof p?p:ae(p,yt)),g=h===Ot?Ct:Ot,_=t.rects.popper,b=t.elements[u?g:h],v=function(t,e,i){var n="clippingParents"===e?function(t){var e=Ae(Zt(t)),i=["absolute","fixed"].indexOf(Yt(t).position)>=0&&zt(t)?te(t):t;return $t(i)?e.filter((function(t){return $t(t)&&Xt(t,i)&&"body"!==Rt(t)})):[]}(t):[].concat(e),s=[].concat(n,[i]),o=s[0],r=s.reduce((function(e,i){var n=Oe(t,i);return e.top=ie(n.top,e.top),e.right=ne(n.right,e.right),e.bottom=ne(n.bottom,e.bottom),e.left=ie(n.left,e.left),e}),Oe(t,o));return r.width=r.right-r.left,r.height=r.bottom-r.top,r.x=r.left,r.y=r.top,r}($t(b)?b:b.contextElement||Gt(t.elements.popper),r,l),y=Vt(t.elements.reference),w=Ce({reference:y,element:_,strategy:"absolute",placement:s}),E=Te(Object.assign({},_,w)),A=h===Ot?E:y,T={top:v.top-A.top+m.top,bottom:A.bottom-v.bottom+m.bottom,left:v.left-A.left+m.left,right:A.right-v.right+m.right},O=t.modifiersData.offset;if(h===Ot&&O){var C=O[s];Object.keys(T).forEach((function(t){var e=[_t,gt].indexOf(t)>=0?1:-1,i=[mt,gt].indexOf(t)>=0?"y":"x";T[t]+=C[i]*e}))}return T}function Le(t,e){void 0===e&&(e={});var i=e,n=i.placement,s=i.boundary,o=i.rootBoundary,r=i.padding,a=i.flipVariations,l=i.allowedAutoPlacements,c=void 0===l?Lt:l,h=ce(n),d=h?a?kt:kt.filter((function(t){return ce(t)===h})):yt,u=d.filter((function(t){return c.indexOf(t)>=0}));0===u.length&&(u=d);var f=u.reduce((function(e,i){return e[i]=ke(t,{placement:i,boundary:s,rootBoundary:o,padding:r})[Ut(i)],e}),{});return Object.keys(f).sort((function(t,e){return f[t]-f[e]}))}const xe={name:"flip",enabled:!0,phase:"main",fn:function(t){var e=t.state,i=t.options,n=t.name;if(!e.modifiersData[n]._skip){for(var s=i.mainAxis,o=void 0===s||s,r=i.altAxis,a=void 0===r||r,l=i.fallbackPlacements,c=i.padding,h=i.boundary,d=i.rootBoundary,u=i.altBoundary,f=i.flipVariations,p=void 0===f||f,m=i.allowedAutoPlacements,g=e.options.placement,_=Ut(g),b=l||(_!==g&&p?function(t){if(Ut(t)===vt)return[];var e=ge(t);return[be(t),e,be(e)]}(g):[ge(g)]),v=[g].concat(b).reduce((function(t,i){return t.concat(Ut(i)===vt?Le(e,{placement:i,boundary:h,rootBoundary:d,padding:c,flipVariations:p,allowedAutoPlacements:m}):i)}),[]),y=e.rects.reference,w=e.rects.popper,E=new Map,A=!0,T=v[0],O=0;O<v.length;O++){var C=v[O],k=Ut(C),L=ce(C)===wt,x=[mt,gt].indexOf(k)>=0,D=x?"width":"height",S=ke(e,{placement:C,boundary:h,rootBoundary:d,altBoundary:u,padding:c}),N=x?L?_t:bt:L?gt:mt;y[D]>w[D]&&(N=ge(N));var I=ge(N),P=[];if(o&&P.push(S[k]<=0),a&&P.push(S[N]<=0,S[I]<=0),P.every((function(t){return t}))){T=C,A=!1;break}E.set(C,P)}if(A)for(var j=function(t){var e=v.find((function(e){var i=E.get(e);if(i)return i.slice(0,t).every((function(t){return t}))}));if(e)return T=e,"break"},M=p?3:1;M>0&&"break"!==j(M);M--);e.placement!==T&&(e.modifiersData[n]._skip=!0,e.placement=T,e.reset=!0)}},requiresIfExists:["offset"],data:{_skip:!1}};function De(t,e,i){return void 0===i&&(i={x:0,y:0}),{top:t.top-e.height-i.y,right:t.right-e.width+i.x,bottom:t.bottom-e.height+i.y,left:t.left-e.width-i.x}}function Se(t){return[mt,_t,gt,bt].some((function(e){return t[e]>=0}))}const Ne={name:"hide",enabled:!0,phase:"main",requiresIfExists:["preventOverflow"],fn:function(t){var e=t.state,i=t.name,n=e.rects.reference,s=e.rects.popper,o=e.modifiersData.preventOverflow,r=ke(e,{elementContext:"reference"}),a=ke(e,{altBoundary:!0}),l=De(r,n),c=De(a,s,o),h=Se(l),d=Se(c);e.modifiersData[i]={referenceClippingOffsets:l,popperEscapeOffsets:c,isReferenceHidden:h,hasPopperEscaped:d},e.attributes.popper=Object.assign({},e.attributes.popper,{"data-popper-reference-hidden":h,"data-popper-escaped":d})}},Ie={name:"offset",enabled:!0,phase:"main",requires:["popperOffsets"],fn:function(t){var e=t.state,i=t.options,n=t.name,s=i.offset,o=void 0===s?[0,0]:s,r=Lt.reduce((function(t,i){return t[i]=function(t,e,i){var n=Ut(t),s=[bt,mt].indexOf(n)>=0?-1:1,o="function"==typeof i?i(Object.assign({},e,{placement:t})):i,r=o[0],a=o[1];return r=r||0,a=(a||0)*s,[bt,_t].indexOf(n)>=0?{x:a,y:r}:{x:r,y:a}}(i,e.rects,o),t}),{}),a=r[e.placement],l=a.x,c=a.y;null!=e.modifiersData.popperOffsets&&(e.modifiersData.popperOffsets.x+=l,e.modifiersData.popperOffsets.y+=c),e.modifiersData[n]=r}},Pe={name:"popperOffsets",enabled:!0,phase:"read",fn:function(t){var e=t.state,i=t.name;e.modifiersData[i]=Ce({reference:e.rects.reference,element:e.rects.popper,strategy:"absolute",placement:e.placement})},data:{}},je={name:"preventOverflow",enabled:!0,phase:"main",fn:function(t){var e=t.state,i=t.options,n=t.name,s=i.mainAxis,o=void 0===s||s,r=i.altAxis,a=void 0!==r&&r,l=i.boundary,c=i.rootBoundary,h=i.altBoundary,d=i.padding,u=i.tether,f=void 0===u||u,p=i.tetherOffset,m=void 0===p?0:p,g=ke(e,{boundary:l,rootBoundary:c,padding:d,altBoundary:h}),_=Ut(e.placement),b=ce(e.placement),v=!b,y=ee(_),w="x"===y?"y":"x",E=e.modifiersData.popperOffsets,A=e.rects.reference,T=e.rects.popper,O="function"==typeof m?m(Object.assign({},e.rects,{placement:e.placement})):m,C={x:0,y:0};if(E){if(o||a){var k="y"===y?mt:bt,L="y"===y?gt:_t,x="y"===y?"height":"width",D=E[y],S=E[y]+g[k],N=E[y]-g[L],I=f?-T[x]/2:0,P=b===wt?A[x]:T[x],j=b===wt?-T[x]:-A[x],M=e.elements.arrow,H=f&&M?Kt(M):{width:0,height:0},B=e.modifiersData["arrow#persistent"]?e.modifiersData["arrow#persistent"].padding:{top:0,right:0,bottom:0,left:0},R=B[k],W=B[L],$=oe(0,A[x],H[x]),z=v?A[x]/2-I-$-R-O:P-$-R-O,q=v?-A[x]/2+I+$+W+O:j+$+W+O,F=e.elements.arrow&&te(e.elements.arrow),U=F?"y"===y?F.clientTop||0:F.clientLeft||0:0,V=e.modifiersData.offset?e.modifiersData.offset[e.placement][y]:0,K=E[y]+z-V-U,X=E[y]+q-V;if(o){var Y=oe(f?ne(S,K):S,D,f?ie(N,X):N);E[y]=Y,C[y]=Y-D}if(a){var Q="x"===y?mt:bt,G="x"===y?gt:_t,Z=E[w],J=Z+g[Q],tt=Z-g[G],et=oe(f?ne(J,K):J,Z,f?ie(tt,X):tt);E[w]=et,C[w]=et-Z}}e.modifiersData[n]=C}},requiresIfExists:["offset"]};function Me(t,e,i){void 0===i&&(i=!1);var n=zt(e);zt(e)&&function(t){var e=t.getBoundingClientRect();e.width,t.offsetWidth,e.height,t.offsetHeight}(e);var s,o,r=Gt(e),a=Vt(t),l={scrollLeft:0,scrollTop:0},c={x:0,y:0};return(n||!n&&!i)&&(("body"!==Rt(e)||we(r))&&(l=(s=e)!==Wt(s)&&zt(s)?{scrollLeft:(o=s).scrollLeft,scrollTop:o.scrollTop}:ve(s)),zt(e)?((c=Vt(e)).x+=e.clientLeft,c.y+=e.clientTop):r&&(c.x=ye(r))),{x:a.left+l.scrollLeft-c.x,y:a.top+l.scrollTop-c.y,width:a.width,height:a.height}}function He(t){var e=new Map,i=new Set,n=[];function s(t){i.add(t.name),[].concat(t.requires||[],t.requiresIfExists||[]).forEach((function(t){if(!i.has(t)){var n=e.get(t);n&&s(n)}})),n.push(t)}return t.forEach((function(t){e.set(t.name,t)})),t.forEach((function(t){i.has(t.name)||s(t)})),n}var Be={placement:"bottom",modifiers:[],strategy:"absolute"};function Re(){for(var t=arguments.length,e=new Array(t),i=0;i<t;i++)e[i]=arguments[i];return!e.some((function(t){return!(t&&"function"==typeof t.getBoundingClientRect)}))}function We(t){void 0===t&&(t={});var e=t,i=e.defaultModifiers,n=void 0===i?[]:i,s=e.defaultOptions,o=void 0===s?Be:s;return function(t,e,i){void 0===i&&(i=o);var s,r,a={placement:"bottom",orderedModifiers:[],options:Object.assign({},Be,o),modifiersData:{},elements:{reference:t,popper:e},attributes:{},styles:{}},l=[],c=!1,h={state:a,setOptions:function(i){var s="function"==typeof i?i(a.options):i;d(),a.options=Object.assign({},o,a.options,s),a.scrollParents={reference:$t(t)?Ae(t):t.contextElement?Ae(t.contextElement):[],popper:Ae(e)};var r,c,u=function(t){var e=He(t);return Bt.reduce((function(t,i){return t.concat(e.filter((function(t){return t.phase===i})))}),[])}((r=[].concat(n,a.options.modifiers),c=r.reduce((function(t,e){var i=t[e.name];return t[e.name]=i?Object.assign({},i,e,{options:Object.assign({},i.options,e.options),data:Object.assign({},i.data,e.data)}):e,t}),{}),Object.keys(c).map((function(t){return c[t]}))));return a.orderedModifiers=u.filter((function(t){return t.enabled})),a.orderedModifiers.forEach((function(t){var e=t.name,i=t.options,n=void 0===i?{}:i,s=t.effect;if("function"==typeof s){var o=s({state:a,name:e,instance:h,options:n});l.push(o||function(){})}})),h.update()},forceUpdate:function(){if(!c){var t=a.elements,e=t.reference,i=t.popper;if(Re(e,i)){a.rects={reference:Me(e,te(i),"fixed"===a.options.strategy),popper:Kt(i)},a.reset=!1,a.placement=a.options.placement,a.orderedModifiers.forEach((function(t){return a.modifiersData[t.name]=Object.assign({},t.data)}));for(var n=0;n<a.orderedModifiers.length;n++)if(!0!==a.reset){var s=a.orderedModifiers[n],o=s.fn,r=s.options,l=void 0===r?{}:r,d=s.name;"function"==typeof o&&(a=o({state:a,options:l,name:d,instance:h})||a)}else a.reset=!1,n=-1}}},update:(s=function(){return new Promise((function(t){h.forceUpdate(),t(a)}))},function(){return r||(r=new Promise((function(t){Promise.resolve().then((function(){r=void 0,t(s())}))}))),r}),destroy:function(){d(),c=!0}};if(!Re(t,e))return h;function d(){l.forEach((function(t){return t()})),l=[]}return h.setOptions(i).then((function(t){!c&&i.onFirstUpdate&&i.onFirstUpdate(t)})),h}}var $e=We(),ze=We({defaultModifiers:[pe,Pe,ue,Ft]}),qe=We({defaultModifiers:[pe,Pe,ue,Ft,Ie,xe,je,le,Ne]});const Fe=Object.freeze({__proto__:null,popperGenerator:We,detectOverflow:ke,createPopperBase:$e,createPopper:qe,createPopperLite:ze,top:mt,bottom:gt,right:_t,left:bt,auto:vt,basePlacements:yt,start:wt,end:Et,clippingParents:At,viewport:Tt,popper:Ot,reference:Ct,variationPlacements:kt,placements:Lt,beforeRead:xt,read:Dt,afterRead:St,beforeMain:Nt,main:It,afterMain:Pt,beforeWrite:jt,write:Mt,afterWrite:Ht,modifierPhases:Bt,applyStyles:Ft,arrow:le,computeStyles:ue,eventListeners:pe,flip:xe,hide:Ne,offset:Ie,popperOffsets:Pe,preventOverflow:je}),Ue="dropdown",Ve="Escape",Ke="Space",Xe="ArrowUp",Ye="ArrowDown",Qe=new RegExp("ArrowUp|ArrowDown|Escape"),Ge="click.bs.dropdown.data-api",Ze="keydown.bs.dropdown.data-api",Je="show",ti='[data-bs-toggle="dropdown"]',ei=".dropdown-menu",ii=m()?"top-end":"top-start",ni=m()?"top-start":"top-end",si=m()?"bottom-end":"bottom-start",oi=m()?"bottom-start":"bottom-end",ri=m()?"left-start":"right-start",ai=m()?"right-start":"left-start",li={offset:[0,2],boundary:"clippingParents",reference:"toggle",display:"dynamic",popperConfig:null,autoClose:!0},ci={offset:"(array|string|function)",boundary:"(string|element)",reference:"(string|element|object)",display:"string",popperConfig:"(null|object|function)",autoClose:"(boolean|string)"};class hi extends B{constructor(t,e){super(t),this._popper=null,this._config=this._getConfig(e),this._menu=this._getMenuElement(),this._inNavbar=this._detectNavbar()}static get Default(){return li}static get DefaultType(){return ci}static get NAME(){return Ue}toggle(){return this._isShown()?this.hide():this.show()}show(){if(c(this._element)||this._isShown(this._menu))return;const t={relatedTarget:this._element};if(j.trigger(this._element,"show.bs.dropdown",t).defaultPrevented)return;const e=hi.getParentFromElement(this._element);this._inNavbar?U.setDataAttribute(this._menu,"popper","none"):this._createPopper(e),"ontouchstart"in document.documentElement&&!e.closest(".navbar-nav")&&[].concat(...document.body.children).forEach((t=>j.on(t,"mouseover",d))),this._element.focus(),this._element.setAttribute("aria-expanded",!0),this._menu.classList.add(Je),this._element.classList.add(Je),j.trigger(this._element,"shown.bs.dropdown",t)}hide(){if(c(this._element)||!this._isShown(this._menu))return;const t={relatedTarget:this._element};this._completeHide(t)}dispose(){this._popper&&this._popper.destroy(),super.dispose()}update(){this._inNavbar=this._detectNavbar(),this._popper&&this._popper.update()}_completeHide(t){j.trigger(this._element,"hide.bs.dropdown",t).defaultPrevented||("ontouchstart"in document.documentElement&&[].concat(...document.body.children).forEach((t=>j.off(t,"mouseover",d))),this._popper&&this._popper.destroy(),this._menu.classList.remove(Je),this._element.classList.remove(Je),this._element.setAttribute("aria-expanded","false"),U.removeDataAttribute(this._menu,"popper"),j.trigger(this._element,"hidden.bs.dropdown",t))}_getConfig(t){if(t={...this.constructor.Default,...U.getDataAttributes(this._element),...t},a(Ue,t,this.constructor.DefaultType),"object"==typeof t.reference&&!o(t.reference)&&"function"!=typeof t.reference.getBoundingClientRect)throw new TypeError(`${Ue.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);return t}_createPopper(t){if(void 0===Fe)throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");let e=this._element;"parent"===this._config.reference?e=t:o(this._config.reference)?e=r(this._config.reference):"object"==typeof this._config.reference&&(e=this._config.reference);const i=this._getPopperConfig(),n=i.modifiers.find((t=>"applyStyles"===t.name&&!1===t.enabled));this._popper=qe(e,this._menu,i),n&&U.setDataAttribute(this._menu,"popper","static")}_isShown(t=this._element){return t.classList.contains(Je)}_getMenuElement(){return V.next(this._element,ei)[0]}_getPlacement(){const t=this._element.parentNode;if(t.classList.contains("dropend"))return ri;if(t.classList.contains("dropstart"))return ai;const e="end"===getComputedStyle(this._menu).getPropertyValue("--bs-position").trim();return t.classList.contains("dropup")?e?ni:ii:e?oi:si}_detectNavbar(){return null!==this._element.closest(".navbar")}_getOffset(){const{offset:t}=this._config;return"string"==typeof t?t.split(",").map((t=>Number.parseInt(t,10))):"function"==typeof t?e=>t(e,this._element):t}_getPopperConfig(){const t={placement:this._getPlacement(),modifiers:[{name:"preventOverflow",options:{boundary:this._config.boundary}},{name:"offset",options:{offset:this._getOffset()}}]};return"static"===this._config.display&&(t.modifiers=[{name:"applyStyles",enabled:!1}]),{...t,..."function"==typeof this._config.popperConfig?this._config.popperConfig(t):this._config.popperConfig}}_selectMenuItem({key:t,target:e}){const i=V.find(".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)",this._menu).filter(l);i.length&&v(i,e,t===Ye,!i.includes(e)).focus()}static jQueryInterface(t){return this.each((function(){const e=hi.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t]()}}))}static clearMenus(t){if(t&&(2===t.button||"keyup"===t.type&&"Tab"!==t.key))return;const e=V.find(ti);for(let i=0,n=e.length;i<n;i++){const n=hi.getInstance(e[i]);if(!n||!1===n._config.autoClose)continue;if(!n._isShown())continue;const s={relatedTarget:n._element};if(t){const e=t.composedPath(),i=e.includes(n._menu);if(e.includes(n._element)||"inside"===n._config.autoClose&&!i||"outside"===n._config.autoClose&&i)continue;if(n._menu.contains(t.target)&&("keyup"===t.type&&"Tab"===t.key||/input|select|option|textarea|form/i.test(t.target.tagName)))continue;"click"===t.type&&(s.clickEvent=t)}n._completeHide(s)}}static getParentFromElement(t){return n(t)||t.parentNode}static dataApiKeydownHandler(t){if(/input|textarea/i.test(t.target.tagName)?t.key===Ke||t.key!==Ve&&(t.key!==Ye&&t.key!==Xe||t.target.closest(ei)):!Qe.test(t.key))return;const e=this.classList.contains(Je);if(!e&&t.key===Ve)return;if(t.preventDefault(),t.stopPropagation(),c(this))return;const i=this.matches(ti)?this:V.prev(this,ti)[0],n=hi.getOrCreateInstance(i);if(t.key!==Ve)return t.key===Xe||t.key===Ye?(e||n.show(),void n._selectMenuItem(t)):void(e&&t.key!==Ke||hi.clearMenus());n.hide()}}j.on(document,Ze,ti,hi.dataApiKeydownHandler),j.on(document,Ze,ei,hi.dataApiKeydownHandler),j.on(document,Ge,hi.clearMenus),j.on(document,"keyup.bs.dropdown.data-api",hi.clearMenus),j.on(document,Ge,ti,(function(t){t.preventDefault(),hi.getOrCreateInstance(this).toggle()})),g(hi);const di=".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",ui=".sticky-top";class fi{constructor(){this._element=document.body}getWidth(){const t=document.documentElement.clientWidth;return Math.abs(window.innerWidth-t)}hide(){const t=this.getWidth();this._disableOverFlow(),this._setElementAttributes(this._element,"paddingRight",(e=>e+t)),this._setElementAttributes(di,"paddingRight",(e=>e+t)),this._setElementAttributes(ui,"marginRight",(e=>e-t))}_disableOverFlow(){this._saveInitialAttribute(this._element,"overflow"),this._element.style.overflow="hidden"}_setElementAttributes(t,e,i){const n=this.getWidth();this._applyManipulationCallback(t,(t=>{if(t!==this._element&&window.innerWidth>t.clientWidth+n)return;this._saveInitialAttribute(t,e);const s=window.getComputedStyle(t)[e];t.style[e]=`${i(Number.parseFloat(s))}px`}))}reset(){this._resetElementAttributes(this._element,"overflow"),this._resetElementAttributes(this._element,"paddingRight"),this._resetElementAttributes(di,"paddingRight"),this._resetElementAttributes(ui,"marginRight")}_saveInitialAttribute(t,e){const i=t.style[e];i&&U.setDataAttribute(t,e,i)}_resetElementAttributes(t,e){this._applyManipulationCallback(t,(t=>{const i=U.getDataAttribute(t,e);void 0===i?t.style.removeProperty(e):(U.removeDataAttribute(t,e),t.style[e]=i)}))}_applyManipulationCallback(t,e){o(t)?e(t):V.find(t,this._element).forEach(e)}isOverflowing(){return this.getWidth()>0}}const pi={className:"modal-backdrop",isVisible:!0,isAnimated:!1,rootElement:"body",clickCallback:null},mi={className:"string",isVisible:"boolean",isAnimated:"boolean",rootElement:"(element|string)",clickCallback:"(function|null)"},gi="show",_i="mousedown.bs.backdrop";class bi{constructor(t){this._config=this._getConfig(t),this._isAppended=!1,this._element=null}show(t){this._config.isVisible?(this._append(),this._config.isAnimated&&u(this._getElement()),this._getElement().classList.add(gi),this._emulateAnimation((()=>{_(t)}))):_(t)}hide(t){this._config.isVisible?(this._getElement().classList.remove(gi),this._emulateAnimation((()=>{this.dispose(),_(t)}))):_(t)}_getElement(){if(!this._element){const t=document.createElement("div");t.className=this._config.className,this._config.isAnimated&&t.classList.add("fade"),this._element=t}return this._element}_getConfig(t){return(t={...pi,..."object"==typeof t?t:{}}).rootElement=r(t.rootElement),a("backdrop",t,mi),t}_append(){this._isAppended||(this._config.rootElement.append(this._getElement()),j.on(this._getElement(),_i,(()=>{_(this._config.clickCallback)})),this._isAppended=!0)}dispose(){this._isAppended&&(j.off(this._element,_i),this._element.remove(),this._isAppended=!1)}_emulateAnimation(t){b(t,this._getElement(),this._config.isAnimated)}}const vi={trapElement:null,autofocus:!0},yi={trapElement:"element",autofocus:"boolean"},wi=".bs.focustrap",Ei="backward";class Ai{constructor(t){this._config=this._getConfig(t),this._isActive=!1,this._lastTabNavDirection=null}activate(){const{trapElement:t,autofocus:e}=this._config;this._isActive||(e&&t.focus(),j.off(document,wi),j.on(document,"focusin.bs.focustrap",(t=>this._handleFocusin(t))),j.on(document,"keydown.tab.bs.focustrap",(t=>this._handleKeydown(t))),this._isActive=!0)}deactivate(){this._isActive&&(this._isActive=!1,j.off(document,wi))}_handleFocusin(t){const{target:e}=t,{trapElement:i}=this._config;if(e===document||e===i||i.contains(e))return;const n=V.focusableChildren(i);0===n.length?i.focus():this._lastTabNavDirection===Ei?n[n.length-1].focus():n[0].focus()}_handleKeydown(t){"Tab"===t.key&&(this._lastTabNavDirection=t.shiftKey?Ei:"forward")}_getConfig(t){return t={...vi,..."object"==typeof t?t:{}},a("focustrap",t,yi),t}}const Ti="modal",Oi="Escape",Ci={backdrop:!0,keyboard:!0,focus:!0},ki={backdrop:"(boolean|string)",keyboard:"boolean",focus:"boolean"},Li="hidden.bs.modal",xi="show.bs.modal",Di="resize.bs.modal",Si="click.dismiss.bs.modal",Ni="keydown.dismiss.bs.modal",Ii="mousedown.dismiss.bs.modal",Pi="modal-open",ji="show",Mi="modal-static";class Hi extends B{constructor(t,e){super(t),this._config=this._getConfig(e),this._dialog=V.findOne(".modal-dialog",this._element),this._backdrop=this._initializeBackDrop(),this._focustrap=this._initializeFocusTrap(),this._isShown=!1,this._ignoreBackdropClick=!1,this._isTransitioning=!1,this._scrollBar=new fi}static get Default(){return Ci}static get NAME(){return Ti}toggle(t){return this._isShown?this.hide():this.show(t)}show(t){this._isShown||this._isTransitioning||j.trigger(this._element,xi,{relatedTarget:t}).defaultPrevented||(this._isShown=!0,this._isAnimated()&&(this._isTransitioning=!0),this._scrollBar.hide(),document.body.classList.add(Pi),this._adjustDialog(),this._setEscapeEvent(),this._setResizeEvent(),j.on(this._dialog,Ii,(()=>{j.one(this._element,"mouseup.dismiss.bs.modal",(t=>{t.target===this._element&&(this._ignoreBackdropClick=!0)}))})),this._showBackdrop((()=>this._showElement(t))))}hide(){if(!this._isShown||this._isTransitioning)return;if(j.trigger(this._element,"hide.bs.modal").defaultPrevented)return;this._isShown=!1;const t=this._isAnimated();t&&(this._isTransitioning=!0),this._setEscapeEvent(),this._setResizeEvent(),this._focustrap.deactivate(),this._element.classList.remove(ji),j.off(this._element,Si),j.off(this._dialog,Ii),this._queueCallback((()=>this._hideModal()),this._element,t)}dispose(){[window,this._dialog].forEach((t=>j.off(t,".bs.modal"))),this._backdrop.dispose(),this._focustrap.deactivate(),super.dispose()}handleUpdate(){this._adjustDialog()}_initializeBackDrop(){return new bi({isVisible:Boolean(this._config.backdrop),isAnimated:this._isAnimated()})}_initializeFocusTrap(){return new Ai({trapElement:this._element})}_getConfig(t){return t={...Ci,...U.getDataAttributes(this._element),..."object"==typeof t?t:{}},a(Ti,t,ki),t}_showElement(t){const e=this._isAnimated(),i=V.findOne(".modal-body",this._dialog);this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE||document.body.append(this._element),this._element.style.display="block",this._element.removeAttribute("aria-hidden"),this._element.setAttribute("aria-modal",!0),this._element.setAttribute("role","dialog"),this._element.scrollTop=0,i&&(i.scrollTop=0),e&&u(this._element),this._element.classList.add(ji),this._queueCallback((()=>{this._config.focus&&this._focustrap.activate(),this._isTransitioning=!1,j.trigger(this._element,"shown.bs.modal",{relatedTarget:t})}),this._dialog,e)}_setEscapeEvent(){this._isShown?j.on(this._element,Ni,(t=>{this._config.keyboard&&t.key===Oi?(t.preventDefault(),this.hide()):this._config.keyboard||t.key!==Oi||this._triggerBackdropTransition()})):j.off(this._element,Ni)}_setResizeEvent(){this._isShown?j.on(window,Di,(()=>this._adjustDialog())):j.off(window,Di)}_hideModal(){this._element.style.display="none",this._element.setAttribute("aria-hidden",!0),this._element.removeAttribute("aria-modal"),this._element.removeAttribute("role"),this._isTransitioning=!1,this._backdrop.hide((()=>{document.body.classList.remove(Pi),this._resetAdjustments(),this._scrollBar.reset(),j.trigger(this._element,Li)}))}_showBackdrop(t){j.on(this._element,Si,(t=>{this._ignoreBackdropClick?this._ignoreBackdropClick=!1:t.target===t.currentTarget&&(!0===this._config.backdrop?this.hide():"static"===this._config.backdrop&&this._triggerBackdropTransition())})),this._backdrop.show(t)}_isAnimated(){return this._element.classList.contains("fade")}_triggerBackdropTransition(){if(j.trigger(this._element,"hidePrevented.bs.modal").defaultPrevented)return;const{classList:t,scrollHeight:e,style:i}=this._element,n=e>document.documentElement.clientHeight;!n&&"hidden"===i.overflowY||t.contains(Mi)||(n||(i.overflowY="hidden"),t.add(Mi),this._queueCallback((()=>{t.remove(Mi),n||this._queueCallback((()=>{i.overflowY=""}),this._dialog)}),this._dialog),this._element.focus())}_adjustDialog(){const t=this._element.scrollHeight>document.documentElement.clientHeight,e=this._scrollBar.getWidth(),i=e>0;(!i&&t&&!m()||i&&!t&&m())&&(this._element.style.paddingLeft=`${e}px`),(i&&!t&&!m()||!i&&t&&m())&&(this._element.style.paddingRight=`${e}px`)}_resetAdjustments(){this._element.style.paddingLeft="",this._element.style.paddingRight=""}static jQueryInterface(t,e){return this.each((function(){const i=Hi.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===i[t])throw new TypeError(`No method named "${t}"`);i[t](e)}}))}}j.on(document,"click.bs.modal.data-api",'[data-bs-toggle="modal"]',(function(t){const e=n(this);["A","AREA"].includes(this.tagName)&&t.preventDefault(),j.one(e,xi,(t=>{t.defaultPrevented||j.one(e,Li,(()=>{l(this)&&this.focus()}))}));const i=V.findOne(".modal.show");i&&Hi.getInstance(i).hide(),Hi.getOrCreateInstance(e).toggle(this)})),R(Hi),g(Hi);const Bi="offcanvas",Ri={backdrop:!0,keyboard:!0,scroll:!1},Wi={backdrop:"boolean",keyboard:"boolean",scroll:"boolean"},$i="show",zi=".offcanvas.show",qi="hidden.bs.offcanvas";class Fi extends B{constructor(t,e){super(t),this._config=this._getConfig(e),this._isShown=!1,this._backdrop=this._initializeBackDrop(),this._focustrap=this._initializeFocusTrap(),this._addEventListeners()}static get NAME(){return Bi}static get Default(){return Ri}toggle(t){return this._isShown?this.hide():this.show(t)}show(t){this._isShown||j.trigger(this._element,"show.bs.offcanvas",{relatedTarget:t}).defaultPrevented||(this._isShown=!0,this._element.style.visibility="visible",this._backdrop.show(),this._config.scroll||(new fi).hide(),this._element.removeAttribute("aria-hidden"),this._element.setAttribute("aria-modal",!0),this._element.setAttribute("role","dialog"),this._element.classList.add($i),this._queueCallback((()=>{this._config.scroll||this._focustrap.activate(),j.trigger(this._element,"shown.bs.offcanvas",{relatedTarget:t})}),this._element,!0))}hide(){this._isShown&&(j.trigger(this._element,"hide.bs.offcanvas").defaultPrevented||(this._focustrap.deactivate(),this._element.blur(),this._isShown=!1,this._element.classList.remove($i),this._backdrop.hide(),this._queueCallback((()=>{this._element.setAttribute("aria-hidden",!0),this._element.removeAttribute("aria-modal"),this._element.removeAttribute("role"),this._element.style.visibility="hidden",this._config.scroll||(new fi).reset(),j.trigger(this._element,qi)}),this._element,!0)))}dispose(){this._backdrop.dispose(),this._focustrap.deactivate(),super.dispose()}_getConfig(t){return t={...Ri,...U.getDataAttributes(this._element),..."object"==typeof t?t:{}},a(Bi,t,Wi),t}_initializeBackDrop(){return new bi({className:"offcanvas-backdrop",isVisible:this._config.backdrop,isAnimated:!0,rootElement:this._element.parentNode,clickCallback:()=>this.hide()})}_initializeFocusTrap(){return new Ai({trapElement:this._element})}_addEventListeners(){j.on(this._element,"keydown.dismiss.bs.offcanvas",(t=>{this._config.keyboard&&"Escape"===t.key&&this.hide()}))}static jQueryInterface(t){return this.each((function(){const e=Fi.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t]||t.startsWith("_")||"constructor"===t)throw new TypeError(`No method named "${t}"`);e[t](this)}}))}}j.on(document,"click.bs.offcanvas.data-api",'[data-bs-toggle="offcanvas"]',(function(t){const e=n(this);if(["A","AREA"].includes(this.tagName)&&t.preventDefault(),c(this))return;j.one(e,qi,(()=>{l(this)&&this.focus()}));const i=V.findOne(zi);i&&i!==e&&Fi.getInstance(i).hide(),Fi.getOrCreateInstance(e).toggle(this)})),j.on(window,"load.bs.offcanvas.data-api",(()=>V.find(zi).forEach((t=>Fi.getOrCreateInstance(t).show())))),R(Fi),g(Fi);const Ui=new Set(["background","cite","href","itemtype","longdesc","poster","src","xlink:href"]),Vi=/^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i,Ki=/^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i,Xi=(t,e)=>{const i=t.nodeName.toLowerCase();if(e.includes(i))return!Ui.has(i)||Boolean(Vi.test(t.nodeValue)||Ki.test(t.nodeValue));const n=e.filter((t=>t instanceof RegExp));for(let t=0,e=n.length;t<e;t++)if(n[t].test(i))return!0;return!1};function Yi(t,e,i){if(!t.length)return t;if(i&&"function"==typeof i)return i(t);const n=(new window.DOMParser).parseFromString(t,"text/html"),s=[].concat(...n.body.querySelectorAll("*"));for(let t=0,i=s.length;t<i;t++){const i=s[t],n=i.nodeName.toLowerCase();if(!Object.keys(e).includes(n)){i.remove();continue}const o=[].concat(...i.attributes),r=[].concat(e["*"]||[],e[n]||[]);o.forEach((t=>{Xi(t,r)||i.removeAttribute(t.nodeName)}))}return n.body.innerHTML}const Qi="tooltip",Gi=new Set(["sanitize","allowList","sanitizeFn"]),Zi={animation:"boolean",template:"string",title:"(string|element|function)",trigger:"string",delay:"(number|object)",html:"boolean",selector:"(string|boolean)",placement:"(string|function)",offset:"(array|string|function)",container:"(string|element|boolean)",fallbackPlacements:"array",boundary:"(string|element)",customClass:"(string|function)",sanitize:"boolean",sanitizeFn:"(null|function)",allowList:"object",popperConfig:"(null|object|function)"},Ji={AUTO:"auto",TOP:"top",RIGHT:m()?"left":"right",BOTTOM:"bottom",LEFT:m()?"right":"left"},tn={animation:!0,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,selector:!1,placement:"top",offset:[0,0],container:!1,fallbackPlacements:["top","right","bottom","left"],boundary:"clippingParents",customClass:"",sanitize:!0,sanitizeFn:null,allowList:{"*":["class","dir","id","lang","role",/^aria-[\w-]*$/i],a:["target","href","title","rel"],area:[],b:[],br:[],col:[],code:[],div:[],em:[],hr:[],h1:[],h2:[],h3:[],h4:[],h5:[],h6:[],i:[],img:["src","srcset","alt","title","width","height"],li:[],ol:[],p:[],pre:[],s:[],small:[],span:[],sub:[],sup:[],strong:[],u:[],ul:[]},popperConfig:null},en={HIDE:"hide.bs.tooltip",HIDDEN:"hidden.bs.tooltip",SHOW:"show.bs.tooltip",SHOWN:"shown.bs.tooltip",INSERTED:"inserted.bs.tooltip",CLICK:"click.bs.tooltip",FOCUSIN:"focusin.bs.tooltip",FOCUSOUT:"focusout.bs.tooltip",MOUSEENTER:"mouseenter.bs.tooltip",MOUSELEAVE:"mouseleave.bs.tooltip"},nn="fade",sn="show",on="show",rn="out",an=".tooltip-inner",ln=".modal",cn="hide.bs.modal",hn="hover",dn="focus";class un extends B{constructor(t,e){if(void 0===Fe)throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");super(t),this._isEnabled=!0,this._timeout=0,this._hoverState="",this._activeTrigger={},this._popper=null,this._config=this._getConfig(e),this.tip=null,this._setListeners()}static get Default(){return tn}static get NAME(){return Qi}static get Event(){return en}static get DefaultType(){return Zi}enable(){this._isEnabled=!0}disable(){this._isEnabled=!1}toggleEnabled(){this._isEnabled=!this._isEnabled}toggle(t){if(this._isEnabled)if(t){const e=this._initializeOnDelegatedTarget(t);e._activeTrigger.click=!e._activeTrigger.click,e._isWithActiveTrigger()?e._enter(null,e):e._leave(null,e)}else{if(this.getTipElement().classList.contains(sn))return void this._leave(null,this);this._enter(null,this)}}dispose(){clearTimeout(this._timeout),j.off(this._element.closest(ln),cn,this._hideModalHandler),this.tip&&this.tip.remove(),this._disposePopper(),super.dispose()}show(){if("none"===this._element.style.display)throw new Error("Please use show on visible elements");if(!this.isWithContent()||!this._isEnabled)return;const t=j.trigger(this._element,this.constructor.Event.SHOW),e=h(this._element),i=null===e?this._element.ownerDocument.documentElement.contains(this._element):e.contains(this._element);if(t.defaultPrevented||!i)return;"tooltip"===this.constructor.NAME&&this.tip&&this.getTitle()!==this.tip.querySelector(an).innerHTML&&(this._disposePopper(),this.tip.remove(),this.tip=null);const n=this.getTipElement(),s=(t=>{do{t+=Math.floor(1e6*Math.random())}while(document.getElementById(t));return t})(this.constructor.NAME);n.setAttribute("id",s),this._element.setAttribute("aria-describedby",s),this._config.animation&&n.classList.add(nn);const o="function"==typeof this._config.placement?this._config.placement.call(this,n,this._element):this._config.placement,r=this._getAttachment(o);this._addAttachmentClass(r);const{container:a}=this._config;H.set(n,this.constructor.DATA_KEY,this),this._element.ownerDocument.documentElement.contains(this.tip)||(a.append(n),j.trigger(this._element,this.constructor.Event.INSERTED)),this._popper?this._popper.update():this._popper=qe(this._element,n,this._getPopperConfig(r)),n.classList.add(sn);const l=this._resolvePossibleFunction(this._config.customClass);l&&n.classList.add(...l.split(" ")),"ontouchstart"in document.documentElement&&[].concat(...document.body.children).forEach((t=>{j.on(t,"mouseover",d)}));const c=this.tip.classList.contains(nn);this._queueCallback((()=>{const t=this._hoverState;this._hoverState=null,j.trigger(this._element,this.constructor.Event.SHOWN),t===rn&&this._leave(null,this)}),this.tip,c)}hide(){if(!this._popper)return;const t=this.getTipElement();if(j.trigger(this._element,this.constructor.Event.HIDE).defaultPrevented)return;t.classList.remove(sn),"ontouchstart"in document.documentElement&&[].concat(...document.body.children).forEach((t=>j.off(t,"mouseover",d))),this._activeTrigger.click=!1,this._activeTrigger.focus=!1,this._activeTrigger.hover=!1;const e=this.tip.classList.contains(nn);this._queueCallback((()=>{this._isWithActiveTrigger()||(this._hoverState!==on&&t.remove(),this._cleanTipClass(),this._element.removeAttribute("aria-describedby"),j.trigger(this._element,this.constructor.Event.HIDDEN),this._disposePopper())}),this.tip,e),this._hoverState=""}update(){null!==this._popper&&this._popper.update()}isWithContent(){return Boolean(this.getTitle())}getTipElement(){if(this.tip)return this.tip;const t=document.createElement("div");t.innerHTML=this._config.template;const e=t.children[0];return this.setContent(e),e.classList.remove(nn,sn),this.tip=e,this.tip}setContent(t){this._sanitizeAndSetContent(t,this.getTitle(),an)}_sanitizeAndSetContent(t,e,i){const n=V.findOne(i,t);e||!n?this.setElementContent(n,e):n.remove()}setElementContent(t,e){if(null!==t)return o(e)?(e=r(e),void(this._config.html?e.parentNode!==t&&(t.innerHTML="",t.append(e)):t.textContent=e.textContent)):void(this._config.html?(this._config.sanitize&&(e=Yi(e,this._config.allowList,this._config.sanitizeFn)),t.innerHTML=e):t.textContent=e)}getTitle(){const t=this._element.getAttribute("data-bs-original-title")||this._config.title;return this._resolvePossibleFunction(t)}updateAttachment(t){return"right"===t?"end":"left"===t?"start":t}_initializeOnDelegatedTarget(t,e){return e||this.constructor.getOrCreateInstance(t.delegateTarget,this._getDelegateConfig())}_getOffset(){const{offset:t}=this._config;return"string"==typeof t?t.split(",").map((t=>Number.parseInt(t,10))):"function"==typeof t?e=>t(e,this._element):t}_resolvePossibleFunction(t){return"function"==typeof t?t.call(this._element):t}_getPopperConfig(t){const e={placement:t,modifiers:[{name:"flip",options:{fallbackPlacements:this._config.fallbackPlacements}},{name:"offset",options:{offset:this._getOffset()}},{name:"preventOverflow",options:{boundary:this._config.boundary}},{name:"arrow",options:{element:`.${this.constructor.NAME}-arrow`}},{name:"onChange",enabled:!0,phase:"afterWrite",fn:t=>this._handlePopperPlacementChange(t)}],onFirstUpdate:t=>{t.options.placement!==t.placement&&this._handlePopperPlacementChange(t)}};return{...e,..."function"==typeof this._config.popperConfig?this._config.popperConfig(e):this._config.popperConfig}}_addAttachmentClass(t){this.getTipElement().classList.add(`${this._getBasicClassPrefix()}-${this.updateAttachment(t)}`)}_getAttachment(t){return Ji[t.toUpperCase()]}_setListeners(){this._config.trigger.split(" ").forEach((t=>{if("click"===t)j.on(this._element,this.constructor.Event.CLICK,this._config.selector,(t=>this.toggle(t)));else if("manual"!==t){const e=t===hn?this.constructor.Event.MOUSEENTER:this.constructor.Event.FOCUSIN,i=t===hn?this.constructor.Event.MOUSELEAVE:this.constructor.Event.FOCUSOUT;j.on(this._element,e,this._config.selector,(t=>this._enter(t))),j.on(this._element,i,this._config.selector,(t=>this._leave(t)))}})),this._hideModalHandler=()=>{this._element&&this.hide()},j.on(this._element.closest(ln),cn,this._hideModalHandler),this._config.selector?this._config={...this._config,trigger:"manual",selector:""}:this._fixTitle()}_fixTitle(){const t=this._element.getAttribute("title"),e=typeof this._element.getAttribute("data-bs-original-title");(t||"string"!==e)&&(this._element.setAttribute("data-bs-original-title",t||""),!t||this._element.getAttribute("aria-label")||this._element.textContent||this._element.setAttribute("aria-label",t),this._element.setAttribute("title",""))}_enter(t,e){e=this._initializeOnDelegatedTarget(t,e),t&&(e._activeTrigger["focusin"===t.type?dn:hn]=!0),e.getTipElement().classList.contains(sn)||e._hoverState===on?e._hoverState=on:(clearTimeout(e._timeout),e._hoverState=on,e._config.delay&&e._config.delay.show?e._timeout=setTimeout((()=>{e._hoverState===on&&e.show()}),e._config.delay.show):e.show())}_leave(t,e){e=this._initializeOnDelegatedTarget(t,e),t&&(e._activeTrigger["focusout"===t.type?dn:hn]=e._element.contains(t.relatedTarget)),e._isWithActiveTrigger()||(clearTimeout(e._timeout),e._hoverState=rn,e._config.delay&&e._config.delay.hide?e._timeout=setTimeout((()=>{e._hoverState===rn&&e.hide()}),e._config.delay.hide):e.hide())}_isWithActiveTrigger(){for(const t in this._activeTrigger)if(this._activeTrigger[t])return!0;return!1}_getConfig(t){const e=U.getDataAttributes(this._element);return Object.keys(e).forEach((t=>{Gi.has(t)&&delete e[t]})),(t={...this.constructor.Default,...e,..."object"==typeof t&&t?t:{}}).container=!1===t.container?document.body:r(t.container),"number"==typeof t.delay&&(t.delay={show:t.delay,hide:t.delay}),"number"==typeof t.title&&(t.title=t.title.toString()),"number"==typeof t.content&&(t.content=t.content.toString()),a(Qi,t,this.constructor.DefaultType),t.sanitize&&(t.template=Yi(t.template,t.allowList,t.sanitizeFn)),t}_getDelegateConfig(){const t={};for(const e in this._config)this.constructor.Default[e]!==this._config[e]&&(t[e]=this._config[e]);return t}_cleanTipClass(){const t=this.getTipElement(),e=new RegExp(`(^|\\s)${this._getBasicClassPrefix()}\\S+`,"g"),i=t.getAttribute("class").match(e);null!==i&&i.length>0&&i.map((t=>t.trim())).forEach((e=>t.classList.remove(e)))}_getBasicClassPrefix(){return"bs-tooltip"}_handlePopperPlacementChange(t){const{state:e}=t;e&&(this.tip=e.elements.popper,this._cleanTipClass(),this._addAttachmentClass(this._getAttachment(e.placement)))}_disposePopper(){this._popper&&(this._popper.destroy(),this._popper=null)}static jQueryInterface(t){return this.each((function(){const e=un.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t]()}}))}}g(un);const fn={...un.Default,placement:"right",offset:[0,8],trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'},pn={...un.DefaultType,content:"(string|element|function)"},mn={HIDE:"hide.bs.popover",HIDDEN:"hidden.bs.popover",SHOW:"show.bs.popover",SHOWN:"shown.bs.popover",INSERTED:"inserted.bs.popover",CLICK:"click.bs.popover",FOCUSIN:"focusin.bs.popover",FOCUSOUT:"focusout.bs.popover",MOUSEENTER:"mouseenter.bs.popover",MOUSELEAVE:"mouseleave.bs.popover"};class gn extends un{static get Default(){return fn}static get NAME(){return"popover"}static get Event(){return mn}static get DefaultType(){return pn}isWithContent(){return this.getTitle()||this._getContent()}setContent(t){this._sanitizeAndSetContent(t,this.getTitle(),".popover-header"),this._sanitizeAndSetContent(t,this._getContent(),".popover-body")}_getContent(){return this._resolvePossibleFunction(this._config.content)}_getBasicClassPrefix(){return"bs-popover"}static jQueryInterface(t){return this.each((function(){const e=gn.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t]()}}))}}g(gn);const _n="scrollspy",bn={offset:10,method:"auto",target:""},vn={offset:"number",method:"string",target:"(string|element)"},yn="active",wn=".nav-link, .list-group-item, .dropdown-item",En="position";class An extends B{constructor(t,e){super(t),this._scrollElement="BODY"===this._element.tagName?window:this._element,this._config=this._getConfig(e),this._offsets=[],this._targets=[],this._activeTarget=null,this._scrollHeight=0,j.on(this._scrollElement,"scroll.bs.scrollspy",(()=>this._process())),this.refresh(),this._process()}static get Default(){return bn}static get NAME(){return _n}refresh(){const t=this._scrollElement===this._scrollElement.window?"offset":En,e="auto"===this._config.method?t:this._config.method,n=e===En?this._getScrollTop():0;this._offsets=[],this._targets=[],this._scrollHeight=this._getScrollHeight(),V.find(wn,this._config.target).map((t=>{const s=i(t),o=s?V.findOne(s):null;if(o){const t=o.getBoundingClientRect();if(t.width||t.height)return[U[e](o).top+n,s]}return null})).filter((t=>t)).sort(((t,e)=>t[0]-e[0])).forEach((t=>{this._offsets.push(t[0]),this._targets.push(t[1])}))}dispose(){j.off(this._scrollElement,".bs.scrollspy"),super.dispose()}_getConfig(t){return(t={...bn,...U.getDataAttributes(this._element),..."object"==typeof t&&t?t:{}}).target=r(t.target)||document.documentElement,a(_n,t,vn),t}_getScrollTop(){return this._scrollElement===window?this._scrollElement.pageYOffset:this._scrollElement.scrollTop}_getScrollHeight(){return this._scrollElement.scrollHeight||Math.max(document.body.scrollHeight,document.documentElement.scrollHeight)}_getOffsetHeight(){return this._scrollElement===window?window.innerHeight:this._scrollElement.getBoundingClientRect().height}_process(){const t=this._getScrollTop()+this._config.offset,e=this._getScrollHeight(),i=this._config.offset+e-this._getOffsetHeight();if(this._scrollHeight!==e&&this.refresh(),t>=i){const t=this._targets[this._targets.length-1];this._activeTarget!==t&&this._activate(t)}else{if(this._activeTarget&&t<this._offsets[0]&&this._offsets[0]>0)return this._activeTarget=null,void this._clear();for(let e=this._offsets.length;e--;)this._activeTarget!==this._targets[e]&&t>=this._offsets[e]&&(void 0===this._offsets[e+1]||t<this._offsets[e+1])&&this._activate(this._targets[e])}}_activate(t){this._activeTarget=t,this._clear();const e=wn.split(",").map((e=>`${e}[data-bs-target="${t}"],${e}[href="${t}"]`)),i=V.findOne(e.join(","),this._config.target);i.classList.add(yn),i.classList.contains("dropdown-item")?V.findOne(".dropdown-toggle",i.closest(".dropdown")).classList.add(yn):V.parents(i,".nav, .list-group").forEach((t=>{V.prev(t,".nav-link, .list-group-item").forEach((t=>t.classList.add(yn))),V.prev(t,".nav-item").forEach((t=>{V.children(t,".nav-link").forEach((t=>t.classList.add(yn)))}))})),j.trigger(this._scrollElement,"activate.bs.scrollspy",{relatedTarget:t})}_clear(){V.find(wn,this._config.target).filter((t=>t.classList.contains(yn))).forEach((t=>t.classList.remove(yn)))}static jQueryInterface(t){return this.each((function(){const e=An.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t]()}}))}}j.on(window,"load.bs.scrollspy.data-api",(()=>{V.find('[data-bs-spy="scroll"]').forEach((t=>new An(t)))})),g(An);const Tn="active",On="fade",Cn="show",kn=".active",Ln=":scope > li > .active";class xn extends B{static get NAME(){return"tab"}show(){if(this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE&&this._element.classList.contains(Tn))return;let t;const e=n(this._element),i=this._element.closest(".nav, .list-group");if(i){const e="UL"===i.nodeName||"OL"===i.nodeName?Ln:kn;t=V.find(e,i),t=t[t.length-1]}const s=t?j.trigger(t,"hide.bs.tab",{relatedTarget:this._element}):null;if(j.trigger(this._element,"show.bs.tab",{relatedTarget:t}).defaultPrevented||null!==s&&s.defaultPrevented)return;this._activate(this._element,i);const o=()=>{j.trigger(t,"hidden.bs.tab",{relatedTarget:this._element}),j.trigger(this._element,"shown.bs.tab",{relatedTarget:t})};e?this._activate(e,e.parentNode,o):o()}_activate(t,e,i){const n=(!e||"UL"!==e.nodeName&&"OL"!==e.nodeName?V.children(e,kn):V.find(Ln,e))[0],s=i&&n&&n.classList.contains(On),o=()=>this._transitionComplete(t,n,i);n&&s?(n.classList.remove(Cn),this._queueCallback(o,t,!0)):o()}_transitionComplete(t,e,i){if(e){e.classList.remove(Tn);const t=V.findOne(":scope > .dropdown-menu .active",e.parentNode);t&&t.classList.remove(Tn),"tab"===e.getAttribute("role")&&e.setAttribute("aria-selected",!1)}t.classList.add(Tn),"tab"===t.getAttribute("role")&&t.setAttribute("aria-selected",!0),u(t),t.classList.contains(On)&&t.classList.add(Cn);let n=t.parentNode;if(n&&"LI"===n.nodeName&&(n=n.parentNode),n&&n.classList.contains("dropdown-menu")){const e=t.closest(".dropdown");e&&V.find(".dropdown-toggle",e).forEach((t=>t.classList.add(Tn))),t.setAttribute("aria-expanded",!0)}i&&i()}static jQueryInterface(t){return this.each((function(){const e=xn.getOrCreateInstance(this);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t]()}}))}}j.on(document,"click.bs.tab.data-api",'[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]',(function(t){["A","AREA"].includes(this.tagName)&&t.preventDefault(),c(this)||xn.getOrCreateInstance(this).show()})),g(xn);const Dn="toast",Sn="hide",Nn="show",In="showing",Pn={animation:"boolean",autohide:"boolean",delay:"number"},jn={animation:!0,autohide:!0,delay:5e3};class Mn extends B{constructor(t,e){super(t),this._config=this._getConfig(e),this._timeout=null,this._hasMouseInteraction=!1,this._hasKeyboardInteraction=!1,this._setListeners()}static get DefaultType(){return Pn}static get Default(){return jn}static get NAME(){return Dn}show(){j.trigger(this._element,"show.bs.toast").defaultPrevented||(this._clearTimeout(),this._config.animation&&this._element.classList.add("fade"),this._element.classList.remove(Sn),u(this._element),this._element.classList.add(Nn),this._element.classList.add(In),this._queueCallback((()=>{this._element.classList.remove(In),j.trigger(this._element,"shown.bs.toast"),this._maybeScheduleHide()}),this._element,this._config.animation))}hide(){this._element.classList.contains(Nn)&&(j.trigger(this._element,"hide.bs.toast").defaultPrevented||(this._element.classList.add(In),this._queueCallback((()=>{this._element.classList.add(Sn),this._element.classList.remove(In),this._element.classList.remove(Nn),j.trigger(this._element,"hidden.bs.toast")}),this._element,this._config.animation)))}dispose(){this._clearTimeout(),this._element.classList.contains(Nn)&&this._element.classList.remove(Nn),super.dispose()}_getConfig(t){return t={...jn,...U.getDataAttributes(this._element),..."object"==typeof t&&t?t:{}},a(Dn,t,this.constructor.DefaultType),t}_maybeScheduleHide(){this._config.autohide&&(this._hasMouseInteraction||this._hasKeyboardInteraction||(this._timeout=setTimeout((()=>{this.hide()}),this._config.delay)))}_onInteraction(t,e){switch(t.type){case"mouseover":case"mouseout":this._hasMouseInteraction=e;break;case"focusin":case"focusout":this._hasKeyboardInteraction=e}if(e)return void this._clearTimeout();const i=t.relatedTarget;this._element===i||this._element.contains(i)||this._maybeScheduleHide()}_setListeners(){j.on(this._element,"mouseover.bs.toast",(t=>this._onInteraction(t,!0))),j.on(this._element,"mouseout.bs.toast",(t=>this._onInteraction(t,!1))),j.on(this._element,"focusin.bs.toast",(t=>this._onInteraction(t,!0))),j.on(this._element,"focusout.bs.toast",(t=>this._onInteraction(t,!1)))}_clearTimeout(){clearTimeout(this._timeout),this._timeout=null}static jQueryInterface(t){return this.each((function(){const e=Mn.getOrCreateInstance(this,t);if("string"==typeof t){if(void 0===e[t])throw new TypeError(`No method named "${t}"`);e[t](this)}}))}}return R(Mn),g(Mn),{Alert:W,Button:z,Carousel:st,Collapse:pt,Dropdown:hi,Modal:Hi,Offcanvas:Fi,Popover:gn,ScrollSpy:An,Tab:xn,Toast:Mn,Tooltip:un}}));
//# sourceMappingURL=bootstrap.bundle.min.js.map
/*! Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")

You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.

See the License for the specific language governing permissions and limitations under the License.
 */
!(function (e, t) {
	'object' == typeof exports && 'object' == typeof module
		? (module.exports = t())
		: 'function' == typeof define && define.amd
		? define([], t)
		: 'object' == typeof exports
		? (exports.OktaSignIn = t())
		: (e.OktaSignIn = t());
})(self, function () {
	return (function () {
		var e = {
				72284: function (e, t, n) {
					'use strict';
					var r = n(12990),
						o = n(66583),
						i = {
							days: function (e) {
								return 864e5 * e;
							},
							hours: function (e) {
								return 36e5 * e;
							},
							minutes: function (e) {
								return 6e4 * e;
							},
							seconds: function (e) {
								return 1e3 * e;
							},
							milliseconds: function (e) {
								return e;
							},
							microseconds: function (e) {
								return e / 1e3;
							},
							nanoseconds: function (e) {
								return e / 1e6;
							},
						},
						a = function (e) {
							return Object.entries(e).reduce(function (e, t) {
								var n = o(t, 2),
									a = n[0],
									s = n[1];
								if ('number' != typeof s)
									throw new TypeError(
										'Expected a `number` for key `'.concat(a, '`, got `').concat(s, '` (').concat(r(s), ')')
									);
								if (!i[a]) throw new Error('Unsupported time key');
								return e + i[a](s);
							}, 0);
						};
					(e.exports = a), (e.exports.default = a);
				},
				67820: function (e) {
					'use strict';
					e.exports = function (e) {
						if ('number' != typeof e) throw new TypeError('Expected a number');
						var t = e > 0 ? Math.floor : Math.ceil;
						return {
							days: t(e / 864e5),
							hours: t(e / 36e5) % 24,
							minutes: t(e / 6e4) % 60,
							seconds: t(e / 1e3) % 60,
							milliseconds: t(e) % 1e3,
							microseconds: t(1e3 * e) % 1e3,
							nanoseconds: t(1e6 * e) % 1e3,
						};
					};
				},
				22603: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.commonjsGlobal = void 0),
						(t.getDefaultExportFromCjs = function (e) {
							return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, 'default') ? e.default : e;
						});
					var n =
						'undefined' != typeof globalThis
							? globalThis
							: 'undefined' != typeof window
							? window
							: 'undefined' != typeof global
							? global
							: 'undefined' != typeof self
							? self
							: {};
					t.commonjsGlobal = n;
				},
				59098: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.b = void 0);
					t.b = { exports: {} };
				},
				76222: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.__exports = void 0);
					t.__exports = {};
				},
				33530: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.b = void 0);
					t.b = { exports: {} };
				},
				88287: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.__exports = void 0);
					t.__exports = {};
				},
				60381: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.__exports = void 0);
					t.__exports = {};
				},
				31178: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.e = void 0);
					t.e = { exports: {} };
				},
				39338: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.e = void 0);
					t.e = { exports: {} };
				},
				99185: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.h = void 0);
					t.h = { exports: {} };
				},
				49982: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.h = void 0);
					t.h = { exports: {} };
				},
				77666: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.__exports = void 0);
					t.__exports = {};
				},
				67196: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t._ = void 0);
					t._ = { exports: {} };
				},
				51822: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.i = void 0);
					t.i = { exports: {} };
				},
				89278: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.j = void 0);
					t.j = { exports: {} };
				},
				1701: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.l = void 0);
					t.l = { exports: {} };
				},
				90147: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.l = void 0);
					t.l = { exports: {} };
				},
				45057: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.l = void 0);
					t.l = { exports: {} };
				},
				64827: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.n = void 0);
					t.n = { exports: {} };
				},
				58324: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.__exports = void 0);
					t.__exports = {};
				},
				82971: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.__exports = void 0);
					t.__exports = {};
				},
				95882: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.s = void 0);
					t.s = { exports: {} };
				},
				3206: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.u = void 0);
					t.u = { exports: {} };
				},
				82014: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.__exports = void 0);
					t.__exports = {};
				},
				59575: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t._ = void 0);
					t._ = { exports: {} };
				},
				21795: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.__exports = void 0);
					t.__exports = {};
				},
				2875: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(22603),
						o = n(99185);
					n(81585), n(85187), n(79267), n(30227), n(29622), n(56470);
					var i = n(76222),
						a = n(82014),
						s = n(82971),
						l = n(39338),
						u = n(64827),
						c = n(95882);
					!(function (e, t) {
						function n(e) {
							return e && e.__esModule ? e : { default: e };
						}
						function r(e) {
							if (e && e.__esModule) return e;
							var t = {};
							if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
							return (t.default = e), t;
						}
						t.__esModule = !0;
						var o = r(i.__exports),
							d = n(c.s.exports),
							f = n(l.e.exports),
							p = r(a.__exports),
							h = r(s.__exports),
							m = n(u.n.exports);
						function v() {
							var e = new o.HandlebarsEnvironment();
							return (
								p.extend(e, o),
								(e.SafeString = d.default),
								(e.Exception = f.default),
								(e.Utils = p),
								(e.escapeExpression = p.escapeExpression),
								(e.VM = h),
								(e.template = function (t) {
									return h.template(t, e);
								}),
								e
							);
						}
						var g = v();
						(g.create = v), m.default(g), (g.default = g), (t.default = g), (e.exports = t.default);
					})(o.h, o.h.exports);
					var d = (0, r.getDefaultExportFromCjs)(o.h.exports);
					(t.default = d), (e.exports = t.default);
				},
				81585: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }),
						Object.defineProperty(t, 'default', {
							enumerable: !0,
							get: function () {
								return r.__exports;
							},
						});
					var r = n(76222);
					n(30227), n(79267), n(60979), n(87390), n(9656), n(61443);
					var o = n(82014),
						i = n(58324),
						a = n(77666),
						s = n(60381),
						l = n(90147),
						u = n(39338);
					function c(e) {
						return e && e.__esModule ? e : { default: e };
					}
					(r.__exports.__esModule = !0), (r.__exports.HandlebarsEnvironment = y);
					var d = o.__exports,
						f = c(u.e.exports),
						p = a.__exports,
						h = s.__exports,
						m = c(l.l.exports),
						v = i.__exports;
					r.__exports.VERSION = '4.7.7';
					r.__exports.COMPILER_REVISION = 8;
					r.__exports.LAST_COMPATIBLE_COMPILER_REVISION = 7;
					r.__exports.REVISION_CHANGES = {
						1: '<= 1.0.rc.2',
						2: '== 1.0.0-rc.3',
						3: '== 1.0.0-rc.4',
						4: '== 1.x.x',
						5: '== 2.0.0-alpha.x',
						6: '>= 2.0.0-beta.1',
						7: '>= 4.0.0 <4.3.0',
						8: '>= 4.3.0',
					};
					var g = '[object Object]';
					function y(e, t, n) {
						(this.helpers = e || {}),
							(this.partials = t || {}),
							(this.decorators = n || {}),
							p.registerDefaultHelpers(this),
							h.registerDefaultDecorators(this);
					}
					y.prototype = {
						constructor: y,
						logger: m.default,
						log: m.default.log,
						registerHelper: function (e, t) {
							if (d.toString.call(e) === g) {
								if (t) throw new f.default('Arg not supported with multiple helpers');
								d.extend(this.helpers, e);
							} else this.helpers[e] = t;
						},
						unregisterHelper: function (e) {
							delete this.helpers[e];
						},
						registerPartial: function (e, t) {
							if (d.toString.call(e) === g) d.extend(this.partials, e);
							else {
								if (void 0 === t)
									throw new f.default('Attempting to register a partial called "' + e + '" as undefined');
								this.partials[e] = t;
							}
						},
						unregisterPartial: function (e) {
							delete this.partials[e];
						},
						registerDecorator: function (e, t) {
							if (d.toString.call(e) === g) {
								if (t) throw new f.default('Arg not supported with multiple decorators');
								d.extend(this.decorators, e);
							} else this.decorators[e] = t;
						},
						unregisterDecorator: function (e) {
							delete this.decorators[e];
						},
						resetLoggedPropertyAccesses: function () {
							v.resetLoggedProperties();
						},
					};
					var b = m.default.log;
					(r.__exports.log = b),
						(r.__exports.createFrame = d.createFrame),
						(r.__exports.logger = m.default),
						(e.exports = t.default);
				},
				87390: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }),
						Object.defineProperty(t, 'default', {
							enumerable: !0,
							get: function () {
								return r.__exports;
							},
						});
					var r = n(60381);
					n(17512);
					var o = n(51822);
					(r.__exports.__esModule = !0),
						(r.__exports.registerDefaultDecorators = function (e) {
							s.default(e);
						});
					var i,
						a = o.i.exports,
						s = (i = a) && i.__esModule ? i : { default: i };
					e.exports = t.default;
				},
				17512: function (e, t, n) {
					'use strict';
					var r = n(51822);
					n(30227);
					var o = n(82014);
					!(function (e, t) {
						t.__esModule = !0;
						var n = o.__exports;
						(t.default = function (e) {
							e.registerDecorator('inline', function (e, t, r, o) {
								var i = e;
								return (
									t.partials ||
										((t.partials = {}),
										(i = function (o, i) {
											var a = r.partials;
											r.partials = n.extend({}, a, t.partials);
											var s = e(o, i);
											return (r.partials = a), s;
										})),
									(t.partials[o.args[0]] = o.fn),
									i
								);
							});
						}),
							(e.exports = t.default);
					})(r.i, r.i.exports);
				},
				79267: function (e, t, n) {
					'use strict';
					var r = n(39338);
					!(function (e, t) {
						t.__esModule = !0;
						var n = ['description', 'fileName', 'lineNumber', 'endLineNumber', 'message', 'name', 'number', 'stack'];
						function r(e, t) {
							var o = t && t.loc,
								i = void 0,
								a = void 0,
								s = void 0,
								l = void 0;
							o &&
								((i = o.start.line),
								(a = o.end.line),
								(s = o.start.column),
								(l = o.end.column),
								(e += ' - ' + i + ':' + s));
							for (var u = Error.prototype.constructor.call(this, e), c = 0; c < n.length; c++) this[n[c]] = u[n[c]];
							Error.captureStackTrace && Error.captureStackTrace(this, r);
							try {
								o &&
									((this.lineNumber = i),
									(this.endLineNumber = a),
									Object.defineProperty
										? (Object.defineProperty(this, 'column', { value: s, enumerable: !0 }),
										  Object.defineProperty(this, 'endColumn', { value: l, enumerable: !0 }))
										: ((this.column = s), (this.endColumn = l)));
							} catch (e) {}
						}
						(r.prototype = new Error()), (t.default = r), (e.exports = t.default);
					})(r.e, r.e.exports);
				},
				60979: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }),
						Object.defineProperty(t, 'default', {
							enumerable: !0,
							get: function () {
								return r.__exports;
							},
						});
					var r = n(77666);
					n(3603), n(9907), n(70891), n(47437), n(40774), n(27004), n(95614);
					var o = n(31178),
						i = n(49982),
						a = n(67196),
						s = n(1701),
						l = n(45057),
						u = n(59575),
						c = n(33530);
					function d(e) {
						return e && e.__esModule ? e : { default: e };
					}
					(r.__exports.__esModule = !0),
						(r.__exports.registerDefaultHelpers = function (e) {
							f.default(e), p.default(e), h.default(e), m.default(e), v.default(e), g.default(e), y.default(e);
						}),
						(r.__exports.moveHelperToHooks = function (e, t, n) {
							e.helpers[t] && ((e.hooks[t] = e.helpers[t]), n || delete e.helpers[t]);
						});
					var f = d(c.b.exports),
						p = d(o.e.exports),
						h = d(i.h.exports),
						m = d(a._.exports),
						v = d(s.l.exports),
						g = d(l.l.exports),
						y = d(u._.exports);
					e.exports = t.default;
				},
				3603: function (e, t, n) {
					'use strict';
					var r = n(33530);
					n(30227);
					var o = n(82014);
					!(function (e, t) {
						t.__esModule = !0;
						var n = o.__exports;
						(t.default = function (e) {
							e.registerHelper('blockHelperMissing', function (t, r) {
								var o = r.inverse,
									i = r.fn;
								if (!0 === t) return i(this);
								if (!1 === t || null == t) return o(this);
								if (n.isArray(t)) return t.length > 0 ? (r.ids && (r.ids = [r.name]), e.helpers.each(t, r)) : o(this);
								if (r.data && r.ids) {
									var a = n.createFrame(r.data);
									(a.contextPath = n.appendContextPath(r.data.contextPath, r.name)), (r = { data: a });
								}
								return i(t, r);
							});
						}),
							(e.exports = t.default);
					})(r.b, r.b.exports);
				},
				9907: function (e, t, n) {
					'use strict';
					var r = n(1654)(n(12990)),
						o = n(22603),
						i = n(31178);
					n(30227), n(79267);
					var a = n(82014),
						s = n(39338);
					!(function (e, t) {
						t.__esModule = !0;
						var n,
							i = a.__exports,
							l = s.e.exports,
							u = (n = l) && n.__esModule ? n : { default: n };
						(t.default = function (e) {
							e.registerHelper('each', function (e, t) {
								if (!t) throw new u.default('Must pass iterator to #each');
								var n,
									a = t.fn,
									s = t.inverse,
									l = 0,
									c = '',
									d = void 0,
									f = void 0;
								function p(t, n, r) {
									d && ((d.key = t), (d.index = n), (d.first = 0 === n), (d.last = !!r), f && (d.contextPath = f + t)),
										(c += a(e[t], { data: d, blockParams: i.blockParams([e[t], t], [f + t, null]) }));
								}
								if (
									(t.data && t.ids && (f = i.appendContextPath(t.data.contextPath, t.ids[0]) + '.'),
									i.isFunction(e) && (e = e.call(this)),
									t.data && (d = i.createFrame(t.data)),
									e && 'object' === (0, r.default)(e))
								)
									if (i.isArray(e)) for (var h = e.length; l < h; l++) l in e && p(l, l, l === e.length - 1);
									else if (o.commonjsGlobal.Symbol && e[o.commonjsGlobal.Symbol.iterator]) {
										for (var m = [], v = e[o.commonjsGlobal.Symbol.iterator](), g = v.next(); !g.done; g = v.next())
											m.push(g.value);
										for (h = (e = m).length; l < h; l++) p(l, l, l === e.length - 1);
									} else
										(n = void 0),
											Object.keys(e).forEach(function (e) {
												void 0 !== n && p(n, l - 1), (n = e), l++;
											}),
											void 0 !== n && p(n, l - 1, !0);
								return 0 === l && (c = s(this)), c;
							});
						}),
							(e.exports = t.default);
					})(i.e, i.e.exports);
				},
				70891: function (e, t, n) {
					'use strict';
					var r = n(49982);
					n(79267);
					var o = n(39338);
					!(function (e, t) {
						t.__esModule = !0;
						var n,
							r = o.e.exports,
							i = (n = r) && n.__esModule ? n : { default: n };
						(t.default = function (e) {
							e.registerHelper('helperMissing', function () {
								if (1 !== arguments.length)
									throw new i.default('Missing helper: "' + arguments[arguments.length - 1].name + '"');
							});
						}),
							(e.exports = t.default);
					})(r.h, r.h.exports);
				},
				47437: function (e, t, n) {
					'use strict';
					var r = n(67196);
					n(30227), n(79267);
					var o = n(82014),
						i = n(39338);
					!(function (e, t) {
						t.__esModule = !0;
						var n,
							r = o.__exports,
							a = i.e.exports,
							s = (n = a) && n.__esModule ? n : { default: n };
						(t.default = function (e) {
							e.registerHelper('if', function (e, t) {
								if (2 != arguments.length) throw new s.default('#if requires exactly one argument');
								return (
									r.isFunction(e) && (e = e.call(this)),
									(!t.hash.includeZero && !e) || r.isEmpty(e) ? t.inverse(this) : t.fn(this)
								);
							}),
								e.registerHelper('unless', function (t, n) {
									if (2 != arguments.length) throw new s.default('#unless requires exactly one argument');
									return e.helpers.if.call(this, t, { fn: n.inverse, inverse: n.fn, hash: n.hash });
								});
						}),
							(e.exports = t.default);
					})(r._, r._.exports);
				},
				40774: function (e, t, n) {
					'use strict';
					var r = n(1701);
					!(function (e, t) {
						(t.__esModule = !0),
							(t.default = function (e) {
								e.registerHelper('log', function () {
									for (var t = [void 0], n = arguments[arguments.length - 1], r = 0; r < arguments.length - 1; r++)
										t.push(arguments[r]);
									var o = 1;
									null != n.hash.level ? (o = n.hash.level) : n.data && null != n.data.level && (o = n.data.level),
										(t[0] = o),
										e.log.apply(e, t);
								});
							}),
							(e.exports = t.default);
					})(r.l, r.l.exports);
				},
				27004: function (e, t, n) {
					'use strict';
					var r = n(45057);
					!(function (e, t) {
						(t.__esModule = !0),
							(t.default = function (e) {
								e.registerHelper('lookup', function (e, t, n) {
									return e ? n.lookupProperty(e, t) : e;
								});
							}),
							(e.exports = t.default);
					})(r.l, r.l.exports);
				},
				95614: function (e, t, n) {
					'use strict';
					var r = n(59575);
					n(30227), n(79267);
					var o = n(82014),
						i = n(39338);
					!(function (e, t) {
						t.__esModule = !0;
						var n,
							r = o.__exports,
							a = i.e.exports,
							s = (n = a) && n.__esModule ? n : { default: n };
						(t.default = function (e) {
							e.registerHelper('with', function (e, t) {
								if (2 != arguments.length) throw new s.default('#with requires exactly one argument');
								r.isFunction(e) && (e = e.call(this));
								var n = t.fn;
								if (r.isEmpty(e)) return t.inverse(this);
								var o = t.data;
								return (
									t.data &&
										t.ids &&
										((o = r.createFrame(t.data)).contextPath = r.appendContextPath(t.data.contextPath, t.ids[0])),
									n(e, { data: o, blockParams: r.blockParams([e], [o && o.contextPath]) })
								);
							});
						}),
							(e.exports = t.default);
					})(r._, r._.exports);
				},
				46192: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }),
						Object.defineProperty(t, 'default', {
							enumerable: !0,
							get: function () {
								return r.__exports;
							},
						});
					var r = n(88287);
					n(30227);
					var o = n(82014);
					(r.__exports.__esModule = !0),
						(r.__exports.createNewLookupObject = function () {
							for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) t[n] = arguments[n];
							return i.extend.apply(void 0, [Object.create(null)].concat(t));
						});
					var i = o.__exports;
					e.exports = t.default;
				},
				61443: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }),
						Object.defineProperty(t, 'default', {
							enumerable: !0,
							get: function () {
								return r.__exports;
							},
						});
					var r = n(58324);
					n(46192), n(9656);
					var o = n(88287),
						i = n(90147);
					(r.__exports.__esModule = !0),
						(r.__exports.createProtoAccessControl = function (e) {
							var t = Object.create(null);
							(t.constructor = !1), (t.__defineGetter__ = !1), (t.__defineSetter__ = !1), (t.__lookupGetter__ = !1);
							var n = Object.create(null);
							return (
								(n.__proto__ = !1),
								{
									properties: {
										whitelist: a.createNewLookupObject(n, e.allowedProtoProperties),
										defaultValue: e.allowProtoPropertiesByDefault,
									},
									methods: {
										whitelist: a.createNewLookupObject(t, e.allowedProtoMethods),
										defaultValue: e.allowProtoMethodsByDefault,
									},
								}
							);
						}),
						(r.__exports.resultIsAllowed = function (e, t, n) {
							return u('function' == typeof e ? t.methods : t.properties, n);
						}),
						(r.__exports.resetLoggedProperties = function () {
							Object.keys(l).forEach(function (e) {
								delete l[e];
							});
						});
					var a = o.__exports,
						s = (function (e) {
							if (e && e.__esModule) return e;
							var t = {};
							if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
							return (t.default = e), t;
						})(i.l.exports),
						l = Object.create(null);
					function u(e, t) {
						return void 0 !== e.whitelist[t]
							? !0 === e.whitelist[t]
							: void 0 !== e.defaultValue
							? e.defaultValue
							: ((function (e) {
									!0 !== l[e] &&
										((l[e] = !0),
										s.log(
											'error',
											'Handlebars: Access has been denied to resolve the property "' +
												e +
												'" because it is not an "own property" of its parent.\nYou can add a runtime option to disable the check or this warning:\nSee https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details'
										));
							  })(t),
							  !1);
					}
					e.exports = t.default;
				},
				86696: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }),
						Object.defineProperty(t, 'default', {
							enumerable: !0,
							get: function () {
								return r.__exports;
							},
						});
					var r = n(21795);
					(r.__exports.__esModule = !0),
						(r.__exports.wrapHelper = function (e, t) {
							if ('function' != typeof e) return e;
							return function () {
								return (arguments[arguments.length - 1] = t(arguments[arguments.length - 1])), e.apply(this, arguments);
							};
						}),
						(e.exports = t.default);
				},
				9656: function (e, t, n) {
					'use strict';
					var r = n(90147);
					n(30227);
					var o = n(82014);
					!(function (e, t) {
						t.__esModule = !0;
						var n = o.__exports,
							r = {
								methodMap: ['debug', 'info', 'warn', 'error'],
								level: 'info',
								lookupLevel: function (e) {
									if ('string' == typeof e) {
										var t = n.indexOf(r.methodMap, e.toLowerCase());
										e = t >= 0 ? t : parseInt(e, 10);
									}
									return e;
								},
								log: function (e) {
									if (((e = r.lookupLevel(e)), 'undefined' != typeof console && r.lookupLevel(r.level) <= e)) {
										var t = r.methodMap[e];
										console[t] || (t = 'log');
										for (var n = arguments.length, o = Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
											o[i - 1] = arguments[i];
									}
								},
							};
						(t.default = r), (e.exports = t.default);
					})(r.l, r.l.exports);
				},
				56470: function (e, t, n) {
					'use strict';
					var r = n(22603),
						o = n(64827);
					!(function (e, t) {
						(t.__esModule = !0),
							(t.default = function (e) {
								var t = void 0 !== r.commonjsGlobal ? r.commonjsGlobal : window,
									n = t.Handlebars;
								e.noConflict = function () {
									return t.Handlebars === e && (t.Handlebars = n), e;
								};
							}),
							(e.exports = t.default);
					})(o.n, o.n.exports);
				},
				29622: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						Object.defineProperty(t, 'default', {
							enumerable: !0,
							get: function () {
								return i.__exports;
							},
						});
					var o = r(n(12990)),
						i = n(82971);
					n(30227), n(79267), n(81585), n(60979), n(86696), n(61443);
					var a = n(82014),
						s = n(76222),
						l = n(58324),
						u = n(77666),
						c = n(21795),
						d = n(39338);
					(i.__exports.__esModule = !0),
						(i.__exports.checkRevision = function (e) {
							var t = (e && e[0]) || 1,
								n = v.COMPILER_REVISION;
							if (t >= v.LAST_COMPATIBLE_COMPILER_REVISION && t <= v.COMPILER_REVISION) return;
							if (t < v.LAST_COMPATIBLE_COMPILER_REVISION) {
								var r = v.REVISION_CHANGES[n],
									o = v.REVISION_CHANGES[t];
								throw new m.default(
									'Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (' +
										r +
										') or downgrade your runtime to an older version (' +
										o +
										').'
								);
							}
							throw new m.default(
								'Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (' +
									e[1] +
									').'
							);
						}),
						(i.__exports.template = function (e, t) {
							if (!t) throw new m.default('No environment passed to template');
							if (!e || !e.main) throw new m.default('Unknown template object: ' + (0, o.default)(e));
							(e.main.decorator = e.main_d), t.VM.checkRevision(e.compiler);
							var n = e.compiler && 7 === e.compiler[0];
							var r = {
								strict: function (e, t, n) {
									if (!e || !(t in e)) throw new m.default('"' + t + '" not defined in ' + e, { loc: n });
									return r.lookupProperty(e, t);
								},
								lookupProperty: function (e, t) {
									var n = e[t];
									return null == n ||
										Object.prototype.hasOwnProperty.call(e, t) ||
										b.resultIsAllowed(n, r.protoAccessControl, t)
										? n
										: void 0;
								},
								lookup: function (e, t) {
									for (var n = e.length, o = 0; o < n; o++) {
										if (null != (e[o] && r.lookupProperty(e[o], t))) return e[o][t];
									}
								},
								lambda: function (e, t) {
									return 'function' == typeof e ? e.call(t) : e;
								},
								escapeExpression: p.escapeExpression,
								invokePartial: function (n, r, o) {
									o.hash && ((r = p.extend({}, r, o.hash)), o.ids && (o.ids[0] = !0)),
										(n = t.VM.resolvePartial.call(this, n, r, o));
									var i = p.extend({}, o, { hooks: this.hooks, protoAccessControl: this.protoAccessControl }),
										a = t.VM.invokePartial.call(this, n, r, i);
									if (
										(null == a &&
											t.compile &&
											((o.partials[o.name] = t.compile(n, e.compilerOptions, t)), (a = o.partials[o.name](r, i))),
										null != a)
									) {
										if (o.indent) {
											for (var s = a.split('\n'), l = 0, u = s.length; l < u && (s[l] || l + 1 !== u); l++)
												s[l] = o.indent + s[l];
											a = s.join('\n');
										}
										return a;
									}
									throw new m.default(
										'The partial ' + o.name + ' could not be compiled when running in runtime-only mode'
									);
								},
								fn: function (t) {
									var n = e[t];
									return (n.decorator = e[t + '_d']), n;
								},
								programs: [],
								program: function (e, t, n, r, o) {
									var i = this.programs[e],
										a = this.fn(e);
									return (
										t || o || r || n ? (i = _(this, e, a, t, n, r, o)) : i || (i = this.programs[e] = _(this, e, a)), i
									);
								},
								data: function (e, t) {
									for (; e && t--; ) e = e._parent;
									return e;
								},
								mergeIfNeeded: function (e, t) {
									var n = e || t;
									return e && t && e !== t && (n = p.extend({}, t, e)), n;
								},
								nullContext: Object.seal({}),
								noop: t.VM.noop,
								compilerInfo: e.compiler,
							};
							function i(t) {
								var n = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
									o = n.data;
								i._setup(n), !n.partial && e.useData && (o = O(t, o));
								var a = void 0,
									s = e.useBlockParams ? [] : void 0;
								function l(t) {
									return '' + e.main(r, t, r.helpers, r.partials, o, s, a);
								}
								return (
									e.useDepths && (a = n.depths ? (t != n.depths[0] ? [t].concat(n.depths) : n.depths) : [t]),
									(l = k(e.main, l, r, n.depths || [], o, s))(t, n)
								);
							}
							return (
								(i.isTop = !0),
								(i._setup = function (o) {
									if (o.partial)
										(r.protoAccessControl = o.protoAccessControl),
											(r.helpers = o.helpers),
											(r.partials = o.partials),
											(r.decorators = o.decorators),
											(r.hooks = o.hooks);
									else {
										var i = p.extend({}, t.helpers, o.helpers);
										!(function (e, t) {
											Object.keys(e).forEach(function (n) {
												var r = e[n];
												e[n] = (function (e, t) {
													var n = t.lookupProperty;
													return y.wrapHelper(e, function (e) {
														return p.extend({ lookupProperty: n }, e);
													});
												})(r, t);
											});
										})(i, r),
											(r.helpers = i),
											e.usePartial && (r.partials = r.mergeIfNeeded(o.partials, t.partials)),
											(e.usePartial || e.useDecorators) && (r.decorators = p.extend({}, t.decorators, o.decorators)),
											(r.hooks = {}),
											(r.protoAccessControl = b.createProtoAccessControl(o));
										var a = o.allowCallsToHelperMissing || n;
										g.moveHelperToHooks(r, 'helperMissing', a), g.moveHelperToHooks(r, 'blockHelperMissing', a);
									}
								}),
								(i._child = function (t, n, o, i) {
									if (e.useBlockParams && !o) throw new m.default('must pass block params');
									if (e.useDepths && !i) throw new m.default('must pass parent depths');
									return _(r, t, e[t], n, 0, o, i);
								}),
								i
							);
						}),
						(i.__exports.wrapProgram = _),
						(i.__exports.resolvePartial = function (e, t, n) {
							e
								? e.call || n.name || ((n.name = e), (e = n.partials[e]))
								: (e = '@partial-block' === n.name ? n.data['partial-block'] : n.partials[n.name]);
							return e;
						}),
						(i.__exports.invokePartial = function (e, t, n) {
							var r = n.data && n.data['partial-block'];
							(n.partial = !0), n.ids && (n.data.contextPath = n.ids[0] || n.data.contextPath);
							var o = void 0;
							n.fn &&
								n.fn !== w &&
								(function () {
									n.data = v.createFrame(n.data);
									var e = n.fn;
									(o = n.data['partial-block'] =
										function (t) {
											var n = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1];
											return (n.data = v.createFrame(n.data)), (n.data['partial-block'] = r), e(t, n);
										}),
										e.partials && (n.partials = p.extend({}, n.partials, e.partials));
								})();
							void 0 === e && o && (e = o);
							if (void 0 === e) throw new m.default('The partial ' + n.name + ' could not be found');
							if (e instanceof Function) return e(t, n);
						}),
						(i.__exports.noop = w);
					var f,
						p = (function (e) {
							if (e && e.__esModule) return e;
							var t = {};
							if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
							return (t.default = e), t;
						})(a.__exports),
						h = d.e.exports,
						m = (f = h) && f.__esModule ? f : { default: f },
						v = s.__exports,
						g = u.__exports,
						y = c.__exports,
						b = l.__exports;
					function _(e, t, n, r, o, i, a) {
						function s(t) {
							var o = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
								s = a;
							return (
								!a || t == a[0] || (t === e.nullContext && null === a[0]) || (s = [t].concat(a)),
								n(e, t, e.helpers, e.partials, o.data || r, i && [o.blockParams].concat(i), s)
							);
						}
						return ((s = k(n, s, e, a, r, i)).program = t), (s.depth = a ? a.length : 0), (s.blockParams = o || 0), s;
					}
					function w() {
						return '';
					}
					function O(e, t) {
						return (t && 'root' in t) || ((t = t ? v.createFrame(t) : {}).root = e), t;
					}
					function k(e, t, n, r, o, i) {
						if (e.decorator) {
							var a = {};
							(t = e.decorator(t, a, n, r && r[0], o, i, r)), p.extend(t, a);
						}
						return t;
					}
					e.exports = t.default;
				},
				85187: function (e, t, n) {
					'use strict';
					var r = n(95882);
					!(function (e, t) {
						function n(e) {
							this.string = e;
						}
						(t.__esModule = !0),
							(n.prototype.toString = n.prototype.toHTML =
								function () {
									return '' + this.string;
								}),
							(t.default = n),
							(e.exports = t.default);
					})(r.s, r.s.exports);
				},
				30227: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						Object.defineProperty(t, 'default', {
							enumerable: !0,
							get: function () {
								return i.__exports;
							},
						});
					var o = r(n(12990)),
						i = n(82014);
					(i.__exports.__esModule = !0),
						(i.__exports.extend = c),
						(i.__exports.indexOf = function (e, t) {
							for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
							return -1;
						}),
						(i.__exports.escapeExpression = function (e) {
							if ('string' != typeof e) {
								if (e && e.toHTML) return e.toHTML();
								if (null == e) return '';
								if (!e) return e + '';
								e = '' + e;
							}
							if (!l.test(e)) return e;
							return e.replace(s, u);
						}),
						(i.__exports.isEmpty = function (e) {
							return (!e && 0 !== e) || !(!p(e) || 0 !== e.length);
						}),
						(i.__exports.createFrame = function (e) {
							var t = c({}, e);
							return (t._parent = e), t;
						}),
						(i.__exports.blockParams = function (e, t) {
							return (e.path = t), e;
						}),
						(i.__exports.appendContextPath = function (e, t) {
							return (e ? e + '.' : '') + t;
						});
					var a = {
							'&': '&amp;',
							'<': '&lt;',
							'>': '&gt;',
							'"': '&quot;',
							"'": '&#x27;',
							'`': '&#x60;',
							'=': '&#x3D;',
						},
						s = /[&<>"'`=]/g,
						l = /[&<>"'`=]/;
					function u(e) {
						return a[e];
					}
					function c(e) {
						for (var t = 1; t < arguments.length; t++)
							for (var n in arguments[t])
								Object.prototype.hasOwnProperty.call(arguments[t], n) && (e[n] = arguments[t][n]);
						return e;
					}
					var d = Object.prototype.toString;
					i.__exports.toString = d;
					var f = function (e) {
						return 'function' == typeof e;
					};
					f(/x/) &&
						(i.__exports.isFunction = f =
							function (e) {
								return 'function' == typeof e && '[object Function]' === d.call(e);
							}),
						(i.__exports.isFunction = f);
					var p =
						Array.isArray ||
						function (e) {
							return !(!e || 'object' !== (0, o.default)(e)) && '[object Array]' === d.call(e);
						};
					(i.__exports.isArray = p), (e.exports = t.default);
				},
				37870: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = n(22603),
						a = n(3206);
					!(function (e, t) {
						i.commonjsGlobal,
							(e.exports = (function () {
								//     (c) 2009-2021 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
								//     Underscore may be freely distributed under the MIT license.
								var e = '1.13.1',
									t =
										('object' == ('undefined' == typeof self ? 'undefined' : (0, o.default)(self)) &&
											self.self === self &&
											self) ||
										('object' == (0, o.default)(i.commonjsGlobal) &&
											i.commonjsGlobal.global === i.commonjsGlobal &&
											i.commonjsGlobal) ||
										Function('return this')() ||
										{},
									n = Array.prototype,
									r = Object.prototype,
									a = 'undefined' != typeof Symbol ? Symbol.prototype : null,
									s = n.push,
									l = n.slice,
									u = r.toString,
									c = r.hasOwnProperty,
									d = 'undefined' != typeof ArrayBuffer,
									f = 'undefined' != typeof DataView,
									p = Array.isArray,
									h = Object.keys,
									m = Object.create,
									v = d && ArrayBuffer.isView,
									g = isNaN,
									y = isFinite,
									b = !{ toString: null }.propertyIsEnumerable('toString'),
									_ = [
										'valueOf',
										'isPrototypeOf',
										'toString',
										'propertyIsEnumerable',
										'hasOwnProperty',
										'toLocaleString',
									],
									w = Math.pow(2, 53) - 1;
								function O(e, t) {
									return (
										(t = null == t ? e.length - 1 : +t),
										function () {
											for (var n = Math.max(arguments.length - t, 0), r = Array(n), o = 0; o < n; o++)
												r[o] = arguments[o + t];
											switch (t) {
												case 0:
													return e.call(this, r);
												case 1:
													return e.call(this, arguments[0], r);
												case 2:
													return e.call(this, arguments[0], arguments[1], r);
											}
											var i = Array(t + 1);
											for (o = 0; o < t; o++) i[o] = arguments[o];
											return (i[t] = r), e.apply(this, i);
										}
									);
								}
								function k(e) {
									var t = (0, o.default)(e);
									return 'function' === t || ('object' === t && !!e);
								}
								function x(e) {
									return void 0 === e;
								}
								function E(e) {
									return !0 === e || !1 === e || '[object Boolean]' === u.call(e);
								}
								function T(e) {
									var t = '[object ' + e + ']';
									return function (e) {
										return u.call(e) === t;
									};
								}
								var S = T('String'),
									A = T('Number'),
									C = T('Date'),
									P = T('RegExp'),
									R = T('Error'),
									I = T('Symbol'),
									N = T('ArrayBuffer'),
									M = T('Function'),
									j = t.document && t.document.childNodes;
								'object' != ('undefined' == typeof Int8Array ? 'undefined' : (0, o.default)(Int8Array)) &&
									'function' != typeof j &&
									(M = function (e) {
										return 'function' == typeof e || !1;
									});
								var D = M,
									L = T('Object'),
									U = f && L(new DataView(new ArrayBuffer(8))),
									F = 'undefined' != typeof Map && L(new Map()),
									B = T('DataView'),
									V = U
										? function (e) {
												return null != e && D(e.getInt8) && N(e.buffer);
										  }
										: B,
									Z = p || T('Array');
								function H(e, t) {
									return null != e && c.call(e, t);
								}
								var q = T('Arguments');
								!(function () {
									q(arguments) ||
										(q = function (e) {
											return H(e, 'callee');
										});
								})();
								var W = q;
								function K(e) {
									return A(e) && g(e);
								}
								function $(e) {
									return function () {
										return e;
									};
								}
								function z(e) {
									return function (t) {
										var n = e(t);
										return 'number' == typeof n && n >= 0 && n <= w;
									};
								}
								function G(e) {
									return function (t) {
										return null == t ? void 0 : t[e];
									};
								}
								var Y = G('byteLength'),
									J = z(Y),
									Q = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/,
									X = d
										? function (e) {
												return v ? v(e) && !V(e) : J(e) && Q.test(u.call(e));
										  }
										: $(!1),
									ee = G('length');
								function te(e, t) {
									t = (function (e) {
										for (var t = {}, n = e.length, r = 0; r < n; ++r) t[e[r]] = !0;
										return {
											contains: function (e) {
												return t[e];
											},
											push: function (n) {
												return (t[n] = !0), e.push(n);
											},
										};
									})(t);
									var n = _.length,
										o = e.constructor,
										i = (D(o) && o.prototype) || r,
										a = 'constructor';
									for (H(e, a) && !t.contains(a) && t.push(a); n--; )
										(a = _[n]) in e && e[a] !== i[a] && !t.contains(a) && t.push(a);
								}
								function ne(e) {
									if (!k(e)) return [];
									if (h) return h(e);
									var t = [];
									for (var n in e) H(e, n) && t.push(n);
									return b && te(e, t), t;
								}
								function re(e, t) {
									var n = ne(t),
										r = n.length;
									if (null == e) return !r;
									for (var o = Object(e), i = 0; i < r; i++) {
										var a = n[i];
										if (t[a] !== o[a] || !(a in o)) return !1;
									}
									return !0;
								}
								function oe(e) {
									return e instanceof oe ? e : this instanceof oe ? void (this._wrapped = e) : new oe(e);
								}
								function ie(e) {
									return new Uint8Array(e.buffer || e, e.byteOffset || 0, Y(e));
								}
								(oe.VERSION = e),
									(oe.prototype.value = function () {
										return this._wrapped;
									}),
									(oe.prototype.valueOf = oe.prototype.toJSON = oe.prototype.value),
									(oe.prototype.toString = function () {
										return String(this._wrapped);
									});
								var ae = '[object DataView]';
								function se(e, t, n, r) {
									if (e === t) return 0 !== e || 1 / e == 1 / t;
									if (null == e || null == t) return !1;
									if (e != e) return t != t;
									var i = (0, o.default)(e);
									return (
										('function' === i || 'object' === i || 'object' == (0, o.default)(t)) &&
										(function e(t, n, r, i) {
											t instanceof oe && (t = t._wrapped), n instanceof oe && (n = n._wrapped);
											var s = u.call(t);
											if (s !== u.call(n)) return !1;
											if (U && '[object Object]' == s && V(t)) {
												if (!V(n)) return !1;
												s = ae;
											}
											switch (s) {
												case '[object RegExp]':
												case '[object String]':
													return '' + t == '' + n;
												case '[object Number]':
													return +t != +t ? +n != +n : 0 == +t ? 1 / +t == 1 / n : +t == +n;
												case '[object Date]':
												case '[object Boolean]':
													return +t == +n;
												case '[object Symbol]':
													return a.valueOf.call(t) === a.valueOf.call(n);
												case '[object ArrayBuffer]':
												case ae:
													return e(ie(t), ie(n), r, i);
											}
											var l = '[object Array]' === s;
											if (!l && X(t)) {
												if (Y(t) !== Y(n)) return !1;
												if (t.buffer === n.buffer && t.byteOffset === n.byteOffset) return !0;
												l = !0;
											}
											if (!l) {
												if ('object' != (0, o.default)(t) || 'object' != (0, o.default)(n)) return !1;
												var c = t.constructor,
													d = n.constructor;
												if (
													c !== d &&
													!(D(c) && c instanceof c && D(d) && d instanceof d) &&
													'constructor' in t &&
													'constructor' in n
												)
													return !1;
											}
											i = i || [];
											for (var f = (r = r || []).length; f--; ) if (r[f] === t) return i[f] === n;
											if ((r.push(t), i.push(n), l)) {
												if ((f = t.length) !== n.length) return !1;
												for (; f--; ) if (!se(t[f], n[f], r, i)) return !1;
											} else {
												var p,
													h = ne(t);
												if (((f = h.length), ne(n).length !== f)) return !1;
												for (; f--; ) if (!H(n, (p = h[f])) || !se(t[p], n[p], r, i)) return !1;
											}
											return r.pop(), i.pop(), !0;
										})(e, t, n, r)
									);
								}
								function le(e) {
									if (!k(e)) return [];
									var t = [];
									for (var n in e) t.push(n);
									return b && te(e, t), t;
								}
								function ue(e) {
									var t = ee(e);
									return function (n) {
										if (null == n) return !1;
										var r = le(n);
										if (ee(r)) return !1;
										for (var o = 0; o < t; o++) if (!D(n[e[o]])) return !1;
										return e !== me || !D(n[ce]);
									};
								}
								var ce = 'forEach',
									de = 'has',
									fe = ['clear', 'delete'],
									pe = ['get', de, 'set'],
									he = fe.concat(ce, pe),
									me = fe.concat(pe),
									ve = ['add'].concat(fe, ce, de),
									ge = F ? ue(he) : T('Map'),
									ye = F ? ue(me) : T('WeakMap'),
									be = F ? ue(ve) : T('Set'),
									_e = T('WeakSet');
								function we(e) {
									for (var t = ne(e), n = t.length, r = Array(n), o = 0; o < n; o++) r[o] = e[t[o]];
									return r;
								}
								function Oe(e) {
									for (var t = {}, n = ne(e), r = 0, o = n.length; r < o; r++) t[e[n[r]]] = n[r];
									return t;
								}
								function ke(e) {
									var t = [];
									for (var n in e) D(e[n]) && t.push(n);
									return t.sort();
								}
								function xe(e, t) {
									return function (n) {
										var r = arguments.length;
										if ((t && (n = Object(n)), r < 2 || null == n)) return n;
										for (var o = 1; o < r; o++)
											for (var i = arguments[o], a = e(i), s = a.length, l = 0; l < s; l++) {
												var u = a[l];
												(t && void 0 !== n[u]) || (n[u] = i[u]);
											}
										return n;
									};
								}
								var Ee = xe(le),
									Te = xe(ne),
									Se = xe(le, !0);
								function Ae(e) {
									if (!k(e)) return {};
									if (m) return m(e);
									var t = function () {};
									t.prototype = e;
									var n = new t();
									return (t.prototype = null), n;
								}
								function Ce(e) {
									return k(e) ? (Z(e) ? e.slice() : Ee({}, e)) : e;
								}
								function Pe(e) {
									return Z(e) ? e : [e];
								}
								function Re(e) {
									return oe.toPath(e);
								}
								function Ie(e, t) {
									for (var n = t.length, r = 0; r < n; r++) {
										if (null == e) return;
										e = e[t[r]];
									}
									return n ? e : void 0;
								}
								function Ne(e, t, n) {
									var r = Ie(e, Re(t));
									return x(r) ? n : r;
								}
								function Me(e) {
									return e;
								}
								function je(e) {
									return (
										(e = Te({}, e)),
										function (t) {
											return re(t, e);
										}
									);
								}
								function De(e) {
									return (
										(e = Re(e)),
										function (t) {
											return Ie(t, e);
										}
									);
								}
								function Le(e, t, n) {
									if (void 0 === t) return e;
									switch (null == n ? 3 : n) {
										case 1:
											return function (n) {
												return e.call(t, n);
											};
										case 3:
											return function (n, r, o) {
												return e.call(t, n, r, o);
											};
										case 4:
											return function (n, r, o, i) {
												return e.call(t, n, r, o, i);
											};
									}
									return function () {
										return e.apply(t, arguments);
									};
								}
								function Ue(e, t, n) {
									return null == e ? Me : D(e) ? Le(e, t, n) : k(e) && !Z(e) ? je(e) : De(e);
								}
								function Fe(e, t) {
									return Ue(e, t, 1 / 0);
								}
								function Be(e, t, n) {
									return oe.iteratee !== Fe ? oe.iteratee(e, t) : Ue(e, t, n);
								}
								function Ve() {}
								function Ze(e, t) {
									return null == t && ((t = e), (e = 0)), e + Math.floor(Math.random() * (t - e + 1));
								}
								(oe.toPath = Pe), (oe.iteratee = Fe);
								var He =
									Date.now ||
									function () {
										return new Date().getTime();
									};
								function qe(e) {
									var t = function (t) {
											return e[t];
										},
										n = '(?:' + ne(e).join('|') + ')',
										r = RegExp(n),
										o = RegExp(n, 'g');
									return function (e) {
										return (e = null == e ? '' : '' + e), r.test(e) ? e.replace(o, t) : e;
									};
								}
								var We = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#x27;', '`': '&#x60;' },
									Ke = qe(We),
									$e = qe(Oe(We)),
									ze = (oe.templateSettings = {
										evaluate: /<%([\s\S]+?)%>/g,
										interpolate: /<%=([\s\S]+?)%>/g,
										escape: /<%-([\s\S]+?)%>/g,
									}),
									Ge = /(.)^/,
									Ye = { "'": "'", '\\': '\\', '\r': 'r', '\n': 'n', '\u2028': 'u2028', '\u2029': 'u2029' },
									Je = /\\|'|\r|\n|\u2028|\u2029/g;
								function Qe(e) {
									return '\\' + Ye[e];
								}
								var Xe = /^\s*(\w|\$)+\s*$/,
									et = 0;
								function tt(e, t, n, r, o) {
									if (!(r instanceof t)) return e.apply(n, o);
									var i = Ae(e.prototype),
										a = e.apply(i, o);
									return k(a) ? a : i;
								}
								var nt = O(function (e, t) {
									var n = nt.placeholder,
										r = function r() {
											for (var o = 0, i = t.length, a = Array(i), s = 0; s < i; s++)
												a[s] = t[s] === n ? arguments[o++] : t[s];
											for (; o < arguments.length; ) a.push(arguments[o++]);
											return tt(e, r, this, this, a);
										};
									return r;
								});
								nt.placeholder = oe;
								var rt = O(function (e, t, n) {
										if (!D(e)) throw new TypeError('Bind must be called on a function');
										var r = O(function (o) {
											return tt(e, r, t, this, n.concat(o));
										});
										return r;
									}),
									ot = z(ee);
								function it(e, t, n, r) {
									if (((r = r || []), t || 0 === t)) {
										if (t <= 0) return r.concat(e);
									} else t = 1 / 0;
									for (var o = r.length, i = 0, a = ee(e); i < a; i++) {
										var s = e[i];
										if (ot(s) && (Z(s) || W(s)))
											if (t > 1) it(s, t - 1, n, r), (o = r.length);
											else for (var l = 0, u = s.length; l < u; ) r[o++] = s[l++];
										else n || (r[o++] = s);
									}
									return r;
								}
								var at = O(function (e, t) {
										var n = (t = it(t, !1, !1)).length;
										if (n < 1) throw new Error('bindAll must be passed function names');
										for (; n--; ) {
											var r = t[n];
											e[r] = rt(e[r], e);
										}
										return e;
									}),
									st = O(function (e, t, n) {
										return setTimeout(function () {
											return e.apply(null, n);
										}, t);
									}),
									lt = nt(st, oe, 1);
								function ut(e) {
									return function () {
										return !e.apply(this, arguments);
									};
								}
								function ct(e, t) {
									var n;
									return function () {
										return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = null), n;
									};
								}
								var dt = nt(ct, 2);
								function ft(e, t, n) {
									t = Be(t, n);
									for (var r, o = ne(e), i = 0, a = o.length; i < a; i++) if (t(e[(r = o[i])], r, e)) return r;
								}
								function pt(e) {
									return function (t, n, r) {
										n = Be(n, r);
										for (var o = ee(t), i = e > 0 ? 0 : o - 1; i >= 0 && i < o; i += e) if (n(t[i], i, t)) return i;
										return -1;
									};
								}
								var ht = pt(1),
									mt = pt(-1);
								function vt(e, t, n, r) {
									for (var o = (n = Be(n, r, 1))(t), i = 0, a = ee(e); i < a; ) {
										var s = Math.floor((i + a) / 2);
										n(e[s]) < o ? (i = s + 1) : (a = s);
									}
									return i;
								}
								function gt(e, t, n) {
									return function (r, o, i) {
										var a = 0,
											s = ee(r);
										if ('number' == typeof i)
											e > 0 ? (a = i >= 0 ? i : Math.max(i + s, a)) : (s = i >= 0 ? Math.min(i + 1, s) : i + s + 1);
										else if (n && i && s) return r[(i = n(r, o))] === o ? i : -1;
										if (o != o) return (i = t(l.call(r, a, s), K)) >= 0 ? i + a : -1;
										for (i = e > 0 ? a : s - 1; i >= 0 && i < s; i += e) if (r[i] === o) return i;
										return -1;
									};
								}
								var yt = gt(1, ht, vt),
									bt = gt(-1, mt);
								function _t(e, t, n) {
									var r = (ot(e) ? ht : ft)(e, t, n);
									if (void 0 !== r && -1 !== r) return e[r];
								}
								function wt(e, t, n) {
									var r, o;
									if (((t = Le(t, n)), ot(e))) for (r = 0, o = e.length; r < o; r++) t(e[r], r, e);
									else {
										var i = ne(e);
										for (r = 0, o = i.length; r < o; r++) t(e[i[r]], i[r], e);
									}
									return e;
								}
								function Ot(e, t, n) {
									t = Be(t, n);
									for (var r = !ot(e) && ne(e), o = (r || e).length, i = Array(o), a = 0; a < o; a++) {
										var s = r ? r[a] : a;
										i[a] = t(e[s], s, e);
									}
									return i;
								}
								function kt(e) {
									var t = function (t, n, r, o) {
										var i = !ot(t) && ne(t),
											a = (i || t).length,
											s = e > 0 ? 0 : a - 1;
										for (o || ((r = t[i ? i[s] : s]), (s += e)); s >= 0 && s < a; s += e) {
											var l = i ? i[s] : s;
											r = n(r, t[l], l, t);
										}
										return r;
									};
									return function (e, n, r, o) {
										var i = arguments.length >= 3;
										return t(e, Le(n, o, 4), r, i);
									};
								}
								var xt = kt(1),
									Et = kt(-1);
								function Tt(e, t, n) {
									var r = [];
									return (
										(t = Be(t, n)),
										wt(e, function (e, n, o) {
											t(e, n, o) && r.push(e);
										}),
										r
									);
								}
								function St(e, t, n) {
									t = Be(t, n);
									for (var r = !ot(e) && ne(e), o = (r || e).length, i = 0; i < o; i++) {
										var a = r ? r[i] : i;
										if (!t(e[a], a, e)) return !1;
									}
									return !0;
								}
								function At(e, t, n) {
									t = Be(t, n);
									for (var r = !ot(e) && ne(e), o = (r || e).length, i = 0; i < o; i++) {
										var a = r ? r[i] : i;
										if (t(e[a], a, e)) return !0;
									}
									return !1;
								}
								function Ct(e, t, n, r) {
									return ot(e) || (e = we(e)), ('number' != typeof n || r) && (n = 0), yt(e, t, n) >= 0;
								}
								var Pt = O(function (e, t, n) {
									var r, o;
									return (
										D(t) ? (o = t) : ((t = Re(t)), (r = t.slice(0, -1)), (t = t[t.length - 1])),
										Ot(e, function (e) {
											var i = o;
											if (!i) {
												if ((r && r.length && (e = Ie(e, r)), null == e)) return;
												i = e[t];
											}
											return null == i ? i : i.apply(e, n);
										})
									);
								});
								function Rt(e, t) {
									return Ot(e, De(t));
								}
								function It(e, t, n) {
									var r,
										i,
										a = -1 / 0,
										s = -1 / 0;
									if (null == t || ('number' == typeof t && 'object' != (0, o.default)(e[0]) && null != e))
										for (var l = 0, u = (e = ot(e) ? e : we(e)).length; l < u; l++)
											null != (r = e[l]) && r > a && (a = r);
									else
										(t = Be(t, n)),
											wt(e, function (e, n, r) {
												((i = t(e, n, r)) > s || (i === -1 / 0 && a === -1 / 0)) && ((a = e), (s = i));
											});
									return a;
								}
								function Nt(e, t, n) {
									if (null == t || n) return ot(e) || (e = we(e)), e[Ze(e.length - 1)];
									var r = ot(e) ? Ce(e) : we(e),
										o = ee(r);
									t = Math.max(Math.min(t, o), 0);
									for (var i = o - 1, a = 0; a < t; a++) {
										var s = Ze(a, i),
											l = r[a];
										(r[a] = r[s]), (r[s] = l);
									}
									return r.slice(0, t);
								}
								function Mt(e, t) {
									return function (n, r, o) {
										var i = t ? [[], []] : {};
										return (
											(r = Be(r, o)),
											wt(n, function (t, o) {
												var a = r(t, o, n);
												e(i, t, a);
											}),
											i
										);
									};
								}
								var jt = Mt(function (e, t, n) {
										H(e, n) ? e[n].push(t) : (e[n] = [t]);
									}),
									Dt = Mt(function (e, t, n) {
										e[n] = t;
									}),
									Lt = Mt(function (e, t, n) {
										H(e, n) ? e[n]++ : (e[n] = 1);
									}),
									Ut = Mt(function (e, t, n) {
										e[n ? 0 : 1].push(t);
									}, !0),
									Ft = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
								function Bt(e, t, n) {
									return t in n;
								}
								var Vt = O(function (e, t) {
										var n = {},
											r = t[0];
										if (null == e) return n;
										D(r)
											? (t.length > 1 && (r = Le(r, t[1])), (t = le(e)))
											: ((r = Bt), (t = it(t, !1, !1)), (e = Object(e)));
										for (var o = 0, i = t.length; o < i; o++) {
											var a = t[o],
												s = e[a];
											r(s, a, e) && (n[a] = s);
										}
										return n;
									}),
									Zt = O(function (e, t) {
										var n,
											r = t[0];
										return (
											D(r)
												? ((r = ut(r)), t.length > 1 && (n = t[1]))
												: ((t = Ot(it(t, !1, !1), String)),
												  (r = function (e, n) {
														return !Ct(t, n);
												  })),
											Vt(e, r, n)
										);
									});
								function Ht(e, t, n) {
									return l.call(e, 0, Math.max(0, e.length - (null == t || n ? 1 : t)));
								}
								function qt(e, t, n) {
									return null == e || e.length < 1
										? null == t || n
											? void 0
											: []
										: null == t || n
										? e[0]
										: Ht(e, e.length - t);
								}
								function Wt(e, t, n) {
									return l.call(e, null == t || n ? 1 : t);
								}
								var Kt = O(function (e, t) {
										return (
											(t = it(t, !0, !0)),
											Tt(e, function (e) {
												return !Ct(t, e);
											})
										);
									}),
									$t = O(function (e, t) {
										return Kt(e, t);
									});
								function zt(e, t, n, r) {
									E(t) || ((r = n), (n = t), (t = !1)), null != n && (n = Be(n, r));
									for (var o = [], i = [], a = 0, s = ee(e); a < s; a++) {
										var l = e[a],
											u = n ? n(l, a, e) : l;
										t && !n
											? ((a && i === u) || o.push(l), (i = u))
											: n
											? Ct(i, u) || (i.push(u), o.push(l))
											: Ct(o, l) || o.push(l);
									}
									return o;
								}
								var Gt = O(function (e) {
									return zt(it(e, !0, !0));
								});
								function Yt(e) {
									for (var t = (e && It(e, ee).length) || 0, n = Array(t), r = 0; r < t; r++) n[r] = Rt(e, r);
									return n;
								}
								var Jt = O(Yt);
								function Qt(e, t) {
									return e._chain ? oe(t).chain() : t;
								}
								function Xt(e) {
									return (
										wt(ke(e), function (t) {
											var n = (oe[t] = e[t]);
											oe.prototype[t] = function () {
												var e = [this._wrapped];
												return s.apply(e, arguments), Qt(this, n.apply(oe, e));
											};
										}),
										oe
									);
								}
								wt(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function (e) {
									var t = n[e];
									oe.prototype[e] = function () {
										var n = this._wrapped;
										return (
											null != n &&
												(t.apply(n, arguments), ('shift' !== e && 'splice' !== e) || 0 !== n.length || delete n[0]),
											Qt(this, n)
										);
									};
								}),
									wt(['concat', 'join', 'slice'], function (e) {
										var t = n[e];
										oe.prototype[e] = function () {
											var e = this._wrapped;
											return null != e && (e = t.apply(e, arguments)), Qt(this, e);
										};
									});
								var en = Xt({
									__proto__: null,
									VERSION: e,
									restArguments: O,
									isObject: k,
									isNull: function (e) {
										return null === e;
									},
									isUndefined: x,
									isBoolean: E,
									isElement: function (e) {
										return !(!e || 1 !== e.nodeType);
									},
									isString: S,
									isNumber: A,
									isDate: C,
									isRegExp: P,
									isError: R,
									isSymbol: I,
									isArrayBuffer: N,
									isDataView: V,
									isArray: Z,
									isFunction: D,
									isArguments: W,
									isFinite: function (e) {
										return !I(e) && y(e) && !isNaN(parseFloat(e));
									},
									isNaN: K,
									isTypedArray: X,
									isEmpty: function (e) {
										if (null == e) return !0;
										var t = ee(e);
										return 'number' == typeof t && (Z(e) || S(e) || W(e)) ? 0 === t : 0 === ee(ne(e));
									},
									isMatch: re,
									isEqual: function (e, t) {
										return se(e, t);
									},
									isMap: ge,
									isWeakMap: ye,
									isSet: be,
									isWeakSet: _e,
									keys: ne,
									allKeys: le,
									values: we,
									pairs: function (e) {
										for (var t = ne(e), n = t.length, r = Array(n), o = 0; o < n; o++) r[o] = [t[o], e[t[o]]];
										return r;
									},
									invert: Oe,
									functions: ke,
									methods: ke,
									extend: Ee,
									extendOwn: Te,
									assign: Te,
									defaults: Se,
									create: function (e, t) {
										var n = Ae(e);
										return t && Te(n, t), n;
									},
									clone: Ce,
									tap: function (e, t) {
										return t(e), e;
									},
									get: Ne,
									has: function (e, t) {
										for (var n = (t = Re(t)).length, r = 0; r < n; r++) {
											var o = t[r];
											if (!H(e, o)) return !1;
											e = e[o];
										}
										return !!n;
									},
									mapObject: function (e, t, n) {
										t = Be(t, n);
										for (var r = ne(e), o = r.length, i = {}, a = 0; a < o; a++) {
											var s = r[a];
											i[s] = t(e[s], s, e);
										}
										return i;
									},
									identity: Me,
									constant: $,
									noop: Ve,
									toPath: Pe,
									property: De,
									propertyOf: function (e) {
										return null == e
											? Ve
											: function (t) {
													return Ne(e, t);
											  };
									},
									matcher: je,
									matches: je,
									times: function (e, t, n) {
										var r = Array(Math.max(0, e));
										t = Le(t, n, 1);
										for (var o = 0; o < e; o++) r[o] = t(o);
										return r;
									},
									random: Ze,
									now: He,
									escape: Ke,
									unescape: $e,
									templateSettings: ze,
									template: function (e, t, n) {
										!t && n && (t = n), (t = Se({}, t, oe.templateSettings));
										var r = RegExp(
												[(t.escape || Ge).source, (t.interpolate || Ge).source, (t.evaluate || Ge).source].join('|') +
													'|$',
												'g'
											),
											o = 0,
											i = "__p+='";
										e.replace(r, function (t, n, r, a, s) {
											return (
												(i += e.slice(o, s).replace(Je, Qe)),
												(o = s + t.length),
												n
													? (i += "'+\n((__t=(" + n + "))==null?'':_.escape(__t))+\n'")
													: r
													? (i += "'+\n((__t=(" + r + "))==null?'':__t)+\n'")
													: a && (i += "';\n" + a + "\n__p+='"),
												t
											);
										}),
											(i += "';\n");
										var a,
											s = t.variable;
										if (s) {
											if (!Xe.test(s)) throw new Error('variable is not a bare identifier: ' + s);
										} else (i = 'with(obj||{}){\n' + i + '}\n'), (s = 'obj');
										i =
											"var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" +
											i +
											'return __p;\n';
										try {
											a = new Function(s, '_', i);
										} catch (e) {
											throw ((e.source = i), e);
										}
										var l = function (e) {
											return a.call(this, e, oe);
										};
										return (l.source = 'function(' + s + '){\n' + i + '}'), l;
									},
									result: function (e, t, n) {
										var r = (t = Re(t)).length;
										if (!r) return D(n) ? n.call(e) : n;
										for (var o = 0; o < r; o++) {
											var i = null == e ? void 0 : e[t[o]];
											void 0 === i && ((i = n), (o = r)), (e = D(i) ? i.call(e) : i);
										}
										return e;
									},
									uniqueId: function (e) {
										var t = ++et + '';
										return e ? e + t : t;
									},
									chain: function (e) {
										var t = oe(e);
										return (t._chain = !0), t;
									},
									iteratee: Fe,
									partial: nt,
									bind: rt,
									bindAll: at,
									memoize: function (e, t) {
										var n = function n(r) {
											var o = n.cache,
												i = '' + (t ? t.apply(this, arguments) : r);
											return H(o, i) || (o[i] = e.apply(this, arguments)), o[i];
										};
										return (n.cache = {}), n;
									},
									delay: st,
									defer: lt,
									throttle: function (e, t, n) {
										var r,
											o,
											i,
											a,
											s = 0;
										n || (n = {});
										var l = function () {
												(s = !1 === n.leading ? 0 : He()), (r = null), (a = e.apply(o, i)), r || (o = i = null);
											},
											u = function () {
												var u = He();
												s || !1 !== n.leading || (s = u);
												var c = t - (u - s);
												return (
													(o = this),
													(i = arguments),
													c <= 0 || c > t
														? (r && (clearTimeout(r), (r = null)), (s = u), (a = e.apply(o, i)), r || (o = i = null))
														: r || !1 === n.trailing || (r = setTimeout(l, c)),
													a
												);
											};
										return (
											(u.cancel = function () {
												clearTimeout(r), (s = 0), (r = o = i = null);
											}),
											u
										);
									},
									debounce: function (e, t, n) {
										var r,
											o,
											i,
											a,
											s,
											l = function l() {
												var u = He() - o;
												t > u
													? (r = setTimeout(l, t - u))
													: ((r = null), n || (a = e.apply(s, i)), r || (i = s = null));
											},
											u = O(function (u) {
												return (
													(s = this), (i = u), (o = He()), r || ((r = setTimeout(l, t)), n && (a = e.apply(s, i))), a
												);
											});
										return (
											(u.cancel = function () {
												clearTimeout(r), (r = i = s = null);
											}),
											u
										);
									},
									wrap: function (e, t) {
										return nt(t, e);
									},
									negate: ut,
									compose: function () {
										var e = arguments,
											t = e.length - 1;
										return function () {
											for (var n = t, r = e[t].apply(this, arguments); n--; ) r = e[n].call(this, r);
											return r;
										};
									},
									after: function (e, t) {
										return function () {
											if (--e < 1) return t.apply(this, arguments);
										};
									},
									before: ct,
									once: dt,
									findKey: ft,
									findIndex: ht,
									findLastIndex: mt,
									sortedIndex: vt,
									indexOf: yt,
									lastIndexOf: bt,
									find: _t,
									detect: _t,
									findWhere: function (e, t) {
										return _t(e, je(t));
									},
									each: wt,
									forEach: wt,
									map: Ot,
									collect: Ot,
									reduce: xt,
									foldl: xt,
									inject: xt,
									reduceRight: Et,
									foldr: Et,
									filter: Tt,
									select: Tt,
									reject: function (e, t, n) {
										return Tt(e, ut(Be(t)), n);
									},
									every: St,
									all: St,
									some: At,
									any: At,
									contains: Ct,
									includes: Ct,
									include: Ct,
									invoke: Pt,
									pluck: Rt,
									where: function (e, t) {
										return Tt(e, je(t));
									},
									max: It,
									min: function (e, t, n) {
										var r,
											i,
											a = 1 / 0,
											s = 1 / 0;
										if (null == t || ('number' == typeof t && 'object' != (0, o.default)(e[0]) && null != e))
											for (var l = 0, u = (e = ot(e) ? e : we(e)).length; l < u; l++)
												null != (r = e[l]) && r < a && (a = r);
										else
											(t = Be(t, n)),
												wt(e, function (e, n, r) {
													((i = t(e, n, r)) < s || (i === 1 / 0 && a === 1 / 0)) && ((a = e), (s = i));
												});
										return a;
									},
									shuffle: function (e) {
										return Nt(e, 1 / 0);
									},
									sample: Nt,
									sortBy: function (e, t, n) {
										var r = 0;
										return (
											(t = Be(t, n)),
											Rt(
												Ot(e, function (e, n, o) {
													return { value: e, index: r++, criteria: t(e, n, o) };
												}).sort(function (e, t) {
													var n = e.criteria,
														r = t.criteria;
													if (n !== r) {
														if (n > r || void 0 === n) return 1;
														if (n < r || void 0 === r) return -1;
													}
													return e.index - t.index;
												}),
												'value'
											)
										);
									},
									groupBy: jt,
									indexBy: Dt,
									countBy: Lt,
									partition: Ut,
									toArray: function (e) {
										return e ? (Z(e) ? l.call(e) : S(e) ? e.match(Ft) : ot(e) ? Ot(e, Me) : we(e)) : [];
									},
									size: function (e) {
										return null == e ? 0 : ot(e) ? e.length : ne(e).length;
									},
									pick: Vt,
									omit: Zt,
									first: qt,
									head: qt,
									take: qt,
									initial: Ht,
									last: function (e, t, n) {
										return null == e || e.length < 1
											? null == t || n
												? void 0
												: []
											: null == t || n
											? e[e.length - 1]
											: Wt(e, Math.max(0, e.length - t));
									},
									rest: Wt,
									tail: Wt,
									drop: Wt,
									compact: function (e) {
										return Tt(e, Boolean);
									},
									flatten: function (e, t) {
										return it(e, t, !1);
									},
									without: $t,
									uniq: zt,
									unique: zt,
									union: Gt,
									intersection: function (e) {
										for (var t = [], n = arguments.length, r = 0, o = ee(e); r < o; r++) {
											var i = e[r];
											if (!Ct(t, i)) {
												var a;
												for (a = 1; a < n && Ct(arguments[a], i); a++);
												a === n && t.push(i);
											}
										}
										return t;
									},
									difference: Kt,
									unzip: Yt,
									transpose: Yt,
									zip: Jt,
									object: function (e, t) {
										for (var n = {}, r = 0, o = ee(e); r < o; r++) t ? (n[e[r]] = t[r]) : (n[e[r][0]] = e[r][1]);
										return n;
									},
									range: function (e, t, n) {
										null == t && ((t = e || 0), (e = 0)), n || (n = t < e ? -1 : 1);
										for (var r = Math.max(Math.ceil((t - e) / n), 0), o = Array(r), i = 0; i < r; i++, e += n) o[i] = e;
										return o;
									},
									chunk: function (e, t) {
										if (null == t || t < 1) return [];
										for (var n = [], r = 0, o = e.length; r < o; ) n.push(l.call(e, r, (r += t)));
										return n;
									},
									mixin: Xt,
									default: oe,
								});
								return (en._ = en), en;
							})());
					})(a.u);
					var s = a.u.exports;
					(t.default = s), (e.exports = t.default);
				},
				2890: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						Object.defineProperty(t, '$', {
							enumerable: !0,
							get: function () {
								return _.default;
							},
						}),
						Object.defineProperty(t, 'Backbone', {
							enumerable: !0,
							get: function () {
								return F.default;
							},
						}),
						Object.defineProperty(t, 'BaseModel', {
							enumerable: !0,
							get: function () {
								return i.default;
							},
						}),
						(t.Form = t.Controller = t.Collection = void 0),
						Object.defineProperty(t, 'FrameworkView', {
							enumerable: !0,
							get: function () {
								return B.default;
							},
						}),
						Object.defineProperty(t, 'Handlebars', {
							enumerable: !0,
							get: function () {
								return b.default;
							},
						}),
						Object.defineProperty(t, 'ListView', {
							enumerable: !0,
							get: function () {
								return O.default;
							},
						}),
						Object.defineProperty(t, 'Model', {
							enumerable: !0,
							get: function () {
								return s.default;
							},
						}),
						(t.View = t.Router = void 0),
						Object.defineProperty(t, '_', {
							enumerable: !0,
							get: function () {
								return w.default;
							},
						}),
						(t.internal = t.createCallout = t.createButton = void 0),
						Object.defineProperty(t, 'isModelPropertySchema', {
							enumerable: !0,
							get: function () {
								return V.isModelPropertySchema;
							},
						}),
						(t.registerInput = t.loc = void 0);
					var o = r(n(74154)),
						i = r(n(34146)),
						a = r(n(50553)),
						s = r(n(13614)),
						l = r(n(84829)),
						u = r(n(41380)),
						c = r(n(23825)),
						d = r(n(2431)),
						f = r(n(96577)),
						p = r(n(11403)),
						h = r(n(86063)),
						m = r(n(83365)),
						v = r(n(77861)),
						g = r(n(88712)),
						y = r(n(51645)),
						b = r(n(2875));
					n(97406), n(37997);
					var _ = r(n(96129)),
						w = r(n(28107)),
						O = r(n(54833)),
						k = r(n(45361)),
						x = r(n(92328)),
						E = r(n(1375)),
						T = r(n(21198)),
						S = r(n(63301)),
						A = r(n(57581)),
						C = r(n(66728)),
						P = r(n(76906)),
						R = r(n(15982)),
						I = r(n(37002)),
						N = r(n(18329)),
						M = r(n(63984)),
						j = r(n(84983)),
						D = r(n(59924)),
						L = r(n(69407)),
						U = r(n(73026)),
						F = r(n(2770)),
						B = r(n(67282));
					n(57223);
					var V = n(50926);
					n(53303);
					var Z = u.default.extend({
						render: function () {
							for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
							return k.default.prototype.render.apply(this, t), this;
						},
					});
					(t.Controller = Z),
						(j.default.prototype.remove = function () {
							return R.default.prototype.remove.apply(this, arguments);
						}),
						(B.default.prototype.compileTemplate = function (e) {
							var t = function () {
								return e;
							};
							return (t.source = ''), t;
						});
					var H = {
							'input input': 'update',
							'change input': 'update',
							'keydown input': 'update',
							'keyup input': function (e) {
								m.default.isEsc(e) && this.model.trigger('form:cancel');
							},
						},
						q = L.default.extend({ events: H }),
						W = N.default.extend({ events: H }),
						K = T.default.extend({
							scrollOnError: function () {
								return !1 !== this.options.settings.get('features.scrollOnError');
							},
						});
					t.Form = K;
					var $ = g.default.localize;
					t.loc = $;
					var z = d.default.create;
					t.createButton = z;
					var G = U.default.create;
					t.createCallout = G;
					var Y = C.default.register;
					t.registerInput = Y;
					var J = o.default;
					t.Collection = J;
					var Q = k.default;
					t.View = Q;
					var X = c.default;
					t.Router = X;
					var ee = {
						util: {
							Util: y.default,
							Cookie: p.default,
							Clipboard: h.default,
							Logger: v.default,
							Class: f.default,
							Keys: m.default,
						},
						views: {
							components: { BaseDropDown: x.default, Notification: E.default },
							forms: {
								helpers: { FormUtil: A.default, SchemaFormFactory: P.default },
								components: { Toolbar: S.default },
								inputs: {
									TextBox: q,
									PasswordBox: W,
									CheckBox: I.default,
									Radio: M.default,
									Select: j.default,
									InputGroup: D.default,
								},
							},
						},
						models: { BaseSchema: a.default, SchemaProperty: l.default },
					};
					(t.internal = ee),
						Y('text', q),
						Y('password', W),
						Y('checkbox', I.default),
						Y('radio', M.default),
						Y('select', j.default),
						Y('group', D.default);
				},
				50843: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = r(n(2770)),
						a = '__STATE__',
						s = 'FETCH_DATA',
						l = 'PAGINATION_DATA',
						u = 'DEFAULT_PARAMS',
						c = 'LINK_BY_HEADER';
					function d(e, t) {
						try {
							var n = (function (e) {
								for (
									var t,
										n = /[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*"))/g,
										r = e.match(
											/<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[\]?={} \t]+)|("[^"]*")))*(,|$)/g
										),
										o = {},
										i = 0;
									i < r.length;
									i++
								) {
									var a = r[i].split('>'),
										s = a[0].substring(1),
										l = { href: void 0, rel: void 0 };
									l.href = s;
									for (var u = a[1].match(n), c = 0; c < u.length; c++) {
										var d = u[c].split('=');
										l[d[0]] =
											'"' === (t = d[1]).charAt(0) && '"' === t.charAt(t.length - 1) ? t.substring(1, t.length - 1) : t;
									}
									void 0 !== l.rel && (o[l.rel] = l);
								}
								return o;
							})(t.getResponseHeader('link'));
							e[a].set(c, !0), e.setPagination(n.next.href);
						} catch (t) {
							e[a].get(c) && e.setPagination(null);
						}
					}
					var f = {
							params: {},
							preinitialize: function (e, t) {
								var n = new i.default.Model(),
									r = o.default.defaults((t && t.params) || {}, o.default.result(this, 'params') || {});
								n.set(u, r),
									(this[a] = n),
									o.default.isFunction(this.model) &&
										0 === this.model.length &&
										!0 !== this.model.isCourageModel &&
										(this.model = o.default.result(this, 'model')),
									i.default.Collection.prototype.preinitialize.apply(this, arguments);
							},
							sync: function (e, t, n) {
								var r = this,
									o = n.success;
								return (
									(n.success = function (e, t, n) {
										d(r, n), o.apply(null, arguments);
									}),
									i.default.Collection.prototype.sync.call(this, e, t, n)
								);
							},
							fetch: function (e) {
								e || (e = {});
								var t = this[a],
									n = t.get('XHR');
								return (
									(e.data = o.default.extend({}, t.get(u), e.data || {})),
									(e.fromFetch = !0),
									t.set(s, e.data),
									n && n.abort && !1 !== e.abort && n.abort(),
									(n = i.default.Collection.prototype.fetch.call(this, e)),
									t.set('XHR', n),
									n
								);
							},
							setPagination: function (e, t) {
								o.default.isString(e) &&
									e &&
									(e = (function (e) {
										for (
											var t = {}, n = e && e.split('?')[1], r = n && n.split('#')[0], o = r ? r.split('&') : [], i = 0;
											i < o.length;
											i++
										) {
											var a = decodeURIComponent(o[i]).replace(/\+/g, ' ').split('=');
											t[a.shift()] = a.join('=');
										}
										return t;
									})(e)),
									o.default.isObject(e) && !o.default.isArray(e) && o.default.size(e)
										? t && t.fromFetch && (e = o.default.extend({}, this.getFetchData(), e))
										: (e = null),
									this[a].set(l, e);
							},
							getFetchData: function () {
								return this[a].get(s) || {};
							},
							getPaginationData: function () {
								return this[a].get(l) || {};
							},
							hasMore: function () {
								return o.default.size(this.getPaginationData()) > 0;
							},
							fetchMore: function () {
								if (!this.hasMore()) throw new Error('Invalid Request');
								return this.fetch({ data: this.getPaginationData(), add: !0, remove: !1, update: !0 });
							},
							reset: function (e, t) {
								return (
									t || (t = {}),
									t.fromFetch || this.setPagination(null),
									i.default.Collection.prototype.reset.apply(this, arguments)
								);
							},
							where: function (e, t) {
								return o.default.isEmpty(e)
									? t
										? void 0
										: []
									: this[t ? 'find' : 'filter'](function (t) {
											for (var n in e) if (e[n] !== t.get(n)) return !1;
											return !0;
									  });
							},
							create: function (e, t) {
								return (
									t || (t = {}),
									o.default.result(e, 'urlRoot') || (t.url = o.default.result(this, 'url')),
									i.default.Collection.prototype.create.call(this, e, t)
								);
							},
							_reset: function () {
								i.default.Collection.prototype._reset.call(this), (this._byId = Object.create(null));
							},
						},
						p = i.default.Collection.extend(f);
					(t.default = p), (p.isCourageCollection = !0), (e.exports = t.default);
				},
				83050: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(67282)),
						i = r(n(28107)),
						a = o.default.extend({
							constructor: function () {
								if ((o.default.apply(this, arguments), !this.collection)) throw new Error('Missing collection');
								this.listenTo(this.collection, 'reset sort', this.reset),
									this.listenTo(this.collection, 'add', this.addItem),
									this.fetchCollection ? this.collection.fetch() : this.collection.each(this.addItem, this);
							},
							item: null,
							itemSelector: null,
							reset: function () {
								var e = this;
								return (
									this.removeChildren(),
									this.collection.each(function (t, n) {
										e.addItem(t, n);
									}),
									this
								);
							},
							addItem: function (e) {
								var t = this.add(this.item, this.itemSelector, { options: { model: e } }).last();
								return (
									this.state && this.state.get('trackItemAdded') && this.state.trigger('itemAdded', t),
									t.listenTo(e, 'destroy remove', t.remove),
									this
								);
							},
							addShowMore: i.default.noop,
						});
					(t.default = a), (e.exports = t.default);
				},
				50926: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0), (t.isModelPropertySchema = u);
					var o,
						i = r(n(12990)),
						a = r(n(28107)),
						s = r(n(2770)),
						l = r(n(77861));
					function u(e) {
						return (e && e.type) || e.deps;
					}
					function c(e, t, n, r) {
						var o = a.default.contains(t, n);
						return (
							r || (r = {}),
							o || !a.default.isObject(e) || a.default.isArray(e) || a.default.isFunction(e)
								? void 0 !== n && (r[n] = e)
								: a.default.each(e, function (e, o) {
										c(e, t, n ? n + '.' + o : o, r);
								  }),
							r
						);
					}
					function d(e) {
						return (
							a.default.each(e, function (e, t, n) {
								if (-1 !== t.indexOf('.')) {
									for (var r, o = n, i = t.split('.'); void 0 !== (r = i.shift()); )
										o[r] || (o[r] = i.length ? {} : e), (o = o[r]);
									delete n[t];
								}
							}),
							e
						);
					}
					function f(e, t) {
						var n = {};
						return (n[e.name] = t), n;
					}
					function p(e, t) {
						var n;
						return (
							(n = a.default.isString(e)
								? { type: e }
								: a.default.isArray(e)
								? { type: e[0], required: e[1], value: e[2] }
								: a.default.clone(e)),
							a.default.defaults(n, { required: !1, name: t }),
							n
						);
					}
					function h(e, t, n) {
						if (!t.test(e)) return n;
					}
					var m = {
						email: function (e) {
							return h(
								e,
								/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
								o.ERROR_INVALID_FORMAT_EMAIL
							);
						},
						uri: function (e) {
							return h(
								e,
								/^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i,
								o.ERROR_INVALID_FORMAT_URI
							);
						},
						ipv4: function (e) {
							return h(
								e,
								/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
								o.ERROR_INVALID_FORMAT_IPV4
							);
						},
						hostname: function (e) {
							return h(
								e,
								/^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/,
								o.ERROR_INVALID_FORMAT_HOSTNAME
							);
						},
					};
					function v(e, t) {
						var n = a.default.partial(f, e),
							r = (function (e, t) {
								var n = m[e.format];
								if (e.format && !n) throw new TypeError(e.format + ' is not a supported string format');
								return n && n(t);
							})(e, t);
						return r
							? n(r)
							: t && e.minLength && t.length < e.minLength
							? n(o.ERROR_STRING_STRING_MIN_LENGTH)
							: t && e.maxLength && t.length > e.maxLength
							? n(o.ERROR_STRING_STRING_MAX_LENGTH)
							: void 0;
					}
					function g(e, t) {
						var n,
							r,
							i,
							s = a.default.partial(f, e),
							l = !a.default.isUndefined(t) && !a.default.isNull(t);
						if (Array.isArray(e.validate)) {
							var u,
								c = [],
								d = !1;
							return (
								e.validate.forEach(function (e) {
									if (t)
										if ('regex' === e.type.toLowerCase()) u = new RegExp(e.value.pattern, e.value.flags || '').test(t);
										else u = !1;
									else u = !1;
									(d = d || !u), c.push({ message: e.hasOwnProperty('message') ? e.message : '', passed: u });
								}),
								d ? s(c) : void 0
							);
						}
						if (e.required && (!l || a.default.isNull(t) || '' === t)) return s(o.ERROR_BLANK);
						if (
							((n =
								a.default[
									'is' +
										((i = e.type),
										i.toLowerCase().replace(/\b[a-z]/g, function (e) {
											return e.toUpperCase();
										}))
								]),
							l && 'any' !== e.type && (!a.default.isFunction(n) || !n(t)))
						)
							return s(o.ERROR_WRONG_TYPE);
						if (t && 'string' === e.type) {
							var h = v(e, t);
							if (h) return h;
						}
						if (l && e.values && !a.default.contains(e.values, t)) return s(o.ERROR_NOT_ALLOWED);
						if (a.default.isFunction(e.validate)) {
							var m = e.validate(t);
							if (a.default.isString(m) && m) return s(m);
							if (!1 === m) return s(o.ERROR_INVALID);
						}
						return l &&
							'array' === e.type &&
							(r = (function (e, t) {
								if (e.minItems && t.length < e.minItems) return 'model.validation.field.array.minItems';
								if (e.maxItems && t.length > e.maxItems) return 'model.validation.field.array.maxItems';
								if (e.uniqueItems && t.length > a.default.uniq(t).length) return o.ERROR_IARRAY_UNIQUE;
								if (e.items)
									for (var n = p(e.items, 'placeholder'), r = 0; r < t.length; r++) {
										var i = g(n, t[r]);
										if (i) return i.placeholder;
									}
							})(e, t))
							? s(r)
							: void 0;
					}
					var y = {
						props: {},
						derived: {},
						local: {},
						flat: !0,
						defaults: {},
						preinitialize: function (e) {
							for (var t, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
								r[o - 1] = arguments[o];
							this.options = e || {};
							var i = (this.__schema__ = {}),
								l = [];
							(i.computedProperties = {}),
								(i.props = a.default.clone(a.default.result(this, 'props') || {})),
								(i.derived = a.default.clone(a.default.result(this, 'derived') || {})),
								(i.local = a.default.clone(a.default.result(this, 'local') || {}));
							var u = {};
							if (
								(a.default.each(
									a.default.extend({}, i.props, i.local),
									function (e, t) {
										var n = p(e, t);
										a.default.isUndefined(n.value) || (u[t] = n.value), 'object' === n.type && l.push(t);
									},
									this
								),
								a.default.size(u))
							) {
								var d = a.default.result(this, 'defaults');
								this.defaults = function () {
									return a.default.defaults({}, u, d);
								};
							}
							(this.validate = a.default.wrap(this.validate, function (e) {
								var t = a.default.rest(arguments),
									n = a.default.extend(this._validateSchema.apply(this, t), e.apply(this, t));
								return (a.default.size(n) && n) || void 0;
							})),
								(this.parse = a.default.wrap(this.parse, function (e) {
									var t = e.apply(this, a.default.rest(arguments));
									return a.default.result(this, 'flat') && (t = c(t, l)), t;
								})),
								(t = s.default.Model.prototype.preinitialize).call.apply(t, [this, e].concat(r));
						},
						constructor: function () {
							s.default.Model.apply(this, arguments);
							var e = this.__schema__;
							a.default.each(
								e.derived,
								function (t, n) {
									e.computedProperties[n] = this.__getDerivedValue(n);
									var r = (u(t) && t.deps) || [];
									r.length &&
										this.on(
											'cache:clear change:' + r.join(' change:'),
											function () {
												var t = this.__getDerivedValue(n);
												t !== e.computedProperties[n] &&
													((e.computedProperties[n] = t), this.trigger('change:' + n, this, t));
											},
											this
										);
								},
								this
							),
								this.on(
									'sync',
									function () {
										this.__syncedData = this.toJSON();
									},
									this
								);
						},
						validate: function () {},
						allows: function (e) {
							var t = this.__schema__,
								n = a.default.extend({}, t.props, t.local);
							return a.default.has(n, e) || l.default.warn('Field not defined in schema', e), !0;
						},
						getPropertySchema: function (e) {
							var t = this.__schema__;
							return a.default.reduce(
								[t.props, t.local],
								function (t, n) {
									return t || p(n[e], e);
								},
								null
							);
						},
						set: function (e, t) {
							var n;
							'object' === (0, i.default)(e) ? (n = e) : ((n = {})[e] = t),
								a.default.each(
									n,
									function (e, t) {
										if (a.default.has(this.__schema__.derived, t))
											throw new Error('overriding derived properties is not supported: '.concat(t));
									},
									this
								);
							var r = [];
							if (
								(a.default.each(
									n,
									function (e, t) {
										this.allows(t) || r.push(t);
									},
									this
								),
								r.length)
							)
								throw new Error('field not allowed: '.concat(r.join(', ')));
							return s.default.Model.prototype.set.apply(this, arguments);
						},
						get: function (e) {
							var t = this.__schema__;
							return a.default.has(t.derived, e)
								? !1 !== t.derived[e].cache
									? t.computedProperties[e]
									: this.__getDerivedValue(e)
								: s.default.Model.prototype.get.apply(this, arguments);
						},
						toJSON: function (e) {
							e || (e = {});
							var t = a.default.clone(s.default.Model.prototype.toJSON.apply(this, arguments)),
								n = this.__schema__;
							return (
								e.verbose
									? a.default.each(
											n.derived,
											function (e, n) {
												t[n] = this.get(n);
											},
											this
									  )
									: (t = a.default.omit(t, a.default.keys(n.local))),
								this.flat && (t = d(t)),
								t
							);
						},
						reset: function (e) {
							this.clear(e), this.set(a.default.result(this, 'defaults'), e);
						},
						isSynced: function () {
							return a.default.isEqual(this.__syncedData, this.toJSON());
						},
						validateField: function (e) {
							var t = e && this.getPropertySchema(e);
							return t && g(t, this.get(e));
						},
						_validateSchema: function () {
							var e = this.__schema__;
							return a.default.reduce(
								a.default.extend({}, e.props, e.local),
								function (e, t, n) {
									return a.default.extend(e, this.validateField(n) || {});
								},
								{},
								this
							);
						},
						__getDerivedValue: function (e) {
							var t = this.__schema__.derived[e];
							if (a.default.isString(t)) {
								var n = t;
								t = {
									deps: [n],
									fn: function () {
										return this.get(n);
									},
								};
							}
							var r = t.deps || [];
							return t.fn.apply(this, a.default.map(r, this.get, this));
						},
					};
					(o = s.default.Model.extend(y, {
						ERROR_BLANK: 'model.validation.field.blank',
						ERROR_WRONG_TYPE: 'model.validation.field.wrong.type',
						ERROR_NOT_ALLOWED: 'model.validation.field.value.not.allowed',
						ERROR_INVALID: 'model.validation.field.invalid',
						ERROR_IARRAY_UNIQUE: 'model.validation.field.array.unique',
						ERROR_INVALID_FORMAT_EMAIL: 'model.validation.field.invalid.format.email',
						ERROR_INVALID_FORMAT_URI: 'model.validation.field.invalid.format.uri',
						ERROR_INVALID_FORMAT_IPV4: 'model.validation.field.invalid.format.ipv4',
						ERROR_INVALID_FORMAT_HOSTNAME: 'model.validation.field.invalid.format.hostname',
						ERROR_STRING_STRING_MIN_LENGTH: 'model.validation.field.string.minLength',
						ERROR_STRING_STRING_MAX_LENGTH: 'model.validation.field.string.maxLength',
					})).isCourageModel = !0;
					var b = o;
					t.default = b;
				},
				67282: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o,
						i = r(n(28107)),
						a = r(n(2770)),
						s = '__children__',
						l = '__rendered__',
						u = '__parent__',
						c = '__children_definitions__',
						d = '__add_to_container__';
					function f(e, t) {
						for (var n = 0; n < e[s].length; n++) if (t.cid === e[s][n].cid) return n;
					}
					function p() {}
					function h(e) {
						var t = /^(?!(?:delegate|undelegate|_))([a-zA-Z0-9]+)(?:Events)$/;
						i.default.each(i.default.allKeys(e), function (n) {
							var r = n.match(t);
							if (r) {
								var o = i.default.result(e, n),
									a = e.options[r[1]] || e[r[1]];
								a &&
									i.default.isObject(o) &&
									i.default.isFunction(a.trigger) &&
									i.default.each(o, function (t, n) {
										var r = i.default.isFunction(t)
											? [t]
											: i.default.reduce(
													t.split(/\s+/),
													function (t, n) {
														return i.default.isFunction(e[n]) && t.push(e[n]), t;
													},
													[]
											  );
										i.default.each(r, function (t) {
											e.listenTo(a, n, t);
										});
									});
							}
						});
					}
					var m = {
						preinitialize: function (e) {
							(this.options = e || {}),
								i.default.extend(this, i.default.pick(this.options, 'state', 'settings')),
								(this[s] = []),
								(this[l] = !1),
								(this[u] = null),
								(this[c] = this.children),
								(this.__original_initialize__ = this.initialize),
								(this.initialize = p);
						},
						constructor: function (e) {
							var t;
							a.default.View.call(this, e),
								i.default.each(
									i.default.result(this, c),
									function (e) {
										this.add.apply(this, i.default.isArray(e) ? e : [e]);
									},
									this
								),
								delete this[c];
							var n = i.default.result(this, 'autoRender');
							if (n && this.model) {
								var r = i.default.isArray(n)
									? i.default
											.map(n, function (e) {
												return 'change:' + e;
											})
											.join(' ')
									: 'change';
								this.listenTo(this.model, r, function () {
									this.render();
								});
							}
							this.initialize = this.__original_initialize__;
							for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), l = 1; l < o; l++)
								s[l - 1] = arguments[l];
							(t = this.initialize).call.apply(t, [this, e].concat(s)), h(this);
						},
						unregister: function (e) {
							this.stopListening(e);
							var t = f(this, e);
							i.default.isNumber(t) && this[s].splice(t, 1);
						},
						autoRender: !1,
						template: null,
						children: [],
						add: function (e, t, n, r, l) {
							var c,
								p = {},
								h = i.default.toArray(arguments);
							if (i.default.isFunction(e) && (!e.prototype || !e.prototype.render))
								throw new Error('Type passed to add() is not a View');
							if (
								(i.default.isObject(t)
									? ((t = (p = t).selector), (n = p.bubble), (r = p.prepend), (l = p.options))
									: i.default.isObject(n) && ((n = (p = n).bubble), (r = p.prepend), (l = p.options)),
								i.default.isString(e) &&
									((c = e),
									(e = o.extend({
										constructor: function () {
											try {
												var e = a.default.$(c);
												if (1 !== e.length) throw new Error('invalid Element');
												var t = /&(\w+|#x\d+);/g,
													n = e.prop('outerHTML').replace(t, ' ').length,
													r = c.replace(t, ' ').length;
												if (n !== r) throw new Error('invalid Element');
												(this.template = e.html()), (this.el = e.empty()[0]);
											} catch (e) {
												this.template = c;
											}
											o.apply(this, arguments);
										},
									}))),
								e.prototype && e.prototype instanceof o)
							) {
								var m = i.default.omit(i.default.extend({}, this.options, l), 'el');
								return (h[0] = new e(m)), this.add.apply(this, h);
							}
							if (i.default.isNumber(f(this, e))) throw new Error('Duplicate child');
							return (
								(e[u] = this),
								(e[d] = function (t) {
									return function () {
										if (t && 1 !== e[u].$(t).length) throw new Error('Invalid selector: ' + t);
										var n = t ? this[u].$(t) : this[u].$el;
										this.render(), this.delegateEvents(), r ? n.prepend(this.el) : n.append(this.el);
									};
								}.call(e, t)),
								n &&
									this.listenTo(e, 'all', function () {
										this.trigger.apply(this, arguments);
									}),
								this.rendered() && e[d](),
								this[s].push(e),
								this
							);
						},
						removeChildren: function () {
							return (
								this.each(function (e) {
									e.remove();
								}),
								this
							);
						},
						remove: function () {
							return (
								this.removeChildren(),
								this[u] && this[u].unregister(this),
								a.default.View.prototype.remove.apply(this, arguments)
							);
						},
						compileTemplate: function (e) {
							return i.default.template(e, void 0);
						},
						renderTemplate: function (e) {
							if ((i.default.isString(e) && (e = this.compileTemplate(e)), i.default.isFunction(e)))
								return e(this.getTemplateData());
						},
						getTemplateData: function () {
							var e = (this.model && this.model.toJSON({ verbose: !0 })) || {},
								t = i.default.omit(this.options, ['state', 'settings', 'model', 'collection']);
							return i.default.defaults({}, e, t);
						},
						render: function () {
							return (
								this.preRender(),
								(function (e) {
									e[l] = !0;
									var t = e.renderTemplate(e.template);
									t ? e.$el.html(t) : e.length && e.$el.empty(),
										e.each(function (e) {
											e[d]();
										});
								})(this),
								this.postRender(),
								this
							);
						},
						preRender: p,
						postRender: p,
						rendered: function () {
							return this[l];
						},
						getChildren: function () {
							return this.toArray();
						},
						at: function (e) {
							return this.getChildren()[e];
						},
						invoke: function (e) {
							var t = i.default.toArray(arguments);
							return (
								this.each(function (n) {
									n.size() && n.invoke.apply(n, t), i.default.isFunction(n[e]) && n[e].apply(n, t.slice(1));
								}),
								this
							);
						},
					};
					o = a.default.View.extend(m);
					i.default.each(
						[
							'each',
							'map',
							'reduce',
							'reduceRight',
							'find',
							'filter',
							'reject',
							'every',
							'some',
							'contains',
							'toArray',
							'size',
							'first',
							'initial',
							'rest',
							'last',
							'without',
							'indexOf',
							'shuffle',
							'lastIndexOf',
							'isEmpty',
							'chain',
							'where',
							'findWhere',
						],
						function (e) {
							o.prototype[e] = function () {
								var t = i.default.toArray(arguments);
								return t.unshift(i.default.toArray(this[s])), i.default[e].apply(i.default, t);
							};
						}
					),
						(o.isCourageView = !0);
					var v = o;
					(t.default = v), (e.exports = t.default);
				},
				74154: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = r(n(50843)),
						a = {
							secureJSON: !1,
							constructor: function () {
								i.default.apply(this, arguments),
									o.default.result(this, 'secureJSON') &&
										(this.sync = o.default.wrap(this.sync, function (e, t, n, r) {
											return e.call(this, t, n, o.default.extend({ dataType: 'secureJSON' }, r));
										}));
							},
						},
						s = i.default.extend(a);
					(t.default = s), (e.exports = t.default);
				},
				34146: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(28107)),
						a = r(n(13614)),
						s = function (e) {
							var t = i.default.omit(e.local, i.default.keys(e._builtInLocalProps));
							return i.default.size(e.props) + i.default.size(t) > 0;
						},
						l = {
							flat: !1,
							constructor: function () {
								a.default.apply(this, arguments), this.on('sync', this._setSynced);
							},
							allows: function () {
								return !s(this) || a.default.prototype.allows.apply(this, arguments);
							},
							set: function (e, t) {
								var n;
								return (
									'object' === (0, o.default)(e) ? (n = e) : ((n = {})[e] = t),
									(0, i.default)(n).each(function (e, t) {
										e &&
											i.default.isArray(e.__attributes) &&
											this.on(
												'change:' + e.__attributes.join(' change:'),
												function () {
													var e = this.get(t);
													e !== this.__schema__.computedProperties[t] &&
														((this.__schema__.computedProperties[t] = e), this.trigger('change:' + t, e));
												},
												this
											);
									}, this),
									a.default.prototype.set.apply(this, arguments)
								);
							},
							get: function () {
								var e = a.default.prototype.get.apply(this, arguments);
								return i.default.isFunction(e) ? e.apply(this, i.default.map(e.__attributes || [], this.get, this)) : e;
							},
							toJSON: function (e) {
								e || (e = {});
								var t = a.default.prototype.toJSON.apply(this, arguments);
								return (
									(0, i.default)(t).each(function (n, r) {
										'function' == typeof n && (e.verbose ? (t[r] = this.get(r)) : delete t[r]);
									}, this),
									e.verbose ||
										(0, i.default)(t).each(function (e, n) {
											/^__\w+__$/.test(n) && delete t[n];
										}),
									t
								);
							},
							sanitizeAttributes: function (e) {
								var t = {};
								return (
									i.default.each(e, function (e, n) {
										i.default.isFunction(e) || (t[n] = e);
									}),
									t
								);
							},
							reset: function (e) {
								this.clear(e), this.set(this.sanitizeAttributes(this.defaults), e);
							},
							clear: function (e) {
								var t = {};
								return (
									i.default.each(this.sanitizeAttributes(this.attributes), function (e, n) {
										t[n] = void 0;
									}),
									this.set(t, i.default.extend({}, e, { unset: !0 }))
								);
							},
							_setSynced: function (e) {
								this._syncedData = e && i.default.isFunction(e.toJSON) ? e.toJSON() : {};
							},
							_getSynced: function () {
								return this._syncedData;
							},
							isSynced: function () {
								return i.default.isEqual(this._getSynced(), this.toJSON());
							},
						},
						u = a.default.extend(l, {
							ComputedProperty: function (e, t) {
								return t || 'function' != typeof e ? (t.__attributes = e) : (t = e), t;
							},
						});
					(t.default = u), (e.exports = t.default);
				},
				50553: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = r(n(74154)),
						a = r(n(34146)),
						s = r(n(84829)),
						l = function (e) {
							var t = o.default.pick(e, 'id', 'name', 'displayName'),
								n = o.default.map(e.schema.properties, function (e, t) {
									return o.default.extend({ name: t }, e);
								});
							return (
								o.default.each(n, function (e) {
									(e.__schemaMeta__ = t), e.__metadata && ((e.__metadata__ = e.__metadata), delete e.__metadata);
								}),
								n
							);
						},
						u = a.default.extend({
							defaults: { id: void 0, displayName: void 0, name: void 0 },
							constructor: function () {
								(this.properties = new s.default.Collection()), a.default.apply(this, arguments);
							},
							getProperties: function () {
								return this.properties;
							},
							clone: function () {
								var e = a.default.prototype.clone.apply(this, arguments);
								return e.getProperties().set(this.getProperties().toJSON({ verbose: !0 })), e;
							},
							parse: function (e) {
								var t = l(e);
								return this.properties.set(t, { parse: !0 }), o.default.omit(e, 'schema');
							},
							trimProperty: function (e) {
								return o.default.omit(e, 'name');
							},
							toJSON: function () {
								var e = a.default.prototype.toJSON.apply(this, arguments);
								return (
									(e.schema = { properties: {} }),
									this.getProperties().each(function (t) {
										var n = t.toJSON();
										e.schema.properties[n.name] = this.trimProperty(n);
									}, this),
									e
								);
							},
							save: function () {
								return (
									this.getProperties().each(function (e) {
										e.cleanup();
									}),
									a.default.prototype.save.apply(this, arguments)
								);
							},
						}),
						c = i.default.extend({ model: u }),
						d = { parseProperties: l, Model: u, Collection: c };
					(t.default = d), (e.exports = t.default);
				},
				13614: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = r(n(50926)),
						a = i.default.extend({
							secureJSON: !1,
							_builtInLocalProps: { __edit__: 'boolean', __pending__: 'boolean' },
							preinitialize: function () {
								(this.local = o.default.defaults({}, o.default.result(this, 'local'), this._builtInLocalProps)),
									i.default.prototype.preinitialize.apply(this, arguments);
							},
							constructor: function () {
								i.default.apply(this, arguments),
									o.default.result(this, 'secureJSON') &&
										(this.sync = o.default.wrap(this.sync, function (e, t, n, r) {
											return e.call(this, t, n, o.default.extend({ dataType: 'secureJSON' }, r));
										}));
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				84829: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(96129)),
						i = r(n(28107)),
						a = r(n(74154)),
						s = r(n(34146)),
						l = r(n(77861)),
						u = r(n(33270)),
						c = r(n(88712)),
						d = r(n(52078)),
						f = c.default.localize,
						p = u.default.STRING,
						h = u.default.NUMBER,
						m = u.default.INTEGER,
						v = u.default.OBJECT,
						g = s.default.extend({
							defaults: { description: void 0, minLength: void 0, maxLength: void 0, format: void 0 },
							parse: function (e) {
								if (i.default.isString(e.format)) {
									var t = /^\/(.+)\/$/.exec(e.format);
									t && (e.format = t[1]);
								}
								return e;
							},
						}),
						y = a.default.extend({ model: g }),
						b = y.extend({ _type: 'allOf' }),
						_ = y.extend({ _type: 'oneOf' }),
						w = y.extend({ _type: 'noneOf' }),
						O = {
							string: f('schema.validation.field.value.must.string', 'courage'),
							number: f('schema.validation.field.value.must.number', 'courage'),
							integer: f('schema.validation.field.value.must.integer', 'courage'),
							object: f('schema.validation.field.value.must.object', 'courage'),
						},
						k = /[^a-zA-Z0-9-]/,
						x = {
							between: '_checkBetweenConstraints',
							greaterThan: '_checkGreaterThanConstraint',
							lessThan: '_checkLessThanConstraint',
							equals: '_checkEqualsConstraint',
						},
						E = s.default.extend({
							idAttribute: 'name',
							local: { __oneOf__: { type: 'array', minItems: 1 } },
							defaults: {
								name: '',
								title: void 0,
								type: void 0,
								description: void 0,
								required: !1,
								format: void 0,
								union: void 0,
								subSchemas: void 0,
								settings: { permissions: { SELF: u.default.PERMISSION.READ_ONLY } },
								unique: void 0,
								__metadata__: void 0,
								__isSensitive__: s.default.ComputedProperty(['settings'], function (e) {
									return !(!e || !e.sensitive || 'NOT_SENSITIVE' === e.sensitive);
								}),
								__isPendingSensitive__: s.default.ComputedProperty(['settings'], function (e) {
									return !(!e || !e.sensitive || 'PENDING_SENSITIVE' !== e.sensitive);
								}),
								__unique__: !1,
								__isUniqueValidated__: s.default.ComputedProperty(['unique'], function (e) {
									return e === u.default.UNIQUENESS.UNIQUE_VALIDATED;
								}),
								__isPendingUniqueness__: s.default.ComputedProperty(['unique'], function (e) {
									return e === u.default.UNIQUENESS.PENDING_UNIQUENESS;
								}),
								__isUniqueness__: s.default.ComputedProperty(
									['__isUniqueValidated__', '__isPendingUniqueness__'],
									function (e, t) {
										return e || t;
									}
								),
								__canBeSensitive__: s.default.ComputedProperty(['__metadata__'], function (e) {
									return !(!e || !e.sensitivizable);
								}),
								__userPermission__: u.default.PERMISSION.READ_ONLY,
								__displayType__: void 0,
								__displayTypeLabel__: s.default.ComputedProperty(['__displayType__'], function (e) {
									return u.default.DATATYPE[e] || e;
								}),
								__supportsMinMax__: !1,
								__isReadOnly__: s.default.ComputedProperty(['mutability'], function (e) {
									return e === u.default.MUTABILITY.READONLY;
								}),
								__isWriteOnly__: s.default.ComputedProperty(['mutability'], function (e) {
									return e === u.default.MUTABILITY.WRITEONLY;
								}),
								__displayScope__: void 0,
								__isScopeSelf__: s.default.ComputedProperty(['scope'], function (e) {
									return e === u.default.SCOPE.SELF;
								}),
								__isNoneScopeArrayType__: s.default.ComputedProperty(
									['__isScopeSelf__', '__displayType__'],
									function (e, t) {
										return !e && u.default.isArrayDataType(t);
									}
								),
								__isImported__: s.default.ComputedProperty(['externalName'], function (e) {
									return !!e;
								}),
								__isFromBaseSchema__: s.default.ComputedProperty(['__schemaMeta__'], function (e) {
									return e && 'base' === e.name;
								}),
								__enumDefined__: !1,
								__supportEnum__: s.default.ComputedProperty(['__displayType__'], function (e) {
									return i.default.contains(u.default.SUPPORTENUM, e);
								}),
								__isNumberTypeEnum__: s.default.ComputedProperty(['__displayType__'], function (e) {
									return i.default.contains([u.default.NUMBER, u.default.ARRAYDISPLAYTYPE.arrayofnumber], e);
								}),
								__isIntegerTypeEnum__: s.default.ComputedProperty(['__displayType__'], function (e) {
									return i.default.contains([u.default.INTEGER, u.default.ARRAYDISPLAYTYPE.arrayofinteger], e);
								}),
								__isObjectTypeEnum__: s.default.ComputedProperty(['__displayType__'], function (e) {
									return i.default.contains([u.default.OBJECT, u.default.ARRAYDISPLAYTYPE.arrayofobject], e);
								}),
								__isStringTypeEnum__: s.default.ComputedProperty(['__displayType__'], function (e) {
									return i.default.contains([u.default.STRING, u.default.ARRAYDISPLAYTYPE.arrayofstring], e);
								}),
								__enumConstraintType__: s.default.ComputedProperty(
									['__isStringTypeEnum__', '__isNumberTypeEnum__', '__isIntegerTypeEnum__', '__isObjectTypeEnum__'],
									function (e, t, n, r) {
										return e ? p : t ? h : n ? m : r ? v : void 0;
									}
								),
								__isEnumDefinedAndSupported__: s.default.ComputedProperty(
									['__enumDefined__', '__supportEnum__'],
									function (e, t) {
										return e && t;
									}
								),
								__isLoginOfBaseSchema__: s.default.ComputedProperty(['__isFromBaseSchema__', 'name'], function (e, t) {
									return e && 'login' === t;
								}),
								__isLoginFormatRestrictionToEmail__: s.default.ComputedProperty(
									['__loginFormatRestriction__'],
									function (e) {
										return e === u.default.LOGINPATTERNFORMAT.EMAIL;
									}
								),
							},
							initialize: function () {
								s.default.prototype.initialize.apply(this, arguments),
									this.listenTo(this, 'change:__displayType__', this._updateTypeFormatConstraints),
									this.listenTo(this, 'change:type change:format change:items', this._updateDisplayType),
									this.listenTo(this, 'change:__minVal__ change:__maxVal__', this._updateMinMax),
									this.listenTo(this, 'change:__equals__', this._convertEqualsToMinMax),
									this.listenTo(this, 'change:__constraint__', this._setConstraintText),
									this._setConstraintText(),
									this._setLoginPattern();
							},
							parse: function (e) {
								return (
									'object' === (e = i.default.clone(e)).type && 'image' === e.extendedType && (e.type = 'image'),
									(e.__displayType__ = u.default.getDisplayType(
										e.type,
										e.format,
										e.items ? (e.items.format ? e.items.format : e.items.type) : void 0
									)),
									this._setRangeConstraints(e),
									(e.__supportsMinMax__ = -1 !== u.default.SUPPORTSMINMAX.indexOf(e.__displayType__)),
									(e.__displayScope__ = u.default.DISPLAYSCOPE[e.scope] || u.default.DISPLAYSCOPE.NA),
									e.settings &&
										e.settings.permissions &&
										e.settings.permissions.SELF &&
										(e.__userPermission__ = e.settings.permissions.SELF),
									this._setMasterOverride(e),
									this._setSubSchemas(e),
									this._setUniqueness(e),
									e
								);
							},
							validate: function () {
								var e = this._validateEnumOneOf();
								if (e) return e;
								if (this.get('__supportsMinMax__') && this.get('__constraint__')) {
									var t = this.get('__constraint__'),
										n = this[x[t]];
									return i.default.isFunction(n)
										? n.call(this)
										: void l.default.warn('No constraint handler found for: ' + t);
								}
							},
							_checkBetweenConstraints: function () {
								var e = this.get('__minVal__'),
									t = this.get('__maxVal__');
								if (e || t) {
									if (!e) return { __minVal__: f('schema.validation.field.enter.minimum.number', 'courage') };
									if (!t) return { __maxVal__: f('schema.validation.field.enter.maximum.number', 'courage') };
									var n = this._checkIntegerConstraints('__minVal__', 'Min value');
									return (
										n ||
										(n = this._checkIntegerConstraints('__maxVal__', 'Max value')) ||
										(+e >= +t
											? { __maxVal__: f('schema.validation.field.maximum.must.be.greater.than.minimum', 'courage') }
											: void 0)
									);
								}
							},
							_checkGreaterThanConstraint: function () {
								if (this.get('__minVal__')) {
									var e = this._checkIntegerConstraints('__minVal__', 'Constraint');
									return e || void 0;
								}
							},
							_checkLessThanConstraint: function () {
								if (this.get('__maxVal__')) {
									var e = this._checkIntegerConstraints('__maxVal__', 'Constraint');
									return e || void 0;
								}
							},
							_checkEqualsConstraint: function () {
								if (this.get('__equals__')) {
									var e = this._checkIntegerConstraints('__equals__', 'Constraint');
									return e || void 0;
								}
							},
							_checkIntegerConstraints: function (e, t) {
								var n = this.get(e),
									r = {};
								return isNaN(n)
									? ('Min value' === t
											? (r[e] = f('schema.validation.field.minimum.value.must.be.number', 'courage'))
											: 'Max value' === t
											? (r[e] = f('schema.validation.field.maximum.value.must.be.number', 'courage'))
											: 'Constraint' === t &&
											  (r[e] = f('schema.validation.field.constraint.must.be.number', 'courage')),
									  r)
									: +n < 0
									? ('Min value' === t
											? (r[e] = f('schema.validation.field.minimum.number.must.be.greater.than.zero', 'courage'))
											: 'Max value' === t
											? (r[e] = f('schema.validation.field.maximum.number.must.be.greater.than.zero', 'courage'))
											: 'Constraint' === t &&
											  (r[e] = f('schema.validation.field.number.must.be.greater.than.zero', 'courage')),
									  r)
									: void 0;
							},
							_setMasterOverride: function (e) {
								if (e.settings && e.settings.masterOverride && e.settings.masterOverride) {
									var t = e.settings.masterOverride.value;
									i.default.isArray(t) && !i.default.isEmpty(t)
										? ((e.__masterOverrideType__ = 'OVERRIDE'), (e.__masterOverrideValue__ = t || []))
										: (e.__masterOverrideType__ = e.settings.masterOverride.type);
								} else e.__masterOverrideType__ = 'INHERIT';
							},
							_setRangeConstraints: function (e) {
								e.__displayType__ === p
									? ((e.__minVal__ = e.minLength), (e.__maxVal__ = e.maxLength))
									: (e.__displayType__ !== m && e.__displayType__ !== h) ||
									  ((e.__minVal__ = e.minimum), (e.__maxVal__ = e.maximum)),
									e.__minVal__ && e.__maxVal__
										? e.__minVal__ === e.__maxVal__
											? ((e.__constraint__ = 'equals'), (e.__equals__ = e.__minVal__))
											: (e.__constraint__ = 'between')
										: !e.__minVal__ && e.__maxVal__
										? (e.__constraint__ = 'lessThan')
										: !e.__maxVal__ && e.__minVal__ && (e.__constraint__ = 'greaterThan');
							},
							_setSubSchemas: function (e) {
								e.allOf
									? (e.subSchemas = new b(e.allOf, { parse: !0 }))
									: e.oneOf
									? (e.subSchemas = new _(e.oneOf, { parse: !0 }))
									: e.noneOf && (e.subSchemas = new w(e.noneOf, { parse: !0 }));
							},
							_setUniqueness: function (e) {
								var t = e && e.unique;
								e.__unique__ = !(
									!t ||
									(t !== u.default.UNIQUENESS.UNIQUE_VALIDATED && t !== u.default.UNIQUENESS.PENDING_UNIQUENESS)
								);
							},
							_setLoginPattern: function () {
								if (this.get('__isLoginOfBaseSchema__')) {
									var e = this.get('pattern');
									'.+' === e
										? this.set('__loginFormatRestriction__', u.default.LOGINPATTERNFORMAT.NONE)
										: e
										? (this.set('__loginFormatRestriction__', u.default.LOGINPATTERNFORMAT.CUSTOM),
										  this.set('__loginFormatRestrictionCustom__', this._extractLoginPattern(e)))
										: this.set('__loginFormatRestriction__', u.default.LOGINPATTERNFORMAT.EMAIL);
								}
							},
							_updateDisplayType: function () {
								var e = this.get('type');
								if (e === p && this.get('format'))
									this.set('__displayType__', u.default.FORMATDISPLAYTYPE[this.get('format')]);
								else {
									var t = this.get('items'),
										n = t && (t.format ? t.format : t.type);
									e && n
										? this.set(
												'__displayType__',
												u.default.ARRAYDISPLAYTYPE[
													(function (e, t) {
														return e + 'of' + t;
													})(e, n)
												]
										  )
										: this.set('__displayType__', e);
								}
							},
							_validateEnumOneOf: function () {
								if (this.get('__isEnumDefinedAndSupported__')) {
									var e = this.get('__oneOf__') || [];
									if (i.default.isEmpty(e)) return { __oneOf__: f('model.validation.field.blank', 'courage') };
									if (!this._isValidateOneOfConstraint(e)) {
										var t = this.get('__enumConstraintType__');
										return { __oneOf__: O[t] };
									}
								}
							},
							_isValidateOneOfConstraint: function (e) {
								var t = this.get('__enumConstraintType__');
								return i.default.all(e, function (e) {
									return d.default.isConstraintValueMatchType(e.const, t);
								});
							},
							toJSON: function () {
								var e = s.default.prototype.toJSON.apply(this, arguments);
								return (
									(e.settings = { permissions: {} }),
									(e.settings.permissions.SELF = this.get('__userPermission__')),
									this.get('__isSensitive__') && (e.settings.sensitive = this.get('__isSensitive__')),
									'image' === this.get('type') && ((e.type = 'object'), (e.extendedType = 'image')),
									(e = this._enumAssignment(e)),
									(e = this._attributeOverrideToJson(e)),
									(e = this._normalizeUnionValue(e)),
									(e = this._patternAssignment(e)),
									(e = this._uniquenessAssignment(e))
								);
							},
							_attributeOverrideToJson: function (e) {
								var t = this.get('__masterOverrideType__'),
									n = this.get('__masterOverrideValue__');
								return (
									'OKTA_MASTERED' === t
										? (e.settings.masterOverride = { type: 'OKTA_MASTERED' })
										: 'OVERRIDE' === t &&
										  ((e.settings.masterOverride = { type: 'ORDERED_LIST', value: [] }),
										  n instanceof a.default
												? i.default.each(n.toJSON(), function (t) {
														e.settings.masterOverride.value.push(t.id);
												  })
												: n instanceof Array && (e.settings.masterOverride.value = n),
										  i.default.isEmpty(e.settings.masterOverride.value) && delete e.settings.masterOverride),
									'INHERIT' === t && delete e.settings.masterOverride,
									e
								);
							},
							_normalizeUnionValue: function (e) {
								return this.get('__isNoneScopeArrayType__') || (e.union = void 0), e;
							},
							_enumAssignment: function (e) {
								if (!this.get('__isEnumDefinedAndSupported__')) return e;
								var t = this._getEnumOneOfWithTitleCheck();
								return (
									'array' === this.get('type')
										? (delete e.items.enum, (e.items.oneOf = t))
										: (delete e.enum, (e.oneOf = t)),
									e
								);
							},
							_patternAssignment: function (e) {
								if (!this.get('__isLoginOfBaseSchema__') || !this.get('__loginFormatRestriction__')) return e;
								switch (this.get('__loginFormatRestriction__')) {
									case u.default.LOGINPATTERNFORMAT.EMAIL:
										delete e.pattern;
										break;
									case u.default.LOGINPATTERNFORMAT.CUSTOM:
										e.pattern = this._buildLoginPattern(this.get('__loginFormatRestrictionCustom__'));
										break;
									case u.default.LOGINPATTERNFORMAT.NONE:
										e.pattern = '.+';
								}
								return e;
							},
							_uniquenessAssignment: function (e) {
								return (
									this.get('__unique__')
										? this.get('__isUniqueness__') || (e.unique = u.default.UNIQUENESS.UNIQUE_VALIDATED)
										: delete e.unique,
									e
								);
							},
							_escapedRegexChar: function (e, t) {
								var n = e.charAt(t);
								return k.test(n) ? '\\' + n : n;
							},
							_buildLoginPattern: function (e) {
								for (var t = '', n = 0; n < e.length; n++) t += this._escapedRegexChar(e, n);
								return '[' + t + ']+';
							},
							_extractLoginPattern: function (e) {
								var t = e.match(/^\[(.*)\]\+/);
								return t ? t[1].replace(/\\(.)/g, '$1') : e;
							},
							_getEnumOneOfWithTitleCheck: function () {
								var e = this.get('__oneOf__');
								return i.default.map(e, function (e) {
									return (
										'' !== o.default.trim(e.title) ||
											(e.title = i.default.isString(e.const) ? e.const : JSON.stringify(e.const)),
										e
									);
								});
							},
							_updateTypeFormatConstraints: function () {
								var e = this.get('__displayType__');
								this.unset('format', { silent: !0 }),
									this.unset('items', { silent: !0 }),
									this.set(u.default.DISPLAYTYPES[e]),
									e !== h && e !== m && (this.unset('minimum'), this.unset('maximum')),
									e !== p && (this.unset('minLength'), this.unset('maxLength')),
									this.unset('__minVal__'),
									this.unset('__maxVal__'),
									this.unset('__equals__'),
									this.set('__supportsMinMax__', -1 !== u.default.SUPPORTSMINMAX.indexOf(this.get('__displayType__')));
							},
							_updateMinMax: function () {
								var e,
									t,
									n = this.get('__displayType__');
								n === p
									? ((e = 'minLength'), (t = 'maxLength'))
									: (n !== m && n !== h) || ((e = 'minimum'), (t = 'maximum')),
									this.get('__minVal__') ? this.set(e, parseInt(this.get('__minVal__'), 10)) : this.unset(e),
									this.get('__maxVal__') ? this.set(t, parseInt(this.get('__maxVal__'), 10)) : this.unset(t);
							},
							_convertEqualsToMinMax: function () {
								var e = this.get('__equals__');
								e && (this.set('__minVal__', e), this.set('__maxVal__', e));
							},
							_setConstraintText: function () {
								var e = this.get('__constraint__'),
									t = this.get('__minVal__'),
									n = this.get('__maxVal__'),
									r = this.get('__equals__');
								switch (e) {
									case 'between':
										this.set('__constraintText__', 'Between ' + t + ' and ' + n);
										break;
									case 'greaterThan':
										this.set('__constraintText__', 'Greater than ' + t);
										break;
									case 'lessThan':
										this.set('__constraintText__', 'Less than ' + n);
										break;
									case 'equals':
										this.set('__constraintText__', 'Equals ' + r);
										break;
									default:
										this.set('__constraintText__', '');
								}
							},
							cleanup: function () {
								'lessThan' === this.get('__constraint__')
									? this.unset('__minVal__')
									: 'greaterThan' === this.get('__constraint__') && this.unset('__maxVal__'),
									this.get('scope') !== u.default.SCOPE.SYSTEM &&
										(!0 === this.get('__isScopeSelf__')
											? this.set({ scope: u.default.SCOPE.SELF }, { silent: !0 })
											: this.unset('scope')),
									this.get('__unique__') || this.unset('unique');
							},
							isEnumType: function () {
								return !!this.getEnumValues();
							},
							getEnumValues: function () {
								return (
									this.get('oneOf') ||
									this.get('enum') ||
									(this.get('items') && this.get('items').oneOf) ||
									(this.get('items') && this.get('items').enum)
								);
							},
							detectHasEnumDefined: function () {
								var e = this.getEnumValues();
								e && (this.set('__oneOf__', d.default.convertToOneOf(e)), this.set('__enumDefined__', !0));
							},
						}),
						T = {
							Model: E,
							Collection: a.default.extend({
								model: E,
								clone: function () {
									return new this.constructor(this.toJSON({ verbose: !0 }), { parse: !0 });
								},
								areAllReadOnly: function () {
									return i.default.all(this.pluck('__isReadOnly__'));
								},
								createModelProperties: function () {
									return this.reduce(function (e, t) {
										var n = t.get('type');
										return (
											(e[t.id] = i.default.clone(u.default.DISPLAYTYPES[n])),
											-1 !== u.default.SUPPORTSMINMAX.indexOf(n) &&
												((e[t.id].minLength = t.get('minLength')), (e[t.id].maxLength = t.get('maxLength'))),
											'string' === n && (e[t.id].format = t.get('format')),
											e
										);
									}, {});
								},
							}),
						};
					(t.default = T), (e.exports = t.default);
				},
				41380: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(96129)),
						i = r(n(28107)),
						a = r(n(23825)),
						s = r(n(53303)),
						l = r(n(50999)),
						u = r(n(45361));
					function c(e) {
						var t = {};
						return (
							i.default.each(e, function (e, n) {
								i.default.isNull(e) || (t[n] = e);
							}),
							t
						);
					}
					var d = {
							preinitialize: function () {
								var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
								this.state = i.default.result(this, 'state');
								var t = this.state instanceof l.default || e.state instanceof l.default;
								if (!t) {
									var n = i.default.defaults(c(e.state), this.state || {});
									(this.state = new l.default(n)), delete e.state;
								}
								e.settings ||
									((e.settings = new s.default(i.default.omit(e || {}, 'el'))),
									this.listen('notification', a.default.prototype._notify),
									this.listen('confirmation', a.default.prototype._confirm)),
									u.default.prototype.preinitialize.call(this, e);
							},
							constructor: function () {
								var e,
									t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
								u.default.call(this, t),
									this.listenTo(this.state, '__invoke__', function () {
										var e = i.default.toArray(arguments),
											t = e.shift();
										i.default.isFunction(this[t]) && this[t].apply(this, e);
									}),
									this.View && this.View.isCourageView
										? (e = this.View)
										: i.default.result(this, 'View') &&
										  i.default.result(this, 'View').isCourageView &&
										  (e = i.default.result(this, 'View')),
									e && this.add(new e(this.toJSON()));
							},
							state: {},
							View: null,
							render: function () {
								var e = arguments,
									t = this;
								return (
									(0, o.default)(function () {
										u.default.prototype.render.apply(t, e);
									}),
									this
								);
							},
							toJSON: function (e) {
								return i.default.extend(i.default.pick(this, 'state', 'settings', 'collection', 'model'), e || {});
							},
							remove: function () {
								return this.removeChildren(), this.stopListening(), this.$el.empty(), this;
							},
						},
						f = u.default.extend(d);
					(t.default = f), (e.exports = t.default);
				},
				23825: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2770)),
						i = r(n(20290)),
						a = r(n(96129)),
						s = r(n(28107)),
						l = r(n(77861)),
						u = r(n(53303)),
						c = r(n(1375));
					function d(e, t) {
						var n = s.default.result(e, 'root') || '';
						return n && s.default.isString(t) ? [n, t].join('/').replace(/\/{2,}/g, '/') : t;
					}
					var f = {
							root: '',
							listen: c.default.prototype.listen,
							constructor: function () {
								var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
								(this.el = e.el),
									(this.settings = new u.default(s.default.omit(e, 'el'))),
									e.root && (this.root = e.root),
									o.default.Router.apply(this, arguments),
									this.listen('notification', this._notify),
									this.listen('confirmation', this._confirm);
							},
							_confirm: function () {
								var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
									t = i.default.extend(
										s.default.pick(
											e,
											'title',
											'subtitle',
											'save',
											'ok',
											'cancel',
											'cancelFn',
											'noCancelButton',
											'noSubmitButton',
											'content',
											'danger',
											'type',
											'closeOnOverlayClick',
											'buttonOrder'
										)
									),
									n = new t({ model: this.settings });
								return n.render(), n;
							},
							_notify: function (e) {
								var t = new c.default(e);
								return (0, a.default)('#content').prepend(t.render().el), t;
							},
							render: function (e, t) {
								this.unload(),
									(t = s.default.extend(s.default.pick(this, 'settings', 'el'), t || {})),
									(this.controller = new e(t)),
									this.controller.render();
							},
							start: function () {
								for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
								(0, a.default)(function () {
									var e;
									o.default.History.started
										? l.default.error('History has already been started')
										: (e = o.default.history).start.apply(e, t);
								});
							},
							unload: function () {
								this.controller &&
									(this.stopListening(this.controller),
									this.stopListening(this.controller.state),
									this.controller.remove());
							},
							route: function (e, t, n) {
								return o.default.Router.prototype.route.call(this, d(this, e), t, n);
							},
							navigate: function (e, t) {
								return o.default.Router.prototype.navigate.call(this, d(this, e), t);
							},
						},
						p = o.default.Router.extend(f);
					(t.default = p), (e.exports = t.default);
				},
				2431: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = r(n(73613));
					function a(e) {
						var t = o.default.extend(e.click ? { click: e.click } : {}, e.events || {}),
							n = {};
						return (
							o.default.each(t, function (t, r) {
								n[r] = function (n) {
									e.href || (n.preventDefault(), n.stopPropagation()),
										(this.disabled && 'click' === r) || t.apply(this, arguments);
								};
							}),
							n
						);
					}
					var s = {
						create: function (e) {
							return (
								((e = o.default.clone(e)).attrs = e.attributes),
								delete e.attributes,
								i.default.extend(o.default.extend(e, { events: a(e) }))
							);
						},
					};
					(t.default = s), (e.exports = t.default);
				},
				96577: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = a);
					var o = r(n(2770)),
						i = r(n(28107));
					function a(e) {
						(this.options = i.default.clone(e || {})),
							(this.cid = i.default.uniqueId('class')),
							this.initialize.apply(this, arguments);
					}
					i.default.extend(a.prototype, o.default.Events, { initialize: function () {} }),
						(a.extend = o.default.Model.extend),
						(e.exports = t.default);
				},
				86063: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(35237)),
						i = r(n(96129)),
						a = r(n(28107)),
						s = r(n(67282)),
						l = r(n(96577)),
						u = o.default,
						c = ['success', 'error', 'target', 'text'],
						d = l.default.extend({
							initialize: function (e, t) {
								var n, r, o;
								(t = a.default.pick(t || {}, c)),
									a.default.isString(e) && (n = e),
									a.default.isElement(e) && (n = e),
									e instanceof i.default && (n = e.selector),
									e instanceof s.default && (n = e.el),
									a.default.isFunction(t.target) && (r = t.target),
									a.default.isElement(t.target) && (r = a.default.constant(t.target)),
									a.default.isString(t.text)
										? (o = a.default.constant(t.text))
										: a.default.isFunction(t.text) && (o = t.text),
									(this.__instance = new u(n, { target: r, text: o })),
									(this.done = a.default.partial(this.__setCallback, 'success')),
									(this.error = a.default.partial(this.__setCallback, 'error')),
									this.done(t.success),
									this.error(t.error);
							},
							__setCallback: function (e, t) {
								if (a.default.isFunction(t)) return this.__instance.on(e, t), this.__instance;
							},
						}),
						f = {
							attach: function (e, t) {
								return new d(e, t);
							},
						};
					(t.default = f), (e.exports = t.default);
				},
				11403: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = r(n(62806)),
						a = /^https/.test(window.location.href),
						s = {
							setCookie: function (e, t, n) {
								i.default.set(e, t, o.default.defaults(n || {}, { secure: a, path: '/' }));
							},
							getCookie: function () {
								return i.default.get.apply(i.default, arguments);
							},
							removeCookie: function () {
								return i.default.remove.apply(i.default, arguments);
							},
						};
					(t.default = s), (e.exports = t.default);
				},
				83365: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					(t.default = {
						UP: 38,
						DOWN: 40,
						DEL: 46,
						TAB: 9,
						RETURN: 13,
						ENTER: 13,
						ESC: 27,
						COMMA: 188,
						PAGEUP: 33,
						PAGEDOWN: 34,
						SPACE: 32,
						BACKSPACE: 8,
						__isKey: function (e, t) {
							return (e.which || e.keyCode) === this[t];
						},
						isEnter: function (e) {
							return this.__isKey(e, 'ENTER');
						},
						isEsc: function (e) {
							return this.__isKey(e, 'ESC');
						},
						isSpaceBar: function (e) {
							return this.__isKey(e, 'SPACE');
						},
					}),
						(e.exports = t.default);
				},
				77861: function (e, t) {
					'use strict';
					function n(e) {
						if (window.console && window.okta && window.okta.debug) {
							for (var t, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
								r[o - 1] = arguments[o];
							(t = window.console)[e].apply(t, r);
						}
					}
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = {
						trace: function () {
							for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
							return n.apply(void 0, ['trace'].concat(t));
						},
						dir: function () {
							for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
							return n.apply(void 0, ['dir'].concat(t));
						},
						time: function () {
							for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
							return n.apply(void 0, ['time'].concat(t));
						},
						timeEnd: function () {
							for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
							return n.apply(void 0, ['timeEnd'].concat(t));
						},
						group: function () {
							for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
							return n.apply(void 0, ['group'].concat(t));
						},
						groupEnd: function () {
							for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
							return n.apply(void 0, ['groupEnd'].concat(t));
						},
						assert: function () {
							for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
							return n.apply(void 0, ['assert'].concat(t));
						},
						log: function () {
							for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
							return n.apply(void 0, ['log'].concat(t));
						},
						info: function () {
							for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
							return n.apply(void 0, ['info'].concat(t));
						},
						warn: function () {
							for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
							return n.apply(void 0, ['warn'].concat(t));
						},
						error: function () {
							for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
							return n.apply(void 0, ['error'].concat(t));
						},
					};
					(t.default = r), (e.exports = t.default);
				},
				33270: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = r(n(88712)).default.localize,
						a = {
							STRING: 'string',
							NUMBER: 'number',
							INTEGER: 'integer',
							BOOLEAN: 'boolean',
							OBJECT: 'object',
							FORMATDISPLAYTYPE: {
								'date-time': 'date',
								'uri': 'uri',
								'email': 'email',
								'country-code': 'country-code',
								'language-code': 'language-code',
								'country_code': 'country_code',
								'language_code': 'language_code',
								'locale': 'locale',
								'timezone': 'timezone',
								'ref-id': 'reference',
							},
							ARRAYDISPLAYTYPE: {
								'arrayofobject': 'arrayofobject',
								'arrayofstring': 'arrayofstring',
								'arrayofnumber': 'arrayofnumber',
								'arrayofinteger': 'arrayofinteger',
								'arrayofref-id': 'arrayofref-id',
							},
							DISPLAYTYPES: {
								'date': { type: 'string', format: 'date-time' },
								'uri': { type: 'string', format: 'uri' },
								'email': { type: 'string', format: 'email' },
								'country-code': { type: 'string', format: 'country-code' },
								'language-code': { type: 'string', format: 'language-code' },
								'country_code': { type: 'string' },
								'language_code': { type: 'string' },
								'locale': { type: 'string', format: 'locale' },
								'timezone': { type: 'string', format: 'timezone' },
								'string': { type: 'string' },
								'number': { type: 'number' },
								'boolean': { type: 'boolean' },
								'integer': { type: 'integer' },
								'reference': { type: 'string', format: 'ref-id' },
								'arrayofobject': { type: 'array', items: { type: 'object' } },
								'arrayofstring': { type: 'array', items: { type: 'string' } },
								'arrayofnumber': { type: 'array', items: { type: 'number' } },
								'arrayofinteger': { type: 'array', items: { type: 'integer' } },
								'arrayofref-id': { type: 'array', items: { type: 'string', format: 'ref-id' } },
								'image': { type: 'image' },
								'password': { type: 'string' },
							},
							SUPPORTSMINMAX: ['string', 'number', 'integer', 'password'],
							SUPPORTENUM: [
								'string',
								'number',
								'integer',
								'object',
								'arrayofstring',
								'arrayofnumber',
								'arrayofinteger',
								'arrayofobject',
							],
							DATATYPE: {
								'string': 'string',
								'number': 'number',
								'boolean': 'boolean',
								'integer': 'integer',
								'date': 'datetime',
								'object': 'object',
								'arrayofobject': 'object array',
								'arrayofstring': 'string array',
								'arrayofnumber': 'number array',
								'arrayofinteger': 'integer array',
								'arrayofref-id': 'reference array',
								'country-code': 'country code',
								'language-code': 'language code',
								'country_code': 'country code',
								'language_code': 'language code',
								'reference': 'reference',
								'timezone': 'timezone',
								'image': 'image',
							},
							MUTABILITY: {
								READONLY: 'READ_ONLY',
								WRITEONLY: 'WRITE_ONLY',
								READWRITE: 'READ_WRITE',
								IMMUTABLE: 'IMMUTABLE',
							},
							SCOPE: { NONE: 'NONE', SELF: 'SELF', SYSTEM: 'SYSTEM' },
							DISPLAYSCOPE: { SELF: 'User personal', SYSTEM: 'System', NA: 'None' },
							UNION: { DISABLE: 'DISABLE', ENABLE: 'ENABLE' },
							UNION_OPTIONS: {
								DISABLE: i('universal-directory.profiles.attribute.form.union.enable.display', 'courage'),
								ENABLE: i('universal-directory.profiles.attribute.form.union.disable.display', 'courage'),
							},
							PERMISSION: { HIDE: 'HIDE', READ_ONLY: 'READ_ONLY', WRITE_ONLY: 'WRITE_ONLY', READ_WRITE: 'READ_WRITE' },
							ENDUSER_ATTRIBUTE_PERMISSION_OPTIONS: {
								HIDE: i('universal-directory.profiles.attribute.enduser.permission.hide', 'courage'),
								READ_ONLY: i('universal-directory.profiles.attribute.enduser.permission.readonly', 'courage'),
								READ_WRITE: i('universal-directory.profiles.attribute.enduser.permission.readwrite', 'courage'),
							},
							ATTRIBUTE_LEVEL_MASTERING_OPTIONS: {
								INHERIT: i('universal-directory.profiles.attribute.source.inherit', 'courage'),
								OKTA_MASTERED: i('universal-directory.profiles.attribute.source.oktamastered', 'courage'),
								OVERRIDE: i('universal-directory.profiles.attribute.source.override', 'courage'),
							},
							USERNAMETYPE: {
								NONE: 'non-username',
								OKTA_TO_APP: 'okta-to-app-username',
								OKTA_TO_AD: 'okta-to-ad-username',
								APP_TO_OKTA: 'app-to-okta-username',
								IDP_TO_OKTA: 'idp-to-okta-username',
							},
							LOGINPATTERNFORMAT: { EMAIL: 'EMAIL', CUSTOM: 'CUSTOM', NONE: 'NONE' },
							UNIQUENESS: {
								NOT_UNIQUE: 'NOT_UNIQUE',
								PENDING_UNIQUENESS: 'PENDING_UNIQUENESS',
								UNIQUE_VALIDATED: 'UNIQUE_VALIDATED',
							},
							getDisplayType: function (e, t, n, r) {
								var o;
								return (
									e && (o = t ? this.FORMATDISPLAYTYPE[t] : n ? this.ARRAYDISPLAYTYPE[e + 'of' + n] : e),
									o || (o = void 0 === r ? '' : r),
									o
								);
							},
							getSourceUsernameType: function (e, t, n) {
								var r = this.USERNAMETYPE.NONE;
								return (
									'oktaToApp' === e
										? 'userName' === t
											? (r = this.USERNAMETYPE.OKTA_TO_APP)
											: 'cn' === t && (r = this.USERNAMETYPE.OKTA_TO_AD)
										: 'appToOkta' === e &&
										  'login' === t &&
										  (r = 'saml_idp' === n ? this.USERNAMETYPE.IDP_TO_OKTA : this.USERNAMETYPE.APP_TO_OKTA),
									r
								);
							},
							isArrayDataType: function (e) {
								return o.default.contains(o.default.values(this.ARRAYDISPLAYTYPE), e);
							},
							isObjectDataType: function (e) {
								return this.DATATYPE.object === e;
							},
						};
					(t.default = a), (e.exports = t.default);
				},
				53303: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = r(n(13614)),
						a = {
							local: function () {
								var e = (window.okta && window.okta.settings) || {},
									t = (window.okta && window.okta.theme) || '';
								return {
									orgId: ['string', !1, e.orgId],
									orgName: ['string', !1, e.orgName],
									serverStatus: ['string', !1, e.serverStatus],
									persona: ['string', !1, e.persona],
									isDeveloperConsole: ['boolean', !1, e.isDeveloperConsole],
									isPreview: ['boolean', !1, e.isPreview],
									permissions: ['array', !0, e.permissions || []],
									theme: ['string', !1, t],
								};
							},
							constructor: function () {
								i.default.apply(this, arguments), (this.features = window._features || []);
							},
							hasFeature: function (e) {
								return o.default.contains(this.features, e);
							},
							hasAnyFeature: function (e) {
								return o.default.some(e, this.hasFeature, this);
							},
							hasPermission: function (e) {
								return o.default.contains(this.get('permissions'), e);
							},
							isDsTheme: function () {
								return 'dstheme' === this.get('theme');
							},
						},
						s = i.default.extend(a);
					(t.default = s), (e.exports = t.default);
				},
				50999: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = r(n(13614)).default.extend({
							invoke: function () {
								var e = o.default.toArray(arguments);
								e.unshift('__invoke__'), this.trigger.apply(this, e);
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				88712: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(96129)),
						i = r(n(28107)),
						a = r(n(52115)),
						s = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'", '&#039;': "'", '&#x2F;': '/' },
						l =
							/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(?!-)((\[?[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\]?)|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
						u = function (e) {
							if (/-/.test(e)) {
								var t = e.split('-');
								return (t[1] = t[1].toUpperCase()), t.join('_');
							}
							return e;
						};
					function c() {
						return window && window.okta && window.okta.locale
							? window.okta.isEnableBcp47OktaUi
								? window.okta.locale
								: window.okta.locale.toLowerCase()
							: 'en';
					}
					function d(e) {
						if (!e) return a.default[i.default.keys(a.default)[0]];
						var t = u(c());
						return a.default[''.concat(e, '_').concat(t)] || a.default[e];
					}
					function f(e, t) {
						t = t || { bubbles: !1, cancelable: !1, detail: null };
						var n = document.createEvent('CustomEvent');
						return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n;
					}
					function p(e, t, n) {
						if ((window.CustomEvent || (window.CustomEvent = f), 'function' == typeof window.CustomEvent)) {
							var r = new CustomEvent('okta-i18n-error', {
								detail: { type: 'l10n-error', key: e, bundleName: t, reason: n },
							});
							document.dispatchEvent(r);
						}
					}
					var h = {
						getRawLocale: function () {
							return c();
						},
						getParsedLocale: function () {
							return u(c());
						},
						isLocaleBundleExist: function (e, t) {
							var n = u(t);
							return !!a.default[''.concat(e, '_').concat(n)];
						},
						sprintf: function () {
							var e = Array.prototype.slice.apply(arguments),
								t = e.shift(),
								n = t;
							function r() {
								throw new Error('Mismatch number of variables: ' + arguments[0] + ', ' + JSON.stringify(e));
							}
							for (var o = 0, i = e.length; o < i; o++) {
								var a = e[o],
									s = new RegExp('\\{' + o + '\\}', 'g');
								(t = t.replace(s, a)), (null != a && t !== n) || r(), (n = t);
							}
							return /\{[\d+]\}/.test(t) && r(), t;
						},
						parseQuery: function (e) {
							for (var t = {}, n = decodeURIComponent(e.replace(/\+/g, ' ')).split('&'), r = 0; r < n.length; r++) {
								var o = n[r].split('=');
								t[o.shift()] = o.join('=');
							}
							return t;
						},
						encodeJSObject: function (e) {
							return encodeURIComponent(JSON.stringify(e));
						},
						decodeJSObject: function (e) {
							try {
								return JSON.parse(decodeURIComponent(e));
							} catch (e) {
								return null;
							}
						},
						unescapeHtml: function (e) {
							return String(e).replace(/&[\w#\d]{2,};/g, function (e) {
								return s[e] || e;
							});
						},
						getTemplate: function (e, t) {
							var n = d(t);
							return n
								? n[e]
									? n[e]
									: (p(e, t, 'key'), 'L10N_ERROR[' + e + ']')
								: (p(e, t, 'bundle'), 'L10N_ERROR[' + t + ']');
						},
						localize: function (e, t, n) {
							var r = d(t);
							if (!r) return p(e, t, 'bundle'), 'L10N_ERROR[' + t + ']';
							var o = r[e];
							try {
								return (
									(n = n && n.slice ? n.slice(0) : []).unshift(o),
									(o = h.sprintf.apply(null, n)) || (p(e, t, 'key'), 'L10N_ERROR[' + e + ']')
								);
							} catch (n) {
								return p(e, t, 'parameters'), 'L10N_ERROR[' + e + ']';
							}
						},
						parseFloat: (function (e) {
							function t(t) {
								return e.apply(this, arguments);
							}
							return (
								(t.toString = function () {
									return e.toString();
								}),
								t
							);
						})(function (e) {
							var t = +e;
							return 'string' == typeof e && t === parseFloat(e) ? t : e;
						}),
						parseInt: (function (e) {
							function t(t) {
								return e.apply(this, arguments);
							}
							return (
								(t.toString = function () {
									return e.toString();
								}),
								t
							);
						})(function (e) {
							var t = +e;
							return i.default.isString(e) && t === parseInt(e, 10) ? t : e;
						}),
						parseObject: function (e) {
							if (!i.default.isString(e)) return e;
							try {
								var t = JSON.parse(e);
								return o.default.isPlainObject(t) ? t : e;
							} catch (t) {
								return e;
							}
						},
						randomString: function (e) {
							var t = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
							if (void 0 === e) e = i.default.random(t.length);
							else if (0 === e) return '';
							for (var n = []; e--; ) n.push(t[i.default.random(t.length - 1)]);
							return n.join('');
						},
						endsWith: function (e, t) {
							return (e += '').length >= (t += '').length && e.substring(e.length - t.length) === t;
						},
						isEmail: function (e) {
							var t = o.default.trim(e);
							return !i.default.isEmpty(t) && l.test(t);
						},
					};
					(t.default = h), (e.exports = t.default);
				},
				86499: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = {
							tpl: r(n(28107)).default.memoize(function (e) {
								return function (t) {
									return o.default.compile(e)(t);
								};
							}),
						};
					(t.default = i), (e.exports = t.default);
				},
				60196: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					(t.default = {
						DEBOUNCE_DELAY: 200,
						LOADING_FADE: 400,
						UNLOADING_FADE: 400,
						ROW_EXPANDER_TRANSITION: 150,
						HIDE_ADD_MAPPING_FORM: 300,
					}),
						(e.exports = t.default);
				},
				51645: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = r(n(45361)),
						a = {
							redirect: function (e) {
								window.location = e;
							},
							reloadPage: function () {
								window.location.reload();
							},
							constantError: function (e) {
								return function () {
									throw new Error(e);
								};
							},
							getUrlQueryString: function (e) {
								o.default.isObject(e) || (e = {});
								var t = o.default
									.without(
										o.default.map(e, function (e, t) {
											if (null != e) return t + '=' + encodeURIComponent(e);
										}),
										void 0
									)
									.join('&');
								return o.default.isEmpty(t) ? '' : '?' + t;
							},
							isABaseView: function (e) {
								return e instanceof i.default || e.prototype instanceof i.default || e === i.default;
							},
							isSafari: function () {
								return /^((?!chrome|android|crios).)*safari/i.test(navigator.userAgent);
							},
						};
					(t.default = a), (e.exports = t.default);
				},
				50808: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107));
					function i(e, t) {
						var n = this.model.get(t);
						return o.default.isFunction(e) ? e.call(this, n) : e === n;
					}
					function a(e, t, n) {
						var r = o.default.bind(n, e, e, t);
						(e.render = o.default.wrap(e.render, function (t) {
							var n = t.call(e);
							return r({ animate: !1 }), n;
						})),
							e.listenTo(
								e.model,
								(function (e) {
									return 'change:' + o.default.keys(e).join(' change:');
								})(t),
								function () {
									r({ animate: !0 });
								}
							);
					}
					var s = {
						applyDoWhen: function (e, t, n) {
							e.model &&
								o.default.isObject(t) &&
								o.default.size(t) &&
								o.default.isFunction(n) &&
								a(e, t, function (e, t, r) {
									var a = o.default.every(o.default.map(t, i, e));
									n.call(e, a, r);
								});
						},
					};
					(t.default = s), (e.exports = t.default);
				},
				97406: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						Object.defineProperty(t, 'default', {
							enumerable: !0,
							get: function () {
								return o.default;
							},
						});
					var o = r(n(2875)),
						i = o.default.Utils.escapeExpression;
					(o.default.Utils.escapeExpression = function (e) {
						return i(e).replace(/&#x3D;/g, '=');
					}),
						(e.exports = t.default);
				},
				37997: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						Object.defineProperty(t, 'default', {
							enumerable: !0,
							get: function () {
								return i.default;
							},
						});
					var o = r(n(66583)),
						i = r(n(2875)),
						a = r(n(28107)),
						s = r(n(77861)),
						l = r(n(88712)),
						u = i.default.Utils.escapeExpression;
					function c(e) {
						return e && e.replace(/^\s+|\s+$/g, '');
					}
					i.default.registerHelper('i18n', function (e) {
						var t,
							n = c(e.hash.code),
							r = c(e.hash.bundle),
							d = c(e.hash.arguments),
							f = Object.keys(e.hash)
								.filter(function (e) {
									return e.match(/^\$\d+/);
								})
								.map(function (t) {
									return { tag: t, value: e.hash[t] };
								});
						d &&
							(t = a.default.map(
								c(d).split(';'),
								function (e) {
									var t,
										n = this;
									return (
										(e = c(e)),
										a.default.each(e.split('.'), function (e) {
											t = t ? t[e] : n[e];
										}),
										t
									);
								},
								this
							));
						var p = l.default.localize(n, r, t);
						if (f.length < 1) return p;
						var h = u(p);
						try {
							return (
								f.forEach(function (e) {
									h = (function (e, t, n) {
										var r = u('<'.concat(t, '>')),
											i = u('</'.concat(t, '>')),
											a = n.split(t),
											s = (0, o.default)(a, 2),
											l = s[0],
											c = s[1];
										if (!e.includes(r) && !e.includes(i))
											throw Error('Parsed tag "'.concat(t, '" is not present in "').concat(e, '"'));
										if (!n.includes(t)) throw Error('Parsed tag "'.concat(t, '" is not present in "').concat(n, '"'));
										if (!l || !c)
											throw Error('Template value "'.concat(n, '" must contain beginning and closing tags'));
										return e.replace(r, l).replace(i, c);
									})(h, e.tag, e.value);
								}),
								new i.default.SafeString(h)
							);
						} catch (e) {
							return s.default.error(e.toString()), p;
						}
					}),
						(e.exports = t.default);
				},
				96129: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(79602));
					o.default.ajaxSetup({
						beforeSend: function (e) {
							e.setRequestHeader('X-Okta-XsrfToken', (0, o.default)('#_xsrfToken').text());
						},
						converters: {
							'text secureJSON': function (e) {
								return 'while(1){};' === e.substring(0, 11) && (e = e.substring(11)), JSON.parse(e);
							},
						},
					});
					var i = o.default;
					(t.default = i), (window.jQueryCourage = i), (e.exports = t.default);
				},
				28107: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = r(n(37870));
					i.default.mixin({
						resultCtx: function (e, t, n, r) {
							var o = i.default.isObject(e) ? e[t] : void 0;
							return i.default.isFunction(o) && (o = o.call(n || e)), o || (i.default.isUndefined(r) ? o : r);
						},
						isInteger: function (e) {
							return i.default.isNumber(e) && e % 1 == 0;
						},
						template: function (e, t) {
							var n = o.default.compile(e);
							if (t) return n(t);
							var r = function (e) {
								return n(e);
							};
							return (r.source = ''), r;
						},
					});
					var a = i.default;
					(t.default = a), (e.exports = t.default);
				},
				2770: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = n(22603),
						a = n(59098),
						s = r(n(79602));
					n(37870);
					var l = n(3206);
					!(function (e, t) {
						//     (c) 2010-2019 Jeremy Ashkenas and DocumentCloud
						//     Backbone may be freely distributed under the MIT license.
						var n = s.default;
						!(function (e) {
							var r,
								a =
									('object' == ('undefined' == typeof self ? 'undefined' : (0, o.default)(self)) &&
										self.self === self &&
										self) ||
									('object' == (0, o.default)(i.commonjsGlobal) &&
										i.commonjsGlobal.global === i.commonjsGlobal &&
										i.commonjsGlobal),
								s = l.u.exports;
							try {
								r = n;
							} catch (e) {}
							!(function (e, t, n, r) {
								var i = e.Backbone,
									a = Array.prototype.slice;
								(t.VERSION = '1.4.0'),
									(t.$ = r),
									(t.noConflict = function () {
										return (e.Backbone = i), this;
									}),
									(t.emulateHTTP = !1),
									(t.emulateJSON = !1);
								var s,
									l = (t.Events = {}),
									u = /\s+/,
									c = function e(t, r, i, a, s) {
										var l,
											c = 0;
										if (i && 'object' === (0, o.default)(i)) {
											void 0 !== a && 'context' in s && void 0 === s.context && (s.context = a);
											for (l = n.keys(i); c < l.length; c++) r = e(t, r, l[c], i[l[c]], s);
										} else if (i && u.test(i)) for (l = i.split(u); c < l.length; c++) r = t(r, l[c], a, s);
										else r = t(r, i, a, s);
										return r;
									};
								(l.on = function (e, t, n) {
									((this._events = c(d, this._events || {}, e, t, { context: n, ctx: this, listening: s })), s) &&
										(((this._listeners || (this._listeners = {}))[s.id] = s), (s.interop = !1));
									return this;
								}),
									(l.listenTo = function (e, t, r) {
										if (!e) return this;
										var o = e._listenId || (e._listenId = n.uniqueId('l')),
											i = this._listeningTo || (this._listeningTo = {}),
											a = (s = i[o]);
										a || (this._listenId || (this._listenId = n.uniqueId('l')), (a = s = i[o] = new g(this, e)));
										var l = f(e, t, r, this);
										if (((s = void 0), l)) throw l;
										return a.interop && a.on(t, r), this;
									});
								var d = function (e, t, n, r) {
										if (n) {
											var o = e[t] || (e[t] = []),
												i = r.context,
												a = r.ctx,
												s = r.listening;
											s && s.count++, o.push({ callback: n, context: i, ctx: i || a, listening: s });
										}
										return e;
									},
									f = function (e, t, n, r) {
										try {
											e.on(t, n, r);
										} catch (e) {
											return e;
										}
									};
								(l.off = function (e, t, n) {
									return this._events
										? ((this._events = c(p, this._events, e, t, { context: n, listeners: this._listeners })), this)
										: this;
								}),
									(l.stopListening = function (e, t, r) {
										var o = this._listeningTo;
										if (!o) return this;
										for (var i = e ? [e._listenId] : n.keys(o), a = 0; a < i.length; a++) {
											var s = o[i[a]];
											if (!s) break;
											s.obj.off(t, r, this), s.interop && s.off(t, r);
										}
										return n.isEmpty(o) && (this._listeningTo = void 0), this;
									});
								var p = function (e, t, r, o) {
									if (e) {
										var i,
											a = o.context,
											s = o.listeners,
											l = 0;
										if (t || a || r) {
											for (i = t ? [t] : n.keys(e); l < i.length; l++) {
												var u = e[(t = i[l])];
												if (!u) break;
												for (var c = [], d = 0; d < u.length; d++) {
													var f = u[d];
													if ((r && r !== f.callback && r !== f.callback._callback) || (a && a !== f.context))
														c.push(f);
													else {
														var p = f.listening;
														p && p.off(t, r);
													}
												}
												c.length ? (e[t] = c) : delete e[t];
											}
											return e;
										}
										for (i = n.keys(s); l < i.length; l++) s[i[l]].cleanup();
									}
								};
								(l.once = function (e, t, n) {
									var r = c(h, {}, e, t, this.off.bind(this));
									return 'string' == typeof e && null == n && (t = void 0), this.on(r, t, n);
								}),
									(l.listenToOnce = function (e, t, n) {
										var r = c(h, {}, t, n, this.stopListening.bind(this, e));
										return this.listenTo(e, r);
									});
								var h = function (e, t, r, o) {
									if (r) {
										var i = (e[t] = n.once(function () {
											o(t, i), r.apply(this, arguments);
										}));
										i._callback = r;
									}
									return e;
								};
								l.trigger = function (e) {
									if (!this._events) return this;
									for (var t = Math.max(0, arguments.length - 1), n = Array(t), r = 0; r < t; r++)
										n[r] = arguments[r + 1];
									return c(m, this._events, e, void 0, n), this;
								};
								var m = function (e, t, n, r) {
										if (e) {
											var o = e[t],
												i = e.all;
											o && i && (i = i.slice()), o && v(o, r), i && v(i, [t].concat(r));
										}
										return e;
									},
									v = function (e, t) {
										var n,
											r = -1,
											o = e.length,
											i = t[0],
											a = t[1],
											s = t[2];
										switch (t.length) {
											case 0:
												for (; ++r < o; ) (n = e[r]).callback.call(n.ctx);
												return;
											case 1:
												for (; ++r < o; ) (n = e[r]).callback.call(n.ctx, i);
												return;
											case 2:
												for (; ++r < o; ) (n = e[r]).callback.call(n.ctx, i, a);
												return;
											case 3:
												for (; ++r < o; ) (n = e[r]).callback.call(n.ctx, i, a, s);
												return;
											default:
												for (; ++r < o; ) (n = e[r]).callback.apply(n.ctx, t);
												return;
										}
									},
									g = function (e, t) {
										(this.id = e._listenId),
											(this.listener = e),
											(this.obj = t),
											(this.interop = !0),
											(this.count = 0),
											(this._events = void 0);
									};
								(g.prototype.on = l.on),
									(g.prototype.off = function (e, t) {
										var n;
										this.interop
											? ((this._events = c(p, this._events, e, t, { context: void 0, listeners: void 0 })),
											  (n = !this._events))
											: (this.count--, (n = 0 === this.count)),
											n && this.cleanup();
									}),
									(g.prototype.cleanup = function () {
										delete this.listener._listeningTo[this.obj._listenId],
											this.interop || delete this.obj._listeners[this.id];
									}),
									(l.bind = l.on),
									(l.unbind = l.off),
									n.extend(t, l);
								var y = (t.Model = function (e, t) {
									var r = e || {};
									t || (t = {}),
										this.preinitialize.apply(this, arguments),
										(this.cid = n.uniqueId(this.cidPrefix)),
										(this.attributes = {}),
										t.collection && (this.collection = t.collection),
										t.parse && (r = this.parse(r, t) || {});
									var o = n.result(this, 'defaults');
									(r = n.defaults(n.extend({}, o, r), o)),
										this.set(r, t),
										(this.changed = {}),
										this.initialize.apply(this, arguments);
								});
								n.extend(y.prototype, l, {
									changed: null,
									validationError: null,
									idAttribute: 'id',
									cidPrefix: 'c',
									preinitialize: function () {},
									initialize: function () {},
									toJSON: function (e) {
										return n.clone(this.attributes);
									},
									sync: function () {
										return t.sync.apply(this, arguments);
									},
									get: function (e) {
										return this.attributes[e];
									},
									escape: function (e) {
										return n.escape(this.get(e));
									},
									has: function (e) {
										return null != this.get(e);
									},
									matches: function (e) {
										return !!n.iteratee(e, this)(this.attributes);
									},
									set: function (e, t, r) {
										if (null == e) return this;
										var i;
										if (
											('object' === (0, o.default)(e) ? ((i = e), (r = t)) : ((i = {})[e] = t),
											r || (r = {}),
											!this._validate(i, r))
										)
											return !1;
										var a = r.unset,
											s = r.silent,
											l = [],
											u = this._changing;
										(this._changing = !0),
											u || ((this._previousAttributes = n.clone(this.attributes)), (this.changed = {}));
										var c = this.attributes,
											d = this.changed,
											f = this._previousAttributes;
										for (var p in i)
											(t = i[p]),
												n.isEqual(c[p], t) || l.push(p),
												n.isEqual(f[p], t) ? delete d[p] : (d[p] = t),
												a ? delete c[p] : (c[p] = t);
										if ((this.idAttribute in i && (this.id = this.get(this.idAttribute)), !s)) {
											l.length && (this._pending = r);
											for (var h = 0; h < l.length; h++) this.trigger('change:' + l[h], this, c[l[h]], r);
										}
										if (u) return this;
										if (!s)
											for (; this._pending; )
												(r = this._pending), (this._pending = !1), this.trigger('change', this, r);
										return (this._pending = !1), (this._changing = !1), this;
									},
									unset: function (e, t) {
										return this.set(e, void 0, n.extend({}, t, { unset: !0 }));
									},
									clear: function (e) {
										var t = {};
										for (var r in this.attributes) t[r] = void 0;
										return this.set(t, n.extend({}, e, { unset: !0 }));
									},
									hasChanged: function (e) {
										return null == e ? !n.isEmpty(this.changed) : n.has(this.changed, e);
									},
									changedAttributes: function (e) {
										if (!e) return !!this.hasChanged() && n.clone(this.changed);
										var t,
											r = this._changing ? this._previousAttributes : this.attributes,
											o = {};
										for (var i in e) {
											var a = e[i];
											n.isEqual(r[i], a) || ((o[i] = a), (t = !0));
										}
										return !!t && o;
									},
									previous: function (e) {
										return null != e && this._previousAttributes ? this._previousAttributes[e] : null;
									},
									previousAttributes: function () {
										return n.clone(this._previousAttributes);
									},
									fetch: function (e) {
										e = n.extend({ parse: !0 }, e);
										var t = this,
											r = e.success;
										return (
											(e.success = function (n) {
												var o = e.parse ? t.parse(n, e) : n;
												if (!t.set(o, e)) return !1;
												r && r.call(e.context, t, n, e), t.trigger('sync', t, n, e);
											}),
											G(this, e),
											this.sync('read', this, e)
										);
									},
									save: function (e, t, r) {
										var i;
										null == e || 'object' === (0, o.default)(e) ? ((i = e), (r = t)) : ((i = {})[e] = t);
										var a = (r = n.extend({ validate: !0, parse: !0 }, r)).wait;
										if (i && !a) {
											if (!this.set(i, r)) return !1;
										} else if (!this._validate(i, r)) return !1;
										var s = this,
											l = r.success,
											u = this.attributes;
										(r.success = function (e) {
											s.attributes = u;
											var t = r.parse ? s.parse(e, r) : e;
											if ((a && (t = n.extend({}, i, t)), t && !s.set(t, r))) return !1;
											l && l.call(r.context, s, e, r), s.trigger('sync', s, e, r);
										}),
											G(this, r),
											i && a && (this.attributes = n.extend({}, u, i));
										var c = this.isNew() ? 'create' : r.patch ? 'patch' : 'update';
										'patch' !== c || r.attrs || (r.attrs = i);
										var d = this.sync(c, this, r);
										return (this.attributes = u), d;
									},
									destroy: function (e) {
										e = e ? n.clone(e) : {};
										var t = this,
											r = e.success,
											o = e.wait,
											i = function () {
												t.stopListening(), t.trigger('destroy', t, t.collection, e);
											};
										e.success = function (n) {
											o && i(), r && r.call(e.context, t, n, e), t.isNew() || t.trigger('sync', t, n, e);
										};
										var a = !1;
										return (
											this.isNew() ? n.defer(e.success) : (G(this, e), (a = this.sync('delete', this, e))), o || i(), a
										);
									},
									url: function () {
										var e = n.result(this, 'urlRoot') || n.result(this.collection, 'url') || z();
										if (this.isNew()) return e;
										var t = this.get(this.idAttribute);
										return e.replace(/[^\/]$/, '$&/') + encodeURIComponent(t);
									},
									parse: function (e, t) {
										return e;
									},
									clone: function () {
										return new this.constructor(this.attributes);
									},
									isNew: function () {
										return !this.has(this.idAttribute);
									},
									isValid: function (e) {
										return this._validate({}, n.extend({}, e, { validate: !0 }));
									},
									_validate: function (e, t) {
										if (!t.validate || !this.validate) return !0;
										e = n.extend({}, this.attributes, e);
										var r = (this.validationError = this.validate(e, t) || null);
										return !r || (this.trigger('invalid', this, r, n.extend(t, { validationError: r })), !1);
									},
								});
								var b = (t.Collection = function (e, t) {
										t || (t = {}),
											this.preinitialize.apply(this, arguments),
											t.model && (this.model = t.model),
											void 0 !== t.comparator && (this.comparator = t.comparator),
											this._reset(),
											this.initialize.apply(this, arguments),
											e && this.reset(e, n.extend({ silent: !0 }, t));
									}),
									_ = { add: !0, remove: !0, merge: !0 },
									w = { add: !0, remove: !1 },
									O = function (e, t, n) {
										n = Math.min(Math.max(n, 0), e.length);
										var r,
											o = Array(e.length - n),
											i = t.length;
										for (r = 0; r < o.length; r++) o[r] = e[r + n];
										for (r = 0; r < i; r++) e[r + n] = t[r];
										for (r = 0; r < o.length; r++) e[r + i + n] = o[r];
									};
								n.extend(b.prototype, l, {
									model: y,
									preinitialize: function () {},
									initialize: function () {},
									toJSON: function (e) {
										return this.map(function (t) {
											return t.toJSON(e);
										});
									},
									sync: function () {
										return t.sync.apply(this, arguments);
									},
									add: function (e, t) {
										return this.set(e, n.extend({ merge: !1 }, t, w));
									},
									remove: function (e, t) {
										t = n.extend({}, t);
										var r = !n.isArray(e);
										e = r ? [e] : e.slice();
										var o = this._removeModels(e, t);
										return (
											!t.silent &&
												o.length &&
												((t.changes = { added: [], merged: [], removed: o }), this.trigger('update', this, t)),
											r ? o[0] : o
										);
									},
									set: function (e, t) {
										if (null != e) {
											(t = n.extend({}, _, t)).parse && !this._isModel(e) && (e = this.parse(e, t) || []);
											var r = !n.isArray(e);
											e = r ? [e] : e.slice();
											var o = t.at;
											null != o && (o = +o), o > this.length && (o = this.length), o < 0 && (o += this.length + 1);
											var i,
												a,
												s = [],
												l = [],
												u = [],
												c = [],
												d = {},
												f = t.add,
												p = t.merge,
												h = t.remove,
												m = !1,
												v = this.comparator && null == o && !1 !== t.sort,
												g = n.isString(this.comparator) ? this.comparator : null;
											for (a = 0; a < e.length; a++) {
												i = e[a];
												var y = this.get(i);
												if (y) {
													if (p && i !== y) {
														var b = this._isModel(i) ? i.attributes : i;
														t.parse && (b = y.parse(b, t)), y.set(b, t), u.push(y), v && !m && (m = y.hasChanged(g));
													}
													d[y.cid] || ((d[y.cid] = !0), s.push(y)), (e[a] = y);
												} else
													f &&
														(i = e[a] = this._prepareModel(i, t)) &&
														(l.push(i), this._addReference(i, t), (d[i.cid] = !0), s.push(i));
											}
											if (h) {
												for (a = 0; a < this.length; a++) d[(i = this.models[a]).cid] || c.push(i);
												c.length && this._removeModels(c, t);
											}
											var w = !1,
												k = !v && f && h;
											if (
												(s.length && k
													? ((w =
															this.length !== s.length ||
															n.some(this.models, function (e, t) {
																return e !== s[t];
															})),
													  (this.models.length = 0),
													  O(this.models, s, 0),
													  (this.length = this.models.length))
													: l.length &&
													  (v && (m = !0),
													  O(this.models, l, null == o ? this.length : o),
													  (this.length = this.models.length)),
												m && this.sort({ silent: !0 }),
												!t.silent)
											) {
												for (a = 0; a < l.length; a++)
													null != o && (t.index = o + a), (i = l[a]).trigger('add', i, this, t);
												(m || w) && this.trigger('sort', this, t),
													(l.length || c.length || u.length) &&
														((t.changes = { added: l, removed: c, merged: u }), this.trigger('update', this, t));
											}
											return r ? e[0] : e;
										}
									},
									reset: function (e, t) {
										t = t ? n.clone(t) : {};
										for (var r = 0; r < this.models.length; r++) this._removeReference(this.models[r], t);
										return (
											(t.previousModels = this.models),
											this._reset(),
											(e = this.add(e, n.extend({ silent: !0 }, t))),
											t.silent || this.trigger('reset', this, t),
											e
										);
									},
									push: function (e, t) {
										return this.add(e, n.extend({ at: this.length }, t));
									},
									pop: function (e) {
										var t = this.at(this.length - 1);
										return this.remove(t, e);
									},
									unshift: function (e, t) {
										return this.add(e, n.extend({ at: 0 }, t));
									},
									shift: function (e) {
										var t = this.at(0);
										return this.remove(t, e);
									},
									slice: function () {
										return a.apply(this.models, arguments);
									},
									get: function (e) {
										if (null != e)
											return (
												this._byId[e] ||
												this._byId[this.modelId(this._isModel(e) ? e.attributes : e)] ||
												(e.cid && this._byId[e.cid])
											);
									},
									has: function (e) {
										return null != this.get(e);
									},
									at: function (e) {
										return e < 0 && (e += this.length), this.models[e];
									},
									where: function (e, t) {
										return this[t ? 'find' : 'filter'](e);
									},
									findWhere: function (e) {
										return this.where(e, !0);
									},
									sort: function (e) {
										var t = this.comparator;
										if (!t) throw new Error('Cannot sort a set without a comparator');
										e || (e = {});
										var r = t.length;
										return (
											n.isFunction(t) && (t = t.bind(this)),
											1 === r || n.isString(t) ? (this.models = this.sortBy(t)) : this.models.sort(t),
											e.silent || this.trigger('sort', this, e),
											this
										);
									},
									pluck: function (e) {
										return this.map(e + '');
									},
									fetch: function (e) {
										var t = (e = n.extend({ parse: !0 }, e)).success,
											r = this;
										return (
											(e.success = function (n) {
												var o = e.reset ? 'reset' : 'set';
												r[o](n, e), t && t.call(e.context, r, n, e), r.trigger('sync', r, n, e);
											}),
											G(this, e),
											this.sync('read', this, e)
										);
									},
									create: function (e, t) {
										var r = (t = t ? n.clone(t) : {}).wait;
										if (!(e = this._prepareModel(e, t))) return !1;
										r || this.add(e, t);
										var o = this,
											i = t.success;
										return (
											(t.success = function (e, t, n) {
												r && o.add(e, n), i && i.call(n.context, e, t, n);
											}),
											e.save(null, t),
											e
										);
									},
									parse: function (e, t) {
										return e;
									},
									clone: function () {
										return new this.constructor(this.models, { model: this.model, comparator: this.comparator });
									},
									modelId: function (e) {
										return e[this.model.prototype.idAttribute || 'id'];
									},
									values: function () {
										return new x(this, E);
									},
									keys: function () {
										return new x(this, T);
									},
									entries: function () {
										return new x(this, S);
									},
									_reset: function () {
										(this.length = 0), (this.models = []), (this._byId = {});
									},
									_prepareModel: function (e, t) {
										if (this._isModel(e)) return e.collection || (e.collection = this), e;
										(t = t ? n.clone(t) : {}).collection = this;
										var r = new this.model(e, t);
										return r.validationError ? (this.trigger('invalid', this, r.validationError, t), !1) : r;
									},
									_removeModels: function (e, t) {
										for (var n = [], r = 0; r < e.length; r++) {
											var o = this.get(e[r]);
											if (o) {
												var i = this.indexOf(o);
												this.models.splice(i, 1), this.length--, delete this._byId[o.cid];
												var a = this.modelId(o.attributes);
												null != a && delete this._byId[a],
													t.silent || ((t.index = i), o.trigger('remove', o, this, t)),
													n.push(o),
													this._removeReference(o, t);
											}
										}
										return n;
									},
									_isModel: function (e) {
										return e instanceof y;
									},
									_addReference: function (e, t) {
										this._byId[e.cid] = e;
										var n = this.modelId(e.attributes);
										null != n && (this._byId[n] = e), e.on('all', this._onModelEvent, this);
									},
									_removeReference: function (e, t) {
										delete this._byId[e.cid];
										var n = this.modelId(e.attributes);
										null != n && delete this._byId[n],
											this === e.collection && delete e.collection,
											e.off('all', this._onModelEvent, this);
									},
									_onModelEvent: function (e, t, n, r) {
										if (t) {
											if (('add' === e || 'remove' === e) && n !== this) return;
											if (('destroy' === e && this.remove(t, r), 'change' === e)) {
												var o = this.modelId(t.previousAttributes()),
													i = this.modelId(t.attributes);
												o !== i && (null != o && delete this._byId[o], null != i && (this._byId[i] = t));
											}
										}
										this.trigger.apply(this, arguments);
									},
								});
								var k = 'function' == typeof Symbol && Symbol.iterator;
								k && (b.prototype[k] = b.prototype.values);
								var x = function (e, t) {
										(this._collection = e), (this._kind = t), (this._index = 0);
									},
									E = 1,
									T = 2,
									S = 3;
								k &&
									(x.prototype[k] = function () {
										return this;
									});
								x.prototype.next = function () {
									if (this._collection) {
										if (this._index < this._collection.length) {
											var e,
												t = this._collection.at(this._index);
											if ((this._index++, this._kind === E)) e = t;
											else {
												var n = this._collection.modelId(t.attributes);
												e = this._kind === T ? n : [n, t];
											}
											return { value: e, done: !1 };
										}
										this._collection = void 0;
									}
									return { value: void 0, done: !0 };
								};
								var A = (t.View = function (e) {
										(this.cid = n.uniqueId('view')),
											this.preinitialize.apply(this, arguments),
											n.extend(this, n.pick(e, P)),
											this._ensureElement(),
											this.initialize.apply(this, arguments);
									}),
									C = /^(\S+)\s*(.*)$/,
									P = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];
								n.extend(A.prototype, l, {
									tagName: 'div',
									$: function (e) {
										return this.$el.find(e);
									},
									preinitialize: function () {},
									initialize: function () {},
									render: function () {
										return this;
									},
									remove: function () {
										return this._removeElement(), this.stopListening(), this;
									},
									_removeElement: function () {
										this.$el.remove();
									},
									setElement: function (e) {
										return this.undelegateEvents(), this._setElement(e), this.delegateEvents(), this;
									},
									_setElement: function (e) {
										(this.$el = e instanceof t.$ ? e : t.$(e)), (this.el = this.$el[0]);
									},
									delegateEvents: function (e) {
										if ((e || (e = n.result(this, 'events')), !e)) return this;
										for (var t in (this.undelegateEvents(), e)) {
											var r = e[t];
											if ((n.isFunction(r) || (r = this[r]), r)) {
												var o = t.match(C);
												this.delegate(o[1], o[2], r.bind(this));
											}
										}
										return this;
									},
									delegate: function (e, t, n) {
										return this.$el.on(e + '.delegateEvents' + this.cid, t, n), this;
									},
									undelegateEvents: function () {
										return this.$el && this.$el.off('.delegateEvents' + this.cid), this;
									},
									undelegate: function (e, t, n) {
										return this.$el.off(e + '.delegateEvents' + this.cid, t, n), this;
									},
									_createElement: function (e) {
										return document.createElement(e);
									},
									_ensureElement: function () {
										if (this.el) this.setElement(n.result(this, 'el'));
										else {
											var e = n.extend({}, n.result(this, 'attributes'));
											this.id && (e.id = n.result(this, 'id')),
												this.className && (e.class = n.result(this, 'className')),
												this.setElement(this._createElement(n.result(this, 'tagName'))),
												this._setAttributes(e);
										}
									},
									_setAttributes: function (e) {
										this.$el.attr(e);
									},
								});
								var R = function (e, t, n, r) {
										switch (t) {
											case 1:
												return function () {
													return e[n](this[r]);
												};
											case 2:
												return function (t) {
													return e[n](this[r], t);
												};
											case 3:
												return function (t, o) {
													return e[n](this[r], N(t, this), o);
												};
											case 4:
												return function (t, o, i) {
													return e[n](this[r], N(t, this), o, i);
												};
											default:
												return function () {
													var t = a.call(arguments);
													return t.unshift(this[r]), e[n].apply(e, t);
												};
										}
									},
									I = function (e, t, r, o) {
										n.each(r, function (n, r) {
											t[r] && (e.prototype[r] = R(t, n, r, o));
										});
									},
									N = function (e, t) {
										return n.isFunction(e)
											? e
											: n.isObject(e) && !t._isModel(e)
											? M(e)
											: n.isString(e)
											? function (t) {
													return t.get(e);
											  }
											: e;
									},
									M = function (e) {
										var t = n.matches(e);
										return function (e) {
											return t(e.attributes);
										};
									},
									j = {
										forEach: 3,
										each: 3,
										map: 3,
										collect: 3,
										reduce: 0,
										foldl: 0,
										inject: 0,
										reduceRight: 0,
										foldr: 0,
										find: 3,
										detect: 3,
										filter: 3,
										select: 3,
										reject: 3,
										every: 3,
										all: 3,
										some: 3,
										any: 3,
										include: 3,
										includes: 3,
										contains: 3,
										invoke: 0,
										max: 3,
										min: 3,
										toArray: 1,
										size: 1,
										first: 3,
										head: 3,
										take: 3,
										initial: 3,
										rest: 3,
										tail: 3,
										drop: 3,
										last: 3,
										without: 0,
										difference: 0,
										indexOf: 3,
										shuffle: 1,
										lastIndexOf: 3,
										isEmpty: 1,
										chain: 1,
										sample: 3,
										partition: 3,
										groupBy: 3,
										countBy: 3,
										sortBy: 3,
										indexBy: 3,
										findIndex: 3,
										findLastIndex: 3,
									},
									D = { keys: 1, values: 1, pairs: 1, invert: 1, pick: 0, omit: 0, chain: 1, isEmpty: 1 };
								n.each(
									[
										[b, j, 'models'],
										[y, D, 'attributes'],
									],
									function (e) {
										var t = e[0],
											r = e[1],
											o = e[2];
										(t.mixin = function (e) {
											var r = n.reduce(
												n.functions(e),
												function (e, t) {
													return (e[t] = 0), e;
												},
												{}
											);
											I(t, e, r, o);
										}),
											I(t, n, r, o);
									}
								),
									(t.sync = function (e, r, o) {
										var i = L[e];
										n.defaults(o || (o = {}), { emulateHTTP: t.emulateHTTP, emulateJSON: t.emulateJSON });
										var a = { type: i, dataType: 'json' };
										if (
											(o.url || (a.url = n.result(r, 'url') || z()),
											null != o.data ||
												!r ||
												('create' !== e && 'update' !== e && 'patch' !== e) ||
												((a.contentType = 'application/json'), (a.data = JSON.stringify(o.attrs || r.toJSON(o)))),
											o.emulateJSON &&
												((a.contentType = 'application/x-www-form-urlencoded'),
												(a.data = a.data ? { model: a.data } : {})),
											o.emulateHTTP && ('PUT' === i || 'DELETE' === i || 'PATCH' === i))
										) {
											(a.type = 'POST'), o.emulateJSON && (a.data._method = i);
											var s = o.beforeSend;
											o.beforeSend = function (e) {
												if ((e.setRequestHeader('X-HTTP-Method-Override', i), s)) return s.apply(this, arguments);
											};
										}
										'GET' === a.type || o.emulateJSON || (a.processData = !1);
										var l = o.error;
										o.error = function (e, t, n) {
											(o.textStatus = t), (o.errorThrown = n), l && l.call(o.context, e, t, n);
										};
										var u = (o.xhr = t.ajax(n.extend(a, o)));
										return r.trigger('request', r, u, o), u;
									});
								var L = { create: 'POST', update: 'PUT', patch: 'PATCH', delete: 'DELETE', read: 'GET' };
								t.ajax = function () {
									return t.$.ajax.apply(t.$, arguments);
								};
								var U = (t.Router = function (e) {
										e || (e = {}),
											this.preinitialize.apply(this, arguments),
											e.routes && (this.routes = e.routes),
											this._bindRoutes(),
											this.initialize.apply(this, arguments);
									}),
									F = /\((.*?)\)/g,
									B = /(\(\?)?:\w+/g,
									V = /\*\w+/g,
									Z = /[\-{}\[\]+?.,\\\^$|#\s]/g;
								n.extend(U.prototype, l, {
									preinitialize: function () {},
									initialize: function () {},
									route: function (e, r, o) {
										n.isRegExp(e) || (e = this._routeToRegExp(e)),
											n.isFunction(r) && ((o = r), (r = '')),
											o || (o = this[r]);
										var i = this;
										return (
											t.history.route(e, function (n) {
												var a = i._extractParameters(e, n);
												!1 !== i.execute(o, a, r) &&
													(i.trigger.apply(i, ['route:' + r].concat(a)),
													i.trigger('route', r, a),
													t.history.trigger('route', i, r, a));
											}),
											this
										);
									},
									execute: function (e, t, n) {
										e && e.apply(this, t);
									},
									navigate: function (e, n) {
										return t.history.navigate(e, n), this;
									},
									_bindRoutes: function () {
										if (this.routes) {
											this.routes = n.result(this, 'routes');
											for (var e, t = n.keys(this.routes); null != (e = t.pop()); ) this.route(e, this.routes[e]);
										}
									},
									_routeToRegExp: function (e) {
										return (
											(e = e
												.replace(Z, '\\$&')
												.replace(F, '(?:$1)?')
												.replace(B, function (e, t) {
													return t ? e : '([^/?]+)';
												})
												.replace(V, '([^?]*?)')),
											new RegExp('^' + e + '(?:\\?([\\s\\S]*))?$')
										);
									},
									_extractParameters: function (e, t) {
										var r = e.exec(t).slice(1);
										return n.map(r, function (e, t) {
											return t === r.length - 1 ? e || null : e ? decodeURIComponent(e) : null;
										});
									},
								});
								var H = (t.History = function () {
										(this.handlers = []),
											(this.checkUrl = this.checkUrl.bind(this)),
											'undefined' != typeof window &&
												((this.location = window.location), (this.history = window.history));
									}),
									q = /^[#\/]|\s+$/g,
									W = /^\/+|\/+$/g,
									K = /#.*$/;
								(H.started = !1),
									n.extend(H.prototype, l, {
										interval: 50,
										atRoot: function () {
											return this.location.pathname.replace(/[^\/]$/, '$&/') === this.root && !this.getSearch();
										},
										matchRoot: function () {
											return (
												this.decodeFragment(this.location.pathname).slice(0, this.root.length - 1) + '/' === this.root
											);
										},
										decodeFragment: function (e) {
											return decodeURI(e.replace(/%25/g, '%2525'));
										},
										getSearch: function () {
											var e = this.location.href.replace(/#.*/, '').match(/\?.+/);
											return e ? e[0] : '';
										},
										getHash: function (e) {
											var t = (e || this).location.href.match(/#(.*)$/);
											return t ? t[1] : '';
										},
										getPath: function () {
											var e = this.decodeFragment(this.location.pathname + this.getSearch()).slice(
												this.root.length - 1
											);
											return '/' === e.charAt(0) ? e.slice(1) : e;
										},
										getFragment: function (e) {
											return (
												null == e &&
													(e = this._usePushState || !this._wantsHashChange ? this.getPath() : this.getHash()),
												e.replace(q, '')
											);
										},
										start: function (e) {
											if (H.started) throw new Error('Backbone.history has already been started');
											if (
												((H.started = !0),
												(this.options = n.extend({ root: '/' }, this.options, e)),
												(this.root = this.options.root),
												(this._wantsHashChange = !1 !== this.options.hashChange),
												(this._hasHashChange =
													'onhashchange' in window && (void 0 === document.documentMode || document.documentMode > 7)),
												(this._useHashChange = this._wantsHashChange && this._hasHashChange),
												(this._wantsPushState = !!this.options.pushState),
												(this._hasPushState = !(!this.history || !this.history.pushState)),
												(this._usePushState = this._wantsPushState && this._hasPushState),
												(this.fragment = this.getFragment()),
												(this.root = ('/' + this.root + '/').replace(W, '/')),
												this._wantsHashChange && this._wantsPushState)
											) {
												if (!this._hasPushState && !this.atRoot()) {
													var t = this.root.slice(0, -1) || '/';
													return this.location.replace(t + '#' + this.getPath()), !0;
												}
												this._hasPushState && this.atRoot() && this.navigate(this.getHash(), { replace: !0 });
											}
											if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
												(this.iframe = document.createElement('iframe')),
													(this.iframe.src = 'javascript:0'),
													(this.iframe.style.display = 'none'),
													(this.iframe.tabIndex = -1);
												var r = document.body,
													o = r.insertBefore(this.iframe, r.firstChild).contentWindow;
												o.document.open(), o.document.close(), (o.location.hash = '#' + this.fragment);
											}
											var i =
												window.addEventListener ||
												function (e, t) {
													return attachEvent('on' + e, t);
												};
											if (
												(this._usePushState
													? i('popstate', this.checkUrl, !1)
													: this._useHashChange && !this.iframe
													? i('hashchange', this.checkUrl, !1)
													: this._wantsHashChange &&
													  (this._checkUrlInterval = setInterval(this.checkUrl, this.interval)),
												!this.options.silent)
											)
												return this.loadUrl();
										},
										stop: function () {
											var e =
												window.removeEventListener ||
												function (e, t) {
													return detachEvent('on' + e, t);
												};
											this._usePushState
												? e('popstate', this.checkUrl, !1)
												: this._useHashChange && !this.iframe && e('hashchange', this.checkUrl, !1),
												this.iframe && (document.body.removeChild(this.iframe), (this.iframe = null)),
												this._checkUrlInterval && clearInterval(this._checkUrlInterval),
												(H.started = !1);
										},
										route: function (e, t) {
											this.handlers.unshift({ route: e, callback: t });
										},
										checkUrl: function (e) {
											var t = this.getFragment();
											if (
												(t === this.fragment && this.iframe && (t = this.getHash(this.iframe.contentWindow)),
												t === this.fragment)
											)
												return !1;
											this.iframe && this.navigate(t), this.loadUrl();
										},
										loadUrl: function (e) {
											return (
												!!this.matchRoot() &&
												((e = this.fragment = this.getFragment(e)),
												n.some(this.handlers, function (t) {
													if (t.route.test(e)) return t.callback(e), !0;
												}))
											);
										},
										navigate: function (e, t) {
											if (!H.started) return !1;
											(t && !0 !== t) || (t = { trigger: !!t }), (e = this.getFragment(e || ''));
											var n = this.root;
											('' !== e && '?' !== e.charAt(0)) || (n = n.slice(0, -1) || '/');
											var r = n + e;
											e = e.replace(K, '');
											var o = this.decodeFragment(e);
											if (this.fragment !== o) {
												if (((this.fragment = o), this._usePushState))
													this.history[t.replace ? 'replaceState' : 'pushState']({}, document.title, r);
												else {
													if (!this._wantsHashChange) return this.location.assign(r);
													if (
														(this._updateHash(this.location, e, t.replace),
														this.iframe && e !== this.getHash(this.iframe.contentWindow))
													) {
														var i = this.iframe.contentWindow;
														t.replace || (i.document.open(), i.document.close()),
															this._updateHash(i.location, e, t.replace);
													}
												}
												return t.trigger ? this.loadUrl(e) : void 0;
											}
										},
										_updateHash: function (e, t, n) {
											if (n) {
												var r = e.href.replace(/(javascript:|#).*$/, '');
												e.replace(r + '#' + t);
											} else e.hash = '#' + t;
										},
									}),
									(t.history = new H());
								var $ = function (e, t) {
									var r,
										o = this;
									return (
										(r =
											e && n.has(e, 'constructor')
												? e.constructor
												: function () {
														return o.apply(this, arguments);
												  }),
										n.extend(r, o, t),
										(r.prototype = n.create(o.prototype, e)),
										(r.prototype.constructor = r),
										(r.__super__ = o.prototype),
										r
									);
								};
								y.extend = b.extend = U.extend = A.extend = H.extend = $;
								var z = function () {
										throw new Error('A "url" property or function must be specified');
									},
									G = function (e, t) {
										var n = t.error;
										t.error = function (r) {
											n && n.call(t.context, e, r, t), e.trigger('error', e, r, t);
										};
									};
							})(a, t, s, r);
						})();
					})(a.b, a.b.exports);
					var u = a.b.exports;
					(t.default = u), (e.exports = t.default);
				},
				62806: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(89278);
					/*!
					 * JavaScript Cookie v2.1.0
					 * https://github.com/js-cookie/js-cookie
					 *
					 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
					 * Released under the MIT license
					 */ !(function (e, t) {
						e.exports = (function () {
							function e() {
								for (var e = 0, t = {}; e < arguments.length; e++) {
									var n = arguments[e];
									for (var r in n) t[r] = n[r];
								}
								return t;
							}
							function t(n) {
								function r(t, o, i) {
									var a;
									if (arguments.length > 1) {
										if ('number' == typeof (i = e({ path: '/' }, r.defaults, i)).expires) {
											var s = new Date();
											s.setMilliseconds(s.getMilliseconds() + 864e5 * i.expires), (i.expires = s);
										}
										try {
											(a = JSON.stringify(o)), /^[\{\[]/.test(a) && (o = a);
										} catch (e) {}
										return (
											(o = n.write
												? n.write(o, t)
												: encodeURIComponent(String(o)).replace(
														/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
														decodeURIComponent
												  )),
											(t = (t = (t = encodeURIComponent(String(t))).replace(
												/%(23|24|26|2B|5E|60|7C)/g,
												decodeURIComponent
											)).replace(/[\(\)]/g, escape)),
											(document.cookie = [
												t,
												'=',
												o,
												i.expires && '; expires=' + i.expires.toUTCString(),
												i.path && '; path=' + i.path,
												i.domain && '; domain=' + i.domain,
												i.secure ? '; secure' : '',
											].join(''))
										);
									}
									t || (a = {});
									for (
										var l = document.cookie ? document.cookie.split('; ') : [], u = /(%[0-9A-Z]{2})+/g, c = 0;
										c < l.length;
										c++
									) {
										var d = l[c].split('='),
											f = d[0].replace(u, decodeURIComponent),
											p = d.slice(1).join('=');
										'"' === p.charAt(0) && (p = p.slice(1, -1));
										try {
											if (((p = n.read ? n.read(p, f) : n(p, f) || p.replace(u, decodeURIComponent)), this.json))
												try {
													p = JSON.parse(p);
												} catch (e) {}
											if (t === f) {
												a = p;
												break;
											}
											t || (a[f] = p);
										} catch (e) {}
									}
									return a;
								}
								return (
									(r.get = r.set = r),
									(r.getJSON = function () {
										return r.apply({ json: !0 }, [].slice.call(arguments));
									}),
									(r.defaults = {}),
									(r.remove = function (t, n) {
										r(t, '', e(n, { expires: -1 }));
									}),
									(r.withConverter = t),
									r
								);
							}
							return t(function () {});
						})();
					})(r.j);
					var o = r.j.exports;
					(t.default = o), (e.exports = t.default);
				},
				55198: function (e, t, n) {
					'use strict';
					var r = n(1654)(n(79602));
					(function () {
						var e;
						((e = (function () {
							function e() {
								(this.options_index = 0), (this.parsed = []);
							}
							return (
								(e.prototype.add_node = function (e) {
									return 'OPTGROUP' === e.nodeName.toUpperCase() ? this.add_group(e) : this.add_option(e);
								}),
								(e.prototype.add_group = function (e) {
									var t, n, r, o, i, a;
									for (
										t = this.parsed.length,
											this.parsed.push({
												array_index: t,
												group: !0,
												label: e.label,
												children: 0,
												disabled: e.disabled,
											}),
											a = [],
											r = 0,
											o = (i = e.childNodes).length;
										r < o;
										r++
									)
										(n = i[r]), a.push(this.add_option(n, t, e.disabled));
									return a;
								}),
								(e.prototype.add_option = function (e, t, n) {
									if ('OPTION' === e.nodeName.toUpperCase())
										return (
											'' !== e.text
												? (null != t && (this.parsed[t].children += 1),
												  this.parsed.push({
														array_index: this.parsed.length,
														options_index: this.options_index,
														value: e.value,
														text: e.text,
														html: e.innerHTML,
														selected: e.selected,
														disabled: !0 === n ? n : e.disabled,
														group_array_index: t,
														classes: e.className,
														style: e.style.cssText,
												  }))
												: this.parsed.push({
														array_index: this.parsed.length,
														options_index: this.options_index,
														empty: !0,
												  }),
											(this.options_index += 1)
										);
								}),
								e
							);
						})()).select_to_array = function (t) {
							var n, r, o, i, a;
							for (r = new e(), o = 0, i = (a = t.childNodes).length; o < i; o++) (n = a[o]), r.add_node(n);
							return r.parsed;
						}),
							(this.SelectParser = e);
					}).call(r.default),
						function () {
							var e;
							(e = (function () {
								function e(t, n) {
									(this.form_field = t),
										(this.options = null != n ? n : {}),
										e.browser_is_supported() &&
											((this.is_multiple = this.form_field.multiple),
											this.set_default_text(),
											this.set_default_values(),
											this.setup(),
											this.set_up_html(),
											this.register_observers(),
											this.finish_setup());
								}
								return (
									(e.prototype.set_default_values = function () {
										var e = this;
										return (
											(this.click_test_action = function (t) {
												return e.test_active_click(t);
											}),
											(this.activate_action = function (t) {
												return e.activate_field(t);
											}),
											(this.active_field = !1),
											(this.mouse_on_container = !1),
											(this.results_showing = !1),
											(this.result_highlighted = null),
											(this.result_single_selected = null),
											(this.allow_single_deselect =
												null != this.options.allow_single_deselect &&
												null != this.form_field.options[0] &&
												'' === this.form_field.options[0].text &&
												this.options.allow_single_deselect),
											(this.disable_search_threshold = this.options.disable_search_threshold || 0),
											(this.disable_search = this.options.disable_search || !1),
											(this.enable_split_word_search =
												null == this.options.enable_split_word_search || this.options.enable_split_word_search),
											(this.search_contains = this.options.search_contains || !1),
											(this.single_backstroke_delete = this.options.single_backstroke_delete || !1),
											(this.max_selected_options = this.options.max_selected_options || 1 / 0),
											(this.inherit_select_classes = this.options.inherit_select_classes || !1)
										);
									}),
									(e.prototype.set_default_text = function () {
										return (
											this.form_field.getAttribute('data-placeholder')
												? (this.default_text = this.form_field.getAttribute('data-placeholder'))
												: this.is_multiple
												? (this.default_text =
														this.options.placeholder_text_multiple ||
														this.options.placeholder_text ||
														e.default_multiple_text)
												: (this.default_text =
														this.options.placeholder_text_single ||
														this.options.placeholder_text ||
														e.default_single_text),
											(this.results_none_found =
												this.form_field.getAttribute('data-no_results_text') ||
												this.options.no_results_text ||
												e.default_no_result_text)
										);
									}),
									(e.prototype.mouse_enter = function () {
										return (this.mouse_on_container = !0);
									}),
									(e.prototype.mouse_leave = function () {
										return (this.mouse_on_container = !1);
									}),
									(e.prototype.input_focus = function (e) {
										var t = this;
										if (this.is_multiple) {
											if (!this.active_field)
												return setTimeout(function () {
													return t.container_mousedown();
												}, 50);
										} else if (!this.active_field) return this.activate_field();
									}),
									(e.prototype.input_blur = function (e) {
										var t = this;
										if (!this.mouse_on_container)
											return (
												(this.active_field = !1),
												setTimeout(function () {
													return t.blur_test();
												}, 100)
											);
									}),
									(e.prototype.result_add_option = function (e) {
										var t, n;
										return (
											(e.dom_id = this.container_id + '_o_' + e.array_index),
											(t = []),
											e.disabled || (e.selected && this.is_multiple) || t.push('active-result'),
											!e.disabled || (e.selected && this.is_multiple) || t.push('disabled-result'),
											e.selected && t.push('result-selected'),
											null != e.group_array_index && t.push('group-option'),
											'' !== e.classes && t.push(e.classes),
											(n = '' !== e.style.cssText && '' !== e.style ? ' style="' + e.style + '"' : ''),
											'<li id="' + e.dom_id + '" class="' + t.join(' ') + '"' + n + '>' + e.html + '</li>'
										);
									}),
									(e.prototype.results_update_field = function () {
										return (
											this.set_default_text(),
											this.is_multiple || this.results_reset_cleanup(),
											this.result_clear_highlight(),
											(this.result_single_selected = null),
											this.results_build()
										);
									}),
									(e.prototype.results_toggle = function () {
										return this.results_showing ? this.results_hide() : this.results_show();
									}),
									(e.prototype.results_search = function (e) {
										return this.results_showing ? this.winnow_results() : this.results_show();
									}),
									(e.prototype.choices_count = function () {
										var e, t, n;
										if (null != this.selected_option_count) return this.selected_option_count;
										for (this.selected_option_count = 0, e = 0, t = (n = this.form_field.options).length; e < t; e++)
											n[e].selected && (this.selected_option_count += 1);
										return this.selected_option_count;
									}),
									(e.prototype.choices_click = function (e) {
										if ((e.preventDefault(), !this.results_showing && !this.is_disabled)) return this.results_show();
									}),
									(e.prototype.keyup_checker = function (e) {
										var t, n;
										switch (((t = null != (n = e.which) ? n : e.keyCode), this.search_field_scale(), t)) {
											case 8:
												if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0)
													return this.keydown_backstroke();
												if (!this.pending_backstroke) return this.result_clear_highlight(), this.results_search();
												break;
											case 13:
												if ((e.preventDefault(), this.results_showing)) return this.result_select(e);
												break;
											case 27:
												return this.results_showing && this.results_hide(), !0;
											case 9:
											case 38:
											case 40:
											case 16:
											case 91:
											case 17:
												break;
											default:
												return this.results_search();
										}
									}),
									(e.prototype.generate_field_id = function () {
										var e;
										return (e = this.generate_random_id()), (this.form_field.id = e), e;
									}),
									(e.prototype.generate_random_char = function () {
										var e, t;
										return (
											(e = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'),
											(t = Math.floor(Math.random() * e.length)),
											e.substring(t, t + 1)
										);
									}),
									(e.prototype.container_width = function () {
										return null != this.options.width ? this.options.width : this.form_field.offsetWidth + 'px';
									}),
									(e.browser_is_supported = function () {
										var e;
										return (
											'Microsoft Internet Explorer' !== window.navigator.appName ||
											(null !== (e = document.documentMode) && e >= 8)
										);
									}),
									(e.default_multiple_text = 'Select Some Options'),
									(e.default_single_text = 'Select an Option'),
									(e.default_no_result_text = 'No results match'),
									e
								);
							})()),
								(this.AbstractChosen = e);
						}.call(r.default),
						function () {
							var e,
								t,
								n,
								o = {}.hasOwnProperty,
								i = (n = this).AbstractChosen;
							(e = r.default).fn.extend({
								chosen: function (n) {
									return i.browser_is_supported()
										? this.each(function (r) {
												var o;
												if (!(o = e(this)).hasClass('chzn-done')) return o.data('chosen', new t(this, n));
										  })
										: this;
								},
							}),
								(t = (function (t) {
									function r() {
										return r.__super__.constructor.apply(this, arguments);
									}
									return (
										(function (e, t) {
											for (var n in t) o.call(t, n) && (e[n] = t[n]);
											function r() {
												this.constructor = e;
											}
											(r.prototype = t.prototype), (e.prototype = new r()), (e.__super__ = t.prototype);
										})(r, t),
										(r.prototype.setup = function () {
											return (
												(this.form_field_jq = e(this.form_field)),
												(this.current_selectedIndex = this.form_field.selectedIndex),
												(this.is_rtl = this.form_field_jq.hasClass('chzn-rtl'))
											);
										}),
										(r.prototype.finish_setup = function () {
											return this.form_field_jq.addClass('chzn-done');
										}),
										(r.prototype.set_up_html = function () {
											var t, n;
											return (
												(this.container_id = this.form_field.id.length
													? this.form_field.id.replace(/[^\w]/g, '_')
													: this.generate_field_id()),
												(this.container_id += '_chzn'),
												(t = ['chzn-container']).push('chzn-container-' + (this.is_multiple ? 'multi' : 'single')),
												this.inherit_select_classes && this.form_field.className && t.push(this.form_field.className),
												this.is_rtl && t.push('chzn-rtl'),
												(n = { id: this.container_id, class: t.join(' '), title: this.form_field.title }),
												(this.container = e('<div></div>', n)),
												(this.container[0].style.width = this.container_width()),
												this.is_multiple
													? this.container.html(
															'<ul class="chzn-choices"><li class="search-field"><input type="text" value="' +
																this.default_text +
																'" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chzn-drop"><ul class="chzn-results"></ul></div>'
													  )
													: this.container.html(
															'<a href="#" class="chzn-single chzn-default" tabindex="-1"><span>' +
																this.default_text +
																'</span><div><b></b></div></a><div class="chzn-drop"><div class="chzn-search"><input type="text" autocomplete="off" /></div><ul class="chzn-results"></ul></div>'
													  ),
												this.form_field_jq.hide().after(this.container),
												(this.dropdown = this.container.find('div.chzn-drop').first()),
												(this.search_field = this.container.find('input').first()),
												(this.search_results = this.container.find('ul.chzn-results').first()),
												this.search_field_scale(),
												(this.search_no_results = this.container.find('li.no-results').first()),
												this.is_multiple
													? ((this.search_choices = this.container.find('ul.chzn-choices').first()),
													  (this.search_container = this.container.find('li.search-field').first()))
													: ((this.search_container = this.container.find('div.chzn-search').first()),
													  (this.selected_item = this.container.find('.chzn-single').first())),
												this.results_build(),
												this.set_tab_index(),
												this.set_label_behavior(),
												this.form_field_jq.trigger('liszt:ready', { chosen: this })
											);
										}),
										(r.prototype.register_observers = function () {
											var e = this;
											return (
												this.container.mousedown(function (t) {
													e.container_mousedown(t);
												}),
												this.container.mouseup(function (t) {
													e.container_mouseup(t);
												}),
												this.container.mouseenter(function (t) {
													e.mouse_enter(t);
												}),
												this.container.mouseleave(function (t) {
													e.mouse_leave(t);
												}),
												this.search_results.mouseup(function (t) {
													e.search_results_mouseup(t);
												}),
												this.search_results.mouseover(function (t) {
													e.search_results_mouseover(t);
												}),
												this.search_results.mouseout(function (t) {
													e.search_results_mouseout(t);
												}),
												this.search_results.bind('mousewheel DOMMouseScroll', function (t) {
													e.search_results_mousewheel(t);
												}),
												this.form_field_jq.bind('liszt:updated', function (t) {
													e.results_update_field(t);
												}),
												this.form_field_jq.bind('liszt:activate', function (t) {
													e.activate_field(t);
												}),
												this.form_field_jq.bind('liszt:open', function (t) {
													e.container_mousedown(t);
												}),
												this.search_field.blur(function (t) {
													e.input_blur(t);
												}),
												this.search_field.keyup(function (t) {
													e.keyup_checker(t);
												}),
												this.search_field.keydown(function (t) {
													e.keydown_checker(t);
												}),
												this.search_field.focus(function (t) {
													e.input_focus(t);
												}),
												this.is_multiple
													? this.search_choices.click(function (t) {
															e.choices_click(t);
													  })
													: this.container.click(function (e) {
															e.preventDefault();
													  })
											);
										}),
										(r.prototype.search_field_disabled = function () {
											return (
												(this.is_disabled = this.form_field_jq[0].disabled),
												this.is_disabled
													? (this.container.addClass('chzn-disabled'),
													  (this.search_field[0].disabled = !0),
													  this.is_multiple || this.selected_item.unbind('focus', this.activate_action),
													  this.close_field())
													: (this.container.removeClass('chzn-disabled'),
													  (this.search_field[0].disabled = !1),
													  this.is_multiple ? void 0 : this.selected_item.bind('focus', this.activate_action))
											);
										}),
										(r.prototype.container_mousedown = function (t) {
											if (
												!this.is_disabled &&
												(t && 'mousedown' === t.type && !this.results_showing && t.preventDefault(),
												null == t || !e(t.target).hasClass('search-choice-close'))
											)
												return (
													this.active_field
														? this.is_multiple ||
														  !t ||
														  (e(t.target)[0] !== this.selected_item[0] &&
																!e(t.target).parents('a.chzn-single').length) ||
														  (t.preventDefault(), this.results_toggle())
														: (this.is_multiple && this.search_field.val(''),
														  e(document).click(this.click_test_action),
														  this.results_show()),
													this.activate_field()
												);
										}),
										(r.prototype.container_mouseup = function (e) {
											if ('ABBR' === e.target.nodeName && !this.is_disabled) return this.results_reset(e);
										}),
										(r.prototype.search_results_mousewheel = function (e) {
											var t, n, r;
											if (
												null !=
												(t =
													-(null != (n = e.originalEvent) ? n.wheelDelta : void 0) ||
													(null != (r = e.originialEvent) ? r.detail : void 0))
											)
												return (
													e.preventDefault(),
													'DOMMouseScroll' === e.type && (t *= 40),
													this.search_results.scrollTop(t + this.search_results.scrollTop())
												);
										}),
										(r.prototype.blur_test = function (e) {
											if (!this.active_field && this.container.hasClass('chzn-container-active'))
												return this.close_field();
										}),
										(r.prototype.close_field = function () {
											return (
												e(document).unbind('click', this.click_test_action),
												(this.active_field = !1),
												this.results_hide(),
												this.container.removeClass('chzn-container-active'),
												this.clear_backstroke(),
												this.show_search_field_default(),
												this.search_field_scale()
											);
										}),
										(r.prototype.activate_field = function () {
											return (
												this.container.addClass('chzn-container-active'),
												(this.active_field = !0),
												this.search_field.val(this.search_field.val()),
												this.search_field.focus()
											);
										}),
										(r.prototype.test_active_click = function (t) {
											return e(t.target).parents('#' + this.container_id).length
												? (this.active_field = !0)
												: this.close_field();
										}),
										(r.prototype.results_build = function () {
											var e, t, r, o, i;
											for (
												this.parsing = !0,
													this.selected_option_count = null,
													this.results_data = n.SelectParser.select_to_array(this.form_field),
													this.is_multiple
														? this.search_choices.find('li.search-choice').remove()
														: this.is_multiple ||
														  (this.selected_item.addClass('chzn-default').find('span').text(this.default_text),
														  this.disable_search || this.form_field.options.length <= this.disable_search_threshold
																? ((this.search_field[0].readOnly = !0),
																  this.container.addClass('chzn-container-single-nosearch'))
																: ((this.search_field[0].readOnly = !1),
																  this.container.removeClass('chzn-container-single-nosearch'))),
													e = '',
													r = 0,
													o = (i = this.results_data).length;
												r < o;
												r++
											)
												(t = i[r]).group
													? (e += this.result_add_group(t))
													: t.empty ||
													  ((e += this.result_add_option(t)),
													  t.selected && this.is_multiple
															? this.choice_build(t)
															: t.selected &&
															  !this.is_multiple &&
															  (this.selected_item.removeClass('chzn-default').find('span').text(t.text),
															  this.allow_single_deselect && this.single_deselect_control_build()));
											return (
												this.search_field_disabled(),
												this.show_search_field_default(),
												this.search_field_scale(),
												this.search_results.html(e),
												(this.parsing = !1)
											);
										}),
										(r.prototype.result_add_group = function (t) {
											return (
												(t.dom_id = this.container_id + '_g_' + t.array_index),
												'<li id="' +
													t.dom_id +
													'" class="group-result">' +
													e('<div></div>').text(t.label).html() +
													'</li>'
											);
										}),
										(r.prototype.result_do_highlight = function (e) {
											var t, n, r, o, i;
											if (e.length) {
												if (
													(this.result_clear_highlight(),
													(this.result_highlight = e),
													this.result_highlight.addClass('highlighted'),
													(o =
														(r = parseInt(this.search_results.css('maxHeight'), 10)) +
														(i = this.search_results.scrollTop())),
													(t =
														(n = this.result_highlight.position().top + this.search_results.scrollTop()) +
														this.result_highlight.outerHeight()) >= o)
												)
													return this.search_results.scrollTop(t - r > 0 ? t - r : 0);
												if (n < i) return this.search_results.scrollTop(n);
											}
										}),
										(r.prototype.result_clear_highlight = function () {
											return (
												this.result_highlight && this.result_highlight.removeClass('highlighted'),
												(this.result_highlight = null)
											);
										}),
										(r.prototype.results_show = function () {
											return this.is_multiple && this.max_selected_options <= this.choices_count()
												? (this.form_field_jq.trigger('liszt:maxselected', { chosen: this }), !1)
												: (this.container.addClass('chzn-with-drop'),
												  this.form_field_jq.trigger('liszt:showing_dropdown', { chosen: this }),
												  (this.results_showing = !0),
												  this.search_field.focus(),
												  this.search_field.val(this.search_field.val()),
												  this.winnow_results());
										}),
										(r.prototype.results_hide = function () {
											return (
												this.results_showing &&
													(this.result_clear_highlight(),
													this.container.removeClass('chzn-with-drop'),
													this.form_field_jq.trigger('liszt:hiding_dropdown', { chosen: this })),
												(this.results_showing = !1)
											);
										}),
										(r.prototype.set_tab_index = function (e) {
											var t;
											if (this.form_field_jq.attr('tabindex'))
												return (
													(t = this.form_field_jq.attr('tabindex')),
													this.form_field_jq.attr('tabindex', -1),
													this.search_field.attr('tabindex', t)
												);
										}),
										(r.prototype.set_label_behavior = function () {
											var t = this;
											if (
												((this.form_field_label = this.form_field_jq.parents('label')),
												!this.form_field_label.length &&
													this.form_field.id.length &&
													(this.form_field_label = e("label[for='" + this.form_field.id + "']")),
												this.form_field_label.length > 0)
											)
												return this.form_field_label.click(function (e) {
													return t.is_multiple ? t.container_mousedown(e) : t.activate_field();
												});
										}),
										(r.prototype.show_search_field_default = function () {
											return this.is_multiple && this.choices_count() < 1 && !this.active_field
												? (this.search_field.val(this.default_text), this.search_field.addClass('default'))
												: (this.search_field.val(''), this.search_field.removeClass('default'));
										}),
										(r.prototype.search_results_mouseup = function (t) {
											var n;
											if (
												(n = e(t.target).hasClass('active-result')
													? e(t.target)
													: e(t.target).parents('.active-result').first()).length
											)
												return (this.result_highlight = n), this.result_select(t), this.search_field.focus();
										}),
										(r.prototype.search_results_mouseover = function (t) {
											var n;
											if (
												(n = e(t.target).hasClass('active-result')
													? e(t.target)
													: e(t.target).parents('.active-result').first())
											)
												return this.result_do_highlight(n);
										}),
										(r.prototype.search_results_mouseout = function (t) {
											if (e(t.target).hasClass('active-result')) return this.result_clear_highlight();
										}),
										(r.prototype.choice_build = function (t) {
											var n,
												r,
												o = this;
											return (
												(n = e('<li></li>', { class: 'search-choice' }).html('<span>' + t.html + '</span>')),
												t.disabled
													? n.addClass('search-choice-disabled')
													: ((r = e('<a></a>', { href: '#', class: 'search-choice-close', rel: t.array_index })).click(
															function (e) {
																return o.choice_destroy_link_click(e);
															}
													  ),
													  n.append(r)),
												this.search_container.before(n)
											);
										}),
										(r.prototype.choice_destroy_link_click = function (t) {
											if ((t.preventDefault(), t.stopPropagation(), !this.is_disabled))
												return this.choice_destroy(e(t.target));
										}),
										(r.prototype.choice_destroy = function (e) {
											if (this.result_deselect(e.attr('rel')))
												return (
													this.show_search_field_default(),
													this.is_multiple &&
														this.choices_count() > 0 &&
														this.search_field.val().length < 1 &&
														this.results_hide(),
													e.parents('li').first().remove(),
													this.search_field_scale()
												);
										}),
										(r.prototype.results_reset = function () {
											if (
												((this.form_field.options[0].selected = !0),
												(this.selected_option_count = null),
												this.selected_item.find('span').text(this.default_text),
												this.is_multiple || this.selected_item.addClass('chzn-default'),
												this.show_search_field_default(),
												this.results_reset_cleanup(),
												this.form_field_jq.trigger('change'),
												this.active_field)
											)
												return this.results_hide();
										}),
										(r.prototype.results_reset_cleanup = function () {
											return (
												(this.current_selectedIndex = this.form_field.selectedIndex),
												this.selected_item.find('abbr').remove()
											);
										}),
										(r.prototype.result_select = function (e) {
											var t, n, r, o;
											if (this.result_highlight)
												return (
													(n = (t = this.result_highlight).attr('id')),
													this.result_clear_highlight(),
													this.is_multiple && this.max_selected_options <= this.choices_count()
														? (this.form_field_jq.trigger('liszt:maxselected', { chosen: this }), !1)
														: (this.is_multiple
																? t.removeClass('active-result')
																: (this.search_results.find('.result-selected').removeClass('result-selected'),
																  (this.result_single_selected = t),
																  this.selected_item.removeClass('chzn-default')),
														  t.addClass('result-selected'),
														  (o = n.substr(n.lastIndexOf('_') + 1)),
														  ((r = this.results_data[o]).selected = !0),
														  (this.form_field.options[r.options_index].selected = !0),
														  (this.selected_option_count = null),
														  this.is_multiple
																? this.choice_build(r)
																: (this.selected_item.find('span').first().text(r.text),
																  this.allow_single_deselect && this.single_deselect_control_build()),
														  ((e.metaKey || e.ctrlKey) && this.is_multiple) || this.results_hide(),
														  this.search_field.val(''),
														  (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) &&
																this.form_field_jq.trigger('change', {
																	selected: this.form_field.options[r.options_index].value,
																}),
														  (this.current_selectedIndex = this.form_field.selectedIndex),
														  this.search_field_scale())
												);
										}),
										(r.prototype.result_activate = function (e, t) {
											return t.disabled
												? e.addClass('disabled-result')
												: this.is_multiple && t.selected
												? e.addClass('result-selected')
												: e.addClass('active-result');
										}),
										(r.prototype.result_deactivate = function (e) {
											return e.removeClass('active-result result-selected disabled-result');
										}),
										(r.prototype.result_deselect = function (t) {
											var n;
											return (
												(n = this.results_data[t]),
												!this.form_field.options[n.options_index].disabled &&
													((n.selected = !1),
													(this.form_field.options[n.options_index].selected = !1),
													(this.selected_option_count = null),
													e('#' + this.container_id + '_o_' + t)
														.removeClass('result-selected')
														.addClass('active-result')
														.show(),
													this.result_clear_highlight(),
													this.winnow_results(),
													this.form_field_jq.trigger('change', {
														deselected: this.form_field.options[n.options_index].value,
													}),
													this.search_field_scale(),
													!0)
											);
										}),
										(r.prototype.single_deselect_control_build = function () {
											if (this.allow_single_deselect)
												return (
													this.selected_item.find('abbr').length ||
														this.selected_item.find('span').first().after('<abbr class="search-choice-close"></abbr>'),
													this.selected_item.addClass('chzn-single-with-deselect')
												);
										}),
										(r.prototype.winnow_results = function () {
											var t, n, r, o, i, a, s, l, u, c, d, f, p, h, m, v, g, y;
											for (
												this.no_results_clear(),
													u = 0,
													c =
														this.search_field.val() === this.default_text
															? ''
															: e('<div></div>').text(e.trim(this.search_field.val())).html(),
													a = this.search_contains ? '' : '^',
													i = new RegExp(a + c.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'i'),
													p = new RegExp(c.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'i'),
													h = 0,
													v = (y = this.results_data).length;
												h < v;
												h++
											)
												if (!(n = y[h]).empty)
													if (n.group) e('#' + n.dom_id).css('display', 'none');
													else {
														if (((t = !1), (l = n.dom_id), (s = e('#' + l)), i.test(n.html))) (t = !0), (u += 1);
														else if (
															this.enable_split_word_search &&
															(n.html.indexOf(' ') >= 0 || 0 === n.html.indexOf('[')) &&
															(o = n.html.replace(/\[|\]/g, '').split(' ')).length
														)
															for (m = 0, g = o.length; m < g; m++) (r = o[m]), i.test(r) && ((t = !0), (u += 1));
														t
															? (c.length
																	? ((d = n.html.search(p)),
																	  (f =
																			(f =
																				n.html.substr(0, d + c.length) + '</em>' + n.html.substr(d + c.length)).substr(
																				0,
																				d
																			) +
																			'<em>' +
																			f.substr(d)))
																	: (f = n.html),
															  s.html(f),
															  this.result_activate(s, n),
															  null != n.group_array_index &&
																	e('#' + this.results_data[n.group_array_index].dom_id).css('display', 'list-item'))
															: (this.result_highlight &&
																	l === this.result_highlight.attr('id') &&
																	this.result_clear_highlight(),
															  this.result_deactivate(s));
													}
											return u < 1 && c.length ? this.no_results(c) : this.winnow_results_set_highlight();
										}),
										(r.prototype.winnow_results_set_highlight = function () {
											var e, t;
											if (
												!this.result_highlight &&
												null !=
													(e = (t = this.is_multiple ? [] : this.search_results.find('.result-selected.active-result'))
														.length
														? t.first()
														: this.search_results.find('.active-result').first())
											)
												return this.result_do_highlight(e);
										}),
										(r.prototype.no_results = function (t) {
											var n;
											return (
												(n = e('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>'))
													.find('span')
													.first()
													.html(t),
												this.search_results.append(n)
											);
										}),
										(r.prototype.no_results_clear = function () {
											return this.search_results.find('.no-results').remove();
										}),
										(r.prototype.keydown_arrow = function () {
											var e;
											return this.results_showing && this.result_highlight
												? (e = this.result_highlight.nextAll('li.active-result').first())
													? this.result_do_highlight(e)
													: void 0
												: this.results_show();
										}),
										(r.prototype.keyup_arrow = function () {
											var e;
											return this.results_showing || this.is_multiple
												? this.result_highlight
													? (e = this.result_highlight.prevAll('li.active-result')).length
														? this.result_do_highlight(e.first())
														: (this.choices_count() > 0 && this.results_hide(), this.result_clear_highlight())
													: void 0
												: this.results_show();
										}),
										(r.prototype.keydown_backstroke = function () {
											var e;
											return this.pending_backstroke
												? (this.choice_destroy(this.pending_backstroke.find('a').first()), this.clear_backstroke())
												: (e = this.search_container.siblings('li.search-choice').last()).length &&
												  !e.hasClass('search-choice-disabled')
												? ((this.pending_backstroke = e),
												  this.single_backstroke_delete
														? this.keydown_backstroke()
														: this.pending_backstroke.addClass('search-choice-focus'))
												: void 0;
										}),
										(r.prototype.clear_backstroke = function () {
											return (
												this.pending_backstroke && this.pending_backstroke.removeClass('search-choice-focus'),
												(this.pending_backstroke = null)
											);
										}),
										(r.prototype.keydown_checker = function (e) {
											var t, n;
											switch (
												((t = null != (n = e.which) ? n : e.keyCode),
												this.search_field_scale(),
												8 !== t && this.pending_backstroke && this.clear_backstroke(),
												t)
											) {
												case 8:
													this.backstroke_length = this.search_field.val().length;
													break;
												case 9:
													this.results_showing && !this.is_multiple && this.result_select(e),
														(this.mouse_on_container = !1);
													break;
												case 13:
													e.preventDefault();
													break;
												case 38:
													e.preventDefault(), this.keyup_arrow();
													break;
												case 40:
													e.preventDefault(), this.keydown_arrow();
											}
										}),
										(r.prototype.search_field_scale = function () {
											var t, n, r, o, i, a, s;
											if (this.is_multiple) {
												for (
													i = 0,
														r = 'position:absolute; left: -1000px; top: -1000px; display:none;',
														a = 0,
														s = (o = [
															'font-size',
															'font-style',
															'font-weight',
															'font-family',
															'line-height',
															'text-transform',
															'letter-spacing',
														]).length;
													a < s;
													a++
												)
													r += (n = o[a]) + ':' + this.search_field.css(n) + ';';
												return (
													(t = e('<div></div>', { style: r })).text(this.search_field.val()),
													e('body').append(t),
													(i = t.width() + 25),
													t.remove(),
													this.f_width || (this.f_width = this.container.outerWidth()),
													i > this.f_width - 10 && (i = this.f_width - 10),
													this.search_field.css({ width: i + 'px' })
												);
											}
										}),
										(r.prototype.generate_random_id = function () {
											var t;
											for (
												t =
													'sel' +
													this.generate_random_char() +
													this.generate_random_char() +
													this.generate_random_char();
												e('#' + t).length > 0;

											)
												t += this.generate_random_char();
											return t;
										}),
										r
									);
								})(i)),
								(n.Chosen = t);
						}.call(r.default);
				},
				1303: function (e, t, n) {
					'use strict';
					var r,
						o,
						i = n(1654)(n(79602));
					/**
					 * --------------------------------------------------------------------
					 * jQuery customInput plugin
					 * Author: Maggie Costello Wachs maggie@filamentgroup.com, Scott Jehl, scott@filamentgroup.com
					 * Copyright (c) 2009 Filament Group
					 * licensed under MIT (filamentgroup.com/examples/mit-license.txt)
					 * --------------------------------------------------------------------
					 */
					(r = i.default),
						(o = r),
						(r.fn.customInput = function () {
							return o(this).each(function () {
								if (o(this).is('[type=checkbox],[type=radio]')) {
									var e = o(this),
										t = e.siblings('label[for="' + e.attr('id') + '"]:first');
									t.length || (t = e.closest('label[for="' + e.attr('id') + '"]:first')),
										e.add(t).wrapAll('<div class="custom-' + e.attr('type') + '"></div>'),
										t.hover(
											function () {
												o(this).addClass('hover');
											},
											function () {
												o(this).removeClass('hover');
											}
										),
										e
											.bind('updateState', function () {
												e.is(':checked') ? t.addClass('checked') : t.removeClass('checked checkedHover checkedFocus');
											})
											.trigger('updateState')
											.click(function () {
												o('input[name="' + o(this).attr('name') + '"]').trigger('updateState');
											})
											.focus(function () {
												t.addClass('focus'), e.is(':checked') && o(this).addClass('checkedFocus');
											})
											.blur(function () {
												t.removeClass('focus checkedFocus');
											});
								}
							});
						});
				},
				22891: function (e, t, n) {
					'use strict';
					var r = n(1654)(n(79602));
					/*! http://mths.be/placeholder v2.0.7 by @mathias */
					!(function () {
						var e,
							t,
							n = r.default,
							o = 'placeholder' in document.createElement('input'),
							i = 'placeholder' in document.createElement('textarea'),
							a = n.fn,
							s = n.valHooks;
						function l(e, t) {
							var r = this,
								o = n(r);
							if (r.value == o.attr('placeholder') && o.hasClass('placeholder'))
								if (o.data('placeholder-password')) {
									if (((o = o.hide().next().show().attr('id', o.removeAttr('id').data('placeholder-id'))), !0 === e))
										return (o[0].value = t);
									o.focus();
								} else (r.value = ''), o.removeClass('placeholder'), r == document.activeElement && r.select();
						}
						function u() {
							var e,
								t,
								r,
								o,
								i = this,
								a = n(i),
								s = this.id;
							if ('' == i.value) {
								if ('password' == i.type) {
									if (!a.data('placeholder-textinput')) {
										try {
											e = a.clone().attr({ type: 'text' });
										} catch (i) {
											e = n('<input>').attr(
												n.extend(
													((t = this),
													(r = {}),
													(o = /^jQuery\d+$/),
													n.each(t.attributes, function (e, t) {
														t.specified && !o.test(t.name) && (r[t.name] = t.value);
													}),
													r),
													{ type: 'text' }
												)
											);
										}
										e
											.removeAttr('name')
											.data({ 'placeholder-password': !0, 'placeholder-id': s })
											.bind('focus.placeholder', l),
											a.data({ 'placeholder-textinput': e, 'placeholder-id': s }).before(e);
									}
									a = a.removeAttr('id').hide().prev().attr('id', s).show();
								}
								a.addClass('placeholder'), (a[0].value = a.attr('placeholder'));
							} else a.removeClass('placeholder');
						}
						o && i
							? ((t = a.placeholder =
									function () {
										return this;
									}).input = t.textarea =
									!0)
							: (((t = a.placeholder =
									function () {
										return (
											this.filter((o ? 'textarea' : ':input') + '[placeholder]')
												.not('.placeholder')
												.bind({ 'focus.placeholder': l, 'blur.placeholder': u })
												.data('placeholder-enabled', !0)
												.trigger('blur.placeholder'),
											this
										);
									}).input = o),
							  (t.textarea = i),
							  (e = {
									get: function (e) {
										var t = n(e);
										return t.data('placeholder-enabled') && t.hasClass('placeholder') ? '' : e.value;
									},
									set: function (e, t) {
										var r = n(e);
										return r.data('placeholder-enabled')
											? ('' == t
													? ((e.value = t), e != document.activeElement && u.call(e))
													: (r.hasClass('placeholder') && l.call(e, !0, t)) || (e.value = t),
											  r)
											: (e.value = t);
									},
							  }),
							  o || (s.input = e),
							  i || (s.textarea = e),
							  n(function () {
									n(document).delegate('form', 'submit.placeholder', function () {
										var e = n('.placeholder', this).each(l);
										setTimeout(function () {
											e.each(u);
										}, 10);
									});
							  }),
							  n(window).bind('beforeunload.placeholder', function () {
									n('.placeholder').each(function () {
										this.value = '';
									});
							  }));
					})();
				},
				54833: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(83050)),
						i = r(n(45361)).default.decorate(o.default);
					(t.default = i), (e.exports = t.default);
				},
				45361: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2770)),
						a = r(n(28107)),
						s = r(n(67282)),
						l = r(n(86499)),
						u = a.default.clone(i.default.Events),
						c = {
							constructor: function (e) {
								for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
									n[r - 1] = arguments[r];
								s.default.call.apply(s.default, [this, e].concat(n)),
									this.module && this.$el.attr('data-view', this.module.id);
							},
							empty: function () {
								return this.removeChildren();
							},
							compileTemplate: l.default.tpl,
							broadcast: function () {
								return u.trigger.apply(u, arguments), this;
							},
							listen: function (e, t) {
								return u.off(e, t), this.listenTo(u, e, t), this;
							},
							notify: function (e, t, n) {
								return this.broadcast('notification', a.default.defaults({ message: t, level: e }, n)), this;
							},
							confirm: function (e, t, n, r) {
								var i;
								return (
									(i =
										'object' === (0, o.default)(e)
											? e
											: 2 === arguments.length && a.default.isFunction(t)
											? { title: 'Okta', subtitle: e, ok: t }
											: { title: e, subtitle: t, ok: n, cancelFn: r }),
									a.default.isFunction(i.ok) && (i.ok = a.default.bind(i.ok, this)),
									a.default.isFunction(i.cancelFn) && (i.cancelFn = a.default.bind(i.cancelFn, this)),
									this.broadcast('confirmation', i),
									this
								);
							},
							alert: function (e) {
								return (
									a.default.isString(e) && (e = { subtitle: e }),
									this.confirm(a.default.extend({}, e, { noCancelButton: !0 })),
									this
								);
							},
						},
						d = s.default.extend(c, {
							decorate: function (e) {
								var t = e.extend({});
								return a.default.defaults(t.prototype, c), t;
							},
						});
					(t.default = d), (e.exports = t.default);
				},
				73613: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = r(n(28107)),
						a = r(n(50808)),
						s = r(n(45361)),
						l = {
							click: function (e) {
								e.preventDefault(), e.stopPropagation();
							},
						},
						u = s.default.extend({
							attributes: function () {
								var e = this.__getAttribute('attrs');
								return i.default.extend({ 'data-se': 'button' }, e);
							},
							tagName: 'a',
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<span class="icon ' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'icon') || (null != t ? a(t, 'icon') : t)) ? i : e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'icon',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 30 }, end: { line: 1, column: 38 } },
												  })
												: i
										) +
										'"></span>'
									);
								},
								3: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'title') || (null != t ? a(t, 'title') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'title',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 67 }, end: { line: 1, column: 76 } },
											  })
											: i
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'icon') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 54 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'title') : t, {
											name: 'if',
											hash: {},
											fn: e.program(3, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 54 }, end: { line: 1, column: 83 } },
										}))
											? i
											: '')
									);
								},
								useData: !0,
							}),
							visible: !0,
							enabled: !0,
							enableWhen: {},
							showWhen: {},
							constructor: function (e) {
								this.options = e || {};
								var t = this.getTemplateData();
								(this.disabled = !1),
									s.default.apply(this, arguments),
									this.$el.addClass('link-button'),
									t.icon && (this.$el.addClass('link-button-icon'), t.title || this.$el.addClass('icon-only'));
							},
							getTemplateData: function () {
								return {
									href: this.__getAttribute('href'),
									title: this.__getAttribute('title'),
									icon: this.__getAttribute('icon'),
								};
							},
							initialize: function () {
								a.default.applyDoWhen(this, i.default.resultCtx(this, 'enableWhen', this), this.toggle),
									a.default.applyDoWhen(this, i.default.resultCtx(this, 'showWhen', this), this.toggleVisible);
							},
							render: function () {
								s.default.prototype.render.apply(this, arguments),
									i.default.result(this, 'enabled') || this.toggle(!1),
									i.default.result(this, 'visible') || this.toggleVisible(!1);
								var e = this.getTemplateData();
								return this.$el.attr('href', e.href || '#'), this;
							},
							__getAttribute: function (e, t) {
								var n = i.default.resultCtx(this.options, e, this);
								return i.default.isUndefined(n) && (n = i.default.result(this, e)), i.default.isUndefined(n) ? t : n;
							},
							enable: function () {
								this.toggle(!0);
							},
							disable: function () {
								this.toggle(!1);
							},
							show: function () {
								this.toggleVisible(!0);
							},
							hide: function () {
								this.toggleVisible(!1);
							},
							toggle: function (e) {
								var t = !!e && i.default.result(this, 'enabled');
								(this.disabled = !t),
									this.$el.toggleClass('link-button-disabled btn-disabled disabled', this.disabled),
									this.delegateEvents(this.disabled ? l : null);
							},
							toggleVisible: function (e) {
								var t = !e || !i.default.result(this, 'visible');
								this.$el.toggleClass('hide', t);
							},
						});
					(t.default = u), (e.exports = t.default);
				},
				92328: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = r(n(96129)),
						s = r(n(28107)),
						l = r(n(45361)),
						u = i.default.template({
							1: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<span class="icon ' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'icon') || (null != t ? a(t, 'icon') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'icon',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 96 }, end: { line: 1, column: 104 } },
											  })
											: i
									) +
									'"></span>'
								);
							},
							3: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return e.escapeExpression(
									'function' ==
										typeof (i =
											null != (i = a(n, 'title') || (null != t ? a(t, 'title') : t)) ? i : e.hooks.helperMissing)
										? i.call(null != t ? t : e.nullContext || {}, {
												name: 'title',
												hash: {},
												data: o,
												loc: { start: { line: 1, column: 133 }, end: { line: 1, column: 142 } },
										  })
										: i
								);
							},
							5: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<p class="option-subtitle">' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'subtitle') || (null != t ? a(t, 'subtitle') : t))
													? i
													: e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'subtitle',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 192 }, end: { line: 1, column: 204 } },
											  })
											: i
									) +
									'</p>'
								);
							},
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, i) {
								var a,
									s,
									l = null != t ? t : e.nullContext || {},
									u = e.hooks.helperMissing,
									c = 'function',
									d = e.escapeExpression,
									f =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<a href="" class="icon-16 ' +
									d(
										((s = null != (s = f(n, 'className') || (null != t ? f(t, 'className') : t)) ? s : u),
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'className',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 26 }, end: { line: 1, column: 39 } },
											  })
											: s)
									) +
									'" data-se="' +
									d(
										((s = null != (s = f(n, 'seleniumId') || (null != t ? f(t, 'seleniumId') : t)) ? s : u),
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'seleniumId',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 50 }, end: { line: 1, column: 64 } },
											  })
											: s)
									) +
									'">' +
									(null !=
									(a = f(n, 'if').call(l, null != t ? f(t, 'icon') : t, {
										name: 'if',
										hash: {},
										fn: e.program(1, i, 0),
										inverse: e.noop,
										data: i,
										loc: { start: { line: 1, column: 66 }, end: { line: 1, column: 120 } },
									}))
										? a
										: '') +
									(null !=
									(a = f(n, 'if').call(l, null != t ? f(t, 'title') : t, {
										name: 'if',
										hash: {},
										fn: e.program(3, i, 0),
										inverse: e.noop,
										data: i,
										loc: { start: { line: 1, column: 120 }, end: { line: 1, column: 149 } },
									}))
										? a
										: '') +
									(null !=
									(a = f(n, 'if').call(l, null != t ? f(t, 'subtitle') : t, {
										name: 'if',
										hash: {},
										fn: e.program(5, i, 0),
										inverse: e.noop,
										data: i,
										loc: { start: { line: 1, column: 149 }, end: { line: 1, column: 215 } },
									}))
										? a
										: '') +
									'</a>'
								);
							},
							useData: !0,
						}),
						c = l.default.extend({
							tagName: 'li',
							events: {
								click: function (e) {
									e.preventDefault(), this.action && this.action.call(this);
								},
							},
							constructor: function () {
								l.default.apply(this, arguments), this.$el.addClass('okta-dropdown-option option');
							},
							render: function () {
								return (
									this.$el.html(
										u({
											icon: s.default.result(this, 'icon'),
											className: s.default.result(this, 'className') || '',
											title: s.default.result(this, 'title'),
											subtitle: s.default.result(this, 'subtitle'),
											seleniumId: s.default.result(this, 'seleniumId'),
										})
									),
									s.default.result(this, 'disabled') && this.disable(),
									this
								);
							},
							disable: function () {
								this.$el.addClass('option-disabled'), this.$el.find('a').attr('tabindex', '-1');
							},
						}),
						d = l.default.extend({
							events: {
								'click a.option-selected': function (e) {
									e.preventDefault(), s.default.result(this, 'disabled') && e.stopPropagation();
								},
								'click .dropdown-disabled': function (e) {
									e.preventDefault(), e.stopPropagation();
								},
							},
							items: [],
							constructor: function () {
								var e = this.className;
								(this.className = null),
									l.default.apply(this, arguments),
									(this.className = e),
									this.$el.addClass('dropdown more-actions float-l'),
									s.default.each(
										s.default.result(this, 'items'),
										function (e) {
											this.addOption(e, this.options);
										},
										this
									);
							},
							template: i.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<span class="icon ' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'icon') || (null != t ? a(t, 'icon') : t)) ? i : e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'icon',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 176 }, end: { line: 1, column: 184 } },
												  })
												: i
										) +
										'"></span>'
									);
								},
								3: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<span class="off-screen">' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'screenReaderText') || (null != t ? a(t, 'screenReaderText') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'screenReaderText',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 249 }, end: { line: 1, column: 269 } },
												  })
												: i
										) +
										'</span>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, i) {
									var a,
										s,
										l = null != t ? t : e.nullContext || {},
										u = e.hooks.helperMissing,
										c = 'function',
										d = e.escapeExpression,
										f =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<a href="#" class="link-button ' +
										d(
											((s = null != (s = f(n, 'className') || (null != t ? f(t, 'className') : t)) ? s : u),
											(0, o.default)(s) === c
												? s.call(l, {
														name: 'className',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 31 }, end: { line: 1, column: 44 } },
												  })
												: s)
										) +
										' link-button-icon option-selected center" aria-expanded="false" aria-controls="okta-dropdown-options">' +
										(null !=
										(a = f(n, 'if').call(l, null != t ? f(t, 'icon') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, i, 0),
											inverse: e.noop,
											data: i,
											loc: { start: { line: 1, column: 146 }, end: { line: 1, column: 200 } },
										}))
											? a
											: '') +
										(null !=
										(a = f(n, 'if').call(l, null != t ? f(t, 'screenReaderText') : t, {
											name: 'if',
											hash: {},
											fn: e.program(3, i, 0),
											inverse: e.noop,
											data: i,
											loc: { start: { line: 1, column: 200 }, end: { line: 1, column: 283 } },
										}))
											? a
											: '') +
										'<span class="option-selected-text">' +
										d(
											((s = null != (s = f(n, 'title') || (null != t ? f(t, 'title') : t)) ? s : u),
											(0, o.default)(s) === c
												? s.call(l, {
														name: 'title',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 318 }, end: { line: 1, column: 327 } },
												  })
												: s)
										) +
										'</span><span class="icon-dm"></span></a><div id="okta-dropdown-options" class="options clearfix"><ul class="okta-dropdown-list options-wrap clearfix"></ul></div>'
									);
								},
								useData: !0,
							}),
							getTemplateData: function () {
								var e = [
									s.default.result(this, 'className') || '',
									s.default.result(this, 'disabled') ? 'dropdown-disabled' : '',
								];
								return {
									icon: s.default.result(this, 'icon'),
									className: a.default.trim(e.join(' ')),
									title: s.default.result(this, 'title'),
									screenReaderText: s.default.result(this, 'screenReaderText'),
								};
							},
							addOption: function (e, t) {
								this.add(c.extend(e), 'ul.options-wrap', { options: t || {} });
							},
						});
					(t.default = d), (e.exports = t.default);
				},
				73026: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = r(n(28107)),
						a = r(n(60196)),
						s = r(n(45361));
					function l(e, t) {
						return i.default.resultCtx(e.options, t, e) || i.default.result(e, t);
					}
					function u(e) {
						var t = 'infobox clearfix infobox-' + l(e, 'type');
						switch (l(e, 'size')) {
							case 'standard':
								t += '';
								break;
							case 'slim':
								t += ' infobox-slim';
								break;
							case 'compact':
								t += ' infobox-compact';
								break;
							case 'large':
								t += ' infobox-md';
						}
						return l(e, 'dismissible') && (t += ' infobox-dismiss'), t;
					}
					var c = {
							'click .infobox-dismiss-link': function (e) {
								var t = this;
								e.preventDefault(),
									this.$el.fadeOut(a.default.UNLOADING_FADE, function () {
										t.trigger('dismissed'), t.remove();
									});
							},
						},
						d = o.default.template({
							1: function (e, t, n, r, o) {
								var i =
									e.lookupProperty ||
									function (e, t) {
										if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
									};
								return (
									'<a data-se="dismiss-link" class="infobox-dismiss-link" title="' +
									e.escapeExpression(
										(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: { bundle: 'courage', code: 'component.dismiss' },
												data: o,
												loc: { start: { line: 1, column: 81 }, end: { line: 1, column: 131 } },
											}
										)
									) +
									'" href="#"><span data-se="icon" class="dismiss-icon"></span></a>'
								);
							},
							3: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<h3 data-se="header">' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'title') || (null != t ? a(t, 'title') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'title',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 286 }, end: { line: 1, column: 295 } },
											  })
											: i
									) +
									'</h3>'
								);
							},
							5: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<p data-se="sub-header">' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'subtitle') || (null != t ? a(t, 'subtitle') : t))
													? i
													: e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'subtitle',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 347 }, end: { line: 1, column: 359 } },
											  })
											: i
									) +
									'</p>'
								);
							},
							7: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<ul data-se="list" class="bullets">' +
									(null !=
									(i = a(n, 'each').call(null != t ? t : e.nullContext || {}, null != t ? a(t, 'bullets') : t, {
										name: 'each',
										hash: {},
										fn: e.program(8, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 420 }, end: { line: 1, column: 483 } },
									}))
										? i
										: '') +
									'</ul>'
								);
							},
							8: function (e, t, n, r, o) {
								return '<li data-se="list-item">' + e.escapeExpression(e.lambda(t, t)) + '</li>';
							},
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a,
									s = null != t ? t : e.nullContext || {},
									l =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									(null !=
									(i = l(n, 'if').call(s, null != t ? l(t, 'dismissible') : t, {
										name: 'if',
										hash: {},
										fn: e.program(1, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 202 } },
									}))
										? i
										: '') +
									'<span data-se="icon" class="icon ' +
									e.escapeExpression(
										'function' ==
											typeof (a =
												null != (a = l(n, 'icon') || (null != t ? l(t, 'icon') : t)) ? a : e.hooks.helperMissing)
											? a.call(s, {
													name: 'icon',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 235 }, end: { line: 1, column: 243 } },
											  })
											: a
									) +
									'"></span>' +
									(null !=
									(i = l(n, 'if').call(s, null != t ? l(t, 'title') : t, {
										name: 'if',
										hash: {},
										fn: e.program(3, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 252 }, end: { line: 1, column: 307 } },
									}))
										? i
										: '') +
									(null !=
									(i = l(n, 'if').call(s, null != t ? l(t, 'subtitle') : t, {
										name: 'if',
										hash: {},
										fn: e.program(5, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 307 }, end: { line: 1, column: 370 } },
									}))
										? i
										: '') +
									(null !=
									(i = l(n, 'if').call(s, null != t ? l(t, 'bullets') : t, {
										name: 'if',
										hash: {},
										fn: e.program(7, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 370 }, end: { line: 1, column: 495 } },
									}))
										? i
										: '')
								);
							},
							useData: !0,
						}),
						f = s.default.extend({
							attributes: { 'data-se': 'callout' },
							content: null,
							size: 'standard',
							type: 'info',
							dismissible: !1,
							title: null,
							subtitle: null,
							bullets: null,
							constructor: function () {
								(this.events = i.default.defaults(this.events || {}, c)),
									s.default.apply(this, arguments),
									this.$el.addClass(u(this)),
									(this.template = d);
								var e = l(this, 'content');
								e && this.add(e);
							},
							getTemplateData: function () {
								var e = l(this, 'type');
								switch (('tip' === e && (e = 'light-bulb'), l(this, 'size'))) {
									case 'slim':
										e = '';
										break;
									case 'large':
										e = [e, '-', '24'].join('');
										break;
									default:
										e = [e, '-', '16'].join('');
								}
								return {
									icon: e,
									title: l(this, 'title'),
									subtitle: l(this, 'subtitle'),
									bullets: l(this, 'bullets'),
									dismissible: l(this, 'dismissible'),
								};
							},
						}),
						p = {
							create: function (e) {
								return new f(e);
							},
						};
					(t.default = p), (e.exports = t.default);
				},
				1375: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = r(n(28107)),
						s = r(n(45361)),
						l = r(n(88712)),
						u = { level: 'success', hide: !0, fade: 400, delay: 3e3, width: 0, dismissable: !1 },
						c = s.default.extend({
							className: 'infobox infobox-confirm infobox-confirm-fixed',
							events: {
								'click .infobox-dismiss-link': function (e) {
									e.preventDefault(), this.fadeOut();
								},
							},
							template: i.default.template({
								1: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<a class="infobox-dismiss-link" title="' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'courage', code: 'component.dismiss' },
													data: o,
													loc: { start: { line: 1, column: 58 }, end: { line: 1, column: 108 } },
												}
											)
										) +
										'" href="#"><span class="dismiss-icon"></span></a>'
									);
								},
								3: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<h3>' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'title') || (null != t ? a(t, 'title') : t)) ? i : e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'title',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 220 }, end: { line: 1, column: 229 } },
												  })
												: i
										) +
										'</h3>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, i) {
									var a,
										s,
										l = null != t ? t : e.nullContext || {},
										u = e.hooks.helperMissing,
										c = 'function',
										d = e.escapeExpression,
										f =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(a = f(n, 'if').call(l, null != t ? f(t, 'dismissable') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, i, 0),
											inverse: e.noop,
											data: i,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 164 } },
										}))
											? a
											: '') +
										'<span class="icon ' +
										d(
											((s = null != (s = f(n, 'level') || (null != t ? f(t, 'level') : t)) ? s : u),
											(0, o.default)(s) === c
												? s.call(l, {
														name: 'level',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 182 }, end: { line: 1, column: 191 } },
												  })
												: s)
										) +
										'-16"></span>' +
										(null !=
										(a = f(n, 'if').call(l, null != t ? f(t, 'title') : t, {
											name: 'if',
											hash: {},
											fn: e.program(3, i, 0),
											inverse: e.noop,
											data: i,
											loc: { start: { line: 1, column: 203 }, end: { line: 1, column: 241 } },
										}))
											? a
											: '') +
										'<p>' +
										d(
											((s = null != (s = f(n, 'message') || (null != t ? f(t, 'message') : t)) ? s : u),
											(0, o.default)(s) === c
												? s.call(l, {
														name: 'message',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 244 }, end: { line: 1, column: 255 } },
												  })
												: s)
										) +
										'</p>'
									);
								},
								useData: !0,
							}),
							initialize: function () {
								if (((this.options = a.default.defaults({}, this.options, u)), !this.options.message))
									switch (this.options.level) {
										case 'success':
											this.options.message = l.default.localize('notification.default.message.success', 'courage');
											break;
										case 'error':
											this.options.message = l.default.localize('notification.default.message.error', 'courage');
											break;
										case 'warning':
											this.options.message = l.default.localize('notification.default.message.warning', 'courage');
									}
								this.$el.addClass('infobox-' + this.options.level),
									this.options.width && this.$el.width(this.options.width);
							},
							getTemplateData: function () {
								return a.default.extend(a.default.pick(this.options, 'level', 'message', 'title'), {
									dismissable: !1 === this.options.hide || !0 === this.options.dismissable,
								});
							},
							postRender: function () {
								this.options.hide && a.default.delay(a.default.bind(this.fadeOut, this), this.options.delay);
							},
							fadeOut: function () {
								this.$el.fadeOut(this.options.fade, a.default.bind(this.remove, this));
							},
						});
					(t.default = c), (e.exports = t.default);
				},
				21198: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = r(n(96129)),
						a = r(n(28107)),
						s = r(n(88712)),
						l = r(n(45361)),
						u = r(n(21990)),
						c = r(n(63301)),
						d = r(n(44995)),
						f = r(n(52930)),
						p = r(n(57581)),
						h = r(n(29752)),
						m = r(n(80685)),
						v = r(n(3197)),
						g = r(n(34564)),
						y = r(n(53303)),
						b = o.default.template({
							1: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<h2 class="o-form-title-bar" data-se="o-form-title-bar">' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'title') || (null != t ? a(t, 'title') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'title',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 75 }, end: { line: 1, column: 84 } },
											  })
											: i
									) +
									'</h2>'
								);
							},
							3: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return null !=
									(i = a(n, 'if').call(null != t ? t : e.nullContext || {}, null != t ? a(t, 'title') : t, {
										name: 'if',
										hash: {},
										fn: e.program(4, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 192 }, end: { line: 1, column: 288 } },
									}))
									? i
									: '';
							},
							4: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<h2 data-se="o-form-head" class="okta-form-title o-form-head">' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'title') || (null != t ? a(t, 'title') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'title',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 267 }, end: { line: 1, column: 276 } },
											  })
											: i
									) +
									'</h2>'
								);
							},
							6: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<p class="okta-form-subtitle o-form-explain" data-se="o-form-explain">' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'subtitle') || (null != t ? a(t, 'subtitle') : t))
													? i
													: e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'subtitle',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 385 }, end: { line: 1, column: 397 } },
											  })
											: i
									) +
									'</p>'
								);
							},
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a,
									s = null != t ? t : e.nullContext || {},
									l =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									(null !=
									(i = l(n, 'if').call(s, null != t ? l(t, 'hasReadMode') : t, {
										name: 'if',
										hash: {},
										fn: e.program(1, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 96 } },
									}))
										? i
										: '') +
									'<div data-se="o-form-content" class="o-form-content ' +
									e.escapeExpression(
										'function' ==
											typeof (a =
												null != (a = l(n, 'layout') || (null != t ? l(t, 'layout') : t)) ? a : e.hooks.helperMissing)
											? a.call(s, {
													name: 'layout',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 148 }, end: { line: 1, column: 158 } },
											  })
											: a
									) +
									' clearfix">' +
									(null !=
									(i = l(n, 'unless').call(s, null != t ? l(t, 'hasReadMode') : t, {
										name: 'unless',
										hash: {},
										fn: e.program(3, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 169 }, end: { line: 1, column: 299 } },
									}))
										? i
										: '') +
									(null !=
									(i = l(n, 'if').call(s, null != t ? l(t, 'subtitle') : t, {
										name: 'if',
										hash: {},
										fn: e.program(6, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 299 }, end: { line: 1, column: 408 } },
									}))
										? i
										: '') +
									'<div class="o-form-error-container" data-se="o-form-error-container"></div><div class="o-form-fieldset-container" data-se="o-form-fieldset-container"></div></div>'
								);
							},
							useData: !0,
						}),
						_ = o.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<h2 class="o-form-head">' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'title') || (null != t ? a(t, 'title') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'title',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 24 }, end: { line: 1, column: 33 } },
											  })
											: i
									) +
									'</h2>'
								);
							},
							useData: !0,
						}),
						w = 'auto' === (0, i.default)('<div>').css({ 'pointer-events': 'auto' })[0].style.pointerEvents;
					function O(e) {
						if (!w && this.$el.hasClass('o-form-saving')) {
							var t = (0, i.default)(e.currentTarget);
							t.css('display', 'none');
							var n = document.elementFromPoint(e.clientX, e.clientY);
							return t.css('display', 'block'), (e.target = n), (0, i.default)(n).trigger(e), !1;
						}
					}
					var k = {
						submit: function (e) {
							e.preventDefault(), this.__save();
						},
					};
					a.default.each(['click', 'dblclick', 'mousedown', 'mouseup'], function (e) {
						k[e + ' .o-form-input'] = O;
					});
					var x = function (e, t) {
							e || (e = '');
							var n = [];
							return a.default.isString(e) && (n = e.split(' ')), (n = a.default.union(n, t)).join(' ');
						},
						E = l.default.extend({
							constructor: function (e) {
								e || (e = {}),
									(this.options = e),
									e.settings ? (this.settings = e.settings) : (this.settings = e.settings = new y.default()),
									(this.id = a.default.uniqueId('form')),
									(this.tagName = 'form'),
									a.default.defaults(this.events, k),
									a.default.defaults(
										this.attributes,
										(function (e) {
											e || (e = {});
											var t = (e && e.collection) || {};
											return {
												'method': 'POST',
												'action':
													a.default.result(e, 'urlRoot') || a.default.result(t, 'url') || window.location.pathname,
												'data-se': 'o-form',
												'slot': 'content',
											};
										})(e.model)
									),
									(this.__buttons = []),
									(this.__errorFields = {}),
									this.__saveModelState(e.model);
								var t = a.default.result(this, 'step');
								if (t) {
									if (!this.save) {
										var n = a.default.result(this, 'totalSteps');
										this.save =
											n && t !== n
												? s.default.localize('oform.button.next', 'courage')
												: s.default.localize('oform.button.finish', 'courage');
									}
									this.className = a.default.result(this, 'className') + ' wizard';
								}
								(this.className = a.default.result(this, 'className') + ' o-form'),
									(this.__toolbar = this.__createToolbar(e)),
									l.default.call(this, e),
									a.default.each(
										a.default.result(this, 'inputs') || [],
										function (e) {
											this.__addLayoutItem(e);
										},
										this
									),
									this.add(this.__toolbar, ''),
									this.listenTo(this.model, 'change:__edit__', this.__applyMode),
									this.listenTo(
										this.model,
										'invalid error',
										a.default.throttle(
											function (e, t, n) {
												this.__showErrors(e, t, !1 !== n);
											},
											100,
											{ trailing: !1 }
										)
									),
									this.listenTo(this.model, 'form:resize', function () {
										this.trigger('resize');
									}),
									this.listenTo(this.model, 'form:cancel', a.default.throttle(this.__cancel, 100, { trailing: !1 })),
									this.listenTo(
										this.model,
										'form:previous',
										a.default.throttle(this.__previous, 100, { trailing: !1 })
									),
									(this.__save = a.default.throttle(this.__save, 200, { trailing: !1 })),
									this.listenTo(this.model, 'form:save', function () {
										this.$el.submit();
									}),
									this.listenTo(this.model, 'sync', function () {
										this.model.get('__edit__') && this.model.set('__edit__', !1, { silent: !0 }),
											this.__saveModelState(this.model),
											this.render();
									});
								var r = this.getAttribute('hasSavingState');
								if (
									(this.getAttribute('autoSave') &&
										(this.listenTo(this, 'save', function (e) {
											var t = this,
												n = e.save();
											n &&
												n.done &&
												n.done(function () {
													t.trigger('saved', e);
												});
										}),
										a.default.isUndefined(r) && (r = !0)),
									r)
								) {
									var o = this.getAttribute('customSavingState', {});
									this.listenTo(this.model, x(o.start || '', ['request']), this.__setSavingState),
										this.listenTo(this.model, x(o.stop || '', ['error', 'sync']), this.__clearSavingState);
								}
							},
							__createToolbar: function (e) {
								var t = !0 === this.getAttribute('danger') ? 'button-error' : 'button-primary',
									n = a.default.result(this, 'step'),
									r = new c.default(
										a.default.extend(
											{
												save: this.save || s.default.localize('oform.save', 'courage'),
												saveId: this.saveId,
												saveClassName: t,
												cancel: this.cancel || s.default.localize('oform.cancel', 'courage'),
												noCancelButton: this.noCancelButton || !1,
												noSubmitButton: this.noSubmitButton || !1,
												buttonOrder: this.buttonOrder,
												hasPrevStep: n && n > 1,
											},
											e || this.options
										)
									);
								return (
									a.default.each(this.__buttons, function (e) {
										r.addButton.apply(r, e);
									}),
									r
								);
							},
							className: '',
							attributes: {},
							events: {},
							inputs: [],
							template: null,
							read: !1,
							readOnly: !1,
							noButtonBar: !1,
							noCancelButton: !1,
							noSubmitButton: !1,
							buttonOrder: ['previous', 'save', 'cancel'],
							save: null,
							cancel: null,
							danger: !1,
							layout: '',
							step: void 0,
							totalSteps: void 0,
							title: null,
							subtitle: null,
							autoSave: !1,
							scrollOnError: !0,
							showErrors: !0,
							resizeSelector: '.o-form-content',
							getAttribute: function (e, t) {
								var n = a.default.resultCtx(this.options, e, this);
								return a.default.isUndefined(n) && (n = a.default.result(this, e)), a.default.isUndefined(n) ? t : n;
							},
							hasReadMode: function () {
								return !!this.getAttribute('read');
							},
							isReadOnly: function () {
								return !!this.getAttribute('readOnly');
							},
							hasButtonBar: function () {
								return !(this.getAttribute('noButtonBar') || this.isReadOnly());
							},
							render: function () {
								if ((this.__readModeBar && this.__readModeBar.remove(), this.hasReadMode() && !this.isReadOnly())) {
									var e = u.default.extend({ formTitle: this.getAttribute('title', '') });
									this.__readModeBar = this.add(e, '.o-form-title-bar').last();
								}
								var t = b({
									layout: this.getAttribute('layout', ''),
									title: this.getAttribute('title', '', !0),
									subtitle: this.getAttribute('subtitle', '', !0),
									hasReadMode: this.hasReadMode(),
								});
								return (
									this.$el.html(t),
									delete this.template,
									l.default.prototype.render.apply(this, arguments),
									this.__applyMode(),
									this
								);
							},
							__setSavingState: function () {
								this.model.trigger('form:set-saving-state'), this.$el.addClass('o-form-saving');
							},
							__clearSavingState: function () {
								this.model.trigger('form:clear-saving-state'), this.$el.removeClass('o-form-saving');
							},
							__toggleToolbar: function () {
								this.__toolbar && this.__toolbar.remove(),
									this.hasButtonBar() &&
										this._editMode() &&
										((this.__toolbar = this.__createToolbar()), this.add(this.__toolbar, '')),
									this.trigger('resize');
							},
							__cancel: function () {
								var e,
									t = this.model.get('__edit__');
								this.model.clear({ silent: !0 }),
									(e = this.model.sanitizeAttributes
										? this.model.sanitizeAttributes(this.__originalModel)
										: a.default.clone(this.__originalModel)),
									this.model.set(e, { silent: !0 }),
									this.trigger('cancel', this.model),
									this.model.trigger('cache:clear'),
									t &&
										(this.model.set('__edit__', !1, { silent: !0 }),
										this.model.trigger('change:__edit__', this.model, !1)),
									this.clearErrors();
							},
							isValid: function () {
								var e,
									t = this;
								function n(e) {
									return a.default.reduce(
										e,
										function (e, n) {
											return a.default.extend(e, t.model.validateField(n));
										},
										{}
									);
								}
								return a.default.isUndefined(this.validate)
									? this.model.isValid()
									: (a.default.isFunction(this.validate)
											? (e = this.validate())
											: a.default.isArray(this.validate)
											? (e = n(this.validate))
											: 'local' === this.validate &&
											  (e = n(
													this.getInputs().map(function (e) {
														return e.options.name;
													})
											  )),
									  !!a.default.isEmpty(e) || (this.model.trigger('invalid', this.model, e), !1));
							},
							__save: function () {
								this.clearErrors(), this.isValid() && this.trigger('save', this.model);
							},
							__previous: function () {
								this.trigger('previous', this.model);
							},
							__applyMode: function () {
								this.clearErrors(),
									this.__toggleToolbar(),
									this._editMode()
										? (this.$el.addClass('o-form-edit-mode'),
										  this.$el.removeClass('o-form-read-mode'),
										  this.$('.o-form-content').removeClass('rounded-btm-4'),
										  this.focus())
										: (this.$el.removeClass('o-form-edit-mode'),
										  this.$el.addClass('o-form-read-mode'),
										  this.$('.o-form-content').addClass('rounded-btm-4'));
							},
							_editMode: function () {
								return this.model.get('__edit__') || !this.hasReadMode();
							},
							parseErrorMessage: a.default.identity,
							_handleErrorScroll: function () {
								if (this.getAttribute('scrollOnError')) {
									var e = (0, i.default)('#' + this.id + ' .o-form-error-container');
									if (e.length) {
										var t,
											n = e.scrollParent();
										n[0] === document
											? ((n = (0, i.default)('html, body')), (t = e.offset().top))
											: (t = n.scrollTop() + e.offset().top - n.offset().top),
											n.animate({ scrollTop: t }, 400);
									}
								}
							},
							__showErrors: function (e, t, n) {
								if ((this.trigger('error', e), this.getAttribute('showErrors'))) {
									var r,
										o = f.default.getResponseJSON(t),
										i = f.default.parseFieldErrors(t);
									a.default.size(i)
										? a.default.each(
												i,
												function (e, t) {
													this.model.trigger(
														'form:field-error',
														this.__errorFields[t] || t,
														a.default.map(e, function (e) {
															return /^model\.validation/.test(e) ? s.default.localize(e, 'courage') : e;
														})
													);
												},
												this
										  )
										: (r = (function () {
												var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
												return Array.isArray(e.errorCauses) && e.errorCauses.length > 0
													? e.errorCauses[0].errorSummary
													: e.errorSummary;
										  })((o = this.parseErrorMessage(o)))),
										n &&
											(this.$('.o-form-error-container').addClass('o-form-has-errors'),
											this.add(d.default, '.o-form-error-container', { options: { errorSummary: r } })),
										this._handleErrorScroll(),
										this.model.trigger('form:resize');
								}
							},
							clearErrors: function () {
								this.$('.o-form-error-container').removeClass('o-form-has-errors'),
									this.model.trigger('form:clear-errors'),
									this.model.trigger('form:resize');
							},
							toggle: function () {
								return this.model.set('__edit__', !this.hasReadMode() || !this.model.get('__edit__')), this;
							},
							__addLayoutItem: function (e) {
								m.default.supports(e) ? this.addInput(e) : this.__addNonInputLayoutItem(e);
							},
							__addNonInputLayoutItem: function (e) {
								var t = a.default.omit(e, 'type');
								switch (e.type) {
									case 'sectionTitle':
										this.addSectionTitle(e.title, a.default.omit(t, 'title'));
										break;
									case 'divider':
										this.addDivider(t);
										break;
									default:
										throw new Error('unknown input: ' + e.type);
								}
							},
							addButton: function (e, t) {
								this.__toolbar && this.__toolbar.addButton(e, t), this.__buttons.push([e, t]);
							},
							addDivider: function (e) {
								return (
									this.add('<div class="okta-form-divider form-divider"></div>'),
									p.default.applyShowWhen(this.last(), e && e.showWhen),
									p.default.applyToggleWhen(this.last(), e && e.toggleWhen),
									this
								);
							},
							addSectionTitle: function (e, t) {
								return (
									this.add(_({ title: e })),
									p.default.applyShowWhen(this.last(), t && t.showWhen),
									p.default.applyToggleWhen(this.last(), t && t.toggleWhen),
									this
								);
							},
							addInput: function (e) {
								(e = a.default.clone(e)), p.default.validateInput(e, this.model);
								var t = p.default.generateInputOptions(e, this, this.__createInput).reverse();
								a.default.isEmpty(this.getInputs().toArray()) && a.default.extend(t[0], { validateOnlyIfDirty: !0 });
								var n = a.default.map(t, this.__createInput, this);
								a.default.each(
									t,
									function (e) {
										e.errorField && (this.__errorFields[e.errorField] = e.name);
									},
									this
								);
								var r = {
									inputId: a.default.last(n).options.inputId,
									input: n,
									multi: t.length > 1 ? t.length : void 0,
								};
								a.default.extend(r, a.default.omit(this.options, 'input'), a.default.omit(e, 'input'));
								var o = this.__createWrapper(r);
								!1 !== r.label && o.add(this.__createLabel(r)),
									o.add(this._createContainer(r)),
									(o.type = r.type || r.input.type || 'custom');
								var i = [o].concat(a.default.rest(arguments));
								return this.add.apply(this, i);
							},
							__createInput: function (e) {
								return (e = a.default.pick(e, p.default.INPUT_OPTIONS)), m.default.create(e);
							},
							__createWrapper: function (e) {
								return (e = a.default.pick(e, p.default.WRAPPER_OPTIONS)), new g.default(e);
							},
							__createLabel: function (e) {
								return (e = a.default.pick(e, p.default.LABEL_OPTIONS)), new v.default(e);
							},
							_createContainer: function (e) {
								return (e = a.default.pick(e, p.default.CONTAINER_OPTIONS)), new h.default(e);
							},
							__saveModelState: function (e) {
								this.__originalModel = i.default.extend(!0, {}, e.attributes);
							},
							add: function () {
								for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
								return (
									void 0 === t[1] && (t[1] = '> div.o-form-content > .o-form-fieldset-container'),
									l.default.prototype.add.apply(this, t)
								);
							},
							focus: function () {
								var e = this.getInputs().first();
								return e && e.focus && e.focus(), this;
							},
							disable: function () {
								return this.invoke('disable'), this;
							},
							enable: function () {
								this.invoke('enable');
							},
							contentHeight: function (e) {
								var t = this.$('.o-form-content');
								if (!a.default.isNumber(e)) return t.height();
								t.css('max-height', e);
							},
							getInputs: function () {
								return (0, a.default)(
									this.filter(function (e) {
										return e instanceof g.default;
									})
								);
							},
						});
					(t.default = E), (e.exports = t.default);
				},
				15982: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = r(n(96129)),
						a = r(n(28107)),
						s = r(n(2431)),
						l = r(n(88712)),
						u = r(n(45361)),
						c = r(n(73026)),
						d = r(n(83365)),
						f = {
							tagName: 'span',
							attributes: function () {
								return { 'data-se': 'o-form-input-' + this.getNameString() };
							},
							defaultPlaceholder: '',
							constructor: function (e) {
								delete (e = a.default.defaults(e || {}, {
									inputId: e.id || a.default.uniqueId('input'),
									placeholder: this.defaultPlaceholder,
									inlineValidation: !0,
									validateOnlyIfDirty: !1,
								})).id;
								var t = this;
								a.default.each({ enable: 'removeClass', disable: 'addClass' }, function (e, n) {
									t[n] = a.default.wrap(t[n], function (n) {
										n.apply(t, arguments), t.$el[e]('o-form-disabled');
									});
								}),
									u.default.call(this, e),
									!0 !== a.default.result(e, 'readOnly') &&
										!0 === a.default.result(e, 'read') &&
										this.listenTo(this.model, 'change:__edit__', this.render),
									a.default.isFunction(this.focus) &&
										(this.focus = a.default.debounce(a.default.bind(this.focus, this), 50)),
									a.default.result(e, 'validateOnlyIfDirty') || this.addInlineValidation(),
									this.addModelListeners(),
									this.$el.addClass('o-form-input-name-' + this.getNameString());
							},
							addAriaLabel: function () {
								var e = this.options.ariaLabel;
								e && this.$(':input').attr('aria-label', e);
							},
							addInlineValidation: function () {
								a.default.result(this.options, 'inlineValidation') &&
									this.$el.on('focusout', ':input', a.default.bind(this.validate, this));
							},
							toModelValue: function () {
								var e = this.val();
								return (
									a.default.isFunction(this.to) && (e = this.to.call(this, e)),
									a.default.isFunction(this.options.to) && (e = this.options.to.call(this, e)),
									e
								);
							},
							__getDependencyCalloutBtn: function (e) {
								var t = this,
									n = a.default.clone(e),
									r = n.click || function () {};
								return (
									(n.click = function () {
										(0, i.default)(window).one('focus.dependency', function () {
											t.__showInputDependencies();
										}),
											r.call(t);
									}),
									new (u.default.extend({ children: [s.default.create(n)] }))()
								);
							},
							getCalloutParent: function () {
								return this.$('input[value="' + this.getModelValue() + '"]').parent();
							},
							__getCalloutMsgContainer: function (e) {
								return u.default.extend({
									template: o.default.template({
										compiler: [8, '>= 4.3.0'],
										main: function (e, t, n, r, o) {
											var i,
												a =
													e.lookupProperty ||
													function (e, t) {
														if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
													};
											return (
												'<span class="o-form-explain">' +
												e.escapeExpression(
													'function' ==
														typeof (i =
															null != (i = a(n, 'msg') || (null != t ? a(t, 'msg') : t)) ? i : e.hooks.helperMissing)
														? i.call(null != t ? t : e.nullContext || {}, {
																name: 'msg',
																hash: {},
																data: o,
																loc: { start: { line: 1, column: 29 }, end: { line: 1, column: 36 } },
														  })
														: i
												) +
												'</span>'
											);
										},
										useData: !0,
									}),
									getTemplateData: function () {
										return { msg: e };
									},
								});
							},
							showCallout: function (e, t) {
								var n = a.default.clone(e);
								(n.className = 'dependency-callout'),
									n.btn && ((n.content = this.__getDependencyCalloutBtn(n.btn)), delete n.btn);
								var r = c.default.create(n);
								t || r.add(this.__getCalloutMsgContainer(l.default.localize('dependency.callout.msg', 'courage'))),
									this.getCalloutParent().append(r.render().el),
									'success' === n.type &&
										a.default.delay(function () {
											r.$el.fadeOut(800);
										}, 1e3);
							},
							removeCallout: function () {
								this.$el.find('.dependency-callout').remove();
							},
							__evaluateCalloutObject: function (e, t) {
								return e
									? {
											title: l.default.localize('dependency.action.completed', 'courage'),
											size: 'large',
											type: 'success',
									  }
									: {
											title: l.default.localize('dependency.action.required', 'courage', [t]),
											size: 'large',
											type: 'warning',
									  };
							},
							__handleDependency: function (e, t) {
								var n = this,
									r = a.default.isFunction(t)
										? t(e)
										: a.default.extend({}, t, n.__evaluateCalloutObject(e.resolved, t.title));
								n.removeCallout(), n.showCallout(r, e.resolved);
							},
							__showInputDependencies: function () {
								var e = this,
									t = e.options.deps[e.getModelValue()];
								t && a.default.isFunction(t.func)
									? t
											.func()
											.done(function (n) {
												e.__handleDependency({ resolved: !0, data: n }, t.callout);
											})
											.fail(function (n) {
												e.__handleDependency({ resolved: !1, data: n }, t.callout);
											})
									: e.removeCallout();
							},
							_isEdited: !1,
							hasIMESupport: !1,
							update: function (e) {
								var t, n;
								if (
									(!this._isEdited &&
										a.default.result(this.options, 'validateOnlyIfDirty') &&
										((this._isEdited = !0), this.addInlineValidation()),
									this.model.set(this.options.name, this.toModelValue()),
									this.options.deps && this.__showInputDependencies(),
									this.hasIMESupport &&
										null !== (t = window) &&
										void 0 !== t &&
										null !== (n = t.okta) &&
										void 0 !== n &&
										n.enableIMESupport)
								) {
									if (this.isComposing) return;
									e && d.default.isEnter(e) && this.model.trigger('form:save');
								}
							},
							isEditMode: function () {
								return (
									!a.default.result(this.options, 'readOnly') &&
									(!0 !== a.default.result(this.options, 'read') || !0 === this.model.get('__edit__'))
								);
							},
							render: function () {
								this.preRender();
								var e = this.options.params;
								return (
									(this.options.params = a.default.resultCtx(this.options, 'params', this)),
									this.isEditMode() ? (this.editMode(), this.applyEnabledState()) : this.readMode(),
									(this.options.params = e),
									this.addAriaLabel(),
									this.postRender(),
									this
								);
							},
							applyEnabledState: function () {
								a.default.resultCtx(this.options, 'disabled', this) ? this.disable() : this.enable();
							},
							validate: function () {
								if (
									!this.model.get('__pending__') &&
									this.isEditMode() &&
									a.default.isFunction(this.model.validateField)
								) {
									var e = this.model.validateField(this.options.name);
									e &&
										a.default.delay(
											function () {
												this.model.trigger('form:clear-error:' + this.options.name),
													this.model.trigger('invalid', this.model, e, !1);
											}.bind(this),
											100
										);
								}
							},
							addModelListeners: function () {
								this.listenTo(this.model, 'form:field-error', function (e) {
									this.options.name === e && this.__markError();
								}),
									this.listenTo(this.model, 'form:clear-errors change:' + this.options.name, this.__clearError),
									this.listenTo(this.model, 'form:clear-error:' + this.options.name, this.__clearError);
							},
							val: function () {
								throw new Error('val() is an abstract method');
							},
							focus: function () {
								throw new Error('focus() is an abstract method');
							},
							defaultValue: function () {
								return '';
							},
							editMode: function () {
								var e = a.default.extend({}, this.options, { value: this.getModelValue() });
								return this.$el.html(this.template(e)), this.options.multi && this.$el.removeClass('margin-r'), this;
							},
							readMode: function () {
								return (
									this.$el.text(this.getReadModeString()),
									this.$el.removeClass('error-field'),
									this.options.multi && this.$el.addClass('margin-r'),
									this
								);
							},
							getReadModeString: function () {
								var e = a.default.resultCtx(this.options, 'readModeString', this);
								return e || this.toStringValue();
							},
							getModelValue: function () {
								var e = this.model.get(this.options.name);
								return (
									a.default.isFunction(this.from) && (e = this.from.call(this, e)),
									a.default.isFunction(this.options.from) && (e = this.options.from.call(this, e)),
									e
								);
							},
							toStringValue: function () {
								var e = this.getModelValue();
								return (
									this.options.options && (e = this.options.options[e]),
									(Number.isInteger(e) || 'boolean' == typeof e) && (e = String(e)),
									e || this.defaultValue()
								);
							},
							resize: function () {
								this.model.trigger('form:resize');
							},
							disable: function () {
								this.$(':input').prop('disabled', !0);
							},
							enable: function () {
								this.$(':input').prop('disabled', !1);
							},
							changeType: function (e) {
								this.$(':input').prop('type', e), (this.options.type = e);
							},
							getNameString: function () {
								return a.default.isArray(this.options.name) ? this.options.name.join('-') : this.options.name;
							},
							getParams: function (e) {
								var t = e || this.options || {};
								return a.default.clone(a.default.resultCtx(t, 'params', this) || {});
							},
							getParam: function (e, t) {
								var n = a.default.resultCtx(this.getParams(), e, this);
								return a.default.isUndefined(n) ? t : n;
							},
							getParamOrAttribute: function (e) {
								return this.getParam(e) || a.default.result(this, e);
							},
							__markError: function () {
								this.$el.addClass('o-form-has-errors');
							},
							__clearError: function () {
								this.$el.removeClass('o-form-has-errors');
							},
						},
						p = u.default.extend(f);
					(t.default = p), (e.exports = t.default);
				},
				21990: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(45361)),
						i = r(n(57581)),
						a = o.default.extend({
							el: '<span class="o-form-toggle" data-type="header-btn"></span>',
							formTitle: '',
							modelEvents: { 'change:__edit__': 'toggle' },
							initialize: function () {
								this.addButton();
							},
							addButton: function () {
								this.model.get('__edit__')
									? this.add(i.default.createReadFormButton({ type: 'cancel' }))
									: this.add(
											i.default.createReadFormButton({
												type: 'edit',
												formTitle: this.formTitle,
												className: 'disable-in-read-only',
											})
									  );
							},
							toggle: function () {
								this.removeChildren(), this.addButton();
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				63301: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = r(n(45361)),
						a = r(n(57581)),
						s = {
							className: function () {
								return 'o-form-button-bar';
							},
							buttonOrder: ['previous', 'save', 'cancel'],
							initialize: function (e) {
								var t = this,
									n = {
										previous: { type: 'previous' },
										save: {
											type: 'save',
											text: o.default.resultCtx(e, 'save', this),
											id: o.default.resultCtx(e, 'saveId', this),
											className: o.default.resultCtx(e, 'saveClassName', this),
										},
										cancel: { type: 'cancel', text: o.default.resultCtx(e, 'cancel', this) },
									};
								this.__getButtonOrder(e).forEach(function (e) {
									t.addButton(n[e]);
								});
							},
							addButton: function (e, t) {
								return this.add(a.default.createButton(e), t);
							},
							__getButtonOrder: function (e) {
								var t = o.default.resultCtx(e, 'buttonOrder', this, this.buttonOrder),
									n = [];
								return (
									e.noSubmitButton && n.push('save'),
									e.noCancelButton && n.push('cancel'),
									e.hasPrevStep || n.push('previous'),
									o.default.without.apply(o.default, [t].concat(n))
								);
							},
						},
						l = i.default.extend(s);
					(t.default = l), (e.exports = t.default);
				},
				52078: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(96129)),
						i = r(n(28107)),
						a = r(n(33270)),
						s = r(n(88712)),
						l = 'name',
						u = '_enum_';
					function c(e) {
						return f(e)
							? i.default.reduce(
									e,
									function (e, t, n) {
										return (e[m(n)] = t.title), e;
									},
									{}
							  )
							: {};
					}
					function d(e) {
						return i.default.all(e, o.default.isPlainObject)
							? f(e)
								? e
								: (function (e) {
										var t = i.default.partial(i.default.has, i.default, l);
										if (i.default.all(e, t))
											return i.default
												.chain(e)
												.filter(function (e) {
													return o.default.isPlainObject(e) && i.default.has(e, l);
												})
												.map(function (e) {
													return { const: e, title: e.name };
												})
												.value();
										return p(e);
								  })(e)
							: p(e);
					}
					function f(e) {
						return (
							i.default.isArray(e) &&
							i.default.all(e, function (e) {
								return i.default.has(e, 'const') && i.default.has(e, 'title');
							})
						);
					}
					function p(e) {
						return i.default.map(e, function (e) {
							return { const: e, title: h(e) };
						});
					}
					function h(e) {
						return i.default.isObject(e) ? JSON.stringify(e) : i.default.isNumber(e) ? e + '' : e;
					}
					function m(e) {
						return ''.concat(u).concat(e);
					}
					function v(e) {
						var t = i.default.findIndex(this.options.params.enumOneOf, function (t) {
							return i.default.isObject(e) ? i.default.isEqual(t.const, e) : t.const === e;
						});
						return t > -1 ? m(t) : e;
					}
					function g(e) {
						if (!i.default.isString(e) || 0 !== e.indexOf(u)) return e;
						var t = e.replace(u, ''),
							n =
								this.options.params && i.default.isArray(this.options.params.enumOneOf)
									? this.options.params.enumOneOf[t]
									: null;
						return i.default.has(n, 'const') ? n.const : n;
					}
					function y(e) {
						return i.default.map(e, g.bind(this));
					}
					function b(e) {
						return i.default.map(e, v.bind(this));
					}
					var _ = {
						getEnumInputOptions: function (e) {
							var t = d(e.enumValues),
								n = {
									name: e.name,
									label: e.title,
									readOnly: e.readOnly,
									customExplain: e.explain,
									params: { enumOneOf: t },
									options: c(t),
								};
							return (
								a.default.isArrayDataType(e.displayType)
									? ((n.type = 'checkboxset'), (n.to = y), (n.from = b))
									: ((n.type = 'select'), (n.to = g), (n.from = v)),
								(n.input = null),
								n
							);
						},
						getDropdownOptions: function (e) {
							return i.default.isArray(e) ? c(d(e)) : {};
						},
						convertToOneOf: d,
						isConstraintValueMatchType: function (e, t) {
							switch (t) {
								case a.default.STRING:
									return (function (e) {
										return i.default.isString(e);
									})(e);
								case a.default.NUMBER:
									return (function (e) {
										return i.default.isNumber(e) || i.default.isNumber(s.default.parseFloat(o.default.trim(e)));
									})(e);
								case a.default.INTEGER:
									return (function (e) {
										var t = i.default.isNumber(e) ? e : s.default.parseInt(o.default.trim(e));
										return 'number' == typeof t && isFinite(t) && Math.floor(t) === t;
									})(e);
								case a.default.OBJECT:
									return (function (e) {
										if (i.default.isObject(e) && !i.default.isArray(e)) return !0;
										var t = s.default.parseObject(o.default.trim(e));
										return i.default.isObject(t) && !i.default.isArray(t);
									})(e);
							}
						},
					};
					(t.default = _), (e.exports = t.default);
				},
				44995: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = r(n(45361)).default.extend({
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p>' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'errorSummary') || (null != t ? a(t, 'errorSummary') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'errorSummary',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 130 }, end: { line: 1, column: 146 } },
												  })
												: i
										) +
										'</p>'
									);
								},
								3: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<p>' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'courage', code: 'oform.errorbanner.title' },
													data: o,
													loc: { start: { line: 1, column: 161 }, end: { line: 1, column: 217 } },
												}
											)
										) +
										'</p>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="okta-form-infobox-error infobox infobox-error" role="alert"><span class="icon error-16"></span>' +
										(null !=
										(i = a(n, 'if').call(null != t ? t : e.nullContext || {}, null != t ? a(t, 'errorSummary') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.program(3, o, 0),
											data: o,
											loc: { start: { line: 1, column: 107 }, end: { line: 1, column: 228 } },
										}))
											? i
											: '') +
										'</div>'
									);
								},
								useData: !0,
							}),
							modelEvents: { 'form:clear-errors': 'remove' },
						});
					(t.default = i), (e.exports = t.default);
				},
				52930: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = r(n(88712)),
						a = /^([\S]+): (.+)$/,
						s = {
							getResponseJSON: function (e) {
								try {
									return e.responseJSON || JSON.parse(e.responseText);
								} catch (e) {}
							},
							parseErrorSummary: function (e) {
								var t = e.match(a);
								if (t) return [t[1], t[2]];
							},
							parseErrorCauseObject: function (e) {
								if (e.property && e.errorSummary) {
									var t = e.reason ? i.default.localize(e.reason) : void 0,
										n = e.errorSummary;
									return [e.property, -1 === (null == t ? void 0 : t.indexOf('L10N_ERROR[')) ? t : n];
								}
							},
							parseErrors: function (e) {
								var t = this.getResponseJSON(e);
								return o.default.map((t && t.errorCauses) || [], function (e) {
									return ('' + e.errorSummary).replace(a, '$2');
								});
							},
							parseFieldErrors: function (e) {
								var t = this.getResponseJSON(e),
									n = {};
								return (
									t
										? o.default.each(
												t.errorCauses || [],
												function (e) {
													var t = [];
													if (
														(t =
															e.property && e.errorSummary
																? this.parseErrorCauseObject(e)
																: e.location && e.errorSummary
																? [e.location, e.errorSummary]
																: this.parseErrorSummary((e && e.errorSummary) || ''))
													) {
														var r = t[0],
															o = t[1];
														n[r] || (n[r] = []), n[r].push(o);
													}
												},
												this
										  )
										: o.default.isObject(e) &&
										  o.default.size(e) &&
										  o.default.each(e, function (e, t) {
												n[t] = [e];
										  }),
									o.default.size(n) ? n : void 0
								);
							},
						};
					(t.default = s), (e.exports = t.default);
				},
				57581: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(31752)),
						i = r(n(28107)),
						a = r(n(83365)),
						s = r(n(77861)),
						l = r(n(88712)),
						u = r(n(50808)),
						c = r(n(45361)),
						d = ['model', 'id', 'inputId', 'type', 'label', 'sublabel', 'tooltip', 'name', 'group'],
						f = [
							'wide',
							'multi',
							'input',
							'label-top',
							'explain',
							'explain-top',
							'customExplain',
							'model',
							'name',
							'type',
							'autoRender',
							'multirowError',
						],
						p = [
							'model',
							'name',
							'label-top',
							'readOnly',
							'events',
							'initialize',
							'showWhen',
							'bindings',
							'render',
							'className',
							'data-se',
							'toggleWhen',
							'group',
						],
						h = [
							'model',
							'name',
							'inputId',
							'type',
							'input',
							'placeholder',
							'label',
							'readOnly',
							'read',
							'disabled',
							'readModeString',
							'options',
							'deps',
							'from',
							'to',
							'autoRender',
							'inlineValidation',
							'validateOnlyIfDirty',
							'ariaLabel',
							'params',
							'autoComplete',
							'sortByKey',
						],
						m = i.default.uniq(i.default.union(d, f, p, h, ['errorField'])),
						v = [
							'â€¢         ',
							'â€¢  â€¢      ',
							'â€¢  â€¢  â€¢   ',
							'â€¢  â€¢  â€¢  â€¢',
							'   â€¢  â€¢  â€¢',
							'      â€¢  â€¢',
							'         â€¢',
							'          ',
							'          ',
							'          ',
						];
					function g(e) {
						if (e && !e.__edit__) return i.default.extend({ __edit__: i.default.constant(!0) }, e);
					}
					var y = {
						LABEL_OPTIONS: d,
						CONTAINER_OPTIONS: f,
						WRAPPER_OPTIONS: p,
						INPUT_OPTIONS: h,
						generateInputOptions: function e(t, n, r) {
							(t = i.default.clone(t)),
								i.default.contains(['list', 'group'], t.type) &&
									((t.params = i.default.defaults(
										{
											create: r,
											inputs: i.default.map(i.default.isArray(t.input) ? t.input : [t.input], function (t) {
												return i.default.first(e(t, n, r));
											}),
										},
										t.params || {}
									)),
									delete t.input);
							var o = i.default.isArray(t.input) ? i.default.clone(t.input) : [t];
							return i.default.map(o, function (e) {
								var r = i.default.defaults({ model: n.model }, e, i.default.omit(t, 'input', 'inputs'), n.options, {
									id: i.default.uniqueId('input'),
									readOnly: n.isReadOnly(),
									read: n.hasReadMode(),
								});
								return n.isReadOnly() && (r.read = r.readOnly = !0), r;
							});
						},
						changeEventString: function (e) {
							return 'change:' + e.join(' change:');
						},
						createReadFormButton: function (e) {
							var t, n, r;
							return (
								'cancel' === e.type
									? ((n = r = l.default.localize('oform.cancel', 'courage')),
									  (t = function () {
											this.model.trigger('form:cancel');
									  }))
									: ((r = (n = l.default.localize('oform.edit', 'courage')) + ' ' + e.formTitle),
									  (t = function () {
											this.model.set('__edit__', !0);
									  })),
								c.default.extend({
									tagName: 'a',
									className: e.className,
									attributes: { 'href': '#', 'aria-label': r },
									template: function () {
										return i.default.escape(n);
									},
									events: {
										click: function (e) {
											e.preventDefault(), t.call(this);
										},
									},
								})
							);
						},
						createButton: function (e) {
							switch ((e = i.default.clone(e)).type) {
								case 'save':
									i.default.defaults(e, { className: 'button-primary' });
									break;
								case 'cancel':
									i.default.defaults(e, {
										className: 'button-clear',
										text: l.default.localize('oform.cancel', 'courage'),
										action: function () {
											this.model.trigger('form:cancel');
										},
									});
									break;
								case 'previous':
									i.default.defaults(e, {
										text: l.default.localize('oform.previous', 'courage'),
										action: function () {
											this.model.trigger('form:previous');
										},
									});
							}
							return (function (e) {
								var t, n, r;
								return (
									(e = i.default.pick(e || {}, 'action', 'id', 'className', 'text', 'type')),
									c.default.extend({
										tagName: 'input',
										className: 'button',
										events: {
											click: function () {
												e.action && !this.disabled() && e.action.call(this);
											},
											keyup: function (t) {
												a.default.isEnter(t) && e.action && !this.disabled() && e.action.call(this);
											},
										},
										disabled: function () {
											return !0 === this.$el.prop('disabled');
										},
										disable: function () {
											this.$el.prop('disabled', !0), this.$el.addClass('btn-disabled');
										},
										enable: function () {
											this.$el.prop('disabled', !1), this.$el.removeClass('btn-disabled');
										},
										initialize: function () {
											var r = this;
											this.$el.attr('type', 'save' === e.type ? 'submit' : 'button'),
												this.$el.val(e.text),
												e.id && this.$el.attr('id', e.id),
												e.className && this.$el.addClass(e.className),
												e.type && this.$el.attr('data-type', e.type),
												this.$el.mousedown(function () {
													r.model.set('__pending__', !0);
												}),
												this.$el.mouseup(function () {
													r.model.set('__pending__', !1);
												}),
												this.listenTo(this.model, 'form:set-saving-state', function () {
													this.disable(),
														'save' === e.type &&
															(clearTimeout(t), (t = setTimeout(i.default.bind(this.__changeSaveText, this), 1e3)));
												}),
												this.listenTo(this.model, 'form:clear-saving-state', function () {
													this.enable(), 'save' === e.type && (clearTimeout(t), clearInterval(n), this.$el.val(e.text));
												});
										},
										__changeSaveText: function () {
											(r = 0), clearInterval(n), (n = setInterval(i.default.bind(this.__showLoadingText, this), 200));
										},
										__showLoadingText: function () {
											this.$el.val(v[r++ % v.length]);
										},
									})
								);
							})(e);
						},
						validateInput: function e(t, n) {
							if ((t || (t = {}), 'label' !== t.type)) {
								if ('button' === t.type)
									return (
										t.title ||
											t.icon ||
											s.default.warn('A button input must have a "title" and/or an "icon" parameter', t),
										void (
											t.click ||
											t.href ||
											s.default.warn('A button input must have a "click" and/or an "href" parameter', t)
										)
									);
								if (
									(t.name || t.input || s.default.warn('Missing "name" or "input" parameters', t),
									i.default.isArray(t.name) && i.default.isArray(t.input))
								)
									throw new Error('Not allowed to have both "name" and "input" defined as array.');
								if ('list' !== t.type && t.name && n && n.allows) {
									var r = [];
									i.default.isArray(t.name) ? (r = t.name) : r.push(t.name),
										i.default.each(r, function (e) {
											if (!n.allows(e)) throw new Error('field not allowed: ' + t.name);
										});
								}
								i.default.isArray(t.input) &&
									'list' !== t.type &&
									i.default.each(t.input, function (t) {
										e(t, n);
									});
								var a = i.default.keys(t),
									l = i.default.intersection(a, m);
								if (i.default.size(l) !== i.default.size(t)) {
									var u = i.default.clone(m);
									s.default.warn(
										'Invalid input parameters',
										i.default.without.apply(i.default, [a].concat((0, o.default)(u))),
										t
									);
								}
							} else t.label || s.default.warn('A label input must have a "label" parameter', t);
						},
						applyShowWhen: function (e, t) {
							u.default.applyDoWhen(e, g(t), function (t, n) {
								n.animate
									? e.$el['slide' + (t ? 'Down' : 'Up')](
											200,
											(function (t) {
												return function () {
													e.$el.toggle(t), e.model.trigger('form:resize');
												};
											})(t)
									  )
									: e.$el.toggle(t);
							});
						},
						applyToggleWhen: function (e, t) {
							u.default.applyDoWhen(e, g(t), function (t, n) {
								e.$el.toggle(t), e.model.trigger('form:resize'), n.animate && e.render();
							});
						},
					};
					(t.default = y), (e.exports = t.default);
				},
				29752: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = r(n(28107)),
						s = r(n(77861)),
						l = r(n(51645)),
						u = r(n(88712)),
						c = r(n(45361)),
						d = l.default.isABaseView,
						f = c.default.extend({
							attributes: function () {
								return { 'data-se': 'o-form-input-container' };
							},
							className: function () {
								var e = 'o-form-input';
								(this.options.wide && (e += ' o-form-wide'), a.default.contains([1, 2, 3, 4], this.options.multi)) &&
									((e += ' o-form-multi-input-' + this.options.multi),
									a.default.isArray(this.options.input) &&
										a.default.find(this.options.input, function (e) {
											return a.default.contains(['text+select', 'select+text'], e.options.type);
										}) &&
										(e += ' o-form-multi-input-group-' + this.options.multi));
								return e;
							},
							_getNames: function () {
								var e = a.default.isArray(this.options.name) ? this.options.name : [this.options.name];
								return (
									'group' === this.options.type
										? e.push.apply(e, a.default.pluck(this.options.input[0].options.params.inputs, 'name'))
										: a.default.isArray(this.options.name)
										? this.options.input &&
										  this.options.input.options &&
										  this.options.input.options.name &&
										  e.push(this.options.input.options.name)
										: this.options.input &&
										  (a.default.isArray(this.options.input)
												? a.default.each(this.options.input, function (t) {
														e.push(t.options.name);
												  })
												: e.push(this.options.input.options.name)),
									a.default.uniq(a.default.compact(e))
								);
							},
							_getInputElement: function () {
								var e = Array.isArray(this.options.input) ? a.default.last(this.options.input) : this.options.input,
									t = e && e.options && e.options.inputId,
									n = t ? this.$('#' + t) : null;
								return n && n.length ? n : null;
							},
							constructor: function () {
								c.default.apply(this, arguments);
								var e = this.options['explain-top'] && this.options['label-top'];
								this.options.input &&
									(a.default.isArray(this.options.input)
										? a.default.each(
												this.options.input,
												function (t) {
													this.add(t, { prepend: !e });
												},
												this
										  )
										: this.add(this.options.input, { prepend: !e })),
									this.__setExplain(this.options);
								var t = this._getNames();
								this.listenTo(this.model, 'form:field-error', function (n, r) {
									a.default.contains(t, n) && this.__setError(r, e);
								}),
									this.listenTo(this.model, 'form:clear-errors change:' + t.join(' change:'), this.__clearError),
									this.listenTo(this.model, 'form:clear-error:' + t.join(' form:clear-error:'), this.__clearError),
									a.default.resultCtx(this.options, 'autoRender', this) &&
										this.listenTo(this.model, 'change:' + this.options.name, this.render),
									(this.__errorState = !1);
							},
							__setExplain: function (e) {
								var t;
								if (e.customExplain)
									return (
										s.default.warn('Deprecated - use explain instead of customExplain'),
										void this.add(this.options.customExplain)
									);
								(t = e.explain),
									a.default.isFunction(t) && !d(t) && (t = a.default.resultCtx(this.options, 'explain', this)),
									t &&
										(d(t)
											? ((this.template = i.default.template({
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, o) {
														return '<p class="o-form-explain"></p>';
													},
													useData: !0,
											  })),
											  this.add(t, ' > .o-form-explain'))
											: (this.template = i.default.template({
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, o) {
														var i,
															a =
																e.lookupProperty ||
																function (e, t) {
																	if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																};
														return (
															'<p class="o-form-explain">' +
															e.escapeExpression(
																'function' ==
																	typeof (i =
																		null != (i = a(n, 'explain') || (null != t ? a(t, 'explain') : t))
																			? i
																			: e.hooks.helperMissing)
																	? i.call(null != t ? t : e.nullContext || {}, {
																			name: 'explain',
																			hash: {},
																			data: o,
																			loc: { start: { line: 1, column: 26 }, end: { line: 1, column: 37 } },
																	  })
																	: i
															) +
															'</p>'
														);
													},
													useData: !0,
											  })));
							},
							__setError: function (e, t) {
								(this.__errorState = !0), this.$el.addClass('o-form-has-errors');
								var n = a.default.uniqueId('input-container-error'),
									r = this.__getHTMLForError(a.default.flatten(e), n),
									o = this.$('.o-form-explain').not('.o-form-input-error').first();
								o.length && !t ? o.before(r) : this.$el.append(r);
								var i = this._getInputElement() || this.$el;
								i.attr('aria-describedby', n), i.attr('aria-invalid', !0);
							},
							__getHTMLForError: function (e, t) {
								var n = i.default.template({
										compiler: [8, '>= 4.3.0'],
										main: function (e, t, n, r, i) {
											var a,
												s = null != t ? t : e.nullContext || {},
												l = e.hooks.helperMissing,
												u = 'function',
												c = e.escapeExpression,
												d =
													e.lookupProperty ||
													function (e, t) {
														if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
													};
											return (
												'<p id="' +
												c(
													((a = null != (a = d(n, 'errorId') || (null != t ? d(t, 'errorId') : t)) ? a : l),
													(0, o.default)(a) === u
														? a.call(s, {
																name: 'errorId',
																hash: {},
																data: i,
																loc: { start: { line: 1, column: 7 }, end: { line: 1, column: 18 } },
														  })
														: a)
												) +
												'" class="okta-form-input-error o-form-input-error o-form-explain" role="alert"><span class="icon icon-16 error-16-small" role="img" aria-label="' +
												c(
													((a = null != (a = d(n, 'iconLabel') || (null != t ? d(t, 'iconLabel') : t)) ? a : l),
													(0, o.default)(a) === u
														? a.call(s, {
																name: 'iconLabel',
																hash: {},
																data: i,
																loc: { start: { line: 1, column: 162 }, end: { line: 1, column: 175 } },
														  })
														: a)
												) +
												'"></span>' +
												c(
													((a = null != (a = d(n, 'text') || (null != t ? d(t, 'text') : t)) ? a : l),
													(0, o.default)(a) === u
														? a.call(s, {
																name: 'text',
																hash: {},
																data: i,
																loc: { start: { line: 1, column: 184 }, end: { line: 1, column: 192 } },
														  })
														: a)
												) +
												'</p>'
											);
										},
										useData: !0,
									}),
									r = u.default.localize('oform.error.icon.ariaLabel', 'courage');
								if (this.options.multirowError) {
									var a = '';
									return (
										e.forEach(function (e) {
											a += n({ errorId: t, iconLabel: r, text: e });
										}),
										a
									);
								}
								return n({ errorId: t, iconLabel: r, text: e.join(', ') });
							},
							__clearError: function () {
								var e = this;
								if (this.__errorState) {
									this.$('.o-form-input-error').remove();
									var t = this._getInputElement() || this.$el;
									t.attr('aria-describedby', null),
										t.attr('aria-invalid', null),
										this.$el.removeClass('o-form-has-errors'),
										(this.__errorState = !1),
										a.default.defer(function () {
											e.model.trigger('form:resize');
										});
								}
							},
							focus: function () {
								return (
									this.each(function (e) {
										if (e.focus) return e.focus();
									}),
									this
								);
							},
						});
					(t.default = f), (e.exports = t.default);
				},
				80685: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = r(n(66728));
					function a(e, t) {
						return i.default.isBaseInput(e) && e.prototype ? new e(o.default.omit(t, 'input')) : e;
					}
					var s = {
						create: function (e) {
							if ((e = o.default.clone(e)).input) return a(e.input, e);
							var t = i.default.get(e);
							if (!t) throw new Error('unknown input: ' + e.type);
							return a(t, e);
						},
						supports: function (e) {
							return !!e.input || !!i.default.get(e);
						},
					};
					(t.default = s), (e.exports = t.default);
				},
				3197: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = r(n(28107));
					n(48231);
					var s = r(n(45361)),
						l = s.default.extend({
							className: 'okta-form-label o-form-label',
							attributes: { 'data-se': 'o-form-label' },
							constructor: function (e) {
								a.default.defaults(e, { inputId: e.id }), delete e.id, s.default.apply(this, arguments);
							},
							template: i.default.template({
								1: function (e, t, n, r, o) {
									return '<legend>';
								},
								3: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<label for="' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'inputId') || (null != t ? a(t, 'inputId') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'inputId',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 61 }, end: { line: 1, column: 72 } },
												  })
												: i
										) +
										'"></label>'
									);
								},
								5: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'label') || (null != t ? a(t, 'label') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'label',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 116 }, end: { line: 1, column: 125 } },
											  })
											: i
									);
								},
								7: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<label for="' +
										c(
											((a = null != (a = d(n, 'inputId') || (null != t ? d(t, 'inputId') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'inputId',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 167 }, end: { line: 1, column: 178 } },
												  })
												: a)
										) +
										'">' +
										c(
											((a = null != (a = d(n, 'label') || (null != t ? d(t, 'label') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'label',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 180 }, end: { line: 1, column: 189 } },
												  })
												: a)
										) +
										'&nbsp;</label>'
									);
								},
								9: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<span class="o-form-explain">' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'sublabel') || (null != t ? a(t, 'sublabel') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'sublabel',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 256 }, end: { line: 1, column: 268 } },
												  })
												: i
										) +
										'</span>'
									);
								},
								11: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<span class="o-form-tooltip icon-16 icon-only form-help-16" title="' +
										e.escapeExpression(e.lambda(null != (i = null != t ? a(t, 'tooltip') : t) ? a(i, 'text') : i, t)) +
										'"></span>'
									);
								},
								13: function (e, t, n, r, o) {
									return '</legend>';
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'group') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 28 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, '_isLabelView') : t, {
											name: 'if',
											hash: {},
											fn: e.program(3, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 28 }, end: { line: 1, column: 89 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, '_isRadioOrCheckbox') : t, {
											name: 'if',
											hash: {},
											fn: e.program(5, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 89 }, end: { line: 1, column: 132 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, '_standardLabel') : t, {
											name: 'if',
											hash: {},
											fn: e.program(7, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 132 }, end: { line: 1, column: 210 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'sublabel') : t, {
											name: 'if',
											hash: {},
											fn: e.program(9, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 210 }, end: { line: 1, column: 282 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'tooltip') : t, {
											name: 'if',
											hash: {},
											fn: e.program(11, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 282 }, end: { line: 1, column: 397 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'group') : t, {
											name: 'if',
											hash: {},
											fn: e.program(13, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 397 }, end: { line: 1, column: 426 } },
										}))
											? i
											: '')
									);
								},
								useData: !0,
							}),
							getTemplateData: function () {
								var e = { label: '' };
								return (
									a.default.each(
										['inputId', 'label', 'sublabel', 'tooltip', 'group'],
										function (t) {
											e[t] = a.default.resultCtx(this.options, t, this);
										},
										this
									),
									this._isLabelView(e.label)
										? (e._isLabelView = !0)
										: a.default.contains(['radio', 'checkbox'], this.options.type) || !e.label
										? (e._isRadioOrCheckbox = !0)
										: (e._standardLabel = !0),
									e.tooltip && a.default.isString(e.tooltip) && (e.tooltip = { text: e.tooltip }),
									e
								);
							},
							_isLabelView: function (e) {
								return !a.default.isUndefined(e) && e instanceof s.default;
							},
							postRender: function () {
								var e = this.getTemplateData();
								this._isLabelView(e.label) && (this.removeChildren(), this.add(e.label, 'label')),
									e.tooltip &&
										this.$('.o-form-tooltip').qtip(
											a.default.extend(
												{
													style: { classes: 'qtip-custom qtip-shadow' },
													position: {
														my: window.okta && 'dstheme' === window.okta.theme ? 'bottom center' : 'bottom left',
														at: 'top center',
													},
													hide: { fixed: !0 },
													show: { delay: 0 },
												},
												e.tooltip.options
											)
										);
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				66728: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = {};
					function a(e) {
						return o.default.isFunction(e)
							? o.default.isFunction(e.prototype.editMode) && o.default.isFunction(e.prototype.readMode)
							: o.default.isObject(e) && o.default.isFunction(e.editMode) && o.default.isFunction(e.readMode);
					}
					var s = {
						isBaseInput: a,
						register: function (e, t) {
							i[e] = t;
						},
						get: function (e) {
							var t = i[e.type];
							return t && (a(t) ? t : t(e));
						},
						unregister: function (e) {
							delete i[e];
						},
					};
					(t.default = s), (e.exports = t.default);
				},
				34564: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = r(n(45361)),
						a = r(n(57581));
					function s(e, t) {
						e.apply(
							this,
							o.default.map(
								t.split(/\s+/),
								function (e) {
									return this.model.get(e);
								},
								this
							)
						);
					}
					function l(e, t) {
						o.default.isFunction(e) && e.call(t);
					}
					var u = i.default.extend({
						tagName: function () {
							return this.options.group ? 'fieldset' : 'div';
						},
						className: function () {
							var e = 'o-form-fieldset';
							return (
								this.options['label-top'] && (e += ' o-form-label-top'),
								this.options.readOnly && (e += ' o-form-read-mode'),
								e
							);
						},
						attributes: function () {
							return { 'data-se': this.options['data-se'] || 'o-form-fieldset' };
						},
						constructor: function (e) {
							e.className &&
								((this.inputWrapperClassName = this.className),
								(this.optionsClassName = e.className),
								(e.className = function () {
									return (
										o.default.result(this, 'inputWrapperClassName', '') +
										' ' +
										o.default.result(this, 'optionsClassName')
									);
								})),
								i.default.apply(this, arguments),
								o.default.each(
									e.events || {},
									function (e, t) {
										this.listenTo(this.model, t, e);
									},
									this
								),
								o.default.each(
									e.bindings || {},
									function (e, t) {
										this.listenTo(
											this.model,
											a.default.changeEventString(t.split(/\s+/)),
											o.default.bind(s, this, e, t)
										);
									},
									this
								),
								a.default.applyShowWhen(this, e.showWhen),
								a.default.applyToggleWhen(this, e.toggleWhen),
								l(e.initialize, this);
						},
						postRender: function () {
							o.default.each(this.options.bindings || {}, s, this), l(this.options.render, this);
						},
						getLabel: function () {
							return this.size() > 1 ? this.at(0) : null;
						},
						getInput: function () {
							return this.getInputContainer();
						},
						getInputContainer: function () {
							return this.at(this.size() > 1 ? 1 : 0);
						},
						getInputs: function () {
							return this.getInputContainer().toArray();
						},
						focus: function () {
							return this.getInput().focus();
						},
					});
					(t.default = u), (e.exports = t.default);
				},
				76906: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = r(n(88712)),
						a = r(n(80699)),
						s = r(n(35575)),
						l = r(n(52078));
					function u(e) {
						var t = i.default.parseFloat(e);
						return '' === e ? null : t;
					}
					function c(e) {
						return o.default.object(e, e);
					}
					function d(e) {
						var t = e.get('items');
						return t ? t.objectName : e.get('objectName');
					}
					function f(e, t, n) {
						var r,
							i = e.get('name'),
							a = n.__nestedProperty__,
							s = t[i],
							l = n.get(i);
						a && e.set('__fieldNamePrefix__', a);
						var u = t[d(e)];
						s && l && (s = o.default.union(s, l)),
							u && u.length ? (r = u) : s && s.length && (r = s),
							e.set('__possibleValues__', r);
					}
					function p(e, t, n) {
						return (
							e.each(function (e) {
								f(e, t, n);
							}),
							e
						);
					}
					function h(e, t) {
						return e.filter(function (e) {
							return (function (e, t) {
								var n = d(e),
									r = t[n];
								return !n || !(0, o.default)(r).isEmpty();
							})(e, t);
						});
					}
					var m = {
						createInputOptions: function (e) {
							var t = (function (e) {
									var t = {},
										n = e.get('name'),
										r = e.get('__displayType__'),
										i = e.get('__possibleValues__'),
										a = e.get('__fieldNamePrefix__');
									if ((a && ((t.name = a + n), (t.errorField = n)), e.isEnumType())) {
										var s = { displayType: r, title: e.get('title'), enumValues: e.getEnumValues() };
										t = o.default.extend({}, l.default.getEnumInputOptions(s), t);
									} else
										(function (e) {
											return e && e.indexOf('array') >= 0;
										})(r) &&
											i &&
											((t.type = 'checkboxset'), (t.input = null), (t.options = c(i)));
									return t;
								})(e),
								n = (function (e) {
									var t = e.get('__displayType__'),
										n = e.get('__possibleValues__'),
										r = e.get('name'),
										l = { type: 'text', name: r, label: e.get('title') || r };
									switch (t) {
										case 'arrayofstring':
											(l.input = s.default), (l.params = { itemType: 'string' });
											break;
										case 'arrayofnumber':
											(l.input = s.default), (l.params = { itemType: 'number' });
											break;
										case 'arrayofinteger':
											(l.input = s.default), (l.params = { itemType: 'integer' });
											break;
										case 'arrayofobject':
											(l.input = s.default), (l.params = { itemType: e.get('items').type });
											break;
										case 'arrayofref-id':
											(l.input = s.default), (l.params = { itemType: e.get('items').format });
											break;
										case 'boolean':
											l.input = a.default;
											break;
										case 'integer':
										case 'number':
											l.to = u;
											break;
										case 'reference':
											(l.type = 'select'), (l.options = c(n));
											break;
										case 'image':
											(l.readOnly = !0),
												(l.from = function (e) {
													return o.default.isEmpty(e)
														? ''
														: i.default.localize('user.profile.image.image_set', 'courage');
												});
											break;
										case 'password':
											l.type = 'password';
											break;
										case 'date':
											l.type = 'date';
											break;
										case 'uri':
										case 'country-code':
										case 'country_code':
										case 'language-code':
										case 'language_code':
										case 'email':
										case 'locale':
										case 'timezone':
										case 'string':
										case 'object':
											break;
										default:
											throw new Error('unknown type: '.concat(t));
									}
									return l;
								})(e);
							return (
								t.params && n.params && (t.params = o.default.defaults(t.params, n.params)), o.default.defaults(t, n)
							);
						},
						hasValidSchemaProps: function (e, t) {
							return !o.default.isEmpty(e) && !!h(e, t).length;
						},
						prepareSchema: function (e, t, n) {
							return e.reset(h(e, t)), p(e, t, n);
						},
						augmentSchemaProps: p,
						augmentSchemaProp: f,
					};
					(t.default = m), (e.exports = t.default);
				},
				80699: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(84983)),
						i = { undefined: 'undefined', true: 'true', false: 'false' },
						a = function (e) {
							return e ? 'true' : !1 === e ? 'false' : 'undefined';
						},
						s = function (e) {
							switch (e) {
								case 'undefined':
								default:
									return null;
								case 'true':
									return !0;
								case 'false':
									return !1;
							}
						},
						l = o.default.extend({
							initialize: function () {
								(this.options.options = i), (this.options.from = a), (this.options.to = s);
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				37002: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = r(n(28107)),
						s = r(n(83365));
					n(1303);
					var l = r(n(15982)).default.extend({
						template: i.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, i) {
								var a,
									s = null != t ? t : e.nullContext || {},
									l = e.hooks.helperMissing,
									u = 'function',
									c = e.escapeExpression,
									d =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<input type="checkbox" name="' +
									c(
										((a = null != (a = d(n, 'name') || (null != t ? d(t, 'name') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'name',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 29 }, end: { line: 1, column: 37 } },
											  })
											: a)
									) +
									'" id="' +
									c(
										((a = null != (a = d(n, 'inputId') || (null != t ? d(t, 'inputId') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'inputId',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 43 }, end: { line: 1, column: 54 } },
											  })
											: a)
									) +
									'"/><label for="' +
									c(
										((a = null != (a = d(n, 'inputId') || (null != t ? d(t, 'inputId') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'inputId',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 69 }, end: { line: 1, column: 80 } },
											  })
											: a)
									) +
									'" data-se-for-name="' +
									c(
										((a = null != (a = d(n, 'name') || (null != t ? d(t, 'name') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'name',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 100 }, end: { line: 1, column: 108 } },
											  })
											: a)
									) +
									'">' +
									c(
										((a = null != (a = d(n, 'placeholder') || (null != t ? d(t, 'placeholder') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'placeholder',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 110 }, end: { line: 1, column: 125 } },
											  })
											: a)
									) +
									'</label>'
								);
							},
							useData: !0,
						}),
						events: {
							'change :checkbox': 'update',
							'keyup': function (e) {
								e.preventDefault(),
									s.default.isSpaceBar(e)
										? this.$(':checkbox').click()
										: s.default.isEnter(e) && this.model.trigger('form:save');
							},
						},
						editMode: function () {
							var e = a.default.resultCtx(this.options, 'placeholder', this);
							return (
								'' === e ? (e = a.default.resultCtx(this.options, 'label', this)) : !1 === e && (e = ''),
								this.$el.html(
									this.template(a.default.extend(a.default.omit(this.options, 'placeholder'), { placeholder: e }))
								),
								this.$(':checkbox').prop('checked', this.getModelValue() || !1),
								this.$('input').customInput(),
								this.model.trigger('form:resize'),
								this
							);
						},
						readMode: function () {
							return this.editMode(), this.$(':checkbox').prop('disabled', !0), this;
						},
						val: function () {
							return this.$(':checkbox').prop('checked');
						},
						focus: function () {
							return this.$(':checkbox').focus();
						},
					});
					(t.default = l), (e.exports = t.default);
				},
				90958: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = r(n(28107)),
						s = r(n(33270)),
						l = r(n(88712)),
						u = r(n(60196)),
						c = r(n(45361)),
						d = i.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, i) {
								var a,
									s = null != t ? t : e.nullContext || {},
									l = e.hooks.helperMissing,
									u = 'function',
									c = e.escapeExpression,
									d =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<div class="o-form-input-group-controls"><span class="input-fix o-form-control"><input type="text" class="o-form-text" name="' +
									c(
										((a = null != (a = d(n, 'key') || (null != t ? d(t, 'key') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'key',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 125 }, end: { line: 1, column: 132 } },
											  })
											: a)
									) +
									'" id="' +
									c(
										((a = null != (a = d(n, 'key') || (null != t ? d(t, 'key') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'key',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 138 }, end: { line: 1, column: 145 } },
											  })
											: a)
									) +
									'" value="' +
									c(
										((a = null != (a = d(n, 'value') || (null != t ? d(t, 'value') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'value',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 154 }, end: { line: 1, column: 163 } },
											  })
											: a)
									) +
									'" placeholder="' +
									c(
										((a = null != (a = d(n, 'placeholder') || (null != t ? d(t, 'placeholder') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'placeholder',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 178 }, end: { line: 1, column: 193 } },
											  })
											: a)
									) +
									'"/></span><a href="#" class="link-button link-button-icon icon-only"><span class="icon clear-input-16 "></span></a></div><p class="o-form-input-error o-form-explain"><span class="icon icon-16 error-16-small"></span>' +
									c(
										((a = null != (a = d(n, 'errorExplain') || (null != t ? d(t, 'errorExplain') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'errorExplain',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 408 }, end: { line: 1, column: 424 } },
											  })
											: a)
									) +
									'</p>'
								);
							},
							useData: !0,
						}),
						f = 'o-form-has-errors',
						p = 'updateArray',
						h = c.default.extend({
							tagName: 'div',
							className: 'o-form-input-group',
							events: {
								'click a': function (e) {
									e.preventDefault(), this.remove();
								},
								'keyup input': function () {
									this.update();
								},
							},
							isEditMode: function () {
								return !this.options.readOnly && (!0 !== this.options.read || !0 === this.model.get('__edit__'));
							},
							initialize: function () {
								(this.template = d(
									a.default.extend(this.options, {
										placeholder: this.getPlaceholderText(),
										errorExplain: this.getErrorExplainText(),
									})
								)),
									(this.update = a.default.debounce(
										this.update,
										this.options.debounceDelay || u.default.DEBOUNCE_DELAY
									));
							},
							render: function () {
								return (
									this.isEditMode()
										? this.$el.html(this.template)
										: (this.$el.text(this.options.value), this.$('a').hide()),
									this
								);
							},
							remove: function () {
								var e = arguments,
									t = this;
								this.trigger(p, null),
									this.$el.slideUp(function () {
										c.default.prototype.remove.call(t, e);
									});
							},
							update: function () {
								var e = this.$('input').val(),
									t = a.default.object(
										[s.default.DATATYPE.number, s.default.DATATYPE.integer],
										[l.default.parseFloat, this.parseInt]
									);
								a.default.has(t, this.options.itemType) &&
									((e = t[this.options.itemType](e)), a.default.isNumber(e) ? this.clearInvalid() : this.markInvalid()),
									this.trigger(p, e);
							},
							markInvalid: function () {
								this.$el.addClass(f);
							},
							clearInvalid: function () {
								this.$el.removeClass(f);
							},
							getPlaceholderText: function () {
								var e;
								switch (this.options.itemType.toLowerCase()) {
									case 'string':
										e = l.default.localize('placeholder.text.string', 'courage');
										break;
									case 'number':
										e = l.default.localize('placeholder.text.number', 'courage');
										break;
									case 'integer':
										e = l.default.localize('placeholder.text.integer', 'courage');
										break;
									default:
										e = '';
								}
								return e;
							},
							getErrorExplainText: function () {
								var e;
								switch (this.options.itemType.toLowerCase()) {
									case 'string':
										e = l.default.localize('string.item.type.error.message', 'courage');
										break;
									case 'number':
										e = l.default.localize('number.item.type.error.message', 'courage');
										break;
									case 'integer':
										e = l.default.localize('integer.item.type.error.message', 'courage');
										break;
									default:
										e = '';
								}
								return e;
							},
							parseInt: (function (e) {
								function t(t) {
									return e.apply(this, arguments);
								}
								return (
									(t.toString = function () {
										return e.toString();
									}),
									t
								);
							})(function (e) {
								if (/^-?\d+$/.test(e)) {
									var t = parseInt(e, 10);
									return a.default.isNaN(t) ? e : t;
								}
								return e;
							}),
						});
					(t.default = h), (e.exports = t.default);
				},
				59924: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(28107)),
						i = r(n(2431)),
						a = r(n(45361)),
						s = r(n(15982));
					var l = s.default.extend({
						tagName: 'span',
						initialize: function () {
							this.$el.text(this.getModelValue());
						},
						editMode: function () {
							this.toggle(!0);
						},
						readMode: function () {
							this.toggle(!1);
						},
						getModelValue: function () {
							return this.options.label;
						},
						toggle: function (e) {
							this.$el.toggleClass('o-form-label-inline', e), this.$el.toggleClass('o-form-control', !e);
						},
						focus: o.default.noop,
					});
					var u = a.default.extend({
							getParams: s.default.prototype.getParams,
							getParam: s.default.prototype.getParam,
							className: function () {
								var e, t;
								return this.getParam('noBaseClasses')
									? ''
									: ((e = 'text' === this.getParam('display') ? 'o-form-input-group-subtle' : 'o-form-input-group'),
									  (t = this.getParam('inputs')),
									  o.default.filter(t || [], function (e) {
											return !o.default.contains(['label', 'button', 'select'], e.type);
									  }).length > 1 && (e += ' o-form-input-group-2'),
									  e);
							},
							initialize: function () {
								o.default.each(
									this.getParam('inputs'),
									function (e) {
										switch (e.type) {
											case 'label':
												this.add(l, { options: e });
												break;
											case 'button':
												this.add(
													((t = e),
													i.default.create(
														o.default.defaults(
															{ getReadModeString: o.default.constant(' '), focus: o.default.noop },
															o.default.pick(t, 'click', 'title', 'href', 'icon')
														)
													))
												);
												break;
											default:
												(e = o.default.defaults(
													{ model: this.model, params: o.default.extend({ autoWidth: !0 }, e.params || {}) },
													e
												)),
													this.add(this.getParams().create(e));
										}
										var t;
									},
									this
								);
							},
							focus: function () {
								this.first().focus();
							},
						}),
						c = s.default.extend(
							{
								constructor: function (e) {
									(this.inputGroupView = new u(e)), s.default.apply(this, arguments);
								},
								editMode: function () {
									this.inputGroupView.remove(),
										(this.inputGroupView = new u(this.options)),
										this.$el.html(this.inputGroupView.render().el);
								},
								readMode: function () {
									this.getParam('useChildInputsReadMode')
										? this.editMode()
										: s.default.prototype.readMode.apply(this, arguments);
								},
								toStringValue: function () {
									var e = this.inputGroupView.map(function (e) {
										return e.getReadModeString();
									});
									return e.length && o.default.every(e) ? e.join(' ') : ' ';
								},
								focus: function () {
									this.inputGroupView.focus();
								},
							},
							{ LabelInput: l, InputGroupView: u }
						);
					(t.default = c), (e.exports = t.default);
				},
				18329: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = r(n(28107)),
						a = r(n(69407)),
						s = o.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								return '<span class="password-toggle"><span class="eyeicon visibility-16 button-show"></span><span class="eyeicon visibility-off-16 button-hide"></span></span>';
							},
							useData: !0,
						}),
						l = a.default.extend({
							initialize: function () {
								this.__showPasswordToggle() &&
									((this.events['click .password-toggle .button-show'] = '__showPassword'),
									(this.events['click .password-toggle .button-hide'] = '__hidePassword')),
									this.delegateEvents();
							},
							postRender: function () {
								this.isEditMode() &&
									this.__showPasswordToggle() &&
									(this.$el.append(s), this.$el.find('input[type="password"]').addClass('password-with-toggle')),
									a.default.prototype.postRender.apply(this, arguments);
							},
							val: function () {
								return this.$('input[type="' + this.options.type + '"]').val();
							},
							__showPasswordToggle: function () {
								return this.options.params && this.options.params.showPasswordToggle;
							},
							__showPassword: function () {
								var e = this;
								this.$('input').attr('spellcheck', !1),
									a.default.prototype.changeType.apply(this, ['text']),
									this.$('.password-toggle .button-show').hide(),
									this.$('.password-toggle .button-hide').show(),
									(this.passwordToggleTimer = i.default.delay(function () {
										e.__hidePassword();
									}, 3e4));
							},
							__hidePassword: function () {
								a.default.prototype.changeType.apply(this, ['password']),
									this.$('.password-toggle .button-show').show(),
									this.$('.password-toggle .button-hide').hide(),
									this.passwordToggleTimer && clearTimeout(this.passwordToggleTimer);
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				63984: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = r(n(96129)),
						s = r(n(28107)),
						l = r(n(83365)),
						u = r(n(51645)),
						c = r(n(45361));
					n(1303);
					var d = r(n(15982)),
						f = u.default.isABaseView,
						p = c.default.extend({
							template: i.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<input type="radio" name="' +
										c(
											((a = null != (a = d(n, 'name') || (null != t ? d(t, 'name') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'name',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 26 }, end: { line: 1, column: 34 } },
												  })
												: a)
										) +
										'" data-se-name="' +
										c(
											((a = null != (a = d(n, 'realName') || (null != t ? d(t, 'realName') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'realName',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 50 }, end: { line: 1, column: 62 } },
												  })
												: a)
										) +
										'" value="' +
										c(
											((a = null != (a = d(n, 'value') || (null != t ? d(t, 'value') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'value',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 71 }, end: { line: 1, column: 80 } },
												  })
												: a)
										) +
										'" id="' +
										c(
											((a = null != (a = d(n, 'optionId') || (null != t ? d(t, 'optionId') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'optionId',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 86 }, end: { line: 1, column: 98 } },
												  })
												: a)
										) +
										'"><label for="' +
										c(
											((a = null != (a = d(n, 'optionId') || (null != t ? d(t, 'optionId') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'optionId',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 112 }, end: { line: 1, column: 124 } },
												  })
												: a)
										) +
										'" data-se-for-name="' +
										c(
											((a = null != (a = d(n, 'realName') || (null != t ? d(t, 'realName') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'realName',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 144 }, end: { line: 1, column: 156 } },
												  })
												: a)
										) +
										'" class="radio-label">' +
										c(
											((a = null != (a = d(n, 'label') || (null != t ? d(t, 'label') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'label',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 178 }, end: { line: 1, column: 187 } },
												  })
												: a)
										) +
										'</label>'
									);
								},
								useData: !0,
							}),
							initialize: function (e) {
								var t;
								(t = e.explain),
									s.default.isFunction(t) && !f(t) && (t = s.default.resultCtx(this.options, 'explain', this)),
									t &&
										(f(t)
											? (this.add('<p class="o-form-explain"></p>', '.radio-label'), this.add(t, '.o-form-explain'))
											: this.add(
													c.default.extend({
														className: 'o-form-explain',
														tagName: 'p',
														template: i.default.template({
															compiler: [8, '>= 4.3.0'],
															main: function (e, t, n, r, o) {
																var i,
																	a =
																		e.lookupProperty ||
																		function (e, t) {
																			if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																		};
																return e.escapeExpression(
																	'function' ==
																		typeof (i =
																			null != (i = a(n, 'explain') || (null != t ? a(t, 'explain') : t))
																				? i
																				: e.hooks.helperMissing)
																		? i.call(null != t ? t : e.nullContext || {}, {
																				name: 'explain',
																				hash: {},
																				data: o,
																				loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 11 } },
																		  })
																		: i
																);
															},
															useData: !0,
														}),
													}),
													'.radio-label'
											  ));
							},
						}),
						h = d.default.extend({
							events: {
								'change :radio': 'update',
								'keyup': function (e) {
									l.default.isSpaceBar(e)
										? (0, a.default)(e.target).click()
										: l.default.isEnter(e) && this.model.trigger('form:save');
								},
							},
							editMode: function () {
								var e = [];
								this.$el.empty(),
									s.default.each(
										this.options.options,
										function (t, n) {
											var r = {
												optionId: s.default.uniqueId('option'),
												name: this.options.inputId,
												realName: this.options.name,
												value: n,
											};
											s.default.isObject(t) || (t = { label: t }), s.default.extend(r, t), e.push(new p(r).render().el);
										},
										this
									),
									this.$el.append(e);
								var t = this.getModelValue();
								return (
									t && this.$(':radio[value=' + t + ']').prop('checked', !0),
									this.$('input').customInput(),
									this.model.trigger('form:resize'),
									!0 === this.getParam('inline') && this.$('div.custom-radio').addClass('inline'),
									this
								);
							},
							readMode: function () {
								return this.editMode(), this.$(':radio').prop('disabled', !0), this;
							},
							val: function () {
								return this.$(':radio:checked').val();
							},
							focus: function () {
								return this.$('label:eq(0)').focus();
							},
						});
					(t.default = h), (e.exports = t.default);
				},
				84983: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = r(n(96129)),
						s = r(n(28107)),
						l = r(n(83365));
					n(55198);
					var u = r(n(15982)),
						c = r(n(51645)),
						d = r(n(88712)),
						f = i.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, i) {
								var a,
									s = null != t ? t : e.nullContext || {},
									l = e.hooks.helperMissing,
									u = 'function',
									c = e.escapeExpression,
									d =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<select id="' +
									c(
										((a = null != (a = d(n, 'inputId') || (null != t ? d(t, 'inputId') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'inputId',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 12 }, end: { line: 1, column: 23 } },
											  })
											: a)
									) +
									'" name="' +
									c(
										((a = null != (a = d(n, 'name') || (null != t ? d(t, 'name') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'name',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 31 }, end: { line: 1, column: 39 } },
											  })
											: a)
									) +
									'"></select>'
								);
							},
							useData: !0,
						}),
						p = i.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, i) {
								var a,
									s = null != t ? t : e.nullContext || {},
									l = e.hooks.helperMissing,
									u = 'function',
									c = e.escapeExpression,
									d =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<option value="' +
									c(
										((a = null != (a = d(n, 'key') || (null != t ? d(t, 'key') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'key',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 15 }, end: { line: 1, column: 22 } },
											  })
											: a)
									) +
									'">' +
									c(
										((a = null != (a = d(n, 'value') || (null != t ? d(t, 'value') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'value',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 24 }, end: { line: 1, column: 33 } },
											  })
											: a)
									) +
									'</option>'
								);
							},
							useData: !0,
						}),
						h = c.default.isSafari;
					function m(e) {
						return this.params.autoWidth ? e.call(this) : s.default.defer(s.default.bind(e, this));
					}
					function v(e, t, n) {
						var r = n.offset();
						e.css({ left: r.left, top: r.top });
						var o = (0, a.default)(window),
							i = t.outerHeight(),
							s = i + t.offset().top - o.scrollTop(),
							l = o.height() - 20,
							u = Math.min(i + l - s, 240);
						t.css('max-height', u);
					}
					function g(e, t) {
						var n = e.next('.chzn-container'),
							r = n.clone(),
							o = n.find('.chzn-results'),
							i = n.find('.chzn-search input[type=text]');
						i.on('keyup', function () {
							!(function (e, t, n) {
								var r = n.find('.active-result.highlighted');
								if (
									(t.find('#' + e.attr('id') + '_txt').attr('aria-activedescendant', r.attr('id')),
									n.find('[aria-selected=true]').attr('aria-selected', 'false'),
									r.attr('aria-selected', 'true'),
									h())
								) {
									var o = d.default.localize('oform.selectInput.country', 'courage', [r.text()]),
										i = e.attr('id');
									'' !== o && (0, a.default)('#'.concat(i, '_aria_div_id')).text(o);
								}
								var s = n.find('li.no-results');
								s.length && s.attr('role', 'alert');
							})(e, n, o);
						}),
							n.addClass('closed'),
							r.css('visibility', 'hidden'),
							r.removeAttr('id'),
							r.find('li').removeAttr('id');
						var l = {
							'left': n.css('left'),
							'top': n.css('top'),
							'position': n.css('position'),
							'float': n.css('float'),
							'z-index': n.css('z-index'),
						};
						o.hide();
						var u = s.default.debounce(function () {
							v(n, o, r);
						}, 10);
						e.off('.fixChosen'),
							e.on('liszt:showing_dropdown.fixChosen', function () {
								n.width(n.width()),
									e.after(r),
									n.css({ 'position': 'absolute', 'float': 'none', 'z-index': 5e4, 'top': -999999 }),
									(0, a.default)('body').append(n),
									(0, a.default)('.chzn-search > :text').prop('placeholder', t),
									o.show(),
									v(n, o, r),
									e.parents().scroll(u),
									(0, a.default)(window).on('resize scroll', u);
							}),
							e.on('liszt:showing_dropdown', function () {
								n.removeClass('closed');
							}),
							e.on('liszt:hiding_dropdown.fixChosen remove.fixChosen', function () {
								e.parents().off('scroll', u),
									(0, a.default)(window).off('resize scroll', u),
									n.css(l),
									o.hide(),
									n.addClass('closed'),
									o.css('max-height', 240),
									r.remove(),
									e.after(n);
							}),
							e.on('liszt:hiding_dropdown.fixChosen', function () {
								i.focus();
							});
					}
					var y = u.default.extend({
						className: 'o-form-select',
						events: {
							'change select': 'update',
							'keyup .chzn-search > :text': function (e) {
								l.default.isEsc(e) && (this.$('.chzn-search > :text').val(''), e.stopPropagation());
							},
						},
						constructor: function () {
							(this.template = f),
								(this.option = this.option || p),
								u.default.apply(this, arguments),
								(this.params = this.options.params || {});
						},
						editMode: function () {
							this.$el.html(f(this.options)), (this.$select = this.$('select')), this.appendOptions();
							var e = this.getModelValue();
							return (
								e ? this.$select.val(e) : this.$('option:first-child').prop('selected', !0),
								this.$el.addClass('o-form-control'),
								!1 !== this.params.chosen && this.__applyChosen(),
								this
							);
						},
						appendOptions: function () {
							var e = this;
							if (this.getOptions()) {
								var t = this.getOptions(),
									n = Object.keys(t);
								this.applySortByKey(n),
									n.forEach(function (n) {
										e.$select.append(e.option({ key: n, value: t[n] }));
									});
							}
						},
						applySortByKey: function (e) {
							var t = this.options.sortByKey;
							t &&
								(t instanceof Function && e.sort(t), 'asc' === t && e.sort(), 'desc' === t && (e.sort(), e.reverse()));
						},
						__applyChosen: function (e) {
							var t = this.options.wide ? '100%' : this.params.width || '62%';
							this.params.autoWidth &&
								(t = (function (e) {
									e.$select.hide();
									var t = (0, a.default)(e.$select[0]).hide();
									(0, a.default)('body').append(t);
									var n = (e.params.width = 1.2 * t.width() + 'px');
									return e.$el.append(t.show()), n;
								})(this)),
								m.call(this, function () {
									var n = this.getParam('searchThreshold', 10);
									s.default.result(this.options, 'autoRender') || !1 === e || this.update(),
										this.$select.chosen({
											width: t,
											disable_search_threshold: n,
											placeholder_text: this.options.placeholder,
											search_contains: !0,
										});
									var r = this.options && this.options.options && Object.keys(this.options.options).length > n;
									this.accessibilityUpdate(r, this.params),
										g(this.$select, this.searchPlaceholder),
										this.params.autoWidth && this.$el.width(0),
										this.model.trigger('form:resize');
								});
						},
						val: function () {
							return this.$select && this.$select.val();
						},
						focus: function () {
							if (this.$select) return this.$select.focus();
						},
						toStringValue: function () {
							var e = this.getModelValue(),
								t = e,
								n = this.getOptions();
							return s.default.isEmpty(n) || (t = n[e]), s.default.isUndefined(t) && (t = this.defaultValue()), t || '';
						},
						getOptions: function () {
							var e = this.options.options;
							return s.default.isFunction(e) && (e = e.call(this)), s.default.isObject(e) ? e : {};
						},
						remove: function () {
							return this.$select && this.$select.trigger('remove'), u.default.prototype.remove.apply(this, arguments);
						},
						createAriaLiveNode: function (e) {
							var t = this.$select.next('.chzn-container');
							(0, a.default)('<div></div>')
								.attr('role', 'log')
								.attr('aria-live', 'polite')
								.attr('id', e)
								.attr('aria-relevant', 'additions')
								.attr('aria-atomic', 'false')
								.attr('class', 'off-screen')
								.insertAfter(t);
						},
						accessibilityUpdate: function (e, t) {
							var n = this.$select.attr('id') + '_txt',
								r = this.$select.attr('id') + '_aria_div_id',
								o = this.$select.attr('id') + '_ul';
							if (
								(h() && this.createAriaLiveNode(r),
								this.$('ul[class=chzn-results]').attr('role', 'listbox').attr('id', o),
								e
									? this.$('input[type=text]')
											.attr('id', n)
											.attr('aria-autocomplete', 'list')
											.attr('aria-activedescendant', '')
											.attr('role', 'combobox')
											.attr('aria-expanded', 'true')
											.attr('aria-controls', o)
									: this.$('input[type=text]').attr('id', n).attr('role', 'listbox'),
								t && t.aria && t.aria.label)
							) {
								var i = t.aria.label.trim();
								this.$('input[type=text]').attr('id', n).attr('aria-label', i),
									this.$('ul[class=chzn-results]').attr('aria-label', i);
							} else {
								var a = this.$el.parent().prev('.o-form-label').find('label').text().trim();
								this.$('input[type=text]').attr('id', n).attr('aria-label', a),
									this.$('ul[class=chzn-results]').attr('aria-label', a);
							}
							this.$('.chzn-results .active-result').attr('role', 'option').attr('aria-selected', 'false');
						},
					});
					(t.default = y), (e.exports = t.default);
				},
				69407: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = r(n(96129));
					n(48231);
					var s = r(n(83365));
					n(22891);
					var l = r(n(15982)),
						u = 'okta-form-input-field input-fix';
					var c = l.default.extend({
						template: i.default.template({
							1: function (e, t, n, r, o) {
								return '<span class="input-tooltip icon form-help-16"></span>';
							},
							3: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<span class="icon input-icon ' +
									e.escapeExpression(e.lambda(null != (i = null != t ? a(t, 'params') : t) ? a(i, 'icon') : i, t)) +
									'"></span>'
								);
							},
							5: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return e.escapeExpression(
									'function' ==
										typeof (i =
											null != (i = a(n, 'autoComplete') || (null != t ? a(t, 'autoComplete') : t))
												? i
												: e.hooks.helperMissing)
										? i.call(null != t ? t : e.nullContext || {}, {
												name: 'autoComplete',
												hash: {},
												data: o,
												loc: { start: { line: 1, column: 333 }, end: { line: 1, column: 349 } },
										  })
										: i
								);
							},
							7: function (e, t, n, r, o) {
								return 'off';
							},
							9: function (e, t, n, r, o) {
								return '<span class="input-icon-divider"></span>';
							},
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, i) {
								var a,
									s,
									l = null != t ? t : e.nullContext || {},
									u = e.hooks.helperMissing,
									c = 'function',
									d = e.escapeExpression,
									f =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									(null !=
									(a = f(n, 'if').call(l, null != (a = null != t ? f(t, 'params') : t) ? f(a, 'innerTooltip') : a, {
										name: 'if',
										hash: {},
										fn: e.program(1, i, 0),
										inverse: e.noop,
										data: i,
										loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 87 } },
									}))
										? a
										: '') +
									(null !=
									(a = f(n, 'if').call(l, null != (a = null != t ? f(t, 'params') : t) ? f(a, 'icon') : a, {
										name: 'if',
										hash: {},
										fn: e.program(3, i, 0),
										inverse: e.noop,
										data: i,
										loc: { start: { line: 1, column: 87 }, end: { line: 1, column: 166 } },
									}))
										? a
										: '') +
									'<input type="' +
									d(
										((s = null != (s = f(n, 'type') || (null != t ? f(t, 'type') : t)) ? s : u),
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'type',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 179 }, end: { line: 1, column: 187 } },
											  })
											: s)
									) +
									'" placeholder="' +
									d(
										((s = null != (s = f(n, 'placeholder') || (null != t ? f(t, 'placeholder') : t)) ? s : u),
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'placeholder',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 202 }, end: { line: 1, column: 217 } },
											  })
											: s)
									) +
									'" name="' +
									d(
										((s = null != (s = f(n, 'name') || (null != t ? f(t, 'name') : t)) ? s : u),
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'name',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 225 }, end: { line: 1, column: 233 } },
											  })
											: s)
									) +
									'" id="' +
									d(
										((s = null != (s = f(n, 'inputId') || (null != t ? f(t, 'inputId') : t)) ? s : u),
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'inputId',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 239 }, end: { line: 1, column: 250 } },
											  })
											: s)
									) +
									'" value="' +
									d(
										((s = null != (s = f(n, 'value') || (null != t ? f(t, 'value') : t)) ? s : u),
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'value',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 259 }, end: { line: 1, column: 268 } },
											  })
											: s)
									) +
									'" aria-label="' +
									d(
										((s = null != (s = f(n, 'placeholder') || (null != t ? f(t, 'placeholder') : t)) ? s : u),
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'placeholder',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 282 }, end: { line: 1, column: 297 } },
											  })
											: s)
									) +
									'" autocomplete="' +
									(null !=
									(a = f(n, 'if').call(l, null != t ? f(t, 'autoComplete') : t, {
										name: 'if',
										hash: {},
										fn: e.program(5, i, 0),
										inverse: e.program(7, i, 0),
										data: i,
										loc: { start: { line: 1, column: 313 }, end: { line: 1, column: 367 } },
									}))
										? a
										: '') +
									'" />' +
									(null !=
									(a = f(n, 'if').call(l, null != (a = null != t ? f(t, 'params') : t) ? f(a, 'iconDivider') : a, {
										name: 'if',
										hash: {},
										fn: e.program(9, i, 0),
										inverse: e.noop,
										data: i,
										loc: { start: { line: 1, column: 371 }, end: { line: 1, column: 444 } },
									}))
										? a
										: '')
								);
							},
							useData: !0,
						}),
						events: {
							'input input': 'update',
							'change input': 'update',
							'keydown input': 'update',
							'compositionend input': function () {
								this.isComposing = !1;
							},
							'compositionstart input': function () {
								this.isComposing = !0;
							},
							'keyup input': function (e) {
								!s.default.isEnter(e) || (window.okta && window.okta.enableIMESupport)
									? s.default.isEsc(e) && this.model.trigger('form:cancel')
									: this.model.trigger('form:save');
							},
						},
						hasIMESupport: !0,
						constructor: function () {
							l.default.apply(this, arguments), this.$el.addClass('o-form-control');
						},
						editMode: function () {
							this.$el.addClass(u), l.default.prototype.editMode.apply(this, arguments), this.$('input').placeholder();
						},
						readMode: function () {
							l.default.prototype.readMode.apply(this, arguments),
								this.$el.addClass('no-translate'),
								'password' === this.options.type && this.$el.text('********'),
								this.$el.removeClass(u);
						},
						val: function () {
							var e = this.$('input[type="' + this.options.type + '"]').val();
							return 'password' !== this.options.type && (e = a.default.trim(e)), e;
						},
						focus: function () {
							return this.$('input').focus();
						},
						postRender: function () {
							var e,
								t = this.options.params;
							if (t && t.innerTooltip) {
								var n = (function (e) {
									var t = e.title,
										n = e.text;
									return t && n && t !== n;
								})((e = t.innerTooltip))
									? e
									: { text: e.text || e };
								this.$('.input-tooltip').qtip({
									content: n,
									style: { classes: 'okta-tooltip qtip-custom qtip-shadow' },
									position: {
										my: 'bottom left',
										target: 'mouse',
										adjust: { method: 'flip', mouse: !0, y: -5, x: 5 },
										viewport: (0, a.default)('body'),
									},
								});
							}
						},
					});
					(t.default = c), (e.exports = t.default);
				},
				35575: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = r(n(28107)),
						a = r(n(33270)),
						s = r(n(15982)),
						l = r(n(90958)),
						u = s.default.extend({
							className: 'array-input',
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<a href="#" class="array-inputs-button link-button">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'courage', code: 'oform.add.another' },
													data: o,
													loc: { start: { line: 1, column: 52 }, end: { line: 1, column: 102 } },
												}
											)
										) +
										'</a>'
									);
								},
								useData: !0,
							}),
							params: { itemType: 'string' },
							events: {
								'click .array-inputs-button': function (e) {
									e.preventDefault(), this.isEditMode() && this.addNewElement();
								},
							},
							initialize: function (e) {
								e || (e = {}),
									(this.params = i.default.defaults(e.params || {}, this.params)),
									(this.uniqueIdPrefix = 'array');
							},
							from: function (e) {
								return i.default.isArray(e) ? e : [];
							},
							editMode: function () {
								return (
									this._setArrayObject(),
									this.$el.html(this.template),
									i.default.each(this.arrayObject, i.default.bind(this._addDeletableBox, this)),
									this
								);
							},
							readMode: function () {
								this.editMode(), this.$('.array-inputs-button').addClass('link-button-disabled');
							},
							val: function () {
								var e = i.default.values(this.arrayObject);
								return (
									i.default.contains([a.default.DATATYPE.number, a.default.DATATYPE.integer], this.params.itemType) &&
										(e = i.default.filter(e, i.default.isNumber)),
									e
								);
							},
							focus: function () {},
							addNewElement: function () {
								var e = i.default.uniqueId(this.uniqueIdPrefix);
								(this.arrayObject[e] = ''), this._addDeletableBox('', e), this.update();
							},
							_addDeletableBox: function (e, t) {
								var n = new l.default(
									i.default.extend(i.default.pick(this.options, 'read', 'readOnly', 'model'), {
										key: t,
										value: e,
										itemType: this.params.itemType,
									})
								);
								return (
									this.listenTo(n, 'updateArray', function (e) {
										i.default.isNull(e)
											? (delete this.arrayObject[t], this.stopListening(n))
											: (this.arrayObject[t] = e),
											this.update();
									}),
									n.render().$el.hide(),
									this.$('.array-inputs-button').before(n.el),
									n.$el.slideDown(),
									n
								);
							},
							_setArrayObject: function () {
								var e = this.model.get(this.options.name);
								if (((this.arrayObject = {}), i.default.isArray(e) && !i.default.isEmpty(e))) {
									var t = [],
										n = this;
									(0, i.default)(e.length).times(function () {
										t.push(i.default.uniqueId(n.uniqueIdPrefix));
									}),
										(this.arrayObject = i.default.object(t, e));
								}
							},
						});
					(t.default = u), (e.exports = t.default);
				},
				20290: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					(t.default = { extend: function () {} }), (e.exports = t.default);
				},
				6475: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						Object.defineProperty(t, '$', {
							enumerable: !0,
							get: function () {
								return s.default;
							},
						}),
						Object.defineProperty(t, 'Backbone', {
							enumerable: !0,
							get: function () {
								return a.default;
							},
						}),
						Object.defineProperty(t, 'BaseModel', {
							enumerable: !0,
							get: function () {
								return d.default;
							},
						}),
						Object.defineProperty(t, 'Collection', {
							enumerable: !0,
							get: function () {
								return o.Collection;
							},
						}),
						Object.defineProperty(t, 'Controller', {
							enumerable: !0,
							get: function () {
								return o.Controller;
							},
						}),
						Object.defineProperty(t, 'Form', {
							enumerable: !0,
							get: function () {
								return o.Form;
							},
						}),
						Object.defineProperty(t, 'FrameworkView', {
							enumerable: !0,
							get: function () {
								return f.default;
							},
						}),
						Object.defineProperty(t, 'Handlebars', {
							enumerable: !0,
							get: function () {
								return u.default;
							},
						}),
						Object.defineProperty(t, 'ListView', {
							enumerable: !0,
							get: function () {
								return p.default;
							},
						}),
						Object.defineProperty(t, 'Model', {
							enumerable: !0,
							get: function () {
								return c.default;
							},
						}),
						Object.defineProperty(t, 'Router', {
							enumerable: !0,
							get: function () {
								return o.Router;
							},
						}),
						Object.defineProperty(t, 'View', {
							enumerable: !0,
							get: function () {
								return o.View;
							},
						}),
						Object.defineProperty(t, '_', {
							enumerable: !0,
							get: function () {
								return l.default;
							},
						}),
						Object.defineProperty(t, 'createButton', {
							enumerable: !0,
							get: function () {
								return o.createButton;
							},
						}),
						Object.defineProperty(t, 'createCallout', {
							enumerable: !0,
							get: function () {
								return o.createCallout;
							},
						}),
						Object.defineProperty(t, 'internal', {
							enumerable: !0,
							get: function () {
								return o.internal;
							},
						}),
						Object.defineProperty(t, 'isModelPropertySchema', {
							enumerable: !0,
							get: function () {
								return i.isModelPropertySchema;
							},
						}),
						Object.defineProperty(t, 'loc', {
							enumerable: !0,
							get: function () {
								return o.loc;
							},
						}),
						Object.defineProperty(t, 'registerInput', {
							enumerable: !0,
							get: function () {
								return o.registerInput;
							},
						});
					var o = n(2890),
						i = n(50926),
						a = r(n(2770)),
						s = r(n(96129)),
						l = r(n(28107)),
						u = r(n(2875)),
						c = r(n(13614)),
						d = r(n(34146)),
						f = r(n(67282)),
						p = r(n(54833));
				},
				57223: function (e, t, n) {
					'use strict';
					var r = n(1654)(n(96129));
					r.default.fn.scrollParent = function (e) {
						var t = this.css('position'),
							n = 'absolute' === t,
							o = e ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
							i = this.parents()
								.filter(function () {
									var e = (0, r.default)(this);
									return (
										(!n || 'static' !== e.css('position')) &&
										o.test(e.css('overflow') + e.css('overflow-y') + e.css('overflow-x'))
									);
								})
								.eq(0);
						return 'fixed' !== t && i.length ? i : (0, r.default)(this[0].ownerDocument || document);
					};
				},
				80496: function (e, t, n) {
					var r = n(66583),
						o = n(12990);
					/**
					 * TypingDNA - Typing Biometrics JavaScript API
					 * https://api.typingdna.com/scripts/typingdna.js
					 * https://typingdna.com/scripts/typingdna.js (alternative)
					 *
					 * @version 2.15
					 * @author Raul Popa
					 * @copyright SC TypingDNA SRL, http://typingdna.com
					 * @license http://www.apache.org/licenses/LICENSE-2.0
					 * Licensed under the Apache License, Version 2.0 (the "License");
					 * you may not use this file except in compliance with the License.
					 * You may obtain a copy of the License at
					 * http://www.apache.org/licenses/LICENSE-2.0
					 *
					 * Unless required by applicable law or agreed to in writing, software
					 * distributed under the License is distributed on an "AS IS" BASIS,
					 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
					 * See the License for the specific language governing permissions and
					 * limitations under the License.
					 *
					 * Typical usage:
					 * var tdna = new TypingDNA(); // creates a new TypingDNA object and starts recording
					 * var typingPattern = tdna.getTypingPattern({type=1, text="Hello5g21?*"});
					 * returns a type 1 typing pattern (and continues recording afterwards)
					 *
					 * Optional:
					 * tdna.stop(); // ends recording and clears history stack (returns recording flag: false)
					 * tdna.start(); // restarts the recording after a stop (returns recording flag: true)
					 * tdna.reset(); // restarts the recording anytime, clears history stack and starts from scratch (returns nothing)
					 * var typingPatternQuality = TypingDNA.getQuality(typingPattern); //returns the quality/strength of any typing pattern
					 * (there is no need to initialize the class to do pattern quality checking)
					 */
					e.exports = function e() {
						if (1 == e.initialized) return e.instance;
						for (var t in ((e.prototype.start = function () {
							return e.start.apply(this, arguments);
						}),
						(e.prototype.stop = function () {
							return e.stop.apply(this, arguments);
						}),
						(e.prototype.reset = function () {
							return e.reset.apply(this, arguments);
						}),
						(e.prototype.addTarget = function () {
							return e.addTarget.apply(this, arguments);
						}),
						(e.prototype.removeTarget = function () {
							return e.removeTarget.apply(this, arguments);
						}),
						(e.prototype.getTypingPattern = function () {
							return e.getTypingPattern.apply(this, arguments);
						}),
						(e.prototype.get = function () {
							return e.get.apply(this, arguments);
						}),
						(e.prototype.startDiagram = function () {}),
						(e.prototype.stopDiagram = function () {}),
						(e.prototype.getDiagram = function () {
							return e.getDiagram.apply(this, arguments);
						}),
						(e.prototype.getExtendedDiagram = function () {
							return e.getExtendedDiagram.apply(this, arguments);
						}),
						(e.prototype.getMouseDiagram = function () {
							return e.getMouseDiagram.apply(this, arguments);
						}),
						(e.prototype.startMouse = function () {
							return e.startMouse.apply(this, arguments);
						}),
						(e.prototype.stopMouse = function () {
							return e.stopMouse.apply(this, arguments);
						}),
						(e.prototype.getQuality = function () {
							return e.getQuality.apply(this, arguments);
						}),
						(e.prototype.getLength = function () {
							return e.getLength.apply(this, arguments);
						}),
						(e.prototype.isMobile = function () {
							return e.isMobile.apply(this, arguments);
						}),
						(e.prototype.getTextId = function () {
							return e.getTextId.apply(this, arguments);
						}),
						(e.initialized = !0),
						(e.prototype.maxHistoryLength = e.maxHistoryLength),
						(e.prototype.defaultHistoryLength = e.defaultHistoryLength),
						(e.prototype.maxSeekTime = e.maxSeekTime),
						(e.prototype.maxPressTime = e.maxPressTime),
						(e.version = 2.15),
						(e.flags = 0),
						(e.instance = this),
						(e.document = document),
						(e.maxHistoryLength = 2e3),
						(e.maxSeekTime = 1500),
						(e.maxPressTime = 300),
						(e.defaultHistoryLength = 160),
						(e.spKeyCodes = [8, 13, 32]),
						(e.spKeyCodesObj = { 8: 1, 13: 1, 32: 1 }),
						(e.keyCodes = [
							65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90,
							32, 222, 188, 190, 186, 187, 189, 191, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
						]),
						(e.keyCodesObj = {}),
						e.keyCodes))
							e.keyCodesObj[e.keyCodes[t]] = 1;
						(e.pt1 = e.ut1 = new Date().getTime()),
							(e.wfk = []),
							(e.sti = []),
							(e.skt = []),
							(e.recording = !0),
							(e.mouseRecording = !0),
							(e.mouseMoveRecording = !1),
							(e.spKeyRecording = !0),
							(e.diagramRecording = !0),
							(e.dwfk = []),
							(e.dsti = []),
							(e.dskt = []),
							(e.drkc = []),
							(e.prevKeyCode = 0),
							(e.maxMoveDeltaTime = 600),
							(e.maxScrollDeltaTime = 800),
							(e.maxStopTime = 1500),
							(e.maxClickTime = 600),
							(e.maxMouseHistoryLength = 500),
							(e.lastMouseMoveTime = e.lastMouseDownTime = new Date().getTime()),
							(e.stopTimes = []),
							(e.clickTimes = []),
							(e.lastMouseStop = !0),
							(e.zl = 1e-7),
							(e.isAndroidChrome = !1),
							(e.ACLastTime = new Date().getTime()),
							(e.ACSeekTime = 0),
							(e.ACPressTime = 0),
							(e.ACLastCharCode = 0),
							(e.ACLastKeyCode = 0),
							(e.ACInputLengths = { inputs: [], lastLength: [] }),
							(e.ACPreviousKeyCode = 0),
							(e.targetIds = []),
							(e.lastTarget = ''),
							(e.lastTargetFound = !1),
							(e.replaceMissingKeys = !0),
							(e.replaceMissingKeysPerc = 7),
							(e.keyDown = function (t) {
								if ((e.recording || e.diagramRecording) && e.isTarget(t.target.id)) {
									var n = t.keyCode;
									if ((1 == e.wfk[n] || e.dwfk[n], 229 == n && e.isMobile() && !e.isAndroidChrome))
										(e.isAndroidChrome = !0),
											(e.ACSeekTime = new Date().getTime() - e.ACLastTime),
											(e.ACLastTime = new Date().getTime()),
											e.document.removeEventListener('keydown', e.keyDown),
											e.document.removeEventListener('keyup', e.keyUp),
											e.document.removeEventListener('keypress', e.keyPress),
											e.document.addEventListener('keydown', e.ACKeyDown),
											e.document.addEventListener('keyup', e.ACKeyUp);
									else {
										var r = e.pt1,
											o = (e.pt1 = new Date().getTime()) - r,
											i = e.pt1;
										(1 == e.recording || (e.spKeyCodesObj[n] && 1 == e.spKeyRecording)) &&
											((t.shiftKey && !e.isMobile()) || ((e.wfk[n] = 1), (e.skt[n] = o), (e.sti[n] = i))),
											1 == e.diagramRecording &&
												((e.dwfk[n] = 1), (e.dskt[n] = o), (e.dsti[n] = i), (e.dlastDownKey = n));
									}
								}
							}),
							(e.keyPress = function (t) {
								(e.recording || e.diagramRecording) &&
									e.isTarget(t.target.id) &&
									1 == e.diagramRecording &&
									(e.drkc[e.dlastDownKey] = t.charCode);
							}),
							(e.keyUp = function (t) {
								if ((e.recording || e.diagramRecording) && e.isTarget(t.target.id)) {
									var n = new Date().getTime(),
										r = t.keyCode;
									if (1 == e.recording || (e.spKeyCodesObj[r] && 1 == e.spKeyRecording)) {
										if ((!t.shiftKey || e.isMobile()) && 1 == e.wfk[r]) {
											var o = n - e.sti[r],
												i = [r, e.skt[r], o, e.prevKeyCode, n, t.target.id];
											e.history.add(i), (e.prevKeyCode = r);
										}
										e.wfk[r] = 0;
									}
									if (1 == e.diagramRecording) {
										if (null != e.drkc[r] && 0 != e.drkc[r] && 1 == e.dwfk[r]) {
											o = n - e.dsti[r];
											var a = [r, e.dskt[r], o, e.drkc[r], n, t.target.id];
											e.history.addDiagram(a);
										}
										e.dwfk[r] = 0;
									}
								}
							}),
							(e.mouseScroll = function (t) {
								if (1 == e.mouseRecording && 1 == e.mouseMoveRecording)
									if (1 == e.mouse.scrollStarted) {
										var n = new Date().getTime();
										e.mouse.scrollTimes.push(n),
											e.mouse.scrollTopArr.push(e.document.body.scrollTop),
											clearInterval(e.scrollInterval),
											(e.scrollInterval = setInterval(e.mouse.checkScroll, e.maxScrollDeltaTime));
									} else e.mouse.scrollStarted = !0;
							}),
							(e.mouseMove = function (t) {
								if (1 == e.mouseRecording) {
									var n = new Date().getTime();
									1 == e.mouseMoveRecording &&
										(1 == e.mouse.started
											? (e.mouse.times.push(n),
											  e.mouse.xPositions.push(t.screenX),
											  e.mouse.yPositions.push(t.screenY),
											  clearInterval(e.moveInterval),
											  (e.moveInterval = setInterval(e.mouse.checkMove, e.maxMoveDeltaTime)))
											: (e.mouse.started = !0)),
										(e.lastMouseMoveTime = n);
								}
							}),
							(e.mouseDown = function (t) {
								if (1 == e.mouseRecording && (e.mouse.checkMove(), e.mouse.checkScroll(), 1 == t.which)) {
									var n = (e.lastMouseDownTime = new Date().getTime()) - e.lastMouseMoveTime;
									if (n < e.maxStopTime && 0 == e.lastMouseStop && (e.stopTimes.push(n), 1 == e.mouseMoveRecording)) {
										var r = [3, n];
										e.mouse.history.add(r), (e.lastMouseStop = !0);
									}
								}
							}),
							(e.mouseUp = function (t) {
								if (1 == e.mouseRecording && 1 == t.which) {
									var n = new Date().getTime() - e.lastMouseDownTime;
									if (
										n < e.maxClickTime &&
										e.lastMouseDownTime > e.lastMouseMoveTime &&
										(e.clickTimes.push(n), 1 == e.mouseMoveRecording)
									) {
										var r = [4, n];
										e.mouse.history.add(r);
									}
								}
							}),
							(e.ACKeyDown = function (t) {
								(e.recording || e.diagramRecording) &&
									((e.ACSeekTime = new Date().getTime() - e.ACLastTime),
									(e.ACLastTime = new Date().getTime()),
									e.isTarget(t.target.id) &&
										-1 === e.ACInputLengths.inputs.indexOf(t.target) &&
										(e.ACInputLengths.inputs.push(t.target), e.ACInputLengths.lastLength.push(0)));
							}),
							(e.ACKeyUp = function (t) {
								if (
									(e.recording || e.diagramRecording) &&
									((e.ACPressTime = new Date().getTime() - e.ACLastTime),
									(e.ACLastTime = new Date().getTime()),
									e.isTarget(t.target.id))
								) {
									var n = t.keyCode,
										r = e.ACInputLengths.inputs.indexOf(t.target);
									if (
										(-1 === r &&
											(e.ACInputLengths.inputs.push(t.target),
											e.ACInputLengths.lastLength.push(0),
											(r = e.ACInputLengths.inputs.indexOf(t.target))),
										229 == n && t.target.value.length >= e.ACInputLengths.lastLength[r])
									) {
										var o = t.target.value.substr(t.target.selectionStart - 1 || 0, 1);
										(n = o.toUpperCase().charCodeAt(0)),
											(e.ACLastCharCode = o.charCodeAt(0)),
											(e.ACLastKeyCode = o.toUpperCase().charCodeAt(0));
									}
									e.ACInputLengths.lastLength[r] = t.target.value.length;
									var i = [n, e.ACSeekTime, e.ACPressTime, e.ACPreviousKeyCode, e.ACLastTime];
									if ((e.history.add(i), (e.ACPreviousKeyCode = n), 1 == e.diagramRecording)) {
										var a = [n, e.ACSeekTime, e.ACPressTime, e.ACLastCharCode];
										e.history.addDiagram(a);
									}
								}
							}),
							(e.isTarget = function (t) {
								if (e.lastTarget == t && e.lastTargetFound) return !0;
								var n = e.targetIds.length,
									r = !1;
								if (n > 0) {
									for (var o = 0; o < n; o++)
										if (e.targetIds[o] == t) {
											r = !0;
											break;
										}
									return (e.lastTarget = t), (e.lastTargetFound = r), r;
								}
								return (e.lastTarget = t), (e.lastTargetFound = !0), !0;
							}),
							e.document.addEventListener
								? (e.document.addEventListener('keydown', e.keyDown),
								  e.document.addEventListener('keyup', e.keyUp),
								  e.document.addEventListener('keypress', e.keyPress),
								  e.document.addEventListener('mousemove', e.mouseMove),
								  e.document.addEventListener('mousedown', e.mouseDown),
								  e.document.addEventListener('mouseup', e.mouseUp),
								  e.document.addEventListener('scroll', e.mouseScroll))
								: e.document.attachEvent &&
								  (e.document.attachEvent('onkeydown', e.keyDown),
								  e.document.attachEvent('onkeyup', e.keyUp),
								  e.document.attachEvent('onkeypress', e.keyPress),
								  e.document.attachEvent('onmousemove', e.mouseMove),
								  e.document.attachEvent('onmousedown', e.mouseDown),
								  e.document.attachEvent('onmouseup', e.mouseUp),
								  e.document.attachEvent('onscroll', e.mouseScroll)),
							((e.mouse = {}).times = []),
							(e.mouse.xPositions = []),
							(e.mouse.yPositions = []),
							(e.mouse.scrollTimes = []),
							(e.mouse.scrollTopArr = []),
							(e.mouse.history = {}),
							(e.mouse.history.stack = []),
							(e.mouse.getDistance = function (e, t) {
								return Math.sqrt(e * e + t * t);
							}),
							(e.mouse.getTotalDistance = function (n, r) {
								var o = 0,
									i = n.length;
								for (t = 1; t < i - 1; t++) {
									var a = n[t] - n[t - 1],
										s = r[t] - r[t - 1];
									o += e.mouse.getDistance(a, s);
								}
								return o;
							}),
							(e.mouse.getAngle = function (e, t) {
								var n = t < 0;
								return e >= 0
									? n
										? 180 + Math.round(Math.atan(Math.abs(e) / (Math.abs(t) + 1e-7)) / 0.01745329251)
										: 90 - Math.round(Math.atan(Math.abs(e) / (Math.abs(t) + 1e-7)) / 0.01745329251) + 270
									: n
									? 90 - Math.round(Math.atan(Math.abs(e) / (Math.abs(t) + 1e-7)) / 0.01745329251) + 90
									: Math.round(Math.atan(Math.abs(e) / (Math.abs(t) + 1e-7)) / 0.01745329251);
							}),
							(e.mouse.recordMoveAction = function () {
								var n = e.mouse.times.length;
								if (!(n < 3)) {
									var r = e.mouse.times[n - 1] - e.mouse.times[0],
										o = e.mouse.xPositions[n - 1] - e.mouse.xPositions[0],
										i = e.mouse.yPositions[n - 1] - e.mouse.yPositions[0],
										a = Math.round(e.mouse.getDistance(o, i)),
										s = Math.round(e.mouse.getTotalDistance(e.mouse.xPositions, e.mouse.yPositions)),
										l = Math.round((100 * s) / a),
										u = [1, r, a, Math.round((100 * a) / r), e.mouse.getAngle(o, i), l];
									for (t in u) if (isNaN(u[t])) return;
									e.mouse.history.add(u), (e.lastMouseStop = !1);
								}
							}),
							(e.mouse.recordScrollAction = function () {
								var n = e.mouse.scrollTimes.length;
								if (!(n < 2)) {
									var r = e.mouse.scrollTimes[n - 1] - e.mouse.scrollTimes[0],
										o = e.mouse.scrollTopArr[n - 1] - e.mouse.scrollTopArr[0],
										i = [2, r, o, Math.round((100 * o) / r)];
									for (t in i) if (isNaN(i[t]) && !isFinite(i[t])) return;
									e.mouse.history.add(i);
								}
							}),
							(e.mouse.history.add = function (t) {
								this.stack.push(t), this.stack.length > e.maxMouseHistoryLength && this.stack.shift();
							}),
							(e.mouse.history.getDiagram = function () {
								var t = this.stack.join('|');
								return [String(e.isMobile()) + ',' + String(e.version), t].join('|');
							}),
							(e.mouse.clearLastMove = function () {
								(e.mouse.times = []), (e.mouse.xPositions = []), (e.mouse.yPositions = []);
							}),
							(e.mouse.checkMove = function () {
								clearInterval(e.moveInterval),
									1 == e.mouse.started && ((e.mouse.started = !1), e.mouse.recordMoveAction(), e.mouse.clearLastMove());
							}),
							(e.mouse.clearLastScroll = function () {
								(e.mouse.scrollTimes = []), (e.mouse.scrollTopArr = []);
							}),
							(e.mouse.checkScroll = function () {
								clearInterval(e.scrollInterval),
									1 == e.mouse.scrollStarted &&
										((e.mouse.scrollStarted = !1), e.mouse.recordScrollAction(), e.mouse.clearLastScroll());
							}),
							(e.addTarget = function (t) {
								var n = e.targetIds.length,
									r = !1;
								if (n > 0) {
									for (var o = 0; o < n; o++)
										if (e.targetIds[o] == t) {
											r = !0;
											break;
										}
									r || e.targetIds.push(t);
								} else e.targetIds.push(t);
							}),
							(e.removeTarget = function (t) {
								var n = e.targetIds.length;
								if (n > 0)
									for (var r = 0; r < n; r++)
										if (e.targetIds[r] == t) {
											e.targetIds.splice(r, 1);
											break;
										}
							}),
							(e.reset = function (t) {
								(e.history.stack = []),
									(e.history.stackDiagram = []),
									(e.clickTimes = []),
									(e.stopTimes = []),
									(e.ACInputLengths = { inputs: [], lastLength: [] }),
									1 == t && (e.mouse.history.stack = []);
							}),
							(e.start = function () {
								return (e.diagramRecording = !0), (e.recording = !0);
							}),
							(e.stop = function () {
								return (e.diagramRecording = !1), (e.recording = !1);
							}),
							(e.startMouse = function () {
								return (e.mouseRecording = e.mouseMoveRecording = !0);
							}),
							(e.stopMouse = function () {
								return (e.mouseRecording = e.mouseMoveRecording = !1);
							}),
							(e.getTypingPattern = function (t) {
								if ('object' !== o(t)) return e.get();
								switch (t.type) {
									case 0:
										return e.get(t.length, t.targetId);
									case 1:
										var n = null != t.text ? t.text : t.length;
										return e.history.getDiagram(t.extended, n, t.textId, t.targetId, t.caseSensitive);
									case 2:
										n = null != t.text ? t.text : t.length;
										return e.history.getDiagram(!0, n, t.textId, t.targetId, t.caseSensitive);
									default:
										return e.get(t.length);
								}
							}),
							(e.getDiagram = function (t, n) {
								return e.history.getDiagram(!1, t, n, void 0, !1);
							}),
							(e.getExtendedDiagram = function (t, n) {
								return e.history.getDiagram(!0, t, n, void 0, !1);
							}),
							(e.getMouseDiagram = function () {
								return e.mouse.history.getDiagram();
							}),
							(e.get = function (t, n) {
								var o = e.history.stack.length;
								(null != t && 0 != t) || (t = e.defaultHistoryLength), t > o && (t = o);
								var i = {},
									a = e.history.get(t, '', n),
									s = r(a, 2);
								(i.arr = s[0]), (targetLength = s[1]), null != n && '' != n && (t = targetLength);
								var l = e.zl,
									u = t,
									c = e.math.fo(e.history.get(t, 'seek', n)),
									d = e.math.fo(e.history.get(t, 'press', n)),
									f = Math.round(e.math.avg(d)),
									p = Math.round(e.math.avg(c)),
									h = Math.round(e.math.sd(d)),
									m = Math.round(e.math.sd(c)),
									v = p + f,
									g = e.math.rd((f + l) / (v + l), 4),
									y = e.math.rd((1 - g) / g, 4),
									b = e.math.rd((h + l) / (f + l), 4),
									_ = e.math.rd((m + l) / (f + l), 4),
									w = Math.round(6e4 / (v + l));
								for (var O in (0 == u && (w = 0), i.arr)) {
									var k = i.arr[O][1].length,
										x = 0,
										E = 0,
										T = 0,
										S = 0,
										A = 0,
										C = 0;
									switch (i.arr[O][0].length) {
										case 0:
											break;
										case 1:
											x = e.math.rd((i.arr[O][0][0] + l) / (p + l), 4);
											break;
										default:
											var P = e.math.fo(i.arr[O][0]);
											(x = e.math.rd((e.math.avg(P) + l) / (p + l), 4)),
												(S = e.math.rd((e.math.sd(P) + l) / (m + l), 4));
									}
									switch (i.arr[O][1].length) {
										case 0:
											break;
										case 1:
											E = e.math.rd((i.arr[O][1][0] + l) / (f + l), 4);
											break;
										default:
											var P = e.math.fo(i.arr[O][1]);
											(E = e.math.rd((e.math.avg(P) + l) / (f + l), 4)),
												(A = e.math.rd((e.math.sd(P) + l) / (h + l), 4));
									}
									switch (i.arr[O][2].length) {
										case 0:
											break;
										case 1:
											T = e.math.rd((i.arr[O][2][0] + l) / (p + l), 4);
											break;
										default:
											P = e.math.fo(i.arr[O][2]);
											(T = e.math.rd((e.math.avg(P) + l) / (p + l), 4)),
												(C = e.math.rd((e.math.sd(P) + l) / (m + l), 4));
									}
									delete i.arr[O][2],
										delete i.arr[O][1],
										delete i.arr[O][0],
										(i.arr[O][0] = k),
										(i.arr[O][1] = x),
										(i.arr[O][2] = E),
										(i.arr[O][3] = T),
										(i.arr[O][4] = S),
										(i.arr[O][5] = A),
										(i.arr[O][6] = C);
								}
								e.apu((P = []), u),
									e.apu(P, w),
									e.apu(P, v),
									e.apu(P, g),
									e.apu(P, y),
									e.apu(P, b),
									e.apu(P, _),
									e.apu(P, f),
									e.apu(P, p),
									e.apu(P, h),
									e.apu(P, m);
								for (var R = 0; R <= 6; R++)
									for (O = 0; O < 44; O++) {
										var I = e.keyCodes[O],
											N = i.arr[I][R];
										0 == N && R > 0 && (N = 1), e.apu(P, N);
									}
								return (
									e.apu(P, e.isMobile()),
									e.apu(P, e.version),
									e.apu(P, e.flags),
									P.push(e.history.getSpecialKeys()),
									P.join(',')
								);
							}),
							(e.apu = function (e, t) {
								'NaN' == String(t) && (t = 0), e.push(t);
							}),
							((e.math = {}).rd = function (e, t) {
								return Number(e.toFixed(t));
							}),
							(e.math.avg = function (e) {
								var t = e.length;
								if (t > 0) {
									for (var n = 0, r = 0; r < t; r++) n += e[r];
									return this.rd(n / t, 4);
								}
								return 0;
							}),
							(e.math.sd = function (e) {
								var t = e.length;
								if (t < 2) return 0;
								for (var n = 0, r = this.avg(e), o = 0; o < t; o++) n += (e[o] - r) * (e[o] - r);
								return Math.sqrt(n / t);
							}),
							(e.math.fo = function (e) {
								if (e.length > 1) {
									var t = e.concat(),
										n = e.length;
									t.sort(function (e, t) {
										return e - t;
									});
									var r = this.sd(t),
										o = t[Math.ceil(e.length / 2)],
										i = o + 2 * r,
										a = o - 2 * r;
									n < 20 && (a = 0);
									for (var s = [], l = 0; l < n; l++) {
										var u = t[l];
										u < i && u > a && s.push(u);
									}
									return s;
								}
								return e;
							}),
							(e.math.fnv1aHash = function (e) {
								if (null == e && 'string' != typeof e) return 0;
								var t,
									n,
									r = 1914395348;
								for (t = 0, n = (e = e.toLowerCase()).length; t < n; t++)
									(r ^= e.charCodeAt(t)), (r += (r << 1) + (r << 4) + (r << 7) + (r << 8) + (r << 24));
								return r >>> 0;
							}),
							((e.history = {}).stack = []),
							(e.history.stackDiagram = []),
							(e.history.add = function (t) {
								this.stack.push(t), this.stack.length > e.maxHistoryLength && this.stack.shift();
							}),
							(e.history.addDiagram = function (e) {
								this.stackDiagram.push(e);
							}),
							(e.history.getDiagram = function (t, n, r, i, a) {
								a = null != a ? a : null == n || '' == n;
								var s = [],
									l = 1 == t ? 1 : 0,
									u = this.stackDiagram;
								if (null != i && '' != i && u.length > 0) {
									if (((u = e.sliceStackByTargetId(u, i)), null == n || '' == n))
										null != (f = e.document.getElementById(i)) && (n = f.value);
								} else {
									var c = e.targetIds.length;
									if ((null == n || '' == n) && c > 0) {
										n = '';
										for (var d = 0; d < c; d++) {
											var f;
											null != (f = e.document.getElementById(e.targetIds[d])) && (n += f.value);
										}
									}
								}
								var p = 0,
									h = u.length,
									m = h;
								'string' == typeof n ? (m = n.length) : 'number' == typeof n && n < h && (m = n);
								var v = 0;
								if (
									(null != r
										? (v = isNaN(parseInt(r)) ? e.math.fnv1aHash(r) : parseInt(r))
										: 'string' == typeof n && (v = e.math.fnv1aHash(n)),
									s.push([e.isMobile(), e.version, e.flags, l, m, v, e.history.getSpecialKeys()]),
									null != n && n.length > 0 && 'string' == typeof n)
								) {
									var g,
										y,
										b = n.toLowerCase(),
										_ = n.toUpperCase(),
										w = [],
										O = 0;
									for (d = 0; d < n.length; d++) {
										var k = n.charCodeAt(d);
										a || (y = (g = _.charCodeAt(d)) != k ? g : b.charCodeAt(d));
										for (var x = O, E = h, T = !1; 0 == T; ) {
											for (var S = x; S < E; S++) {
												if ((D = (j = u[S])[3]) == k || (!a && D == y)) {
													if (((T = !0), S == O)) O++, (w = []);
													else {
														w.push(S);
														var A = w.length;
														A > 1 && w[A - 1] == w[A - 2] + 1 && ((O = S + 1), (w = []));
													}
													var C = j[0],
														P = j[1],
														R = j[2];
													t ? s.push([D, P, R, C]) : s.push([P, R]);
													break;
												}
											}
											if (0 == T)
												if (0 != x) (x = 0), (E = O);
												else if (((T = !0), e.replaceMissingKeys)) {
													if (
														(p++, 'object' !== o(e.savedMissingAvgValues) || e.savedMissingAvgValues.historyLength != h)
													) {
														var I = e.math.fo(e.history.get(0, 'seek')),
															N = e.math.fo(e.history.get(0, 'press'));
														(P = Math.round(e.math.avg(I))), (R = Math.round(e.math.avg(N)));
														e.savedMissingAvgValues = { seekTime: P, pressTime: R, historyLength: h };
													} else (P = e.savedMissingAvgValues.seekTime), (R = e.savedMissingAvgValues.pressTime);
													t ? s.push([k, P, R, k, 1]) : s.push([P, R, 1]);
													break;
												}
										}
										if (e.replaceMissingKeysPerc < (100 * p) / m) return null;
									}
								} else {
									var M = 0;
									'number' == typeof n && (M = h - n), M < 0 && (M = 0);
									for (d = M; d < h; d++) {
										var j;
										(C = (j = u[d])[0]), (P = j[1]), (R = j[2]);
										if (t) {
											var D = j[3];
											s.push([D, P, R, C]);
										} else s.push([P, R]);
									}
								}
								return s.join('|');
							}),
							(e.sliceStackByTargetId = function (e, n) {
								var r = e.length,
									o = [];
								for (t = 0; t < r; t++) {
									var i = e[t];
									i[5] == n && o.push(i);
								}
								return o;
							}),
							(e.history.get = function (t, n, r) {
								var o = this.stack;
								null != r && '' != r && o.length > 0 && (o = e.sliceStackByTargetId(o, r));
								var i = o.length;
								switch (((0 != t && null != t) || (t = e.defaultHistoryLength), t > i && (t = i), n)) {
									case 'seek':
										var a = [];
										for (u = 1; u <= t; u++) {
											(f = o[i - u][1]) <= e.maxSeekTime && a.push(f);
										}
										return a;
									case 'press':
										var s = [];
										for (u = 1; u <= t; u++) {
											(p = o[i - u][2]) <= e.maxPressTime && s.push(p);
										}
										return s;
									default:
										var l = {};
										for (var u in e.keyCodes) l[e.keyCodes[u]] = [[], [], []];
										for (u = 1; u <= t; u++) {
											var c = o[i - u],
												d = c[0],
												f = c[1],
												p = c[2],
												h = c[3];
											e.keyCodesObj[d] &&
												(f <= e.maxSeekTime && (l[d][0].push(f), 0 != h && e.keyCodesObj[h] && l[h][2].push(f)),
												p <= e.maxPressTime && l[d][1].push(p));
										}
										return [l, t];
								}
							}),
							(e.history.getSpecialKeys = function () {
								var t = [],
									n = this.stack.length,
									r = {};
								for (var o in e.spKeyCodes) r[e.spKeyCodes[o]] = [[]];
								for (o = 1; o <= n; o++) {
									var i = this.stack[n - o];
									if (e.spKeyCodesObj[i[0]]) {
										var a = i[0],
											s = i[2];
										s <= e.maxPressTime && r[a][0].push(s);
									}
								}
								for (var o in e.spKeyCodes) {
									var l = (i = e.math.fo(r[e.spKeyCodes[o]][0])).length;
									t.push(l),
										l > 1
											? (t.push(Math.round(e.math.avg(i))), t.push(Math.round(e.math.sd(i))))
											: 1 == l
											? t.push([i[0], -1])
											: t.push([-1, -1]);
								}
								var u = e.clickTimes.length;
								t.push(u),
									u > 1
										? (t.push(Math.round(e.math.avg(e.clickTimes))), t.push(Math.round(e.math.sd(e.clickTimes))))
										: 1 == u
										? t.push(e.clickTimes[0], -1)
										: t.push([-1, -1]);
								var c = e.stopTimes.length;
								return (
									t.push(c),
									c > 1
										? (t.push(Math.round(e.math.avg(e.stopTimes))), t.push(Math.round(e.math.sd(e.stopTimes))))
										: 1 == c
										? t.push(e.stopTimes[0], -1)
										: t.push([-1, -1]),
									t
								);
							}),
							(e.getQuality = function (t) {
								var n = t.split(',');
								for (a = 0; a < n.length; a++) n[a] = Number(n[a]);
								n[0];
								var r = (rec = avgAcc = 0),
									o = e.math.avg(n),
									i = n.slice(11, 55);
								for (var a in i) (rec += Number(i[a] > 0)), (r += Number(i[a] > 4)), (avgAcc += Number(i[a] > o));
								var s = Math.sqrt(rec * r * avgAcc) / 80;
								return s > 1 ? 1 : s;
							}),
							(e.checkMobileValidity = function (e) {
								var t = e.split(','),
									n = t[0];
								if (0 == n) return 0;
								var r = 0,
									o = t.slice(11, 55);
								for (var i in o) r += Number(o[i]);
								return r / n;
							}),
							(e.getLength = function (e) {
								return Number(e.split(',')[1]);
							}),
							(e.isMobile = function () {
								if (null != e.mobile) return e.mobile;
								var t,
									n = 0;
								return (
									(t = navigator.userAgent || navigator.vendor || window.opera),
									(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
										t
									) ||
										/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
											t.substr(0, 4)
										)) &&
										(n = 1),
									(e.mobile = n),
									n
								);
							}),
							(e.getTextId = function (t) {
								return e.math.fnv1aHash(t);
							});
					};
				},
				79084: function (e) {
					/**
					 * Duo Web SDK v2
					 * Copyright 2019, Duo Security
					 */
					e.exports = (function () {
						var e,
							t,
							n,
							r,
							o,
							i,
							a = /^(?:AUTH|ENROLL)+\|[A-Za-z0-9\+\/=]+\|[A-Za-z0-9\+\/=]+$/,
							s = /^ERR\|[\w\s\.\(\)]+$/,
							l = /^DUO_OPEN_WINDOW\|/,
							u = ['duo.com', 'duosecurity.com', 'duomobile.s3-us-west-1.amazonaws.com'];
						function c() {
							(e = ''), (t = 'sig_response'), (n = void 0), (r = void 0), (o = void 0), (i = void 0);
						}
						function d(e, t) {
							var n = t || 'https://www.duosecurity.com/docs/duoweb#3.-show-the-iframe';
							throw new Error('Duo Web SDK error: ' + e + (n ? '\nSee ' + n + ' for more information' : ''));
						}
						function f(e) {
							return e.replace(/([a-z])([A-Z])/, '$1-$2').toLowerCase();
						}
						function p(e, t) {
							return 'dataset' in e ? e.dataset[t] : e.getAttribute('data-' + f(t));
						}
						function h(e, t, n, r) {
							'addEventListener' in window ? e.addEventListener(t, r, !1) : e.attachEvent(n, r);
						}
						function m(e, t, n, r) {
							'removeEventListener' in window ? e.removeEventListener(t, r, !1) : e.detachEvent(n, r);
						}
						function v(e) {
							h(document, 'DOMContentLoaded', 'onreadystatechange', e);
						}
						function g(e) {
							m(document, 'DOMContentLoaded', 'onreadystatechange', e);
						}
						function y(e) {
							h(window, 'message', 'onmessage', e);
						}
						function b(e) {
							m(window, 'message', 'onmessage', e);
						}
						function _(e) {
							if (e) {
								0 === e.indexOf('ERR|') && d(e.split('|')[1]),
									(-1 !== e.indexOf(':') && 2 === e.split(':').length) ||
										d(
											"Duo was given a bad token.  This might indicate a configuration problem with one of Duo's client libraries."
										);
								var t = e.split(':');
								return (r = t[0]), (o = t[1]), { sigRequest: e, duoSig: t[0], appSig: t[1] };
							}
						}
						function w(e) {
							return Boolean(
								e.origin === 'https://' + n &&
									'string' == typeof e.data &&
									(e.data.match(a) || e.data.match(s) || e.data.match(l))
							);
						}
						function O(r) {
							c(),
								r &&
									(r.host && (n = r.host),
									r.sig_request && _(r.sig_request),
									r.post_action && (e = r.post_action),
									r.post_argument && (t = r.post_argument),
									'function' == typeof r.submit_callback && r.submit_callback);
							var o = k(r);
							o ? I(o, r.iframeAttributes || {}) : R(r), g(O);
						}
						function k(e) {
							var t;
							return (
								e.iframe && e.iframeContainer
									? d('Passing both `iframe` and `iframeContainer` arguments at the same time is not allowed.')
									: e.iframe
									? T((t = x(e.iframe)))
									: e.iframeContainer
									? S((t = x(e.iframeContainer)))
									: (t = document.getElementById('duo_iframe')),
								t
							);
						}
						function x(e) {
							return e.tagName ? e : 'string' == typeof e ? document.getElementById(e) : null;
						}
						function E(e) {
							return e && e.tagName && 'iframe' === e.tagName.toLowerCase();
						}
						function T(e) {
							e &&
								!E(e) &&
								d(
									'`iframe` only accepts an iframe element or the id of an iframe. To use a non-iframe element, use the `iframeContainer` argument.'
								);
						}
						function S(e) {
							e &&
								E(e) &&
								d(
									'`iframeContainer` only accepts a non-iframe element or the id of a non-iframe. To use a non-iframe element, use the `iframeContainer` argument on Duo.init().'
								);
						}
						function A() {
							return [
								'https://',
								n,
								'/frame/web/v1/auth?tx=',
								r,
								'&parent=',
								encodeURIComponent(document.location.href),
								'&v=2.8',
							].join('');
						}
						function C(e) {
							if (w(e))
								if (e.data.match(l)) {
									var t = e.data.substring('DUO_OPEN_WINDOW|'.length);
									P(t) && window.open(t, '_self');
								} else N(e.data), b(C);
						}
						function P(e) {
							if (!e) return !1;
							var t = document.createElement('a');
							if (((t.href = e), 'duotrustedendpoints:' === t.protocol)) return !0;
							if ('https:' !== t.protocol) return !1;
							for (var n = 0; n < u.length; n++) if (t.hostname.endsWith('.' + u[n]) || t.hostname === u[n]) return !0;
							return !1;
						}
						function R(e) {
							v(function t() {
								var n = k(e);
								n ||
									d(
										'This page does not contain an iframe for Duo to use. Add an element like <iframe id="duo_iframe"></iframe> to this page.'
									),
									I(n, e.iframeAttributes || {}),
									g(t);
							});
						}
						function I(a, s) {
							if (
								(n ||
									(n = p(a, 'host')) ||
									d(
										'No API hostname is given for Duo to use.  Be sure to pass a `host` parameter to Duo.init, or through the `data-host` attribute on the iframe element.'
									),
								(r && o) ||
									(_(p(a, 'sigRequest')),
									(r && o) ||
										d(
											'No valid signed request is given.  Be sure to give the `sig_request` parameter to Duo.init, or use the `data-sig-request` attribute on the iframe element.'
										)),
								'' === e && (e = p(a, 'postAction') || e),
								'sig_response' === t && (t = p(a, 'postArgument') || t),
								E(a))
							)
								(i = a).src = A();
							else {
								for (; a.firstChild; ) a.removeChild(a.firstChild);
								for (var l in ((i = document.createElement('iframe')), (s.src = A()), s)) i.setAttribute(l, s[l]);
								a.appendChild(i);
							}
							y(C);
						}
						function N(t) {
							e(t + ':' + o);
						}
						return c(), { init: O, _onReady: v, _parseSigRequest: _, _isDuoMessage: w, _doPostBack: N };
					})();
				},
				21576: function (e, t, n) {
					n(58245),
						n(58603),
						n(53950),
						n(27672),
						n(44799),
						n(91512),
						n(88991),
						n(89691),
						n(75497),
						n(70257),
						n(42075),
						n(72534),
						n(88150),
						n(24611),
						n(26397),
						n(560),
						n(20697),
						n(18470),
						n(87971),
						n(86797),
						n(61068),
						n(33268),
						n(23582),
						n(69765);
				},
				66757: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(15985)),
						i = r(n(6321)),
						a = r(n(35546));
					function s(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function l(e) {
						for (var t = 1; t < arguments.length; t++) {
							var n = null != arguments[t] ? arguments[t] : {};
							t % 2
								? s(Object(n), !0).forEach(function (t) {
										(0, o.default)(e, t, n[t]);
								  })
								: Object.getOwnPropertyDescriptors
								? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
								: s(Object(n)).forEach(function (t) {
										Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
								  });
						}
						return e;
					}
					var u = {};
					function c(e, t, n) {
						var r = i.default.defer();
						return (
							e.animate(
								{ 'text-indent': 1 },
								{
									duration: 200,
									easing: 'swing',
									step: function (r, o) {
										(o.start = t), (o.end = n), e.css('transform', 'scale(' + r + ', ' + r + ')');
									},
									always: function () {
										r.resolve(e);
									},
								}
							),
							r.promise
						);
					}
					function d(e, t, n) {
						var r = i.default.defer();
						return (
							e.animate(
								{ 'text-indent': 1 },
								{
									duration: 150,
									easing: 'swing',
									step: function (r, o) {
										(o.start = t), (o.end = n), e.css('transform', 'rotate(' + r + 'deg)');
									},
									always: function () {
										r.resolve(e);
									},
								}
							),
							r.promise
						);
					}
					(u.swapPages = function (e) {
						var t = i.default.defer(),
							n = e.$parent,
							r = e.$oldRoot,
							s = e.$newRoot,
							u = e.success,
							c = e.ctx,
							d = 'transition-from-right';
						e.dir && e.dir === a.default.DIRECTION_BACK && (d = 'transition-from-left'),
							s.addClass(d),
							n.append(s),
							n.addClass('animation-container-overflow');
						var f = { left: '0px', top: '0px', opacity: 1 };
						return (
							s.animate(f, 200, function () {
								n.removeClass('animation-container-overflow'), s.removeClass(d);
								var e = Object.keys(f).reduce(function (e, t) {
									return l(l({}, e), {}, (0, o.default)({}, t, ''));
								}, {});
								s.css(e), u.call(c), t.resolve();
							}),
							r.animate({ height: s.height(), opacity: 0 }, 160),
							t.promise
						);
					}),
						(u.swapBeacons = function (e) {
							var t = e.$el,
								n = e.swap,
								r = e.ctx;
							return this.implode(t)
								.then(function () {
									return n.call(r), t;
								})
								.then(this.explode);
						}),
						(u.explode = function (e) {
							return c(e, 0, 1);
						}),
						(u.implode = function (e) {
							return c(e, 1, 0);
						}),
						(u.radialProgressBar = function (e) {
							var t = e.$el,
								n = e.swap,
								r = t.children();
							return d(r, 0, 180)
								.then(function () {
									t.css({ clip: 'auto' });
								})
								.then(function () {
									var e = r.eq(0);
									return n(), d(e, 180, 360);
								})
								.then(function () {
									t.css({ clip: 'rect(0px, 96px, 96px, 48px)' }),
										r.css({ 'transform': 'rotate(0deg)', 'text-indent': '1px' });
								});
						});
					var f = u;
					(t.default = f), (e.exports = t.default);
				},
				28766: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(35546)),
						i = {};
					(i.lighten = function (e, t) {
						(t = t || 0), (e = e.substr(1));
						for (var n = '#', r = 0; r < 3; r++) {
							var o = parseInt(e.substr(2 * r, 2), 16);
							n += ('00' + (o = Math.round(Math.min(Math.max(0, o + o * t), 255)).toString(16))).substr(o.length);
						}
						return n;
					}),
						(i.addStyle = function (e, t) {
							var n = (function (e) {
									return '\n#okta-sign-in.auth-container .button-primary,\n#okta-sign-in.auth-container .button-primary:active,\n#okta-sign-in.auth-container .button-primary:focus { background: '
										.concat(e.brand, '; }\n#okta-sign-in.auth-container .button-primary:hover { background: ')
										.concat(
											i.lighten(e.brand, 0.05),
											'; }\n#okta-sign-in.auth-container .button.button-primary.link-button-disabled {\n  background: '
										)
										.concat(e.brand, ';\n  opacity: 0.5;\n}\n    ');
								})(e),
								r = document.getElementById(o.default.WIDGET_CONTAINER_ID),
								a = document.createElement('style');
							(a.id = o.default.WIDGET_CONFIG_COLORS_ID),
								(a.type = 'text/css'),
								t && (a.nonce = t),
								a.appendChild(document.createTextNode(n)),
								r.appendChild(a);
						}),
						(i.isLoaded = function () {
							return !!document.getElementById(o.default.WIDGET_CONFIG_COLORS_ID);
						});
					var a = i;
					(t.default = a), (e.exports = t.default);
				},
				26368: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475).internal.util.Cookie,
						o = 'ln',
						i = {
							getCookieUsername: function () {
								return r.getCookie(o);
							},
							setUsernameCookie: function (e) {
								r.setCookie(o, e, { expires: 365, path: '/' });
							},
							removeUsernameCookie: function () {
								r.removeCookie(o, { path: '/' });
							},
						},
						a = i;
					(t.default = a), (e.exports = t.default);
				},
				73390: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(87462)),
						i = n(71244),
						a = r(n(52115)),
						s = r(n(53512)),
						l = {
							getCountries: function () {
								var e = o.default.omit(a.default.country, 'HM', 'BV', 'TF'),
									t = o.default.map(e, function (e, t) {
										return { name: e, code: t };
									});
								t = o.default.sortBy(t, 'name');
								var n = {};
								return (
									o.default.each(t, function (e) {
										n[e.code] = e.name;
									}),
									n
								);
							},
							getCountryCode: function () {
								var e = o.default.omit(a.default.country, 'HM', 'BV', 'TF'),
									t = o.default.map(e, function (e, t) {
										return { name: e, code: t };
									});
								t = o.default.sortBy(t, 'name');
								var n = {};
								return (
									o.default.each(t, function (e) {
										n[e.code] = (0, i.loc)('country.option.label', 'login', [e.name, e.code]);
									}),
									n
								);
							},
							getCallingCodeForCountry: function (e) {
								return s.default[e];
							},
						},
						u = l;
					(t.default = u), (e.exports = t.default);
				},
				76587: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var n = {
							getStringHash: function (e) {
								for (var t = 5381, n = e.length; n; ) t = (33 * t) ^ e.charCodeAt(--n);
								return t >>> 0;
							},
							base64UrlSafeToBase64: function (e) {
								return e.replace(new RegExp('_', 'g'), '/').replace(new RegExp('-', 'g'), '+');
							},
							binToStr: function (e) {
								return btoa(
									new Uint8Array(e).reduce(function (e, t) {
										return e + String.fromCharCode(t);
									}, '')
								);
							},
							strToBin: function (e) {
								return Uint8Array.from(atob(this.base64UrlSafeToBase64(e)), function (e) {
									return e.charCodeAt(0);
								});
							},
						},
						r = n;
					(t.default = r), (e.exports = t.default);
				},
				35546: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					(t.default = {
						API_RATE_LIMIT: 3e4,
						WIDGET_LOGIN_CONTAINER_ID: 'signin-container',
						WIDGET_CONTAINER_ID: 'okta-sign-in',
						WIDGET_CONFIG_COLORS_ID: 'okta-sign-in-config-colors',
						DIRECTION_BACK: 'DIRECTION_BACK',
						RECOVERY_TYPE_PASSWORD: 'PASSWORD',
						RECOVERY_TYPE_UNLOCK: 'UNLOCK',
						RECOVERY_FACTOR_TYPE_SMS: 'SMS',
						RECOVERY_FACTOR_TYPE_EMAIL: 'EMAIL',
						RECOVERY_FACTOR_TYPE_CALL: 'CALL',
						IOS: 'ios',
						ANDROID: 'android',
						ODA: 'oda',
						MDM: 'mdm',
						WS1: 'ws1',
						SUCCESS: 'SUCCESS',
						FORGOT_PASSWORD_EMAIL_SENT: 'FORGOT_PASSWORD_EMAIL_SENT',
						UNLOCK_ACCOUNT_EMAIL_SENT: 'UNLOCK_ACCOUNT_EMAIL_SENT',
						CONFIG_ERROR: 'CONFIG_ERROR',
						UNSUPPORTED_BROWSER_ERROR: 'UNSUPPORTED_BROWSER_ERROR',
						OAUTH_ERROR: 'OAUTH_ERROR',
						AUTH_STOP_POLL_INITIATION_ERROR: 'AUTH_STOP_POLL_INITIATION_ERROR',
						U2F_ERROR: 'U2F_ERROR',
						WEB_AUTHN_ERROR: 'WEB_AUTHN_ERROR',
						WEBAUTHN_ABORT_ERROR: 'WEBAUTHN_ABORT_ERROR',
						CONFIGURED_FLOW_ERROR: 'CONFIGURED_FLOW_ERROR',
						ALL_OPTIONAL_NONE_ENROLLED: 'ALL_OPTIONAL_NONE_ENROLLED',
						ALL_OPTIONAL_SOME_ENROLLED: 'ALL_OPTIONAL_SOME_ENROLLED',
						HAS_REQUIRED_NONE_ENROLLED: 'HAS_REQUIRED_NONE_ENROLLED',
						HAS_REQUIRED_SOME_REQUIRED_ENROLLED: 'HAS_REQUIRED_SOME_REQUIRED_ENROLLED',
						HAS_REQUIRED_ALL_REQUIRED_ENROLLED: 'HAS_REQUIRED_ALL_REQUIRED_ENROLLED',
						PRIMARY_AUTH: 'PRIMARY_AUTH',
						FORGOT_PASSWORD: 'FORGOT_PASSWORD',
						UNLOCK_ACCOUNT: 'UNLOCK_ACCOUNT',
						SESSION_SSO: 'SESSION_SSO',
						SESSION_STEP_UP: 'SESSION_STEP_UP',
						ACTIVATION_EMAIL_SENT: 'ACTIVATION_EMAIL_SENT',
						REGISTRATION_COMPLETE: 'REGISTRATION_COMPLETE',
						REGISTRATION_FAILED: 'REGISTRATION_FAILED',
						IDP_DISCOVERY: 'IDP_DISCOVERY',
						OKTA_VERIFY_APPLE_APP_STORE_URL: 'https://apps.apple.com/us/app/okta-verify/id490179405',
						OKTA_VERIFY_GOOGLE_PLAY_STORE_URL: 'https://play.google.com/store/apps/details?id=com.okta.android.auth',
						LOOPBACK_CHALLENGE: 'LOOPBACK',
						CUSTOM_URI_CHALLENGE: 'CUSTOM_URI',
						UNIVERSAL_LINK_CHALLENGE: 'UNIVERSAL_LINK',
						APP_LINK_CHALLENGE: 'APP_LINK',
						CHROME_DTC: 'CHROME_DTC',
					}),
						(e.exports = t.default);
				},
				88882: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					(t.default = { INVALID_TOKEN_EXCEPTION: 'E0000011' }), (e.exports = t.default);
				},
				2645: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(87462)),
						i = n(71244),
						a = r(n(30471)),
						s = {},
						l = {
							OKTA_VERIFY: {
								label: 'factor.totpSoft.oktaVerify',
								description: 'factor.totpSoft.description',
								iconClassName: 'mfa-okta-verify',
								sortOrder: 1,
							},
							OKTA_VERIFY_PUSH: {
								label: 'factor.oktaVerifyPush',
								description: 'factor.push.description',
								iconClassName: 'mfa-okta-verify',
								sortOrder: 1,
							},
							U2F: {
								label: 'factor.u2f',
								description: function (e) {
									return e ? 'factor.u2f.description.specific' : 'factor.u2f.description.generic';
								},
								iconClassName: 'mfa-u2f',
								sortOrder: 2,
							},
							WEBAUTHN: {
								label: 'factor.webauthn.biometric',
								description: 'factor.webauthn.biometric.description',
								iconClassName: 'mfa-webauthn',
								sortOrder: 2,
							},
							WINDOWS_HELLO: {
								label: 'factor.windowsHello',
								description: function (e) {
									return e
										? 'factor.windowsHello.signin.description.specific'
										: 'factor.windowsHello.signin.description.generic';
								},
								iconClassName: 'mfa-windows-hello',
								sortOrder: 3,
							},
							YUBIKEY: {
								label: 'factor.totpHard.yubikey',
								description: 'factor.totpHard.yubikey.description',
								iconClassName: 'mfa-yubikey',
								sortOrder: 4,
							},
							GOOGLE_AUTH: {
								label: 'factor.totpSoft.googleAuthenticator',
								description: 'factor.totpSoft.description',
								iconClassName: 'mfa-google-auth',
								sortOrder: 5,
							},
							CUSTOM_HOTP: {
								label: '',
								description: 'factor.hotp.description',
								iconClassName: 'mfa-hotp',
								sortOrder: 6,
							},
							SMS: {
								label: 'factor.sms',
								description: 'factor.sms.description',
								iconClassName: 'mfa-okta-sms',
								sortOrder: 7,
							},
							CALL: {
								label: 'factor.call',
								description: 'factor.call.description',
								iconClassName: 'mfa-okta-call',
								sortOrder: 8,
							},
							EMAIL: {
								label: 'factor.email',
								description: 'factor.email.description',
								iconClassName: 'mfa-okta-email',
								sortOrder: 9,
							},
							QUESTION: {
								label: 'factor.securityQuestion',
								description: 'factor.securityQuestion.description',
								iconClassName: 'mfa-okta-security-question',
								sortOrder: 10,
							},
							DUO: {
								label: 'factor.duo',
								description: 'factor.duo.description',
								iconClassName: 'mfa-duo',
								sortOrder: 11,
							},
							SYMANTEC_VIP: {
								label: 'factor.totpHard.symantecVip',
								description: 'factor.totpHard.description',
								iconClassName: 'mfa-symantec',
								sortOrder: 12,
							},
							RSA_SECURID: {
								label: 'factor.totpHard.rsaSecurId',
								description: 'factor.totpHard.description',
								iconClassName: 'mfa-rsa',
								sortOrder: 13,
							},
							ON_PREM: {
								label: '',
								description: 'factor.totpHard.description',
								iconClassName: 'mfa-onprem',
								sortOrder: 14,
							},
							PASSWORD: {
								label: 'factor.password',
								description: '',
								iconClassName: 'mfa-okta-password',
								sortOrder: 15,
							},
							CUSTOM_CLAIMS: {
								label: '',
								description: 'factor.customFactor.description',
								iconClassName: 'mfa-custom-factor',
								sortOrder: 16,
							},
							GENERIC_SAML: {
								label: '',
								description: function (e) {
									return e ? 'factor.customFactor.description.specific' : 'factor.customFactor.description.generic';
								},
								iconClassName: 'mfa-custom-factor',
								sortOrder: 17,
							},
							GENERIC_OIDC: {
								label: '',
								description: function (e) {
									return e ? 'factor.customFactor.description.specific' : 'factor.customFactor.description.generic';
								},
								iconClassName: 'mfa-custom-factor',
								sortOrder: 18,
							},
						},
						u = function (e, t, n) {
							var r = { complexity: [], history: [], age: [] };
							r.complexity = (function (e, t) {
								if (e.complexity) {
									var n = t.complexity,
										r = (function (e) {
											var t = e.excludeAttributes;
											return (
												(e.excludeFirstName = o.default.contains(t, 'firstName')),
												(e.excludeLastName = o.default.contains(t, 'lastName')),
												o.default.omit(e, 'excludeAttributes')
											);
										})(e.complexity),
										a = r;
									r.useADComplexityRequirements &&
										(a = o.default.pick(r, [
											'minLength',
											'useADComplexityRequirements',
											'excludeUsername',
											'excludeFirstName',
											'excludeLastName',
											'excludeAttributes',
										]));
									var s = o.default.map(a, function (e, t) {
										if (!(e <= 0)) {
											var r = n[t];
											return r.args ? (0, i.loc)(r.i18n, 'login', [e]) : (0, i.loc)(r.i18n, 'login');
										}
									});
									return o.default.compact(s);
								}
								return [];
							})(e, t);
							var s = (function (e, t, n) {
								return e.age && e.age.historyCount > 0
									? n
										? 1 === e.age.historyCount
											? (0, i.loc)(t.history.one.i18n, 'login')
											: (0, i.loc)(t.history.many.i18n, 'login', [e.age.historyCount])
										: (0, i.loc)(t.history.i18n, 'login', [e.age.historyCount])
									: null;
							})(e, t, n);
							s && r.history.push(s);
							var l = (function (e, t) {
								return e.age && e.age.minAgeMinutes > 0
									? (function (e) {
											var n;
											switch (e.unit) {
												case 'DAY':
													n = t.age.days.i18n;
													break;
												case 'HOUR':
													n = t.age.hours.i18n;
													break;
												case 'MINUTE':
													n = t.age.minutes.i18n;
											}
											return (0, i.loc)(n, 'login', [e.time]);
									  })(a.default.getTimeInHighestRelevantUnit(e.age.minAgeMinutes, 'MINUTE'))
									: null;
							})(e, t);
							return l && r.age.push(l), r;
						};
					(s.getFactorName = function (e, t) {
						return 'OKTA' === e && 'token:software:totp' === t
							? 'OKTA_VERIFY'
							: 'OKTA' === e && 'push' === t
							? 'OKTA_VERIFY_PUSH'
							: 'GOOGLE' === e
							? 'GOOGLE_AUTH'
							: 'SYMANTEC' === e && 'token' === t
							? 'SYMANTEC_VIP'
							: 'RSA' === e && 'token' === t
							? 'RSA_SECURID'
							: 'DEL_OATH' === e && 'token' === t
							? 'ON_PREM'
							: 'DUO' === e && 'web' === t
							? 'DUO'
							: 'YUBICO' === e && 'token:hardware' === t
							? 'YUBIKEY'
							: 'OKTA' === e && 'sms' === t
							? 'SMS'
							: 'OKTA' === e && 'call' === t
							? 'CALL'
							: 'OKTA' === e && 'question' === t
							? 'QUESTION'
							: 'OKTA' === e && 'email' === t
							? 'EMAIL'
							: 'OKTA' === e && 'password' === t
							? 'PASSWORD'
							: 'GENERIC_SAML' === e && 'assertion:saml2' === t
							? 'GENERIC_SAML'
							: 'GENERIC_OIDC' === e && 'assertion:oidc' === t
							? 'GENERIC_OIDC'
							: s.getFactorNameForFactorType.call(this, t);
					}),
						(s.getFactorNameForFactorType = function (e) {
							return 'u2f' === e
								? 'U2F'
								: 'token:software:totp' === e
								? 'OKTA_VERIFY'
								: 'webauthn' === e
								? this.settings.get('features.webauthn')
									? 'WEBAUTHN'
									: 'WINDOWS_HELLO'
								: 'token:hotp' === e
								? 'CUSTOM_HOTP'
								: 'claims_provider' === e
								? 'CUSTOM_CLAIMS'
								: void 0;
						}),
						(s.isOktaVerify = function (e, t) {
							return 'OKTA' === e && ('token:software:totp' === t || 'push' === t);
						}),
						(s.getFactorLabel = function (e, t) {
							var n = l[s.getFactorName.apply(this, [e, t])].label;
							return (0, i.loc)(n, 'login');
						}),
						(s.getFactorDescription = function (e, t) {
							var n = l[s.getFactorName.apply(this, [e, t])].description;
							if (o.default.isFunction(n)) {
								var r = this.settings.get('brandName'),
									a = n(r);
								return r ? (0, i.loc)(a, 'login', [r]) : (0, i.loc)(a, 'login');
							}
							return n ? (0, i.loc)(n, 'login') : '';
						}),
						(s.getFactorIconClassName = function (e, t) {
							return l[s.getFactorName.apply(this, [e, t])].iconClassName;
						}),
						(s.getFactorSortOrder = function (e, t) {
							return l[s.getFactorName.apply(this, [e, t])].sortOrder;
						}),
						(s.getRememberDeviceValue = function (e) {
							return e && e.get('rememberDeviceByDefault');
						}),
						(s.getSecurityQuestionLabel = function (e) {
							var t = (0, i.loc)('security.' + e.question);
							return t.indexOf('L10N_ERROR') < 0 ? t : e.questionText;
						}),
						(s.removeRequirementsFromError = function (e, t) {
							var n = this.getPasswordComplexityDescription(t);
							return (
								e.errorCauses &&
									e.errorCauses.length > 0 &&
									o.default.isString(e.errorCauses[0].errorSummary) &&
									(e.errorCauses[0].errorSummary = e.errorCauses[0].errorSummary.replace(n, '').trim()),
								e
							);
						}),
						(s.getPasswordComplexityDescriptionForHtmlList = function (e) {
							var t = u(
								e,
								{
									complexity: {
										minLength: { i18n: 'password.complexity.length.description', args: !0 },
										minLowerCase: { i18n: 'password.complexity.lowercase.description' },
										minUpperCase: { i18n: 'password.complexity.uppercase.description' },
										minNumber: { i18n: 'password.complexity.number.description' },
										minSymbol: { i18n: 'password.complexity.symbol.description' },
										excludeUsername: { i18n: 'password.complexity.no_username.description' },
										excludeFirstName: { i18n: 'password.complexity.no_first_name.description' },
										excludeLastName: { i18n: 'password.complexity.no_last_name.description' },
										useADComplexityRequirements: { i18n: 'password.complexity.adRequirements.description' },
										maxConsecutiveRepeatingCharacters: {
											i18n: 'password.complexity.maxConsecutiveRepeatingCharacters.description',
											args: !0,
										},
									},
									history: {
										one: { i18n: 'password.complexity.history.one.description' },
										many: { i18n: 'password.complexity.history.description' },
									},
									age: {
										minutes: { i18n: 'password.complexity.minAgeMinutes.description' },
										hours: { i18n: 'password.complexity.minAgeHours.description' },
										days: { i18n: 'password.complexity.minAgeDays.description' },
									},
								},
								!0
							);
							return o.default.union(t.complexity, t.history, t.age);
						}),
						(s.getPasswordComplexityDescription = function (e) {
							var t = [],
								n = u(
									e,
									{
										complexity: {
											minLength: { i18n: 'password.complexity.length', args: !0 },
											minLowerCase: { i18n: 'password.complexity.lowercase' },
											minUpperCase: { i18n: 'password.complexity.uppercase' },
											minNumber: { i18n: 'password.complexity.number' },
											minSymbol: { i18n: 'password.complexity.symbol' },
											excludeUsername: { i18n: 'password.complexity.no_username' },
											excludeFirstName: { i18n: 'password.complexity.no_first_name' },
											excludeLastName: { i18n: 'password.complexity.no_last_name' },
											useADComplexityRequirements: { i18n: 'password.complexity.adRequirements' },
											maxConsecutiveRepeatingCharacters: {
												i18n: 'password.complexity.maxConsecutiveRepeatingCharacters',
												args: !0,
											},
										},
										history: { i18n: 'password.complexity.history' },
										age: {
											minutes: { i18n: 'password.complexity.minAgeMinutes' },
											hours: { i18n: 'password.complexity.minAgeHours' },
											days: { i18n: 'password.complexity.minAgeDays' },
										},
									},
									!1
								),
								r = n.complexity;
							return (
								r.length > 0 &&
									((r = o.default.reduce(r, function (e, t) {
										return e ? e + (0, i.loc)('password.complexity.list.element', 'login', [t]) : t;
									})),
									t.push((0, i.loc)('password.complexity.requirements', 'login', [r]))),
								t.push(n.history[0]),
								t.push(n.age[0]),
								o.default.compact(t).join(' ')
							);
						}),
						(s.getCardinalityText = function (e, t, n) {
							if (n) {
								if (e)
									return 1 === n.enrolled ? '' : (0, i.loc)('enroll.choices.cardinality.setup', 'login', [n.enrolled]);
								if (t && n.maximum > 1)
									return (0, i.loc)('enroll.choices.cardinality.setup.remaining', 'login', [n.enrolled, n.minimum]);
							}
							return '';
						}),
						(s.findFactorInFactorsArray = function (e, t, n) {
							var r = e.findWhere({ provider: t, factorType: n });
							return void 0 === r && (r = e.findWhere({ factorType: n })), r;
						});
					var c = s;
					(t.default = c), (e.exports = t.default);
				},
				14726: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(71244),
						o = {
							getU2fEnrollErrorMessageKeyByCode: function (e) {
								switch (e) {
									default:
									case 1:
										return 'u2f.error.other';
									case 2:
									case 3:
										return 'u2f.error.badRequest';
									case 4:
										return 'u2f.error.unsupported';
									case 5:
										return 'u2f.error.timeout';
								}
							},
							getU2fVerifyErrorMessageKeyByCode: function (e, t) {
								switch (e) {
									case 1:
										return t ? 'u2f.error.other.oneFactor' : 'u2f.error.other';
									case 2:
									case 3:
										return t ? 'u2f.error.badRequest.oneFactor' : 'u2f.error.badRequest';
									case 4:
										return t ? 'u2f.error.unsupported.oneFactor' : 'u2f.error.unsupported';
									case 5:
										return 'u2f.error.timeout';
								}
							},
							getU2fEnrollErrorMessageByCode: function (e) {
								return (0, r.loc)(o.getU2fEnrollErrorMessageKeyByCode(e), 'login');
							},
							getU2fVerifyErrorMessageByCode: function (e, t) {
								return (0, r.loc)(o.getU2fVerifyErrorMessageKeyByCode(e, t), 'login');
							},
							getU2fVersion: function () {
								return 'U2F_V2';
							},
							isU2fAvailable: function () {
								return Object.prototype.hasOwnProperty.call(window, 'u2f');
							},
						},
						i = o;
					(t.default = i), (e.exports = t.default);
				},
				53736: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.executeHookFunctions = a),
						(t.executeHooksAfter = function (e) {
							return u.apply(this, arguments);
						}),
						(t.executeHooksBefore = function (e) {
							return l.apply(this, arguments);
						}),
						(t.mergeHook = function (e, t, n) {
							var r = (e[t] = e[t] || { before: [], after: [] });
							n.before && (r.before = (r.before || []).concat(n.before));
							n.after && (r.after = (r.after || []).concat(n.after));
						});
					var o = r(n(70232)),
						i = r(n(31049));
					function a(e) {
						return s.apply(this, arguments);
					}
					function s() {
						return (s = (0, i.default)(
							o.default.mark(function e(t) {
								var n;
								return o.default.wrap(function (e) {
									for (;;)
										switch ((e.prev = e.next)) {
											case 0:
												n = 0;
											case 1:
												if (!(n < t.length)) {
													e.next = 7;
													break;
												}
												return (e.next = 4), t[n]();
											case 4:
												n++, (e.next = 1);
												break;
											case 7:
											case 'end':
												return e.stop();
										}
								}, e);
							})
						)).apply(this, arguments);
					}
					function l() {
						return (l = (0, i.default)(
							o.default.mark(function e(t) {
								return o.default.wrap(function (e) {
									for (;;)
										switch ((e.prev = e.next)) {
											case 0:
												if (t && t.before && t.before.length) {
													e.next = 2;
													break;
												}
												return e.abrupt('return');
											case 2:
												return (e.next = 4), a(t.before);
											case 4:
											case 'end':
												return e.stop();
										}
								}, e);
							})
						)).apply(this, arguments);
					}
					function u() {
						return (u = (0, i.default)(
							o.default.mark(function e(t) {
								return o.default.wrap(function (e) {
									for (;;)
										switch ((e.prev = e.next)) {
											case 0:
												if (t && t.after && t.after.length) {
													e.next = 2;
													break;
												}
												return e.abrupt('return');
											case 2:
												return (e.next = 4), a(t.after);
											case 4:
											case 'end':
												return e.stop();
										}
								}, e);
							})
						)).apply(this, arguments);
					}
				},
				78719: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var n = {
						SUPPORTED_SOCIAL_IDPS: [
							'facebook',
							'google',
							'linkedin',
							'microsoft',
							'apple',
							'github',
							'gitlab',
							'yahoo',
							'line',
							'paypal',
							'paypal_sandbox',
							'salesforce',
							'amazon',
							'yahoojp',
							'discord',
							'adobe',
							'orcid',
							'spotify',
							'xero',
							'quickbooks',
						],
					};
					(t.default = n), (e.exports = t.default);
				},
				42804: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(52115)),
						i = r(n(7174));
					var a = {
						loadLanguage: function (e, t) {
							var n = e.get('languageCode') || t.get('languageCode') || i.default.defaultLanguage,
								r = t.get('i18n'),
								a = t.get('assets.baseUrl'),
								s = t.get('assets.rewrite'),
								l = t.get('supportedLanguages'),
								u = setTimeout(function () {
									e.trigger('loading', !0);
								}, 200);
							return o.default.loadLanguage(n, r, { baseUrl: a, rewrite: s }, l).then(function () {
								clearTimeout(u), e.trigger('loading', !1), e.trigger('removeLoading');
							});
						},
					};
					(t.default = a), (e.exports = t.default);
				},
				36894: function (e, t) {
					'use strict';
					function n(e, t) {
						var n, r, o;
						('error' === e ||
							(null !== (n = window) &&
								void 0 !== n &&
								null !== (r = n.OktaSignInDebug) &&
								void 0 !== r &&
								null !== (o = r.isEnabled) &&
								void 0 !== o &&
								o.call(r))) &&
							window.console[e].apply(window.console, t);
					}
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = {
						trace: function () {
							return n('trace', arguments);
						},
						dir: function () {
							return n('dir', arguments);
						},
						time: function () {
							return n('time', arguments);
						},
						timeEnd: function () {
							return n('timeEnd', arguments);
						},
						group: function () {
							return n('group', arguments);
						},
						groupEnd: function () {
							return n('groupEnd', arguments);
						},
						assert: function () {
							return n('assert', arguments);
						},
						log: function () {
							return n('log', arguments);
						},
						info: function () {
							return n('info', arguments);
						},
						warn: function () {
							return n('warn', arguments);
						},
						error: function () {
							return n('error', arguments);
						},
						deprecate: function (e) {
							return n('warn', ['[okta-signin-widget] DEPRECATED:', e]);
						},
					};
					(t.default = r), (e.exports = t.default);
				},
				97329: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(87462)),
						i = n(71244),
						a = r(n(35546)),
						s = n(45570),
						l = r(n(90570)),
						u = {},
						c = [
							'responseType',
							'scopes',
							'state',
							'nonce',
							'idp',
							'idpScope',
							'display',
							'prompt',
							'maxAge',
							'loginHint',
						];
					(u.AUTH_PARAMS = c),
						(u.getTokens = function (e, t, n) {
							function r(t) {
								e.callGlobalSuccess(a.default.SUCCESS, t);
							}
							function u(t) {
								var r = (0, s.getTypedOAuthError)(t);
								r.is('terminal')
									? (n.model.appState.set('flashError', r), n.model.appState.trigger('navigate', 'signin/error'))
									: r.is('inline') &&
									  (n.model.trigger('error', n.model, { responseJSON: { errorSummary: r.errorDetails.errorSummary } }),
									  n.model.appState.trigger('removeLoading')),
									r.is('terminal') || l.default.triggerAfterError(n, r, e),
									r instanceof s.NonRecoverableError && e.callGlobalError(r);
							}
							var d = e.getAuthClient(),
								f = d.isAuthorizationCodeFlow() && !d.isPKCE(),
								p = e.toJSON({ verbose: !0 }),
								h = {};
							o.default.extend(h, o.default.pick(p, 'clientId', 'redirectUri'), o.default.pick(p.authParams, c), t),
								(h.popupTitle = (0, i.loc)('socialauth.popup.title', 'login')),
								(h.timeout = p.oAuthTimeout),
								'always' === p.redirect || f
									? d.token.getWithRedirect(h).catch(u)
									: h.sessionToken
									? d.token.getWithoutPrompt(h).then(r).catch(u)
									: d.token.getWithPopup(h).then(r).catch(u);
						});
					var d = u;
					(t.default = d), (e.exports = t.default);
				},
				30471: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(15985)),
						i = r(n(72284)),
						a = r(n(67820)),
						s = { MILLISECOND: 'milliseconds', SECOND: 'seconds', MINUTE: 'minutes', HOUR: 'hours', DAY: 'days' },
						l = Object.keys(s),
						u = {
							getTimeInHighestRelevantUnit: function (e, t) {
								var n,
									r = s[t] || t;
								try {
									var u = (0, i.default)(
										Object.assign(
											{ days: 0, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 },
											(0, o.default)({}, r, e)
										)
									);
									n = (0, a.default)(u);
								} catch (e) {
									n = {};
								}
								var c,
									d,
									f,
									p,
									h = Object.keys(n).reduce(function (e, t) {
										return 0 !== n[t] && (e[t] = n[t]), e;
									}, {});
								return (
									1 === Object.keys(h).length
										? Object.keys(h).forEach(function (e) {
												(d = h[e]), (c = e);
										  })
										: ((d = e), (c = r)),
									{
										time: d,
										unit:
											((f = c),
											(p = l.filter(function (e) {
												return s[e] === f;
											})),
											1 === p.length ? p[0] : f),
									}
								);
							},
							formatDateToDeviceAssuranceGracePeriodExpiryLocaleString: function (e, t) {
								var n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
								try {
									return e && !isNaN(e.valueOf()) && null !== t
										? (n && e.setMinutes(0, 0, 0),
										  e.toLocaleString(t, {
												year: 'numeric',
												month: '2-digit',
												day: '2-digit',
												hour: '2-digit',
												minute: '2-digit',
												timeZoneName: 'short',
										  }))
										: null;
								} catch (e) {
									return null;
								}
							},
							calculateDaysBetween: function (e, t) {
								try {
									if ('number' == typeof e && 'number' == typeof t) {
										var n = Math.abs(t - e);
										return Math.floor(n / 864e5);
									}
								} catch (e) {}
								return null;
							},
						};
					(t.default = u), (e.exports = t.default);
				},
				90570: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(87462)),
						a = n(71244),
						s = r(n(35546)),
						l = r(n(36894)),
						u = r(n(34425)),
						c = {},
						d = function (e, t) {
							var n = document.createElement('input');
							return (n.name = e), (n.value = decodeURIComponent(t)), (n.type = 'hidden'), n;
						},
						f = function () {
							var e = document.createElement('input');
							return (e.type = 'submit'), e;
						},
						p = function () {
							var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '',
								t = arguments.length > 1 ? arguments[1] : void 0,
								n = e.split('#'),
								r = n[1],
								o = (n[0] || '').split('?'),
								i = o[1],
								a = o[0];
							r && (a += '#' + r);
							var s = document.createElement('form');
							if (((s.method = t), (s.style.display = 'none'), (s.action = a), i && i.length)) {
								var l = i.split('&');
								l.forEach(function (e) {
									var t = e.split('='),
										n = d(t[0], t[1]);
									s.appendChild(n);
								});
							}
							return s.appendChild(f()), s;
						};
					function h(e) {
						for (var t = [e], n = e.split('-'); n.pop() && n.length > 0; ) t.push(n.join('-'));
						return t;
					}
					(c.transformErrorXHR = function (e) {
						if (0 === e.status && i.default.isEmpty(e.responseJSON))
							return (e.responseJSON = { errorSummary: (0, a.loc)('error.network.connection', 'login') }), e;
						if (!e.responseJSON) {
							if (!e.responseText)
								return (e.responseJSON = { errorSummary: (0, a.loc)('error.unsupported.response', 'login') }), e;
							if ('string' == typeof e.responseText)
								try {
									e.responseJSON = JSON.parse(e.responseText);
								} catch (t) {
									return (e.responseJSON = { errorSummary: (0, a.loc)('error.unsupported.response', 'login') }), e;
								}
							else 'object' === (0, o.default)(e.responseText) && (e.responseJSON = e.responseText);
						}
						if (
							(e.responseJSON &&
								e.responseJSON.errorCauses &&
								e.responseJSON.errorCauses.length &&
								(e.responseJSON.errorSummary = e.responseJSON.errorCauses[0].errorSummary),
							!i.default.isEmpty(e.responseJSON))
						) {
							var t = e.responseJSON.errorCode,
								n =
									t && (0, a.doesTranslationExist)('errors.' + t, 'login')
										? (0, a.loc)('errors.' + t, 'login', [], !0)
										: void 0;
							-1 === (null == n ? void 0 : n.indexOf('L10N_ERROR[')) &&
								((e.responseJSON.errorSummary = n),
								e.responseJSON &&
									e.responseJSON.errorCauses &&
									e.responseJSON.errorCauses.length &&
									delete e.responseJSON.errorCauses);
						}
						return e;
					}),
						(c.toLower = function (e) {
							return i.default.map(e, function (e) {
								return e.toLowerCase();
							});
						}),
						(c.expandLanguages = function (e) {
							return i.default.chain(e).map(h).flatten().uniq().value();
						}),
						(c.callAfterTimeout = function (e, t) {
							return setTimeout(e, t);
						}),
						(c.callAfterTimeoutOrWindowRefocus = function (e, t) {
							var n,
								r,
								o = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
								i = function () {
									if ((document.removeEventListener('visibilitychange', r), !o)) return e();
									setTimeout(e, t);
								};
							return (
								(r = function () {
									document.hidden ? clearTimeout(n) : i();
								}),
								document.addEventListener('visibilitychange', r),
								(n = setTimeout(i, t)),
								function () {
									clearTimeout(n), document.removeEventListener('visibilitychange', r);
								}
							);
						}),
						(c.debugMessage = function (e) {
							l.default.warn('\n'.concat(e.replace(/^(\s)+/gm, '')));
						}),
						(c.logConsoleError = function (e) {
							l.default.error(e);
						}),
						(c.triggerAfterError = function (e) {
							var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
							!t.statusCode && t.xhr && t.xhr.status && (t.statusCode = t.xhr.status);
							var n = i.default.isFunction(e.className) ? e.className() : e.className,
								r = i.default.pick(t, 'name', 'message', 'statusCode', 'xhr');
							e.trigger('afterError', { controller: n }, r), l.default.warn('controller: ' + n + ', error: ' + r);
						}),
						(c.redirect = function (e) {
							var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : window,
								n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
							u.default.isAndroid() && !n ? c.redirectWithFormGet(e) : c.changeLocation(e, t);
						}),
						(c.changeLocation = function (e) {
							var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : window;
							e ? (t.location.href = e) : l.default.error('Cannot redirect to empty URL: ('.concat(e, ')'));
						}),
						(c.executeOnVisiblePage = function (e) {
							if ('hidden' === document.visibilityState) {
								document.addEventListener('visibilitychange', function t() {
									'visible' === document.visibilityState && (document.removeEventListener('visibilitychange', t), e());
								});
							} else e();
						}),
						(c.redirectWithFormGet = function (e) {
							c.redirectWithForm(e, 'get');
						}),
						(c.redirectWithForm = function (e) {
							var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 'post';
							if (e) {
								var n = document.getElementById(s.default.WIDGET_CONTAINER_ID);
								if (n) {
									var r = p(e, t);
									n.appendChild(r), r.querySelector('input[type="submit"]').click();
								} else l.default.error('Cannot find okta-sign-in container append to which a form');
							} else l.default.error('Cannot redirect to empty URL: ('.concat(e, ')'));
						}),
						(c.createInputExplain = function (e, t, n, r, o) {
							var i = r ? (0, a.loc)(e, n, r) : (0, a.loc)(e, n);
							return i !== (o ? (0, a.loc)(t, n, o) : (0, a.loc)(t, n)) && i;
						}),
						(c.isV1StateToken = function (e) {
							return !!(e && i.default.isString(e) && e.startsWith('00'));
						}),
						(c.getAutocompleteValue = function (e, t) {
							return (null == e ? void 0 : e.get('features.disableAutocomplete')) ? 'off' : t;
						}),
						(c.searchParamsToString = function (e) {
							return Object.keys(e)
								.filter(function (t) {
									var n = e[t];
									return null != n;
								})
								.map(function (t) {
									return encodeURIComponent(t) + '=' + encodeURIComponent(e[t]);
								})
								.join('&');
						});
					var m = c;
					(t.default = m), (e.exports = t.default);
				},
				53512: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					(t.default = {
						'US': '1',
						'AG': '1',
						'AI': '1',
						'AS': '1',
						'BB': '1',
						'BM': '1',
						'BS': '1',
						'CA': '1',
						'DM': '1',
						'DO': '1',
						'GD': '1',
						'GU': '1',
						'JM': '1',
						'KN': '1',
						'KY': '1',
						'LC': '1',
						'MP': '1',
						'MS': '1',
						'PR': '1',
						'SX': '1',
						'TC': '1',
						'TT': '1',
						'VC': '1',
						'VG': '1',
						'VI': '1',
						'RU': '7',
						'KZ': '7',
						'EG': '20',
						'ZA': '27',
						'GR': '30',
						'NL': '31',
						'BE': '32',
						'FR': '33',
						'ES': '34',
						'HU': '36',
						'IT': '39',
						'VA': '39',
						'RO': '40',
						'CH': '41',
						'AT': '43',
						'GB': '44',
						'GG': '44',
						'IM': '44',
						'JE': '44',
						'DK': '45',
						'SE': '46',
						'NO': '47',
						'SJ': '47',
						'PL': '48',
						'DE': '49',
						'PE': '51',
						'MX': '52',
						'CU': '53',
						'AR': '54',
						'BR': '55',
						'CL': '56',
						'CO': '57',
						'VE': '58',
						'MY': '60',
						'AU': '61',
						'CC': '61',
						'CX': '61',
						'ID': '62',
						'PH': '63',
						'NZ': '64',
						'SG': '65',
						'TH': '66',
						'JP': '81',
						'KR': '82',
						'VN': '84',
						'CN': '86',
						'TR': '90',
						'IN': '91',
						'PK': '92',
						'AF': '93',
						'LK': '94',
						'MM': '95',
						'IR': '98',
						'SS': '211',
						'MA': '212',
						'EH': '212',
						'DZ': '213',
						'TN': '216',
						'LY': '218',
						'GM': '220',
						'SN': '221',
						'MR': '222',
						'ML': '223',
						'GN': '224',
						'CI': '225',
						'BF': '226',
						'NE': '227',
						'TG': '228',
						'BJ': '229',
						'MU': '230',
						'LR': '231',
						'SL': '232',
						'GH': '233',
						'NG': '234',
						'TD': '235',
						'CF': '236',
						'CM': '237',
						'CV': '238',
						'ST': '239',
						'GQ': '240',
						'GA': '241',
						'CG': '242',
						'CD': '243',
						'AO': '244',
						'GW': '245',
						'IO': '246',
						'AC': '247',
						'SC': '248',
						'SD': '249',
						'RW': '250',
						'ET': '251',
						'SO': '252',
						'DJ': '253',
						'KE': '254',
						'TZ': '255',
						'UG': '256',
						'BI': '257',
						'MZ': '258',
						'ZM': '260',
						'MG': '261',
						'RE': '262',
						'YT': '262',
						'ZW': '263',
						'NA': '264',
						'MW': '265',
						'LS': '266',
						'BW': '267',
						'SZ': '268',
						'KM': '269',
						'SH': '290',
						'TA': '290',
						'ER': '291',
						'AW': '297',
						'FO': '298',
						'GL': '299',
						'GI': '350',
						'PT': '351',
						'LU': '352',
						'IE': '353',
						'IS': '354',
						'AL': '355',
						'MT': '356',
						'CY': '357',
						'FI': '358',
						'AX': '358',
						'BG': '359',
						'LT': '370',
						'LV': '371',
						'EE': '372',
						'MD': '373',
						'AM': '374',
						'BY': '375',
						'AD': '376',
						'MC': '377',
						'SM': '378',
						'UA': '380',
						'RS': '381',
						'ME': '382',
						'XK': '383',
						'HR': '385',
						'SI': '386',
						'BA': '387',
						'MK': '389',
						'CZ': '420',
						'SK': '421',
						'LI': '423',
						'FK': '500',
						'BZ': '501',
						'GT': '502',
						'SV': '503',
						'HN': '504',
						'NI': '505',
						'CR': '506',
						'PA': '507',
						'PM': '508',
						'HT': '509',
						'GP': '590',
						'BL': '590',
						'MF': '590',
						'BO': '591',
						'GY': '592',
						'EC': '593',
						'GF': '594',
						'PY': '595',
						'MQ': '596',
						'SR': '597',
						'UY': '598',
						'CW': '599',
						'BQ': '599',
						'TL': '670',
						'NF': '672',
						'BN': '673',
						'NR': '674',
						'PG': '675',
						'TO': '676',
						'SB': '677',
						'VU': '678',
						'FJ': '679',
						'PW': '680',
						'WF': '681',
						'CK': '682',
						'NU': '683',
						'WS': '685',
						'KI': '686',
						'NC': '687',
						'TV': '688',
						'PF': '689',
						'TK': '690',
						'FM': '691',
						'MH': '692',
						'001': '979',
						'KP': '850',
						'HK': '852',
						'MO': '853',
						'KH': '855',
						'LA': '856',
						'BD': '880',
						'TW': '886',
						'MV': '960',
						'LB': '961',
						'JO': '962',
						'SY': '963',
						'IQ': '964',
						'KW': '965',
						'SA': '966',
						'YE': '967',
						'OM': '968',
						'PS': '970',
						'AE': '971',
						'IL': '972',
						'BH': '973',
						'QA': '974',
						'BT': '975',
						'MN': '976',
						'NP': '977',
						'TJ': '992',
						'TM': '993',
						'AZ': '994',
						'GE': '995',
						'KG': '996',
						'UZ': '998',
						'GS': '500',
						'PN': '64',
						'AQ': '672',
						'UM': '1',
						'AN': '599',
					}),
						(e.exports = t.default);
				},
				49268: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(70232)),
						i = r(n(31049)),
						a = r(n(6321)),
						s = r(n(14726));
					function l(e) {
						return new a.default(e);
					}
					var u,
						c = {
							makeCredential: function (e, t, n) {
								return (
									(t = t.map(function (e) {
										return { type: 'FIDO_2_0', algorithm: e.algorithm };
									})),
									l(
										window.msCredentials.makeCredential(e, t, n).then(function (e) {
											return Object.freeze({
												credential: { id: e.id },
												publicKey: JSON.parse(e.publicKey),
												attestation: e.attestation,
											});
										})
									)
								);
							},
							getAssertion: function (e, t) {
								var n = {
									accept: t.map(function (e) {
										return { type: 'FIDO_2_0', id: e.id };
									}),
								};
								return l(
									window.msCredentials.getAssertion(e, n).then(function (e) {
										var t = e.signature;
										return Object.freeze({
											credential: { id: e.id },
											clientData: t.clientData,
											authenticatorData: t.authnrData,
											signature: t.signature,
										});
									})
								);
							},
							processWebAuthnResponse: function (e, t) {
								if (void 0 === e) return null;
								var n = e.apply(t);
								return null == n ? null : JSON.stringify(n);
							},
							isAvailable: function () {
								return Object.prototype.hasOwnProperty.call(window, 'msCredentials');
							},
							isNewApiAvailable: function () {
								return navigator && navigator.credentials && navigator.credentials.create;
							},
							isWebauthnOrU2fAvailable: function () {
								return this.isNewApiAvailable() || s.default.isU2fAvailable();
							},
							isConditionalMediationAvailable: function () {
								return (
									'undefined' != typeof PublicKeyCredential &&
									void 0 !== PublicKeyCredential.isConditionalMediationAvailable
								);
							},
							isPasskeyAutofillAvailable:
								((u = (0, i.default)(
									o.default.mark(function e() {
										var t;
										return o.default.wrap(
											function (e) {
												for (;;)
													switch ((e.prev = e.next)) {
														case 0:
															if (((t = !1), !this.isConditionalMediationAvailable())) {
																e.next = 5;
																break;
															}
															return (e.next = 4), PublicKeyCredential.isConditionalMediationAvailable();
														case 4:
															t = e.sent;
														case 5:
															return e.abrupt('return', t);
														case 6:
														case 'end':
															return e.stop();
													}
											},
											e,
											this
										);
									})
								)),
								function () {
									return u.apply(this, arguments);
								}),
						};
					(t.default = c), (e.exports = t.default);
				},
				67934: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(58346)),
						a = r(n(27447)),
						s = r(n(52115)),
						l = r(n(36894)),
						u = r(n(84757)),
						c = r(n(4449)),
						d = r(n(94164)),
						f = r(n(66757)),
						p = r(n(34425)),
						h = r(n(28766)),
						m = r(n(35546)),
						v = n(13671),
						g = r(n(39409)),
						y = r(n(90570)),
						b = r(n(42804));
					var _ = o.Router.extend({
						Events: o.Backbone.Events,
						initialize: function (e) {
							e.globalSuccessFn || (e.globalSuccessFn = function () {}),
								e.globalErrorFn ||
									(e.globalErrorFn = function (e) {
										l.default.error(e);
									}),
								(this.settings = new a.default(o._.omit(e, 'el'), { parse: !0 })),
								e.el || this.settings.callGlobalError(new v.ConfigError((0, o.loc)('error.required.el'))),
								(0, o.$)('body > div').on('click', function () {}),
								(this.appState = new i.default(
									{ baseUrl: this.settings.get('baseUrl'), settings: this.settings },
									{ parse: !0 }
								));
							var t = new u.default({ appState: this.appState });
							(0, o.$)(e.el).append(t.render().$el),
								(this.el = '#'.concat(m.default.WIDGET_CONTAINER_ID)),
								(this.header = new c.default({ el: this.el, appState: this.appState, settings: this.settings })),
								this.hide(),
								this.listenTo(this.appState, 'change:transactionError', function (e, t) {
									g.default.routeAfterAuthStatusChangeError(this, t);
								}),
								this.listenTo(this.appState, 'change:transaction', function (e, t) {
									g.default.routeAfterAuthStatusChange(this, t.data);
								}),
								this.listenTo(this.appState, 'navigate', function (e) {
									this.navigate(e, { trigger: !0 });
								});
						},
						execute: function (e, t) {
							var n = this.settings.get('recoveryToken');
							if (n)
								return (
									this.settings.unset('recoveryToken'),
									void this.navigate(g.default.createRecoveryUrl(n), { trigger: !0 })
								);
							var r = this.settings.get('stateToken');
							if (r)
								return (
									this.settings.unset('stateToken'), void this.navigate(g.default.createRefreshUrl(r), { trigger: !0 })
								);
							var i,
								a,
								s = this.appState.get('transaction');
							(s && s.data) ||
							((i = this),
							(a = e),
							o._.find(i.stateLessRouteHandlers, function (e) {
								return a === i[e];
							}))
								? e.apply(this, t)
								: this.settings.getAuthClient().tx.exists()
								? this.navigate(g.default.createRefreshUrl(), { trigger: !0 })
								: this.navigate('', { trigger: !0 });
						},
						navigate: function (e, t) {
							return this.settings.get('features.router')
								? o.Router.prototype.navigate.apply(this, arguments)
								: t && t.trigger
								? o.Backbone.history.loadUrl(e)
								: void 0;
						},
						render: function (e, t) {
							var n = this;
							t || (t = {});
							var r = t.Beacon,
								i = o._.extend({ settings: this.settings, appState: this.appState }, o._.omit(t, 'Beacon'));
							if (
								(this.header.rendered() || (this.el = this.header.render().getContentEl()),
								!s.default.isLoaded(this.appState.get('languageCode')))
							)
								return b.default.loadLanguage(this.appState, this.settings).then(o._.bind(this.render, this, e, t));
							if (this.settings.get('colors.brand') && !h.default.isLoaded()) {
								var a = { brand: this.settings.get('colors.brand') },
									l = this.settings.get('cspNonce');
								h.default.addStyle(a, l);
							}
							var u = this.controller;
							return (
								(this.controller = new e(i)),
								this.listenTo(this.controller, 'all', this.trigger),
								this.controller
									.fetchInitialData()
									.then(function () {
										return (
											(function (e, t) {
												return !!e && (e !== d.default || t.get('features.securityImage'));
											})(r, n.settings) || (r = null),
											n.header.setBeacon(r, i),
											n.show(),
											n.controller.render(),
											u
												? f.default.swapPages({
														$parent: n.el,
														$oldRoot: u.$el,
														$newRoot: n.controller.$el,
														dir: u.state.get('navigateDir'),
														ctx: n,
														success: function () {
															var e,
																t = this.appState.get('flashError'),
																n = this.controller.model;
															(u.remove(), u.$el.remove(), this.controller.postRenderAnimation(), t) &&
																((e =
																	t.is && t.is('terminal')
																		? t.errorDetails.errorSummary
																		: (0, o.loc)(
																				this.settings.get('features.mfaOnlyFlow')
																					? 'error.mfa.only.expired.session'
																					: 'error.expired.session'
																		  )),
																n.trigger('error', n, { responseJSON: { errorSummary: e } }),
																this.appState.unset('flashError'),
																y.default.triggerAfterError(this.controller, t));
														},
												  })
												: (n.el.append(n.controller.el), void n.controller.postRenderAnimation())
										);
									})
									.catch(function () {
										u && (u.remove(), u.$el.remove());
									})
							);
						},
						start: function () {
							var e = this,
								t = !1;
							window.addEventListener &&
								this.settings.get('features.router') &&
								(window.addEventListener('popstate', function (t) {
									e.controller.back && (t.preventDefault(), t.stopImmediatePropagation(), e.controller.back());
								}),
								(t = p.default.supportsPushState())),
								o.Router.prototype.start.call(this, { pushState: t });
						},
						hide: function () {
							this.header.$el.hide();
						},
						show: function () {
							this.header.$el.show();
						},
						remove: function () {
							this.controller && this.controller.remove(),
								this.header.$el.remove(),
								s.default.remove(),
								o.Backbone.history.stop();
						},
					});
					(t.default = _), (e.exports = t.default);
				},
				45385: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(35546)),
						a = r(n(73650)),
						s = r(n(39694)),
						l = a.default.extend({
							className: 'account-unlocked',
							Model: function () {
								return { local: { userFullName: ['string', !1, this.options.appState.get('userFullName')] } };
							},
							Form: {
								title: o._.partial(o.loc, 'account.unlock.unlocked.title', 'login'),
								subtitle: o._.partial(o.loc, 'account.unlock.unlocked.desc', 'login'),
								noButtonBar: !0,
								attributes: { 'data-se': 'account-unlocked' },
								formChildren: function () {
									return [
										s.default.Button({
											title: (0, o.loc)('goback', 'login'),
											className: 'button button-primary button-wide',
											attributes: { 'data-se': 'back-button' },
											click: function () {
												this.state.set('navigateDir', i.default.DIRECTION_BACK),
													this.options.appState.trigger('navigate', '');
											},
										}),
									];
								},
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				91939: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(73650)),
						i = r(n(21304)),
						a = r(n(68457)),
						s = o.default.extend({
							className: 'activate-totp',
							Model: function () {
								return {
									props: {
										factorId: ['string', !0, this.options.appState.get('activatedFactorId')],
										passCode: ['string', !0],
									},
									local: {
										__factorType__: ['string', !1, this.options.factorType],
										__provider__: ['string', !1, this.options.provider],
									},
									save: function () {
										return this.doTransaction(function (e) {
											return e.activate({ passCode: this.get('passCode') });
										});
									},
								};
							},
							Form: i.default,
							Footer: a.default,
						});
					(t.default = s), (e.exports = t.default);
				},
				61525: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(73650)),
						a = r(n(39694)),
						s = r(n(29531)),
						l = r(n(91482)),
						u = {
							props: { scopes: ['array', !0] },
							save: function () {
								return this.doTransaction(function (e) {
									return e.consent({ consent: { scopes: o._.pluck(this.get('scopes'), 'name') } });
								});
							},
							cancel: function () {
								var e = this;
								return this.doTransaction(function (e) {
									return e.cancel();
								}).then(function () {
									var t = e.settings.get('consent.cancel');
									o._.isFunction(t) && t();
								});
							},
						},
						c = o.View.extend({
							className: 'consent-title detail-row',
							template: l.default,
							getTemplateData: function () {
								var e = this.options.appState;
								return {
									appName: e.escape('targetLabel'),
									customLogo: e.get('targetLogo') && e.get('targetLogo').href,
									defaultLogo: e.get('defaultAppLogo'),
									clientURI: e.get('targetClientURI') && e.get('targetClientURI').href,
									issuer: e.get('issuer'),
								};
							},
						}),
						d = {
							noCancelButton: !1,
							buttonOrder: ['cancel', 'save'],
							autoSave: !0,
							save: o._.partial(o.loc, 'consent.required.consentButton', 'login'),
							cancel: o._.partial(o.loc, 'consent.required.cancelButton', 'login'),
							formChildren: [a.default.View({ View: c }), a.default.View({ View: s.default })],
						},
						f = i.default.extend({
							Model: u,
							Form: d,
							className: 'admin-consent-required',
							initialize: function () {
								var e = this;
								this.model.set('scopes', this.options.appState.get('scopes')),
									this.listenTo(this.form, 'cancel', function () {
										e.model.cancel();
									});
							},
						});
					(t.default = f), (e.exports = t.default);
				},
				24687: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(2645)),
						a = r(n(73650)),
						s = r(n(39694)),
						l = r(n(34361)),
						u = r(n(68457)),
						c = a.default.extend({
							className: 'barcode-push',
							Model: function () {
								return {
									local: {
										__factorType__: ['string', !1, this.options.factorType],
										__provider__: ['string', !1, this.options.provider],
									},
								};
							},
							Form: {
								title: function () {
									var e = i.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
									return (0, o.loc)('enroll.totp.title', 'login', [e]);
								},
								noButtonBar: !0,
								attributes: { 'data-se': 'step-scan' },
								className: 'barcode-scan',
								initialize: function () {
									this.listenTo(this.model, 'error errors:clear', function () {
										this.clearErrors();
									});
								},
								formChildren: [s.default.View({ View: l.default })],
							},
							Footer: u.default,
							initialize: function () {
								this.pollForEnrollment().catch(function () {});
							},
							pollForEnrollment: function () {
								return this.model.doTransaction(function (e) {
									return e.poll(6e3);
								});
							},
							trapAuthResponse: function () {
								if (this.options.appState.get('isMfaEnrollActivate')) return !0;
							},
						});
					(t.default = c), (e.exports = t.default);
				},
				98318: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(2645)),
						a = r(n(73650)),
						s = r(n(39694)),
						l = r(n(39409)),
						u = r(n(34361)),
						c = r(n(68457)),
						d = a.default.extend({
							className: 'barcode-totp',
							Model: function () {
								return {
									local: {
										__factorType__: ['string', !1, this.options.factorType],
										__provider__: ['string', !1, this.options.provider],
									},
								};
							},
							Form: {
								title: function () {
									var e = i.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
									return (0, o.loc)('enroll.totp.title', 'login', [e]);
								},
								save: o._.partial(o.loc, 'oform.next', 'login'),
								noCancelButton: !0,
								attributes: { 'data-se': 'step-scan' },
								className: 'barcode-scan',
								formChildren: [s.default.View({ View: u.default })],
							},
							Footer: c.default,
							initialize: function () {
								this.listenTo(this.form, 'save', function () {
									var e = l.default.createActivateFactorUrl(
										this.model.get('__provider__'),
										this.model.get('__factorType__'),
										'activate'
									);
									this.options.appState.trigger('navigate', e);
								});
							},
						});
					(t.default = d), (e.exports = t.default);
				},
				93100: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(35546)),
						s = r(n(73650)),
						l = r(n(39694)),
						u = r(n(99629)),
						c = r(n(27008)),
						d = r(n(26069)),
						f = r(n(91482)),
						p = o.default.template({
							1: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<a href="' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'clientURI') || (null != t ? a(t, 'clientURI') : t))
													? i
													: e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'clientURI',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 26 }, end: { line: 1, column: 39 } },
											  })
											: i
									) +
									'" class="client-logo-link" target="_blank">'
								);
							},
							3: function (e, t, n, r, o) {
								var i,
									a = null != t ? t : e.nullContext || {},
									s = e.hooks.helperMissing,
									l = e.escapeExpression,
									u =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<img class="client-logo custom-logo" src="' +
									l(
										'function' ==
											typeof (i = null != (i = u(n, 'customLogo') || (null != t ? u(t, 'customLogo') : t)) ? i : s)
											? i.call(a, {
													name: 'customLogo',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 149 }, end: { line: 1, column: 163 } },
											  })
											: i
									) +
									'" alt="' +
									l(
										(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'common.logo.alt' },
											data: o,
											loc: { start: { line: 1, column: 170 }, end: { line: 1, column: 216 } },
										})
									) +
									'" aria-hidden="true" />'
								);
							},
							5: function (e, t, n, r, o) {
								var i,
									a = null != t ? t : e.nullContext || {},
									s = e.hooks.helperMissing,
									l = e.escapeExpression,
									u =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<img class="client-logo default-logo" src="' +
									l(
										'function' ==
											typeof (i = null != (i = u(n, 'defaultLogo') || (null != t ? u(t, 'defaultLogo') : t)) ? i : s)
											? i.call(a, {
													name: 'defaultLogo',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 290 }, end: { line: 1, column: 305 } },
											  })
											: i
									) +
									'" alt="' +
									l(
										(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'common.logo.alt' },
											data: o,
											loc: { start: { line: 1, column: 312 }, end: { line: 1, column: 358 } },
										})
									) +
									'" aria-hidden="true" />'
								);
							},
							7: function (e, t, n, r, o) {
								return '</a>';
							},
							9: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<div class="issuer"><span>' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'issuer') || (null != t ? a(t, 'issuer') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'issuer',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 624 }, end: { line: 1, column: 634 } },
											  })
											: i
									) +
									'</span></div>'
								);
							},
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a = null != t ? t : e.nullContext || {},
									s =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									(null !=
									(i = s(n, 'if').call(a, null != t ? s(t, 'clientURI') : t, {
										name: 'if',
										hash: {},
										fn: e.program(1, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 89 } },
									}))
										? i
										: '') +
									(null !=
									(i = s(n, 'if').call(a, null != t ? s(t, 'customLogo') : t, {
										name: 'if',
										hash: {},
										fn: e.program(3, o, 0),
										inverse: e.program(5, o, 0),
										data: o,
										loc: { start: { line: 1, column: 89 }, end: { line: 1, column: 388 } },
									}))
										? i
										: '') +
									(null !=
									(i = s(n, 'if').call(a, null != t ? s(t, 'clientURI') : t, {
										name: 'if',
										hash: {},
										fn: e.program(7, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 388 }, end: { line: 1, column: 416 } },
									}))
										? i
										: '') +
									'<h1><span class="title-text">' +
									e.escapeExpression(
										(s(n, 'i18n') || (t && s(t, 'i18n')) || e.hooks.helperMissing).call(a, {
											name: 'i18n',
											hash: {
												$2: '<p>$2</p>',
												$1: "<b class='no-translate'>$1</b>",
												arguments: 'appName',
												bundle: 'login',
												code: 'granular.consent.scopes.title',
											},
											data: o,
											loc: { start: { line: 1, column: 445 }, end: { line: 1, column: 577 } },
										})
									) +
									'</span>' +
									(null !=
									(i = s(n, 'if').call(a, null != t ? s(t, 'issuer') : t, {
										name: 'if',
										hash: {},
										fn: e.program(9, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 584 }, end: { line: 1, column: 654 } },
									}))
										? i
										: '') +
									'</h1>'
								);
							},
							useData: !0,
						}),
						h = function (e) {
							return l.default.View({
								View: i.View.extend({
									className: 'consent-title detail-row',
									template: e,
									getTemplateData: function () {
										var e = this.options.appState;
										return {
											appName: e.escape('targetLabel'),
											customLogo: e.get('targetLogo') && e.get('targetLogo').href,
											defaultLogo: e.get('defaultAppLogo'),
											clientURI: e.get('targetClientURI') && e.get('targetClientURI').href,
										};
									},
								}),
							});
						},
						m = l.default.View({
							View: i.View.extend({
								className: 'consent-description detail-row',
								template: o.default.template({
									compiler: [8, '>= 4.3.0'],
									main: function (e, t, n, r, o) {
										var i =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
										return (
											'<p>' +
											e.escapeExpression(
												(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
													null != t ? t : e.nullContext || {},
													{
														name: 'i18n',
														hash: { bundle: 'login', code: 'consent.required.description' },
														data: o,
														loc: { start: { line: 1, column: 3 }, end: { line: 1, column: 62 } },
													}
												)
											) +
											'</p>'
										);
									},
									useData: !0,
								}),
							}),
						}),
						v = l.default.View({
							View: i.View.extend({
								className: 'consent-description',
								template: o.default.template({
									compiler: [8, '>= 4.3.0'],
									main: function (e, t, n, r, o) {
										var i =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
										return (
											'<p>' +
											e.escapeExpression(
												(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
													null != t ? t : e.nullContext || {},
													{
														name: 'i18n',
														hash: { bundle: 'login', code: 'granular.consent.scopes.description' },
														data: o,
														loc: { start: { line: 1, column: 3 }, end: { line: 1, column: 69 } },
													}
												)
											) +
											'</p>'
										);
									},
									useData: !0,
								}),
							}),
						}),
						g = function (e) {
							return 'optional' in e.get('scopes')[0];
						},
						y = s.default.extend({
							className: 'consent-required',
							initialize: function () {
								var e = this;
								this.model.set('expiresAt', this.options.appState.get('expiresAt')),
									this.model.set('scopes', this.options.appState.get('scopes')),
									this.listenTo(this.form, 'cancel', i._.bind(this.model.cancel, this.model));
								var t = new d.default();
								(0, i.$)('#'.concat(a.default.WIDGET_LOGIN_CONTAINER_ID)).prepend(t.render().$el),
									g(this.options.appState) &&
										(this.$el.addClass('granular-consent').removeClass('consent-required'),
										(this.form.cancel = i._.partial(i.loc, 'oform.cancel', 'login')),
										i._.forEach(this.options.appState.get('scopes'), function (t) {
											e.model.set(t.name, !0);
										}));
							},
							postRender: function () {
								s.default.prototype.postRender.apply(this, arguments),
									this.$('.o-form-button-bar .button-primary').removeClass('button-primary');
							},
							Model: {
								props: { expiresAt: ['string', !0], scopes: ['array', !0] },
								save: function () {
									return this.doTransaction(function (e) {
										var t = this,
											n = i._.pluck(this.get('scopes'), 'name'),
											r = { expiresAt: this.get('expiresAt') };
										return (
											g(this)
												? (r.optedScopes = i._.reduce(
														n,
														function (e, n) {
															return (e[n] = t.get(n)), e;
														},
														{}
												  ))
												: (r.scopes = n),
											e.consent({ consent: r })
										);
									});
								},
								cancel: function () {
									var e = this;
									return this.doTransaction(function (e) {
										return e.cancel();
									}).then(function () {
										var t = e.settings.get('consent.cancel');
										i._.isFunction(t) && t();
									});
								},
							},
							Form: {
								noCancelButton: !1,
								buttonOrder: ['cancel', 'save'],
								autoSave: !0,
								save: i._.partial(i.loc, 'consent.required.consentButton', 'login'),
								cancel: i._.partial(i.loc, 'consent.required.cancelButton', 'login'),
								formChildren: function () {
									return g(this.options.appState)
										? [h(p), v].concat(
												((e = this.options.appState.get('scopes')),
												(t = e.slice().sort(function (e, t) {
													return t.optional - e.optional;
												})),
												i._.map(t, function (e) {
													var t = e.name,
														n = e.displayName,
														r = e.description,
														o = e.optional,
														i = e.isCustomized;
													return l.default.Input({
														name: t,
														input: c.default,
														placeholder: n,
														label: !1,
														modelType: 'boolean',
														required: !0,
														options: { description: r, optional: o, isCustomized: i },
													});
												}))
										  )
										: [h(f.default), l.default.View({ View: new u.default({ model: this.model }) }), m];
									var e, t;
								},
							},
							Footer: i.View.extend({
								className: 'consent-footer',
								template: o.default.template({
									1: function (e, t, n, r, o) {
										var i,
											a,
											s = null != t ? t : e.nullContext || {},
											l = e.hooks.helperMissing,
											u = e.escapeExpression,
											c =
												e.lookupProperty ||
												function (e, t) {
													if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
												};
										return (
											'<a class="terms-of-service" href="' +
											u(
												'function' ==
													typeof (a =
														null != (a = c(n, 'termsOfService') || (null != t ? c(t, 'termsOfService') : t)) ? a : l)
													? a.call(s, {
															name: 'termsOfService',
															hash: {},
															data: o,
															loc: { start: { line: 1, column: 56 }, end: { line: 1, column: 74 } },
													  })
													: a
											) +
											'" target="_blank">' +
											u(
												(c(n, 'i18n') || (t && c(t, 'i18n')) || l).call(s, {
													name: 'i18n',
													hash: { bundle: 'login', code: 'consent.required.termsOfService' },
													data: o,
													loc: { start: { line: 1, column: 92 }, end: { line: 1, column: 154 } },
												})
											) +
											'</a>' +
											(null !=
											(i = c(n, 'if').call(s, null != t ? c(t, 'privacyPolicy') : t, {
												name: 'if',
												hash: {},
												fn: e.program(2, o, 0),
												inverse: e.noop,
												data: o,
												loc: { start: { line: 1, column: 158 }, end: { line: 1, column: 194 } },
											}))
												? i
												: '')
										);
									},
									2: function (e, t, n, r, o) {
										return ' &#8226 ';
									},
									4: function (e, t, n, r, o) {
										var i,
											a = null != t ? t : e.nullContext || {},
											s = e.hooks.helperMissing,
											l = e.escapeExpression,
											u =
												e.lookupProperty ||
												function (e, t) {
													if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
												};
										return (
											'<a class="privacy-policy" href="' +
											l(
												'function' ==
													typeof (i =
														null != (i = u(n, 'privacyPolicy') || (null != t ? u(t, 'privacyPolicy') : t)) ? i : s)
													? i.call(a, {
															name: 'privacyPolicy',
															hash: {},
															data: o,
															loc: { start: { line: 1, column: 254 }, end: { line: 1, column: 271 } },
													  })
													: i
											) +
											'" target="_blank">' +
											l(
												(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
													name: 'i18n',
													hash: { bundle: 'login', code: 'consent.required.privacyPolicy' },
													data: o,
													loc: { start: { line: 1, column: 289 }, end: { line: 1, column: 350 } },
												})
											) +
											'</a>'
										);
									},
									compiler: [8, '>= 4.3.0'],
									main: function (e, t, n, r, o) {
										var i,
											a = null != t ? t : e.nullContext || {},
											s =
												e.lookupProperty ||
												function (e, t) {
													if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
												};
										return (
											(null !=
											(i = s(n, 'if').call(a, null != t ? s(t, 'termsOfService') : t, {
												name: 'if',
												hash: {},
												fn: e.program(1, o, 0),
												inverse: e.noop,
												data: o,
												loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 201 } },
											}))
												? i
												: '') +
											(null !=
											(i = s(n, 'if').call(a, null != t ? s(t, 'privacyPolicy') : t, {
												name: 'if',
												hash: {},
												fn: e.program(4, o, 0),
												inverse: e.noop,
												data: o,
												loc: { start: { line: 1, column: 201 }, end: { line: 1, column: 361 } },
											}))
												? i
												: '')
										);
									},
									useData: !0,
								}),
								getTemplateData: function () {
									var e = this.options.appState;
									return {
										termsOfService: e.get('targetTermsOfService') && e.get('targetTermsOfService').href,
										privacyPolicy: e.get('targetPrivacyPolicy') && e.get('targetPrivacyPolicy').href,
									};
								},
							}),
						});
					(t.default = y), (e.exports = t.default);
				},
				93788: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(73650)),
						a = r(n(39694)),
						s = r(n(84977)),
						l = o.internal.util.Util,
						u = i.default.extend({
							className: 'custom-password-expired',
							Model: {},
							Form: {
								noButtonBar: !0,
								title: function () {
									var e = this.options.appState.get('isPwdExpiringSoon'),
										t = this.options.appState.get('passwordExpireDays');
									return e && t > 0
										? (0, o.loc)('password.expiring.title', 'login', [t])
										: e && 0 === t
										? (0, o.loc)('password.expiring.today', 'login')
										: e
										? (0, o.loc)('password.expiring.soon', 'login')
										: this.settings.get('brandName')
										? (0, o.loc)('password.expired.title.specific', 'login', [this.settings.get('brandName')])
										: (0, o.loc)('password.expired.title.generic', 'login');
								},
								subtitle: function () {
									return this.options.appState.get('isPwdExpiringSoon')
										? this.settings.get('brandName')
											? (0, o.loc)('password.expiring.soon.subtitle.specific', 'login', [
													this.settings.get('brandName'),
											  ])
											: (0, o.loc)('password.expiring.soon.subtitle.generic', 'login')
										: (0, o.loc)('password.expired.custom.subtitle', 'login');
								},
								formChildren: function () {
									return [
										a.default.Button({
											title: o._.partial(o.loc, 'password.expired.custom.submit', 'login', [
												this.options.appState.get('passwordExpiredWebsiteName'),
											]),
											className: 'button button-primary button-wide',
											attributes: { 'data-se': 'custom-button' },
											click: function () {
												l.redirect(this.options.appState.get('passwordExpiredLinkUrl'));
											},
										}),
									];
								},
							},
							Footer: s.default,
						});
					(t.default = u), (e.exports = t.default);
				},
				43252: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(73650)),
						s = r(n(39694)),
						l = r(n(50160)),
						u = i.View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<div class="okta-form-infobox-error infobox infobox-error" role="alert"><span class="icon error-16"></span><p>' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'api.authn.error.PASSCODE_INVALID' },
													data: o,
													loc: { start: { line: 1, column: 110 }, end: { line: 1, column: 173 } },
												}
											)
										) +
										'</p></div>'
									);
								},
								useData: !0,
							}),
						}),
						c = a.default.extend({
							className: 'device-code-activate',
							Model: function () {
								var e, t;
								return {
									props: {
										userCode: [
											'string',
											!0,
											null === (e = this.options) || void 0 === e || null === (t = e.appState) || void 0 === t
												? void 0
												: t.get('userCode'),
										],
										stateToken: 'string',
									},
									save: function () {
										var e = this;
										return this.doTransaction(function (t) {
											return t.deviceActivate({ userCode: e.get('userCode') });
										});
									},
								};
							},
							Form: {
								noCancelButton: !0,
								autoSave: !0,
								save: function () {
									return (0, i.loc)('oform.next', 'login');
								},
								title: function () {
									return (0, i.loc)('device.code.activate.title', 'login');
								},
								subtitle: function () {
									return (0, i.loc)('device.code.activate.subtitle', 'login');
								},
								formChildren: function () {
									return (
										'INVALID_USER_CODE' === this.options.appState.get('deviceActivationStatus') &&
											this.add(u, '.o-form-error-container'),
										[
											s.default.Input({
												'label': (0, i.loc)('device.code.activate.label', 'login'),
												'label-top': !0,
												'name': 'userCode',
												'input': l.default,
												'inputId': 'user-code',
												'type': 'text',
												'inlineValidation': !1,
											}),
										]
									);
								},
								events: {
									'keyup input[name="userCode"]': function (e) {
										e.preventDefault(), this.addHyphen(e);
									},
								},
								addHyphen: function (e) {
									var t = e.target.value;
									t &&
										4 === t.length &&
										!['Backspace', 'Delete', '-'].includes(e.key) &&
										(e.target.value = t.concat('-'));
								},
							},
						});
					(t.default = c), (e.exports = t.default);
				},
				76920: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(73650)),
						s = r(n(39694)),
						l = 'DEVICE_ACTIVATED',
						u = 'DEVICE_NOT_ACTIVATED_CONSENT_DENIED',
						c = 'DEVICE_NOT_ACTIVATED',
						d = [u, c],
						f = a.default.extend({
							className: 'device-code-terminal',
							postRender: function () {
								a.default.prototype.postRender.apply(this, arguments);
								var e = this.options.appState.get('deviceActivationStatus') === l ? 'success-24-green' : 'error-24-red';
								this.$('.o-form-head').before(
									'<div class="device-code-terminal--icon-container"><span class="device-code-terminal--icon ' +
										e +
										'"></span></div>'
								);
							},
							Model: {},
							Form: {
								noCancelButton: !0,
								noButtonBar: !0,
								title: function () {
									var e = this.options.appState.get('deviceActivationStatus');
									return e === l
										? (0, i.loc)('device.code.activated.success.title', 'login')
										: i._.contains(d, e)
										? (0, i.loc)('device.code.activated.error.title', 'login')
										: void 0;
								},
								subtitle: function () {
									var e = this.options.appState.get('deviceActivationStatus');
									return e === l
										? (0, i.loc)('idx.device.activated', 'login')
										: e === u
										? (0, i.loc)('idx.device.not.activated.consent.denied', 'login')
										: e === c
										? (0, i.loc)('idx.device.not.activated.internal.error', 'login')
										: void 0;
								},
								formChildren: function () {
									return [
										s.default.View({
											View: i.View.extend({
												template: o.default.template({
													1: function (e, t, n, r, o) {
														var i =
															e.lookupProperty ||
															function (e, t) {
																if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
															};
														return (
															'<a href="/activate" class="button button-primary text-align-c retry-button" data-se="try-again">' +
															e.escapeExpression(
																(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
																	null != t ? t : e.nullContext || {},
																	{
																		name: 'i18n',
																		hash: { bundle: 'login', code: 'oie.try.again' },
																		data: o,
																		loc: { start: { line: 1, column: 121 }, end: { line: 1, column: 165 } },
																	}
																)
															) +
															'</a>'
														);
													},
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, o) {
														var i,
															a =
																e.lookupProperty ||
																function (e, t) {
																	if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																};
														return null !=
															(i = a(n, 'if').call(
																null != t ? t : e.nullContext || {},
																null != t ? a(t, 'isDeviceCodeError') : t,
																{
																	name: 'if',
																	hash: {},
																	fn: e.program(1, o, 0),
																	inverse: e.noop,
																	data: o,
																	loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 176 } },
																}
															))
															? i
															: '';
													},
													useData: !0,
												}),
												getTemplateData: function () {
													return {
														isDeviceCodeError: i._.contains(d, this.options.appState.get('deviceActivationStatus')),
													};
												},
											}),
										}),
									];
								},
							},
						});
					(t.default = f), (e.exports = t.default);
				},
				4374: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(83567)),
						a = r(n(15073)),
						s = r(n(39694)),
						l = r(n(81824)),
						u = o.internal.util.Util,
						c = i.default.extend({
							Model: {
								local: { provider: 'string', factorType: 'string' },
								save: function () {
									var e = this;
									return this.manageTransaction(function () {
										var t = e.appState.get('enrollCustomFactorRedirectUrl');
										null !== t && u.redirect(t);
									});
								},
							},
							Form: function () {
								var e = new a.default.Model(this.options.appState.get('factor'), this.toJSON()).get('vendorName');
								return {
									autoSave: !0,
									title: e,
									subtitle: (0, o.loc)('enroll.customFactor.subtitle', 'login', [e]),
									save: (0, o.loc)('enroll.customFactor.save', 'login'),
									formChildren: function () {
										var e = [];
										return (
											this.options.appState.get('isFactorResultFailed') &&
												e.push(
													s.default.View(
														{ View: new l.default({ message: this.options.appState.get('factorResultErrorMessage') }) },
														{ selector: '.o-form-error-container' }
													)
												),
											e
										);
									},
								};
							},
						});
					(t.default = c), (e.exports = t.default);
				},
				90192: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(73650)),
						s = r(n(39694)),
						l = r(n(53292)),
						u = r(n(68457)),
						c = a.default.extend({
							className: 'enroll-activate-email',
							Model: {
								props: { passCode: 'string' },
								resend: function () {
									return (
										this.trigger('form:clear-errors'),
										this.doTransaction(function (e) {
											return e.resend('email');
										})
									);
								},
								save: function () {
									this.trigger('save');
									var e = this.toJSON();
									return this.doTransaction(function (t) {
										return t.activate(e);
									});
								},
							},
							Form: function () {
								return {
									title: i._.partial(i.loc, 'email.enroll.title', 'login'),
									noButtonBar: !1,
									autoSave: !0,
									save: i._.partial(i.loc, 'oform.verify', 'login'),
									formChildren: [
										s.default.View({
											View: i.View.extend({
												className: 'enroll-activate-email-content',
												attributes: { 'data-se': 'enroll-activate-email-content' },
												template: o.default.template({
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, o) {
														var i,
															a =
																e.lookupProperty ||
																function (e, t) {
																	if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																};
														return null !=
															(i = (a(n, 'i18n') || (t && a(t, 'i18n')) || e.hooks.helperMissing).call(
																null != t ? t : e.nullContext || {},
																{
																	name: 'i18n',
																	hash: {
																		arguments: 'factorEmail',
																		bundle: 'login',
																		code: 'email.mfa.email.sent.description',
																	},
																	data: o,
																	loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 89 } },
																}
															))
															? i
															: '';
													},
													useData: !0,
												}),
												getTemplateData: function () {
													var e = this.options.appState.get('factor'),
														t = e && e.profile ? e.profile.email : '';
													return {
														factorEmail: o.default.template({
															compiler: [8, '>= 4.3.0'],
															main: function (e, t, n, r, o) {
																var i,
																	a =
																		e.lookupProperty ||
																		function (e, t) {
																			if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																		};
																return (
																	'<span class="mask-email">' +
																	e.escapeExpression(
																		'function' ==
																			typeof (i =
																				null != (i = a(n, 'email') || (null != t ? a(t, 'email') : t))
																					? i
																					: e.hooks.helperMissing)
																			? i.call(null != t ? t : e.nullContext || {}, {
																					name: 'email',
																					hash: {},
																					data: o,
																					loc: { start: { line: 1, column: 25 }, end: { line: 1, column: 34 } },
																			  })
																			: i
																	) +
																	'</span>'
																);
															},
															useData: !0,
														})({ email: t }),
													};
												},
											}),
										}),
										s.default.View({ View: l.default }),
										s.default.Input({
											'label': (0, i.loc)('email.code.label', 'login'),
											'label-top': !0,
											'name': 'passCode',
											'type': 'text',
											'wide': !0,
										}),
									],
								};
							},
							Footer: u.default,
						});
					(t.default = c), (e.exports = t.default);
				},
				66493: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(73390)),
						s = r(n(35546)),
						l = r(n(73650)),
						u = r(n(39694)),
						c = r(n(90570)),
						d = r(n(68457)),
						f = r(n(39838)),
						p = r(n(50160)),
						h = i.internal.util.Keys,
						m = i.View.extend({
							className: 'okta-form-infobox-warning infobox infobox-warning login-timeout-warning',
							attributes: { 'aria-live': 'polite' },
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a,
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<span class="icon warning-16"></span><p>' +
										(null !=
										(i =
											'function' ==
											typeof (a =
												null != (a = s(n, 'warning') || (null != t ? s(t, 'warning') : t)) ? a : e.hooks.helperMissing)
												? a.call(null != t ? t : e.nullContext || {}, {
														name: 'warning',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 40 }, end: { line: 1, column: 53 } },
												  })
												: a)
											? i
											: '') +
										'</p>'
									);
								},
								useData: !0,
							}),
						}),
						v = {
							factorId: function (e) {
								return !i._.isUndefined(e);
							},
						};
					function g(e) {
						return 'call' === e;
					}
					function y(e) {
						return g(e) ? 'enroll-call' : 'enroll-sms';
					}
					function b(e) {
						h.isEnter(e) &&
							(e.stopPropagation(),
							e.preventDefault(),
							'keyup' === e.type && e.data && e.data.model && e.data.model.sendCode());
					}
					var _ = l.default.extend({
						className: function () {
							return y(this.options.factorType);
						},
						Model: function () {
							return {
								props: {
									phoneNumber: ['string', !0],
									phoneExtension: ['string', !1],
									lastEnrolledPhoneNumber: 'string',
									passCode: ['string', !0],
									factorId: 'string',
								},
								local: {
									countryCode: ['string', !1, this.options.appState.get('userCountryCode')],
									hasExistingPhones: 'boolean',
									trapEnrollment: 'boolean',
									ableToResend: 'boolean',
									factorType: 'string',
									skipPhoneValidation: 'boolean',
								},
								derived: {
									countryCallingCode: {
										deps: ['countryCode'],
										fn: function (e) {
											return '+' + a.default.getCallingCodeForCountry(e);
										},
									},
									fullPhoneNumber: {
										deps: ['countryCallingCode', 'phoneNumber'],
										fn: function (e, t) {
											return t ? e + t : '';
										},
									},
									enrolled: {
										deps: ['lastEnrolledPhoneNumber', 'fullPhoneNumber'],
										fn: function (e, t) {
											return e === t;
										},
									},
								},
								limitResending: function () {
									this.set({ ableToResend: !1 }),
										i._.delay(i._.bind(this.set, this), s.default.API_RATE_LIMIT, { ableToResend: !0 });
								},
								sendCode: function () {
									var e = this,
										t = this.get('fullPhoneNumber'),
										n = this.get('phoneExtension');
									if ((e.trigger('errors:clear'), t.length))
										return this.doTransaction(function (r) {
											var o = 'MFA_ENROLL' === r.status || 'FACTOR_ENROLL' === r.status,
												a = { phoneNumber: t, updatePhone: !o || e.get('hasExistingPhones') };
											g(e.get('factorType')) && (a.phoneExtension = n),
												e.get('skipPhoneValidation') && (a.validatePhone = !1);
											var s = function (t) {
												return i._.findWhere(t.factors, { factorType: e.get('factorType'), provider: 'OKTA' })
													.enroll({ profile: a })
													.catch(function (t) {
														throw (
															('E0000098' === t.errorCode &&
																(e.set('skipPhoneValidation', !0),
																(t.xhr.responseJSON.errorSummary = (0, i.loc)('enroll.sms.try_again', 'login'))),
															t)
														);
													});
											};
											return o
												? s(r)
												: (e.set('trapEnrollment', !0),
												  r
														.prev()
														.then(s)
														.then(function (t) {
															return e.set('trapEnrollment', !1), t;
														}));
										}, !0)
											.then(function () {
												e.set('lastEnrolledPhoneNumber', t), e.limitResending();
											})
											.catch(function () {
												e.set('trapEnrollment', !1);
											});
									e.trigger('invalid', e, { phoneNumber: 'model.validation.field.blank' });
								},
								resendCode: function () {
									return (
										this.trigger('errors:clear'),
										this.limitResending(),
										this.doTransaction(function (e) {
											return e.resend(this.get('factorType'));
										})
									);
								},
								save: function () {
									return this.doTransaction(function (e) {
										return e.activate({ passCode: this.get('passCode') });
									});
								},
							};
						},
						Form: function () {
							var e = this.options.factorType,
								t = g(e),
								n = (0, i.loc)(t ? 'enroll.call.setup' : 'enroll.sms.setup', 'login'),
								r = (0, i.loc)(t ? 'mfa.call' : 'mfa.sendCode', 'login'),
								s = (0, i.loc)(t ? 'mfa.redial' : 'mfa.resendCode', 'login'),
								l = (0, i.loc)(t ? 'mfa.calling' : 'mfa.sent', 'login'),
								d = t ? 'enroll-call-phone' : 'enroll-sms-phone',
								h = t ? 'call-request-button' : 'sms-request-button',
								_ = [
									u.default.Input({ name: 'countryCode', type: 'select', wide: !0, options: a.default.getCountries() }),
									u.default.Input({
										'label': (0, i.loc)('mfa.phoneNumber.placeholder', 'login'),
										'label-top': !0,
										'className': d,
										'name': 'phoneNumber',
										'input': f.default,
										'type': 'text',
										'render': function () {
											this.$('input[name="phoneNumber"]')
												.off('keydown keyup', b)
												.keydown(b)
												.keyup({ model: this.model }, b);
										},
									}),
								];
							return (
								t &&
									_.push(
										u.default.Input({
											'label': (0, i.loc)('mfa.phoneNumber.ext.placeholder', 'login'),
											'label-top': !0,
											'className': 'enroll-call-extension',
											'name': 'phoneExtension',
											'input': p.default,
											'type': 'text',
										})
									),
								_.push(
									u.default.Button({
										title: r,
										attributes: { 'data-se': h },
										className: 'button button-primary js-enroll-phone margin-top-30 ' + h,
										click: function () {
											this.model.sendCode();
										},
									}),
									u.default.Button({
										title: s,
										attributes: { 'data-se': h },
										className: 'button js-enroll-phone margin-top-30 ' + h,
										click: function () {
											this.model.resendCode();
										},
										initialize: function () {
											this.$el.css({ display: 'none' }),
												this.listenTo(this.model, 'change:ableToResend', function (e, t) {
													t ? ((this.options.title = s), this.enable()) : ((this.options.title = l), this.disable()),
														this.render();
												});
										},
									}),
									u.default.Divider({ showWhen: v }),
									u.default.Input({
										'label': (0, i.loc)('mfa.challenge.enterCode.placeholder', 'login'),
										'label-top': !0,
										'explain': c.default.createInputExplain(
											'mfa.challenge.enterCode.tooltip',
											'mfa.challenge.enterCode.placeholder',
											'login'
										),
										'explain-top': !0,
										'name': 'passCode',
										'input': p.default,
										'type': 'tel',
										'showWhen': v,
									}),
									u.default.Toolbar({
										noCancelButton: !0,
										save: (0, i.loc)('mfa.challenge.verify', 'login'),
										showWhen: v,
									})
								),
								{
									title: n,
									noButtonBar: !0,
									autoSave: !0,
									className: y(e),
									showWarning: function (e) {
										this.clearWarnings(), this.add(m, '.o-form-error-container', { options: { warning: e } });
									},
									clearWarnings: function () {
										this.$('.okta-form-infobox-warning').remove();
									},
									initialize: function () {
										var e = o.default.template({
												compiler: [8, '>= 4.3.0'],
												main: function (e, t, n, r, o) {
													var i =
														e.lookupProperty ||
														function (e, t) {
															if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
														};
													return e.escapeExpression(
														(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
															null != t ? t : e.nullContext || {},
															{
																name: 'i18n',
																hash: { $1: '<b>$1</b>', bundle: 'login', code: 'factor.call.time.warning' },
																data: o,
																loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 71 } },
															}
														)
													);
												},
												useData: !0,
											}),
											n = o.default.template({
												compiler: [8, '>= 4.3.0'],
												main: function (e, t, n, r, o) {
													var i =
														e.lookupProperty ||
														function (e, t) {
															if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
														};
													return e.escapeExpression(
														(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
															null != t ? t : e.nullContext || {},
															{
																name: 'i18n',
																hash: { $1: '<b>$1</b>', bundle: 'login', code: 'factor.sms.time.warning' },
																data: o,
																loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 70 } },
															}
														)
													);
												},
												useData: !0,
											});
										this.listenTo(this.model, 'change:ableToResend', function (r, o) {
											o ? this.showWarning(t ? e : n) : this.clearWarnings();
										}),
											this.listenTo(this.model, 'error errors:clear', function () {
												this.clearWarnings(), this.clearErrors();
											}),
											this.listenTo(this.model, 'change:enrolled', function () {
												this.$('.js-enroll-phone').toggle();
											});
									},
									formChildren: _,
								}
							);
						},
						Footer: d.default,
						trapAuthResponse: function () {
							return this.options.appState.get('isMfaEnrollActivate')
								? (this.model.set('factorId', this.options.appState.get('activatedFactorId')), !0)
								: !(!this.options.appState.get('isMfaEnroll') || !this.model.get('trapEnrollment')) || void 0;
						},
						initialize: function () {
							g(this.options.factorType)
								? this.model.set('hasExistingPhones', this.options.appState.get('hasExistingPhonesForCall'))
								: this.model.set('hasExistingPhones', this.options.appState.get('hasExistingPhones')),
								this.model.set('factorType', this.options.factorType);
						},
					});
					(t.default = _), (e.exports = t.default);
				},
				87459: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(38513)),
						s = r(n(91537)),
						l = r(n(10268)),
						u = r(n(35546)),
						c = r(n(73650)),
						d = r(n(39409)),
						f = o.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a,
									s =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<span>' +
									(null !=
									(i =
										'function' ==
										typeof (a =
											null != (a = s(n, 'subtitle') || (null != t ? s(t, 'subtitle') : t)) ? a : e.hooks.helperMissing)
											? a.call(null != t ? t : e.nullContext || {}, {
													name: 'subtitle',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 6 }, end: { line: 1, column: 20 } },
											  })
											: a)
										? i
										: '') +
									'</span>'
								);
							},
							useData: !0,
						}),
						p = c.default.extend({
							className: 'enroll-choices',
							state: { pageType: null },
							Model: {},
							Form: {
								noCancelButton: !0,
								title: i._.partial(i.loc, 'enroll.choices.title', 'login'),
								noButtonBar: function () {
									return this.state.get('pageType') === u.default.ALL_OPTIONAL_NONE_ENROLLED;
								},
								subtitle: ' ',
								getSubtitle: function () {
									switch (this.state.get('pageType')) {
										case u.default.ALL_OPTIONAL_SOME_ENROLLED:
										case u.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
											return (0, i.loc)('enroll.choices.optional', 'login');
										case u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
											var e = this.options.appState.get('gracePeriodRemainingDays');
											return null !== e && e >= 0 ? this.getGracePeriodSubtitle(e) : this.getDefaultSubtitle();
										default:
											return this.getDefaultSubtitle();
									}
								},
								getDefaultSubtitle: function () {
									return this.settings.get('brandName')
										? (0, i.loc)('enroll.choices.description.specific', 'login', [this.settings.get('brandName')])
										: (0, i.loc)('enroll.choices.description.generic', 'login');
								},
								getGracePeriodSubtitle: function (e) {
									return e >= 1
										? (0, i.loc)('enroll.choices.description.gracePeriod.bold', 'login', [e])
										: (0, i.loc)('enroll.choices.description.gracePeriod.oneDay.bold', 'login');
								},
								save: function () {
									switch (this.state.get('pageType')) {
										case u.default.ALL_OPTIONAL_SOME_ENROLLED:
										case u.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
											return (0, i.loc)('enroll.choices.submit.finish', 'login');
										case u.default.HAS_REQUIRED_NONE_ENROLLED:
											return (0, i.loc)('enroll.choices.submit.configure', 'login');
										case u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
											return (0, i.loc)('enroll.choices.submit.next', 'login');
										default:
											return '';
									}
								},
								initialize: function (e) {
									this.listenTo(this, 'save', function () {
										var t;
										switch (this.state.get('pageType')) {
											case u.default.HAS_REQUIRED_NONE_ENROLLED:
											case u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
												(t = e.appState.get('factors').getFirstUnenrolledRequiredFactor()),
													e.appState.trigger(
														'navigate',
														d.default.createEnrollFactorUrl(t.get('provider'), t.get('factorType'))
													);
												break;
											default:
												return this.model.doTransaction(function (e) {
													return e.skip();
												});
										}
									});
								},
								preRender: function () {
									this.add(f({ subtitle: this.getSubtitle() }), 'p.okta-form-subtitle');
									var e = this.options.appState.get('factors');
									switch (this.state.get('pageType')) {
										case u.default.HAS_REQUIRED_NONE_ENROLLED:
										case u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED:
											this.add(
												new l.default({
													minimize: !0,
													collection: new i.Collection(e.where({ required: !0 })),
													appState: this.options.appState,
												})
											);
											break;
										case u.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED:
										case u.default.ALL_OPTIONAL_SOME_ENROLLED:
										case u.default.ALL_OPTIONAL_NONE_ENROLLED:
											var t,
												n = e.where({ enrolled: !0 }),
												r = e.filter(function (e) {
													return !e.get('enrolled') || e.get('additionalEnrollment');
												});
											n.length > 0 &&
												((t = (0, i.loc)('enroll.choices.list.optional', 'login')),
												this.add(
													new a.default({
														listTitle: (0, i.loc)('enroll.choices.list.enrolled', 'login'),
														minimize: !0,
														collection: new i.Collection(n),
														appState: this.options.appState,
													})
												)),
												this.add(
													new a.default({
														listTitle: t,
														collection: new i.Collection(r),
														appState: this.options.appState,
														showInlineSetupButton: !0,
													})
												);
									}
								},
							},
							initialize: function (e) {
								var t,
									n,
									r = 0,
									o = 0,
									i = 0,
									a = 0;
								e.appState.get('factors').each(function (e) {
									var t = e.get('required'),
										n = e.get('enrolled'),
										s = e.get('additionalEnrollment');
									t && n ? r++ : t && !n ? o++ : !t && n ? i++ : t || n || a++, n && s && a++;
								}),
									(t = r > 0 || o > 0) && 0 === r
										? (n = u.default.HAS_REQUIRED_NONE_ENROLLED)
										: t && o > 0
										? (n = u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED)
										: t && a > 0
										? (n = u.default.HAS_REQUIRED_ALL_REQUIRED_ENROLLED)
										: 0 === i && a > 0
										? (n = u.default.ALL_OPTIONAL_NONE_ENROLLED)
										: a > 0
										? (n = u.default.ALL_OPTIONAL_SOME_ENROLLED)
										: this.model.doTransaction(function (e) {
												return e.skip();
										  }),
									this.state.set('pageType', n),
									this.options.appState.get('skipLink') &&
										n === u.default.HAS_REQUIRED_SOME_REQUIRED_ENROLLED &&
										this.add(new s.default(this.toJSON()));
							},
						});
					(t.default = p), (e.exports = t.default);
				},
				83567: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(73650)),
						a = r(n(68457)),
						s = o.internal.util.Util,
						l = i.default.extend({
							className: 'enroll-custom-factor',
							Model: {
								local: { provider: 'string', factorType: 'string' },
								save: function () {
									var e = this;
									return this.manageTransaction(function (t, n) {
										return o._.findWhere(t.factors, { provider: e.get('provider'), factorType: e.get('factorType') })
											.enroll()
											.then(function (t) {
												n(t);
												var r = e.appState.get('enrollCustomFactorRedirectUrl');
												null !== r && s.redirect(r);
											})
											.catch(function (e) {
												throw e;
											});
									});
								},
							},
							Form: function () {
								var e = this.options.appState
									.get('factors')
									.findWhere({ provider: this.options.provider, factorType: this.options.factorType })
									.get('vendorName');
								return {
									autoSave: !0,
									title: e,
									subtitle: (0, o.loc)('enroll.customFactor.subtitle', 'login', [e]),
									save: (0, o.loc)('enroll.customFactor.save', 'login'),
								};
							},
							trapAuthResponse: function () {
								if (this.options.appState.get('isMfaEnrollActivate')) return !0;
							},
							initialize: function () {
								this.model.set('provider', this.options.provider),
									this.model.set('factorType', this.options.factorType);
							},
							Footer: a.default,
						});
					(t.default = l), (e.exports = t.default);
				},
				40471: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(79084)),
						a = r(n(6321)),
						s = r(n(73650)),
						l = r(n(68457)),
						u = s.default.extend({
							className: 'enroll-duo duo-form',
							Model: {
								props: {
									host: 'string',
									signature: 'string',
									postAction: 'string',
									factorId: 'string',
									stateToken: 'string',
								},
								getInitOptions: function () {
									return this.doTransaction(function (e) {
										return o._.findWhere(e.factors, { factorType: 'web', provider: 'DUO' }).enroll();
									});
								},
								activate: function (e) {
									var t = this.get('postAction'),
										n = this.get('factorId'),
										r = this,
										i = { id: n, stateToken: this.get('stateToken'), sig_response: e };
									return (0, a.default)(o.$.post(t, i))
										.then(function () {
											return r.doTransaction(function (e) {
												return e.poll();
											});
										})
										.catch(function (e) {
											r.trigger('error', r, e.xhr);
										});
								},
							},
							Form: {
								autoSave: !0,
								noButtonBar: !0,
								title: o._.partial(o.loc, 'enroll.duo.title', 'login'),
								postRender: function () {
									this.add('<iframe frameborder="0" title="' + this.title() + '"></iframe>'),
										i.default.init({
											host: this.model.get('host'),
											sig_request: this.model.get('signature'),
											iframe: this.$('iframe').get(0),
											post_action: o._.bind(this.model.activate, this.model),
										});
								},
							},
							Footer: l.default,
							fetchInitialData: function () {
								var e = this;
								return this.model.getInitOptions(this.options.appState).then(function (t) {
									var n = t.data;
									if (
										!(
											n &&
											n._embedded &&
											n._embedded.factor &&
											n._embedded.factor._embedded &&
											n._embedded.factor._embedded.activation
										)
									)
										throw new Error('Response does not have duo activation options');
									var r = n._embedded.factor,
										o = r._embedded.activation;
									e.model.set({
										host: o.host,
										signature: o.signature,
										postAction: o._links.complete.href,
										factorId: r.id,
										stateToken: n.stateToken,
									});
								});
							},
							trapAuthResponse: function () {
								if (this.options.appState.get('isMfaEnrollActivate')) return !0;
							},
						});
					(t.default = u), (e.exports = t.default);
				},
				25523: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(73650)),
						s = r(n(39694)),
						l = r(n(68457)),
						u = {
							local: { factorType: 'string', provider: 'string' },
							save: function () {
								this.trigger('save');
								var e = this.pick('factorType', 'provider');
								return this.doTransaction(function (t) {
									return i._.findWhere(t.factors, e).enroll();
								});
							},
						},
						c = a.default.extend({
							className: 'enroll-email',
							Model: u,
							Form: function () {
								return {
									title: i._.partial(i.loc, 'email.enroll.title', 'login'),
									noButtonBar: !1,
									autoSave: !0,
									save: i._.partial(i.loc, 'email.button.send', 'login'),
									formChildren: [
										s.default.View({
											View: i.View.extend({
												attributes: { 'data-se': 'enroll-email-content' },
												template: o.default.template({
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, o) {
														var i =
															e.lookupProperty ||
															function (e, t) {
																if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
															};
														return e.escapeExpression(
															(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
																null != t ? t : e.nullContext || {},
																{
																	name: 'i18n',
																	hash: { bundle: 'login', code: 'email.enroll.description' },
																	data: o,
																	loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 55 } },
																}
															)
														);
													},
													useData: !0,
												}),
											}),
										}),
									],
								};
							},
							Footer: l.default,
							initialize: function () {
								this.model.set(i._.pick(this.options, 'factorType', 'provider'));
							},
						});
					(t.default = c), (e.exports = t.default);
				},
				6418: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(73650)),
						a = r(n(39694)),
						s = r(n(68457)),
						l = r(n(81824)),
						u = i.default.extend({
							className: 'enroll-hotp',
							Model: function () {
								return {
									local: {
										__factorType__: ['string', !1, this.options.factorType],
										__provider__: ['string', !1, this.options.provider],
									},
								};
							},
							Form: {
								title: function () {
									var e = this.options.appState
										.get('factors')
										.findWhere({
											provider: this.model.get('__provider__'),
											factorType: this.model.get('__factorType__'),
										});
									return (0, o.loc)('enroll.totp.title', 'login', [e.get('factorLabel')]);
								},
								noButtonBar: !0,
								attributes: { 'data-se': 'restrict-enroll' },
								formChildren: function () {
									return [
										a.default.View({ View: new l.default({ message: (0, o.loc)('enroll.hotp.restricted', 'login') }) }),
									];
								},
							},
							Footer: s.default,
						});
					(t.default = u), (e.exports = t.default);
				},
				98702: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(73650)),
						a = r(n(39694)),
						s = r(n(90570)),
						l = r(n(68457)),
						u = r(n(50160));
					function c(e) {
						return 'RSA' === e;
					}
					function d(e) {
						return c(e) ? 'enroll-rsa' : 'enroll-onprem';
					}
					var f = i.default.extend({
						className: function () {
							return d(this.options.provider);
						},
						Model: function () {
							var e = this.options.provider,
								t = this.options.appState
									.get('factors')
									.findWhere(o._.pick(this.options, 'provider', 'factorType'))
									.get('profile');
							return {
								props: {
									credentialId: ['string', !0, t && t.credentialId ? t.credentialId : ''],
									passCode: ['string', !0],
									factorId: 'string',
								},
								save: function () {
									return this.doTransaction(function (t) {
										return o._.findWhere(t.factors, { factorType: 'token', provider: e }).enroll({
											passCode: this.get('passCode'),
											profile: { credentialId: this.get('credentialId') },
										});
									});
								},
							};
						},
						Form: function () {
							var e = this.options.provider,
								t = this.options.appState
									.get('factors')
									.findWhere(o._.pick(this.options, 'provider', 'factorType'))
									.get('vendorName');
							return {
								title: c(e) ? (0, o.loc)('factor.totpHard.rsaSecurId', 'login') : t,
								noButtonBar: !0,
								autoSave: !0,
								className: d(e),
								initialize: function () {
									var e = this;
									this.listenTo(this.model, 'error', function (t, n) {
										n &&
											409 === n.status &&
											(e.$('.o-form-input-name-passCode input').val(''),
											e.$('.o-form-input-name-passCode input').trigger('change'),
											e.$('.o-form-input-name-passCode input').focus());
									});
								},
								formChildren: [
									a.default.Input({
										'label': (0, o.loc)('enroll.onprem.username.placeholder', 'login', [t]),
										'label-top': !0,
										'explain': s.default.createInputExplain(
											'enroll.onprem.username.tooltip',
											'enroll.onprem.username.placeholder',
											'login',
											[t],
											[t]
										),
										'explain-top': !0,
										'name': 'credentialId',
										'input': u.default,
										'type': 'text',
									}),
									a.default.Input({
										'label': (0, o.loc)('enroll.onprem.passcode.placeholder', 'login', [t]),
										'label-top': !0,
										'explain': s.default.createInputExplain(
											'enroll.onprem.passcode.tooltip',
											'enroll.onprem.passcode.placeholder',
											'login',
											[t],
											[t]
										),
										'explain-top': !0,
										'name': 'passCode',
										'input': u.default,
										'type': 'password',
									}),
									a.default.Toolbar({ noCancelButton: !0, save: (0, o.loc)('mfa.challenge.verify', 'login') }),
								],
							};
						},
						Footer: l.default,
					});
					(t.default = f), (e.exports = t.default);
				},
				33874: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(73650)),
						a = r(n(78419)),
						s = r(n(68457)),
						l = r(n(50160)),
						u = i.default.extend({
							className: 'enroll-password',
							Model: {
								props: { password: ['string', !0], confirmPassword: ['string', !0] },
								validate: function () {
									return a.default.validateFieldsMatch(
										this,
										'password',
										'confirmPassword',
										(0, o.loc)('password.enroll.error.match', 'login')
									);
								},
								save: function () {
									return this.doTransaction(function (e) {
										return o._.findWhere(e.factors, { factorType: 'password', provider: 'OKTA' }).enroll({
											profile: { password: this.get('password') },
										});
									});
								},
							},
							Form: {
								autoSave: !0,
								title: o._.partial(o.loc, 'enroll.password.setup', 'login'),
								inputs: function () {
									return [
										{
											'label': (0, o.loc)('mfa.challenge.password.placeholder', 'login'),
											'label-top': !0,
											'className': 'o-form-fieldset o-form-label-top auth-passcode',
											'name': 'password',
											'input': l.default,
											'type': 'password',
										},
										{
											'label': (0, o.loc)('password.confirmPassword.placeholder', 'login'),
											'label-top': !0,
											'className': 'o-form-fieldset o-form-label-top auth-passcode',
											'name': 'confirmPassword',
											'input': l.default,
											'type': 'password',
										},
									];
								},
							},
							Footer: s.default,
						});
					(t.default = u), (e.exports = t.default);
				},
				70567: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(2645)),
						a = r(n(73650)),
						s = r(n(90570)),
						l = r(n(68457)),
						u = r(n(50160)),
						c = a.default.extend({
							className: 'enroll-question',
							Model: {
								props: { question: 'string', answer: ['string', !0] },
								local: { securityQuestions: 'object' },
								save: function () {
									return this.doTransaction(function (e) {
										return o._.findWhere(e.factors, { factorType: 'question', provider: 'OKTA' }).enroll({
											profile: { question: this.get('question'), answer: this.get('answer') },
										});
									});
								},
							},
							Form: {
								autoSave: !0,
								title: o._.partial(o.loc, 'enroll.securityQuestion.setup', 'login'),
								inputs: function () {
									return [
										{
											'label': !1,
											'label-top': !0,
											'name': 'question',
											'type': 'select',
											'wide': !0,
											'options': function () {
												return this.model.get('securityQuestions');
											},
											'params': { searchThreshold: 25 },
										},
										{
											'label': (0, o.loc)('mfa.challenge.answer.placeholder', 'login'),
											'label-top': !0,
											'explain': s.default.createInputExplain(
												'mfa.challenge.answer.tooltip',
												'mfa.challenge.answer.placeholder',
												'login'
											),
											'explain-top': !0,
											'className': 'o-form-fieldset o-form-label-top auth-passcode',
											'name': 'answer',
											'input': u.default,
											'type': 'text',
										},
									];
								},
							},
							Footer: l.default,
							fetchInitialData: function () {
								var e = this;
								return this.model
									.manageTransaction(function (e) {
										return o._.findWhere(e.factors, { factorType: 'question', provider: 'OKTA' }).questions();
									})
									.then(function (t) {
										var n = {};
										o._.each(t, function (e) {
											n[e.question] = i.default.getSecurityQuestionLabel(e);
										}),
											e.model.set('securityQuestions', n);
									});
							},
						});
					(t.default = c), (e.exports = t.default);
				},
				32436: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(73650)),
						a = r(n(39694)),
						s = r(n(90570)),
						l = r(n(68457)),
						u = r(n(50160)),
						c = i.default.extend({
							className: 'enroll-symantec',
							Model: {
								props: {
									credentialId: ['string', !0],
									passCode: ['string', !0],
									nextPassCode: ['string', !0],
									factorId: 'string',
								},
								save: function () {
									return this.doTransaction(function (e) {
										return o._.findWhere(e.factors, { factorType: 'token', provider: 'SYMANTEC' }).enroll({
											passCode: this.get('passCode'),
											nextPassCode: this.get('nextPassCode'),
											profile: { credentialId: this.get('credentialId') },
										});
									});
								},
							},
							Form: {
								title: o._.partial(o.loc, 'factor.totpHard.symantecVip', 'login'),
								subtitle: o._.partial(o.loc, 'enroll.symantecVip.subtitle', 'login'),
								noButtonBar: !0,
								autoSave: !0,
								className: 'enroll-symantec',
								formChildren: function () {
									return [
										a.default.Input({
											'label': (0, o.loc)('enroll.symantecVip.credentialId.placeholder', 'login'),
											'label-top': !0,
											'explain': s.default.createInputExplain(
												'enroll.symantecVip.credentialId.tooltip',
												'enroll.symantecVip.credentialId.placeholder',
												'login'
											),
											'explain-top': !0,
											'name': 'credentialId',
											'input': u.default,
											'type': 'text',
										}),
										a.default.Input({
											'label': (0, o.loc)('enroll.symantecVip.passcode1.placeholder', 'login'),
											'label-top': !0,
											'explain': s.default.createInputExplain(
												'enroll.symantecVip.passcode1.tooltip',
												'enroll.symantecVip.passcode1.placeholder',
												'login'
											),
											'explain-top': !0,
											'name': 'passCode',
											'input': u.default,
											'type': 'text',
										}),
										a.default.Input({
											'label': (0, o.loc)('enroll.symantecVip.passcode2.placeholder', 'login'),
											'label-top': !0,
											'explain': s.default.createInputExplain(
												'enroll.symantecVip.passcode2.tooltip',
												'enroll.symantecVip.passcode2.placeholder',
												'login'
											),
											'explain-top': !0,
											'name': 'nextPassCode',
											'input': u.default,
											'type': 'text',
										}),
										a.default.Toolbar({ noCancelButton: !0, save: (0, o.loc)('mfa.challenge.verify', 'login') }),
									];
								},
							},
							Footer: l.default,
						});
					(t.default = c), (e.exports = t.default);
				},
				41438: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = r(n(2645)),
						l = r(n(73650)),
						u = r(n(39694)),
						c = r(n(89866)),
						d = r(n(68457)),
						f = {
							__deviceType__: function (e) {
								return void 0 !== e;
							},
						},
						p = a.View.extend({
							attributes: { 'data-se': 'app-download-instructions' },
							className: 'app-download-instructions',
							template: i.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, i) {
									var a,
										s,
										l = null != t ? t : e.nullContext || {},
										u = e.hooks.helperMissing,
										c = 'function',
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<span class="app-logo ' +
										e.escapeExpression(
											((s = null != (s = d(n, 'appIcon') || (null != t ? d(t, 'appIcon') : t)) ? s : u),
											(0, o.default)(s) === c
												? s.call(l, {
														name: 'appIcon',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 22 }, end: { line: 1, column: 33 } },
												  })
												: s)
										) +
										'"></span><p class="instructions">' +
										(null !=
										((s = null != (s = d(n, 'appStoreLinkText') || (null != t ? d(t, 'appStoreLinkText') : t)) ? s : u),
										(a =
											(0, o.default)(s) === c
												? s.call(l, {
														name: 'appStoreLinkText',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 66 }, end: { line: 1, column: 88 } },
												  })
												: s))
											? a
											: '') +
										'</p>'
									);
								},
								useData: !0,
							}),
							initialize: function () {
								this.listenTo(this.model, 'change:__deviceType__', this.render);
							},
							postRender: function () {
								var e = this.$el.find('.instructions a');
								e.length && (e[0].setAttribute('target', '_blank'), e[0].setAttribute('rel', 'noreferer noopener'));
							},
							getTemplateData: function () {
								var e,
									t,
									n,
									r = s.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
								return (
									(n = c.default.STORE[this.model.get('__deviceType__')]),
									'GOOGLE' === this.model.get('__provider__')
										? ((e = c.default.GOOGLE[this.model.get('__deviceType__')]), (t = 'google-auth-38'))
										: ((e = c.default.OKTA[this.model.get('__deviceType__')]), (t = 'okta-verify-download-icon')),
									{ appStoreLinkText: n ? (0, a.loc)('enroll.totp.downloadApp', 'login', [e, r, n]) : null, appIcon: t }
								);
							},
						}),
						h = l.default.extend({
							className: 'enroll-totp',
							Model: function () {
								return {
									local: {
										__deviceType__: 'string',
										__factorType__: ['string', !1, this.options.factorType],
										__provider__: ['string', !1, this.options.provider],
									},
									save: function () {
										return this.doTransaction(function (e) {
											return a._.findWhere(e.factors, {
												factorType: this.get('__factorType__'),
												provider: this.get('__provider__'),
											}).enroll();
										});
									},
								};
							},
							Form: {
								title: function () {
									var e = s.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
									return (0, a.loc)('enroll.totp.title', 'login', [e]);
								},
								noButtonBar: !0,
								attributes: { 'data-se': 'step-device-type' },
								formChildren: function () {
									var e = { APPLE: (0, a.loc)('iphone', 'login'), ANDROID: (0, a.loc)('android', 'login') };
									return [
										u.default.Input({
											name: '__deviceType__',
											type: 'radio',
											options: e,
											group: !0,
											label: a._.partial(a.loc, 'enroll.totp.selectDevice', 'login'),
										}),
										u.default.Divider({ showWhen: f }),
										u.default.View({ View: p, showWhen: f }),
										u.default.Button({
											title: (0, a.loc)('oform.next', 'login'),
											attributes: { 'data-type': 'save' },
											className: 'button button-primary default-custom-button',
											click: function () {
												this.model.save();
											},
											showWhen: f,
										}),
									];
								},
							},
							Footer: d.default,
						});
					(t.default = h), (e.exports = t.default);
				},
				87312: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(6321));
					n(83147);
					var s = n(13671),
						l = r(n(14726)),
						u = r(n(73650)),
						c = r(n(39694)),
						d = r(n(68457)),
						f = r(n(81824)),
						p = u.default.extend({
							className: 'enroll-u2f',
							Model: {
								local: { __enrolled__: 'boolean' },
								save: function () {
									return (
										this.trigger('request'),
										this.get('__enrolled__')
											? this.activate()
											: this.doTransaction(function (e) {
													return i._.findWhere(e.factors, { factorType: 'u2f', provider: 'FIDO' }).enroll();
											  })
									);
								},
								activate: function () {
									return (
										this.set('__enrolled__', !0),
										this.trigger('errors:clear'),
										this.doTransaction(function (e) {
											var t = e.factor.activation,
												n = t.appId,
												r = [{ version: l.default.getU2fVersion(), challenge: t.nonce }],
												o = this,
												i = a.default.defer();
											return (
												u2f.register(n, r, [], function (t) {
													o.trigger('errors:clear'),
														t.errorCode && 0 !== t.errorCode
															? i.reject(
																	new s.U2FError({
																		xhr: {
																			responseJSON: {
																				errorSummary: l.default.getU2fEnrollErrorMessageByCode(t.errorCode),
																			},
																		},
																	})
															  )
															: i.resolve(
																	e.activate({
																		registrationData: t.registrationData,
																		version: t.version,
																		challenge: t.challenge,
																		clientData: t.clientData,
																	})
															  );
												}),
												i.promise
											);
										})
									);
								},
							},
							Form: {
								title: i._.partial(i.loc, 'enroll.u2f.title', 'login'),
								save: i._.partial(i.loc, 'enroll.u2f.save', 'login'),
								noCancelButton: !0,
								hasSavingState: !1,
								autoSave: !0,
								className: 'enroll-u2f-form',
								noButtonBar: function () {
									return !l.default.isU2fAvailable();
								},
								modelEvents: { request: '_startEnrollment', error: '_stopEnrollment' },
								formChildren: function () {
									var e = [];
									if (l.default.isU2fAvailable())
										e.push(
											c.default.View({
												View: i.View.extend({
													template: o.default.template({
														compiler: [8, '>= 4.3.0'],
														main: function (e, t, n, r, o) {
															var i,
																a = null != t ? t : e.nullContext || {},
																s = e.hooks.helperMissing,
																l =
																	e.lookupProperty ||
																	function (e, t) {
																		if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																	};
															return (
																'<div class="u2f-instructions"><ol><li>' +
																(null !=
																(i = (l(n, 'i18n') || (t && l(t, 'i18n')) || s).call(a, {
																	name: 'i18n',
																	hash: { bundle: 'login', code: 'enroll.u2f.general2' },
																	data: o,
																	loc: { start: { line: 1, column: 38 }, end: { line: 1, column: 90 } },
																}))
																	? i
																	: '') +
																'</li><li>' +
																e.escapeExpression(
																	(l(n, 'i18n') || (t && l(t, 'i18n')) || s).call(a, {
																		name: 'i18n',
																		hash: { bundle: 'login', code: 'enroll.u2f.general3' },
																		data: o,
																		loc: { start: { line: 1, column: 99 }, end: { line: 1, column: 149 } },
																	})
																) +
																'</li></ol></div>'
															);
														},
														useData: !0,
													}),
												}),
											})
										),
											e.push(
												c.default.View({
													View: i.View.extend({
														template: o.default.template({
															compiler: [8, '>= 4.3.0'],
															main: function (e, t, n, r, o) {
																var i = null != t ? t : e.nullContext || {},
																	a = e.hooks.helperMissing,
																	s = e.escapeExpression,
																	l =
																		e.lookupProperty ||
																		function (e, t) {
																			if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																		};
																return (
																	'<div class="u2f-enroll-text hide"><p>' +
																	s(
																		(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
																			name: 'i18n',
																			hash: { bundle: 'login', code: 'enroll.u2f.instructions' },
																			data: o,
																			loc: { start: { line: 1, column: 37 }, end: { line: 1, column: 91 } },
																		})
																	) +
																	'</p><p>' +
																	s(
																		(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
																			name: 'i18n',
																			hash: { bundle: 'login', code: 'enroll.u2f.instructionsBluetooth' },
																			data: o,
																			loc: { start: { line: 1, column: 98 }, end: { line: 1, column: 161 } },
																		})
																	) +
																	'</p><div data-se="u2f-devices" class="u2f-devices-images"><div class="u2f-usb"></div><div class="u2f-bluetooth"></div></div><div data-se="u2f-waiting" class="okta-waiting-spinner"></div></div>'
																);
															},
															useData: !0,
														}),
													}),
												})
											);
									else {
										var t = 'u2f.error.factorNotSupported';
										1 === this.options.appState.get('factors').length && (t = 'u2f.error.factorNotSupported.oneFactor'),
											e.push(
												c.default.View(
													{ View: new f.default({ message: (0, i.loc)(t, 'login') }) },
													{ selector: '.o-form-error-container' }
												)
											);
									}
									return e;
								},
								_startEnrollment: function () {
									this.$('.u2f-instructions').addClass('hide'),
										this.$('.u2f-enroll-text').removeClass('hide'),
										this.$('.o-form-button-bar').hide();
								},
								_stopEnrollment: function () {
									this.$('.u2f-instructions').removeClass('hide'),
										this.$('.u2f-enroll-text').addClass('hide'),
										this.$('.o-form-button-bar').show();
								},
							},
							Footer: d.default,
							trapAuthResponse: function () {
								if (this.options.appState.get('isMfaEnrollActivate')) return this.model.activate(), !0;
							},
						});
					(t.default = p), (e.exports = t.default);
				},
				85584: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(21749)),
						i = r(n(96336)),
						a = r(n(80549)),
						s = r(n(41706)),
						l = i.default.extend({
							className: 'enroll-user',
							initialize: function (e) {
								(this.options = e || {}), (this.model = new o.default(this.options));
							},
							fetchInitialData: function () {
								return this.options.appState.get('isUnauthenticated')
									? this.model.getEnrollFormData()
									: i.default.prototype.fetchInitialData.call();
							},
							trapAuthResponse: function () {
								if (this.options.appState.get('isProfileRequired')) return !0;
							},
							postRender: function () {
								var e = new a.default(this.toJSON());
								this.add(e), this.add(new s.default(this.toJSON())), this.addListeners();
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				43125: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(6321)),
						s = r(n(34425)),
						l = r(n(76587)),
						u = n(13671),
						c = r(n(73650)),
						d = r(n(39694)),
						f = r(n(49268)),
						p = r(n(68457)),
						h = r(n(81824));
					var m = c.default.extend({
						className: 'enroll-webauthn',
						Model: {
							local: { __enrolled__: 'boolean' },
							save: function () {
								return (
									this.trigger('request'),
									this.get('__enrolled__')
										? this.activate()
										: this.doTransaction(function (e) {
												return i._.findWhere(e.factors, { factorType: 'webauthn', provider: 'FIDO' }).enroll();
										  })
								);
							},
							activate: function () {
								var e = this;
								return (
									this.set('__enrolled__', !0),
									this.trigger('errors:clear'),
									this.appState.on('backToFactors', function () {
										e.webauthnAbortController &&
											(e.webauthnAbortController.abort(), (e.webauthnAbortController = null));
									}),
									this.doTransaction(function (e) {
										var t,
											n,
											r = e.factor.activation,
											o = this;
										if (f.default.isNewApiAvailable()) {
											var s = i._.extend({}, r, {
												challenge: l.default.strToBin(r.challenge),
												user: { id: l.default.strToBin(r.user.id), name: r.user.name, displayName: r.user.displayName },
												excludeCredentials:
													((t = r.excludeCredentials),
													(n = []),
													i._.each(t, function (e) {
														n.push({ type: 'public-key', id: l.default.strToBin(e.id) });
													}),
													n),
											});
											return (
												'undefined' != typeof AbortController && (o.webauthnAbortController = new AbortController()),
												new a.default(
													navigator.credentials.create({
														publicKey: s,
														signal: o.webauthnAbortController && o.webauthnAbortController.signal,
													})
												)
													.then(function (t) {
														return e.activate({
															attestation: l.default.binToStr(t.response.attestationObject),
															clientData: l.default.binToStr(t.response.clientDataJSON),
															transports: f.default.processWebAuthnResponse(t.response.getTransports, t.response),
															clientExtensions: f.default.processWebAuthnResponse(t.getClientExtensionResults, t),
														});
													})
													.catch(function (e) {
														throw (
															(o.trigger('errors:clear'),
															o.webauthnAbortController
																? new u.WebAuthnError({ xhr: { responseJSON: { errorSummary: e.message } } })
																: new u.WebauthnAbortError())
														);
													})
													.finally(function () {
														o.webauthnAbortController = null;
													})
											);
										}
									})
								);
							},
						},
						Form: {
							title: i._.partial(i.loc, 'enroll.webauthn.biometric.title', 'login'),
							save: i._.partial(i.loc, 'enroll.webauthn.save', 'login'),
							noCancelButton: !0,
							hasSavingState: !1,
							autoSave: !0,
							className: 'enroll-webauthn-form',
							noButtonBar: function () {
								return !f.default.isNewApiAvailable();
							},
							modelEvents: { request: '_startEnrollment', error: '_stopEnrollment' },
							formChildren: function () {
								var e = [];
								if (f.default.isNewApiAvailable())
									e.push(
										d.default.View({
											View: i.View.extend({
												className: 'webauthn-enroll-text',
												template: o.default.template({
													1: function (e, t, n, r, o) {
														var i,
															a =
																e.lookupProperty ||
																function (e, t) {
																	if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																};
														return (
															'<div class="webauthn-edge-text"><p>' +
															(null !=
															(i = (a(n, 'i18n') || (t && a(t, 'i18n')) || e.hooks.helperMissing).call(
																null != t ? t : e.nullContext || {},
																{
																	name: 'i18n',
																	hash: { bundle: 'login', code: 'enroll.webauthn.biometric.instructions.edge' },
																	data: o,
																	loc: { start: { line: 1, column: 173 }, end: { line: 1, column: 249 } },
																}
															))
																? i
																: '') +
															'</p></div>'
														);
													},
													3: function (e, t, n, r, o) {
														var i,
															a =
																e.lookupProperty ||
																function (e, t) {
																	if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																};
														return (
															'<div class="webauthn-restrictions-text"><p>' +
															(null !=
															(i = (a(n, 'i18n') || (t && a(t, 'i18n')) || e.hooks.helperMissing).call(
																null != t ? t : e.nullContext || {},
																{
																	name: 'i18n',
																	hash: { bundle: 'login', code: 'enroll.webauthn.instructions.noSupportForBiometric' },
																	data: o,
																	loc: { start: { line: 1, column: 340 }, end: { line: 1, column: 423 } },
																}
															))
																? i
																: '') +
															'</p></div>'
														);
													},
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, o) {
														var i,
															a = null != t ? t : e.nullContext || {},
															s =
																e.lookupProperty ||
																function (e, t) {
																	if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																};
														return (
															'<div class="webauthn-enroll-instructions"><p>' +
															e.escapeExpression(
																(s(n, 'i18n') || (t && s(t, 'i18n')) || e.hooks.helperMissing).call(a, {
																	name: 'i18n',
																	hash: { bundle: 'login', code: 'enroll.webauthn.biometric.instructions' },
																	data: o,
																	loc: { start: { line: 1, column: 45 }, end: { line: 1, column: 114 } },
																})
															) +
															'</p></div>' +
															(null !=
															(i = s(n, 'if').call(a, null != t ? s(t, 'isEdge') : t, {
																name: 'if',
																hash: {},
																fn: e.program(1, o, 0),
																inverse: e.noop,
																data: o,
																loc: { start: { line: 1, column: 124 }, end: { line: 1, column: 266 } },
															}))
																? i
																: '') +
															(null !=
															(i = s(n, 'if').call(a, null != t ? s(t, 'onlySupportsSecurityKey') : t, {
																name: 'if',
																hash: {},
																fn: e.program(3, o, 0),
																inverse: e.noop,
																data: o,
																loc: { start: { line: 1, column: 266 }, end: { line: 1, column: 440 } },
															}))
																? i
																: '') +
															'<div data-se="webauthn-waiting" class="okta-waiting-spinner hide"></div>'
														);
													},
													useData: !0,
												}),
												getTemplateData: function () {
													return {
														isEdge: s.default.isEdge(),
														onlySupportsSecurityKey:
															(s.default.isFirefox() || s.default.isSafari()) && s.default.isMac(),
													};
												},
											}),
										})
									);
								else {
									var t = 'webauthn.biometric.error.factorNotSupported';
									1 === this.options.appState.get('factors').length &&
										(t = 'webauthn.biometric.error.factorNotSupported.oneFactor'),
										e.push(
											d.default.View(
												{ View: new h.default({ message: (0, i.loc)(t, 'login') }) },
												{ selector: '.o-form-error-container' }
											)
										);
								}
								return e;
							},
							_startEnrollment: function () {
								this.$('.okta-waiting-spinner').show(), this.$('.o-form-button-bar').hide();
							},
							_stopEnrollment: function () {
								this.$('.okta-waiting-spinner').hide(), this.$('.o-form-button-bar').show();
							},
						},
						Footer: p.default,
						trapAuthResponse: function () {
							if (this.options.appState.get('isMfaEnrollActivate')) return this.model.activate(), !0;
						},
					});
					(t.default = m), (e.exports = t.default);
				},
				63824: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(73650)),
						a = r(n(39694)),
						s = r(n(49268)),
						l = r(n(68457)),
						u = r(n(81824)),
						c = r(n(64521)),
						d = i.default.extend({
							className: 'enroll-windows-hello',
							Model: {
								local: { __isEnrolled__: 'boolean' },
								save: function () {
									if (s.default.isAvailable())
										return (
											this.trigger('request'),
											this.get('__isEnrolled__')
												? this.activate()
												: this.doTransaction(function (e) {
														return this._enroll(e);
												  })
										);
								},
								_enroll: function (e) {
									return o._.findWhere(e.factors, { factorType: 'webauthn', provider: 'FIDO' }).enroll();
								},
								activate: function () {
									return (
										this.set('__isEnrolled__', !0),
										this.doTransaction(function (e) {
											var t = e.factor.activation,
												n = e.user,
												r = this,
												o = {
													rpDisplayName: t.rpDisplayName,
													userDisplayName: n.profile.displayName,
													accountName: n.profile.login,
													userId: n.id,
												},
												i = [{ algorithm: t.algorithm }],
												a = t.nonce;
											return s.default
												.makeCredential(o, i, a)
												.then(function (t) {
													return e.activate({
														credentialId: t.credential.id,
														publicKey: t.publicKey,
														attestation: null,
													});
												})
												.catch(function (t) {
													switch (t.message) {
														case 'AbortError':
														case 'NotFoundError':
														case 'NotSupportedError':
															return r.trigger('abort', t.message), e;
													}
													throw t;
												});
										})
									);
								},
							},
							Form: {
								autoSave: !0,
								hasSavingState: !1,
								title: o._.partial(o.loc, 'enroll.windowsHello.title', 'login'),
								subtitle: function () {
									return s.default.isAvailable() ? (0, o.loc)('enroll.windowsHello.subtitle', 'login') : '';
								},
								save: o._.partial(o.loc, 'enroll.windowsHello.save', 'login'),
								customSavingState: { stop: 'abort' },
								modelEvents: function () {
									return s.default.isAvailable()
										? { request: '_startEnrollment', error: '_stopEnrollment', abort: '_stopEnrollment' }
										: {};
								},
								noButtonBar: function () {
									return !s.default.isAvailable();
								},
								formChildren: function () {
									var e = [];
									return (
										s.default.isAvailable() ||
											e.push(
												a.default.View(
													{
														View: new u.default({
															message: (0, o.loc)('enroll.windowsHello.error.notWindows', 'login'),
														}),
													},
													{ selector: '.o-form-error-container' }
												)
											),
										e.push(a.default.View({ View: new c.default({ model: this.model, visible: !1 }) })),
										e
									);
								},
								_startEnrollment: function () {
									(this.subtitle = (0, o.loc)('enroll.windowsHello.subtitle.loading', 'login')),
										this.model.trigger('spinner:show'),
										this._resetErrorMessage(),
										this.render(),
										this.$('.o-form-button-bar').addClass('hide');
								},
								_stopEnrollment: function (e) {
									var t;
									if (
										((this.subtitle = (0, o.loc)('enroll.windowsHello.subtitle', 'login')),
										this.model.trigger('spinner:hide'),
										'NotSupportedError' === e)
									)
										t = (0, o.loc)('enroll.windowsHello.error.notConfiguredHtml', 'login');
									if ((this._resetErrorMessage(), t)) {
										var n = new u.default({ message: t });
										this.$('.o-form-error-container').addClass('o-form-has-errors'),
											this.add(n, { selector: '.o-form-error-container' }),
											(this._errorMessageView = this.last());
									}
									this.render(), this.$('.o-form-button-bar').removeClass('hide');
								},
								_resetErrorMessage: function () {
									this._errorMessageView && this._errorMessageView.remove(),
										(this._errorMessageView = void 0),
										this.clearErrors();
								},
							},
							Footer: l.default,
							trapAuthResponse: function () {
								if (this.options.appState.get('isMfaEnrollActivate')) return this.model.activate(), !0;
							},
						});
					(t.default = d), (e.exports = t.default);
				},
				53177: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(73650)),
						a = r(n(39694)),
						s = r(n(68457)),
						l = r(n(50160)),
						u = i.default.extend({
							className: 'enroll-yubikey',
							Model: {
								props: { passCode: ['string', !0], factorId: 'string' },
								save: function () {
									return this.doTransaction(function (e) {
										return o._.findWhere(e.factors, { factorType: 'token:hardware', provider: 'YUBICO' }).enroll({
											passCode: this.get('passCode'),
										});
									});
								},
							},
							Form: {
								title: o._.partial(o.loc, 'enroll.yubikey.title', 'login'),
								subtitle: o._.partial(o.loc, 'enroll.yubikey.subtitle', 'login'),
								noCancelButton: !0,
								save: o._.partial(o.loc, 'mfa.challenge.verify', 'login'),
								autoSave: !0,
								className: 'enroll-yubikey',
								formChildren: [
									a.default.View({ View: '<div class="yubikey-demo" data-type="yubikey-example"></div>' }),
									a.default.Input({ name: 'passCode', input: l.default, type: 'password' }),
								],
							},
							Footer: s.default,
						});
					(t.default = u), (e.exports = t.default);
				},
				38889: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(73390)),
						s = r(n(73650)),
						l = r(n(39694)),
						u = r(n(39409)),
						c = i.View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<a href="#" class="link help js-back" data-se="back-link">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'oform.back' },
													data: o,
													loc: { start: { line: 1, column: 58 }, end: { line: 1, column: 99 } },
												}
											)
										) +
										'</a>'
									);
								},
								useData: !0,
							}),
							className: 'auth-footer',
							events: {
								'click .js-back': function (e) {
									e.preventDefault(), this.back();
								},
							},
							back: function () {
								var e = u.default.createActivateFactorUrl(
									this.options.appState.get('activatedFactorProvider'),
									this.options.appState.get('activatedFactorType'),
									'manual'
								);
								this.options.appState.trigger('navigate', e);
							},
						}),
						d = {
							title: i._.partial(i.loc, 'enroll.totp.enrollViaEmail.title', 'login'),
							noButtonBar: !0,
							attributes: { 'data-se': 'sent-email-activation-link' },
							formChildren: [
								l.default.View({
									View: i.View.extend({
										template: o.default.template({
											compiler: [8, '>= 4.3.0'],
											main: function (e, t, n, r, o) {
												var i,
													a = null != t ? t : e.nullContext || {},
													s = e.hooks.helperMissing,
													l = e.escapeExpression,
													u =
														e.lookupProperty ||
														function (e, t) {
															if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
														};
												return (
													'<p>' +
													l(
														(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
															name: 'i18n',
															hash: { bundle: 'login', code: 'enroll.totp.enrollViaEmail.msg' },
															data: o,
															loc: { start: { line: 1, column: 3 }, end: { line: 1, column: 64 } },
														})
													) +
													'</p><p class="email-address">' +
													l(
														'function' ==
															typeof (i = null != (i = u(n, 'email') || (null != t ? u(t, 'email') : t)) ? i : s)
															? i.call(a, {
																	name: 'email',
																	hash: {},
																	data: o,
																	loc: { start: { line: 1, column: 93 }, end: { line: 1, column: 102 } },
															  })
															: i
													) +
													'</p>'
												);
											},
											useData: !0,
										}),
										getTemplateData: function () {
											return { email: this.options.appState.get('userEmail') };
										},
									}),
								}),
							],
						},
						f = {
							title: i._.partial(i.loc, 'enroll.totp.enrollViaSms.title', 'login'),
							noButtonBar: !0,
							attributes: { 'data-se': 'sent-sms-activation-link' },
							formChildren: [
								l.default.View({
									View: i.View.extend({
										template: o.default.template({
											compiler: [8, '>= 4.3.0'],
											main: function (e, t, n, r, o) {
												var i,
													a = null != t ? t : e.nullContext || {},
													s = e.hooks.helperMissing,
													l = e.escapeExpression,
													u =
														e.lookupProperty ||
														function (e, t) {
															if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
														};
												return (
													'<p>' +
													l(
														(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
															name: 'i18n',
															hash: { bundle: 'login', code: 'enroll.totp.enrollViaSms.msg' },
															data: o,
															loc: { start: { line: 1, column: 3 }, end: { line: 1, column: 62 } },
														})
													) +
													'</p><p class="phone-number">' +
													l(
														'function' ==
															typeof (i =
																null != (i = u(n, 'phoneNumber') || (null != t ? u(t, 'phoneNumber') : t)) ? i : s)
															? i.call(a, {
																	name: 'phoneNumber',
																	hash: {},
																	data: o,
																	loc: { start: { line: 1, column: 90 }, end: { line: 1, column: 105 } },
															  })
															: i
													) +
													'</p>'
												);
											},
											useData: !0,
										}),
										getTemplateData: function () {
											return { phoneNumber: this.model.get('fullPhoneNumber') };
										},
									}),
								}),
							],
						},
						p = s.default.extend({
							className: 'enroll-activation-link-sent',
							Model: function () {
								return {
									local: {
										countryCode: ['string', !1, this.options.appState.get('userCountryCode')],
										phoneNumber: ['string', !1, this.options.appState.get('userPhoneNumber')],
										__factorType__: ['string', !1, this.options.factorType],
										__provider__: ['string', !1, this.options.provider],
									},
									derived: {
										countryCallingCode: {
											deps: ['countryCode'],
											fn: function (e) {
												return '+' + a.default.getCallingCodeForCountry(e);
											},
										},
										fullPhoneNumber: {
											deps: ['countryCallingCode', 'phoneNumber'],
											fn: function (e, t) {
												return e + t;
											},
										},
									},
								};
							},
							Form: function () {
								var e = this.options.appState.get('factorActivationType');
								switch (e) {
									case 'SMS':
										return f;
									case 'EMAIL':
										return d;
									default:
										throw new Error('Unknown activation option: ' + e);
								}
							},
							Footer: c,
							initialize: function () {
								this.pollForEnrollment();
							},
							remove: function () {
								return s.default.prototype.remove.apply(this, arguments);
							},
							pollForEnrollment: function () {
								return this.model.doTransaction(function (e) {
									return e.poll(6e3);
								});
							},
							trapAuthResponse: function () {
								if (this.options.appState.get('isWaitingForActivation')) return this.pollForEnrollment(), !0;
							},
						});
					(t.default = p), (e.exports = t.default);
				},
				2093: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(73650)),
						s = r(n(39409)),
						l = r(n(21304)),
						u = i.View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<a href="#" class="link help js-back" data-se="back-link">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'oform.back' },
													data: o,
													loc: { start: { line: 1, column: 58 }, end: { line: 1, column: 99 } },
												}
											)
										) +
										'</a>'
									);
								},
								useData: !0,
							}),
							className: 'auth-footer',
							events: {
								'click .js-back': function (e) {
									e.preventDefault(), this.back();
								},
							},
							back: function () {
								var e = s.default.createActivateFactorUrl(
									this.options.appState.get('activatedFactorProvider'),
									'push',
									'manual'
								);
								this.options.appState.trigger('navigate', e);
							},
						}),
						c = a.default.extend({
							className: 'activate-push',
							Model: function () {
								return {
									props: {
										factorId: ['string', !0, this.options.appState.get('activatedFactorId')],
										passCode: ['string', !0],
									},
									local: {
										__factorType__: ['string', !1, this.options.factorType],
										__provider__: ['string', !1, this.options.provider],
									},
									save: function () {
										return this.doTransaction(function (e) {
											return e.activate({ passCode: this.get('passCode') });
										});
									},
								};
							},
							Form: l.default,
							Footer: u,
						});
					(t.default = c), (e.exports = t.default);
				},
				75996: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(73650)),
						i = r(n(11205)),
						a = o.default.extend({ className: 'error-state', Model: {}, Form: { noButtonBar: !0 }, Footer: i.default });
					(t.default = a), (e.exports = t.default);
				},
				40635: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(64521)),
						i = r(n(96336)),
						a = r(n(90570)),
						s = i.default.extend({
							className: 'force-idp-discovery',
							View: o.default,
							Model: {},
							initialize: function () {
								var e = this,
									t = this.options,
									n = t.appState.get('lastAuthResponse'),
									r = { resource: 'okta:acct:', requestContext: n && (null == n ? void 0 : n.stateToken) };
								t.appState.settings
									.getAuthClient()
									.webfinger(r)
									.then(function (n) {
										if (
											null != n &&
											n.links &&
											n.links[0] &&
											'OKTA' !== n.links[0].properties['okta:idp:type'] &&
											n.links[0].href
										)
											return void (
												n.links[0].href.includes('OKTA_INVALID_SESSION_REPOST%3Dtrue')
													? a.default.redirectWithFormGet.bind(a.default)
													: e.settings.get('redirectUtilFn')
											)(n.links[0].href);
										t.appState.trigger('navigate', '');
									})
									.catch(function () {
										t.appState.trigger('navigate', '');
									});
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				61437: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(35546)),
						s = r(n(73650)),
						l = r(n(39694)),
						u = r(n(90570)),
						c = r(n(78419)),
						d = r(n(17849)),
						f = r(n(50160)),
						p = i.View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<div class="okta-form-infobox-error infobox infobox-error" role="alert"><span class="icon error-16"></span><p>' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'password.forgot.noFactorsEnabled' },
													data: o,
													loc: { start: { line: 1, column: 110 }, end: { line: 1, column: 173 } },
												}
											)
										) +
										'</p></div>'
									);
								},
								useData: !0,
							}),
						}),
						h = i.View.extend({
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<a href="#" class="link help js-back" data-se="back-link">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'goback' },
													data: o,
													loc: { start: { line: 1, column: 94 }, end: { line: 1, column: 131 } },
												}
											)
										) +
										'</a>'
									);
								},
								3: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<a href="#" class="link goto js-contact-support">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'mfa.noAccessToEmail' },
													data: o,
													loc: { start: { line: 1, column: 220 }, end: { line: 1, column: 270 } },
												}
											)
										) +
										'</a>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = s(n, 'unless').call(a, null != t ? s(t, 'hideBackToSignInForReset') : t, {
											name: 'unless',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 146 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'helpSupportNumber') : t, {
											name: 'if',
											hash: {},
											fn: e.program(3, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 146 }, end: { line: 1, column: 281 } },
										}))
											? i
											: '')
									);
								},
								useData: !0,
							}),
							className: 'auth-footer',
							events: {
								'click .js-back': function (e) {
									e.preventDefault(), this.back();
								},
								'click .js-contact-support': function (e) {
									e.preventDefault(), this.state.trigger('contactSupport'), this.$('.js-contact-support').hide();
								},
							},
							getTemplateData: function () {
								return {
									hideBackToSignInForReset: this.settings.get('features.hideBackToSignInForReset'),
									helpSupportNumber: this.settings.get('helpSupportNumber'),
								};
							},
							back: function () {
								this.state.set('navigateDir', a.default.DIRECTION_BACK), this.options.appState.trigger('navigate', '');
							},
						}),
						m = s.default.extend({
							className: 'forgot-password',
							Model: {
								props: { username: ['string', !0], factorType: ['string', !0] },
								validate: function () {
									return c.default.validateUsername(this);
								},
								save: function () {
									var e = this,
										t = this.settings.get('relayState');
									this.startTransaction(function (n) {
										return n.forgotPassword({
											username: e.settings.transformUsername(e.get('username'), a.default.FORGOT_PASSWORD),
											factorType: e.get('factorType'),
											relayState: t,
										});
									}).catch(function () {});
								},
							},
							Form: {
								noButtonBar: !0,
								title: i._.partial(i.loc, 'password.reset', 'login'),
								formChildren: function () {
									var e = this.settings.get('features.smsRecovery'),
										t = this.settings.get('features.callRecovery'),
										n = this.settings.get('features.emailRecovery'),
										r = [];
									return (
										!(e || t || n)
											? this.add(p, '.o-form-error-container')
											: (r.push(
													l.default.Input({
														'label': (0, i.loc)('password.forgot.email.or.username.placeholder', 'login'),
														'label-top': !0,
														'explain': u.default.createInputExplain(
															'password.forgot.email.or.username.tooltip',
															'password.forgot.email.or.username.placeholder',
															'login'
														),
														'explain-top': !0,
														'name': 'username',
														'input': f.default,
														'inputId': 'account-recovery-username',
														'autoComplete': u.default.getAutocompleteValue(this.settings, 'username'),
														'type': 'text',
														'inlineValidation': !1,
													})
											  ),
											  (e || t) &&
													r.push(
														l.default.View({
															View: i.View.extend({
																template: o.default.template({
																	compiler: [8, '>= 4.3.0'],
																	main: function (e, t, n, r, o) {
																		var i =
																			e.lookupProperty ||
																			function (e, t) {
																				if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																			};
																		return (
																			'<p class="mobile-recovery-hint">' +
																			e.escapeExpression(
																				(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
																					null != t ? t : e.nullContext || {},
																					{
																						name: 'i18n',
																						hash: {
																							arguments: 'mobileFactors',
																							bundle: 'login',
																							code: 'recovery.mobile.hint',
																						},
																						data: o,
																						loc: { start: { line: 1, column: 32 }, end: { line: 1, column: 109 } },
																					}
																				)
																			) +
																			'</p>'
																		);
																	},
																	useData: !0,
																}),
																getTemplateData: function () {
																	return {
																		mobileFactors:
																			e && t
																				? (0, i.loc)('recovery.smsOrCall')
																				: t
																				? (0, i.loc)('recovery.call')
																				: (0, i.loc)('recovery.sms'),
																	};
																},
															}),
														})
													),
											  e &&
													(this.$el.addClass('forgot-password-sms-enabled'),
													r.push(
														this.createRecoveryFactorButton(
															'sms-button',
															'password.forgot.sendText',
															a.default.RECOVERY_FACTOR_TYPE_SMS,
															this
														)
													),
													this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_SMS)),
											  t &&
													(this.$el.addClass('forgot-password-call-enabled'),
													r.push(
														this.createRecoveryFactorButton(
															'call-button',
															'password.forgot.call',
															a.default.RECOVERY_FACTOR_TYPE_CALL,
															this
														)
													),
													this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_CALL)),
											  n &&
													(this.$el.addClass('forgot-password-email-enabled'),
													r.push(
														this.createRecoveryFactorButton(
															'email-button',
															'password.forgot.sendEmail',
															a.default.RECOVERY_FACTOR_TYPE_EMAIL,
															this
														)
													),
													this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_EMAIL))),
										r
									);
								},
								initialize: function () {
									this.listenTo(this.state, 'contactSupport', function () {
										this.add(d.default, '.o-form-error-container');
									}),
										this.listenTo(this, 'save', function () {
											this.options.appState.set('username', this.model.get('username')), this.model.save();
										});
								},
								setDefaultFactorType: function (e) {
									i._.isEmpty(this.model.get('factorType')) && this.model.set('factorType', e);
								},
								createRecoveryFactorButton: function (e, t, n, r) {
									return l.default.Button({
										attributes: { 'data-se': e },
										className: 'button button-primary button-wide ' + e,
										title: (0, i.loc)(t, 'login'),
										click: function () {
											r.clearErrors(),
												this.model.isValid() && (this.model.set('factorType', n), r.trigger('save', this.model));
										},
									});
								},
							},
							Footer: h,
							initialize: function () {
								this.options.appState.unset('username');
							},
						});
					(t.default = m), (e.exports = t.default);
				},
				94408: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(23947)),
						i = r(n(31749)),
						a = r(n(28528)),
						s = r(n(96336)),
						l = r(n(69834)),
						u = r(n(65422)),
						c = r(n(75104)),
						d = r(n(39409)),
						f = r(n(90570)),
						p = o.default.extend({
							className: 'idp-discovery',
							View: l.default,
							constructor: function (e) {
								e.appState.unset('username');
								var t = e.settings.get('idpDiscovery.requestContext'),
									n = e.appState.get('lastAuthResponse'),
									r = n && (null == n ? void 0 : n.stateToken);
								f.default.isV1StateToken(t) && (t = r),
									(this.model = new i.default(
										{ requestContext: t, settings: e.settings, appState: e.appState },
										{ parse: !0 }
									)),
									s.default.apply(this, arguments),
									this.addListeners(),
									e.settings.get('hasConfiguredButtons') &&
										this.add(u.default, {
											prepend: e.settings.get('socialAuthPositionTop'),
											options: { currentController: this },
										}),
									this.addFooter(e),
									this.setUsername();
							},
							initialize: function () {
								o.default.prototype.initialize.apply(this),
									this.listenTo(this.model, 'goToPrimaryAuth', function () {
										this.settings.set('username', this.model.get('username'));
										var e = this;
										this.settings.get('features.deviceFingerprinting')
											? c.default
													.generateDeviceFingerprint(this.settings.getAuthClient(), this.$el[0])
													.then(function (t) {
														e.options.appState.set('deviceFingerprint', t),
															e.options.appState.set('username', e.model.get('username'));
													})
													.catch(function () {
														e.options.appState.set('username', e.model.get('username'));
													})
													.finally(function () {
														e.doPrimaryAuth();
													})
											: e.doPrimaryAuth();
									});
							},
							doPrimaryAuth: function () {
								if (this.settings.get('features.passwordlessAuth')) {
									var e = new a.default(
										{
											username: this.model.get('username'),
											multiOptionalFactorEnroll: this.options.settings.get('features.multiOptionalFactorEnroll'),
											settings: this.options.settings,
											appState: this.options.appState,
										},
										{ parse: !0 }
									);
									this.listenTo(e, 'error', function (e, t) {
										this.toggleButtonState(!1), this.model.trigger('error', this.model, t);
									}),
										this.addModelListeners(e),
										e.save();
								} else {
									this.options.appState.set('disableUsername', !0);
									var t = d.default.createSigninUrl(
										this.settings.get('features.prefillUsernameFromIdpDiscovery') && this.model.get('username')
									);
									this.options.appState.trigger('navigate', t);
								}
							},
						});
					(t.default = p), (e.exports = t.default);
				},
				32992: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = r(n(73390)),
						l = r(n(2645)),
						u = r(n(73650)),
						c = r(n(39694)),
						d = r(n(39409)),
						f = r(n(4940)),
						p = r(n(39838));
					function h(e, t) {
						var n = d.default.createActivateFactorUrl(
							e.options.appState.get('activatedFactorProvider'),
							e.options.appState.get('activatedFactorType'),
							t
						);
						e.options.appState.trigger('navigate', n);
					}
					var m = {
						sharedSecret: function (e) {
							return !a._.isUndefined(e);
						},
						activationType: 'MANUAL',
					};
					function v(e) {
						var t, n;
						'SMS' === e.model.get('activationType') &&
							((n = e.model.get('countryCode')), (t = e.model.get('phoneNumber'))),
							e.options.appState.set({
								factorActivationType: e.model.get('activationType'),
								userCountryCode: n,
								userPhoneNumber: t,
							});
					}
					function g(e, t) {
						return e.model.doTransaction(function (n) {
							return n
								.prev()
								.then(function (e) {
									return a._.findWhere(e.factors, { factorType: t, provider: 'OKTA' }).enroll();
								})
								.then(function (t) {
									var n,
										r,
										o,
										i = t.data;
									if (
										i &&
										i._embedded &&
										i._embedded.factor &&
										i._embedded.factor._embedded &&
										i._embedded.factor._embedded.activation
									) {
										var s = i._embedded.factor;
										if (
											((o = s._embedded.activation.sharedSecret),
											s._embedded.activation._links && s._embedded.activation._links.send)
										) {
											var l = s._embedded.activation._links.send,
												u = a._.findWhere(l, { name: 'sms' });
											n = u ? u.href : null;
											var c = a._.findWhere(l, { name: 'email' });
											r = c ? c.href : null;
										}
									}
									return e.model.set({ SMS: n, EMAIL: r, sharedSecret: o }), t;
								});
						});
					}
					var y = u.default.extend({
						className: 'enroll-manual-push',
						Model: function () {
							return {
								local: {
									activationType: ['string', !0, this.options.appState.get('factorActivationType') || 'SMS'],
									countryCode: ['string', !1, this.options.appState.get('userCountryCode')],
									phoneNumber: 'string',
									SMS: ['string', !1, this.options.appState.get('textActivationLinkUrl')],
									EMAIL: ['string', !1, this.options.appState.get('emailActivationLinkUrl')],
									sharedSecret: ['string', !1, this.options.appState.get('sharedSecret')],
									__factorType__: ['string', !1, this.options.factorType],
									__provider__: ['string', !1, this.options.provider],
								},
								derived: {
									countryCallingCode: {
										deps: ['countryCode'],
										fn: function (e) {
											return '+' + s.default.getCallingCodeForCountry(e);
										},
									},
									fullPhoneNumber: {
										deps: ['countryCallingCode', 'phoneNumber'],
										fn: function (e, t) {
											return e + t;
										},
									},
								},
							};
						},
						Form: {
							title: function () {
								var e = l.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
								return (0, a.loc)('enroll.totp.title', 'login', [e]);
							},
							subtitle: a._.partial(a.loc, 'enroll.totp.cannotScanBarcode', 'login'),
							noButtonBar: !0,
							attributes: { 'data-se': 'step-manual-setup' },
							formChildren: function () {
								var e = this,
									t = this.settings.get('brandName')
										? (0, a.loc)('enroll.totp.sharedSecretInstructions.specific', 'login', [
												this.settings.get('brandName'),
										  ])
										: (0, a.loc)('enroll.totp.sharedSecretInstructions.generic', 'login');
								return [
									c.default.Input({
										name: 'activationType',
										label: (0, a.loc)('mfa.setupOptions', 'login'),
										type: 'select',
										wide: !0,
										options: {
											SMS: (0, a.loc)('enroll.totp.sendSms', 'login'),
											EMAIL: (0, a.loc)('enroll.totp.sendEmail', 'login'),
											MANUAL: (0, a.loc)('enroll.totp.setupManually', 'login'),
										},
									}),
									c.default.Input({
										label: (0, a.loc)('mfa.country', 'login'),
										name: 'countryCode',
										type: 'select',
										wide: !0,
										options: s.default.getCountries(),
										showWhen: { activationType: 'SMS' },
									}),
									c.default.Input({
										'label': (0, a.loc)('mfa.phoneNumber.placeholder', 'login'),
										'label-top': !0,
										'className': 'enroll-sms-phone',
										'name': 'phoneNumber',
										'input': p.default,
										'type': 'text',
										'showWhen': { activationType: 'SMS' },
									}),
									c.default.View({
										View: a.View.extend({
											className: 'secret-key-instructions',
											attributes: { 'data-se': 'secret-key-instructions' },
											template: i.default.template({
												compiler: [8, '>= 4.3.0'],
												main: function (e, t, n, r, i) {
													var a,
														s = null != t ? t : e.nullContext || {},
														l = e.hooks.helperMissing,
														u = 'function',
														c = e.escapeExpression,
														d =
															e.lookupProperty ||
															function (e, t) {
																if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
															};
													return (
														'<section aria-live="assertive"><p class="okta-form-subtitle o-form-explain text-align-c">' +
														c(
															((a =
																null != (a = d(n, 'instructions') || (null != t ? d(t, 'instructions') : t)) ? a : l),
															(0, o.default)(a) === u
																? a.call(s, {
																		name: 'instructions',
																		hash: {},
																		data: i,
																		loc: { start: { line: 1, column: 89 }, end: { line: 1, column: 105 } },
																  })
																: a)
														) +
														'</p><p class="shared-key margin-top-10" tabindex=0 aria-label="' +
														c(
															(d(n, 'i18n') || (t && d(t, 'i18n')) || l).call(s, {
																name: 'i18n',
																hash: {
																	arguments: 'sharedSecretKey',
																	bundle: 'login',
																	code: 'enroll.totp.sharedSecretInstructions.aria.secretKey',
																},
																data: i,
																loc: { start: { line: 1, column: 168 }, end: { line: 1, column: 278 } },
															})
														) +
														'">' +
														c(
															((a =
																null != (a = d(n, 'sharedSecretKey') || (null != t ? d(t, 'sharedSecretKey') : t))
																	? a
																	: l),
															(0, o.default)(a) === u
																? a.call(s, {
																		name: 'sharedSecretKey',
																		hash: {},
																		data: i,
																		loc: { start: { line: 1, column: 280 }, end: { line: 1, column: 299 } },
																  })
																: a)
														) +
														'</p></section>'
													);
												},
												useData: !0,
											}),
											initialize: function () {
												this.listenTo(this.model, 'change:sharedSecret', this.render);
											},
											getTemplateData: function () {
												return { instructions: t, sharedSecretKey: this.model.get('sharedSecret') };
											},
										}),
										showWhen: { activationType: 'MANUAL' },
									}),
									c.default.View({
										View: a.View.extend({
											template: i.default.template({
												compiler: [8, '>= 4.3.0'],
												main: function (e, t, n, r, o) {
													return '<div data-type="next-button-wrap"></div>';
												},
												useData: !0,
											}),
										}),
										showWhen: m,
									}),
									c.default.Button(
										{
											title: (0, a.loc)('oform.next', 'login'),
											className: 'button button-primary button-wide button-next',
											attributes: { 'data-se': 'next-button' },
											click: function () {
												v(e), h(e, 'passcode');
											},
										},
										'[data-type="next-button-wrap"]'
									),
									c.default.Toolbar({
										noCancelButton: !0,
										save: (0, a.loc)('oform.send', 'login'),
										showWhen: {
											activationType: function (e) {
												return 'SMS' === e || 'EMAIL' === e;
											},
										},
									}),
								];
							},
						},
						Footer: f.default,
						initialize: function () {
							this.setInitialModel(),
								this.listenTo(this.form, 'save', function () {
									var e = this;
									this.model.doTransaction(function (t) {
										var n = this.get('activationType').toLowerCase(),
											r = {};
										return (
											'sms' === n && (r.profile = { phoneNumber: this.get('fullPhoneNumber') }),
											t.factor.activation.send(n, r).then(function (t) {
												return (
													v(e),
													a._.defer(function () {
														h(e, 'sent');
													}),
													t
												);
											})
										);
									});
								}),
								this.listenTo(this.model, 'change:activationType', function (e, t) {
									this.form.clearErrors(),
										'MANUAL' === t && 'token:software:totp' !== this.options.appState.get('activatedFactorType')
											? g(this, 'token:software:totp')
											: 'push' !== this.options.appState.get('activatedFactorType') && g(this, 'push');
								});
						},
						setInitialModel: function () {
							'SMS' === this.options.appState.get('factorActivationType') &&
								this.model.set({
									countryCode: this.options.appState.get('userCountryCode') || 'US',
									phoneNumber: this.options.appState.get('userPhoneNumber'),
								});
						},
						trapAuthResponse: function () {
							if (this.options.appState.get('isMfaEnrollActivate') || this.options.appState.get('isMfaEnroll'))
								return !0;
						},
					});
					(t.default = y), (e.exports = t.default);
				},
				47685: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = r(n(2645)),
						l = r(n(73650)),
						u = r(n(39694)),
						c = r(n(39409)),
						d = r(n(89104)),
						f = l.default.extend({
							className: 'enroll-manual-totp',
							Model: function () {
								return {
									local: {
										sharedSecret: ['string', !1, this.options.appState.get('sharedSecret')],
										__factorType__: ['string', !1, this.options.factorType],
										__provider__: ['string', !1, this.options.provider],
									},
								};
							},
							Form: {
								title: function () {
									var e = s.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
									return (0, a.loc)('enroll.totp.title', 'login', [e]);
								},
								subtitle: a._.partial(a.loc, 'enroll.totp.cannotScanBarcode', 'login'),
								noButtonBar: !0,
								attributes: { 'data-se': 'step-manual-setup' },
								formChildren: function () {
									var e = this.settings.get('brandName')
										? (0, a.loc)('enroll.totp.manualSetupInstructions.specific', 'login', [
												this.settings.get('brandName'),
										  ])
										: (0, a.loc)('enroll.totp.manualSetupInstructions.generic', 'login');
									return [
										u.default.View({
											View: a.View.extend({
												className: 'secret-key-instructions',
												attributes: { 'data-se': 'secret-key-instructions' },
												template: i.default.template({
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, i) {
														var a,
															s = null != t ? t : e.nullContext || {},
															l = e.hooks.helperMissing,
															u = 'function',
															c = e.escapeExpression,
															d =
																e.lookupProperty ||
																function (e, t) {
																	if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																};
														return (
															'<section aria-live="assertive"><p class="okta-form-subtitle o-form-explain text-align-c">' +
															c(
																((a =
																	null != (a = d(n, 'instructions') || (null != t ? d(t, 'instructions') : t)) ? a : l),
																(0, o.default)(a) === u
																	? a.call(s, {
																			name: 'instructions',
																			hash: {},
																			data: i,
																			loc: { start: { line: 1, column: 89 }, end: { line: 1, column: 105 } },
																	  })
																	: a)
															) +
															'</p><p class="shared-key margin-top-10" tabindex=0 aria-label="' +
															c(
																(d(n, 'i18n') || (t && d(t, 'i18n')) || l).call(s, {
																	name: 'i18n',
																	hash: {
																		arguments: 'sharedSecretKey',
																		bundle: 'login',
																		code: 'enroll.totp.sharedSecretInstructions.aria.secretKey',
																	},
																	data: i,
																	loc: { start: { line: 1, column: 168 }, end: { line: 1, column: 278 } },
																})
															) +
															'">' +
															c(
																((a =
																	null != (a = d(n, 'sharedSecretKey') || (null != t ? d(t, 'sharedSecretKey') : t))
																		? a
																		: l),
																(0, o.default)(a) === u
																	? a.call(s, {
																			name: 'sharedSecretKey',
																			hash: {},
																			data: i,
																			loc: { start: { line: 1, column: 280 }, end: { line: 1, column: 299 } },
																	  })
																	: a)
															) +
															'</p></section>'
														);
													},
													useData: !0,
												}),
												initialize: function () {
													this.listenTo(this.model, 'change:sharedSecret', this.render);
												},
												getTemplateData: function () {
													return { instructions: e, sharedSecretKey: this.model.get('sharedSecret') };
												},
											}),
										}),
										u.default.Toolbar({ noCancelButton: !0, save: (0, a.loc)('oform.next', 'login') }),
									];
								},
							},
							Footer: d.default,
							initialize: function () {
								this.listenTo(this.form, 'save', function () {
									var e = c.default.createActivateFactorUrl(
										this.model.get('__provider__'),
										this.model.get('__factorType__'),
										'activate'
									);
									this.options.appState.trigger('navigate', e);
								});
							},
						});
					(t.default = f), (e.exports = t.default);
				},
				26e3: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(96336)),
						a = r(n(96823)),
						s = r(n(86139)),
						l = r(n(54311)),
						u = r(n(89274)),
						c = r(n(99423)),
						d = r(n(39877)),
						f = r(n(83344)),
						p = r(n(61174)),
						h = r(n(27797)),
						m = r(n(71271)),
						v = o.internal.views.forms.inputs.CheckBox,
						g = i.default.extend({
							className: 'mfa-verify',
							initialize: function (e) {
								var t,
									n = e.factorType;
								switch (n) {
									case 'question':
										t = d.default;
										break;
									case 'email':
										t = this.options.appState.get('isIdxStateToken') ? a.default : f.default;
										break;
									case 'sms':
									case 'call':
										t = l.default;
										break;
									case 'token':
									case 'token:software:totp':
									case 'token:hotp':
										t = p.default;
										break;
									case 'token:hardware':
										t = h.default;
										break;
									case 'push':
										t = c.default;
										break;
									case 'password':
										t = u.default;
										break;
									default:
										throw new Error('Unrecognized factor type');
								}
								if (((this.model = this.findModel(n, e)), !this.model)) throw new Error('Unrecognized factor/provider');
								this.addListeners(),
									this.add(new t(this.toJSON())),
									'push' === n &&
										this.model.get('isOktaFactor') &&
										(this.model.get('backupFactor') &&
											(this.inlineTotpForm = this.add(s.default, {
												options: { model: this.model.get('backupFactor') },
											}).last()),
										this.settings.get('features.autoPush') &&
											(this.autoPushCheckBox = this.add(v, {
												options: {
													'model': this.model,
													'name': 'autoPush',
													'placeholder': (0, o.loc)('autoPush', 'login'),
													'label': !1,
													'label-top': !1,
													'className': 'margin-btm-0',
												},
											}).last()),
										this.options.appState.get('allowRememberDevice') &&
											(this.rememberDeviceCheckbox = this.add(v, {
												options: {
													'model': this.model,
													'name': 'rememberDevice',
													'placeholder': this.options.appState.get('rememberDeviceLabel'),
													'label': !1,
													'label-top': !0,
													'className': 'margin-btm-0',
												},
											}).last()),
										this.model.get('backupFactor') &&
											this.listenTo(this.model, 'change:rememberDevice', function (e, t) {
												e.get('backupFactor').set('rememberDevice', t);
											})),
									this.listenTo(this.options.appState, 'change:isWaitingForNumberChallenge', function (e, t) {
										t || 'SUCCESS' === this.options.appState.get('lastAuthResponse').status
											? (this.autoPushCheckBox && this.autoPushCheckBox.$el.hide(),
											  this.rememberDeviceCheckbox && this.rememberDeviceCheckbox.$el.hide(),
											  this.inlineTotpForm && this.inlineTotpForm.$el.hide())
											: (this.autoPushCheckBox && this.autoPushCheckBox.$el.show(),
											  this.rememberDeviceCheckbox && this.rememberDeviceCheckbox.$el.show(),
											  this.inlineTotpForm && this.inlineTotpForm.$el.show());
									}),
									this.add(new m.default(this.toJSON()));
							},
							findModel: function (e, t) {
								var n = t.appState.get('factors'),
									r = t.provider,
									o = t.factorIndex;
								return r
									? n.hasMultipleFactorsOfSameType(e) && o
										? n.getFactorByTypeAndIndex(e, o)
										: n.findWhere({ provider: r, factorType: e })
									: n.findWhere({ factorType: e, isFactorTypeVerification: !0 });
							},
							trapAuthResponse: function () {
								return (
									!!(
										(this.options.appState.get('isMfaRequired') &&
											this.options.appState.get('trapMfaRequiredResponse')) ||
										this.options.appState.get('isMfaChallenge')
									) && (this.options.appState.set('trapMfaRequiredResponse', !1), !0)
								);
							},
							back: function () {},
						});
					(t.default = g), (e.exports = t.default);
				},
				29161: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(2645)),
						a = r(n(73650)),
						s = r(n(39694)),
						l = r(n(90570)),
						u = r(n(78419)),
						c = r(n(84977)),
						d = r(n(25015)),
						f = r(n(50160)),
						p = a.default.extend({
							className: 'password-expired',
							Model: {
								props: { oldPassword: ['string', !0], newPassword: ['string', !0], confirmPassword: ['string', !0] },
								validate: function () {
									return u.default.validatePasswordMatch(this);
								},
								save: function () {
									return (
										this.trigger('save'),
										this.doTransaction(function (e) {
											return e.changePassword({
												oldPassword: this.get('oldPassword'),
												newPassword: this.get('newPassword'),
											});
										})
									);
								},
							},
							Form: {
								save: o._.partial(o.loc, 'password.expired.submit', 'login'),
								title: function () {
									var e = this.options.appState.get('isPwdExpiringSoon'),
										t = this.options.appState.get('passwordExpireDays');
									return e && t > 0
										? (0, o.loc)('password.expiring.title', 'login', [t])
										: e && 0 === t
										? (0, o.loc)('password.expiring.today', 'login')
										: e
										? (0, o.loc)('password.expiring.soon', 'login')
										: this.settings.get('brandName')
										? (0, o.loc)('password.expired.title.specific', 'login', [this.settings.get('brandName')])
										: (0, o.loc)('password.expired.title.generic', 'login');
								},
								subtitle: function () {
									if (this.options.appState.get('isPwdExpiringSoon'))
										return this.settings.get('brandName')
											? (0, o.loc)('password.expiring.subtitle.specific', 'login', [this.settings.get('brandName')])
											: (0, o.loc)('password.expiring.subtitle.generic', 'login');
									var e = this.options.appState.get('policy');
									return e && !this.settings.get('features.showPasswordRequirementsAsHtmlList')
										? i.default.getPasswordComplexityDescription(e)
										: void 0;
								},
								parseErrorMessage: function (e) {
									var t = this.options.appState.get('policy');
									return (
										t &&
											this.settings.get('features.showPasswordRequirementsAsHtmlList') &&
											(e = i.default.removeRequirementsFromError(e, t)),
										e
									);
								},
								formChildren: function () {
									var e = [];
									return (
										this.settings.get('features.showPasswordRequirementsAsHtmlList') &&
											e.push(s.default.View({ View: new d.default({ policy: this.options.appState.get('policy') }) })),
										(e = e.concat([
											s.default.Input({
												'label-top': !0,
												'label': (0, o.loc)('password.oldPassword.placeholder', 'login'),
												'explain': l.default.createInputExplain(
													'password.oldPassword.tooltip',
													'password.oldPassword.placeholder',
													'login'
												),
												'explain-top': !0,
												'name': 'oldPassword',
												'input': f.default,
												'type': 'password',
											}),
											s.default.Divider(),
											s.default.Input({
												'className': 'margin-btm-5',
												'label-top': !0,
												'label': (0, o.loc)('password.newPassword.placeholder', 'login'),
												'explain': l.default.createInputExplain(
													'password.newPassword.tooltip',
													'password.newPassword.placeholder',
													'login'
												),
												'explain-top': !0,
												'name': 'newPassword',
												'input': f.default,
												'type': 'password',
											}),
											s.default.Input({
												'label-top': !0,
												'label': (0, o.loc)('password.confirmPassword.placeholder', 'login'),
												'explain': l.default.createInputExplain(
													'password.confirmPassword.tooltip',
													'password.confirmPassword.placeholder',
													'login'
												),
												'explain-top': !0,
												'name': 'confirmPassword',
												'input': f.default,
												'type': 'password',
											}),
										]))
									);
								},
							},
							Footer: c.default,
							initialize: function () {
								this.listenTo(this.form, 'save', function () {
									var e = { username: this.options.appState.get('userEmail'), password: this.model.get('newPassword') };
									this.settings.processCreds(e).then(o._.bind(this.model.save, this.model));
								});
							},
						});
					(t.default = p), (e.exports = t.default);
				},
				31539: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(2645)),
						a = r(n(73650)),
						s = r(n(39694)),
						l = r(n(90570)),
						u = r(n(78419)),
						c = r(n(88522)),
						d = r(n(25015)),
						f = r(n(50160)),
						p = o.internal.views.forms.inputs.CheckBox,
						h = a.default.extend({
							className: 'password-reset',
							Model: {
								props: {
									newPassword: ['string', !0],
									confirmPassword: ['string', !0],
									revokeSessions: ['boolean', !1],
								},
								validate: function () {
									return u.default.validatePasswordMatch(this);
								},
								save: function () {
									this.trigger('save');
									var e = this;
									return this.doTransaction(function (t) {
										var n = { newPassword: e.get('newPassword') };
										return (
											e.settings.get('features.showSessionRevocation') && (n.revokeSessions = e.get('revokeSessions')),
											t.resetPassword(n)
										);
									});
								},
							},
							Form: {
								save: o._.partial(o.loc, 'password.reset', 'login'),
								title: function () {
									return this.settings.get('brandName')
										? (0, o.loc)('password.reset.title.specific', 'login', [this.settings.get('brandName')])
										: (0, o.loc)('password.reset.title.generic', 'login');
								},
								subtitle: function () {
									var e = this.options.appState.get('policy');
									if (e && !this.settings.get('features.showPasswordRequirementsAsHtmlList'))
										return i.default.getPasswordComplexityDescription(e);
								},
								parseErrorMessage: function (e) {
									var t = this.options.appState.get('policy');
									return (
										t &&
											this.settings.get('features.showPasswordRequirementsAsHtmlList') &&
											(e = i.default.removeRequirementsFromError(e, t)),
										e
									);
								},
								formChildren: function () {
									var e = [];
									return (
										this.settings.get('features.showPasswordRequirementsAsHtmlList') &&
											e.push(s.default.View({ View: new d.default({ policy: this.options.appState.get('policy') }) })),
										(e = e.concat([
											s.default.Input({
												'className': 'margin-btm-5',
												'label': (0, o.loc)('password.newPassword.placeholder', 'login'),
												'label-top': !0,
												'explain': l.default.createInputExplain(
													'password.newPassword.tooltip',
													'password.newPassword.placeholder',
													'login'
												),
												'explain-top': !0,
												'name': 'newPassword',
												'input': f.default,
												'type': 'password',
												'autoComplete': l.default.getAutocompleteValue(this.settings, 'new-password'),
											}),
											s.default.Input({
												'label': (0, o.loc)('password.confirmPassword.placeholder', 'login'),
												'label-top': !0,
												'explain': l.default.createInputExplain(
													'password.confirmPassword.tooltip',
													'password.confirmPassword.placeholder',
													'login'
												),
												'explain-top': !0,
												'name': 'confirmPassword',
												'input': f.default,
												'type': 'password',
												'autoComplete': l.default.getAutocompleteValue(this.settings, 'new-password'),
											}),
										])),
										this.settings.get('features.showSessionRevocation') &&
											(e = e.concat([
												s.default.Input({
													placeholder: (0, o.loc)('password.reset.revokeSessions', 'login'),
													name: 'revokeSessions',
													input: p,
													type: 'checkbox',
												}),
											])),
										e
									);
								},
							},
							initialize: function () {
								this.listenTo(this.form, 'save', function () {
									var e = { username: this.options.appState.get('userEmail'), password: this.model.get('newPassword') };
									this.settings.processCreds(e).then(o._.bind(this.model.save, this.model));
								}),
									this.settings.get('features.hideBackToSignInForReset') || this.addFooter(c.default);
							},
						});
					(t.default = h), (e.exports = t.default);
				},
				37210: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(73650)),
						a = r(n(39694)),
						s = i.default.extend({
							className: 'poll',
							Model: {
								save: function () {
									var e = this;
									return (
										this.trigger('cancelRequest'),
										this.appState
											.get('transaction')
											.cancel()
											.then(function () {
												e.options.appState.trigger('navigate', '');
											})
											.catch(function () {
												e._stopCountDown();
											})
									);
								},
							},
							Form: {
								autoSave: !0,
								hasSavingState: !1,
								title: function () {
									return this.title;
								},
								className: 'poll-controller',
								noCancelButton: !0,
								save: (0, o.loc)('oform.cancel', 'login'),
								modelEvents: { cancelRequest: '_stopCountDown' },
								formChildren: [
									a.default.View({
										View: '<div >               <div data-se="poll-waiting" class="hide okta-waiting-spinner"></div>             </div>',
									}),
								],
								_checkStatus: function () {
									var e = this;
									this.transactionObject
										.poll()
										.then(function (t) {
											if (t.data && 'POLL' !== t.status) e.options.appState.set('transaction', t);
											else {
												e.$('.okta-waiting-spinner').hide();
												var n = Math.ceil(t.transaction.profile.refresh / 1e3);
												e._startCountDown(n);
											}
										})
										.catch(function () {
											e._stopCountDown();
										});
								},
								_startCountDown: function (e) {
									var t = this;
									this.countDown = setInterval(function () {
										t._updateTitle(e),
											0 === e
												? (t._stopCountDown(),
												  t.$('.okta-waiting-spinner').show(),
												  (t.checkStatusTimeout = setTimeout(function () {
														t._checkStatus();
												  }, 200)))
												: (e -= 1);
									}, 1e3);
								},
								_updateTitle: function (e) {
									(this.title = (0, o.loc)('polling.title', 'login', [e])),
										this.$el.find('.okta-form-title').text(this.title);
								},
								_stopCountDown: function () {
									this.countDown && clearInterval(this.countDown),
										this.checkStatusTimeout && clearInterval(this.checkStatusTimeout);
								},
								initialize: function (e) {
									(this.transactionObject = e.appState.get('transaction')),
										(this.factorPollingIntervalSeconds = Math.ceil(
											this.transactionObject.transaction.profile.refresh / 1e3
										)),
										this._updateTitle(this.factorPollingIntervalSeconds),
										this._startCountDown(this.factorPollingIntervalSeconds);
								},
							},
							back: function () {},
							remove: function () {
								this.form._stopCountDown();
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				23947: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(28528)),
						a = r(n(96336)),
						s = r(n(75104)),
						l = r(n(65422)),
						u = r(n(25708)),
						c = r(n(89365)),
						d = r(n(83536)),
						f = r(n(41706)),
						p = a.default.extend({
							className: 'primary-auth',
							state: { enabled: !0 },
							View: u.default,
							constructor: function (e) {
								e.appState.unset('username'),
									(this.model = new i.default(
										{
											multiOptionalFactorEnroll: e.settings.get('features.multiOptionalFactorEnroll'),
											settings: e.settings,
											appState: e.appState,
										},
										{ parse: !0 }
									)),
									a.default.apply(this, arguments),
									this.addListeners(),
									e.settings.get('hasConfiguredButtons') &&
										this.add(l.default, {
											prepend: e.settings.get('socialAuthPositionTop'),
											options: { currentController: this },
										}),
									this.addFooter(e),
									this.options.appState.get('disableUsername') && this.addFooterWithBackLink(this.options),
									this.setUsername();
							},
							addFooter: function (e) {
								this.add(new c.default(this.toJSON({ appState: e.appState }))),
									(e.settings.get('features.registration') || e.appState.get('isIdxStateToken')) &&
										this.add(new d.default({ settings: this.settings, appState: e.appState }));
							},
							addFooterWithBackLink: function (e) {
								this.$el.find('.footer-back-link').length ||
									this.add(
										new f.default(this.toJSON({ appState: e.appState, className: 'auth-footer footer-back-link' }))
									);
							},
							setUsername: function () {
								var e = this.model.get('username');
								e && this.options.appState.set('username', e);
							},
							setUsernameFromIdpDiscovery: function () {
								var e = this.options.username;
								e && (this.model.set('username', e), this.options.appState.set('disableUsername', !0));
							},
							events: {
								'focusout input[name=username]': function () {
									if (this.shouldComputeDeviceFingerprint() && this.model.get('username')) {
										var e = this;
										this.options.appState.trigger('loading', !0),
											s.default
												.generateDeviceFingerprint(this.settings.getAuthClient(), this.$el[0])
												.then(function (t) {
													e.options.appState.set('deviceFingerprint', t),
														e.options.appState.set('username', e.model.get('username'));
												})
												.catch(function () {
													e.options.appState.set('username', e.model.get('username'));
												})
												.finally(function () {
													e.options.appState.trigger('loading', !1);
												});
									} else this.options.appState.set('username', this.model.get('username'));
								},
								'focusin input': function (e) {
									(0, o.$)(e.target.parentElement).addClass('focused-input');
								},
								'focusout input': function (e) {
									(0, o.$)(e.target.parentElement).removeClass('focused-input');
								},
							},
							initialize: function () {
								this.options.appState.unset('deviceFingerprint'),
									this.settings.get('features.prefillUsernameFromIdpDiscovery') && this.setUsernameFromIdpDiscovery(),
									this.listenTo(this.model, 'change:username', function (e, t) {
										t || this.options.appState.set('username', '');
									}),
									this.listenTo(this.model, 'save', function () {
										this.state.set('enabled', !1);
									}),
									this.listenTo(this.model, 'error', function () {
										this.state.set('enabled', !0),
											this.options.appState.get('disableUsername') &&
												(this.state.set('disableUsername', !0), this.addFooterWithBackLink(this.options));
									}),
									this.listenTo(this.state, 'togglePrimaryAuthButton', function (e) {
										this.toggleButtonState(e);
									});
							},
							shouldComputeDeviceFingerprint: function () {
								return (
									this.settings.get('features.securityImage') &&
									this.settings.get('features.deviceFingerprinting') &&
									this.settings.get('features.useDeviceFingerprintForSecurityImage')
								);
							},
						});
					(t.default = p), (e.exports = t.default);
				},
				33243: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(35546)),
						s = r(n(73650)),
						l = r(n(39694)),
						u = s.default.extend({
							className: 'password-reset-email-sent',
							Model: function () {
								return { local: { userFullName: ['string', !1, this.options.appState.get('userFullName')] } };
							},
							Form: {
								title: i._.partial(i.loc, 'password.forgot.emailSent.title', 'login'),
								subtitle: function () {
									var e = this.options.appState.get('username');
									return (0, i.loc)('password.forgot.emailSent.desc', 'login', [e]);
								},
								noButtonBar: !0,
								attributes: { 'data-se': 'pwd-reset-email-sent' },
								formChildren: function () {
									var e = [
										l.default.View({
											View: i.View.extend({
												template: o.default.template({
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, o) {
														var i,
															a =
																e.lookupProperty ||
																function (e, t) {
																	if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																};
														return (
															'<span class="accessibility-text" role="status">' +
															e.escapeExpression(
																'function' ==
																	typeof (i =
																		null != (i = a(n, 'alert') || (null != t ? a(t, 'alert') : t))
																			? i
																			: e.hooks.helperMissing)
																	? i.call(null != t ? t : e.nullContext || {}, {
																			name: 'alert',
																			hash: {},
																			data: o,
																			loc: { start: { line: 1, column: 47 }, end: { line: 1, column: 56 } },
																	  })
																	: i
															) +
															'</span>'
														);
													},
													useData: !0,
												}),
												getTemplateData: function () {
													return { alert: (0, i.loc)('password.forgot.emailSent.title', 'login') };
												},
											}),
										}),
									];
									return (
										this.settings.get('features.hideBackToSignInForReset') ||
											e.push(
												l.default.Button({
													title: (0, i.loc)('goback', 'login'),
													className: 'button button-primary button-wide',
													attributes: { 'data-se': 'back-button' },
													click: function () {
														var e = this;
														return this.model
															.doTransaction(function (e) {
																return e.cancel();
															})
															.then(function () {
																e.state.set('navigateDir', a.default.DIRECTION_BACK),
																	e.options.appState.trigger('navigate', '');
															});
													},
												})
											),
										e
									);
								},
							},
							initialize: function (e) {
								this.settings.callGlobalSuccess(a.default.FORGOT_PASSWORD_EMAIL_SENT, {
									username: e.appState.get('username'),
								});
							},
						});
					(t.default = u), (e.exports = t.default);
				},
				46615: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(35546)),
						s = r(n(73650)),
						l = r(n(39694)),
						u = r(n(88522)),
						c = r(n(50160)),
						d = s.default.extend({
							className: 'recovery-challenge',
							Model: {
								props: { passCode: ['string', !0] },
								local: { ableToResend: 'boolean' },
								resendCode: function () {
									return (
										this.limitResending(),
										this.doTransaction(function (e) {
											return e.resend();
										})
									);
								},
								limitResending: function () {
									this.set({ ableToResend: !1 }),
										i._.delay(i._.bind(this.set, this), a.default.API_RATE_LIMIT, { ableToResend: !0 });
								},
								save: function () {
									return this.doTransaction(function (e) {
										return e.verify({ passCode: this.get('passCode') });
									});
								},
							},
							Form: {
								autoSave: !0,
								save: i._.partial(i.loc, 'mfa.challenge.verify', 'login'),
								title: function () {
									return this.options.appState.get('factorType') === a.default.RECOVERY_FACTOR_TYPE_CALL
										? (0, i.loc)('recoveryChallenge.call.title', 'login')
										: (0, i.loc)('recoveryChallenge.sms.title', 'login');
								},
								className: 'recovery-challenge',
								initialize: function () {
									this.listenTo(this.model, 'error', function () {
										this.clearErrors();
									});
								},
								formChildren: function () {
									return [
										l.default.Button({
											title: (0, i.loc)('mfa.resendCode', 'login'),
											attributes: { 'data-se': 'resend-button' },
											className: 'button sms-request-button margin-top-30',
											click: function () {
												this.model.resendCode();
											},
											initialize: function () {
												this.listenTo(this.model, 'change:ableToResend', function (e, t) {
													t
														? ((this.options.title = (0, i.loc)('mfa.resendCode', 'login')),
														  this.enable(),
														  this.render())
														: ((this.options.title = (0, i.loc)('mfa.sent', 'login')), this.disable(), this.render());
												});
											},
										}),
										l.default.Input({
											'label': (0, i.loc)('mfa.challenge.enterCode.placeholder', 'login'),
											'label-top': !0,
											'className': 'enroll-sms-phone',
											'name': 'passCode',
											'input': c.default,
											'type': 'text',
										}),
									];
								},
							},
							events: {
								'click .send-email-link': function (e) {
									e.preventDefault();
									var t = this.model.settings,
										n = this.options.appState.get('username'),
										r = this.options.appState.get('recoveryType');
									this.model
										.startTransaction(function (e) {
											switch (r) {
												case a.default.RECOVERY_TYPE_PASSWORD:
													return e.forgotPassword({
														username: t.transformUsername(n, a.default.FORGOT_PASSWORD),
														factorType: a.default.RECOVERY_FACTOR_TYPE_EMAIL,
													});
												case a.default.RECOVERY_TYPE_UNLOCK:
													return e.unlockAccount({
														username: t.transformUsername(n, a.default.UNLOCK_ACCOUNT),
														factorType: a.default.RECOVERY_FACTOR_TYPE_EMAIL,
													});
												default:
													return;
											}
										})
										.catch(function () {});
								},
							},
							initialize: function () {
								var e;
								switch (this.options.appState.get('recoveryType')) {
									case a.default.RECOVERY_TYPE_PASSWORD:
										e = o.default.template({
											compiler: [8, '>= 4.3.0'],
											main: function (e, t, n, r, o) {
												var i =
													e.lookupProperty ||
													function (e, t) {
														if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
													};
												return e.escapeExpression(
													(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
														null != t ? t : e.nullContext || {},
														{
															name: 'i18n',
															hash: { bundle: 'login', code: 'password.forgot.code.notReceived' },
															data: o,
															loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 63 } },
														}
													)
												);
											},
											useData: !0,
										});
										break;
									case a.default.RECOVERY_TYPE_UNLOCK:
										e = o.default.template({
											compiler: [8, '>= 4.3.0'],
											main: function (e, t, n, r, o) {
												var i =
													e.lookupProperty ||
													function (e, t) {
														if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
													};
												return e.escapeExpression(
													(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
														null != t ? t : e.nullContext || {},
														{
															name: 'i18n',
															hash: { bundle: 'login', code: 'account.unlock.code.notReceived' },
															data: o,
															loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 62 } },
														}
													)
												);
											},
											useData: !0,
										});
								}
								e &&
									this.settings.get('features.emailRecovery') &&
									this.add(
										i.View.extend({
											className: 'link send-email-link',
											tagName: 'a',
											attributes: { 'href': '#', 'data-se': 'send-email-link' },
											template: e,
										})
									),
									this.settings.get('features.hideBackToSignInForReset') || this.addFooter(u.default);
							},
							postRender: function () {
								this.model.limitResending();
							},
						});
					(t.default = d), (e.exports = t.default);
				},
				79518: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(73650)).default.extend({
						className: 'recovery-loading',
						Model: {},
						Form: { noButtonBar: !0 },
						initialize: function (e) {
							var t = this;
							return this.model
								.startTransaction(function (t) {
									return t.verifyRecoveryToken({ recoveryToken: e.token });
								})
								.catch(function () {
									t.options.appState.trigger('loading', !1), t.options.appState.trigger('removeLoading');
								});
						},
						preRender: function () {
							this.options.appState.trigger('loading', !0);
						},
						trapAuthResponse: function () {
							return this.options.appState.trigger('loading', !1), !1;
						},
					});
					(t.default = o), (e.exports = t.default);
				},
				79636: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(73650)),
						a = r(n(39694)),
						s = r(n(88522)),
						l = r(n(50160)),
						u = i.default.extend({
							className: 'recovery-question',
							Model: {
								props: { answer: ['string', !0], showAnswer: 'boolean' },
								save: function () {
									return this.doTransaction(function (e) {
										return e.answer({ answer: this.get('answer') });
									});
								},
							},
							Form: {
								autoSave: !0,
								save: function () {
									switch (this.options.appState.get('recoveryType')) {
										case 'PASSWORD':
											return (0, o.loc)('password.forgot.question.submit', 'login');
										case 'UNLOCK':
											return (0, o.loc)('account.unlock.question.submit', 'login');
										default:
											return (0, o.loc)('mfa.challenge.verify', 'login');
									}
								},
								title: function () {
									switch (this.options.appState.get('recoveryType')) {
										case 'PASSWORD':
											return (0, o.loc)('password.forgot.question.title', 'login');
										case 'UNLOCK':
											return (0, o.loc)('account.unlock.question.title', 'login');
										default:
											return '';
									}
								},
								formChildren: function () {
									return [
										a.default.Input({
											label: this.options.appState.get('recoveryQuestion'),
											placeholder: (0, o.loc)('mfa.challenge.answer.placeholder', 'login'),
											name: 'answer',
											input: l.default,
											type: 'password',
											initialize: function () {
												this.listenTo(this.model, 'change:showAnswer', function () {
													var e = this.model.get('showAnswer') ? 'text' : 'password';
													this.getInputs()[0].changeType(e);
												});
											},
										}),
										a.default.Input({
											'label': !1,
											'label-top': !0,
											'placeholder': (0, o.loc)('mfa.challenge.answer.showAnswer', 'login'),
											'className': 'recovery-question-show margin-btm-0',
											'name': 'showAnswer',
											'type': 'checkbox',
										}),
									];
								},
							},
							initialize: function () {
								this.settings.get('features.hideBackToSignInForReset') || this.addFooter(s.default);
							},
						});
					(t.default = u), (e.exports = t.default);
				},
				30929: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(73650)),
						i = o.default.extend({
							className: 'refresh-auth-state',
							Model: {},
							Form: { noButtonBar: !0 },
							preRender: function () {
								var e = this.options.appState,
									t = this.options.token;
								this.model.startTransaction(function (n) {
									return (
										e.trigger('loading', !0),
										t
											? n.tx.introspect({ stateToken: t })
											: n.tx.exists()
											? n.tx.resume()
											: void e.trigger('navigate', '')
									);
								});
							},
							remove: function () {
								return this.options.appState.trigger('loading', !1), o.default.prototype.remove.apply(this, arguments);
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				94617: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = r(n(35546)),
						l = r(n(73650)),
						u = r(n(39694)),
						c = l.default.extend({
							events: {
								'click .back-btn': function (e) {
									e.preventDefault(), this.back();
								},
							},
							back: function () {
								this.state.set('navigateDir', s.default.DIRECTION_BACK), this.options.appState.trigger('navigate', '');
							},
							className: 'registration-complete',
							Model: function () {},
							initialize: function () {
								this.settings.callGlobalSuccess(s.default.ACTIVATION_EMAIL_SENT, {
									username: this.options.appState.get('username'),
								});
							},
							Form: {
								noButtonBar: !0,
								formChildren: function () {
									return [
										u.default.View({
											View: a.View.extend({
												template: i.default.template({
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, i) {
														var a,
															s = null != t ? t : e.nullContext || {},
															l = e.hooks.helperMissing,
															u = 'function',
															c = e.escapeExpression,
															d =
																e.lookupProperty ||
																function (e, t) {
																	if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																};
														return (
															'<div class="container"><span class="title-icon icon icon-16 confirm-16-green"></span><h2 class="title">' +
															c(
																((a = null != (a = d(n, 'title') || (null != t ? d(t, 'title') : t)) ? a : l),
																(0, o.default)(a) === u
																	? a.call(s, {
																			name: 'title',
																			hash: {},
																			data: i,
																			loc: { start: { line: 1, column: 103 }, end: { line: 1, column: 112 } },
																	  })
																	: a)
															) +
															'</h2><div class="desc">' +
															c(
																((a = null != (a = d(n, 'desc') || (null != t ? d(t, 'desc') : t)) ? a : l),
																(0, o.default)(a) === u
																	? a.call(s, {
																			name: 'desc',
																			hash: {},
																			data: i,
																			loc: { start: { line: 1, column: 135 }, end: { line: 1, column: 143 } },
																	  })
																	: a)
															) +
															'</div></div><a href="#" class="back-btn" data-se="back-link">' +
															c(
																(d(n, 'i18n') || (t && d(t, 'i18n')) || l).call(s, {
																	name: 'i18n',
																	hash: { bundle: 'login', code: 'goback' },
																	data: i,
																	loc: { start: { line: 1, column: 204 }, end: { line: 1, column: 241 } },
																})
															) +
															'</a>'
														);
													},
													useData: !0,
												}),
												getTemplateData: function () {
													return {
														desc: (0, a.loc)('registration.complete.confirm.text', 'login'),
														title: (0, a.loc)('registration.complete.title', 'login'),
													};
												},
											}),
										}),
									];
								},
							},
						});
					(t.default = c), (e.exports = t.default);
				},
				78070: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(97020)),
						s = r(n(71440)),
						l = r(n(6321)),
						u = r(n(96336)),
						c = r(n(35546)),
						d = n(13671),
						f = r(n(37197)),
						p = r(n(90570)),
						h = r(n(41797)),
						m = i.View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<a href="#" class="link help" data-se="back-link">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'goback' },
													data: o,
													loc: { start: { line: 1, column: 50 }, end: { line: 1, column: 87 } },
												}
											)
										) +
										'</a>'
									);
								},
								useData: !0,
							}),
							className: 'auth-footer',
							events: {
								'click .help': function (e) {
									e.preventDefault(), this.back();
								},
							},
							back: function () {
								this.state.set('navigateDir', c.default.DIRECTION_BACK), this.options.appState.trigger('navigate', '');
							},
						}),
						v = u.default.extend({
							className: 'registration',
							initialize: function () {
								var e = new (s.default.extend({
									settings: this.options.settings,
									url: this.options.settings.get('baseUrl') + '/api/v1/registration/form',
								}))();
								this.state.set('schema', e);
							},
							getRegistrationApiUrl: function () {
								var e = this.settings.get('defaultPolicyId'),
									t = this.options.settings.get('policyId');
								return e ? this.getRegistrationPolicyApi(e) : this.getRegistrationPolicyApi(t);
							},
							getRegistrationPolicyApi: function (e) {
								return this.options.settings.get('baseUrl') + '/api/v1/registration/' + e;
							},
							doPostSubmit: function () {
								if (this.model.get('activationToken')) {
									var e = this;
									e.settings.callGlobalSuccess(c.default.REGISTRATION_COMPLETE, {
										activationToken: this.model.get('activationToken'),
									}),
										new a.default({ settings: e.model.appState.settings })
											.loginWithActivationToken(this.model.get('activationToken'))
											.then(function (t) {
												e.model.trigger('setTransaction', t);
											});
								} else
									this.model.appState.set('username', this.model.get('email')),
										this.model.appState.trigger('navigate', 'signin/register-complete');
							},
							registerUser: function (e) {
								var t = this,
									n = this;
								Object.keys(e).forEach(function (t) {
									return (i._.isNull(e[t]) || i._.isUndefined(e[t]) || '' === e[t]) && delete e[t];
								}),
									(this.model.attributes = e),
									i.Backbone.Model.prototype.save
										.call(this.model)
										.then(function () {
											n.model.trigger('startSaving');
											var e = n.model.get('activationToken'),
												t = e || n.model.get('email');
											n.settings.postRegistrationSubmit(
												t,
												function () {
													n.doPostSubmit();
												},
												function (e) {
													n.showErrors(e);
												}
											);
										})
										.fail(function (e) {
											var n = e.responseJSON;
											if (n && n.errorCauses.length) {
												var r = n.errorCode,
													o = n.errorCauses[0],
													i = o.errorSummary,
													a = o.reason,
													s = o.location;
												'E0000001' === r && 'UNIQUE_CONSTRAINT' === a && t.renderIsNotUniqueError(n),
													t.renderLegacyLocationErrorIfNeeded(s, i),
													p.default.triggerAfterError(t, new d.RegistrationError(i));
											}
										});
							},
							renderIsNotUniqueError: function (e) {
								var t = e.errorCauses[0].location,
									n = (0, i.loc)('registration.error.userName.notUniqueWithinOrg', 'login', [t]);
								this.$el.find('.okta-form-infobox-error p').text(n);
							},
							renderLegacyLocationErrorIfNeeded: function (e, t) {
								e && /^data\.userProfile.*/.test(e) && this.$el.find('.okta-form-infobox-error p').text(t);
							},
							createRegistrationModel: function (e) {
								var t = this,
									n = i.Model.extend({
										url: t.getRegistrationApiUrl() + '/register',
										settings: this.settings,
										appState: this.options.appState,
										props: e,
										local: { activationToken: 'string' },
										toJSON: function () {
											var e = i.Model.prototype.toJSON.apply(this, arguments);
											return { userProfile: e, relayState: this.settings.get('relayState') };
										},
										parse: function (e) {
											return this.set('activationToken', e.activationToken), delete e.activationToken, e;
										},
										save: function () {
											this.settings.preRegistrationSubmit(
												this.attributes,
												function (e) {
													t.registerUser(e);
												},
												function (e) {
													t.showErrors(e);
												}
											);
										},
									});
								return new n();
							},
							showErrors: function (e, t) {
								'parseRegistrationSchema' === e.callback &&
									e.errorCauses &&
									((e.errorSummary = i._.clone(e.errorCauses[0].errorSummary)), delete e.errorCauses),
									this.model.trigger('error', this.model, { responseJSON: e });
								var n = e.callback ? e.callback + ':' + e.errorSummary : e.errorSummary;
								p.default.triggerAfterError(this, new d.RegistrationError(n)),
									t && this.$el.find('.button-primary').hide();
							},
							fetchInitialData: function () {
								var e = this;
								return (
									e.state.get('schema').on('parseComplete', function (t) {
										var n = t.properties.createModelProperties();
										e.settings.set('defaultPolicyId', t.properties.defaultPolicyId),
											(e.model = e.createRegistrationModel(n));
										var r = new (i.Form.extend({
											layout: 'o-form-theme',
											autoSave: !0,
											noCancelButton: !0,
											title: (0, i.loc)('registration.form.title', 'login'),
											save: (0, i.loc)('registration.form.submit', 'login'),
											modelEvents: { invalid: 'modifyErrors' },
											hasSavingState: !0,
											customSavingState: { start: 'startSaving', stop: 'stopSaving' },
											modifyErrors: function (e, t) {
												for (var n in t)
													'model.validation.field.string.minLength' === t[n]
														? (t[n] = (0, i.loc)('registration.model.validation.field.string.too.short', 'login', [
																e.props[n].minLength,
														  ]))
														: 'model.validation.field.string.maxLength' === t[n] &&
														  (t[n] = (0, i.loc)('registration.model.validation.field.string.too.long', 'login', [
																e.props[n].maxLength + 1,
														  ]));
											},
										}))(e.toJSON());
										if ((e.add(r), (e.footer = new e.Footer(e.toJSON())), e.add(e.footer), e.addListeners(), t.error))
											e.showErrors(t.error, !0);
										else {
											t.properties.each(function (e) {
												var t = f.default.createInputOptions(e),
													n = e.get('subSchemas'),
													o = e.get('name');
												r.addInput(t),
													'password' === o && n && r.add(h.default.extend({ id: 'subschemas-' + o, subSchemas: n }));
											});
											var a = o.default.template({
												compiler: [8, '>= 4.3.0'],
												main: function (e, t, n, r, o) {
													var i,
														a =
															e.lookupProperty ||
															function (e, t) {
																if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
															};
													return (
														'<span class="required-fields-label">' +
														e.escapeExpression(
															'function' ==
																typeof (i =
																	null != (i = a(n, 'label') || (null != t ? a(t, 'label') : t))
																		? i
																		: e.hooks.helperMissing)
																? i.call(null != t ? t : e.nullContext || {}, {
																		name: 'label',
																		hash: {},
																		data: o,
																		loc: { start: { line: 1, column: 36 }, end: { line: 1, column: 45 } },
																  })
																: i
														) +
														'</span>'
													);
												},
												useData: !0,
											})({ label: (0, i.loc)('registration.required.fields.label', 'login') });
											r.add(a);
										}
									}),
									(0, l.default)(this.state.get('schema').fetch())
								);
							},
							Footer: m,
						});
					(t.default = v), (e.exports = t.default);
				},
				72468: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(35546)),
						s = r(n(73650)),
						l = r(n(39694)),
						u = r(n(90570)),
						c = r(n(78419)),
						d = r(n(17849)),
						f = r(n(50160)),
						p = i.View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<div class="okta-form-infobox-error infobox infobox-error" role="alert"><span class="icon error-16"></span><p>' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'account.unlock.noFactorsEnabled' },
													data: o,
													loc: { start: { line: 1, column: 110 }, end: { line: 1, column: 172 } },
												}
											)
										) +
										'</p></div>'
									);
								},
								useData: !0,
							}),
						}),
						h = i.View.extend({
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<a href="#" class="link goto js-contact-support">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'mfa.noAccessToEmail' },
													data: o,
													loc: { start: { line: 1, column: 173 }, end: { line: 1, column: 223 } },
												}
											)
										) +
										'</a>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<a href="#" class="link help js-back" data-se="back-link">' +
										e.escapeExpression(
											(s(n, 'i18n') || (t && s(t, 'i18n')) || e.hooks.helperMissing).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'goback' },
												data: o,
												loc: { start: { line: 1, column: 58 }, end: { line: 1, column: 95 } },
											})
										) +
										'</a>' +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'helpSupportNumber') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 99 }, end: { line: 1, column: 234 } },
										}))
											? i
											: '')
									);
								},
								useData: !0,
							}),
							className: 'auth-footer',
							events: {
								'click .js-back': function (e) {
									e.preventDefault(), this.back();
								},
								'click .js-contact-support': function (e) {
									e.preventDefault(), this.state.trigger('contactSupport'), this.$('.js-contact-support').hide();
								},
							},
							getTemplateData: function () {
								return this.settings.pick('helpSupportNumber');
							},
							back: function () {
								this.state.set('navigateDir', a.default.DIRECTION_BACK), this.options.appState.trigger('navigate', '');
							},
						}),
						m = s.default.extend({
							className: 'account-unlock',
							Model: {
								props: { username: ['string', !0], factorType: ['string', !0] },
								validate: function () {
									return c.default.validateUsername(this);
								},
								save: function () {
									var e = this;
									return this.startTransaction(function (t) {
										return t.unlockAccount({
											username: e.settings.transformUsername(e.get('username'), a.default.UNLOCK_ACCOUNT),
											factorType: e.get('factorType'),
										});
									}).catch(function () {});
								},
							},
							Form: {
								noButtonBar: !0,
								title: i._.partial(i.loc, 'account.unlock.title', 'login'),
								formChildren: function () {
									var e = this.settings.get('features.smsRecovery'),
										t = this.settings.get('features.callRecovery'),
										n = this.settings.get('features.emailRecovery'),
										r = [],
										s = this;
									return (
										!(e || t || n)
											? this.add(p, '.o-form-error-container')
											: (r.push(
													l.default.Input({
														'label': (0, i.loc)('account.unlock.email.or.username.placeholder', 'login'),
														'label-top': !0,
														'explain': u.default.createInputExplain(
															'account.unlock.email.or.username.tooltip',
															'account.unlock.email.or.username.placeholder',
															'login'
														),
														'explain-top': !0,
														'name': 'username',
														'input': f.default,
														'inputId': 'account-recovery-username',
														'type': 'text',
														'inlineValidation': !1,
													})
											  ),
											  (e || t) &&
													r.push(
														l.default.View({
															View: i.View.extend({
																template: o.default.template({
																	compiler: [8, '>= 4.3.0'],
																	main: function (e, t, n, r, o) {
																		var i =
																			e.lookupProperty ||
																			function (e, t) {
																				if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																			};
																		return (
																			'<p class="mobile-recovery-hint">' +
																			e.escapeExpression(
																				(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
																					null != t ? t : e.nullContext || {},
																					{
																						name: 'i18n',
																						hash: {
																							arguments: 'mobileFactors',
																							bundle: 'login',
																							code: 'recovery.mobile.hint',
																						},
																						data: o,
																						loc: { start: { line: 1, column: 32 }, end: { line: 1, column: 109 } },
																					}
																				)
																			) +
																			'</p>'
																		);
																	},
																	useData: !0,
																}),
																getTemplateData: function () {
																	return {
																		mobileFactors:
																			e && t
																				? (0, i.loc)('recovery.smsOrCall')
																				: t
																				? (0, i.loc)('recovery.call')
																				: (0, i.loc)('recovery.sms'),
																	};
																},
															}),
														})
													),
											  e &&
													(this.$el.addClass('forgot-password-sms-enabled'),
													r.push(
														this.createRecoveryFactorButton(
															'sms-button',
															'account.unlock.sendText',
															a.default.RECOVERY_FACTOR_TYPE_SMS,
															s
														)
													),
													this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_SMS)),
											  t &&
													(this.$el.addClass('forgot-password-call-enabled'),
													r.push(
														this.createRecoveryFactorButton(
															'call-button',
															'account.unlock.voiceCall',
															a.default.RECOVERY_FACTOR_TYPE_CALL,
															s
														)
													),
													this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_CALL)),
											  n &&
													(this.$el.addClass('forgot-password-email-enabled'),
													r.push(
														this.createRecoveryFactorButton(
															'email-button',
															'account.unlock.sendEmail',
															a.default.RECOVERY_FACTOR_TYPE_EMAIL,
															s
														)
													),
													this.setDefaultFactorType(a.default.RECOVERY_FACTOR_TYPE_EMAIL))),
										r
									);
								},
								initialize: function () {
									this.listenTo(this, 'save', function () {
										this.options.appState.set('username', this.model.get('username')), this.model.save();
									}),
										this.listenTo(this.state, 'contactSupport', function () {
											this.add(d.default, '.o-form-error-container');
										});
								},
								setDefaultFactorType: function (e) {
									i._.isEmpty(this.model.get('factorType')) && this.model.set('factorType', e);
								},
								createRecoveryFactorButton: function (e, t, n, r) {
									return l.default.Button({
										attributes: { 'data-se': e },
										className: 'button button-primary button-wide ' + e,
										title: (0, i.loc)(t, 'login'),
										click: function () {
											r.clearErrors(),
												this.model.isValid() && (this.model.set('factorType', n), r.trigger('save', this.model));
										},
									});
								},
							},
							Footer: h,
						});
					(t.default = m), (e.exports = t.default);
				},
				15629: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(35546)),
						a = r(n(73650)),
						s = r(n(39694)),
						l = a.default.extend({
							className: 'account-unlock-email-sent',
							Model: function () {
								return { local: { userFullName: ['string', !1, this.options.appState.get('userFullName')] } };
							},
							Form: {
								title: o._.partial(o.loc, 'account.unlock.emailSent.title', 'login'),
								subtitle: function () {
									var e = this.options.appState.get('username');
									return (0, o.loc)('account.unlock.emailSent.desc', 'login', [e]);
								},
								noButtonBar: !0,
								attributes: { 'data-se': 'unlock-email-sent' },
								formChildren: function () {
									return [
										s.default.Button({
											title: (0, o.loc)('goback', 'login'),
											className: 'button button-primary button-wide',
											attributes: { 'data-se': 'back-button' },
											click: function () {
												this.state.set('navigateDir', i.default.DIRECTION_BACK),
													this.options.appState.trigger('navigate', '');
											},
										}),
									];
								},
							},
							initialize: function (e) {
								this.settings.callGlobalSuccess(i.default.UNLOCK_ACCOUNT_EMAIL_SENT, {
									username: e.appState.get('username'),
								});
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				68358: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(2645)),
						a = r(n(73650)),
						s = r(n(39694)),
						l = r(n(81824)),
						u = r(n(71271)),
						c = o.internal.util.Util,
						d = a.default.extend({
							className: 'verify-custom-factor custom-factor-form',
							Model: {
								props: { rememberDevice: 'boolean' },
								initialize: function () {
									var e = i.default.getRememberDeviceValue(this.appState);
									this.set('rememberDevice', e),
										this.settings.get('features.skipIdpFactorVerificationBtn') &&
											!this.appState.get('lastFailedChallengeFactorData') &&
											(this.set('provider', 'CUSTOM'), this.set('factorType', 'claims_provider'), this.save());
								},
								save: function () {
									var e = this,
										t = !!this.get('rememberDevice');
									return this.manageTransaction(function (n, r) {
										var i = { rememberDevice: t };
										return o._.findWhere(n.factors, { provider: e.get('provider'), factorType: e.get('factorType') })
											.verify(i)
											.then(function (t) {
												r(t);
												var n = e.appState.get('verifyCustomFactorRedirectUrl');
												null !== n && c.redirect(n);
											})
											.catch(function (e) {
												throw e;
											});
									});
								},
							},
							Form: function () {
								var e = this,
									t = this.options.appState
										.get('factors')
										.findWhere({ provider: this.options.provider, factorType: this.options.factorType })
										.get('vendorName'),
									n = (0, o.loc)('mfa.challenge.verify', 'login'),
									r = this.options.appState.get('lastFailedChallengeFactorData'),
									i = (0, o.loc)('verify.customFactor.subtitle', 'login', [t]);
								return (
									this.settings.get('features.skipIdpFactorVerificationBtn') &&
										!r &&
										((i = (0, o.loc)('verify.customFactor.subtitle.redirect', 'login', [t])),
										this.listenTo(this.model, 'error', function () {
											(i = (0, o.loc)('verify.customFactor.subtitle', 'login', [t])), e.$('.o-form-explain').text(i);
										})),
									{
										autoSave: !0,
										title: t,
										save: n,
										subtitle: i,
										attributes: { 'data-se': 'factor-custom' },
										initialize: function () {
											this.options.appState.get('allowRememberDevice') &&
												this.addInput({
													'label': !1,
													'label-top': !0,
													'placeholder': this.options.appState.get('rememberDeviceLabel'),
													'className': 'margin-btm-0',
													'name': 'rememberDevice',
													'type': 'checkbox',
												});
										},
										formChildren: function () {
											var e = [],
												t = this.options.appState.get('lastFailedChallengeFactorData');
											return (
												this.settings.get('features.skipIdpFactorVerificationBtn') &&
													!t &&
													e.push(
														s.default.View({
															View: '<div data-se="custom-factor-waiting" class="okta-waiting-spinner"></div>',
														})
													),
												t &&
													e.push(
														s.default.View(
															{ View: new l.default({ message: t.errorMessage }) },
															{ selector: '.o-form-error-container' }
														)
													),
												e
											);
										},
									}
								);
							},
							postRender: function () {
								this.settings.get('features.skipIdpFactorVerificationBtn') &&
									!this.options.appState.get('lastFailedChallengeFactorData') &&
									(this.$('.o-form-button-bar').hide(), this.$('.okta-waiting-spinner').show());
							},
							trapAuthResponse: function () {
								if (this.options.appState.get('isMfaChallenge')) return !0;
							},
							back: function () {},
							initialize: function () {
								var e = this;
								this.model.set('provider', this.options.provider),
									this.model.set('factorType', this.options.factorType),
									this.settings.get('features.skipIdpFactorVerificationBtn') &&
										this.listenTo(this.model, 'error', function () {
											e.$('.okta-waiting-spinner').hide(), e.$('.o-form-button-bar').show();
										}),
									this.addFooter(u.default);
							},
						});
					(t.default = d), (e.exports = t.default);
				},
				38864: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(79084)),
						a = r(n(6321)),
						s = r(n(2645)),
						l = r(n(73650)),
						u = r(n(71271)),
						c = l.default.extend({
							className: 'mfa-verify-duo duo-form',
							Model: {
								props: {
									host: 'string',
									signature: 'string',
									postAction: 'string',
									factorId: 'string',
									stateToken: 'string',
									rememberDevice: 'boolean',
								},
								initialize: function () {
									var e = s.default.getRememberDeviceValue(this.appState);
									this.set('rememberDevice', e);
								},
								getInitOptions: function () {
									var e = !!this.get('rememberDevice');
									return this.doTransaction(function (t) {
										var n = { rememberDevice: e };
										return o._.findWhere(t.factors, { provider: 'DUO', factorType: 'web' })
											.verify(n)
											.catch(function (e) {
												throw e;
											});
									}, !0);
								},
								verify: function (e) {
									var t = this.get('postAction'),
										n = this.get('factorId'),
										r = this,
										i = { id: n, stateToken: this.get('stateToken'), sig_response: e },
										s = this.get('rememberDevice');
									return (0, a.default)(o.$.post(t, i))
										.then(function () {
											return r.doTransaction(function (e) {
												var t;
												return s && (t = { rememberDevice: s }), e.poll(t);
											});
										})
										.catch(function (e) {
											r.trigger('error', r, e.xhr);
										});
								},
							},
							Form: {
								autoSave: !0,
								noButtonBar: !0,
								title: o._.partial(o.loc, 'factor.duo'),
								attributes: { 'data-se': 'factor-duo' },
								postRender: function () {
									this.add('<iframe frameborder="0" title="' + this.title() + '"></iframe>'),
										this.options.appState.get('allowRememberDevice') &&
											this.addInput({
												'label': !1,
												'label-top': !0,
												'placeholder': this.options.appState.get('rememberDeviceLabel'),
												'className': 'margin-btm-0',
												'name': 'rememberDevice',
												'type': 'checkbox',
											}),
										i.default.init({
											host: this.model.get('host'),
											sig_request: this.model.get('signature'),
											iframe: this.$('iframe').get(0),
											post_action: o._.bind(this.model.verify, this.model),
										});
								},
							},
							fetchInitialData: function () {
								var e = this;
								return this.model.getInitOptions().then(function (t) {
									var n = t.data;
									if (
										!(
											n._embedded &&
											n._embedded.factor &&
											n._embedded.factor._embedded &&
											n._embedded.factor._embedded.verification
										)
									)
										throw new Error('Response does not have duo verification options');
									var r = n._embedded.factor._embedded.verification;
									e.model.set({
										host: r.host,
										signature: r.signature,
										postAction: r._links.complete.href,
										factorId: n._embedded.factor.id,
										stateToken: n.stateToken,
									});
								});
							},
							trapAuthResponse: function () {
								if (this.options.appState.get('isMfaChallenge')) return !0;
							},
							back: function () {},
							Footer: u.default,
						});
					(t.default = c), (e.exports = t.default);
				},
				92835: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o,
						i = r(n(70232)),
						a = r(n(31049)),
						s = r(n(2875)),
						l = n(6475),
						u = r(n(73650)),
						c = r(n(39694)),
						d = r(n(41706)),
						f = l.internal.util.Util,
						p = u.default.extend({
							className: 'piv-cac-card',
							Model: {
								save:
									((o = (0, a.default)(
										i.default.mark(function e() {
											var t, n, r, o;
											return i.default.wrap(
												function (e) {
													for (;;)
														switch ((e.prev = e.next)) {
															case 0:
																return (
																	this.trigger('request'),
																	(t = this),
																	(n = this.settings.get('piv')),
																	(r = {
																		fromURI: this.settings.get('relayState'),
																		isCustomDomain: n.isCustomDomain,
																		customDomain: n.customDomain,
																	}),
																	(e.prev = 4),
																	(e.next = 7),
																	this.getCert(n.certAuthUrl)
																);
															case 7:
																return (e.next = 9), this.postCert(n.certAuthUrl, r);
															case 9:
																(o = e.sent), f.redirect(o.redirectUrl), (e.next = 17);
																break;
															case 13:
																(e.prev = 13),
																	(e.t0 = e.catch(4)),
																	l._.isEmpty(e.t0.responseJSON) &&
																		!e.t0.responseText &&
																		(e.t0.responseJSON = { errorSummary: (0, l.loc)('piv.cac.error', 'login') }),
																	t.trigger('error', t, e.t0);
															case 17:
															case 'end':
																return e.stop();
														}
												},
												e,
												this,
												[[4, 13]]
											);
										})
									)),
									function () {
										return o.apply(this, arguments);
									}),
								getCert: function (e) {
									return l.$.get({ url: e, xhrFields: { withCredentials: !0 }, beforeSend: function () {} });
								},
								postCert: function (e, t) {
									return l.$.post({
										url: e,
										xhrFields: { withCredentials: !0 },
										data: JSON.stringify(t),
										contentType: 'text/plain',
										beforeSend: function () {},
									});
								},
							},
							Form: {
								autoSave: !0,
								hasSavingState: !1,
								title: l._.partial(l.loc, 'piv.cac.title', 'login'),
								className: 'piv-cac-card',
								noCancelButton: !0,
								save: l._.partial(l.loc, 'retry', 'login'),
								modelEvents: { request: '_startEnrollment', error: '_stopEnrollment' },
								formChildren: [
									c.default.View({
										View: l.View.extend({
											template: s.default.template({
												compiler: [8, '>= 4.3.0'],
												main: function (e, t, n, r, o) {
													var i =
														e.lookupProperty ||
														function (e, t) {
															if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
														};
													return (
														'<div class="piv-verify-text"><p>' +
														e.escapeExpression(
															(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
																null != t ? t : e.nullContext || {},
																{
																	name: 'i18n',
																	hash: { bundle: 'login', code: 'piv.cac.card.insert' },
																	data: o,
																	loc: { start: { line: 1, column: 32 }, end: { line: 1, column: 82 } },
																}
															)
														) +
														'</p><div data-se="piv-waiting" class="okta-waiting-spinner"></div></div>'
													);
												},
												useData: !0,
											}),
										}),
									}),
								],
								_startEnrollment: function () {
									this.$('.okta-waiting-spinner').show(), this.$('.o-form-button-bar').hide();
								},
								_stopEnrollment: function () {
									this.$('.okta-waiting-spinner').hide(), this.$('.o-form-button-bar').show();
								},
								postRender: function () {
									var e = this;
									l._.defer(function () {
										e.model.save();
									});
								},
							},
							back: function () {},
							Footer: d.default,
						});
					(t.default = p), (e.exports = t.default);
				},
				45375: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(6321));
					n(83147);
					var s = n(13671),
						l = r(n(2645)),
						u = r(n(14726)),
						c = r(n(73650)),
						d = r(n(39694)),
						f = r(n(81824)),
						p = r(n(71271));
					var h = c.default.extend({
						className: 'mfa-verify verify-u2f',
						Model: {
							props: { rememberDevice: 'boolean' },
							initialize: function () {
								var e = l.default.getRememberDeviceValue(this.appState);
								this.set('rememberDevice', e);
							},
							save: function () {
								return (
									this.trigger('request'),
									this.doTransaction(function (e) {
										var t;
										t = e.factorTypes
											? i._.findWhere(e.factorTypes, { factorType: 'u2f' })
											: i._.findWhere(e.factors, { factorType: 'u2f', provider: 'FIDO' });
										var n = this;
										return t.verify().then(function (e) {
											var r, o, l;
											if (e.factors) {
												var c = e.factors;
												(o = c[0].profile.appId),
													(l = e.challenge.nonce),
													(r = (function (e) {
														var t = [];
														return (
															i._.each(e, function (e) {
																t.push({ version: e.profile.version, keyHandle: e.profile.credentialId });
															}),
															t
														);
													})(c));
											} else {
												var d = e.factor;
												(o = d.profile.appId),
													(l = d.challenge.nonce),
													(r = [{ version: u.default.getU2fVersion(), keyHandle: d.profile.credentialId }]);
											}
											n.trigger('request');
											var f = a.default.defer();
											return (
												u2f.sign(o, l, r, function (e) {
													if ((n.trigger('errors:clear'), !e.errorCode || 0 === e.errorCode)) {
														var r = !!n.get('rememberDevice');
														return t
															.verify({ clientData: e.clientData, signatureData: e.signatureData, rememberDevice: r })
															.then(f.resolve);
													}
													var o = 1 === n.options.appState.get('factors').length;
													f.reject(
														new s.U2FError({
															xhr: {
																responseJSON: {
																	errorSummary: u.default.getU2fVerifyErrorMessageByCode(e.errorCode, o),
																},
															},
														})
													);
												}),
												f.promise
											);
										});
									}).catch(function () {})
								);
							},
						},
						Form: {
							autoSave: !0,
							hasSavingState: !1,
							title: i._.partial(i.loc, 'factor.u2f', 'login'),
							className: 'verify-u2f-form',
							noCancelButton: !0,
							save: i._.partial(i.loc, 'verify.u2f.retry', 'login'),
							noButtonBar: function () {
								return !u.default.isU2fAvailable();
							},
							modelEvents: { request: '_startEnrollment', error: '_stopEnrollment' },
							formChildren: function () {
								var e = [];
								if (u.default.isU2fAvailable())
									e.push(
										d.default.View({
											View: i.View.extend({
												template: o.default.template({
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, o) {
														var i = null != t ? t : e.nullContext || {},
															a = e.hooks.helperMissing,
															s = e.escapeExpression,
															l =
																e.lookupProperty ||
																function (e, t) {
																	if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																};
														return (
															'<div class="u2f-verify-text"><p>' +
															s(
																(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
																	name: 'i18n',
																	hash: { bundle: 'login', code: 'verify.u2f.instructions' },
																	data: o,
																	loc: { start: { line: 1, column: 32 }, end: { line: 1, column: 86 } },
																})
															) +
															'</p><p>' +
															s(
																(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
																	name: 'i18n',
																	hash: { bundle: 'login', code: 'verify.u2f.instructionsBluetooth' },
																	data: o,
																	loc: { start: { line: 1, column: 93 }, end: { line: 1, column: 156 } },
																})
															) +
															'</p><div data-se="u2f-waiting" class="okta-waiting-spinner"></div></div>'
														);
													},
													useData: !0,
												}),
											}),
										})
									);
								else {
									var t = 'u2f.error.factorNotSupported';
									1 === this.options.appState.get('factors').length && (t = 'u2f.error.factorNotSupported.oneFactor'),
										e.push(
											d.default.View(
												{ View: new f.default({ message: (0, i.loc)(t, 'login') }) },
												{ selector: '.o-form-error-container' }
											)
										);
								}
								return (
									this.options.appState.get('allowRememberDevice') &&
										e.push(
											d.default.Input({
												'label': !1,
												'label-top': !0,
												'placeholder': this.options.appState.get('rememberDeviceLabel'),
												'className': 'margin-btm-0',
												'name': 'rememberDevice',
												'type': 'checkbox',
											})
										),
									e
								);
							},
							postRender: function () {
								var e = this;
								i._.defer(function () {
									u.default.isU2fAvailable() ? e.model.save() : e.$('[data-se="u2f-waiting"]').addClass('hide');
								});
							},
							_startEnrollment: function () {
								this.$('.okta-waiting-spinner').removeClass('hide'), this.$('.o-form-button-bar').hide();
							},
							_stopEnrollment: function () {
								this.$('.okta-waiting-spinner').addClass('hide'), this.$('.o-form-button-bar').show();
							},
						},
						back: function () {},
						Footer: p.default,
					});
					(t.default = h), (e.exports = t.default);
				},
				25152: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(6321)),
						s = r(n(76587)),
						l = n(13671),
						u = r(n(2645)),
						c = r(n(73650)),
						d = r(n(39694)),
						f = r(n(49268)),
						p = r(n(34425)),
						h = r(n(81824)),
						m = r(n(71271));
					function v(e) {
						var t = [];
						return (
							i._.each(e, function (e) {
								t.push({ type: 'public-key', id: s.default.strToBin(e.profile.credentialId) });
							}),
							t
						);
					}
					var g = c.default.extend({
						className: 'mfa-verify verify-webauthn',
						Model: {
							props: { rememberDevice: 'boolean' },
							initialize: function () {
								var e = this,
									t = u.default.getRememberDeviceValue(this.appState);
								this.set('rememberDevice', t),
									this.appState.on('factorSwitched signOut', function () {
										e.webauthnAbortController &&
											(e.webauthnAbortController.abort(), (e.webauthnAbortController = null));
									});
							},
							save: function () {
								return (
									this.trigger('request'),
									this.doTransaction(function (e) {
										var t;
										t = e.factorTypes
											? i._.findWhere(e.factorTypes, { factorType: 'webauthn' })
											: i._.findWhere(e.factors, { factorType: 'webauthn', provider: 'FIDO' });
										var n = this;
										return t.verify().then(function (e) {
											var r, o;
											if (e.factors) {
												var u = e.factors;
												(o = e.challenge), (r = v(u));
											} else {
												var c = e.factor;
												(o = c.challenge), (r = v([c]));
											}
											n.trigger('request');
											var d = i._.extend({}, o, { allowCredentials: r, challenge: s.default.strToBin(o.challenge) });
											return (
												'undefined' != typeof AbortController && (n.webauthnAbortController = new AbortController()),
												new a.default(
													navigator.credentials.get({
														publicKey: d,
														signal: n.webauthnAbortController && n.webauthnAbortController.signal,
													})
												)
													.then(function (e) {
														var r = !!n.get('rememberDevice');
														return t.verify({
															clientData: s.default.binToStr(e.response.clientDataJSON),
															authenticatorData: s.default.binToStr(e.response.authenticatorData),
															signatureData: s.default.binToStr(e.response.signature),
															rememberDevice: r,
														});
													})
													.catch(function (e) {
														throw (
															(n.trigger('errors:clear'),
															n.webauthnAbortController
																? new l.WebAuthnError({ xhr: { responseJSON: { errorSummary: e.message } } })
																: new l.WebauthnAbortError())
														);
													})
													.finally(function () {
														n.webauthnAbortController = null;
													})
											);
										});
									}).catch(function () {})
								);
							},
						},
						Form: {
							autoSave: !0,
							hasSavingState: !1,
							title: i._.partial(i.loc, 'factor.webauthn.biometric', 'login'),
							className: 'verify-webauthn-form',
							noCancelButton: !0,
							save: i._.partial(i.loc, 'mfa.challenge.verify', 'login'),
							noButtonBar: function () {
								return !f.default.isNewApiAvailable();
							},
							modelEvents: { request: '_startEnrollment', error: '_stopEnrollment' },
							formChildren: function () {
								var e = [];
								if (f.default.isNewApiAvailable())
									e.push(
										d.default.View({
											View: i.View.extend({
												template: o.default.template({
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, o) {
														var i =
															e.lookupProperty ||
															function (e, t) {
																if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
															};
														return (
															'<div class="webauthn-verify-text"><p>' +
															e.escapeExpression(
																(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
																	null != t ? t : e.nullContext || {},
																	{
																		name: 'i18n',
																		hash: { bundle: 'login', code: 'verify.webauthn.biometric.instructions' },
																		data: o,
																		loc: { start: { line: 1, column: 37 }, end: { line: 1, column: 106 } },
																	}
																)
															) +
															'</p><div data-se="webauthn-waiting" class="okta-waiting-spinner"></div></div>'
														);
													},
													useData: !0,
												}),
											}),
										})
									);
								else {
									var t = 'webauthn.biometric.error.factorNotSupported';
									1 === this.options.appState.get('factors').length &&
										(t = 'webauthn.biometric.error.factorNotSupported.oneFactor'),
										e.push(
											d.default.View(
												{ View: new h.default({ message: (0, i.loc)(t, 'login') }) },
												{ selector: '.o-form-error-container' }
											)
										);
								}
								return (
									this.options.appState.get('allowRememberDevice') &&
										e.push(
											d.default.Input({
												'label': !1,
												'label-top': !0,
												'placeholder': this.options.appState.get('rememberDeviceLabel'),
												'className': 'margin-btm-0',
												'name': 'rememberDevice',
												'type': 'checkbox',
											})
										),
									e
								);
							},
							_startEnrollment: function () {
								this.$('.okta-waiting-spinner').show(), this.$('.o-form-button-bar').hide();
							},
							_stopEnrollment: function () {
								this.$('.okta-waiting-spinner').hide(),
									(this.$('.o-form-button-bar [type="submit"]')[0].value = (0, i.loc)('verify.u2f.retry', 'login')),
									this.$('.o-form-button-bar').show();
							},
						},
						postRender: function () {
							var e = this;
							i._.defer(function () {
								f.default.isNewApiAvailable() && !p.default.isSafari() && e.model.save();
							});
						},
						back: function () {},
						Footer: m.default,
					});
					(t.default = g), (e.exports = t.default);
				},
				73269: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(73650)),
						a = r(n(39694)),
						s = r(n(49268)),
						l = r(n(81824)),
						u = r(n(71271)),
						c = r(n(64521)),
						d = i.default.extend({
							className: 'mfa-verify verify-windows-hello',
							Model: {
								local: { __autoTriggered__: 'boolean' },
								save: function () {
									if (s.default.isAvailable()) {
										this.trigger('request');
										var e = this;
										return this.doTransaction(function (t) {
											var n = o._.findWhere(t.factors, { factorType: 'webauthn', provider: 'FIDO' });
											return n.verify().then(function (r) {
												var o = r.factor;
												return s.default
													.getAssertion(o.challenge.nonce, [{ id: o.profile.credentialId }])
													.then(function (e) {
														return n.verify({
															authenticatorData: e.authenticatorData,
															clientData: e.clientData,
															signatureData: e.signature,
														});
													})
													.then(function (t) {
														return e.trigger('sync'), e.trigger('signIn'), t;
													})
													.catch(function (n) {
														switch (n.message) {
															case 'AbortError':
															case 'NotFoundError':
															case 'NotSupportedError':
																return e.trigger('abort', n.message), t;
														}
														throw n;
													});
											});
										});
									}
								},
							},
							Form: {
								autoSave: !0,
								hasSavingState: !1,
								title: o._.partial(o.loc, 'factor.windowsHello', 'login'),
								subtitle: function () {
									return s.default.isAvailable() ? (0, o.loc)('verify.windowsHello.subtitle', 'login') : '';
								},
								save: o._.partial(o.loc, 'verify.windowsHello.save', 'login'),
								customSavingState: { stop: 'abort' },
								modelEvents: function () {
									return s.default.isAvailable()
										? {
												request: '_startEnrollment',
												error: '_stopEnrollment',
												abort: '_stopEnrollment',
												signIn: '_successEnrollment',
										  }
										: {};
								},
								noButtonBar: function () {
									return !s.default.isAvailable();
								},
								formChildren: function () {
									var e = [];
									return (
										s.default.isAvailable() ||
											e.push(
												a.default.View(
													{
														View: new l.default({
															message: (0, o.loc)('enroll.windowsHello.error.notWindows', 'login'),
														}),
													},
													{ selector: '.o-form-error-container' }
												)
											),
										e.push(a.default.View({ View: new c.default({ model: this.model, visible: !1 }) })),
										e
									);
								},
								postRender: function () {
									1 !== this.options.appState.get('factors').length ||
										this.model.get('__autoTriggered__') ||
										(this.model.set('__autoTriggered__', !0), this.model.save());
								},
								_startEnrollment: function () {
									(this.subtitle = (0, o.loc)('verify.windowsHello.subtitle.loading', 'login')),
										this.model.trigger('spinner:show'),
										this._resetErrorMessage(),
										this.render(),
										this.$('.o-form-button-bar').addClass('hide');
								},
								_stopEnrollment: function (e) {
									var t;
									switch (
										((this.subtitle = (0, o.loc)('verify.windowsHello.subtitle', 'login')),
										this.model.trigger('spinner:hide'),
										this.$('.o-form-button-bar').removeClass('hide'),
										e)
									) {
										case 'NotFoundError':
											t =
												this.options.appState.get('factors').length > 1
													? (0, o.loc)('verify.windowsHello.error.notFound.selectAnother', 'login')
													: (0, o.loc)('verify.windowsHello.error.notFound', 'login');
											break;
										case 'NotSupportedError':
											t = (0, o.loc)('enroll.windowsHello.error.notConfiguredHtml', 'login');
									}
									if ((this._resetErrorMessage(), t)) {
										var n = new l.default({ message: t });
										this.$('.o-form-error-container').addClass('o-form-has-errors'),
											this.add(n, { selector: '.o-form-error-container' }),
											(this._errorMessageView = this.last());
									}
									this.render();
								},
								_successEnrollment: function () {
									(this.subtitle = this.settings.get('brandName')
										? (0, o.loc)('verify.windowsHello.subtitle.signingIn.specific', 'login', [
												this.settings.get('brandName'),
										  ])
										: (0, o.loc)('verify.windowsHello.subtitle.signingIn.generic', 'login')),
										this.render(),
										this.$('.o-form-button-bar').addClass('hide');
								},
								_resetErrorMessage: function () {
									this._errorMessageView && this._errorMessageView.remove(),
										(this._errorMessageView = void 0),
										this.clearErrors();
								},
							},
							back: function () {},
							Footer: u.default,
						});
					(t.default = d), (e.exports = t.default);
				},
				58346: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0), (t.getSecurityImageUrl = d);
					var o = n(6475),
						i = r(n(15073)),
						a = r(n(6321)),
						s = r(n(34425)),
						l = n(13671),
						u = '/img/security/default.png',
						c = '/img/security/unknown-device.png';
					function d(e, t) {
						var n = encodeURIComponent(t);
						return ''.concat(e, '/login/getimage?username=').concat(n);
					}
					var f = o.Model.extend({
						initialize: function () {
							if (this.settings.get('features.securityImage')) {
								var e = this;
								this.listenTo(this, 'change:username', function (t, n) {
									(function (e, t, n) {
										if (o._.isEmpty(t) || o._.isUndefined(t))
											return (0, a.default)({ securityImage: u, securityImageDescription: '' });
										var r = { url: d(e, t), dataType: 'json' };
										return (
											n && (r.headers = { 'X-Device-Fingerprint': n }),
											(0, a.default)(o.$.ajax(r)).then(function (e) {
												return '/img/security/unknown.png' === e.pwdImg
													? { securityImage: c, securityImageDescription: '' }
													: { securityImage: e.pwdImg, securityImageDescription: e.imageDescription || '' };
											})
										);
									})(this.get('baseUrl'), n, this.get('deviceFingerprint'))
										.then(function (e) {
											t.set('securityImage', e.securityImage),
												t.set('securityImageDescription', e.securityImageDescription),
												t.unset('deviceFingerprint');
										})
										.fail(function (t) {
											s.default.corsIsNotEnabled(t)
												? e.settings.callGlobalError(new l.UnsupportedBrowserError((0, o.loc)('error.enabled.cors')))
												: e.settings.callGlobalError(
														new Error('Failed to fetch security image: '.concat(t.statusText))
												  );
										})
										.done();
								});
							}
						},
						local: {
							baseUrl: 'string',
							lastAuthResponse: ['object', !0, {}],
							transaction: 'object',
							transactionError: 'object',
							username: 'string',
							factors: 'object',
							policy: 'object',
							securityImage: ['string', !0, u],
							securityImageDescription: ['string', !0, ''],
							userCountryCode: 'string',
							userPhoneNumber: 'string',
							factorActivationType: 'string',
							flashError: 'object',
							beaconType: 'string',
							deviceFingerprint: 'string',
							typingPattern: 'string',
							languageCode: ['string', !0],
							disableUsername: ['boolean', !1, !1],
							trapMfaRequiredResponse: ['boolean', !1, !1],
							lastFailedChallengeFactorData: ['object', !1],
						},
						setAuthResponse: function (e) {
							var t = this;
							if (
								(e._embedded && e._embedded.policy && this.set('policy', e._embedded.policy),
								e._embedded && e._embedded.factors)
							) {
								var n = e._embedded.factors;
								e._embedded.factorTypes &&
									(n = (function (e, t) {
										var n = [],
											r = [];
										return (
											o._.each(t, function (t) {
												var i = t.factorType;
												if (!o._.contains(n, i)) {
													var a = o._.findWhere(e, { factorType: i });
													a ? (n.push(i), r.push(a)) : r.push(t);
												}
											}),
											r
										);
									})(e._embedded.factorTypes, n));
								var r = o._.map(n, function (e) {
									return (e.settings = t.settings), (e.appState = t), e;
								});
								this.set('factors', new i.default.Collection(r, { parse: !0 }));
							}
							this.set('lastAuthResponse', e);
						},
						clearLastAuthResponse: function () {
							this.set('lastAuthResponse', {});
						},
						setLastFailedChallengeFactorData: function () {
							this.set('lastFailedChallengeFactorData', {
								factor: this.get('factor'),
								errorMessage: this.get('factorResultErrorMessage'),
							});
						},
						clearLastFailedChallengeFactorData: function () {
							this.unset('lastFailedChallengeFactorData');
						},
						getUser: function () {
							return this.get('user');
						},
						derived: {
							isSuccessResponse: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return 'SUCCESS' === e.status;
								},
							},
							isMfaRequired: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return 'MFA_REQUIRED' === e.status || 'FACTOR_REQUIRED' === e.status;
								},
							},
							isProfileRequired: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return 'PROFILE_REQUIRED' === e.status;
								},
							},
							isMfaEnroll: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return 'MFA_ENROLL' === e.status || 'FACTOR_ENROLL' === e.status;
								},
							},
							isMfaChallenge: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return 'MFA_CHALLENGE' === e.status || 'FACTOR_CHALLENGE' === e.status;
								},
							},
							isSMSPasswordRecovery: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									var t = e.status,
										n = e.factorType,
										r = e.recoveryType;
									return (
										'RECOVERY_CHALLENGE' === t &&
										'sms' === (null == n ? void 0 : n.toLowerCase()) &&
										'password' === (null == r ? void 0 : r.toLowerCase())
									);
								},
							},
							isUnauthenticated: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return 'UNAUTHENTICATED' === e.status;
								},
							},
							isMfaRejected: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return 'REJECTED' === e.factorResult;
								},
							},
							isMfaTimeout: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return 'TIMEOUT' === e.factorResult;
								},
							},
							isMfaEnrollActivate: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return 'MFA_ENROLL_ACTIVATE' === e.status || 'FACTOR_ENROLL_ACTIVATE' === e.status;
								},
							},
							isWaitingForActivation: {
								deps: ['isMfaEnrollActivate', 'lastAuthResponse'],
								fn: function (e, t) {
									return e && 'WAITING' === t.factorResult;
								},
							},
							isWaitingForNumberChallenge: {
								deps: ['lastAuthResponse', 'isMfaChallenge'],
								fn: function (e, t) {
									return !!(
										t &&
										e &&
										'WAITING' === e.factorResult &&
										e._embedded &&
										e._embedded.factor &&
										e._embedded.factor._embedded &&
										e._embedded.factor._embedded.challenge
									);
								},
							},
							hasMultipleFactorsAvailable: {
								deps: ['factors', 'isMfaRequired', 'isMfaChallenge', 'isUnauthenticated'],
								fn: function (e, t, n, r) {
									return !!(t || n || r) && e && e.length > 1;
								},
							},
							promptForFactorInUnauthenticated: {
								deps: ['lastAuthResponse', 'factors'],
								fn: function (e, t) {
									return 'UNAUTHENTICATED' === e.status && t && t.length > 0;
								},
							},
							userId: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e._embedded && e._embedded.user ? e._embedded.user.id : null;
								},
							},
							isIdxStateToken: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e && o._.isString(e.stateToken) && e.stateToken.startsWith('01');
								},
							},
							isPwdExpiringSoon: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return 'PASSWORD_WARN' === e.status;
								},
							},
							passwordExpireDays: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e._embedded && e._embedded.policy && e._embedded.policy.expiration
										? e._embedded.policy.expiration.passwordExpireDays
										: null;
								},
							},
							isPwdManagedByOkta: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return !(e._links && e._links.next && e._links.next.title);
								},
							},
							passwordExpiredWebsiteName: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e._links && e._links.next && e._links.next.title ? e._links.next.title : null;
								},
							},
							passwordExpiredLinkUrl: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e._links && e._links.next && e._links.next.title && e._links.next.href
										? e._links.next.href
										: null;
								},
							},
							recoveryType: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e.recoveryType;
								},
							},
							factorType: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e.factorType;
								},
							},
							factor: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e._embedded && e._embedded.factor ? e._embedded.factor : null;
								},
							},
							activatedFactorId: {
								deps: ['factor'],
								fn: function (e) {
									return e ? e.id : null;
								},
							},
							activatedFactorType: {
								deps: ['factor'],
								fn: function (e) {
									return e ? e.factorType : null;
								},
							},
							activatedFactorProvider: {
								deps: ['factor'],
								fn: function (e) {
									return e ? e.provider : null;
								},
							},
							qrcode: {
								deps: ['factor'],
								fn: function (e) {
									try {
										return e._embedded.activation._links.qrcode.href;
									} catch (e) {
										return null;
									}
								},
							},
							activationSendLinks: {
								deps: ['factor'],
								fn: function (e) {
									var t;
									try {
										t = e._embedded.activation._links.send;
									} catch (e) {
										t = [];
									}
									return t;
								},
							},
							textActivationLinkUrl: {
								deps: ['activationSendLinks'],
								fn: function (e) {
									var t = o._.findWhere(e, { name: 'sms' });
									return t ? t.href : null;
								},
							},
							emailActivationLinkUrl: {
								deps: ['activationSendLinks'],
								fn: function (e) {
									var t = o._.findWhere(e, { name: 'email' });
									return t ? t.href : null;
								},
							},
							sharedSecret: {
								deps: ['factor'],
								fn: function (e) {
									try {
										return e._embedded.activation.sharedSecret;
									} catch (e) {
										return null;
									}
								},
							},
							duoEnrollActivation: {
								deps: ['factor'],
								fn: function (e) {
									return e && e._embedded && e._embedded.activation ? e._embedded.activation : null;
								},
							},
							prevLink: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e._links && e._links.prev ? e._links.prev.href : null;
								},
							},
							skipLink: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e._links && e._links.skip ? e._links.skip.href : null;
								},
							},
							gracePeriodRemainingDays: {
								deps: ['policy'],
								fn: function (e) {
									return e && e.gracePeriod && e.gracePeriod.endDate
										? ((t = e.gracePeriod.endDate),
										  (n = new Date(t).getTime()),
										  Math.floor((n - new Date().getTime()) / 864e5))
										: null;
									var t, n;
								},
							},
							user: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e._embedded && e._embedded.user ? e._embedded.user : null;
								},
							},
							recoveryQuestion: {
								deps: ['user'],
								fn: function (e) {
									return e && e.recovery_question ? e.recovery_question.question : null;
								},
							},
							userProfile: {
								deps: ['user'],
								fn: function (e) {
									return e && e.profile ? e.profile : null;
								},
							},
							userConsentName: {
								deps: ['userProfile', 'username'],
								fn: function (e, t) {
									return !e || o._.isEmpty(e.firstName)
										? t
										: o._.isEmpty(e.lastName)
										? e.firstName
										: e.firstName + ' ' + e.lastName.charAt(0) + '.';
								},
							},
							userEmail: {
								deps: ['userProfile'],
								fn: function (e) {
									return e && e.login ? e.login : null;
								},
							},
							userFullName: {
								deps: ['userProfile'],
								fn: function (e) {
									return e && (e.firstName || e.lastName) ? e.firstName + ' ' + e.lastName : '';
								},
							},
							defaultAppLogo: {
								deps: ['baseUrl'],
								fn: function (e) {
									return e + '/img/logos/default.png';
								},
							},
							expiresAt: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e.expiresAt;
								},
							},
							target: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e._embedded ? e._embedded.target : null;
								},
							},
							targetLabel: {
								deps: ['target'],
								fn: function (e) {
									return e ? e.label : null;
								},
							},
							targetLogo: {
								deps: ['target'],
								fn: function (e) {
									return e && e._links ? e._links.logo : null;
								},
							},
							targetTermsOfService: {
								deps: ['target'],
								fn: function (e) {
									return e && e._links ? e._links['terms-of-service'] : null;
								},
							},
							targetPrivacyPolicy: {
								deps: ['target'],
								fn: function (e) {
									return e && e._links ? e._links['privacy-policy'] : null;
								},
							},
							targetClientURI: {
								deps: ['target'],
								fn: function (e) {
									return e && e._links ? e._links['client-uri'] : null;
								},
							},
							scopes: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e._embedded ? e._embedded.scopes : null;
								},
							},
							issuer: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									var t, n, r;
									return null == e ||
										null === (t = e._embedded) ||
										void 0 === t ||
										null === (n = t.authentication) ||
										void 0 === n ||
										null === (r = n.issuer) ||
										void 0 === r
										? void 0
										: r.uri;
								},
							},
							hasExistingPhones: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									if (!e._embedded || !e._embedded.factors) return !1;
									var t = e._embedded.factors,
										n = o._.findWhere(t, { factorType: 'sms', provider: 'OKTA' });
									return !(!n || !n._embedded) && !!n._embedded.phones.length;
								},
							},
							hasExistingPhonesForCall: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									if (!e._embedded || !e._embedded.factors) return !1;
									var t = e._embedded.factors,
										n = o._.findWhere(t, { factorType: 'call', provider: 'OKTA' });
									return !(!n || !n._embedded) && !!n._embedded.phones.length;
								},
							},
							isUndefinedUser: {
								deps: ['securityImage'],
								fn: function (e) {
									return e === u;
								},
							},
							isNewUser: {
								deps: ['securityImage'],
								fn: function (e) {
									return e === c;
								},
							},
							allowRememberDevice: {
								deps: ['policy'],
								fn: function (e) {
									return e && e.allowRememberDevice;
								},
							},
							rememberDeviceLabel: {
								deps: ['policy'],
								fn: function (e) {
									if (e && e.rememberDeviceLifetimeInMinutes > 0) {
										var t = (function (e) {
											if (e > 60 && e <= 1440) {
												var t = e / 60;
												return (0, o.loc)('hours', 'login', [t]);
											}
											if (e > 1440) {
												var n = e / 1440;
												return (0, o.loc)('days', 'login', [n]);
											}
											return 1 === e ? (0, o.loc)('minutes.oneMinute', 'login') : (0, o.loc)('minutes', 'login', [e]);
										})(e.rememberDeviceLifetimeInMinutes);
										return (0, o.loc)('rememberDevice.timebased', 'login', [t]);
									}
									return e && 0 === e.rememberDeviceLifetimeInMinutes
										? (0, o.loc)('rememberDevice.devicebased', 'login')
										: (0, o.loc)('rememberDevice', 'login');
								},
							},
							rememberDeviceByDefault: {
								deps: ['policy'],
								fn: function (e) {
									return e && e.rememberDeviceByDefault;
								},
							},
							factorsPolicyInfo: {
								deps: ['policy'],
								fn: function (e) {
									return e && e.factorsPolicyInfo ? e.factorsPolicyInfo : null;
								},
							},
							verifyCustomFactorRedirectUrl: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e._links && e._links.next && 'redirect' === e._links.next.name && e._links.next.href
										? e._links.next.href
										: null;
								},
							},
							enrollCustomFactorRedirectUrl: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e._links && e._links.next && 'activate' === e._links.next.name && e._links.next.href
										? e._links.next.href
										: null;
								},
							},
							isFactorResultFailed: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return 'FAILED' === e.factorResult;
								},
							},
							factorResultErrorMessage: {
								deps: ['lastAuthResponse', 'isFactorResultFailed'],
								fn: function (e, t) {
									return t ? e.factorResultMessage || (0, o.loc)('oform.error.unexpected', 'login') : null;
								},
							},
							deviceActivationStatus: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return e._embedded ? e._embedded.deviceActivationStatus : null;
								},
							},
							usingDeviceFlow: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									return !(!e._embedded || !e._embedded.usingDeviceFlow);
								},
							},
							userCode: {
								deps: ['lastAuthResponse'],
								fn: function (e) {
									var t;
									return null == e || null === (t = e._embedded) || void 0 === t ? void 0 : t.userCode;
								},
							},
						},
						parse: function (e) {
							return (
								(this.settings = e.settings),
								o._.extend(o._.omit(e, 'settings'), {
									languageCode: this.settings.get('languageCode'),
									userCountryCode: this.settings.get('countryCode'),
								})
							);
						},
					});
					t.default = f;
				},
				29685: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(6321)),
						a = r(n(35546)),
						s = ['OAuthError', 'AuthSdkError', 'AuthPollStopError', 'AuthApiError'],
						l = o.Model.extend({
							doTransaction: function (e, t) {
								var n = this;
								return e
									.call(this, this.appState.get('transaction'))
									.then(function (e) {
										return n.trigger('setTransaction', e), e;
									})
									.catch(function (e) {
										if (
											'AuthPollStopError' !== e.name &&
											e.name !== a.default.AUTH_STOP_POLL_INITIATION_ERROR &&
											e.name !== a.default.WEBAUTHN_ABORT_ERROR &&
											(n.trigger('error', n, e.xhr),
											n.trigger('setTransactionError', e),
											t || -1 === o._.indexOf(s, e.name))
										)
											throw e;
									});
							},
							manageTransaction: function (e) {
								var t = this,
									n = e.call(this, this.appState.get('transaction'), o._.bind(this.setTransaction, this));
								return i.default.isPromiseAlike(n)
									? n.catch(function (e) {
											'AuthPollStopError' !== e.name &&
												e.name !== a.default.AUTH_STOP_POLL_INITIATION_ERROR &&
												e.name !== a.default.WEBAUTHN_ABORT_ERROR &&
												(t.trigger('error', t, e.xhr), t.trigger('setTransactionError', e));
									  })
									: i.default.resolve(n);
							},
							startTransaction: function (e) {
								var t = this,
									n = e.call(this, this.settings.getAuthClient());
								return i.default.isPromiseAlike(n)
									? n
											.then(function (e) {
												return t.trigger('setTransaction', e), e;
											})
											.catch(function (e) {
												throw (t.trigger('error', t, e.xhr), t.trigger('setTransactionError', e), e);
											})
									: i.default.resolve(n);
							},
							setTransaction: function (e) {
								this.appState.set('transaction', e);
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				21749: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(29685)),
						a = i.default.extend({
							initialize: function (e) {
								(this.options = e || {}), (this.appState = this.options.appState);
							},
							constructPostData: function (e) {
								var t = { registration: { profile: e } };
								return (
									this.appState.get('policy').registration.createNewAccount && (t.registration.createNewAccount = !0), t
								);
							},
							getEnrollFormData: function () {
								return this.manageTransaction(function (e, t) {
									return e.enroll().then(function (e) {
										t(e);
									});
								});
							},
							save: function () {
								var e = i.default.prototype.toJSON.apply(this, arguments);
								if (((e = o._.omit(e, ['appState', 'settings', 'createNewAccount'])), !o._.isEmpty(e)))
									return this.manageTransaction(function (t, n) {
										t.enroll(this.constructPostData(e)).then(function (e) {
											n(e);
										});
									});
								var t = { errorSummary: (0, o.loc)('oform.errorbanner.title', 'login') };
								this.trigger('error', this, { responseJSON: t });
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				15073: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(6321)),
						a = n(13671),
						s = r(n(2645)),
						l = r(n(90570)),
						u = r(n(34425)),
						c = r(n(29685)),
						d = c.default.extend({
							extraProperties: !0,
							flat: !1,
							props: {
								id: 'string',
								factorType: {
									type: 'string',
									values: [
										'sms',
										'call',
										'email',
										'token',
										'token:software:totp',
										'token:hotp',
										'token:hardware',
										'question',
										'push',
										'u2f',
										'password',
										'assertion:saml2',
										'assertion:oidc',
										'claims_provider',
										'webauthn',
									],
								},
								provider: {
									type: 'string',
									values: [
										'OKTA',
										'RSA',
										'DEL_OATH',
										'SYMANTEC',
										'GOOGLE',
										'YUBICO',
										'FIDO',
										'CUSTOM',
										'GENERIC_SAML',
										'GENERIC_OIDC',
									],
								},
								enrollment: { type: 'string', values: ['OPTIONAL', 'REQUIRED'] },
								status: { type: 'string', values: ['NOT_SETUP', 'ACTIVE'] },
								profile: ['object'],
								vendorName: 'string',
								policy: ['object'],
								profiles: ['object'],
							},
							local: {
								answer: 'string',
								password: 'string',
								backupFactor: 'object',
								showAnswer: 'boolean',
								rememberDevice: 'boolean',
								autoPush: ['boolean', !0, !1],
							},
							derived: {
								isOktaFactor: {
									deps: ['provider'],
									fn: function (e) {
										return 'OKTA' === e;
									},
								},
								factorName: { deps: ['provider', 'factorType'], fn: s.default.getFactorName },
								factorLabel: {
									deps: ['provider', 'factorType', 'vendorName'],
									fn: function (e, t, n) {
										return o._.contains(['DEL_OATH', 'GENERIC_SAML', 'GENERIC_OIDC', 'CUSTOM'], e)
											? n
											: s.default.getFactorLabel.apply(this, [e, t]);
									},
								},
								factorDescription: { deps: ['provider', 'factorType'], fn: s.default.getFactorDescription },
								sortOrder: { deps: ['provider', 'factorType'], fn: s.default.getFactorSortOrder },
								iconClassName: { deps: ['provider', 'factorType'], fn: s.default.getFactorIconClassName },
								securityQuestion: {
									deps: ['profile', 'factorType'],
									fn: function (e, t) {
										return 'question' !== t ? null : e && s.default.getSecurityQuestionLabel(e);
									},
								},
								phoneNumber: {
									deps: ['profile', 'factorType'],
									fn: function (e, t) {
										return o._.contains(['sms', 'call'], t) ? e && e.phoneNumber : null;
									},
								},
								email: {
									deps: ['profile', 'factorType'],
									fn: function (e, t) {
										return 'email' === t ? e && e.email : null;
									},
								},
								deviceName: {
									deps: ['profile', 'factorType'],
									fn: function (e, t) {
										return 'push' !== t ? null : e && e.name;
									},
								},
								enrolled: {
									deps: ['status'],
									fn: function (e) {
										return 'ACTIVE' === e;
									},
								},
								cardinality: {
									deps: ['policy', 'profiles'],
									fn: function (e, t) {
										if (t && t.length > 0) {
											var n = t[0],
												r = n._embedded.enrolledFactors.length,
												i = o._.findWhere(n._embedded.features, { type: 'adoption' });
											return (
												!(!i || !i.cardinality) && {
													enrolled: r,
													minimum: i.cardinality.min,
													maximum: i.cardinality.max,
												}
											);
										}
										return !(!e || !e.enrollment) && e.enrollment;
									},
								},
								additionalEnrollment: {
									deps: ['cardinality'],
									fn: function (e) {
										return !!e && 0 !== e.enrolled && e.enrolled < e.maximum;
									},
								},
								required: {
									deps: ['enrollment'],
									fn: function (e) {
										return 'REQUIRED' === e;
									},
								},
								canUseResend: {
									deps: ['provider', 'factorType'],
									fn: function (e, t) {
										return 'OKTA' === e && o._.contains(['push', 'sms', 'call', 'email'], t);
									},
								},
								isAnswerRequired: {
									deps: ['factorType'],
									fn: function (e) {
										return o._.contains(['sms', 'call', 'email', 'token', 'token:software:totp', 'question'], e);
									},
								},
								isFactorTypeVerification: {
									deps: ['provider', 'id'],
									fn: function (e, t) {
										return void 0 === e && void 0 === t;
									},
								},
							},
							parse: function (e) {
								return (
									(this.settings = e.settings),
									(this.appState = e.appState),
									(e.rememberDevice = s.default.getRememberDeviceValue(this.appState)),
									this.setCustomHotpVendorName(e),
									o._.omit(e, ['settings', 'appState'])
								);
							},
							validate: function () {
								return this.get('isAnswerRequired') && !this.get('answer')
									? { answer: (0, o.loc)('model.validation.field.blank') }
									: 'password' !== this.get('factorType') || this.get('password')
									? void 0
									: { password: (0, o.loc)('error.password.required') };
							},
							needsPasscode: function () {
								return !(this.options.appState.get('isIdxStateToken') && 'email' === this.get('factorType'));
							},
							resend: function () {
								return (
									this.trigger('form:clear-errors'),
									this.manageTransaction(function (e) {
										var t = e.data._links.resend[0];
										return e.resend(t.name);
									})
								);
							},
							save: function () {
								var e = !!this.get('rememberDevice'),
									t = this;
								return this.manageTransaction(function (n, r) {
									var o,
										s = { rememberDevice: e };
									if (
										('question' === this.get('factorType')
											? (s.answer = this.get('answer'))
											: 'password' === this.get('factorType')
											? (s.password = this.get('password'))
											: this.needsPasscode() && (s.passCode = this.get('answer')),
										this.pushFactorHasAutoPush() && (s.autoPush = this.get('autoPush')),
										'MFA_REQUIRED' === n.status ||
											'FACTOR_REQUIRED' === n.status ||
											this.appState.get('promptForFactorInUnauthenticated'))
									)
										o = this._findFactor(n).verify(s);
									else if (this.get('canUseResend') && !this.get('answer') && n.resend) {
										var c = n.data._links.resend[0];
										o = n.resend(c.name);
									} else o = n.verify(s);
									return (
										this.trigger('save'),
										o.then(function (e) {
											var n = !1,
												o = {
													delay: 4e3,
													transactionCallBack: function (e) {
														(n = !0), t.options.appState.set('lastAuthResponse', e);
													},
												};
											if (
												(r(e), ('MFA_CHALLENGE' === e.status && e.poll) || ('FACTOR_CHALLENGE' === e.status && e.poll))
											) {
												var s = i.default.defer(),
													c = l.default.callAfterTimeoutOrWindowRefocus(s.resolve, 4e3);
												return (
													t.listenToOnce(t.options.appState, 'factorSwitched', function () {
														c(), s.reject(new a.AuthStopPollInitiationError());
													}),
													s.promise.then(function () {
														var a, s, c;
														(t.stopListening(t.options.appState, 'factorSwitched'),
														t.pushFactorHasAutoPush() &&
															((o.autoPush = function () {
																return t.get('autoPush');
															}),
															(o.rememberDevice = function () {
																return t.get('rememberDevice');
															})),
														u.default.isIOS())
															? (a = i.default
																	.race([
																		e.poll(o),
																		((c = i.default.defer()),
																		(s = l.default.callAfterTimeoutOrWindowRefocus(c.resolve, 2e3, !0)),
																		c.promise.then(function () {
																			return n ? i.default.defer().promise : e.poll(o);
																		})),
																	])
																	.then(function (e) {
																		return s(), e;
																	}))
															: (a = e.poll(o));
														return a.then(function (e) {
															t.options.appState.set('lastAuthResponse', e.data), r(e);
														});
													})
												);
											}
										})
									);
								});
							},
							_findFactor: function (e) {
								var t;
								return (
									e.factorTypes && (t = o._.findWhere(e.factorTypes, { factorType: this.get('factorType') })),
									t || (t = o._.findWhere(e.factors, { id: this.get('id') })),
									t
								);
							},
							pushFactorHasAutoPush: function () {
								return this.settings.get('features.autoPush') && 'push' === this.get('factorType');
							},
							setCustomHotpVendorName: function (e) {
								if ('token:hotp' === e.factorType && e.profiles)
									if ('NOT_SETUP' === e.status) e.vendorName = e.profiles[0].name;
									else if ('ACTIVE' === e.status) {
										var t = e.profiles.filter(function (e) {
											return e._embedded.enrolledFactors.length > 0;
										});
										e.vendorName = t[0].name;
									}
								return e;
							},
						}),
						f = o.Collection.extend({
							model: d,
							comparator: 'sortOrder',
							parse: function (e) {
								this.lastUsedFactor = e[0];
								var t,
									n = o._.findWhere(e, { provider: 'OKTA', factorType: 'push' });
								if (
									((t =
										o._.where(e, { factorType: 'push' }).length > 1
											? o._.findWhere(e, { factorType: 'token:software:totp' })
											: o._.findWhere(e, { provider: 'OKTA', factorType: 'token:software:totp' })),
									!n || !t)
								)
									return e;
								var r = t === e[0],
									i = o._.reduce(
										e,
										function (e, r) {
											var o = 'OKTA' === r.provider,
												i = o && 'token:software:totp' === r.factorType,
												a = o && 'push' === r.factorType,
												s = 'ACTIVE' !== r.status,
												l = i && (s || 'ACTIVE' === n.status),
												u = a && s && 'ACTIVE' === t.status;
											return l || u || (a && (r.backupFactor = new d(t, { parse: !0 })), e.push(r)), e;
										},
										[]
									);
								return r && (this.lastUsedFactor = n), i;
							},
							getDefaultFactor: function () {
								var e = o._.pick(this.lastUsedFactor, 'factorType', 'provider');
								return this.findWhere(e);
							},
							getFirstUnenrolledRequiredFactor: function () {
								return this.findWhere({ required: !0, enrolled: !1 });
							},
							_getFactorsOfType: function (e) {
								return this.where({ factorType: e });
							},
							getFactorIndex: function (e, t) {
								return this._getFactorsOfType(e).findIndex(function (e) {
									return e.get('id') === t;
								});
							},
							hasMultipleFactorsOfSameType: function (e) {
								return this._getFactorsOfType(e).length > 1;
							},
							getFactorByTypeAndIndex: function (e, t) {
								return this._getFactorsOfType(e)[t];
							},
						}),
						p = { Model: d, Collection: f };
					(t.default = p), (e.exports = t.default);
				},
				31749: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(28528)),
						a = r(n(26368)),
						s = r(n(35546)),
						l = r(n(90570)),
						u = i.default.extend({
							props: function () {
								var e = a.default.getCookieUsername(),
									t = this.getUsernameAndRemember(e);
								return {
									username: ['string', !0, t.username],
									lastUsername: ['string', !1, e],
									context: ['object', !1],
									remember: ['boolean', !0, t.remember],
								};
							},
							local: {},
							save: function () {
								var e = this,
									t = this.settings.transformUsername(this.get('username'), s.default.IDP_DISCOVERY),
									n = this.get('remember'),
									r = this.get('lastUsername'),
									i = 'okta:acct:' + t,
									u = this.get('requestContext');
								this.setUsernameCookie(t, n, r), this.trigger('save'), this.appState.trigger('loading', !0);
								var c = { resource: i, requestContext: u };
								this.appState.settings
									.getAuthClient()
									.webfinger(c)
									.then(function (t) {
										if (t && t.links && t.links[0])
											if ('OKTA' === t.links[0].properties['okta:idp:type']) e.trigger('goToPrimaryAuth');
											else if (t.links[0].href) {
												(t.links[0].href.includes('OKTA_INVALID_SESSION_REPOST%3Dtrue')
													? l.default.redirectWithFormGet.bind(l.default)
													: e.settings.get('redirectUtilFn'))(t.links[0].href);
											}
									})
									.catch(function () {
										var t = { errorSummary: (0, o.loc)('oform.error.webfinger', 'login') };
										e.trigger('error', e, { responseJSON: t }),
											e.appState.trigger('removeLoading'),
											a.default.removeUsernameCookie();
									})
									.finally(function () {
										e.appState.trigger('loading', !1);
									});
							},
						});
					(t.default = u), (e.exports = t.default);
				},
				97020: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(29685)).default.extend({
							constructor: function (e) {
								(this.settings = e && e.settings), o.Model.apply(this, arguments);
							},
							loginWithActivationToken: function (e) {
								return this.startTransaction(function (t) {
									return t.signInWithCredentials({ token: e });
								});
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				28528: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(26368)),
						a = r(n(35546)),
						s = r(n(29685)).default.extend({
							props: function () {
								var e = i.default.getCookieUsername(),
									t = this.getUsernameAndRemember(e),
									n = {
										username: {
											type: 'string',
											validate: function (e) {
												if (o._.isEmpty(e)) return (0, o.loc)('error.username.required', 'login');
											},
											value: t.username,
										},
										lastUsername: ['string', !1, e],
										context: ['object', !1],
										remember: ['boolean', !0, t.remember],
										multiOptionalFactorEnroll: ['boolean', !0],
									};
								return (
									(this.settings && this.settings.get('features.passwordlessAuth')) ||
										(n.password = {
											type: 'string',
											validate: function (e) {
												if (o._.isEmpty(e)) return (0, o.loc)('error.password.required', 'login');
											},
										}),
									n
								);
							},
							getUsernameAndRemember: function (e) {
								var t,
									n = this.settings && this.settings.get('username'),
									r = this.settings && this.settings.get('features.rememberMe'),
									o = !1;
								return n ? ((t = n), (o = r && t === e)) : r && e && ((t = e), (o = !0)), { username: t, remember: o };
							},
							constructor: function (e) {
								(this.settings = e && e.settings),
									(this.appState = e && e.appState),
									o.Model.apply(this, arguments),
									this.listenTo(this, 'change:username', function (e, t) {
										this.set({ remember: t === this.get('lastUsername') });
									});
							},
							parse: function (e) {
								return o._.omit(e, ['settings', 'appState']);
							},
							save: function () {
								var e = this,
									t = this.settings.transformUsername(this.get('username'), a.default.PRIMARY_AUTH),
									n = this.get('remember'),
									r = this.get('lastUsername');
								this.setUsernameCookie(t, n, r), this.trigger('save'), this.appState.trigger('loading', !0);
								var s,
									l = this.getSignInArgs(t);
								if (this.appState.get('isUnauthenticated')) {
									var u = this.appState.settings.getAuthClient();
									s = this.appState.get('isIdxStateToken')
										? this.doTransaction(function (e) {
												return this.doPrimaryAuth(u, l, e.login);
										  })
										: this.doTransaction(function (e) {
												return this.doPrimaryAuth(u, l, e.authenticate);
										  }, !0);
								} else
									s = this.startTransaction(function (e) {
										return this.doPrimaryAuth(e, l, o._.bind(e.signInWithCredentials, e));
									});
								return s
									.catch(function () {
										e.appState.trigger('removeLoading'), i.default.removeUsernameCookie();
									})
									.finally(function () {
										e.appState.trigger('loading', !1);
									});
							},
							getSignInArgs: function (e) {
								var t = this.get('multiOptionalFactorEnroll'),
									n = {};
								return (
									this.settings.get('features.passwordlessAuth') || (n.password = this.get('password')),
									this.appState.get('isIdxStateToken')
										? (n.identifier = e)
										: ((n.username = e), (n.options = { warnBeforePasswordExpired: !0, multiOptionalFactorEnroll: t })),
									n
								);
							},
							setUsernameCookie: function (e, t, n) {
								this.settings.get('features.rememberMe') &&
									(t || n !== e ? t && i.default.setUsernameCookie(e) : i.default.removeUsernameCookie());
							},
							doPrimaryAuth: function (e, t, n) {
								var r = this.settings.get('features.deviceFingerprinting'),
									o = this.settings.get('features.trackTypingPattern');
								r &&
									this.appState.get('deviceFingerprint') &&
									e.http.setRequestHeader('X-Device-Fingerprint', this.appState.get('deviceFingerprint')),
									o &&
										this.appState.get('typingPattern') &&
										e.http.setRequestHeader('X-Typing-Pattern', this.appState.get('typingPattern'));
								var i = this;
								return n(t).finally(function () {
									r && (e.http.setRequestHeader('X-Device-Fingerprint', void 0), i.appState.unset('deviceFingerprint')),
										o && (e.http.setRequestHeader('X-Typing-Pattern', void 0), i.appState.unset('typingPattern'));
								});
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				51730: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475),
						o = r.internal.models.BaseSchema.Model.extend({
							expand: ['schema'],
							setFieldPlaceholder: function (e) {
								return (
									r._.each(e, function (e) {
										e.title = e.label;
									}),
									e
								);
							},
							initialize: function (e) {
								var t = e.profileSchemaAttributes;
								if ((t = this.setFieldPlaceholder(t))) {
									for (var n = { properties: {} }, r = 0; r < t.length; r++) {
										var o = t[r];
										n.properties[o.name] = o;
									}
									this.parse.apply(this, [{ schema: n }]);
								}
							},
						});
					(t.default = o), (e.exports = t.default);
				},
				71440: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475),
						o = r.internal.models,
						i = o.BaseSchema,
						a = o.SchemaProperty,
						s = a.Collection.extend({
							createModelProperties: function () {
								var e = a.Collection.prototype.createModelProperties.apply(this);
								return (
									r._.each(
										e,
										function (e, t) {
											e.required = !!this.get(t).get('required');
										},
										this
									),
									e
								);
							},
						}),
						l = i.Model.extend({
							expand: ['schema'],
							constructor: function () {
								(this.properties = new s()), r.BaseModel.apply(this, arguments);
							},
							parse: function (e) {
								var t = this,
									n = this;
								this.settings.parseRegistrationSchema(
									e,
									function (e) {
										e.profileSchema &&
											((e.schema = e.profileSchema),
											i.Model.prototype.parse.apply(n, [e]),
											(e = (function (e) {
												var n = e.schema.required;
												r._.isArray(n) &&
													r._.each(
														n,
														function (e) {
															var t = this.properties.get(e);
															t && t.set('required', !0);
														},
														t
													);
												var o = e.schema.fieldOrder;
												return (
													r._.isArray(o) &&
														(r._.each(
															o,
															function (e, t) {
																var n = this.properties.get(e);
																n && n.set('sortOrder', t);
															},
															t
														),
														(t.properties.comparator = 'sortOrder'),
														t.properties.sort()),
													(t.properties.defaultPolicyId = e.policyId),
													e
												);
											})(e))),
											n.trigger('parseComplete', { properties: n.properties });
									},
									function (e) {
										n.trigger('parseComplete', { properties: n.properties, error: e });
									}
								);
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				96336: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(6321));
					var a = o.Controller.extend({
						addListeners: function () {
							this.listenTo(this.model, 'save', function () {
								var e,
									t =
										((e = this),
										o._.find(e.getChildren(), function (e) {
											return e instanceof o.Form;
										}));
								(t.disableSubmitButton && !t.disableSubmitButton()) || this.toggleButtonState(!0);
							}),
								this.listenTo(this.model, 'error', function () {
									this.toggleButtonState(!1);
								}),
								this.addModelListeners(this.model);
						},
						addModelListeners: function (e) {
							var t = this,
								n = function (e) {
									t.options.appState.set('transaction', e);
								},
								r = function (e) {
									t.options.appState.set('transactionError', e);
								};
							this.listenTo(e, 'setTransaction', n), this.listenTo(e, 'setTransactionError', r);
							var o = e.get('backupFactor');
							o && (this.listenTo(o, 'setTransaction', n), this.listenTo(o, 'setTransactionError', r));
						},
						fetchInitialData: function () {
							return (0, i.default)();
						},
						trapAuthResponse: function () {
							return !1;
						},
						toJSON: function () {
							var e = o.Controller.prototype.toJSON.apply(this, arguments);
							return o._.extend(o._.pick(this.options, 'appState'), e);
						},
						toggleButtonState: function (e) {
							this.$el.find('.button').toggleClass('link-button-disabled', e).prop('disabled', e);
						},
						postRenderAnimation: function () {
							this.trigger('pageRendered', { page: this.className }),
								this.trigger('afterRender', { controller: this.className });
						},
					});
					(t.default = a), (e.exports = t.default);
				},
				75104: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					(t.default = {
						generateDeviceFingerprint: function (e, t) {
							return e.fingerprint({ timeout: 2e3, container: t });
						},
					}),
						(e.exports = t.default);
				},
				73650: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(29685)),
						a = r(n(96336)),
						s = r(n(39694)),
						l = o.internal.views.forms.components.Toolbar,
						u = o.internal.views.forms.helpers.FormUtil,
						c = o.Form.extend({
							layout: 'o-form-theme',
							noCancelButton: !0,
							constructor: function (e) {
								o.Form.call(this, e),
									o._.each(
										o._.result(this, 'formChildren') || [],
										function (e) {
											switch (e.type) {
												case s.default.INPUT:
													this.addInput(o._.extend({ 'label': !1, 'label-top': !0 }, e.viewOptions));
													break;
												case s.default.BUTTON:
													this.add((0, o.createButton)(o._.extend({ model: this.model }, e.viewOptions)), e.addOptions),
														u.applyShowWhen(this.last(), e.viewOptions && e.viewOptions.showWhen);
													break;
												case s.default.DIVIDER:
													this.addDivider(e.viewOptions);
													break;
												case s.default.TOOLBAR:
													this.add(l, { options: e.viewOptions }),
														u.applyShowWhen(this.last(), e.viewOptions && e.viewOptions.showWhen);
													break;
												case s.default.VIEW:
													this.add(e.viewOptions.View, e.addOptions),
														u.applyShowWhen(this.last(), e.viewOptions.showWhen);
													break;
												default:
													throw new Error('Unrecognized child type: ' + e.type);
											}
										},
										this
									);
							},
						}),
						d = a.default.extend({
							constructor: function () {
								var e = this.initialize;
								if (((this.initialize = function () {}), a.default.apply(this, arguments), this.Model && this.Form)) {
									var t = i.default.extend(
										o._.extend(
											{
												parse: function (e) {
													return (
														(this.settings = e.settings),
														(this.appState = e.appState),
														o._.omit(e, ['settings', 'appState'])
													);
												},
											},
											o._.result(this, 'Model')
										)
									);
									this.model = new t({ settings: this.settings, appState: this.options.appState }, { parse: !0 });
									var n = c.extend(o._.result(this, 'Form', this));
									(this.form = new n(this.toJSON())), this.add(this.form);
								}
								this.Footer && this.addFooter(this.Footer), this.addListeners(), e.apply(this, arguments);
							},
							addFooter: function (e, t) {
								(this.footer = new e(o._.extend(this.toJSON(), t || {}))), this.add(this.footer);
							},
							toJSON: function () {
								var e = a.default.prototype.toJSON.apply(this, arguments);
								return o._.extend(o._.pick(this.options, 'appState'), e);
							},
							back: function () {
								this.footer && this.footer.back && this.footer.back();
							},
						});
					(t.default = d), (e.exports = t.default);
				},
				39694: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var n = 'INPUT',
						r = 'BUTTON',
						o = 'DIVIDER',
						i = 'TOOLBAR',
						a = 'VIEW';
					function s(e) {
						return function (t, n) {
							return { type: e, viewOptions: t, addOptions: n };
						};
					}
					var l = {
						Input: s(n),
						Button: s(r),
						Divider: s(o),
						Toolbar: s(i),
						View: s(a),
						INPUT: n,
						BUTTON: r,
						DIVIDER: o,
						TOOLBAR: i,
						VIEW: a,
					};
					(t.default = l), (e.exports = t.default);
				},
				37197: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(50160)),
						a = o.internal.views.forms.helpers.SchemaFormFactory,
						s = o.internal.views.forms.inputs.CheckBox,
						l = function (e) {
							var t = e.split(''),
								n = [],
								r = [',', '.', '-', '_', '#', '@'],
								i = '';
							return (
								o._.each(t, function (e) {
									-1 === r.indexOf(e) ? (i += e) : (i.length >= 4 && n.push(o._.clone(i)), (i = ''));
								}),
								i.length >= 4 && n.push(o._.clone(i)),
								n.filter(Boolean)
							);
						},
						u = function (e, t) {
							if (!e) return !1;
							(e = e.toLowerCase()), (t = t.toLowerCase());
							for (var n = l(e), r = 0; r < n.length; r++) {
								var o = n[r];
								if (-1 !== t.indexOf(o)) return !0;
							}
							return !1;
						},
						c = function (e, t, n, r) {
							var i = t.get(e);
							o._.isString(i) &&
								n.each(function (n, a) {
									var s = (0, o.$)('#subschemas-' + e + ' .subschema-' + a);
									i ? s.children('p').removeClass('default-schema') : s.children('p').addClass('default-schema'),
										s.children('p').removeAttr('role').removeAttr('aria-live'),
										s.removeClass('subschema-satisfied subschema-unsatisfied subschema-error'),
										!(function (e, t, n) {
											var r = e.get('minLength'),
												i = e.get('maxLength'),
												a = e.get('format');
											if (o._.isNumber(r) && t.length < r) return !1;
											if (o._.isNumber(i) && t.length > i) return !1;
											var s = t;
											if (o._.isString(a)) {
												if ('^[#/userName]' === a || '^[#/firstName]' === a || '^[#/lastName]' === a) {
													var l = a.split('^[#/')[1].split(']')[0],
														c = n.get(l);
													return (
														'userName' === l && (c = n.has('userName') ? n.get('userName') : n.get('email')), !u(c, s)
													);
												}
												if (!new RegExp(a).test(t)) return !1;
											}
											return !0;
										})(n, i, t)
											? r &&
											  (s.find('p span').removeClass('confirm-16'),
											  s.find('p span').addClass('error error-16-small'),
											  s.addClass('subschema-error subschema-unsatisfied'),
											  s.find('p').attr('role', 'alert').attr('aria-live', 'polite'))
											: (s.addClass('subschema-satisfied'),
											  s.find('p span').removeClass('error error-16-small'),
											  s.find('p span').addClass('confirm-16'));
								});
						},
						d = {
							createInputOptions: function (e) {
								var t,
									n = a.createInputOptions(e);
								if (
									('boolean' === (null === (t = e.options) || void 0 === t ? void 0 : t.type) && (n.input = s),
									'select' === n.type)
								)
									n = o._.extend(n, { label: e.get('title') });
								else {
									var r = e.get('title');
									e.get('required') && (r += ' *'),
										(n = o._.extend(n, { 'label': !1, 'label-top': !0, 'placeholder': r }));
								}
								var l = e.get('name');
								switch (l) {
									case 'userName':
										(n.input = i.default), (n.params = { icon: 'person-16-gray' });
										break;
									case 'password':
										(n.type = 'password'), (n.input = i.default), (n.params = { icon: 'remote-lock-16' });
								}
								var u = e.get('subSchemas');
								return (
									u &&
										(n.events = {
											'input': function () {
												c(l, this.model, u, !0);
											},
											'focusout': function () {
												c(l, this.model, u, !0);
											},
											'change:userName': function () {
												c(l, this.model, u, !0);
											},
											'change:firstName': function () {
												c(l, this.model, u, !0);
											},
											'change:lastName': function () {
												c(l, this.model, u, !0);
											},
											'change:email': function () {
												c(l, this.model, u, !0);
											},
										}),
									n
								);
							},
							getUsernameParts: l,
							passwordContainsFormField: u,
						};
					(t.default = d), (e.exports = t.default);
				},
				39409: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = r(n(34425)),
						l = r(n(35546)),
						u = r(n(88882)),
						c = n(13671),
						d = r(n(97329)),
						f = r(n(90570)),
						p = {},
						h = i.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, i) {
								var a,
									s = null != t ? t : e.nullContext || {},
									l = e.hooks.helperMissing,
									u = 'function',
									c = e.escapeExpression,
									d =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'signin/verify/' +
									c(
										((a = null != (a = d(n, 'provider') || (null != t ? d(t, 'provider') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'provider',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 14 }, end: { line: 1, column: 26 } },
											  })
											: a)
									) +
									'/' +
									c(
										((a = null != (a = d(n, 'factorType') || (null != t ? d(t, 'factorType') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'factorType',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 27 }, end: { line: 1, column: 41 } },
											  })
											: a)
									)
								);
							},
							useData: !0,
						}),
						m = i.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, i) {
								var a,
									s = null != t ? t : e.nullContext || {},
									l = e.hooks.helperMissing,
									u = 'function',
									c = e.escapeExpression,
									d =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'signin/verify/' +
									c(
										((a = null != (a = d(n, 'provider') || (null != t ? d(t, 'provider') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'provider',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 14 }, end: { line: 1, column: 26 } },
											  })
											: a)
									) +
									'/' +
									c(
										((a = null != (a = d(n, 'factorType') || (null != t ? d(t, 'factorType') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'factorType',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 27 }, end: { line: 1, column: 41 } },
											  })
											: a)
									) +
									'/' +
									c(
										((a = null != (a = d(n, 'factorIndex') || (null != t ? d(t, 'factorIndex') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'factorIndex',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 42 }, end: { line: 1, column: 57 } },
											  })
											: a)
									)
								);
							},
							useData: !0,
						}),
						v = i.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'signin/verify/' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'factorType') || (null != t ? a(t, 'factorType') : t))
													? i
													: e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'factorType',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 14 }, end: { line: 1, column: 28 } },
											  })
											: i
									)
								);
							},
							useData: !0,
						}),
						g = i.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, i) {
								var a,
									s = null != t ? t : e.nullContext || {},
									l = e.hooks.helperMissing,
									u = 'function',
									c = e.escapeExpression,
									d =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'signin/enroll/' +
									c(
										((a = null != (a = d(n, 'provider') || (null != t ? d(t, 'provider') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'provider',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 14 }, end: { line: 1, column: 26 } },
											  })
											: a)
									) +
									'/' +
									c(
										((a = null != (a = d(n, 'factorType') || (null != t ? d(t, 'factorType') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'factorType',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 27 }, end: { line: 1, column: 41 } },
											  })
											: a)
									)
								);
							},
							useData: !0,
						}),
						y = i.default.template({
							1: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'/' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'step') || (null != t ? a(t, 'step') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'step',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 63 }, end: { line: 1, column: 71 } },
											  })
											: i
									)
								);
							},
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, i) {
								var a,
									s,
									l = null != t ? t : e.nullContext || {},
									u = e.hooks.helperMissing,
									c = 'function',
									d = e.escapeExpression,
									f =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'signin/enroll-activate/' +
									d(
										((s = null != (s = f(n, 'provider') || (null != t ? f(t, 'provider') : t)) ? s : u),
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'provider',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 23 }, end: { line: 1, column: 35 } },
											  })
											: s)
									) +
									'/' +
									d(
										((s = null != (s = f(n, 'factorType') || (null != t ? f(t, 'factorType') : t)) ? s : u),
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'factorType',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 36 }, end: { line: 1, column: 50 } },
											  })
											: s)
									) +
									(null !=
									(a = f(n, 'if').call(l, null != t ? f(t, 'step') : t, {
										name: 'if',
										hash: {},
										fn: e.program(1, i, 0),
										inverse: e.noop,
										data: i,
										loc: { start: { line: 1, column: 50 }, end: { line: 1, column: 78 } },
									}))
										? a
										: '')
								);
							},
							useData: !0,
						}),
						b = i.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'signin/recovery/' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'recoveryToken') || (null != t ? a(t, 'recoveryToken') : t))
													? i
													: e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'recoveryToken',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 16 }, end: { line: 1, column: 33 } },
											  })
											: i
									)
								);
							},
							useData: !0,
						}),
						_ = i.default.template({
							1: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'/' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'token') || (null != t ? a(t, 'token') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'token',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 39 }, end: { line: 1, column: 48 } },
											  })
											: i
									)
								);
							},
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'signin/refresh-auth-state' +
									(null !=
									(i = a(n, 'if').call(null != t ? t : e.nullContext || {}, null != t ? a(t, 'token') : t, {
										name: 'if',
										hash: {},
										fn: e.program(1, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 25 }, end: { line: 1, column: 55 } },
									}))
										? i
										: '')
								);
							},
							useData: !0,
						}),
						w = i.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'signin/okta/' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'username') || (null != t ? a(t, 'username') : t))
													? i
													: e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'username',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 12 }, end: { line: 1, column: 24 } },
											  })
											: i
									)
								);
							},
							useData: !0,
						}),
						O = i.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, i) {
								var a,
									s,
									l = null != t ? t : e.nullContext || {},
									u = e.hooks.helperMissing,
									c = 'function',
									d =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									e.escapeExpression(
										((s = null != (s = d(n, 'baseUrl') || (null != t ? d(t, 'baseUrl') : t)) ? s : u),
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'baseUrl',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 11 } },
											  })
											: s)
									) +
									'/login/sessionCookieRedirect?checkAccountSetupComplete=true&token=' +
									(null !=
									((s = null != (s = d(n, 'token') || (null != t ? d(t, 'token') : t)) ? s : u),
									(a =
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'token',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 77 }, end: { line: 1, column: 88 } },
											  })
											: s))
										? a
										: '') +
									'&redirectUrl=' +
									(null !=
									((s = null != (s = d(n, 'redirectUrl') || (null != t ? d(t, 'redirectUrl') : t)) ? s : u),
									(a =
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'redirectUrl',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 101 }, end: { line: 1, column: 118 } },
											  })
											: s))
										? a
										: '')
								);
							},
							useData: !0,
						}),
						k = ['DEVICE_ACTIVATED', 'DEVICE_NOT_ACTIVATED_CONSENT_DENIED', 'DEVICE_NOT_ACTIVATED'];
					(p.isHostBackgroundChromeTab = function () {
						return !!(navigator.userAgent.match(/Android/) && navigator.userAgent.match(/Chrome/) && document.hidden);
					}),
						(p.isDocumentVisible = function () {
							return 'visible' === document.visibilityState;
						}),
						(p.createVerifyUrl = function (e, t, n) {
							return e && n
								? m({
										provider: encodeURIComponent(e.toLowerCase()),
										factorType: encodeURIComponent(t),
										factorIndex: encodeURIComponent(n),
								  })
								: e
								? h({ provider: encodeURIComponent(e.toLowerCase()), factorType: encodeURIComponent(t) })
								: v({ factorType: encodeURIComponent(t) });
						}),
						(p.createEnrollFactorUrl = function (e, t) {
							return g({ provider: encodeURIComponent(e.toLowerCase()), factorType: encodeURIComponent(t) });
						}),
						(p.createActivateFactorUrl = function (e, t, n) {
							return y({
								provider: encodeURIComponent(e.toLowerCase()),
								factorType: encodeURIComponent(t),
								step: !!n && encodeURIComponent(n),
							});
						}),
						(p.createRecoveryUrl = function (e) {
							return b({ recoveryToken: encodeURIComponent(e) });
						}),
						(p.createRefreshUrl = function (e) {
							var t = e ? encodeURIComponent(e) : null;
							return _({ token: t });
						}),
						(p.createSigninUrl = function (e) {
							return e ? w({ username: encodeURIComponent(e) }) : 'signin';
						}),
						(p.routeAfterAuthStatusChangeError = function (e, t) {
							if (t) {
								if (!t.xhr || !s.default.corsIsNotEnabled(t.xhr))
									return t.errorCode === u.default.INVALID_TOKEN_EXCEPTION
										? (e.appState.set('flashError', t),
										  e.controller.state.set('navigateDir', l.default.DIRECTION_BACK),
										  void (e.settings.get('features.mfaOnlyFlow')
												? e.navigate('signin/error', { trigger: !0 })
												: e.navigate('', { trigger: !0 })))
										: void f.default.triggerAfterError(e.controller, t);
								e.settings.callGlobalError(new c.UnsupportedBrowserError((0, a.loc)('error.enabled.cors')));
							}
						}),
						(p.routeAfterAuthStatusChange = function (e, t) {
							t && t.status
								? (e.appState.setAuthResponse(t),
								  (e.controller && e.controller.trapAuthResponse(t)) || p.handleResponseStatus(e, t))
								: e.appState.clearLastAuthResponse();
						}),
						(p.handleResponseStatus = function (e, t) {
							switch (t.status) {
								case 'SUCCESS':
									return void (function (e, t) {
										var n, r, o, i, s;
										if (t.recoveryType === l.default.RECOVERY_TYPE_UNLOCK)
											return void e.navigate('signin/account-unlocked', { trigger: !0 });
										if (a._.contains(k, null === (n = t._embedded) || void 0 === n ? void 0 : n.deviceActivationStatus))
											return void e.navigate('signin/device-activate-complete', { trigger: !0 });
										if (e.settings.get('oauth2Enabled'))
											return void d.default.getTokens(e.settings, { sessionToken: t.sessionToken }, e.controller);
										var u = { user: t._embedded.user, type: t.type || l.default.SESSION_SSO };
										t.relayState && (u.relayState = t.relayState);
										var h = e.settings.get('redirectUtilFn'),
											m =
												(null == t ||
												null === (r = t._links) ||
												void 0 === r ||
												null === (o = r.original) ||
												void 0 === o
													? void 0
													: o.href) ||
												(null == t || null === (i = t._links) || void 0 === i || null === (s = i.next) || void 0 === s
													? void 0
													: s.href);
										if (t.type === l.default.SESSION_STEP_UP) {
											var v,
												g,
												y =
													null == t || null === (v = t._links) || void 0 === v || null === (g = v.next) || void 0 === g
														? void 0
														: g.href;
											u.stepUp = {
												url: y,
												finish: function () {
													h(y);
												},
											};
										} else
											m
												? (u.next = function () {
														h(m);
												  })
												: (u.type = l.default.SESSION_SSO),
												t.sessionToken &&
													(u.session = {
														token: t.sessionToken,
														setCookieAndRedirect: function (n) {
															if (
																(n &&
																	f.default.debugMessage(
																		'\n              Passing a "redirectUri" to "setCookieAndRedirect" is strongly discouraged.\n              It is recommended to set a "redirectUri" option in the config object passed to the widget constructor.\n            '
																	),
																!(n = n || e.settings.get('redirectUri')))
															)
																throw new c.ConfigError('"redirectUri" is required');
															h(
																O({
																	baseUrl: e.settings.get('baseUrl'),
																	token: encodeURIComponent(t.sessionToken),
																	redirectUrl: encodeURIComponent(n),
																})
															);
														},
													});
										p.isHostBackgroundChromeTab()
											? document.addEventListener('visibilitychange', function t() {
													p.isDocumentVisible() &&
														(document.removeEventListener('visibilitychange', t),
														e.settings.callGlobalSuccess(l.default.SUCCESS, u));
											  })
											: e.settings.callGlobalSuccess(l.default.SUCCESS, u);
									})(e, t);
								case 'ADMIN_CONSENT_REQUIRED':
									return void e.navigate('signin/admin-consent', { trigger: !0 });
								case 'CONSENT_REQUIRED':
									return void e.navigate('signin/consent', { trigger: !0 });
								case 'DEVICE_ACTIVATE':
									return void e.navigate('signin/device-activate', { trigger: !0 });
								case 'FACTOR_REQUIRED':
								case 'FACTOR_CHALLENGE':
								case 'MFA_REQUIRED':
									var n = e.appState.get('lastFailedChallengeFactorData');
									n && n.factor && (e.appState.get('factors').lastUsedFactor = n.factor);
									var r = e.appState.get('factors').getDefaultFactor(),
										o = p.createVerifyUrl(r.get('provider'), r.get('factorType'));
									return e.navigate(o, { trigger: !0 }), void e.appState.clearLastFailedChallengeFactorData();
								case 'POLL':
									return void e.navigate('signin/poll', { trigger: !0 });
								case 'MFA_CHALLENGE':
									return (
										e.appState.get('isFactorResultFailed') && e.appState.setLastFailedChallengeFactorData(),
										void e.appState
											.get('transaction')
											.prev()
											.then(function (t) {
												e.appState.set('transaction', t);
											})
									);
								case 'MFA_ENROLL':
								case 'FACTOR_ENROLL':
									return void e.navigate('signin/enroll', { trigger: !0 });
								case 'MFA_ENROLL_ACTIVATE':
								case 'FACTOR_ENROLL_ACTIVATE':
									var i = p.createActivateFactorUrl(
										e.appState.get('activatedFactorProvider'),
										e.appState.get('activatedFactorType')
									);
									return void e.navigate(i, { trigger: !0 });
								case 'PASSWORD_WARN':
								case 'PASSWORD_EXPIRED':
									return void (e.settings.get('features.customExpiredPassword') && !e.appState.get('isPwdManagedByOkta')
										? e.navigate('signin/custom-password-expired', { trigger: !0 })
										: e.navigate('signin/password-expired', { trigger: !0 }));
								case 'RECOVERY_CHALLENGE':
									var s = t.factorType.toLowerCase() === l.default.RECOVERY_FACTOR_TYPE_EMAIL.toLowerCase(),
										u = t.recoveryType === l.default.RECOVERY_TYPE_PASSWORD,
										h = t.recoveryType === l.default.RECOVERY_TYPE_UNLOCK;
									return void (u && s
										? e.navigate('signin/recovery-emailed', { trigger: !0 })
										: h && s
										? e.navigate('signin/unlock-emailed', { trigger: !0 })
										: e.navigate('signin/recovery-challenge', { trigger: !0 }));
								case 'RECOVERY':
									return void e.navigate('signin/recovery-question', { trigger: !0 });
								case 'PASSWORD_RESET':
									return void e.navigate('signin/password-reset', { trigger: !0 });
								case 'LOCKED_OUT':
									if (e.settings.get('features.selfServiceUnlock')) e.navigate('signin/unlock', { trigger: !0 });
									else {
										var m = (0, a.loc)('error.auth.lockedOut', 'login'),
											v = { responseJSON: { errorCauses: [], errorSummary: m, errorCode: 'E0000119' } },
											g = { name: 'AuthApiError', message: m, xhr: v };
										e.controller.model.appState.trigger('removeLoading'),
											e.controller.model.trigger('error', e.controller.model, v),
											f.default.triggerAfterError(e.controller, g);
									}
									return;
								case 'PROFILE_REQUIRED':
									return void e.navigate('signin/enroll-user', { trigger: !0 });
								case 'UNAUTHENTICATED':
									if (e.appState.get('promptForFactorInUnauthenticated')) {
										var y = e.appState.get('factors').getDefaultFactor(),
											b = p.createVerifyUrl(y.get('provider'), y.get('factorType'));
										return void e.navigate(b, { trigger: !0 });
									}
									return e.appState.get('usingDeviceFlow')
										? void e.navigate('signin/idp-discovery-check', { trigger: !0 })
										: void e.navigate('', { trigger: !0 });
								default:
									throw new Error('Unknown status: ' + t.status);
							}
						});
					var x = p;
					(t.default = x), (e.exports = t.default);
				},
				89866: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					(t.default = {
						OKTA: {
							APPLE: 'https://itunes.apple.com/us/app/okta-verify/id490179405',
							ANDROID: 'https://play.google.com/store/apps/details?id=com.okta.android.auth',
						},
						GOOGLE: {
							APPLE: 'https://itunes.apple.com/us/app/google-authenticator/id388497605',
							ANDROID: 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2',
						},
						STORE: { APPLE: 'App Store', ANDROID: 'Google Play Store' },
					}),
						(e.exports = t.default);
				},
				73771: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o,
						i = r(n(80496)),
						a = {
							track: function (e) {
								try {
									(o = new i.default()).addTarget(e), o.start();
								} catch (e) {}
							},
							getTypingPattern: function () {
								try {
									return o.getTypingPattern({ type: 1 });
								} catch (e) {
									return null;
								}
							},
						};
					(t.default = a), (e.exports = t.default);
				},
				78419: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475),
						o = {
							validateUsername: function (e) {
								var t = e.get('username');
								if (t && t.length > 256) return { username: (0, r.loc)('model.validation.field.username', 'login') };
							},
							validateFieldsMatch: function (e, t, n, r) {
								if (e.get(t) !== e.get(n)) {
									var o = {};
									return (o[n] = r), o;
								}
							},
							validatePasswordMatch: function (e) {
								return o.validateFieldsMatch(
									e,
									'newPassword',
									'confirmPassword',
									(0, r.loc)('password.error.match', 'login')
								);
							},
						},
						i = o;
					(t.default = i), (e.exports = t.default);
				},
				53292: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(35546)),
						s = i.View.extend({
							className: 'hide resend-email-infobox',
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i = null != t ? t : e.nullContext || {},
										a = e.hooks.helperMissing,
										s = e.escapeExpression,
										l =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="infobox infobox-warning" aria-live="polite"><span class="icon warning-16"></span><p><span>' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'email.code.not.received' },
												data: o,
												loc: { start: { line: 1, column: 102 }, end: { line: 1, column: 156 } },
											})
										) +
										'</span><a href="#" class="resend-email-btn">' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'email.button.resend' },
												data: o,
												loc: { start: { line: 1, column: 200 }, end: { line: 1, column: 250 } },
											})
										) +
										'</a></p></div>'
									);
								},
								useData: !0,
							}),
							events: { 'click .resend-email-btn': 'resendEmail' },
							postRender: function () {
								this.showResendCallout();
							},
							showResendCallout: function () {
								var e = this;
								i._.delay(function () {
									e.$el.removeClass('hide');
								}, a.default.API_RATE_LIMIT);
							},
							hideResendCallout: function () {
								this.$el.addClass('hide');
							},
							resendEmail: function (e) {
								e.preventDefault(),
									this.hideResendCallout(),
									this.model.resend().finally(this.showResendCallout.bind(this));
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				6896: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475);
					n(48231);
					var a = i.View.extend({
						className: 'scope-item',
						template: o.default.template({
							1: function (e, t, n, r, o) {
								return '<span class="scope-item-tooltip icon form-help-16" />';
							},
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a,
									s = null != t ? t : e.nullContext || {},
									l =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<p class="scope-item-text no-translate">' +
									e.escapeExpression(
										'function' ==
											typeof (a =
												null != (a = l(n, 'name') || (null != t ? l(t, 'name') : t)) ? a : e.hooks.helperMissing)
											? a.call(s, {
													name: 'name',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 40 }, end: { line: 1, column: 48 } },
											  })
											: a
									) +
									'</p>' +
									(null !=
									(i = l(n, 'if').call(s, null != t ? l(t, 'description') : t, {
										name: 'if',
										hash: {},
										fn: e.program(1, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 52 }, end: { line: 1, column: 131 } },
									}))
										? i
										: '')
								);
							},
							useData: !0,
						}),
						postRender: function () {
							this.$('.scope-item-tooltip').qtip({
								content: { text: i._.escape(this.options.description) },
								style: { classes: 'okta-tooltip qtip-custom qtip-shadow' },
								position: { my: 'bottom left', target: 'mouse' },
							});
						},
					});
					(t.default = a), (e.exports = t.default);
				},
				29531: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(6896)),
						s = {
							groups: 'user',
							myAccount: 'user',
							users: 'user',
							apps: 'resource',
							authenticators: 'resource',
							authorizationServers: 'resource',
							clients: 'resource',
							domains: 'resource',
							factors: 'resource',
							idps: 'resource',
							linkedObjects: 'resource',
							policies: 'resource',
							templates: 'resource',
							eventHooks: 'hook',
							inlineHooks: 'hook',
							events: 'system',
							logs: 'system',
							orgs: 'system',
							roles: 'system',
							schemas: 'system',
							sessions: 'system',
							trustedOrigins: 'system',
						},
						l = function (e) {
							var t = e.name,
								n = (void 0 === t ? '' : t).split('.')[1];
							return s[n] || 'system';
						},
						u = i.View.extend({
							className: 'scope-group',
							events: { click: 'expandScopes' },
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="scope-group--header"><h3>' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'groupName') || (null != t ? a(t, 'groupName') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'groupName',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 37 }, end: { line: 1, column: 50 } },
												  })
												: i
										) +
										'</h3><span class="scope-group--toggle"><svg class="caret" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="path" fill-rule="evenodd" clip-rule="evenodd" d="M5.99967 4.66663L10.2663 8.66663L11.333 7.66663L5.99967 2.66663L0.666342 7.73636L1.73301 8.66663L5.99967 4.66663Z" fill="#A0A7AC"></path></svg></span></div>'
									);
								},
								useData: !0,
							}),
							expandScopes: function () {
								this.$el.toggleClass('scope-group--is-expanded'), this.$('.caret').toggleClass('caret--is-rotated');
							},
							preRender: function () {
								var e = this;
								i._.chain(this.options.scopes)
									.sortBy(function (e) {
										return e.name;
									})
									.each(function (t) {
										var n = t.name,
											r = t.displayName,
											o = t.description;
										e.add(a.default, { options: { name: r || n, description: o } });
									});
							},
						}),
						c = i.View.extend({
							className: 'scope-list detail-row',
							postRender: function () {
								var e = this,
									t = this.model.get('scopes'),
									n = i._.groupBy(t, l),
									r = {
										user: (0, i.loc)('admin.consent.group.user.group', 'login'),
										resource: (0, i.loc)('admin.consent.group.resource.policy', 'login'),
										hook: (0, i.loc)('admin.consent.group.hook', 'login'),
										system: (0, i.loc)('admin.consent.group.system', 'login'),
									};
								i._.each(r, function (t, r) {
									var o = n[r];
									Array.isArray(o) && e.add(u, { options: { groupName: t, scopes: o } });
								});
							},
						});
					(t.default = c), (e.exports = t.default);
				},
				27008: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = a.internal.views.forms.inputs.CheckBox.extend({
							template: i.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<input type="checkbox" name="' +
										c(
											((a = null != (a = d(n, 'name') || (null != t ? d(t, 'name') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'name',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 29 }, end: { line: 1, column: 37 } },
												  })
												: a)
										) +
										'" id="' +
										c(
											((a = null != (a = d(n, 'inputId') || (null != t ? d(t, 'inputId') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'inputId',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 43 }, end: { line: 1, column: 54 } },
												  })
												: a)
										) +
										'"/><label for="' +
										c(
											((a = null != (a = d(n, 'inputId') || (null != t ? d(t, 'inputId') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'inputId',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 69 }, end: { line: 1, column: 80 } },
												  })
												: a)
										) +
										'" data-se-for-name="' +
										c(
											((a = null != (a = d(n, 'name') || (null != t ? d(t, 'name') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'name',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 100 }, end: { line: 1, column: 108 } },
												  })
												: a)
										) +
										'"><b>' +
										c(
											((a = null != (a = d(n, 'placeholder') || (null != t ? d(t, 'placeholder') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'placeholder',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 113 }, end: { line: 1, column: 128 } },
												  })
												: a)
										) +
										'</b><p>' +
										c(
											((a = null != (a = d(n, 'desc') || (null != t ? d(t, 'desc') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'desc',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 135 }, end: { line: 1, column: 143 } },
												  })
												: a)
										) +
										'</p></label>'
									);
								},
								useData: !0,
							}),
							enable: function () {
								this.options.options.optional && this.$(':input').prop('disabled', !1);
							},
							editMode: function () {
								if (
									(this.$el.html(
										this.template(
											a._.extend(a._.omit(this.options, 'placeholder'), {
												placeholder: this.options.placeholder || this.options.name,
												desc: this.options.options.description,
											})
										)
									),
									this.$(':checkbox').prop('checked', this.getModelValue() || !1),
									this.$('input').customInput(),
									this.model.trigger('form:resize'),
									!this.options.options.optional)
								) {
									var e = this.$('input').get(0);
									this.$(e.parentElement).addClass('o-form-read-mode'), this.$(':checkbox').prop('disabled', !0);
								}
								return (
									('openid' === this.options.name || this.options.options.isCustomized) &&
										(this.$('label > b').addClass('no-translate'),
										this.options.options.isCustomized && this.$('label > p').addClass('no-translate')),
									this
								);
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				47894: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475);
					n(48231);
					var s = a.View.extend({
						className: 'scope-item',
						template: i.default.template({
							1: function (e, t, n, r, o) {
								return '<span class="scope-item-tooltip icon form-help-16"></span>';
							},
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, i) {
								var a,
									s,
									l = null != t ? t : e.nullContext || {},
									u = e.hooks.helperMissing,
									c = 'function',
									d = e.escapeExpression,
									f =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<div class="' +
									d(
										((s = null != (s = f(n, 'classNames') || (null != t ? f(t, 'classNames') : t)) ? s : u),
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'classNames',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 12 }, end: { line: 1, column: 26 } },
											  })
											: s)
									) +
									'"><p>' +
									d(
										((s = null != (s = f(n, 'name') || (null != t ? f(t, 'name') : t)) ? s : u),
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'name',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 31 }, end: { line: 1, column: 39 } },
											  })
											: s)
									) +
									'</p></div>' +
									(null !=
									(a = f(n, 'if').call(l, null != t ? f(t, 'description') : t, {
										name: 'if',
										hash: {},
										fn: e.program(1, i, 0),
										inverse: e.noop,
										data: i,
										loc: { start: { line: 1, column: 49 }, end: { line: 1, column: 133 } },
									}))
										? a
										: '')
								);
							},
							useData: !0,
						}),
						getTemplateData: function () {
							var e = this.options,
								t = e.name,
								n = e.description,
								r = e.isCustomized,
								o = 'scope-item-text';
							return { classNames: 'openid' === t || r ? ''.concat(o, ' no-translate') : o, name: t, description: n };
						},
						postRender: function () {
							this.$('.scope-item-tooltip').qtip({
								content: { text: a._.escape(this.options.description) },
								style: { classes: 'okta-tooltip qtip-custom qtip-shadow' },
								position: { my: 'bottom right', target: 'mouse' },
							});
						},
					});
					(t.default = s), (e.exports = t.default);
				},
				99629: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(47894)),
						a = o.View.extend({
							className: 'scope-list detail-row',
							postRender: function () {
								var e = this;
								this.model.get('scopes').forEach(function (t) {
									e.add(i.default, {
										options: {
											name: t.displayName || t.name,
											description: t.description,
											isCustomized: t.isCustomized,
										},
									});
								});
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				38513: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = r(n(2645)),
						l = r(n(39409)),
						u = i.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<span class="factor-cardinality">' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'cardinalityText') || (null != t ? a(t, 'cardinalityText') : t))
													? i
													: e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'cardinalityText',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 33 }, end: { line: 1, column: 52 } },
											  })
											: i
									) +
									'</span>'
								);
							},
							useData: !0,
						}),
						c = a.View.extend({
							tagName: 'li',
							className: 'enroll-factor-row clearfix',
							template: i.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p>' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'factorDescription') || (null != t ? a(t, 'factorDescription') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'factorDescription',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 235 }, end: { line: 1, column: 256 } },
												  })
												: i
										) +
										'</p>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, i) {
									var a,
										s,
										l = null != t ? t : e.nullContext || {},
										u = e.hooks.helperMissing,
										c = 'function',
										d = e.escapeExpression,
										f =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="enroll-factor-icon-container"><div class="factor-icon enroll-factor-icon ' +
										d(
											((s = null != (s = f(n, 'iconClassName') || (null != t ? f(t, 'iconClassName') : t)) ? s : u),
											(0, o.default)(s) === c
												? s.call(l, {
														name: 'iconClassName',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 85 }, end: { line: 1, column: 102 } },
												  })
												: s)
										) +
										'"></div></div><div class="enroll-factor-description"><h3 class="enroll-factor-label">' +
										d(
											((s = null != (s = f(n, 'factorLabel') || (null != t ? f(t, 'factorLabel') : t)) ? s : u),
											(0, o.default)(s) === c
												? s.call(l, {
														name: 'factorLabel',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 187 }, end: { line: 1, column: 202 } },
												  })
												: s)
										) +
										'</h3>' +
										(null !=
										(a = f(n, 'if').call(l, null != t ? f(t, 'factorDescription') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, i, 0),
											inverse: e.noop,
											data: i,
											loc: { start: { line: 1, column: 207 }, end: { line: 1, column: 267 } },
										}))
											? a
											: '') +
										'<div class="enroll-factor-button"></div></div>'
									);
								},
								useData: !0,
							}),
							attributes: function () {
								return { 'data-se': this.model.get('factorName') };
							},
							children: function () {
								var e = [],
									t = this.model.get('enrolled'),
									n = this.model.get('required'),
									r = this.model.get('cardinality');
								if (this.options.showInlineSetupButton)
									return [
										[
											(0, a.createButton)({
												className: 'button',
												title: this.getSetupButtonText(),
												click: function () {
													this.options.appState.trigger(
														'navigate',
														l.default.createEnrollFactorUrl(this.model.get('provider'), this.model.get('factorType'))
													);
												},
											}),
											'.enroll-factor-button',
										],
									];
								t
									? e.push(['<span class="icon success-16-green"></span>', '.enroll-factor-label'])
									: n && e.push(['<span class="icon success-16-gray"></span>', '.enroll-factor-label']);
								var o = s.default.getCardinalityText(t, n, r);
								return o && e.push([u({ cardinalityText: o }), '.enroll-factor-description']), e;
							},
							minimize: function () {
								this.$el.addClass('enroll-factor-row-min');
							},
							maximize: function () {
								this.$el.removeClass('enroll-factor-row-min');
							},
							getSetupButtonText: function () {
								return this.model.get('additionalEnrollment')
									? (0, a.loc)('enroll.choices.setup.another', 'login')
									: (0, a.loc)('enroll.choices.setup', 'login');
							},
						}),
						d = a.ListView.extend({
							className: 'enroll-factor-list',
							item: c,
							itemSelector: '.list-content',
							template: i.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<h3 class="list-title">' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'listTitle') || (null != t ? a(t, 'listTitle') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'listTitle',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 40 }, end: { line: 1, column: 53 } },
												  })
												: i
										) +
										'</h3>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = a(n, 'if').call(null != t ? t : e.nullContext || {}, null != t ? a(t, 'listTitle') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 65 } },
										}))
											? i
											: '') + '<ul class="list-content"></ul>'
									);
								},
								useData: !0,
							}),
							getTemplateData: function () {
								var e = a.ListView.prototype.getTemplateData.call(this);
								return a._.extend(e, this), e;
							},
							postRender: function () {
								this.options.minimize && this.invoke('minimize');
							},
						});
					(t.default = d), (e.exports = t.default);
				},
				91537: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475).View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<a href="#" class="link goto js-skip" data-se="skip-link">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'enroll.choices.setup.skip' },
													data: o,
													loc: { start: { line: 1, column: 58 }, end: { line: 1, column: 114 } },
												}
											)
										) +
										'</a>'
									);
								},
								useData: !0,
							}),
							className: 'auth-footer clearfix',
							events: {
								'click .js-skip': function (e) {
									e.preventDefault(),
										this.model.doTransaction(function (e) {
											return e.skip();
										});
								},
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				10268: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(38513)),
						a = i.default.extend({
							listTitle: o._.partial(o.loc, 'enroll.choices.list.setup', 'login'),
							className: function () {
								return i.default.prototype.className + ' enroll-required-factor-list';
							},
							postRender: function () {
								var e;
								i.default.prototype.postRender.apply(this, arguments),
									(e = this.options.appState.get('factors').getFirstUnenrolledRequiredFactor()),
									this.find(function (t) {
										return t.model === e;
									}).maximize();
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				34361: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = r(n(2645)),
						l = r(n(39409)),
						u = a.View.extend({
							className: 'scan-instructions clearfix',
							template: i.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="scan-instructions-details-wrapper"><div class="scan-instructions-details"><p>' +
										c(
											((a = null != (a = d(n, 'instructions') || (null != t ? d(t, 'instructions') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'instructions',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 89 }, end: { line: 1, column: 105 } },
												  })
												: a)
										) +
										'</p></div></div><div class="scan-instructions-qrcode-wrapper"><div class="qrcode-wrap"><img data-se="qrcode" alt="' +
										c(
											((a = null != (a = d(n, 'altQRCode') || (null != t ? d(t, 'altQRCode') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'altQRCode',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 219 }, end: { line: 1, column: 232 } },
												  })
												: a)
										) +
										'" class="qrcode-image" src="' +
										c(
											((a = null != (a = d(n, 'qrcode') || (null != t ? d(t, 'qrcode') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'qrcode',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 260 }, end: { line: 1, column: 270 } },
												  })
												: a)
										) +
										'"><div data-se="qrcode-success" class="qrcode-success"></div><div data-se="qrcode-error" class="qrcode-error"></div></div><a href="#" data-type="manual-setup" data-se="manual-setup" class="link manual-setup" aria-label="' +
										c(
											(d(n, 'i18n') || (t && d(t, 'i18n')) || l).call(s, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.totp.aria.cannotScan' },
												data: i,
												loc: { start: { line: 1, column: 490 }, end: { line: 1, column: 549 } },
											})
										) +
										'">' +
										c(
											(d(n, 'i18n') || (t && d(t, 'i18n')) || l).call(s, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.totp.cannotScan' },
												data: i,
												loc: { start: { line: 1, column: 551 }, end: { line: 1, column: 604 } },
											})
										) +
										'</a><a href="#" data-type="refresh-qrcode" data-se="refresh-qrcode" class="link refresh-qrcode">' +
										c(
											(d(n, 'i18n') || (t && d(t, 'i18n')) || l).call(s, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.totp.refreshBarcode' },
												data: i,
												loc: { start: { line: 1, column: 700 }, end: { line: 1, column: 757 } },
											})
										) +
										'</a></div>'
									);
								},
								useData: !0,
							}),
							events: {
								'click [data-type="manual-setup"]': function (e) {
									var t = this;
									e.preventDefault();
									var n = l.default.createActivateFactorUrl(
										this.model.get('__provider__'),
										this.model.get('__factorType__'),
										'manual'
									);
									'push' === this.model.get('__factorType__')
										? this.model
												.doTransaction(function (e) {
													return e.prev().then(function (e) {
														return a._.findWhere(e.factors, { factorType: 'push', provider: 'OKTA' }).enroll();
													});
												})
												.then(function () {
													t.options.appState.trigger('navigate', n);
												})
										: this.options.appState.trigger('navigate', n);
								},
								'click [data-type="refresh-qrcode"]': function (e) {
									e.preventDefault(), this.model.trigger('errors:clear');
									var t = this;
									this.model
										.doTransaction(function (e) {
											return this.appState.get('isWaitingForActivation') ? e.poll() : e.activate();
										})
										.then(function (e) {
											var n = e.data;
											('MFA_ENROLL_ACTIVATE' !== n.status && 'FACTOR_ENROLL_ACTIVATE' !== n.status) ||
												'WAITING' !== n.factorResult ||
												a._.defer(a._.bind(t.render, t));
										});
								},
							},
							initialize: function () {
								this.listenTo(this.options.appState, 'change:lastAuthResponse', function () {
									this.options.appState.get('isMfaEnrollActivate')
										? this.$el.toggleClass('qrcode-expired', !this.options.appState.get('isWaitingForActivation'))
										: this.options.appState.get('isSuccessResponse') && this.$el.addClass('qrcode-success');
								}),
									this.listenTo(this.model, 'error', function () {
										this.options.appState.get('isMfaEnrollActivate') && this.$el.toggleClass('qrcode-expired', !0);
									});
							},
							getTemplateData: function () {
								var e = s.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
								return {
									instructions:
										'GOOGLE' === this.model.get('__provider__')
											? (0, a.loc)('enroll.totp.setupGoogleAuthApp', 'login', [e])
											: (0, a.loc)('enroll.totp.setupApp', 'login', [e]),
									qrcode: this.options.appState.get('qrcode'),
									altQRCode: (0, a.loc)('mfa.altQrCode', 'login'),
								};
							},
						});
					(t.default = u), (e.exports = t.default);
				},
				21304: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(2645)),
						a = r(n(39694)),
						s = r(n(90570)),
						l = r(n(50160)),
						u = {
							title: function () {
								var e = i.default.getFactorLabel(this.model.get('__provider__'), this.model.get('__factorType__'));
								return (0, o.loc)('enroll.totp.title', 'login', [e]);
							},
							subtitle: o._.partial(o.loc, 'enroll.totp.enterCode', 'login'),
							autoSave: !0,
							noButtonBar: !0,
							attributes: { 'data-se': 'step-sendcode' },
							formChildren: function () {
								return [
									a.default.Input({
										'label': (0, o.loc)('mfa.challenge.enterCode.placeholder', 'login'),
										'label-top': !0,
										'explain': s.default.createInputExplain(
											'mfa.challenge.enterCode.tooltip',
											'mfa.challenge.enterCode.placeholder',
											'login'
										),
										'explain-top': !0,
										'name': 'passCode',
										'input': l.default,
										'type': 'tel',
									}),
									a.default.Toolbar({ noCancelButton: !0, save: (0, o.loc)('oform.verify', 'login') }),
								];
							},
						};
					(t.default = u), (e.exports = t.default);
				},
				68457: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(35546)),
						s = i.View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<a href="#" class="link help js-back" data-se="back-link">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'mfa.backToFactors' },
													data: o,
													loc: { start: { line: 1, column: 58 }, end: { line: 1, column: 106 } },
												}
											)
										) +
										'</a>'
									);
								},
								useData: !0,
							}),
							className: 'auth-footer',
							events: {
								'click .js-back': function (e) {
									e.preventDefault(), this.options.appState.trigger('backToFactors'), this.back();
								},
							},
							back: function () {
								this.state.set('navigateDir', a.default.DIRECTION_BACK),
									this.options.appState.get('prevLink')
										? this.model.doTransaction(function (e) {
												return e.prev();
										  })
										: this.options.appState.trigger('navigate', 'signin/enroll');
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				89104: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(35546)),
						s = i.View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i = null != t ? t : e.nullContext || {},
										a = e.hooks.helperMissing,
										s = e.escapeExpression,
										l =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<a href="#" class="link help js-back" data-se="back-link">' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'mfa.backToFactors' },
												data: o,
												loc: { start: { line: 1, column: 58 }, end: { line: 1, column: 106 } },
											})
										) +
										'</a><a href="#" class="link help goto js-goto" data-se="goto-link">' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'mfa.scanBarcode' },
												data: o,
												loc: { start: { line: 1, column: 173 }, end: { line: 1, column: 219 } },
											})
										) +
										'</a>'
									);
								},
								useData: !0,
							}),
							className: 'auth-footer',
							events: {
								'click .js-back': function (e) {
									e.preventDefault(), this.back();
								},
								'click .js-goto': function (e) {
									e.preventDefault(),
										this.model.startTransaction(function (e) {
											return e.tx.resume();
										});
								},
							},
							back: function () {
								this.state.set('navigateDir', a.default.DIRECTION_BACK),
									this.options.appState.get('prevLink')
										? this.model.doTransaction(function (e) {
												return e.prev();
										  })
										: this.options.appState.trigger('navigate', 'signin/enroll');
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				4940: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(39409));
					function s(e) {
						var t = a.default.createActivateFactorUrl(e.get('activatedFactorProvider'), e.get('activatedFactorType'));
						e.trigger('navigate', t);
					}
					var l = i.View.extend({
						template: o.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i = null != t ? t : e.nullContext || {},
									a = e.hooks.helperMissing,
									s = e.escapeExpression,
									l =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<a href="#" class="link help js-back" data-se="back-link">' +
									s(
										(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'mfa.backToFactors' },
											data: o,
											loc: { start: { line: 1, column: 58 }, end: { line: 1, column: 106 } },
										})
									) +
									'</a><a href="#" class="link help goto js-goto" data-se="goto-link">' +
									s(
										(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'mfa.scanBarcode' },
											data: o,
											loc: { start: { line: 1, column: 173 }, end: { line: 1, column: 219 } },
										})
									) +
									'</a>'
								);
							},
							useData: !0,
						}),
						className: 'auth-footer',
						events: {
							'click .js-back': function (e) {
								e.preventDefault(), this.back();
							},
							'click .js-goto': function (e) {
								e.preventDefault();
								var t = i._.partial(s, this.options.appState);
								this.options.appState.unset('factorActivationType'),
									this.model
										.doTransaction(function (e) {
											return e.prev().then(function (e) {
												return i._.findWhere(e.factors, { factorType: 'push', provider: 'OKTA' }).enroll();
											});
										})
										.then(t);
							},
						},
						back: function () {
							var e = this;
							e.options.appState.unset('factorActivationType'),
								e.options.appState.get('prevLink')
									? this.model
											.doTransaction(function (e) {
												return e.prev();
											})
											.then(function () {
												e.options.appState.trigger('navigate', 'signin/enroll');
											})
									: e.options.appState.trigger('navigate', 'signin/enroll');
						},
					});
					(t.default = l), (e.exports = t.default);
				},
				39838: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = r(n(90570)),
						l = a.internal.views.forms.inputs.TextBox.extend({
							template: i.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<span class="okta-form-label-inline o-form-label-inline">' +
										c(
											((a =
												null != (a = d(n, 'countryCallingCode') || (null != t ? d(t, 'countryCallingCode') : t))
													? a
													: l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'countryCallingCode',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 57 }, end: { line: 1, column: 79 } },
												  })
												: a)
										) +
										'</span><span class="okta-form-input-field input-fix o-form-control"><input type="' +
										c(
											((a = null != (a = d(n, 'type') || (null != t ? d(t, 'type') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'type',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 160 }, end: { line: 1, column: 168 } },
												  })
												: a)
										) +
										'" placeholder="' +
										c(
											((a = null != (a = d(n, 'placeholder') || (null != t ? d(t, 'placeholder') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'placeholder',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 183 }, end: { line: 1, column: 198 } },
												  })
												: a)
										) +
										'" name="' +
										c(
											((a = null != (a = d(n, 'name') || (null != t ? d(t, 'name') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'name',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 206 }, end: { line: 1, column: 214 } },
												  })
												: a)
										) +
										'" id="' +
										c(
											((a = null != (a = d(n, 'inputId') || (null != t ? d(t, 'inputId') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'inputId',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 220 }, end: { line: 1, column: 231 } },
												  })
												: a)
										) +
										'" value="' +
										c(
											((a = null != (a = d(n, 'value') || (null != t ? d(t, 'value') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'value',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 240 }, end: { line: 1, column: 249 } },
												  })
												: a)
										) +
										'" autocomplete="' +
										c(
											((a = null != (a = d(n, 'autocomplete') || (null != t ? d(t, 'autocomplete') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'autocomplete',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 265 }, end: { line: 1, column: 281 } },
												  })
												: a)
										) +
										'"></span>'
									);
								},
								useData: !0,
							}),
							initialize: function () {
								this.listenTo(this.model, 'change:countryCallingCode', function () {
									this.$('.o-form-label-inline').text(this.model.get('countryCallingCode'));
								});
							},
							preRender: function () {
								(this.options.countryCallingCode = this.model.get('countryCallingCode')),
									(this.options.autocomplete = s.default.getAutocompleteValue(this.options.model.settings, 'tel'));
							},
							postRender: function () {
								var e = this;
								this.$el.removeClass('input-fix o-form-control'),
									a._.defer(function () {
										e.$el.parent().addClass('o-form-input-group');
									});
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				80549: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(51730)),
						s = r(n(37197)),
						l = i.Form.extend({
							layout: 'o-form-theme',
							autoSave: !0,
							noCancelButton: !0,
							title: function () {
								return (0, i.loc)('registration.form.title', 'login');
							},
							save: function () {
								return (0, i.loc)('registration.form.submit', 'login');
							},
							initialize: function (e) {
								var t = this;
								(this.options = e || {}),
									(this.schema = new a.default({
										profileSchemaAttributes: this.options.appState.get('policy').registration.profile,
									})),
									this.schema.properties.each(function (e) {
										var n = s.default.createInputOptions(e);
										t.addInput(n);
									});
								var n = o.default.template({
									compiler: [8, '>= 4.3.0'],
									main: function (e, t, n, r, o) {
										var i,
											a =
												e.lookupProperty ||
												function (e, t) {
													if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
												};
										return (
											'<span class="required-fields-label">' +
											e.escapeExpression(
												'function' ==
													typeof (i =
														null != (i = a(n, 'label') || (null != t ? a(t, 'label') : t)) ? i : e.hooks.helperMissing)
													? i.call(null != t ? t : e.nullContext || {}, {
															name: 'label',
															hash: {},
															data: o,
															loc: { start: { line: 1, column: 36 }, end: { line: 1, column: 45 } },
													  })
													: i
											) +
											'</span>'
										);
									},
									useData: !0,
								})({ label: (0, i.loc)('registration.required.fields.label', 'login') });
								this.add(n);
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				84977: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(35546)),
						s = i.internal.util.Util,
						l = i.View.extend({
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<a href="#" class="link help js-skip" data-se="skip-link">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'password.expiring.later' },
													data: o,
													loc: { start: { line: 1, column: 78 }, end: { line: 1, column: 132 } },
												}
											)
										) +
										'</a>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'passwordWarn') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 143 } },
										}))
											? i
											: '') +
										'<a href="#" class="link help goto js-signout" data-se="signout-link">' +
										e.escapeExpression(
											(s(n, 'i18n') || (t && s(t, 'i18n')) || e.hooks.helperMissing).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'signout' },
												data: o,
												loc: { start: { line: 1, column: 212 }, end: { line: 1, column: 250 } },
											})
										) +
										'</a>'
									);
								},
								useData: !0,
							}),
							className: 'auth-footer clearfix',
							events: {
								'click .js-signout': function (e) {
									e.preventDefault();
									var t = this,
										n = t.settings.getAuthClient();
									this.model
										.doTransaction(function (e) {
											return e.cancel();
										})
										.then(function () {
											return n.session.exists();
										})
										.then(function (e) {
											if (e) return n.closeSession().catch(function () {});
										})
										.then(function () {
											t.settings.get('backToSignInUri')
												? s.redirect(t.settings.get('backToSignInUri'))
												: (t.state.set('navigateDir', a.default.DIRECTION_BACK),
												  t.options.appState.trigger('navigate', ''));
										});
								},
								'click .js-skip': function (e) {
									e.preventDefault(),
										this.model.doTransaction(function (e) {
											return e.skip();
										});
								},
							},
							getTemplateData: function () {
								return { passwordWarn: this.options.appState.get('isPwdExpiringSoon') };
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				96823: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(6321)),
						a = r(n(35546)),
						s = o.Form.extend({
							layout: 'o-form-theme',
							className: 'factor-verify-magiclink',
							autoSave: !0,
							noCancelButton: !0,
							initialize: function () {
								var e = this;
								this.title = this.model.get('factorLabel');
								var t =
									this.model.get('email') || this.options.appState.get('lastAuthResponse')._embedded.user.profile.login;
								(this.subtitle = '(' + t + ')'),
									this.add(
										(0, o.createButton)({
											attributes: { 'data-se': 'email-send-code' },
											className: 'button email-request-button',
											title: (0, o.loc)('mfa.sendEmail', 'login'),
											click: function () {
												var t = this;
												e.clearErrors(),
													this.disable(),
													(this.options.title = (0, o.loc)('mfa.sent', 'login')),
													this.render(),
													this.model
														.save()
														.then(function () {
															return i.default.delay(a.default.API_RATE_LIMIT);
														})
														.then(function () {
															(t.options.title = (0, o.loc)('mfa.resendEmail', 'login')), t.enable(), t.render();
														});
											},
										})
									);
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				69834: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(25708)).default.extend({
							className: 'idp-discovery-form',
							save: function () {
								return (0, o.loc)('oform.next', 'login');
							},
							saveId: 'idp-discovery-submit',
							initialize: function () {
								this.listenTo(this, 'save', o._.bind(this.model.save, this.model)), this.stateEnableChange();
							},
							inputs: function () {
								var e = [],
									t = {
										className: 'margin-btm-30',
										label: (0, o.loc)('primaryauth.username.placeholder', 'login'),
										inputId: 'idp-discovery-username',
										disabled: !1,
									};
								return (
									e.push(o._.extend(this.getUsernameField(), t)),
									this.settings.get('features.rememberMe') && e.push(this.getRemeberMeCheckbox()),
									e
								);
							},
							focus: function () {
								this.model.get('username')
									? this.getInputs().toArray()[1] && this.getInputs().toArray()[1].focus()
									: this.getInputs().first().focus();
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				81824: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = o.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a,
									s =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<span class="icon error-24"></span><h4><strong>' +
									(null !=
									(i =
										'function' ==
										typeof (a =
											null != (a = s(n, 'message') || (null != t ? s(t, 'message') : t)) ? a : e.hooks.helperMissing)
											? a.call(null != t ? t : e.nullContext || {}, {
													name: 'message',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 47 }, end: { line: 1, column: 60 } },
											  })
											: a)
										? i
										: '') +
									'</strong></h4>'
								);
							},
							useData: !0,
						}),
						s = i.View.extend({
							template: a,
							className: 'okta-infobox-error infobox infobox-error infobox-md margin-btm-25',
							attributes: { 'data-se': 'o-form-error-html' },
							message: '',
							initialize: function (e) {
								e && e.message && (this.message = e.message);
							},
							getTemplateData: function () {
								return { message: this.message };
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				86139: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(50160));
					var a = o.Form.extend({
						autoSave: !0,
						noButtonBar: !0,
						scrollOnError: !1,
						layout: 'o-form-theme',
						className: 'mfa-verify-totp-inline',
						attributes: { 'data-se': 'factor-inline-totp' },
						initialize: function () {
							var e = this;
							this.listenTo(this.model, 'error', function () {
								this.clearErrors();
							}),
								this.add(
									(0, o.createButton)({
										className: 'link',
										attributes: { 'data-se': 'inline-totp-add' },
										title: (0, o.loc)('mfa.challenge.orEnterCode', 'login'),
										click: function () {
											this.remove(),
												(function (e) {
													e.addDivider(),
														e.addInput({
															'label': (0, o.loc)('mfa.challenge.enterCode.placeholder', 'login'),
															'label-top': !0,
															'className': 'o-form-fieldset o-form-label-top inline-input auth-passcode',
															'name': 'answer',
															'input': i.default,
															'type': 'tel',
														}),
														e.add(
															(0, o.createButton)({
																attributes: { 'data-se': 'inline-totp-verify' },
																className: 'button inline-totp-verify margin-top-30',
																title: (0, o.loc)('mfa.challenge.verify', 'login'),
																click: function () {
																	e.clearErrors(),
																		e.isValid() &&
																			e.model.manageTransaction(function (t, n) {
																				if ('MFA_CHALLENGE' === t.status && t.prev)
																					return (
																						e.options.appState.set('trapMfaRequiredResponse', !0),
																						t.prev().then(function (t) {
																							n(t), e.model.save();
																						})
																					);
																				e.model.save();
																			});
																},
															})
														),
														e.at(1).focus();
												})(e);
										},
									})
								);
						},
					});
					(t.default = a), (e.exports = t.default);
				},
				75166: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475).View.extend({
							className: 'number-challenge-view',
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p data-se="number-challenge-instruction">' +
										(null !=
										(i = (a(n, 'i18n') || (t && a(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: { arguments: 'number', bundle: 'login', code: 'oktaverify.numberchallenge.instruction' },
												data: o,
												loc: { start: { line: 1, column: 73 }, end: { line: 1, column: 163 } },
											}
										))
											? i
											: '') +
										'</p>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = e.escapeExpression,
										c =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = c(n, 'if').call(s, null != t ? c(t, 'number') : t, {
											name: 'if',
											hash: { includeZero: !0 },
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 174 } },
										}))
											? i
											: '') +
										'<div class="phone"><div class="phone--body"><div class="phone--screen"><span class="phone--number" data-se="challenge-number">' +
										u(
											'function' ==
												typeof (a = null != (a = c(n, 'number') || (null != t ? c(t, 'number') : t)) ? a : l)
												? a.call(s, {
														name: 'number',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 300 }, end: { line: 1, column: 310 } },
												  })
												: a
										) +
										'</span></div><div class="phone--home-button"></div></div></div><p>' +
										u(
											(c(n, 'i18n') || (t && c(t, 'i18n')) || l).call(s, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oktaverify.numberchallenge.explain' },
												data: o,
												loc: { start: { line: 1, column: 376 }, end: { line: 1, column: 441 } },
											})
										) +
										'</p>'
									);
								},
								useData: !0,
							}),
							initialize: function () {
								var e = this;
								this.listenTo(this.options.appState, 'change:isWaitingForNumberChallenge', function () {
									'SUCCESS' !== e.options.appState.get('lastAuthResponse').status && e.render();
								});
							},
							getTemplateData: function () {
								var e = this.options.appState.get('lastAuthResponse');
								return this.options.appState.get('isWaitingForNumberChallenge')
									? { number: e._embedded.factor._embedded.challenge.correctAnswer }
									: { number: null };
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				54311: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(6321)),
						s = r(n(35546)),
						l = r(n(50160)),
						u = o.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'(' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'subtitle') || (null != t ? a(t, 'subtitle') : t))
													? i
													: e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'subtitle',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 1 }, end: { line: 1, column: 13 } },
											  })
											: i
									) +
									')'
								);
							},
							useData: !0,
						}),
						c = i.View.extend({
							className: 'okta-form-infobox-warning infobox infobox-warning login-timeout-warning',
							attributes: { 'aria-live': 'polite' },
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a,
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<span class="icon warning-16"></span><p>' +
										(null !=
										(i =
											'function' ==
											typeof (a =
												null != (a = s(n, 'warning') || (null != t ? s(t, 'warning') : t)) ? a : e.hooks.helperMissing)
												? a.call(null != t ? t : e.nullContext || {}, {
														name: 'warning',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 40 }, end: { line: 1, column: 53 } },
												  })
												: a)
											? i
											: '') +
										'</p>'
									);
								},
								useData: !0,
							}),
						});
					function d(e) {
						switch (e) {
							case 'sms':
								return {
									buttonDataSe: 'sms-send-code',
									buttonClassName: 'sms-request-button',
									formSubmit: (0, i.loc)('mfa.sendCode', 'login'),
									formRetry: (0, i.loc)('mfa.resendCode', 'login'),
									formSubmitted: (0, i.loc)('mfa.sent', 'login'),
									subtitle: u({ subtitle: this.model.get('phoneNumber') }),
									warning: o.default.template({
										compiler: [8, '>= 4.3.0'],
										main: function (e, t, n, r, o) {
											var i =
												e.lookupProperty ||
												function (e, t) {
													if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
												};
											return e.escapeExpression(
												(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
													null != t ? t : e.nullContext || {},
													{
														name: 'i18n',
														hash: { $1: '<b>$1</b>', bundle: 'login', code: 'factor.sms.time.warning' },
														data: o,
														loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 70 } },
													}
												)
											);
										},
										useData: !0,
									}),
								};
							case 'call':
								return {
									buttonDataSe: 'make-call',
									buttonClassName: 'call-request-button',
									formSubmit: (0, i.loc)('mfa.call', 'login'),
									formRetry: (0, i.loc)('mfa.redial', 'login'),
									formSubmitted: (0, i.loc)('mfa.calling', 'login'),
									subtitle: u({ subtitle: this.model.get('phoneNumber') }),
									warning: o.default.template({
										compiler: [8, '>= 4.3.0'],
										main: function (e, t, n, r, o) {
											var i =
												e.lookupProperty ||
												function (e, t) {
													if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
												};
											return e.escapeExpression(
												(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
													null != t ? t : e.nullContext || {},
													{
														name: 'i18n',
														hash: { $1: '<b>$1</b>', bundle: 'login', code: 'factor.call.time.warning' },
														data: o,
														loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 71 } },
													}
												)
											);
										},
										useData: !0,
									}),
								};
							case 'email':
								return {
									buttonDataSe: 'email-send-code',
									buttonClassName: 'email-request-button',
									formSubmit: (0, i.loc)('mfa.sendEmail', 'login'),
									formRetry: (0, i.loc)('mfa.resendEmail', 'login'),
									formSubmitted: (0, i.loc)('mfa.sent', 'login'),
									subtitle: u({ subtitle: this.model.get('email') }),
								};
							default:
								return { buttonDataSe: '', buttonClassName: '', formSubmit: '', formRetry: '', formSubmitted: '' };
						}
					}
					var f = i.Form.extend({
						className: 'mfa-verify-passcode',
						autoSave: !0,
						noCancelButton: !0,
						save: i._.partial(i.loc, 'mfa.challenge.verify', 'login'),
						scrollOnError: !1,
						layout: 'o-form-theme',
						disableSubmitButton: function () {
							return this.model.appState.get('isMfaChallenge') && this.model.get('answer');
						},
						showWarning: function (e) {
							this.clearWarnings(), this.add(c, '.o-form-error-container', { options: { warning: e } });
						},
						clearWarnings: function () {
							this.$('.okta-form-infobox-warning').remove();
						},
						initialize: function () {
							var e = this;
							this.title = this.model.get('factorLabel');
							var t = this.model.get('factorType'),
								n = d.call(this, t),
								r = n.warning;
							this.$el.attr('data-se', 'factor-' + t),
								(this.subtitle = n.subtitle),
								this.listenTo(this.model, 'error', function () {
									this.clearErrors();
								}),
								this.addInput({
									'label': (0, i.loc)('mfa.challenge.enterCode.placeholder', 'login'),
									'label-top': !0,
									'className': 'o-form-fieldset o-form-label-top auth-passcode',
									'name': 'answer',
									'input': l.default,
									'type': 'tel',
								}),
								this.add(
									(0, i.createButton)({
										attributes: { 'data-se': n.buttonDataSe },
										className: 'button ' + n.buttonClassName,
										title: n.formSubmit,
										click: function () {
											var o = this;
											e.clearErrors(),
												this.disable(),
												e.clearWarnings(),
												(this.options.title = n.formSubmitted),
												this.render(),
												this.model.set('answer', ''),
												this.model
													.save()
													.then(function () {
														return e.getInputs().first().render().focus(), a.default.delay(s.default.API_RATE_LIMIT);
													})
													.then(function () {
														(o.options.title = n.formRetry),
															o.enable(),
															('call' !== t && 'sms' !== t) || e.showWarning(r),
															o.render();
													});
										},
									})
								),
								this.options.appState.get('allowRememberDevice') &&
									this.addInput({
										'label': !1,
										'label-top': !0,
										'placeholder': this.options.appState.get('rememberDeviceLabel'),
										'className': 'margin-btm-0',
										'name': 'rememberDevice',
										'type': 'checkbox',
									});
						},
					});
					(t.default = f), (e.exports = t.default);
				},
				89274: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475),
						o = r.Form.extend({
							className: 'mfa-verify-password',
							autoSave: !0,
							noCancelButton: !0,
							save: r._.partial(r.loc, 'mfa.challenge.verify', 'login'),
							scrollOnError: !1,
							layout: 'o-form-theme',
							attributes: { 'data-se': 'factor-password' },
							initialize: function () {
								(this.title = this.model.get('factorLabel')),
									this.addInput({
										'label': (0, r.loc)('mfa.challenge.password.placeholder', 'login'),
										'label-top': !0,
										'className': 'auth-passcode',
										'name': 'password',
										'type': 'password',
										'params': { showPasswordToggle: !0 },
									}),
									this.options.appState.get('allowRememberDevice') &&
										this.addInput({
											'label': !1,
											'label-top': !0,
											'placeholder': this.options.appState.get('rememberDeviceLabel'),
											'className': 'margin-btm-0',
											'name': 'rememberDevice',
											'type': 'checkbox',
										});
							},
						});
					(t.default = o), (e.exports = t.default);
				},
				99423: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = r(n(90570)),
						l = r(n(75166)),
						u = i.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, i) {
								var a,
									s,
									l = null != t ? t : e.nullContext || {},
									u = e.hooks.helperMissing,
									c = 'function',
									d =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									e.escapeExpression(
										((s = null != (s = d(n, 'factorName') || (null != t ? d(t, 'factorName') : t)) ? s : u),
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'factorName',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 14 } },
											  })
											: s)
									) +
									' (' +
									(null !=
									((s = null != (s = d(n, 'deviceName') || (null != t ? d(t, 'deviceName') : t)) ? s : u),
									(a =
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'deviceName',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 16 }, end: { line: 1, column: 32 } },
											  })
											: s))
										? a
										: '') +
									')'
								);
							},
							useData: !0,
						}),
						c = a.View.extend({
							className: 'okta-form-infobox-warning infobox infobox-warning',
							attributes: { 'aria-live': 'polite' },
							template: i.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<span class="icon warning-16"></span><p>' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'warning') || (null != t ? a(t, 'warning') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'warning',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 40 }, end: { line: 1, column: 51 } },
												  })
												: i
										) +
										'</p>'
									);
								},
								useData: !0,
							}),
						}),
						d = a.Form.extend({
							className: 'mfa-verify-push',
							autoSave: !0,
							noCancelButton: !0,
							save: a._.partial(a.loc, 'oktaverify.send', 'login'),
							scrollOnError: !1,
							layout: 'o-form-theme',
							attributes: { 'data-se': 'factor-push' },
							events: { submit: 'submit' },
							initialize: function () {
								(this.enabled = !0),
									this.listenTo(this.options.appState, 'change:isMfaRejected', this.handleRejectStateChange),
									(this.numberChallengeView = this.add(l.default).last()),
									this.listenTo(this.options.appState, 'change:isWaitingForNumberChallenge', function (e, t) {
										t || 'SUCCESS' === this.options.appState.get('lastAuthResponse').status
											? (this.clearWarnings(), this.$el.find('.button').hide(), this.numberChallengeView.$el.show())
											: (this.numberChallengeView.$el.hide(), this.$el.find('.button').show());
									}),
									this.listenTo(this.options.appState, 'change:isMfaTimeout', function (e, t) {
										this.setSubmitState(t), t && this.showError((0, a.loc)('oktaverify.timeout', 'login'));
									}),
									this.listenTo(this.options.appState, 'change:isMfaRequired', function (e, t) {
										t && (this.clearErrors(), this.clearWarnings());
									}),
									(this.title = u({
										factorName: this.model.get('factorLabel'),
										deviceName: this.model.get('deviceName'),
									}));
							},
							setSubmitState: function (e) {
								var t = this.$el.find('.button'),
									n = this.$el.find('.accessibility-text');
								(this.enabled = e),
									e
										? (t.removeClass('link-button-disabled'),
										  t.prop('value', (0, a.loc)('oktaverify.send', 'login')),
										  t.prop('disabled', !1),
										  n && n.remove())
										: (t.addClass('link-button-disabled'),
										  t.prop('value', (0, a.loc)('oktaverify.sent', 'login')),
										  t.prop('disabled', !0),
										  this.add(
												"<span class='accessibility-text' role='alert'>".concat(
													(0, a.loc)('oktaverify.sent', 'login'),
													'</span>'
												)
										  ));
							},
							submit: function (e) {
								void 0 !== e && e.preventDefault(), this.enabled && (this.setSubmitState(!1), this.doSave());
							},
							postRender: function () {
								var e = this.options.appState.get('factorsPolicyInfo'),
									t = this.model.get('id');
								!!(this.settings.get('features.autoPush') && e && e[t]) &&
									e[t].autoPushEnabled &&
									(this.model.set('autoPush', !0), a._.defer(a._.bind(this.submit, this)));
							},
							doSave: function () {
								var e,
									t = this;
								this.clearErrors(),
									this.clearWarnings(),
									this.model.isValid() &&
										(this.listenToOnce(this.model, 'error', function () {
											this.setSubmitState(!0), this.clearWarnings(), clearTimeout(e);
										}),
										this.trigger('save', this.model),
										(e = s.default.callAfterTimeout(function () {
											t.options.appState.get('isWaitingForNumberChallenge') ||
												t.showWarning((0, a.loc)('oktaverify.warning', 'login'));
										}, 3e4)));
							},
							showError: function (e) {
								this.clearWarnings(), this.model.trigger('error', this.model, { responseJSON: { errorSummary: e } });
							},
							showWarning: function (e) {
								this.clearWarnings(), this.add(c, '.o-form-error-container', { options: { warning: e } });
							},
							clearWarnings: function () {
								this.$('.okta-form-infobox-warning').remove();
							},
							handleRejectStateChange: function (e, t) {
								t && (this.setSubmitState(t), this.setRejectedErrorMessage());
							},
							setRejectedErrorMessage: function () {
								'OKTA_VERIFY_UPGRADE_REQUIRED' === this.options.appState.get('lastAuthResponse').factorResultMessage
									? 'IOS' === this.options.appState.get('factor').profile.platform
										? this.showError((0, a.loc)('oktaverify.rejected.upgradeRequired.ios', 'login'))
										: this.showError((0, a.loc)('oktaverify.rejected.upgradeRequired.android', 'login'))
									: this.showError((0, a.loc)('oktaverify.rejected', 'login'));
							},
						});
					(t.default = d), (e.exports = t.default);
				},
				39877: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475),
						o = r.Form.extend({
							className: 'mfa-verify-question',
							autoSave: !0,
							noCancelButton: !0,
							save: r._.partial(r.loc, 'mfa.challenge.verify', 'login'),
							scrollOnError: !1,
							layout: 'o-form-theme',
							attributes: { 'data-se': 'factor-question' },
							initialize: function () {
								(this.title = this.model.get('factorLabel')),
									this.addInput({
										'label': this.model.get('securityQuestion'),
										'label-top': !0,
										'placeholder': (0, r.loc)('mfa.challenge.answer.placeholder', 'login'),
										'className': 'auth-passcode',
										'name': 'answer',
										'type': 'password',
										'params': { showPasswordToggle: !0 },
									}),
									this.options.appState.get('allowRememberDevice') &&
										this.addInput({
											'label': !1,
											'label-top': !0,
											'placeholder': this.options.appState.get('rememberDeviceLabel'),
											'className': 'margin-btm-0',
											'name': 'rememberDevice',
											'type': 'checkbox',
										});
							},
						});
					(t.default = o), (e.exports = t.default);
				},
				83344: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(53292)),
						s = r(n(50160)),
						l = function () {
							var e = this.model.get('email');
							return {
								factorEmail: o.default.template({
									compiler: [8, '>= 4.3.0'],
									main: function (e, t, n, r, o) {
										var i,
											a =
												e.lookupProperty ||
												function (e, t) {
													if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
												};
										return (
											'<span class="mask-email">' +
											e.escapeExpression(
												'function' ==
													typeof (i =
														null != (i = a(n, 'email') || (null != t ? a(t, 'email') : t)) ? i : e.hooks.helperMissing)
													? i.call(null != t ? t : e.nullContext || {}, {
															name: 'email',
															hash: {},
															data: o,
															loc: { start: { line: 1, column: 25 }, end: { line: 1, column: 34 } },
													  })
													: i
											) +
											'</span>'
										);
									},
									useData: !0,
								})({ email: e }),
							};
						},
						u = i.Form.extend({
							layout: 'o-form-theme',
							className: 'mfa-verify-email',
							title: i._.partial(i.loc, 'email.mfa.title', 'login'),
							noButtonBar: !1,
							autoSave: !0,
							noCancelButton: !0,
							attributes: { 'data-se': 'factor-email' },
							save: function () {
								return this.options.appState.get('isMfaChallenge')
									? (0, i.loc)('mfa.challenge.verify', 'login')
									: (0, i.loc)('email.button.send', 'login');
							},
							events: Object.assign({}, i.Form.prototype.events, {
								submit: function (e) {
									e.preventDefault(), this.handleSubmit();
								},
							}),
							handleSubmit: function () {
								this.clearErrors(),
									this.options.appState.get('isMfaChallenge')
										? this.isValid() && this.model.save()
										: (this.model.set('answer', ''), this.model.save().then(this.renderChallengView.bind(this)));
							},
							initialize: function () {
								i.Form.prototype.initialize.apply(this, arguments),
									this.add(
										i.View.extend({
											attributes: { 'data-se': 'mfa-send-email-content' },
											className: 'mfa-send-email-content',
											template: o.default.template({
												compiler: [8, '>= 4.3.0'],
												main: function (e, t, n, r, o) {
													var i,
														a =
															e.lookupProperty ||
															function (e, t) {
																if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
															};
													return null !=
														(i = (a(n, 'i18n') || (t && a(t, 'i18n')) || e.hooks.helperMissing).call(
															null != t ? t : e.nullContext || {},
															{
																name: 'i18n',
																hash: { arguments: 'factorEmail', bundle: 'login', code: 'email.mfa.description' },
																data: o,
																loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 78 } },
															}
														))
														? i
														: '';
												},
												useData: !0,
											}),
											getTemplateData: l,
										})
									);
							},
							renderChallengView: function () {
								this.removeChildren(),
									this.add(
										i.View.extend({
											className: 'mfa-email-sent-content',
											attributes: { 'data-se': 'mfa-email-sent-content' },
											template: o.default.template({
												compiler: [8, '>= 4.3.0'],
												main: function (e, t, n, r, o) {
													var i,
														a =
															e.lookupProperty ||
															function (e, t) {
																if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
															};
													return null !=
														(i = (a(n, 'i18n') || (t && a(t, 'i18n')) || e.hooks.helperMissing).call(
															null != t ? t : e.nullContext || {},
															{
																name: 'i18n',
																hash: {
																	arguments: 'factorEmail',
																	bundle: 'login',
																	code: 'email.mfa.email.sent.description',
																},
																data: o,
																loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 89 } },
															}
														))
														? i
														: '';
												},
												useData: !0,
											}),
											getTemplateData: l,
										})
									),
									this.add(a.default),
									this.addInput({
										'label': (0, i.loc)('email.code.label', 'login'),
										'label-top': !0,
										'name': 'answer',
										'input': s.default,
										'wide': !0,
										'type': 'tel',
									}),
									this.options.appState.get('allowRememberDevice') &&
										this.addInput({
											'label': !1,
											'label-top': !0,
											'placeholder': this.options.appState.get('rememberDeviceLabel'),
											'className': 'margin-btm-0',
											'name': 'rememberDevice',
											'type': 'checkbox',
										}),
									this.render();
							},
						}),
						c = u;
					(t.default = c), (e.exports = t.default);
				},
				61174: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(50160)),
						a = o.Form.extend({
							className: 'mfa-verify-totp',
							autoSave: !0,
							noCancelButton: !0,
							save: o._.partial(o.loc, 'mfa.challenge.verify', 'login'),
							scrollOnError: !1,
							layout: 'o-form-theme',
							attributes: { 'data-se': 'factor-totp' },
							initialize: function () {
								var e = this,
									t = this.model.get('factorLabel'),
									n = 'RSA' === this.model.get('provider') || 'DEL_OATH' === this.model.get('provider');
								(this.title = t),
									this.model.get('isFactorTypeVerification')
										? (this.subtitle = (0, o.loc)('mfa.challenge.totp.subtitle.multiple', 'login', [t]))
										: (this.subtitle = (0, o.loc)('mfa.challenge.title', 'login', [t])),
									this.addInput({
										'label': (0, o.loc)('mfa.challenge.enterCode.placeholder', 'login'),
										'label-top': !0,
										'className': 'o-form-fieldset o-form-label-top auth-passcode',
										'name': 'answer',
										'input': i.default,
										'type': n ? 'password' : 'tel',
									}),
									this.options.appState.get('allowRememberDevice') &&
										this.addInput({
											'label': !1,
											'label-top': !0,
											'placeholder': this.options.appState.get('rememberDeviceLabel'),
											'className': 'margin-btm-0',
											'name': 'rememberDevice',
											'type': 'checkbox',
										}),
									('RSA' !== this.model.get('provider') && 'DEL_OATH' !== this.model.get('provider')) ||
										this.listenTo(this.model, 'error', function (t, n) {
											n &&
												409 === n.status &&
												(e.$('.auth-passcode input').val(''),
												e.$('.auth-passcode input').trigger('change'),
												e.$('.auth-passcode input').focus());
										});
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				27797: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(50160)),
						a = o.Form.extend({
							className: 'mfa-verify-yubikey',
							autoSave: !0,
							noCancelButton: !0,
							save: o._.partial(o.loc, 'mfa.challenge.verify', 'login'),
							scrollOnError: !1,
							layout: 'o-form-theme',
							attributes: { 'data-se': 'factor-yubikey' },
							initialize: function () {
								var e = this.model.get('factorLabel');
								(this.title = e),
									(this.subtitle = (0, o.loc)('factor.totpHard.yubikey.description', 'login')),
									this.addInput({
										'label': (0, o.loc)('factor.totpHard.yubikey.placeholder', 'login'),
										'label-top': !0,
										'className': 'o-form-fieldset o-form-label-top auth-passcode',
										'name': 'answer',
										'input': i.default,
										'inputId': 'mfa-answer',
										'type': 'password',
									}),
									this.options.appState.get('allowRememberDevice') &&
										this.addInput({
											'label': !1,
											'label-top': !0,
											'className': 'margin-btm-0',
											'placeholder': this.options.appState.get('rememberDeviceLabel'),
											'name': 'rememberDevice',
											'type': 'checkbox',
										});
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				75422: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(2645)),
						a = r(n(15073)),
						s = r(n(2726)),
						l = o.internal.views.components.BaseDropDown;
					(0, o.$)(document).click(function (e) {
						var t = (0, o.$)(e.target);
						(t.closest('.option-selected').length > 0 && t.closest('.dropdown').length > 0) ||
							((0, o.$)('.dropdown .options').hide(),
							(0, o.$)('.dropdown a.option-selected').attr('aria-expanded', !1));
					});
					var u = l.extend({
						className: 'bg-helper icon-button',
						screenReaderText: function () {
							var e,
								t = this.options.appState.get('factors');
							return (
								(e = (
									t
										? i.default.findFactorInFactorsArray(t, this.options.provider, this.options.factorType)
										: new a.default.Model(this.options.appState.get('factor'), this.toJSON())
								).get('factorLabel')),
								(0, o.loc)('mfa.factors.dropdown.sr.text', 'login', [e])
							);
						},
						events: {
							'click a.option-selected': function (e) {
								if ((e.preventDefault(), o._.result(this, 'disabled'))) e.stopPropagation();
								else {
									var t = this.$('.options').toggle().is(':visible');
									this.$('a.option-selected').attr('aria-expanded', t),
										t && this.$('#okta-dropdown-options').find('li.factor-option:first a').focus();
								}
							},
							'click .dropdown-disabled': function (e) {
								e.preventDefault(), e.stopPropagation();
							},
						},
						initialize: function () {
							this.addOption(s.default.getDropdownOption('TITLE'));
							var e = this.options.appState.get('factors'),
								t = e.hasMultipleFactorsOfSameType('push');
							e.each(function (e) {
								('token:software:totp' === e.get('factorType') && t) ||
									(this.addOption(s.default.getDropdownOption(e.get('factorName')), { model: e }),
									this.listenTo(this.last(), 'options:toggle', function () {
										this.$('.options').hide(), this.$('a.option-selected').attr('aria-expanded', !1);
									}));
							}, this);
						},
					});
					(t.default = u), (e.exports = t.default);
				},
				2726: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = r(n(39409)),
						l = i.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, i) {
								var a,
									s,
									l = null != t ? t : e.nullContext || {},
									u = e.hooks.helperMissing,
									c = 'function',
									d =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									e.escapeExpression(
										((s = null != (s = d(n, 'factorName') || (null != t ? d(t, 'factorName') : t)) ? s : u),
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'factorName',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 14 } },
											  })
											: s)
									) +
									' (' +
									(null !=
									((s = null != (s = d(n, 'deviceName') || (null != t ? d(t, 'deviceName') : t)) ? s : u),
									(a =
										(0, o.default)(s) === c
											? s.call(l, {
													name: 'deviceName',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 16 }, end: { line: 1, column: 32 } },
											  })
											: s))
										? a
										: '') +
									')'
								);
							},
							useData: !0,
						}),
						u = function (e) {
							var t,
								n = e.get('factorType'),
								r = this.options.appState.get('factors');
							r.hasMultipleFactorsOfSameType(n) && (t = r.getFactorIndex(n, e.get('id')));
							var o = s.default.createVerifyUrl(e.get('provider'), n, t),
								i = this;
							this.options.appState.trigger('factorSwitched'),
								this.model.manageTransaction(function (e, t) {
									if (
										('FACTOR_CHALLENGE' === e.status && this.options.appState.set('trapMfaRequiredResponse', !0),
										'MFA_CHALLENGE' === e.status && e.prev)
									)
										return (
											this.options.appState.set('trapMfaRequiredResponse', !0),
											e.prev().then(function (e) {
												i.trigger('options:toggle'), t(e), i.options.appState.trigger('navigate', o);
											})
										);
									i.trigger('options:toggle'), i.options.appState.trigger('navigate', o);
								});
						},
						c = {
							TITLE: {
								title: a._.partial(a.loc, 'mfa.factors.dropdown.title', 'login'),
								className: 'dropdown-list-title',
								disabled: !0,
							},
							OKTA_VERIFY: {
								icon: 'factor-icon mfa-okta-verify-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							OKTA_VERIFY_PUSH: {
								icon: 'factor-icon mfa-okta-verify-30',
								className: 'factor-option',
								title: function () {
									return l({ factorName: this.model.get('factorLabel'), deviceName: this.model.get('deviceName') });
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							GOOGLE_AUTH: {
								icon: 'factor-icon mfa-google-auth-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							CUSTOM_HOTP: {
								icon: 'factor-icon mfa-hotp-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							SYMANTEC_VIP: {
								icon: 'factor-icon mfa-symantec-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							RSA_SECURID: {
								icon: 'factor-icon mfa-rsa-30',
								className: 'factor-option',
								title: a._.partial(a.loc, 'factor.totpHard.rsaSecurId', 'login'),
								action: function () {
									u.call(this, this.model);
								},
							},
							ON_PREM: {
								icon: 'factor-icon mfa-onprem-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							DUO: {
								icon: 'factor-icon mfa-duo-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							DUO_PUSH: {
								icon: 'duo-push-16',
								className: 'suboption factor-option',
								title: a._.partial(a.loc, 'mfa.duoSecurity.push', 'login', ['XXX-XXX-7890']),
							},
							DUO_SMS: {
								icon: 'duo-sms-16',
								className: 'suboption factor-option',
								title: a._.partial(a.loc, 'mfa.duoSecurity.sms', 'login', ['XXX-XXX-7890']),
							},
							DUO_CALL: {
								icon: 'duo-call-16',
								className: 'suboption factor-option',
								title: a._.partial(a.loc, 'mfa.duoSecurity.call', 'login', ['XXX-XXX-7890']),
							},
							YUBIKEY: {
								icon: 'factor-icon mfa-yubikey-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							SMS: {
								icon: 'factor-icon mfa-sms-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							CALL: {
								icon: 'factor-icon mfa-call-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							QUESTION: {
								icon: 'factor-icon mfa-question-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							PASSWORD: {
								icon: 'factor-icon mfa-password-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							WINDOWS_HELLO: {
								icon: 'factor-icon mfa-windows-hello-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							U2F: {
								icon: 'factor-icon mfa-u2f-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							WEBAUTHN: {
								icon: 'factor-icon mfa-webauthn-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							EMAIL: {
								icon: 'factor-icon mfa-email-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							GENERIC_SAML: {
								icon: 'factor-icon mfa-custom-factor-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							GENERIC_OIDC: {
								icon: 'factor-icon mfa-custom-factor-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
							CUSTOM_CLAIMS: {
								icon: 'factor-icon mfa-custom-factor-30',
								className: 'factor-option',
								title: function () {
									return this.model.get('factorLabel');
								},
								action: function () {
									u.call(this, this.model);
								},
							},
						},
						d = {
							getDropdownOption: function (e) {
								return c[e];
							},
						};
					(t.default = d), (e.exports = t.default);
				},
				65422: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(97329)),
						s = i.internal.util.Util,
						l = o.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<div class="auth-divider"><span class="auth-divider-text">' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'text') || (null != t ? a(t, 'text') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'text',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 58 }, end: { line: 1, column: 66 } },
											  })
											: i
									) +
									'</span></div>'
								);
							},
							useData: !0,
						}),
						u = o.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<h2 data-se="o-form-head" class="okta-form-title o-form-head">' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'title') || (null != t ? a(t, 'title') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'title',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 62 }, end: { line: 1, column: 71 } },
											  })
											: i
									) +
									'</h2>'
								);
							},
							useData: !0,
						}),
						c = i.View.extend({
							className: 'primary-auth-container',
							children: function () {
								var e = [],
									t = this.settings.get('configuredSocialIdps'),
									n = this.settings.get('piv'),
									r = this.settings.get('customButtons'),
									o = l({ text: (0, i.loc)('socialauth.divider.text', 'login') });
								return (
									this.settings.get('hasPivCard') && e.push(this._createPivButton(n)),
									i._.each(
										t,
										function (t) {
											e.push(this._createSocialIdpButton(t));
										},
										this
									),
									i._.each(
										r,
										function (t) {
											e.push(this._createCustomButton(t));
										},
										this
									),
									this.settings.get('socialAuthPositionTop')
										? (e.unshift(u({ title: (0, i.loc)('primaryauth.title', 'login') })), e.push(o))
										: e.unshift(o),
									e
								);
							},
							_createSocialIdpButton: function (e) {
								return (0, i.createButton)({
									attributes: { 'data-se': e.dataAttr },
									className: e.className,
									title: function () {
										return e.text || (0, i.loc)(e.i18nKey);
									},
									click: function (t) {
										if ((t.preventDefault(), this.settings.get('oauth2Enabled')))
											a.default.getTokens(this.settings, { idp: e.id }, this.options.currentController);
										else {
											var n,
												r = this.settings.get('baseUrl'),
												o = this.options.appState.get('lastAuthResponse');
											n = this.options.appState.get('usingDeviceFlow')
												? i.$.param({ stateToken: null == o ? void 0 : o.stateToken })
												: i.$.param({ fromURI: this.settings.get('relayState') });
											var l = ''.concat(r, '/sso/idps/').concat(e.id, '?').concat(n);
											s.redirect(l);
										}
									},
								});
							},
							_createPivButton: function (e) {
								var t = e.className || '';
								return (0, i.createButton)({
									attributes: { 'data-se': 'piv-card-button' },
									className: t + ' piv-button',
									title: e.text || (0, i.loc)('piv.cac.card', 'login'),
									click: function (e) {
										e.preventDefault(), this.options.appState.trigger('navigate', 'signin/verify/piv');
									},
								});
							},
							_createCustomButton: function (e) {
								return (0, i.createButton)({
									attributes: { 'data-se': e.dataAttr },
									className: e.className + ' default-custom-button',
									title: function () {
										return e.title || (0, i.loc)(e.i18nKey);
									},
									click: e.click,
								});
							},
						});
					(t.default = c), (e.exports = t.default);
				},
				25708: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(70232)),
						i = r(n(31049)),
						a = n(6475),
						s = r(n(75104)),
						l = r(n(73771)),
						u = r(n(90570)),
						c = r(n(50160)),
						d = a.Form.extend({
							className: 'primary-auth-form',
							noCancelButton: !0,
							attributes: { novalidate: 'novalidate' },
							save: function () {
								return this.settings.get('features.passwordlessAuth')
									? (0, a.loc)('oform.next', 'login')
									: (0, a.loc)('primaryauth.submit', 'login');
							},
							saveId: 'okta-signin-submit',
							layout: 'o-form-theme',
							title: function () {
								var e = (0, a.loc)('primaryauth.title', 'login');
								return this.settings.get('socialAuthPositionTop') && (e = ''), e;
							},
							initialize: function () {
								var e = this.settings.get('features.trackTypingPattern');
								this.listenTo(
									this,
									'save',
									(0, i.default)(
										o.default.mark(function t() {
											var n, r, i, a;
											return o.default.wrap(
												function (t) {
													for (;;)
														switch ((t.prev = t.next)) {
															case 0:
																return (
																	(n = this.options.appState),
																	e && ((r = l.default.getTypingPattern()), n.set('typingPattern', r)),
																	(i = { username: this.model.get('username') }),
																	this.settings.get('features.passwordlessAuth') ||
																		(i.password = this.model.get('password')),
																	n.trigger('loading', !0),
																	this.state.trigger('togglePrimaryAuthButton', !0),
																	(t.next = 8),
																	this.settings.processCreds(i)
																);
															case 8:
																if (!this.settings.get('features.deviceFingerprinting')) {
																	t.next = 18;
																	break;
																}
																return (
																	(t.prev = 9),
																	(t.next = 12),
																	s.default.generateDeviceFingerprint(this.settings.getAuthClient(), this.$el[0])
																);
															case 12:
																(a = t.sent), n.set('deviceFingerprint', a), (t.next = 18);
																break;
															case 16:
																(t.prev = 16), (t.t0 = t.catch(9));
															case 18:
																this.model.save();
															case 19:
															case 'end':
																return t.stop();
														}
												},
												t,
												this,
												[[9, 16]]
											);
										})
									)
								),
									this.stateEnableChange(),
									this.stateUsernameChange();
							},
							stateEnableChange: function () {
								this.listenTo(this.state, 'change:enabled', function (e, t) {
									t ? this.enable() : this.disable();
								});
							},
							stateUsernameChange: function () {
								this.listenTo(this.state, 'change:disableUsername', function (e, t) {
									t
										? this.$el.find('#okta-signin-username').attr('disabled', !0)
										: this.$el.find('#okta-signin-username').removeAttr('disabled');
								});
							},
							inputs: function () {
								var e = [];
								return (
									e.push(this.getUsernameField()),
									this.settings.get('features.passwordlessAuth') || e.push(this.getPasswordField()),
									this.settings.get('features.rememberMe') && e.push(this.getRemeberMeCheckbox()),
									e
								);
							},
							getUsernameField: function () {
								var e = this;
								return {
									'className': 'margin-btm-5',
									'label': (0, a.loc)('primaryauth.username.placeholder', 'login'),
									'label-top': !0,
									'explain': function () {
										return (
											!!e.isCustomized('primaryauth.username.tooltip') &&
											u.default.createInputExplain(
												'primaryauth.username.tooltip',
												'primaryauth.username.placeholder',
												'login'
											)
										);
									},
									'explain-top': !0,
									'name': 'username',
									'input': c.default,
									'inputId': 'okta-signin-username',
									'type': 'text',
									'disabled': this.options.appState.get('disableUsername'),
									'autoComplete': u.default.getAutocompleteValue(this.settings, 'username'),
									'render': function () {
										var e = this;
										function t() {
											e.$(this).removeAttr('aria-invalid').off('focusout', t).off('change', t);
										}
										this.$('input[name='.concat(this.options.name, ']'))
											.attr({ 'aria-invalid': 'false', 'aria-required': 'true' })
											.prop({ required: !0 })
											.focusout(t)
											.change(t);
									},
								};
							},
							getPasswordField: function () {
								var e = this,
									t = {
										'className': 'margin-btm-30',
										'label': (0, a.loc)('primaryauth.password.placeholder', 'login'),
										'label-top': !0,
										'explain': function () {
											return (
												!!e.isCustomized('primaryauth.password.tooltip') &&
												u.default.createInputExplain(
													'primaryauth.password.tooltip',
													'primaryauth.password.placeholder',
													'login'
												)
											);
										},
										'explain-top': !0,
										'name': 'password',
										'inputId': 'okta-signin-password',
										'validateOnlyIfDirty': !0,
										'type': 'password',
										'autoComplete': u.default.getAutocompleteValue(this.settings, 'current-password'),
										'render': function () {
											var e = this;
											function t() {
												e.$(this).removeAttr('aria-invalid').off('focusout', t).off('change', t);
											}
											this.$('input[name='.concat(this.options.name, ']'))
												.attr({ 'aria-invalid': 'false', 'aria-required': 'true' })
												.prop({ required: !0 })
												.focusout(t)
												.change(t);
										},
									};
								return (
									this.settings.get('features.showPasswordToggleOnSignInPage') &&
										((t.params = {}), (t.params.showPasswordToggle = !0)),
									t
								);
							},
							isCustomized: function (e) {
								var t = this.settings.get('language'),
									n = this.settings.get('i18n');
								return !!(n && n[t] && n[t][e]);
							},
							getRemeberMeCheckbox: function () {
								return {
									'label': !1,
									'placeholder': (0, a.loc)('remember', 'login'),
									'name': 'remember',
									'type': 'checkbox',
									'label-top': !0,
									'className': 'margin-btm-0',
									'initialize': function () {
										this.listenTo(this.model, 'change:remember', function (e, t) {
											this.$(':checkbox').prop('checked', t).trigger('updateState');
										});
									},
								};
							},
							focus: function () {
								this.model.get('username')
									? this.settings.get('features.passwordlessAuth') || this.getInputs().toArray()[1].focus()
									: this.getInputs().first().focus(),
									this.settings.get('features.trackTypingPattern') && l.default.track('okta-signin-username');
							},
						});
					(t.default = d), (e.exports = t.default);
				},
				41797: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = i.View.extend({
							index: '',
							message: '',
							class: function () {},
							className: function () {
								return 'subschema-unsatisfied subschema-' + this.index;
							},
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p class="default-schema"><span class="icon icon-16"></span>' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'message') || (null != t ? a(t, 'message') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'message',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 60 }, end: { line: 1, column: 71 } },
												  })
												: i
										) +
										'</p>'
									);
								},
								useData: !0,
							}),
							getTemplateData: function () {
								return { message: this.message };
							},
						}),
						s = i.View.extend({
							className: 'subschema',
							children: function () {
								return this.subSchemas.map(function (e, t) {
									var n = e.get('description');
									return a.extend({ index: t, message: n });
								});
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				84757: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(35546)),
						a = o.View.extend({
							tagName: 'main',
							className: 'auth-container main-container',
							id: i.default.WIDGET_CONTAINER_ID,
							attributes: { 'data-se': 'auth-container', 'tabindex': '-1' },
							initialize: function (e) {
								this.listenTo(e.appState, 'change:beaconType', function (e, t) {
									this.$el.toggleClass('can-remove-beacon', 'security' === t);
								});
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				17849: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475).View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<div class="infobox"><span class="icon info-16"></span><p>' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { arguments: 'helpSupportNumber', bundle: 'login', code: 'contact.support' },
													data: o,
													loc: { start: { line: 1, column: 58 }, end: { line: 1, column: 134 } },
												}
											)
										) +
										'</p></div>'
									);
								},
								useData: !0,
							}),
							className: 'contact-support',
							getTemplateData: function () {
								return this.settings.pick('helpSupportNumber');
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				20109: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(15073)),
						s = r(n(6321)),
						l = r(n(2645)),
						u = r(n(75422)),
						c = i.View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="beacon-blank auth-beacon"><div class="beacon-blank js-blank-beacon-border auth-beacon-border"></div></div><div class="bg-helper auth-beacon auth-beacon-factor ' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'className') || (null != t ? a(t, 'className') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'className',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 171 }, end: { line: 1, column: 184 } },
												  })
												: i
										) +
										'" data-se="factor-beacon"><div class="okta-sign-in-beacon-border auth-beacon-border"></div></div><div data-type="factor-types-dropdown" class="factors-dropdown-wrap"></div>'
									);
								},
								useData: !0,
							}),
							events: {
								'click .auth-beacon-factor': function (e) {
									e.preventDefault(), e.stopPropagation();
									var t = this.$('.dropdown .options').toggle().is(':visible');
									this.$('a.option-selected').attr('aria-expanded', t),
										t && this.$('#okta-dropdown-options').find('li.factor-option:first a').focus();
								},
							},
							initialize: function () {
								this.options.appState.set('beaconType', 'factor');
							},
							getTemplateData: function () {
								var e = this.options.appState.get('factors');
								return {
									className:
										(e
											? l.default.findFactorInFactorsArray(e, this.options.provider, this.options.factorType)
											: new a.default.Model(this.options.appState.get('factor'))
										).get('iconClassName') || '',
								};
							},
							postRender: function () {
								this.options.animate && this.$('.auth-beacon-factor').fadeIn(200),
									this.options.appState.get('hasMultipleFactorsAvailable') &&
										this.add(u.default, '[data-type="factor-types-dropdown"]');
							},
							fadeOut: function () {
								var e = s.default.defer();
								return (
									this.$('.auth-beacon-factor').fadeOut(200, function () {
										e.resolve();
									}),
									e.promise
								);
							},
							equals: function (e, t) {
								return (
									e &&
									this instanceof e &&
									t.provider === this.options.provider &&
									(t.factorType === this.options.factorType ||
										(l.default.isOktaVerify(t.provider, t.factorType) &&
											l.default.isOktaVerify(this.options.provider, this.options.factorType)))
								);
							},
						});
					(t.default = c), (e.exports = t.default);
				},
				89365: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = a.internal.util.Util,
						l = a.View.extend({
							template: i.default.template({
								1: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<li><a href="#" data-se="unlock" class="link js-unlock">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'unlockaccount' },
													data: o,
													loc: { start: { line: 1, column: 440 }, end: { line: 1, column: 484 } },
												}
											)
										) +
										'</a></li>'
									);
								},
								3: function (e, t, n, r, i) {
									var a,
										s,
										l = null != t ? t : e.nullContext || {},
										u = e.hooks.helperMissing,
										c = 'function',
										d = e.escapeExpression,
										f =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<li><a href="' +
										d(
											((s = null != (s = f(n, 'href') || (null != t ? f(t, 'href') : t)) ? s : u),
											(0, o.default)(s) === c
												? s.call(l, {
														name: 'href',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 539 }, end: { line: 1, column: 547 } },
												  })
												: s)
										) +
										'" class="link js-custom" rel="noopener noreferrer" ' +
										(null !=
										(a = f(n, 'if').call(l, null != t ? f(t, 'target') : t, {
											name: 'if',
											hash: {},
											fn: e.program(4, i, 0),
											inverse: e.noop,
											data: i,
											loc: { start: { line: 1, column: 598 }, end: { line: 1, column: 638 } },
										}))
											? a
											: '') +
										'>' +
										d(
											((s = null != (s = f(n, 'text') || (null != t ? f(t, 'text') : t)) ? s : u),
											(0, o.default)(s) === c
												? s.call(l, {
														name: 'text',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 639 }, end: { line: 1, column: 647 } },
												  })
												: s)
										) +
										'</a></li>'
									);
								},
								4: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'target="' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'target') || (null != t ? a(t, 'target') : t)) ? i : e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'target',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 620 }, end: { line: 1, column: 630 } },
												  })
												: i
										) +
										'"'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = e.escapeExpression,
										c =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<a href="#" data-se="needhelp" aria-expanded="false" aria-controls="help-links-container" class="link help js-help">' +
										u(
											(c(n, 'i18n') || (t && c(t, 'i18n')) || l).call(s, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'needhelp' },
												data: o,
												loc: { start: { line: 1, column: 116 }, end: { line: 1, column: 155 } },
											})
										) +
										'</a><ul class="help-links js-help-links" id="help-links-container"><li><a href="#" data-se="forgot-password" class="link js-forgot-password">' +
										u(
											(c(n, 'i18n') || (t && c(t, 'i18n')) || l).call(s, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'forgotpassword' },
												data: o,
												loc: { start: { line: 1, column: 296 }, end: { line: 1, column: 341 } },
											})
										) +
										'</a></li>' +
										(null !=
										(i = c(n, 'if').call(
											s,
											null != (i = null != t ? c(t, 'features') : t) ? c(i, 'selfServiceUnlock') : i,
											{
												name: 'if',
												hash: {},
												fn: e.program(1, o, 0),
												inverse: e.noop,
												data: o,
												loc: { start: { line: 1, column: 350 }, end: { line: 1, column: 500 } },
											}
										))
											? i
											: '') +
										(null !=
										(i = c(n, 'each').call(s, null != (i = null != t ? c(t, 'helpLinks') : t) ? c(i, 'custom') : i, {
											name: 'each',
											hash: {},
											fn: e.program(3, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 500 }, end: { line: 1, column: 665 } },
										}))
											? i
											: '') +
										'<li><a href="' +
										u(
											'function' ==
												typeof (a = null != (a = c(n, 'helpLinkUrl') || (null != t ? c(t, 'helpLinkUrl') : t)) ? a : l)
												? a.call(s, {
														name: 'helpLinkUrl',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 678 }, end: { line: 1, column: 693 } },
												  })
												: a
										) +
										'" data-se="help-link" class="link js-help-link" rel="noopener noreferrer" target="_blank">' +
										u(
											(c(n, 'i18n') || (t && c(t, 'i18n')) || l).call(s, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'help' },
												data: o,
												loc: { start: { line: 1, column: 783 }, end: { line: 1, column: 818 } },
											})
										) +
										'</a></li></ul>'
									);
								},
								useData: !0,
							}),
							className: 'auth-footer',
							initialize: function () {
								this.listenTo(this.state, 'change:enabled', function (e, t) {
									this.$('.link').toggleClass('o-form-disabled', !t);
								});
							},
							getTemplateData: function () {
								var e,
									t = this.settings.get('helpLinks.help');
								return (
									(e =
										t ||
										i.default.template({
											compiler: [8, '>= 4.3.0'],
											main: function (e, t, n, r, o) {
												var i,
													a =
														e.lookupProperty ||
														function (e, t) {
															if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
														};
												return (
													e.escapeExpression(
														'function' ==
															typeof (i =
																null != (i = a(n, 'baseUrl') || (null != t ? a(t, 'baseUrl') : t))
																	? i
																	: e.hooks.helperMissing)
															? i.call(null != t ? t : e.nullContext || {}, {
																	name: 'baseUrl',
																	hash: {},
																	data: o,
																	loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 11 } },
															  })
															: i
													) + '/help/login'
												);
											},
											useData: !0,
										})({ baseUrl: this.settings.get('baseUrl') })),
									a._.extend(this.settings.toJSON({ verbose: !0 }), { helpLinkUrl: e })
								);
							},
							postRender: function () {
								this.$('.js-help-links').hide();
							},
							toggleLinks: function (e) {
								var t = this;
								e.preventDefault(),
									this.$('.js-help-links').slideToggle(200, function () {
										t.$('.js-help').attr('aria-expanded', t.$('.js-help-links').is(':visible'));
									});
							},
							events: {
								'click .js-help': function (e) {
									e.preventDefault(), this.state.get('enabled') && this.toggleLinks(e);
								},
								'click .js-forgot-password': function (e) {
									if ((e.preventDefault(), this.state.get('enabled'))) {
										var t = this.settings.get('helpLinks.forgotPassword');
										t ? s.redirect(t) : this.options.appState.trigger('navigate', 'signin/forgot-password');
									}
								},
								'click .js-unlock': function (e) {
									if ((e.preventDefault(), this.state.get('enabled'))) {
										var t = this.settings.get('helpLinks.unlock');
										t ? s.redirect(t) : this.options.appState.trigger('navigate', 'signin/unlock');
									}
								},
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				71271: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = r(n(88522)),
						s = a.default.extend({
							template: i.default.template({
								1: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<a href="' +
										c(
											((a =
												null !=
												(a = d(n, 'factorPageCustomLinkHref') || (null != t ? d(t, 'factorPageCustomLinkHref') : t))
													? a
													: l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'factorPageCustomLinkHref',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 40 }, end: { line: 1, column: 68 } },
												  })
												: a)
										) +
										'" data-se="factor-page-custom-link" class="link js-factor-page-custom-link" rel="noopener noreferrer" target="_blank">' +
										c(
											((a =
												null !=
												(a = d(n, 'factorPageCustomLinkText') || (null != t ? d(t, 'factorPageCustomLinkText') : t))
													? a
													: l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'factorPageCustomLinkText',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 186 }, end: { line: 1, column: 214 } },
												  })
												: a)
										) +
										'</a>'
									);
								},
								3: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<a href="#" class="link ' +
										c(
											((a = null != (a = d(n, 'linkClassName') || (null != t ? d(t, 'linkClassName') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'linkClassName',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 265 }, end: { line: 1, column: 282 } },
												  })
												: a)
										) +
										'" data-se="signout-link">' +
										c(
											((a = null != (a = d(n, 'linkText') || (null != t ? d(t, 'linkText') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'linkText',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 307 }, end: { line: 1, column: 319 } },
												  })
												: a)
										) +
										'</a>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'hasFactorPageCustomLink') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 225 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'showLink') : t, {
											name: 'if',
											hash: {},
											fn: e.program(3, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 225 }, end: { line: 1, column: 330 } },
										}))
											? i
											: '')
									);
								},
								useData: !0,
							}),
							className: 'auth-footer clearfix',
							getTemplateData: function () {
								var e = a.default.prototype.getTemplateData.apply(this, arguments),
									t = this.settings.get('helpLinks.factorPage.href'),
									n = this.settings.get('helpLinks.factorPage.text'),
									r = !this.settings.get('features.hideSignOutLinkInMFA') && !this.settings.get('features.mfaOnlyFlow');
								return Object.assign({}, e, {
									hasFactorPageCustomLink: n && t,
									factorPageCustomLinkHref: t,
									factorPageCustomLinkText: n,
									showLink: r,
								});
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				83536: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = a.View.extend({
							template: i.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="content-container"><span class="registration-label">' +
										c(
											((a = null != (a = d(n, 'label') || (null != t ? d(t, 'label') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'label',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 64 }, end: { line: 1, column: 73 } },
												  })
												: a)
										) +
										'</span><a title="' +
										c(
											((a = null != (a = d(n, 'text') || (null != t ? d(t, 'text') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'text',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 90 }, end: { line: 1, column: 98 } },
												  })
												: a)
										) +
										'" aria-label="' +
										c(
											((a = null != (a = d(n, 'text') || (null != t ? d(t, 'text') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'text',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 112 }, end: { line: 1, column: 120 } },
												  })
												: a)
										) +
										'" class="registration-link" href="#">' +
										c(
											((a = null != (a = d(n, 'text') || (null != t ? d(t, 'text') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'text',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 157 }, end: { line: 1, column: 165 } },
												  })
												: a)
										) +
										'</a></div>'
									);
								},
								useData: !0,
							}),
							className: 'registration-container',
							events: { 'click a.registration-link': 'handleClickEvent' },
							handleClickEvent: function (e) {
								e.preventDefault();
								var t = this.settings.get('registration.click');
								t
									? t()
									: this.options.appState.get('isIdxStateToken')
									? this.options.appState.trigger('navigate', 'signin/enroll-user')
									: this.options.appState.trigger('navigate', 'signin/register');
							},
							getTemplateData: function () {
								return {
									label: (0, a.loc)('registration.signup.label', 'login'),
									text: (0, a.loc)('registration.signup.text', 'login'),
								};
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				88522: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(15985)),
						i = r(n(12990)),
						a = r(n(2875)),
						s = n(6475),
						l = r(n(35546));
					function u(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function c(e) {
						for (var t = 1; t < arguments.length; t++) {
							var n = null != arguments[t] ? arguments[t] : {};
							t % 2
								? u(Object(n), !0).forEach(function (t) {
										(0, o.default)(e, t, n[t]);
								  })
								: Object.getOwnPropertyDescriptors
								? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
								: u(Object(n)).forEach(function (t) {
										Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
								  });
						}
						return e;
					}
					var d = s.internal.util.Util,
						f = s.View.extend({
							template: a.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<a href="#" class="link ' +
										c(
											((a = null != (a = d(n, 'linkClassName') || (null != t ? d(t, 'linkClassName') : t)) ? a : l),
											(0, i.default)(a) === u
												? a.call(s, {
														name: 'linkClassName',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 24 }, end: { line: 1, column: 41 } },
												  })
												: a)
										) +
										'" data-se="signout-link">' +
										c(
											((a = null != (a = d(n, 'linkText') || (null != t ? d(t, 'linkText') : t)) ? a : l),
											(0, i.default)(a) === u
												? a.call(s, {
														name: 'linkText',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 66 }, end: { line: 1, column: 78 } },
												  })
												: a)
										) +
										'</a>'
									);
								},
								useData: !0,
							}),
							className: 'auth-footer clearfix',
							events: { 'click a[data-se="signout-link"]': 'handleSignout' },
							handleSignout: function (e) {
								var t = this;
								e.preventDefault();
								var n = this.options.appState;
								n.trigger('signOut');
								var r = n.get('isSMSPasswordRecovery');
								this.model
									.doTransaction(function (e) {
										return e.cancel().then(p);
									})
									.then(function () {
										t.settings.get('backToSignInUri') && !r
											? d.redirect(t.settings.get('backToSignInUri'))
											: (t.state.set('navigateDir', l.default.DIRECTION_BACK), n.trigger('navigate', ''));
									});
							},
							getTemplateData: function () {
								return {
									linkClassName: s._.isUndefined(this.options.linkClassName) ? 'goto' : this.options.linkClassName,
									linkText: this.options.linkText || (0, s.loc)('goback', 'login'),
								};
							},
						});
					function p(e) {
						return c(c({}, e), {}, { data: null });
					}
					(t.default = f), (e.exports = t.default);
				},
				41706: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(35546)),
						s = i.View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<a href="#" class="link help" data-se="back-link">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'goback' },
													data: o,
													loc: { start: { line: 1, column: 50 }, end: { line: 1, column: 87 } },
												}
											)
										) +
										'</a>'
									);
								},
								useData: !0,
							}),
							className: 'auth-footer',
							events: {
								'click .help': function (e) {
									e.preventDefault(), this.back();
								},
							},
							back: function () {
								this.state.set('navigateDir', a.default.DIRECTION_BACK), this.options.appState.trigger('navigate', '');
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				11205: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(35546)),
						s = i.View.extend({
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<a href="#" class="link help" data-se="back-link">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'goback' },
													data: o,
													loc: { start: { line: 1, column: 66 }, end: { line: 1, column: 103 } },
												}
											)
										) +
										'</a>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return null !=
										(i = a(n, 'if').call(null != t ? t : e.nullContext || {}, null != t ? a(t, 'showLink') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 114 } },
										}))
										? i
										: '';
								},
								useData: !0,
							}),
							className: 'auth-footer',
							events: {
								'click .help': function (e) {
									e.preventDefault(), this.back();
								},
							},
							back: function () {
								this.state.set('navigateDir', a.default.DIRECTION_BACK), this.options.appState.trigger('navigate', '');
							},
							getTemplateData: function () {
								var e = this.model.appState.get('flashError');
								return { showLink: e.is && e.is('terminal') };
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				1752: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475).View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									return '<div class="beacon-blank"></div><div class="bg-helper auth-beacon auth-beacon-security" data-se="loading-beacon"><div class="okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border"></div></div>';
								},
								useData: !0,
							}),
							equals: function (e) {
								return e && this instanceof e;
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				9695: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475).View.extend({
							className: 'piv-beacon',
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									return '<div class="beacon-blank auth-beacon"><div class="beacon-blank js-blank-beacon-border auth-beacon-border"></div></div><div class="bg-helper auth-beacon smartcard" data-se="piv-beacon"><div class="okta-sign-in-beacon-border auth-beacon-border"></div></div>';
								},
								useData: !0,
							}),
							equals: function (e) {
								return e && this instanceof e;
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				25015: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(2645)),
						s = i.View.extend({
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="password-requirements--header">' +
										e.escapeExpression(
											(s(n, 'i18n') || (t && s(t, 'i18n')) || e.hooks.helperMissing).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'password.complexity.requirements.header' },
												data: o,
												loc: { start: { line: 1, column: 63 }, end: { line: 1, column: 133 } },
											})
										) +
										'</div><ul class="password-requirements--list">' +
										(null !=
										(i = s(n, 'each').call(a, null != t ? s(t, 'requirements') : t, {
											name: 'each',
											hash: {},
											fn: e.program(2, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 179 }, end: { line: 1, column: 268 } },
										}))
											? i
											: '') +
										'</ul>'
									);
								},
								2: function (e, t, n, r, o) {
									return '<li class="password-requirements--list-item">' + e.escapeExpression(e.lambda(t, t)) + '</li>';
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return null !=
										(i = a(n, 'if').call(null != t ? t : e.nullContext || {}, null != t ? a(t, 'requirements') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 280 } },
										}))
										? i
										: '';
								},
								useData: !0,
							}),
							attributes: { 'data-se': 'password-requirements-html' },
							allRequirements: [],
							initialize: function (e) {
								var t = e.policy;
								t && (this.allRequirements = a.default.getPasswordComplexityDescriptionForHtmlList(t));
							},
							getTemplateData: function () {
								return { requirements: this.allRequirements };
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				94164: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(70232)),
						i = r(n(31049)),
						a = r(n(2875)),
						s = n(6475),
						l = r(n(66757));
					function u(e, t) {
						var n = t.get('securityImage'),
							r = t.get('securityImageDescription'),
							o = t.get('isUndefinedUser'),
							i = t.get('isNewUser'),
							a = !o && !i;
						if ((e.css('background-image', ''), e.removeClass('new-user undefined-user'), i)) e.addClass('new-user');
						else {
							if (!o)
								return a
									? (e.removeAttr('aria-describedby'),
									  e.find('.accessibility-text').text(r),
									  void e.css('background-image', 'url(' + s._.escape(n) + ')'))
									: void 0;
							e.addClass('undefined-user');
						}
					}
					function c(e, t) {
						(0, s.$)(window).on(
							'resize.securityBeaconQtip',
							s._.debounce(function () {
								e.is(':visible') && e.qtip('show');
							}, 300)
						),
							e.qtip({
								prerender: !0,
								content: {
									text: (0, s.loc)('primaryauth.newUser.tooltip', 'login', [s._.escape(t)]),
									button: (0, s.loc)('primaryauth.newUser.tooltip.close', 'login'),
								},
								style: {
									classes: 'okta-security-image-tooltip security-image-qtip qtip-custom qtip-shadow qtip-rounded',
									tip: { height: 12, width: 16 },
								},
								position: {
									my: 'top center',
									at: 'center',
									target: (0, s.$)('.auth-beacon-security'),
									adjust: { method: 'flip', scroll: !1, resize: !0 },
									effect: !1,
								},
								hide: { event: !1, fixed: !0 },
								show: { event: !1, delay: 200 },
								events: {
									move: function (e, t) {
										t.elements.target.is(':visible') || (t.set('hide.effect', !1), t.hide(), t.set('hide.effect', !0));
									},
								},
							}),
							setTimeout(function () {
								e.qtip('toggle', e.is(':visible'));
							}, 0);
					}
					function d(e) {
						e.qtip('destroy'), (0, s.$)(window).off('resize.securityBeaconQtip');
					}
					function f(e, t, n) {
						return p.apply(this, arguments);
					}
					function p() {
						return (p = (0, i.default)(
							o.default.mark(function e(t, n, r) {
								var i, a, s, f, p, h, m;
								return o.default.wrap(function (e) {
									for (;;)
										switch ((e.prev = e.next)) {
											case 0:
												if (
													((i = t.find('.auth-beacon-security')),
													(a = t.find('.js-auth-beacon-border')),
													(s = !n.get('isUndefinedUser')),
													(f = n.get('isNewUser')),
													(p = t.find('.radial-progress-bar')),
													(h = n.get('baseUrl').match(/https?:\/\/(.[^/]+)/)[1]),
													(m = 200),
													r)
												) {
													e.next = 11;
													break;
												}
												return u(i, n), a.toggleClass('auth-beacon-border', s), e.abrupt('return');
											case 11:
												if ((d(i), s)) {
													e.next = 16;
													break;
												}
												i.fadeOut(m, function () {
													u(i, n), a.removeClass('auth-beacon-border'), i.fadeIn(m);
												}),
													(e.next = 21);
												break;
											case 16:
												return (
													a.removeClass('auth-beacon-border'),
													(e.next = 19),
													l.default.radialProgressBar({
														$el: p,
														swap: function () {
															i.fadeOut(m, function () {
																u(i, n), i.fadeIn(m);
															});
														},
													})
												);
											case 19:
												a.addClass('auth-beacon-border'), f && c(i, h);
											case 21:
											case 'end':
												return e.stop();
										}
								}, e);
							})
						)).apply(this, arguments);
					}
					var h = s.View.extend({
						template: a.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								return '<div class="beacon-blank"><div class="radial-progress-bar"><div class="circle left"></div><div class="circle right"></div></div></div><div aria-live="polite" role="img" class="bg-helper auth-beacon auth-beacon-security" data-se="security-beacon"><span class="accessibility-text"></span><div class="okta-sign-in-beacon-border auth-beacon-border js-auth-beacon-border"></div></div>';
							},
							useData: !0,
						}),
						className: 'js-security-beacon',
						initialize: function (e) {
							(this.update = s._.partial(f, this.$el, e.appState)),
								this.listenTo(e.appState, 'change:securityImage', this.update),
								this.listenTo(e.appState, 'loading', function (e) {
									this.$el.toggleClass('beacon-loading', e), this.removeAntiPhishingMessage();
								}),
								this.options.appState.set('beaconType', 'security'),
								this.listenTo(e.appState, 'navigate', this.removeAntiPhishingMessage);
						},
						postRender: function () {
							this.update(!1);
						},
						equals: function (e) {
							return e && this instanceof e;
						},
						removeAntiPhishingMessage: function () {
							this.$el.find('.auth-beacon-security').qtip('destroy');
						},
					});
					(t.default = h), (e.exports = t.default);
				},
				26069: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(35546)),
						a = o.View.extend({
							tagName: 'a',
							className: 'skip-to-content-link',
							attributes: { href: '#'.concat(i.default.WIDGET_CONTAINER_ID) },
							initialize: function () {
								this.$el.append((0, o.loc)('skip.to.main.content', 'login'));
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				64521: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475).View.extend({
						className: 'okta-waiting-spinner',
						attributes: { 'data-se': 'o-form-okta-waiting-spinner' },
						modelEvents: { 'spinner:show': 'show', 'spinner:hide': 'hide' },
						initialize: function (e) {
							e && !1 === e.visible && this.hide();
						},
						show: function () {
							this.$el.removeClass('hide');
						},
						hide: function () {
							this.$el.addClass('hide');
						},
					});
					(t.default = r), (e.exports = t.default);
				},
				50160: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475);
					n(48231);
					var i = r(n(34425)),
						a = o.internal.views.forms.inputs.TextBox,
						s = a.extend({
							postRender: function () {
								if ('number' === this.options.type) {
									var e = this.$('input');
									e.attr({ pattern: '[0-9]*', inputmode: 'numeric' });
								}
								a.prototype.postRender.apply(this, arguments);
							},
							focus: function () {
								if (!i.default.isIE()) return a.prototype.focus.apply(this, arguments);
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				91482: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)).default.template({
						1: function (e, t, n, r, o) {
							var i,
								a =
									e.lookupProperty ||
									function (e, t) {
										if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
									};
							return (
								'<a href="' +
								e.escapeExpression(
									'function' ==
										typeof (i =
											null != (i = a(n, 'clientURI') || (null != t ? a(t, 'clientURI') : t))
												? i
												: e.hooks.helperMissing)
										? i.call(null != t ? t : e.nullContext || {}, {
												name: 'clientURI',
												hash: {},
												data: o,
												loc: { start: { line: 1, column: 26 }, end: { line: 1, column: 39 } },
										  })
										: i
								) +
								'" class="client-logo-link" target="_blank">'
							);
						},
						3: function (e, t, n, r, o) {
							var i,
								a = null != t ? t : e.nullContext || {},
								s = e.hooks.helperMissing,
								l = e.escapeExpression,
								u =
									e.lookupProperty ||
									function (e, t) {
										if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
									};
							return (
								'<img class="client-logo custom-logo" src="' +
								l(
									'function' ==
										typeof (i = null != (i = u(n, 'customLogo') || (null != t ? u(t, 'customLogo') : t)) ? i : s)
										? i.call(a, {
												name: 'customLogo',
												hash: {},
												data: o,
												loc: { start: { line: 1, column: 149 }, end: { line: 1, column: 163 } },
										  })
										: i
								) +
								'" alt="' +
								l(
									(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
										name: 'i18n',
										hash: { bundle: 'login', code: 'common.logo.alt' },
										data: o,
										loc: { start: { line: 1, column: 170 }, end: { line: 1, column: 216 } },
									})
								) +
								'" aria-hidden="true" />'
							);
						},
						5: function (e, t, n, r, o) {
							var i,
								a = null != t ? t : e.nullContext || {},
								s = e.hooks.helperMissing,
								l = e.escapeExpression,
								u =
									e.lookupProperty ||
									function (e, t) {
										if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
									};
							return (
								'<img class="client-logo default-logo" src="' +
								l(
									'function' ==
										typeof (i = null != (i = u(n, 'defaultLogo') || (null != t ? u(t, 'defaultLogo') : t)) ? i : s)
										? i.call(a, {
												name: 'defaultLogo',
												hash: {},
												data: o,
												loc: { start: { line: 1, column: 290 }, end: { line: 1, column: 305 } },
										  })
										: i
								) +
								'" alt="' +
								l(
									(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
										name: 'i18n',
										hash: { bundle: 'login', code: 'common.logo.alt' },
										data: o,
										loc: { start: { line: 1, column: 312 }, end: { line: 1, column: 358 } },
									})
								) +
								'" aria-hidden="true" />'
							);
						},
						7: function (e, t, n, r, o) {
							return '</a>';
						},
						9: function (e, t, n, r, o) {
							var i,
								a =
									e.lookupProperty ||
									function (e, t) {
										if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
									};
							return (
								'<div class="issuer"><span>' +
								e.escapeExpression(
									'function' ==
										typeof (i =
											null != (i = a(n, 'issuer') || (null != t ? a(t, 'issuer') : t)) ? i : e.hooks.helperMissing)
										? i.call(null != t ? t : e.nullContext || {}, {
												name: 'issuer',
												hash: {},
												data: o,
												loc: { start: { line: 1, column: 566 }, end: { line: 1, column: 576 } },
										  })
										: i
								) +
								'</span></div>'
							);
						},
						compiler: [8, '>= 4.3.0'],
						main: function (e, t, n, r, o) {
							var i,
								a = null != t ? t : e.nullContext || {},
								s =
									e.lookupProperty ||
									function (e, t) {
										if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
									};
							return (
								(null !=
								(i = s(n, 'if').call(a, null != t ? s(t, 'clientURI') : t, {
									name: 'if',
									hash: {},
									fn: e.program(1, o, 0),
									inverse: e.noop,
									data: o,
									loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 89 } },
								}))
									? i
									: '') +
								(null !=
								(i = s(n, 'if').call(a, null != t ? s(t, 'customLogo') : t, {
									name: 'if',
									hash: {},
									fn: e.program(3, o, 0),
									inverse: e.program(5, o, 0),
									data: o,
									loc: { start: { line: 1, column: 89 }, end: { line: 1, column: 388 } },
								}))
									? i
									: '') +
								(null !=
								(i = s(n, 'if').call(a, null != t ? s(t, 'clientURI') : t, {
									name: 'if',
									hash: {},
									fn: e.program(7, o, 0),
									inverse: e.noop,
									data: o,
									loc: { start: { line: 1, column: 388 }, end: { line: 1, column: 416 } },
								}))
									? i
									: '') +
								'<h1><span class="title-text">' +
								(null !=
								(i = (s(n, 'i18n') || (t && s(t, 'i18n')) || e.hooks.helperMissing).call(a, {
									name: 'i18n',
									hash: { arguments: 'appName', bundle: 'login', code: 'consent.required.text' },
									data: o,
									loc: { start: { line: 1, column: 445 }, end: { line: 1, column: 519 } },
								}))
									? i
									: '') +
								'</span>' +
								(null !=
								(i = s(n, 'if').call(a, null != t ? s(t, 'issuer') : t, {
									name: 'if',
									hash: {},
									fn: e.program(9, o, 0),
									inverse: e.noop,
									data: o,
									loc: { start: { line: 1, column: 526 }, end: { line: 1, column: 596 } },
								}))
									? i
									: '') +
								'</h1>'
							);
						},
						useData: !0,
					});
					(t.default = o), (e.exports = t.default);
				},
				13871: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.CONFIGURED_FLOW = void 0);
					t.CONFIGURED_FLOW = {
						DEFAULT: 'default',
						PROCEED: 'proceed',
						LOGIN: 'login',
						REGISTRATION: 'signup',
						RESET_PASSWORD: 'resetPassword',
						UNLOCK_ACCOUNT: 'unlockAccount',
					};
				},
				92282: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.handleConfiguredFlow = function (e, t) {
							return h.apply(this, arguments);
						});
					var o = r(n(70232)),
						i = r(n(31049)),
						a = n(13671),
						s = r(n(36894)),
						l = n(13955),
						u = n(13871);
					function c(e, t, n) {
						return d.apply(this, arguments);
					}
					function d() {
						return (d = (0, i.default)(
							o.default.mark(function e(t, n, r) {
								var i;
								return o.default.wrap(
									function (e) {
										for (;;)
											switch ((e.prev = e.next)) {
												case 0:
													if (
														t.neededToProceed.find(function (e) {
															return e.name === n;
														})
													) {
														e.next = 4;
														break;
													}
													return (
														s.default.warn('Expected remediation not found, Org may be misconfigured for this flow'),
														e.abrupt('return', t)
													);
												case 4:
													return (e.prev = 4), (e.next = 7), t.proceed(n);
												case 7:
													return (i = e.sent), e.abrupt('return', i);
												case 11:
													if (
														((e.prev = 11),
														(e.t0 = e.catch(4)),
														'string' != typeof e.t0 || !e.t0.startsWith('Unknown remediation choice'))
													) {
														e.next = 18;
														break;
													}
													return (
														s.default.warn('flow ['.concat(r, '] not valid with current Org configurations')),
														e.abrupt('return', t)
													);
												case 18:
													throw e.t0;
												case 19:
												case 'end':
													return e.stop();
											}
									},
									e,
									null,
									[[4, 11]]
								);
							})
						)).apply(this, arguments);
					}
					function f(e) {
						return p.apply(this, arguments);
					}
					function p() {
						return (
							(p = (0, i.default)(
								o.default.mark(function e(t) {
									var n,
										r = arguments;
									return o.default.wrap(function (e) {
										for (;;)
											switch ((e.prev = e.next)) {
												case 0:
													(n = r.length > 1 && void 0 !== r[1] ? r[1] : 'default'),
														(e.t0 = n),
														(e.next =
															e.t0 === u.CONFIGURED_FLOW.DEFAULT ||
															e.t0 === u.CONFIGURED_FLOW.PROCEED ||
															e.t0 === u.CONFIGURED_FLOW.LOGIN
																? 4
																: e.t0 === u.CONFIGURED_FLOW.REGISTRATION || e.t0 === u.CONFIGURED_FLOW.RESET_PASSWORD
																? 5
																: e.t0 === u.CONFIGURED_FLOW.UNLOCK_ACCOUNT
																? 6
																: 9);
													break;
												case 4:
												case 5:
													return e.abrupt('return', t);
												case 6:
													return (e.next = 8), c(t, l.FORMS.UNLOCK_ACCOUNT, n);
												case 8:
													return e.abrupt('return', e.sent);
												case 9:
													throw (
														(s.default.warn('Unknown `flow` value: '.concat(n)),
														new a.ConfigError('Invalid "flow" configuration'))
													);
												case 11:
												case 'end':
													return e.stop();
											}
									}, e);
								})
							)),
							p.apply(this, arguments)
						);
					}
					function h() {
						return (h = (0, i.default)(
							o.default.mark(function e(t, n) {
								var r, i, a;
								return o.default.wrap(function (e) {
									for (;;)
										switch ((e.prev = e.next)) {
											case 0:
												return (r = n.getAuthClient()), (i = r.idx.getFlow()), (e.next = 4), f(t, i);
											case 4:
												return (a = e.sent), e.abrupt('return', a);
											case 6:
											case 'end':
												return e.stop();
										}
								}, e);
							})
						)).apply(this, arguments);
					}
				},
				98462: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 });
					var r = n(59155);
					Object.keys(r).forEach(function (e) {
						'default' !== e &&
							'__esModule' !== e &&
							((e in t && t[e] === r[e]) ||
								Object.defineProperty(t, e, {
									enumerable: !0,
									get: function () {
										return r[e];
									},
								}));
					});
					var o = n(86183);
					Object.keys(o).forEach(function (e) {
						'default' !== e &&
							'__esModule' !== e &&
							((e in t && t[e] === o[e]) ||
								Object.defineProperty(t, e, {
									enumerable: !0,
									get: function () {
										return o[e];
									},
								}));
					});
					var i = n(92282);
					Object.keys(i).forEach(function (e) {
						'default' !== e &&
							'__esModule' !== e &&
							((e in t && t[e] === i[e]) ||
								Object.defineProperty(t, e, {
									enumerable: !0,
									get: function () {
										return i[e];
									},
								}));
					});
					var a = n(13871);
					Object.keys(a).forEach(function (e) {
						'default' !== e &&
							'__esModule' !== e &&
							((e in t && t[e] === a[e]) ||
								Object.defineProperty(t, e, {
									enumerable: !0,
									get: function () {
										return a[e];
									},
								}));
					});
					var s = n(57852);
					Object.keys(s).forEach(function (e) {
						'default' !== e &&
							'__esModule' !== e &&
							((e in t && t[e] === s[e]) ||
								Object.defineProperty(t, e, {
									enumerable: !0,
									get: function () {
										return s[e];
									},
								}));
					});
				},
				59155: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.interactionCodeFlow = function (e, t) {
							return c.apply(this, arguments);
						});
					var o = r(n(70232)),
						i = r(n(31049)),
						a = r(n(35546)),
						s = n(13671),
						l = n(2659),
						u = n(45570);
					function c() {
						return (c = (0, i.default)(
							o.default.mark(function e(t, n) {
								var r, i, c, d, f, p, h, m;
								return o.default.wrap(function (e) {
									for (;;)
										switch ((e.prev = e.next)) {
											case 0:
												return (
													(r = n.interactionCode),
													(i = t.getAuthClient()),
													(e.next = 4),
													i.idx.getSavedTransactionMeta()
												);
											case 4:
												if (
													((c = e.sent),
													(d = i.options.state || (null == c ? void 0 : c.state)),
													(f = 'remediation' === t.get('mode')) && i.idx.clearTransactionMeta(),
													!('always' === t.get('redirect')))
												) {
													e.next = 16;
													break;
												}
												if ((p = t.get('redirectUri'))) {
													e.next = 13;
													break;
												}
												throw new s.ConfigError('"redirectUri" is required');
											case 13:
												return (
													(h = (0, l.toQueryString)({ interaction_code: r, state: d })),
													window.location.assign(p + h),
													e.abrupt('return')
												);
											case 16:
												if (!f) {
													e.next = 19;
													break;
												}
												return (
													t.callGlobalSuccess(a.default.SUCCESS, { interaction_code: r, state: d }), e.abrupt('return')
												);
											case 19:
												if (c) {
													e.next = 21;
													break;
												}
												throw new s.ConfigError('Could not load transaction data from storage');
											case 21:
												return (
													(m = c.codeVerifier),
													e.abrupt(
														'return',
														i.token
															.exchangeCodeForTokens({ codeVerifier: m, interactionCode: r })
															.then(function (e) {
																var n = e.tokens;
																t.callGlobalSuccess(a.default.SUCCESS, { tokens: n });
															})
															.catch(function (e) {
																var n = (0, u.getTypedOAuthError)(e);
																if (n instanceof u.RecoverableError && n.is('terminal')) throw n;
																t.callGlobalError(e);
															})
															.finally(function () {
																i.idx.clearTransactionMeta();
															})
													)
												);
											case 23:
											case 'end':
												return e.stop();
										}
								}, e);
							})
						)).apply(this, arguments);
					}
				},
				69977: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var n = 'osw-oie-state-handle',
						r = 'osw-oie-last-initiated-login-url',
						o = 'osw-oie-resend-timestamp',
						i = {
							removeStateHandle: function () {
								sessionStorage.removeItem(n), sessionStorage.removeItem(r);
							},
							setStateHandle: function (e) {
								sessionStorage.setItem(n, e), sessionStorage.setItem(r, window.location.href);
							},
							getStateHandle: function () {
								return sessionStorage.getItem(n);
							},
							getLastInitiatedLoginUrl: function () {
								return sessionStorage.getItem(r);
							},
							removeResendTimestamp: function () {
								sessionStorage.removeItem(o);
							},
							setResendTimestamp: function (e) {
								sessionStorage.setItem(o, e);
							},
							getResendTimestamp: function () {
								return sessionStorage.getItem(o);
							},
						};
					(t.default = i), (e.exports = t.default);
				},
				16100: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(87462)),
						i = n(19596),
						a = function (e) {
							var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
							return o.default
								.chain(t)
								.filter(function (e) {
									var t;
									return (
										Array.isArray(null === (t = e.messages) || void 0 === t ? void 0 : t.value) &&
										e.messages.value.length
									);
								})
								.map(function (t) {
									return {
										property: e ? ''.concat(e, '.').concat(t.name) : t.name,
										errorSummary: t.messages.value.map(i.getMessage),
										errorKey: t.messages.value.map(i.getMessageKey),
									};
								})
								.value();
						},
						s = function (e) {
							var t = [];
							if (!e.remediation || !Array.isArray(e.remediation.value) || 0 === e.remediation.value.length) return t;
							var n = e.remediation.value[0].value;
							return Array.isArray(n)
								? (t.push(a(null, n)),
								  o.default.each(n, function (e) {
										var n,
											r = e.name;
										Array.isArray(null === (n = e.form) || void 0 === n ? void 0 : n.value) &&
											t.push(a(r, e.form.value)),
											Array.isArray(e.options) &&
												o.default.each(e.options, function (e) {
													var n, o;
													Array.isArray(
														null === (n = e.value) || void 0 === n || null === (o = n.form) || void 0 === o
															? void 0
															: o.value
													) && t.push(a(r, e.value.form.value));
												});
								  }),
								  (function (e, t) {
										if (!Array.isArray(e)) return [];
										if (!o.default.isFunction(t) || 1 === e.length) return e;
										for (var n = [], r = 0; r < e.length; r++) {
											for (var i = !1, a = r + 1; a < e.length; a++)
												if (t(e[r], e[a])) {
													i = !0;
													break;
												}
											i || n.push(e[r]);
										}
										return n;
								  })(o.default.flatten(t), o.default.isEqual))
								: t;
						},
						l = function (e) {
							var t,
								n = [];
							return (
								Array.isArray(null === (t = e.messages) || void 0 === t ? void 0 : t.value) &&
									(n = e.messages.value.map(i.getMessageKey)),
								n
							);
						},
						u = {
							convertFormErrors: function (e) {
								var t, n, r;
								return {
									responseJSON: {
										errorCauses: s(e),
										errorSummary:
											((t = e),
											(r = []),
											Array.isArray(null === (n = t.messages) || void 0 === n ? void 0 : n.value) &&
												(r = t.messages.value.map(i.getMessage)),
											r.join('. ')),
										errorSummaryKeys: l(e),
										errorIntent: e.intent,
									},
								};
							},
							isIonErrorResponse: function () {
								var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
								return e.version;
							},
							isIdxSessionExpiredError: function (e) {
								var t,
									n,
									r,
									o,
									i =
										null == e ||
										null === (t = e.context) ||
										void 0 === t ||
										null === (n = t.messages) ||
										void 0 === n ||
										null === (r = n.value[0]) ||
										void 0 === r ||
										null === (o = r.i18n) ||
										void 0 === o
											? void 0
											: o.key;
								return i && 'idx.session.expired' === i;
							},
						};
					(t.default = u), (e.exports = t.default);
				},
				13955: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.TERMINAL_FORMS =
							t.ORG_PASSWORD_RECOVERY_LINK =
							t.INTERSTITIAL_REDIRECT_VIEW =
							t.ID_PROOFING_TYPE =
							t.IDP_FORM_TYPE =
							t.HINTS =
							t.FORM_NAME_TO_OPERATION_MAP =
							t.FORMS_WITH_STATIC_BACK_LINK =
							t.FORMS_WITHOUT_SIGNOUT =
							t.FORMS_FOR_VERIFICATION =
							t.FORMS =
							t.AUTHENTICATOR_METHODS =
							t.AUTHENTICATOR_KEY =
							t.ATTR_FORMAT =
							t.ACTIONS =
								void 0);
					var o,
						i = r(n(15985)),
						a = r(n(35546)),
						s = {
							IDENTIFY: 'identify',
							SELECT_IDENTIFY: 'select-identify',
							IDENTIFY_RECOVERY: 'identify-recovery',
							SELECT_ENROLL_PROFILE: 'select-enroll-profile',
							ENROLL_PROFILE: 'enroll-profile',
							ENROLL_PROFILE_UPDATE: 'profile-update',
							UNLOCK_ACCOUNT: 'unlock-account',
							REQUEST_ACTIVATION: 'request-activation-email',
							CONSENT_ADMIN: 'admin-consent',
							CONSENT_ENDUSER: 'consent',
							CONSENT_GRANULAR: 'granular-consent',
							CONSENT_EMAIL_CHALLENGE: 'email-challenge-consent',
							SELECT_AUTHENTICATOR_AUTHENTICATE: 'select-authenticator-authenticate',
							SELECT_AUTHENTICATOR_UNLOCK: 'select-authenticator-unlock-account',
							AUTHENTICATOR_VERIFICATION_DATA: 'authenticator-verification-data',
							CHALLENGE_AUTHENTICATOR: 'challenge-authenticator',
							CHALLENGE_WEBAUTHN_AUTOFILLUI_AUTHENTICATOR: 'challenge-webauthn-autofillui-authenticator',
							CHALLENGE_POLL: 'challenge-poll',
							RESEND: 'resend',
							SELECT_AUTHENTICATOR_ENROLL: 'select-authenticator-enroll',
							SELECT_AUTHENTICATOR_ENROLL_DATA: 'select-authenticator-enroll-data',
							AUTHENTICATOR_ENROLLMENT_DATA: 'authenticator-enrollment-data',
							ENROLL_AUTHENTICATOR: 'enroll-authenticator',
							SELECT_ENROLLMENT_CHANNEL: 'select-enrollment-channel',
							ENROLLMENT_CHANNEL_DATA: 'enrollment-channel-data',
							ENROLL_POLL: 'enroll-poll',
							REENROLL_AUTHENTICATOR: 'reenroll-authenticator',
							REENROLL_AUTHENTICATOR_WARNING: 'reenroll-authenticator-warning',
							REENROLL_CUSTOM_PASSWORD_EXPIRY: 'reenroll-custom-password-expiry',
							REENROLL_CUSTOM_PASSWORD_EXPIRY_WARNING: 'reenroll-custom-password-expiry-warning',
							RESET_AUTHENTICATOR: 'reset-authenticator',
							SKIP: 'skip',
							POLL: 'poll',
							FAILURE_REDIRECT: 'failure-redirect',
							SUCCESS_REDIRECT: 'success-redirect',
							REDIRECT_IDP: 'redirect-idp',
							REDIRECT_IDVERIFY: 'redirect-idverify',
							PIV_IDP: 'piv-idp',
							DEVICE_CHALLENGE_POLL: 'device-challenge-poll',
							DEVICE_APPLE_SSO_EXTENSION: 'device-apple-sso-extension',
							CANCEL_TRANSACTION: 'cancel-transaction',
							LAUNCH_AUTHENTICATOR: 'launch-authenticator',
							LAUNCH_WEBAUTHN_AUTHENTICATOR: 'launch-webauthn-authenticator',
							ENROLL_WEBAUTHN_RESIDENTKEY: 'enroll-webauthn-residentkey',
							DEVICE_ENROLLMENT_TERMINAL: 'device-enrollment-terminal',
							USER_CODE: 'user-code',
							KEEP_ME_SIGNED_IN: 'keep-me-signed-in',
							DEVICE_ASSURANCE_GRACE_PERIOD: 'device-assurance-grace-period',
							TERMINAL: 'terminal',
						};
					t.FORMS = s;
					var l = [
						s.IDENTIFY,
						s.SUCCESS_REDIRECT,
						s.ENROLL_PROFILE,
						s.DEVICE_ENROLLMENT_TERMINAL,
						s.CONSENT_ADMIN,
						s.CONSENT_ENDUSER,
						s.CONSENT_GRANULAR,
						s.CONSENT_EMAIL_CHALLENGE,
						s.USER_CODE,
						s.KEEP_ME_SIGNED_IN,
					];
					t.FORMS_WITHOUT_SIGNOUT = l;
					var u = [s.SELECT_AUTHENTICATOR_ENROLL, s.SELECT_AUTHENTICATOR_AUTHENTICATE];
					t.FORMS_WITH_STATIC_BACK_LINK = u;
					var c = [s.SELECT_AUTHENTICATOR_AUTHENTICATE, s.CHALLENGE_AUTHENTICATOR, s.CHALLENGE_POLL, s.RESEND];
					t.FORMS_FOR_VERIFICATION = c;
					t.AUTHENTICATOR_KEY = {
						EMAIL: 'okta_email',
						PASSWORD: 'okta_password',
						PHONE: 'phone_number',
						WEBAUTHN: 'webauthn',
						SECURITY_QUESTION: 'security_question',
						OV: 'okta_verify',
						GOOGLE_OTP: 'google_otp',
						ON_PREM: 'onprem_mfa',
						RSA: 'rsa_token',
						DUO: 'duo',
						IDP: 'external_idp',
						CUSTOM_OTP: 'custom_otp',
						SYMANTEC_VIP: 'symantec_vip',
						YUBIKEY: 'yubikey_token',
						CUSTOM_APP: 'custom_app',
						SMARTCARD: 'smart_card_idp',
					};
					t.AUTHENTICATOR_METHODS = { PUSH: 'push' };
					var d =
						((o = {}),
						(0, i.default)(o, s.SELECT_AUTHENTICATOR_UNLOCK, a.default.UNLOCK_ACCOUNT),
						(0, i.default)(o, s.IDENTIFY, a.default.PRIMARY_AUTH),
						(0, i.default)(o, s.IDENTIFY_RECOVERY, a.default.FORGOT_PASSWORD),
						o);
					t.FORM_NAME_TO_OPERATION_MAP = d;
					var f = 'currentAuthenticator-recover';
					t.ORG_PASSWORD_RECOVERY_LINK = f;
					var p = {
						ENROLLED_PASSWORD_RECOVERY_LINK: 'currentAuthenticatorEnrollment-recover',
						ORG_PASSWORD_RECOVERY_LINK: f,
					};
					t.ACTIONS = p;
					t.HINTS = { CAPTCHA: 'captcha' };
					var h = [s.TERMINAL, s.DEVICE_ENROLLMENT_TERMINAL];
					t.TERMINAL_FORMS = h;
					t.IDP_FORM_TYPE = { X509: 'X509' };
					t.INTERSTITIAL_REDIRECT_VIEW = { DEFAULT: 'DEFAULT', NONE: 'NONE' };
					t.ATTR_FORMAT = { COUNTRY_CODE: 'country-code' };
					t.ID_PROOFING_TYPE = { IDV_PERSONA: 'IDV_PERSONA', IDV_CLEAR: 'IDV_CLEAR', IDV_INCODE: 'IDV_INCODE' };
				},
				2715: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.getV1ClassName = t.getClassNameMapping = void 0);
					var o,
						i,
						a,
						s,
						l,
						u,
						c = r(n(15985)),
						d = n(13955),
						f =
							((u = {}),
							(0, c.default)(
								u,
								d.FORMS.IDENTIFY,
								((o = {}),
								(0, c.default)(o, d.FORMS.IDENTIFY, 'primary-auth'),
								(0, c.default)(o, d.AUTHENTICATOR_KEY.PASSWORD, 'primary-auth'),
								o)
							),
							(0, c.default)(
								u,
								d.FORMS.IDENTIFY_RECOVERY,
								(0, c.default)({}, d.FORMS.IDENTIFY_RECOVERY, 'forgot-password')
							),
							(0, c.default)(u, d.FORMS.ENROLL_PROFILE, (0, c.default)({}, d.FORMS.ENROLL_PROFILE, 'registration')),
							(0, c.default)(
								u,
								d.FORMS.CHALLENGE_AUTHENTICATOR,
								((i = {}),
								(0, c.default)(i, d.AUTHENTICATOR_KEY.EMAIL, 'mfa-verify-passcode'),
								(0, c.default)(i, d.AUTHENTICATOR_KEY.PASSWORD, 'mfa-verify-password'),
								(0, c.default)(i, 'sms', 'mfa-verify-passcode'),
								(0, c.default)(i, 'voice', 'mfa-verify-passcode'),
								(0, c.default)(i, d.AUTHENTICATOR_KEY.SECURITY_QUESTION, 'mfa-verify-question'),
								(0, c.default)(i, d.AUTHENTICATOR_KEY.WEBAUTHN, 'mfa-verify-webauthn'),
								(0, c.default)(i, d.AUTHENTICATOR_KEY.ON_PREM, 'mfa-verify-totp'),
								(0, c.default)(i, d.AUTHENTICATOR_KEY.RSA, 'mfa-verify-totp'),
								(0, c.default)(i, d.AUTHENTICATOR_KEY.OV, 'mfa-verify'),
								(0, c.default)(i, d.AUTHENTICATOR_KEY.GOOGLE_OTP, 'mfa-verify'),
								(0, c.default)(i, d.AUTHENTICATOR_KEY.DUO, 'mfa-verify-duo'),
								(0, c.default)(i, d.AUTHENTICATOR_KEY.SYMANTEC_VIP, 'mfa-verify'),
								(0, c.default)(i, d.AUTHENTICATOR_KEY.YUBIKEY, 'mfa-verify'),
								(0, c.default)(i, d.AUTHENTICATOR_KEY.CUSTOM_APP, 'mfa-verify'),
								i)
							),
							(0, c.default)(
								u,
								d.FORMS.CHALLENGE_POLL,
								((a = {}),
								(0, c.default)(a, d.AUTHENTICATOR_KEY.OV, 'mfa-verify'),
								(0, c.default)(a, d.AUTHENTICATOR_KEY.CUSTOM_APP, 'mfa-verify'),
								a)
							),
							(0, c.default)(
								u,
								d.FORMS.RESEND_PUSH,
								((s = {}),
								(0, c.default)(s, d.AUTHENTICATOR_KEY.OV, 'mfa-verify'),
								(0, c.default)(s, d.AUTHENTICATOR_KEY.CUSTOM_APP, 'mfa-verify'),
								s)
							),
							(0, c.default)(
								u,
								d.FORMS.ENROLL_AUTHENTICATOR,
								((l = {}),
								(0, c.default)(l, d.AUTHENTICATOR_KEY.EMAIL, 'enroll-email'),
								(0, c.default)(l, d.AUTHENTICATOR_KEY.PASSWORD, 'enroll-password'),
								(0, c.default)(l, 'sms', 'enroll-sms'),
								(0, c.default)(l, 'voice', 'enroll-call'),
								(0, c.default)(l, d.AUTHENTICATOR_KEY.SECURITY_QUESTION, 'enroll-question'),
								(0, c.default)(l, d.AUTHENTICATOR_KEY.WEBAUTHN, 'enroll-webauthn'),
								(0, c.default)(l, d.AUTHENTICATOR_KEY.ON_PREM, 'enroll-onprem'),
								(0, c.default)(l, d.AUTHENTICATOR_KEY.RSA, 'enroll-rsa'),
								(0, c.default)(l, d.AUTHENTICATOR_KEY.DUO, 'enroll-duo'),
								(0, c.default)(l, d.AUTHENTICATOR_KEY.SYMANTEC_VIP, 'enroll-symantec'),
								(0, c.default)(l, d.AUTHENTICATOR_KEY.YUBIKEY, 'enroll-yubikey'),
								l)
							),
							(0, c.default)(u, d.FORMS.SELECT_AUTHENTICATOR_ENROLL, {
								'select-authenticator-enroll': 'enroll-choices',
							}),
							(0, c.default)(
								u,
								d.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE,
								(0, c.default)({}, d.AUTHENTICATOR_KEY.PASSWORD, 'forgot-password')
							),
							(0, c.default)(
								u,
								d.FORMS.REENROLL_AUTHENTICATOR,
								(0, c.default)({}, d.AUTHENTICATOR_KEY.PASSWORD, 'password-expired')
							),
							(0, c.default)(
								u,
								d.FORMS.REENROLL_CUSTOM_PASSWORD_EXPIRY,
								(0, c.default)({}, d.AUTHENTICATOR_KEY.PASSWORD, 'custom-password-expired')
							),
							(0, c.default)(
								u,
								d.FORMS.REENROLL_CUSTOM_PASSWORD_EXPIRY_WARNING,
								(0, c.default)({}, d.AUTHENTICATOR_KEY.PASSWORD, 'custom-password-expiry-warning')
							),
							(0, c.default)(
								u,
								d.FORMS.RESET_AUTHENTICATOR,
								(0, c.default)({}, d.AUTHENTICATOR_KEY.PASSWORD, 'forgot-password')
							),
							(0, c.default)(
								u,
								d.FORMS.CONSENT_ADMIN,
								(0, c.default)({}, d.FORMS.CONSENT_ADMIN, 'admin-consent-required')
							),
							(0, c.default)(
								u,
								d.FORMS.CONSENT_ENDUSER,
								(0, c.default)({}, d.FORMS.CONSENT_ENDUSER, 'consent-required')
							),
							u),
						p = function (e, t, n, r) {
							if (r && e === d.FORMS.IDENTIFY) return 'forgot-password';
							var o = e;
							return (
								t === d.AUTHENTICATOR_KEY.PHONE ? (o = ''.concat(n)) : t && (o = ''.concat(t)),
								f[e] && f[e][o] ? f[e][o] : null
							);
						};
					t.getV1ClassName = p;
					t.getClassNameMapping = function (e, t, n, r) {
						var o = e;
						t && (o = o + '--' + t);
						var i = p(e, t, n, r),
							a = [o];
						return i && a.push(i), a;
					};
				},
				43318: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 });
					var o = {};
					t.default = void 0;
					var i = n(6475),
						a = r(n(36894)),
						s = n(13955),
						l = n(19596);
					Object.keys(l).forEach(function (e) {
						'default' !== e &&
							'__esModule' !== e &&
							(Object.prototype.hasOwnProperty.call(o, e) ||
								(e in t && t[e] === l[e]) ||
								Object.defineProperty(t, e, {
									enumerable: !0,
									get: function () {
										return l[e];
									},
								}));
					});
					var u = function e(t, n) {
						var r, o;
						if (!(!1 === n.mutable && n.name.indexOf('questionKey') < 0)) {
							a.default.info('i18n label transformer'),
								a.default.info('\t remediationName: ', t.name),
								a.default.info('\t uiSchema: ', JSON.stringify(n));
							var u =
									null === (r = t.relatesTo) || void 0 === r || null === (o = r.value) || void 0 === o ? void 0 : o.key,
								c = u ? '.'.concat(t.relatesTo.value.key) : '',
								d = ''.concat(t.name).concat(c, '.'),
								f = ''.concat(d).concat(n.name);
							if (
								('text' === n.type &&
									n.name.indexOf('questionKey') >= 0 &&
									'custom' !== n.value &&
									(f = ''.concat(f, '.').concat(n.value)),
								'checkbox' === n.type &&
									n.placeholder &&
									(a.default.info('\t 1: ', f), (n.placeholder = (0, l.getI18NValue)(f, n.placeholder))),
								n.label)
							) {
								a.default.info('\t 2: ', f);
								var p = (0, l.getI18NParams)(t, u);
								n.label = n.customLabel ? n.label : (0, l.getI18NValue)(f, n.label, p);
							}
							i.$.isPlainObject(n.options) &&
								(n.options = i._.mapObject(n.options, function (e, t) {
									var n = ''.concat(f, '.').concat(t);
									return a.default.info('\t 3: ', n), (0, l.getI18NValue)(n, e);
								})),
								Array.isArray(n.options) &&
									n.options.forEach(function (e) {
										if (e.label) {
											var t;
											if (e.authenticatorKey) {
												var n;
												t = ''.concat(f, '.').concat(e.authenticatorKey);
												var r = null === (n = e.value) || void 0 === n ? void 0 : n.methodType;
												e.authenticatorKey === s.AUTHENTICATOR_KEY.OV && r && (t = ''.concat(t, '.').concat(r));
											} else
												t =
													'string' == typeof e.value || 'number' == typeof e.value
														? ''.concat(f, '.').concat(e.value)
														: f;
											a.default.info('\t 4: ', t), (e.label = (0, l.getI18NValue)(t, e.label));
										}
									}),
								Array.isArray(n.optionsUiSchemas) &&
									n.optionsUiSchemas.forEach(function (n) {
										n.forEach(function (n) {
											return e(t, n);
										});
									});
						}
					};
					t.default = function (e) {
						var t;
						return (
							Array.isArray(e.remediations) &&
								e.remediations
									.filter(function (e) {
										return Array.isArray(e.uiSchema) && e.uiSchema.length;
									})
									.forEach(function (e) {
										e.uiSchema.forEach(function (t) {
											return u(e, t);
										});
									}),
							Array.isArray(null === (t = e.messages) || void 0 === t ? void 0 : t.value) &&
								e.messages.value.forEach(function (e) {
									e.message = (0, l.getMessage)(e);
								}),
							e
						);
					};
				},
				19596: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.isCustomizedI18nKey =
							t.getMessageKey =
							t.getMessageFromBrowserError =
							t.getMessage =
							t.getI18nKey =
							t.getI18NValue =
							t.getI18NParams =
							t.doesI18NKeyExist =
								void 0);
					var o,
						i = r(n(15985)),
						a = r(n(52115)),
						s = r(n(36894)),
						l = n(71244),
						u = n(25795),
						c = n(13955),
						d = n(60296);
					function f(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					var p = 'authfactor.webauthn.error',
						h = [
							'enroll-authenticator.security_question.credentials.questionKey.',
							'challenge-authenticator.security_question.credentials.questionKey.',
						],
						m = (function (e) {
							for (var t = 1; t < arguments.length; t++) {
								var n = null != arguments[t] ? arguments[t] : {};
								t % 2
									? f(Object(n), !0).forEach(function (t) {
											(0, i.default)(e, t, n[t]);
									  })
									: Object.getOwnPropertyDescriptors
									? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
									: f(Object(n)).forEach(function (t) {
											Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
									  });
							}
							return e;
						})(
							{
								'identify.identifier': 'primaryauth.username.placeholder',
								'select-authenticator-unlock-account.identifier': 'primaryauth.username.placeholder',
								'unlock-account.identifier': 'primaryauth.username.placeholder',
								'identify.credentials.passcode': 'primaryauth.password.placeholder',
								'identify.rememberMe': 'oie.remember',
								'enroll-profile.userProfile.rememberMe': 'oie.remember',
								'identify-recovery.identifier': 'password.forgot.email.or.username.placeholder',
								'select-authenticator-enroll.authenticator.duo': 'factor.duo',
								'select-authenticator-enroll.authenticator.google_otp': 'oie.google_authenticator.label',
								'select-authenticator-enroll.authenticator.okta_email': 'oie.email.label',
								'select-authenticator-enroll.authenticator.okta_password': 'oie.password.label',
								'select-authenticator-enroll.authenticator.okta_verify': 'oie.okta_verify.label',
								'select-authenticator-enroll.authenticator.phone_number': 'oie.phone.label',
								'select-authenticator-enroll.authenticator.rsa_token': 'factor.totpHard.rsaSecurId',
								'select-authenticator-enroll.authenticator.security_question': 'oie.security.question.label',
								'select-authenticator-enroll.authenticator.symantec_vip': 'factor.totpHard.symantecVip',
								'select-authenticator-enroll.authenticator.webauthn': 'oie.webauthn.label',
								'select-authenticator-enroll.authenticator.yubikey_token': 'oie.yubikey.label',
								'select-authenticator-authenticate.authenticator.duo': 'factor.duo',
								'select-authenticator-authenticate.authenticator.google_otp': 'oie.google_authenticator.label',
								'select-authenticator-authenticate.authenticator.okta_email': 'oie.email.label',
								'select-authenticator-authenticate.authenticator.okta_password': 'oie.password.label',
								'select-authenticator-authenticate.authenticator.okta_verify.push': 'oie.okta_verify.push.title',
								'select-authenticator-authenticate.authenticator.okta_verify.signed_nonce':
									'oie.okta_verify.signed_nonce.label',
								'select-authenticator-authenticate.authenticator.okta_verify.totp': 'oie.okta_verify.totp.title',
								'select-authenticator-authenticate.authenticator.phone_number': 'oie.phone.label',
								'select-authenticator-authenticate.authenticator.rsa_token': 'factor.totpHard.rsaSecurId',
								'select-authenticator-authenticate.authenticator.security_question': 'oie.security.question.label',
								'select-authenticator-authenticate.authenticator.symantec_vip': 'factor.totpHard.symantecVip',
								'select-authenticator-authenticate.authenticator.webauthn': 'oie.webauthn.label',
								'select-authenticator-authenticate.authenticator.yubikey_token': 'oie.yubikey.label',
								'select-authenticator-authenticate.authenticator.custom_app': 'oie.custom.app.authenticator.title',
								'select-authenticator-unlock-account.authenticator.okta_email': 'oie.email.label',
								'select-authenticator-unlock-account.authenticator.phone_number': 'oie.phone.label',
								'select-authenticator-unlock-account.authenticator.okta_verify.push': 'oie.okta_verify.push.title',
								'authenticator-verification-data.okta_verify.authenticator.methodType.signed_nonce':
									'oie.okta_verify.signed_nonce.label',
								'authenticator-verification-data.okta_verify.authenticator.methodType.push':
									'oie.okta_verify.push.title',
								'authenticator-verification-data.okta_verify.authenticator.methodType.totp':
									'oie.okta_verify.totp.title',
								'authenticator-enrollment-data.phone_number.authenticator.phoneNumber': 'mfa.phoneNumber.placeholder',
								'authenticator-enrollment-data.phone_number.authenticator.methodType.sms': 'oie.phone.enroll.sms.label',
								'authenticator-enrollment-data.phone_number.authenticator.methodType.voice':
									'oie.phone.enroll.voice.label',
								'enroll-authenticator.okta_password.credentials.passcode': 'oie.password.passwordLabel',
								'enroll-authenticator.okta_email.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
								'enroll-authenticator.phone_number.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
								'enroll-authenticator.security_question.sub_schema_local_credentials.0':
									'oie.security.question.questionKey.label',
								'enroll-authenticator.security_question.sub_schema_local_credentials.1':
									'oie.security.question.createQuestion.label',
								'enroll-authenticator.security_question.credentials.answer': 'mfa.challenge.answer.placeholder',
								'enroll-authenticator.security_question.credentials.question':
									'oie.security.question.createQuestion.label',
								'enroll-authenticator.security_question.credentials.questionKey':
									'oie.security.question.questionKey.label',
								'enroll-authenticator.google_otp.credentials.passcode': 'oie.google_authenticator.otp.enterCodeText',
								'enroll-authenticator.onprem_mfa.credentials.clientData': 'enroll.onprem.username.placeholder',
								'enroll-authenticator.onprem_mfa.credentials.passcode': 'enroll.onprem.passcode.placeholder',
								'enroll-authenticator.rsa_token.credentials.clientData': 'enroll.onprem.username.placeholder',
								'enroll-authenticator.rsa_token.credentials.passcode': 'enroll.onprem.passcode.placeholder',
								'enroll-authenticator.symantec_vip.credentials.credentialId':
									'enroll.symantecVip.credentialId.placeholder',
								'enroll-authenticator.symantec_vip.credentials.passcode': 'enroll.symantecVip.passcode1.placeholder',
								'enroll-authenticator.symantec_vip.credentials.nextPasscode':
									'enroll.symantecVip.passcode2.placeholder',
								'enroll-authenticator.yubikey_token.credentials.passcode': 'oie.yubikey.passcode.label',
								'enrollment-channel-data.email': 'oie.enroll.okta_verify.channel.email.label',
								'enrollment-channel-data.phoneNumber': 'mfa.phoneNumber.placeholder',
								'select-enrollment-channel.authenticator.channel.qrcode':
									'oie.enroll.okta_verify.select.channel.qrcode.label',
								'select-enrollment-channel.authenticator.channel.email':
									'oie.enroll.okta_verify.select.channel.email.label',
								'select-enrollment-channel.authenticator.channel.sms':
									'oie.enroll.okta_verify.select.channel.sms.label',
								'challenge-authenticator.okta_email.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
								'challenge-authenticator.okta_password.credentials.passcode': 'mfa.challenge.password.placeholder',
								'challenge-authenticator.phone_number.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
								'challenge-authenticator.security_question.credentials.answer': 'mfa.challenge.answer.placeholder',
								'challenge-authenticator.okta_verify.credentials.totp': 'oie.okta_verify.totp.enterCodeText',
								'challenge-authenticator.google_otp.credentials.passcode': 'oie.google_authenticator.otp.enterCodeText',
								'challenge-authenticator.onprem_mfa.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
								'challenge-authenticator.rsa_token.credentials.passcode': 'mfa.challenge.enterCode.placeholder',
								'challenge-authenticator.custom_otp.credentials.passcode': 'oie.custom_otp.verify.passcode.label',
								'challenge-authenticator.symantec_vip.credentials.passcode': 'oie.symantecVip.verify.passcode.label',
								'challenge-authenticator.yubikey_token.credentials.passcode': 'oie.yubikey.passcode.label',
								'challenge-authenticator.credentials.passcode': 'oie.password.label',
								'reset-authenticator.okta_password.credentials.passcode': 'oie.password.newPasswordLabel',
								'reset-authenticator.okta_password.confirmPassword': 'oie.password.confirmPasswordLabel',
								'reset-authenticator.okta_password.credentials.revokeSessions': 'password.reset.revokeSessions',
								'reenroll-authenticator.okta_password.credentials.passcode': 'oie.password.newPasswordLabel',
								'reenroll-authenticator.okta_password.confirmPassword': 'oie.password.confirmPasswordLabel',
								'reenroll-authenticator.okta_password.credentials.revokeSessions': 'password.reset.revokeSessions',
								'reenroll-authenticator-warning.okta_password.credentials.passcode': 'oie.password.newPasswordLabel',
								'reenroll-authenticator-warning.okta_password.confirmPassword': 'oie.password.confirmPasswordLabel',
								'reenroll-authenticator-warning.okta_password.credentials.revokeSessions':
									'password.reset.revokeSessions',
								'enroll-authenticator.okta_password.confirmPassword': 'oie.password.confirmPasswordLabel',
								'enroll-authenticator.okta_password.credentials.revokeSessions': 'password.reset.revokeSessions',
								'incorrectPassword': 'oie.password.incorrect.message',
								'profile-update.userProfile.secondEmail': 'oie.user.profile.secondary.email',
								'user-code.userCode': 'device.code.activate.label',
								'api.authn.poll.error.push_rejected': 'oktaverify.rejected',
								'oie.authenticator.duo.method.duo.verification_timeout': 'oie.authenticator.duo.error',
								'oie.authenticator.duo.method.duo.verification_failed': 'oie.authenticator.duo.error',
								'idx.email.verification.required': 'registration.complete.confirm.text',
								'tooManyRequests': 'oie.tooManyRequests',
								'api.users.auth.error.POST_PASSWORD_UPDATE_AUTH_FAILURE': 'oie.post.password.update.auth.failure.error',
								'security.access_denied': 'errors.E0000006',
								'E0000009': 'errors.E0000009',
								'E0000020': 'errors.E0000020',
								'api.factors.error.sms.invalid_phone': 'oie.phone.invalid',
								'app.ldap.password.reset.failed': 'errors.E0000017',
								'oie.selfservice.unlock_user.challenge.failed.permissions': 'errors.E0000006',
								'core.auth.factor.signedNonce.error.invalidEnrollment': 'core.auth.factor.signedNonce.error',
								'core.auth.factor.signedNonce.error.invalidFactor': 'core.auth.factor.signedNonce.error',
								'core.auth.factor.signedNonce.error.deletedDevice': 'core.auth.factor.signedNonce.error',
								'core.auth.factor.signedNonce.error.invalidDeviceStatus':
									'core.auth.factor.signedNonce.error.invalidDevice',
								'challenge-poll.custom_app.autoChallenge': 'autoPush',
								'challenge-poll.okta_verify.autoChallenge': 'autoPush',
								'authenticator-verification-data.authenticator.autoChallenge': 'autoPush',
								'authenticator-verification-data.okta_verify.authenticator.autoChallenge': 'autoPush',
								'authenticator-verification-data.custom_app.authenticator.autoChallenge': 'autoPush',
							},
							d.I18N_BASE_ATTRIBUTE_ENROLL_PROFILE_MAPPINGS
						),
						v = (0, i.default)(
							{},
							c.FORMS.ENROLL_AUTHENTICATOR,
							((o = {}),
							(0, i.default)(o, c.AUTHENTICATOR_KEY.ON_PREM, { getParam: u.getAuthenticatorDisplayName }),
							(0, i.default)(o, c.AUTHENTICATOR_KEY.RSA, { getParam: u.getAuthenticatorDisplayName }),
							o)
						),
						g = {
							'registration.error.invalidLoginEmail': { Email: 'Email' },
							'registration.error.doesNotMatchPattern': { Email: 'Email' },
							'registration.error.notUniqueWithinOrg': { Email: 'Email' },
						};
					t.getI18NParams = function (e, t) {
						var n = [],
							r = e.name;
						if (v[r] && v[r][t]) {
							var o = v[r][t].getParam(e);
							n.push(o);
						}
						return n;
					};
					var y = function (e) {
						var t;
						return (
							h.forEach(function (n) {
								if (0 === e.indexOf(n)) {
									var r = e.replace(n, '');
									t = 'security.'.concat(r);
								}
							}),
							m[e] && (t = m[e]),
							t &&
								!a.default.login[t] &&
								(s.default.warn('expect i18n key '.concat(t, ' for ').concat(e, " but not found in 'login' bundle.")),
								(t = null)),
							t
						);
					};
					t.getI18nKey = y;
					t.doesI18NKeyExist = function (e) {
						return !!a.default.login[e];
					};
					t.getI18NValue = function (e, t) {
						var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
							r = y(e);
						return r
							? (0, l.loc)(r, 'login', n)
							: (s.default.warn('Avoid rendering unlocalized text sent from the API: '.concat(t)), t);
					};
					t.getMessage = function (e) {
						var t;
						if (null !== (t = e.i18n) && void 0 !== t && t.key) {
							var n,
								r,
								o = e.i18n.key,
								i = e.i18n.params || [];
							if (
								(1 === i.length && '' === i[0] && (i = []), m[null === (n = e.i18n) || void 0 === n ? void 0 : n.key])
							)
								o = m[null === (r = e.i18n) || void 0 === r ? void 0 : r.key];
							else if (g[o]) {
								var u,
									c = null === (u = e.i18n.params) || void 0 === u ? void 0 : u[0];
								(o = (function (e, t) {
									var n = e;
									return g[n][t] ? (n += '.'.concat(t)) : (n += '.custom'), n;
								})(o, c)),
									(i = o.endsWith('custom') ? [c] : []);
							}
							if (a.default.login[o])
								return s.default.info('Override messages using i18n key '.concat(o)), (0, l.loc)(o, 'login', i);
							if (
								(function (e) {
									return e.startsWith(p);
								})(o)
							)
								return (0, l.loc)(p, 'login');
							if (o.startsWith('device.assurance.custom.remediation.')) return e.message;
						}
						return s.default.warn('Avoid rendering unlocalized text sent from the API: '.concat(e.message)), e.message;
					};
					t.getMessageFromBrowserError = function (e) {
						if (e.name) {
							var t = 'oie.browser.error.'.concat(e.name);
							if (a.default.login[t])
								return s.default.info('Override messages using i18n key '.concat(t)), (0, l.loc)(t, 'login');
						}
						return e.message;
					};
					t.getMessageKey = function (e) {
						var t;
						return (null == e || null === (t = e.i18n) || void 0 === t ? void 0 : t.key) || '';
					};
					t.isCustomizedI18nKey = function (e, t) {
						var n = t.get('languageCode'),
							r = t.get('i18n');
						return !!(r && r[n] && r[n][e]);
					};
				},
				74600: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(15985)),
						i = r(n(12990)),
						a = n(13955);
					function s(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function l(e) {
						for (var t = 1; t < arguments.length; t++) {
							var n = null != arguments[t] ? arguments[t] : {};
							t % 2
								? s(Object(n), !0).forEach(function (t) {
										(0, o.default)(e, t, n[t]);
								  })
								: Object.getOwnPropertyDescriptors
								? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
								: s(Object(n)).forEach(function (t) {
										Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
								  });
						}
						return e;
					}
					var u = function e(t) {
							var n = {};
							return (
								Object.keys(t).forEach(function (r) {
									if ('object' === (0, i.default)(t[r])) {
										var o = e(t[r]);
										Object.keys(o).forEach(function (e) {
											n[r + '.' + e] = o[e];
										});
									} else n[r] = t[r];
								}),
								n
							);
						},
						c = (0, o.default)({}, a.FORMS.CONSENT_GRANULAR, function (e) {
							return e.optedScopes && 'string' != typeof e.optedScopes
								? l(l({}, e), {}, { optedScopes: u(e.optedScopes) })
								: e;
						}),
						d = function (e, t) {
							var n = t.toJSON(),
								r = c[e];
							return void 0 === r ? n : r(n);
						};
					(t.default = d), (e.exports = t.default);
				},
				31639: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(31752)),
						i = n(6475),
						a = n(13955),
						s = function (e) {
							return i._.isObject(e);
						},
						l = function (e) {
							return !!e.messages;
						},
						u = function (e) {
							var t = {};
							return (
								i._.each(e, function () {
									var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
										n = arguments.length > 1 ? arguments[1] : void 0;
									'remediation' !== n &&
										('array' === e.type && (t[n] = { value: e.value }), 'object' === e.type && (t[n] = e.value));
								}),
								t
							);
						},
						c = function (e) {
							var t = [],
								n = 1 === e.neededToProceed.length && 'skip' === e.neededToProceed[0].name;
							return (
								(i._.isEmpty(e.neededToProceed) || n) &&
									(e.context.success
										? t.push({ name: e.context.success.name, href: e.context.success.href, value: [] })
										: e.context.messages
										? t.push({ name: a.FORMS.TERMINAL, value: [] })
										: e.context.deviceEnrollment && t.push({ name: a.FORMS.DEVICE_ENROLLMENT_TERMINAL, value: [] })),
								{ remediations: [].concat(t, (0, o.default)(e.neededToProceed)) }
							);
						},
						d = function (e, t) {
							var n = t.remediations;
							if (
								0 ===
								n.filter(function (e) {
									return 'identify' === e.name;
								}).length
							)
								return t;
							var r = e.get('idps');
							if (Array.isArray(r)) {
								var o = {};
								n.forEach(function (e) {
									e.name === a.FORMS.REDIRECT_IDP && e.idp && (o[e.idp.id] = !0);
								});
								var i = e.get('baseUrl'),
									s = t.idx.context.stateHandle,
									l = r
										.filter(function (e) {
											return !o[e.id];
										})
										.map(function (e) {
											var t = { id: e.id, name: e.text },
												n = ''.concat(i, '/sso/idps/').concat(e.id, '?stateToken=').concat(s);
											return (
												e.className && (t.className = e.className),
												{ name: a.FORMS.REDIRECT_IDP, type: e.type, idp: t, href: n }
											);
										});
								t.remediations = n.concat(l);
							}
							return t;
						},
						f = function (e, t, n) {
							if (Array.isArray(t.remediations)) {
								var r = t.remediations.filter(function (e) {
									return e.name === a.FORMS.REDIRECT_IDP;
								});
								if (1 !== r.length || 1 !== t.remediations.length) return;
								if (e.get('oauth2Enabled') && !n) return;
								var o = { name: a.FORMS.SUCCESS_REDIRECT, href: r[0].href, value: [] };
								t.remediations = [o];
							}
						},
						p = function (e) {
							Array.isArray(e.remediations) &&
								e.remediations.forEach(function (t) {
									var n, r;
									if (
										t.name === a.FORMS.REDIRECT_IDP &&
										(null == t || null === (n = t.relatesTo) || void 0 === n || null === (r = n.value) || void 0 === r
											? void 0
											: r.key) === a.AUTHENTICATOR_KEY.IDP
									) {
										var o = Object.prototype.hasOwnProperty.call(e, 'currentAuthenticatorEnrollment');
										t.name = o ? 'challenge-authenticator' : 'enroll-authenticator';
									}
									t.name === a.FORMS.REDIRECT_IDP && t.type === a.IDP_FORM_TYPE.X509 && (t.name = a.FORMS.PIV_IDP);
								});
						},
						h = function (e) {
							var t = e.idx.context;
							return t.failure && 'failure-redirect' === t.failure.name;
						},
						m = function (e, t) {
							var n = t.idx.context,
								r = e.get('oauth2Enabled'),
								o = 'always' === e.get('redirect');
							if (!r || o) {
								var i = { name: a.FORMS.FAILURE_REDIRECT, href: n.failure.href, value: [] };
								t.remediations = [i];
							}
						},
						v = function (e) {
							var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
								n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
							if (!s(t.rawIdxState)) return null;
							var r = u(t.rawIdxState),
								o = c(t),
								i = Object.assign({}, r, o, { idx: t });
							return l(i) && h(i) && m(e, i), d(e, i), p(i), l(i) || f(e, i, n), i;
						};
					(t.default = v), (e.exports = t.default);
				},
				58937: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.default = function (e, t, n) {
							return o._.compose(s.default, a.default.bind({}, e), i.default.bind({}, e))(t, n);
						});
					var o = n(6475),
						i = r(n(31639)),
						a = r(n(67285)),
						s = r(n(43318));
					e.exports = t.default;
				},
				65298: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(13955),
						o = n(6475),
						i = function (e, t) {
							var n, i, a, s, l, u, c, d, f, p, h;
							if ([r.FORMS.CONSENT_ENDUSER, r.FORMS.CONSENT_ADMIN].includes(t.name)) {
								var m = t.scopes.map(function (e) {
									return { name: e.name, displayName: e.label, description: e.desc };
								});
								return { type: t.name, scopes: m, options: e.options };
							}
							return Array.isArray(e.options) &&
								'radio' ===
									(null === (n = e.options[0]) ||
									void 0 === n ||
									null === (i = n.value) ||
									void 0 === i ||
									null === (a = i.value) ||
									void 0 === a
										? void 0
										: a.inputType)
								? ((p = (f = e).label),
								  (h = f.required),
								  {
										displayName: p,
										type: 'radio',
										required: h,
										options: f.options[0].value.value.options,
										sublabel: h ? null : (0, o.loc)('oie.form.field.optional', 'login'),
								  })
								: Array.isArray(e.options) &&
								  'checkbox' ===
										(null === (s = e.options[0]) ||
										void 0 === s ||
										null === (l = s.value) ||
										void 0 === l ||
										null === (u = l.value) ||
										void 0 === u
											? void 0
											: u.inputType)
								? {
										placeholder: (d = e).label,
										label: !1,
										modelType: d.type,
										type: 'checkbox',
										required: !0,
										value: !1,
								  }
								: {
										placeholder: (c = e).label,
										label: !1,
										modelType: c.type,
										type: 'checkbox',
										required: c.required || !1,
								  };
						};
					(t.default = i), (e.exports = t.default);
				},
				3877: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.createOVOptions = l),
						(t.default = function (e, t, n, r, o) {
							var i = {};
							'authenticator' !== e.name ||
							('select-authenticator-authenticate' !== t.name && 'select-authenticator-unlock-account' !== t.name)
								? 'authenticator' === e.name && 'select-authenticator-enroll' === t.name
									? Object.assign(i, { type: 'authenticatorEnrollSelect', options: u(e.options) })
									: Array.isArray(e.options) &&
									  ((i.optionsUiSchemas = e.options.map(function (t) {
											return r(n, { value: [{ name: e.name, value: t.value }] }, o);
									  })),
									  (i.options = e.options.map(function (e, t) {
											return { label: e.label, value: t };
									  })),
									  (i.type = 'radio'),
									  (i.value = '0'),
									  (i.name = 'sub_schema_local_'.concat(e.name)))
								: Object.assign(i, { type: 'authenticatorVerifySelect', options: u(e.options) });
							return i;
						});
					var o = r(n(15985)),
						i = r(n(31752)),
						a = n(6475),
						s = n(13955);
					function l() {
						var e,
							t,
							n,
							r,
							o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
							l = o.find(function (e) {
								return e.relatesTo.key === s.AUTHENTICATOR_KEY.OV;
							}),
							u =
								null == l ||
								null === (e = l.value) ||
								void 0 === e ||
								null === (t = e.form) ||
								void 0 === t ||
								null === (n = t.value) ||
								void 0 === n
									? void 0
									: n.find(function (e) {
											return 'methodType' === e.name;
									  }),
							c = null == u ? void 0 : u.options;
						if (c) {
							var d = [];
							c.forEach(function (e) {
								var t = (0, i.default)(l.value.form.value),
									n = l.value.form.value.findIndex(function (e) {
										return 'methodType' === e.name;
									}),
									o = Object.assign(a._.omit(u, 'options'), e);
								(o.required = !0), (o.mutable = !1), t.splice(n, 1, o);
								var s = Object.assign({}, l, { label: e.label, value: { form: { value: t } } });
								'signed_nonce' === e.value ? (r = s) : d.push(s);
							});
							var f = o.findIndex(function (e) {
								return e.relatesTo.key === s.AUTHENTICATOR_KEY.OV;
							});
							o.splice.apply(o, [f, 1].concat(d)), r && (l.relatesTo.deviceKnown ? o.unshift(r) : o.push(r));
						}
					}
					function u() {
						var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
						return (
							l(e),
							e.map(function (e) {
								var t,
									n,
									r,
									i = (
										(null === (t = e.value) || void 0 === t || null === (n = t.form) || void 0 === n
											? void 0
											: n.value) || []
									)
										.filter(function (e) {
											return !0 === e.required && !1 === e.mutable;
										})
										.reduce(function (e, t) {
											return Object.assign(e, (0, o.default)({}, t.name, t.value));
										}, {});
								return {
									label: e.label,
									value: i,
									relatesTo: e.relatesTo,
									authenticatorKey: null === (r = e.relatesTo) || void 0 === r ? void 0 : r.key,
								};
							})
						);
					}
				},
				71067: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(13955),
						a = r(n(73390)),
						s = r(n(77653)),
						l = function (e) {
							var t = {};
							return (
								e.forEach(function (e) {
									var n = e.value,
										r = e.label;
									t[n] = r;
								}),
								t
							);
						},
						u = { type: 'select', wide: !0 },
						c = ['text', 'radio', 'select'],
						d = function (e, t, n, r, d) {
							var f,
								p = { type: 'text' };
							if (
								(!0 === e.secret &&
									Object.assign(
										p,
										(function (e) {
											return { type: 'password', params: { showPasswordToggle: e.get('showPasswordToggle') } };
										})(d)
									),
								e.hint === i.HINTS.CAPTCHA && Object.assign(p, { type: 'captcha' }),
								'userProfile.timezone' === e.name &&
									(Object.assign(p, u), (p.options = Object.assign({ '': '' }, s.default))),
								Array.isArray(e.options) && e.options[0] && e.options[0].value)
							) {
								var h = e.options[0];
								'display' === h.label
									? (function (e, t) {
											var n,
												r = null == t || null === (n = t.value) || void 0 === n ? void 0 : n.value;
											(e.type = r.inputType),
												'radio' === r.inputType
													? (e.options = r.options)
													: 'select' === r.inputType &&
													  ((e.wide = !0),
													  r.format === i.ATTR_FORMAT.COUNTRY_CODE
															? (e.options = Object.assign({ '': '' }, a.default.getCountryCode()))
															: (e.options = Object.assign({ '': '' }, l(r.options))));
									  })(p, h)
									: (f = e.name).indexOf('methodType') >= 0 || f.indexOf('channel') >= 0
									? (function (e, t) {
											(e.type = 'radio'), (t.value = t.options[0].value);
									  })(p, e)
									: ((p.type = 'select'), (p.wide = !0), (p.options = l(e.options)));
							}
							return (
								!1 === e.required &&
									c.includes(p.type) &&
									(p.sublabel = (0, o.loc)('oie.form.field.optional', 'login')),
								p
							);
						};
					(t.default = d), (e.exports = t.default);
				},
				67285: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(65298)),
						a = r(n(3877)),
						s = { string: r(n(71067)).default, boolean: i.default, object: a.default },
						l = function e(t, n, r) {
							return o._.chain(n.value || [])
								.filter(function (e) {
									return !1 !== e.visible;
								})
								.map(function (e) {
									var t, n;
									if (
										(e.form ? (n = e.form) : null !== (t = e.value) && void 0 !== t && t.form && (n = e.value.form), n)
									) {
										var r = e.name;
										return n.value.map(function (e) {
											return Object.assign({}, e, { name: r + '.' + e.name });
										});
									}
									return e;
								})
								.flatten()
								.value()
								.map(function (o) {
									var i = { 'label-top': !0, 'multirowError': !0, 'data-se': 'o-form-fieldset-'.concat(o.name) },
										a = o.type || 'string',
										l = (0, s[a])(o, n, t, e, r);
									return Object.assign({}, o, i, l);
								});
						},
						u = function (e, t) {
							return (
								t &&
									(t.remediations = t.remediations.map(function (n) {
										return (n.uiSchema = l(t, n, e)), n;
									})),
								t
							);
						};
					(t.default = u), (e.exports = t.default);
				},
				75888: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = n(13955),
						s = r(n(30471)),
						l = n(86725),
						u = i.View.extend({
							className: 'authenticator-row clearfix',
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s = e.hooks.helperMissing,
										l = e.escapeExpression,
										u =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="factor-icon authenticator-icon ' +
										l(
											'function' ==
												typeof (i =
													null != (i = u(n, 'iconClassName') || (null != t ? u(t, 'iconClassName') : t)) ? i : s)
												? i.call(a, {
														name: 'iconClassName',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 100 }, end: { line: 1, column: 117 } },
												  })
												: i
										) +
										' custom-app-logo" role="img" aria-label="' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.auth.logo.aria.label' },
												data: o,
												loc: { start: { line: 1, column: 158 }, end: { line: 1, column: 213 } },
											})
										) +
										'"></div>'
									);
								},
								3: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s = e.hooks.helperMissing,
										l = e.escapeExpression,
										u =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="factor-icon authenticator-icon ' +
										l(
											'function' ==
												typeof (i =
													null != (i = u(n, 'iconClassName') || (null != t ? u(t, 'iconClassName') : t)) ? i : s)
												? i.call(a, {
														name: 'iconClassName',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 272 }, end: { line: 1, column: 289 } },
												  })
												: i
										) +
										'" role="img" aria-label="' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.auth.logo.aria.label' },
												data: o,
												loc: { start: { line: 1, column: 314 }, end: { line: 1, column: 369 } },
											})
										) +
										'"></div>'
									);
								},
								5: function (e, t, n, r, o) {
									var i,
										a,
										s = null != t ? t : e.nullContext || {},
										l =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<span class="authenticator-grace-period-required-icon"></span><div class="authenticator-grace-period-text-container"><p class="authenticator-grace-period-required-description">' +
										e.escapeExpression(
											'function' ==
												typeof (a =
													null !=
													(a =
														l(n, 'gracePeriodRequiredDescription') ||
														(null != t ? l(t, 'gracePeriodRequiredDescription') : t))
														? a
														: e.hooks.helperMissing)
												? a.call(s, {
														name: 'gracePeriodRequiredDescription',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 702 }, end: { line: 1, column: 736 } },
												  })
												: a
										) +
										'</p>' +
										(null !=
										(i = l(n, 'if').call(s, null != t ? l(t, 'gracePeriodExpiry') : t, {
											name: 'if',
											hash: {},
											fn: e.program(6, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 740 }, end: { line: 1, column: 847 } },
										}))
											? i
											: '') +
										'</div>'
									);
								},
								6: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p class="authenticator-grace-period-expiry-date">' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'gracePeriodExpiry') || (null != t ? a(t, 'gracePeriodExpiry') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'gracePeriodExpiry',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 815 }, end: { line: 1, column: 836 } },
												  })
												: i
										) +
										'</p>'
									);
								},
								8: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'description') : t, {
											name: 'if',
											hash: {},
											fn: e.program(9, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 861 }, end: { line: 1, column: 949 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'authenticatorUsageText') : t, {
											name: 'if',
											hash: {},
											fn: e.program(11, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 949 }, end: { line: 1, column: 1052 } },
										}))
											? i
											: '')
									);
								},
								9: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p class="authenticator-description--text">' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'description') || (null != t ? a(t, 'description') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'description',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 923 }, end: { line: 1, column: 938 } },
												  })
												: i
										) +
										'</p>'
									);
								},
								11: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p class="authenticator-usage-text">' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null !=
													(i = a(n, 'authenticatorUsageText') || (null != t ? a(t, 'authenticatorUsageText') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'authenticatorUsageText',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 1015 }, end: { line: 1, column: 1041 } },
												  })
												: i
										) +
										'</p>'
									);
								},
								13: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'data-se="' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'buttonDataSeAttr') || (null != t ? a(t, 'buttonDataSeAttr') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'buttonDataSeAttr',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 1126 }, end: { line: 1, column: 1146 } },
												  })
												: i
										) +
										'"'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a,
										s = null != t ? t : e.nullContext || {},
										l =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="authenticator-icon-container">' +
										(null !=
										(i = l(n, 'if').call(s, null != t ? l(t, 'logoUri') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.program(3, o, 0),
											data: o,
											loc: { start: { line: 1, column: 42 }, end: { line: 1, column: 384 } },
										}))
											? i
											: '') +
										'</div><div class="authenticator-description"><h3 class="authenticator-label no-translate">' +
										e.escapeExpression(
											'function' ==
												typeof (a =
													null != (a = l(n, 'label') || (null != t ? l(t, 'label') : t)) ? a : e.hooks.helperMissing)
												? a.call(s, {
														name: 'label',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 474 }, end: { line: 1, column: 483 } },
												  })
												: a
										) +
										'</h3>' +
										(null !=
										(i = l(n, 'if').call(s, null != t ? l(t, 'gracePeriodRequiredDescription') : t, {
											name: 'if',
											hash: {},
											fn: e.program(5, o, 0),
											inverse: e.program(8, o, 0),
											data: o,
											loc: { start: { line: 1, column: 488 }, end: { line: 1, column: 1059 } },
										}))
											? i
											: '') +
										'<div class="authenticator-button" ' +
										(null !=
										(i = l(n, 'if').call(s, null != t ? l(t, 'buttonDataSeAttr') : t, {
											name: 'if',
											hash: {},
											fn: e.program(13, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 1093 }, end: { line: 1, column: 1154 } },
										}))
											? i
											: '') +
										'></div></div>'
									);
								},
								useData: !0,
							}),
							postRender: function () {
								i.View.prototype.postRender.apply(this, arguments),
									this.model.get('logoUri') &&
										(this.el.querySelector('.custom-app-logo').style.backgroundImage = 'url('.concat(
											this.model.get('logoUri'),
											')'
										));
							},
							children: function () {
								return [
									[
										(0, i.createButton)({
											className: 'button select-factor',
											title: function () {
												return (0, i.loc)('oie.enroll.authenticator.button.text', 'login');
											},
											attributes: { 'aria-label': this.model.get('ariaLabel') },
											click: function () {
												this.model.trigger('selectAuthenticator', this.model.get('value'));
											},
										}),
										'.authenticator-button',
									],
								];
							},
							minimize: function () {
								this.$el.addClass('authenticator-row-min');
							},
							getTemplateData: function () {
								var e,
									t,
									n,
									r = this.model.get('relatesTo').allowedFor;
								if (r)
									switch (r) {
										case l.AUTHENTICATOR_ALLOWED_FOR_OPTIONS.ANY:
											n = (0, i.loc)('oie.enroll.authenticator.usage.text.access.recovery', 'login');
											break;
										case l.AUTHENTICATOR_ALLOWED_FOR_OPTIONS.RECOVERY:
											n = (0, i.loc)('oie.enroll.authenticator.usage.text.recovery', 'login');
											break;
										case l.AUTHENTICATOR_ALLOWED_FOR_OPTIONS.SSO:
											n = (0, i.loc)('oie.enroll.authenticator.usage.text.access', 'login');
									}
								var o = i.View.prototype.getTemplateData.apply(this, arguments),
									a = Date.now(),
									u = new Date(
										null === (e = this.model.get('relatesTo')) ||
										void 0 === e ||
										null === (t = e.gracePeriod) ||
										void 0 === t
											? void 0
											: t.expiry
									).getTime();
								if (!isNaN(u) && a < u) {
									var c = s.default.calculateDaysBetween(a, u);
									(o.gracePeriodRequiredDescription =
										1 === c
											? (0, i.loc)('oie.enrollment.policy.grace.period.required.in.one.day', 'login')
											: c > 1
											? (0, i.loc)('oie.enrollment.policy.grace.period.required.in.days', 'login', [c])
											: (0, i.loc)('oie.enrollment.policy.grace.period.required.today', 'login')),
										u &&
											(o.gracePeriodExpiry = s.default.formatDateToDeviceAssuranceGracePeriodExpiryLocaleString(
												new Date(u),
												this.settings.get('languageCode'),
												!1
											));
								}
								return (o.authenticatorUsageText = n), o;
							},
						}),
						c = i.ListView.extend({
							className: 'authenticator-enroll-list authenticator-list',
							item: u,
							itemSelector: '.list-content',
							initialize: function () {
								this.listenTo(this.collection, 'selectAuthenticator', function (e) {
									this.model.set(this.options.name, e), this.options.appState.trigger('saveForm', this.model);
								}),
									(this.hasOptionalFactors = this.options.appState.hasRemediationObject(a.FORMS.SKIP));
							},
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p class="authenticator-list-subtitle">' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'subtitle') || (null != t ? a(t, 'subtitle') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'subtitle',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 134 }, end: { line: 1, column: 146 } },
												  })
												: i
										) +
										'</p>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a,
										s = null != t ? t : e.nullContext || {},
										l =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="list-content"><div class="authenticator-list-title">' +
										e.escapeExpression(
											'function' ==
												typeof (a =
													null != (a = l(n, 'title') || (null != t ? l(t, 'title') : t)) ? a : e.hooks.helperMissing)
												? a.call(s, {
														name: 'title',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 64 }, end: { line: 1, column: 73 } },
												  })
												: a
										) +
										'</div>' +
										(null !=
										(i = l(n, 'if').call(s, null != t ? l(t, 'subtitle') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 79 }, end: { line: 1, column: 157 } },
										}))
											? i
											: '') +
										'</div>'
									);
								},
								useData: !0,
							}),
							getTemplateData: function () {
								var e = this.hasOptionalFactors
									? (0, i.loc)('oie.setup.optional', 'login')
									: (0, i.loc)('oie.setup.required', 'login');
								return { title: this.options.listTitle || e, subtitle: this.options.listSubtitle || null };
							},
						});
					(t.default = c), (e.exports = t.default);
				},
				82625: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(15985)),
						i = n(6475),
						a = n(13955),
						s = r(n(75888)),
						l = r(n(21876)),
						u = r(n(45112));
					function c(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function d(e) {
						for (var t = 1; t < arguments.length; t++) {
							var n = null != arguments[t] ? arguments[t] : {};
							t % 2
								? c(Object(n), !0).forEach(function (t) {
										(0, o.default)(e, t, n[t]);
								  })
								: Object.getOwnPropertyDescriptors
								? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
								: c(Object(n)).forEach(function (t) {
										Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
								  });
						}
						return e;
					}
					var f = i.View.extend({
						className: 'authenticator-enroll-list-container',
						initialize: function () {
							var e,
								t = [],
								n = [];
							this.options.optionItems.forEach(function (e) {
								var r, o, i, a;
								null !== (r = e.relatesTo) &&
								void 0 !== r &&
								null !== (o = r.gracePeriod) &&
								void 0 !== o &&
								o.expiry &&
								new Date(
									null === (i = e.relatesTo) || void 0 === i || null === (a = i.gracePeriod) || void 0 === a
										? void 0
										: a.expiry
								).getTime() > Date.now()
									? t.push(e)
									: n.push(e);
							}),
								(this.hasSkipRemediation = !!this.options.appState.hasRemediationObject(
									null === a.FORMS || void 0 === a.FORMS ? void 0 : a.FORMS.SKIP
								)),
								(this.hasOnlyOptional = this.hasSkipRemediation && 0 === (null == t ? void 0 : t.length)),
								(this.hasOnlyGracePeriod =
									this.hasSkipRemediation &&
									(null === (e = this.options.optionItems) || void 0 === e ? void 0 : e.length) ===
										(null == t ? void 0 : t.length)),
								n.length &&
									this.add(
										new s.default(
											d(
												d({}, this.options),
												{},
												{
													collection: new i.Collection(n),
													optionItems: n,
													listTitle: this.hasOnlyOptional
														? (0, i.loc)('oie.setup.optional.short', 'login')
														: (0, i.loc)('oie.setup.required.now', 'login'),
												}
											)
										)
									),
								t.length &&
									this.add(
										new s.default(
											d(
												d({}, this.options),
												{},
												{
													collection: new i.Collection(t),
													optionItems: t,
													listTitle: (0, i.loc)('oie.setup.required.soon', 'login'),
													listSubtitle: (0, i.loc)('oie.setup.required.soon.description', 'login'),
												}
											)
										)
									),
								this.hasOnlyGracePeriod ? this.add(l.default) : this.hasOnlyOptional && this.add(u.default);
						},
					});
					(t.default = f), (e.exports = t.default);
				},
				93831: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(17587),
						o = n(71101),
						i = r.BaseFooter.extend({
							links: function () {
								return (0, o.getFactorPageCustomLink)(this.options.appState, this.options.settings).concat(
									(0, o.getSwitchAuthenticatorLink)(this.options.appState)
								);
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				40647: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = a.View.extend({
							className: 'authenticator-row clearfix',
							template: i.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s = e.hooks.helperMissing,
										l = e.escapeExpression,
										u =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="factor-icon authenticator-icon ' +
										l(
											'function' ==
												typeof (i =
													null != (i = u(n, 'iconClassName') || (null != t ? u(t, 'iconClassName') : t)) ? i : s)
												? i.call(a, {
														name: 'iconClassName',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 100 }, end: { line: 1, column: 117 } },
												  })
												: i
										) +
										' custom-logo" role="img" aria-label="' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.auth.logo.aria.label' },
												data: o,
												loc: { start: { line: 1, column: 154 }, end: { line: 1, column: 209 } },
											})
										) +
										'"></div>'
									);
								},
								3: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s = e.hooks.helperMissing,
										l = e.escapeExpression,
										u =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="factor-icon authenticator-icon ' +
										l(
											'function' ==
												typeof (i =
													null != (i = u(n, 'iconClassName') || (null != t ? u(t, 'iconClassName') : t)) ? i : s)
												? i.call(a, {
														name: 'iconClassName',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 268 }, end: { line: 1, column: 285 } },
												  })
												: i
										) +
										'" role="img" aria-label="' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.auth.logo.aria.label' },
												data: o,
												loc: { start: { line: 1, column: 310 }, end: { line: 1, column: 365 } },
											})
										) +
										'"></div>'
									);
								},
								5: function (e, t, n, r, o) {
									return 'authenticator-label--small';
								},
								7: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p class="authenticator-description--text ' +
										c(
											((a =
												null != (a = d(n, 'noTranslateClassName') || (null != t ? d(t, 'noTranslateClassName') : t))
													? a
													: l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'noTranslateClassName',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 603 }, end: { line: 1, column: 627 } },
												  })
												: a)
										) +
										'">' +
										c(
											((a = null != (a = d(n, 'description') || (null != t ? d(t, 'description') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'description',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 629 }, end: { line: 1, column: 644 } },
												  })
												: a)
										) +
										'</p>'
									);
								},
								9: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p class="authenticator-enrollment-nickname ' +
										c(
											((a =
												null != (a = d(n, 'noTranslateClassName') || (null != t ? d(t, 'noTranslateClassName') : t))
													? a
													: l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'noTranslateClassName',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 715 }, end: { line: 1, column: 739 } },
												  })
												: a)
										) +
										'">' +
										c(
											((a = null != (a = d(n, 'nickname') || (null != t ? d(t, 'nickname') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'nickname',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 741 }, end: { line: 1, column: 753 } },
												  })
												: a)
										) +
										'</p>'
									);
								},
								11: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'data-se="' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'buttonDataSeAttr') || (null != t ? a(t, 'buttonDataSeAttr') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'buttonDataSeAttr',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 837 }, end: { line: 1, column: 857 } },
												  })
												: i
										) +
										'"'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a,
										s = null != t ? t : e.nullContext || {},
										l =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="authenticator-icon-container">' +
										(null !=
										(i = l(n, 'if').call(s, null != t ? l(t, 'logoUri') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.program(3, o, 0),
											data: o,
											loc: { start: { line: 1, column: 42 }, end: { line: 1, column: 380 } },
										}))
											? i
											: '') +
										'</div><div class="authenticator-description"><div><h3 class="authenticator-label no-translate ' +
										(null !=
										(i = l(n, 'if').call(s, null != t ? l(t, 'description') : t, {
											name: 'if',
											hash: {},
											fn: e.program(5, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 474 }, end: { line: 1, column: 526 } },
										}))
											? i
											: '') +
										'">' +
										e.escapeExpression(
											'function' ==
												typeof (a =
													null != (a = l(n, 'label') || (null != t ? l(t, 'label') : t)) ? a : e.hooks.helperMissing)
												? a.call(s, {
														name: 'label',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 528 }, end: { line: 1, column: 537 } },
												  })
												: a
										) +
										'</h3>' +
										(null !=
										(i = l(n, 'if').call(s, null != t ? l(t, 'description') : t, {
											name: 'if',
											hash: {},
											fn: e.program(7, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 542 }, end: { line: 1, column: 655 } },
										}))
											? i
											: '') +
										(null !=
										(i = l(n, 'if').call(s, null != t ? l(t, 'nickname') : t, {
											name: 'if',
											hash: {},
											fn: e.program(9, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 655 }, end: { line: 1, column: 764 } },
										}))
											? i
											: '') +
										'</div><div class="authenticator-button" ' +
										(null !=
										(i = l(n, 'if').call(s, null != t ? l(t, 'buttonDataSeAttr') : t, {
											name: 'if',
											hash: {},
											fn: e.program(11, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 804 }, end: { line: 1, column: 865 } },
										}))
											? i
											: '') +
										'></div></div>'
									);
								},
								useData: !0,
							}),
							postRender: function () {
								a.View.prototype.postRender.apply(this, arguments);
								var e = this.model.get('logoUri');
								e && (this.el.querySelector('.custom-logo').style.backgroundImage = 'url('.concat(e, ')'));
							},
							children: function () {
								return [
									[
										(0, a.createButton)({
											className: 'button select-factor',
											title: function () {
												return (0, a.loc)('oie.verify.authenticator.button.text', 'login');
											},
											attributes: { 'aria-label': this.model.get('ariaLabel') },
											click: function () {
												this.model.trigger('selectAuthenticator', this.model.get('value'));
											},
										}),
										'.authenticator-button',
									],
								];
							},
							minimize: function () {
								this.$el.addClass('authenticator-row-min');
							},
						}),
						l = a.ListView.extend({
							className: 'authenticator-verify-list authenticator-list',
							item: s,
							itemSelector: '.list-content',
							initialize: function () {
								this.listenTo(this.collection, 'selectAuthenticator', this.handleSelect),
									this.listenTo(this.model, 'invalid', this.handleModelInvalid);
							},
							handleModelInvalid: function (e, t) {
								this.options.name in t && !this.model.get(this.options.name) && this.showAuthenticatorRequiredError();
							},
							showAuthenticatorRequiredError: function () {
								var e =
									this.collection.length > 1
										? (0, a.loc)('account.unlock.authenticatorRequired.multiple', 'login')
										: (0, a.loc)('account.unlock.authenticatorRequired.single', 'login');
								this.model.trigger('error', this.model, { responseJSON: { errorSummary: e } });
							},
							handleSelect: function (e) {
								var t,
									n = this.model.validateField('identifier');
								this.model.trigger('clearFormError'),
									null !== (t = this.model.getPropertySchema('identifier')) && void 0 !== t && t.required && n
										? this.model.trigger('invalid', this.model, n)
										: (this.model.set(this.options.name, e), this.options.appState.trigger('saveForm', this.model));
							},
							template: i.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									return '<div class="list-content"></div>';
								},
								useData: !0,
							}),
						});
					(t.default = l), (e.exports = t.default);
				},
				83966: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = t.BaseAuthenticatorBeacon = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(93831)),
						s = r(n(99422)),
						l = n(25795),
						u = n(13955),
						c = s.default.extend({
							authenticatorKey: function () {
								return this.options.appState.get('authenticatorKey');
							},
							idvName: function () {
								var e,
									t,
									n =
										null === (e = this.options.appState.get('remediations')) || void 0 === e
											? void 0
											: e.find(function (e) {
													return e.name === u.FORMS.REDIRECT_IDVERIFY;
											  });
								return null == n || null === (t = n.idp) || void 0 === t ? void 0 : t.id;
							},
							getBeaconClassName: function () {
								var e = o._.result(this, 'authenticatorKey'),
									t = o._.result(this, 'idvName');
								return (0, l.getIconClassNameForBeacon)(e, t);
							},
						});
					t.BaseAuthenticatorBeacon = c;
					var d = i.BaseView.extend({ Header: i.BaseHeader.extend({ HeaderBeacon: c }), Footer: a.default });
					t.default = d;
				},
				9867: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(93831)),
						s = 'Okta_Authenticator',
						l = i.View.extend({
							id: 'help-description-container',
							className: 'help-description js-help-description',
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i = null != t ? t : e.nullContext || {},
										a = e.hooks.helperMissing,
										s = e.escapeExpression,
										l =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<h3>' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: {
													bundle: 'login',
													code: 'oie.verify.webauthn.cant.verify.biometric.authenticator.title',
												},
												data: o,
												loc: { start: { line: 1, column: 4 }, end: { line: 1, column: 96 } },
											})
										) +
										'</h3><br><p>' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: {
													bundle: 'login',
													code: 'oie.verify.webauthn.cant.verify.biometric.authenticator.description1',
												},
												data: o,
												loc: { start: { line: 1, column: 108 }, end: { line: 1, column: 207 } },
											})
										) +
										'</p><br><p>' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: {
													bundle: 'login',
													code: 'oie.verify.webauthn.cant.verify.biometric.authenticator.description2',
												},
												data: o,
												loc: { start: { line: 1, column: 218 }, end: { line: 1, column: 317 } },
											})
										) +
										'</p><br><h3>' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.verify.webauthn.cant.verify.security.key.title' },
												data: o,
												loc: { start: { line: 1, column: 329 }, end: { line: 1, column: 410 } },
											})
										) +
										'</h3><br><p>' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.verify.webauthn.cant.verify.security.key.description' },
												data: o,
												loc: { start: { line: 1, column: 422 }, end: { line: 1, column: 509 } },
											})
										) +
										'</p><br>'
									);
								},
								useData: !0,
							}),
						}),
						u = i.View.extend({
							id: 'help-description-container',
							className: 'help-description js-help-description',
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i = null != t ? t : e.nullContext || {},
										a = e.hooks.helperMissing,
										s = e.escapeExpression,
										l =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<ol class="ov-enrollment-info"><li>' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.verify.webauthn.cant.verify.enrollment.step1' },
												data: o,
												loc: { start: { line: 1, column: 35 }, end: { line: 1, column: 114 } },
											})
										) +
										'</li><br><li>' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.verify.webauthn.cant.verify.enrollment.step2' },
												data: o,
												loc: { start: { line: 1, column: 127 }, end: { line: 1, column: 206 } },
											})
										) +
										'</li><br><li>' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.verify.webauthn.cant.verify.enrollment.step3' },
												data: o,
												loc: { start: { line: 1, column: 219 }, end: { line: 1, column: 298 } },
											})
										) +
										'</li><br><li>' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.verify.webauthn.cant.verify.enrollment.step4' },
												data: o,
												loc: { start: { line: 1, column: 311 }, end: { line: 1, column: 390 } },
											})
										) +
										'</><br></ol>'
									);
								},
								useData: !0,
							}),
						}),
						c = a.default.extend({
							links: function () {
								var e = a.default.prototype.links.apply(this, arguments),
									t = this.options.appState.get('app') && this.options.appState.get('app').name === s ? u : l;
								return (
									e.unshift({
										'label': (0, i.loc)('oie.verify.webauthn.cant.verify', 'login'),
										'name': 'cant-verify',
										'aria-controls': 'help-description-container',
										'class': 'link help js-help',
										'type': 'toggle-text-link',
										'additionalOptions': { view: t, selector: '.js-help-description' },
									}),
									e
								);
							},
						});
					(t.default = c), (e.exports = t.default);
				},
				89597: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(17587),
						o = n(13955),
						i = n(83966),
						a = r.BaseHeader.extend({
							HeaderBeacon: i.BaseAuthenticatorBeacon.extend({ authenticatorKey: o.AUTHENTICATOR_KEY.EMAIL }),
						});
					(t.default = a), (e.exports = t.default);
				},
				99422: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = i.View.extend({
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s = e.hooks.helperMissing,
										l = e.escapeExpression,
										u =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="bg-helper auth-beacon auth-beacon-factor ' +
										l(
											'function' ==
												typeof (i = null != (i = u(n, 'className') || (null != t ? u(t, 'className') : t)) ? i : s)
												? i.call(a, {
														name: 'className',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 245 }, end: { line: 1, column: 258 } },
												  })
												: i
										) +
										' custom-app-logo" data-se="factor-beacon" role="img" aria-label="' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.auth.logo.aria.label' },
												data: o,
												loc: { start: { line: 1, column: 323 }, end: { line: 1, column: 378 } },
											})
										) +
										'">'
									);
								},
								3: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="bg-helper auth-beacon auth-beacon-factor ' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'className') || (null != t ? a(t, 'className') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'className',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 441 }, end: { line: 1, column: 454 } },
												  })
												: i
										) +
										'" data-se="factor-beacon">'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div data-type="beacon-container" class="beacon-container"><div class="beacon-blank auth-beacon"><div class="beacon-blank js-blank-beacon-border auth-beacon-border"></div></div>' +
										(null !=
										(i = a(n, 'if').call(null != t ? t : e.nullContext || {}, null != t ? a(t, 'logoUri') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.program(3, o, 0),
											data: o,
											loc: { start: { line: 1, column: 177 }, end: { line: 1, column: 487 } },
										}))
											? i
											: '') +
										'<div class="okta-sign-in-beacon-border auth-beacon-border"></div></div></div >'
									);
								},
								useData: !0,
							}),
							postRender: function () {
								i.View.prototype.postRender.apply(this, arguments);
								var e = this.getTemplateData();
								e.logoUri &&
									(this.el.querySelector('.custom-app-logo').style.backgroundImage = 'url('.concat(e.logoUri, ')'));
							},
							getTemplateData: function () {
								var e,
									t,
									n,
									r = null === (e = this.options) || void 0 === e ? void 0 : e.appState;
								return {
									className: this.getBeaconClassName() || '',
									logoUri:
										(null == r || null === (t = r.get('currentAuthenticator')) || void 0 === t ? void 0 : t.logoUri) ||
										(null == r || null === (n = r.get('currentAuthenticatorEnrollment')) || void 0 === n
											? void 0
											: n.logoUri),
								};
							},
							getBeaconClassName: function () {
								return 'undefined-user';
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				7667: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = n(17587),
						s = n(13955),
						l = n(71101),
						u = r(n(87547)),
						c = a.BaseFooter.extend({
							showForgotPasswordLink: function () {
								return !this.options.appState.isIdentifierOnlyView();
							},
							footerInfo: function () {
								var e,
									t = (0, l.getSignUpLink)(this.options.appState, this.options.settings);
								return (
									t.length &&
										(e = i.View.extend({
											className: 'signup-info',
											template: o.default.template({
												compiler: [8, '>= 4.3.0'],
												main: function (e, t, n, r, o) {
													var i =
														e.lookupProperty ||
														function (e, t) {
															if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
														};
													return (
														'<span>' +
														e.escapeExpression(
															(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
																null != t ? t : e.nullContext || {},
																{
																	name: 'i18n',
																	hash: { bundle: 'login', code: 'registration.signup.label' },
																	data: o,
																	loc: { start: { line: 1, column: 6 }, end: { line: 1, column: 62 } },
																}
															)
														) +
														'</span><span class="signup-link"></span>'
													);
												},
												useData: !0,
											}),
											initialize: function () {
												this.add(u.default, '.signup-link', { options: t[0] });
											},
										})),
									e
								);
							},
							links: function () {
								var e,
									t = this.options,
									n = t.appState,
									r = t.settings;
								r.get('helpLinks.help') ? (e = r.get('helpLinks.help')) : (e = r.get('baseUrl') + '/help/login');
								var o = [{ name: 'help', label: (0, i.loc)('help', 'login'), href: e, target: '_blank' }],
									a = [];
								this.showForgotPasswordLink() && (a = (0, l.getForgotPasswordLink)(n, r));
								var u = [];
								r.get('helpLinks.custom') &&
									r.get('helpLinks.custom').forEach(function (e) {
										(e.name = 'custom'), (e.label = e.text), u.push(e);
									});
								var c = [];
								return (
									r.get('helpLinks.unlock')
										? c.push({
												type: 'link',
												label: (0, i.loc)('unlockaccount', 'login'),
												name: 'unlock',
												href: r.get('helpLinks.unlock'),
										  })
										: n.hasRemediationObject(s.FORMS.UNLOCK_ACCOUNT) &&
										  c.push({
												type: 'link',
												label: (0, i.loc)('unlockaccount', 'login'),
												name: 'unlock',
												actionPath: s.FORMS.UNLOCK_ACCOUNT,
										  }),
									a.concat(c).concat(o).concat(u)
								);
							},
						});
					(t.default = c), (e.exports = t.default);
				},
				87547: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475).View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'label') || (null != t ? a(t, 'label') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'label',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 9 } },
											  })
											: i
									);
								},
								useData: !0,
							}),
							tagName: 'a',
							attributes: function () {
								var e = this.options.href || '#',
									t = '_blank' !== this.options.target || this.options.rel ? this.options.rel : 'noopener noreferrer';
								return { 'data-se': this.options.name, 'href': e, 'target': this.options.target, 'rel': t };
							},
							className: function () {
								var e = ['link'];
								if (this.options.name) {
									var t = this.options.name.replace(/[ ]/g, '-');
									e.push('js-'.concat(t));
								}
								return e.join(' ');
							},
							postRender: function () {
								var e = this;
								this.options.href ||
									this.$el.click(function (t) {
										t.preventDefault();
										var n = e.options,
											r = n.appState,
											o = n.formName,
											i = n.actionPath,
											a = n.clickHandler;
										a ? a() : o ? r.trigger('switchForm', o) : i && r.trigger('invokeAction', i);
									});
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				11098: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = i.internal.views.components.Notification,
						s = i.internal.util.Clipboard,
						l = i.View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s = e.hooks.helperMissing,
										l = e.escapeExpression,
										u =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div>' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.explanation.mdm' },
												data: o,
												loc: { start: { line: 1, column: 5 }, end: { line: 1, column: 58 } },
											})
										) +
										'</div><ol><li>' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.mdm.step.copyLink' },
												data: o,
												loc: { start: { line: 1, column: 72 }, end: { line: 1, column: 127 } },
											})
										) +
										'<a data-clipboard-text="' +
										l(
											'function' ==
												typeof (i =
													null != (i = u(n, 'enrollmentLink') || (null != t ? u(t, 'enrollmentLink') : t)) ? i : s)
												? i.call(a, {
														name: 'enrollmentLink',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 151 }, end: { line: 1, column: 169 } },
												  })
												: i
										) +
										'" class="button link-button copy-clipboard-button">' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.mdm.copyLink' },
												data: o,
												loc: { start: { line: 1, column: 220 }, end: { line: 1, column: 270 } },
											})
										) +
										'</a></li><li>' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.mdm.step.pasteLink' },
												data: o,
												loc: { start: { line: 1, column: 283 }, end: { line: 1, column: 339 } },
											})
										) +
										'</li><li>' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: {
													$1: "<span class='semi-strong'>$1</span>",
													arguments: 'vendor',
													bundle: 'login',
													code: 'enroll.mdm.step.followInstructions',
												},
												data: o,
												loc: { start: { line: 1, column: 348 }, end: { line: 1, column: 473 } },
											})
										) +
										'</li><li>' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.mdm.step.relogin' },
												data: o,
												loc: { start: { line: 1, column: 482 }, end: { line: 1, column: 536 } },
											})
										) +
										'</li></ol>'
									);
								},
								useData: !0,
							}),
							getTemplateData: function () {
								return this.options.appState.get('deviceEnrollment');
							},
							postRender: function () {
								var e = this;
								s.attach('.copy-clipboard-button').done(function () {
									var t = new a({ message: (0, i.loc)('enroll.mdm.copyLink.success', 'login'), level: 'success' });
									return e.el.prepend(t.render().el), !1;
								});
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				73204: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.getDeviceEnrollmentContext =
							t.IosAndAndroidLoopbackOdaTerminalView =
							t.AndroidAppLinkWithoutAccountOdaTerminalView =
							t.AndroidAppLinkWithAccountOdaTerminalView =
								void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = r(n(35546)),
						l = a.internal.views.components.Notification,
						u = a.internal.util.Clipboard,
						c = function (e) {
							var t = (e.platform || '').toLowerCase(),
								n = e.challengeMethod,
								r = e.name,
								o = t === s.default.IOS,
								i = t === s.default.ANDROID && 'APP_LINK' === n,
								a = t === s.default.ANDROID && 'LOOPBACK' === n;
							return {
								signInUrl: e.signInUrl,
								isIOS: o,
								enrollmentType: r,
								isAndroidLoopback: a,
								isAndroidAppLink: i,
								appStoreLink: o
									? s.default.OKTA_VERIFY_APPLE_APP_STORE_URL
									: s.default.OKTA_VERIFY_GOOGLE_PLAY_STORE_URL,
								orgName: e.orgName,
							};
						};
					t.getDeviceEnrollmentContext = c;
					var d = a.View.extend({
							getTemplateData: function () {
								var e = this.options.appState.get('deviceEnrollment');
								return c(e);
							},
						}),
						f = d.extend({
							template: i.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s = e.hooks.helperMissing,
										l = e.escapeExpression,
										u =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<li>' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.mdm.step.copyLink' },
												data: o,
												loc: { start: { line: 1, column: 120 }, end: { line: 1, column: 175 } },
											})
										) +
										'<a data-clipboard-text="' +
										l(
											'function' ==
												typeof (i =
													null != (i = u(n, 'appStoreLink') || (null != t ? u(t, 'appStoreLink') : t)) ? i : s)
												? i.call(a, {
														name: 'appStoreLink',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 199 }, end: { line: 1, column: 215 } },
												  })
												: i
										) +
										'" class="button link-button copy-clipboard-button">' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.mdm.copyLink' },
												data: o,
												loc: { start: { line: 1, column: 266 }, end: { line: 1, column: 316 } },
											})
										) +
										'</a></li><li>' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.mdm.step.pasteLink' },
												data: o,
												loc: { start: { line: 1, column: 329 }, end: { line: 1, column: 385 } },
											})
										) +
										'</li><li>' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.oda.step3' },
												data: o,
												loc: { start: { line: 1, column: 394 }, end: { line: 1, column: 441 } },
											})
										) +
										'</li>'
									);
								},
								3: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<li>' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'enroll.oda.android.step1' },
													data: o,
													loc: { start: { line: 1, column: 482 }, end: { line: 1, column: 537 } },
												}
											)
										) +
										'</li>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, i) {
									var a,
										s,
										l = null != t ? t : e.nullContext || {},
										u = e.hooks.helperMissing,
										c = e.escapeExpression,
										d = 'function',
										f =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p class="explanation" data-se="subheader">' +
										c(
											(f(n, 'i18n') || (t && f(t, 'i18n')) || u).call(l, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.explanation.p1' },
												data: i,
												loc: { start: { line: 1, column: 43 }, end: { line: 1, column: 95 } },
											})
										) +
										'</p><ol>' +
										(null !=
										(a = f(n, 'if').call(l, null != t ? f(t, 'isIOS') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, i, 0),
											inverse: e.noop,
											data: i,
											loc: { start: { line: 1, column: 103 }, end: { line: 1, column: 453 } },
										}))
											? a
											: '') +
										(null !=
										(a = f(n, 'if').call(l, null != t ? f(t, 'isAndroidLoopback') : t, {
											name: 'if',
											hash: {},
											fn: e.program(3, i, 0),
											inverse: e.noop,
											data: i,
											loc: { start: { line: 1, column: 453 }, end: { line: 1, column: 549 } },
										}))
											? a
											: '') +
										'<li>' +
										c(
											(f(n, 'i18n') || (t && f(t, 'i18n')) || u).call(l, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.oda.step1' },
												data: i,
												loc: { start: { line: 1, column: 553 }, end: { line: 1, column: 600 } },
											})
										) +
										'</li><li>' +
										c(
											(f(n, 'i18n') || (t && f(t, 'i18n')) || u).call(l, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.oda.step2' },
												data: i,
												loc: { start: { line: 1, column: 609 }, end: { line: 1, column: 656 } },
											})
										) +
										'<p class="org-signin-link"><span class="no-translate">' +
										c(
											((s = null != (s = f(n, 'signInUrl') || (null != t ? f(t, 'signInUrl') : t)) ? s : u),
											(0, o.default)(s) === d
												? s.call(l, {
														name: 'signInUrl',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 710 }, end: { line: 1, column: 723 } },
												  })
												: s)
										) +
										'</span></p><a data-clipboard-text="' +
										c(
											((s = null != (s = f(n, 'signInUrl') || (null != t ? f(t, 'signInUrl') : t)) ? s : u),
											(0, o.default)(s) === d
												? s.call(l, {
														name: 'signInUrl',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 758 }, end: { line: 1, column: 771 } },
												  })
												: s)
										) +
										'" class="button link-button copy-org-clipboard-button">' +
										c(
											(f(n, 'i18n') || (t && f(t, 'i18n')) || u).call(l, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.oda.org.copyLink' },
												data: i,
												loc: { start: { line: 1, column: 826 }, end: { line: 1, column: 880 } },
											})
										) +
										'</a></li><li>' +
										c(
											(f(n, 'i18n') || (t && f(t, 'i18n')) || u).call(l, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.oda.step6' },
												data: i,
												loc: { start: { line: 1, column: 893 }, end: { line: 1, column: 940 } },
											})
										) +
										'</li></ol>'
									);
								},
								useData: !0,
							}),
							postRender: function () {
								var e = this;
								u.attach('.copy-clipboard-button').done(function () {
									var t = new l({ message: (0, a.loc)('enroll.mdm.copyLink.success', 'login'), level: 'success' });
									return e.el.prepend(t.render().el), !1;
								}),
									u.attach('.copy-org-clipboard-button').done(function () {
										var t = new l({
											message: (0, a.loc)('enroll.oda.org.copyLink.success', 'login'),
											level: 'success',
										});
										return e.el.prepend(t.render().el), !1;
									});
							},
						});
					t.IosAndAndroidLoopbackOdaTerminalView = f;
					var p = d.extend({
						template: i.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i = null != t ? t : e.nullContext || {},
									a = e.hooks.helperMissing,
									s = e.escapeExpression,
									l =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<p class="explanation" data-se="subheader">' +
									s(
										(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'enroll.oda.with.account.explanation' },
											data: o,
											loc: { start: { line: 1, column: 43 }, end: { line: 1, column: 109 } },
										})
									) +
									'</p><p class="subtitle">' +
									s(
										(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'enroll.oda.with.account.subtitile1 ' },
											data: o,
											loc: { start: { line: 1, column: 133 }, end: { line: 1, column: 199 } },
										})
									) +
									'</p><ul><li>' +
									s(
										(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'enroll.oda.with.account.step1' },
											data: o,
											loc: { start: { line: 1, column: 211 }, end: { line: 1, column: 271 } },
										})
									) +
									'</li><li>' +
									s(
										(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'enroll.oda.with.account.step2' },
											data: o,
											loc: { start: { line: 1, column: 280 }, end: { line: 1, column: 340 } },
										})
									) +
									'</li><li>' +
									s(
										(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'enroll.oda.with.account.step3' },
											data: o,
											loc: { start: { line: 1, column: 349 }, end: { line: 1, column: 409 } },
										})
									) +
									'</li></ul><p class="subtitle">' +
									s(
										(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'enroll.oda.with.account.subtitile2 ' },
											data: o,
											loc: { start: { line: 1, column: 439 }, end: { line: 1, column: 505 } },
										})
									) +
									'</p><ol><li>' +
									s(
										(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'enroll.oda.with.account.step4' },
											data: o,
											loc: { start: { line: 1, column: 517 }, end: { line: 1, column: 577 } },
										})
									) +
									'</li><li>' +
									s(
										(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
											name: 'i18n',
											hash: { arguments: 'signInUrl', bundle: 'login', code: 'enroll.oda.with.account.step5' },
											data: o,
											loc: { start: { line: 1, column: 586 }, end: { line: 1, column: 668 } },
										})
									) +
									'</li><li>' +
									s(
										(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'enroll.oda.with.account.step6' },
											data: o,
											loc: { start: { line: 1, column: 677 }, end: { line: 1, column: 737 } },
										})
									) +
									'</li><li>' +
									s(
										(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'enroll.oda.with.account.step7' },
											data: o,
											loc: { start: { line: 1, column: 746 }, end: { line: 1, column: 806 } },
										})
									) +
									'</li></ol>'
								);
							},
							useData: !0,
						}),
					});
					t.AndroidAppLinkWithAccountOdaTerminalView = p;
					var h = d.extend({
						template: i.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, i) {
								var a,
									s,
									l = null != t ? t : e.nullContext || {},
									u = e.hooks.helperMissing,
									c = e.escapeExpression,
									d = 'function',
									f =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<p class="explanation" data-se="subheader">' +
									c(
										(f(n, 'i18n') || (t && f(t, 'i18n')) || u).call(l, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'enroll.oda.without.account.explanation' },
											data: i,
											loc: { start: { line: 1, column: 43 }, end: { line: 1, column: 112 } },
										})
									) +
									'</p><ol><li>' +
									(null !=
									(a = (f(n, 'i18n') || (t && f(t, 'i18n')) || u).call(l, {
										name: 'i18n',
										hash: { arguments: 'appStoreLink', bundle: 'login', code: 'enroll.oda.without.account.step1' },
										data: i,
										loc: { start: { line: 1, column: 124 }, end: { line: 1, column: 214 } },
									}))
										? a
										: '') +
									'</li><li>' +
									c(
										(f(n, 'i18n') || (t && f(t, 'i18n')) || u).call(l, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'enroll.oda.step1' },
											data: i,
											loc: { start: { line: 1, column: 223 }, end: { line: 1, column: 270 } },
										})
									) +
									'</li><li>' +
									c(
										(f(n, 'i18n') || (t && f(t, 'i18n')) || u).call(l, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'enroll.oda.step2' },
											data: i,
											loc: { start: { line: 1, column: 279 }, end: { line: 1, column: 326 } },
										})
									) +
									'<p class="org-signin-link"><span class="no-translate">' +
									c(
										((s = null != (s = f(n, 'signInUrl') || (null != t ? f(t, 'signInUrl') : t)) ? s : u),
										(0, o.default)(s) === d
											? s.call(l, {
													name: 'signInUrl',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 380 }, end: { line: 1, column: 393 } },
											  })
											: s)
									) +
									'</span></p><a data-clipboard-text="' +
									c(
										((s = null != (s = f(n, 'signInUrl') || (null != t ? f(t, 'signInUrl') : t)) ? s : u),
										(0, o.default)(s) === d
											? s.call(l, {
													name: 'signInUrl',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 428 }, end: { line: 1, column: 441 } },
											  })
											: s)
									) +
									'" class="button link-button copy-org-clipboard-button">' +
									c(
										(f(n, 'i18n') || (t && f(t, 'i18n')) || u).call(l, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'enroll.oda.org.copyLink' },
											data: i,
											loc: { start: { line: 1, column: 496 }, end: { line: 1, column: 550 } },
										})
									) +
									'</a></li><li>' +
									c(
										(f(n, 'i18n') || (t && f(t, 'i18n')) || u).call(l, {
											name: 'i18n',
											hash: { bundle: 'login', code: 'enroll.oda.without.account.step4' },
											data: i,
											loc: { start: { line: 1, column: 563 }, end: { line: 1, column: 626 } },
										})
									) +
									'</li></ol>'
								);
							},
							useData: !0,
						}),
						postRender: function () {
							var e = this;
							u.attach('.copy-org-clipboard-button').done(function () {
								var t = new l({ message: (0, a.loc)('enroll.oda.org.copyLink.success', 'login'), level: 'success' });
								return e.el.prepend(t.render().el), !1;
							});
						},
					});
					t.AndroidAppLinkWithoutAccountOdaTerminalView = h;
				},
				76757: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(17587),
						o = n(13955),
						i = n(83966),
						a = r.BaseHeader.extend({
							HeaderBeacon: i.BaseAuthenticatorBeacon.extend({ authenticatorKey: o.AUTHENTICATOR_KEY.OV }),
						});
					(t.default = a), (e.exports = t.default);
				},
				21876: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475),
						o = n(13955),
						i = (0, r.createButton)({
							className: 'button-primary button skip-all',
							title: function () {
								return (0, r.loc)('oie.setup.remind.me.later', 'login');
							},
							click: function () {
								this.options.appState.trigger('invokeAction', o.FORMS.SKIP);
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				16002: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = n(43318),
						l = a.internal.views.forms.inputs.CheckBox.extend({
							template: i.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<input type="checkbox" name="' +
										c(
											((a = null != (a = d(n, 'name') || (null != t ? d(t, 'name') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'name',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 29 }, end: { line: 1, column: 37 } },
												  })
												: a)
										) +
										'" id="' +
										c(
											((a = null != (a = d(n, 'inputId') || (null != t ? d(t, 'inputId') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'inputId',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 43 }, end: { line: 1, column: 54 } },
												  })
												: a)
										) +
										'"/><label for="' +
										c(
											((a = null != (a = d(n, 'inputId') || (null != t ? d(t, 'inputId') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'inputId',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 69 }, end: { line: 1, column: 80 } },
												  })
												: a)
										) +
										'" data-se-for-name="' +
										c(
											((a = null != (a = d(n, 'name') || (null != t ? d(t, 'name') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'name',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 100 }, end: { line: 1, column: 108 } },
												  })
												: a)
										) +
										'"><b>' +
										c(
											((a = null != (a = d(n, 'placeholder') || (null != t ? d(t, 'placeholder') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'placeholder',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 113 }, end: { line: 1, column: 128 } },
												  })
												: a)
										) +
										'</b><p>' +
										c(
											((a = null != (a = d(n, 'desc') || (null != t ? d(t, 'desc') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'desc',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 135 }, end: { line: 1, column: 143 } },
												  })
												: a)
										) +
										'</p></label>'
									);
								},
								useData: !0,
							}),
							getLocalizedLabel: function () {
								var e = 'consent.scopes.'.concat(this.options.options.scopeName, '.label');
								return (0, s.doesI18NKeyExist)(e)
									? (0, a.loc)(e, 'login')
									: this.options.placeholder || this.options.options.scopeName;
							},
							getLocalizedDesc: function () {
								var e = 'consent.scopes.'.concat(this.options.options.scopeName, '.desc');
								return (0, s.doesI18NKeyExist)(e) ? (0, a.loc)(e, 'login') : this.options.options.desc;
							},
							isCustomizedScope: function () {
								return !(0, s.doesI18NKeyExist)('consent.scopes.'.concat(this.options.options.scopeName, '.label'));
							},
							enable: function () {
								this.options.options.mutable && this.$(':input').prop('disabled', !1);
							},
							editMode: function () {
								if (
									(this.$el.html(
										this.template(
											a._.extend(a._.omit(this.options, 'placeholder'), {
												placeholder: this.getLocalizedLabel(),
												desc: this.getLocalizedDesc(),
											})
										)
									),
									this.$(':checkbox').prop('checked', this.getModelValue() || !1),
									this.$('input').customInput(),
									this.model.trigger('form:resize'),
									!this.options.options.mutable)
								) {
									var e = this.$('input').get(0);
									this.$(e.parentElement).addClass('o-form-read-mode'), this.$(':checkbox').prop('disabled', !0);
								}
								return (
									('openid' === this.options.options.scopeName || this.isCustomizedScope()) &&
										(this.$('label > b').addClass('no-translate'),
										this.isCustomizedScope() && this.$('label > p').addClass('no-translate')),
									this
								);
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				45112: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475),
						o = n(13955),
						i = (0, r.createButton)({
							className: 'button-primary button skip-all',
							title: function () {
								return (0, r.loc)('oie.optional.authenticator.button.title', 'login');
							},
							click: function () {
								this.options.appState.trigger('invokeAction', o.FORMS.SKIP);
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				16264: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(87547)),
						a = o.View.extend({
							initialize: function () {
								o.View.prototype.initialize.apply(this, arguments);
								var e = this.options.additionalOptions,
									t = this.options.name,
									n = Object.assign({}, this.options, {
										'type': 'link',
										'aria-expanded': !1,
										'clickHandler': function () {
											(0, o.$)(e.selector).slideToggle(200, function () {
												(0, o.$)('.js-'.concat(t)).attr('aria-expanded', (0, o.$)(e.selector).is(':visible'));
											});
										},
									});
								this.add(i.default, { options: n }), this.add(e.view);
							},
							postRender: function () {
								var e = this.options.additionalOptions;
								this.$(e.selector).hide();
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				8517: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(87547)),
						a = r(n(16264)),
						s = n(71101),
						l = o.View.extend({
							className: 'auth-footer',
							links: [],
							footerInfo: null,
							hasBackToSignInLink: !0,
							initialize: function () {
								var e = this,
									t = o._.resultCtx(this, 'links', this),
									n = o._.resultCtx(this, 'footerInfo', this),
									r = o._.resultCtx(this, 'hasBackToSignInLink', this);
								(t = Array.isArray(t)
									? t.filter(function (e) {
											return o.$.isPlainObject(e);
									  })
									: []),
									this.options.appState.shouldShowSignOutLinkInCurrentForm(
										this.options.settings.get('features.hideSignOutLinkInMFA') ||
											this.settings.get('features.mfaOnlyFlow')
									) &&
										r &&
										(t = t.concat((0, s.getSignOutLink)(this.options.settings))),
									t.forEach(function (t) {
										var n = i.default;
										'toggle-text-link' === t.type && (n = a.default), e.add(n, { options: t });
									}),
									n && (this.add(o.View.extend({ className: 'footer-info' })), this.add(n, '.footer-info'));
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				68013: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(52574)),
						i = r(n(71750)),
						a = i.default.extend(
							Object.assign(
								{
									initialize: function () {
										i.default.prototype.initialize.apply(this, arguments),
											this.listenTo(this.options.appState, 'change:dynamicRefreshInterval', this.updateRefreshInterval);
									},
									updateRefreshInterval: function () {
										this.polling &&
											(this.stopPolling(), this.startPolling(this.options.appState.get('dynamicRefreshInterval')));
									},
								},
								o.default
							)
						);
					(t.default = a), (e.exports = t.default);
				},
				27279: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(66757)),
						a = r(n(35546)),
						s = o.View.extend({
							HeaderBeacon: null,
							initialize: function () {
								this.HeaderBeacon && this.add(this.HeaderBeacon);
							},
							postRender: function () {
								var e = (0, o.$)('#'.concat(a.default.WIDGET_CONTAINER_ID));
								if (this.HeaderBeacon) {
									e.removeClass('no-beacon');
									var t = this.$el.find('[data-type="beacon-container"]');
									i.default.explode(t);
								} else e.addClass('no-beacon');
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				55957: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(15985)),
						i = n(6475),
						a = function (e) {
							var t = Object.assign(
								{},
								i._.chain(e)
									.pick('minLength', 'maxLength', 'required', 'value')
									.defaults({ type: 'string', required: !0 })
									.value()
							);
							return e.modelType && (t.type = e.modelType), (0, o.default)({}, e.name, t);
						},
						s = function e() {
							var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
								n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
								r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
								o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
								i = t.uiSchema || [];
							i.forEach(function (t) {
								if (Array.isArray(t.optionsUiSchemas)) {
									var i,
										s = {};
									Number(t.value) >= 0 && (i = t.value),
										n[t.name] && ((s = { value: n[t.name] }), (i = Number(s.value))),
										Object.assign(o, a(Object.assign({}, t, s))),
										i && e({ uiSchema: t.optionsUiSchemas[i] }, n, r, o);
								} else Object.assign(r, a(t));
							});
						},
						l = {
							create: function () {
								var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
									t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
									n = {},
									r = { formName: 'string', useRedirect: 'boolean' };
								s(e, t, n, r);
								var o = i.Model.extend({ props: n, local: r });
								return o;
							},
						};
					(t.default = l), (e.exports = t.default);
				},
				59204: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(68013)),
						a = r(n(36894)),
						s = n(86725),
						l = r(n(34425)),
						u = n(66200),
						c = function (e) {
							var t = Object.assign({ method: 'GET', contentType: 'application/json' }, e);
							return o.$.ajax(t);
						},
						d = i.default.extend({
							noButtonBar: !0,
							className: 'ion-form device-challenge-poll',
							removed: !1,
							events: {
								'click #launch-ov': function (e) {
									e.preventDefault(), this.doCustomURI();
								},
							},
							pollingCancelAction: s.AUTHENTICATOR_CANCEL_ACTION,
							initialize: function () {
								i.default.prototype.initialize.apply(this, arguments),
									(this.removed = !1),
									this.listenTo(this.model, 'error', this.onPollingFail),
									this.doChallenge(),
									this.startPolling();
							},
							doChallenge: function () {
								(0, u.doChallenge)(this);
							},
							onPollingFail: function () {
								this.$('.spinner').hide(), this.stopPolling();
							},
							remove: function () {
								i.default.prototype.remove.apply(this, arguments),
									(this.removed = !0),
									this.stopProbing(),
									this.stopPolling();
							},
							getDeviceChallengePayload: function () {
								throw new Error('getDeviceChallengePayload needs to be implemented');
							},
							doLoopback: function (e) {
								var t,
									n = this,
									r = void 0 !== e.domain ? e.domain : '',
									i = void 0 !== e.httpsDomain ? e.httpsDomain : '',
									d = void 0 !== e.ports ? e.ports : [],
									f = d.length,
									p = void 0 !== e.challengeRequest ? e.challengeRequest : '',
									h = void 0 !== e.probeTimeoutMillis ? e.probeTimeoutMillis : 100,
									m = !1,
									v = !1,
									g = 0,
									y = function (e, n) {
										return ''.concat(n, ':').concat(t, '/').concat(e);
									},
									b = function () {
										return (
											a.default.error('Something unexpected happened while we were checking port '.concat(t, '.')),
											o.$.Deferred().reject()
										);
									},
									_ = function (t) {
										return ((r = y('probe', t)), c({ url: r, timeout: l.default.isAndroid() ? 3e3 : h }))
											.then(function () {
												return (function (e) {
													return c({
														url: e,
														method: 'POST',
														data: JSON.stringify({ challengeRequest: p }),
														timeout: s.CHALLENGE_TIMEOUT,
													});
												})(y('challenge', t))
													.then(function () {
														return (
															(m = !0),
															!1 !== e.enhancedPollingEnabled
																? (n.stopPolling(), void n.startPolling(1))
																: n.trigger('save', n.model)
														);
													})
													.catch(function (e) {
														g++,
															503 !== e.status
																? ((v = !0),
																  (0, u.cancelPollingWithParams)(
																		n.options.appState,
																		n.pollingCancelAction,
																		s.AUTHENTICATION_CANCEL_REASONS.OV_ERROR,
																		e.status,
																		!n.removed
																  ))
																: g === f &&
																  (0, u.cancelPollingWithParams)(
																		n.options.appState,
																		n.pollingCancelAction,
																		s.AUTHENTICATION_CANCEL_REASONS.LOOPBACK_FAILURE,
																		null,
																		!n.removed
																  );
													});
											})
											.catch(b);
										var r;
									},
									w = Promise.resolve(),
									O = function (e, r, o) {
										w = w
											.then(function () {
												if (!m && !v) return (t = e), _(r);
											})
											.catch(function () {
												g++,
													a.default.error('Authenticator is not listening on port '.concat(t, '.')),
													o &&
														g === f &&
														(a.default.error('No available ports. Loopback server failed and polling is cancelled.'),
														n.stopPolling(),
														(0, u.cancelPollingWithParams)(
															n.options.appState,
															n.pollingCancelAction,
															s.AUTHENTICATION_CANCEL_REASONS.LOOPBACK_FAILURE,
															null,
															!n.removed
														));
											});
									};
								i &&
									(a.default.info('httpsDomain enabled, will probe and challenge https first'),
									(f += f),
									d.forEach(function (e) {
										O(e, i, !1);
									})),
									d.forEach(function (e) {
										O(e, r, !0);
									});
							},
							doCustomURI: function () {
								this.ulDom && this.ulDom.remove();
								var e = (0, u.createInvisibleIFrame)('custom-uri-container', this.customURI);
								this.ulDom = this.add(e).last();
							},
							doChromeDTC: function (e) {
								this.ulDom && this.ulDom.remove();
								var t = (0, u.createInvisibleIFrame)('chrome-dtc-container', e.href);
								this.ulDom = this.add(t).last();
							},
							stopProbing: function () {
								this.checkPortXhr && this.checkPortXhr.abort(), this.probingXhr && this.probingXhr.abort();
							},
						}),
						f = d;
					(t.default = f), (e.exports = t.default);
				},
				96167: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(27279)),
						s = r(n(71750)),
						l = r(n(55957)),
						u = r(n(8517)),
						c = n(2715),
						d = i.View.extend({
							Header: a.default,
							Body: s.default,
							Footer: u.default,
							className: function () {
								var e = this.options.appState,
									t = e.get('currentFormName'),
									n = e.get('authenticatorKey'),
									r = e.get('authenticatorMethodType'),
									o = e.get('isPasswordRecoveryFlow'),
									i = (0, c.getClassNameMapping)(t, n, r, o);
								return ['siw-main-view'].concat(i).join(' ');
							},
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									return '<div class="siw-main-header"></div><div class="siw-main-body"></div><div class="siw-main-footer"></div>';
								},
								useData: !0,
							}),
							preRender: function () {
								i.View.prototype.preRender.apply(this, arguments),
									null !== this.Header &&
										this.add(this.Header, { selector: '.siw-main-header', options: this.options }),
									this.renderForm(),
									this.add(this.Footer, { selector: '.siw-main-footer', options: this.options });
							},
							renderForm: function () {
								var e,
									t = this;
								this.form && (this.form.remove(), (e = this.form.model.toJSON({ verbose: !0 })));
								var n = new (this.createModelClass(this.options.currentViewState, e, this.settings))({
									formName: this.options.currentViewState.name,
								});
								e || (e = n.toJSON({ verbose: !0 })),
									(this.model = n),
									(this.form = this.add(this.Body, {
										selector: '.siw-main-body',
										options: Object.assign({}, this.options, { model: n, optionUiSchemaConfig: e }),
									}).last()),
									i._.each(n.attributes, function (e, r) {
										r.match(/sub_schema_local_[^ ]+/) &&
											t.listenTo(n, 'change:'.concat(r), function () {
												t.renderForm();
											});
									});
							},
							createModelClass: function (e) {
								var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
								return l.default.create(e, t);
							},
						});
					(t.default = d), (e.exports = t.default);
				},
				17587: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						Object.defineProperty(t, 'BaseFooter', {
							enumerable: !0,
							get: function () {
								return i.default;
							},
						}),
						Object.defineProperty(t, 'BaseForm', {
							enumerable: !0,
							get: function () {
								return a.default;
							},
						}),
						Object.defineProperty(t, 'BaseFormWithPolling', {
							enumerable: !0,
							get: function () {
								return s.default;
							},
						}),
						Object.defineProperty(t, 'BaseHeader', {
							enumerable: !0,
							get: function () {
								return o.default;
							},
						}),
						Object.defineProperty(t, 'BaseModel', {
							enumerable: !0,
							get: function () {
								return u.default;
							},
						}),
						Object.defineProperty(t, 'BaseOktaVerifyChallengeView', {
							enumerable: !0,
							get: function () {
								return l.default;
							},
						}),
						Object.defineProperty(t, 'BaseView', {
							enumerable: !0,
							get: function () {
								return c.default;
							},
						}),
						Object.defineProperty(t, 'addCustomButton', {
							enumerable: !0,
							get: function () {
								return d.addCustomButton;
							},
						}),
						Object.defineProperty(t, 'createCustomButtons', {
							enumerable: !0,
							get: function () {
								return d.createCustomButtons;
							},
						}),
						Object.defineProperty(t, 'createIdpButtons', {
							enumerable: !0,
							get: function () {
								return d.createIdpButtons;
							},
						});
					var o = r(n(27279)),
						i = r(n(8517)),
						a = r(n(71750)),
						s = r(n(68013)),
						l = r(n(59204)),
						u = r(n(55957)),
						c = r(n(96167)),
						d = n(88469);
				},
				25795: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.getAuthenticatorDataForEnroll = function (e) {
							return c(e);
						}),
						(t.getAuthenticatorDataForVerification = function (e) {
							return c(e, !0);
						}),
						(t.getAuthenticatorDisplayName = function (e) {
							var t, n;
							return null === (t = e.relatesTo) || void 0 === t || null === (n = t.value) || void 0 === n
								? void 0
								: n.displayName;
						}),
						(t.getIconClassNameForBeacon = function (e, t) {
							return (
								c({ authenticatorKey: e }).iconClassName ||
								(function (e) {
									var t = {};
									switch (e) {
										case s.ID_PROOFING_TYPE.IDV_PERSONA:
											t = { iconClassName: 'mfa-idv-persona' };
											break;
										case s.ID_PROOFING_TYPE.IDV_CLEAR:
											t = { iconClassName: 'mfa-idv-clear' };
											break;
										case s.ID_PROOFING_TYPE.IDV_INCODE:
											t = { iconClassName: 'mfa-idv-incode' };
									}
									return t;
								})(t).iconClassName
							);
						}),
						(t.getOktaVerifyAriaLabel = p),
						(t.getPasswordComplexityDescriptionForHtmlList = void 0),
						(t.getVerifyEmailAriaLabel = d),
						(t.getVerifyPhoneAriaLabel = f),
						(t.removeRequirementsFromError = function (e) {
							var t;
							if (
								(null === (t = e.errorCauses) || void 0 === t ? void 0 : t.length) > 0 &&
								Array.isArray(e.errorCauses[0].errorSummary) &&
								e.errorCauses[0].errorSummary.length > 0
							) {
								var n;
								(e.errorCauses[0].errorSummary = e.errorCauses[0].errorSummary[0]),
									'password.passwordRequirementsNotMet' ===
										((null === (n = e.errorCauses[0].errorKey) || void 0 === n ? void 0 : n.length) > 0 &&
											e.errorCauses[0].errorKey[0]) &&
										(e.errorCauses[0].errorSummary = (0, i.loc)(
											'registration.error.password.passwordRequirementsNotMet',
											'login'
										));
							}
							return e;
						});
					var o = r(n(87462)),
						i = n(71244),
						a = r(n(2645)),
						s = n(13955),
						l = a.default.getPasswordComplexityDescriptionForHtmlList;
					t.getPasswordComplexityDescriptionForHtmlList = l;
					var u = function (e) {
							if (e.authenticatorKey) {
								var t,
									n,
									r =
										null !== (t = e.value) && void 0 !== t && t.methodType
											? '-' + (null === (n = e.value) || void 0 === n ? void 0 : n.methodType)
											: '';
								return e.authenticatorKey + r;
							}
							return '';
						},
						c = function (e, t) {
							var n,
								r,
								a,
								l,
								c,
								h,
								m,
								v,
								g,
								y,
								b = e.authenticatorKey,
								_ = o.default.isString(b) ? b.toLowerCase() : '',
								w = {},
								O = t ? (null === (n = e.relatesTo) || void 0 === n ? void 0 : n.nickname) : void 0;
							switch (_) {
								case s.AUTHENTICATOR_KEY.EMAIL:
									Object.assign(w, {
										description: t
											? (null === (r = e.relatesTo) || void 0 === r || null === (a = r.profile) || void 0 === a
													? void 0
													: a.email) || ''
											: (0, i.loc)('oie.email.authenticator.description', 'login'),
										iconClassName: 'mfa-okta-email',
										noTranslateClassName: t ? 'no-translate' : '',
										buttonDataSeAttr: u(e),
										ariaLabel: t
											? d(
													null === (l = e.relatesTo) || void 0 === l || null === (c = l.profile) || void 0 === c
														? void 0
														: c.email
											  )
											: (0, i.loc)('oie.select.authenticator.enroll.email.label', 'login'),
									});
									break;
								case s.AUTHENTICATOR_KEY.PASSWORD:
									Object.assign(w, {
										description: t ? '' : (0, i.loc)('oie.password.authenticator.description', 'login'),
										iconClassName: 'mfa-okta-password',
										buttonDataSeAttr: u(e),
										ariaLabel: t
											? (0, i.loc)('oie.select.authenticator.verify.password.label', 'login')
											: (0, i.loc)('oie.select.authenticator.enroll.password.label', 'login'),
									});
									break;
								case s.AUTHENTICATOR_KEY.PHONE:
									Object.assign(w, {
										nickname: O,
										description: t
											? null === (h = e.relatesTo) || void 0 === h || null === (m = h.profile) || void 0 === m
												? void 0
												: m.phoneNumber
											: (0, i.loc)('oie.phone.authenticator.description', 'login'),
										iconClassName: 'mfa-okta-phone',
										noTranslateClassName: t ? 'no-translate' : '',
										buttonDataSeAttr: u(e),
										ariaLabel: t
											? f(
													null === (v = e.relatesTo) || void 0 === v || null === (g = v.profile) || void 0 === g
														? void 0
														: g.phoneNumber
											  )
											: (0, i.loc)('oie.select.authenticator.enroll.phone.label', 'login'),
									});
									break;
								case s.AUTHENTICATOR_KEY.SECURITY_QUESTION:
									Object.assign(w, {
										description: t ? '' : (0, i.loc)('oie.security.question.authenticator.description', 'login'),
										iconClassName: 'mfa-okta-security-question',
										buttonDataSeAttr: u(e),
										ariaLabel: t
											? (0, i.loc)('oie.select.authenticator.verify.security.question.label', 'login')
											: (0, i.loc)('oie.select.authenticator.enroll.security.question.label', 'login'),
									});
									break;
								case s.AUTHENTICATOR_KEY.WEBAUTHN:
									Object.assign(w, {
										description: t ? '' : (0, i.loc)('oie.webauthn.description', 'login'),
										iconClassName: 'mfa-webauthn',
										buttonDataSeAttr: u(e),
										ariaLabel: t
											? (0, i.loc)('oie.select.authenticator.verify.webauthn.label', 'login')
											: (0, i.loc)('oie.select.authenticator.enroll.webauthn.label', 'login'),
									});
									break;
								case s.AUTHENTICATOR_KEY.OV:
									Object.assign(w, {
										description: t
											? (0, i.loc)('oie.okta_verify.label', 'login')
											: (0, i.loc)('oie.okta_verify.authenticator.description', 'login'),
										iconClassName: 'mfa-okta-verify',
										buttonDataSeAttr: u(e),
										ariaLabel: p(t, null == e || null === (y = e.value) || void 0 === y ? void 0 : y.methodType),
									});
									break;
								case s.AUTHENTICATOR_KEY.GOOGLE_OTP:
									Object.assign(w, {
										description: t ? '' : (0, i.loc)('oie.google_authenticator.authenticator.description', 'login'),
										iconClassName: 'mfa-google-auth',
										buttonDataSeAttr: u(e),
										ariaLabel: t
											? (0, i.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [e.label])
											: (0, i.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [e.label]),
									});
									break;
								case s.AUTHENTICATOR_KEY.ON_PREM:
									var k,
										x =
											(null === (k = e.relatesTo) || void 0 === k ? void 0 : k.displayName) ||
											(0, i.loc)('oie.on_prem.authenticator.default.vendorName', 'login');
									Object.assign(w, {
										description: t ? '' : (0, i.loc)('oie.on_prem.authenticator.description', 'login', [x]),
										iconClassName: 'mfa-onprem',
										buttonDataSeAttr: u(e),
										ariaLabel: t
											? (0, i.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [e.label])
											: (0, i.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [e.label]),
									});
									break;
								case s.AUTHENTICATOR_KEY.RSA:
									Object.assign(w, {
										description: t ? '' : (0, i.loc)('oie.rsa.authenticator.description', 'login'),
										iconClassName: 'mfa-rsa',
										buttonDataSeAttr: u(e),
										ariaLabel: t
											? (0, i.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [e.label])
											: (0, i.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [e.label]),
									});
									break;
								case s.AUTHENTICATOR_KEY.DUO:
									Object.assign(w, {
										description: t ? '' : (0, i.loc)('oie.duo.authenticator.description', 'login'),
										iconClassName: 'mfa-duo',
										buttonDataSeAttr: u(e),
										ariaLabel: t
											? (0, i.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [e.label])
											: (0, i.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [e.label]),
									});
									break;
								case s.AUTHENTICATOR_KEY.IDP:
									var E,
										T,
										S = null === (E = e.relatesTo) || void 0 === E ? void 0 : E.displayName;
									Object.assign(w, {
										description: t ? '' : (0, i.loc)('oie.idp.authenticator.description', 'login', [S]),
										iconClassName: 'mfa-custom-factor',
										buttonDataSeAttr: u(e),
										logoUri: (null == e || null === (T = e.relatesTo) || void 0 === T ? void 0 : T.logoUri) || '',
										ariaLabel: t
											? (0, i.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [e.label])
											: (0, i.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [e.label]),
									});
									break;
								case s.AUTHENTICATOR_KEY.CUSTOM_OTP:
									Object.assign(w, {
										description: t ? '' : (0, i.loc)('oie.custom_otp.description', 'login'),
										iconClassName: 'mfa-hotp',
										buttonDataSeAttr: u(e),
										ariaLabel: t
											? (0, i.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [e.label])
											: (0, i.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [e.label]),
									});
									break;
								case s.AUTHENTICATOR_KEY.SYMANTEC_VIP:
									var A,
										C = null === (A = e.relatesTo) || void 0 === A ? void 0 : A.displayName;
									Object.assign(w, {
										description: t ? '' : (0, i.loc)('oie.symantecVip.authenticator.description', 'login', [C]),
										iconClassName: 'mfa-symantec',
										buttonDataSeAttr: u(e),
										ariaLabel: t
											? (0, i.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [e.label])
											: (0, i.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [e.label]),
									});
									break;
								case s.AUTHENTICATOR_KEY.YUBIKEY:
									Object.assign(w, {
										description: t ? '' : (0, i.loc)('oie.yubikey.authenticator.description', 'login'),
										iconClassName: 'mfa-yubikey',
										buttonDataSeAttr: u(e),
										ariaLabel: t
											? (0, i.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [e.label])
											: (0, i.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [e.label]),
									});
									break;
								case s.AUTHENTICATOR_KEY.CUSTOM_APP:
									var P, R, I;
									Object.assign(w, {
										description: t
											? null == e || null === (P = e.relatesTo) || void 0 === P
												? void 0
												: P.displayName
											: (0, i.loc)('oie.custom.app.authenticator.description', 'login', [e.label]),
										noTranslateClassName: t ? 'no-translate' : '',
										buttonDataSeAttr: u(e),
										iconClassName: 'mfa-custom-app-logo',
										logoUri: (null == e || null === (R = e.relatesTo) || void 0 === R ? void 0 : R.logoUri) || '',
										ariaLabel: t
											? (0, i.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [
													null == e || null === (I = e.relatesTo) || void 0 === I ? void 0 : I.displayName,
											  ])
											: (0, i.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [e.label]),
									});
									break;
								case s.AUTHENTICATOR_KEY.SMARTCARD:
									Object.assign(w, {
										description: t ? '' : (0, i.loc)('oie.smartcard.authenticator.description', 'login'),
										iconClassName: 'mfa-smartcard',
										buttonDataSeAttr: u(e),
										ariaLabel: t
											? (0, i.loc)('oie.select.authenticator.verify.named.authenticator.label', 'login', [e.label])
											: (0, i.loc)('oie.select.authenticator.enroll.named.authenticator.label', 'login', [e.label]),
									});
							}
							return w;
						};
					function d(e) {
						return e
							? (0, i.loc)('oie.select.authenticator.verify.email.with.email.label', 'login', [e])
							: (0, i.loc)('oie.select.authenticator.verify.email.label', 'login');
					}
					function f(e) {
						return e
							? (0, i.loc)('oie.select.authenticator.verify.phone.with.phone.label', 'login', [e])
							: (0, i.loc)('oie.select.authenticator.verify.phone.label', 'login');
					}
					function p(e, t) {
						if (!e) return (0, i.loc)('oie.select.authenticator.enroll.okta_verify.authenticator.label', 'login');
						var n = (0, i.loc)('oie.select.authenticator.verify.okta_verify.label', 'login');
						return void 0 === t
							? n
							: {
									push: (0, i.loc)('oie.select.authenticator.okta_verify.push.label', 'login'),
									totp: (0, i.loc)('oie.select.authenticator.okta_verify.totp.label', 'login'),
									signed_nonce: (0, i.loc)('oie.select.authenticator.okta_verify.signed_nonce.label', 'login'),
							  }[t] || n;
					}
				},
				66200: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.appendLoginHint = c),
						(t.cancelPollingWithParams = function (e, t, n, r, o) {
							var i = {};
							(i[u.REQUEST_PARAM_AUTHENTICATION_CANCEL_REASON] = n),
								(i[u.LOOPBACK_RESPONSE_STATUS_CODE] = r),
								e.trigger('invokeAction', t, i, o);
						}),
						(t.createInvisibleIFrame = function (e, t) {
							return a.View.extend({
								tagName: 'iframe',
								id: e,
								attributes: { src: t },
								initialize: function () {
									this.el.style.display = 'none';
								},
							});
						}),
						(t.doChallenge = function (e, t) {
							var n,
								r,
								d = e.getDeviceChallengePayload(),
								f =
									null === (n = e.options) || void 0 === n || null === (r = n.settings) || void 0 === r
										? void 0
										: r.get('identifier'),
								p = 'hide';
							switch (d.challengeMethod) {
								case s.default.LOOPBACK_CHALLENGE:
									(e.title = (0, a.loc)('deviceTrust.sso.redirectText', 'login')),
										e.add(
											a.View.extend({
												className: 'loopback-content',
												template: i.default.template({
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, o) {
														return '<div class="spinner"></div>';
													},
													useData: !0,
												}),
											})
										),
										e.doLoopback(d);
									break;
								case s.default.CUSTOM_URI_CHALLENGE:
									(e.title = (0, a.loc)('customUri.title', 'login')),
										e.add(
											a.View.extend({
												className: 'skinny-content',
												template: i.default.template({
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, o) {
														var i =
															e.lookupProperty ||
															function (e, t) {
																if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
															};
														return (
															'<p>' +
															e.escapeExpression(
																(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
																	null != t ? t : e.nullContext || {},
																	{
																		name: 'i18n',
																		hash: { bundle: 'login', code: 'customUri.required.content.prompt' },
																		data: o,
																		loc: { start: { line: 1, column: 3 }, end: { line: 1, column: 67 } },
																	}
																)
															) +
															'</p>'
														);
													},
													useData: !0,
												}),
											})
										),
										e.add(
											(0, a.createButton)({
												className: 'ul-button button button-wide button-primary',
												title: (0, a.loc)('oktaVerify.open.button', 'login'),
												id: 'launch-ov',
												click: function () {
													e.doCustomURI();
												},
											})
										),
										e.add(
											a.View.extend({
												className: 'skinny-content',
												template: i.default.template({
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, o) {
														var i,
															a = null != t ? t : e.nullContext || {},
															s = e.hooks.helperMissing,
															l = e.escapeExpression,
															u =
																e.lookupProperty ||
																function (e, t) {
																	if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																};
														return (
															'<p>' +
															l(
																(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
																	name: 'i18n',
																	hash: { bundle: 'login', code: 'customUri.required.content.download.title' },
																	data: o,
																	loc: { start: { line: 1, column: 3 }, end: { line: 1, column: 75 } },
																})
															) +
															'</p><p><a href="' +
															l(
																'function' ==
																	typeof (i =
																		null != (i = u(n, 'downloadOVLink') || (null != t ? u(t, 'downloadOVLink') : t))
																			? i
																			: s)
																	? i.call(a, {
																			name: 'downloadOVLink',
																			hash: {},
																			data: o,
																			loc: { start: { line: 1, column: 91 }, end: { line: 1, column: 109 } },
																	  })
																	: i
															) +
															'" target="_blank" id="download-ov" class="link">' +
															l(
																(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
																	name: 'i18n',
																	hash: { bundle: 'login', code: 'customUri.required.content.download.linkText' },
																	data: o,
																	loc: { start: { line: 1, column: 157 }, end: { line: 1, column: 232 } },
																})
															) +
															'</a></p>'
														);
													},
													useData: !0,
												}),
												getTemplateData: function () {
													return { downloadOVLink: d.downloadHref };
												},
											})
										),
										(e.customURI = c(d.href, f)),
										e.doCustomURI();
									break;
								case s.default.UNIVERSAL_LINK_CHALLENGE:
									(e.title = (0, a.loc)('universalLink.title', 'login')),
										e.add(
											a.View.extend({
												className: 'universal-link-content',
												template: i.default.template({
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, o) {
														var i =
															e.lookupProperty ||
															function (e, t) {
																if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
															};
														return (
															'<div class="spinner"></div>' +
															e.escapeExpression(
																(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
																	null != t ? t : e.nullContext || {},
																	{
																		name: 'i18n',
																		hash: { bundle: 'login', code: 'universalLink.content' },
																		data: o,
																		loc: { start: { line: 1, column: 27 }, end: { line: 1, column: 79 } },
																	}
																)
															)
														);
													},
													useData: !0,
												}),
											})
										),
										e.add(
											(0, a.createButton)({
												className: 'ul-button button button-wide button-primary',
												title: (0, a.loc)('oktaVerify.open.button', 'login'),
												click: function () {
													var e = c(d.href, f);
													l.default.redirect(e);
												},
											})
										);
									break;
								case s.default.APP_LINK_CHALLENGE:
									(e.title = (0, a.loc)('appLink.title', 'login')),
										e.add(
											a.View.extend({
												className: 'app-link-content',
												template: i.default.template({
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, i) {
														var a,
															s = null != t ? t : e.nullContext || {},
															l = e.hooks.helperMissing,
															u = 'function',
															c = e.escapeExpression,
															d =
																e.lookupProperty ||
																function (e, t) {
																	if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																};
														return (
															'<div class="spinner ' +
															c(
																((a = null != (a = d(n, 'hideClass') || (null != t ? d(t, 'hideClass') : t)) ? a : l),
																(0, o.default)(a) === u
																	? a.call(s, {
																			name: 'hideClass',
																			hash: {},
																			data: i,
																			loc: { start: { line: 1, column: 20 }, end: { line: 1, column: 33 } },
																	  })
																	: a)
															) +
															'"></div><div class="appLinkContent ' +
															c(
																((a = null != (a = d(n, 'hideClass') || (null != t ? d(t, 'hideClass') : t)) ? a : l),
																(0, o.default)(a) === u
																	? a.call(s, {
																			name: 'hideClass',
																			hash: {},
																			data: i,
																			loc: { start: { line: 1, column: 68 }, end: { line: 1, column: 81 } },
																	  })
																	: a)
															) +
															'">' +
															c(
																(d(n, 'i18n') || (t && d(t, 'i18n')) || l).call(s, {
																	name: 'i18n',
																	hash: { bundle: 'login', code: 'appLink.content' },
																	data: i,
																	loc: { start: { line: 1, column: 83 }, end: { line: 1, column: 129 } },
																})
															) +
															'</div>'
														);
													},
													useData: !0,
												}),
												getTemplateData: function () {
													return { hideClass: p };
												},
												postRender: function () {
													var e = this;
													t === u.IDENTIFIER_FLOW
														? (this.$('.spinner').removeClass(p),
														  setTimeout(
																a._.bind(function () {
																	var t = { label: (0, a.loc)('goback', 'login') };
																	e.options.appState.trigger('updateFooterLink', t),
																		e.$('.spinner').addClass(p),
																		e.$('.appLinkContent').removeClass(p);
																}, this),
																u.FASTPASS_FALLBACK_SPINNER_TIMEOUT
														  ))
														: this.$('.appLinkContent').removeClass(p);
												},
											})
										),
										e.add(
											(0, a.createButton)({
												className: ''.concat(p, ' al-button button button-wide button-primary'),
												title: (0, a.loc)('oktaVerify.open.button', 'login'),
												click: function () {
													var e = c(d.href, f);
													l.default.redirect(e, window, !0);
												},
												postRender: function () {
													var e = this;
													t === u.IDENTIFIER_FLOW
														? setTimeout(
																a._.bind(function () {
																	e.$el.removeClass(p);
																}, this),
																u.FASTPASS_FALLBACK_SPINNER_TIMEOUT
														  )
														: this.$el.removeClass(p);
												},
											})
										);
									break;
								case s.default.CHROME_DTC:
									(e.title = (0, a.loc)('deviceTrust.sso.redirectText', 'login')),
										e.add(
											a.View.extend({
												className: 'chrome-dtc-content',
												template: i.default.template({
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, o) {
														return '<div class="spinner"></div>';
													},
													useData: !0,
												}),
											})
										),
										e.doChromeDTC(d);
							}
						}),
						(t.getBiometricsErrorOptions = function (e, t) {
							var n, r, o;
							n = t
								? Object.values(null == e || null === (r = e.value[0]) || void 0 === r ? void 0 : r.i18n)
								: null == e || null === (o = e.responseJSON) || void 0 === o
								? void 0
								: o.errorSummaryKeys;
							var i = n && n.includes(u.OV_UV_ENABLE_BIOMETRICS_FASTPASS_MOBILE),
								s = n && n.includes(u.OV_UV_ENABLE_BIOMETRICS_FASTPASS_DESKTOP),
								l = [];
							if (!i && !s) return l;
							var c = [
								(0, a.loc)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point1', 'login'),
								(0, a.loc)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point2', 'login'),
								(0, a.loc)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point3', 'login'),
							];
							s &&
								c.push(
									(0, a.loc)('oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point4', 'login')
								);
							return (l = {
								type: 'error',
								className: 'okta-verify-uv-callout-content',
								title: (0, a.loc)(
									'oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.title',
									'login'
								),
								subtitle: (0, a.loc)(
									'oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.description',
									'login'
								),
								bullets: c,
							});
						});
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = r(n(35546)),
						l = r(n(90570)),
						u = n(86725);
					function c(e, t) {
						return e && t && (e += '&login_hint=' + t), e;
					}
				},
				86725: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.WIDGET_FOOTER_CLASS =
							t.WARNING_TIMEOUT =
							t.UNIVERSAL_LINK_POST_DELAY =
							t.SHOW_RESEND_TIMEOUT =
							t.REQUEST_PARAM_AUTHENTICATION_CANCEL_REASON =
							t.OV_UV_ENABLE_BIOMETRICS_FASTPASS_MOBILE =
							t.OV_UV_ENABLE_BIOMETRICS_FASTPASS_DESKTOP =
							t.MS_PER_SEC =
							t.LOOPBACK_RESPONSE_STATUS_CODE =
							t.IDENTIFIER_FLOW =
							t.FASTPASS_FALLBACK_SPINNER_TIMEOUT =
							t.CHALLENGE_TIMEOUT =
							t.CANCEL_POLLING_ACTION =
							t.AUTHENTICATOR_CANCEL_ACTION =
							t.AUTHENTICATOR_ALLOWED_FOR_OPTIONS =
							t.AUTHENTICATION_CANCEL_REASONS =
								void 0);
					t.SHOW_RESEND_TIMEOUT = 3e4;
					t.WARNING_TIMEOUT = 3e4;
					t.CHALLENGE_TIMEOUT = 3e5;
					t.MS_PER_SEC = 1e3;
					t.UNIVERSAL_LINK_POST_DELAY = 500;
					t.CANCEL_POLLING_ACTION = 'authenticatorChallenge-cancel';
					t.AUTHENTICATOR_CANCEL_ACTION = 'currentAuthenticator-cancel';
					t.WIDGET_FOOTER_CLASS = 'siw-main-footer';
					t.FASTPASS_FALLBACK_SPINNER_TIMEOUT = 4e3;
					t.IDENTIFIER_FLOW = 'IDENTIFIER';
					t.OV_UV_ENABLE_BIOMETRICS_FASTPASS_DESKTOP =
						'oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.desktop';
					t.OV_UV_ENABLE_BIOMETRICS_FASTPASS_MOBILE =
						'oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.mobile';
					t.AUTHENTICATOR_ALLOWED_FOR_OPTIONS = { ANY: 'any', SSO: 'sso', RECOVERY: 'recovery' };
					t.REQUEST_PARAM_AUTHENTICATION_CANCEL_REASON = 'reason';
					t.LOOPBACK_RESPONSE_STATUS_CODE = 'statusCode';
					t.AUTHENTICATION_CANCEL_REASONS = {
						LOOPBACK_FAILURE: 'OV_UNREACHABLE_BY_LOOPBACK',
						OV_ERROR: 'OV_RETURNED_ERROR',
						USER_CANCELED: 'USER_CANCELED',
					};
				},
				23376: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					(t.default = {
						generateDeviceFingerprint: function (e, t) {
							return e.fingerprint({ timeout: 2e3, container: t });
						},
					}),
						(e.exports = t.default);
				},
				64459: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.probeLoopbackAndExecute = t.isLoopbackDeviceRemediation = t.hasDeviceRemediationAction = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(35546)),
						s = r(n(36894)),
						l = r(n(90570)),
						u = n(43318),
						c = function (e) {
							var t = Object.assign({ method: 'GET', contentType: 'application/json' }, e);
							return i.$.ajax(t);
						},
						d = function (e, t) {
							switch (e.type) {
								case 'APP_LINK':
									l.default.executeOnVisiblePage(function () {
										l.default.redirect(e.href, window, !0);
									});
									break;
								case 'MESSAGE':
									var n = document.getElementById(a.default.WIDGET_CONTAINER_ID);
									if (!n) return void s.default.error('Cannot find okta-sign-in container to display message');
									var r = n.querySelectorAll('[data-se="'.concat(t, '"]'));
									r &&
										r[0] &&
										(r[0].outerHTML =
											'idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.android_device_policy_app_required_manual_install' ===
											(i = e).message.i18n.key
												? o.default.template({
														compiler: [8, '>= 4.3.0'],
														main: function (e, t, n, r, o) {
															var i =
																e.lookupProperty ||
																function (e, t) {
																	if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																};
															return e.escapeExpression(
																(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
																	null != t ? t : e.nullContext || {},
																	{
																		name: 'i18n',
																		hash: {
																			$1: "<span class='strong'>$1</span>",
																			bundle: 'login',
																			code: 'idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.android_device_policy_app_required_manual_install',
																		},
																		data: o,
																		loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 194 } },
																	}
																)
															);
														},
														useData: !0,
												  })()
												: (0, u.getMessage)(i.message));
							}
							var i;
						},
						f = function (e, t) {
							return ((n = ''.concat(e, '/').concat('probe')), (r = t.probeTimeoutMillis), c({ url: n, timeout: r }))
								.then(function () {
									return (function (e, t) {
										return c({ url: e, method: 'GET', timeout: t });
									})(''.concat(e, '/').concat(t.remediationPath, '/').concat(t.actionPath), t.probeTimeoutMillis).then(
										function () {
											t.isSuccess = !0;
										}
									);
								})
								.catch(function () {
									return (
										s.default.error('Something unexpected happened while we were checking url: '.concat(e, '.')),
										i.$.Deferred().reject()
									);
								});
							var n, r;
						};
					t.hasDeviceRemediationAction = function (e) {
						return e.deviceRemediation && e.deviceRemediation.value && e.deviceRemediation.value.action;
					};
					t.isLoopbackDeviceRemediation = function (e) {
						return e && 'LOOPBACK' === e.remediationType;
					};
					t.probeLoopbackAndExecute = function (e) {
						var t = e.domain,
							n = e.ports,
							r = n.length,
							o = 0,
							i = {
								remediationPath: e.remediationPath,
								actionPath: e.action,
								probeTimeoutMillis: e.probeTimeoutMillis,
								isSuccess: !1,
							},
							a = Promise.resolve();
						n.map(function (e) {
							return ''.concat(t, ':').concat(e);
						}).forEach(function (t) {
							i.isSuccess ||
								(a = a
									.then(function () {
										return f(t, i);
									})
									.catch(function () {
										(o += 1),
											s.default.error('Authenticator is not listening on: '.concat(t, '.')),
											o >= r &&
												!i.isSuccess &&
												(s.default.error('No available ports. Loopback server failed and using fallback mechanism.'),
												d(e.fallback, e.action));
									}));
						});
					};
				},
				78747: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.getHelpLinks = function (e) {
							var t,
								n,
								r = o(e);
							switch (null == r ? void 0 : r.toUpperCase()) {
								case 'PERSONA':
									(t = 'https://withpersona.com/legal/terms-of-use'),
										(n = 'https://withpersona.com/legal/privacy-policy');
									break;
								case 'CLEAR':
									(t = 'https://www.clearme.com/member-terms'), (n = 'https://www.clearme.com/privacy-policy');
									break;
								case 'INCODE':
									(t = 'https://incode.id/terms'), (n = 'https://incode.id/privacy');
							}
							return { termsOfUse: t, privacyPolicy: n };
						}),
						(t.getIdvName = o);
					var r = n(13955);
					function o(e) {
						return e.find(function (e) {
							return e.name === r.FORMS.REDIRECT_IDVERIFY;
						}).idp.name;
					}
				},
				71101: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.goBackLink =
							t.getSwitchAuthenticatorLink =
							t.getSkipSetupLink =
							t.getSignUpLink =
							t.getSignOutLink =
							t.getReloadPageButtonLink =
							t.getForgotPasswordLink =
							t.getFactorPageCustomLink =
							t.getBackToSignInLink =
								void 0);
					var o = r(n(15985)),
						i = n(6475),
						a = n(13955);
					function s(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function l(e) {
						for (var t = 1; t < arguments.length; t++) {
							var n = null != arguments[t] ? arguments[t] : {};
							t % 2
								? s(Object(n), !0).forEach(function (t) {
										(0, o.default)(e, t, n[t]);
								  })
								: Object.getOwnPropertyDescriptors
								? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
								: s(Object(n)).forEach(function (t) {
										Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
								  });
						}
						return e;
					}
					var u = a.ACTIONS.ENROLLED_PASSWORD_RECOVERY_LINK,
						c = a.ACTIONS.ORG_PASSWORD_RECOVERY_LINK;
					t.getSwitchAuthenticatorLink = function (e) {
						return e.getRemediationAuthenticationOptions(a.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE).length > 1
							? [
									{
										type: 'link',
										label: (0, i.loc)('oie.verification.switch.authenticator', 'login'),
										name: 'switchAuthenticator',
										formName: a.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE,
									},
							  ]
							: e.getRemediationAuthenticationOptions(a.FORMS.SELECT_AUTHENTICATOR_ENROLL).length >= 1
							? [
									{
										type: 'link',
										label: (0, i.loc)('oie.enroll.switch.authenticator', 'login'),
										name: 'switchAuthenticator',
										formName: a.FORMS.SELECT_AUTHENTICATOR_ENROLL,
									},
							  ]
							: [];
					};
					t.getForgotPasswordLink = function (e, t) {
						var n = { type: 'link', label: (0, i.loc)('forgotpassword', 'login'), name: 'forgot-password' },
							r = t.get('helpLinks.forgotPassword');
						return r
							? [Object.assign({}, { href: r, label: (0, i.loc)('forgotpassword', 'login'), name: 'forgot-password' })]
							: e.getActionByPath(c)
							? [Object.assign({}, n, { actionPath: c })]
							: e.getActionByPath(u)
							? [Object.assign({}, n, { actionPath: u })]
							: [];
					};
					t.goBackLink = function (e) {
						return e.hasRemediationObject(a.FORMS.SELECT_AUTHENTICATOR_ENROLL)
							? [
									{
										type: 'link',
										label: (0, i.loc)('oie.go.back', 'login'),
										name: 'go-back',
										formName: a.FORMS.SELECT_AUTHENTICATOR_ENROLL,
									},
							  ]
							: [];
					};
					t.getSkipSetupLink = function (e, t) {
						return e.hasRemediationObject(a.FORMS.SKIP)
							? [
									{
										type: 'link',
										label: null != t ? t : (0, i.loc)('oie.enroll.skip.setup', 'login'),
										name: 'skip-setup',
										actionPath: a.FORMS.SKIP,
									},
							  ]
							: [];
					};
					t.getSignOutLink = function (e) {
						var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
						return null != e && e.get('backToSignInUri')
							? [{ label: (0, i.loc)('goback', 'login'), name: 'cancel', href: e.get('backToSignInUri') }]
							: [
									{
										actionPath: 'cancel',
										label: t.label ? t.label : (0, i.loc)('goback', 'login'),
										name: 'cancel',
										type: 'link',
									},
							  ];
					};
					t.getBackToSignInLink = function (e) {
						var t = e.settings,
							n = e.appState,
							r = {};
						return (
							null != t && t.get('backToSignInUri')
								? (r.href = t.get('backToSignInUri'))
								: null != t && t.get('oauth2Enabled')
								? (r.clickHandler = function () {
										n.trigger('restartLoginFlow');
								  })
								: (r.href = null == t ? void 0 : t.get('baseUrl')),
							[l({ type: 'link', label: (0, i.loc)('goback', 'login'), name: 'go-back' }, r)]
						);
					};
					t.getReloadPageButtonLink = function () {
						return [
							{
								type: 'link',
								label: (0, i.loc)('oie.try.again', 'login'),
								name: 'try-again',
								href: window.location,
								className: 'button button-primary text-align-c',
							},
						];
					};
					t.getSignUpLink = function (e, t) {
						var n = [];
						if (e.hasRemediationObject(a.FORMS.SELECT_ENROLL_PROFILE)) {
							var r = { type: 'link', label: (0, i.loc)('oie.registration.form.title', 'login'), name: 'enroll' };
							i._.isFunction(t.get('registration.click'))
								? (r.clickHandler = t.get('registration.click'))
								: (r.actionPath = a.FORMS.SELECT_ENROLL_PROFILE),
								n.push(r);
						}
						return n;
					};
					t.getFactorPageCustomLink = function (e, t) {
						var n = [],
							r = [
								a.FORMS.CHALLENGE_AUTHENTICATOR,
								a.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE,
								a.FORMS.CHALLENGE_POLL,
								a.FORMS.AUTHENTICATOR_VERIFICATION_DATA,
							];
						if (!e.get('isPasswordRecovery') && r.includes(e.get('currentFormName'))) {
							var o = t.get('helpLinks.factorPage.text'),
								i = t.get('helpLinks.factorPage.href');
							o && i && n.push({ type: 'link', label: o, name: 'factorPageHelpLink', href: i, target: '_blank' });
						}
						return n;
					};
				},
				77653: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					(t.default = {
						GMT: 'UTC',
						WET: 'WET',
						CET: 'CET',
						MET: 'CET',
						ECT: 'CET',
						EET: 'EET',
						MIT: 'Pacific/Apia',
						HST: 'Pacific/Honolulu',
						AST: 'America/Anchorage',
						PST: 'America/Los_Angeles',
						MST: 'America/Denver',
						PNT: 'America/Phoenix',
						CST: 'America/Chicago',
						EST: 'America/New_York',
						IET: 'America/Indiana/Indianapolis',
						PRT: 'America/Puerto_Rico',
						CNT: 'America/St_Johns',
						AGT: 'America/Argentina/Buenos_Aires',
						BET: 'America/Sao_Paulo',
						ART: 'Africa/Cairo',
						CAT: 'Africa/Harare',
						EAT: 'Africa/Addis_Ababa',
						NET: 'Asia/Yerevan',
						PLT: 'Asia/Karachi',
						IST: 'Asia/Kolkata',
						BST: 'Asia/Dhaka',
						VST: 'Asia/Ho_Chi_Minh',
						CTT: 'Asia/Shanghai',
						JST: 'Asia/Tokyo',
						ACT: 'Australia/Darwin',
						AET: 'Australia/Sydney',
						SST: 'Pacific/Guadalcanal',
						NST: 'Pacific/Auckland',
					}),
						(e.exports = t.default);
				},
				57785: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = n(13955),
						s = r(n(91002)),
						l = 'security.access_denied_custom_message',
						u = i.BaseForm.extend({
							title: function () {
								var e = (0, o.loc)('oie.success.text.signingIn', 'login'),
									t = this.options.appState.get('app'),
									n = this.options.appState.get('user');
								if (!this.redirectView || this.redirectView === a.INTERSTITIAL_REDIRECT_VIEW.NONE)
									return (e = (0, o.loc)('oie.success.text.signingIn.with.ellipsis', 'login'));
								if (o._.isEmpty(t)) return e;
								var r = t.label,
									i = t.name,
									s = (n || {}).identifier,
									l = r || i;
								return (
									l && s && !this.settings.get('features.showIdentifier')
										? (e = (0, o.loc)('oie.success.text.signingIn.with.appName.and.identifier', 'login', [l, s]))
										: l && (e = (0, o.loc)('oie.success.text.signingIn.with.appName', 'login', [l])),
									e
								);
							},
							showMessages: function () {
								if (this.isUnlockSuccess()) {
									var e = (0, o.loc)('oie.selfservice.unlock_user.landing.to.app.signing.in.message', 'login');
									this.add(
										'<div class="ion-messages-container"><p>'.concat(e, '</p></div>'),
										'.o-form-error-container'
									);
								} else if (this.options.appState.containsMessageStartingWithI18nKey(l)) {
									var t = this.options.appState.get('messages').value.find(function (e) {
											return e.i18n.key === l;
										}),
										n = t.message,
										r = t.links;
									this.add((0, o.createCallout)({ type: 'error', content: new s.default({ message: n, links: r }) }));
								} else i.BaseForm.prototype.showMessages.call(this);
							},
							isUnlockSuccess: function () {
								return this.options.appState.containsMessageWithI18nKey(
									'oie.selfservice.unlock_user.landing.to.app.success.message'
								);
							},
							noButtonBar: !0,
							initialize: function () {
								i.BaseForm.prototype.initialize.apply(this, arguments),
									(this.redirectView = this.settings.get('interstitialBeforeLoginRedirect')),
									this.model.set('useRedirect', !0),
									this.trigger('save', this.model);
							},
							render: function () {
								i.BaseForm.prototype.render.apply(this, arguments),
									this.redirectView === a.INTERSTITIAL_REDIRECT_VIEW.DEFAULT &&
										this.add('<div class="okta-waiting-spinner"></div>');
							},
						}),
						c = i.BaseView.extend({ Body: u });
					(t.default = c), (e.exports = t.default);
				},
				60342: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = n(17587),
						s = n(71101),
						l = a.BaseForm.extend({
							className: 'profile-update',
							title: function () {
								return (0, i.loc)('oie.profile.additional.title', 'login');
							},
							save: function () {
								return (0, i.loc)('enroll.choices.submit.finish', 'login');
							},
							getUISchema: function () {
								var e = a.BaseForm.prototype.getUISchema.apply(this, arguments);
								return (
									e.forEach(function (e) {
										'userProfile.secondEmail' === e.name &&
											(e.explain = i.View.extend({
												template: o.default.template({
													compiler: [8, '>= 4.3.0'],
													main: function (e, t, n, r, o) {
														var i,
															a =
																e.lookupProperty ||
																function (e, t) {
																	if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																};
														return null !=
															(i = (a(n, 'i18n') || (t && a(t, 'i18n')) || e.hooks.helperMissing).call(
																null != t ? t : e.nullContext || {},
																{
																	name: 'i18n',
																	hash: {
																		$1: "<span class='strong'>$1</span>",
																		bundle: 'login',
																		code: 'oie.profile.additional.secondemail.subtitle',
																	},
																	data: o,
																	loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 112 } },
																}
															))
															? i
															: '';
													},
													useData: !0,
												}),
											}));
									}),
									e
								);
							},
							initialize: function () {
								a.BaseForm.prototype.initialize.apply(this, arguments);
							},
						}),
						u = a.BaseFooter.extend({
							className: 'auth-footer side-by-side-links',
							links: function () {
								var e = this.options.currentViewState.uiSchema,
									t = e.filter(function (e) {
										return !1 === e.required;
									});
								if (e.length === t.length)
									return (0, s.getSkipSetupLink)(this.options.appState, (0, i.loc)('oie.enroll.skip.profile', 'login'));
								this.$el.removeClass('.side-by-side-links');
							},
						}),
						c = a.BaseView.extend({
							Body: l,
							Footer: u,
							postRender: function () {
								a.BaseView.prototype.postRender.apply(this, arguments),
									this.options.appState.getSchemaByName('userProfile.secondEmail') &&
										this.model.set('userProfile.secondEmail', '');
							},
						});
					(t.default = c), (e.exports = t.default);
				},
				56111: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(15985)),
						i = n(6475),
						a = n(17587),
						s = n(13955),
						l = n(25795),
						u = n(81554),
						c = r(n(21586));
					function d(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function f(e) {
						for (var t = 1; t < arguments.length; t++) {
							var n = null != arguments[t] ? arguments[t] : {};
							t % 2
								? d(Object(n), !0).forEach(function (t) {
										(0, o.default)(e, t, n[t]);
								  })
								: Object.getOwnPropertyDescriptors
								? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
								: d(Object(n)).forEach(function (t) {
										Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
								  });
						}
						return e;
					}
					var p = a.BaseForm.extend({
							title: function () {
								if (this.options.appState.getCurrentViewState().href.endsWith('idp/idx/enroll/update')) {
									var e,
										t = this.options.appState.attributes;
									return null != t && null !== (e = t.uiDisplay) && void 0 !== e && e.label
										? (0, i.loc)('oie.registration.form.customize.label', 'login', [t.uiDisplay.label])
										: (0, i.loc)('oie.primaryauth.submit', 'login');
								}
								return (0, i.loc)('oie.registration.form.title', 'login');
							},
							save: function () {
								if (this.options.appState.getCurrentViewState().href.endsWith('idp/idx/enroll/update')) {
									var e,
										t = this.options.appState.attributes;
									return null != t && null !== (e = t.uiDisplay) && void 0 !== e && e.buttonLabel
										? (0, i.loc)('oie.registration.form.customize.buttonLabel', 'login', [t.uiDisplay.buttonLabel])
										: (0, i.loc)('oie.registration.form.update.submit', 'login');
								}
								return (0, i.loc)('oie.registration.form.submit', 'login');
							},
							saveForm: function () {
								var e = this;
								this.settings.preRegistrationSubmit(
									this.model.toJSON(),
									function (t) {
										(e.model.attributes = f(f({}, e.model.attributes), e.model.parse(t))),
											a.BaseForm.prototype.saveForm.call(e, e.model);
									},
									function (t) {
										return e.model.trigger('error', e.model, { responseJSON: t });
									}
								);
							},
							triggerAfterError: function (e, t) {
								var n;
								(null == t || null === (n = t.responseJSON) || void 0 === n ? void 0 : n.errorCauses) &&
									Array.isArray(t.responseJSON.errorCauses) &&
									t.responseJSON.errorCauses.forEach(function (e) {
										var t;
										null !== (t = e.errorKey) &&
											void 0 !== t &&
											t.includes('password.passwordRequirementsNotMet') &&
											(e.errorSummary = (0, i.loc)('registration.error.password.passwordRequirementsNotMet', 'login'));
									}),
									this.options.appState.trigger('afterError', t);
							},
						}),
						h = a.BaseFooter.extend({
							links: function () {
								var e = [];
								return (
									this.options.appState.hasRemediationObject(s.FORMS.SELECT_IDENTIFY) &&
										e.push({
											type: 'link',
											label: (0, i.loc)('haveaccount', 'login'),
											name: 'back',
											actionPath: s.FORMS.SELECT_IDENTIFY,
										}),
									e
								);
							},
						}),
						m = a.BaseView.extend({
							Body: p,
							Footer: h,
							createModelClass: function (e, t, n) {
								var r = this,
									o = JSON.parse(JSON.stringify(e.uiSchema)),
									s = a.BaseView.prototype.createModelClass.apply(this, arguments, e);
								return (
									(s = s.extend({
										toJSON: function () {
											var t = i.Model.prototype.toJSON.call(this, arguments, e);
											if (t.userProfile) {
												var n = e.uiSchema,
													r = t.userProfile;
												i._.each(r, function (e, t) {
													if (i._.isEmpty(e)) {
														var o = n.find(function (e) {
															return e.name === 'userProfile.'.concat(t);
														});
														i._.isUndefined(o) || o.required || delete r[t];
													}
												});
											}
											return t;
										},
									})),
									n.parseRegistrationSchema(
										o,
										function (n) {
											i._.isEqual(n, e.uiSchema) ||
												((e.uiSchema = n), (s = a.BaseView.prototype.createModelClass.call(r, e, t)));
										},
										function (e) {
											s = s.extend({ local: f({ parseSchemaError: { value: e, type: 'object' } }, s.prototype.local) });
										}
									),
									s
								);
							},
							postRender: function () {
								a.BaseView.prototype.postRender.apply(this, arguments);
								var e = this.model.get('parseSchemaError');
								e && this.model.trigger('error', this.model, { responseJSON: e }), this.renderPasswordPolicySettings();
								var t = (0, a.createIdpButtons)(this.options);
								Array.isArray(t) && t.length && this._addIdpView(t);
							},
							renderPasswordPolicySettings: function () {
								var e,
									t,
									n,
									r = this.options.currentViewState.value.filter(function (e) {
										return 'credentials' === e.name;
									})[0],
									o = null == r || null === (e = r.form) || void 0 === e ? void 0 : e.value;
								o &&
									o.filter(function (e) {
										return 'passcode' === e.name;
									}) &&
									(0, u.generatePasswordPolicyHtml)(
										this,
										(0, l.getPasswordComplexityDescriptionForHtmlList)(
											null == r || null === (t = r.relatesTo) || void 0 === t || null === (n = t.value) || void 0 === n
												? void 0
												: n.settings
										),
										!1
									);
							},
							_addIdpView: function (e) {
								var t = this.options.settings.get('idpDisplay'),
									n = t && 'PRIMARY' === t.toUpperCase();
								this.add(c.default, {
									prepend: n,
									selector: n ? '.o-form-fieldset-container' : '.o-form-button-bar',
									options: { idpButtons: e, isPrimaryIdpDisplay: n },
								});
							},
						});
					(t.default = m), (e.exports = t.default);
				},
				57973: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(70232)),
						i = r(n(31049)),
						a = r(n(15985)),
						s = n(6475),
						l = n(13955),
						u = n(17587),
						c = r(n(76587)),
						d = r(n(23376)),
						f = r(n(7667)),
						p = r(n(87547)),
						h = r(n(21586)),
						m = r(n(94438)),
						v = r(n(83201)),
						g = r(n(156)),
						y = n(43318),
						b = n(71101),
						_ = r(n(26368)),
						w = r(n(91002)),
						O = r(n(90570)),
						k = r(n(49268));
					function x(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function E(e) {
						for (var t = 1; t < arguments.length; t++) {
							var n = null != arguments[t] ? arguments[t] : {};
							t % 2
								? x(Object(n), !0).forEach(function (t) {
										(0, a.default)(e, t, n[t]);
								  })
								: Object.getOwnPropertyDescriptors
								? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
								: x(Object(n)).forEach(function (t) {
										Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
								  });
						}
						return e;
					}
					var T = 'security.access_denied_custom_message',
						S = u.BaseForm.extend({
							title: function () {
								return (0, s.loc)('primaryauth.title', 'login');
							},
							save: function () {
								return (0, s.loc)('oform.next', 'login');
							},
							initialize: function () {
								u.BaseForm.prototype.initialize.apply(this, arguments);
								var e = this.getUISchema();
								e.find(function (e) {
									return 'credentials.passcode' === e.name;
								}) && (this.save = (0, s.loc)('oie.primaryauth.submit', 'login')),
									this._shouldAddUsername(e)
										? this.model.set('identifier', this.settings.get('username'))
										: !this.model.get('identifier') &&
										  this._shouldApplyRememberMyUsername(e) &&
										  this._applyRememberMyUsername();
							},
							saveForm: function () {
								var e = this,
									t = arguments;
								if (this.settings.get('features.deviceFingerprinting')) {
									this.model.trigger('request');
									var n = this.settings.getAuthClient();
									d.default
										.generateDeviceFingerprint(n, this.$el[0])
										.then(function (t) {
											e.options.appState.set('deviceFingerprint', t);
										})
										.catch(function () {})
										.finally(function () {
											u.BaseForm.prototype.saveForm.apply(e, t);
										});
								} else u.BaseForm.prototype.saveForm.apply(this, arguments);
							},
							render: function () {
								u.BaseForm.prototype.render.apply(this, arguments),
									this.options.appState.hasRemediationObject(l.FORMS.LAUNCH_AUTHENTICATOR) &&
										this.add(v.default, '.o-form-fieldset-container', !1, !0, { isRequired: !1 }),
									this.options.appState.hasRemediationObject(l.FORMS.LAUNCH_WEBAUTHN_AUTHENTICATOR) &&
										this.add(g.default, '.o-form-fieldset-container', !1, !0, { isRequired: !1 });
								var e = (0, u.createIdpButtons)(this.options);
								Array.isArray(e) && e.length && (this._addForgotPasswordView(), this._addIdpView(e));
								var t = (0, u.createCustomButtons)(this.options.settings);
								Array.isArray(t) &&
									t.length &&
									this.add(m.default, {
										selector: '.o-form-button-bar',
										options: { customButtons: t, addSeparateLine: !0 },
									});
							},
							postRender: function () {
								u.BaseForm.prototype.postRender.apply(this, arguments),
									this.$el.find('.identifier-container').remove(),
									this.getCredentialsAndInvokeAction();
							},
							getUISchema: function () {
								var e = this,
									t = u.BaseForm.prototype.getUISchema.apply(this, arguments),
									n = this.options.settings,
									r = 'primaryauth.username.tooltip',
									o = 'primaryauth.password.tooltip',
									i = t.map(function (t) {
										var i = E({}, t);
										if ('identifier' === t.name) {
											(0, y.isCustomizedI18nKey)(r, n) &&
												(i = E(E({}, i), {}, { 'explain': (0, s.loc)(r, 'login'), 'explain-top': !0 }));
											var a =
												e.options.appState.hasRemediationObject(l.FORMS.CHALLENGE_WEBAUTHN_AUTOFILLUI_AUTHENTICATOR) &&
												k.default.isConditionalMediationAvailable()
													? 'username webauthn'
													: 'username';
											i = E(E({}, i), {}, { autoComplete: O.default.getAutocompleteValue(e.options.settings, a) });
										} else 'credentials.passcode' === t.name && ((i = E(E({}, i), {}, { autoComplete: O.default.getAutocompleteValue(e.options.settings, 'current-password') })), (0, y.isCustomizedI18nKey)(o, n) && (i = E(E({}, i), {}, { 'explain': (0, s.loc)(o, 'login'), 'explain-top': !0 })));
										return i;
									});
								return (
									!1 === this.settings.get('features.showKeepMeSignedIn') &&
										(i = i.filter(function (e) {
											return 'rememberMe' !== e.name;
										})),
									i
								);
							},
							showCustomFormErrorCallout: function (e, t) {
								var n, r;
								if (
									null == e ||
									null === (n = e.responseJSON) ||
									void 0 === n ||
									null === (r = n.errorSummaryKeys) ||
									void 0 === r ||
									!r.includes(T)
								)
									return !1;
								var o =
									null == t
										? void 0
										: t.find(function (e) {
												return e.i18n.key === T;
										  });
								if (!o) return !1;
								var i = e.responseJSON.errorSummary,
									a = { type: 'error', content: new w.default({ message: i, links: o.links }) };
								return this.showMessages((0, s.createCallout)(a)), !0;
							},
							remove: function () {
								u.BaseForm.prototype.remove.apply(this, arguments),
									this.webauthnAbortController &&
										(this.webauthnAbortController.abort(), (this.webauthnAbortController = null));
							},
							getCredentialsAndInvokeAction: function () {
								var e = this;
								return (0, i.default)(
									o.default.mark(function t() {
										var n, r, i, a;
										return o.default.wrap(function (t) {
											for (;;)
												switch ((t.prev = t.next)) {
													case 0:
														return (
															(r =
																null === (n = e.options.appState.get('webauthnAutofillUIChallenge')) || void 0 === n
																	? void 0
																	: n.challengeData),
															(t.next = 3),
															k.default.isPasskeyAutofillAvailable()
														);
													case 3:
														if (((i = t.sent), r && i && 'undefined' != typeof AbortController)) {
															t.next = 6;
															break;
														}
														return t.abrupt('return');
													case 6:
														(a = s._.extend({}, r, { challenge: c.default.strToBin(r.challenge) })),
															(e.webauthnAbortController = new AbortController()),
															navigator.credentials
																.get({
																	mediation: 'conditional',
																	publicKey: a,
																	signal: e.webauthnAbortController.signal,
																})
																.then(
																	function (t) {
																		var n,
																			r = c.default.binToStr(
																				null !== (n = t.response.userHandle) && void 0 !== n ? n : ''
																			);
																		if (s._.isEmpty(r)) {
																			var o = (0, s.loc)('oie.webauthn.error.invalidPasskey', 'login');
																			e.model.trigger('error', e.model, e._generateErrorObject(o));
																		} else {
																			var i = {
																				clientData: c.default.binToStr(t.response.clientDataJSON),
																				authenticatorData: c.default.binToStr(t.response.authenticatorData),
																				signatureData: c.default.binToStr(t.response.signature),
																				userHandle: r,
																			};
																			e.options.appState.trigger(
																				'invokeAction',
																				l.FORMS.CHALLENGE_WEBAUTHN_AUTOFILLUI_AUTHENTICATOR,
																				{ credentials: i }
																			);
																		}
																	},
																	function (t) {
																		if (e.webauthnAbortController) {
																			var n = (0, y.getMessageFromBrowserError)(t);
																			e.model.trigger('error', e.model, e._generateErrorObject(n));
																		}
																	}
																)
																.finally(function () {
																	e.webauthnAbortController = null;
																});
													case 9:
													case 'end':
														return t.stop();
												}
										}, t);
									})
								)();
							},
							_generateErrorObject: function (e) {
								return { responseJSON: { errorSummary: e } };
							},
							_addForgotPasswordView: function () {
								var e = (0, b.getForgotPasswordLink)(this.options.appState, this.options.settings);
								e.length &&
									(this.add('<div class="links-primary"></div>', { selector: '.o-form-button-bar' }),
									this.add(p.default, { selector: '.links-primary', options: e[0] }));
							},
							_addIdpView: function (e) {
								var t = this.options.settings.get('idpDisplay'),
									n = t && 'PRIMARY' === t.toUpperCase();
								this.add(h.default, {
									prepend: n,
									selector: n ? '.o-form-fieldset-container' : '.o-form-button-bar',
									options: { idpButtons: e, isPrimaryIdpDisplay: n },
								});
							},
							_shouldAddUsername: function (e) {
								return (
									e.find(function (e) {
										return 'identifier' === e.name;
									}) && this.settings.get('username')
								);
							},
							_shouldApplyRememberMyUsername: function (e) {
								return (
									e.find(function (e) {
										return 'identifier' === e.name;
									}) && this.settings.get('features.rememberMe')
								);
							},
							_applyRememberMyUsername: function () {
								var e = _.default.getCookieUsername();
								e && this.model.set('identifier', e);
							},
						}),
						A = u.BaseView.extend({
							Body: S,
							createModelClass: function () {
								var e = this,
									t = u.BaseView.prototype.createModelClass.apply(this, arguments),
									n = 'error.username.required',
									r = 'error.password.required',
									o = t.prototype.props,
									i = function (t) {
										var i = {},
											a = o.identifier && !(null != t && t.identifier),
											l = o['credentials.passcode'] && !(null != t && t['credentials.passcode']);
										return (
											a && (0, y.isCustomizedI18nKey)(n, e.settings) && (i.identifier = (0, s.loc)(n, 'login')),
											l &&
												(0, y.isCustomizedI18nKey)(r, e.settings) &&
												(i['credentials.passcode'] = (0, s.loc)(r, 'login')),
											i
										);
									};
								return t.extend({ validate: i });
							},
							initialize: function () {
								var e = this;
								this.Footer = f.default.extend({
									showForgotPasswordLink: function () {
										var t = (0, u.createIdpButtons)(e.options);
										return !(e.options.appState.isIdentifierOnlyView() || (Array.isArray(t) && 0 !== t.length));
									},
								});
							},
							postRender: function () {
								u.BaseView.prototype.postRender.apply(this, arguments);
								var e = this.options.appState;
								this.$el.find('.js-sign-up').click(function () {
									return e.trigger('invokeAction', l.FORMS.SELECT_ENROLL_PROFILE), !1;
								});
							},
						});
					(t.default = A), (e.exports = t.default);
				},
				91485: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(15985)),
						i = n(6475),
						a = n(17587),
						s = r(n(90570));
					function l(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function u(e) {
						for (var t = 1; t < arguments.length; t++) {
							var n = null != arguments[t] ? arguments[t] : {};
							t % 2
								? l(Object(n), !0).forEach(function (t) {
										(0, o.default)(e, t, n[t]);
								  })
								: Object.getOwnPropertyDescriptors
								? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
								: l(Object(n)).forEach(function (t) {
										Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
								  });
						}
						return e;
					}
					var c = a.BaseForm.extend({
							title: function () {
								return (0, i.loc)('password.reset.title.generic', 'login');
							},
							save: function () {
								return (0, i.loc)('oform.next', 'login');
							},
							getUISchema: function () {
								var e = this,
									t = a.BaseForm.prototype.getUISchema.apply(this, arguments),
									n = t.map(function (t) {
										var n = u({}, t);
										return (
											'identifier' === t.name &&
												(n = u(
													u({}, n),
													{},
													{ autoComplete: s.default.getAutocompleteValue(e.options.settings, 'username') }
												)),
											n
										);
									});
								return n;
							},
						}),
						d = a.BaseView.extend({ Body: c, Footer: a.BaseFooter });
					(t.default = d), (e.exports = t.default);
				},
				57571: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = n(17587),
						s = n(86725),
						l = i.View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<div class="ion-messages-container"><p>' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: {
														$1: "<span class='strong'>$1</span>",
														arguments: 'countDownCounterValue',
														bundle: 'login',
														code: 'poll.form.message',
													},
													data: o,
													loc: { start: { line: 1, column: 39 }, end: { line: 1, column: 157 } },
												}
											)
										) +
										'</p></div><div class="hide okta-waiting-spinner"></div>'
									);
								},
								useData: !0,
							}),
							getTemplateData: function () {
								return { countDownCounterValue: this.options };
							},
						}),
						u = a.BaseForm.extend(
							Object.assign({
								title: function () {
									return (0, i.loc)('poll.form.title', 'login');
								},
								noButtonBar: !0,
								initialize: function () {
									var e = this;
									a.BaseForm.prototype.initialize.apply(this, arguments);
									var t = this.options.appState.getCurrentViewState().refresh;
									this.refreshTimeout = setTimeout(function () {
										e.$el.find('.okta-waiting-spinner').show(),
											setTimeout(function () {
												return e.saveForm(e.model);
											}, 200);
									}, t);
								},
								render: function () {
									a.BaseForm.prototype.render.apply(this, arguments),
										(this.countDownCounterValue = Math.ceil(
											this.options.appState.getCurrentViewState().refresh / s.MS_PER_SEC
										)),
										this.add(new l(this.countDownCounterValue)),
										this.startCountDown('.ion-messages-container span', s.MS_PER_SEC);
								},
								remove: function () {
									a.BaseForm.prototype.remove.apply(this, arguments), clearTimeout(this.refreshTimeout);
								},
								triggerAfterError: function () {
									a.BaseForm.prototype.triggerAfterError.apply(this, arguments),
										clearTimeout(this.refreshTimeout),
										this.stopCountDown(),
										this.$el.find('.o-form-fieldset-container').empty();
								},
								startCountDown: function (e, t) {
									var n = this;
									this.countDown && clearInterval(this.countDown),
										(this.counterEl = this.$el.find(e)),
										(this.countDown = setInterval(
											function () {
												'0' !== n.counterEl.text() && n.counterEl.text(n.counterEl.text() - 1);
											},
											t,
											this
										));
								},
								stopCountDown: function () {
									this.countDown && clearInterval(this.countDown);
								},
							})
						),
						c = a.BaseView.extend({ Body: u });
					(t.default = c), (e.exports = t.default);
				},
				92017: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(57973)),
						i = o.default.extend({
							render: function () {
								o.default.prototype.render.apply(this, arguments),
									this.$el.find('.sign-in-with-idp .separation-line').hide(),
									this.$el.find('.button-primary').hide();
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				81261: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(17587),
						o = n(6475),
						i = r.BaseForm.extend({
							title: function () {
								return (0, o.loc)('oie.select.authenticators.enroll.title', 'login');
							},
							subtitle: function () {
								var e = this.options.settings.get('brandName')
									? (0, o.loc)('oie.select.authenticators.enroll.subtitle.custom', 'login', [
											this.options.settings.get('brandName'),
									  ])
									: (0, o.loc)('oie.select.authenticators.enroll.subtitle', 'login');
								return e;
							},
							noButtonBar: !0,
						}),
						a = r.BaseView.extend({ Body: i });
					(t.default = a), (e.exports = t.default);
				},
				21748: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = t.Body = void 0);
					var o = n(17587),
						i = n(6475),
						a = r(n(8517)),
						s = n(71101),
						l = o.BaseForm.extend({
							title: function () {
								return this.isPasswordRecoveryFlow()
									? (0, i.loc)('password.reset.title.generic', 'login')
									: (0, i.loc)('oie.select.authenticators.verify.title', 'login');
							},
							subtitle: function () {
								if (this.isPasswordRecoveryFlow()) return (0, i.loc)('oie.password.reset.verification', 'login');
								if (!this.isUnlockSuccess()) return (0, i.loc)('oie.select.authenticators.verify.subtitle', 'login');
								var e = (0, i.loc)('oie.select.authenticators.verify.subtitle', 'login');
								this.add('<div class="ion-messages-container"><p>'.concat(e, '</p></div>'), '.o-form-error-container');
							},
							isPasswordRecoveryFlow: function () {
								return this.options.appState.get('isPasswordRecovery');
							},
							noButtonBar: !0,
							showMessages: function () {
								if (this.isUnlockSuccess()) {
									var e = {};
									return (
										(e.subtitle = (0, i.loc)('oie.selfservice.unlock_user.landing.to.app.success.message', 'login')),
										(e.type = 'success'),
										(e = (0, i.createCallout)(e)),
										void o.BaseForm.prototype.showMessages.call(this, e)
									);
								}
								o.BaseForm.prototype.showMessages.call(this);
							},
							isUnlockSuccess: function () {
								return this.options.appState.containsMessageWithI18nKey(
									'oie.selfservice.unlock_user.landing.to.app.success.message'
								);
							},
						});
					t.Body = l;
					var u = o.BaseView.extend({
						Body: l,
						Footer: a.default.extend({
							links: function () {
								return (0, s.getFactorPageCustomLink)(this.options.appState, this.options.settings);
							},
						}),
					});
					t.default = u;
				},
				44822: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.default = t.REGISTRATION_NOT_ENABLED = t.FORGOT_PASSWORD_NOT_ENABLED = void 0);
					var o,
						i = r(n(15985)),
						a = r(n(31752)),
						s = n(6475),
						l = n(17587),
						u = n(71101),
						c = r(n(89597)),
						d = n(90959),
						f = r(n(91002)),
						p = r(n(11024)),
						h = 'idx.return.link.expired',
						m = 'idx.enter.otp.in.original.tab',
						v = 'idx.error.server.safe.mode',
						g = 'oie.selfservice.unlock_user.success.message',
						y = 'idx.return.to.original.tab',
						b = 'idx.operation.cancelled.on.other.device',
						_ = 'idx.device.activated',
						w = 'idx.device.not.activated.consent.denied',
						O = 'idx.device.not.activated.internal.error',
						k = 'idx.transferred.to.new.tab',
						x = 'oie.registration.is.not.enabled';
					t.REGISTRATION_NOT_ENABLED = x;
					var E = 'oie.forgot.password.is.not.enabled';
					t.FORGOT_PASSWORD_NOT_ENABLED = E;
					var T = [
							k,
							'idx.return.stale',
							'idx.return.error',
							'idx.email.verification.required',
							y,
							h,
							b,
							'idx.operation.cancelled.by.user',
							m,
						],
						S = [w, O],
						A = [_].concat(S),
						C = [g, y, k, b].concat((0, a.default)(A), [
							'oie.selfservice.unlock_user.challenge.failed.permissions',
							'oie.selfservice.reset.password.not.allowed',
							m,
						]),
						P =
							((o = {}),
							(0, i.default)(o, h, 'oie.email.return.link.expired.title'),
							(0, i.default)(o, g, 'account.unlock.unlocked.title'),
							(0, i.default)(o, _, 'device.code.activated.success.title'),
							(0, i.default)(o, x, 'oie.registration.form.title'),
							(0, i.default)(o, E, 'password.reset.title.generic'),
							(0, i.default)(o, 'idx.expired.activation.token', 'oie.activation.request.email.title.expire'),
							(0, i.default)(o, 'idx.request.activation.email', 'oie.activation.request.email.title.submitted'),
							(0, i.default)(o, 'idx.activating.inactive.user', 'oie.activation.request.email.title.suspended'),
							(0, i.default)(o, 'idx.missing.activation.token', 'oie.activation.request.email.title.invalid'),
							(0, i.default)(o, w, 'device.code.activated.error.title'),
							(0, i.default)(o, O, 'device.code.activated.error.title'),
							(0, i.default)(o, y, 'oie.consent.enduser.email.allow.title'),
							(0, i.default)(o, m, 'idx.return.link.otponly.your.verification.code'),
							o),
						R = l.BaseForm.extend({
							noButtonBar: !0,
							postRender: function () {
								if (
									(l.BaseForm.prototype.postRender.apply(this, arguments),
									this.$el.addClass('terminal-state'),
									this.options.appState.containsMessageWithI18nKey(A))
								) {
									var e = this.options.appState.containsMessageWithI18nKey(_) ? 'success-24-green' : 'error-24-red';
									this.$('.o-form-head').before(
										'<div class="device-code-terminal--icon-container"><span class="device-code-terminal--icon ' +
											e +
											'"></span></div>'
									);
								}
							},
							title: function () {
								return this.getTerminalViewTitle();
							},
							getTerminalViewTitle: function () {
								var e = this;
								if (this.options.appState.containsMessageStartingWithI18nKey(v))
									return (0, s.loc)('oie.safe.mode.title', 'login');
								var t = Object.keys(P).find(function (t) {
									return e.options.appState.containsMessageWithI18nKey(t);
								});
								return t ? (0, s.loc)(P[t], 'login') : void 0;
							},
							prepareMessageForCustomView: function (e) {
								var t = !1;
								return (
									this.options.appState.containsMessageWithI18nKey(m)
										? (this.add(d.OTPInformationTerminalView), (t = !0))
										: this.options.appState.containsMessageStartingWithI18nKey('security.access_denied_custom_message')
										? (this.add(
												(0, s.createCallout)({
													type: 'error',
													content: new f.default({ message: e.value[0].message, links: e.value[0].links }),
												})
										  ),
										  (t = !0))
										: this.options.appState.containsMessageStartingWithI18nKey(
												'idx.error.code.access_denied.device_assurance.remediation.'
										  ) &&
										  (this.add((0, s.createCallout)({ type: 'error', content: new p.default({ messages: e.value }) })),
										  (t = !0)),
									t
								);
							},
							showMessages: function () {
								var e,
									t = this.options.appState.get('messages'),
									n = !1;
								this.options.appState.containsMessageWithI18nKey(b)
									? ((e = (0, s.loc)('idx.operation.cancelled.on.other.device', 'login')),
									  t.value.push({ message: (0, s.loc)('oie.consent.enduser.deny.description', 'login') }))
									: this.options.appState.containsMessageWithI18nKey(y)
									? ((e = (0, s.loc)('oie.consent.enduser.email.allow.description', 'login')),
									  t.value.push({ message: (0, s.loc)('oie.return.to.original.tab', 'login') }))
									: this.options.appState.containsMessageWithI18nKey('tooManyRequests')
									? (e = (0, s.loc)('oie.tooManyRequests', 'login'))
									: this.options.appState.containsMessageWithI18nKey(h)
									? (t.value[0].class = 'ERROR')
									: (n = this.prepareMessageForCustomView(t)),
									e && Array.isArray(null == t ? void 0 : t.value) && (t.value[0].message = e),
									this.options.appState.set('messages', t),
									n || l.BaseForm.prototype.showMessages.call(this);
							},
						}),
						I = l.BaseFooter.extend({
							links: function () {
								return this.options.appState.containsMessageStartingWithI18nKey(v)
									? (0, u.getSkipSetupLink)(this.options.appState)
									: this.options.appState.containsMessageWithI18nKey(S)
									? (0, u.getReloadPageButtonLink)()
									: !(
											this.options.appState.hasActionObject('cancel') ||
											this.options.appState.containsMessageWithI18nKey(C) ||
											this.options.settings.get('features.hideSignOutLinkInMFA') ||
											this.options.settings.get('features.mfaOnlyFlow')
									  )
									? (0, u.getBackToSignInLink)(this.options)
									: void 0;
							},
						}),
						N = l.BaseView.extend({
							initialize: function () {
								l.BaseView.prototype.initialize.apply(this, arguments),
									this.options.appState.containsMessageWithI18nKey(T) && (this.Header = c.default);
							},
							Body: R,
							Footer: I,
						});
					t.default = N;
				},
				99208: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(17587),
						o = n(6475),
						i = r.BaseForm.extend({
							title: function () {
								return (0, o.loc)('oie.activation.request.email.title.expire', 'login');
							},
							save: function () {
								return (0, o.loc)('oie.activation.request.email.button', 'login');
							},
						}),
						a = r.BaseView.extend({ Body: i });
					(t.default = a), (e.exports = t.default);
				},
				99836: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(17587),
						o = n(6475),
						i = r.BaseForm.extend({
							noButtonBar: !0,
							title: function () {
								return (0, o.loc)('oie.select.authenticators.verify.title', 'login');
							},
							subtitle: function () {
								return (0, o.loc)('oie.select.authenticators.verify.subtitle', 'login');
							},
						}),
						a = r.BaseView.extend({ Body: i });
					(t.default = a), (e.exports = t.default);
				},
				28141: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(17587),
						o = n(6475),
						i = r.BaseForm.extend({
							title: function () {
								return (0, o.loc)('account.unlock.title', 'login');
							},
						}),
						a = r.BaseView.extend({
							initialize: function () {
								r.BaseView.prototype.initialize.apply(this, arguments), (this.Body = i);
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				19277: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(15985)),
						i = r(n(12990)),
						a = r(n(2875)),
						s = n(6475),
						l = r(n(35546)),
						u = r(n(90570)),
						c = n(86725);
					function d(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function f(e) {
						for (var t = 1; t < arguments.length; t++) {
							var n = null != arguments[t] ? arguments[t] : {};
							t % 2
								? d(Object(n), !0).forEach(function (t) {
										(0, o.default)(e, t, n[t]);
								  })
								: Object.getOwnPropertyDescriptors
								? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
								: d(Object(n)).forEach(function (t) {
										Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
								  });
						}
						return e;
					}
					var p = 'OktaSignInWidgetOnCaptchaLoaded',
						h = 'OktaSignInWidgetOnCaptchaSolved',
						m = s.View.extend({
							className: 'captcha-view',
							template: a.default.template({
								1: function (e, t, n, r, o) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div id ="captcha-container" class="' +
										c(
											((a = null != (a = d(n, 'className') || (null != t ? d(t, 'className') : t)) ? a : l),
											(0, i.default)(a) === u
												? a.call(s, {
														name: 'className',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 63 }, end: { line: 1, column: 76 } },
												  })
												: a)
										) +
										'" data-sitekey="' +
										c(
											((a = null != (a = d(n, 'siteKey') || (null != t ? d(t, 'siteKey') : t)) ? a : l),
											(0, i.default)(a) === u
												? a.call(s, {
														name: 'siteKey',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 92 }, end: { line: 1, column: 103 } },
												  })
												: a)
										) +
										'" data-callback="' +
										c(
											((a =
												null !=
												(a = d(n, 'onCaptchaSolvedCallback') || (null != t ? d(t, 'onCaptchaSolvedCallback') : t))
													? a
													: l),
											(0, i.default)(a) === u
												? a.call(s, {
														name: 'onCaptchaSolvedCallback',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 120 }, end: { line: 1, column: 147 } },
												  })
												: a)
										) +
										'" data-size="invisible"></div>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return null !=
										(i = a(n, 'if').call(
											null != t ? t : e.nullContext || {},
											null != t ? a(t, 'isCaptchaConfigured') : t,
											{
												name: 'if',
												hash: {},
												fn: e.program(1, o, 0),
												inverse: e.noop,
												data: o,
												loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 184 } },
											}
										))
										? i
										: '';
								},
								useData: !0,
							}),
							getTemplateData: function () {
								if (this.captchaConfig) {
									var e = 'HCAPTCHA' === this.captchaConfig.type ? 'h-captcha' : 'g-recaptcha';
									return {
										siteKey: this.captchaConfig.siteKey,
										isCaptchaConfigured: !0,
										onCaptchaSolvedCallback: h,
										className: e,
									};
								}
								return {};
							},
							initialize: function () {
								this.options.appState.get('captcha') &&
									((this.captchaConfig = this.options.appState.get('captcha')), this._addCaptcha());
							},
							remove: function () {
								s.View.prototype.remove.apply(this, arguments),
									'HCAPTCHA' === this.captchaConfig.type
										? (window.hcaptcha = void 0)
										: 'RECAPTCHA_V2' === this.captchaConfig.type && (window.grecaptcha = void 0);
							},
							_addCaptcha: function () {
								var e = this,
									t = function (t) {
										var n = e._getCaptchaOject(),
											r = e.$el.find('#captcha-container').attr('data-captcha-id');
										n.reset(r);
										var o = e.options.name;
										e.model.set(o, t), e.options.appState.trigger('saveForm', e.model);
									};
								(window.OktaSignInWidgetOnCaptchaLoaded = function () {
									if (!e.$el.find('#captcha-container').attr('data-captcha-id')) {
										var n = e._getCaptchaOject();
										e.model.set(e.options.name, 'tempToken');
										var r = n.render('captcha-container', { sitekey: e.captchaConfig.siteKey, callback: t });
										e.$el.find('#captcha-container').attr('data-captcha-id', r),
											e.options.appState.trigger('onCaptchaLoaded', n),
											'HCAPTCHA' === e.captchaConfig.type && e._addHCaptchaFooter();
									}
								}),
									(window.OktaSignInWidgetOnCaptchaSolved = t),
									'HCAPTCHA' === this.captchaConfig.type
										? this._loadCaptchaLib(this._getCaptchaUrl('https://hcaptcha.com/1/api.js', 'hcaptcha'))
										: 'RECAPTCHA_V2' === this.captchaConfig.type &&
										  this._loadCaptchaLib(this._getCaptchaUrl('https://www.google.com/recaptcha/api.js', 'recaptcha'));
							},
							_loadCaptchaLib: function (e) {
								var t = document.createElement('script');
								(t.src = e),
									(t.async = !0),
									(t.defer = !0),
									document.getElementById(l.default.WIDGET_CONTAINER_ID).appendChild(t);
							},
							_addHCaptchaFooter: function () {
								var e = document.getElementsByClassName(c.WIDGET_FOOTER_CLASS);
								if (e.length) {
									var t = a.default.template({
										compiler: [8, '>= 4.3.0'],
										main: function (e, t, n, r, o) {
											var i =
												e.lookupProperty ||
												function (e, t) {
													if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
												};
											return (
												'<div class="captcha-footer"><span class="footer-text">' +
												e.escapeExpression(
													(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
														null != t ? t : e.nullContext || {},
														{
															name: 'i18n',
															hash: {
																$2: "<a href='https://hcaptcha.com/terms' target='_blank'>$2</a>",
																$1: "<a href='https://hcaptcha.com/privacy' target='_blank'>$1</a>",
																bundle: 'login',
																code: 'hcaptcha.footer.label',
															},
															data: o,
															loc: { start: { line: 1, column: 54 }, end: { line: 1, column: 238 } },
														}
													)
												) +
												'</span></div>'
											);
										},
										useData: !0,
									});
									e[0].insertAdjacentHTML('beforeend', t());
								}
							},
							_getCaptchaOject: function () {
								return 'HCAPTCHA' === this.captchaConfig.type ? window.hcaptcha : window.grecaptcha;
							},
							_getCaptchaUrl: function (e, t) {
								var n = this.options.settings.get('language'),
									r = this.options.settings.get(''.concat(t, '.scriptSource')) || e,
									o = f(
										f({}, this.options.settings.get(''.concat(t, '.scriptParams'))),
										{},
										{ onload: p, render: 'explicit', hl: n || navigator.language }
									);
								return r + '?' + u.default.searchParamsToString(o);
							},
						});
					(t.default = m), (e.exports = t.default);
				},
				51662: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(17587),
						i = n(6475),
						a = r(n(59247)),
						s = r(n(51087)),
						l = n(43318),
						u = o.BaseView.extend({
							Header: a.default,
							Body: s.default,
							createModelClass: function (e) {
								var t = o.BaseView.prototype.createModelClass.apply(this, arguments),
									n = e.uiSchema,
									r = n[0].scopes,
									a = 'consent.scopes',
									s = r.map(function (e) {
										var t = e.name,
											n = e.displayName,
											r = e.description,
											o = ''.concat(a, '.').concat(t),
											s = ''.concat(o, '.label'),
											u = ''.concat(o, '.desc'),
											c = (0, l.doesI18NKeyExist)(s),
											d = (0, l.doesI18NKeyExist)(u);
										return {
											name: t,
											displayName: c ? (0, i.loc)(s, 'login') : n,
											description: d ? (0, i.loc)(u, 'login') : r,
											isCustomized: !c,
										};
									});
								return t.extend({
									props: { scopes: { type: 'array', value: s } },
									local: { consent: { type: 'boolean', value: !1 } },
									toJSON: function () {
										return { consent: this.get('consent') };
									},
								});
							},
						});
					(t.default = u), (e.exports = t.default);
				},
				59247: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = a.View.extend({
							className: 'consent-title detail-row',
							titleText: function () {
								return (0, a.loc)('oie.consent.scopes.admin.title', 'login');
							},
							hasIssuer: !0,
							template: i.default.template({
								1: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<a href="' +
										c(
											((a = null != (a = d(n, 'clientURI') || (null != t ? d(t, 'clientURI') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'clientURI',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 26 }, end: { line: 1, column: 39 } },
												  })
												: a)
										) +
										'" class="client-logo-link" title="' +
										c(
											((a = null != (a = d(n, 'altText') || (null != t ? d(t, 'altText') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'altText',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 73 }, end: { line: 1, column: 84 } },
												  })
												: a)
										) +
										'" target="_blank">'
									);
								},
								3: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<img class="client-logo custom-logo" src="' +
										c(
											((a = null != (a = d(n, 'customLogo') || (null != t ? d(t, 'customLogo') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'customLogo',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 169 }, end: { line: 1, column: 183 } },
												  })
												: a)
										) +
										'" alt="' +
										c(
											((a = null != (a = d(n, 'altText') || (null != t ? d(t, 'altText') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'altText',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 190 }, end: { line: 1, column: 201 } },
												  })
												: a)
										) +
										'" aria-hidden="true" />'
									);
								},
								5: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<img class="client-logo default-logo" src="' +
										c(
											((a = null != (a = d(n, 'defaultLogo') || (null != t ? d(t, 'defaultLogo') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'defaultLogo',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 275 }, end: { line: 1, column: 290 } },
												  })
												: a)
										) +
										'" alt="' +
										c(
											((a = null != (a = d(n, 'altText') || (null != t ? d(t, 'altText') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'altText',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 297 }, end: { line: 1, column: 308 } },
												  })
												: a)
										) +
										'" aria-hidden="true" />'
									);
								},
								7: function (e, t, n, r, o) {
									return '</a>';
								},
								9: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="issuer no-translate"><span>' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'issuer') || (null != t ? a(t, 'issuer') : t)) ? i : e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'issuer',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 513 }, end: { line: 1, column: 523 } },
												  })
												: i
										) +
										'</span></div>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, i) {
									var a,
										s,
										l = null != t ? t : e.nullContext || {},
										u = e.hooks.helperMissing,
										c = 'function',
										d = e.escapeExpression,
										f =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(a = f(n, 'if').call(l, null != t ? f(t, 'clientURI') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, i, 0),
											inverse: e.noop,
											data: i,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 109 } },
										}))
											? a
											: '') +
										(null !=
										(a = f(n, 'if').call(l, null != t ? f(t, 'customLogo') : t, {
											name: 'if',
											hash: {},
											fn: e.program(3, i, 0),
											inverse: e.program(5, i, 0),
											data: i,
											loc: { start: { line: 1, column: 109 }, end: { line: 1, column: 338 } },
										}))
											? a
											: '') +
										(null !=
										(a = f(n, 'if').call(l, null != t ? f(t, 'clientURI') : t, {
											name: 'if',
											hash: {},
											fn: e.program(7, i, 0),
											inverse: e.noop,
											data: i,
											loc: { start: { line: 1, column: 338 }, end: { line: 1, column: 366 } },
										}))
											? a
											: '') +
										'<h1><span class="title-text"><b class="no-translate">' +
										d(
											((s = null != (s = f(n, 'appName') || (null != t ? f(t, 'appName') : t)) ? s : u),
											(0, o.default)(s) === c
												? s.call(l, {
														name: 'appName',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 419 }, end: { line: 1, column: 430 } },
												  })
												: s)
										) +
										'</b>&nbsp;' +
										d(
											((s = null != (s = f(n, 'titleText') || (null != t ? f(t, 'titleText') : t)) ? s : u),
											(0, o.default)(s) === c
												? s.call(l, {
														name: 'titleText',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 440 }, end: { line: 1, column: 453 } },
												  })
												: s)
										) +
										'</span>' +
										(null !=
										(a = f(n, 'if').call(l, null != t ? f(t, 'issuer') : t, {
											name: 'if',
											hash: {},
											fn: e.program(9, i, 0),
											inverse: e.noop,
											data: i,
											loc: { start: { line: 1, column: 460 }, end: { line: 1, column: 543 } },
										}))
											? a
											: '') +
										'</h1>'
									);
								},
								useData: !0,
							}),
							getTemplateData: function () {
								var e = this.options.appState,
									t = e.get('app'),
									n = t.label,
									r = t.clientUri,
									o = t.logo,
									i = e.get('authentication').issuer,
									s = null == o ? void 0 : o.href,
									l = (0, a.loc)('logo.for.the.app.alt.text', 'login'),
									u = a._.escape(n);
								return {
									customLogo: s,
									defaultLogo: '/img/logos/default.png',
									clientURI: null == r ? void 0 : r.href,
									issuer: this.hasIssuer ? (null == i ? void 0 : i.uri) : null,
									altText: l,
									appName: u,
									titleText: this.titleText(),
								};
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				51087: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475),
						o = n(17587).BaseForm.extend({
							noButtonBar: !1,
							noCancelButton: !1,
							buttonOrder: ['cancel', 'save'],
							save: function () {
								return (0, r.loc)('consent.required.consentButton', 'login');
							},
							cancel: function () {
								return (0, r.loc)('consent.required.cancelButton', 'login');
							},
							title: !1,
							events: {
								'click input[data-type="save"]': function () {
									this.setConsent(!0);
								},
							},
							setConsent: function (e) {
								this.model.set('consent', e);
							},
							cancelForm: function () {
								this.setConsent(!1), this.options.appState.trigger('saveForm', this.model);
							},
						});
					(t.default = o), (e.exports = t.default);
				},
				90959: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.OTPInformationTerminalView = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = {
							AUTHENTICATION: 'idx.return.link.otponly.enter.code.on.sign.in.page',
							RECOVERY: 'idx.return.link.otponly.enter.code.on.password.reset.page',
							UNLOCK_ACCOUNT: 'idx.return.link.otponly.enter.code.on.account.unlock.page',
							ENROLLMENT: 'idx.return.link.otponly.enter.code.on.sign.up.page',
						},
						l = function (e, t) {
							var n,
								r,
								o,
								i,
								l,
								u,
								c = t.get('app'),
								d = t.get('client'),
								f = s[t.get('idx').context.intent],
								p = f ? (0, a.loc)(f, 'login') : (0, a.loc)('idx.enter.otp.in.original.tab', 'login');
							return (
								null != c && c.label && (o = (0, a.loc)('idx.return.link.otponly.app', 'login', [c.label])),
								d &&
									((l =
										(i = (0, a.loc)('idx.return.link.otponly.browser.on.os', 'login', [d.browser, d.os])).includes(
											'Android'
										) || i.includes('iOS')),
									(u = (function () {
										var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
										return e.city || e.country
											? e.state
												? (0, a.loc)('geolocation.formatting.all', 'login', [e.city, e.state, e.country])
												: (0, a.loc)('geolocation.formatting.partial', 'login', [e.city, e.country])
											: null;
									})(d.location))),
								{
									showRequestInfo: o || i || u,
									appName: o,
									browserOnOsString: i,
									isMobileDevice: l,
									geolocation: u,
									otp:
										e.get('otp') ||
										(null === (n = t.get('currentAuthenticator')) ||
										void 0 === n ||
										null === (r = n.contextualData) ||
										void 0 === r
											? void 0
											: r.otp),
									enterCodeOnFlowPage: p,
								}
							);
						},
						u = a.View.extend({
							getTemplateData: function () {
								return l(this.options.settings, this.options.appState);
							},
						}).extend({
							template: i.default.template({
								1: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<div class="enduser-email-otp-only--info"><div class="okta-form-label">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'idx.return.link.otponly.request' },
													data: o,
													loc: { start: { line: 1, column: 198 }, end: { line: 1, column: 260 } },
												}
											)
										) +
										'</div></div>'
									);
								},
								3: function (e, t, n, r, o) {
									var i,
										a,
										s = null != t ? t : e.nullContext || {},
										l =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="enduser-email-otp-only--info">' +
										(null !=
										(i = l(n, 'if').call(s, null != t ? l(t, 'isMobileDevice') : t, {
											name: 'if',
											hash: {},
											fn: e.program(4, o, 0),
											inverse: e.program(6, o, 0),
											data: o,
											loc: { start: { line: 1, column: 346 }, end: { line: 1, column: 540 } },
										}))
											? i
											: '') +
										'<div data-se="otp-browser-os">' +
										e.escapeExpression(
											'function' ==
												typeof (a =
													null != (a = l(n, 'browserOnOsString') || (null != t ? l(t, 'browserOnOsString') : t))
														? a
														: e.hooks.helperMissing)
												? a.call(s, {
														name: 'browserOnOsString',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 570 }, end: { line: 1, column: 591 } },
												  })
												: a
										) +
										'</div></div>'
									);
								},
								4: function (e, t, n, r, o) {
									return '<i class="enduser-email-otp-only--icon icon--smartphone" aria-hidden="true"></i>';
								},
								6: function (e, t, n, r, o) {
									return '<i class="enduser-email-otp-only--icon icon--desktop" aria-hidden="true"></i>';
								},
								8: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="enduser-email-otp-only--info"><i class="enduser-email-otp-only--icon icon--app" aria-hidden="true"></i><div data-se="otp-app">' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'appName') || (null != t ? a(t, 'appName') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'appName',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 763 }, end: { line: 1, column: 774 } },
												  })
												: i
										) +
										'</div></div>'
									);
								},
								10: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="enduser-email-otp-only--info"><i class="enduser-email-otp-only--icon icon--location" aria-hidden="true"></i><div data-se="otp-geolocation">' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'geolocation') || (null != t ? a(t, 'geolocation') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'geolocation',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 963 }, end: { line: 1, column: 978 } },
												  })
												: i
										) +
										'</div></div>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, i) {
									var a,
										s,
										l = null != t ? t : e.nullContext || {},
										u = e.hooks.helperMissing,
										c = 'function',
										d = e.escapeExpression,
										f =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p class="enter-code-on-page">' +
										d(
											((s =
												null != (s = f(n, 'enterCodeOnFlowPage') || (null != t ? f(t, 'enterCodeOnFlowPage') : t))
													? s
													: u),
											(0, o.default)(s) === c
												? s.call(l, {
														name: 'enterCodeOnFlowPage',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 30 }, end: { line: 1, column: 53 } },
												  })
												: s)
										) +
										"</p><h1 class='otp-value no-translate'>" +
										d(
											((s = null != (s = f(n, 'otp') || (null != t ? f(t, 'otp') : t)) ? s : u),
											(0, o.default)(s) === c
												? s.call(l, {
														name: 'otp',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 92 }, end: { line: 1, column: 99 } },
												  })
												: s)
										) +
										'</h1>' +
										(null !=
										(a = f(n, 'if').call(l, null != t ? f(t, 'showRequestInfo') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, i, 0),
											inverse: e.noop,
											data: i,
											loc: { start: { line: 1, column: 104 }, end: { line: 1, column: 279 } },
										}))
											? a
											: '') +
										(null !=
										(a = f(n, 'if').call(l, null != t ? f(t, 'browserOnOsString') : t, {
											name: 'if',
											hash: {},
											fn: e.program(3, i, 0),
											inverse: e.noop,
											data: i,
											loc: { start: { line: 1, column: 279 }, end: { line: 1, column: 610 } },
										}))
											? a
											: '') +
										(null !=
										(a = f(n, 'if').call(l, null != t ? f(t, 'appName') : t, {
											name: 'if',
											hash: {},
											fn: e.program(8, i, 0),
											inverse: e.noop,
											data: i,
											loc: { start: { line: 1, column: 610 }, end: { line: 1, column: 793 } },
										}))
											? a
											: '') +
										(null !=
										(a = f(n, 'if').call(l, null != t ? f(t, 'geolocation') : t, {
											name: 'if',
											hash: {},
											fn: e.program(10, i, 0),
											inverse: e.noop,
											data: i,
											loc: { start: { line: 1, column: 793 }, end: { line: 1, column: 997 } },
										}))
											? a
											: '') +
										"<br><p class='otp-warning'>" +
										d(
											(f(n, 'i18n') || (t && f(t, 'i18n')) || u).call(l, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'idx.return.link.otponly.warning.text' },
												data: i,
												loc: { start: { line: 1, column: 1024 }, end: { line: 1, column: 1091 } },
											})
										) +
										'</p>'
									);
								},
								useData: !0,
							}),
						});
					t.OTPInformationTerminalView = u;
				},
				32617: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475).View.extend({
							className: 'consent-description detail-row',
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<p>' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'consent.required.description' },
													data: o,
													loc: { start: { line: 1, column: 3 }, end: { line: 1, column: 62 } },
												}
											)
										) +
										'</p>'
									);
								},
								useData: !0,
							}),
						});
					(t.default = i), (e.exports = t.default);
				},
				57353: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(51662)),
						i = r(n(19098)),
						a = r(n(36740)),
						s = r(n(32617)),
						l = o.default.extend({
							Header: a.default,
							Footer: i.default,
							postRender: function () {
								var e = this.$el.find('.scope-list'),
									t = new s.default().render().el;
								e.after(t);
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				19098: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475).View.extend({
							className: 'consent-footer',
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = e.escapeExpression,
										c =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<a class="terms-of-service" href="' +
										u(
											'function' ==
												typeof (a =
													null != (a = c(n, 'termsOfService') || (null != t ? c(t, 'termsOfService') : t)) ? a : l)
												? a.call(s, {
														name: 'termsOfService',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 56 }, end: { line: 1, column: 74 } },
												  })
												: a
										) +
										'" target="_blank">' +
										u(
											(c(n, 'i18n') || (t && c(t, 'i18n')) || l).call(s, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'consent.required.termsOfService' },
												data: o,
												loc: { start: { line: 1, column: 92 }, end: { line: 1, column: 154 } },
											})
										) +
										'</a>' +
										(null !=
										(i = c(n, 'if').call(s, null != t ? c(t, 'privacyPolicy') : t, {
											name: 'if',
											hash: {},
											fn: e.program(2, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 158 }, end: { line: 1, column: 226 } },
										}))
											? i
											: '')
									);
								},
								2: function (e, t, n, r, o) {
									return '<span class="no-translate">&#8226</span>';
								},
								4: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s = e.hooks.helperMissing,
										l = e.escapeExpression,
										u =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<a class="privacy-policy" href="' +
										l(
											'function' ==
												typeof (i =
													null != (i = u(n, 'privacyPolicy') || (null != t ? u(t, 'privacyPolicy') : t)) ? i : s)
												? i.call(a, {
														name: 'privacyPolicy',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 286 }, end: { line: 1, column: 303 } },
												  })
												: i
										) +
										'" target="_blank">' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'consent.required.privacyPolicy' },
												data: o,
												loc: { start: { line: 1, column: 321 }, end: { line: 1, column: 382 } },
											})
										) +
										'</a>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'termsOfService') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 233 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'privacyPolicy') : t, {
											name: 'if',
											hash: {},
											fn: e.program(4, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 233 }, end: { line: 1, column: 393 } },
										}))
											? i
											: '')
									);
								},
								useData: !0,
							}),
							getTemplateData: function () {
								var e = this.options.appState.get('app');
								return {
									termsOfService: e.termsOfService && e.termsOfService.href,
									privacyPolicy: e.privacyPolicy && e.privacyPolicy.href,
								};
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				36740: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(59247)).default.extend({
							titleText: function () {
								return (0, o.loc)('oie.consent.scopes.enduser.title', 'login');
							},
							hasIssuer: !1,
						});
					(t.default = i), (e.exports = t.default);
				},
				68875: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = n(17587),
						s = r(n(51087)),
						l = r(n(83966)),
						u = r(n(89597)),
						c = o.default.template({
							1: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<div class="enduser-email-consent--info no-translate"><i class="enduser-email-consent--icon icon--desktop"></i><div>' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'browser') || (null != t ? a(t, 'browser') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'browser',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 131 }, end: { line: 1, column: 142 } },
											  })
											: i
									) +
									'</div></div>'
								);
							},
							3: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<div class="enduser-email-consent--info no-translate"><i class="enduser-email-consent--icon icon--app"></i><div>' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'app') || (null != t ? a(t, 'app') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'app',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 284 }, end: { line: 1, column: 291 } },
											  })
											: i
									) +
									'</div></div>'
								);
							},
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a = null != t ? t : e.nullContext || {},
									s =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									(null !=
									(i = s(n, 'if').call(a, null != t ? s(t, 'browser') : t, {
										name: 'if',
										hash: {},
										fn: e.program(1, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 161 } },
									}))
										? i
										: '') +
									(null !=
									(i = s(n, 'if').call(a, null != t ? s(t, 'app') : t, {
										name: 'if',
										hash: {},
										fn: e.program(3, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 161 }, end: { line: 1, column: 310 } },
									}))
										? i
										: '')
								);
							},
							useData: !0,
						}),
						d = s.default.extend({
							className: 'enduser-email-consent',
							title: function () {
								return (0, i.loc)('oie.consent.enduser.title', 'login');
							},
							save: function () {
								return (0, i.loc)('oie.consent.enduser.accept.label', 'login');
							},
							cancel: function () {
								return (0, i.loc)('oie.consent.enduser.deny.label', 'login');
							},
							initialize: function () {
								a.BaseForm.prototype.initialize.apply(this, arguments);
								var e = c(this.model.pick('browser', 'app'));
								this.add(e);
							},
							getUISchema: function () {
								var e = a.BaseForm.prototype.getUISchema.apply(this, arguments);
								return e.filter(function (e) {
									return 'consent' !== e.name;
								});
							},
						}),
						f = l.default.extend({
							Header: u.default,
							buttonOrder: ['cancel', 'save'],
							postRender: function () {
								this.$el.find('.o-form-button-bar').find('.button-primary').removeClass('button-primary');
							},
							Body: d,
							createModelClass: function (e) {
								var t = e.requestInfo,
									n = l.default.prototype.createModelClass.apply(this, arguments),
									r = t.find(function (e) {
										return 'browser' === e.name;
									}),
									o = t.find(function (e) {
										return 'appName' === e.name;
									}),
									i = Object.assign(
										{
											browser: { type: 'string', value: null == r ? void 0 : r.value },
											app: { type: 'string', value: null == o ? void 0 : o.value },
										},
										n.prototype.local
									);
								return n.extend({
									local: i,
									toJSON: function () {
										return { consent: this.get('consent') };
									},
								});
							},
						});
					(t.default = f), (e.exports = t.default);
				},
				81205: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(17587),
						s = n(6475),
						l = r(n(51087)),
						u = r(n(59247)),
						c = r(n(19098)),
						d = r(n(16002)),
						f = u.default.extend({
							hasIssuer: !1,
							template: i.default.template({
								1: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<a href="' +
										c(
											((a = null != (a = d(n, 'clientURI') || (null != t ? d(t, 'clientURI') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'clientURI',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 26 }, end: { line: 1, column: 39 } },
												  })
												: a)
										) +
										'" class="client-logo-link" title="' +
										c(
											((a = null != (a = d(n, 'altText') || (null != t ? d(t, 'altText') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'altText',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 73 }, end: { line: 1, column: 84 } },
												  })
												: a)
										) +
										'" target="_blank">'
									);
								},
								3: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<img class="client-logo custom-logo" src="' +
										c(
											((a = null != (a = d(n, 'customLogo') || (null != t ? d(t, 'customLogo') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'customLogo',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 169 }, end: { line: 1, column: 183 } },
												  })
												: a)
										) +
										'" alt="' +
										c(
											((a = null != (a = d(n, 'altText') || (null != t ? d(t, 'altText') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'altText',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 190 }, end: { line: 1, column: 201 } },
												  })
												: a)
										) +
										'" aria-hidden />'
									);
								},
								5: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<img class="client-logo default-logo" src="' +
										c(
											((a = null != (a = d(n, 'defaultLogo') || (null != t ? d(t, 'defaultLogo') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'defaultLogo',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 268 }, end: { line: 1, column: 283 } },
												  })
												: a)
										) +
										'" alt="' +
										c(
											((a = null != (a = d(n, 'altText') || (null != t ? d(t, 'altText') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'altText',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 290 }, end: { line: 1, column: 301 } },
												  })
												: a)
										) +
										'" aria-hidden />'
									);
								},
								7: function (e, t, n, r, o) {
									return '</a>';
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'clientURI') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 109 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'customLogo') : t, {
											name: 'if',
											hash: {},
											fn: e.program(3, o, 0),
											inverse: e.program(5, o, 0),
											data: o,
											loc: { start: { line: 1, column: 109 }, end: { line: 1, column: 324 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'clientURI') : t, {
											name: 'if',
											hash: {},
											fn: e.program(7, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 324 }, end: { line: 1, column: 352 } },
										}))
											? i
											: '') +
										'<h1><span class="title-text">' +
										e.escapeExpression(
											(s(n, 'i18n') || (t && s(t, 'i18n')) || e.hooks.helperMissing).call(a, {
												name: 'i18n',
												hash: {
													$2: '<p>$2</p>',
													$1: "<b class='no-translate'>$1</b>",
													arguments: 'appName',
													bundle: 'login',
													code: 'oie.consent.scopes.granular.title',
												},
												data: o,
												loc: { start: { line: 1, column: 381 }, end: { line: 1, column: 517 } },
											})
										) +
										'</span></h1>'
									);
								},
								useData: !0,
							}),
						}),
						p = l.default.extend({
							cancel: a.BaseForm.prototype.cancel,
							getUISchema: function () {
								var e = a.BaseForm.prototype.getUISchema.apply(this, arguments);
								return (
									e.forEach(function (e) {
										'checkbox' === e.type &&
											s._.assign(e, {
												input: d.default,
												options: {
													desc: e.desc,
													mutable: e.mutable,
													scopeName: e.name.substring(e.name.indexOf('.') + 1),
												},
											});
									}),
									e
								);
							},
						}),
						h = s.View.extend({
							className: 'consent-description',
							template: i.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<p>' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'oie.consent.scopes.granular.description' },
													data: o,
													loc: { start: { line: 1, column: 3 }, end: { line: 1, column: 73 } },
												}
											)
										) +
										'</p>'
									);
								},
								useData: !0,
							}),
						}),
						m = a.BaseView.extend({
							Header: f,
							Body: p,
							Footer: c.default,
							postRender: function () {
								var e = this.$el.find('.o-form-fieldset-container');
								e.before(new h().render().el),
									this.$(':disabled').each(function () {
										e.append((0, s.$)(this).closest('.o-form-fieldset'));
									});
							},
						});
					(t.default = m), (e.exports = t.default);
				},
				50066: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = i.BaseForm.extend(
							Object.assign({
								className: 'custom-app-verify-resend-push',
								title: function () {
									return (0, o.loc)('oie.verify.custom_app.title', 'login', [
										this.options.appState.getAuthenticatorDisplayName(),
									]);
								},
								save: function () {
									return (0, o.loc)('oie.custom_app.push.resend', 'login');
								},
								showMessages: function () {
									var e = {};
									this.options.appState.containsMessageWithI18nKey(
										'oie.authenticator.custom_app.method.push.verify.enable.biometrics'
									) &&
										((e.content = null),
										(e.className = 'okta-verify-uv-callout-content'),
										(e.title = (0, o.loc)(
											'oie.authenticator.custom_app.method.push.verify.enable.biometrics.title',
											'login',
											[this.options.appState.getAuthenticatorDisplayName()]
										)),
										(e.subtitle = (0, o.loc)(
											'oie.authenticator.custom_app.method.push.verify.enable.biometrics.description',
											'login'
										)),
										(e.type = 'error'),
										(e.bullets = [
											(0, o.loc)('oie.authenticator.custom_app.method.push.verify.enable.biometrics.point1', 'login'),
											(0, o.loc)('oie.authenticator.custom_app.method.push.verify.enable.biometrics.point2', 'login', [
												this.options.appState.getAuthenticatorDisplayName(),
											]),
											(0, o.loc)('oie.authenticator.custom_app.method.push.verify.enable.biometrics.point3', 'login', [
												this.options.appState.getAuthenticatorDisplayName(),
											]),
										]),
										(e = (0, o.createCallout)(e))),
										i.BaseForm.prototype.showMessages.call(this, e);
								},
							})
						),
						l = a.default.extend({ Body: s });
					(t.default = l), (e.exports = t.default);
				},
				64840: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = i.BaseForm.extend(
							Object.assign({
								className: 'mfa-verify-custom-otp',
								title: function () {
									var e =
										this.options.appState.getAuthenticatorDisplayName() ||
										(0, o.loc)('oie.custom_otp.authenticator.default.vendorName', 'login');
									return (0, o.loc)('oie.verify.custom_otp.title', 'login', [e]);
								},
								subtitle: function () {
									return (0, o.loc)('oie.verify.custom_otp.description', 'login');
								},
								save: function () {
									return (0, o.loc)('mfa.challenge.verify', 'login');
								},
							})
						),
						l = a.default.extend({ Body: s });
					(t.default = l), (e.exports = t.default);
				},
				58930: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(90570)),
						s = i.BaseForm.extend({
							title: function () {
								return (0, o.loc)('password.expired.title.generic', 'login');
							},
							subtitle: function () {
								return (0, o.loc)('password.expired.custom.subtitle', 'login');
							},
							noSubmitButton: !0,
							initialize: function () {
								var e = this.options.currentViewState,
									t = e.customExpiredPasswordName,
									n = e.customExpiredPasswordURL;
								this.add(
									(0, o.createButton)({
										className: 'button button-primary button-wide',
										title: o._.partial(o.loc, 'password.expired.custom.submit', 'login', [t]),
										click: function () {
											a.default.redirect(n);
										},
									})
								);
							},
						}),
						l = i.BaseView.extend({ Body: s });
					(t.default = l), (e.exports = t.default);
				},
				2982: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(90570)),
						s = i.BaseForm.extend({
							className: 'password-authenticator',
							subtitle: function () {
								return this.settings.get('brandName')
									? (0, o.loc)('password.expiring.soon.subtitle.specific', 'login', [this.settings.get('brandName')])
									: (0, o.loc)('password.expiring.soon.subtitle.generic', 'login');
							},
							title: function () {
								var e,
									t = (
										null === (e = this.options.appState.get('currentAuthenticator')) || void 0 === e
											? void 0
											: e.settings
									).daysToExpiry;
								return t > 0
									? (0, o.loc)('password.expiring.title', 'login', [t])
									: 0 === t
									? (0, o.loc)('password.expiring.today', 'login')
									: (0, o.loc)('password.expiring.soon', 'login');
							},
							noSubmitButton: !0,
							initialize: function () {
								var e = this.options.currentViewState,
									t = e.customExpiredPasswordName,
									n = e.customExpiredPasswordURL;
								this.add(
									(0, o.createButton)({
										className: 'button button-primary button-wide',
										title: o._.partial(o.loc, 'password.expired.custom.submit', 'login', [t]),
										click: function () {
											a.default.redirect(n);
										},
									})
								);
							},
						}),
						l = i.BaseFooter.extend({
							links: function () {
								var e = [];
								return (
									this.options.appState.hasRemediationObject('skip') &&
										e.push({
											type: 'link',
											label: (0, o.loc)('password.expiring.later', 'login'),
											name: 'skip',
											actionPath: 'skip',
										}),
									e
								);
							},
						}),
						u = i.BaseView.extend({ Body: s, Footer: l });
					(t.default = u), (e.exports = t.default);
				},
				73386: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(11024)),
						s = i.BaseForm.extend({
							title: function () {
								return (0, o.loc)('idx.device_assurance.grace_period.title', 'login');
							},
							save: function () {
								return (0, o.loc)('idx.device_assurance.grace_period.continue_to_app', 'login');
							},
							showMessages: function () {
								var e = this.options.appState.get('messages').value,
									t = this.settings.get('languageCode');
								e &&
									this.add(
										(0, o.createCallout)({ content: new a.default({ messages: e, languageCode: t }), type: 'warning' })
									);
							},
						}),
						l = i.BaseView.extend({
							initialize: function () {
								i.BaseView.prototype.initialize.apply(this, arguments), (this.Body = s);
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				59953: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(35546)),
						s = n(86725),
						l = r(n(87547)),
						u = n(66200),
						c = r(n(76757)),
						d = n(71101),
						f = r(n(91002)),
						p = i.BaseOktaVerifyChallengeView.extend({
							pollingCancelAction: s.CANCEL_POLLING_ACTION,
							getDeviceChallengePayload: function () {
								return this.options.currentViewState.relatesTo.value;
							},
							doChallenge: function () {
								(0, u.doChallenge)(this, s.IDENTIFIER_FLOW);
							},
							onPollingFail: function () {
								i.BaseOktaVerifyChallengeView.prototype.onPollingFail.apply(this, arguments);
								var e = { label: (0, o.loc)('loopback.polling.cancel.link.with.form.error', 'login') };
								this.options.appState.trigger('updateFooterLink', e);
							},
							showCustomFormErrorCallout: function (e, t) {
								var n = e.responseJSON,
									r = { type: 'error', className: 'okta-verify-uv-callout-content', subtitle: n.errorSummary };
								if (
									(n.errorSummaryKeys &&
										n.errorSummaryKeys.some(function (e) {
											return e.includes('auth.factor.signedNonce.error');
										}) &&
										(r.title = (0, o.loc)('user.fail.verifyIdentity', 'login')),
									n.errorSummaryKeys &&
										n.errorSummaryKeys.some(function (e) {
											return e.includes('security.access_denied_custom_message');
										}))
								) {
									var i =
										null == t
											? void 0
											: t.find(function (e) {
													return 'security.access_denied_custom_message' === e.i18n.key;
											  });
									if (!i) return !1;
									r = { type: 'error', content: new f.default({ message: n.errorSummary, links: i.links }) };
								}
								return this.showMessages((0, o.createCallout)(r)), !0;
							},
						}),
						h = i.BaseFooter.extend({
							initialize: function () {
								var e = this;
								this.listenTo(this.options.appState, 'updateFooterLink', this.handleUpdateFooterLink),
									this.isFallbackApproach() && !this.isFallbackDelayed()
										? i.BaseFooter.prototype.initialize.apply(this, arguments)
										: (this.backLink = this.add(l.default, {
												options: {
													name: 'cancel-authenticator-challenge',
													label: (0, o.loc)('loopback.polling.cancel.link', 'login'),
													clickHandler: function () {
														(0, u.cancelPollingWithParams)(
															e.options.appState,
															s.CANCEL_POLLING_ACTION,
															s.AUTHENTICATION_CANCEL_REASONS.USER_CANCELED,
															null
														);
													},
												},
										  }).last());
							},
							handleUpdateFooterLink: function (e) {
								(this.isFallbackApproach() && !this.isFallbackDelayed()) ||
									(this.backLink && this.backLink.remove(),
									(this.backLink = this.add(l.default, {
										options: (0, d.getSignOutLink)(this.options.settings, e)[0],
									}).last()));
							},
							isFallbackApproach: function () {
								return [
									a.default.CUSTOM_URI_CHALLENGE,
									a.default.UNIVERSAL_LINK_CHALLENGE,
									a.default.APP_LINK_CHALLENGE,
								].includes(this.options.currentViewState.relatesTo.value.challengeMethod);
							},
							isFallbackDelayed: function () {
								return this.options.currentViewState.relatesTo.value.challengeMethod === a.default.APP_LINK_CHALLENGE;
							},
						}),
						m = i.BaseView.extend({ Header: c.default, Body: p, Footer: h });
					(t.default = m), (e.exports = t.default);
				},
				14763: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475),
						o = n(17587),
						i = o.BaseForm.extend({
							title: function () {
								return (0, r.loc)('device.code.activate.title', 'login');
							},
							subtitle: function () {
								return (0, r.loc)('device.code.activate.subtitle', 'login');
							},
							events: {
								'keyup input[name="userCode"]': function (e) {
									e.preventDefault(), this.addHyphen(e);
								},
							},
							addHyphen: function (e) {
								var t = e.target.value;
								t &&
									4 === t.length &&
									!['Backspace', 'Delete', '-'].includes(e.key) &&
									(e.target.value = t.concat('-'));
							},
						}),
						a = o.BaseView.extend({ Body: i });
					(t.default = a), (e.exports = t.default);
				},
				64623: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = n(73204),
						s = r(n(11098)),
						l = r(n(35546)),
						u = r(n(76757)),
						c = r(n(87547)),
						d = i.BaseForm.extend({ noButtonBar: !0, className: 'device-enrollment-terminal' }),
						f = i.BaseForm.extend({
							attributes: { 'data-se': 'android-app-link-setup-options-terminal' },
							title: function () {
								return (0, o.loc)('enroll.title.oda.with.account', 'login');
							},
							initialize: function () {
								i.BaseForm.prototype.initialize.apply(this, arguments);
								var e = (0, a.getDeviceEnrollmentContext)(this.options.appState.get('deviceEnrollment'));
								this.model.set('hasOVAccount', 'no'),
									this.addInput({
										'label': function () {
											return (0, o.loc)('enroll.subtitle.fastpass', 'login', [e.orgName]);
										},
										'label-top': !0,
										'options': {
											no: (0, o.loc)('enroll.option.noaccount.fastpass', 'login'),
											yes: (0, o.loc)('enroll.option.account.fastpass', 'login'),
										},
										'name': 'hasOVAccount',
										'type': 'radio',
									});
							},
							saveForm: function () {
								this.$el.find('.o-form-error-container').empty(),
									this.options.appState.trigger('updateDeviceEnrollmentView', 'yes' === this.model.get('hasOVAccount'));
							},
						}),
						p = d.extend({
							attributes: { 'data-se': 'android-oda-app-link-with-ov-account-terminal' },
							title: function () {
								return (0, o.loc)('enroll.title.oda.with.account', 'login');
							},
							initialize: function () {
								d.prototype.initialize.apply(this, arguments), this.add(a.AndroidAppLinkWithAccountOdaTerminalView);
							},
						}),
						h = d.extend({
							attributes: { 'data-se': 'android-oda-app-link-without-ov-account-terminal' },
							title: function () {
								return (0, o.loc)('enroll.title.oda.without.account', 'login');
							},
							initialize: function () {
								d.prototype.initialize.apply(this, arguments), this.add(a.AndroidAppLinkWithoutAccountOdaTerminalView);
							},
						}),
						m = d.extend({
							attributes: { 'data-se': 'loopback-terminal' },
							title: function () {
								return (0, o.loc)('enroll.title.oda', 'login');
							},
							initialize: function () {
								d.prototype.initialize.apply(this, arguments), this.add(a.IosAndAndroidLoopbackOdaTerminalView);
							},
						}),
						v = d.extend({
							attributes: { 'data-se': 'mdm-terminal' },
							title: function () {
								return (0, o.loc)('enroll.title.mdm', 'login');
							},
							initialize: function () {
								d.prototype.initialize.apply(this, arguments), this.add(s.default);
							},
						}),
						g = c.default.extend({
							postRender: function () {
								var e = this;
								this.$el.click(function (t) {
									t.preventDefault(), e.options.appState.trigger('switchBackToPreselect');
								});
							},
						}),
						y = i.BaseView.extend({
							initialize: function () {
								i.BaseView.prototype.initialize.apply(this, arguments),
									this.listenTo(
										this.options.appState,
										'updateDeviceEnrollmentView',
										this.handleUpdateDeviceEnrollmentView
									),
									this.listenTo(this.options.appState, 'switchBackToPreselect', this.handleSwitchBackToPreselect);
								var e = (0, a.getDeviceEnrollmentContext)(this.options.appState.get('deviceEnrollment'));
								switch (((this.enrollmentType = (e.enrollmentType || '').toLowerCase()), this.enrollmentType)) {
									case l.default.ODA:
										(this.Header = u.default), (this.Body = e.isAndroidAppLink ? f : m);
										break;
									case l.default.MDM:
									case l.default.WS1:
										this.Body = v;
								}
							},
							handleUpdateDeviceEnrollmentView: function (e) {
								(this.Body = e ? p : h),
									(this.backLink = this.add(g, {
										options: { name: 'back-to-preselect', label: (0, o.loc)('oform.back', 'login') },
									}).last()),
									this.renderForm();
							},
							handleSwitchBackToPreselect: function () {
								(this.Body = f), this.backLink && this.backLink.remove(), this.render();
							},
						});
					(t.default = y), (e.exports = t.default);
				},
				63417: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(17587),
						o = n(6475),
						i = r.BaseForm.extend({
							noButtonBar: !0,
							className: 'ion-form device-challenge-poll',
							title: function () {
								return (0, o.loc)('deviceTrust.sso.redirectText', 'login');
							},
							initialize: function () {
								var e,
									t,
									n = this;
								r.BaseForm.prototype.initialize.apply(this, arguments),
									this.listenTo(this.model, 'error', function () {
										n.$('.spinner').hide();
									}),
									this.add('<div class="spinner"></div>');
								var o =
									'get' ===
									(null === (e = this.options.currentViewState) ||
									void 0 === e ||
									null === (t = e.method) ||
									void 0 === t
										? void 0
										: t.toLowerCase());
								this.model.set('useRedirect', o), this.trigger('save', this.model);
							},
						}),
						a = r.BaseView.extend({ Body: i });
					(t.default = a), (e.exports = t.default);
				},
				88981: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(7667)),
						s = r(n(83201)),
						l = i.BaseForm.extend({
							title: function () {
								return (0, o.loc)('primaryauth.title', 'login');
							},
							noButtonBar: !0,
							initialize: function () {
								i.BaseForm.prototype.initialize.apply(this, arguments),
									this.add(s.default, {
										selector: '.o-form-fieldset-container',
										bubble: !1,
										prepend: !0,
										options: { isRequired: !0 },
									});
							},
						}),
						u = a.default.extend({ hasBackToSignInLink: !1 }),
						c = i.BaseView.extend({ Body: l, Footer: u });
					(t.default = c), (e.exports = t.default);
				},
				5330: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(79084)),
						a = n(17587).BaseForm.extend({
							noButtonBar: !0,
							postRender: function () {
								var e = this,
									t = this.getContextualData(),
									n = this.add('<iframe frameborder="0" title="\''.concat(this.title(), '\'"></iframe>')).last();
								try {
									i.default.init({
										host: t.host,
										sig_request: t.signedToken,
										iframe: n.el,
										post_action: function (t) {
											e.model.set('credentials.signatureData', t), e.saveForm(e.model);
										},
									});
								} catch (e) {
									n.remove(),
										this.add(
											(0, o.createCallout)({ type: 'error', subtitle: (0, o.loc)('oie.duo.iFrameError', 'login') }),
											'.o-form-error-container'
										);
								}
							},
							getContextualData: function () {},
						});
					(t.default = a), (e.exports = t.default);
				},
				48167: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(5330)),
						a = r(n(83966)),
						s = i.default.extend({
							title: function () {
								return (0, o.loc)('oie.duo.verify.title', 'login');
							},
							getContextualData: function () {
								return this.options.appState.get('currentAuthenticatorEnrollment').contextualData;
							},
						}),
						l = a.default.extend({ Body: s });
					(t.default = l), (e.exports = t.default);
				},
				19220: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(5330)),
						a = r(n(83966)),
						s = i.default.extend({
							title: function () {
								return (0, o.loc)('oie.duo.enroll.title', 'login');
							},
							getContextualData: function () {
								return this.options.appState.get('currentAuthenticator').contextualData;
							},
						}),
						l = a.default.extend({ Body: s });
					(t.default = l), (e.exports = t.default);
				},
				64642: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.getCheckYourEmailEnrollTitle = function () {
							return s;
						}),
						(t.getCheckYourEmailTitle = function () {
							return a;
						}),
						(t.getEnterCodeLink = function () {
							return l;
						});
					var o = r(n(2875)),
						i = n(6475),
						a = i.View.extend({
							className: 'okta-form-subtitle',
							attributes: { 'data-se': 'o-form-explain' },
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return null !=
										(i = a(n, 'if').call(null != t ? t : e.nullContext || {}, null != t ? a(t, 'secondaryEmail') : t, {
											name: 'if',
											hash: {},
											fn: e.program(2, o, 0),
											inverse: e.program(4, o, 0),
											data: o,
											loc: { start: { line: 1, column: 13 }, end: { line: 1, column: 433 } },
										}))
										? i
										: '';
								},
								2: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return e.escapeExpression(
										(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: {
													$2: "<span class='strong no-translate'>$2</span>",
													$1: "<span class='strong no-translate'>$1</span>",
													arguments: 'email;secondaryEmail',
													bundle: 'login',
													code: 'oie.email.verify.alternate.magicLinkToEmailAddress.with.secondary.email',
												},
												data: o,
												loc: { start: { line: 1, column: 35 }, end: { line: 1, column: 269 } },
											}
										)
									);
								},
								4: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return e.escapeExpression(
										(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: {
													$1: "<span class='strong no-translate'>$1</span>",
													arguments: 'email',
													bundle: 'login',
													code: 'oie.email.verify.alternate.magicLinkToEmailAddress',
												},
												data: o,
												loc: { start: { line: 1, column: 277 }, end: { line: 1, column: 426 } },
											}
										)
									);
								},
								6: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return e.escapeExpression(
										(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.email.verify.alternate.magicLinkToYourEmail' },
												data: o,
												loc: { start: { line: 1, column: 441 }, end: { line: 1, column: 520 } },
											}
										)
									);
								},
								8: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return e.escapeExpression(
										(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.email.verify.alternate.instructions' },
												data: o,
												loc: { start: { line: 1, column: 557 }, end: { line: 1, column: 628 } },
											}
										)
									);
								},
								10: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return e.escapeExpression(
										(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.email.verify.alternate.verificationCode.instructions' },
												data: o,
												loc: { start: { line: 1, column: 636 }, end: { line: 1, column: 724 } },
											}
										)
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'email') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.program(6, o, 0),
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 527 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'useEmailMagicLinkValue') : t, {
											name: 'if',
											hash: {},
											fn: e.program(8, o, 0),
											inverse: e.program(10, o, 0),
											data: o,
											loc: { start: { line: 1, column: 527 }, end: { line: 1, column: 731 } },
										}))
											? i
											: '')
									);
								},
								useData: !0,
							}),
							getTemplateData: function () {
								return this.options;
							},
						}),
						s = i.View.extend({
							className: 'okta-form-subtitle',
							attributes: { 'data-se': 'o-form-explain' },
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return e.escapeExpression(
										(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.email.enroll.subtitle' },
												data: o,
												loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 56 } },
											}
										)
									);
								},
								useData: !0,
							}),
						}),
						l = i.View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<button class="button-link enter-auth-code-instead-link" >' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { code: 'oie.email.verify.alternate.show.verificationCode.text' },
													data: o,
													loc: { start: { line: 1, column: 58 }, end: { line: 1, column: 127 } },
												}
											)
										) +
										'</button>'
									);
								},
								useData: !0,
							}),
						});
				},
				99283: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(22873)),
						s = r(n(83966)),
						l = r(n(25590)),
						u = r(n(68013)),
						c = l.default.extend({
							className: 'hide resend-email-view',
							events: { 'click a.resend-link': 'handleResendLink' },
							modelEvents: { error: 'handleError' },
							initialize: function () {
								this.add(
									(0, o.createCallout)({
										content: ''
											.concat((0, o.loc)('email.code.not.received', 'login'), "\n        <a class='resend-link'>")
											.concat((0, o.loc)('email.button.resend', 'login'), '</a>'),
										type: 'warning',
									})
								);
							},
							hideResendViewAndShowAfterTimeout: function () {
								this.$el.hasClass('hide') || this.$el.addClass('hide'), this.showCalloutAfterTimeout();
							},
							handleResendLink: function (e) {
								null == e || e.preventDefault(),
									this.options.appState.trigger('invokeAction', this.options.resendEmailAction),
									this.hideResendViewAndShowAfterTimeout();
							},
							handleError: function () {
								this.hideResendViewAndShowAfterTimeout();
							},
						}),
						d = u.default.extend(
							Object.assign(
								{
									save: function () {
										return (0, o.loc)('mfa.challenge.verify', 'login');
									},
									initialize: function () {
										u.default.prototype.initialize.apply(this, arguments), this.startPolling();
									},
									postRender: function () {
										i.BaseForm.prototype.postRender.apply(this, arguments),
											this.$el.find('.resend-email-view').length ||
												this.add(c, {
													selector: '.o-form-info-container',
													prepend: !0,
													options: { resendEmailAction: this.resendEmailAction },
												});
									},
									saveForm: function () {
										i.BaseForm.prototype.saveForm.apply(this, arguments), this.stopPolling();
									},
									remove: function () {
										i.BaseForm.prototype.remove.apply(this, arguments), this.stopPolling();
									},
									triggerAfterError: function (e, t) {
										var n, r;
										i.BaseForm.prototype.triggerAfterError.apply(this, arguments);
										var o = !!this.polling;
										this.stopPolling(),
											(null !== (n = t.responseJSON) &&
												void 0 !== n &&
												null !== (r = n.errorSummaryKeys) &&
												void 0 !== r &&
												r.includes('idx.session.expired')) ||
												(this.isRateLimitError(t)
													? (o &&
															setTimeout(function () {
																e.trigger('clearFormError');
															}, 0),
													  this.startPolling(6e4))
													: this.startPolling(this.options.appState.get('dynamicRefreshInterval')));
									},
									isRateLimitError: function (e) {
										var t, n, r, o;
										return (
											(null === (t = e.responseJSON) ||
											void 0 === t ||
											null === (n = t.errorSummaryKeys) ||
											void 0 === n
												? void 0
												: n.includes('tooManyRequests')) ||
											('E0000047' === (null === (r = e.responseJSON) || void 0 === r ? void 0 : r.errorCode) &&
												!(null !== (o = e.responseJSON) && void 0 !== o && o.errorIntent))
										);
									},
								},
								a.default
							)
						),
						f = s.default.extend({ Body: d });
					(t.default = f), (e.exports = t.default);
				},
				10765: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(83966)),
						s = a.default.prototype.Body,
						l = i.View.extend({
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return null !=
										(i = a(n, 'if').call(null != t ? t : e.nullContext || {}, null != t ? a(t, 'secondaryEmail') : t, {
											name: 'if',
											hash: {},
											fn: e.program(2, o, 0),
											inverse: e.program(4, o, 0),
											data: o,
											loc: { start: { line: 1, column: 70 }, end: { line: 1, column: 471 } },
										}))
										? i
										: '';
								},
								2: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return e.escapeExpression(
										(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: {
													$2: "<span class='strong no-translate'>$2</span>",
													$1: "<span class='strong no-translate'>$1</span>",
													arguments: 'email;secondaryEmail',
													bundle: 'login',
													code: 'oie.email.verify.subtitle.text.with.email.and.secondary.email',
												},
												data: o,
												loc: { start: { line: 1, column: 92 }, end: { line: 1, column: 316 } },
											}
										)
									);
								},
								4: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return e.escapeExpression(
										(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: {
													$1: "<span class='strong no-translate'>$1</span>",
													arguments: 'email',
													bundle: 'login',
													code: 'oie.email.verify.subtitle.text.with.email',
												},
												data: o,
												loc: { start: { line: 1, column: 324 }, end: { line: 1, column: 464 } },
											}
										)
									);
								},
								6: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return e.escapeExpression(
										(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.email.verify.subtitle.text.without.email' },
												data: o,
												loc: { start: { line: 1, column: 479 }, end: { line: 1, column: 555 } },
											}
										)
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="okta-form-subtitle" data-se="o-form-explain">' +
										(null !=
										(i = a(n, 'if').call(null != t ? t : e.nullContext || {}, null != t ? a(t, 'email') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.program(6, o, 0),
											data: o,
											loc: { start: { line: 1, column: 57 }, end: { line: 1, column: 562 } },
										}))
											? i
											: '') +
										'</div>'
									);
								},
								useData: !0,
							}),
							getTemplateData: function () {
								var e, t, n, r;
								return {
									email:
										null === (e = this.options.appState.get('currentAuthenticatorEnrollment')) ||
										void 0 === e ||
										null === (t = e.profile) ||
										void 0 === t
											? void 0
											: t.email,
									secondaryEmail:
										null === (n = this.options.appState.get('currentAuthenticatorEnrollment')) ||
										void 0 === n ||
										null === (r = n.profile) ||
										void 0 === r
											? void 0
											: r.secondaryEmail,
								};
							},
						}),
						u = s.extend({
							title: function () {
								return (0, i.loc)('oie.email.challenge.mfa.title', 'login');
							},
							save: function () {
								return (0, i.loc)('oie.email.verify.primaryButton', 'login');
							},
							postRender: function () {
								s.prototype.postRender.apply(this, arguments),
									this.add(l, { prepend: !0, selector: '.o-form-info-container' });
							},
							getUISchema: function () {
								var e = s.prototype.getUISchema.apply(this, arguments);
								return e.filter(function (e) {
									return 'authenticator.methodType' !== e.name;
								});
							},
						}),
						c = a.default.extend({ Body: u });
					(t.default = c), (e.exports = t.default);
				},
				37437: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(99283)),
						i = n(64642),
						a = o.default.prototype.Body,
						s = a.extend(
							Object.assign({
								noButtonBar: !0,
								resendEmailAction: 'currentAuthenticatorEnrollment-resend',
								events: { 'click .enter-auth-code-instead-link': 'showAuthCodeEntry' },
								initialize: function () {
									var e, t;
									a.prototype.initialize.apply(this, arguments);
									var n =
											(null === (e = this.options.currentViewState.relatesTo) ||
											void 0 === e ||
											null === (t = e.value) ||
											void 0 === t
												? void 0
												: t.profile) || {},
										r = n.email,
										o = n.secondaryEmail,
										s = this.isUseEmailMagicLink();
									s && this.add((0, i.getEnterCodeLink)(), { prepend: !0, selector: '.o-form-error-container' }),
										this.add((0, i.getCheckYourEmailTitle)(), {
											prepend: !0,
											selector: '.o-form-error-container',
											options: { email: r, secondaryEmail: o, useEmailMagicLinkValue: s },
										});
								},
								postRender: function () {
									a.prototype.postRender.apply(this, arguments),
										this.isUseEmailMagicLink() ? this.showCodeEntryField(!1) : (this.noButtonBar = !1);
								},
								isUseEmailMagicLink: function () {
									var e,
										t,
										n =
											null === (e = this.options.appState.get('currentAuthenticatorEnrollment')) ||
											void 0 === e ||
											null === (t = e.contextualData) ||
											void 0 === t
												? void 0
												: t.useEmailMagicLink;
									return void 0 === n || n;
								},
								showAuthCodeEntry: function () {
									(this.noButtonBar = !1),
										this.render(),
										this.showCodeEntryField(!0),
										this.removeEnterAuthCodeInsteadLink();
								},
								showCodeEntryField: function () {
									var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
										t = this.$el.find('.o-form-fieldset-container');
									t.toggle(e);
								},
								removeEnterAuthCodeInsteadLink: function () {
									this.$el.find('.enter-auth-code-instead-link').remove();
								},
							})
						),
						l = o.default.extend({ Body: s });
					(t.default = l), (e.exports = t.default);
				},
				29118: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(99283)),
						i = n(64642),
						a = o.default.prototype.Body,
						s = a.extend(
							Object.assign({
								resendEmailAction: 'currentAuthenticator-resend',
								initialize: function () {
									var e, t, n;
									a.prototype.initialize.apply(this, arguments);
									var r =
											(null === (e = this.options.appState.get('user')) ||
											void 0 === e ||
											null === (t = e.profile) ||
											void 0 === t
												? void 0
												: t.email) ||
											(null === (n = this.options.appState.get('user')) || void 0 === n ? void 0 : n.identifier) ||
											{},
										o = this.isUseEmailMagicLink();
									void 0 !== o
										? ((this.noButtonBar = !0),
										  (this.events['click .enter-auth-code-instead-link'] = 'showAuthCodeEntry'),
										  o && this.add((0, i.getEnterCodeLink)(), { prepend: !0, selector: '.o-form-error-container' }),
										  this.add((0, i.getCheckYourEmailTitle)(), {
												prepend: !0,
												selector: '.o-form-error-container',
												options: { email: r, useEmailMagicLinkValue: o },
										  }))
										: this.add((0, i.getCheckYourEmailEnrollTitle)(), {
												prepend: !0,
												selector: '.o-form-error-container',
										  });
								},
								postRender: function () {
									a.prototype.postRender.apply(this, arguments),
										void 0 !== this.isUseEmailMagicLink() &&
											(this.isUseEmailMagicLink() ? this.showCodeEntryField(!1) : (this.noButtonBar = !1));
								},
								isUseEmailMagicLink: function () {
									var e, t;
									return null === (e = this.options.appState.get('currentAuthenticator')) ||
										void 0 === e ||
										null === (t = e.contextualData) ||
										void 0 === t
										? void 0
										: t.useEmailMagicLink;
								},
								showAuthCodeEntry: function () {
									(this.noButtonBar = !1),
										this.render(),
										this.showCodeEntryField(!0),
										this.removeEnterAuthCodeInsteadLink();
								},
								showCodeEntryField: function () {
									var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
										t = this.$el.find('.o-form-fieldset-container');
									t.toggle(e);
								},
								removeEnterAuthCodeInsteadLink: function () {
									this.$el.find('.enter-auth-code-instead-link').remove();
								},
							})
						),
						l = o.default.extend({ Body: s });
					(t.default = l), (e.exports = t.default);
				},
				11024: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475),
						s = n(43318),
						l = r(n(30471)),
						u = n(71244),
						c = n(64459),
						d = 'idx.error.code.access_denied.device_assurance.remediation',
						f = ''.concat(d, '.additional_help_'),
						p = ''.concat(d, '.additional_help_custom'),
						h = ''.concat(d, '.option_index'),
						m = ''.concat(d, '.title'),
						v = ''.concat('idx.device_assurance.grace_period.warning', '.title'),
						g = ''.concat(d, '.explanation_');
					var y = a.View.extend({
						className: 'end-user-remediation-messages-view',
						template: i.default.template({
							1: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<div class="end-user-remediation-title">' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'title') || (null != t ? a(t, 'title') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'title',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 53 }, end: { line: 1, column: 62 } },
											  })
											: i
									) +
									'</div>'
								);
							},
							3: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<div class="end-user-remediation-explanation">' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'explanation') || (null != t ? a(t, 'explanation') : t))
													? i
													: e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'explanation',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 140 }, end: { line: 1, column: 155 } },
											  })
											: i
									) +
									'</div>'
								);
							},
							5: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<div class="end-user-remediation-options">' +
									(null !=
									(i = a(n, 'each').call(
										null != t ? t : e.nullContext || {},
										null != t ? a(t, 'remediationOptions') : t,
										{
											name: 'each',
											hash: {},
											fn: e.program(6, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 236 }, end: { line: 1, column: 605 } },
										}
									))
										? i
										: '') +
									'</div>'
								);
							},
							6: function (e, t, n, r, o) {
								var i,
									a,
									s = null != t ? t : e.nullContext || {},
									l =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<div class="' +
									e.escapeExpression(
										'function' ==
											typeof (a =
												null != (a = l(n, 'className') || (null != t ? l(t, 'className') : t))
													? a
													: e.hooks.helperMissing)
											? a.call(s, {
													name: 'className',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 276 }, end: { line: 1, column: 289 } },
											  })
											: a
									) +
									'">' +
									(null !=
									(i = l(n, 'if').call(s, null != t ? l(t, 'link') : t, {
										name: 'if',
										hash: {},
										fn: e.program(7, o, 0),
										inverse: e.program(9, o, 0),
										data: o,
										loc: { start: { line: 1, column: 291 }, end: { line: 1, column: 590 } },
									}))
										? i
										: '') +
									'</div>'
								);
							},
							7: function (e, t, n, r, i) {
								var a,
									s = null != t ? t : e.nullContext || {},
									l = e.hooks.helperMissing,
									u = 'function',
									c = e.escapeExpression,
									d =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<a href="' +
									c(
										((a = null != (a = d(n, 'link') || (null != t ? d(t, 'link') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'link',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 312 }, end: { line: 1, column: 320 } },
											  })
											: a)
									) +
									'" target="_blank" rel="noopener noreferrer">' +
									c(
										((a = null != (a = d(n, 'message') || (null != t ? d(t, 'message') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'message',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 364 }, end: { line: 1, column: 375 } },
											  })
											: a)
									) +
									'</a>'
								);
							},
							9: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return null !=
									(i = a(n, 'if').call(
										null != t ? t : e.nullContext || {},
										null != t ? a(t, 'deviceRemediationAction') : t,
										{
											name: 'if',
											hash: {},
											fn: e.program(10, o, 0),
											inverse: e.program(12, o, 0),
											data: o,
											loc: { start: { line: 1, column: 387 }, end: { line: 1, column: 583 } },
										}
									))
									? i
									: '';
							},
							10: function (e, t, n, r, i) {
								var a,
									s = null != t ? t : e.nullContext || {},
									l = e.hooks.helperMissing,
									u = 'function',
									c = e.escapeExpression,
									d =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'<button class="enduser-remediation-button-link" id="' +
									c(
										((a =
											null != (a = d(n, 'deviceRemediationAction') || (null != t ? d(t, 'deviceRemediationAction') : t))
												? a
												: l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'deviceRemediationAction',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 470 }, end: { line: 1, column: 497 } },
											  })
											: a)
									) +
									'" data-se="' +
									c(
										((a =
											null != (a = d(n, 'deviceRemediationAction') || (null != t ? d(t, 'deviceRemediationAction') : t))
												? a
												: l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'deviceRemediationAction',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 508 }, end: { line: 1, column: 535 } },
											  })
											: a)
									) +
									'">' +
									c(
										((a = null != (a = d(n, 'message') || (null != t ? d(t, 'message') : t)) ? a : l),
										(0, o.default)(a) === u
											? a.call(s, {
													name: 'message',
													hash: {},
													data: i,
													loc: { start: { line: 1, column: 537 }, end: { line: 1, column: 548 } },
											  })
											: a)
									) +
									'</button>'
								);
							},
							12: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return e.escapeExpression(
									'function' ==
										typeof (i =
											null != (i = a(n, 'message') || (null != t ? a(t, 'message') : t)) ? i : e.hooks.helperMissing)
										? i.call(null != t ? t : e.nullContext || {}, {
												name: 'message',
												hash: {},
												data: o,
												loc: { start: { line: 1, column: 565 }, end: { line: 1, column: 576 } },
										  })
										: i
								);
							},
							14: function (e, t, n, r, o) {
								var i =
									e.lookupProperty ||
									function (e, t) {
										if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
									};
								return e.escapeExpression(
									(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
										null != t ? t : e.nullContext || {},
										{
											name: 'i18n',
											hash: {
												$1: "<a href='#' target='_blank' rel='noopener noreferrer' class='additional-help'>$1</a>",
												bundle: 'login',
												code: 'idx.error.code.access_denied.device_assurance.remediation.additional_help_custom',
											},
											data: o,
											loc: { start: { line: 1, column: 695 }, end: { line: 1, column: 897 } },
										}
									)
								);
							},
							16: function (e, t, n, r, o) {
								var i =
									e.lookupProperty ||
									function (e, t) {
										if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
									};
								return e.escapeExpression(
									(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
										null != t ? t : e.nullContext || {},
										{
											name: 'i18n',
											hash: {
												$1: "<a href='#' target='_blank' rel='noopener noreferrer' class='additional-help'>$1</a>",
												bundle: 'login',
												code: 'idx.error.code.access_denied.device_assurance.remediation.additional_help_default',
											},
											data: o,
											loc: { start: { line: 1, column: 905 }, end: { line: 1, column: 1108 } },
										}
									)
								);
							},
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a = null != t ? t : e.nullContext || {},
									s =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									(null !=
									(i = s(n, 'if').call(a, null != t ? s(t, 'title') : t, {
										name: 'if',
										hash: {},
										fn: e.program(1, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 75 } },
									}))
										? i
										: '') +
									(null !=
									(i = s(n, 'if').call(a, null != t ? s(t, 'explanation') : t, {
										name: 'if',
										hash: {},
										fn: e.program(3, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 75 }, end: { line: 1, column: 168 } },
									}))
										? i
										: '') +
									(null !=
									(i = s(n, 'if').call(a, null != t ? s(t, 'remediationOptions') : t, {
										name: 'if',
										hash: {},
										fn: e.program(5, o, 0),
										inverse: e.noop,
										data: o,
										loc: { start: { line: 1, column: 168 }, end: { line: 1, column: 618 } },
									}))
										? i
										: '') +
									'<div class="end-user-remediation-help-and-contact">' +
									(null !=
									(i = s(n, 'if').call(a, null != t ? s(t, 'useCustomHelpText') : t, {
										name: 'if',
										hash: {},
										fn: e.program(14, o, 0),
										inverse: e.program(16, o, 0),
										data: o,
										loc: { start: { line: 1, column: 669 }, end: { line: 1, column: 1115 } },
									}))
										? i
										: '') +
									'</div>'
								);
							},
							useData: !0,
						}),
						getTemplateData: function () {
							var e = this,
								t = this.options.messages,
								n = [],
								r = null,
								o = null,
								i = !1;
							return (
								t.forEach(function (t) {
									var a = t.i18n,
										d = a.key,
										y = a.params,
										b = void 0 === y ? [] : y,
										_ = t.links,
										w = t.message;
									if (d === m) r = (0, s.getMessage)(t);
									else if (d.startsWith(v)) {
										if (b.length > 0) {
											var O = b[0],
												k = new Date(O),
												x = l.default.formatDateToDeviceAssuranceGracePeriodExpiryLocaleString(
													k,
													e.options.languageCode
												);
											r = x ? (0, u.loc)(d, 'login', [x]) : w;
										}
									} else
										d.startsWith(g)
											? (o = (0, s.getMessage)(t))
											: d.startsWith(f)
											? ((i = d === p), _ && _[0] && _[0].url && (e.additionalHelpUrl = _[0].url))
											: n.push(
													(function (e) {
														var t = null,
															n = null;
														return (
															e.links && e.links[0] && e.links[0].url
																? (t = e.links[0].url)
																: (0, c.hasDeviceRemediationAction)(e) && (n = e.deviceRemediation.value.action),
															{
																message: (0, s.getMessage)(e),
																link: t,
																deviceRemediationAction: n,
																className:
																	e.i18n.key === h ? 'end-user-remediation-option' : 'end-user-remediation-action',
															}
														);
													})(t)
											  );
								}),
								{ title: r, explanation: o, remediationOptions: n, useCustomHelpText: i }
							);
						},
						render: function () {
							a.View.prototype.render.apply(this, arguments),
								this.additionalHelpUrl && this.$el.find('.additional-help').attr('href', this.additionalHelpUrl);
						},
						postRender: function () {
							var e = this;
							Array.isArray(this.options.messages) &&
								this.options.messages
									.filter(function (e) {
										return (0, c.hasDeviceRemediationAction)(e);
									})
									.map(function (e) {
										return e.deviceRemediation.value;
									})
									.forEach(function (t) {
										e.$el.find('#'.concat(t.action)).click(function (e) {
											e.preventDefault(), (0, c.isLoopbackDeviceRemediation)(t) && (0, c.probeLoopbackAndExecute)(t);
										});
									});
						},
					});
					(t.default = y), (e.exports = t.default);
				},
				60296: function (e, t) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.I18N_BASE_ATTRIBUTE_ENROLL_PROFILE_MAPPINGS = void 0);
					t.I18N_BASE_ATTRIBUTE_ENROLL_PROFILE_MAPPINGS = {
						'enroll-profile.userProfile.login': 'oie.user.profile.login',
						'enroll-profile.userProfile.lastName': 'oie.user.profile.lastname',
						'enroll-profile.userProfile.firstName': 'oie.user.profile.firstname',
						'enroll-profile.userProfile.email': 'oie.user.profile.primary.email',
						'enroll-profile.userProfile.secondEmail': 'oie.user.profile.secondary.email',
						'enroll-profile.userProfile.middleName': 'oie.user.profile.middleName',
						'enroll-profile.userProfile.honorificPrefix': 'oie.user.profile.honorificPrefix',
						'enroll-profile.userProfile.honorificSuffix': 'oie.user.profile.honorificSuffix',
						'enroll-profile.userProfile.title': 'oie.user.profile.title',
						'enroll-profile.userProfile.displayName': 'oie.user.profile.displayName',
						'enroll-profile.userProfile.nickName': 'oie.user.profile.nickName',
						'enroll-profile.userProfile.profileUrl': 'oie.user.profile.profileUrl',
						'enroll-profile.userProfile.mobilePhone': 'oie.user.profile.mobilePhone',
						'enroll-profile.userProfile.primaryPhone': 'oie.user.profile.primaryPhone',
						'enroll-profile.userProfile.streetAddress': 'oie.user.profile.streetAddress',
						'enroll-profile.userProfile.city': 'oie.user.profile.city',
						'enroll-profile.userProfile.state': 'oie.user.profile.state',
						'enroll-profile.userProfile.zipCode': 'oie.user.profile.zipCode',
						'enroll-profile.userProfile.postalCode': 'oie.user.profile.postalCode',
						'enroll-profile.userProfile.countryCode': 'oie.user.profile.countryCode',
						'enroll-profile.userProfile.postalAddress': 'oie.user.profile.postalAddress',
						'enroll-profile.userProfile.preferredLanguage': 'oie.user.profile.preferredLanguage',
						'enroll-profile.userProfile.locale': 'oie.user.profile.locale',
						'enroll-profile.userProfile.timezone': 'oie.user.profile.timezone',
						'enroll-profile.userProfile.userType': 'oie.user.profile.userType',
						'enroll-profile.userProfile.employeeNumber': 'oie.user.profile.employeeNumber',
						'enroll-profile.userProfile.costCenter': 'oie.user.profile.costCenter',
						'enroll-profile.userProfile.organization': 'oie.user.profile.organization',
						'enroll-profile.userProfile.division': 'oie.user.profile.division',
						'enroll-profile.userProfile.department': 'oie.user.profile.department',
						'enroll-profile.userProfile.managerId': 'oie.user.profile.managerId',
						'enroll-profile.userProfile.manager': 'oie.user.profile.manager',
						'enroll-profile.credentials.passcode': 'oie.password.label',
					};
				},
				7925: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = i.BaseForm.extend(
							Object.assign({
								className: 'google-authenticator-challenge',
								title: function () {
									return (0, o.loc)('oie.verify.google_authenticator.otp.title', 'login');
								},
								subtitle: function () {
									return (0, o.loc)('oie.verify.google_authenticator.otp.description', 'login');
								},
								save: function () {
									return (0, o.loc)('mfa.challenge.verify', 'login');
								},
							})
						),
						l = a.default.extend({ Body: s });
					(t.default = l), (e.exports = t.default);
				},
				12167: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = n(17587),
						s = r(n(83966)),
						l = r(n(37974)),
						u = r(n(57298)),
						c = 'viewToDisplay',
						d = 'barcode',
						f = 'manual',
						p = 'enterCode',
						h = a.BaseForm.extend({
							title: function () {
								return (0, i.loc)('oie.enroll.google_authenticator.setup.title', 'login');
							},
							noButtonBar: !0,
							className: 'oie-enroll-google-authenticator',
							enterCodeSubtitle: i.View.extend({
								template: o.default.template({
									compiler: [8, '>= 4.3.0'],
									main: function (e, t, n, r, o) {
										var i =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
										return (
											'<div class="google-authenticator-setup-info-title enter-code-title">' +
											e.escapeExpression(
												(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
													null != t ? t : e.nullContext || {},
													{
														name: 'i18n',
														hash: { bundle: 'login', code: 'oie.enroll.google_authenticator.enterCode.title' },
														data: o,
														loc: { start: { line: 1, column: 68 }, end: { line: 1, column: 146 } },
													}
												)
											) +
											'</div>'
										);
									},
									useData: !0,
								}),
							}),
							getUISchema: function () {
								var e = this,
									t = a.BaseForm.prototype.getUISchema.apply(this, arguments),
									n = (0, a.addCustomButton)({
										className: 'google-authenticator-next',
										title: (0, i.loc)('oform.next', 'login'),
										click: function () {
											e.model.set(c, p);
										},
									}),
									r = (0, a.addCustomButton)({
										className: 'google-authenticator-verify',
										title: (0, i.loc)('oform.verify', 'login'),
										click: function () {
											e.$el.submit();
										},
									});
								return (
									(t[0].showWhen = { viewToDisplay: p }),
									t.unshift({
										View: this.enterCodeSubtitle,
										selector: '.o-form-fieldset-container',
										showWhen: { viewToDisplay: p },
									}),
									t.push(
										{ View: l.default, selector: '.o-form-fieldset-container', showWhen: { viewToDisplay: d } },
										{ View: u.default, selector: '.o-form-fieldset-container', showWhen: { viewToDisplay: f } },
										{
											label: !1,
											className: 'shared-secret no-translate',
											type: 'text',
											placeholder: this.options.appState.get('currentAuthenticator').contextualData.sharedSecret,
											disabled: !0,
											showWhen: { viewToDisplay: f },
										},
										{
											View: n,
											showWhen: {
												viewToDisplay: function (e) {
													return e === d || e === f;
												},
											},
										},
										{
											View: r,
											showWhen: {
												viewToDisplay: function (e) {
													return e === p;
												},
											},
										}
									),
									t
								);
							},
						}),
						m = s.default.extend({
							Body: h,
							createModelClass: function () {
								var e = a.BaseView.prototype.createModelClass.apply(this, arguments),
									t = Object.assign(
										{ viewToDisplay: { value: 'barcode', type: 'string', required: !0, values: [d, f, p] } },
										e.prototype.local
									);
								return e.extend({ local: t });
							},
						});
					(t.default = m), (e.exports = t.default);
				},
				57298: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475).View.extend({
							className: 'oie-enroll-google-authenticator-manual-setup',
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i = null != t ? t : e.nullContext || {},
										a = e.hooks.helperMissing,
										s = e.escapeExpression,
										l =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="google-authenticator-setup-info-title manual-setup-title">' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.google_authenticator.cannotScanBarcode.title' },
												data: o,
												loc: { start: { line: 1, column: 70 }, end: { line: 1, column: 156 } },
											})
										) +
										'</div><p class="google-authenticator-setup-info">' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.google_authenticator.manualSetupInstructions' },
												data: o,
												loc: { start: { line: 1, column: 205 }, end: { line: 1, column: 291 } },
											})
										) +
										'</p>'
									);
								},
								useData: !0,
							}),
						});
					(t.default = i), (e.exports = t.default);
				},
				37974: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475).View.extend({
							className: 'oie-enroll-google-authenticator-barcode',
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s = e.hooks.helperMissing,
										l = e.escapeExpression,
										u =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="google-authenticator-setup-info-title barcode-setup-title">' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.google_authenticator.scanBarcode.title' },
												data: o,
												loc: { start: { line: 1, column: 83 }, end: { line: 1, column: 163 } },
											})
										) +
										'</div><div class="qrcode-info-container"><p class="google-authenticator-setup-info">' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.google_authenticator.scanBarcode.description' },
												data: o,
												loc: { start: { line: 1, column: 247 }, end: { line: 1, column: 333 } },
											})
										) +
										'</p><div class="qrcode-container"><img class="qrcode" src=' +
										l(
											'function' == typeof (i = null != (i = u(n, 'href') || (null != t ? u(t, 'href') : t)) ? i : s)
												? i.call(a, {
														name: 'href',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 391 }, end: { line: 1, column: 399 } },
												  })
												: i
										) +
										' alt="qr code"></img><a href="#" class="cannot-scan-link">' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.google_authenticator.scanBarcode.cannotScan' },
												data: o,
												loc: { start: { line: 1, column: 457 }, end: { line: 1, column: 542 } },
											})
										) +
										'</a></div></div>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return null !=
										(i = a(n, 'if').call(null != t ? t : e.nullContext || {}, null != t ? a(t, 'href') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 565 } },
										}))
										? i
										: '';
								},
								useData: !0,
							}),
							getTemplateData: function () {
								var e;
								return {
									href:
										null === (e = this.options.appState.get('currentAuthenticator').contextualData.qrcode) ||
										void 0 === e
											? void 0
											: e.href,
								};
							},
							events: {
								'click .cannot-scan-link': function (e) {
									e.preventDefault(), this.options.model.set('viewToDisplay', 'manual');
								},
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				82640: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475),
						o = n(2976),
						i = o.BaseIdPAuthenticatorBody.extend({
							title: function () {
								var e = this.options.appState.getAuthenticatorDisplayName();
								return (0, r.loc)('oie.idp.enroll.title', 'login', [e]);
							},
							subtitle: function () {
								var e = this.options.appState.getAuthenticatorDisplayName();
								return (0, r.loc)('oie.idp.enroll.description', 'login', [e]);
							},
							save: function () {
								return (0, r.loc)('mfa.enroll', 'login');
							},
						}),
						a = o.BaseIdpAuthenticatorView.extend({ Body: i });
					(t.default = a), (e.exports = t.default);
				},
				49065: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475),
						o = n(2976),
						i = o.BaseIdPAuthenticatorBody.extend({
							title: function () {
								var e = this.options.appState.getAuthenticatorDisplayName();
								return (0, r.loc)('oie.idp.challenge.title', 'login', [e]);
							},
							subtitle: function () {
								var e = this.options.appState.getAuthenticatorDisplayName();
								return (0, r.loc)('oie.idp.challenge.description', 'login', [e]);
							},
							save: function () {
								return (0, r.loc)('mfa.challenge.verify', 'login');
							},
						}),
						a = o.BaseIdpAuthenticatorView.extend({ Body: i });
					(t.default = a), (e.exports = t.default);
				},
				2976: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.BaseIdpAuthenticatorView = t.BaseIdPAuthenticatorBody = void 0);
					var o = n(17587),
						i = r(n(83966)),
						a = n(13955),
						s = o.BaseForm.extend({
							initialize: function () {
								o.BaseForm.prototype.initialize.apply(this, arguments),
									this.model.set('useRedirect', !0),
									this.add('<div class="okta-waiting-spinner"></div>');
							},
						});
					t.BaseIdPAuthenticatorBody = s;
					var l = i.default.extend({
						postRender: function () {
							i.default.prototype.postRender.apply(this, arguments);
							var e = this.options.appState.get('messages') || {};
							this.settings.get('features.skipIdpFactorVerificationBtn') &&
							!Array.isArray(e.value) &&
							this.model.get('formName') !== a.FORMS.REDIRECT_IDVERIFY
								? (this.$('.o-form-button-bar').hide(),
								  this.$('.okta-waiting-spinner').show(),
								  this.form.trigger('save', this.model))
								: (this.$('.okta-waiting-spinner').hide(), this.$('.o-form-button-bar').show());
						},
					});
					t.BaseIdpAuthenticatorView = l;
				},
				91671: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = n(2976),
						s = n(17587),
						l = n(78747),
						u = i.View.extend({
							tagName: 'p',
							className: 'privacy-footer',
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i = null != t ? t : e.nullContext || {},
										a = e.hooks.helperMissing,
										s = e.escapeExpression,
										l =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p>' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: {
													$2: "<a class='inline-link' data-se='privacy-policy' target='_blank' rel='noopener noreferrer'>$2</a>",
													$1: "<a class='inline-link' data-se='terms-of-use' target='_blank' rel='noopener noreferrer'>$1</a>",
													arguments: 'idpName',
													bundle: 'login',
													code: 'oie.idv.idp.desc.termsOfUse',
												},
												data: o,
												loc: { start: { line: 1, column: 3 }, end: { line: 1, column: 283 } },
											})
										) +
										'</p><p>' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { arguments: 'idpName', bundle: 'login', code: 'oie.idv.idp.desc.agreement' },
												data: o,
												loc: { start: { line: 1, column: 290 }, end: { line: 1, column: 367 } },
											})
										) +
										'</p>'
									);
								},
								useData: !0,
							}),
							getTemplateData: function () {
								return { idpName: (0, l.getIdvName)(this.options.appState.get('remediations')) };
							},
						}),
						c = a.BaseIdPAuthenticatorBody.extend({
							title: function () {
								return (0, i.loc)('oie.idv.idp.title', 'login', [
									(0, l.getIdvName)(this.options.appState.get('remediations')),
								]);
							},
							subtitle: function () {
								return (0, i.loc)('oie.idv.idp.desc', 'login', [
									(0, l.getIdvName)(this.options.appState.get('remediations')),
								]);
							},
							save: function () {
								return (0, i.loc)('oie.optional.authenticator.button.title', 'login');
							},
						}),
						d = a.BaseIdpAuthenticatorView.extend({
							Body: c,
							Footer: s.BaseFooter.extend({
								postRender: function () {
									this.add(u);
									var e = (0, l.getHelpLinks)(this.options.appState.get('remediations')),
										t = e.termsOfUse,
										n = e.privacyPolicy;
									this.$el.find('[data-se="terms-of-use"]').attr('href', t),
										this.$el.find('[data-se="privacy-policy"]').attr('href', n);
								},
							}),
						});
					(t.default = d), (e.exports = t.default);
				},
				1850: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475),
						o = n(17587),
						i = o.BaseForm.extend({
							noSubmitButton: !0,
							title: function () {
								return (0, r.loc)('oie.kmsi.title', 'login');
							},
							subtitle: function () {
								return (0, r.loc)('oie.kmsi.subtitle', 'login');
							},
							saveForm: function (e) {
								this.model.set('keepMeSignedIn', e), this.options.appState.trigger('saveForm', this.model);
							},
							getUISchema: function () {
								var e = this;
								return [
									{
										View: (0, r.createButton)({
											className: 'button button-secondary',
											title: (0, r.loc)('oie.kmsi.accept', 'login'),
											attributes: { 'data-se': 'stay-signed-in-btn' },
											click: function () {
												e.saveForm(!0);
											},
										}),
									},
									{
										View: (0, r.createButton)({
											className: 'button button-secondary',
											title: (0, r.loc)('oie.kmsi.reject', 'login'),
											attributes: { 'data-se': 'do-not-stay-signed-in-btn' },
											click: function () {
												e.saveForm(!1);
											},
										}),
									},
								];
							},
						}),
						a = o.BaseView.extend({ Body: i });
					(t.default = a), (e.exports = t.default);
				},
				58734: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = i.BaseForm.extend({
							className: 'on-prem-authenticator-verify',
							modelEvents: { error: '_checkTokenChange' },
							title: function () {
								var e =
									this.options.appState.getAuthenticatorDisplayName() ||
									(0, o.loc)('oie.on_prem.authenticator.default.vendorName', 'login');
								return (0, o.loc)('oie.on_prem.verify.title', 'login', [e]);
							},
							_checkTokenChange: function (e, t) {
								var n,
									r = null == t || null === (n = t.responseJSON) || void 0 === n ? void 0 : n.errorSummaryKeys;
								r && r.includes('errors.E0000113') && (this.model.set('credentials.passcode', ''), this.render());
							},
							save: function () {
								return (0, o.loc)('mfa.challenge.verify', 'login');
							},
						}),
						l = a.default.extend({ Body: s });
					(t.default = l), (e.exports = t.default);
				},
				79091: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = i.BaseForm.extend({
							className: 'on-prem-authenticator-enroll',
							modelEvents: { error: '_checkTokenChange' },
							title: function () {
								var e =
									this.options.appState.getAuthenticatorDisplayName() ||
									(0, o.loc)('oie.on_prem.authenticator.default.vendorName', 'login');
								return (0, o.loc)('oie.on_prem.enroll.title', 'login', [e]);
							},
							_checkTokenChange: function (e, t) {
								var n,
									r = null == t || null === (n = t.responseJSON) || void 0 === n ? void 0 : n.errorSummaryKeys;
								r && r.includes('errors.E0000113') && (this.model.set('credentials.passcode', ''), this.render());
							},
							save: function () {
								return (0, o.loc)('mfa.challenge.verify', 'login');
							},
						}),
						l = a.default.extend({ Body: s });
					(t.default = l), (e.exports = t.default);
				},
				32290: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475),
						o = n(17587),
						i = n(66200),
						a = o.BaseOktaVerifyChallengeView.extend({
							getDeviceChallengePayload: function () {
								return this.options.currentViewState.relatesTo.value.contextualData.challenge.value;
							},
							showCustomFormErrorCallout: function (e) {
								var t = (0, i.getBiometricsErrorOptions)(e, !1);
								return !r._.isEmpty(t) && (this.showMessages((0, r.createCallout)(t)), !0);
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				99214: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = i.BaseForm.extend(
							Object.assign({
								className: 'okta-verify-resend-push',
								title: function () {
									return (0, o.loc)('oie.okta_verify.push.title', 'login');
								},
								save: function () {
									return (0, o.loc)('oie.okta_verify.push.resend', 'login');
								},
								showMessages: function () {
									var e = {};
									this.options.appState.containsMessageWithI18nKey(
										'oie.authenticator.app.method.push.force.upgrade.number_challenge'
									)
										? (e.title = (0, o.loc)('oie.numberchallenge.force.upgrade.title', 'login'))
										: this.options.appState.containsMessageWithI18nKey(
												'oie.authenticator.app.method.push.verify.enable.biometrics'
										  ) &&
										  ((e.content = null),
										  (e.className = 'okta-verify-uv-callout-content'),
										  (e.title = (0, o.loc)(
												'oie.authenticator.app.method.push.verify.enable.biometrics.title',
												'login'
										  )),
										  (e.subtitle = (0, o.loc)(
												'oie.authenticator.app.method.push.verify.enable.biometrics.description',
												'login'
										  )),
										  (e.type = 'error'),
										  (e.bullets = [
												(0, o.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point1', 'login'),
												(0, o.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point2', 'login'),
												(0, o.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point3', 'login'),
										  ]),
										  (e = (0, o.createCallout)(e))),
										i.BaseForm.prototype.showMessages.call(this, e);
								},
							})
						),
						l = a.default.extend({ Body: s });
					(t.default = l), (e.exports = t.default);
				},
				36529: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(83966)),
						i = n(17587),
						a = n(6475),
						s = n(66200),
						l = i.BaseForm.extend({
							noButtonBar: !0,
							className: 'ion-form device-challenge-poll',
							title: function () {
								return (0, a.loc)('deviceTrust.sso.redirectText', 'login');
							},
							initialize: function () {
								var e,
									t,
									n = this;
								i.BaseForm.prototype.initialize.apply(this, arguments),
									this.listenTo(this.model, 'error', function () {
										n.$('.spinner').hide();
									}),
									this.add('<div class="credential-sso-extension"><div class="spinner"></div></div>');
								var r =
									'get' ===
									(null === (e = this.options.currentViewState) ||
									void 0 === e ||
									null === (t = e.method) ||
									void 0 === t
										? void 0
										: t.toLowerCase());
								this.model.set('useRedirect', r), this.trigger('save', this.model);
							},
							showCustomFormErrorCallout: function (e) {
								var t = (0, s.getBiometricsErrorOptions)(e, !1);
								return !a._.isEmpty(t) && (this.showMessages((0, a.createCallout)(t)), !0);
							},
						}),
						u = o.default.extend({ Body: l });
					(t.default = u), (e.exports = t.default);
				},
				90088: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = i.BaseForm.extend(
							Object.assign({
								className: 'okta-verify-totp-challenge',
								title: function () {
									return (0, o.loc)('oie.okta_verify.totp.title', 'login');
								},
								save: function () {
									return (0, o.loc)('mfa.challenge.verify', 'login');
								},
								showCustomFormErrorCallout: function (e) {
									var t,
										n,
										r = null == e || null === (t = e.responseJSON) || void 0 === t ? void 0 : t.errorSummaryKeys;
									if (r && r.includes('oie.authenticator.oktaverify.method.totp.verify.enable.biometrics'))
										return (
											(n = {
												type: 'error',
												className: 'okta-verify-uv-callout-content',
												title: (0, o.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.title', 'login'),
												subtitle: (0, o.loc)(
													'oie.authenticator.app.method.push.verify.enable.biometrics.description',
													'login'
												),
												bullets: [
													(0, o.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point1', 'login'),
													(0, o.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point2', 'login'),
													(0, o.loc)('oie.authenticator.app.method.push.verify.enable.biometrics.point3', 'login'),
												],
											}),
											this.showMessages((0, o.createCallout)(n)),
											!0
										);
								},
							})
						),
						l = a.default.extend({ Body: s });
					(t.default = l), (e.exports = t.default);
				},
				1705: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(83966)),
						i = n(70621),
						a = r(n(32290)),
						s = r(n(58474)),
						l = n(13955),
						u = o.default.extend({
							initialize: function () {
								var e, t, n;
								o.default.prototype.initialize.apply(this, arguments);
								var r =
										null === (e = this.options) || void 0 === e || null === (t = e.appState) || void 0 === t
											? void 0
											: t.get('currentAuthenticator'),
									u = null == r ? void 0 : r.methods[0];
								(null == u ? void 0 : u.type) === l.AUTHENTICATOR_METHODS.PUSH &&
								null != r &&
								null !== (n = r.contextualData) &&
								void 0 !== n &&
								n.correctAnswer
									? (this.Body = s.default)
									: (null == u ? void 0 : u.type) === l.AUTHENTICATOR_METHODS.PUSH
									? (this.Body = i.Body)
									: (this.Body = a.default);
							},
						});
					(t.default = u), (e.exports = t.default);
				},
				67436: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(15985)),
						i = r(n(2875)),
						a = n(6475),
						s = n(13955),
						l = n(66200);
					function u(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function c(e) {
						for (var t = 1; t < arguments.length; t++) {
							var n = null != arguments[t] ? arguments[t] : {};
							t % 2
								? u(Object(n), !0).forEach(function (t) {
										(0, o.default)(e, t, n[t]);
								  })
								: Object.getOwnPropertyDescriptors
								? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
								: u(Object(n)).forEach(function (t) {
										Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
								  });
						}
						return e;
					}
					var d = a.internal.views.components.Notification,
						f = a.internal.util.Clipboard,
						p = a.View.extend({
							initialize: function () {
								var e = h(this.options.appState);
								if (e && e.setupOVUrl && e.isDesktop) {
									this.ulDom && this.ulDom.remove();
									var t = (0, l.createInvisibleIFrame)('custom-uri-container', e.setupOVUrl);
									this.ulDom = this.add(t).last();
								}
							},
							template: i.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s = e.hooks.helperMissing,
										l = e.escapeExpression,
										u =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<ol class="qrcode-info ov-info"><li>' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.okta_verify.qrcode.step1.updated' },
												data: o,
												loc: { start: { line: 1, column: 48 }, end: { line: 1, column: 122 } },
											})
										) +
										'</li><li>' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.okta_verify.qrcode.step2' },
												data: o,
												loc: { start: { line: 1, column: 131 }, end: { line: 1, column: 197 } },
											})
										) +
										'</li><li>' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: {
													$1: "<span class='strong'>$1</span>",
													bundle: 'login',
													code: 'oie.enroll.okta_verify.qrcode.step3.updated',
												},
												data: o,
												loc: { start: { line: 1, column: 206 }, end: { line: 1, column: 316 } },
											})
										) +
										'</li></ol><div class="qrcode-container"><img class="qrcode" src=' +
										l(
											'function' == typeof (i = null != (i = u(n, 'href') || (null != t ? u(t, 'href') : t)) ? i : s)
												? i.call(a, {
														name: 'href',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 380 }, end: { line: 1, column: 388 } },
												  })
												: i
										) +
										' alt="' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'mfa.altQrCode' },
												data: o,
												loc: { start: { line: 1, column: 394 }, end: { line: 1, column: 439 } },
											})
										) +
										'"></img></div>'
									);
								},
								3: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<ul class="email-info ov-info"><li>' +
										(null !=
										(i = (a(n, 'i18n') || (t && a(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: {
													$1: "<span class='strong'>$1</span>",
													arguments: 'email',
													bundle: 'login',
													code: 'oie.enroll.okta_verify.email.info.updated',
												},
												data: o,
												loc: { start: { line: 1, column: 508 }, end: { line: 1, column: 636 } },
											}
										))
											? i
											: '') +
										'</li><li class="switch-channel-content"></li></ul>'
									);
								},
								5: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<ul class="sms-info ov-info"><li>' +
										(null !=
										(i = (a(n, 'i18n') || (t && a(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: {
													$1: "<span class='strong'>$1</span>",
													arguments: 'phoneNumber',
													bundle: 'login',
													code: 'oie.enroll.okta_verify.sms.info.updated',
												},
												data: o,
												loc: { start: { line: 1, column: 745 }, end: { line: 1, column: 877 } },
											}
										))
											? i
											: '') +
										'</li><li class="switch-channel-content"></li></ul>'
									);
								},
								7: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s = e.escapeExpression,
										l =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="sameDevice-setup' +
										(null !=
										(i = l(n, 'if').call(a, null != t ? l(t, 'sameDeviceOVEnrollmentEnabled') : t, {
											name: 'if',
											hash: {},
											fn: e.program(8, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 990 }, end: { line: 1, column: 1056 } },
										}))
											? i
											: '') +
										'"><p class="explanation" data-se="subheader">' +
										(null !=
										(i = l(n, 'if').call(a, null != (i = null != t ? l(t, 'deviceMap') : t) ? l(i, 'isDesktop') : i, {
											name: 'if',
											hash: {},
											fn: e.program(10, o, 0),
											inverse: e.program(17, o, 0),
											data: o,
											loc: { start: { line: 1, column: 1101 }, end: { line: 1, column: 1874 } },
										}))
											? i
											: '') +
										'</p><ol class="ov-info">' +
										(null !=
										(i = l(n, 'unless').call(a, null != t ? l(t, 'sameDeviceOVEnrollmentEnabled') : t, {
											name: 'unless',
											hash: {},
											fn: e.program(19, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 1898 }, end: { line: 1, column: 2312 } },
										}))
											? i
											: '') +
										'<li><a href="' +
										s(e.lambda(null != (i = null != t ? l(t, 'deviceMap') : t) ? l(i, 'setupOVUrl') : i, t)) +
										'" class="button button-primary setup-button">' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || e.hooks.helperMissing).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.okta_verify.setup.title' },
												data: o,
												loc: { start: { line: 1, column: 2394 }, end: { line: 1, column: 2459 } },
											})
										) +
										'</a></li>' +
										(null !=
										(i = l(n, 'if').call(a, null != t ? l(t, 'sameDeviceOVEnrollmentEnabled') : t, {
											name: 'if',
											hash: {},
											fn: e.program(22, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 2468 }, end: { line: 1, column: 2786 } },
										}))
											? i
											: '') +
										(null !=
										(i = l(n, 'if').call(a, null != t ? l(t, 'showAnotherDeviceLink') : t, {
											name: 'if',
											hash: {},
											fn: e.program(24, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 2786 }, end: { line: 1, column: 3125 } },
										}))
											? i
											: '') +
										'</ol></div>'
									);
								},
								8: function (e, t, n, r, o) {
									return ' ov-enrollment-enabled';
								},
								10: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="desktop-instructions ov-info">' +
										e.escapeExpression(
											(s(n, 'i18n') || (t && s(t, 'i18n')) || e.hooks.helperMissing).call(a, {
												name: 'i18n',
												hash: {
													$1: "<span class='semi-strong'>$1</span>",
													bundle: 'login',
													code: 'oie.enroll.okta_verify.setup.customUri.prompt',
												},
												data: o,
												loc: { start: { line: 1, column: 1170 }, end: { line: 1, column: 1287 } },
											})
										) +
										'</div><div class="desktop-instructions">' +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'sameDeviceOVEnrollmentEnabled') : t, {
											name: 'if',
											hash: {},
											fn: e.program(11, o, 0),
											inverse: e.program(13, o, 0),
											data: o,
											loc: { start: { line: 1, column: 1327 }, end: { line: 1, column: 1583 } },
										}))
											? i
											: '') +
										'</div>' +
										(null !=
										(i = s(n, 'unless').call(a, null != t ? s(t, 'sameDeviceOVEnrollmentEnabled') : t, {
											name: 'unless',
											hash: {},
											fn: e.program(15, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 1589 }, end: { line: 1, column: 1765 } },
										}))
											? i
											: '')
									);
								},
								11: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return e.escapeExpression(
										(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: { $1: '<span>$1</span>', bundle: 'login', code: 'customUri.required.content.prompt' },
												data: o,
												loc: { start: { line: 1, column: 1364 }, end: { line: 1, column: 1449 } },
											}
										)
									);
								},
								13: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return e.escapeExpression(
										(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: {
													$1: "<span class='semi-strong'>$1</span>",
													bundle: 'login',
													code: 'oie.enroll.okta_verify.setup.customUri.noPrompt',
												},
												data: o,
												loc: { start: { line: 1, column: 1457 }, end: { line: 1, column: 1576 } },
											}
										)
									);
								},
								15: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<div class="desktop-instructions">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'oie.enroll.okta_verify.setup.customUri.makeSureHaveOV' },
													data: o,
													loc: { start: { line: 1, column: 1664 }, end: { line: 1, column: 1748 } },
												}
											)
										) +
										'</div>'
									);
								},
								17: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return e.escapeExpression(
										(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: {
													bundle: 'login',
													code: 'oie.enroll.okta_verify.setup.customUri.makeSureHaveOVToContinue',
												},
												data: o,
												loc: { start: { line: 1, column: 1773 }, end: { line: 1, column: 1867 } },
											}
										)
									);
								},
								19: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = s(n, 'if').call(a, null != (i = null != t ? s(t, 'deviceMap') : t) ? s(i, 'platformLC') : i, {
											name: 'if',
											hash: {},
											fn: e.program(20, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 1939 }, end: { line: 1, column: 2176 } },
										}))
											? i
											: '') +
										'<li>' +
										e.escapeExpression(
											(s(n, 'i18n') || (t && s(t, 'i18n')) || e.hooks.helperMissing).call(a, {
												name: 'i18n',
												hash: {
													$1: "<span class='semi-strong'>$1</span>",
													bundle: 'login',
													code: 'oie.enroll.okta_verify.setup.customUri.setup',
												},
												data: o,
												loc: { start: { line: 1, column: 2180 }, end: { line: 1, column: 2296 } },
											})
										) +
										'</li>'
									);
								},
								20: function (e, t, n, r, o) {
									var i,
										a = e.escapeExpression,
										s = e.lambda,
										l =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										"<li><a aria-label='" +
										a(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'customUri.required.content.download.linkText' },
													data: o,
													loc: { start: { line: 1, column: 1986 }, end: { line: 1, column: 2061 } },
												}
											)
										) +
										'\' href="' +
										a(s(null != (i = null != t ? l(t, 'deviceMap') : t) ? l(i, 'downloadHref') : i, t)) +
										'" class="app-store-logo ' +
										a(s(null != (i = null != t ? l(t, 'deviceMap') : t) ? l(i, 'platformLC') : i, t)) +
										'-app-store-logo"></a></li>'
									);
								},
								22: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s = e.hooks.helperMissing,
										l = e.escapeExpression,
										u =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<li><span>' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'customUri.required.content.download.title' },
												data: o,
												loc: { start: { line: 1, column: 2515 }, end: { line: 1, column: 2587 } },
											})
										) +
										'</span>&nbsp;<a href="' +
										l(e.lambda(null != (i = null != t ? u(t, 'deviceMap') : t) ? u(i, 'downloadHref') : i, t)) +
										'" target="_blank" id="download-ov" class="download-ov-link">' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'customUri.required.content.download.linkText' },
												data: o,
												loc: { start: { line: 1, column: 2695 }, end: { line: 1, column: 2770 } },
											})
										) +
										'</a></li>'
									);
								},
								24: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<li>' +
										(null !=
										(i = a(n, 'if').call(
											null != t ? t : e.nullContext || {},
											null != (i = null != t ? a(t, 'deviceMap') : t) ? a(i, 'isDesktop') : i,
											{
												name: 'if',
												hash: {},
												fn: e.program(25, o, 0),
												inverse: e.program(27, o, 0),
												data: o,
												loc: { start: { line: 1, column: 2819 }, end: { line: 1, column: 3113 } },
											}
										))
											? i
											: '') +
										'</li>'
									);
								},
								25: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return e.escapeExpression(
										(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: {
													$1: "<a class='orOnMobileLink' href='#'>$1</a>",
													bundle: 'login',
													code: 'oie.enroll.okta_verify.setup.customUri.orOnMobile',
												},
												data: o,
												loc: { start: { line: 1, column: 2846 }, end: { line: 1, column: 2973 } },
											}
										)
									);
								},
								27: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return e.escapeExpression(
										(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: {
													$1: "<a class='orOnMobileLink' href='#'>$1</a>",
													bundle: 'login',
													code: 'oie.enroll.okta_verify.setup.customUri.orMobile',
												},
												data: o,
												loc: { start: { line: 1, column: 2981 }, end: { line: 1, column: 3106 } },
											}
										)
									);
								},
								29: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'sameDevice') : t, {
											name: 'if',
											hash: {},
											fn: e.program(30, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 3144 }, end: { line: 1, column: 4021 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'deviceBootstrap') : t, {
											name: 'if',
											hash: {},
											fn: e.program(32, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 4021 }, end: { line: 1, column: 4802 } },
										}))
											? i
											: '')
									);
								},
								30: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s = e.hooks.helperMissing,
										l = e.escapeExpression,
										u = e.lambda,
										c =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p class="explanation" data-se="subheader">' +
										l(
											(c(n, 'i18n') || (t && c(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.okta_verify.setup.subtitle ' },
												data: o,
												loc: { start: { line: 1, column: 3205 }, end: { line: 1, column: 3274 } },
											})
										) +
										'</p><ol class="sameDevice-info ov-info"><li>' +
										(null !=
										(i = (c(n, 'i18n') || (t && c(t, 'i18n')) || s).call(a, {
											name: 'i18n',
											hash: {
												arguments: 'sameDevice.downloadHref',
												bundle: 'login',
												code: 'enroll.oda.without.account.step1',
											},
											data: o,
											loc: { start: { line: 1, column: 3318 }, end: { line: 1, column: 3419 } },
										}))
											? i
											: '') +
										'</li><li>' +
										l(
											(c(n, 'i18n') || (t && c(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.okta_verify.setup.openOv' },
												data: o,
												loc: { start: { line: 1, column: 3428 }, end: { line: 1, column: 3494 } },
											})
										) +
										'</li><li>' +
										l(
											(c(n, 'i18n') || (t && c(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.okta_verify.setup.signInUrl' },
												data: o,
												loc: { start: { line: 1, column: 3503 }, end: { line: 1, column: 3572 } },
											})
										) +
										"<br><br/><span class='semi-strong no-translate'>" +
										l(u(null != (i = null != t ? c(t, 'sameDevice') : t) ? c(i, 'orgUrl') : i, t)) +
										'</span><a data-clipboard-text="' +
										l(u(null != (i = null != t ? c(t, 'sameDevice') : t) ? c(i, 'orgUrl') : i, t)) +
										'" class="button link-button copy-org-clipboard-button">' +
										l(
											(c(n, 'i18n') || (t && c(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.oda.org.copyLink' },
												data: o,
												loc: { start: { line: 1, column: 3748 }, end: { line: 1, column: 3802 } },
											})
										) +
										'</a></li><li>' +
										l(
											(c(n, 'i18n') || (t && c(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.okta_verify.setup.skipAuth.followInstruction' },
												data: o,
												loc: { start: { line: 1, column: 3815 }, end: { line: 1, column: 3901 } },
											})
										) +
										'</li></ol><p class="closing">' +
										l(
											(c(n, 'i18n') || (t && c(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.okta_verify.setup.skipAuth.canBeClosed' },
												data: o,
												loc: { start: { line: 1, column: 3930 }, end: { line: 1, column: 4010 } },
											})
										) +
										'</p>'
									);
								},
								32: function (e, t, n, r, o) {
									var i = null != t ? t : e.nullContext || {},
										a = e.hooks.helperMissing,
										s = e.escapeExpression,
										l =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p class="explanation" data-se="subheader">' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.okta_verify.setup.skipAuth.subtitle' },
												data: o,
												loc: { start: { line: 1, column: 4087 }, end: { line: 1, column: 4164 } },
											})
										) +
										'</p><ol class="deviceBootstrap-info ov-info"><li>' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: {
													$1: "<span class='semi-strong'>$1</span>",
													arguments: 'enrolledDeviceName',
													bundle: 'login',
													code: 'oie.enroll.okta_verify.setup.skipAuth.openOv.suchAs',
												},
												data: o,
												loc: { start: { line: 1, column: 4213 }, end: { line: 1, column: 4367 } },
											})
										) +
										'</li><li>' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.okta_verify.setup.skipAuth.selectAccount' },
												data: o,
												loc: { start: { line: 1, column: 4376 }, end: { line: 1, column: 4458 } },
											})
										) +
										'</li><li>' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: {
													$1: "<span class='semi-strong'>$1</span>",
													bundle: 'login',
													code: 'oie.enroll.okta_verify.setup.skipAuth.addAccount',
												},
												data: o,
												loc: { start: { line: 1, column: 4467 }, end: { line: 1, column: 4587 } },
											})
										) +
										'</li><li>' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.okta_verify.setup.skipAuth.followInstruction' },
												data: o,
												loc: { start: { line: 1, column: 4596 }, end: { line: 1, column: 4682 } },
											})
										) +
										'</li></ol><p class="closing">' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.okta_verify.setup.skipAuth.canBeClosed' },
												data: o,
												loc: { start: { line: 1, column: 4711 }, end: { line: 1, column: 4791 } },
											})
										) +
										'</p>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'href') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 460 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'email') : t, {
											name: 'if',
											hash: {},
											fn: e.program(3, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 460 }, end: { line: 1, column: 693 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'phoneNumber') : t, {
											name: 'if',
											hash: {},
											fn: e.program(5, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 693 }, end: { line: 1, column: 934 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != (i = null != t ? s(t, 'deviceMap') : t) ? s(i, 'setupOVUrl') : i, {
											name: 'if',
											hash: {},
											fn: e.program(7, o, 0),
											inverse: e.program(29, o, 0),
											data: o,
											loc: { start: { line: 1, column: 934 }, end: { line: 1, column: 4809 } },
										}))
											? i
											: '')
									);
								},
								useData: !0,
							}),
							getTemplateData: function () {
								var e,
									t = this.options.appState.get('currentAuthenticator').contextualData,
									n = '',
									r = h(this.options.appState),
									o = !1;
								if (t && null != t && t.devicebootstrap && null != t && t.devicebootstrap.enrolledDevices) {
									var i = null == t ? void 0 : t.devicebootstrap.enrolledDevices;
									n = Array.isArray(i) && !a._.isEmpty(i) ? i[0] : i;
								}
								r.securityLevel && 'ANY' === r.securityLevel && (o = !0);
								var s = this.options.settings.get('features.sameDeviceOVEnrollmentEnabled');
								return {
									href: null === (e = t.qrcode) || void 0 === e ? void 0 : e.href,
									email: a._.escape(null == t ? void 0 : t.email),
									phoneNumber: a._.escape(null == t ? void 0 : t.phoneNumber),
									sameDevice: null == t ? void 0 : t.samedevice,
									deviceBootstrap: null == t ? void 0 : t.devicebootstrap,
									enrolledDeviceName: n,
									deviceMap: r,
									showAnotherDeviceLink: o,
									sameDeviceOVEnrollmentEnabled: s,
								};
							},
							postRender: function () {
								var e = this,
									t = this.options && this.options.appState,
									n = this.model;
								this.$('.orOnMobileLink').click(function () {
									var e;
									if (t && n) {
										var r = 'qrcode',
											o = t.get('remediations').find(function (e) {
												return e.name === s.FORMS.SELECT_ENROLLMENT_CHANNEL;
											});
										if (o) {
											var i = a._.find(o.uiSchema, function (e) {
												return 'authenticator.id' === e.name;
											});
											if (i) {
												var l = a._.find(o.uiSchema, function (e) {
													return 'authenticator.channel' === e.name;
												});
												l &&
													((l.options = a._.filter(null == l ? void 0 : l.options, function (e) {
														return e.value === r;
													})),
													(l.value = (null === (e = l.options[0]) || void 0 === e ? void 0 : e.value) || r),
													(l.sublabel = null),
													n.set('authenticator.channel', l.value),
													n.set('authenticator.id', i.value),
													n.set('formName', o.name),
													t.trigger('saveForm', n));
											}
										}
									}
								}),
									f.attach('.copy-org-clipboard-button').done(function () {
										var t = new d({
											message: (0, a.loc)('enroll.oda.org.copyLink.success', 'login'),
											level: 'success',
										});
										return e.el.prepend(t.render().el), !1;
									});
							},
						});
					function h(e) {
						var t, n;
						if (!e) return null;
						var r = e.get('currentAuthenticator').contextualData,
							o = {};
						return (
							null !== (t = r.samedevice) && void 0 !== t && t.setupOVUrl
								? (o = c({}, r.samedevice))
								: null !== (n = r.devicebootstrap) && void 0 !== n && n.setupOVUrl && (o = c({}, r.devicebootstrap)),
							o.platform &&
								((o.platformLC = o.platform.toLowerCase()),
								(o.isDesktop = !('ios' === o.platformLC || 'android' === o.platformLC))),
							o
						);
					}
					(t.default = p), (e.exports = t.default);
				},
				41553: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = r(n(52574)),
						l = r(n(19654)),
						u = r(n(99519)),
						c = r(n(67436)),
						d = !0,
						f = i.BaseFormWithPolling.extend(
							Object.assign(
								{
									title: function () {
										var e;
										switch (this.options.appState.get('currentAuthenticator').contextualData.selectedChannel) {
											case 'email':
												e = (0, o.loc)('oie.enroll.okta_verify.setup.email.title', 'login');
												break;
											case 'sms':
												e = (0, o.loc)('oie.enroll.okta_verify.setup.sms.title', 'login');
												break;
											default:
												e = (0, o.loc)('oie.enroll.okta_verify.setup.title', 'login');
										}
										return e;
									},
									className: 'oie-enroll-ov-poll',
									noButtonBar: !0,
									initialize: function () {
										i.BaseFormWithPolling.prototype.initialize.apply(this, arguments),
											this.listenTo(this.model, 'error', this.stopPolling),
											d && this.startPolling();
									},
									showMessages: function () {
										var e = {};
										this.options.appState.containsMessageWithI18nKey(
											'oie.authenticator.app.non_fips_compliant_enrollment_device_incompatible'
										) ||
										this.options.appState.containsMessageWithI18nKey(
											'oie.authenticator.app.non_fips_compliant_enrollment_app_update_required'
										)
											? (e.title = (0, o.loc)('oie.okta_verify.enroll.force.upgrade.title', 'login'))
											: this.options.appState.containsMessageWithI18nKey(
													'oie.authenticator.app.method.push.enroll.enable.biometrics'
											  ) &&
											  (e.title = (0, o.loc)(
													'oie.authenticator.app.method.push.enroll.enable.biometrics.title',
													'login'
											  )),
											i.BaseFormWithPolling.prototype.showMessages.call(this, e);
									},
									getUISchema: function () {
										var e,
											t = [],
											n = this.options.appState.get('currentAuthenticator').contextualData.selectedChannel;
										return (
											'qrcode' === n
												? ((e = '.qrcode-container'), (d = !0))
												: ['email', 'sms'].includes(n)
												? ((e = '.switch-channel-content'), (d = !0))
												: ['samedevice'].includes(n)
												? (d = !0)
												: ['devicebootstrap'].includes(n) && (d = !1),
											t.push({ View: c.default }),
											t.push({ View: u.default, options: { selectedChannel: n }, selector: e }),
											['email', 'sms'].includes(n) && t.push({ View: l.default, selector: '.o-form-error-container' }),
											t
										);
									},
									remove: function () {
										i.BaseFormWithPolling.prototype.remove.apply(this, arguments), this.stopPolling();
									},
								},
								s.default
							)
						),
						p = a.default.extend({ Body: f });
					(t.default = p), (e.exports = t.default);
				},
				88930: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = r(n(73390)),
						l = r(n(99519)),
						u = i.BaseForm.extend({
							className: 'oie-enroll-ov-data',
							title: function () {
								return 'email' === this.options.appState.get('currentAuthenticator').contextualData.selectedChannel
									? (0, o.loc)('oie.enroll.okta_verify.enroll.channel.email.title', 'login')
									: (0, o.loc)('oie.enroll.okta_verify.enroll.channel.sms.title', 'login');
							},
							save: function () {
								return (0, o.loc)('oie.enroll.okta_verify.setupLink', 'login');
							},
							getUISchema: function () {
								var e = i.BaseForm.prototype.getUISchema.apply(this, arguments),
									t = o._.find(e, function (e) {
										return 'phoneNumber' === e.name;
									}),
									n = o._.findIndex(e, function (e) {
										return 'phoneNumber' === e.name;
									}),
									r = {
										'label-top': !0,
										'label': (0, o.loc)('mfa.country', 'login'),
										'type': 'select',
										'options': s.default.getCountries(),
										'name': 'country',
										'wide': !0,
									},
									a = {
										'label': (0, o.loc)('mfa.phoneNumber.placeholder', 'login'),
										'type': 'group',
										'modelType': 'string',
										'label-top': !0,
										'name': 'phoneCode',
										'input': [
											{
												type: 'label',
												label: '+'.concat(this.model.get('phoneCode')),
												className: 'country-code-label no-translate',
											},
											Object.assign({}, t),
										],
									};
								-1 !== n && e.splice(n, 1, r, a);
								var l = {
									View:
										'email' === this.options.appState.get('currentAuthenticator').contextualData.selectedChannel
											? (0, o.loc)('oie.enroll.okta_verify.enroll.channel.email.subtitle', 'login')
											: (0, o.loc)('oie.enroll.okta_verify.channel.sms.description.updated', 'login'),
									selector: '.o-form-fieldset-container',
								};
								return e.push(l), e;
							},
							handlePhoneCodeChange: function () {
								this.el.querySelector('.country-code-label').innerText = '+'.concat(this.model.get('phoneCode'));
							},
							initialize: function () {
								i.BaseForm.prototype.initialize.apply(this, arguments),
									'sms' === this.options.appState.get('currentAuthenticator').contextualData.selectedChannel &&
										this.listenTo(this.model, 'change:phoneCode', this.handlePhoneCodeChange.bind(this));
							},
						}),
						c = a.default.extend({
							Body: u,
							createModelClass: function () {
								var e = i.BaseView.prototype.createModelClass.apply(this, arguments);
								if ('sms' !== this.options.appState.get('currentAuthenticator').contextualData.selectedChannel)
									return e;
								var t = Object.assign(
										{ country: { value: this.settings.get('defaultCountryCode'), type: 'string' } },
										e.prototype.local
									),
									n = Object.assign(
										{
											phoneCode: {
												deps: ['country'],
												fn: function (e) {
													return s.default.getCallingCodeForCountry(e);
												},
											},
										},
										e.prototype.derived
									);
								return e.extend({
									local: t,
									derived: n,
									toJSON: function () {
										var e = o.Model.prototype.toJSON.call(this, arguments),
											t = this.get('phoneCode'),
											n = '+'.concat(t).concat(e.phoneNumber);
										return (e.phoneNumber = n), e;
									},
								});
							},
							postRender: function () {
								this.add(l.default, 'form');
							},
						});
					(t.default = c), (e.exports = t.default);
				},
				17042: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475).View.extend({
							className: 'number-challenge-section',
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s = e.hooks.helperMissing,
										l = e.escapeExpression,
										u =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p>' +
										l(
											(u(n, 'i18n') || (t && u(t, 'i18n')) || s).call(a, {
												name: 'i18n',
												hash: {
													$1: "<span class='strong'>$1</span>",
													arguments: 'correctAnswer',
													bundle: 'login',
													code: 'oie.numberchallenge.instruction',
												},
												data: o,
												loc: { start: { line: 1, column: 3 }, end: { line: 1, column: 127 } },
											})
										) +
										'</p><div class="phone no-translate"><div class="phone--body"><div class="phone--screen"><span class="phone--number" data-se="challenge-number">' +
										l(
											'function' ==
												typeof (i =
													null != (i = u(n, 'correctAnswer') || (null != t ? u(t, 'correctAnswer') : t)) ? i : s)
												? i.call(a, {
														name: 'correctAnswer',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 270 }, end: { line: 1, column: 287 } },
												  })
												: i
										) +
										'</span></div><div class="phone--home-button"></div></div></div>'
									);
								},
								useData: !0,
							}),
							getTemplateData: function () {
								var e, t;
								return {
									correctAnswer:
										null === (e = this.options.appState.get('currentAuthenticator')) ||
										void 0 === e ||
										null === (t = e.contextualData) ||
										void 0 === t
											? void 0
											: t.correctAnswer,
								};
							},
						});
					(t.default = i), (e.exports = t.default);
				},
				58474: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(52574)),
						s = r(n(32339)),
						l = r(n(17042)),
						u = i.BaseFormWithPolling.extend(
							Object.assign(
								{
									noButtonBar: !0,
									className: 'okta-verify-number-challenge',
									events: { 'click a.resend-number-challenge': 'handleResendNumberChallenge' },
									handleResendNumberChallenge: function () {
										this.options.appState.trigger('invokeAction', 'currentAuthenticator-resend'),
											this.options.appState.trigger('hideNumberChallengeWarning');
									},
									title: function () {
										return (0, o.loc)('oie.okta_verify.push.sent', 'login');
									},
									initialize: function () {
										i.BaseFormWithPolling.prototype.initialize.apply(this, arguments), this.add(l.default);
									},
									triggerAfterError: function () {
										i.BaseFormWithPolling.prototype.triggerAfterError.apply(this, arguments),
											this.stopPolling(),
											this.$el.find('.o-form-fieldset-container').empty();
									},
									postRender: function () {
										i.BaseFormWithPolling.prototype.postRender.apply(this, arguments), this.startPoll();
									},
									startPoll: function () {
										this.startPolling(), this.addWarning();
									},
									stopPoll: function () {
										this.stopPolling();
									},
									addWarning: function () {
										this.add(s.default, '.o-form-error-container'),
											this.options.appState.trigger('showNumberChallengeWarning');
									},
									remove: function () {
										i.BaseFormWithPolling.prototype.remove.apply(this, arguments), this.stopPolling();
									},
								},
								a.default
							)
						),
						c = u;
					(t.default = c), (e.exports = t.default);
				},
				19654: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(25590)).default.extend({
							className: 'hide resend-ov-link-view',
							events: { 'click a.resend-link': 'handelResendLink' },
							initialize: function () {
								var e = this.options.appState.get('currentAuthenticator').contextualData.selectedChannel;
								this.add(
									(0, i.createCallout)({
										content:
											'email' === e
												? o.default.template({
														compiler: [8, '>= 4.3.0'],
														main: function (e, t, n, r, o) {
															var i,
																a =
																	e.lookupProperty ||
																	function (e, t) {
																		if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																	};
															return null !=
																(i = (a(n, 'i18n') || (t && a(t, 'i18n')) || e.hooks.helperMissing).call(
																	null != t ? t : e.nullContext || {},
																	{
																		name: 'i18n',
																		hash: { bundle: 'login', code: 'oie.enroll.okta_verify.email.notReceived' },
																		data: o,
																		loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 73 } },
																	}
																))
																? i
																: '';
														},
														useData: !0,
												  })
												: o.default.template({
														compiler: [8, '>= 4.3.0'],
														main: function (e, t, n, r, o) {
															var i,
																a =
																	e.lookupProperty ||
																	function (e, t) {
																		if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
																	};
															return null !=
																(i = (a(n, 'i18n') || (t && a(t, 'i18n')) || e.hooks.helperMissing).call(
																	null != t ? t : e.nullContext || {},
																	{
																		name: 'i18n',
																		hash: { bundle: 'login', code: 'oie.enroll.okta_verify.sms.notReceived' },
																		data: o,
																		loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 71 } },
																	}
																))
																? i
																: '';
														},
														useData: !0,
												  }),
										type: 'warning',
									})
								);
							},
							handelResendLink: function (e) {
								null == e || e.preventDefault(),
									this.options.appState.trigger('invokeAction', 'currentAuthenticator-resend'),
									this.$el.addClass('hide'),
									this.showCalloutAfterTimeout();
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				32339: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = n(86725),
						s = i.View.extend({
							initialize: function () {
								var e = this;
								this.listenTo(this.options.appState, 'showNumberChallengeWarning', function () {
									e.startWarningTimeout();
								}),
									this.listenTo(this.options.appState, 'hideNumberChallengeWarning', function () {
										e.clearWarning();
									});
							},
							className: 'resend-number-challenge-warning hide',
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<div class="okta-form-infobox-warning infobox infobox-warning"><span class="icon warning-16"></span><p>' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: {
														$1: "<a href='#' class='resend-number-challenge'>$1</a>",
														bundle: 'login',
														code: 'oie.numberchallenge.warning',
													},
													data: o,
													loc: { start: { line: 1, column: 103 }, end: { line: 1, column: 217 } },
												}
											)
										) +
										'</p></div>'
									);
								},
								useData: !0,
							}),
							showWarning: function () {
								this.$el.removeClass('hide');
							},
							clearWarning: function () {
								this.$el.addClass('hide'), clearTimeout(this.warningTimeout), this.startWarningTimeout();
							},
							startWarningTimeout: function () {
								this.warningTimeout = setTimeout(
									i._.bind(function () {
										this.showWarning();
									}, this),
									a.WARNING_TIMEOUT
								);
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				50509: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = n(13955),
						s = i.View.extend({
							className: 'ov-same-device-enroll-text',
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return null !=
										(i = (a(n, 'i18n') || (t && a(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: {
													$1: "<a class='ov-same-device-enroll-link' href='#'>$1</a>",
													bundle: 'login',
													code: 'oie.enroll.okta_verify.select.channel.ovOnThisDevice',
												},
												data: o,
												loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 144 } },
											}
										))
										? i
										: '';
								},
								useData: !0,
							}),
							postRender: function () {
								var e = this.options && this.options.appState,
									t = this.model;
								this.$('.ov-same-device-enroll-link').click(function () {
									var n, r, o, i;
									if (e && t) {
										var s = 'samedevice',
											l = e.get('remediations').find(function (e) {
												return e.name === a.FORMS.SELECT_ENROLLMENT_CHANNEL;
											});
										if (l) {
											var u =
												null === (n = l.uiSchema) || void 0 === n
													? void 0
													: n.find(function (e) {
															return 'authenticator.id' === e.name;
													  });
											if (u) {
												var c =
													null === (r = l.uiSchema) || void 0 === r
														? void 0
														: r.find(function (e) {
																return 'authenticator.channel' === e.name;
														  });
												c &&
													((c.options =
														null === (o = c.options) || void 0 === o
															? void 0
															: o.filter(function (e) {
																	return e.value === s;
															  })),
													(c.value = (null === (i = c.options[0]) || void 0 === i ? void 0 : i.value) || s),
													(c.sublabel = null),
													t.set('authenticator.channel', c.value),
													t.set('authenticator.id', u.value),
													t.set('formName', l.name),
													e.trigger('saveForm', t));
											}
										}
									}
								});
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				98355: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(31752)),
						i = n(6475),
						a = n(17587),
						s = r(n(83966)),
						l = r(n(34425)),
						u = r(n(50509)),
						c = a.BaseForm.extend({
							title: function () {
								return l.default.isAndroid() || l.default.isIOS()
									? (0, i.loc)('oie.enroll.okta_verify.setup.title', 'login')
									: (0, i.loc)('oie.enroll.okta_verify.select.channel.title.updated', 'login');
							},
							getUISchema: function () {
								var e,
									t = this,
									n = a.BaseForm.prototype.getUISchema.apply(this, arguments),
									r = i._.find(n, function (e) {
										return 'authenticator.channel' === e.name;
									});
								(r.options = i._.filter(null == r ? void 0 : r.options, function (e) {
									var n, r;
									return (
										e.value !==
											(null === (n = t.options.appState.get('currentAuthenticator')) ||
											void 0 === n ||
											null === (r = n.contextualData) ||
											void 0 === r
												? void 0
												: r.selectedChannel) && 'samedevice' !== e.value
									);
								})),
									(r.value = null === (e = r.options[0]) || void 0 === e ? void 0 : e.value),
									(r.sublabel = null),
									this.model.set('authenticator.channel', r.value);
								var s = {
									View: (0, i.loc)('oie.enroll.okta_verify.select.channel.subtitle', 'login'),
									selector: '.o-form-fieldset-container',
								};
								return [s].concat((0, o.default)(n));
							},
						}),
						d = s.default.extend({
							Body: c,
							postRender: function () {
								var e,
									t,
									n =
										null === (e = this.options.currentViewState.value) || void 0 === e
											? void 0
											: e.find(function (e) {
													return 'authenticator' === e.name;
											  }).value.form.value;
								(null == n ||
								null ===
									(t = n.find(function (e) {
										return 'channel' === e.name;
									}).options) ||
								void 0 === t
									? void 0
									: t.find(function (e) {
											return 'samedevice' === e.value;
									  })) &&
									this.add(
										new u.default({ model: this.model, settings: this.settings, appState: this.options.appState }),
										'form'
									);
							},
						});
					(t.default = d), (e.exports = t.default);
				},
				99519: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = n(13955),
						s = i.View.extend({
							className: 'switch-channel-text',
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return null !=
										(i = a(n, 'if').call(
											null != t ? t : e.nullContext || {},
											null != t ? a(t, 'sameDeviceOVEnrollmentEnabled') : t,
											{
												name: 'if',
												hash: {},
												fn: e.program(2, o, 0),
												inverse: e.program(4, o, 0),
												data: o,
												loc: { start: { line: 1, column: 23 }, end: { line: 1, column: 325 } },
											}
										))
										? i
										: '';
								},
								2: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return null !=
										(i = (a(n, 'i18n') || (t && a(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.okta_verify.switch.channel.link.text' },
												data: o,
												loc: { start: { line: 1, column: 60 }, end: { line: 1, column: 140 } },
											}
										))
										? i
										: '';
								},
								4: function (e, t, n, r, o) {
									var i = null != t ? t : e.nullContext || {},
										a = e.hooks.helperMissing,
										s = e.escapeExpression,
										l =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<a href="#" class="switch-channel-link" aria-label="' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.totp.aria.cannotScan' },
												data: o,
												loc: { start: { line: 1, column: 200 }, end: { line: 1, column: 259 } },
											})
										) +
										'">' +
										s(
											(l(n, 'i18n') || (t && l(t, 'i18n')) || a).call(i, {
												name: 'i18n',
												hash: { bundle: 'login', code: 'enroll.totp.cannotScan' },
												data: o,
												loc: { start: { line: 1, column: 261 }, end: { line: 1, column: 314 } },
											})
										) +
										'</a>'
									);
								},
								6: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return null !=
										(i = a(n, 'if').call(
											null != t ? t : e.nullContext || {},
											null != t ? a(t, 'isSameDeviceChannel') : t,
											{
												name: 'if',
												hash: {},
												fn: e.program(7, o, 0),
												inverse: e.program(9, o, 0),
												data: o,
												loc: { start: { line: 1, column: 325 }, end: { line: 1, column: 480 } },
											}
										))
										? i
										: '';
								},
								7: function (e, t, n, r, o) {
									return '';
								},
								9: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return null !=
										(i = a(n, 'if').call(
											null != t ? t : e.nullContext || {},
											null != t ? a(t, 'isDeviceBootstrapChannel') : t,
											{
												name: 'if',
												hash: {},
												fn: e.program(7, o, 0),
												inverse: e.program(2, o, 0),
												data: o,
												loc: { start: { line: 1, column: 356 }, end: { line: 1, column: 480 } },
											}
										))
										? i
										: '';
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return null !=
										(i = a(n, 'if').call(null != t ? t : e.nullContext || {}, null != t ? a(t, 'isQRcodeChannel') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.program(6, o, 0),
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 487 } },
										}))
										? i
										: '';
								},
								useData: !0,
							}),
							getTemplateData: function () {
								var e = this.options.appState.get('currentAuthenticator').contextualData.selectedChannel;
								return {
									sameDeviceOVEnrollmentEnabled: this.settings.get('features.sameDeviceOVEnrollmentEnabled'),
									isQRcodeChannel: 'qrcode' === e,
									isSameDeviceChannel: 'samedevice' === e,
									isDeviceBootstrapChannel: 'devicebootstrap' === e,
								};
							},
							postRender: function () {
								var e = this;
								this.$el.find('.switch-channel-link').on('click', function (t) {
									var n = e.options.appState;
									t.preventDefault(), n.trigger('switchForm', a.FORMS.SELECT_ENROLLMENT_CHANNEL);
								});
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				26097: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(93831)),
						s = r(n(83966)),
						l = n(71101),
						u = n(43318),
						c = i.BaseForm.extend({
							title: function () {
								return (0, o.loc)('oie.password.challenge.title', 'login');
							},
							save: function () {
								return (0, o.loc)('mfa.challenge.verify', 'login');
							},
							getUISchema: function () {
								var e = i.BaseForm.prototype.getUISchema.apply(this, arguments),
									t = this.options.settings,
									n = 'primaryauth.password.tooltip',
									r = e.find(function (e) {
										return 'credentials.passcode' === e.name;
									});
								return (
									r &&
										(0, u.isCustomizedI18nKey)(n, t) &&
										((r.explain = (0, o.loc)(n, 'login')), (r['explain-top'] = !0)),
									e
								);
							},
						}),
						d = a.default.extend({
							links: function () {
								var e = a.default.prototype.links.apply(this, arguments);
								return (e = (0, l.getForgotPasswordLink)(this.options.appState, this.options.settings).concat(e)), e;
							},
						}),
						f = s.default.extend({ Body: c, Footer: d });
					(t.default = f), (e.exports = t.default);
				},
				75582: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = n(25795),
						l = n(81554);
					function u(e, t) {
						var n = ('undefined' != typeof Symbol && e[Symbol.iterator]) || e['@@iterator'];
						if (!n) {
							if (
								Array.isArray(e) ||
								(n = (function (e, t) {
									if (!e) return;
									if ('string' == typeof e) return c(e, t);
									var n = Object.prototype.toString.call(e).slice(8, -1);
									'Object' === n && e.constructor && (n = e.constructor.name);
									if ('Map' === n || 'Set' === n) return Array.from(e);
									if ('Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return c(e, t);
								})(e)) ||
								(t && e && 'number' == typeof e.length)
							) {
								n && (e = n);
								var r = 0,
									o = function () {};
								return {
									s: o,
									n: function () {
										return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
									},
									e: function (e) {
										throw e;
									},
									f: o,
								};
							}
							throw new TypeError(
								'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
							);
						}
						var i,
							a = !0,
							s = !1;
						return {
							s: function () {
								n = n.call(e);
							},
							n: function () {
								var e = n.next();
								return (a = e.done), e;
							},
							e: function (e) {
								(s = !0), (i = e);
							},
							f: function () {
								try {
									a || null == n.return || n.return();
								} finally {
									if (s) throw i;
								}
							},
						};
					}
					function c(e, t) {
						(null == t || t > e.length) && (t = e.length);
						for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
						return r;
					}
					var d = i.BaseForm.extend({
							title: function () {
								return (0, o.loc)('oie.password.enroll.title', 'login');
							},
							save: function () {
								return (0, o.loc)('oform.next', 'login');
							},
							initialize: function () {
								i.BaseForm.prototype.initialize.apply(this, arguments);
								var e = this.getPasswordPolicySettings();
								this.displayPasswordPolicy(e);
							},
							displayPasswordPolicy: function (e) {
								if (e) {
									var t = (0, s.getPasswordComplexityDescriptionForHtmlList)(e);
									(0, l.generatePasswordPolicyHtml)(this, t, !0);
								}
							},
							triggerAfterError: function (e, t) {
								(t.responseJSON = (0, s.removeRequirementsFromError)(t.responseJSON)),
									this.options.appState.trigger('afterError', t);
							},
							getPasswordPolicySettings: function () {
								var e,
									t = this.options.currentViewState.relatesTo;
								return null == t || null === (e = t.value) || void 0 === e ? void 0 : e.settings;
							},
							getUISchema: function () {
								var e,
									t = i.BaseForm.prototype.getUISchema.apply(this, arguments),
									n = {
										'name': 'confirmPassword',
										'label': (0, o.loc)('oie.password.confirmPasswordLabel', 'login'),
										'type': 'password',
										'label-top': !0,
										'params': { showPasswordToggle: this.settings.get('showPasswordToggle') },
									},
									r = [],
									a = u(t);
								try {
									for (a.s(); !(e = a.n()).done; ) {
										var s = e.value;
										r.push(s), 'credentials.passcode' === s.name && r.push(n);
									}
								} catch (e) {
									a.e(e);
								} finally {
									a.f();
								}
								return r;
							},
						}),
						f = a.default.extend({
							Body: d,
							createModelClass: function () {
								var e = i.BaseView.prototype.createModelClass.apply(this, arguments),
									t = Object.assign({ confirmPassword: { type: 'string', required: !0 } }, e.prototype.local);
								return e.extend({
									local: t,
									validate: function () {
										return this.get('credentials.passcode') !== this.get('confirmPassword') &&
											this.get('credential.value') !== this.get('confirmPassword')
											? { confirmPassword: (0, o.loc)('password.error.match', 'login') }
											: null;
									},
								});
							},
						});
					(t.default = f), (e.exports = t.default);
				},
				81554: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.generatePasswordPolicyHtml = void 0);
					var o = r(n(2875)),
						i = n(6475);
					t.generatePasswordPolicyHtml = function (e, t, n) {
						e.add(
							i.View.extend({
								tagName: 'section',
								template: o.default.template({
									1: function (e, t, n, r, o) {
										return '<li>' + e.escapeExpression(e.lambda(t, t)) + '</li>';
									},
									compiler: [8, '>= 4.3.0'],
									main: function (e, t, n, r, o) {
										var i,
											a = null != t ? t : e.nullContext || {},
											s =
												e.lookupProperty ||
												function (e, t) {
													if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
												};
										return (
											'<div class="password-authenticator--heading">' +
											e.escapeExpression(
												(s(n, 'i18n') || (t && s(t, 'i18n')) || e.hooks.helperMissing).call(a, {
													name: 'i18n',
													hash: { bundle: 'login', code: 'password.complexity.requirements.header' },
													data: o,
													loc: { start: { line: 1, column: 45 }, end: { line: 1, column: 115 } },
												})
											) +
											'</div><ul class="password-authenticator--list">' +
											(null !=
											(i = s(n, 'each').call(a, null != t ? s(t, 'rulesList') : t, {
												name: 'each',
												hash: {},
												fn: e.program(1, o, 0),
												inverse: e.noop,
												data: o,
												loc: { start: { line: 1, column: 162 }, end: { line: 1, column: 207 } },
											}))
												? i
												: '') +
											'</ul>'
										);
									},
									useData: !0,
								}),
								getTemplateData: function () {
									return { rulesList: t };
								},
								attributes: { 'data-se': 'password-authenticator--rules' },
							}),
							{ prepend: n, selector: '.o-form-fieldset-container' }
						);
					};
				},
				62665: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(75582)),
						a = i.default.prototype.Body.extend({
							className: 'password-authenticator',
							title: function () {
								var e = this.options.settings.get('brandName')
									? (0, o.loc)('password.expired.title.specific', 'login', [this.options.settings.get('brandName')])
									: (0, o.loc)('password.expired.title.generic', 'login');
								return e;
							},
							save: function () {
								return (0, o.loc)('password.expired.submit', 'login');
							},
							getPasswordPolicySettings: function () {
								var e, t;
								return (
									(null === (e = this.options.appState.get('recoveryAuthenticator')) || void 0 === e
										? void 0
										: e.settings) ||
									(null === (t = this.options.appState.get('enrollmentAuthenticator')) || void 0 === t
										? void 0
										: t.settings)
								);
							},
						}),
						s = i.default.extend({ Body: a });
					(t.default = s), (e.exports = t.default);
				},
				40973: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(75582)),
						s = a.default.prototype.Body.extend({
							className: 'password-authenticator',
							subtitle: function () {
								if (this.options.settings.get('brandName'))
									return (0, o.loc)('password.expiring.subtitle.specific', 'login', [
										this.options.settings.get('brandName'),
									]);
							},
							title: function () {
								var e = (this.getPasswordPolicySettings() || {}).daysToExpiry;
								return e > 0
									? (0, o.loc)('password.expiring.title', 'login', [e])
									: 0 === e
									? (0, o.loc)('password.expiring.today', 'login')
									: (0, o.loc)('password.expiring.soon', 'login');
							},
							save: function () {
								return (0, o.loc)('password.expired.submit', 'login');
							},
							showMessages: function () {
								if (this.options.settings.get('brandName')) return null;
								a.default.prototype.Body.prototype.showMessages.apply(this, arguments);
							},
						}),
						l = i.BaseFooter.extend({
							links: function () {
								var e = [];
								return (
									this.options.appState.hasRemediationObject('skip') &&
										e.push({
											type: 'link',
											label: (0, o.loc)('password.expiring.later', 'login'),
											name: 'skip',
											actionPath: 'skip',
										}),
									e
								);
							},
						}),
						u = a.default.extend({ Body: s, Footer: l });
					(t.default = u), (e.exports = t.default);
				},
				13591: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(75582)),
						a = i.default.prototype.Body.extend({
							className: 'password-authenticator',
							title: function () {
								var e = this.options.settings.get('brandName')
									? (0, o.loc)('password.reset.title.specific', 'login', [this.options.settings.get('brandName')])
									: (0, o.loc)('password.reset.title.generic', 'login');
								return e;
							},
							save: function () {
								return (0, o.loc)('password.reset', 'login');
							},
						}),
						s = i.default.extend({ Body: a });
					(t.default = s), (e.exports = t.default);
				},
				65425: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = i.BaseForm.extend({
							className: 'phone-authenticator-challenge',
							events: { 'click a.phone-authenticator-challenge__link': 'handleSecondaryLinkClick' },
							title: function () {
								return (0, o.loc)('oie.phone.verify.title', 'login');
							},
							save: function () {
								return 'sms' === this.model.get('primaryMode')
									? (0, o.loc)('oie.phone.sms.primaryButton', 'login')
									: (0, o.loc)('oie.phone.call.primaryButton', 'login');
							},
							handleSecondaryLinkClick: function (e) {
								e.preventDefault();
								var t = this.model.get('secondaryMode');
								this.model.set('authenticator.methodType', t), this.saveForm(this.model);
							},
							initialize: function () {
								var e = this;
								this.model.on('error', function () {
									return e.model.set('authenticator.methodType', e.model.get('primaryMode'));
								}),
									i.BaseForm.prototype.initialize.apply(this, arguments);
								var t =
										'sms' === this.model.get('primaryMode')
											? (0, o.loc)('oie.phone.verify.sms.sendText', 'login')
											: (0, o.loc)('oie.phone.verify.call.sendText', 'login'),
									n = (0, o.loc)('oie.phone.carrier.charges', 'login'),
									r = this.model.get('phoneNumber') !== (0, o.loc)('oie.phone.alternate.title', 'login'),
									a = r ? 'strong no-translate nowrap' : '',
									s = r ? this.model.get('nickname') : '',
									l = s ? ' ('.concat(s, ')') : '',
									u = l ? 'no-translate authenticator-verify-nickname' : '',
									c = l
										? '<span class="'.concat(u || '', '">').concat(l, '.</span>')
										: '<span class="no-translate">.</span>',
									d =
										''.concat(t, ' ') +
										'<span '
											.concat(a ? ' class="'.concat(a, '"') : '', '>')
											.concat(this.model.escape('phoneNumber'), '</span>') +
										''.concat(c);
								this.add(
									'<div class="okta-form-subtitle" data-se="o-form-explain">' +
										''.concat(d) +
										'<p>'.concat(n, '</p>') +
										'</div>'
								);
							},
							getUISchema: function () {
								var e = i.BaseForm.prototype.getUISchema.apply(this, arguments);
								return e.filter(function (e) {
									return 'authenticator.methodType' !== e.name;
								});
							},
							render: function () {
								i.BaseForm.prototype.render.apply(this, arguments);
								var e = this.model.get('secondaryMode');
								if (e) {
									var t =
										'sms' === e
											? (0, o.loc)('oie.phone.sms.secondaryButton', 'login')
											: (0, o.loc)('oie.phone.call.secondaryButton', 'login');
									this.add(
										'<a href="#"\n            class="link phone-authenticator-challenge__link"\n            data-se="phone-authenticator-challenge__link">'.concat(
											t,
											'</a>'
										),
										'.o-form-button-bar'
									);
								}
							},
						}),
						l = a.default.extend({
							Body: s,
							createModelClass: function (e) {
								var t = e.uiSchema,
									n = o._.find(t, function (e) {
										return 'authenticator.methodType' === e.name;
									}),
									r = n.options,
									a = this.options.currentViewState.relatesTo,
									s = (null == a ? void 0 : a.value) || {},
									l = s.profile,
									u = s.nickname,
									c = i.BaseView.prototype.createModelClass.apply(this, arguments),
									d = Object.assign(
										{
											primaryMode: { value: r[0].value, type: 'string' },
											secondaryMode: { value: r[1] && r[1].value, type: 'string' },
											phoneNumber: {
												value:
													null != l && l.phoneNumber ? l.phoneNumber : (0, o.loc)('oie.phone.alternate.title', 'login'),
												type: 'string',
											},
											nickname: { value: u || '', type: 'string' },
										},
										c.prototype.local
									);
								return c.extend({ local: d });
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				94257: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = t.ResendView = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = r(n(25590)).default.extend({
							className: 'phone-authenticator-challenge__resend-warning hide',
							events: { 'click a.resend-link': 'handleResendLink' },
							modelEvents: { error: 'handleError' },
							resendActionKey: 'currentAuthenticatorEnrollment-resend',
							initialize: function () {
								var e =
										'sms' === this.model.get('mode')
											? (0, o.loc)('oie.phone.verify.sms.resendText', 'login')
											: (0, o.loc)('oie.phone.verify.call.resendText', 'login'),
									t =
										'sms' === this.model.get('mode')
											? (0, o.loc)('oie.phone.verify.sms.resendLinkText', 'login')
											: (0, o.loc)('oie.phone.verify.call.resendLinkText', 'login');
								this.add(
									(0, o.createCallout)({
										content: ''.concat(e, "&nbsp;<a class='resend-link'>").concat(t, '</a>'),
										type: 'warning',
									})
								);
							},
							hideResendViewAndShowAfterTimeout: function () {
								this.el.classList.contains('hide') || this.el.classList.add('hide'), this.showCalloutAfterTimeout();
							},
							handleResendLink: function (e) {
								null == e || e.preventDefault(),
									this.options.appState.trigger('invokeAction', this.resendActionKey),
									this.hideResendViewAndShowAfterTimeout();
							},
							handleError: function () {
								this.hideResendViewAndShowAfterTimeout();
							},
						});
					t.ResendView = s;
					var l = i.BaseForm.extend(
							Object.assign({
								className: 'phone-authenticator-challenge',
								title: function () {
									return (0, o.loc)('oie.phone.verify.title', 'login');
								},
								save: function () {
									return (0, o.loc)('mfa.challenge.verify', 'login');
								},
								initialize: function () {
									i.BaseForm.prototype.initialize.apply(this, arguments);
									var e =
											'sms' === this.model.get('mode')
												? (0, o.loc)('oie.phone.verify.sms.codeSentText', 'login')
												: (0, o.loc)('mfa.calling', 'login'),
										t = (0, o.loc)('oie.phone.verify.enterCodeText', 'login'),
										n = (0, o.loc)('oie.phone.carrier.charges', 'login'),
										r = this.model.get('phoneNumber') !== (0, o.loc)('oie.phone.alternate.title', 'login'),
										a = r ? 'strong no-translate nowrap' : '',
										s = r ? this.model.get('nickname') : '',
										l = s ? ' ('.concat(s, ')') : '',
										u = l ? 'no-translate authenticator-verify-nickname' : '',
										c = l
											? '<span class="'.concat(u || '', '"}>').concat(l, '.</span>')
											: '<span class="no-translate">.</span>';
									this.add(
										'<div class="okta-form-subtitle" data-se="o-form-explain">' +
											''.concat(e, ' ') +
											'<span class="'.concat(a, '">').concat(this.model.escape('phoneNumber'), '</span>') +
											''.concat(c) +
											'&nbsp;'.concat(t) +
											'<p>'.concat(n, '</p>') +
											'</div>',
										{ prepend: !0, selector: '.o-form-fieldset-container' }
									);
								},
								postRender: function () {
									i.BaseForm.prototype.postRender.apply(this, arguments),
										this.add(s, { selector: '.o-form-info-container', prepend: !0 });
								},
							})
						),
						u = a.default.extend({
							Body: l,
							createModelClass: function () {
								var e = this.options.currentViewState.relatesTo,
									t = (null == e ? void 0 : e.value) || {},
									n = t.methods,
									r = t.profile,
									a = t.nickname,
									s = i.BaseView.prototype.createModelClass.apply(this, arguments),
									l = Object.assign(
										{
											mode: { value: n[0].type, type: 'string' },
											phoneNumber: {
												value:
													null != r && r.phoneNumber ? r.phoneNumber : (0, o.loc)('oie.phone.alternate.title', 'login'),
												type: 'string',
											},
											nickname: { value: a || '', type: 'string' },
										},
										s.prototype.local
									);
								return s.extend({ local: l });
							},
						});
					t.default = u;
				},
				86598: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = r(n(73390)),
						l = i.BaseForm.extend({
							className: 'phone-authenticator-enroll',
							title: function () {
								return (0, o.loc)('oie.phone.enroll.title', 'login');
							},
							subtitle: function () {
								return 'voice' === this.model.get('authenticator.methodType')
									? (0, o.loc)('oie.phone.enroll.call.subtitle', 'login')
									: (0, o.loc)('oie.phone.enroll.sms.subtitle', 'login');
							},
							render: function () {
								i.BaseForm.prototype.render.apply(this, arguments),
									(this.el.querySelector('.phone-authenticator-enroll__phone-code').innerText = '+'.concat(
										this.model.get('phoneCode')
									));
							},
							handlePhoneCodeChange: function () {
								this.el.querySelector('.phone-authenticator-enroll__phone-code').innerText = '+'.concat(
									this.model.get('phoneCode')
								);
							},
							save: function () {
								return 'voice' === this.model.get('authenticator.methodType')
									? (0, o.loc)('oie.phone.call.primaryButton', 'login')
									: (0, o.loc)('oie.phone.sms.primaryButton', 'login');
							},
							getUISchema: function () {
								var e = i.BaseForm.prototype.getUISchema.apply(this, arguments),
									t = o._.findIndex(e, function (e) {
										return 'authenticator.phoneNumber' === e.name;
									}),
									n = {
										'label-top': !0,
										'label': (0, o.loc)('mfa.country', 'login'),
										'type': 'select',
										'options': s.default.getCountries(),
										'name': 'country',
										'wide': !0,
									},
									r = 'okta-phone-number-input',
									a = {
										'label': (0, o.loc)('mfa.phoneNumber.placeholder', 'login'),
										'inputId': r,
										'type': 'group',
										'modelType': 'string',
										'label-top': !0,
										'name': 'phoneCode',
										'className': 'phone-authenticator-enroll__phone',
										'input': [
											{
												type: 'label',
												label: '+'.concat(this.model.get('phoneCode')),
												className: 'phone-authenticator-enroll__phone-code no-translate',
											},
											Object.assign({ inputId: r }, e[t]),
										],
									},
									l = {
										'label': (0, o.loc)('phone.extention.label', 'login'),
										'type': 'text',
										'className': 'phone-authenticator-enroll__phone-ext',
										'label-top': !0,
										'name': 'extension',
										'showWhen': { 'authenticator.methodType': 'voice' },
									};
								-1 !== t && (e.splice(t, 1, a), e.splice(t, 0, n), e.splice(t + 2, 0, l));
								var u = o._.find(e, function (e) {
									return 'authenticator.methodType' === e.name;
								});
								return u && 1 === u.options.length && (u.className = 'hide'), e;
							},
							updateConditionalText: function () {
								(this.el.querySelector('.okta-form-subtitle').innerText = this.subtitle()),
									(this.el.querySelector('input[type="submit"]').value = this.save());
							},
							initialize: function () {
								i.BaseForm.prototype.initialize.apply(this, arguments),
									this.listenTo(this.model, 'change:authenticator.methodType', this.updateConditionalText),
									this.listenTo(this.model, 'change:phoneCode', this.handlePhoneCodeChange.bind(this));
							},
						}),
						u = a.default.extend({
							Body: l,
							createModelClass: function () {
								var e = i.BaseView.prototype.createModelClass.apply(this, arguments),
									t = Object.assign(
										{
											country: { value: this.settings.get('defaultCountryCode'), type: 'string' },
											extension: { type: 'string' },
										},
										e.prototype.local
									),
									n = Object.assign(
										{
											phoneCode: {
												deps: ['country'],
												fn: function (e) {
													return s.default.getCallingCodeForCountry(e);
												},
											},
										},
										e.prototype.derived
									);
								return e.extend({
									local: t,
									derived: n,
									toJSON: function () {
										var e = o.Model.prototype.toJSON.call(this, arguments),
											t = this.get('extension'),
											n = this.get('phoneCode'),
											r = '+'.concat(n).concat(e.authenticator.phoneNumber);
										return (
											'voice' === e.authenticator.methodType &&
												null != t &&
												t.trim().length &&
												(r = ''.concat(r, 'x').concat(t)),
											(e.authenticator.phoneNumber = r),
											e
										);
									},
								});
							},
						});
					(t.default = u), (e.exports = t.default);
				},
				15918: function (e, t, n) {
					'use strict';
					var r = n(12990);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = (function (e, t) {
							if (!t && e && e.__esModule) return e;
							if (null === e || ('object' !== r(e) && 'function' != typeof e)) return { default: e };
							var n = s(t);
							if (n && n.has(e)) return n.get(e);
							var o = {},
								i = Object.defineProperty && Object.getOwnPropertyDescriptor;
							for (var a in e)
								if ('default' !== a && Object.prototype.hasOwnProperty.call(e, a)) {
									var l = i ? Object.getOwnPropertyDescriptor(e, a) : null;
									l && (l.get || l.set) ? Object.defineProperty(o, a, l) : (o[a] = e[a]);
								}
							(o.default = e), n && n.set(e, o);
							return o;
						})(n(94257)),
						a = n(17587);
					function s(e) {
						if ('function' != typeof WeakMap) return null;
						var t = new WeakMap(),
							n = new WeakMap();
						return (s = function (e) {
							return e ? n : t;
						})(e);
					}
					var l = i.ResendView.extend({
							className: 'phone-authenticator-enroll--warning hide',
							resendActionKey: 'currentAuthenticator-resend',
						}),
						u = i.default.prototype.Body.extend({
							className: 'phone-authenticator-enroll',
							title: function () {
								return (0, o.loc)('oie.phone.enroll.title', 'login');
							},
							postRender: function () {
								a.BaseForm.prototype.postRender.apply(this, arguments),
									this.add(l, { selector: '.o-form-info-container', prepend: !0 });
							},
						}),
						c = i.default.extend({ Body: u });
					(t.default = c), (e.exports = t.default);
				},
				21606: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = r(n(39797)),
						l = i.BaseForm.extend({
							className: 'piv-cac-card',
							modelEvents: { request: 'startAuthentication', error: 'stopAuthentication' },
							initialize: function () {
								i.BaseForm.prototype.initialize.apply(this, arguments),
									this.model.set('useRedirect', !0),
									this.addInstructions();
							},
							title: function () {
								return (0, o.loc)('piv.cac.title', 'login');
							},
							save: function () {
								return (0, o.loc)('retry', 'login');
							},
							addInstructions: function () {
								this.add(
									"<div class='piv-verify-text'>\n        <p>".concat(
										(0, o.loc)('piv.cac.card.insert', 'login'),
										"</p>\n        <div data-se='piv-waiting' class='okta-waiting-spinner'></div>\n      </div>"
									)
								);
							},
							startAuthentication: function () {
								this.$('.okta-waiting-spinner').show(), this.$('.o-form-button-bar').hide();
							},
							stopAuthentication: function () {
								this.$('.okta-waiting-spinner').hide(), this.$('.o-form-button-bar').show();
							},
						}),
						u = a.default.extend({
							Header: s.default,
							Body: l,
							postRender: function () {
								a.default.prototype.postRender.apply(this, arguments);
								var e = this.options.appState.get('messages') || {};
								Array.isArray(e.value)
									? this.form.stopAuthentication()
									: (this.form.startAuthentication(), this.form.trigger('save', this.model));
							},
						});
					(t.default = u), (e.exports = t.default);
				},
				39797: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(17587),
						i = r(n(99422)),
						a = o.BaseHeader.extend({
							HeaderBeacon: i.default.extend({
								getBeaconClassName: function () {
									return 'smartcard';
								},
							}),
						});
					(t.default = a), (e.exports = t.default);
				},
				9699: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = i.BaseForm.extend({
							title: function () {
								return (0, o.loc)('oie.security.question.challenge.title', 'login');
							},
							save: function () {
								return (0, o.loc)('mfa.challenge.verify', 'login');
							},
							getUISchema: function () {
								var e = i.BaseForm.prototype.getUISchema.apply(this, arguments),
									t = e.filter(function (e) {
										return e.name.indexOf('questionKey') >= 0;
									}),
									n = e.filter(function (e) {
										return e.name.indexOf('answer') >= 0;
									});
								return 1 === t.length && 1 === n.length && (n[0].label = t[0].label), e;
							},
						}),
						l = a.default.extend({ Body: s });
					(t.default = l), (e.exports = t.default);
				},
				14425: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = i.BaseForm.extend({
							title: function () {
								return (0, o.loc)('oie.security.question.enroll.title', 'login');
							},
							save: function () {
								return (0, o.loc)('mfa.challenge.verify', 'login');
							},
						}),
						l = a.default.extend({ Body: s });
					(t.default = l), (e.exports = t.default);
				},
				25590: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(86725),
						a = r(n(69977)),
						s = o.View.extend({
							postRender: function () {
								this.showCalloutAfterTimeout();
							},
							showCalloutAfterTimeout: function () {
								var e = this;
								a.default.getResendTimestamp() || a.default.setResendTimestamp(Date.now()),
									(this.showMeInterval = setInterval(function () {
										var t = a.default.getResendTimestamp();
										Date.now() - t >= i.SHOW_RESEND_TIMEOUT &&
											(e.$el.removeClass('hide'), clearInterval(e.showMeInterval), a.default.removeResendTimestamp());
									}, 250));
							},
							remove: function () {
								var e, t;
								o.View.prototype.remove.apply(this, arguments), clearInterval(this.showMeInterval);
								var n = this.options.appState.get('currentFormName'),
									r =
										(null === (e = this.options.appState.get('currentAuthenticator')) || void 0 === e
											? void 0
											: e.resend) ||
										(null === (t = this.options.appState.get('currentAuthenticatorEnrollment')) || void 0 === t
											? void 0
											: t.resend),
									i = this.options.model.get('formName') !== n;
								!a.default.getResendTimestamp() || (r && !i) || a.default.removeResendTimestamp();
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				14709: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(17587),
						i = r(n(83966)),
						a = r(n(70845)),
						s = r(n(59583)),
						l = i.default.extend({
							initialize: function () {
								i.default.prototype.initialize.apply(this, arguments),
									this.isPushOnlyWithAutoChallengeFlow()
										? (this.Body = a.default)
										: ((this.Body = s.default), (this.Footer = o.BaseFooter));
							},
							isPushOnlyWithAutoChallengeFlow: function () {
								var e = this.options.appState.getSchemaByName('authenticator.methodType'),
									t = this.options.appState.getSchemaByName('authenticator.autoChallenge'),
									n = null == e ? void 0 : e.options;
								return t && 1 === n.length && 'push' === n[0].value;
							},
						});
					(t.default = l), (e.exports = t.default);
				},
				59583: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(40647)),
						s = n(25795),
						l = n(21748),
						u = n(13955),
						c = l.Body.extend({
							getUISchema: function () {
								var e = this,
									t = i.BaseForm.prototype.getUISchema.apply(this, arguments),
									n = t.find(function (e) {
										return 'authenticator.methodType' === e.name;
									});
								this._sortMethodOptionsIfDeviceKnown(n.options);
								var r = n.options.map(function (t) {
									return Object.assign(
										{},
										t,
										(0, s.getAuthenticatorDataForVerification)({
											authenticatorKey: e.isOV() ? u.AUTHENTICATOR_KEY.OV : u.AUTHENTICATOR_KEY.CUSTOM_APP,
											value: { methodType: t.value },
										})
									);
								});
								return [{ View: a.default, options: { name: n.name, collection: new o.Collection(r) } }];
							},
							_sortMethodOptionsIfDeviceKnown: function (e) {
								var t, n, r, o;
								if (
									null === (t = this.options) ||
									void 0 === t ||
									null === (n = t.currentViewState) ||
									void 0 === n ||
									null === (r = n.relatesTo) ||
									void 0 === r ||
									null === (o = r.value) ||
									void 0 === o
										? void 0
										: o.deviceKnown
								) {
									var i = e.findIndex(function (e) {
										return 'signed_nonce' === e.value;
									});
									if (i > 0) {
										var a = e[i];
										e.splice(i, 1), e.unshift(a);
									}
								}
							},
							isOV: function () {
								return this.options.appState.get('authenticatorKey') === u.AUTHENTICATOR_KEY.OV;
							},
						}),
						d = c;
					(t.default = d), (e.exports = t.default);
				},
				70845: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(17587),
						o = n(13955),
						i = n(6475),
						a = r.BaseForm.extend(
							Object.assign({
								className: function () {
									return this.isOV() ? 'okta-verify-send-push-form' : 'custom-app-send-push-form';
								},
								save: function () {
									return this.options.appState.get('authenticatorKey') === o.AUTHENTICATOR_KEY.OV
										? (0, i.loc)('oie.okta_verify.sendPushButton', 'login')
										: (0, i.loc)('oie.custom_app.sendPushButton', 'login');
								},
								title: function () {
									return this.isOV()
										? (0, i.loc)('oie.okta_verify.push.title', 'login')
										: (0, i.loc)('oie.custom_app.push.title', 'login');
								},
								render: function () {
									r.BaseForm.prototype.render.apply(this, arguments);
									var e = this.$el.find('[data-se="o-form-fieldset-authenticator.autoChallenge"]');
									e.length && this.$el.find('.o-form-button-bar').after(e);
								},
								getUISchema: function () {
									var e = r.BaseForm.prototype.getUISchema.apply(this, arguments);
									return e.filter(function (e) {
										return 'authenticator.methodType' !== e.name;
									});
								},
								isOV: function () {
									return this.options.appState.get('authenticatorKey') === o.AUTHENTICATOR_KEY.OV;
								},
							})
						),
						s = a;
					(t.default = s), (e.exports = t.default);
				},
				70621: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = t.Body = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = n(17587),
						s = r(n(52574)),
						l = n(86725),
						u = r(n(83966)),
						c = n(13955),
						d = i.View.extend({
							className: 'okta-form-infobox-warning infobox infobox-warning',
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<span class="icon warning-16"></span><p>' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'warning') || (null != t ? a(t, 'warning') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'warning',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 40 }, end: { line: 1, column: 51 } },
												  })
												: i
										) +
										'</p>'
									);
								},
								useData: !0,
							}),
						}),
						f = a.BaseFormWithPolling.extend(
							Object.assign(
								{
									noButtonBar: !0,
									title: function () {
										return this.isOV()
											? (0, i.loc)('oie.okta_verify.push.title', 'login')
											: (0, i.loc)('oie.verify.custom_app.title', 'login', [
													this.options.appState.getAuthenticatorDisplayName(),
											  ]);
									},
									initialize: function () {
										a.BaseFormWithPolling.prototype.initialize.apply(this, arguments),
											(this.isOV() || this.isCustomApp()) &&
												this.isAutoChallengeSupported() &&
												(this.hasSavingState = !1),
											this.listenTo(this.model, 'error', this.stopPoll),
											this.addView();
									},
									addView: function () {
										this.add(
											(0, i.createButton)({
												className: 'button button-wide button-primary send-push link-button-disabled',
												title: this.isOV()
													? (0, i.loc)('oie.okta_verify.push.sent', 'login')
													: (0, i.loc)('oie.custom_app.push.sent', 'login'),
												click: function (e) {
													e.preventDefault();
												},
											})
										),
											this.add(
												"<span class='accessibility-text' role='alert'>\n        ".concat(
													this.isOV()
														? (0, i.loc)('oie.okta_verify.push.sent', 'login')
														: (0, i.loc)('oie.custom_app.push.sent', 'login'),
													'</span>'
												)
											);
									},
									render: function () {
										a.BaseFormWithPolling.prototype.render.apply(this, arguments);
										var e = this.$el.find('[data-se="o-form-fieldset-autoChallenge"]');
										this.isAutoChallengeSupported()
											? (this.isOV() || this.isCustomApp()) &&
											  e.length &&
											  this.$el.find('.o-form-fieldset-container').append(e)
											: e.length && e.hide();
									},
									postRender: function () {
										a.BaseFormWithPolling.prototype.postRender.apply(this, arguments);
										var e = this.isOV() ? 'okta-verify-push-challenge' : ' custom-app-push-challenge';
										this.$el.addClass(e), this.startPoll();
									},
									startPoll: function () {
										var e = this;
										this.startPolling(),
											(this.warningTimeout = setTimeout(function () {
												var t = e.isOV()
													? (0, i.loc)('oktaverify.warning', 'login')
													: (0, i.loc)('oie.custom_app.push.warning', 'login', [
															e.options.appState.getAuthenticatorDisplayName(),
													  ]);
												e.showWarning(t);
											}, l.WARNING_TIMEOUT));
									},
									stopPoll: function () {
										this.stopPolling(), this.clearWarning();
									},
									showWarning: function (e) {
										this.clearWarning(), this.add(d, '.o-form-error-container', { options: { warning: e } });
									},
									clearWarning: function () {
										this.$('.o-form-error-container div').hasClass('okta-form-infobox-warning') &&
											this.$('.okta-form-infobox-warning').remove(),
											clearTimeout(this.warningTimeout);
									},
									remove: function () {
										a.BaseFormWithPolling.prototype.remove.apply(this, arguments), this.stopPoll();
									},
									isOV: function () {
										return this.options.appState.get('authenticatorKey') === c.AUTHENTICATOR_KEY.OV;
									},
									isCustomApp: function () {
										return this.options.appState.get('authenticatorKey') === c.AUTHENTICATOR_KEY.CUSTOM_APP;
									},
									isAutoChallengeSupported: function () {
										return (
											null !== this.options.appState.getSchemaByName('autoChallenge') &&
											void 0 !== this.options.appState.getSchemaByName('autoChallenge')
										);
									},
								},
								s.default
							)
						);
					t.Body = f;
					var p = u.default.extend({ Body: f });
					t.default = p;
				},
				91002: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(2875)),
						a = n(6475).View.extend({
							className: 'custom-access-denied-error-message',
							template: i.default.template({
								1: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<p>' +
										e.escapeExpression(
											'function' ==
												typeof (i =
													null != (i = a(n, 'message') || (null != t ? a(t, 'message') : t))
														? i
														: e.hooks.helperMissing)
												? i.call(null != t ? t : e.nullContext || {}, {
														name: 'message',
														hash: {},
														data: o,
														loc: { start: { line: 1, column: 18 }, end: { line: 1, column: 29 } },
												  })
												: i
										) +
										'</p>'
									);
								},
								3: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<ul class="custom-links">' +
										(null !=
										(i = a(n, 'each').call(null != t ? t : e.nullContext || {}, null != t ? a(t, 'links') : t, {
											name: 'each',
											hash: {},
											fn: e.program(4, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 78 }, end: { line: 1, column: 182 } },
										}))
											? i
											: '') +
										'</ul>'
									);
								},
								4: function (e, t, n, r, i) {
									var a,
										s = null != t ? t : e.nullContext || {},
										l = e.hooks.helperMissing,
										u = 'function',
										c = e.escapeExpression,
										d =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<li><a href=' +
										c(
											((a = null != (a = d(n, 'url') || (null != t ? d(t, 'url') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'url',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 105 }, end: { line: 1, column: 112 } },
												  })
												: a)
										) +
										' target="_blank" rel="noopener noreferrer">' +
										c(
											((a = null != (a = d(n, 'label') || (null != t ? d(t, 'label') : t)) ? a : l),
											(0, o.default)(a) === u
												? a.call(s, {
														name: 'label',
														hash: {},
														data: i,
														loc: { start: { line: 1, column: 155 }, end: { line: 1, column: 164 } },
												  })
												: a)
										) +
										'</a></li>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'message') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 40 } },
										}))
											? i
											: '') +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'links') : t, {
											name: 'if',
											hash: {},
											fn: e.program(3, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 40 }, end: { line: 1, column: 194 } },
										}))
											? i
											: '')
									);
								},
								useData: !0,
							}),
							getTemplateData: function () {
								return { message: this.options.message, links: this.options.links };
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				22873: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475),
						o = {
							title: function () {
								return (0, r.loc)('oie.email.mfa.title', 'login');
							},
						};
					(t.default = o), (e.exports = t.default);
				},
				52574: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(6475),
						o = n(86725),
						i = {
							startPolling: function (e) {
								(this.fixedPollingInterval = this.options.currentViewState.refresh),
									(this.dynamicPollingInterval = e),
									(this.countDownCounterValue = Math.ceil(this.pollingInterval / o.MS_PER_SEC)),
									this.fixedPollingInterval ? this._startRemediationPolling() : this._startAuthenticatorPolling();
							},
							_startAuthenticatorPolling: function () {
								var e = this;
								['currentAuthenticator', 'currentAuthenticatorEnrollment'].some(function (t) {
									if (e.options.appState.has(t)) {
										var n,
											o = e.options.appState.get(t),
											i = ''.concat(t, '-poll'),
											a =
												e.dynamicPollingInterval ||
												(null == o || null === (n = o.poll) || void 0 === n ? void 0 : n.refresh);
										return (
											r._.isNumber(a) &&
												(e.polling = setTimeout(function () {
													e.options.appState.trigger('invokeAction', i);
												}, a)),
											!0
										);
									}
									return !1;
								});
							},
							_startRemediationPolling: function () {
								var e = this,
									t = this.dynamicPollingInterval || this.fixedPollingInterval;
								r._.isNumber(t) &&
									(this.polling = setTimeout(function () {
										e.options.appState.trigger('saveForm', e.model);
									}, t));
							},
							stopPolling: function () {
								this.polling && (clearTimeout(this.polling), (this.polling = null));
							},
						};
					(t.default = i), (e.exports = t.default);
				},
				94438: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = i.View.extend({
							className: 'custom-buttons',
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<div class="separation-line"><span>' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'socialauth.divider.text' },
													data: o,
													loc: { start: { line: 1, column: 58 }, end: { line: 1, column: 112 } },
												}
											)
										) +
										'</span></div>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = a(n, 'if').call(null != t ? t : e.nullContext || {}, null != t ? a(t, 'addSeparateLine') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 132 } },
										}))
											? i
											: '') + '<div class="okta-custom-buttons-container primary-auth-container"></div>'
									);
								},
								useData: !0,
							}),
							initialize: function (e) {
								var t = this;
								e.customButtons.forEach(function (e) {
									t.add((0, i.createButton)(e), '.okta-custom-buttons-container');
								});
							},
							getTemplateData: function () {
								var e = i.View.prototype.getTemplateData.apply(this, arguments);
								return Object.assign(e, { addSeparateLine: this.options.addSeparateLine });
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				83201: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(90570)),
						s = r(n(35546)),
						l = n(86725),
						u = n(13955),
						c = n(66200),
						d = i.View.extend({
							className: 'sign-in-with-device-option',
							template: o.default.template({
								1: function (e, t, n, r, o) {
									return '<div class="signin-with-ov-description"></div>';
								},
								3: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<div class="separation-line"><span>' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'authbutton.divider.text' },
													data: o,
													loc: { start: { line: 1, column: 201 }, end: { line: 1, column: 255 } },
												}
											)
										) +
										'</span></div>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div class="okta-verify-container">' +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'signInWithDeviceIsRequired') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 35 }, end: { line: 1, column: 122 } },
										}))
											? i
											: '') +
										'</div>' +
										(null !=
										(i = s(n, 'unless').call(a, null != t ? s(t, 'signInWithDeviceIsRequired') : t, {
											name: 'unless',
											hash: {},
											fn: e.program(3, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 128 }, end: { line: 1, column: 279 } },
										}))
											? i
											: '')
									);
								},
								useData: !0,
							}),
							initialize: function () {
								var e,
									t = this.options.appState,
									n = t.hasRemediationObject(u.FORMS.LAUNCH_AUTHENTICATOR),
									r = null == n || null === (e = n.relatesTo) || void 0 === e ? void 0 : e.value;
								this.add(
									(0, i.createButton)({
										className: 'button',
										icon: 'okta-verify-authenticator',
										title: (0, i.loc)('oktaVerify.button', 'login'),
										click: function () {
											var e = this;
											this.model.get('identifier') &&
												this.options.settings.set('identifier', encodeURIComponent(this.model.get('identifier')));
											var n = (null == r ? void 0 : r.challengeMethod) === s.default.UNIVERSAL_LINK_CHALLENGE;
											if (n) {
												var o,
													i,
													d = (0, c.appendLoginHint)(
														r.href,
														null === (o = this.options) || void 0 === o || null === (i = o.settings) || void 0 === i
															? void 0
															: i.get('identifier')
													);
												a.default.redirect(d);
											}
											var f = (null == r ? void 0 : r.challengeMethod) === s.default.APP_LINK_CHALLENGE;
											if (f) {
												var p,
													h,
													m = (0, c.appendLoginHint)(
														r.href,
														null === (p = this.options) || void 0 === p || null === (h = p.settings) || void 0 === h
															? void 0
															: h.get('identifier')
													);
												a.default.redirect(m, window, !0);
											}
											a.default.callAfterTimeout(
												function () {
													e.options.isRequired
														? t.trigger('saveForm', e.model)
														: t.trigger('invokeAction', u.FORMS.LAUNCH_AUTHENTICATOR, {
																rememberMe: e.model.get('rememberMe'),
														  });
												},
												n || f ? l.UNIVERSAL_LINK_POST_DELAY : 0
											);
										},
									}),
									'.okta-verify-container'
								);
							},
							getTemplateData: function () {
								return { signInWithDeviceIsRequired: !!this.options.isRequired };
							},
							postRender: function () {
								if (this.options.isRequired) {
									var e,
										t,
										n =
											null === (e = this.options.appState.attributes) ||
											void 0 === e ||
											null === (t = e.app) ||
											void 0 === t
												? void 0
												: t.label,
										r = n
											? (0, i.loc)('oktaVerify.appDescription', 'login', [n])
											: (0, i.loc)('oktaVerify.description', 'login');
									this.$el.find('.signin-with-ov-description').text(r);
								}
							},
						});
					(t.default = d), (e.exports = t.default);
				},
				21586: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = i.View.extend({
							className: 'sign-in-with-idp',
							template: o.default.template({
								1: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<div class="separation-line"><span>' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'socialauth.divider.text' },
													data: o,
													loc: { start: { line: 1, column: 64 }, end: { line: 1, column: 118 } },
												}
											)
										) +
										'</span></div>'
									);
								},
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a = null != t ? t : e.nullContext || {},
										s =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'isSecondaryIdpDisplay') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 138 } },
										}))
											? i
											: '') +
										'<div class="okta-idps-container"></div>' +
										(null !=
										(i = s(n, 'if').call(a, null != t ? s(t, 'isPrimaryIdpDisplay') : t, {
											name: 'if',
											hash: {},
											fn: e.program(1, o, 0),
											inverse: e.noop,
											data: o,
											loc: { start: { line: 1, column: 177 }, end: { line: 1, column: 313 } },
										}))
											? i
											: '')
									);
								},
								useData: !0,
							}),
							initialize: function () {
								var e = this;
								this.options.idpButtons.forEach(function (t) {
									e.add((0, i.createButton)(t), '.okta-idps-container');
								});
							},
							getTemplateData: function () {
								var e = i.View.prototype.getTemplateData.apply(this, arguments),
									t = this.options.idpButtons.length > 0;
								return Object.assign(e, {
									isPrimaryIdpDisplay: t && this.options.isPrimaryIdpDisplay,
									isSecondaryIdpDisplay: t && !this.options.isPrimaryIdpDisplay,
								});
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				156: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = n(13955),
						s = i.View.extend({
							className: 'sign-in-with-webauthn-option',
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<div class="okta-webauthn-container"></div><div class="separation-line"><span>' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'authbutton.divider.text' },
													data: o,
													loc: { start: { line: 1, column: 78 }, end: { line: 1, column: 132 } },
												}
											)
										) +
										'</span></div>'
									);
								},
								useData: !0,
							}),
							initialize: function () {
								var e = this;
								this.add(
									(0, i.createButton)({
										className: 'button',
										icon: 'okta-webauthn-authenticator',
										title: (0, i.loc)('signinWithWebAuthn.button', 'login'),
										click: function () {
											e.options.appState.trigger('invokeAction', a.FORMS.LAUNCH_WEBAUTHN_AUTHENTICATOR);
										},
									}),
									'.okta-webauthn-container'
								);
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				2854: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = r(n(71750)),
						a = r(n(83966)),
						s = i.default.extend({
							title: function () {
								var e = this.options.appState.getAuthenticatorDisplayName();
								return this.options.appState.isAuthenticatorChallenge()
									? (0, o.loc)('oie.symantecVip.challenge.title', 'login', [e])
									: (0, o.loc)('oie.symantecVip.enroll.title', 'login', [e]);
							},
							subtitle: function () {
								var e = this.options.appState.getAuthenticatorDisplayName();
								return this.options.appState.isAuthenticatorChallenge()
									? (0, o.loc)('oie.symantecVip.challenge.description', 'login', [e])
									: (0, o.loc)('oie.symantecVip.enroll.description', 'login', [e]);
							},
							save: function () {
								return this.options.appState.isAuthenticatorChallenge()
									? (0, o.loc)('mfa.challenge.verify', 'login')
									: (0, o.loc)('mfa.enroll', 'login');
							},
						}),
						l = a.default.extend({ Body: s });
					(t.default = l), (e.exports = t.default);
				},
				98380: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = i.View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<p class="idx-webauthn-verify-text">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'oie.verify.webauthn.instructions' },
													data: o,
													loc: { start: { line: 1, column: 36 }, end: { line: 1, column: 99 } },
												}
											)
										) +
										'</p>'
									);
								},
								useData: !0,
							}),
							initialize: function () {
								var e = this.options.currentViewState.relatesTo;
								'required' === (null == e ? void 0 : e.value.contextualData.challengeData).userVerification &&
									this.add(
										(0, i.createCallout)({
											className: 'uv-required-callout',
											size: 'slim',
											type: 'warning',
											subtitle: (0, i.loc)('oie.verify.webauthn.uv.required.instructions', 'login'),
										})
									),
									this.add('<div data-se="webauthn-waiting" class="okta-waiting-spinner"></div>');
							},
						});
					(t.default = a), (e.exports = t.default);
				},
				30836: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = r(n(76587)),
						l = r(n(49268)),
						u = r(n(34425)),
						c = r(n(98380)),
						d = n(43318),
						f = r(n(9867)),
						p = n(13955),
						h = r(n(21286)),
						m = i.BaseForm.extend({
							title: function () {
								return (0, o.loc)('oie.verify.webauth.title', 'login');
							},
							className: 'oie-verify-webauthn',
							getUISchema: function () {
								var e = this,
									t = [];
								if (l.default.isNewApiAvailable()) {
									var n = (0, o.createButton)({
										className: 'retry-webauthn button-primary default-custom-button',
										title: (0, o.loc)('mfa.challenge.verify', 'login'),
										click: function () {
											e.getCredentialsAndSave();
										},
									});
									t.push({ View: c.default }, { View: n }),
										this._canSetupWebAuthnResidentKey() && t.push({ View: h.default });
								} else
									t.push({
										View: (0, o.createCallout)({
											className: 'webauthn-not-supported',
											type: 'error',
											subtitle: (0, o.loc)('oie.webauthn.error.not.supported', 'login'),
										}),
									});
								return t;
							},
							remove: function () {
								i.BaseForm.prototype.remove.apply(this, arguments),
									this.webauthnAbortController &&
										(this.webauthnAbortController.abort(), (this.webauthnAbortController = null));
							},
							noButtonBar: !0,
							modelEvents: { error: '_stopVerification' },
							getCredentialsAndSave: function () {
								var e,
									t = this;
								this.clearErrors(),
									this._startVerification(),
									'undefined' != typeof AbortController && (this.webauthnAbortController = new AbortController());
								var n = this.options.currentViewState.relatesTo,
									r = (null == n ? void 0 : n.value) || {},
									i = [];
								(
									(null === (e = this.options.appState.get('authenticatorEnrollments')) || void 0 === e
										? void 0
										: e.value) || []
								).forEach(function (e) {
									'webauthn' === e.key && i.push({ type: 'public-key', id: s.default.strToBin(e.credentialId) });
								});
								var a = r.contextualData.challengeData,
									l = o._.extend({}, a, { allowCredentials: i, challenge: s.default.strToBin(a.challenge) });
								navigator.credentials
									.get({ publicKey: l, signal: this.webauthnAbortController && this.webauthnAbortController.signal })
									.then(
										function (e) {
											var n,
												r = {
													clientData: s.default.binToStr(e.response.clientDataJSON),
													authenticatorData: s.default.binToStr(e.response.authenticatorData),
													signatureData: s.default.binToStr(e.response.signature),
												};
											t.options.appState.getSchemaByName('credentials.userHandle') &&
												o._.extend(r, {
													userHandle: s.default.binToStr(null !== (n = e.response.userHandle) && void 0 !== n ? n : ''),
												});
											t.model.set({ credentials: r }), t.saveForm(t.model);
										},
										function (e) {
											t.webauthnAbortController &&
												t.model.trigger('error', t.model, {
													responseJSON: { errorSummary: (0, d.getMessageFromBrowserError)(e) },
												});
										}
									)
									.finally(function () {
										t.webauthnAbortController = null;
									});
							},
							_startVerification: function () {
								this.$('.okta-waiting-spinner').show(),
									this.$('.retry-webauthn').hide(),
									this.$('.setup-webauthn-residentkey-text').hide(),
									(this.$('.retry-webauthn')[0].textContent = (0, o.loc)('retry', 'login'));
							},
							_stopVerification: function () {
								this.$('.okta-waiting-spinner').hide(),
									this.$('.retry-webauthn').show(),
									this.$('.setup-webauthn-residentkey-text').show();
							},
							_canSetupWebAuthnResidentKey: function () {
								return this.options.appState.hasRemediationObject(p.FORMS.ENROLL_WEBAUTHN_RESIDENTKEY);
							},
						}),
						v = a.default.extend({
							Body: m,
							Footer: f.default,
							postRender: function () {
								a.default.prototype.postRender.apply(this, arguments),
									l.default.isNewApiAvailable() && !u.default.isSafari() && this.form.getCredentialsAndSave();
							},
						});
					(t.default = v), (e.exports = t.default);
				},
				21286: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = n(13955),
						s = i.View.extend({
							className: 'setup-webauthn-residentkey-text',
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i,
										a =
											e.lookupProperty ||
											function (e, t) {
												if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
											};
									return (
										'<div>' +
										(null !=
										(i = (a(n, 'i18n') || (t && a(t, 'i18n')) || e.hooks.helperMissing).call(
											null != t ? t : e.nullContext || {},
											{
												name: 'i18n',
												hash: { bundle: 'login', code: 'oie.enroll.webauthn.rk.link' },
												data: o,
												loc: { start: { line: 1, column: 5 }, end: { line: 1, column: 65 } },
											}
										))
											? i
											: '') +
										'</div>'
									);
								},
								useData: !0,
							}),
							events: {
								'click .setup-webauthn-residentkey-link': function (e) {
									e.preventDefault(),
										this.options.appState.trigger('invokeAction', a.FORMS.ENROLL_WEBAUTHN_RESIDENTKEY);
								},
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				46523: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(34425)),
						s = i.View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									var i =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
									return (
										'<p class="idx-webauthn-enroll-text">' +
										e.escapeExpression(
											(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
												null != t ? t : e.nullContext || {},
												{
													name: 'i18n',
													hash: { bundle: 'login', code: 'oie.enroll.webauthn.instructions' },
													data: o,
													loc: { start: { line: 1, column: 36 }, end: { line: 1, column: 99 } },
												}
											)
										) +
										'</p>'
									);
								},
								useData: !0,
							}),
							initialize: function () {
								var e = this.options.currentViewState.relatesTo,
									t = null == e ? void 0 : e.value.contextualData.activationData;
								a.default.isEdge() &&
									this.add(
										i.View.extend({
											tagName: 'p',
											className: 'idx-webauthn-enroll-text-edge',
											template: o.default.template({
												compiler: [8, '>= 4.3.0'],
												main: function (e, t, n, r, o) {
													var i =
														e.lookupProperty ||
														function (e, t) {
															if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
														};
													return e.escapeExpression(
														(i(n, 'i18n') || (t && i(t, 'i18n')) || e.hooks.helperMissing).call(
															null != t ? t : e.nullContext || {},
															{
																name: 'i18n',
																hash: { bundle: 'login', code: 'oie.enroll.webauthn.instructions.edge' },
																data: o,
																loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 68 } },
															}
														)
													);
												},
												useData: !0,
											}),
										})
									),
									'required' === t.authenticatorSelection.userVerification &&
										this.add(
											(0, i.createCallout)({
												className: 'uv-required-callout',
												size: 'slim',
												type: 'warning',
												subtitle: (0, i.loc)('oie.enroll.webauthn.uv.required.instructions', 'login'),
											})
										),
									this.add('<div data-se="webauthn-waiting" class="okta-waiting-spinner"></div>');
							},
						});
					(t.default = s), (e.exports = t.default);
				},
				65387: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = n(6475),
						i = n(17587),
						a = r(n(83966)),
						s = r(n(49268)),
						l = r(n(76587)),
						u = r(n(46523)),
						c = n(43318);
					var d = i.BaseForm.extend({
							title: function () {
								return (0, o.loc)('oie.enroll.webauthn.title', 'login');
							},
							className: 'oie-enroll-webauthn',
							modelEvents: { error: '_stopEnrollment' },
							getUISchema: function () {
								var e = this,
									t = [];
								return (
									s.default.isNewApiAvailable()
										? (t.push({ View: u.default }),
										  t.push({
												View: (0, o.createButton)({
													className: 'webauthn-setup button button-primary button-wide',
													title: (0, o.loc)('oie.enroll.webauthn.save', 'login'),
													click: function () {
														e.triggerWebauthnPrompt();
													},
												}),
										  }))
										: t.push({
												View: (0, o.createCallout)({
													className: 'webauthn-not-supported',
													type: 'error',
													subtitle: (0, o.loc)('oie.webauthn.error.not.supported', 'login'),
												}),
										  }),
									t
								);
							},
							triggerWebauthnPrompt: function () {
								var e = this;
								this.$el.find('.o-form-error-container').empty(), this._startEnrollment();
								var t = this.options.currentViewState.relatesTo,
									n = null == t ? void 0 : t.value.contextualData.activationData;
								if (s.default.isNewApiAvailable()) {
									var r,
										i =
											!0 === (null === (r = n.authenticatorSelection) || void 0 === r ? void 0 : r.requireResidentKey)
												? []
												: (function () {
														var e = [];
														return (
															(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).forEach(function (
																t
															) {
																'webauthn' === t.key &&
																	e.push({ type: 'public-key', id: l.default.strToBin(t.credentialId) });
															}),
															e
														);
												  })(this.options.appState.get('authenticatorEnrollments').value),
										a = o._.extend({}, n, {
											challenge: l.default.strToBin(n.challenge),
											user: { id: l.default.strToBin(n.user.id), name: n.user.name, displayName: n.user.displayName },
											excludeCredentials: i,
										});
									'undefined' != typeof AbortController && (this.webauthnAbortController = new AbortController()),
										navigator.credentials
											.create({
												publicKey: a,
												signal: this.webauthnAbortController && this.webauthnAbortController.signal,
											})
											.then(function (t) {
												e.model.set({
													credentials: {
														clientData: l.default.binToStr(t.response.clientDataJSON),
														attestation: l.default.binToStr(t.response.attestationObject),
														transports: s.default.processWebAuthnResponse(t.response.getTransports, t.response),
														clientExtensions: s.default.processWebAuthnResponse(t.getClientExtensionResults, t),
													},
												}),
													e.saveForm(e.model);
											})
											.catch(function (t) {
												e.model.trigger('error', e.model, {
													responseJSON: { errorSummary: (0, c.getMessageFromBrowserError)(t) },
												});
											})
											.finally(function () {
												e.webauthnAbortController = null;
											});
								}
							},
							_startEnrollment: function () {
								this.$('.okta-waiting-spinner').show(), this.$('.webauthn-setup').hide();
							},
							_stopEnrollment: function () {
								this.$('.okta-waiting-spinner').hide(), this.$('.webauthn-setup').show();
							},
						}),
						f = a.default.extend({
							Body: d,
							postRender: function () {
								a.default.prototype.postRender.apply(this, arguments),
									this.$el.find('.o-form-button-bar [type="submit"]').remove();
							},
						});
					(t.default = f), (e.exports = t.default);
				},
				23986: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(2875)),
						i = n(6475),
						a = r(n(71750)),
						s = r(n(83966)),
						l = i.View.extend({
							template: o.default.template({
								compiler: [8, '>= 4.3.0'],
								main: function (e, t, n, r, o) {
									return '<div aria-hidden="true" class="yubikey-demo"></div>';
								},
								useData: !0,
							}),
						}),
						u = a.default.extend({
							title: function () {
								return this.options.appState.isAuthenticatorChallenge()
									? (0, i.loc)('oie.yubikey.challenge.title', 'login')
									: (0, i.loc)('oie.yubikey.enroll.title', 'login');
							},
							subtitle: function () {
								return (0, i.loc)('oie.yubikey.description', 'login');
							},
							save: function () {
								return (0, i.loc)('mfa.challenge.verify', 'login');
							},
							getUISchema: function () {
								var e = a.default.prototype.getUISchema.apply(this, arguments);
								return e.unshift({ View: l, selector: '.o-form-fieldset-container' }), e;
							},
						}),
						c = s.default.extend({ Body: u });
					(t.default = c), (e.exports = t.default);
				},
				22544: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.default = function () {
							var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
								t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
								n = o.$.extend(!0, {}, e.authParams, o._.pick(t, a.default.AUTH_PARAMS)),
								r = Object.assign({}, e, t),
								s = r.el,
								l = r.clientId,
								u = r.redirectUri,
								c = Object.assign({}, { el: s, clientId: l, redirectUri: u, authParams: n });
							if (!c.el) throw new i.ConfigError('"el" is required');
							if (!c.clientId) throw new i.ConfigError('"clientId" is required');
							if (!c.redirectUri) throw new i.ConfigError('"redirectUri" is required');
							return c;
						});
					var o = n(6475),
						i = n(13671),
						a = r(n(97329));
					e.exports = t.default;
				},
				99083: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.default = function (e, t, n, r, a, s, l) {
							var u,
								c,
								d = new Promise(function (e, t) {
									(u = e), (c = t);
								}),
								f = o.$.extend(!0, {}, t, n, {
									authClient: r,
									hooks: l,
									globalSuccessFn: function (e) {
										a && a(e), e && e.status === i.default.SUCCESS && u(e);
									},
									globalErrorFn: function (e) {
										s && s(e), c(e);
									},
								}),
								p = new e(f);
							return p.start(), { router: p, routerOptions: f, promise: d };
						});
					var o = n(6475),
						i = r(n(35546));
					e.exports = t.default;
				},
				78998: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.OktaAuth = void 0);
					var r = n(2659),
						o = n(50356),
						i = (0, r.mixinAuthn)(o.OktaAuth);
					t.OktaAuth = i;
				},
				50356: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.OktaAuth = void 0);
					var r = n(2659),
						o = (0, r.createIdxOptionsConstructor)(),
						i = (0, r.createIdxStorageManager)(),
						a = (0, r.createIdxTransactionManager)(),
						s = (0, r.createOktaAuthOAuth)(i, o, a),
						l = (0, r.mixinIdx)(s);
					t.OktaAuth = l;
				},
				92484: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var r = n(3528).OktaSignIn;
					(t.default = r), (e.exports = t.default);
				},
				3528: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 });
					var o = { OktaSignIn: !0 };
					t.default = t.OktaSignIn = void 0;
					var i = r(n(78463)),
						a = r(n(39131)),
						s = r(n(35075)),
						l = r(n(35432)),
						u = r(n(2132)),
						c = n(78998),
						d = n(22390),
						f = n(44371),
						p = n(8347);
					function h(e) {
						var t = (function () {
							if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
							if (Reflect.construct.sham) return !1;
							if ('function' == typeof Proxy) return !0;
							try {
								return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
							} catch (e) {
								return !1;
							}
						})();
						return function () {
							var n,
								r = (0, u.default)(e);
							if (t) {
								var o = (0, u.default)(this).constructor;
								n = Reflect.construct(r, arguments, o);
							} else n = r.apply(this, arguments);
							return (0, l.default)(this, n);
						};
					}
					Object.keys(p).forEach(function (e) {
						'default' !== e &&
							'__esModule' !== e &&
							(Object.prototype.hasOwnProperty.call(o, e) ||
								(e in t && t[e] === p[e]) ||
								Object.defineProperty(t, e, {
									enumerable: !0,
									get: function () {
										return p[e];
									},
								}));
					});
					var m = (function (e) {
						(0, s.default)(n, e);
						var t = h(n);
						function n(e) {
							return (0, a.default)(this, n), t.call(this, e);
						}
						return (0, i.default)(n);
					})((0, f.createOktaSignIn)(c.OktaAuth, d.routerClassFactory));
					t.OktaSignIn = m;
					var v = m;
					t.default = v;
				},
				76404: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(39131)),
						i = r(n(78463)),
						a = r(n(35075)),
						s = r(n(35432)),
						l = r(n(2132)),
						u = n(6475),
						c = n(53736);
					function d(e) {
						var t = (function () {
							if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
							if (Reflect.construct.sham) return !1;
							if ('function' == typeof Proxy) return !0;
							try {
								return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
							} catch (e) {
								return !1;
							}
						})();
						return function () {
							var n,
								r = (0, l.default)(e);
							if (t) {
								var o = (0, l.default)(this).constructor;
								n = Reflect.construct(r, arguments, o);
							} else n = r.apply(this, arguments);
							return (0, s.default)(this, n);
						};
					}
					var f = (function (e) {
						(0, a.default)(n, e);
						var t = d(n);
						function n() {
							return (0, o.default)(this, n), t.apply(this, arguments);
						}
						return (
							(0, i.default)(n, [
								{
									key: 'mergeHook',
									value: function (e, t) {
										var n = this.get('hooks') || {};
										(0, c.mergeHook)(n, e, t), this.set('hooks', n);
									},
								},
								{
									key: 'getHook',
									value: function (e) {
										return (this.get('hooks') || {})[e];
									},
								},
							]),
							n
						);
					})(u.Model);
					(t.default = f), (e.exports = t.default);
				},
				27447: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(39131)),
						i = r(n(78463)),
						a = r(n(35075)),
						s = r(n(35432)),
						l = r(n(2132)),
						u = r(n(2875)),
						c = n(6475),
						d = r(n(7174)),
						f = r(n(6321)),
						p = r(n(34425)),
						h = n(13671),
						m = r(n(78719)),
						v = r(n(36894)),
						g = r(n(90570)),
						y = r(n(73390));
					function b(e) {
						var t = (function () {
							if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
							if (Reflect.construct.sham) return !1;
							if ('function' == typeof Proxy) return !0;
							try {
								return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
							} catch (e) {
								return !1;
							}
						})();
						return function () {
							var n,
								r = (0, l.default)(e);
							if (t) {
								var o = (0, l.default)(this).constructor;
								n = Reflect.construct(r, arguments, o);
							} else n = r.apply(this, arguments);
							return (0, s.default)(this, n);
						};
					}
					var _ = c.internal.util.Util,
						w = u.default.template({
							compiler: [8, '>= 4.3.0'],
							main: function (e, t, n, r, o) {
								var i,
									a =
										e.lookupProperty ||
										function (e, t) {
											if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
										};
								return (
									'https://global.oktacdn.com/okta-signin-widget/' +
									e.escapeExpression(
										'function' ==
											typeof (i =
												null != (i = a(n, 'version') || (null != t ? a(t, 'version') : t)) ? i : e.hooks.helperMissing)
											? i.call(null != t ? t : e.nullContext || {}, {
													name: 'version',
													hash: {},
													data: o,
													loc: { start: { line: 1, column: 46 }, end: { line: 1, column: 57 } },
											  })
											: i
									)
								);
							},
							useData: !0,
						}),
						O = {
							'authClient': ['object', !1, void 0],
							'baseUrl': ['string', !0],
							'recoveryToken': ['string', !1, void 0],
							'stateToken': ['string', !1, void 0],
							'username': ['string', !1],
							'relayState': ['string', !1],
							'signOutLink': ['string', !1],
							'backToSignInLink': ['string', !1],
							'redirect': { type: 'string', values: ['never', 'always', 'auto'], value: 'auto' },
							'flow': ['string', !1, 'default'],
							'transformUsername': ['function', !1],
							'globalSuccessFn': 'function',
							'globalErrorFn': 'function',
							'processCreds': 'function',
							'hooks': 'object',
							'logo': 'string',
							'logoText': ['string', !1],
							'helpSupportNumber': 'string',
							'proxyIdxResponse': ['object', !1],
							'overrideExistingStateToken': ['boolean', !1, !1],
							'features.router': ['boolean', !0, !1],
							'features.securityImage': ['boolean', !0, !1],
							'features.rememberMe': ['boolean', !0, !0],
							'features.autoPush': ['boolean', !0, !1],
							'features.smsRecovery': ['boolean', !0, !1],
							'features.callRecovery': ['boolean', !0, !1],
							'features.emailRecovery': ['boolean', !1, !0],
							'features.webauthn': ['boolean', !0, !1],
							'features.selfServiceUnlock': ['boolean', !0, !1],
							'features.multiOptionalFactorEnroll': ['boolean', !0, !1],
							'features.deviceFingerprinting': ['boolean', !1, !1],
							'features.hideSignOutLinkInMFA': ['boolean', !1, !1],
							'features.skipIdpFactorVerificationBtn': ['boolean', !1, !1],
							'features.hideBackToSignInForReset': ['boolean', !1, !1],
							'features.customExpiredPassword': ['boolean', !0, !1],
							'features.registration': ['boolean', !1, !1],
							'features.idpDiscovery': ['boolean', !1, !1],
							'features.passwordlessAuth': ['boolean', !1, !1],
							'features.showPasswordToggleOnSignInPage': ['boolean', !1, !1],
							'features.trackTypingPattern': ['boolean', !1, !1],
							'features.redirectByFormSubmit': ['boolean', !1, !1],
							'features.useDeviceFingerprintForSecurityImage': ['boolean', !1, !0],
							'features.showPasswordRequirementsAsHtmlList': ['boolean', !1, !1],
							'features.mfaOnlyFlow': ['boolean', !1, !1],
							'features.scrollOnError': ['boolean', !1, !0],
							'features.showKeepMeSignedIn': ['boolean', !1, !0],
							'features.showIdentifier': ['boolean', !1, !0],
							'features.autoFocus': ['boolean', !1, !0],
							'features.sameDeviceOVEnrollmentEnabled': ['boolean', !1, !1],
							'features.showSessionRevocation': ['boolean', !1, !1],
							'features.disableAutocomplete': ['boolean', !1, !1],
							'defaultCountryCode': ['string', !1, 'US'],
							'language': ['any', !1],
							'i18n': ['object', !1],
							'assets.baseUrl': ['string', !1],
							'assets.rewrite': { type: 'function', value: c._.identity },
							'assets.languages': ['array', !1],
							'issuer': 'string',
							'clientId': 'string',
							'redirectUri': 'string',
							'state': 'string',
							'nonce': 'string',
							'scopes': 'array',
							'codeChallenge': 'string',
							'codeChallengeMethod': ['string', !1],
							'oAuthTimeout': ['number', !1],
							'authScheme': ['string', !1, 'OAUTH2'],
							'idps': ['array', !1, []],
							'idpDisplay': { type: 'string', values: ['PRIMARY', 'SECONDARY'], value: 'SECONDARY' },
							'helpLinks.help': 'string',
							'helpLinks.forgotPassword': 'string',
							'helpLinks.unlock': 'string',
							'helpLinks.custom': 'array',
							'helpLinks.factorPage.href': 'string',
							'helpLinks.factorPage.text': 'string',
							'customButtons': ['array', !1, []],
							'policyId': 'string',
							'registration.click': 'function',
							'registration.parseSchema': 'function',
							'registration.preSubmit': 'function',
							'registration.postSubmit': 'function',
							'consent.cancel': 'function',
							'idpDiscovery.requestContext': 'string',
							'colors.brand': 'string',
							'cspNonce': 'string',
							'brandName': 'string',
							'piv': ['object', !1, {}],
							'otp': 'string',
							'useClassicEngine': ['boolean', !1, !1],
							'hcaptcha.scriptSource': ['string', !1],
							'hcaptcha.scriptParams': ['object', !1, {}],
							'recaptcha.scriptSource': ['string', !1],
						},
						k = {
							backToSignInUri: {
								deps: ['backToSignInLink', 'signOutLink'],
								fn: function (e, t) {
									return e || t;
								},
							},
							showPasswordToggle: {
								deps: ['features.showPasswordToggleOnSignInPage'],
								fn: function () {
									var e,
										t,
										n,
										r,
										o =
											null !==
												(e =
													null === (t = this.options) || void 0 === t || null === (n = t.features) || void 0 === n
														? void 0
														: n.showPasswordToggleOnSignInPage) && void 0 !== e
												? e
												: null === (r = this.options) || void 0 === r
												? void 0
												: r['features.showPasswordToggleOnSignInPage'];
									return null == o || o;
								},
								cache: !0,
							},
							redirectUtilFn: {
								deps: ['features.redirectByFormSubmit'],
								fn: function (e) {
									return e ? g.default.redirectWithFormGet.bind(g.default) : _.redirect.bind(_);
								},
								cache: !0,
							},
							supportedLanguages: {
								deps: ['i18n', 'language', 'assets.languages'],
								fn: function (e, t, n) {
									var r = n || d.default.supportedLanguages;
									return c._.union(r, c._.keys(e), c._.isString(t) ? [t] : []);
								},
								cache: !0,
							},
							languageCode: {
								deps: ['language', 'supportedLanguages'],
								fn: function (e, t) {
									var n = p.default.getUserLanguages();
									n.forEach(function (e, t) {
										'nl' === e ? (n[t] = 'nl-NL') : 'pt' === e && (n[t] = 'pt-BR');
									});
									var r = c._.clone(n),
										o = g.default.toLower(t);
									c._.isString(e) ? r.unshift(e) : c._.isFunction(e) && r.unshift(e(t, n)),
										r.push(d.default.defaultLanguage);
									var i,
										a,
										s = g.default.toLower(g.default.expandLanguages(r));
									for (i = 0; i < s.length; i++) if ((a = o.indexOf(s[i])) > -1) return t[a];
								},
							},
							countryCode: {
								deps: ['defaultCountryCode'],
								fn: function (e) {
									var t = y.default.getCountries();
									return Object.keys(t).includes(e) ? e : 'US';
								},
							},
							mode: {
								deps: ['codeChallenge'],
								fn: function (e) {
									return e ? 'remediation' : 'relying-party';
								},
							},
							oauth2Enabled: {
								deps: ['clientId', 'authScheme', 'authClient'],
								fn: function (e, t, n) {
									return !e && n && (e = n.options.clientId), !!e && 'oauth2' === t.toLowerCase();
								},
								cache: !0,
							},
							oauthRedirectUri: {
								deps: ['redirectUri'],
								fn: function (e) {
									if (e) return e;
									var t = window.location.origin;
									if (!t) {
										var n = window.location.href,
											r = window.location.pathname;
										'' !== r && (t = n.substring(0, n.lastIndexOf(r)));
									}
									return encodeURI(t);
								},
							},
							configuredSocialIdps: {
								deps: ['idps'],
								fn: function (e) {
									return c._.map(e, function (e) {
										var t = c._.clone(e),
											n = t.type && t.type.toLowerCase();
										return (
											(n && c._.contains(m.default.SUPPORTED_SOCIAL_IDPS, n)) ||
												((n = 'general-idp'), (t.text = t.text || '{ Please provide a text value }')),
											(t.className = [
												'social-auth-button',
												'social-auth-' + n + '-button ',
												t.className ? t.className : '',
											].join(' ')),
											(t.dataAttr = 'social-auth-' + n + '-button'),
											(t.i18nKey = 'socialauth.' + n + '.label'),
											t
										);
									});
								},
								cache: !0,
							},
							hasPivCard: {
								deps: ['piv'],
								fn: function (e) {
									return e && e.certAuthUrl;
								},
								cache: !0,
							},
							socialAuthPositionTop: {
								deps: ['configuredSocialIdps', 'hasPivCard', 'idpDisplay'],
								fn: function (e, t, n) {
									return (!c._.isEmpty(e) || t) && 'PRIMARY' === n.toUpperCase();
								},
								cache: !0,
							},
							hasConfiguredButtons: {
								deps: ['configuredSocialIdps', 'customButtons', 'hasPivCard'],
								fn: function (e, t, n) {
									return !c._.isEmpty(e) || !c._.isEmpty(t) || n;
								},
								cache: !0,
							},
						},
						x = (function (e) {
							(0, a.default)(n, e);
							var t = b(n);
							function n(e, r) {
								var i;
								(0, o.default)(this, n);
								var a = (i = t.call(this, e, r)).getAuthClient();
								return i.setAcceptLanguageHeader(a), i;
							}
							return (
								(0, i.default)(n, [
									{
										key: 'get',
										value: function (e) {
											return c.Model.prototype.get.call(this, e);
										},
									},
									{
										key: 'preinitialize',
										value: function () {
											(this.local = O), (this.derived = k);
											for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
											c.Model.prototype.preinitialize.apply(this, t);
										},
									},
									{
										key: 'initialize',
										value: function (e) {
											var t = (e = e || {}),
												n = t.colors,
												r = t.authClient,
												o = t.flow,
												i = e.baseUrl;
											if (!i) {
												if (r) i = r.getIssuerOrigin();
												else {
													var a,
														s = e.authParams,
														l = e.issuer;
													i =
														null === (a = l = l || (null == s ? void 0 : s.issuer)) || void 0 === a
															? void 0
															: a.split('/oauth2/')[0];
												}
												this.set('baseUrl', i);
											}
											r && o && r.idx.setFlow(o),
												i
													? n && c._.isString(n.brand) && !n.brand.match(/^#[0-9A-Fa-f]{6}$/)
														? this.callGlobalError(new h.ConfigError((0, c.loc)('error.invalid.colors.brand')))
														: p.default.corsIsNotSupported() &&
														  this.callGlobalError(new h.UnsupportedBrowserError((0, c.loc)('error.unsupported.cors')))
													: this.callGlobalError(new h.ConfigError((0, c.loc)('error.required.baseUrl')));
										},
									},
									{
										key: 'setAcceptLanguageHeader',
										value: function (e) {
											e && e.http.setRequestHeader('Accept-Language', this.get('languageCode'));
										},
									},
									{
										key: 'setAuthClient',
										value: function (e) {
											this.set('authClient', e), this.setAcceptLanguageHeader(e);
										},
									},
									{
										key: 'getAuthClient',
										value: function () {
											return this.get('authClient');
										},
									},
									{
										key: 'set',
										value: function () {
											try {
												for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
												return c.Model.prototype.set.apply(this, t);
											} catch (e) {
												var r = e.message ? e.message : e;
												this.callGlobalError(new h.ConfigError(r));
											}
										},
									},
									{
										key: 'callGlobalSuccess',
										value: function (e, t) {
											var n = c._.extend(t, { status: e });
											c._.defer(c._.partial(this.get('globalSuccessFn'), n));
										},
									},
									{
										key: 'callGlobalError',
										value: function (e) {
											var t = this.get('globalErrorFn') || this.options.globalErrorFn;
											if (!t) throw e;
											t(e);
										},
									},
									{
										key: 'transformUsername',
										value: function (e, t) {
											var n = this.get('transformUsername');
											return n && c._.isFunction(n) ? n(e, t) : e;
										},
									},
									{
										key: 'processCreds',
										value: function (e) {
											var t = this.get('processCreds');
											return f.default.Promise(function (n) {
												c._.isFunction(t) ? (2 === t.length ? t(e, n) : (t(e), n())) : n();
											});
										},
									},
									{
										key: 'parseRegistrationSchema',
										value: function (e, t, n) {
											var r = this.get('registration.parseSchema');
											c._.isFunction(r)
												? r(
														e,
														function (e) {
															t(e);
														},
														function (e) {
															((e = e || {
																errorSummary: (0, c.loc)('registration.default.callbackhook.error'),
															}).callback = 'parseSchema'),
																n(e);
														}
												  )
												: t(e);
										},
									},
									{
										key: 'preRegistrationSubmit',
										value: function (e, t, n) {
											var r = this.get('registration.preSubmit');
											c._.isFunction(r)
												? r(
														e,
														function (e) {
															t(e);
														},
														function (e) {
															((e = e || {
																errorSummary: (0, c.loc)('registration.default.callbackhook.error'),
															}).callback = 'preSubmit'),
																n(e);
														}
												  )
												: t(e);
										},
									},
									{
										key: 'postRegistrationSubmit',
										value: function (e, t, n) {
											var r = this.get('registration.postSubmit');
											c._.isFunction(r)
												? r(
														e,
														function (e) {
															t(e);
														},
														function (e) {
															((e = e || {
																errorSummary: (0, c.loc)('registration.default.callbackhook.error'),
															}).callback = 'postSubmit'),
																n(e);
														}
												  )
												: t(e);
										},
									},
									{
										key: 'parse',
										value: function (e) {
											if (e.labels || e.country) {
												v.default.deprecate('Use "i18n" instead of "labels" and "country"');
												var t = e.labels || {};
												c._.each(e.country, function (e, n) {
													t['country.' + n] = e;
												}),
													(e.i18n = {}),
													c._.each(d.default.supportedLanguages, function (n) {
														e.i18n[n] = t;
													}),
													delete e.labels,
													delete e.country;
											}
											e.assets || (e.assets = {});
											var n = e.assets.baseUrl;
											return (
												n
													? '/' === n[n.length - 1] && (e.assets.baseUrl = n.substring(0, n.length - 1))
													: (e.assets.baseUrl = w({ version: d.default.version })),
												e
											);
										},
									},
									{
										key: 'isDsTheme',
										value: function () {
											return !1;
										},
									},
								]),
								n
							);
						})(c.Model);
					(t.default = x), (e.exports = t.default);
				},
				22390: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.routerClassFactory = function (e) {
							var t,
								n = !e.stateToken && !e.clientId && !e.proxyIdxResponse,
								r = e.stateToken && o.default.isV1StateToken(e.stateToken),
								s = e.clientId && !0 === e.useClassicEngine;
							t = n || r || s ? i.default : a.default;
							return t;
						});
					var o = r(n(90570)),
						i = r(n(26207)),
						a = r(n(80585));
				},
				26963: function () {},
				80079: function () {},
				91322: function () {},
				72600: function () {},
				5122: function () {},
				8347: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 });
					var r = n(80079);
					Object.keys(r).forEach(function (e) {
						'default' !== e &&
							'__esModule' !== e &&
							((e in t && t[e] === r[e]) ||
								Object.defineProperty(t, e, {
									enumerable: !0,
									get: function () {
										return r[e];
									},
								}));
					});
					var o = n(26963);
					Object.keys(o).forEach(function (e) {
						'default' !== e &&
							'__esModule' !== e &&
							((e in t && t[e] === o[e]) ||
								Object.defineProperty(t, e, {
									enumerable: !0,
									get: function () {
										return o[e];
									},
								}));
					});
					var i = n(91322);
					Object.keys(i).forEach(function (e) {
						'default' !== e &&
							'__esModule' !== e &&
							((e in t && t[e] === i[e]) ||
								Object.defineProperty(t, e, {
									enumerable: !0,
									get: function () {
										return i[e];
									},
								}));
					});
					var a = n(72600);
					Object.keys(a).forEach(function (e) {
						'default' !== e &&
							'__esModule' !== e &&
							((e in t && t[e] === a[e]) ||
								Object.defineProperty(t, e, {
									enumerable: !0,
									get: function () {
										return a[e];
									},
								}));
					});
					var s = n(5122);
					Object.keys(s).forEach(function (e) {
						'default' !== e &&
							'__esModule' !== e &&
							((e in t && t[e] === s[e]) ||
								Object.defineProperty(t, e, {
									enumerable: !0,
									get: function () {
										return s[e];
									},
								}));
					});
					var l = n(73006);
					Object.keys(l).forEach(function (e) {
						'default' !== e &&
							'__esModule' !== e &&
							((e in t && t[e] === l[e]) ||
								Object.defineProperty(t, e, {
									enumerable: !0,
									get: function () {
										return l[e];
									},
								}));
					});
					var u = n(16065);
					Object.keys(u).forEach(function (e) {
						'default' !== e &&
							'__esModule' !== e &&
							((e in t && t[e] === u[e]) ||
								Object.defineProperty(t, e, {
									enumerable: !0,
									get: function () {
										return u[e];
									},
								}));
					});
					var c = n(47341);
					Object.keys(c).forEach(function (e) {
						'default' !== e &&
							'__esModule' !== e &&
							((e in t && t[e] === c[e]) ||
								Object.defineProperty(t, e, {
									enumerable: !0,
									get: function () {
										return c[e];
									},
								}));
					});
					var d = n(64694);
					Object.keys(d).forEach(function (e) {
						'default' !== e &&
							'__esModule' !== e &&
							((e in t && t[e] === d[e]) ||
								Object.defineProperty(t, e, {
									enumerable: !0,
									get: function () {
										return d[e];
									},
								}));
					});
				},
				16065: function () {},
				73006: function () {},
				47341: function () {},
				64694: function () {},
				34425: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(31752)),
						i = {},
						a = 'withCredentials' in new window.XMLHttpRequest(),
						s = void 0 !== window.XDomainRequest;
					(i.corsIsNotSupported = function () {
						return !(a || s);
					}),
						(i.corsIsNotEnabled = function (e) {
							return 0 === e.status;
						}),
						(i.localStorageIsNotSupported = function () {
							var e = 'test';
							try {
								return localStorage.setItem(e, e), localStorage.removeItem(e), !1;
							} catch (e) {
								return !0;
							}
						}),
						(i.supportsPushState = function (e) {
							return !(!(e = e || window).history || !e.history.pushState);
						}),
						(i.isIE = function () {
							return /(msie|trident)/i.test(navigator.userAgent);
						}),
						(i.isFirefox = function () {
							return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
						}),
						(i.isEdge = function () {
							return navigator.userAgent.toLowerCase().indexOf('edge') > -1;
						}),
						(i.isSafari = function () {
							return (
								navigator.userAgent.toLowerCase().indexOf('safari') > -1 &&
								-1 === navigator.userAgent.toLowerCase().indexOf('chrome')
							);
						}),
						(i.isMac = function () {
							return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
						}),
						(i.isAndroid = function () {
							return /android/i.test(navigator.userAgent) && !/windows phone/i.test(navigator.userAgent);
						}),
						(i.isIOS = function () {
							return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
						}),
						(i.getUserLanguages = function () {
							if (navigator.languages) return (0, o.default)(navigator.languages);
							var e = [];
							return (
								['language', 'userLanguage', 'browserLanguage', 'systemLanguage'].forEach(function (t) {
									navigator[t] && e.push(navigator[t]);
								}),
								e
							);
						});
					var l = i;
					(t.default = l), (e.exports = t.default);
				},
				52115: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(70232)),
						i = r(n(66583)),
						a = r(n(31049)),
						s = r(n(7174)),
						l = r(n(21147)),
						u = r(n(83755)),
						c = r(n(74752)),
						d = r(n(87462)),
						f = r(n(34425)),
						p = r(n(36894)),
						h = 'osw.languages';
					function m(e) {
						if (!e) return {};
						var t = {};
						return (
							d.default.each(d.default.keys(e), function (n) {
								t[n.toLowerCase()] = e[n];
							}),
							d.default.mapObject(t, function (e) {
								var t = { login: {}, country: {} };
								if (!d.default.isObject(e)) throw new Error('Invalid format for "i18n"');
								return (
									d.default.each(e, function (e, n) {
										var r = n.split(/^country\./);
										r.length > 1 ? (t.country[r[1]] = e) : (t.login[r[0]] = e);
									}),
									t
								);
							})
						);
					}
					function v() {
						var e = JSON.parse(localStorage.getItem(h));
						return (e && e.version === s.default.version) || (e = { version: s.default.version }), e;
					}
					function g(e, t, n) {
						var r = v();
						(r[e] = { login: t, country: n }), localStorage.setItem(h, JSON.stringify(r));
					}
					function y(e, t, n) {
						var r = t.replace('-', '_'),
							o = n.rewrite(encodeURI('/labels/json/'.concat(e, '_').concat(r, '.json')));
						return (0, l.default)(n.baseUrl + o, {
							method: 'GET',
							headers: { Accept: 'application/json' },
							mode: 'cors',
						})
							.then(function (e) {
								return e.text();
							})
							.then(function (e) {
								return JSON.parse(e);
							});
					}
					function b(e, t, n) {
						return _.apply(this, arguments);
					}
					function _() {
						return (_ = (0, a.default)(
							o.default.mark(function e(t, n, r) {
								var a, l, u, c, h, m;
								return o.default.wrap(
									function (e) {
										for (;;)
											switch ((e.prev = e.next)) {
												case 0:
													if (t !== s.default.defaultLanguage && d.default.contains(r, t)) {
														e.next = 2;
														break;
													}
													return e.abrupt('return', {});
												case 2:
													if (!(a = !f.default.localStorageIsNotSupported())) {
														e.next = 7;
														break;
													}
													if (!(l = v())[t]) {
														e.next = 7;
														break;
													}
													return e.abrupt('return', l[t]);
												case 7:
													return (e.prev = 7), (e.next = 10), Promise.all([y('login', t, n), y('country', t, n)]);
												case 10:
													return (
														(u = e.sent),
														(c = (0, i.default)(u, 2)),
														(h = c[0]),
														(m = c[1]),
														a && g(t, h, m),
														e.abrupt('return', { login: h, country: m })
													);
												case 18:
													return (
														(e.prev = 18),
														(e.t0 = e.catch(7)),
														p.default.warn('Unable to load language: ' + t),
														e.abrupt('return', {})
													);
												case 22:
												case 'end':
													return e.stop();
											}
									},
									e,
									null,
									[[7, 18]]
								);
							})
						)).apply(this, arguments);
					}
					var w,
						O = {
							login: c.default,
							country: u.default,
							courage: c.default,
							currentLanguage: null,
							isLoaded: function (e) {
								return this.currentLanguage === e;
							},
							remove: function () {
								this.currentLanguage = null;
							},
							loadLanguage:
								((w = (0, a.default)(
									o.default.mark(function e(t, n, r, i) {
										var a, s, l;
										return o.default.wrap(
											function (e) {
												for (;;)
													switch ((e.prev = e.next)) {
														case 0:
															return (a = m(n)), (s = t.toLowerCase()), (e.next = 4), b(t, r, i);
														case 4:
															(l = e.sent),
																(this.login = d.default.extend({}, c.default, l.login)),
																(this.country = d.default.extend({}, u.default, l.country)),
																(this.courage = d.default.extend({}, c.default, l.login)),
																a[s] &&
																	(d.default.extend(this.login, a[s].login),
																	d.default.extend(this.country, a[s].country),
																	d.default.extend(this.courage, a[s].login)),
																(this.currentLanguage = t);
														case 10:
														case 'end':
															return e.stop();
													}
											},
											e,
											this
										);
									})
								)),
								function (e, t, n, r) {
									return w.apply(this, arguments);
								}),
						};
					(t.default = O), (e.exports = t.default);
				},
				13671: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.WebauthnAbortError =
							t.WebAuthnError =
							t.UnsupportedBrowserError =
							t.U2FError =
							t.RegistrationError =
							t.OAuthError =
							t.ConfiguredFlowError =
							t.ConfigError =
							t.AuthStopPollInitiationError =
								void 0);
					var o = r(n(78463)),
						i = r(n(39131)),
						a = r(n(77111)),
						s = r(n(35075)),
						l = r(n(35432)),
						u = r(n(2132)),
						c = r(n(19457)),
						d = n(71244),
						f = r(n(35546));
					function p(e) {
						var t = (function () {
							if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
							if (Reflect.construct.sham) return !1;
							if ('function' == typeof Proxy) return !0;
							try {
								return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
							} catch (e) {
								return !1;
							}
						})();
						return function () {
							var n,
								r = (0, u.default)(e);
							if (t) {
								var o = (0, u.default)(this).constructor;
								n = Reflect.construct(r, arguments, o);
							} else n = r.apply(this, arguments);
							return (0, l.default)(this, n);
						};
					}
					var h = (function (e) {
							(0, s.default)(n, e);
							var t = p(n);
							function n(e) {
								var r;
								return (
									(0, i.default)(this, n),
									(r = t.call(this, e)),
									Object.setPrototypeOf((0, a.default)(r), (this instanceof n ? this.constructor : void 0).prototype),
									r
								);
							}
							return (0, o.default)(n);
						})((0, c.default)(Error)),
						m = (function (e) {
							(0, s.default)(n, e);
							var t = p(n);
							function n(e) {
								var r;
								return (
									(0, i.default)(this, n),
									((r = t.call(this, e || (0, d.loc)('error.config'))).name = f.default.CONFIG_ERROR),
									r
								);
							}
							return (0, o.default)(n);
						})(h);
					t.ConfigError = m;
					var v = (function (e) {
						(0, s.default)(n, e);
						var t = p(n);
						function n(e) {
							var r;
							return (
								(0, i.default)(this, n),
								((r = t.call(this, e || (0, d.loc)('error.unsupported.browser'))).name =
									f.default.UNSUPPORTED_BROWSER_ERROR),
								r
							);
						}
						return (0, o.default)(n);
					})(h);
					t.UnsupportedBrowserError = v;
					var g = (function (e) {
						(0, s.default)(n, e);
						var t = p(n);
						function n() {
							var e;
							(0, i.default)(this, n);
							for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++) o[a] = arguments[a];
							return ((e = t.call.apply(t, [this].concat(o))).name = f.default.OAUTH_ERROR), e;
						}
						return (0, o.default)(n);
					})(h);
					t.OAuthError = g;
					var y = (function (e) {
						(0, s.default)(n, e);
						var t = p(n);
						function n() {
							var e;
							(0, i.default)(this, n);
							for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++) o[a] = arguments[a];
							return ((e = t.call.apply(t, [this].concat(o))).name = f.default.REGISTRATION_FAILED), e;
						}
						return (0, o.default)(n);
					})(h);
					t.RegistrationError = y;
					var b = (function (e) {
						(0, s.default)(n, e);
						var t = p(n);
						function n() {
							var e;
							(0, i.default)(this, n);
							for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++) o[a] = arguments[a];
							return ((e = t.call.apply(t, [this].concat(o))).name = f.default.AUTH_STOP_POLL_INITIATION_ERROR), e;
						}
						return (0, o.default)(n);
					})(h);
					t.AuthStopPollInitiationError = b;
					var _ = (function (e) {
						(0, s.default)(n, e);
						var t = p(n);
						function n(e) {
							var r, o, a;
							return (
								(0, i.default)(this, n),
								((a = t.call(
									this,
									null === (r = e.xhr) || void 0 === r || null === (o = r.responseJSON) || void 0 === o
										? void 0
										: o.errorSummary
								)).name = f.default.U2F_ERROR),
								(a.xhr = e.xhr),
								a
							);
						}
						return (0, o.default)(n);
					})(h);
					t.U2FError = _;
					var w = (function (e) {
						(0, s.default)(n, e);
						var t = p(n);
						function n(e) {
							var r, o, a;
							return (
								(0, i.default)(this, n),
								((a = t.call(
									this,
									null === (r = e.xhr) || void 0 === r || null === (o = r.responseJSON) || void 0 === o
										? void 0
										: o.errorSummary
								)).name = f.default.WEB_AUTHN_ERROR),
								(a.xhr = e.xhr),
								a
							);
						}
						return (0, o.default)(n);
					})(h);
					t.WebAuthnError = w;
					var O = (function (e) {
						(0, s.default)(n, e);
						var t = p(n);
						function n() {
							var e;
							(0, i.default)(this, n);
							for (var r = arguments.length, o = new Array(r), a = 0; a < r; a++) o[a] = arguments[a];
							return ((e = t.call.apply(t, [this].concat(o))).name = f.default.WEBAUTHN_ABORT_ERROR), e;
						}
						return (0, o.default)(n);
					})(h);
					t.WebauthnAbortError = O;
					var k = (function (e) {
						(0, s.default)(n, e);
						var t = p(n);
						function n(e, r) {
							var o;
							return (
								(0, i.default)(this, n),
								((o = t.call(this, e)).name = f.default.CONFIGURED_FLOW_ERROR),
								(o.flowSetting = r),
								o
							);
						}
						return (0, o.default)(n);
					})(h);
					t.ConfiguredFlowError = k;
				},
				45570: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.UserNotAssignedError =
							t.TypedOAuthError =
							t.RecoverableError =
							t.NonRecoverableError =
							t.MfaRequiredError =
							t.JITProfileProvisioningError =
							t.ClockDriftError =
								void 0),
						(t.getTypedOAuthError = function (e) {
							switch (e.errorCode) {
								case 'access_denied':
									return new y(e);
								case 'jit_failure_missing_fields':
								case 'jit_failure_invalid_login_format':
								case 'jit_failure_values_not_match_pattern':
								case 'jit_failure_values_too_long':
								case 'jit_failure_invalid_locale':
									return new b(e);
								case 'login_required':
									if (
										'The client specified not to prompt, but the client app requires re-authentication or MFA.' ===
										e.message
									)
										return new _(e);
								case 'INTERNAL':
									if ('The JWT was issued in the future' === e.message) return new g(e);
								default:
									return new m(e, Object);
							}
						});
					var o = r(n(35075)),
						i = r(n(35432)),
						a = r(n(2132)),
						s = r(n(78463)),
						l = r(n(39131)),
						u = n(71244),
						c = n(13671);
					function d(e) {
						var t = (function () {
							if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
							if (Reflect.construct.sham) return !1;
							if ('function' == typeof Proxy) return !0;
							try {
								return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
							} catch (e) {
								return !1;
							}
						})();
						return function () {
							var n,
								r = (0, a.default)(e);
							if (t) {
								var o = (0, a.default)(this).constructor;
								n = Reflect.construct(r, arguments, o);
							} else n = r.apply(this, arguments);
							return (0, i.default)(this, n);
						};
					}
					var f = (0, s.default)(function e() {
							(0, l.default)(this, e), (this.inline = !0);
						}),
						p = (0, s.default)(function e() {
							(0, l.default)(this, e), (this.terminal = !0);
						}),
						h = (function (e) {
							(0, o.default)(n, e);
							var t = d(n);
							function n(e, r) {
								var o;
								return (
									(0, l.default)(this, n),
									((o = t.call(this, e.message)).errorType = new r()),
									(o.orginalError = e),
									(o.errorDetails = {
										errorSummary: o.getErrorSummary(),
										errorCode: e.errorCode,
										errorCauses: 'errorCauses' in e ? e.errorCauses : void 0,
									}),
									o
								);
							}
							return (
								(0, s.default)(n, [
									{
										key: 'getErrorSummary',
										value: function () {
											return this.orginalError.errorSummary;
										},
									},
									{
										key: 'is',
										value: function (e) {
											var t;
											return Boolean(
												null === (t = Object.getOwnPropertyDescriptor(this.errorType, e)) || void 0 === t
													? void 0
													: t.value
											);
										},
									},
								]),
								n
							);
						})(c.OAuthError);
					t.TypedOAuthError = h;
					var m = (function (e) {
						(0, o.default)(n, e);
						var t = d(n);
						function n() {
							return (0, l.default)(this, n), t.apply(this, arguments);
						}
						return (0, s.default)(n);
					})(h);
					t.RecoverableError = m;
					var v = (function (e) {
						(0, o.default)(n, e);
						var t = d(n);
						function n() {
							return (0, l.default)(this, n), t.apply(this, arguments);
						}
						return (0, s.default)(n);
					})(h);
					t.NonRecoverableError = v;
					var g = (function (e) {
						(0, o.default)(n, e);
						var t = d(n);
						function n(e) {
							return (0, l.default)(this, n), t.call(this, e, p);
						}
						return (
							(0, s.default)(n, [
								{
									key: 'getErrorSummary',
									value: function () {
										return (0, u.loc)('error.unsynced.clock', 'login');
									},
								},
							]),
							n
						);
					})(m);
					t.ClockDriftError = g;
					var y = (function (e) {
						(0, o.default)(n, e);
						var t = d(n);
						function n(e) {
							return (0, l.default)(this, n), t.call(this, e, f);
						}
						return (0, s.default)(n);
					})(m);
					t.UserNotAssignedError = y;
					var b = (function (e) {
						(0, o.default)(n, e);
						var t = d(n);
						function n(e) {
							return (0, l.default)(this, n), t.call(this, e, f);
						}
						return (
							(0, s.default)(n, [
								{
									key: 'getErrorSummary',
									value: function () {
										return (0, u.loc)('error.jit_failure', 'login');
									},
								},
							]),
							n
						);
					})(m);
					t.JITProfileProvisioningError = b;
					var _ = (function (e) {
						(0, o.default)(n, e);
						var t = d(n);
						function n(e) {
							return (0, l.default)(this, n), t.call(this, e, f);
						}
						return (
							(0, s.default)(n, [
								{
									key: 'getErrorSummary',
									value: function () {
										return (0, u.loc)('error.mfa.required', 'login');
									},
								},
							]),
							n
						);
					})(v);
					t.MfaRequiredError = _;
				},
				71244: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.loc = t.doesTranslationExist = void 0);
					var o = r(n(12990)),
						i = r(n(52115));
					t.doesTranslationExist = function (e) {
						var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 'login',
							n = a(t);
						return !(null == n || !n[e]);
					};
					t.loc = function (e) {
						var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 'login',
							n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
							r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
							o = a(t);
						if (!o) return s(e, t, 'bundle'), 'L10N_ERROR[' + t + ']';
						var i = o[e];
						try {
							return (i = u(i, (n = n && n.slice ? n.slice(0) : []))) || (s(e, t, 'key'), 'L10N_ERROR[' + e + ']');
						} catch (n) {
							return r || s(e, t, 'parameters'), 'L10N_ERROR[' + e + ']';
						}
					};
					function a(e) {
						if (!e) {
							var t = Object.keys(i.default).filter(function (e) {
								return 'object' === (0, o.default)(e);
							})[0];
							return i.default[t];
						}
						var n,
							r,
							a = (function (e) {
								if (/-/.test(e)) {
									var t = e.split('-');
									return (t[1] = t[1].toUpperCase()), t.join('_');
								}
								return e;
							})(
								(null === (n = window) || void 0 === n || null === (r = n.okta) || void 0 === r ? void 0 : r.locale) ||
									'en'
							);
						return i.default[''.concat(e, '_').concat(a)] || i.default[e];
					}
					function s(e, t, n) {
						var r = l('okta-i18n-error', { detail: { type: 'l10n-error', key: e, bundleName: t, reason: n } });
						r && document.dispatchEvent(r);
					}
					var l = function (e, t) {
						if ('function' == typeof window.CustomEvent) return new CustomEvent(e, t);
						if (!window.CustomEvent) {
							t = t || { bubbles: !1, cancelable: !1, detail: null };
							var n = document.createEvent('CustomEvent');
							return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n;
						}
					};
					function u(e, t) {
						function n() {
							throw new Error('Mismatch number of variables: ' + e + ', ' + JSON.stringify(t));
						}
						for (var r = e, o = e, i = 0, a = t.length; i < a; i++) {
							var s = String(t[i]),
								l = new RegExp('\\{' + i + '\\}', 'g');
							(o = o.replace(l, s)), (null != s && o !== r) || n(), (r = o);
						}
						return /\{[\d+]\}/.test(o) && n(), o;
					}
				},
				26207: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(45385)),
						i = r(n(91939)),
						a = r(n(61525)),
						s = r(n(24687)),
						l = r(n(98318)),
						u = r(n(93100)),
						c = r(n(93788)),
						d = r(n(43252)),
						f = r(n(76920)),
						p = r(n(4374)),
						h = r(n(90192)),
						m = r(n(66493)),
						v = r(n(87459)),
						g = r(n(83567)),
						y = r(n(40471)),
						b = r(n(25523)),
						_ = r(n(6418)),
						w = r(n(98702)),
						O = r(n(33874)),
						k = r(n(70567)),
						x = r(n(32436)),
						E = r(n(41438)),
						T = r(n(87312)),
						S = r(n(85584)),
						A = r(n(43125)),
						C = r(n(63824)),
						P = r(n(53177)),
						R = r(n(38889)),
						I = r(n(2093)),
						N = r(n(61437)),
						M = r(n(94408)),
						j = r(n(40635)),
						D = r(n(32992)),
						L = r(n(47685)),
						U = r(n(26e3)),
						F = r(n(29161)),
						B = r(n(31539)),
						V = r(n(37210)),
						Z = r(n(23947)),
						H = r(n(33243)),
						q = r(n(46615)),
						W = r(n(79518)),
						K = r(n(79636)),
						$ = r(n(30929)),
						z = r(n(94617)),
						G = r(n(78070)),
						Y = r(n(72468)),
						J = r(n(15629)),
						Q = r(n(68358)),
						X = r(n(38864)),
						ee = r(n(92835)),
						te = r(n(45375)),
						ne = r(n(25152)),
						re = r(n(73269)),
						oe = r(n(75996)),
						ie = r(n(67934)),
						ae = r(n(20109)),
						se = r(n(9695)),
						le = r(n(94164)),
						ue = r(n(35546)),
						ce = ie.default.extend({
							routes: {
								'': 'defaultAuth',
								'signin': 'primaryAuth',
								'signin/okta/:username': 'primaryAuth',
								'signin/verify/duo/web': 'verifyDuo',
								'signin/verify/piv': 'verifyPIV',
								'signin/poll': 'poll',
								'signin/verify/fido/webauthn': 'verifyWebauthn',
								'signin/verify/webauthn': 'verifyWebauthn',
								'signin/verify/fido/u2f': 'verifyU2F',
								'signin/verify/u2f': 'verifyU2F',
								'signin/verify/generic_saml/assertion:saml2': 'verifySAMLFactor',
								'signin/verify/generic_oidc/assertion:oidc': 'verifyOIDCFactor',
								'signin/verify/custom/claims_provider': 'verifyClaimsFactor',
								'signin/verify/:factorType': 'verifyNoProvider',
								'signin/verify/:provider/:factorType(/:factorIndex)': 'verify',
								'signin/enroll': 'enrollChoices',
								'signin/enroll/duo/web': 'enrollDuo',
								'signin/enroll/okta/question': 'enrollQuestion',
								'signin/enroll/okta/password': 'enrollPassword',
								'signin/enroll/okta/sms': 'enrollSms',
								'signin/enroll/okta/call': 'enrollCall',
								'signin/enroll/okta/email': 'enrollEmail',
								'signin/enroll-activate/okta/sms': 'enrollSms',
								'signin/enroll-activate/okta/call': 'enrollCall',
								'signin/enroll/rsa/token': 'enrollRsa',
								'signin/enroll/del_oath/token': 'enrollOnPrem',
								'signin/enroll/symantec/token': 'enrollSymantecVip',
								'signin/enroll/yubico/token:hardware': 'enrollYubikey',
								'signin/enroll/fido/webauthn': 'enrollWebauthn',
								'signin/enroll/fido/u2f': 'enrollU2F',
								'signin/enroll/generic_saml/assertion:saml2': 'enrollSAMLFactor',
								'signin/enroll/generic_oidc/assertion:oidc': 'enrollOIDCFactor',
								'signin/enroll/custom/claims_provider': 'enrollClaimsFactor',
								'signin/enroll/custom/token:hotp': 'enrollHotpFactor',
								'signin/enroll/:provider/:factorType': 'enrollTotpFactor',
								'signin/enroll-activate/okta/email': 'enrollActivateEmail',
								'signin/enroll-activate/okta/push': 'scanBarcodePushFactor',
								'signin/enroll-activate/okta/push/manual': 'manualSetupPushFactor',
								'signin/enroll-activate/okta/push/sent': 'activationLinkSent',
								'signin/enroll-activate/okta/token:software:totp/passcode': 'enterPasscodeInPushEnrollmentFlow',
								'signin/enroll-activate/custom/claims_provider': 'enrollActivateClaimsFactor',
								'signin/enroll-activate/:provider/:factorType': 'scanBarcodeTotpFactor',
								'signin/enroll-activate/:provider/:factorType/activate': 'activateTotpFactor',
								'signin/enroll-activate/:provider/:factorType/manual': 'manualSetupTotpFactor',
								'signin/password-expired': 'passwordExpired',
								'signin/custom-password-expired': 'customPasswordExpired',
								'signin/forgot-password': 'forgotPassword',
								'signin/recovery-challenge': 'recoveryChallenge',
								'signin/recovery-emailed': 'recoveryEmailSent',
								'signin/recovery-question': 'recoveryQuestion',
								'signin/password-reset': 'passwordReset',
								'signin/reset-password/:token': 'recoveryLoading',
								'signin/user-unlock/:token': 'recoveryLoading',
								'signin/recovery/:token': 'recoveryLoading',
								'signin/unlock-emailed': 'unlockEmailSent',
								'signin/unlock': 'unlockAccount',
								'signin/account-unlocked': 'accountUnlocked',
								'signin/refresh-auth-state(/:token)': 'refreshAuthState',
								'signin/register': 'register',
								'signin/register-complete': 'registerComplete',
								'signin/error': 'errorState',
								'signin/consent': 'consentRequired',
								'signin/admin-consent': 'adminConsentRequired',
								'signin/enroll-user': 'enrollUser',
								'signin/device-activate-complete': 'deviceActivateComplete',
								'signin/device-activate': 'deviceActivate',
								'signin/idp-discovery-check': 'idpDiscoveryCheck',
								'*wildcard': 'defaultAuth',
							},
							stateLessRouteHandlers: [
								'defaultAuth',
								'idpDiscovery',
								'primaryAuth',
								'forgotPassword',
								'recoveryLoading',
								'unlockAccount',
								'refreshAuthState',
								'register',
								'registerComplete',
								'errorState',
								'verifyPIV',
							],
							defaultAuth: function () {
								window.location.hash !== '#'.concat(ue.default.WIDGET_CONTAINER_ID)
									? this.settings.get('features.idpDiscovery')
										? this.idpDiscovery()
										: this.primaryAuth()
									: document.getElementById(ue.default.WIDGET_CONTAINER_ID).focus();
							},
							idpDiscoveryCheck: function () {
								this.render(j.default, { Beacon: le.default });
							},
							idpDiscovery: function () {
								this.render(M.default, { Beacon: le.default });
							},
							primaryAuth: function (e) {
								this.render(Z.default, { Beacon: le.default, username: e });
							},
							verifyDuo: function () {
								this.render(X.default, { provider: 'DUO', factorType: 'web', Beacon: ae.default });
							},
							verifyPIV: function () {
								this.render(ee.default, { Beacon: se.default });
							},
							poll: function () {
								this.render(V.default);
							},
							verifyWebauthn: function () {
								this.settings.get('features.webauthn')
									? this.render(ne.default, { provider: 'FIDO', factorType: 'webauthn', Beacon: ae.default })
									: this.render(re.default, { provider: 'FIDO', factorType: 'webauthn', Beacon: ae.default });
							},
							verifyU2F: function () {
								this.render(te.default, { provider: 'FIDO', factorType: 'u2f', Beacon: ae.default });
							},
							verifySAMLFactor: function () {
								this.render(Q.default, { provider: 'GENERIC_SAML', factorType: 'assertion:saml2', Beacon: ae.default });
							},
							verifyOIDCFactor: function () {
								this.render(Q.default, { provider: 'GENERIC_OIDC', factorType: 'assertion:oidc', Beacon: ae.default });
							},
							verifyClaimsFactor: function () {
								this.render(Q.default, { provider: 'CUSTOM', factorType: 'claims_provider', Beacon: ae.default });
							},
							verify: function (e, t, n) {
								this.render(U.default, {
									provider: e.toUpperCase(),
									factorType: t,
									factorIndex: n,
									Beacon: ae.default,
								});
							},
							verifyNoProvider: function (e) {
								this.render(U.default, { factorType: e, Beacon: ae.default });
							},
							enrollChoices: function () {
								this.render(v.default, { Beacon: le.default });
							},
							enrollDuo: function () {
								this.render(y.default, { provider: 'DUO', factorType: 'web', Beacon: ae.default });
							},
							enrollQuestion: function () {
								this.render(k.default, { provider: 'OKTA', factorType: 'question', Beacon: ae.default });
							},
							enrollPassword: function () {
								this.render(O.default, { provider: 'OKTA', factorType: 'password', Beacon: ae.default });
							},
							enrollSms: function () {
								this.render(m.default, { provider: 'OKTA', factorType: 'sms', Beacon: ae.default });
							},
							enrollCall: function () {
								this.render(m.default, { provider: 'OKTA', factorType: 'call', Beacon: ae.default });
							},
							enrollEmail: function () {
								this.render(b.default, { provider: 'OKTA', factorType: 'email', Beacon: ae.default });
							},
							enrollActivateEmail: function () {
								this.render(h.default, { provider: 'OKTA', factorType: 'email', Beacon: ae.default });
							},
							enrollRsa: function () {
								this.render(w.default, { provider: 'RSA', factorType: 'token', Beacon: ae.default });
							},
							enrollOnPrem: function () {
								this.render(w.default, { provider: 'DEL_OATH', factorType: 'token', Beacon: ae.default });
							},
							enrollSymantecVip: function () {
								this.render(x.default, { provider: 'SYMANTEC', factorType: 'token', Beacon: ae.default });
							},
							enrollYubikey: function () {
								this.render(P.default, { provider: 'YUBICO', factorType: 'token:hardware', Beacon: ae.default });
							},
							enrollSAMLFactor: function () {
								this.render(g.default, { provider: 'GENERIC_SAML', factorType: 'assertion:saml2', Beacon: ae.default });
							},
							enrollOIDCFactor: function () {
								this.render(g.default, { provider: 'GENERIC_OIDC', factorType: 'assertion:oidc', Beacon: ae.default });
							},
							enrollClaimsFactor: function () {
								this.render(g.default, { provider: 'CUSTOM', factorType: 'claims_provider', Beacon: ae.default });
							},
							enrollActivateClaimsFactor: function () {
								this.render(p.default, { provider: 'CUSTOM', factorType: 'claims_provider', Beacon: ae.default });
							},
							enrollTotpFactor: function (e, t) {
								this.render(E.default, { provider: e.toUpperCase(), factorType: t, Beacon: ae.default });
							},
							enrollHotpFactor: function () {
								this.render(_.default, { provider: 'CUSTOM', factorType: 'token:hotp', Beacon: ae.default });
							},
							enrollWebauthn: function () {
								this.settings.get('features.webauthn')
									? this.render(A.default, { provider: 'FIDO', factorType: 'webauthn', Beacon: ae.default })
									: this.render(C.default, { provider: 'FIDO', factorType: 'webauthn', Beacon: ae.default });
							},
							enrollU2F: function () {
								this.render(T.default, { provider: 'FIDO', factorType: 'u2f', Beacon: ae.default });
							},
							scanBarcodeTotpFactor: function (e, t) {
								this.render(l.default, { provider: e.toUpperCase(), factorType: t, Beacon: ae.default });
							},
							scanBarcodePushFactor: function () {
								this.render(s.default, { provider: 'OKTA', factorType: 'push', Beacon: ae.default });
							},
							activateTotpFactor: function (e, t) {
								this.render(i.default, { provider: e.toUpperCase(), factorType: t, Beacon: ae.default });
							},
							manualSetupTotpFactor: function (e, t) {
								this.render(L.default, { provider: e.toUpperCase(), factorType: t, Beacon: ae.default });
							},
							manualSetupPushFactor: function () {
								this.render(D.default, { provider: 'OKTA', factorType: 'push', Beacon: ae.default });
							},
							activationLinkSent: function () {
								this.render(R.default, { provider: 'OKTA', factorType: 'push', Beacon: ae.default });
							},
							enterPasscodeInPushEnrollmentFlow: function () {
								this.render(I.default, { provider: 'OKTA', factorType: 'token:software:totp', Beacon: ae.default });
							},
							passwordExpired: function () {
								this.render(F.default, { Beacon: le.default });
							},
							customPasswordExpired: function () {
								this.render(c.default, { Beacon: le.default });
							},
							forgotPassword: function () {
								this.render(N.default);
							},
							recoveryChallenge: function () {
								this.render(q.default, { Beacon: le.default });
							},
							recoveryEmailSent: function () {
								this.render(H.default, { Beacon: le.default });
							},
							unlockEmailSent: function () {
								this.render(J.default, { Beacon: le.default });
							},
							recoveryQuestion: function () {
								this.render(K.default, { Beacon: le.default });
							},
							passwordReset: function () {
								this.render(B.default, { Beacon: le.default });
							},
							recoveryLoading: function (e) {
								this.render(W.default, { token: e, Beacon: le.default });
							},
							unlockAccount: function () {
								this.render(Y.default);
							},
							accountUnlocked: function () {
								this.render(o.default, { Beacon: le.default });
							},
							refreshAuthState: function (e) {
								this.render($.default, { token: e, Beacon: le.default });
							},
							register: function () {
								this.render(G.default);
							},
							registerComplete: function () {
								this.render(z.default);
							},
							errorState: function () {
								this.render(oe.default, { Beacon: le.default });
							},
							consentRequired: function () {
								this.render(u.default);
							},
							adminConsentRequired: function () {
								this.render(a.default);
							},
							enrollUser: function () {
								this.render(S.default);
							},
							deviceActivate: function () {
								this.render(d.default);
							},
							deviceActivateComplete: function () {
								this.render(f.default);
							},
						});
					(t.default = ce), (e.exports = t.default);
				},
				4449: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(12990)),
						i = r(n(39131)),
						a = r(n(78463)),
						s = r(n(35075)),
						l = r(n(35432)),
						u = r(n(2132)),
						c = r(n(2875)),
						d = n(6475),
						f = r(n(66757)),
						p = r(n(1752));
					function h(e) {
						var t = (function () {
							if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
							if (Reflect.construct.sham) return !1;
							if ('function' == typeof Proxy) return !0;
							try {
								return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
							} catch (e) {
								return !1;
							}
						})();
						return function () {
							var n,
								r = (0, u.default)(e);
							if (t) {
								var o = (0, u.default)(this).constructor;
								n = Reflect.construct(r, arguments, o);
							} else n = r.apply(this, arguments);
							return (0, l.default)(this, n);
						};
					}
					var m = 'no-beacon',
						v = 'beacon-small beacon-loading';
					function g(e) {
						return e && e.equals(p.default);
					}
					function y(e) {
						e.currentBeacon && (e.currentBeacon.remove(), (e.currentBeacon = null));
					}
					function b(e, t, n, r) {
						e.add(t, { selector: n, options: r }), (e.currentBeacon = e.first());
					}
					var _ = (function (e) {
						(0, s.default)(n, e);
						var t = h(n);
						function n() {
							return (0, i.default)(this, n), t.apply(this, arguments);
						}
						return (
							(0, a.default)(n, [
								{
									key: 'preinitialize',
									value: function () {
										(this.currentBeacon = null),
											(this.template = c.default.template({
												1: function (e, t, n, r, i) {
													var a,
														s = null != t ? t : e.nullContext || {},
														l = e.hooks.helperMissing,
														u = 'function',
														c = e.escapeExpression,
														d =
															e.lookupProperty ||
															function (e, t) {
																if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
															};
													return (
														'<h1><img src="' +
														c(
															((a = null != (a = d(n, 'logo') || (null != t ? d(t, 'logo') : t)) ? a : l),
															(0, o.default)(a) === u
																? a.call(s, {
																		name: 'logo',
																		hash: {},
																		data: i,
																		loc: { start: { line: 1, column: 71 }, end: { line: 1, column: 79 } },
																  })
																: a)
														) +
														'" class="auth-org-logo" alt="' +
														c(
															((a = null != (a = d(n, 'logoText') || (null != t ? d(t, 'logoText') : t)) ? a : l),
															(0, o.default)(a) === u
																? a.call(s, {
																		name: 'logoText',
																		hash: {},
																		data: i,
																		loc: { start: { line: 1, column: 108 }, end: { line: 1, column: 120 } },
																  })
																: a)
														) +
														' logo" aria-label="' +
														c(
															((a = null != (a = d(n, 'logoText') || (null != t ? d(t, 'logoText') : t)) ? a : l),
															(0, o.default)(a) === u
																? a.call(s, {
																		name: 'logoText',
																		hash: {},
																		data: i,
																		loc: { start: { line: 1, column: 139 }, end: { line: 1, column: 151 } },
																  })
																: a)
														) +
														' logo"></h1>'
													);
												},
												compiler: [8, '>= 4.3.0'],
												main: function (e, t, n, r, o) {
													var i,
														a =
															e.lookupProperty ||
															function (e, t) {
																if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
															};
													return (
														'<div class="okta-sign-in-header auth-header">' +
														(null !=
														(i = a(n, 'if').call(null != t ? t : e.nullContext || {}, null != t ? a(t, 'logo') : t, {
															name: 'if',
															hash: {},
															fn: e.program(1, o, 0),
															inverse: e.noop,
															data: o,
															loc: { start: { line: 1, column: 45 }, end: { line: 1, column: 170 } },
														}))
															? i
															: '') +
														'<div data-type="beacon-container" class="beacon-container"></div></div><div class="auth-content"><div class="auth-content-inner"></div></div>'
													);
												},
												useData: !0,
											}));
										for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
										d.View.prototype.preinitialize.apply(this, t);
									},
								},
								{
									key: 'initialize',
									value: function (e) {
										e.settings.get('features.securityImage') ||
											(this.$el.addClass(m),
											this.listenTo(e.appState, 'loading', this.setLoadingBeacon),
											this.listenTo(e.appState, 'removeLoading', this.removeLoadingBeacon));
									},
								},
								{
									key: 'setBeacon',
									value: function (e, t) {
										var n = this,
											r = '[data-type="beacon-container"]',
											o = this.$(r),
											i = (function (e, t, n) {
												return e || t
													? !e && n.loading
														? 'load'
														: e && g(e)
														? t
															? 'swap'
															: 'unload'
														: e && e.equals(t, n)
														? 'same'
														: !e && t
														? 'add'
														: e && !t
														? 'remove'
														: e instanceof t
														? 'fade'
														: 'swap'
													: 'none';
											})(this.currentBeacon, e, t);
										switch (i) {
											case 'none':
												return void this.$el.addClass(m);
											case 'same':
												return;
											case 'add':
												return this.$el.removeClass(m), b(this, e, r, t), f.default.explode(o);
											case 'remove':
												return (
													this.$el.addClass(m),
													f.default
														.implode(o)
														.then(function () {
															y(n);
														})
														.done()
												);
											case 'fade':
												if (!this.currentBeacon.fadeOut)
													throw new Error('The current beacon is missing the "fadeOut" method');
												return (
													(t.animate = !0),
													this.currentBeacon
														.fadeOut()
														.then(function () {
															y(n), b(n, e, r, t);
														})
														.done()
												);
											case 'swap':
												return f.default
													.swapBeacons({
														$el: o,
														swap: function () {
															var i = g(n.currentBeacon);
															y(n), n.$el.removeClass(m), i && o.removeClass(v), b(n, e, r, t);
														},
													})
													.done();
											case 'load':
												return o.addClass(v), b(this, e, r, t), f.default.explode(o);
											case 'unload':
												return this.removeLoadingBeacon();
											default:
												throw new Error('the "' + i + '" is not recognized');
										}
									},
								},
								{
									key: 'setLoadingBeacon',
									value: function (e) {
										e && !g(this.currentBeacon) && this.setBeacon(p.default, { loading: !0 });
									},
								},
								{
									key: 'removeLoadingBeacon',
									value: function () {
										var e = this;
										if (g(this.currentBeacon)) {
											var t = this.$('[data-type="beacon-container"]');
											return f.default
												.implode(t)
												.then(function () {
													y(e), t.removeClass(v);
												})
												.done();
										}
									},
								},
								{
									key: 'getTemplateData',
									value: function () {
										return this.settings.toJSON({ verbose: !0 });
									},
								},
								{
									key: 'getContentEl',
									value: function () {
										return this.$('.auth-content-inner');
									},
								},
							]),
							n
						);
					})(d.View);
					(t.default = _), (e.exports = t.default);
				},
				76785: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(70232)),
						i = r(n(15985)),
						a = r(n(31049)),
						s = r(n(39131)),
						l = r(n(78463)),
						u = r(n(35075)),
						c = r(n(35432)),
						d = r(n(2132)),
						f = n(6475),
						p = r(n(27447)),
						h = r(n(52115)),
						m = r(n(34425)),
						v = r(n(28766)),
						g = r(n(35546)),
						y = n(13671),
						b = r(n(36894)),
						_ = r(n(42804)),
						w = r(n(84757)),
						O = r(n(4449)),
						k = r(n(81325)),
						x = r(n(69977)),
						E = n(98462),
						T = r(n(26368)),
						S = n(86007),
						A = r(n(16100));
					function C(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function P(e) {
						for (var t = 1; t < arguments.length; t++) {
							var n = null != arguments[t] ? arguments[t] : {};
							t % 2
								? C(Object(n), !0).forEach(function (t) {
										(0, i.default)(e, t, n[t]);
								  })
								: Object.getOwnPropertyDescriptors
								? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
								: C(Object(n)).forEach(function (t) {
										Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
								  });
						}
						return e;
					}
					function R(e) {
						var t = (function () {
							if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
							if (Reflect.construct.sham) return !1;
							if ('function' == typeof Proxy) return !0;
							try {
								return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
							} catch (e) {
								return !1;
							}
						})();
						return function () {
							var n,
								r = (0, d.default)(e);
							if (t) {
								var o = (0, d.default)(this).constructor;
								n = Reflect.construct(r, arguments, o);
							} else n = r.apply(this, arguments);
							return (0, c.default)(this, n);
						};
					}
					var I = (function (e) {
						(0, u.default)(c, e);
						var t,
							n,
							r,
							i = R(c);
						function c(e) {
							var t;
							(0, s.default)(this, c),
								((t = i.call(this, e)).Events = f.Backbone.Events),
								(t.hasControllerRendered = !1),
								e.globalSuccessFn || (e.globalSuccessFn = function () {}),
								e.globalErrorFn ||
									(e.globalErrorFn = function (e) {
										b.default.error(e);
									}),
								(t.settings = new p.default(f._.omit(e, 'el', 'hooks'), { parse: !0 })),
								e.el || t.settings.callGlobalError(new y.ConfigError((0, f.loc)('error.required.el'))),
								(0, f.$)('body > div').on('click', function () {}),
								(t.hooks = e.hooks),
								(t.appState = new k.default({}, { settings: t.settings, hooks: t.hooks }));
							var n = new w.default({ appState: t.appState });
							return (
								(0, f.$)(e.el).append(n.render().$el),
								(t.el = '#'.concat(g.default.WIDGET_CONTAINER_ID)),
								(t.header = new O.default({ el: t.el, appState: t.appState, settings: t.settings })),
								t.hide(),
								t.listenTo(t.appState, 'change:deviceFingerprint', t.updateDeviceFingerprint),
								t.listenTo(t.appState, 'restartLoginFlow', t.restartLoginFlow),
								t
							);
						}
						return (
							(0, l.default)(c, [
								{
									key: 'updateDeviceFingerprint',
									value: function () {
										var e = this.settings.getAuthClient(),
											t = this.appState.get('deviceFingerprint');
										t && e.http.setRequestHeader('X-Device-Fingerprint', t);
									},
								},
								{
									key: 'handleIdxResponseFailure',
									value:
										((r = (0, a.default)(
											o.default.mark(function e() {
												var t,
													n = arguments;
												return o.default.wrap(
													function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	return (
																		(t =
																			n.length > 0 && void 0 !== n[0] ? n[0] : { error: 'unknown', details: void 0 }),
																		(t = (0, S.formatError)(t)),
																		(e.next = 4),
																		(0, E.updateAppState)(this.appState, t.details)
																	);
																case 4:
																case 'end':
																	return e.stop();
															}
													},
													e,
													this
												);
											})
										)),
										function () {
											return r.apply(this, arguments);
										}),
								},
								{
									key: 'handleError',
									value:
										((n = (0, a.default)(
											o.default.mark(function e() {
												var t,
													n,
													r = arguments;
												return o.default.wrap(
													function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	return (
																		(t =
																			r.length > 0 && void 0 !== r[0] ? r[0] : { error: 'unknown', details: void 0 }),
																		(n = (0, S.formatError)(P({}, t))),
																		(e.next = 4),
																		(0, E.updateAppState)(this.appState, n.details)
																	);
																case 4:
																case 'end':
																	return e.stop();
															}
													},
													e,
													this
												);
											})
										)),
										function () {
											return n.apply(this, arguments);
										}),
								},
								{
									key: 'render',
									value:
										((t = (0, a.default)(
											o.default.mark(function e(t) {
												var n,
													r,
													i,
													a,
													s,
													l,
													u,
													c = arguments;
												return o.default.wrap(
													function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (
																		((n = c.length > 1 && void 0 !== c[1] ? c[1] : {}),
																		x.default.getLastInitiatedLoginUrl() !== window.location.href &&
																			x.default.removeStateHandle(),
																		this.header.rendered() || (this.el = this.header.render().getContentEl()),
																		h.default.isLoaded(this.settings.get('languageCode')))
																	) {
																		e.next = 6;
																		break;
																	}
																	return (e.next = 6), _.default.loadLanguage(this.appState, this.settings);
																case 6:
																	return (e.prev = 6), (e.next = 9), (0, E.startLoginFlow)(this.settings);
																case 9:
																	if (!(i = e.sent).error) {
																		e.next = 15;
																		break;
																	}
																	return (e.next = 13), this.handleIdxResponseFailure(i.error);
																case 13:
																	e.next = 22;
																	break;
																case 15:
																	if (!this.settings.get('flow') || this.hasControllerRendered) {
																		e.next = 19;
																		break;
																	}
																	return (e.next = 18), (0, E.handleConfiguredFlow)(i, this.settings);
																case 18:
																	i = e.sent;
																case 19:
																	return (
																		!i.requestDidSucceed &&
																			A.default.isIdxSessionExpiredError(i) &&
																			this.settings.getAuthClient().transactionManager.clear(),
																		(e.next = 22),
																		(0, E.updateAppState)(this.appState, i)
																	);
																case 22:
																	e.next = 33;
																	break;
																case 24:
																	if (
																		((e.prev = 24),
																		(e.t0 = e.catch(6)),
																		null === (a = e.t0.is) || void 0 === a || !a.call(e.t0, 'terminal'))
																	) {
																		e.next = 30;
																		break;
																	}
																	this.appState.setNonIdxError(e.t0), (e.next = 33);
																	break;
																case 30:
																	return (r = e.t0), (e.next = 33), this.handleError(e.t0);
																case 33:
																	return (
																		(e.prev = 33),
																		this.settings.unset('stateToken'),
																		this.settings.unset('proxyIdxResponse'),
																		e.finish(33)
																	);
																case 37:
																	this.settings.get('colors.brand') &&
																		!v.default.isLoaded() &&
																		((s = { brand: this.settings.get('colors.brand') }),
																		(l = this.settings.get('cspNonce')),
																		v.default.addStyle(s, l)),
																		this.show(),
																		this.unload(),
																		(u = f._.extend(
																			{ el: this.el, settings: this.settings, appState: this.appState },
																			n
																		)),
																		(this.controller = new t(u)),
																		this.listenTo(this.controller, 'all', this.trigger),
																		this.controller.render(),
																		(this.hasControllerRendered = !0),
																		r && this.settings.callGlobalError(r);
																case 46:
																case 'end':
																	return e.stop();
															}
													},
													e,
													this,
													[[6, 24, 33, 37]]
												);
											})
										)),
										function (e) {
											return t.apply(this, arguments);
										}),
								},
								{
									key: 'updateIdentifierCookie',
									value: function (e) {
										if (this.settings.get('features.rememberMe')) {
											var t,
												n = null == e || null === (t = e.context) || void 0 === t ? void 0 : t.user,
												r = ((null == n ? void 0 : n.value) || {}).identifier;
											r && T.default.setUsernameCookie(r);
										} else T.default.removeUsernameCookie();
									},
								},
								{
									key: 'hasAuthenticationSucceeded',
									value: function (e) {
										var t, n;
										return (
											(null == e || null === (t = e.rawIdxState) || void 0 === t ? void 0 : t.success) ||
											(null == e || null === (n = e.rawIdxState) || void 0 === n
												? void 0
												: n.successWithInteractionCode)
										);
									},
								},
								{
									key: 'restartLoginFlow',
									value: function (e) {
										var t;
										this.settings.getAuthClient().transactionManager.clear(), this.appState.set('idx', void 0);
										var n = this.settings.getAuthClient();
										delete n.options.recoveryToken,
											this.settings.unset('recoveryToken'),
											this.settings.unset('otp'),
											this.controller.stopListening(),
											n.idx.setFlow(
												null !== (t = null != e ? e : this.settings.get('flow')) && void 0 !== t ? t : 'default'
											),
											this.render(this.controller.constructor);
									},
								},
								{
									key: 'start',
									value: function () {
										var e = m.default.supportsPushState();
										f.Router.prototype.start.call(this, { pushState: e });
									},
								},
								{
									key: 'hide',
									value: function () {
										this.header.$el.hide();
									},
								},
								{
									key: 'show',
									value: function () {
										this.header.$el.show();
									},
								},
								{
									key: 'remove',
									value: function () {
										this.unload(),
											this.header.$el.remove(),
											this.stopListening(this.appState),
											this.stopListening(this.settings),
											h.default.remove(),
											f.Backbone.history.stop();
									},
								},
							]),
							c
						);
					})(f.Router);
					I.prototype.Events = f.Backbone.Events;
					var N = I;
					(t.default = N), (e.exports = t.default);
				},
				80585: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(15985)),
						i = r(n(39131)),
						a = r(n(78463)),
						s = r(n(35075)),
						l = r(n(35432)),
						u = r(n(2132)),
						c = r(n(76785)),
						d = r(n(56640));
					function f(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function p(e) {
						var t = (function () {
							if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
							if (Reflect.construct.sham) return !1;
							if ('function' == typeof Proxy) return !0;
							try {
								return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
							} catch (e) {
								return !1;
							}
						})();
						return function () {
							var n,
								r = (0, u.default)(e);
							if (t) {
								var o = (0, u.default)(this).constructor;
								n = Reflect.construct(r, arguments, o);
							} else n = r.apply(this, arguments);
							return (0, l.default)(this, n);
						};
					}
					var h = { '': 'defaultAuth', '*wildcard': 'defaultAuth' },
						m = (function (e) {
							(0, s.default)(n, e);
							var t = p(n);
							function n(e) {
								return (
									(0, i.default)(this, n),
									t.call(
										this,
										(function (e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? f(Object(n), !0).forEach(function (t) {
															(0, o.default)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: f(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										})({ routes: h }, e)
									)
								);
							}
							return (
								(0, a.default)(n, [
									{
										key: 'defaultAuth',
										value: function () {
											this.render(d.default);
										},
									},
								]),
								n
							);
						})(c.default);
					(t.default = m), (e.exports = t.default);
				},
				47550: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.emailVerifyCallback = function (e) {
							return u.apply(this, arguments);
						});
					var o = r(n(70232)),
						i = r(n(15985)),
						a = r(n(31049));
					function s(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function l(e) {
						for (var t = 1; t < arguments.length; t++) {
							var n = null != arguments[t] ? arguments[t] : {};
							t % 2
								? s(Object(n), !0).forEach(function (t) {
										(0, i.default)(e, t, n[t]);
								  })
								: Object.getOwnPropertyDescriptors
								? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
								: s(Object(n)).forEach(function (t) {
										Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
								  });
						}
						return e;
					}
					function u() {
						return (u = (0, a.default)(
							o.default.mark(function e(t) {
								var n, r, i, a, s, u, c;
								return o.default.wrap(function (e) {
									for (;;)
										switch ((e.prev = e.next)) {
											case 0:
												return (
													(n = t.getAuthClient()),
													(r = { exchangeCodeForTokens: !1 }),
													(e.next = 4),
													n.idx.getSavedTransactionMeta()
												);
											case 4:
												if ((i = e.sent) && i.interactionHandle) {
													e.next = 9;
													break;
												}
												return (
													(s = {
														neededToProceed: [],
														rawIdxState: {
															messages: (a = {
																type: 'array',
																value: [
																	{
																		message: 'Enter the OTP in your original browser or device.',
																		i18n: { key: 'idx.enter.otp.in.original.tab' },
																		class: 'INFO',
																	},
																],
															}),
														},
														context: { messages: a },
													}),
													e.abrupt('return', s)
												);
											case 9:
												return (u = t.get('otp')), (e.next = 12), n.idx.proceed(l(l({}, r), {}, { otp: u }));
											case 12:
												return (c = e.sent), e.abrupt('return', c);
											case 14:
											case 'end':
												return e.stop();
										}
								}, e);
							})
						)).apply(this, arguments);
					}
				},
				86007: function (e, t, n) {
					'use strict';
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.formatError = function (e) {
							'string' == typeof e && (e = new Error(e));
							if (o(e)) return a(e);
							if (i(e)) return s(e);
							if (l(e)) return u(e);
							if (c(e)) return d(e);
							return (e = f(e));
						}),
						(t.formatIDXError = f),
						(t.formatInvalidActivationTokenError = s),
						(t.formatInvalidRecoveryTokenError = a),
						(t.formatOIEConfigurationError = d),
						(t.formatOIENotEnabledError = u),
						(t.isInvalidActivationTokenError = i),
						(t.isInvalidRecoveryTokenError = o),
						(t.isOIEConfigurationError = c),
						(t.isOIENotEnabledError = l);
					var r = n(6475);
					function o(e) {
						return (
							'invalid_request' === (null == e ? void 0 : e.error) &&
							'The recovery token is invalid' === e.error_description
						);
					}
					function i(e) {
						return (
							'invalid_request' === (null == e ? void 0 : e.error) &&
							'The activation token is invalid' === e.error_description
						);
					}
					function a(e) {
						var t = f(e),
							n = t.details,
							r = {
								type: 'array',
								value: [{ message: e.error_description, i18n: { key: 'oie.invalid.recovery.token' }, class: 'ERROR' }],
							};
						return (n.rawIdxState.messages = r), (n.context.messages = r), t;
					}
					function s(e) {
						var t = f(e),
							n = t.details,
							r = {
								type: 'array',
								value: [
									{ message: e.error_description, i18n: { key: 'idx.missing.activation.token' }, class: 'ERROR' },
								],
							};
						return (n.rawIdxState.messages = r), (n.context.messages = r), t;
					}
					function l(e) {
						return 'access_denied' === (null == e ? void 0 : e.error) && e.error_description;
					}
					function u(e) {
						var t = f(e).details,
							n = {
								type: 'array',
								value: [{ message: e.error_description, i18n: { key: 'oie.feature.disabled' }, class: 'ERROR' }],
							};
						return (t.rawIdxState.messages = n), (t.context.messages = n), e;
					}
					function c(e) {
						return (null == e ? void 0 : e.error) && e.error_description;
					}
					function d(e) {
						var t = f(e).details,
							n = {
								type: 'array',
								value: [{ message: (0, r.loc)('oie.configuration.error', 'login'), class: 'ERROR', i18n: void 0 }],
							};
						return (t.rawIdxState.messages = n), (t.context.messages = n), e;
					}
					function f(e) {
						var t = e;
						t.details = t.details || {};
						var n = t.details;
						if (
							((n.rawIdxState = n.rawIdxState || {}),
							(n.context = n.context || {}),
							(n.neededToProceed = n.neededToProceed || []),
							!n.rawIdxState.messages)
						) {
							var o = {
								type: 'array',
								value: [{ message: (0, r.loc)('oform.error.unexpected', 'login'), class: 'ERROR', i18n: void 0 }],
							};
							(n.rawIdxState.messages = o), (n.context.messages = o);
						}
						return t;
					}
				},
				86183: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.startLoginFlow = h);
					var o = r(n(70232)),
						i = r(n(15985)),
						a = r(n(31049)),
						s = n(13671),
						l = n(47550),
						u = r(n(69977)),
						c = n(13871);
					function d(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function f(e) {
						for (var t = 1; t < arguments.length; t++) {
							var n = null != arguments[t] ? arguments[t] : {};
							t % 2
								? d(Object(n), !0).forEach(function (t) {
										(0, i.default)(e, t, n[t]);
								  })
								: Object.getOwnPropertyDescriptors
								? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
								: d(Object(n)).forEach(function (t) {
										Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
								  });
						}
						return e;
					}
					var p = (function () {
						var e = (0, a.default)(
							o.default.mark(function e(t) {
								return o.default.wrap(function (e) {
									for (;;)
										switch ((e.prev = e.next)) {
											case 0:
												return e.abrupt(
													'return',
													Promise.resolve({
														rawIdxState: t.get('proxyIdxResponse'),
														context: t.get('proxyIdxResponse'),
														neededToProceed: [],
													})
												);
											case 1:
											case 'end':
												return e.stop();
										}
								}, e);
							})
						);
						return function (t) {
							return e.apply(this, arguments);
						};
					})();
					function h(e) {
						return m.apply(this, arguments);
					}
					function m() {
						return (m = (0, a.default)(
							o.default.mark(function e(t) {
								var n, r, i, a, d, m, v, g, y, b, _;
								return o.default.wrap(
									function (e) {
										for (;;)
											switch ((e.prev = e.next)) {
												case 0:
													if (
														((n = t.getAuthClient()),
														(r = t.toJSON({ verbose: !0 })),
														(i = r.authParams),
														(a = t.get('nonce') || (null == i ? void 0 : i.nonce)),
														(d = f({ exchangeCodeForTokens: !1 }, a && { nonce: a })),
														!t.get('proxyIdxResponse'))
													) {
														e.next = 6;
														break;
													}
													return e.abrupt('return', p(t));
												case 6:
													if ((t.get('overrideExistingStateToken') && u.default.removeStateHandle(), !t.get('otp'))) {
														e.next = 9;
														break;
													}
													return e.abrupt('return', (0, l.emailVerifyCallback)(t));
												case 9:
													if (!t.get('oauth2Enabled')) {
														e.next = 19;
														break;
													}
													return (e.next = 12), n.idx.getSavedTransactionMeta();
												case 12:
													if (e.sent) {
														e.next = 18;
														break;
													}
													if (!(m = n.idx.getFlow()) || m !== c.CONFIGURED_FLOW.PROCEED) {
														e.next = 17;
														break;
													}
													throw new s.ConfiguredFlowError(
														'Unable to proceed: saved transaction could not be loaded',
														m
													);
												case 17:
													return e.abrupt('return', n.idx.start(d));
												case 18:
													return e.abrupt('return', n.idx.proceed(d));
												case 19:
													if (!(v = u.default.getStateHandle())) {
														e.next = 36;
														break;
													}
													return (e.prev = 21), (e.next = 24), n.idx.start(f(f({}, d), {}, { stateHandle: v }));
												case 24:
													if (
														((b = e.sent),
														!(
															(null === (g = b.context) || void 0 === g || null === (y = g.messages) || void 0 === y
																? void 0
																: y.value.length) > 0
														))
													) {
														e.next = 28;
														break;
													}
													throw new Error('saved stateToken is invalid');
												case 28:
													return t.set('stateToken', v), e.abrupt('return', b);
												case 32:
													return (
														(e.prev = 32), (e.t0 = e.catch(21)), u.default.removeStateHandle(), e.abrupt('return', h(t))
													);
												case 36:
													if (!(_ = t.get('stateToken'))) {
														e.next = 39;
														break;
													}
													return e.abrupt('return', n.idx.start(f(f({}, d), {}, { stateHandle: _ })));
												case 39:
													throw new s.ConfigError(
														'Invalid OIDC configuration. Set "clientId" and "redirectUri" in the widget options.'
													);
												case 40:
												case 'end':
													return e.stop();
											}
									},
									e,
									null,
									[[21, 32]]
								);
							})
						)).apply(this, arguments);
					}
				},
				57852: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.updateAppState = function (e, t) {
							return c.apply(this, arguments);
						});
					var o = r(n(70232)),
						i = r(n(31049)),
						a = r(n(69977)),
						s = n(59155),
						l = n(13955),
						u = r(n(58937));
					function c() {
						return (c = (0, i.default)(
							o.default.mark(function e(t, n) {
								var r, i, c, d, f;
								return o.default.wrap(function (e) {
									for (;;)
										switch ((e.prev = e.next)) {
											case 0:
												if (((r = t.settings), (i = t.get('idx')), !r.get('oauth2Enabled'))) {
													e.next = 13;
													break;
												}
												if (!n.interactionCode) {
													e.next = 11;
													break;
												}
												return a.default.removeStateHandle(), (e.next = 8), (0, s.interactionCodeFlow)(r, n);
											case 8:
												return (c = e.sent), t.unset('currentFormName', { silent: !0 }), e.abrupt('return', c);
											case 11:
												e.next = 15;
												break;
											case 13:
												i &&
													a.default.setStateHandle(
														null == n || null === (d = n.context) || void 0 === d ? void 0 : d.stateHandle
													),
													t.get('currentFormName') === l.FORMS.CANCEL_TRANSACTION && a.default.removeStateHandle();
											case 15:
												return (f = (0, u.default)(r, n, i)), (e.next = 18), t.setIonResponse(f);
											case 18:
											case 'end':
												return e.stop();
										}
								}, e);
							})
						)).apply(this, arguments);
					}
				},
				56640: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(70232)),
						i = r(n(15985)),
						a = r(n(31049)),
						s = n(6475),
						l = r(n(68133)),
						u = r(n(16100)),
						c = n(2715),
						d = n(13955),
						f = r(n(74600)),
						p = r(n(90570)),
						h = r(n(69977)),
						m = n(2659),
						v = n(13871),
						g = n(13671),
						y = n(98462),
						b = r(n(26368));
					function _(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function w(e) {
						for (var t = 1; t < arguments.length; t++) {
							var n = null != arguments[t] ? arguments[t] : {};
							t % 2
								? _(Object(n), !0).forEach(function (t) {
										(0, i.default)(e, t, n[t]);
								  })
								: Object.getOwnPropertyDescriptors
								? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
								: _(Object(n)).forEach(function (t) {
										Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
								  });
						}
						return e;
					}
					var O = s.Controller.extend({
						className: 'form-controller',
						appStateEvents: {
							'change:currentFormName': 'handleFormNameChange',
							'afterError': 'handleAfterError',
							'invokeAction': 'handleInvokeAction',
							'saveForm': 'handleSaveForm',
							'switchForm': 'handleSwitchForm',
						},
						preRender: function () {
							this.removeChildren();
						},
						postRender: function () {
							var e = this.options.appState.getCurrentViewState();
							if (e) {
								this.clearMetadata();
								var t = e.name;
								'identify' === t &&
									this.options.settings.get('flow') === v.CONFIGURED_FLOW.RESET_PASSWORD &&
									(t = 'identify-recovery');
								var n = l.default.create(t, this.options.appState.get('authenticatorKey'));
								try {
									this.formView = this.add(n, { options: { currentViewState: e } }).last();
								} catch (e) {
									return void this.options.settings.callGlobalError(e);
								}
								this.triggerAfterRenderEvent();
							}
						},
						clearMetadata: function () {
							var e = this.options.appState.get('currentFormName');
							d.TERMINAL_FORMS.includes(e) && h.default.removeStateHandle();
						},
						triggerAfterRenderEvent: function () {
							var e = this.createAfterEventContext();
							this.trigger('afterRender', e);
						},
						handleFormNameChange: function () {
							this.$el.click(), this.render();
						},
						handleAfterError: function (e) {
							var t = this.createAfterEventContext(),
								n = { xhr: e, errorSummary: e.responseJSON && e.responseJSON.errorSummary };
							this.trigger('afterError', t, n);
						},
						createAfterEventContext: function () {
							var e = this.options.appState.get('currentFormName'),
								t = this.options.appState.get('authenticatorKey'),
								n = this.options.appState.get('authenticatorMethodType'),
								r = this.options.appState.get('isPasswordRecoveryFlow'),
								o = { controller: (0, c.getV1ClassName)(e, t, n, r), formName: e };
							return t && (o.authenticatorKey = t), n && (o.methodType = n), o;
						},
						handleSwitchForm: function (e) {
							this.options.appState.get('messages') && this.options.appState.unset('messages'),
								this.options.appState.set('currentFormName', e);
						},
						handleInvokeAction: function () {
							var e = arguments,
								t = this;
							return (0, a.default)(
								o.default.mark(function n() {
									var r, i, a, l, u, c, f, p, m, v;
									return o.default.wrap(function (n) {
										for (;;)
											switch ((n.prev = n.next)) {
												case 0:
													if (
														((r = e.length > 0 && void 0 !== e[0] ? e[0] : ''),
														(i = e.length > 1 && void 0 !== e[1] ? e[1] : {}),
														(a = !(e.length > 2 && void 0 !== e[2]) || e[2]),
														(l = t.options),
														(u = l.appState),
														(c = l.settings),
														r !== d.ORG_PASSWORD_RECOVERY_LINK || !c.get('oauth2Enabled'))
													) {
														n.next = 7;
														break;
													}
													return u.trigger('restartLoginFlow', 'resetPassword'), n.abrupt('return');
												case 7:
													if (
														((f = u.get('idx')),
														(p = f.context.stateHandle),
														(m = { exchangeCodeForTokens: !1, stateHandle: p }),
														'cancel' !== r)
													) {
														n.next = 17;
														break;
													}
													if (
														(c.getAuthClient().transactionManager.clear({ clearIdxResponse: !1 }),
														h.default.removeStateHandle(),
														u.clearAppStateCache(),
														!c.get('oauth2Enabled'))
													) {
														n.next = 17;
														break;
													}
													return u.trigger('restartLoginFlow'), n.abrupt('return');
												case 17:
													if (
														![
															d.FORMS.LAUNCH_AUTHENTICATOR,
															d.FORMS.CHALLENGE_WEBAUTHN_AUTOFILLUI_AUTHENTICATOR,
														].includes(r) ||
														!i
													) {
														n.next = 22;
														break;
													}
													(m = w(w({}, m), {}, { actions: [{ name: r, params: i }] })), (n.next = 36);
													break;
												case 22:
													if (
														!f.neededToProceed.find(function (e) {
															return e.name === r;
														})
													) {
														n.next = 26;
														break;
													}
													(m = w(w({}, m), {}, { step: r })), (n.next = 36);
													break;
												case 26:
													if (!s._.isFunction(f.actions[r])) {
														n.next = 30;
														break;
													}
													(m = w(w({}, m), {}, { actions: [{ name: r, params: i }] })), (n.next = 36);
													break;
												case 30:
													if (
														((v = new g.ConfigError('Invalid action selected: '.concat(r))),
														t.options.settings.callGlobalError(v),
														!a)
													) {
														n.next = 35;
														break;
													}
													return (n.next = 35), t.showFormErrors(t.formView.model, v, t.formView.form);
												case 35:
													return n.abrupt('return');
												case 36:
													return (n.next = 38), t.invokeAction(m);
												case 38:
												case 'end':
													return n.stop();
											}
									}, n);
								})
							)();
						},
						invokeAction: function (e) {
							var t = this;
							return (0, a.default)(
								o.default.mark(function n() {
									var r, i, a;
									return o.default.wrap(
										function (n) {
											for (;;)
												switch ((n.prev = n.next)) {
													case 0:
														return (
															(r = t.options.settings.getAuthClient()), (n.prev = 1), (n.next = 4), r.idx.proceed(e)
														);
													case 4:
														!1 === (i = n.sent).requestDidSucceed && (a = i), (n.next = 11);
														break;
													case 8:
														(n.prev = 8), (n.t0 = n.catch(1)), (a = n.t0);
													case 11:
														if (!a) {
															n.next = 15;
															break;
														}
														return (n.next = 14), t.showFormErrors(t.formView.model, a, t.formView.form);
													case 14:
														return n.abrupt('return');
													case 15:
														return (n.next = 17), t.handleIdxResponse(i);
													case 17:
													case 'end':
														return n.stop();
												}
										},
										n,
										null,
										[[1, 8]]
									);
								})
							)();
						},
						handleSaveForm: function (e) {
							var t = this;
							return (0, a.default)(
								o.default.mark(function n() {
									var r, i, a, s, l, c, g, y, _, O, k, x, E;
									return o.default.wrap(
										function (n) {
											for (;;)
												switch ((n.prev = n.next)) {
													case 0:
														if (
															((r = e.get('formName')),
															t.toggleFormButtonState(!0),
															e.trigger('request'),
															!e.get('useRedirect'))
														) {
															n.next = 8;
															break;
														}
														return (
															h.default.removeStateHandle(),
															(i = t.options.appState.getCurrentViewState()),
															p.default.executeOnVisiblePage(function () {
																p.default.redirectWithFormGet(i.href);
															}),
															n.abrupt('return')
														);
													case 8:
														if (
															((a = (0, f.default)(r, e)),
															(s = a.identifier),
															(l = t.transformIdentifier(r, a)),
															t.options.settings.get('features.rememberMe')
																? s && b.default.setUsernameCookie(s)
																: b.default.removeUsernameCookie(),
															t.options.appState.hasRemediationObject(r))
														) {
															n.next = 17;
															break;
														}
														return (
															t.options.settings.callGlobalError('Cannot find http action for "'.concat(r, '".')),
															(n.next = 16),
															t.showFormErrors(t.formView.model, 'Cannot find action to proceed.', t.formView.form)
														);
													case 16:
													case 33:
													case 37:
														return n.abrupt('return');
													case 17:
														return (
															'identify' === r &&
																t.options.settings.get('flow') === v.CONFIGURED_FLOW.RESET_PASSWORD &&
																(l.authenticator = 'okta_password'),
															(c = t.options.settings.getAuthClient()),
															(g = { exchangeCodeForTokens: !1 }),
															(n.prev = 20),
															(y = t.options.appState.get('idx')),
															(_ = y.context.stateHandle),
															(n.next = 25),
															c.idx.proceed(w(w({}, g), {}, { step: r, stateHandle: _ }, l))
														);
													case 25:
														if ((O = n.sent).status !== m.IdxStatus.FAILURE) {
															n.next = 28;
															break;
														}
														throw O.error;
													case 28:
														if (!u.default.isIdxSessionExpiredError(O)) {
															n.next = 34;
															break;
														}
														return (
															t.settings.getAuthClient().transactionManager.clear(),
															(n.next = 33),
															t.handleIdxResponse(O)
														);
													case 34:
														if (!1 !== O.requestDidSucceed || O.stepUp) {
															n.next = 38;
															break;
														}
														return (n.next = 37), t.showFormErrors(e, O, t.formView.form);
													case 38:
														if (((k = t.handleIdxResponse.bind(t, O)), r !== d.FORMS.ENROLL_PROFILE)) {
															n.next = 43;
															break;
														}
														t.settings.postRegistrationSubmit(
															null == l || null === (x = l.userProfile) || void 0 === x ? void 0 : x.email,
															k,
															function (t) {
																e.trigger('error', e, { responseJSON: t });
															}
														),
															(n.next = 45);
														break;
													case 43:
														return (n.next = 45), k();
													case 45:
														n.next = 55;
														break;
													case 47:
														if (
															((n.prev = 47),
															(n.t0 = n.catch(20)),
															null === (E = n.t0.is) || void 0 === E || !E.call(n.t0, 'terminal'))
														) {
															n.next = 53;
															break;
														}
														t.options.appState.setNonIdxError(n.t0), (n.next = 55);
														break;
													case 53:
														return (n.next = 55), t.showFormErrors(e, n.t0, t.formView.form);
													case 55:
														return (n.prev = 55), t.toggleFormButtonState(!1), n.finish(55);
													case 58:
													case 'end':
														return n.stop();
												}
										},
										n,
										null,
										[[20, 47, 55, 58]]
									);
								})
							)();
						},
						transformIdentifier: function (e, t) {
							if (Object.prototype.hasOwnProperty.call(t, 'identifier')) {
								var n = d.FORM_NAME_TO_OPERATION_MAP[e];
								t.identifier = this.settings.transformUsername(t.identifier, n);
							}
							return t;
						},
						showFormErrors: function (e, t, n) {
							var r = this;
							return (0, a.default)(
								o.default.mark(function i() {
									var a, l, c, d, f;
									return o.default.wrap(function (o) {
										for (;;)
											switch ((o.prev = o.next)) {
												case 0:
													(d = !0),
														e.trigger('clearFormError'),
														t || ((t = 'FormController - unknown error found'), r.options.settings.callGlobalError(t)),
														null !== (a = t) && void 0 !== a && a.rawIdxState && ((c = t), (t = t.rawIdxState)),
														u.default.isIonErrorResponse(t)
															? (l = u.default.convertFormErrors(t))
															: t.errorSummary
															? (l = { responseJSON: t })
															: (p.default.logConsoleError(t),
															  (l = {
																	responseJSON: { errorSummary: (0, s.loc)('error.unsupported.response', 'login') },
															  })),
														s._.isFunction(null == n ? void 0 : n.showCustomFormErrorCallout) &&
															(d = !n.showCustomFormErrorCallout(
																l,
																null === (f = c) || void 0 === f ? void 0 : f.messages
															)),
														e.trigger('error', e, l, d),
														(c = Object.assign({}, c, { hasFormError: !0 }));
												case 8:
												case 'end':
													return o.stop();
											}
									}, i);
								})
							)();
						},
						handleIdxResponse: function (e) {
							var t = this;
							return (0, a.default)(
								o.default.mark(function n() {
									return o.default.wrap(function (n) {
										for (;;)
											switch ((n.prev = n.next)) {
												case 0:
													return (n.next = 2), (0, y.updateAppState)(t.options.appState, e);
												case 2:
												case 'end':
													return n.stop();
											}
									}, n);
								})
							)();
						},
						toggleFormButtonState: function (e) {
							this.$el.find('.o-form-button-bar .button').toggleClass('link-button-disabled', e);
						},
					});
					(t.default = O), (e.exports = t.default);
				},
				62215: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						Object.defineProperty(t, '_', {
							enumerable: !0,
							get: function () {
								return i._;
							},
						});
					var o = r(n(12990)),
						i = n(6475);
					i._.mixin({
						nestedOmit: function (e, t) {
							var n = i._.omit(e, t);
							return (
								t.includes(n.name) && (n = i._.omit(n, 'value')),
								i._.each(n, function (e, r) {
									Array.isArray(e)
										? (n[r] = e.map(function (e) {
												return i._.nestedOmit(e, t);
										  }))
										: 'object' === (0, o.default)(e) && (n[r] = i._.nestedOmit(e, t));
								}),
								n
							);
						},
					});
				},
				81325: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o = r(n(70232)),
						i = r(n(31049)),
						a = r(n(31752)),
						s = r(n(39131)),
						l = r(n(78463)),
						u = r(n(35075)),
						c = r(n(35432)),
						d = r(n(2132)),
						f = n(6475),
						p = r(n(36894)),
						h = n(13955),
						m = n(3877),
						v = n(62215),
						g = n(53736),
						y = r(n(34425));
					function b(e) {
						var t = (function () {
							if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
							if (Reflect.construct.sham) return !1;
							if ('function' == typeof Proxy) return !0;
							try {
								return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
							} catch (e) {
								return !1;
							}
						})();
						return function () {
							var n,
								r = (0, d.default)(e);
							if (t) {
								var o = (0, d.default)(this).constructor;
								n = Reflect.construct(r, arguments, o);
							} else n = r.apply(this, arguments);
							return (0, c.default)(this, n);
						};
					}
					var _ = {
							user: 'object',
							currentFormName: 'string',
							idx: 'object',
							remediations: 'array',
							dynamicRefreshInterval: 'number',
							deviceFingerprint: 'string',
							hooks: 'object',
						},
						w = {
							authenticatorProfile: {
								deps: ['currentAuthenticator', 'currentAuthenticatorEnrollment'],
								fn: function () {
									var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : { profile: void 0 },
										t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { profile: void 0 };
									return e.profile || t.profile || {};
								},
							},
							authenticatorKey: {
								deps: ['currentAuthenticator', 'currentAuthenticatorEnrollment'],
								fn: function () {
									var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : { key: void 0 },
										t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { key: void 0 };
									return e.key || t.key || '';
								},
							},
							authenticatorMethodType: {
								deps: ['currentAuthenticator', 'currentAuthenticatorEnrollment'],
								fn: function () {
									var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : { methods: void 0 },
										t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : { methods: void 0 };
									return (e.methods && e.methods[0].type) || (t.methods && t.methods[0].type) || '';
								},
							},
							isPasswordRecovery: {
								deps: ['recoveryAuthenticator'],
								fn: function () {
									var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : { type: void 0 };
									return 'password' === (null == e ? void 0 : e.type);
								},
							},
						},
						O = (function (e) {
							(0, u.default)(r, e);
							var t,
								n = b(r);
							function r(e, t) {
								var o;
								return (
									(0, s.default)(this, r), ((o = n.call(this, e, t)).settings = t.settings), (o.hooks = t.hooks), o
								);
							}
							return (
								(0, l.default)(r, [
									{
										key: 'get',
										value: function (e) {
											return f.Model.prototype.get.call(this, e);
										},
									},
									{
										key: 'preinitialize',
										value: function () {
											(this.local = _), (this.derived = w);
											for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
											f.Model.prototype.preinitialize.apply(this, t);
										},
									},
									{
										key: 'isIdentifierOnlyView',
										value: function () {
											var e, t, n;
											return !(
												null !== (e = this.get('remediations')) &&
												void 0 !== e &&
												null !==
													(t = e.find(function (e) {
														return 'identify' === e.name;
													})) &&
												void 0 !== t &&
												null !== (n = t.uiSchema) &&
												void 0 !== n &&
												n.find(function (e) {
													return 'credentials.passcode' === e.name;
												})
											);
										},
									},
									{
										key: 'hasRemediationObject',
										value: function (e) {
											return this.get('idx').neededToProceed.find(function (t) {
												return t.name === e;
											});
										},
									},
									{
										key: 'hasActionObject',
										value: function (e) {
											var t, n;
											return !(
												null === (t = this.get('idx')) ||
												void 0 === t ||
												null === (n = t.actions) ||
												void 0 === n ||
												!n[e]
											);
										},
									},
									{
										key: 'getRemediationAuthenticationOptions',
										value: function (e) {
											var t = this.hasRemediationObject(e);
											if (!t) return [];
											var n = t.value.find(function (e) {
													return 'authenticator' === e.name;
												}),
												r = (null == n ? void 0 : n.options) || [];
											return (r = (0, a.default)(r)), (0, m.createOVOptions)(r), r;
										},
									},
									{
										key: 'getActionByPath',
										value: function (e) {
											var t,
												n = e.split('.');
											t = 1 === n.length ? this.get('idx').actions : this.get(n.shift());
											var r = n.shift();
											return t && v._.isFunction(t[r]) ? t[r] : null;
										},
									},
									{
										key: 'getCurrentViewState',
										value: function () {
											var e = this.get('currentFormName');
											if (e) {
												var t = this.get('remediations').filter(function (t) {
													return t.name === e;
												})[0];
												if (!t) {
													p.default.error('Panic!!'),
														p.default.error('\tCannot find view state for form '.concat(e, '.'));
													var n = this.get('remediations').map(function (e) {
														return e.name;
													});
													p.default.error('\tAll available form names: '.concat(n));
												}
												return t;
											}
										},
									},
									{
										key: 'getSchemaByName',
										value: function (e) {
											var t = this.getCurrentViewState();
											if (t)
												return t.uiSchema.find(function (t) {
													return t.name === e;
												});
										},
									},
									{
										key: 'getAuthenticatorDisplayName',
										value: function () {
											var e = this.get('currentAuthenticator') || {},
												t = this.get('currentAuthenticatorEnrollment') || {};
											return e.displayName || t.displayName;
										},
									},
									{
										key: 'isAuthenticatorChallenge',
										value: function () {
											var e = this.get('currentFormName');
											return h.FORMS_FOR_VERIFICATION.includes(e);
										},
									},
									{
										key: 'shouldReRenderView',
										value: function (e) {
											var t;
											if (null != e && null !== (t = e.idx) && void 0 !== t && t.hasFormError) return !1;
											var n = this.has('idx') ? this.get('idx').rawIdxState : null,
												r = v._.isEqual(
													v._.nestedOmit(e.idx.rawIdxState, ['expiresAt', 'refresh', 'stateHandle', 'headers']),
													v._.nestedOmit(n, ['expiresAt', 'refresh', 'stateHandle', 'headers'])
												);
											return (
												r && this.set('dynamicRefreshInterval', this.getRefreshInterval(e)),
												this._isReRenderRequired(r, e, n)
											);
										},
									},
									{
										key: 'getRefreshInterval',
										value: function (e) {
											var t,
												n,
												r,
												o,
												i = this.get('currentFormName');
											return (
												e.remediations.filter(function (e) {
													return e.name === i;
												})[0].refresh ||
												(null === (t = e.currentAuthenticatorEnrollment) ||
												void 0 === t ||
												null === (n = t.poll) ||
												void 0 === n
													? void 0
													: n.refresh) ||
												(null === (r = e.currentAuthenticator) || void 0 === r || null === (o = r.poll) || void 0 === o
													? void 0
													: o.refresh)
											);
										},
									},
									{
										key: 'shouldShowSignOutLinkInCurrentForm',
										value: function (e) {
											var t = this.get('idx') && this.get('idx').actions,
												n = this.get('currentFormName');
											return (
												!e && v._.isFunction(null == t ? void 0 : t.cancel) && !h.FORMS_WITHOUT_SIGNOUT.includes(n)
											);
										},
									},
									{
										key: 'containsMessageWithI18nKey',
										value: function (e) {
											Array.isArray(e) || (e = [e]);
											var t = this.get('messages');
											return (
												t &&
												Array.isArray(t.value) &&
												t.value.some(function (t) {
													var n;
													return v._.contains(e, null === (n = t.i18n) || void 0 === n ? void 0 : n.key);
												})
											);
										},
									},
									{
										key: 'containsMessageStartingWithI18nKey',
										value: function (e) {
											var t = this.get('messages');
											return (
												t &&
												Array.isArray(t.value) &&
												t.value.some(function (t) {
													var n;
													return null === (n = t.i18n) || void 0 === n ? void 0 : n.key.startsWith(e);
												})
											);
										},
									},
									{
										key: 'clearAppStateCache',
										value: function () {
											var e = {};
											for (var t in this.attributes) 'currentFormName' !== t && (e[t] = void 0);
											this.set(e, Object.assign({}, { unset: !0, silent: !0 })), this.trigger('cache:clear');
										},
									},
									{
										key: 'chooseRemediation',
										value: function (e) {
											var t, n;
											if (!v._.isEmpty(e.remediations)) {
												var r = e.remediations[0];
												return 'enroll-poll' === r.name &&
													this.get('authenticatorKey') === h.AUTHENTICATOR_KEY.OV &&
													(y.default.isAndroid() || y.default.isIOS()) &&
													'qrcode' ===
														(null === (t = e.currentAuthenticator) ||
														void 0 === t ||
														null === (n = t.contextualData) ||
														void 0 === n
															? void 0
															: n.selectedChannel)
													? e.remediations.find(function (e) {
															return 'select-enrollment-channel' === e.name;
													  })
													: r;
											}
										},
									},
									{
										key: 'setIonResponse',
										value:
											((t = (0, i.default)(
												o.default.mark(function e(t) {
													var n, r, i, a, s;
													return o.default.wrap(
														function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		if (
																			((n = this.shouldReRenderView(t)), this.clearAppStateCache(), this.set(t), !n)
																		) {
																			e.next = 14;
																			break;
																		}
																		return (
																			(i = this.chooseRemediation(t)),
																			(a = null),
																			i
																				? (a = i.name)
																				: (p.default.error('Panic!!'),
																				  p.default.error('\tNo remediation found.'),
																				  p.default.error('\tHere is the entire response'),
																				  p.default.error(JSON.stringify(t, null, 2))),
																			(s = null === (r = this.hooks) || void 0 === r ? void 0 : r.getHook(a)),
																			(e.next = 10),
																			(0, g.executeHooksBefore)(s)
																		);
																	case 10:
																		return (
																			this.unset('currentFormName', { silent: !0 }),
																			this.set({ currentFormName: a }),
																			(e.next = 14),
																			(0, g.executeHooksAfter)(s)
																		);
																	case 14:
																	case 'end':
																		return e.stop();
																}
														},
														e,
														this
													);
												})
											)),
											function (e) {
												return t.apply(this, arguments);
											}),
									},
									{
										key: 'setNonIdxError',
										value: function (e) {
											this.set('remediations', [{ name: h.FORMS.TERMINAL }]),
												this.set('messages', { value: [{ message: e.errorDetails.errorSummary, class: 'ERROR' }] }),
												this.set('currentFormName', h.FORMS.TERMINAL);
										},
									},
									{
										key: 'getUser',
										value: function () {
											return this.get('user');
										},
									},
									{
										key: '_isReRenderRequired',
										value: function (e, t, n) {
											var r,
												o = !0;
											return (
												(null === (r = this.get('idx')) || void 0 === r ? void 0 : r.hasFormError) &&
													this._isChallengeAuthenticatorPoll(t, n) &&
													(o = !1),
												e &&
													((o = !1),
													('poll' === this.get('currentFormName') ||
														h.FORMS_WITH_STATIC_BACK_LINK.includes(this.get('currentFormName')) ||
														this.containsMessageWithI18nKey('idx.unknown.user')) &&
														(o = !0)),
												o
											);
										},
									},
									{
										key: '_isChallengeAuthenticatorPoll',
										value: function (e, t) {
											var n,
												r = v._.isEqual(
													v._.nestedOmit(e.idx.rawIdxState, ['expiresAt', 'refresh', 'stateHandle', 'headers']),
													v._.nestedOmit(t, ['expiresAt', 'refresh', 'stateHandle', 'messages', 'headers'])
												),
												o = 'challenge-authenticator' === this.get('currentFormName'),
												i =
													(null === (n = this.get('currentAuthenticatorEnrollment')) || void 0 === n
														? void 0
														: n.key) === h.AUTHENTICATOR_KEY.EMAIL;
											return r && o && i;
										},
									},
								]),
								r
							);
						})(f.Model);
					(t.default = O), (e.exports = t.default);
				},
				68133: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var o,
						i,
						a,
						s,
						l,
						u,
						c,
						d,
						f,
						p = r(n(15985)),
						h = r(n(36894)),
						m = n(13955),
						v = n(17587),
						g = r(n(57973)),
						y = r(n(92017)),
						b = r(n(91671)),
						_ = r(n(91485)),
						w = r(n(44822)),
						O = r(n(57785)),
						k = r(n(57571)),
						x = r(n(51662)),
						E = r(n(57353)),
						T = r(n(81205)),
						S = r(n(68875)),
						A = r(n(59953)),
						C = r(n(63417)),
						P = r(n(88981)),
						R = r(n(64623)),
						I = r(n(56111)),
						N = r(n(60342)),
						M = r(n(99208)),
						j = r(n(81261)),
						D = r(n(21748)),
						L = r(n(99836)),
						U = r(n(75582)),
						F = r(n(26097)),
						B = r(n(62665)),
						V = r(n(40973)),
						Z = r(n(13591)),
						H = r(n(15918)),
						q = r(n(86598)),
						W = r(n(94257)),
						K = r(n(65425)),
						$ = r(n(14425)),
						z = r(n(9699)),
						G = r(n(65387)),
						Y = r(n(30836)),
						J = r(n(29118)),
						Q = r(n(37437)),
						X = r(n(10765)),
						ee = r(n(41553)),
						te = r(n(98355)),
						ne = r(n(88930)),
						re = r(n(1705)),
						oe = r(n(90088)),
						ie = r(n(99214)),
						ae = r(n(14709)),
						se = r(n(36529)),
						le = r(n(12167)),
						ue = r(n(7925)),
						ce = r(n(79091)),
						de = r(n(58734)),
						fe = r(n(19220)),
						pe = r(n(48167)),
						he = r(n(49065)),
						me = r(n(82640)),
						ve = r(n(64840)),
						ge = r(n(2854)),
						ye = r(n(14763)),
						be = r(n(21606)),
						_e = r(n(23986)),
						we = r(n(70621)),
						Oe = r(n(50066)),
						ke = r(n(58930)),
						xe = r(n(2982)),
						Ee = r(n(1850)),
						Te = r(n(28141)),
						Se = r(n(73386)),
						Ae = '_',
						Ce =
							((f = {}),
							(0, p.default)(f, m.FORMS.IDENTIFY, (0, p.default)({}, Ae, g.default)),
							(0, p.default)(f, m.FORMS.IDENTIFY_RECOVERY, (0, p.default)({}, Ae, _.default)),
							(0, p.default)(f, m.FORMS.DEVICE_CHALLENGE_POLL, (0, p.default)({}, Ae, A.default)),
							(0, p.default)(f, m.FORMS.LAUNCH_AUTHENTICATOR, (0, p.default)({}, Ae, P.default)),
							(0, p.default)(
								f,
								m.FORMS.DEVICE_APPLE_SSO_EXTENSION,
								((o = {}), (0, p.default)(o, Ae, C.default), (0, p.default)(o, m.AUTHENTICATOR_KEY.OV, se.default), o)
							),
							(0, p.default)(f, m.FORMS.CANCEL_TRANSACTION, (0, p.default)({}, Ae, C.default)),
							(0, p.default)(f, m.FORMS.ENROLL_PROFILE, (0, p.default)({}, Ae, I.default)),
							(0, p.default)(f, m.FORMS.ENROLL_PROFILE_UPDATE, (0, p.default)({}, Ae, N.default)),
							(0, p.default)(f, m.FORMS.POLL, (0, p.default)({}, Ae, k.default)),
							(0, p.default)(f, m.FORMS.REQUEST_ACTIVATION, (0, p.default)({}, Ae, M.default)),
							(0, p.default)(f, m.FORMS.SELECT_AUTHENTICATOR_ENROLL, (0, p.default)({}, Ae, j.default)),
							(0, p.default)(
								f,
								m.FORMS.AUTHENTICATOR_ENROLLMENT_DATA,
								((i = {}),
								(0, p.default)(i, m.AUTHENTICATOR_KEY.PHONE, q.default),
								(0, p.default)(i, m.AUTHENTICATOR_KEY.EMAIL, X.default),
								i)
							),
							(0, p.default)(f, m.FORMS.CONSENT_ADMIN, (0, p.default)({}, Ae, x.default)),
							(0, p.default)(f, m.FORMS.CONSENT_ENDUSER, (0, p.default)({}, Ae, E.default)),
							(0, p.default)(f, m.FORMS.CONSENT_GRANULAR, (0, p.default)({}, Ae, T.default)),
							(0, p.default)(f, m.FORMS.CONSENT_EMAIL_CHALLENGE, (0, p.default)({}, Ae, S.default)),
							(0, p.default)(
								f,
								m.FORMS.ENROLL_AUTHENTICATOR,
								((a = {}),
								(0, p.default)(a, m.AUTHENTICATOR_KEY.DUO, fe.default),
								(0, p.default)(a, m.AUTHENTICATOR_KEY.EMAIL, J.default),
								(0, p.default)(a, m.AUTHENTICATOR_KEY.GOOGLE_OTP, le.default),
								(0, p.default)(a, m.AUTHENTICATOR_KEY.IDP, me.default),
								(0, p.default)(a, m.AUTHENTICATOR_KEY.ON_PREM, ce.default),
								(0, p.default)(a, m.AUTHENTICATOR_KEY.PASSWORD, U.default),
								(0, p.default)(a, m.AUTHENTICATOR_KEY.PHONE, H.default),
								(0, p.default)(a, m.AUTHENTICATOR_KEY.RSA, ce.default),
								(0, p.default)(a, m.AUTHENTICATOR_KEY.SECURITY_QUESTION, $.default),
								(0, p.default)(a, m.AUTHENTICATOR_KEY.SYMANTEC_VIP, ge.default),
								(0, p.default)(a, m.AUTHENTICATOR_KEY.WEBAUTHN, G.default),
								(0, p.default)(a, m.AUTHENTICATOR_KEY.YUBIKEY, _e.default),
								a)
							),
							(0, p.default)(
								f,
								m.FORMS.CHALLENGE_AUTHENTICATOR,
								((s = {}),
								(0, p.default)(s, m.AUTHENTICATOR_KEY.CUSTOM_OTP, ve.default),
								(0, p.default)(s, m.AUTHENTICATOR_KEY.DUO, pe.default),
								(0, p.default)(s, m.AUTHENTICATOR_KEY.EMAIL, Q.default),
								(0, p.default)(s, m.AUTHENTICATOR_KEY.GOOGLE_OTP, ue.default),
								(0, p.default)(s, m.AUTHENTICATOR_KEY.IDP, he.default),
								(0, p.default)(s, m.AUTHENTICATOR_KEY.ON_PREM, de.default),
								(0, p.default)(s, m.AUTHENTICATOR_KEY.OV, oe.default),
								(0, p.default)(s, m.AUTHENTICATOR_KEY.PASSWORD, F.default),
								(0, p.default)(s, m.AUTHENTICATOR_KEY.PHONE, W.default),
								(0, p.default)(s, m.AUTHENTICATOR_KEY.RSA, de.default),
								(0, p.default)(s, m.AUTHENTICATOR_KEY.SECURITY_QUESTION, z.default),
								(0, p.default)(s, m.AUTHENTICATOR_KEY.SYMANTEC_VIP, ge.default),
								(0, p.default)(s, m.AUTHENTICATOR_KEY.WEBAUTHN, Y.default),
								(0, p.default)(s, m.AUTHENTICATOR_KEY.YUBIKEY, _e.default),
								s)
							),
							(0, p.default)(f, m.FORMS.ENROLL_POLL, (0, p.default)({}, m.AUTHENTICATOR_KEY.OV, ee.default)),
							(0, p.default)(
								f,
								m.FORMS.SELECT_ENROLLMENT_CHANNEL,
								(0, p.default)({}, m.AUTHENTICATOR_KEY.OV, te.default)
							),
							(0, p.default)(
								f,
								m.FORMS.ENROLLMENT_CHANNEL_DATA,
								(0, p.default)({}, m.AUTHENTICATOR_KEY.OV, ne.default)
							),
							(0, p.default)(
								f,
								m.FORMS.REENROLL_AUTHENTICATOR,
								(0, p.default)({}, m.AUTHENTICATOR_KEY.PASSWORD, B.default)
							),
							(0, p.default)(
								f,
								m.FORMS.REENROLL_CUSTOM_PASSWORD_EXPIRY,
								(0, p.default)({}, m.AUTHENTICATOR_KEY.PASSWORD, ke.default)
							),
							(0, p.default)(
								f,
								m.FORMS.REENROLL_CUSTOM_PASSWORD_EXPIRY_WARNING,
								(0, p.default)({}, m.AUTHENTICATOR_KEY.PASSWORD, xe.default)
							),
							(0, p.default)(
								f,
								m.FORMS.REENROLL_AUTHENTICATOR_WARNING,
								(0, p.default)({}, m.AUTHENTICATOR_KEY.PASSWORD, V.default)
							),
							(0, p.default)(
								f,
								m.FORMS.RESET_AUTHENTICATOR,
								((l = {}),
								(0, p.default)(l, m.AUTHENTICATOR_KEY.PASSWORD, Z.default),
								(0, p.default)(l, m.AUTHENTICATOR_KEY.GOOGLE_OTP, le.default),
								l)
							),
							(0, p.default)(f, m.FORMS.SELECT_AUTHENTICATOR_AUTHENTICATE, (0, p.default)({}, Ae, D.default)),
							(0, p.default)(f, m.FORMS.SELECT_AUTHENTICATOR_UNLOCK, (0, p.default)({}, Ae, L.default)),
							(0, p.default)(f, m.FORMS.UNLOCK_ACCOUNT, (0, p.default)({}, Ae, Te.default)),
							(0, p.default)(
								f,
								m.FORMS.CHALLENGE_POLL,
								((u = {}),
								(0, p.default)(u, m.AUTHENTICATOR_KEY.OV, re.default),
								(0, p.default)(u, m.AUTHENTICATOR_KEY.CUSTOM_APP, we.default),
								u)
							),
							(0, p.default)(
								f,
								m.FORMS.RESEND,
								((c = {}),
								(0, p.default)(c, m.AUTHENTICATOR_KEY.OV, ie.default),
								(0, p.default)(c, m.AUTHENTICATOR_KEY.CUSTOM_APP, Oe.default),
								c)
							),
							(0, p.default)(
								f,
								m.FORMS.AUTHENTICATOR_VERIFICATION_DATA,
								((d = {}),
								(0, p.default)(d, m.AUTHENTICATOR_KEY.PHONE, K.default),
								(0, p.default)(d, m.AUTHENTICATOR_KEY.OV, ae.default),
								(0, p.default)(d, m.AUTHENTICATOR_KEY.EMAIL, X.default),
								(0, p.default)(d, m.AUTHENTICATOR_KEY.CUSTOM_APP, ae.default),
								d)
							),
							(0, p.default)(f, m.FORMS.FAILURE_REDIRECT, (0, p.default)({}, Ae, O.default)),
							(0, p.default)(f, m.FORMS.SUCCESS_REDIRECT, (0, p.default)({}, Ae, O.default)),
							(0, p.default)(f, m.FORMS.REDIRECT_IDP, (0, p.default)({}, Ae, y.default)),
							(0, p.default)(f, m.FORMS.REDIRECT_IDVERIFY, (0, p.default)({}, Ae, b.default)),
							(0, p.default)(f, m.FORMS.PIV_IDP, (0, p.default)({}, Ae, be.default)),
							(0, p.default)(f, m.FORMS.DEVICE_ENROLLMENT_TERMINAL, (0, p.default)({}, Ae, R.default)),
							(0, p.default)(f, m.FORMS.USER_CODE, (0, p.default)({}, Ae, ye.default)),
							(0, p.default)(f, m.FORMS.KEEP_ME_SIGNED_IN, (0, p.default)({}, Ae, Ee.default)),
							(0, p.default)(f, m.FORMS.TERMINAL, (0, p.default)({}, Ae, w.default)),
							(0, p.default)(f, m.FORMS.DEVICE_ASSURANCE_GRACE_PERIOD, (0, p.default)({}, Ae, Se.default)),
							f),
						Pe = {
							create: function (e) {
								var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Ae,
									n = Ce[e];
								if (!n) return h.default.warn('Cannot find customized View for '.concat(e, '.')), v.BaseView;
								var r = n[t] || n._;
								return (
									r || (h.default.warn('Cannot find customized View for '.concat(e, ' + ').concat(t, '.')), v.BaseView)
								);
							},
						};
					(t.default = Pe), (e.exports = t.default);
				},
				71750: function (e, t, n) {
					'use strict';
					var r = n(1654),
						o = n(12990);
					Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = void 0);
					var i = r(n(15985)),
						a = r(n(12990)),
						s = r(n(2875)),
						l = n(6475),
						u = (function (e, t) {
							if (!t && e && e.__esModule) return e;
							if (null === e || ('object' !== o(e) && 'function' != typeof e)) return { default: e };
							var n = c(t);
							if (n && n.has(e)) return n.get(e);
							var r = {},
								i = Object.defineProperty && Object.getOwnPropertyDescriptor;
							for (var a in e)
								if ('default' !== a && Object.prototype.hasOwnProperty.call(e, a)) {
									var s = i ? Object.getOwnPropertyDescriptor(e, a) : null;
									s && (s.get || s.set) ? Object.defineProperty(r, a, s) : (r[a] = e[a]);
								}
							(r.default = e), n && n.set(e, r);
							return r;
						})(n(88469));
					function c(e) {
						if ('function' != typeof WeakMap) return null;
						var t = new WeakMap(),
							n = new WeakMap();
						return (c = function (e) {
							return e ? n : t;
						})(e);
					}
					function d(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					var f = l.internal.views.forms.helpers.FormUtil,
						p = l.Form.extend({
							layout: 'o-form-theme',
							className: 'ion-form',
							hasSavingState: !0,
							autoSave: !1,
							noCancelButton: !0,
							title: function () {
								return (0, l.loc)('oform.title.authenticate', 'login');
							},
							save: function () {
								return (0, l.loc)('oform.next', 'login');
							},
							modelEvents: { clearFormError: 'handleClearFormError', error: 'triggerAfterError' },
							initialize: function () {
								var e = this,
									t = this.getUISchema().map(u.create);
								this.showMessages(),
									this.listenTo(this.options.appState, 'onCaptchaLoaded', function (t) {
										e.captchaObject = t;
									}),
									t.forEach(function (t) {
										e.addInputOrView(t);
									}),
									this.listenTo(this, 'save', this.saveForm),
									this.listenTo(this, 'cancel', this.cancelForm);
							},
							focus: function () {
								if (this.settings.get('features.autoFocus')) {
									for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
									l.Form.prototype.focus.apply(this, t);
								}
							},
							handleClearFormError: function () {
								var e = this.$('.o-form-error-container');
								e.empty(), e.hasClass('o-form-has-errors') && this.clearErrors();
							},
							triggerAfterError: function (e, t) {
								this.options.appState.trigger('afterError', t);
							},
							saveForm: function (e) {
								this.$el.find('.o-form-error-container').empty(),
									this.captchaObject ? this.captchaObject.execute() : this.options.appState.trigger('saveForm', e);
							},
							postRender: function () {
								var e = this.$el.find('.o-form-info-container');
								e.length ||
									(this.add('<div class="o-form-info-container"></div>'),
									(e = this.$el.find('.o-form-info-container'))),
									this.$el.find('.o-form-error-container').attr('role', 'alert').before(e),
									this.addIdentifier();
							},
							addIdentifier: function () {
								var e = (this.options.appState.get('user') || {}).identifier;
								if (e && this.settings.get('features.showIdentifier')) {
									var t = this.$el.find('[data-se="o-form-head"]'),
										n = s.default.template({
											compiler: [8, '>= 4.3.0'],
											main: function (e, t, n, r, o) {
												var i,
													s = null != t ? t : e.nullContext || {},
													l = e.hooks.helperMissing,
													u = 'function',
													c = e.escapeExpression,
													d =
														e.lookupProperty ||
														function (e, t) {
															if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
														};
												return (
													'<div class="identifier-container"><span class="identifier no-translate" data-se="identifier" title="' +
													c(
														((i = null != (i = d(n, 'identifier') || (null != t ? d(t, 'identifier') : t)) ? i : l),
														(0, a.default)(i) === u
															? i.call(s, {
																	name: 'identifier',
																	hash: {},
																	data: o,
																	loc: { start: { line: 1, column: 100 }, end: { line: 1, column: 114 } },
															  })
															: i)
													) +
													'">' +
													c(
														((i = null != (i = d(n, 'identifier') || (null != t ? d(t, 'identifier') : t)) ? i : l),
														(0, a.default)(i) === u
															? i.call(s, {
																	name: 'identifier',
																	hash: {},
																	data: o,
																	loc: { start: { line: 1, column: 116 }, end: { line: 1, column: 130 } },
															  })
															: i)
													) +
													'</span></div>'
												);
											},
											useData: !0,
										})({ identifier: e });
									t.length ? t.after(n) : this.$el.find('.o-form-error-container').after(n);
								}
							},
							cancelForm: function () {
								this.options.appState.trigger('invokeAction', 'cancel');
							},
							getUISchema: function () {
								return Array.isArray(this.options.currentViewState.uiSchema)
									? this.options.currentViewState.uiSchema
									: [];
							},
							addInputOrView: function (e) {
								if (
									!1 !== e.visible &&
									(!1 !== e.mutable || !0 === e.visible) &&
									(e.View
										? (this.add(e.View, l._.omit(e, 'View', 'showWhen')),
										  e.showWhen && f.applyShowWhen(this.last(), e.showWhen))
										: this.addInput(e),
									Array.isArray(e.optionsUiSchemas) && this.options.optionUiSchemaConfig[e.name])
								) {
									var t = Number(this.options.optionUiSchemaConfig[e.name]);
									(e.optionsUiSchemas[t] || []).forEach(this.addInputOrView.bind(this));
								}
							},
							showCustomFormErrorCallout: null,
							showMessages: function (e) {
								var t = this,
									n = this.options.appState.get('messages') || {},
									r = '.o-form-error-container';
								!Array.isArray(n.value) || e instanceof l.View
									? e instanceof l.View && this.add(e, r)
									: (this.add('<div class="ion-messages-container"></div>', r),
									  n.value.forEach(function (n) {
											if (null != n && n.class && 'INFO' !== n.class) {
												var o,
													a = (function (e) {
														for (var t = 1; t < arguments.length; t++) {
															var n = null != arguments[t] ? arguments[t] : {};
															t % 2
																? d(Object(n), !0).forEach(function (t) {
																		(0, i.default)(e, t, n[t]);
																  })
																: Object.getOwnPropertyDescriptors
																? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
																: d(Object(n)).forEach(function (t) {
																		Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
																  });
														}
														return e;
													})(
														{
															class: null !== (o = null == n ? void 0 : n.class) && void 0 !== o ? o : '',
															message: null == n ? void 0 : n.message,
															title: '',
														},
														e
													);
												t.add(
													(0, l.createCallout)({ content: a.message, type: a.class.toLowerCase(), title: a.title }),
													r
												),
													(e = null);
											} else t.add('<p>'.concat(n.message, '</p>'), '.ion-messages-container');
									  }));
							},
						});
					(t.default = p), (e.exports = t.default);
				},
				88469: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.isTextOverflowing = t.createIdpButtons = t.createCustomButtons = t.create = t.addCustomButton = void 0);
					var o,
						i = r(n(31752)),
						a = r(n(15985)),
						s = n(6475),
						l = r(n(82625)),
						u = r(n(40647)),
						c = n(25795),
						d = n(13955),
						f = r(n(78719)),
						p = r(n(29531)),
						h = r(n(99629)),
						m = r(n(19277));
					function v(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function g(e) {
						for (var t = 1; t < arguments.length; t++) {
							var n = null != arguments[t] ? arguments[t] : {};
							t % 2
								? v(Object(n), !0).forEach(function (t) {
										(0, a.default)(e, t, n[t]);
								  })
								: Object.getOwnPropertyDescriptors
								? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
								: v(Object(n)).forEach(function (t) {
										Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
								  });
						}
						return e;
					}
					var y = function (e, t) {
						var n = document.createElement('div');
						(n.style.position = 'absolute'),
							(n.style.left = '-9999px'),
							(n.style.whiteSpace = 'nowrap'),
							(n.innerHTML = e),
							document.body.appendChild(n);
						var r = n.clientWidth;
						return document.body.removeChild(n), r > t;
					};
					t.isTextOverflowing = y;
					var b =
						((o = {
							authenticatorEnrollSelect: function (e) {
								var t = (e.options || []).map(function (e) {
									return Object.assign({}, e, (0, c.getAuthenticatorDataForEnroll)(e));
								});
								return { View: l.default, options: { name: e.name, optionItems: t, collection: new s.Collection(t) } };
							},
							authenticatorVerifySelect: function (e) {
								var t = e.options || [],
									n = new Set();
								return (
									(t = t.filter(function (e) {
										var t;
										if (e.authenticatorKey === d.AUTHENTICATOR_KEY.WEBAUTHN)
											(t = n.has(e.authenticatorKey)), n.add(e.authenticatorKey);
										else if (e.authenticatorKey === d.AUTHENTICATOR_KEY.CUSTOM_APP) {
											var r, o;
											(t = n.has(null == e || null === (r = e.value) || void 0 === r ? void 0 : r.id)),
												n.add(null == e || null === (o = e.value) || void 0 === o ? void 0 : o.id);
										}
										return !t;
									})),
									(t = t.map(function (e) {
										return Object.assign({}, e, (0, c.getAuthenticatorDataForVerification)(e));
									})),
									{ View: u.default, options: { name: e.name, collection: new s.Collection(t) } }
								);
							},
						}),
						(0, a.default)(o, 'admin-consent', function () {
							return { View: p.default };
						}),
						(0, a.default)(o, 'consent', function () {
							return { View: h.default };
						}),
						(0, a.default)(o, 'captcha', function (e) {
							return { View: m.default, options: { name: e.name } };
						}),
						o);
					t.create = function (e) {
						return (b[e.type] || s._.identity)(e);
					};
					t.createIdpButtons = function (e) {
						var t = e.settings,
							n = e.appState,
							r = n.get('remediations').filter(function (e) {
								return e.name === d.FORMS.REDIRECT_IDP;
							});
						if (!Array.isArray(r)) return [];
						var o = (function (e, t) {
								if (
									t.get('remediations').filter(function (e) {
										return e.name === d.FORMS.PIV_IDP;
									}).length < 1
								)
									return [];
								var n = e.get('piv');
								return [
									{
										attributes: { 'data-se': 'piv-card-button' },
										className: (n.className || '') + ' piv-button',
										title: n.text || (0, s.loc)('piv.cac.card', 'login'),
										click: function (e) {
											e.preventDefault(), t.trigger('switchForm', d.FORMS.PIV_IDP);
										},
									},
								];
							})(t, n),
							a = r.map(function (e) {
								var t,
									n,
									r,
									o = null === (t = e.type) || void 0 === t ? void 0 : t.toLowerCase();
								s._.contains(f.default.SUPPORTED_SOCIAL_IDPS, o)
									? (n = (0, s.loc)('socialauth.'.concat(o, '.label'), 'login'))
									: ((o = 'general-idp'),
									  (n = (0, s.loc)('customauth.sign.in.with.label', 'login', [
											null === (r = e.idp) || void 0 === r ? void 0 : r.name,
									  ])));
								var i = ['social-auth-button', 'social-auth-'.concat(o, '-button')];
								'general-idp' === o && i.push('no-translate'), e.idp.className && i.push(e.idp.className);
								var a = {
									attributes: { 'data-se': 'social-auth-'.concat(o, '-button') },
									className: i.join(' '),
									title: n,
									href: e.href,
								};
								return y(n, 186) && (a.attributes.title = n), a;
							});
						return [].concat((0, i.default)(o), (0, i.default)(a));
					};
					t.createCustomButtons = function (e) {
						return e.get('customButtons').map(function (e) {
							return {
								attributes: { 'data-se': e.dataAttr },
								className: e.className + ' default-custom-button',
								title: e.title || (0, s.loc)(e.i18nKey, 'login'),
								click: e.click,
							};
						});
					};
					t.addCustomButton = function (e) {
						return (0, s.createButton)(
							g(g({}, e), {}, { className: ''.concat(e.className, ' default-custom-button button-primary') })
						);
					};
				},
				44371: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.createOktaSignIn = function (e, t) {
							return (function () {
								function n(r) {
									var i, l, c;
									((0, o.default)(this, n),
									s.default.debugMessage(
										'\n          The Okta Sign-In Widget is running in development mode.\n          When you are ready to publish your app, embed the minified version to turn on production mode.\n          See: https://developer.okta.com/code/javascript/okta_sign-in_widget#cdn\n        '
									),
									r.stateToken) ||
										(r.stateToken =
											null === (i = window) ||
											void 0 === i ||
											null === (l = i.oktaData) ||
											void 0 === l ||
											null === (c = l.signIn) ||
											void 0 === c
												? void 0
												: c.stateToken);
									if (
										((this.options = r),
										(this.authClient = (0, u.default)(e, r)),
										!0 !== r.useClassicEngine && this.authClient.options.clientId && !1 === this.authClient.isPKCE())
									)
										throw new a.ConfigError(
											'OAuth2 with interaction code flow requires PKCE to be enabled on the authClient.'
										);
									(this.hooks = new f.default({ hooks: r.hooks })),
										(this.Router = t(r)),
										(this._eventCallbackMap = new WeakMap()),
										this.Router.prototype.Events.listenTo.call(this, this.Router.prototype, 'all', this.trigger),
										this.once('afterRender', function (e) {
											this.trigger('ready', e);
										});
								}
								return (
									(0, i.default)(n, [
										{
											key: 'renderEl',
											value: function (e, t, n) {
												if (this.router)
													throw new Error('An instance of the widget has already been rendered. Call remove() first.');
												var r = (0, d.default)(this.Router, this.options, e, this.authClient, t, n, this.hooks);
												return (this.router = r.router), r.promise;
											},
										},
										{
											key: 'hide',
											value: function () {
												this.router && this.router.hide();
											},
										},
										{
											key: 'show',
											value: function () {
												this.router && this.router.show();
											},
										},
										{
											key: 'remove',
											value: function () {
												this.router && (this.router.remove(), (this.router = void 0));
											},
										},
										{
											key: 'showSignInToGetTokens',
											value: function (e) {
												var t = Object.assign((0, c.default)(this.options, e), { redirect: 'never' }),
													n = this.renderEl(t).then(function (e) {
														return e.tokens;
													}),
													r = this.router.settings.getAuthClient();
												if (r.isAuthorizationCodeFlow() && !r.isPKCE())
													throw new a.ConfigError(
														'"showSignInToGetTokens()" should not be used for authorization_code flow. Use "showSignInAndRedirect()" instead'
													);
												return n;
											},
										},
										{
											key: 'showSignInAndRedirect',
											value: function (e) {
												var t = Object.assign((0, c.default)(this.options, e), { redirect: 'always' });
												return this.renderEl(t).then(function () {});
											},
										},
										{
											key: 'showSignIn',
											value: function (e) {
												var t = Object.assign((0, c.default)(this.options, e));
												return this.renderEl(t);
											},
										},
										{
											key: 'before',
											value: function (e, t) {
												this.hooks.mergeHook(e, { before: [t] });
											},
										},
										{
											key: 'after',
											value: function (e, t) {
												this.hooks.mergeHook(e, { after: [t] });
											},
										},
										{
											key: 'getUser',
											value: function () {
												var e, t;
												return null === (e = this.router) || void 0 === e || null === (t = e.appState) || void 0 === t
													? void 0
													: t.getUser();
											},
										},
										{
											key: 'on',
											value: function (e, t) {
												if (p.includes(e)) {
													var n = t;
													(t = function () {
														try {
															for (var t = arguments.length, r = new Array(t), o = 0; o < t; o++) r[o] = arguments[o];
															n.apply(this, r);
														} catch (t) {
															l.default.error('[okta-signin-widget] "'.concat(e, '" event handler error:'), t);
														}
													}),
														this._eventCallbackMap.set(n, t);
												}
												this.Router.prototype.Events.on.call(this, e, t);
											},
										},
										{
											key: 'off',
											value: function (e, t) {
												t && (t = this._eventCallbackMap.get(t) || t),
													this.Router.prototype.Events.off.call(this, e, t);
											},
										},
										{
											key: 'once',
											value: function (e, t) {
												this.Router.prototype.Events.once.call(this, e, t);
											},
										},
										{
											key: 'stopListening',
											value: function (e, t) {
												this.Router.prototype.Events.stopListening.call(this, e, t);
											},
										},
										{
											key: 'listenTo',
											value: function (e, t, n) {
												this.Router.prototype.Events.listenTo.call(this, e, t, n);
											},
										},
										{
											key: 'trigger',
											value: function (e) {
												for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
													n[r - 1] = arguments[r];
												this.Router.prototype.Events.trigger.apply(this, [e].concat(n));
											},
										},
									]),
									n
								);
							})();
						});
					var o = r(n(39131)),
						i = r(n(78463)),
						a = n(13671),
						s = r(n(90570)),
						l = r(n(36894)),
						u = r(n(53419)),
						c = r(n(22544)),
						d = r(n(99083)),
						f = r(n(76404)),
						p = ['ready', 'afterError', 'afterRender'];
				},
				53419: function (e, t, n) {
					'use strict';
					var r = n(1654);
					Object.defineProperty(t, '__esModule', { value: !0 }),
						(t.default = function (e) {
							var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
								n = t.authClient,
								r = t.authParams;
							if (!n) {
								var o = t.issuer,
									l = t.clientId,
									c = t.redirectUri,
									d = t.state,
									f = t.scopes,
									p = t.flow,
									h = t.codeChallenge,
									m = t.codeChallengeMethod,
									v = t.recoveryToken;
								(r = u(
									{
										issuer: o,
										clientId: l,
										redirectUri: c,
										state: d,
										scopes: f,
										flow: p,
										codeChallenge: h,
										codeChallengeMethod: m,
										transformErrorXHR: a.default.transformErrorXHR,
										recoveryToken: v,
										pollDelay: 500,
									},
									r
								)).issuer || (r.issuer = t.baseUrl + '/oauth2/default'),
									(n = new e(r));
							}
							if (!n._oktaUserAgent)
								throw new i.ConfigError('The passed in authClient should be version 5.4.0 or above.');
							n._oktaUserAgent.addEnvironment('okta-signin-widget-'.concat(s.default.version));
							return n;
						});
					var o = r(n(15985)),
						i = n(13671),
						a = r(n(90570)),
						s = r(n(7174));
					function l(e, t) {
						var n = Object.keys(e);
						if (Object.getOwnPropertySymbols) {
							var r = Object.getOwnPropertySymbols(e);
							t &&
								(r = r.filter(function (t) {
									return Object.getOwnPropertyDescriptor(e, t).enumerable;
								})),
								n.push.apply(n, r);
						}
						return n;
					}
					function u(e) {
						for (var t = 1; t < arguments.length; t++) {
							var n = null != arguments[t] ? arguments[t] : {};
							t % 2
								? l(Object(n), !0).forEach(function (t) {
										(0, o.default)(e, t, n[t]);
								  })
								: Object.getOwnPropertyDescriptors
								? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
								: l(Object(n)).forEach(function (t) {
										Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
								  });
						}
						return e;
					}
					e.exports = t.default;
				},
				2659: function (e) {
					/*! For license information please see default.js.LICENSE.txt */
					self,
						(e.exports = (function () {
							var e = {
									9748: function (e, t, n) {
										'use strict';
										n.d(t, {
											b: function () {
												return k;
											},
										});
										var r = n(5385),
											o = n(9123),
											i = n(1971);
										function a(e, t) {
											var n = {};
											return Object.assign(n, t), !n.stateToken && e.stateToken && (n.stateToken = e.stateToken), n;
										}
										function s(e, t) {
											return (
												(t = a(e, t)), (0, r.v_)(e, e.getIssuerOrigin() + '/api/v1/authn', t, { withCredentials: !0 })
											);
										}
										function l(e) {
											return !!c(e);
										}
										function u(e, t, n, o, i) {
											return (
												(i = Object.assign({ withCredentials: !0 }, i)),
												(0, r.v_)(e, n, o, i).then(function (e) {
													return t.createTransaction(e);
												})
											);
										}
										function c(e) {
											return e.options.storageUtil.storage.get(i.STATE_TOKEN_KEY_NAME);
										}
										var d = n(3144),
											f = n(5671),
											p = n(4942),
											h = n(3193),
											m = n(4771),
											v = n(6718);
										function g(e, t, n, i, s, l) {
											if (Array.isArray(s))
												return function (r, a) {
													if (!r) throw new o.Z('Must provide a link name');
													var u = (0, h.sE)(s, { name: r });
													if (!u) throw new o.Z('No link found for that name');
													return g(e, t, n, i, u, l)(a);
												};
											if (s.hints && s.hints.allow && 1 === s.hints.allow.length)
												switch (s.hints.allow[0]) {
													case 'GET':
														return function () {
															return (0, r.U2)(e, s.href, { withCredentials: !0 });
														};
													case 'POST':
														return function (r) {
															l && l.isPolling && (l.isPolling = !1);
															var c = a(n, r);
															('MFA_ENROLL' !== n.status && 'FACTOR_ENROLL' !== n.status) ||
																Object.assign(c, { factorType: i.factorType, provider: i.provider });
															var d = {},
																f = c.autoPush;
															if (void 0 !== f) {
																if ('function' == typeof f)
																	try {
																		d.autoPush = !!f();
																	} catch (e) {
																		return Promise.reject(new o.Z('AutoPush resulted in an error.'));
																	}
																else null !== f && (d.autoPush = !!f);
																c = (0, h.CE)(c, 'autoPush');
															}
															var p = c.rememberDevice;
															if (void 0 !== p) {
																if ('function' == typeof p)
																	try {
																		d.rememberDevice = !!p();
																	} catch (e) {
																		return Promise.reject(new o.Z('RememberDevice resulted in an error.'));
																	}
																else null !== p && (d.rememberDevice = !!p);
																c = (0, h.CE)(c, 'rememberDevice');
															} else
																c.profile &&
																	void 0 !== c.profile.updatePhone &&
																	(c.profile.updatePhone && (d.updatePhone = !0),
																	(c.profile = (0, h.CE)(c.profile, 'updatePhone')));
															var m = s.href + (0, v.UK)(d);
															return u(e, t, m, c);
														};
												}
										}
										var y = n(8750),
											b = n(6573);
										function _(e, t, n) {
											return function (s) {
												var l, u, c, d;
												(0, m.hj)(s)
													? (l = s)
													: (0, m.Kn)(s) &&
													  ((l = s.delay), (u = s.rememberDevice), (c = s.autoPush), (d = s.transactionCallBack)),
													l || 0 === l || (l = i.DEFAULT_POLLING_DELAY);
												var f = (0, h.Rg)(t, 'next', 'poll');
												n.isPolling = !0;
												var p = 0;
												return (function i() {
													return n.isPolling
														? (function () {
																var n = {};
																if ('function' == typeof c)
																	try {
																		n.autoPush = !!c();
																	} catch (e) {
																		return Promise.reject(new o.Z('AutoPush resulted in an error.'));
																	}
																else null != c && (n.autoPush = !!c);
																if ('function' == typeof u)
																	try {
																		n.rememberDevice = !!u();
																	} catch (e) {
																		return Promise.reject(new o.Z('RememberDevice resulted in an error.'));
																	}
																else null != u && (n.rememberDevice = !!u);
																var i = f.href + (0, v.UK)(n);
																return (0, r.v_)(
																	e,
																	i,
																	(function (e) {
																		return a(e);
																	})(t),
																	{ saveAuthnState: !1, withCredentials: !0, pollingIntent: !0 }
																);
														  })()
																.then(function (t) {
																	if (((p = 0), t.factorResult && 'WAITING' === t.factorResult)) {
																		if (!n.isPolling) throw new b.Z();
																		return 'function' == typeof d && d(t), (0, y.gw)(l).then(i);
																	}
																	return (n.isPolling = !1), e.tx.createTransaction(t);
																})
																.catch(function (e) {
																	if (e.xhr && (0 === e.xhr.status || 429 === e.xhr.status) && p <= 4) {
																		var t = 1e3 * Math.pow(2, p);
																		return p++, (0, y.gw)(t).then(i);
																	}
																	throw e;
																})
														: Promise.reject(new b.Z());
												})().catch(function (e) {
													throw ((n.isPolling = !1), e);
												});
											};
										}
										function w(e, t, n, r, o) {
											if (((r = r || n), (r = (0, h.d9)(r)), Array.isArray(r))) {
												for (var i = [], a = 0, s = r.length; a < s; a++) i.push(w(e, t, n, r[a], o));
												return i;
											}
											var l = r._embedded || {};
											for (var u in l)
												Object.prototype.hasOwnProperty.call(l, u) &&
													((0, m.Kn)(l[u]) || Array.isArray(l[u])) &&
													(l[u] = w(e, t, n, l[u], o));
											var c = (function (e, t, n, r, o) {
												var i = {};
												for (var a in r._links)
													if (Object.prototype.hasOwnProperty.call(r._links, a)) {
														var s = r._links[a];
														if (('next' === a && (a = s.name), s.type)) i[a] = s;
														else if ('poll' === a) i.poll = _(e, n, o);
														else {
															var l = g(e, t, n, r, s, o);
															l && (i[a] = l);
														}
													}
												return i;
											})(e, t, n, r, o);
											return Object.assign(l, c), (r = (0, h.CE)(r, '_embedded', '_links')), Object.assign(r, l), r;
										}
										var O = (0, d.Z)(function e(t, n) {
											var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
											(0, f.Z)(this, e),
												(0, p.Z)(this, 'next', void 0),
												(0, p.Z)(this, 'cancel', void 0),
												(0, p.Z)(this, 'skip', void 0),
												(0, p.Z)(this, 'unlock', void 0),
												(0, p.Z)(this, 'changePassword', void 0),
												(0, p.Z)(this, 'resetPassword', void 0),
												(0, p.Z)(this, 'answer', void 0),
												(0, p.Z)(this, 'recovery', void 0),
												(0, p.Z)(this, 'verify', void 0),
												(0, p.Z)(this, 'resend', void 0),
												(0, p.Z)(this, 'activate', void 0),
												(0, p.Z)(this, 'poll', void 0),
												(0, p.Z)(this, 'prev', void 0),
												(0, p.Z)(this, 'data', void 0),
												(0, p.Z)(this, 'stateToken', void 0),
												(0, p.Z)(this, 'sessionToken', void 0),
												(0, p.Z)(this, 'status', void 0),
												(0, p.Z)(this, 'user', void 0),
												(0, p.Z)(this, 'factor', void 0),
												(0, p.Z)(this, 'factors', void 0),
												(0, p.Z)(this, 'policy', void 0),
												(0, p.Z)(this, 'scopes', void 0),
												(0, p.Z)(this, 'target', void 0),
												(0, p.Z)(this, 'authentication', void 0),
												(this.data = void 0),
												(this.status = void 0),
												r &&
													((this.data = r),
													Object.assign(this, w(t, n, r, r, {})),
													delete this.stateToken,
													'RECOVERY_CHALLENGE' !== r.status ||
														r._links ||
														(this.cancel = function () {
															return Promise.resolve(n.createTransaction());
														}));
										});
										function k(e) {
											var t = {
												status: s.bind(null, e),
												resume: function (n) {
													return (function (e, t, n) {
														if (!n || !n.stateToken) {
															var r = c(e);
															if (!r) return Promise.reject(new o.Z('No transaction to resume'));
															n = { stateToken: r };
														}
														return s(e, n).then(function (e) {
															return t.createTransaction(e);
														});
													})(e, t, n);
												},
												exists: l.bind(null, e),
												introspect: function (n) {
													return (function (e, t, n) {
														if (!n || !n.stateToken) {
															var i = c(e);
															if (!i) return Promise.reject(new o.Z('No transaction to evaluate'));
															n = { stateToken: i };
														}
														return (function (e, t) {
															return (
																(t = a(e, t)),
																(0, r.v_)(e, e.getIssuerOrigin() + '/api/v1/authn/introspect', t, {
																	withCredentials: !0,
																})
															);
														})(e, n).then(function (e) {
															return t.createTransaction(e);
														});
													})(e, t, n);
												},
												createTransaction: function (n) {
													return new O(e, t, n);
												},
												postToTransaction: function (n, r, o) {
													return u(e, t, n, r, o);
												},
											};
											return t;
										}
									},
									3398: function (e, t, n) {
										'use strict';
										n.d(t, {
											b: function () {
												return r.b;
											},
											t: function () {
												return o.t;
											},
										});
										var r = n(9748),
											o = n(3164);
									},
									3164: function (e, t, n) {
										'use strict';
										n.d(t, {
											t: function () {
												return v;
											},
										});
										var r = n(5861),
											o = n(5671),
											i = n(3144),
											a = n(7326),
											s = n(136),
											l = n(2963),
											u = n(1120),
											c = n(4942),
											d = n(4687),
											f = n.n(d),
											p = n(3193),
											h = n(8719),
											m = n(9748);
										function v(e) {
											return (function (e) {
												(0, s.Z)(y, e);
												var t,
													n,
													d,
													v,
													g =
														((d = y),
														(v = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																t = (0, u.Z)(d);
															if (v) {
																var n = (0, u.Z)(this).constructor;
																e = Reflect.construct(t, arguments, n);
															} else e = t.apply(this, arguments);
															return (0, l.Z)(this, e);
														});
												function y() {
													var e;
													(0, o.Z)(this, y);
													for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
													return (
														(e = g.call.apply(g, [this].concat(n))),
														(0, c.Z)((0, a.Z)(e), 'tx', void 0),
														(0, c.Z)((0, a.Z)(e), 'authn', void 0),
														(0, c.Z)((0, a.Z)(e), 'fingerprint', void 0),
														(e.authn = e.tx = (0, m.b)((0, a.Z)(e))),
														(e.fingerprint = h.Z.bind(null, (0, a.Z)(e))),
														e
													);
												}
												return (
													(0, i.Z)(y, [
														{
															key: 'signIn',
															value:
																((n = (0, r.Z)(
																	f().mark(function e(t) {
																		var n,
																			r = this;
																		return f().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							if (
																								((t = (0, p.d9)(t || {})),
																								(n = function (e) {
																									return (
																										delete t.sendFingerprint,
																										r.tx.postToTransaction('/api/v1/authn', t, e)
																									);
																								}),
																								t.sendFingerprint)
																							) {
																								e.next = 4;
																								break;
																							}
																							return e.abrupt('return', n());
																						case 4:
																							return e.abrupt(
																								'return',
																								this.fingerprint().then(function (e) {
																									return n({ headers: { 'X-Device-Fingerprint': e } });
																								})
																							);
																						case 5:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function (e) {
																	return n.apply(this, arguments);
																}),
														},
														{
															key: 'signInWithCredentials',
															value:
																((t = (0, r.Z)(
																	f().mark(function e(t) {
																		return f().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							return e.abrupt('return', this.signIn(t));
																						case 1:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function (e) {
																	return t.apply(this, arguments);
																}),
														},
														{
															key: 'forgotPassword',
															value: function (e) {
																return this.tx.postToTransaction('/api/v1/authn/recovery/password2', e);
															},
														},
														{
															key: 'unlockAccount',
															value: function (e) {
																return this.tx.postToTransaction('/api/v1/authn/recovery/unlock', e);
															},
														},
														{
															key: 'verifyRecoveryToken',
															value: function (e) {
																return this.tx.postToTransaction('/api/v1/authn/recovery/token', e);
															},
														},
													]),
													y
												);
											})(e);
										}
									},
									9893: function (e, t, n) {
										'use strict';
										n.d(t, {
											a: function () {
												return d;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(4942),
											a = n(3193),
											s = n(415),
											l = n(1971),
											u = n(4279),
											c = n.n(u);
										function d(e) {
											var t = (0, r.Z)(function t() {
												(0, o.Z)(this, t),
													(0, i.Z)(this, 'options', void 0),
													(0, i.Z)(this, 'emitter', void 0),
													(0, i.Z)(this, 'features', void 0);
												var n = new e((arguments.length && (arguments.length <= 0 ? void 0 : arguments[0])) || {});
												(this.options = (0, a.YY)(n)), (this.emitter = new (c())()), (this.features = s);
											});
											return (
												(0, i.Z)(t, 'features', s),
												(0, i.Z)(t, 'constants', l),
												(t.features = t.prototype.features = s),
												Object.assign(t, { constants: l }),
												t
											);
										}
									},
									3306: function (e, t, n) {
										'use strict';
										n.d(t, {
											X: function () {
												return o.X;
											},
											a: function () {
												return r.a;
											},
										});
										var r = n(9893),
											o = n(5093);
									},
									5093: function (e, t, n) {
										'use strict';
										n.d(t, {
											X: function () {
												return a;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(4942);
										function a() {
											return (0, r.Z)(function e(t) {
												(0, o.Z)(this, e), (0, i.Z)(this, 'devMode', void 0), (this.devMode = !!t.devMode);
											});
										}
									},
									4858: function (e, t, n) {
										'use strict';
										function r(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = arguments[t];
												for (var r in n) e[r] = n[r];
											}
											return e;
										}
										n.d(t, {
											Z: function () {
												return c;
											},
										});
										var o = (function e(t, n) {
												function o(e, o, i) {
													if ('undefined' != typeof document) {
														'number' == typeof (i = r({}, n, i)).expires &&
															(i.expires = new Date(Date.now() + 864e5 * i.expires)),
															i.expires && (i.expires = i.expires.toUTCString()),
															(e = encodeURIComponent(e)
																.replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
																.replace(/[()]/g, escape));
														var a = '';
														for (var s in i) i[s] && ((a += '; ' + s), !0 !== i[s] && (a += '=' + i[s].split(';')[0]));
														return (document.cookie = e + '=' + t.write(o, e) + a);
													}
												}
												return Object.create(
													{
														set: o,
														get: function (e) {
															if ('undefined' != typeof document && (!arguments.length || e)) {
																for (
																	var n = document.cookie ? document.cookie.split('; ') : [], r = {}, o = 0;
																	o < n.length;
																	o++
																) {
																	var i = n[o].split('='),
																		a = i.slice(1).join('=');
																	try {
																		var s = decodeURIComponent(i[0]);
																		if (((r[s] = t.read(a, s)), e === s)) break;
																	} catch (e) {}
																}
																return e ? r[e] : r;
															}
														},
														remove: function (e, t) {
															o(e, '', r({}, t, { expires: -1 }));
														},
														withAttributes: function (t) {
															return e(this.converter, r({}, this.attributes, t));
														},
														withConverter: function (t) {
															return e(r({}, this.converter, t), this.attributes);
														},
													},
													{ attributes: { value: Object.freeze(n) }, converter: { value: Object.freeze(t) } }
												);
											})(
												{
													read: function (e) {
														return (
															'"' === e[0] && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
														);
													},
													write: function (e) {
														return encodeURIComponent(e).replace(
															/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
															decodeURIComponent
														);
													},
												},
												{ path: '/' }
											),
											i = o,
											a = n(9123),
											s = n(146),
											l = n(415),
											u = {
												browserHasLocalStorage: function () {
													try {
														var e = this.getLocalStorage();
														return this.testStorage(e);
													} catch (e) {
														return !1;
													}
												},
												browserHasSessionStorage: function () {
													try {
														var e = this.getSessionStorage();
														return this.testStorage(e);
													} catch (e) {
														return !1;
													}
												},
												testStorageType: function (e) {
													var t = !1;
													switch (e) {
														case 'sessionStorage':
															t = this.browserHasSessionStorage();
															break;
														case 'localStorage':
															t = this.browserHasLocalStorage();
															break;
														case 'cookie':
														case 'memory':
															t = !0;
															break;
														default:
															t = !1;
													}
													return t;
												},
												getStorageByType: function (e, t) {
													var n;
													switch (e) {
														case 'sessionStorage':
															n = this.getSessionStorage();
															break;
														case 'localStorage':
															n = this.getLocalStorage();
															break;
														case 'cookie':
															n = this.getCookieStorage(t);
															break;
														case 'memory':
															n = this.getInMemoryStorage();
															break;
														default:
															throw new a.Z('Unrecognized storage option: '.concat(e));
													}
													return n;
												},
												findStorageType: function (e) {
													var t, n;
													return (
														(t = (e = e.slice()).shift()),
														(n = e.length ? e[0] : null)
															? this.testStorageType(t)
																? t
																: ((0, s.ZK)(
																		"This browser doesn't support ".concat(t, '. Switching to ').concat(n, '.')
																  ),
																  this.findStorageType(e))
															: t
													);
												},
												getLocalStorage: function () {
													return (
														(0, l.isIE11OrLess)() && !window.onstorage && (window.onstorage = function () {}),
														localStorage
													);
												},
												getSessionStorage: function () {
													return sessionStorage;
												},
												getCookieStorage: function (e) {
													var t = this,
														n = e.secure,
														r = e.sameSite,
														o = e.sessionCookie;
													if (void 0 === n || void 0 === r)
														throw new a.Z('getCookieStorage: "secure" and "sameSite" options must be provided');
													var i = {
														getItem: this.storage.get,
														setItem: function (e, i) {
															var a =
																arguments.length > 2 && void 0 !== arguments[2]
																	? arguments[2]
																	: '2200-01-01T00:00:00.000Z';
															(a = o ? null : a), t.storage.set(e, i, a, { secure: n, sameSite: r });
														},
														removeItem: function (e) {
															t.storage.delete(e);
														},
													};
													return e.useSeparateCookies
														? {
																getItem: function (e) {
																	var t = i.getItem(),
																		n = {};
																	return (
																		Object.keys(t).forEach(function (r) {
																			0 === r.indexOf(e) && (n[r.replace(''.concat(e, '_'), '')] = JSON.parse(t[r]));
																		}),
																		JSON.stringify(n)
																	);
																},
																setItem: function (e, t) {
																	var n = JSON.parse(this.getItem(e));
																	(t = JSON.parse(t)),
																		Object.keys(t).forEach(function (r) {
																			var o = e + '_' + r,
																				a = JSON.stringify(t[r]);
																			i.setItem(o, a), delete n[r];
																		}),
																		Object.keys(n).forEach(function (t) {
																			i.removeItem(e + '_' + t);
																		});
																},
																removeItem: function (e) {
																	var t = JSON.parse(this.getItem(e));
																	Object.keys(t).forEach(function (t) {
																		i.removeItem(e + '_' + t);
																	});
																},
														  }
														: i;
												},
												inMemoryStore: {},
												getInMemoryStorage: function () {
													var e = this;
													return {
														getItem: function (t) {
															return e.inMemoryStore[t];
														},
														setItem: function (t, n) {
															e.inMemoryStore[t] = n;
														},
													};
												},
												testStorage: function (e) {
													var t = 'okta-test-storage';
													try {
														return e.setItem(t, t), e.removeItem(t), !0;
													} catch (e) {
														return !1;
													}
												},
												storage: {
													set: function (e, t, n, r) {
														var o = r.sameSite,
															s = r.secure;
														if (void 0 === s || void 0 === o)
															throw new a.Z('storage.set: "secure" and "sameSite" options must be provided');
														var l = { path: r.path || '/', secure: s, sameSite: o };
														return Date.parse(n) && (l.expires = new Date(n)), i.set(e, t, l), this.get(e);
													},
													get: function (e) {
														return arguments.length ? i.get(e) : i.get();
													},
													delete: function (e) {
														return i.remove(e, { path: '/' });
													},
												},
											},
											c = u;
									},
									8719: function (e, t, n) {
										'use strict';
										n.d(t, {
											Z: function () {
												return s;
											},
										});
										var r = n(9123),
											o = n(415),
											i = n(4970),
											a = function (e, t) {
												return t.source === e.contentWindow;
											};
										function s(e, t) {
											var n;
											if (!(0, o.isFingerprintSupported)())
												return Promise.reject(new r.Z('Fingerprinting is not supported on this device'));
											var s,
												l,
												u,
												c = null !== (n = null == t ? void 0 : t.container) && void 0 !== n ? n : document.body;
											return new Promise(function (n, o) {
												((l = document.createElement('iframe')).style.display = 'none'),
													(u = function (t) {
														if (a(l, t) && t && t.data && t.origin === e.getIssuerOrigin()) {
															var i, s, u;
															try {
																i = JSON.parse(t.data);
															} catch (e) {
																return;
															}
															if (i)
																return 'FingerprintAvailable' === i.type
																	? n(i.fingerprint)
																	: 'FingerprintServiceReady' !== i.type
																	? o(new r.Z('No data'))
																	: void (
																			null === (s = l) ||
																			void 0 === s ||
																			null === (u = s.contentWindow) ||
																			void 0 === u ||
																			u.postMessage(JSON.stringify({ type: 'GetFingerprint' }), t.origin)
																	  );
														}
													}),
													(0, i.NH)(window, 'message', u),
													(l.src = e.getIssuerOrigin() + '/auth/services/devicefingerprint'),
													c.appendChild(l),
													(s = setTimeout(function () {
														o(new r.Z('Fingerprinting timed out'));
													}, (null == t ? void 0 : t.timeout) || 15e3));
											}).finally(function () {
												var e;
												clearTimeout(s),
													(0, i.ys)(window, 'message', u),
													c.contains(l) && (null === (e = l.parentElement) || void 0 === e || e.removeChild(l));
											});
										}
									},
									1971: function (e, t, n) {
										'use strict';
										n.r(t),
											n.d(t, {
												ACCESS_TOKEN_STORAGE_KEY: function () {
													return m;
												},
												CACHE_STORAGE_NAME: function () {
													return u;
												},
												DEFAULT_CACHE_DURATION: function () {
													return s;
												},
												DEFAULT_CODE_CHALLENGE_METHOD: function () {
													return w;
												},
												DEFAULT_MAX_CLOCK_SKEW: function () {
													return a;
												},
												DEFAULT_POLLING_DELAY: function () {
													return o;
												},
												IDX_API_VERSION: function () {
													return O;
												},
												IDX_RESPONSE_STORAGE_NAME: function () {
													return h;
												},
												ID_TOKEN_STORAGE_KEY: function () {
													return v;
												},
												IOS_MAX_RETRY_COUNT: function () {
													return i;
												},
												MAX_VERIFIER_LENGTH: function () {
													return _;
												},
												MIN_VERIFIER_LENGTH: function () {
													return b;
												},
												ORIGINAL_URI_STORAGE_NAME: function () {
													return p;
												},
												PKCE_STORAGE_NAME: function () {
													return c;
												},
												REFERRER_PATH_STORAGE_KEY: function () {
													return y;
												},
												REFRESH_TOKEN_STORAGE_KEY: function () {
													return g;
												},
												SHARED_TRANSACTION_STORAGE_NAME: function () {
													return f;
												},
												STATE_TOKEN_KEY_NAME: function () {
													return r;
												},
												TOKEN_STORAGE_NAME: function () {
													return l;
												},
												TRANSACTION_STORAGE_NAME: function () {
													return d;
												},
											});
										var r = 'oktaStateToken',
											o = 500,
											i = 3,
											a = 300,
											s = 86400,
											l = 'okta-token-storage',
											u = 'okta-cache-storage',
											c = 'okta-pkce-storage',
											d = 'okta-transaction-storage',
											f = 'okta-shared-transaction-storage',
											p = 'okta-original-uri-storage',
											h = 'okta-idx-response-storage',
											m = 'accessToken',
											v = 'idToken',
											g = 'refreshToken',
											y = 'referrerPath',
											b = 43,
											_ = 128,
											w = 'S256',
											O = '1.0.0';
									},
									1018: function (e, t, n) {
										'use strict';
										n.d(t, {
											E: function () {
												return _;
											},
											a: function () {
												return g;
											},
										});
										var r = n(5861),
											o = n(5671),
											i = n(3144),
											a = n(4942),
											s = n(4687),
											l = n.n(s),
											u = n(3615),
											c = n.n(u),
											d = n(9123),
											f = n(7088),
											p = n(3548),
											h = n(146);
										function m(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function v(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? m(Object(n), !0).forEach(function (t) {
															(0, a.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: m(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var g = null,
											y = { updateAuthStatePromise: null, canceledTimes: 0 },
											b = 'authStateChange',
											_ = (function () {
												function e(t) {
													var n = this;
													if (
														((0, o.Z)(this, e),
														(0, a.Z)(this, '_sdk', void 0),
														(0, a.Z)(this, '_pending', void 0),
														(0, a.Z)(this, '_authState', void 0),
														(0, a.Z)(this, '_prevAuthState', void 0),
														(0, a.Z)(this, '_logOptions', void 0),
														(0, a.Z)(this, '_transformQueue', void 0),
														!t.emitter)
													)
														throw new d.Z('Emitter should be initialized before AuthStateManager');
													(this._sdk = t),
														(this._pending = v({}, y)),
														(this._authState = g),
														(this._logOptions = {}),
														(this._prevAuthState = null),
														(this._transformQueue = new p.b({ quiet: !0 })),
														t.tokenManager.on(f.O3, function (e, t) {
															n._setLogOptions({ event: f.O3, key: e, token: t }), n.updateAuthState();
														}),
														t.tokenManager.on(f.FT, function (e, t) {
															n._setLogOptions({ event: f.FT, key: e, token: t }), n.updateAuthState();
														});
												}
												var t;
												return (
													(0, i.Z)(e, [
														{
															key: '_setLogOptions',
															value: function (e) {
																this._logOptions = e;
															},
														},
														{
															key: 'getAuthState',
															value: function () {
																return this._authState;
															},
														},
														{
															key: 'getPreviousAuthState',
															value: function () {
																return this._prevAuthState;
															},
														},
														{
															key: 'updateAuthState',
															value:
																((t = (0, r.Z)(
																	l().mark(function e() {
																		var t,
																			n,
																			r,
																			o,
																			i,
																			a,
																			s,
																			u = this;
																		return l().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							if (
																								((t = this._sdk.options),
																								(n = t.transformAuthState),
																								(r = t.devMode),
																								(o = function (e) {
																									var t = u._logOptions,
																										n = t.event,
																										r = t.key,
																										o = t.token;
																									(0, h.dr)().group(
																										'OKTA-AUTH-JS:updateAuthState: Event:'
																											.concat(n, ' Status:')
																											.concat(e)
																									),
																										(0, h.dr)().log(r, o),
																										(0, h.dr)().log('Current authState', u._authState),
																										(0, h.dr)().groupEnd(),
																										(u._logOptions = {});
																								}),
																								(i = function (e) {
																									var t, n;
																									(n = e),
																										(t = u._authState) &&
																										t.isAuthenticated === n.isAuthenticated &&
																										JSON.stringify(t.idToken) === JSON.stringify(n.idToken) &&
																										JSON.stringify(t.accessToken) === JSON.stringify(n.accessToken) &&
																										t.error === n.error
																											? r && o('unchanged')
																											: ((u._prevAuthState = u._authState),
																											  (u._authState = e),
																											  u._sdk.emitter.emit(b, v({}, e)),
																											  r && o('emitted'));
																								}),
																								(a = function e(t) {
																									return u._pending.updateAuthStatePromise.then(function () {
																										var n = u._pending.updateAuthStatePromise;
																										return n && n !== t ? e(n) : u.getAuthState();
																									});
																								}),
																								!this._pending.updateAuthStatePromise)
																							) {
																								e.next = 11;
																								break;
																							}
																							if (!(this._pending.canceledTimes >= 10)) {
																								e.next = 10;
																								break;
																							}
																							return (
																								r && o('terminated'),
																								e.abrupt('return', a(this._pending.updateAuthStatePromise))
																							);
																						case 10:
																							this._pending.updateAuthStatePromise.cancel();
																						case 11:
																							return (
																								(s = new (c())(function (e, t, a) {
																									(a.shouldReject = !1),
																										a(function () {
																											(u._pending.updateAuthStatePromise = null),
																												(u._pending.canceledTimes = u._pending.canceledTimes + 1),
																												r && o('canceled');
																										});
																									var l = function (t) {
																										s.isCanceled ? e() : (i(t), e(), (u._pending = v({}, y)));
																									};
																									u._sdk.isAuthenticated().then(function () {
																										if (s.isCanceled) e();
																										else {
																											var t = u._sdk.tokenManager.getTokensSync(),
																												r = t.accessToken,
																												o = t.idToken,
																												i = t.refreshToken,
																												a = {
																													accessToken: r,
																													idToken: o,
																													refreshToken: i,
																													isAuthenticated: !(!r || !o),
																												};
																											(n
																												? u._transformQueue.push(n, null, u._sdk, a)
																												: Promise.resolve(a)
																											)
																												.then(function (e) {
																													return l(e);
																												})
																												.catch(function (e) {
																													return l({
																														accessToken: r,
																														idToken: o,
																														refreshToken: i,
																														isAuthenticated: !1,
																														error: e,
																													});
																												});
																										}
																									});
																								})),
																								(this._pending.updateAuthStatePromise = s),
																								e.abrupt('return', a(s))
																							);
																						case 14:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function () {
																	return t.apply(this, arguments);
																}),
														},
														{
															key: 'subscribe',
															value: function (e) {
																this._sdk.emitter.on(b, e);
															},
														},
														{
															key: 'unsubscribe',
															value: function (e) {
																this._sdk.emitter.off(b, e);
															},
														},
													]),
													e
												);
											})();
									},
									7145: function (e, t, n) {
										'use strict';
										n.d(t, {
											W: function () {
												return ge;
											},
										});
										var r = n(885),
											o = n(2982),
											i = n(5861),
											a = n(5671),
											s = n(3144),
											l = n(4942),
											u = n(4687),
											c = n.n(u);
										Promise.resolve(!1);
										var d = Promise.resolve(!0),
											f = Promise.resolve();
										function p(e, t) {
											return (
												e || (e = 0),
												new Promise(function (n) {
													return setTimeout(function () {
														return n(t);
													}, e);
												})
											);
										}
										function h() {
											return Math.random().toString(36).substring(2);
										}
										var m = 0,
											v = 0;
										function g() {
											var e = new Date().getTime();
											return e === m ? 1e3 * e + ++v : ((m = e), (v = 0), 1e3 * e);
										}
										var y = {
												create: function (e) {
													var t = { messagesCallback: null, bc: new BroadcastChannel(e), subFns: [] };
													return (
														(t.bc.onmessage = function (e) {
															t.messagesCallback && t.messagesCallback(e.data);
														}),
														t
													);
												},
												close: function (e) {
													e.bc.close(), (e.subFns = []);
												},
												onMessage: function (e, t) {
													e.messagesCallback = t;
												},
												postMessage: function (e, t) {
													try {
														return e.bc.postMessage(t, !1), f;
													} catch (e) {
														return Promise.reject(e);
													}
												},
												canBeUsed: function () {
													if (
														('undefined' == typeof window && 'undefined' == typeof self) ||
														'function' != typeof BroadcastChannel
													)
														return !1;
													if (BroadcastChannel._pubkey)
														throw new Error(
															'BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill'
														);
													return !0;
												},
												type: 'native',
												averageResponseTime: function () {
													return 150;
												},
												microSeconds: g,
											},
											b = (function () {
												function e(e) {
													(this.ttl = e), (this.map = new Map()), (this._to = !1);
												}
												return (
													(e.prototype.has = function (e) {
														return this.map.has(e);
													}),
													(e.prototype.add = function (e) {
														var t = this;
														this.map.set(e, _()),
															this._to ||
																((this._to = !0),
																setTimeout(function () {
																	(t._to = !1),
																		(function (e) {
																			for (var t = _() - e.ttl, n = e.map[Symbol.iterator](); ; ) {
																				var r = n.next().value;
																				if (!r) return;
																				var o = r[0];
																				if (!(r[1] < t)) return;
																				e.map.delete(o);
																			}
																		})(t);
																}, 0));
													}),
													(e.prototype.clear = function () {
														this.map.clear();
													}),
													e
												);
											})();
										function _() {
											return new Date().getTime();
										}
										function w() {
											var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
												t = JSON.parse(JSON.stringify(e));
											return (
												void 0 === t.webWorkerSupport && (t.webWorkerSupport = !0),
												t.idb || (t.idb = {}),
												t.idb.ttl || (t.idb.ttl = 45e3),
												t.idb.fallbackInterval || (t.idb.fallbackInterval = 150),
												e.idb && 'function' == typeof e.idb.onclose && (t.idb.onclose = e.idb.onclose),
												t.localstorage || (t.localstorage = {}),
												t.localstorage.removeTimeout || (t.localstorage.removeTimeout = 6e4),
												e.methods && (t.methods = e.methods),
												t.node || (t.node = {}),
												t.node.ttl || (t.node.ttl = 12e4),
												t.node.maxParallelWrites || (t.node.maxParallelWrites = 2048),
												void 0 === t.node.useFastPath && (t.node.useFastPath = !0),
												t
											);
										}
										var O = 'messages',
											k = { durability: 'relaxed' };
										function x() {
											if ('undefined' != typeof indexedDB) return indexedDB;
											if ('undefined' != typeof window) {
												if (void 0 !== window.mozIndexedDB) return window.mozIndexedDB;
												if (void 0 !== window.webkitIndexedDB) return window.webkitIndexedDB;
												if (void 0 !== window.msIndexedDB) return window.msIndexedDB;
											}
											return !1;
										}
										function E(e) {
											e.commit && e.commit();
										}
										function T(e) {
											e.closed ||
												S(e)
													.then(function () {
														return p(e.options.idb.fallbackInterval);
													})
													.then(function () {
														return T(e);
													});
										}
										function S(e) {
											return e.closed
												? f
												: e.messagesCallback
												? (function (e, t) {
														var n = e.transaction(O, 'readonly', k),
															r = n.objectStore(O),
															o = [],
															i = IDBKeyRange.bound(t + 1, 1 / 0);
														if (r.getAll) {
															var a = r.getAll(i);
															return new Promise(function (e, t) {
																(a.onerror = function (e) {
																	return t(e);
																}),
																	(a.onsuccess = function (t) {
																		e(t.target.result);
																	});
															});
														}
														return new Promise(function (e, a) {
															var s = (function () {
																try {
																	return (i = IDBKeyRange.bound(t + 1, 1 / 0)), r.openCursor(i);
																} catch (e) {
																	return r.openCursor();
																}
															})();
															(s.onerror = function (e) {
																return a(e);
															}),
																(s.onsuccess = function (r) {
																	var i = r.target.result;
																	i
																		? i.value.id < t + 1
																			? i.continue(t + 1)
																			: (o.push(i.value), i.continue())
																		: (E(n), e(o));
																});
														});
												  })(e.db, e.lastCursorId).then(function (t) {
														var n = t
															.filter(function (e) {
																return !!e;
															})
															.map(function (t) {
																return t.id > e.lastCursorId && (e.lastCursorId = t.id), t;
															})
															.filter(function (t) {
																return (function (e, t) {
																	return !(
																		e.uuid === t.uuid ||
																		t.eMIs.has(e.id) ||
																		e.data.time < t.messagesCallbackTime
																	);
																})(t, e);
															})
															.sort(function (e, t) {
																return e.time - t.time;
															});
														return (
															n.forEach(function (t) {
																e.messagesCallback && (e.eMIs.add(t.id), e.messagesCallback(t.data));
															}),
															f
														);
												  })
												: f;
										}
										var A = {
											create: function (e, t) {
												return (
													(t = w(t)),
													(function (e) {
														var t = 'pubkey.broadcast-channel-0-' + e,
															n = x().open(t);
														return (
															(n.onupgradeneeded = function (e) {
																e.target.result.createObjectStore(O, { keyPath: 'id', autoIncrement: !0 });
															}),
															new Promise(function (e, t) {
																(n.onerror = function (e) {
																	return t(e);
																}),
																	(n.onsuccess = function () {
																		e(n.result);
																	});
															})
														);
													})(e).then(function (n) {
														var r = {
															closed: !1,
															lastCursorId: 0,
															channelName: e,
															options: t,
															uuid: h(),
															eMIs: new b(2 * t.idb.ttl),
															writeBlockPromise: f,
															messagesCallback: null,
															readQueuePromises: [],
															db: n,
														};
														return (
															(n.onclose = function () {
																(r.closed = !0), t.idb.onclose && t.idb.onclose();
															}),
															T(r),
															r
														);
													})
												);
											},
											close: function (e) {
												(e.closed = !0), e.db.close();
											},
											onMessage: function (e, t, n) {
												(e.messagesCallbackTime = n), (e.messagesCallback = t), S(e);
											},
											postMessage: function (e, t) {
												return (
													(e.writeBlockPromise = e.writeBlockPromise
														.then(function () {
															return (function (e, t, n) {
																var r = { uuid: t, time: new Date().getTime(), data: n },
																	o = e.transaction([O], 'readwrite', k);
																return new Promise(function (e, t) {
																	(o.oncomplete = function () {
																		return e();
																	}),
																		(o.onerror = function (e) {
																			return t(e);
																		}),
																		o.objectStore(O).add(r),
																		E(o);
																});
															})(e.db, e.uuid, t);
														})
														.then(function () {
															0 === Math.floor(11 * Math.random() + 0) &&
																(function (e) {
																	return ((t = e.db),
																	(n = e.options.idb.ttl),
																	(r = new Date().getTime() - n),
																	(o = t.transaction(O, 'readonly', k)),
																	(i = o.objectStore(O)),
																	(a = []),
																	new Promise(function (e) {
																		i.openCursor().onsuccess = function (t) {
																			var n = t.target.result;
																			if (n) {
																				var i = n.value;
																				i.time < r ? (a.push(i), n.continue()) : (E(o), e(a));
																			} else e(a);
																		};
																	})).then(function (t) {
																		return (function (e, t) {
																			if (e.closed) return Promise.resolve([]);
																			var n = e.db.transaction(O, 'readwrite', k).objectStore(O);
																			return Promise.all(
																				t.map(function (e) {
																					var t = n.delete(e);
																					return new Promise(function (e) {
																						t.onsuccess = function () {
																							return e();
																						};
																					});
																				})
																			);
																		})(
																			e,
																			t.map(function (e) {
																				return e.id;
																			})
																		);
																	});
																	var t, n, r, o, i, a;
																})(e);
														})),
													e.writeBlockPromise
												);
											},
											canBeUsed: function () {
												return !!x();
											},
											type: 'idb',
											averageResponseTime: function (e) {
												return 2 * e.idb.fallbackInterval;
											},
											microSeconds: g,
										};
										function C() {
											var e;
											if ('undefined' == typeof window) return null;
											try {
												(e = window.localStorage), (e = window['ie8-eventlistener/storage'] || window.localStorage);
											} catch (e) {}
											return e;
										}
										function P(e) {
											return 'pubkey.broadcastChannel-' + e;
										}
										function R() {
											var e = C();
											if (!e) return !1;
											try {
												var t = '__broadcastchannel_check';
												e.setItem(t, 'works'), e.removeItem(t);
											} catch (e) {
												return !1;
											}
											return !0;
										}
										var I = {
												create: function (e, t) {
													if (((t = w(t)), !R())) throw new Error('BroadcastChannel: localstorage cannot be used');
													var n = h(),
														r = new b(t.localstorage.removeTimeout),
														o = { channelName: e, uuid: n, eMIs: r };
													return (
														(o.listener = (function (e, t) {
															var i = P(e),
																a = function (e) {
																	var t;
																	e.key === i &&
																		((t = JSON.parse(e.newValue)),
																		o.messagesCallback &&
																			t.uuid !== n &&
																			t.token &&
																			!r.has(t.token) &&
																			((t.data.time && t.data.time < o.messagesCallbackTime) ||
																				(r.add(t.token), o.messagesCallback(t.data))));
																};
															return window.addEventListener('storage', a), a;
														})(e)),
														o
													);
												},
												close: function (e) {
													var t;
													(t = e.listener), window.removeEventListener('storage', t);
												},
												onMessage: function (e, t, n) {
													(e.messagesCallbackTime = n), (e.messagesCallback = t);
												},
												postMessage: function (e, t) {
													return new Promise(function (n) {
														p().then(function () {
															var r = P(e.channelName),
																o = { token: h(), time: new Date().getTime(), data: t, uuid: e.uuid },
																i = JSON.stringify(o);
															C().setItem(r, i);
															var a = document.createEvent('Event');
															a.initEvent('storage', !0, !0),
																(a.key = r),
																(a.newValue = i),
																window.dispatchEvent(a),
																n();
														});
													});
												},
												canBeUsed: R,
												type: 'localstorage',
												averageResponseTime: function () {
													var e = navigator.userAgent.toLowerCase();
													return e.includes('safari') && !e.includes('chrome') ? 240 : 120;
												},
												microSeconds: g,
											},
											N = g,
											M = new Set(),
											j = {
												create: function (e) {
													var t = { name: e, messagesCallback: null };
													return M.add(t), t;
												},
												close: function (e) {
													M.delete(e);
												},
												onMessage: function (e, t) {
													e.messagesCallback = t;
												},
												postMessage: function (e, t) {
													return new Promise(function (n) {
														return setTimeout(function () {
															Array.from(M)
																.filter(function (t) {
																	return t.name === e.name;
																})
																.filter(function (t) {
																	return t !== e;
																})
																.filter(function (e) {
																	return !!e.messagesCallback;
																})
																.forEach(function (e) {
																	return e.messagesCallback(t);
																}),
																n();
														}, 5);
													});
												},
												canBeUsed: function () {
													return !0;
												},
												type: 'simulate',
												averageResponseTime: function () {
													return 5;
												},
												microSeconds: N,
											},
											D = [y, A, I],
											L = new Set(),
											U = 0,
											F = function (e, t) {
												var n, r, o;
												(this.id = U++),
													L.add(this),
													(this.name = e),
													(this.options = w(t)),
													(this.method = (function (e) {
														var t = [].concat(e.methods, D).filter(Boolean);
														if (e.type) {
															if ('simulate' === e.type) return j;
															var n = t.find(function (t) {
																return t.type === e.type;
															});
															if (n) return n;
															throw new Error('method-type ' + e.type + ' not found');
														}
														e.webWorkerSupport ||
															(t = t.filter(function (e) {
																return 'idb' !== e.type;
															}));
														var r = t.find(function (e) {
															return e.canBeUsed();
														});
														if (r) return r;
														throw new Error(
															'No usable method found in ' +
																JSON.stringify(
																	D.map(function (e) {
																		return e.type;
																	})
																)
														);
													})(this.options)),
													(this._iL = !1),
													(this._onML = null),
													(this._addEL = { message: [], internal: [] }),
													(this._uMP = new Set()),
													(this._befC = []),
													(this._prepP = null),
													(o = r = (n = this).method.create(n.name, n.options)) && 'function' == typeof o.then
														? ((n._prepP = r),
														  r.then(function (e) {
																n._state = e;
														  }))
														: (n._state = r);
											};
										function B(e, t, n) {
											var r = { time: e.method.microSeconds(), type: t, data: n };
											return (e._prepP ? e._prepP : f).then(function () {
												var t = e.method.postMessage(e._state, r);
												return (
													e._uMP.add(t),
													t.catch().then(function () {
														return e._uMP.delete(t);
													}),
													t
												);
											});
										}
										function V(e) {
											return e._addEL.message.length > 0 || e._addEL.internal.length > 0;
										}
										function Z(e, t, n) {
											e._addEL[t].push(n),
												(function (e) {
													if (!e._iL && V(e)) {
														var t = function (t) {
																e._addEL[t.type].forEach(function (e) {
																	var n = e.time - 1e5;
																	t.time >= n && e.fn(t.data);
																});
															},
															n = e.method.microSeconds();
														e._prepP
															? e._prepP.then(function () {
																	(e._iL = !0), e.method.onMessage(e._state, t, n);
															  })
															: ((e._iL = !0), e.method.onMessage(e._state, t, n));
													}
												})(e);
										}
										function H(e, t, n) {
											(e._addEL[t] = e._addEL[t].filter(function (e) {
												return e !== n;
											})),
												(function (e) {
													if (e._iL && !V(e)) {
														e._iL = !1;
														var t = e.method.microSeconds();
														e.method.onMessage(e._state, null, t);
													}
												})(e);
										}
										(F._pubkey = !0),
											(F.prototype = {
												postMessage: function (e) {
													if (this.closed)
														throw new Error(
															'BroadcastChannel.postMessage(): Cannot post message after channel has closed ' +
																JSON.stringify(e)
														);
													return B(this, 'message', e);
												},
												postInternal: function (e) {
													return B(this, 'internal', e);
												},
												set onmessage(e) {
													var t = { time: this.method.microSeconds(), fn: e };
													H(this, 'message', this._onML),
														e && 'function' == typeof e
															? ((this._onML = t), Z(this, 'message', t))
															: (this._onML = null);
												},
												addEventListener: function (e, t) {
													Z(this, e, { time: this.method.microSeconds(), fn: t });
												},
												removeEventListener: function (e, t) {
													H(
														this,
														e,
														this._addEL[e].find(function (e) {
															return e.fn === t;
														})
													);
												},
												close: function () {
													var e = this;
													if (!this.closed) {
														L.delete(this), (this.closed = !0);
														var t = this._prepP ? this._prepP : f;
														return (
															(this._onML = null),
															(this._addEL.message = []),
															t
																.then(function () {
																	return Promise.all(Array.from(e._uMP));
																})
																.then(function () {
																	return Promise.all(
																		e._befC.map(function (e) {
																			return e();
																		})
																	);
																})
																.then(function () {
																	return e.method.close(e._state);
																})
														);
													}
												},
												get type() {
													return this.method.type;
												},
												get isClosed() {
													return this.closed;
												},
											});
										var q =
												'[object process]' ===
												Object.prototype.toString.call('undefined' != typeof process ? process : 0)
													? function (e) {
															process.on('exit', function () {
																return e();
															}),
																process.on('beforeExit', function () {
																	return e().then(function () {
																		return process.exit();
																	});
																}),
																process.on('SIGINT', function () {
																	return e().then(function () {
																		return process.exit();
																	});
																}),
																process.on('uncaughtException', function (t) {
																	return e().then(function () {
																		process.exit(101);
																	});
																});
													  }
													: function (e) {
															if ('function' == typeof WorkerGlobalScope && self instanceof WorkerGlobalScope) {
																var t = self.close.bind(self);
																self.close = function () {
																	return e(), t();
																};
															} else {
																if ('function' != typeof window.addEventListener) return;
																window.addEventListener(
																	'beforeunload',
																	function () {
																		e();
																	},
																	!0
																),
																	window.addEventListener(
																		'unload',
																		function () {
																			e();
																		},
																		!0
																	);
															}
													  },
											W = new Set(),
											K = !1;
										function $() {
											var e = [];
											return (
												W.forEach(function (t) {
													e.push(t()), W.delete(t);
												}),
												Promise.all(e)
											);
										}
										function z(e, t) {
											var n = { context: 'leader', action: t, token: e.token };
											return e.broadcastChannel.postInternal(n);
										}
										function G(e) {
											(e.isLeader = !0), (e._hasLeader = !0);
											var t = (function (e) {
												if ((K || ((K = !0), q($)), 'function' != typeof e)) throw new Error('Listener is no function');
												return (
													W.add(e),
													{
														remove: function () {
															return W.delete(e);
														},
														run: function () {
															return W.delete(e), e();
														},
													}
												);
											})(function () {
												return e.die();
											});
											e._unl.push(t);
											var n = function (t) {
												'leader' === t.context && 'apply' === t.action && z(e, 'tell'),
													'leader' !== t.context ||
														'tell' !== t.action ||
														e._dpLC ||
														((e._dpLC = !0), e._dpL(), z(e, 'tell'));
											};
											return e.broadcastChannel.addEventListener('internal', n), e._lstns.push(n), z(e, 'tell');
										}
										var Y = function (e, t) {
											var n = this;
											(this.broadcastChannel = e),
												e._befC.push(function () {
													return n.die();
												}),
												(this._options = t),
												(this.isLeader = !1),
												(this.isDead = !1),
												(this.token = h()),
												(this._lstns = []),
												(this._unl = []),
												(this._dpL = function () {}),
												(this._dpLC = !1),
												(this._wKMC = {}),
												(this.lN = 'pubkey-bc||' + e.method.type + '||' + e.name);
										};
										Y.prototype = {
											hasLeader: function () {
												var e = this;
												return navigator.locks.query().then(function (t) {
													var n = t.held
														? t.held.filter(function (t) {
																return t.name === e.lN;
														  })
														: [];
													return !!(n && n.length > 0);
												});
											},
											awaitLeadership: function () {
												var e = this;
												if (!this._wLMP) {
													this._wKMC.c = new AbortController();
													var t = new Promise(function (t, n) {
														(e._wKMC.res = t), (e._wKMC.rej = n);
													});
													this._wLMP = new Promise(function (n) {
														navigator.locks
															.request(e.lN, { signal: e._wKMC.c.signal }, function () {
																return (e._wKMC.c = void 0), G(e), n(), t;
															})
															.catch(function () {});
													});
												}
												return this._wLMP;
											},
											set onduplicate(e) {},
											die: function () {
												var e = this;
												return (
													this._lstns.forEach(function (t) {
														return e.broadcastChannel.removeEventListener('internal', t);
													}),
													(this._lstns = []),
													this._unl.forEach(function (e) {
														return e.remove();
													}),
													(this._unl = []),
													this.isLeader && (this.isLeader = !1),
													(this.isDead = !0),
													this._wKMC.res && this._wKMC.res(),
													this._wKMC.c && this._wKMC.c.abort('LeaderElectionWebLock.die() called'),
													z(this, 'death')
												);
											},
										};
										var J = function (e, t) {
											var n = this;
											(this.broadcastChannel = e),
												(this._options = t),
												(this.isLeader = !1),
												(this._hasLeader = !1),
												(this.isDead = !1),
												(this.token = h()),
												(this._aplQ = f),
												(this._aplQC = 0),
												(this._unl = []),
												(this._lstns = []),
												(this._dpL = function () {}),
												(this._dpLC = !1);
											var r = function (e) {
												'leader' === e.context &&
													('death' === e.action && (n._hasLeader = !1), 'tell' === e.action && (n._hasLeader = !0));
											};
											this.broadcastChannel.addEventListener('internal', r), this._lstns.push(r);
										};
										function Q(e, t) {
											if (e._leaderElector) throw new Error('BroadcastChannel already has a leader-elector');
											t = (function (e, t) {
												return (
													e || (e = {}),
													(e = JSON.parse(JSON.stringify(e))).fallbackInterval || (e.fallbackInterval = 3e3),
													e.responseTime || (e.responseTime = t.method.averageResponseTime(t.options)),
													e
												);
											})(t, e);
											var n =
												'undefined' != typeof navigator &&
												void 0 !== navigator.locks &&
												'function' == typeof navigator.locks.request
													? new Y(e, t)
													: new J(e, t);
											return (
												e._befC.push(function () {
													return n.die();
												}),
												(e._leaderElector = n),
												n
											);
										}
										J.prototype = {
											hasLeader: function () {
												return Promise.resolve(this._hasLeader);
											},
											applyOnce: function (e) {
												var t = this;
												return this.isLeader
													? p(0, !0)
													: this.isDead
													? p(0, !1)
													: this._aplQC > 1
													? this._aplQ
													: ((this._aplQC = this._aplQC + 1),
													  (this._aplQ = this._aplQ
															.then(function () {
																return (function () {
																	if (t.isLeader) return d;
																	var n,
																		r = !1,
																		o = new Promise(function (e) {
																			n = function () {
																				(r = !0), e();
																			};
																		}),
																		i = function (e) {
																			'leader' === e.context &&
																				e.token != t.token &&
																				('apply' === e.action && e.token > t.token && n(),
																				'tell' === e.action && (n(), (t._hasLeader = !0)));
																		};
																	t.broadcastChannel.addEventListener('internal', i);
																	var a = e ? 4 * t._options.responseTime : t._options.responseTime;
																	return z(t, 'apply')
																		.then(function () {
																			return Promise.race([
																				p(a),
																				o.then(function () {
																					return Promise.reject(new Error());
																				}),
																			]);
																		})
																		.then(function () {
																			return z(t, 'apply');
																		})
																		.then(function () {
																			return Promise.race([
																				p(a),
																				o.then(function () {
																					return Promise.reject(new Error());
																				}),
																			]);
																		})
																		.catch(function () {})
																		.then(function () {
																			return (
																				t.broadcastChannel.removeEventListener('internal', i),
																				!r &&
																					G(t).then(function () {
																						return !0;
																					})
																			);
																		});
																})();
															})
															.then(function () {
																t._aplQC = t._aplQC - 1;
															})),
													  this._aplQ.then(function () {
															return t.isLeader;
													  }));
											},
											awaitLeadership: function () {
												return (
													this._aLP ||
														(this._aLP = (e = this).isLeader
															? f
															: new Promise(function (t) {
																	var n = !1;
																	function r() {
																		n || ((n = !0), e.broadcastChannel.removeEventListener('internal', o), t(!0));
																	}
																	e.applyOnce().then(function () {
																		e.isLeader && r();
																	}),
																		(function t() {
																			return p(e._options.fallbackInterval).then(function () {
																				if (!e.isDead && !n)
																					return e.isLeader
																						? void r()
																						: e.applyOnce(!0).then(function () {
																								e.isLeader ? r() : t();
																						  });
																			});
																		})();
																	var o = function (t) {
																		'leader' === t.context &&
																			'death' === t.action &&
																			((e._hasLeader = !1),
																			e.applyOnce().then(function () {
																				e.isLeader && r();
																			}));
																	};
																	e.broadcastChannel.addEventListener('internal', o), e._lstns.push(o);
															  })),
													this._aLP
												);
												var e;
											},
											set onduplicate(e) {
												this._dpL = e;
											},
											die: function () {
												var e = this;
												return (
													this._lstns.forEach(function (t) {
														return e.broadcastChannel.removeEventListener('internal', t);
													}),
													(this._lstns = []),
													this._unl.forEach(function (e) {
														return e.remove();
													}),
													(this._unl = []),
													this.isLeader && ((this._hasLeader = !1), (this.isLeader = !1)),
													(this.isDead = !0),
													z(this, 'death')
												);
											},
										};
										var X = n(415),
											ee = (function () {
												function e() {
													var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
													(0, a.Z)(this, e),
														(0, l.Z)(this, 'options', void 0),
														(0, l.Z)(this, 'channel', void 0),
														(0, l.Z)(this, 'elector', void 0),
														(0, l.Z)(this, 'started', !1),
														(this.options = t),
														(this.onLeaderDuplicate = this.onLeaderDuplicate.bind(this)),
														(this.onLeader = this.onLeader.bind(this));
												}
												var t, n, r;
												return (
													(0, s.Z)(e, [
														{ key: 'onLeaderDuplicate', value: function () {} },
														{
															key: 'onLeader',
															value:
																((r = (0, i.Z)(
																	c().mark(function e() {
																		var t, n;
																		return c().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							return (
																								(e.next = 2),
																								null === (t = (n = this.options).onLeader) || void 0 === t
																									? void 0
																									: t.call(n)
																							);
																						case 2:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function () {
																	return r.apply(this, arguments);
																}),
														},
														{
															key: 'isLeader',
															value: function () {
																var e;
																return !(null === (e = this.elector) || void 0 === e || !e.isLeader);
															},
														},
														{
															key: 'hasLeader',
															value: function () {
																var e;
																return !(null === (e = this.elector) || void 0 === e || !e.hasLeader);
															},
														},
														{
															key: 'start',
															value:
																((n = (0, i.Z)(
																	c().mark(function e() {
																		var t;
																		return c().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							this.canStart() &&
																								((t = this.options.electionChannelName),
																								(this.channel = new F(t)),
																								(this.elector = Q(this.channel)),
																								(this.elector.onduplicate = this.onLeaderDuplicate),
																								this.elector.awaitLeadership().then(this.onLeader),
																								(this.started = !0));
																						case 1:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function () {
																	return n.apply(this, arguments);
																}),
														},
														{
															key: 'stop',
															value:
																((t = (0, i.Z)(
																	c().mark(function e() {
																		return c().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							if (!this.started) {
																								e.next = 11;
																								break;
																							}
																							if (!this.elector) {
																								e.next = 5;
																								break;
																							}
																							return (e.next = 4), this.elector.die();
																						case 4:
																							this.elector = void 0;
																						case 5:
																							if (!this.channel) {
																								e.next = 10;
																								break;
																							}
																							return (
																								(this.channel.postInternal = function () {
																									return Promise.resolve();
																								}),
																								(e.next = 9),
																								this.channel.close()
																							);
																						case 9:
																							this.channel = void 0;
																						case 10:
																							this.started = !1;
																						case 11:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function () {
																	return t.apply(this, arguments);
																}),
														},
														{
															key: 'requiresLeadership',
															value: function () {
																return !1;
															},
														},
														{
															key: 'isStarted',
															value: function () {
																return this.started;
															},
														},
														{
															key: 'canStart',
															value: function () {
																return (0, X.isBrowser)() && !this.started;
															},
														},
													]),
													e
												);
											})(),
											te = n(9123),
											ne = n(6488),
											re = n(7088),
											oe = (function () {
												function e(t) {
													var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
													(0, a.Z)(this, e),
														(0, l.Z)(this, 'tokenManager', void 0),
														(0, l.Z)(this, 'options', void 0),
														(0, l.Z)(this, 'renewTimeQueue', void 0),
														(0, l.Z)(this, 'started', !1),
														(this.tokenManager = t),
														(this.options = n),
														(this.renewTimeQueue = []),
														(this.onTokenExpiredHandler = this.onTokenExpiredHandler.bind(this));
												}
												var t, n;
												return (
													(0, s.Z)(e, [
														{
															key: 'shouldThrottleRenew',
															value: function () {
																var e = !1;
																if ((this.renewTimeQueue.push(Date.now()), this.renewTimeQueue.length >= 10)) {
																	var t = this.renewTimeQueue.shift();
																	e = this.renewTimeQueue[this.renewTimeQueue.length - 1] - t < 3e4;
																}
																return e;
															},
														},
														{
															key: 'requiresLeadership',
															value: function () {
																return !!this.options.syncStorage && (0, X.isBrowser)();
															},
														},
														{
															key: 'processExpiredTokens',
															value: function () {
																var e = this,
																	t = this.tokenManager.getStorage().getStorage();
																Object.keys(t).forEach(function (n) {
																	var r = t[n];
																	!(0, ne.z9)(r) && e.tokenManager.hasExpired(r) && e.onTokenExpiredHandler(n);
																});
															},
														},
														{
															key: 'onTokenExpiredHandler',
															value: function (e) {
																if (this.options.autoRenew)
																	if (this.shouldThrottleRenew()) {
																		var t = new te.Z('Too many token renew requests');
																		this.tokenManager.emitError(t);
																	} else this.tokenManager.renew(e).catch(function () {});
																else this.options.autoRemove && this.tokenManager.remove(e);
															},
														},
														{
															key: 'canStart',
															value: function () {
																return !((!this.options.autoRenew && !this.options.autoRemove) || this.started);
															},
														},
														{
															key: 'start',
															value:
																((n = (0, i.Z)(
																	c().mark(function e() {
																		return c().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							this.canStart() &&
																								(this.tokenManager.on(re.$Y, this.onTokenExpiredHandler),
																								this.tokenManager.isStarted() && this.processExpiredTokens(),
																								(this.started = !0));
																						case 1:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function () {
																	return n.apply(this, arguments);
																}),
														},
														{
															key: 'stop',
															value:
																((t = (0, i.Z)(
																	c().mark(function e() {
																		return c().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							this.started &&
																								(this.tokenManager.off(re.$Y, this.onTokenExpiredHandler),
																								(this.renewTimeQueue = []),
																								(this.started = !1));
																						case 1:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function () {
																	return t.apply(this, arguments);
																}),
														},
														{
															key: 'isStarted',
															value: function () {
																return this.started;
															},
														},
													]),
													e
												);
											})(),
											ie = (function () {
												function e(t) {
													var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
													(0, a.Z)(this, e),
														(0, l.Z)(this, 'tokenManager', void 0),
														(0, l.Z)(this, 'options', void 0),
														(0, l.Z)(this, 'channel', void 0),
														(0, l.Z)(this, 'started', !1),
														(0, l.Z)(this, 'enablePostMessage', !0),
														(this.tokenManager = t),
														(this.options = n),
														(this.onTokenAddedHandler = this.onTokenAddedHandler.bind(this)),
														(this.onTokenRemovedHandler = this.onTokenRemovedHandler.bind(this)),
														(this.onTokenRenewedHandler = this.onTokenRenewedHandler.bind(this)),
														(this.onSetStorageHandler = this.onSetStorageHandler.bind(this)),
														(this.onSyncMessageHandler = this.onSyncMessageHandler.bind(this));
												}
												var t, n;
												return (
													(0, s.Z)(e, [
														{
															key: 'requiresLeadership',
															value: function () {
																return !1;
															},
														},
														{
															key: 'isStarted',
															value: function () {
																return this.started;
															},
														},
														{
															key: 'canStart',
															value: function () {
																return !!this.options.syncStorage && (0, X.isBrowser)() && !this.started;
															},
														},
														{
															key: 'start',
															value:
																((n = (0, i.Z)(
																	c().mark(function e() {
																		var t;
																		return c().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							if (this.canStart()) {
																								e.next = 2;
																								break;
																							}
																							return e.abrupt('return');
																						case 2:
																							(t = this.options.syncChannelName),
																								(e.prev = 3),
																								(this.channel = new F(t)),
																								(e.next = 10);
																							break;
																						case 7:
																							throw (
																								((e.prev = 7),
																								(e.t0 = e.catch(3)),
																								new te.Z('SyncStorageService is not supported in current browser.'))
																							);
																						case 10:
																							this.tokenManager.on(re.O3, this.onTokenAddedHandler),
																								this.tokenManager.on(re.FT, this.onTokenRemovedHandler),
																								this.tokenManager.on(re.E, this.onTokenRenewedHandler),
																								this.tokenManager.on(re.zr, this.onSetStorageHandler),
																								this.channel.addEventListener('message', this.onSyncMessageHandler),
																								(this.started = !0);
																						case 16:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this,
																			[[3, 7]]
																		);
																	})
																)),
																function () {
																	return n.apply(this, arguments);
																}),
														},
														{
															key: 'stop',
															value:
																((t = (0, i.Z)(
																	c().mark(function e() {
																		var t, n;
																		return c().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							if (!this.started) {
																								e.next = 10;
																								break;
																							}
																							return (
																								this.tokenManager.off(re.O3, this.onTokenAddedHandler),
																								this.tokenManager.off(re.FT, this.onTokenRemovedHandler),
																								this.tokenManager.off(re.E, this.onTokenRenewedHandler),
																								this.tokenManager.off(re.zr, this.onSetStorageHandler),
																								null === (t = this.channel) ||
																									void 0 === t ||
																									t.removeEventListener('message', this.onSyncMessageHandler),
																								(e.next = 8),
																								null === (n = this.channel) || void 0 === n ? void 0 : n.close()
																							);
																						case 8:
																							(this.channel = void 0), (this.started = !1);
																						case 10:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function () {
																	return t.apply(this, arguments);
																}),
														},
														{
															key: 'onTokenAddedHandler',
															value: function (e, t) {
																var n;
																this.enablePostMessage &&
																	(null === (n = this.channel) ||
																		void 0 === n ||
																		n.postMessage({ type: re.O3, key: e, token: t }));
															},
														},
														{
															key: 'onTokenRemovedHandler',
															value: function (e, t) {
																var n;
																this.enablePostMessage &&
																	(null === (n = this.channel) ||
																		void 0 === n ||
																		n.postMessage({ type: re.FT, key: e, token: t }));
															},
														},
														{
															key: 'onTokenRenewedHandler',
															value: function (e, t, n) {
																var r;
																this.enablePostMessage &&
																	(null === (r = this.channel) ||
																		void 0 === r ||
																		r.postMessage({ type: re.E, key: e, token: t, oldToken: n }));
															},
														},
														{
															key: 'onSetStorageHandler',
															value: function (e) {
																var t;
																null === (t = this.channel) ||
																	void 0 === t ||
																	t.postMessage({ type: re.zr, storage: e });
															},
														},
														{
															key: 'onSyncMessageHandler',
															value: function (e) {
																switch (((this.enablePostMessage = !1), e.type)) {
																	case re.zr:
																		this.tokenManager.getStorage().setStorage(e.storage);
																		break;
																	case re.O3:
																		this.tokenManager.emitAdded(e.key, e.token),
																			this.tokenManager.setExpireEventTimeout(e.key, e.token);
																		break;
																	case re.FT:
																		this.tokenManager.clearExpireEventTimeout(e.key),
																			this.tokenManager.emitRemoved(e.key, e.token);
																		break;
																	case re.E:
																		this.tokenManager.emitRenewed(e.key, e.token, e.oldToken);
																}
																this.enablePostMessage = !0;
															},
														},
													]),
													e
												);
											})(),
											ae = function () {
												return Math.floor(Date.now() / 1e3);
											},
											se = (function () {
												function e(t) {
													var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
													(0, a.Z)(this, e),
														(0, l.Z)(this, 'tokenManager', void 0),
														(0, l.Z)(this, 'started', !1),
														(0, l.Z)(this, 'options', void 0),
														(0, l.Z)(this, 'lastHidden', -1),
														(0, l.Z)(this, 'onPageVisbilityChange', void 0),
														(this.tokenManager = t),
														(this.options = n),
														(this.onPageVisbilityChange = this._onPageVisbilityChange.bind(this));
												}
												var t, n;
												return (
													(0, s.Z)(e, [
														{
															key: '_onPageVisbilityChange',
															value: function () {
																if (document.hidden) this.lastHidden = ae();
																else if (
																	this.lastHidden > 0 &&
																	ae() - this.lastHidden >= this.options.tabInactivityDuration
																) {
																	var e = this.tokenManager.getTokensSync(),
																		t = e.accessToken,
																		n = e.idToken;
																	if (t && this.tokenManager.hasExpired(t)) {
																		var r = this.tokenManager.getStorageKeyByType('accessToken');
																		this.tokenManager.renew(r).catch(function () {});
																	} else if (n && this.tokenManager.hasExpired(n)) {
																		var o = this.tokenManager.getStorageKeyByType('idToken');
																		this.tokenManager.renew(o).catch(function () {});
																	}
																}
															},
														},
														{
															key: 'start',
															value:
																((n = (0, i.Z)(
																	c().mark(function e() {
																		return c().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							this.canStart() &&
																								document &&
																								(document.addEventListener(
																									'visibilitychange',
																									this.onPageVisbilityChange
																								),
																								(this.started = !0));
																						case 1:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function () {
																	return n.apply(this, arguments);
																}),
														},
														{
															key: 'stop',
															value:
																((t = (0, i.Z)(
																	c().mark(function e() {
																		return c().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							document &&
																								(document.removeEventListener(
																									'visibilitychange',
																									this.onPageVisbilityChange
																								),
																								(this.started = !1));
																						case 1:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function () {
																	return t.apply(this, arguments);
																}),
														},
														{
															key: 'canStart',
															value: function () {
																return (
																	(0, X.isBrowser)() &&
																	!!this.options.autoRenew &&
																	!!this.options.renewOnTabActivation &&
																	!this.started
																);
															},
														},
														{
															key: 'requiresLeadership',
															value: function () {
																return !1;
															},
														},
														{
															key: 'isStarted',
															value: function () {
																return this.started;
															},
														},
													]),
													e
												);
											})(),
											le = n(3193);
										function ue(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function ce(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? ue(Object(n), !0).forEach(function (t) {
															(0, l.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: ue(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function de(e, t) {
											var n = ('undefined' != typeof Symbol && e[Symbol.iterator]) || e['@@iterator'];
											if (!n) {
												if (
													Array.isArray(e) ||
													(n = (function (e, t) {
														if (e) {
															if ('string' == typeof e) return fe(e, t);
															var n = Object.prototype.toString.call(e).slice(8, -1);
															return (
																'Object' === n && e.constructor && (n = e.constructor.name),
																'Map' === n || 'Set' === n
																	? Array.from(e)
																	: 'Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
																	? fe(e, t)
																	: void 0
															);
														}
													})(e)) ||
													(t && e && 'number' == typeof e.length)
												) {
													n && (e = n);
													var r = 0,
														o = function () {};
													return {
														s: o,
														n: function () {
															return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
														},
														e: function (e) {
															throw e;
														},
														f: o,
													};
												}
												throw new TypeError(
													'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
												);
											}
											var i,
												a = !0,
												s = !1;
											return {
												s: function () {
													n = n.call(e);
												},
												n: function () {
													var e = n.next();
													return (a = e.done), e;
												},
												e: function (e) {
													(s = !0), (i = e);
												},
												f: function () {
													try {
														a || null == n.return || n.return();
													} finally {
														if (s) throw i;
													}
												},
											};
										}
										function fe(e, t) {
											(null == t || t > e.length) && (t = e.length);
											for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
											return r;
										}
										var pe = 'autoRenew',
											he = 'syncStorage',
											me = 'leaderElection',
											ve = 'renewOnTabActivation',
											ge = (function () {
												function e(t) {
													var n = this,
														r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
													(0, a.Z)(this, e),
														(0, l.Z)(this, 'sdk', void 0),
														(0, l.Z)(this, 'options', void 0),
														(0, l.Z)(this, 'services', void 0),
														(0, l.Z)(this, 'started', void 0),
														(this.sdk = t),
														(this.onLeader = this.onLeader.bind(this));
													var o = t.tokenManager.getOptions(),
														i = o.autoRenew,
														s = o.autoRemove,
														u = o.syncStorage;
													(r.electionChannelName = r.electionChannelName || r.broadcastChannelName),
														(this.options = Object.assign(
															{},
															e.defaultOptions,
															{ autoRenew: i, autoRemove: s, syncStorage: u },
															{
																electionChannelName: ''.concat(t.options.clientId, '-election'),
																syncChannelName: ''.concat(t.options.clientId, '-sync'),
															},
															(0, le.YY)(r)
														)),
														(this.started = !1),
														(this.services = new Map()),
														e.knownServices.forEach(function (e) {
															var t = n.createService(e);
															t && n.services.set(e, t);
														});
												}
												var t, n, u, d, f;
												return (
													(0, s.Z)(e, [
														{
															key: 'onLeader',
															value:
																((f = (0, i.Z)(
																	c().mark(function e() {
																		return c().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							if (!this.started) {
																								e.next = 3;
																								break;
																							}
																							return (e.next = 3), this.startServices();
																						case 3:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function () {
																	return f.apply(this, arguments);
																}),
														},
														{
															key: 'isLeader',
															value: function () {
																var e;
																return null === (e = this.getService(me)) || void 0 === e ? void 0 : e.isLeader();
															},
														},
														{
															key: 'isLeaderRequired',
															value: function () {
																return (0, o.Z)(this.services.values()).some(function (e) {
																	return e.canStart() && e.requiresLeadership();
																});
															},
														},
														{
															key: 'start',
															value:
																((d = (0, i.Z)(
																	c().mark(function e() {
																		return c().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							if (!this.started) {
																								e.next = 2;
																								break;
																							}
																							return e.abrupt('return');
																						case 2:
																							return (e.next = 4), this.startServices();
																						case 4:
																							this.started = !0;
																						case 5:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function () {
																	return d.apply(this, arguments);
																}),
														},
														{
															key: 'stop',
															value:
																((u = (0, i.Z)(
																	c().mark(function e() {
																		return c().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							return (e.next = 2), this.stopServices();
																						case 2:
																							this.started = !1;
																						case 3:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function () {
																	return u.apply(this, arguments);
																}),
														},
														{
															key: 'getService',
															value: function (e) {
																return this.services.get(e);
															},
														},
														{
															key: 'startServices',
															value:
																((n = (0, i.Z)(
																	c().mark(function e() {
																		var t, n, o, i, a;
																		return c().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							(t = de(this.services.entries())), (e.prev = 1), t.s();
																						case 3:
																							if ((n = t.n()).done) {
																								e.next = 10;
																								break;
																							}
																							if (
																								((o = (0, r.Z)(n.value, 2)),
																								(i = o[0]),
																								(a = o[1]),
																								!this.canStartService(i, a))
																							) {
																								e.next = 8;
																								break;
																							}
																							return (e.next = 8), a.start();
																						case 8:
																							e.next = 3;
																							break;
																						case 10:
																							e.next = 15;
																							break;
																						case 12:
																							(e.prev = 12), (e.t0 = e.catch(1)), t.e(e.t0);
																						case 15:
																							return (e.prev = 15), t.f(), e.finish(15);
																						case 18:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this,
																			[[1, 12, 15, 18]]
																		);
																	})
																)),
																function () {
																	return n.apply(this, arguments);
																}),
														},
														{
															key: 'stopServices',
															value:
																((t = (0, i.Z)(
																	c().mark(function e() {
																		var t, n, r;
																		return c().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							(t = de(this.services.values())), (e.prev = 1), t.s();
																						case 3:
																							if ((n = t.n()).done) {
																								e.next = 9;
																								break;
																							}
																							return (r = n.value), (e.next = 7), r.stop();
																						case 7:
																							e.next = 3;
																							break;
																						case 9:
																							e.next = 14;
																							break;
																						case 11:
																							(e.prev = 11), (e.t0 = e.catch(1)), t.e(e.t0);
																						case 14:
																							return (e.prev = 14), t.f(), e.finish(14);
																						case 17:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this,
																			[[1, 11, 14, 17]]
																		);
																	})
																)),
																function () {
																	return t.apply(this, arguments);
																}),
														},
														{
															key: 'canStartService',
															value: function (e, t) {
																var n = t.canStart() && !t.isStarted();
																return (
																	e === me
																		? n && (n = this.isLeaderRequired())
																		: t.requiresLeadership() && n && (n = this.isLeader()),
																	n
																);
															},
														},
														{
															key: 'createService',
															value: function (e) {
																var t,
																	n = this.sdk.tokenManager;
																switch (e) {
																	case me:
																		t = new ee(ce(ce({}, this.options), {}, { onLeader: this.onLeader }));
																		break;
																	case pe:
																		t = new oe(n, ce({}, this.options));
																		break;
																	case he:
																		t = new ie(n, ce({}, this.options));
																		break;
																	case ve:
																		t = new se(n, ce({}, this.options));
																		break;
																	default:
																		throw new Error('Unknown service '.concat(e));
																}
																return t;
															},
														},
													]),
													e
												);
											})();
										(0, l.Z)(ge, 'knownServices', [pe, he, me, ve]),
											(0, l.Z)(ge, 'defaultOptions', {
												autoRenew: !0,
												autoRemove: !0,
												syncStorage: !0,
												renewOnTabActivation: !0,
												tabInactivityDuration: 1800,
											});
									},
									6599: function (e, t, n) {
										'use strict';
										n.d(t, {
											W: function () {
												return r.W;
											},
										});
										var r = n(7145);
									},
									1578: function (e, t, n) {
										'use strict';
										n.d(t, {
											K: function () {
												return u;
											},
										});
										var r = n(9893),
											o = n(265),
											i = n(279),
											a = n(2724),
											s = n(8386),
											l = n(3980);
										function u(e, t, n) {
											var u = (0, r.a)(t),
												c = (0, o.H)(u, e),
												d = (0, i.A)(c),
												f = (0, l.Z)(d),
												p = (0, a.J)(f, n);
											return (0, s.i)(p);
										}
									},
									3961: function (e, t, n) {
										'use strict';
										n.r(t),
											n.d(t, {
												AuthStateManager: function () {
													return r.E;
												},
												INITIAL_AUTH_STATE: function () {
													return r.a;
												},
												ServiceManager: function () {
													return d.W;
												},
												createCoreOptionsConstructor: function () {
													return o.n;
												},
												createCoreStorageManager: function () {
													return s.a;
												},
												createOktaAuthCore: function () {
													return i.K;
												},
												mixinCore: function () {
													return a.i;
												},
											});
										var r = n(1018),
											o = n(9133),
											i = n(1578),
											a = n(8386),
											s = n(2647),
											l = n(8553),
											u = {};
										for (var c in l)
											[
												'default',
												'AuthStateManager',
												'INITIAL_AUTH_STATE',
												'createCoreOptionsConstructor',
												'createOktaAuthCore',
												'mixinCore',
												'createCoreStorageManager',
											].indexOf(c) < 0 &&
												(u[c] = function (e) {
													return l[e];
												}.bind(0, c));
										n.d(t, u);
										var d = n(6599);
									},
									8386: function (e, t, n) {
										'use strict';
										n.d(t, {
											i: function () {
												return v;
											},
										});
										var r = n(5861),
											o = n(5671),
											i = n(3144),
											a = n(7326),
											s = n(136),
											l = n(2963),
											u = n(1120),
											c = n(4942),
											d = n(4687),
											f = n.n(d),
											p = n(5372),
											h = n(1018),
											m = n(7145);
										function v(e) {
											return (function (e) {
												(0, s.Z)(_, e);
												var t,
													n,
													d,
													v,
													g,
													y,
													b =
														((g = _),
														(y = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																t = (0, u.Z)(g);
															if (y) {
																var n = (0, u.Z)(this).constructor;
																e = Reflect.construct(t, arguments, n);
															} else e = t.apply(this, arguments);
															return (0, l.Z)(this, e);
														});
												function _() {
													var e;
													(0, o.Z)(this, _);
													for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
													return (
														(e = b.call.apply(b, [this].concat(n))),
														(0, c.Z)((0, a.Z)(e), 'authStateManager', void 0),
														(0, c.Z)((0, a.Z)(e), 'serviceManager', void 0),
														(e.authStateManager = new h.E((0, a.Z)(e))),
														(e.serviceManager = new m.W((0, a.Z)(e), e.options.services)),
														e
													);
												}
												return (
													(0, i.Z)(_, [
														{
															key: 'start',
															value:
																((v = (0, r.Z)(
																	f().mark(function e() {
																		return f().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							return (e.next = 2), this.serviceManager.start();
																						case 2:
																							if ((this.tokenManager.start(), this.token.isLoginRedirect())) {
																								e.next = 6;
																								break;
																							}
																							return (e.next = 6), this.authStateManager.updateAuthState();
																						case 6:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function () {
																	return v.apply(this, arguments);
																}),
														},
														{
															key: 'stop',
															value:
																((d = (0, r.Z)(
																	f().mark(function e() {
																		return f().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							return this.tokenManager.stop(), (e.next = 3), this.serviceManager.stop();
																						case 3:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function () {
																	return d.apply(this, arguments);
																}),
														},
														{
															key: 'handleRedirect',
															value:
																((n = (0, r.Z)(
																	f().mark(function e(t) {
																		return f().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							return (e.next = 2), this.handleLoginRedirect(void 0, t);
																						case 2:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function (e) {
																	return n.apply(this, arguments);
																}),
														},
														{
															key: 'handleLoginRedirect',
															value:
																((t = (0, r.Z)(
																	f().mark(function e(t, n) {
																		var r, o, i;
																		return f().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							if (((r = this.options.state), !t)) {
																								e.next = 6;
																								break;
																							}
																							this.tokenManager.setTokens(t),
																								(n = n || this.getOriginalUri(this.options.state)),
																								(e.next = 25);
																							break;
																						case 6:
																							if (!this.isLoginRedirect()) {
																								e.next = 24;
																								break;
																							}
																							return (e.prev = 7), (e.next = 10), (0, p.Tp)(this, {});
																						case 10:
																							return (
																								(o = e.sent),
																								(r = o.state),
																								(n = n || this.getOriginalUri(r)),
																								(e.next = 15),
																								this.storeTokensFromRedirect()
																							);
																						case 15:
																							e.next = 22;
																							break;
																						case 17:
																							return (
																								(e.prev = 17),
																								(e.t0 = e.catch(7)),
																								(e.next = 21),
																								this.authStateManager.updateAuthState()
																							);
																						case 21:
																							throw e.t0;
																						case 22:
																							e.next = 25;
																							break;
																						case 24:
																							return e.abrupt('return');
																						case 25:
																							return (e.next = 27), this.authStateManager.updateAuthState();
																						case 27:
																							if ((this.removeOriginalUri(r), !(i = this.options.restoreOriginalUri))) {
																								e.next = 34;
																								break;
																							}
																							return (e.next = 32), i(this, n);
																						case 32:
																							e.next = 35;
																							break;
																						case 34:
																							n && window.location.replace(n);
																						case 35:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this,
																			[[7, 17]]
																		);
																	})
																)),
																function (e, n) {
																	return t.apply(this, arguments);
																}),
														},
													]),
													_
												);
											})(e);
										}
									},
									9133: function (e, t, n) {
										'use strict';
										n.d(t, {
											n: function () {
												return d;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(7326),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942),
											c = n(9453);
										function d() {
											return (function (e) {
												(0, a.Z)(d, e);
												var t,
													n,
													c =
														((t = d),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, l.Z)(t);
															if (n) {
																var o = (0, l.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, s.Z)(this, e);
														});
												function d(e) {
													var t;
													return (
														(0, o.Z)(this, d),
														(t = c.call(this, e)),
														(0, u.Z)((0, i.Z)(t), 'services', void 0),
														(0, u.Z)((0, i.Z)(t), 'transformAuthState', void 0),
														(t.services = e.services),
														(t.transformAuthState = e.transformAuthState),
														t
													);
												}
												return (0, r.Z)(d);
											})((0, c.m)());
										}
									},
									2647: function (e, t, n) {
										'use strict';
										n.d(t, {
											a: function () {
												return o;
											},
										});
										var r = n(2333);
										function o() {
											return (0, r.a)();
										}
									},
									5675: function () {},
									8553: function (e, t, n) {
										'use strict';
										n.r(t);
										var r = n(5675),
											o = {};
										for (var i in r)
											'default' !== i &&
												(o[i] = function (e) {
													return r[e];
												}.bind(0, i));
										n.d(t, o);
									},
									7987: function (e, t, n) {
										'use strict';
										n.d(t, {
											Df: function () {
												return s;
											},
											EL: function () {
												return c;
											},
											NL: function () {
												return i;
											},
											Wy: function () {
												return l;
											},
											aR: function () {
												return a;
											},
											dX: function () {
												return d;
											},
											k8: function () {
												return u;
											},
											kQ: function () {
												return f;
											},
										});
										var r = n(9123),
											o = n(7594);
										function i(e) {
											return a((0, o.r3)(e));
										}
										function a(e) {
											return e.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
										}
										function s(e) {
											return e.replace(/-/g, '+').replace(/_/g, '/');
										}
										function l(e) {
											var t = s(e);
											switch (t.length % 4) {
												case 0:
													break;
												case 2:
													t += '==';
													break;
												case 3:
													t += '=';
													break;
												default:
													throw new r.Z('Not a valid Base64Url');
											}
											var n = (0, o.ty)(t);
											try {
												return decodeURIComponent(escape(n));
											} catch (e) {
												return n;
											}
										}
										function u(e) {
											for (var t = new Uint8Array(e.length), n = 0; n < e.length; n++) t[n] = e.charCodeAt(n);
											return t;
										}
										function c(e) {
											return (0, o.ty)(s(e));
										}
										function d(e) {
											return Uint8Array.from(c(e), function (e) {
												return e.charCodeAt(0);
											});
										}
										function f(e) {
											return (0, o.r3)(
												new Uint8Array(e).reduce(function (e, t) {
													return e + String.fromCharCode(t);
												}, '')
											);
										}
									},
									7594: function (e, t, n) {
										'use strict';
										n.d(t, {
											KP: function () {
												return i;
											},
											r3: function () {
												return o;
											},
											ty: function () {
												return r;
											},
										});
										var r = function (e) {
												return atob(e);
											},
											o = function (e) {
												return btoa(e);
											},
											i = 'undefined' == typeof crypto ? null : crypto;
									},
									9718: function (e, t, n) {
										'use strict';
										n.r(t),
											n.d(t, {
												atob: function () {
													return u.ty;
												},
												base64ToBase64Url: function () {
													return r.aR;
												},
												base64UrlDecode: function () {
													return r.EL;
												},
												base64UrlToBase64: function () {
													return r.Df;
												},
												base64UrlToBuffer: function () {
													return r.dX;
												},
												base64UrlToString: function () {
													return r.Wy;
												},
												btoa: function () {
													return u.r3;
												},
												bufferToBase64Url: function () {
													return r.kQ;
												},
												getOidcHash: function () {
													return o.X;
												},
												stringToBase64Url: function () {
													return r.NL;
												},
												stringToBuffer: function () {
													return r.k8;
												},
												verifyToken: function () {
													return l.W;
												},
												webcrypto: function () {
													return u.KP;
												},
											});
										var r = n(7987),
											o = n(5698),
											i = n(6332),
											a = {};
										for (var s in i)
											[
												'default',
												'base64ToBase64Url',
												'base64UrlDecode',
												'base64UrlToBase64',
												'base64UrlToBuffer',
												'base64UrlToString',
												'bufferToBase64Url',
												'stringToBase64Url',
												'stringToBuffer',
												'getOidcHash',
											].indexOf(s) < 0 &&
												(a[s] = function (e) {
													return i[e];
												}.bind(0, s));
										n.d(t, a);
										var l = n(3154),
											u = n(1);
									},
									5698: function (e, t, n) {
										'use strict';
										n.d(t, {
											X: function () {
												return i;
											},
										});
										var r = n(7987),
											o = n(7594);
										function i(e) {
											var t = new TextEncoder().encode(e);
											return o.KP.subtle.digest('SHA-256', t).then(function (e) {
												var t = new Uint8Array(e).slice(0, 16),
													n = String.fromCharCode.apply(null, t);
												return (0, r.NL)(n);
											});
										}
									},
									6332: function () {},
									3154: function (e, t, n) {
										'use strict';
										n.d(t, {
											W: function () {
												return a;
											},
										});
										var r = n(3193),
											o = n(7987),
											i = n(7594);
										function a(e, t) {
											t = (0, r.d9)(t);
											var n = { name: 'RSASSA-PKCS1-v1_5', hash: { name: 'SHA-256' } };
											return (
												delete t.use,
												i.KP.subtle.importKey('jwk', t, n, !0, ['verify']).then(function (t) {
													var r = e.split('.'),
														a = (0, o.k8)(r[0] + '.' + r[1]),
														s = (0, o.EL)(r[2]),
														l = (0, o.k8)(s);
													return i.KP.subtle.verify(n, t, l, a);
												})
											);
										}
									},
									1: function (e, t, n) {
										'use strict';
										n.d(t, {
											KP: function () {
												return r.KP;
											},
											r3: function () {
												return r.r3;
											},
											ty: function () {
												return r.ty;
											},
										});
										var r = n(7594);
									},
									3983: function (e, t, n) {
										'use strict';
										n.d(t, {
											Z: function () {
												return c;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(7326),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942),
											c = (function (e) {
												(0, a.Z)(d, e);
												var t,
													n,
													c =
														((t = d),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, l.Z)(t);
															if (n) {
																var o = (0, l.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, s.Z)(this, e);
														});
												function d(e, t, n) {
													var r;
													(0, o.Z)(this, d);
													var a = e.errorSummary;
													return (
														(r = c.call(this, a)),
														(0, u.Z)((0, i.Z)(r), 'errorSummary', void 0),
														(0, u.Z)((0, i.Z)(r), 'errorCode', void 0),
														(0, u.Z)((0, i.Z)(r), 'errorLink', void 0),
														(0, u.Z)((0, i.Z)(r), 'errorId', void 0),
														(0, u.Z)((0, i.Z)(r), 'errorCauses', void 0),
														(0, u.Z)((0, i.Z)(r), 'xhr', void 0),
														(0, u.Z)((0, i.Z)(r), 'meta', void 0),
														(r.name = 'AuthApiError'),
														(r.errorSummary = e.errorSummary),
														(r.errorCode = e.errorCode),
														(r.errorLink = e.errorLink),
														(r.errorId = e.errorId),
														(r.errorCauses = e.errorCauses),
														t && (r.xhr = t),
														n && (r.meta = n),
														r
													);
												}
												return (0, r.Z)(d);
											})(n(6245).Z);
									},
									6573: function (e, t, n) {
										'use strict';
										n.d(t, {
											Z: function () {
												return l;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(136),
											a = n(2963),
											s = n(1120),
											l = (function (e) {
												(0, i.Z)(u, e);
												var t,
													n,
													l =
														((t = u),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, s.Z)(t);
															if (n) {
																var o = (0, s.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, a.Z)(this, e);
														});
												function u() {
													return (0, o.Z)(this, u), l.call(this, 'The poll was stopped by the sdk');
												}
												return (0, r.Z)(u);
											})(n(6245).Z);
									},
									9123: function (e, t, n) {
										'use strict';
										n.d(t, {
											Z: function () {
												return c;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(7326),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942),
											c = (function (e) {
												(0, a.Z)(d, e);
												var t,
													n,
													c =
														((t = d),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, l.Z)(t);
															if (n) {
																var o = (0, l.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, s.Z)(this, e);
														});
												function d(e, t) {
													var n;
													return (
														(0, o.Z)(this, d),
														(n = c.call(this, e)),
														(0, u.Z)((0, i.Z)(n), 'errorSummary', void 0),
														(0, u.Z)((0, i.Z)(n), 'errorCode', void 0),
														(0, u.Z)((0, i.Z)(n), 'errorLink', void 0),
														(0, u.Z)((0, i.Z)(n), 'errorId', void 0),
														(0, u.Z)((0, i.Z)(n), 'errorCauses', void 0),
														(0, u.Z)((0, i.Z)(n), 'xhr', void 0),
														(n.name = 'AuthSdkError'),
														(n.errorCode = 'INTERNAL'),
														(n.errorSummary = e),
														(n.errorLink = 'INTERNAL'),
														(n.errorId = 'INTERNAL'),
														(n.errorCauses = []),
														t && (n.xhr = t),
														n
													);
												}
												return (0, r.Z)(d);
											})(n(6245).Z);
									},
									6245: function (e, t, n) {
										'use strict';
										n.d(t, {
											Z: function () {
												return f;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(7326),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(9611);
										function c(e, t, n) {
											return (
												(c = (function () {
													if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
													if (Reflect.construct.sham) return !1;
													if ('function' == typeof Proxy) return !0;
													try {
														return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
													} catch (e) {
														return !1;
													}
												})()
													? Reflect.construct.bind()
													: function (e, t, n) {
															var r = [null];
															r.push.apply(r, t);
															var o = new (Function.bind.apply(e, r))();
															return n && (0, u.Z)(o, n.prototype), o;
													  }),
												c.apply(null, arguments)
											);
										}
										function d(e) {
											var t = 'function' == typeof Map ? new Map() : void 0;
											return (
												(d = function (e) {
													if (null === e || ((n = e), -1 === Function.toString.call(n).indexOf('[native code]')))
														return e;
													var n;
													if ('function' != typeof e)
														throw new TypeError('Super expression must either be null or a function');
													if (void 0 !== t) {
														if (t.has(e)) return t.get(e);
														t.set(e, r);
													}
													function r() {
														return c(e, arguments, (0, l.Z)(this).constructor);
													}
													return (
														(r.prototype = Object.create(e.prototype, {
															constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 },
														})),
														(0, u.Z)(r, e)
													);
												}),
												d(e)
											);
										}
										var f = (function (e) {
											(0, a.Z)(c, e);
											var t,
												n,
												u =
													((t = c),
													(n = (function () {
														if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
														if (Reflect.construct.sham) return !1;
														if ('function' == typeof Proxy) return !0;
														try {
															return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
														} catch (e) {
															return !1;
														}
													})()),
													function () {
														var e,
															r = (0, l.Z)(t);
														if (n) {
															var o = (0, l.Z)(this).constructor;
															e = Reflect.construct(r, arguments, o);
														} else e = r.apply(this, arguments);
														return (0, s.Z)(this, e);
													});
											function c(e) {
												var t;
												return (
													(0, o.Z)(this, c),
													(t = u.call(this, e)),
													Object.setPrototypeOf((0, i.Z)(t), (this instanceof c ? this.constructor : void 0).prototype),
													t
												);
											}
											return (0, r.Z)(c);
										})(d(Error));
									},
									2886: function (e, t, n) {
										'use strict';
										n.d(t, {
											Z: function () {
												return c;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(7326),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942),
											c = (function (e) {
												(0, a.Z)(d, e);
												var t,
													n,
													c =
														((t = d),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, l.Z)(t);
															if (n) {
																var o = (0, l.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, s.Z)(this, e);
														});
												function d(e, t, n) {
													var r;
													return (
														(0, o.Z)(this, d),
														(r = c.call(this, t)),
														(0, u.Z)((0, i.Z)(r), 'errorCode', void 0),
														(0, u.Z)((0, i.Z)(r), 'errorSummary', void 0),
														(0, u.Z)((0, i.Z)(r), 'error', void 0),
														(0, u.Z)((0, i.Z)(r), 'error_description', void 0),
														(0, u.Z)((0, i.Z)(r), 'resp', null),
														(r.name = 'OAuthError'),
														(r.errorCode = e),
														(r.errorSummary = t),
														(r.error = e),
														(r.error_description = t),
														n && (r.resp = n),
														r
													);
												}
												return (0, r.Z)(d);
											})(n(6245).Z);
									},
									3114: function (e, t, n) {
										'use strict';
										n.d(t, {
											Z: function () {
												return f;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(7326),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942),
											c = n(6245),
											d = n(4771),
											f = (function (e) {
												(0, a.Z)(f, e);
												var t,
													n,
													c =
														((t = f),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, l.Z)(t);
															if (n) {
																var o = (0, l.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, s.Z)(this, e);
														});
												function f(e, t, n) {
													var o, a;
													return (
														(0, r.Z)(this, f),
														(a = c.call(this, null !== (o = t.error) && void 0 !== o ? o : f.UNKNOWN_ERROR)),
														(0, u.Z)((0, i.Z)(a), 'scheme', void 0),
														(0, u.Z)((0, i.Z)(a), 'parameters', void 0),
														(0, u.Z)((0, i.Z)(a), 'name', 'WWWAuthError'),
														(0, u.Z)((0, i.Z)(a), 'resp', null),
														(a.scheme = e),
														(a.parameters = t),
														n && (a.resp = n),
														a
													);
												}
												return (
													(0, o.Z)(
														f,
														[
															{
																key: 'error',
																get: function () {
																	return this.parameters.error;
																},
															},
															{
																key: 'errorCode',
																get: function () {
																	return this.error;
																},
															},
															{
																key: 'error_description',
																get: function () {
																	return this.parameters.error_description;
																},
															},
															{
																key: 'errorDescription',
																get: function () {
																	return this.error_description;
																},
															},
															{
																key: 'errorSummary',
																get: function () {
																	return this.errorDescription;
																},
															},
															{
																key: 'realm',
																get: function () {
																	return this.parameters.realm;
																},
															},
														],
														[
															{
																key: 'parseHeader',
																value: function (e) {
																	if (!e) return null;
																	for (
																		var t,
																			n =
																				/(?:,|, )?([a-zA-Z0-9!#$%&'*+\-.^_`|~]+)=(?:"([a-zA-Z0-9!#$%&'*+\-.,^_`|~ /:]+)"|([a-zA-Z0-9!#$%&'*+\-.^_`|~/:]+))/g,
																			r = e.indexOf(' '),
																			o = e.slice(0, r),
																			i = e.slice(r + 1),
																			a = {};
																		null !== (t = n.exec(i));

																	) {
																		var s;
																		a[t[1]] = null !== (s = t[2]) && void 0 !== s ? s : t[3];
																	}
																	return new f(o, a);
																},
															},
															{
																key: 'getWWWAuthenticateHeader',
																value: function () {
																	var e,
																		t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
																	return (0, d.mf)(null == t ? void 0 : t.get)
																		? t.get('WWW-Authenticate')
																		: null !== (e = t['www-authenticate']) && void 0 !== e
																		? e
																		: t['WWW-Authenticate'];
																},
															},
														]
													),
													f
												);
											})(c.Z);
										(0, u.Z)(f, 'UNKNOWN_ERROR', 'UNKNOWN_WWW_AUTH_ERROR');
									},
									5728: function (e, t, n) {
										'use strict';
										n.r(t),
											n.d(t, {
												AuthApiError: function () {
													return r.Z;
												},
												AuthPollStopError: function () {
													return o.Z;
												},
												AuthSdkError: function () {
													return i.Z;
												},
												OAuthError: function () {
													return a.Z;
												},
												WWWAuthError: function () {
													return s.Z;
												},
												isAuthApiError: function () {
													return d;
												},
												isOAuthError: function () {
													return f;
												},
												isWWWAuthError: function () {
													return p;
												},
											});
										var r = n(3983),
											o = n(6573),
											i = n(9123),
											a = n(2886),
											s = n(3114),
											l = n(1243),
											u = {};
										for (var c in l)
											[
												'default',
												'isAuthApiError',
												'isOAuthError',
												'isWWWAuthError',
												'AuthApiError',
												'AuthPollStopError',
												'AuthSdkError',
												'OAuthError',
												'WWWAuthError',
											].indexOf(c) < 0 &&
												(u[c] = function (e) {
													return l[e];
												}.bind(0, c));
										function d(e) {
											return e instanceof r.Z;
										}
										function f(e) {
											return e instanceof a.Z;
										}
										function p(e) {
											return e instanceof s.Z;
										}
										n.d(t, u);
									},
									1243: function () {},
									6736: function (e, t, n) {
										'use strict';
										n.r(t),
											n.d(t, {
												ACCESS_TOKEN_STORAGE_KEY: function () {
													return i.ACCESS_TOKEN_STORAGE_KEY;
												},
												BaseStorageManager: function () {
													return p.W8;
												},
												CACHE_STORAGE_NAME: function () {
													return i.CACHE_STORAGE_NAME;
												},
												DEFAULT_CACHE_DURATION: function () {
													return i.DEFAULT_CACHE_DURATION;
												},
												DEFAULT_CODE_CHALLENGE_METHOD: function () {
													return i.DEFAULT_CODE_CHALLENGE_METHOD;
												},
												DEFAULT_MAX_CLOCK_SKEW: function () {
													return i.DEFAULT_MAX_CLOCK_SKEW;
												},
												DEFAULT_POLLING_DELAY: function () {
													return i.DEFAULT_POLLING_DELAY;
												},
												IDX_API_VERSION: function () {
													return i.IDX_API_VERSION;
												},
												IDX_RESPONSE_STORAGE_NAME: function () {
													return i.IDX_RESPONSE_STORAGE_NAME;
												},
												ID_TOKEN_STORAGE_KEY: function () {
													return i.ID_TOKEN_STORAGE_KEY;
												},
												IOS_MAX_RETRY_COUNT: function () {
													return i.IOS_MAX_RETRY_COUNT;
												},
												MAX_VERIFIER_LENGTH: function () {
													return i.MAX_VERIFIER_LENGTH;
												},
												MIN_VERIFIER_LENGTH: function () {
													return i.MIN_VERIFIER_LENGTH;
												},
												ORIGINAL_URI_STORAGE_NAME: function () {
													return i.ORIGINAL_URI_STORAGE_NAME;
												},
												OktaUserAgent: function () {
													return c.ed;
												},
												PKCE_STORAGE_NAME: function () {
													return i.PKCE_STORAGE_NAME;
												},
												PromiseQueue: function () {
													return h.bo;
												},
												REFERRER_PATH_STORAGE_KEY: function () {
													return i.REFERRER_PATH_STORAGE_KEY;
												},
												REFRESH_TOKEN_STORAGE_KEY: function () {
													return i.REFRESH_TOKEN_STORAGE_KEY;
												},
												SHARED_TRANSACTION_STORAGE_NAME: function () {
													return i.SHARED_TRANSACTION_STORAGE_NAME;
												},
												STATE_TOKEN_KEY_NAME: function () {
													return i.STATE_TOKEN_KEY_NAME;
												},
												SavedObject: function () {
													return p._e;
												},
												TOKEN_STORAGE_NAME: function () {
													return i.TOKEN_STORAGE_NAME;
												},
												TRANSACTION_STORAGE_NAME: function () {
													return i.TRANSACTION_STORAGE_NAME;
												},
												bind: function () {
													return h.ak;
												},
												clone: function () {
													return h.d9;
												},
												closeSession: function () {
													return f.RJ;
												},
												createBaseOptionsConstructor: function () {
													return o.X;
												},
												createHttpOptionsConstructor: function () {
													return c.ZM;
												},
												createOktaAuthBase: function () {
													return o.a;
												},
												createSessionApi: function () {
													return f.MG;
												},
												createStorageOptionsConstructor: function () {
													return p.Tp;
												},
												crypto: function () {
													return r;
												},
												delay: function () {
													return h.gw;
												},
												deprecate: function () {
													return h.Rn;
												},
												deprecateWrap: function () {
													return h.VA;
												},
												extend: function () {
													return h.l7;
												},
												find: function () {
													return h.sE;
												},
												genRandomString: function () {
													return h.uh;
												},
												get: function () {
													return c.U2;
												},
												getConsole: function () {
													return h.dr;
												},
												getLink: function () {
													return h.Rg;
												},
												getNativeConsole: function () {
													return h.sW;
												},
												getSession: function () {
													return f.Gg;
												},
												httpRequest: function () {
													return c.c3;
												},
												isAbsoluteUrl: function () {
													return h.sD;
												},
												isFunction: function () {
													return h.mf;
												},
												isNumber: function () {
													return h.hj;
												},
												isObject: function () {
													return h.Kn;
												},
												isPromise: function () {
													return h.tI;
												},
												isString: function () {
													return h.HD;
												},
												isoToUTCString: function () {
													return h.ng;
												},
												logServerSideMemoryStorageWarning: function () {
													return p.Vp;
												},
												mixinHttp: function () {
													return c.Am;
												},
												mixinSession: function () {
													return f.Zg;
												},
												mixinStorage: function () {
													return p.Ho;
												},
												omit: function () {
													return h.CE;
												},
												post: function () {
													return c.v_;
												},
												refreshSession: function () {
													return f.dx;
												},
												removeNils: function () {
													return h.YY;
												},
												removeTrailingSlash: function () {
													return h.Qj;
												},
												sessionExists: function () {
													return f.sH;
												},
												setCookieAndRedirect: function () {
													return f.OT;
												},
												setRequestHeader: function () {
													return c.rn;
												},
												split2: function () {
													return h.YQ;
												},
												toAbsoluteUrl: function () {
													return h.BY;
												},
												toQueryString: function () {
													return h.UK;
												},
												toRelativeUrl: function () {
													return h.QN;
												},
												warn: function () {
													return h.ZK;
												},
											});
										var r = n(9718),
											o = n(3306),
											i = n(1971),
											a = n(3961),
											s = {};
										for (var l in a)
											[
												'default',
												'crypto',
												'createBaseOptionsConstructor',
												'createOktaAuthBase',
												'ACCESS_TOKEN_STORAGE_KEY',
												'CACHE_STORAGE_NAME',
												'DEFAULT_CACHE_DURATION',
												'DEFAULT_CODE_CHALLENGE_METHOD',
												'DEFAULT_MAX_CLOCK_SKEW',
												'DEFAULT_POLLING_DELAY',
												'IDX_API_VERSION',
												'IDX_RESPONSE_STORAGE_NAME',
												'ID_TOKEN_STORAGE_KEY',
												'IOS_MAX_RETRY_COUNT',
												'MAX_VERIFIER_LENGTH',
												'MIN_VERIFIER_LENGTH',
												'ORIGINAL_URI_STORAGE_NAME',
												'PKCE_STORAGE_NAME',
												'REFERRER_PATH_STORAGE_KEY',
												'REFRESH_TOKEN_STORAGE_KEY',
												'SHARED_TRANSACTION_STORAGE_NAME',
												'STATE_TOKEN_KEY_NAME',
												'TOKEN_STORAGE_NAME',
												'TRANSACTION_STORAGE_NAME',
											].indexOf(l) < 0 &&
												(s[l] = function (e) {
													return a[e];
												}.bind(0, l));
										n.d(t, s);
										var u = n(5728);
										for (var l in ((s = {}), u))
											[
												'default',
												'crypto',
												'createBaseOptionsConstructor',
												'createOktaAuthBase',
												'ACCESS_TOKEN_STORAGE_KEY',
												'CACHE_STORAGE_NAME',
												'DEFAULT_CACHE_DURATION',
												'DEFAULT_CODE_CHALLENGE_METHOD',
												'DEFAULT_MAX_CLOCK_SKEW',
												'DEFAULT_POLLING_DELAY',
												'IDX_API_VERSION',
												'IDX_RESPONSE_STORAGE_NAME',
												'ID_TOKEN_STORAGE_KEY',
												'IOS_MAX_RETRY_COUNT',
												'MAX_VERIFIER_LENGTH',
												'MIN_VERIFIER_LENGTH',
												'ORIGINAL_URI_STORAGE_NAME',
												'PKCE_STORAGE_NAME',
												'REFERRER_PATH_STORAGE_KEY',
												'REFRESH_TOKEN_STORAGE_KEY',
												'SHARED_TRANSACTION_STORAGE_NAME',
												'STATE_TOKEN_KEY_NAME',
												'TOKEN_STORAGE_NAME',
												'TRANSACTION_STORAGE_NAME',
												'AuthStateManager',
												'INITIAL_AUTH_STATE',
												'ServiceManager',
												'createCoreOptionsConstructor',
												'createCoreStorageManager',
												'createOktaAuthCore',
												'mixinCore',
											].indexOf(l) < 0 &&
												(s[l] = function (e) {
													return u[e];
												}.bind(0, l));
										n.d(t, s);
										var c = n(4777),
											d = n(9443);
										for (var l in ((s = {}), d))
											[
												'default',
												'crypto',
												'createBaseOptionsConstructor',
												'createOktaAuthBase',
												'ACCESS_TOKEN_STORAGE_KEY',
												'CACHE_STORAGE_NAME',
												'DEFAULT_CACHE_DURATION',
												'DEFAULT_CODE_CHALLENGE_METHOD',
												'DEFAULT_MAX_CLOCK_SKEW',
												'DEFAULT_POLLING_DELAY',
												'IDX_API_VERSION',
												'IDX_RESPONSE_STORAGE_NAME',
												'ID_TOKEN_STORAGE_KEY',
												'IOS_MAX_RETRY_COUNT',
												'MAX_VERIFIER_LENGTH',
												'MIN_VERIFIER_LENGTH',
												'ORIGINAL_URI_STORAGE_NAME',
												'PKCE_STORAGE_NAME',
												'REFERRER_PATH_STORAGE_KEY',
												'REFRESH_TOKEN_STORAGE_KEY',
												'SHARED_TRANSACTION_STORAGE_NAME',
												'STATE_TOKEN_KEY_NAME',
												'TOKEN_STORAGE_NAME',
												'TRANSACTION_STORAGE_NAME',
												'AuthStateManager',
												'INITIAL_AUTH_STATE',
												'ServiceManager',
												'createCoreOptionsConstructor',
												'createCoreStorageManager',
												'createOktaAuthCore',
												'mixinCore',
												'AuthApiError',
												'AuthPollStopError',
												'AuthSdkError',
												'OAuthError',
												'WWWAuthError',
												'isAuthApiError',
												'isOAuthError',
												'isWWWAuthError',
												'OktaUserAgent',
												'createHttpOptionsConstructor',
												'get',
												'httpRequest',
												'mixinHttp',
												'post',
												'setRequestHeader',
											].indexOf(l) < 0 &&
												(s[l] = function (e) {
													return d[e];
												}.bind(0, l));
										n.d(t, s);
										var f = n(8041),
											p = n(9927),
											h = n(305);
									},
									415: function (e, t, n) {
										'use strict';
										n.r(t),
											n.d(t, {
												getUserAgent: function () {
													return s;
												},
												hasTextEncoder: function () {
													return f;
												},
												isBrowser: function () {
													return i;
												},
												isDPoPSupported: function () {
													return v;
												},
												isFingerprintSupported: function () {
													return l;
												},
												isHTTPS: function () {
													return h;
												},
												isIE11OrLess: function () {
													return a;
												},
												isIOS: function () {
													return g;
												},
												isLocalhost: function () {
													return m;
												},
												isPKCESupported: function () {
													return p;
												},
												isPopupPostMessageSupported: function () {
													return u;
												},
												isTokenVerifySupported: function () {
													return d;
												},
											});
										var r = n(7594),
											o = /windows phone|iemobile|wpdesktop/i;
										function i() {
											return 'undefined' != typeof document && 'undefined' != typeof window;
										}
										function a() {
											if (!i()) return !1;
											var e = document.documentMode;
											return !!e && e <= 11;
										}
										function s() {
											return navigator.userAgent;
										}
										function l() {
											var e = s();
											return e && !o.test(e);
										}
										function u() {
											if (!i()) return !1;
											var e = document.documentMode,
												t = e && e < 10;
											return void 0 !== window.postMessage && !t;
										}
										function c() {
											return (
												void 0 !== r.KP && null !== r.KP && void 0 !== r.KP.subtle && 'undefined' != typeof Uint8Array
											);
										}
										function d() {
											return c();
										}
										function f() {
											return 'undefined' != typeof TextEncoder;
										}
										function p() {
											return d() && f();
										}
										function h() {
											return !!i() && 'https:' === window.location.protocol;
										}
										function m() {
											return i() && 'localhost' === window.location.hostname;
										}
										function v() {
											return !a() && void 0 !== window.indexedDB && f() && c();
										}
										function g() {
											return (
												i() &&
												'undefined' != typeof navigator &&
												void 0 !== navigator.userAgent &&
												/iPad|iPhone|iPod/.test(navigator.userAgent) &&
												!window.MSStream
											);
										}
									},
									287: function (e, t, n) {
										'use strict';
										n.d(t, {
											e: function () {
												return s;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(4942),
											a = n(415),
											s = (function () {
												function e() {
													(0, r.Z)(this, e),
														(0, i.Z)(this, 'environments', void 0),
														(this.environments = ['okta-auth-js/'.concat('7.11.0')]),
														this.maybeAddNodeEnvironment();
												}
												return (
													(0, o.Z)(e, [
														{
															key: 'addEnvironment',
															value: function (e) {
																this.environments.push(e);
															},
														},
														{
															key: 'getHttpHeader',
															value: function () {
																return { 'X-Okta-User-Agent-Extended': this.environments.join(' ') };
															},
														},
														{
															key: 'getVersion',
															value: function () {
																return '7.11.0';
															},
														},
														{
															key: 'maybeAddNodeEnvironment',
															value: function () {
																if (!(0, a.isBrowser)() && process && process.versions) {
																	var e = process.versions.node;
																	this.environments.push('nodejs/'.concat(e));
																}
															},
														},
													]),
													e
												);
											})();
									},
									2281: function (e, t, n) {
										'use strict';
										function r(e, t, n) {
											(e.options.headers = e.options.headers || {}), (e.options.headers[t] = n);
										}
										n.d(t, {
											r: function () {
												return r;
											},
										});
									},
									4777: function (e, t, n) {
										'use strict';
										n.d(t, {
											Am: function () {
												return a.A;
											},
											U2: function () {
												return i.U2;
											},
											ZM: function () {
												return s.Z;
											},
											c3: function () {
												return i.c3;
											},
											ed: function () {
												return o.e;
											},
											rn: function () {
												return r.r;
											},
											v_: function () {
												return i.v_;
											},
										});
										var r = n(2281),
											o = n(287),
											i = n(5385),
											a = n(279),
											s = n(8817);
									},
									279: function (e, t, n) {
										'use strict';
										n.d(t, {
											A: function () {
												return h;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(7326),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942),
											c = n(287),
											d = n(2281),
											f = n(6718),
											p = n(5385);
										function h(e) {
											return (function (e) {
												(0, a.Z)(m, e);
												var t,
													n,
													h =
														((t = m),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, l.Z)(t);
															if (n) {
																var o = (0, l.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, s.Z)(this, e);
														});
												function m() {
													var e;
													(0, r.Z)(this, m);
													for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) n[o] = arguments[o];
													return (
														(e = h.call.apply(h, [this].concat(n))),
														(0, u.Z)((0, i.Z)(e), '_oktaUserAgent', void 0),
														(0, u.Z)((0, i.Z)(e), 'http', void 0),
														(e._oktaUserAgent = new c.e()),
														(e.http = { setRequestHeader: d.r.bind(null, (0, i.Z)(e)) }),
														e
													);
												}
												return (
													(0, o.Z)(m, [
														{
															key: 'setHeaders',
															value: function (e) {
																this.options.headers = Object.assign({}, this.options.headers, e);
															},
														},
														{
															key: 'getIssuerOrigin',
															value: function () {
																return this.options.issuer.split('/oauth2/')[0];
															},
														},
														{
															key: 'webfinger',
															value: function (e) {
																var t = '/.well-known/webfinger' + (0, f.UK)(e);
																return (0, p.U2)(this, t, { headers: { Accept: 'application/jrd+json' } });
															},
														},
													]),
													m
												);
											})(e);
										}
									},
									8817: function (e, t, n) {
										'use strict';
										n.d(t, {
											Z: function () {
												return y;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(7326),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942),
											c = n(3849),
											d = n(885),
											f = n(1002),
											p = n(4098),
											h = n.n(p);
										function m(e, t) {
											(null == t || t > e.length) && (t = e.length);
											for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
											return r;
										}
										var v = /application\/\w*\+?json/,
											g = function (e, t, r) {
												var o = r.data,
													i = r.headers || {},
													a = i['Content-Type'] || i['content-type'] || '';
												o &&
													'string' != typeof o &&
													(v.test(a)
														? (o = JSON.stringify(o))
														: 'application/x-www-form-urlencoded' === a &&
														  (o = Object.entries(o)
																.map(function (e) {
																	var t = (0, d.Z)(e, 2),
																		n = t[0],
																		r = t[1];
																	return ''.concat(n, '=').concat(encodeURIComponent(r));
																})
																.join('&')));
												var s = (n.g.fetch || h())(t, {
													method: e,
													headers: r.headers,
													body: o,
													credentials: r.withCredentials ? 'include' : 'omit',
												});
												return (
													s.finally || (s = Promise.resolve(s)),
													s.then(function (e) {
														var t = !e.ok,
															n = e.status;
														return (function (e) {
															return e.headers.get('Content-Type') &&
																e.headers.get('Content-Type').toLowerCase().indexOf('application/json') >= 0
																? e.json().catch(function (e) {
																		return { error: e, errorSummary: 'Could not parse server response' };
																  })
																: e.text();
														})(e)
															.then(function (t) {
																return (function (e, t, n) {
																	var r,
																		o = 'object' === (0, f.Z)(t),
																		i = {},
																		a = (function (e, t) {
																			var n = ('undefined' != typeof Symbol && e[Symbol.iterator]) || e['@@iterator'];
																			if (!n) {
																				if (
																					Array.isArray(e) ||
																					(n = (function (e, t) {
																						if (e) {
																							if ('string' == typeof e) return m(e, t);
																							var n = Object.prototype.toString.call(e).slice(8, -1);
																							return (
																								'Object' === n && e.constructor && (n = e.constructor.name),
																								'Map' === n || 'Set' === n
																									? Array.from(e)
																									: 'Arguments' === n ||
																									  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
																									? m(e, t)
																									: void 0
																							);
																						}
																					})(e)) ||
																					(t && e && 'number' == typeof e.length)
																				) {
																					n && (e = n);
																					var r = 0,
																						o = function () {};
																					return {
																						s: o,
																						n: function () {
																							return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
																						},
																						e: function (e) {
																							throw e;
																						},
																						f: o,
																					};
																				}
																				throw new TypeError(
																					'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
																				);
																			}
																			var i,
																				a = !0,
																				s = !1;
																			return {
																				s: function () {
																					n = n.call(e);
																				},
																				n: function () {
																					var e = n.next();
																					return (a = e.done), e;
																				},
																				e: function (e) {
																					(s = !0), (i = e);
																				},
																				f: function () {
																					try {
																						a || null == n.return || n.return();
																					} finally {
																						if (s) throw i;
																					}
																				},
																			};
																		})(n.headers.entries());
																	try {
																		for (a.s(); !(r = a.n()).done; ) {
																			var s = r.value;
																			i[s[0]] = s[1];
																		}
																	} catch (e) {
																		a.e(e);
																	} finally {
																		a.f();
																	}
																	var l = { responseText: o ? JSON.stringify(t) : t, status: e, headers: i };
																	return o && ((l.responseType = 'json'), (l.responseJSON = t)), l;
																})(n, t, e);
															})
															.then(function (e) {
																var n;
																if (t || (null !== (n = e.responseJSON) && void 0 !== n && n.error)) throw e;
																return e;
															});
													})
												);
											};
										function y() {
											return (function (e) {
												(0, a.Z)(d, e);
												var t,
													n,
													c =
														((t = d),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, l.Z)(t);
															if (n) {
																var o = (0, l.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, s.Z)(this, e);
														});
												function d(e) {
													var t;
													return (
														(0, o.Z)(this, d),
														(t = c.call(this, e)),
														(0, u.Z)((0, i.Z)(t), 'issuer', void 0),
														(0, u.Z)((0, i.Z)(t), 'transformErrorXHR', void 0),
														(0, u.Z)((0, i.Z)(t), 'headers', void 0),
														(0, u.Z)((0, i.Z)(t), 'httpRequestClient', void 0),
														(0, u.Z)((0, i.Z)(t), 'httpRequestInterceptors', void 0),
														(0, u.Z)((0, i.Z)(t), 'pollDelay', void 0),
														(t.issuer = e.issuer),
														(t.transformErrorXHR = e.transformErrorXHR),
														(t.headers = e.headers),
														(t.httpRequestClient = e.httpRequestClient || g),
														(t.httpRequestInterceptors = e.httpRequestInterceptors),
														(t.pollDelay = e.pollDelay),
														t
													);
												}
												return (0, r.Z)(d);
											})((0, c.T)());
										}
									},
									5385: function (e, t, n) {
										'use strict';
										n.d(t, {
											U2: function () {
												return _;
											},
											c3: function () {
												return b;
											},
											v_: function () {
												return w;
											},
										});
										var r = n(1002),
											o = n(4942),
											i = n(4771),
											a = n(3193),
											s = n(6718),
											l = n(1971),
											u = n(3983),
											c = n(3114),
											d = n(2886),
											f = n(415);
										function p(e, t) {
											(null == t || t > e.length) && (t = e.length);
											for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
											return r;
										}
										function h(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function m(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? h(Object(n), !0).forEach(function (t) {
															(0, o.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: h(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var v,
											g = 0;
										(0, f.isBrowser)() &&
											((g = Date.now()),
											(v = function () {
												document.hidden || (g = Date.now());
											}),
											document.addEventListener('visibilitychange', v));
										var y = function (e, t) {
											var n, r, o, s;
											if (t instanceof Error) return new u.Z({ errorSummary: t.message });
											var l,
												f = t,
												p = {};
											if (f.responseText && (0, i.HD)(f.responseText))
												try {
													p = JSON.parse(f.responseText);
												} catch (e) {
													p = { errorSummary: 'Unknown error' };
												}
											f.status >= 500 && (p.errorSummary = 'Unknown error'),
												e.options.transformErrorXHR && (f = e.options.transformErrorXHR((0, a.d9)(f)));
											var h =
												null !==
													(n = c.Z.getWWWAuthenticateHeader(null === (r = f) || void 0 === r ? void 0 : r.headers)) &&
												void 0 !== n
													? n
													: '';
											if (
												((l =
													p.error && p.error_description
														? new d.Z(p.error, p.error_description, f)
														: new u.Z(p, f, { wwwAuthHeader: h })),
												h &&
													(null === (o = f) || void 0 === o ? void 0 : o.status) >= 400 &&
													(null === (s = f) || void 0 === s ? void 0 : s.status) < 500)
											) {
												var v = c.Z.parseHeader(h);
												if (
													403 === f.status &&
													'insufficient_authentication_context' === (null == v ? void 0 : v.error)
												) {
													var g = v.parameters,
														y = g.max_age,
														b = g.acr_values;
													l = new u.Z(
														{ errorSummary: v.error, errorCauses: [{ errorSummary: v.errorDescription }] },
														f,
														m({ max_age: +y }, b && { acr_values: b })
													);
												} else 'DPoP' === (null == v ? void 0 : v.scheme) && (l = v);
											}
											return l;
										};
										function b(e, t) {
											var n;
											if (((t = t || {}), e.options.httpRequestInterceptors)) {
												var o,
													s = (function (e, t) {
														var n = ('undefined' != typeof Symbol && e[Symbol.iterator]) || e['@@iterator'];
														if (!n) {
															if (
																Array.isArray(e) ||
																(n = (function (e, t) {
																	if (e) {
																		if ('string' == typeof e) return p(e, t);
																		var n = Object.prototype.toString.call(e).slice(8, -1);
																		return (
																			'Object' === n && e.constructor && (n = e.constructor.name),
																			'Map' === n || 'Set' === n
																				? Array.from(e)
																				: 'Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
																				? p(e, t)
																				: void 0
																		);
																	}
																})(e)) ||
																(t && e && 'number' == typeof e.length)
															) {
																n && (e = n);
																var r = 0,
																	o = function () {};
																return {
																	s: o,
																	n: function () {
																		return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
																	},
																	e: function (e) {
																		throw e;
																	},
																	f: o,
																};
															}
															throw new TypeError(
																'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
															);
														}
														var i,
															a = !0,
															s = !1;
														return {
															s: function () {
																n = n.call(e);
															},
															n: function () {
																var e = n.next();
																return (a = e.done), e;
															},
															e: function (e) {
																(s = !0), (i = e);
															},
															f: function () {
																try {
																	a || null == n.return || n.return();
																} finally {
																	if (s) throw i;
																}
															},
														};
													})(e.options.httpRequestInterceptors);
												try {
													for (s.s(); !(o = s.n()).done; ) (0, o.value)(t);
												} catch (T) {
													s.e(T);
												} finally {
													s.f();
												}
											}
											var u = t.url,
												c = t.method,
												d = t.args,
												h = t.saveAuthnState,
												v = t.accessToken,
												b = !0 === t.withCredentials,
												_ = e.options.storageUtil.storage,
												w = e.storageManager.getHttpCache(e.options.cookies),
												O = t.pollingIntent,
												k = null !== (n = e.options.pollDelay) && void 0 !== n ? n : 0;
											if (t.cacheResponse) {
												var x = w.getStorage()[u];
												if (x && Date.now() / 1e3 < x.expiresAt) return Promise.resolve(x.response);
											}
											var E = m(
												{ 'Accept': 'application/json', 'Content-Type': 'application/json' },
												e._oktaUserAgent.getHttpHeader()
											);
											Object.assign(E, e.options.headers, t.headers),
												(E = (0, a.YY)(E)),
												v && (0, i.HD)(v) && (E.Authorization = 'Bearer ' + v);
											var T,
												S,
												A,
												C = { headers: E, data: d || void 0, withCredentials: b };
											if (O && (0, f.isBrowser)() && k > 0) {
												var P,
													R,
													I,
													N = 0;
												(R = function () {
													var e = Date.now() - g;
													return e < k
														? new Promise(function (t) {
																return setTimeout(function () {
																	document.hidden ? t(P()) : t();
																}, k - e);
														  })
														: Promise.resolve();
												}),
													(P = function () {
														var e;
														return document.hidden
															? new Promise(function (t) {
																	(e = function () {
																		document.hidden || (document.removeEventListener('visibilitychange', e), t(R()));
																	}),
																		document.addEventListener('visibilitychange', e);
															  })
															: R();
													});
												var M = function () {
													return e.options.httpRequestClient(c, u, C).catch(function (e) {
														if ('Load failed' === (null == e ? void 0 : e.message) && N < l.IOS_MAX_RETRY_COUNT)
															return N++, I();
														throw e;
													});
												};
												A = (I = function () {
													return P().then(M);
												})();
											} else A = e.options.httpRequestClient(c, u, C);
											return A.then(function (n) {
												return (
													(S = n.responseText) &&
														(0, i.HD)(S) &&
														(S = JSON.parse(S)) &&
														'object' === (0, r.Z)(S) &&
														!S.headers &&
														(Array.isArray(S)
															? S.forEach(function (e) {
																	e.headers = n.headers;
															  })
															: (S.headers = n.headers)),
													h && (S.stateToken || _.delete(l.STATE_TOKEN_KEY_NAME)),
													S &&
														S.stateToken &&
														S.expiresAt &&
														_.set(l.STATE_TOKEN_KEY_NAME, S.stateToken, S.expiresAt, e.options.cookies),
													S &&
														t.cacheResponse &&
														w.updateStorage(u, {
															expiresAt: Math.floor(Date.now() / 1e3) + l.DEFAULT_CACHE_DURATION,
															response: S,
														}),
													S
												);
											}).catch(function (t) {
												throw ('E0000011' === (T = y(e, t)).errorCode && _.delete(l.STATE_TOKEN_KEY_NAME), T);
											});
										}
										function _(e, t, n) {
											var r = { url: (t = (0, s.sD)(t) ? t : e.getIssuerOrigin() + t), method: 'GET' };
											return Object.assign(r, n), b(e, r);
										}
										function w(e, t, n, r) {
											var o = {
												url: (t = (0, s.sD)(t) ? t : e.getIssuerOrigin() + t),
												method: 'POST',
												args: n,
												saveAuthnState: !0,
											};
											return Object.assign(o, r), b(e, o);
										}
									},
									3334: function (e, t, n) {
										'use strict';
										n.d(t, {
											v: function () {
												return d;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(1752),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(1646),
											c = n(480);
										function d() {
											return (function (e) {
												(0, a.Z)(d, e);
												var t,
													n,
													u =
														((t = d),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, l.Z)(t);
															if (n) {
																var o = (0, l.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, s.Z)(this, e);
														});
												function d(e) {
													return (0, r.Z)(this, d), u.call(this, e);
												}
												return (
													(0, o.Z)(d, [
														{
															key: 'clear',
															value: function () {
																var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
																(0, i.Z)((0, l.Z)(d.prototype), 'clear', this).call(this, e),
																	!1 !== e.clearIdxResponse && this.clearIdxResponse();
															},
														},
														{
															key: 'saveIdxResponse',
															value: function (e) {
																if (this.saveLastResponse) {
																	var t = this.storageManager.getIdxResponseStorage();
																	t && t.setStorage(e);
																}
															},
														},
														{
															key: 'loadIdxResponse',
															value: function (e) {
																if (!this.saveLastResponse) return null;
																var t = this.storageManager.getIdxResponseStorage();
																if (!t) return null;
																var n = t.getStorage();
																if (!n || !(0, c.P)(n.rawIdxResponse)) return null;
																if (e) {
																	var r = e.stateHandle,
																		o = e.interactionHandle;
																	if (!e.useGenericRemediator && r && n.stateHandle !== r) return null;
																	if (o && n.interactionHandle !== o) return null;
																}
																return n;
															},
														},
														{
															key: 'clearIdxResponse',
															value: function () {
																if (this.saveLastResponse) {
																	var e = this.storageManager.getIdxResponseStorage();
																	null == e || e.clearStorage();
																}
															},
														},
													]),
													d
												);
											})((0, u.P)());
										}
									},
									1286: function (e, t, n) {
										'use strict';
										n.d(t, {
											Y: function () {
												return d;
											},
										});
										var r = n(4942),
											o = n(5861),
											i = n(4687),
											a = n.n(i),
											s = n(7595),
											l = n(3377);
										function u(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function c(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? u(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: u(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function d(e) {
											return f.apply(this, arguments);
										}
										function f() {
											return (
												(f = (0, o.Z)(
													a().mark(function e(t) {
														var n,
															r = arguments;
														return a().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(n = r.length > 1 && void 0 !== r[1] ? r[1] : {}).password &&
																				!n.authenticator &&
																				(n.authenticator = s.pc.OKTA_PASSWORD),
																			e.abrupt('return', (0, l.K)(t, c(c({}, n), {}, { flow: 'authenticate' })))
																		);
																	case 3:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												f.apply(this, arguments)
											);
										}
									},
									7644: function (e, t, n) {
										'use strict';
										n.d(t, {
											_: function () {
												return a;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(4942),
											a = (0, r.Z)(function e(t) {
												(0, o.Z)(this, e), (0, i.Z)(this, 'meta', void 0), (this.meta = t);
											});
									},
									9582: function (e, t, n) {
										'use strict';
										n.d(t, {
											a: function () {
												return d;
											},
										});
										var r = n(4942),
											o = n(5671),
											i = n(3144),
											a = n(136),
											s = n(2963),
											l = n(1120);
										function u(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function c(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? u(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: u(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var d = (function (e) {
											(0, a.Z)(u, e);
											var t,
												n,
												r =
													((t = u),
													(n = (function () {
														if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
														if (Reflect.construct.sham) return !1;
														if ('function' == typeof Proxy) return !0;
														try {
															return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
														} catch (e) {
															return !1;
														}
													})()),
													function () {
														var e,
															r = (0, l.Z)(t);
														if (n) {
															var o = (0, l.Z)(this).constructor;
															e = Reflect.construct(r, arguments, o);
														} else e = r.apply(this, arguments);
														return (0, s.Z)(this, e);
													});
											function u() {
												return (0, o.Z)(this, u), r.apply(this, arguments);
											}
											return (
												(0, i.Z)(u, [
													{
														key: 'canVerify',
														value: function (e) {
															return !!(e.credentials || e.password || e.passcode);
														},
													},
													{
														key: 'mapCredentials',
														value: function (e) {
															var t = e.credentials,
																n = e.password,
																r = e.passcode,
																o = e.revokeSessions;
															if (t || n || r) return t || { passcode: r || n, revokeSessions: o };
														},
													},
													{
														key: 'getInputs',
														value: function (e) {
															var t,
																n,
																r = [
																	c(
																		c({}, null === (t = e.form) || void 0 === t ? void 0 : t.value[0]),
																		{},
																		{ name: 'password', type: 'string', required: e.required }
																	),
																];
															return (
																(null === (n = e.form) || void 0 === n
																	? void 0
																	: n.value.find(function (e) {
																			return 'revokeSessions' === e.name;
																	  })) &&
																	r.push({
																		name: 'revokeSessions',
																		type: 'boolean',
																		label: 'Sign me out of all other devices',
																		required: !1,
																	}),
																r
															);
														},
													},
												]),
												u
											);
										})(n(7644)._);
									},
									9344: function (e, t, n) {
										'use strict';
										n.d(t, {
											LL: function () {
												return i;
											},
											PN: function () {
												return a;
											},
											h_: function () {
												return s;
											},
										});
										var r = n(7595);
										function o(e, t) {
											(null == t || t > e.length) && (t = e.length);
											for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
											return r;
										}
										function i(e) {
											var t;
											if ((0, r.H)(e)) t = e;
											else {
												if ('string' != typeof e) throw new Error('Invalid format for authenticator');
												t = { key: e };
											}
											return t;
										}
										function a(e, t) {
											return !!(e && t && (e.id && t.id ? e.id === t.id : e.key && t.key && e.key === t.key));
										}
										function s(e, t) {
											var n,
												r,
												i = (function (e, t) {
													var n = ('undefined' != typeof Symbol && e[Symbol.iterator]) || e['@@iterator'];
													if (!n) {
														if (
															Array.isArray(e) ||
															(n = (function (e, t) {
																if (e) {
																	if ('string' == typeof e) return o(e, t);
																	var n = Object.prototype.toString.call(e).slice(8, -1);
																	return (
																		'Object' === n && e.constructor && (n = e.constructor.name),
																		'Map' === n || 'Set' === n
																			? Array.from(e)
																			: 'Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
																			? o(e, t)
																			: void 0
																	);
																}
															})(e)) ||
															(t && e && 'number' == typeof e.length)
														) {
															n && (e = n);
															var r = 0,
																i = function () {};
															return {
																s: i,
																n: function () {
																	return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
																},
																e: function (e) {
																	throw e;
																},
																f: i,
															};
														}
														throw new TypeError(
															'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
														);
													}
													var a,
														s = !0,
														l = !1;
													return {
														s: function () {
															n = n.call(e);
														},
														n: function () {
															var e = n.next();
															return (s = e.done), e;
														},
														e: function (e) {
															(l = !0), (a = e);
														},
														f: function () {
															try {
																s || null == n.return || n.return();
															} finally {
																if (l) throw a;
															}
														},
													};
												})(e);
											try {
												var a = function () {
													var e = r.value;
													if (
														(n = t.find(function (t) {
															var n = t.relatesTo;
															return n.key && n.key === e.key;
														}))
													)
														return 'break';
												};
												for (i.s(); !(r = i.n()).done && 'break' !== a(); );
											} catch (e) {
												i.e(e);
											} finally {
												i.f();
											}
											return n;
										}
									},
									9192: function (e, t, n) {
										'use strict';
										n.d(t, {
											a: function () {
												return d;
											},
										});
										var r = n(4942),
											o = n(5861),
											i = n(4687),
											a = n.n(i),
											s = n(3377),
											l = n(7738);
										function u(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function c(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? u(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: u(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function d(e, t) {
											return f.apply(this, arguments);
										}
										function f() {
											return (f = (0, o.Z)(
												a().mark(function e(t, n) {
													var r, o;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	return (
																		(r = t.transactionManager.load()),
																		(o = (0, l.s)(t, r.flow)),
																		e.abrupt('return', (0, s.K)(t, c(c(c({}, n), o), {}, { actions: ['cancel'] })))
																	);
																case 3:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
									},
									7985: function (e, t, n) {
										'use strict';
										n.d(t, {
											GA: function () {
												return g;
											},
											Jn: function () {
												return b;
											},
											gc: function () {
												return v;
											},
											mo: function () {
												return y;
											},
										});
										var r = n(5861),
											o = n(3144),
											i = n(5671),
											a = n(7326),
											s = n(136),
											l = n(2963),
											u = n(1120),
											c = n(4942),
											d = n(4687),
											f = n.n(d),
											p = n(6245),
											h = n(1969),
											m = (function (e) {
												(0, s.Z)(d, e);
												var t,
													n,
													r =
														((t = d),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, u.Z)(t);
															if (n) {
																var o = (0, u.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, l.Z)(this, e);
														});
												function d(e, t) {
													var n;
													return (
														(0, i.Z)(this, d),
														(n = r.call(this, 'Enter the OTP code in the originating client: '.concat(t))),
														(0, c.Z)((0, a.Z)(n), 'state', void 0),
														(0, c.Z)((0, a.Z)(n), 'otp', void 0),
														(n.name = 'EmailVerifyCallbackError'),
														(n.state = e),
														(n.otp = t),
														n
													);
												}
												return (0, o.Z)(d);
											})(p.Z);
										function v(e) {
											return 'EmailVerifyCallbackError' === e.name;
										}
										function g(e) {
											return /(otp=)/i.test(e) && /(state=)/i.test(e);
										}
										function y(e) {
											return (0, h.v)(e);
										}
										function b(e, t) {
											return _.apply(this, arguments);
										}
										function _() {
											return (_ = (0, r.Z)(
												f().mark(function e(t, n) {
													var r, o, i;
													return f().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (!g(n)) {
																		e.next = 9;
																		break;
																	}
																	if (((r = y(n)), (o = r.state), (i = r.otp), !t.idx.canProceed({ state: o }))) {
																		e.next = 8;
																		break;
																	}
																	return (e.next = 5), t.idx.proceed({ state: o, otp: i });
																case 5:
																	return e.abrupt('return', e.sent);
																case 8:
																	throw new m(o, i);
																case 9:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
									},
									2144: function (e, t, n) {
										'use strict';
										n.d(t, {
											Y: function () {
												return i;
											},
										});
										var r = n(1578),
											o = n(8137);
										function i(e, t, n) {
											var i = (0, r.K)(e, t, n);
											return (0, o.B)(i);
										}
									},
									8717: function (e, t, n) {
										'use strict';
										n.d(t, {
											F: function () {
												return H;
											},
										});
										var r = {};
										n.r(r),
											n.d(r, {
												AuthenticatorEnrollmentData: function () {
													return U.q;
												},
												AuthenticatorVerificationData: function () {
													return L.q;
												},
												ChallengeAuthenticator: function () {
													return E.J;
												},
												ChallengePoll: function () {
													return T.U;
												},
												EnrollAuthenticator: function () {
													return w.q;
												},
												EnrollPoll: function () {
													return O.T;
												},
												EnrollProfile: function () {
													return A.w;
												},
												EnrollmentChannelData: function () {
													return x.t;
												},
												GenericRemediator: function () {
													return B.P;
												},
												Identify: function () {
													return C.h;
												},
												ReEnrollAuthenticator: function () {
													return P.j;
												},
												ReEnrollAuthenticatorWarning: function () {
													return R.i;
												},
												RedirectIdp: function () {
													return I.O;
												},
												Remediator: function () {
													return _.n;
												},
												ResetAuthenticator: function () {
													return S.G;
												},
												SelectAuthenticatorAuthenticate: function () {
													return N.X;
												},
												SelectAuthenticatorEnroll: function () {
													return M.j;
												},
												SelectAuthenticatorUnlockAccount: function () {
													return j.G;
												},
												SelectEnrollProfile: function () {
													return D.j;
												},
												SelectEnrollmentChannel: function () {
													return k.V;
												},
												Skip: function () {
													return F.h;
												},
											});
										var o = n(8221),
											i = n(9912),
											a = n(1286),
											s = n(9192),
											l = n(7985),
											u = n(5021),
											c = n(5923),
											d = n(6131),
											f = n(2660),
											p = n(9310),
											h = n(2845),
											m = n(9214),
											v = n(8826),
											g = n(2473),
											y = n(2620),
											b = n(8277),
											_ = n(3118),
											w = n(3857),
											O = n(2288),
											k = n(3403),
											x = n(3679),
											E = n(4560),
											T = n(1104),
											S = n(1019),
											A = n(7522),
											C = n(8628),
											P = n(9024),
											R = n(8107),
											I = n(8490),
											N = n(7311),
											M = n(9865),
											j = n(5272),
											D = n(4713),
											L = n(5278),
											U = n(2541),
											F = n(8443),
											B = n(9732),
											V = n(7738),
											Z = n(5031);
										function H(e) {
											(0, Z.TC)({ remediators: r, getFlowSpecification: V.s });
											var t = g.Y.bind(null, e);
											return {
												interact: d.E.bind(null, e),
												introspect: f.L.bind(null, e),
												makeIdxResponse: c._T.bind(null, e),
												authenticate: a.Y.bind(null, e),
												register: v.z.bind(null, e),
												start: t,
												startTransaction: t,
												poll: p.$.bind(null, e),
												proceed: h.x.bind(null, e),
												cancel: s.a.bind(null, e),
												recoverPassword: m.M.bind(null, e),
												handleInteractionCodeRedirect: u.X.bind(null, e),
												isInteractionRequired: o.wc.bind(null, e),
												isInteractionRequiredError: i.Cf,
												handleEmailVerifyCallback: l.Jn.bind(null, e),
												isEmailVerifyCallback: l.GA,
												parseEmailVerifyCallback: l.mo,
												isEmailVerifyCallbackError: l.gc,
												getSavedTransactionMeta: y.uN.bind(null, e),
												createTransactionMeta: y.Xc.bind(null, e),
												getTransactionMeta: y.Co.bind(null, e),
												saveTransactionMeta: y.r0.bind(null, e),
												clearTransactionMeta: y.Jm.bind(null, e),
												isTransactionMetaValid: y.Wf,
												setFlow: function (t) {
													e.options.flow = t;
												},
												getFlow: function () {
													return e.options.flow;
												},
												canProceed: h.C.bind(null, e),
												unlockAccount: b.l.bind(null, e),
											};
										}
									},
									7738: function (e, t, n) {
										'use strict';
										n.d(t, {
											s: function () {
												return T;
											},
										});
										var r = n(8628),
											o = n(7311),
											i = n(9865),
											a = n(2541),
											s = n(5278),
											l = n(3857),
											u = n(4560),
											c = n(1104),
											d = n(9024),
											f = n(8107),
											p = n(2288),
											h = n(3403),
											m = n(3679),
											v = n(8490),
											g = n(8443),
											y = {
												'identify': r.h,
												'select-authenticator-authenticate': o.X,
												'select-authenticator-enroll': i.j,
												'authenticator-enrollment-data': a.q,
												'authenticator-verification-data': s.q,
												'enroll-authenticator': l.q,
												'challenge-authenticator': u.J,
												'challenge-poll': c.U,
												'reenroll-authenticator': d.j,
												'reenroll-authenticator-warning': f.i,
												'enroll-poll': p.T,
												'select-enrollment-channel': h.V,
												'enrollment-channel-data': m.t,
												'redirect-idp': v.O,
												'skip': g.h,
											},
											b = n(1019),
											_ = {
												'identify': r.h,
												'identify-recovery': r.h,
												'select-authenticator-authenticate': o.X,
												'select-authenticator-enroll': i.j,
												'challenge-authenticator': u.J,
												'authenticator-verification-data': s.q,
												'authenticator-enrollment-data': a.q,
												'reset-authenticator': b.G,
												'reenroll-authenticator': d.j,
												'reenroll-authenticator-warning': f.i,
												'enroll-poll': p.T,
											},
											w = n(4713),
											O = n(7522),
											k = {
												'select-enroll-profile': w.j,
												'enroll-profile': O.w,
												'authenticator-enrollment-data': a.q,
												'select-authenticator-enroll': i.j,
												'enroll-poll': p.T,
												'select-enrollment-channel': h.V,
												'enrollment-channel-data': m.t,
												'enroll-authenticator': l.q,
												'skip': g.h,
											},
											x = n(5272),
											E = {
												'identify': r.h,
												'select-authenticator-unlock-account': x.G,
												'select-authenticator-authenticate': o.X,
												'challenge-authenticator': u.J,
												'challenge-poll': c.U,
												'authenticator-verification-data': s.q,
												'reenroll-authenticator-warning': f.i,
											};
										function T(e) {
											var t,
												n,
												r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 'default',
												o = !0;
											switch (r) {
												case 'register':
												case 'signup':
												case 'enrollProfile':
													(t = k), (o = !1);
													break;
												case 'recoverPassword':
												case 'resetPassword':
													(t = _),
														(n = ['currentAuthenticator-recover', 'currentAuthenticatorEnrollment-recover']),
														(o = !1);
													break;
												case 'unlockAccount':
													(t = E), (o = !1), (n = ['unlock-account']);
													break;
												default:
													t = y;
											}
											return { flow: r, remediators: t, actions: n, withCredentials: o };
										}
									},
									5021: function (e, t, n) {
										'use strict';
										n.d(t, {
											X: function () {
												return l;
											},
										});
										var r = n(5861),
											o = n(4687),
											i = n.n(o),
											a = n(9123),
											s = n(2886);
										function l(e, t) {
											return u.apply(this, arguments);
										}
										function u() {
											return (u = (0, r.Z)(
												i().mark(function e(t, n) {
													var r, o, l, u, c, d, f, p, h, m;
													return i().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if ((r = t.transactionManager.load())) {
																		e.next = 3;
																		break;
																	}
																	throw new a.Z('No transaction data was found in storage');
																case 3:
																	if (
																		((o = r.codeVerifier),
																		(l = r.state),
																		(u = new URL(n)),
																		(c = u.searchParams),
																		(d = c.get('state')),
																		(f = c.get('interaction_code')),
																		!(p = c.get('error')))
																	) {
																		e.next = 10;
																		break;
																	}
																	throw new s.Z(p, c.get('error_description'));
																case 10:
																	if (d === l) {
																		e.next = 12;
																		break;
																	}
																	throw new a.Z('State in redirect uri does not match with transaction state');
																case 12:
																	if (f) {
																		e.next = 14;
																		break;
																	}
																	throw new a.Z('Unable to parse interaction_code from the url');
																case 14:
																	return (
																		(e.next = 16),
																		t.token.exchangeCodeForTokens({ interactionCode: f, codeVerifier: o })
																	);
																case 16:
																	(h = e.sent), (m = h.tokens), t.tokenManager.setTokens(m);
																case 19:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
									},
									5923: function (e, t, n) {
										'use strict';
										n.d(t, {
											_T: function () {
												return U;
											},
											A0: function () {
												return L;
											},
										});
										var r = n(1971),
											o = n(5861),
											i = n(2982),
											a = n(4687),
											s = n.n(a),
											l = n(885),
											u = n(4942),
											c = n(4925),
											d = n(1002),
											f = n(5385);
										function p(e, t) {
											var n = ('undefined' != typeof Symbol && e[Symbol.iterator]) || e['@@iterator'];
											if (!n) {
												if (
													Array.isArray(e) ||
													(n = (function (e, t) {
														if (e) {
															if ('string' == typeof e) return h(e, t);
															var n = Object.prototype.toString.call(e).slice(8, -1);
															return (
																'Object' === n && e.constructor && (n = e.constructor.name),
																'Map' === n || 'Set' === n
																	? Array.from(e)
																	: 'Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
																	? h(e, t)
																	: void 0
															);
														}
													})(e)) ||
													(t && e && 'number' == typeof e.length)
												) {
													n && (e = n);
													var r = 0,
														o = function () {};
													return {
														s: o,
														n: function () {
															return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
														},
														e: function (e) {
															throw e;
														},
														f: o,
													};
												}
												throw new TypeError(
													'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
												);
											}
											var i,
												a = !0,
												s = !1;
											return {
												s: function () {
													n = n.call(e);
												},
												n: function () {
													var e = n.next();
													return (a = e.done), e;
												},
												e: function (e) {
													(s = !0), (i = e);
												},
												f: function () {
													try {
														a || null == n.return || n.return();
													} finally {
														if (s) throw i;
													}
												},
											};
										}
										function h(e, t) {
											(null == t || t > e.length) && (t = e.length);
											for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
											return r;
										}
										var m = function (e) {
												return !1 !== e.mutable;
											},
											v = function (e) {
												var t = {},
													n = [],
													r = {};
												if (!e.value)
													return (
														n.push(e),
														{ defaultParamsForAction: t, neededParamsForAction: n, immutableParamsForAction: r }
													);
												var o,
													i = p(e.value);
												try {
													for (i.s(); !(o = i.n()).done; ) {
														var a,
															s,
															l = o.value;
														m(l)
															? (n.push(l), null !== (a = l.value) && void 0 !== a && a && (t[l.name] = l.value))
															: (r[l.name] = null !== (s = l.value) && void 0 !== s ? s : '');
													}
												} catch (e) {
													i.e(e);
												} finally {
													i.f();
												}
												return { defaultParamsForAction: t, neededParamsForAction: n, immutableParamsForAction: r };
											},
											g = n(3983);
										function y(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function b(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? y(Object(n), !0).forEach(function (t) {
															(0, u.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: y(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var _ = function (e, t) {
												var n = t.actionDefinition,
													r = t.defaultParamsForAction,
													i = void 0 === r ? {} : r,
													a = t.immutableParamsForAction,
													l = void 0 === a ? {} : a,
													u = t.toPersist,
													c = void 0 === u ? {} : u,
													d = n.href;
												return (0, o.Z)(
													s().mark(function t() {
														var r,
															o,
															a,
															u,
															p,
															h,
															m,
															v,
															y,
															_,
															w,
															O = arguments;
														return s().wrap(
															function (t) {
																for (;;)
																	switch ((t.prev = t.next)) {
																		case 0:
																			return (
																				(r = O.length > 0 && void 0 !== O[0] ? O[0] : {}),
																				(o = {
																					'Content-Type': 'application/json',
																					'Accept': n.accepts || 'application/ion+json',
																				}),
																				(a = JSON.stringify(b(b(b({}, i), r), l))),
																				(t.prev = 3),
																				(h = {
																					url: d,
																					method: n.method,
																					headers: o,
																					args: a,
																					withCredentials:
																						null === (u = null == c ? void 0 : c.withCredentials) || void 0 === u || u,
																				}),
																				('poll' === n.name ||
																					(null === (p = n.name) || void 0 === p ? void 0 : p.endsWith('-poll'))) &&
																					(h.pollingIntent = !0),
																				(t.next = 9),
																				(0, f.c3)(e, h)
																			);
																		case 9:
																			return (m = t.sent), t.abrupt('return', e.idx.makeIdxResponse(b({}, m), c, !0));
																		case 13:
																			if (
																				((t.prev = 13),
																				(t.t0 = t.catch(3)),
																				t.t0 instanceof g.Z && null !== t.t0 && void 0 !== t.t0 && t.t0.xhr)
																			) {
																				t.next = 17;
																				break;
																			}
																			throw t.t0;
																		case 17:
																			return (
																				(v = t.t0.xhr),
																				(y = v.responseJSON || JSON.parse(v.responseText)),
																				(_ = v.headers['WWW-Authenticate'] || v.headers['www-authenticate']),
																				(w = e.idx.makeIdxResponse(b({}, y), c, !1)),
																				401 === v.status &&
																					'Oktadevicejwt realm="Okta Device"' === _ &&
																					(w.stepUp = !0),
																				t.abrupt('return', w)
																			);
																		case 23:
																		case 'end':
																			return t.stop();
																	}
															},
															t,
															null,
															[[3, 13]]
														);
													})
												);
											},
											w = function (e, t, n) {
												var r = _,
													o = (function (e) {
														var t,
															n = [],
															r = {},
															o = {},
															i = p((e = Array.isArray(e) ? e : [e]));
														try {
															for (i.s(); !(t = i.n()).done; ) {
																var a = t.value,
																	s = v(a),
																	l = s.defaultParamsForAction,
																	u = s.neededParamsForAction,
																	c = s.immutableParamsForAction;
																n.push(u), (r[a.name] = l), (o[a.name] = c);
															}
														} catch (e) {
															i.e(e);
														} finally {
															i.f();
														}
														return { defaultParams: r, neededParams: n, immutableParams: o };
													})(t),
													i = o.defaultParams,
													a = o.neededParams,
													s = o.immutableParams,
													l = r(e, {
														actionDefinition: t,
														defaultParamsForAction: i[t.name],
														immutableParamsForAction: s[t.name],
														toPersist: n,
													});
												return (l.neededParams = a), l;
											};
										function O(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function k(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? O(Object(n), !0).forEach(function (t) {
															(0, u.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: O(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var x = n(136),
											E = n(9611);
										function T() {
											T = function (e, t) {
												return new n(e, void 0, t);
											};
											var e = RegExp.prototype,
												t = new WeakMap();
											function n(e, r, o) {
												var i = new RegExp(e, r);
												return t.set(i, o || t.get(e)), (0, E.Z)(i, n.prototype);
											}
											function r(e, n) {
												var r = t.get(n);
												return Object.keys(r).reduce(function (t, n) {
													var o = r[n];
													if ('number' == typeof o) t[n] = e[o];
													else {
														for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length; ) i++;
														t[n] = e[o[i]];
													}
													return t;
												}, Object.create(null));
											}
											return (
												(0, x.Z)(n, RegExp),
												(n.prototype.exec = function (t) {
													var n = e.exec.call(this, t);
													return n && (n.groups = r(n, this)), n;
												}),
												(n.prototype[Symbol.replace] = function (n, o) {
													if ('string' == typeof o) {
														var i = t.get(this);
														return e[Symbol.replace].call(
															this,
															n,
															o.replace(/\$<([^>]+)>/g, function (e, t) {
																return '$' + i[t];
															})
														);
													}
													if ('function' == typeof o) {
														var a = this;
														return e[Symbol.replace].call(this, n, function () {
															var e = arguments;
															return (
																'object' != (0, d.Z)(e[e.length - 1]) && (e = [].slice.call(e)).push(r(e, a)),
																o.apply(this, e)
															);
														});
													}
													return e[Symbol.replace].call(this, n, o);
												}),
												T.apply(this, arguments)
											);
										}
										var S = T(/\$?(\w+)|(?:\[(\d+)\])/g, { step: 1, index: 2 }),
											A = n(9123),
											C = ['value', 'type'];
										function P(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function R(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? P(Object(n), !0).forEach(function (t) {
															(0, u.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: P(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var I = { remediation: !0, context: !0 },
											N = function e(t, n) {
												Object.keys(n).forEach(function (r) {
													if ('relatesTo' === r) {
														var o = Array.isArray(n[r]) ? n[r][0] : n[r];
														if ('string' == typeof o) {
															var i = (function (e) {
																for (var t, n = e.path, r = e.json, o = []; null !== (t = S.exec(n)); ) {
																	var i,
																		a,
																		s,
																		l,
																		u,
																		c =
																			null !==
																				(i =
																					null === (a = t) || void 0 === a || null === (s = a.groups) || void 0 === s
																						? void 0
																						: s.step) && void 0 !== i
																				? i
																				: null === (l = t) || void 0 === l || null === (u = l.groups) || void 0 === u
																				? void 0
																				: u.index;
																	c && o.push(c);
																}
																if (!(o.length < 1)) {
																	for (var f = o.pop(), p = r, h = 0, m = o; h < m.length; h++) {
																		var v = m[h];
																		if (Object.prototype.hasOwnProperty.call(p, v)) {
																			if ('object' !== (0, d.Z)(p[v])) return;
																			p = p[v];
																		}
																	}
																	return p[f];
																}
															})({ path: o, json: t });
															if (i) return void (n[r] = i);
															throw new A.Z('Cannot resolve relatesTo: '.concat(o));
														}
													}
													Array.isArray(n[r]) &&
														n[r].forEach(function (n) {
															return e(t, n);
														});
												});
											},
											M = function (e, t) {
												var n,
													r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
													o = (null === (n = t.remediation) || void 0 === n ? void 0 : n.value) || [];
												o.forEach(function (e) {
													var n;
													if (
														'launch-authenticator' !== e.name ||
														'authenticatorChallenge' !==
															(null == e || null === (n = e.relatesTo) || void 0 === n ? void 0 : n[0]) ||
														(null != t && t.authenticatorChallenge)
													)
														return N(t, e);
													delete e.relatesTo;
												});
												var i = o.map(function (t) {
														return (function (e, t, n) {
															if (t.rel) {
																var r = (function (e, t) {
																		var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
																		return t.reduce(function (t, r) {
																			return k(k({}, t), {}, (0, u.Z)({}, r.name, w(e, r, n)));
																		}, {});
																	})(e, [t], n),
																	o = r[t.name];
																return R(R({}, t), {}, { action: o });
															}
															return t;
														})(e, t, r);
													}),
													a = (function (e, t) {
														var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
															r = {},
															o = {};
														return (
															Object.keys(t)
																.filter(function (e) {
																	return !I[e];
																})
																.forEach(function (i) {
																	if ('object' === (0, d.Z)(t[i]) && t[i])
																		if (t[i].rel) r[t[i].name] = w(e, t[i], n);
																		else {
																			var a = t[i],
																				s = a.value,
																				u = a.type,
																				f = (0, c.Z)(a, C);
																			(o[i] = R({ type: u }, f)),
																				'object' === u
																					? ((o[i].value = {}),
																					  Object.entries(s).forEach(function (t) {
																							var a = (0, l.Z)(t, 2),
																								s = a[0],
																								u = a[1];
																							u.rel
																								? (r[''.concat(i, '-').concat(s.name || s)] = w(e, u, n))
																								: (o[i].value[s] = u);
																					  }))
																					: (o[i].value = s);
																		}
																	else o[i] = t[i];
																}),
															{ context: o, actions: r }
														);
													})(e, t, r);
												return { remediations: i, context: a.context, actions: a.actions };
											},
											j = {
												makeIdxState: function (e, t, n, r) {
													var a,
														l,
														u,
														c,
														d = t,
														f = M(e, t, n),
														p = f.remediations,
														h = f.context,
														m = f.actions,
														v = (0, i.Z)(p),
														g =
															((c = (0, o.Z)(
																s().mark(function e(t) {
																	var n,
																		r,
																		o = arguments;
																	return s().wrap(function (e) {
																		for (;;)
																			switch ((e.prev = e.next)) {
																				case 0:
																					if (
																						((n = o.length > 1 && void 0 !== o[1] ? o[1] : {}),
																						(r = p.find(function (e) {
																							return e.name === t;
																						})))
																					) {
																						e.next = 4;
																						break;
																					}
																					return e.abrupt(
																						'return',
																						Promise.reject('Unknown remediation choice: ['.concat(t, ']'))
																					);
																				case 4:
																					if ('function' == typeof r.action) {
																						e.next = 7;
																						break;
																					}
																					return e.abrupt(
																						'return',
																						Promise.reject(
																							'Current remediation cannot make form submit action: ['.concat(t, ']')
																						)
																					);
																				case 7:
																					return e.abrupt('return', r.action(n));
																				case 8:
																				case 'end':
																					return e.stop();
																			}
																	}, e);
																})
															)),
															function (e) {
																return c.apply(this, arguments);
															});
													return {
														proceed: g,
														neededToProceed: v,
														actions: m,
														context: h,
														rawIdxState: d,
														interactionCode:
															null === (a = d.successWithInteractionCode) ||
															void 0 === a ||
															null === (l = a.value) ||
															void 0 === l ||
															null ===
																(u = l.find(function (e) {
																	return 'interaction_code' === e.name;
																})) ||
															void 0 === u
																? void 0
																: u.value,
														toPersist: n,
														requestDidSucceed: r,
													};
												},
											},
											D = function (e) {
												switch (e) {
													case '1.0.0':
														return j;
													case void 0:
													case null:
														throw new Error('Api version is required');
													default:
														throw new Error('Unknown api version: '.concat(e, '.  Use an exact semver version.'));
												}
											};
										function L(e) {
											if (!e) throw new Error('version is required');
											if ((null != e ? e : '').replace(/[^0-9a-zA-Z._-]/, '') !== e || !e)
												throw new Error('invalid version supplied - version is required and uses semver syntax');
											D(e);
										}
										function U(e, t, n, o) {
											var i,
												a = null !== (i = null == t ? void 0 : t.version) && void 0 !== i ? i : r.IDX_API_VERSION;
											return L(a), (0, D(a).makeIdxState)(e, t, n, o);
										}
									},
									9999: function (e, t, n) {
										'use strict';
										n.d(t, {
											pc: function () {
												return Z.pc;
											},
											Fw: function () {
												return Z.Fw;
											},
											Qd: function () {
												return Z.Qd;
											},
											YR: function () {
												return r.Y;
											},
											Ch: function () {
												return u.C;
											},
											al: function () {
												return o.a;
											},
											Jm: function () {
												return m.Jm;
											},
											F4: function () {
												return v.F;
											},
											SL: function () {
												return B.S;
											},
											aT: function () {
												return V.a;
											},
											vK: function () {
												return H.v;
											},
											UB: function () {
												return U;
											},
											Yn: function () {
												return g.Y;
											},
											Xc: function () {
												return m.Xc;
											},
											uN: function () {
												return m.uN;
											},
											Co: function () {
												return m.Co;
											},
											Jn: function () {
												return i.Jn;
											},
											Xx: function () {
												return f.X;
											},
											$0: function () {
												return m.$0;
											},
											EW: function () {
												return a.E;
											},
											L8: function () {
												return s.L;
											},
											H: function () {
												return Z.H;
											},
											GA: function () {
												return i.GA;
											},
											gc: function () {
												return i.gc;
											},
											Wf: function () {
												return m.Wf;
											},
											bl: function () {
												return m.bl;
											},
											UC: function () {
												return m.UC;
											},
											B_: function () {
												return F.B;
											},
											mo: function () {
												return i.mo;
											},
											$l: function () {
												return l.$;
											},
											xc: function () {
												return u.x;
											},
											M4: function () {
												return d.M;
											},
											z2: function () {
												return c.z;
											},
											r0: function () {
												return m.r0;
											},
											Yr: function () {
												return p.Y;
											},
											le: function () {
												return h.l;
											},
										});
										var r = n(1286),
											o = n(9192),
											i = n(7985),
											a = n(6131),
											s = n(2660),
											l = n(9310),
											u = n(2845),
											c = n(8826),
											d = n(9214),
											f = n(5021),
											p = n(2473),
											h = n(8277),
											m = n(2620),
											v = n(8717),
											g = n(2144),
											y = n(3144),
											b = n(5671),
											_ = n(7326),
											w = n(136),
											O = n(2963),
											k = n(1120),
											x = n(4942),
											E = n(5923),
											T = n(8719),
											S = n(8716);
										function A(e) {
											var t;
											return (
												(t = (function (e) {
													(0, w.Z)(o, e);
													var t,
														n,
														r =
															((t = o),
															(n = (function () {
																if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
																if (Reflect.construct.sham) return !1;
																if ('function' == typeof Proxy) return !0;
																try {
																	return (
																		Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																	);
																} catch (e) {
																	return !1;
																}
															})()),
															function () {
																var e,
																	r = (0, k.Z)(t);
																if (n) {
																	var o = (0, k.Z)(this).constructor;
																	e = Reflect.construct(r, arguments, o);
																} else e = r.apply(this, arguments);
																return (0, O.Z)(this, e);
															});
													function o() {
														var e, t, n;
														(0, b.Z)(this, o);
														for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++) a[s] = arguments[s];
														return (
															(e = r.call.apply(r, [this].concat(a))),
															(0, x.Z)((0, _.Z)(e), 'idx', void 0),
															(0, x.Z)((0, _.Z)(e), 'fingerprint', void 0),
															(e.idx =
																((t = (0, _.Z)(e)),
																(n = p.Y.bind(null, t)),
																{
																	makeIdxResponse: E._T.bind(null, t),
																	start: n,
																	startTransaction: n,
																	proceed: u.x.bind(null, t),
																	canProceed: u.C.bind(null, t),
																	getSavedTransactionMeta: m.uN.bind(null, t),
																	createTransactionMeta: m.Xc.bind(null, t),
																	getTransactionMeta: m.Co.bind(null, t),
																	saveTransactionMeta: m.r0.bind(null, t),
																	clearTransactionMeta: m.Jm.bind(null, t),
																	isTransactionMetaValid: m.Wf,
																})),
															(e.fingerprint = T.Z.bind(null, (0, _.Z)(e))),
															e
														);
													}
													return (0, y.Z)(o);
												})(e)),
												(0, x.Z)(t, 'webauthn', S),
												t
											);
										}
										var C = n(9893),
											P = n(265),
											R = n(279),
											I = n(3980),
											N = n(1237),
											M = n(8707),
											j = n(6898),
											D = n(8221);
										function L(e, t) {
											return (function (e) {
												(0, w.Z)(i, e);
												var n,
													r,
													o =
														((n = i),
														(r = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																t = (0, k.Z)(n);
															if (r) {
																var o = (0, k.Z)(this).constructor;
																e = Reflect.construct(t, arguments, o);
															} else e = t.apply(this, arguments);
															return (0, O.Z)(this, e);
														});
												function i() {
													var e, n;
													(0, b.Z)(this, i);
													for (var r = arguments.length, a = new Array(r), s = 0; s < r; s++) a[s] = arguments[s];
													return (
														(e = o.call.apply(o, [this].concat(a))),
														(0, x.Z)((0, _.Z)(e), 'token', void 0),
														(0, x.Z)((0, _.Z)(e), 'transactionManager', void 0),
														(e.transactionManager = new t(
															Object.assign({ storageManager: e.storageManager }, e.options.transactionManager)
														)),
														(e.token =
															((n = (0, _.Z)(e)),
															{
																prepareTokenParams: j.wu.bind(null, n),
																exchangeCodeForTokens: M.r.bind(null, n),
																decode: N.T,
															})),
														e
													);
												}
												return (
													(0, y.Z)(i, [
														{
															key: 'isLoginRedirect',
															value: function () {
																return (0, D.gM)(this);
															},
														},
														{
															key: 'isPKCE',
															value: function () {
																return !!this.options.pkce;
															},
														},
														{
															key: 'hasResponseType',
															value: function (e) {
																return (0, D.wV)(e, this.options);
															},
														},
														{
															key: 'isAuthorizationCodeFlow',
															value: function () {
																return this.hasResponseType('code');
															},
														},
													]),
													i
												);
											})(e);
										}
										function U(e, t, n) {
											var r = (0, C.a)(t),
												o = (0, P.H)(r, e),
												i = (0, R.A)(o);
											return A(L((0, I.Z)(i), n));
										}
										var F = n(8137),
											B = n(4602),
											V = n(4143),
											Z = n(7595),
											H = n(3334);
									},
									6131: function (e, t, n) {
										'use strict';
										n.d(t, {
											E: function () {
												return h;
											},
										});
										var r = n(4942),
											o = n(5861),
											i = n(4687),
											a = n.n(i),
											s = n(2620),
											l = n(7599),
											u = n(3193),
											c = n(5385);
										function d(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function f(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? d(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: d(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function p(e) {
											return { meta: e, interactionHandle: e.interactionHandle, state: e.state };
										}
										function h(e) {
											return m.apply(this, arguments);
										}
										function m() {
											return (
												(m = (0, o.Z)(
													a().mark(function e(t) {
														var n,
															r,
															o,
															i,
															d,
															h,
															m,
															v,
															g,
															y,
															b,
															_,
															w,
															O,
															k,
															x,
															E,
															T,
															S,
															A,
															C,
															P,
															R,
															I,
															N,
															M = arguments;
														return a().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		if (
																			((o = M.length > 1 && void 0 !== M[1] ? M[1] : {}),
																			(o = (0, u.YY)(o)),
																			(i = (0, s.uN)(t, o)),
																			null === (n = i) || void 0 === n || !n.interactionHandle)
																		) {
																			e.next = 5;
																			break;
																		}
																		return e.abrupt('return', p(i));
																	case 5:
																		return (e.next = 7), (0, s.Xc)(t, f(f({}, i), o));
																	case 7:
																		return (
																			(i = e.sent),
																			(d = (0, l.zf)(t)),
																			(m = (h = i).clientId),
																			(v = h.redirectUri),
																			(g = h.state),
																			(y = h.scopes),
																			(b = h.withCredentials),
																			(_ = h.codeChallenge),
																			(w = h.codeChallengeMethod),
																			(O = h.activationToken),
																			(k = h.recoveryToken),
																			(x = h.maxAge),
																			(E = h.acrValues),
																			(T = h.nonce),
																			(S = o.clientSecret || t.options.clientSecret),
																			(b = null === (r = b) || void 0 === r || r),
																			(A = ''.concat(d, '/v1/interact')),
																			(C = f(
																				f(
																					f(
																						f(
																							f(
																								f(
																									{
																										client_id: m,
																										scope: y.join(' '),
																										redirect_uri: v,
																										code_challenge: _,
																										code_challenge_method: w,
																										state: g,
																									},
																									O && { activation_token: O }
																								),
																								k && { recovery_token: k }
																							),
																							S && { client_secret: S }
																						),
																						x && { max_age: x }
																					),
																					E && { acr_values: E }
																				),
																				T && { nonce: T }
																			)),
																			(P = { 'Content-Type': 'application/x-www-form-urlencoded' }),
																			(e.next = 17),
																			(0, c.c3)(t, { method: 'POST', url: A, headers: P, withCredentials: b, args: C })
																		);
																	case 17:
																		return (
																			(R = e.sent),
																			(I = R.interaction_handle),
																			(N = f(
																				f({}, i),
																				{},
																				{
																					interactionHandle: I,
																					withCredentials: b,
																					state: g,
																					scopes: y,
																					recoveryToken: k,
																					activationToken: O,
																				}
																			)),
																			(0, s.r0)(t, N),
																			e.abrupt('return', p(N))
																		);
																	case 22:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												m.apply(this, arguments)
											);
										}
									},
									2660: function (e, t, n) {
										'use strict';
										n.d(t, {
											L: function () {
												return f;
											},
										});
										var r = n(5861),
											o = n(4687),
											i = n.n(o),
											a = n(5923),
											s = n(480),
											l = n(7599),
											u = n(1971),
											c = n(5385),
											d = n(5728);
										function f(e) {
											return p.apply(this, arguments);
										}
										function p() {
											return (
												(p = (0, r.Z)(
													i().mark(function e(t) {
														var n,
															r,
															o,
															f,
															p,
															h,
															m,
															v,
															g,
															y,
															b,
															_,
															w,
															O,
															k = arguments;
														return i().wrap(
															function (e) {
																for (;;)
																	switch ((e.prev = e.next)) {
																		case 0:
																			if (
																				((n = k.length > 1 && void 0 !== k[1] ? k[1] : {}),
																				(f = t.transactionManager.loadIdxResponse(n)) &&
																					((r = f.rawIdxResponse), (o = f.requestDidSucceed)),
																				r)
																			) {
																				e.next = 27;
																				break;
																			}
																			return (
																				(h = n.version || u.IDX_API_VERSION),
																				(m = (0, l.Xp)(t)),
																				(v = n.interactionHandle),
																				(g = n.stateHandle),
																				(y = null === (p = n.withCredentials) || void 0 === p || p),
																				(e.prev = 8),
																				(o = !0),
																				(0, a.A0)(h),
																				(b = ''.concat(m, '/idp/idx/introspect')),
																				(_ = g ? { stateToken: g } : { interactionHandle: v }),
																				(w = {
																					'Content-Type': 'application/ion+json; okta-version='.concat(h),
																					'Accept': 'application/ion+json; okta-version='.concat(h),
																				}),
																				(e.next = 16),
																				(0, c.c3)(t, {
																					method: 'POST',
																					url: b,
																					headers: w,
																					withCredentials: y,
																					args: _,
																				})
																			);
																		case 16:
																			(r = e.sent), (e.next = 27);
																			break;
																		case 19:
																			if (
																				((e.prev = 19),
																				(e.t0 = e.catch(8)),
																				!((0, d.isAuthApiError)(e.t0) && e.t0.xhr && (0, s.P)(e.t0.xhr.responseJSON)))
																			) {
																				e.next = 26;
																				break;
																			}
																			(r = e.t0.xhr.responseJSON), (o = !1), (e.next = 27);
																			break;
																		case 26:
																			throw e.t0;
																		case 27:
																			return (
																				(O = n.withCredentials),
																				e.abrupt('return', (0, a._T)(t, r, { withCredentials: O }, o))
																			);
																		case 29:
																		case 'end':
																			return e.stop();
																	}
															},
															e,
															null,
															[[8, 19]]
														);
													})
												)),
												p.apply(this, arguments)
											);
										}
									},
									8137: function (e, t, n) {
										'use strict';
										n.d(t, {
											B: function () {
												return p;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(7326),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942),
											c = n(8717),
											d = n(8719),
											f = n(8716);
										function p(e) {
											var t;
											return (
												(t = (function (e) {
													(0, a.Z)(p, e);
													var t,
														n,
														f =
															((t = p),
															(n = (function () {
																if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
																if (Reflect.construct.sham) return !1;
																if ('function' == typeof Proxy) return !0;
																try {
																	return (
																		Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																	);
																} catch (e) {
																	return !1;
																}
															})()),
															function () {
																var e,
																	r = (0, l.Z)(t);
																if (n) {
																	var o = (0, l.Z)(this).constructor;
																	e = Reflect.construct(r, arguments, o);
																} else e = r.apply(this, arguments);
																return (0, s.Z)(this, e);
															});
													function p() {
														var e;
														(0, o.Z)(this, p);
														for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
														return (
															(e = f.call.apply(f, [this].concat(n))),
															(0, u.Z)((0, i.Z)(e), 'idx', void 0),
															(0, u.Z)((0, i.Z)(e), 'fingerprint', void 0),
															(e.idx = (0, c.F)((0, i.Z)(e))),
															(e.fingerprint = d.Z.bind(null, (0, i.Z)(e))),
															e
														);
													}
													return (0, r.Z)(p);
												})(e)),
												(0, u.Z)(t, 'webauthn', f),
												t
											);
										}
									},
									4602: function (e, t, n) {
										'use strict';
										n.d(t, {
											S: function () {
												return d;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(7326),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942),
											c = n(9133);
										function d() {
											return (function (e) {
												(0, a.Z)(d, e);
												var t,
													n,
													c =
														((t = d),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, l.Z)(t);
															if (n) {
																var o = (0, l.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, s.Z)(this, e);
														});
												function d(e) {
													var t;
													return (
														(0, o.Z)(this, d),
														(t = c.call(this, e)),
														(0, u.Z)((0, i.Z)(t), 'flow', void 0),
														(0, u.Z)((0, i.Z)(t), 'activationToken', void 0),
														(0, u.Z)((0, i.Z)(t), 'recoveryToken', void 0),
														(0, u.Z)((0, i.Z)(t), 'idx', void 0),
														(t.flow = e.flow),
														(t.activationToken = e.activationToken),
														(t.recoveryToken = e.recoveryToken),
														(t.idx = e.idx),
														t
													);
												}
												return (0, r.Z)(d);
											})((0, c.n)());
										}
									},
									9310: function (e, t, n) {
										'use strict';
										n.d(t, {
											$: function () {
												return u;
											},
										});
										var r = n(5861),
											o = n(4687),
											i = n.n(o),
											a = n(2845),
											s = n(2620),
											l = n(146);
										function u(e) {
											return c.apply(this, arguments);
										}
										function c() {
											return (
												(c = (0, r.Z)(
													i().mark(function e(t) {
														var n,
															o,
															c,
															d,
															f,
															p = arguments;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(o = p.length > 1 && void 0 !== p[1] ? p[1] : {}),
																			(e.next = 3),
																			(0, a.x)(t, { startPolling: !0 })
																		);
																	case 3:
																		if (
																			((c = e.sent),
																			(d = (0, s.uN)(t)),
																			(null !=
																				(f =
																					null == d || null === (n = d.remediations) || void 0 === n
																						? void 0
																						: n.find(function (e) {
																								return e.includes('poll');
																						  })) &&
																				f.length) ||
																				(0, l.ZK)('No polling remediations available at the current IDX flow stage'),
																			!Number.isInteger(o.refresh))
																		) {
																			e.next = 9;
																			break;
																		}
																		return e.abrupt(
																			'return',
																			new Promise(function (e, n) {
																				setTimeout(
																					(0, r.Z)(
																						i().mark(function r() {
																							var o, a, s;
																							return i().wrap(function (r) {
																								for (;;)
																									switch ((r.prev = r.next)) {
																										case 0:
																											try {
																												(s =
																													null === (o = c.nextStep) ||
																													void 0 === o ||
																													null === (a = o.poll) ||
																													void 0 === a
																														? void 0
																														: a.refresh),
																													e(s ? u(t, { refresh: s }) : c);
																											} catch (e) {
																												n(e);
																											}
																										case 1:
																										case 'end':
																											return r.stop();
																									}
																							}, r);
																						})
																					),
																					o.refresh
																				);
																			})
																		);
																	case 9:
																		return e.abrupt('return', c);
																	case 10:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												c.apply(this, arguments)
											);
										}
									},
									2845: function (e, t, n) {
										'use strict';
										n.d(t, {
											C: function () {
												return f;
											},
											x: function () {
												return p;
											},
										});
										var r = n(4942),
											o = n(5861),
											i = n(4687),
											a = n.n(i),
											s = n(3377),
											l = n(2620),
											u = n(9123);
										function c(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function d(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? c(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: c(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function f(e) {
											var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
											return !(!(0, l.uN)(e, t) && !t.stateHandle);
										}
										function p(e) {
											return h.apply(this, arguments);
										}
										function h() {
											return (
												(h = (0, o.Z)(
													a().mark(function e(t) {
														var n,
															r,
															o,
															i,
															c = arguments;
														return a().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		if (f(t, (n = c.length > 1 && void 0 !== c[1] ? c[1] : {}))) {
																			e.next = 3;
																			break;
																		}
																		throw new u.Z('Unable to proceed: saved transaction could not be loaded');
																	case 3:
																		return (
																			(r = n.flow),
																			(o = n.state),
																			r || ((i = (0, l.uN)(t, { state: o })), (r = null == i ? void 0 : i.flow)),
																			e.abrupt('return', (0, s.K)(t, d(d({}, n), {}, { flow: r })))
																		);
																	case 6:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												h.apply(this, arguments)
											);
										}
									},
									9214: function (e, t, n) {
										'use strict';
										n.d(t, {
											M: function () {
												return d;
											},
										});
										var r = n(4942),
											o = n(5861),
											i = n(4687),
											a = n.n(i),
											s = n(3377),
											l = n(7738);
										function u(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function c(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? u(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: u(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function d(e) {
											return f.apply(this, arguments);
										}
										function f() {
											return (
												(f = (0, o.Z)(
													a().mark(function e(t) {
														var n,
															r,
															o = arguments;
														return a().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(n = o.length > 1 && void 0 !== o[1] ? o[1] : {}),
																			(r = (0, l.s)(t, 'recoverPassword')),
																			e.abrupt('return', (0, s.K)(t, c(c({}, n), r)))
																		);
																	case 3:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												f.apply(this, arguments)
											);
										}
									},
									8826: function (e, t, n) {
										'use strict';
										n.d(t, {
											z: function () {
												return h;
											},
										});
										var r = n(4942),
											o = n(5861),
											i = n(4687),
											a = n.n(i),
											s = n(3377),
											l = n(2620),
											u = n(2473),
											c = n(9123),
											d = n(7595);
										function f(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function p(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? f(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: f(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function h(e) {
											return m.apply(this, arguments);
										}
										function m() {
											return (
												(m = (0, o.Z)(
													a().mark(function e(t) {
														var n,
															r,
															o,
															i = arguments;
														return a().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		if (((n = i.length > 1 && void 0 !== i[1] ? i[1] : {}), (0, l.$0)(t))) {
																			e.next = 8;
																			break;
																		}
																		return (
																			(e.next = 4),
																			(0, u.Y)(t, p(p({}, n), {}, { flow: 'register', autoRemediate: !1 }))
																		);
																	case 4:
																		if (
																			((r = e.sent),
																			(o = r.enabledFeatures),
																			n.activationToken || !o || o.includes(d.Fw.REGISTRATION))
																		) {
																			e.next = 8;
																			break;
																		}
																		throw new c.Z(
																			'Registration is not supported based on your current org configuration.'
																		);
																	case 8:
																		return e.abrupt('return', (0, s.K)(t, p(p({}, n), {}, { flow: 'register' })));
																	case 9:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												m.apply(this, arguments)
											);
										}
									},
									2541: function (e, t, n) {
										'use strict';
										n.d(t, {
											q: function () {
												return h;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(1752),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942),
											c = n(4794),
											d = n(6064);
										function f(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function p(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? f(Object(n), !0).forEach(function (t) {
															(0, u.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: f(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var h = (function (e) {
											(0, a.Z)(c, e);
											var t,
												n,
												u =
													((t = c),
													(n = (function () {
														if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
														if (Reflect.construct.sham) return !1;
														if ('function' == typeof Proxy) return !0;
														try {
															return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
														} catch (e) {
															return !1;
														}
													})()),
													function () {
														var e,
															r = (0, l.Z)(t);
														if (n) {
															var o = (0, l.Z)(this).constructor;
															e = Reflect.construct(r, arguments, o);
														} else e = r.apply(this, arguments);
														return (0, s.Z)(this, e);
													});
											function c() {
												return (0, r.Z)(this, c), u.apply(this, arguments);
											}
											return (
												(0, o.Z)(c, [
													{
														key: 'mapAuthenticator',
														value: function () {
															var e = this.getAuthenticatorData();
															return {
																id: (0, d.zg)(this.remediation).form.value.find(function (e) {
																	return 'id' === e.name;
																}).value,
																methodType: e.methodType,
																phoneNumber: e.phoneNumber,
															};
														},
													},
													{
														key: 'getInputAuthenticator',
														value: function (e) {
															return [
																{ name: 'methodType', type: 'string' },
																{ name: 'phoneNumber', label: 'Phone Number', type: 'string' },
															].map(function (t) {
																return p(
																	p(
																		{},
																		e.form.value.find(function (e) {
																			return e.name === t.name;
																		})
																	),
																	t
																);
															});
														},
													},
													{
														key: 'mapAuthenticatorDataFromValues',
														value: function (e) {
															e = (0, i.Z)((0, l.Z)(c.prototype), 'mapAuthenticatorDataFromValues', this).call(this, e);
															var t = this.values.phoneNumber;
															if (e || t) return p(p({}, e && e), t && { phoneNumber: t });
														},
													},
												]),
												c
											);
										})(c.a);
										(0, u.Z)(h, 'remediationName', 'authenticator-enrollment-data');
									},
									5278: function (e, t, n) {
										'use strict';
										n.d(t, {
											q: function () {
												return p;
											},
										});
										var r = n(2982),
											o = n(5671),
											i = n(3144),
											a = n(1752),
											s = n(136),
											l = n(2963),
											u = n(1120),
											c = n(4942);
										function d(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function f(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? d(Object(n), !0).forEach(function (t) {
															(0, c.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: d(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var p = (function (e) {
											(0, s.Z)(p, e);
											var t,
												n,
												d =
													((t = p),
													(n = (function () {
														if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
														if (Reflect.construct.sham) return !1;
														if ('function' == typeof Proxy) return !0;
														try {
															return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
														} catch (e) {
															return !1;
														}
													})()),
													function () {
														var e,
															r = (0, u.Z)(t);
														if (n) {
															var o = (0, u.Z)(this).constructor;
															e = Reflect.construct(r, arguments, o);
														} else e = r.apply(this, arguments);
														return (0, l.Z)(this, e);
													});
											function p() {
												return (0, o.Z)(this, p), d.apply(this, arguments);
											}
											return (
												(0, i.Z)(p, [
													{
														key: 'mapAuthenticator',
														value: function () {
															return this.getAuthenticatorData();
														},
													},
													{
														key: 'getInputAuthenticator',
														value: function () {
															var e = this.getAuthenticatorFromRemediation(),
																t = e.form.value.find(function (e) {
																	return 'methodType' === e.name;
																});
															return t && t.options
																? { name: 'methodType', type: 'string', required: !0, options: t.options }
																: (0, r.Z)(e.form.value);
														},
													},
													{
														key: 'getValuesAfterProceed',
														value: function () {
															var e = this;
															return (
																(this.values = (0, a.Z)((0, u.Z)(p.prototype), 'getValuesAfterProceed', this).call(
																	this
																)),
																Object.keys(this.values)
																	.filter(function (e) {
																		return 'authenticator' !== e;
																	})
																	.reduce(function (t, n) {
																		return f(f({}, t), {}, (0, c.Z)({}, n, e.values[n]));
																	}, {})
															);
														},
													},
												]),
												p
											);
										})(n(4794).a);
										(0, c.Z)(p, 'remediationName', 'authenticator-verification-data');
									},
									4794: function (e, t, n) {
										'use strict';
										n.d(t, {
											a: function () {
												return v;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(7326),
											a = n(1752),
											s = n(136),
											l = n(2963),
											u = n(1120),
											c = n(4942),
											d = n(3118),
											f = n(7595),
											p = n(9344);
										function h(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function m(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? h(Object(n), !0).forEach(function (t) {
															(0, c.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: h(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var v = (function (e) {
											(0, s.Z)(h, e);
											var t,
												n,
												d =
													((t = h),
													(n = (function () {
														if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
														if (Reflect.construct.sham) return !1;
														if ('function' == typeof Proxy) return !0;
														try {
															return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
														} catch (e) {
															return !1;
														}
													})()),
													function () {
														var e,
															r = (0, u.Z)(t);
														if (n) {
															var o = (0, u.Z)(this).constructor;
															e = Reflect.construct(r, arguments, o);
														} else e = r.apply(this, arguments);
														return (0, l.Z)(this, e);
													});
											function h(e) {
												var t,
													n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
												return (
													(0, r.Z)(this, h),
													(t = d.call(this, e, n)),
													(0, c.Z)((0, i.Z)(t), 'authenticator', void 0),
													(t.authenticator = t.getAuthenticator()),
													t.formatAuthenticatorData(),
													t
												);
											}
											return (
												(0, o.Z)(h, [
													{
														key: 'formatAuthenticatorData',
														value: function () {
															var e = this;
															if (this.getAuthenticatorData())
																this.values.authenticatorsData = this.values.authenticatorsData.map(function (t) {
																	return (0, p.PN)(e.authenticator, t) ? e.mapAuthenticatorDataFromValues(t) : t;
																});
															else {
																var t = this.mapAuthenticatorDataFromValues();
																t && this.values.authenticatorsData.push(t);
															}
														},
													},
													{
														key: 'getAuthenticatorData',
														value: function () {
															var e = this;
															return this.values.authenticatorsData.find(function (t) {
																return (0, p.PN)(e.authenticator, t);
															});
														},
													},
													{
														key: 'canRemediate',
														value: function () {
															var e = this;
															return this.values.authenticatorsData.some(function (t) {
																return (0, p.PN)(e.authenticator, t);
															});
														},
													},
													{
														key: 'mapAuthenticatorDataFromValues',
														value: function (e) {
															var t = this.values,
																n = t.methodType,
																r = t.authenticator;
															!n && (0, f.H)(r) && (n = null == r ? void 0 : r.methodType);
															var o = this.authenticator,
																i = m(m({ id: o.id, enrollmentId: o.enrollmentId }, e && e), n && { methodType: n });
															return i.methodType ? i : null;
														},
													},
													{
														key: 'getAuthenticatorFromRemediation',
														value: function () {
															return this.remediation.value.find(function (e) {
																return 'authenticator' === e.name;
															});
														},
													},
													{
														key: 'getValuesAfterProceed',
														value: function () {
															var e = this;
															this.values = (0, a.Z)((0, u.Z)(h.prototype), 'getValuesAfterProceed', this).call(this);
															var t = this.values.authenticatorsData.filter(function (t) {
																return !0 !== (0, p.PN)(e.authenticator, t);
															});
															return m(m({}, this.values), {}, { authenticatorsData: t });
														},
													},
												]),
												h
											);
										})(d.n);
									},
									3118: function (e, t, n) {
										'use strict';
										n.d(t, {
											n: function () {
												return p;
											},
										});
										var r = n(2982),
											o = n(1002),
											i = n(5671),
											a = n(3144),
											s = n(4942),
											l = n(6064),
											u = n(9344);
										function c(e, t) {
											(null == t || t > e.length) && (t = e.length);
											for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
											return r;
										}
										function d(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function f(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? d(Object(n), !0).forEach(function (t) {
															(0, s.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: d(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var p = (function () {
											function e(t) {
												var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
													r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
												(0, i.Z)(this, e),
													(0, s.Z)(this, 'remediation', void 0),
													(0, s.Z)(this, 'values', void 0),
													(0, s.Z)(this, 'options', void 0),
													(0, s.Z)(this, 'map', void 0),
													(this.values = f({}, n)),
													(this.options = f({}, r)),
													this.formatAuthenticators(),
													(this.remediation = t);
											}
											return (
												(0, a.Z)(
													e,
													[
														{
															key: 'formatAuthenticators',
															value: function () {
																if (
																	((this.values.authenticators = this.values.authenticators || []),
																	(this.values.authenticators = this.values.authenticators.map(function (e) {
																		return (0, u.LL)(e);
																	})),
																	this.values.authenticator)
																) {
																	var e = (0, u.LL)(this.values.authenticator);
																	this.values.authenticators.some(function (t) {
																		return (0, u.PN)(e, t);
																	}) || this.values.authenticators.push(e);
																}
																this.values.authenticatorsData = this.values.authenticators.reduce(function (e, t) {
																	return 'object' === (0, o.Z)(t) && Object.keys(t).length > 1 && e.push(t), e;
																}, this.values.authenticatorsData || []);
															},
														},
														{
															key: 'getName',
															value: function () {
																return this.remediation.name;
															},
														},
														{
															key: 'canRemediate',
															value: function (e) {
																var t = this;
																return !(0, l.QG)(this.remediation).find(function (e) {
																	return !t.hasData(e);
																});
															},
														},
														{
															key: 'getData',
															value: function (e) {
																var t = this;
																if (!e) {
																	var n = (0, l.ix)(this.remediation).reduce(function (e, n) {
																		return (e[n] = t.getData(n)), e;
																	}, {});
																	return n;
																}
																if ('function' == typeof this['map'.concat((0, l.Qs)(e))]) {
																	var r = this['map'.concat((0, l.Qs)(e))](
																		this.remediation.value.find(function (t) {
																			return t.name === e;
																		})
																	);
																	if (r) return r;
																}
																if (this.map && this.map[e])
																	for (var o = this.map[e], i = 0; i < o.length; i++) {
																		var a = this.values[o[i]];
																		if (a) return a;
																	}
																return this.values[e];
															},
														},
														{
															key: 'hasData',
															value: function (e) {
																return !!this.getData(e);
															},
														},
														{
															key: 'getNextStep',
															value: function (e, t) {
																var n = this.getName(),
																	r = this.getInputs(),
																	o = this.getAuthenticator(),
																	i = null == o ? void 0 : o.type;
																return f(f({ name: n, inputs: r }, i && { type: i }), o && { authenticator: o });
															},
														},
														{
															key: 'getInputs',
															value: function () {
																var e = this,
																	t = [];
																return (
																	(this.remediation.value || []).forEach(function (n) {
																		var r,
																			o = n.name,
																			i = n.type,
																			a = n.visible,
																			s = n.messages;
																		if (!1 !== a) {
																			if ('function' == typeof e['getInput'.concat((0, l.Qs)(o))])
																				r = e['getInput'.concat((0, l.Qs)(o))](n);
																			else if ('object' !== i) {
																				var u,
																					c = (e.map ? e.map[o] : null) || [];
																				(u =
																					1 === c.length
																						? c[0]
																						: c.find(function (t) {
																								return Object.keys(e.values).includes(t);
																						  })),
																					u && (r = f(f({}, n), {}, { name: u }));
																			}
																			r || (r = n),
																				Array.isArray(r)
																					? r.forEach(function (e) {
																							return t.push(e);
																					  })
																					: (s && (r.messages = s), t.push(r));
																		}
																	}),
																	t
																);
															},
														},
														{
															key: 'getValuesAfterProceed',
															value: function () {
																var e,
																	t = this.remediation.value || [],
																	n = this.getInputs(),
																	o = (function (e, t) {
																		var n = ('undefined' != typeof Symbol && e[Symbol.iterator]) || e['@@iterator'];
																		if (!n) {
																			if (
																				Array.isArray(e) ||
																				(n = (function (e, t) {
																					if (e) {
																						if ('string' == typeof e) return c(e, t);
																						var n = Object.prototype.toString.call(e).slice(8, -1);
																						return (
																							'Object' === n && e.constructor && (n = e.constructor.name),
																							'Map' === n || 'Set' === n
																								? Array.from(e)
																								: 'Arguments' === n ||
																								  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
																								? c(e, t)
																								: void 0
																						);
																					}
																				})(e)) ||
																				(t && e && 'number' == typeof e.length)
																			) {
																				n && (e = n);
																				var r = 0,
																					o = function () {};
																				return {
																					s: o,
																					n: function () {
																						return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
																					},
																					e: function (e) {
																						throw e;
																					},
																					f: o,
																				};
																			}
																			throw new TypeError(
																				'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
																			);
																		}
																		var i,
																			a = !0,
																			s = !1;
																		return {
																			s: function () {
																				n = n.call(e);
																			},
																			n: function () {
																				var e = n.next();
																				return (a = e.done), e;
																			},
																			e: function (e) {
																				(s = !0), (i = e);
																			},
																			f: function () {
																				try {
																					a || null == n.return || n.return();
																				} finally {
																					if (s) throw i;
																				}
																			},
																		};
																	})([].concat((0, r.Z)(t), (0, r.Z)(n)));
																try {
																	for (o.s(); !(e = o.n()).done; ) {
																		var i = e.value;
																		delete this.values[i.name];
																	}
																} catch (e) {
																	o.e(e);
																} finally {
																	o.f();
																}
																return this.values;
															},
														},
														{
															key: 'getAuthenticator',
															value: function () {
																var e,
																	t,
																	n = null === (e = this.remediation.relatesTo) || void 0 === e ? void 0 : e.value;
																if (n) {
																	var r = (0, l.zg)(this.remediation);
																	if (!r) return n;
																	var o = r.form.value.find(function (e) {
																			return 'id' === e.name;
																		}).value,
																		i =
																			null ===
																				(t = r.form.value.find(function (e) {
																					return 'enrollmentId' === e.name;
																				})) || void 0 === t
																				? void 0
																				: t.value;
																	return f(f({}, n), {}, { id: o, enrollmentId: i });
																}
															},
														},
													],
													[
														{
															key: 'getMessages',
															value: function (e) {
																var t, n;
																if (e.value)
																	return null === (t = e.value[0]) ||
																		void 0 === t ||
																		null === (n = t.form) ||
																		void 0 === n
																		? void 0
																		: n.value.reduce(function (e, t) {
																				return (
																					t.messages && (e = [].concat((0, r.Z)(e), (0, r.Z)(t.messages.value))), e
																				);
																		  }, []);
															},
														},
													]
												),
												e
											);
										})();
										(0, s.Z)(p, 'remediationName', void 0);
									},
									9164: function (e, t, n) {
										'use strict';
										n.d(t, {
											n: function () {
												return y;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(7326),
											a = n(1752),
											s = n(136),
											l = n(2963),
											u = n(1120),
											c = n(4942),
											d = n(3118),
											f = n(6064),
											p = n(7595),
											h = n(9344);
										function m(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function v(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? m(Object(n), !0).forEach(function (t) {
															(0, c.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: m(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function g(e, t) {
											(null == t || t > e.length) && (t = e.length);
											for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
											return r;
										}
										var y = (function (e) {
											(0, s.Z)(m, e);
											var t,
												n,
												d =
													((t = m),
													(n = (function () {
														if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
														if (Reflect.construct.sham) return !1;
														if ('function' == typeof Proxy) return !0;
														try {
															return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
														} catch (e) {
															return !1;
														}
													})()),
													function () {
														var e,
															r = (0, u.Z)(t);
														if (n) {
															var o = (0, u.Z)(this).constructor;
															e = Reflect.construct(r, arguments, o);
														} else e = r.apply(this, arguments);
														return (0, l.Z)(this, e);
													});
											function m() {
												var e;
												(0, r.Z)(this, m);
												for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) n[o] = arguments[o];
												return (
													(e = d.call.apply(d, [this].concat(n))),
													(0, c.Z)((0, i.Z)(e), 'selectedAuthenticator', void 0),
													(0, c.Z)((0, i.Z)(e), 'selectedOption', void 0),
													e
												);
											}
											return (
												(0, o.Z)(m, [
													{
														key: 'findMatchedOption',
														value: function (e, t) {
															var n,
																r,
																o = (function (e, t) {
																	var n = ('undefined' != typeof Symbol && e[Symbol.iterator]) || e['@@iterator'];
																	if (!n) {
																		if (
																			Array.isArray(e) ||
																			(n = (function (e, t) {
																				if (e) {
																					if ('string' == typeof e) return g(e, t);
																					var n = Object.prototype.toString.call(e).slice(8, -1);
																					return (
																						'Object' === n && e.constructor && (n = e.constructor.name),
																						'Map' === n || 'Set' === n
																							? Array.from(e)
																							: 'Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
																							? g(e, t)
																							: void 0
																					);
																				}
																			})(e)) ||
																			(t && e && 'number' == typeof e.length)
																		) {
																			n && (e = n);
																			var r = 0,
																				o = function () {};
																			return {
																				s: o,
																				n: function () {
																					return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
																				},
																				e: function (e) {
																					throw e;
																				},
																				f: o,
																			};
																		}
																		throw new TypeError(
																			'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
																		);
																	}
																	var i,
																		a = !0,
																		s = !1;
																	return {
																		s: function () {
																			n = n.call(e);
																		},
																		n: function () {
																			var e = n.next();
																			return (a = e.done), e;
																		},
																		e: function (e) {
																			(s = !0), (i = e);
																		},
																		f: function () {
																			try {
																				a || null == n.return || n.return();
																			} finally {
																				if (s) throw i;
																			}
																		},
																	};
																})(e);
															try {
																var i = function () {
																	var e = r.value;
																	if (
																		(n = t.find(function (t) {
																			var n = t.relatesTo;
																			return n.key && n.key === e.key;
																		}))
																	)
																		return 'break';
																};
																for (o.s(); !(r = o.n()).done && 'break' !== i(); );
															} catch (e) {
																o.e(e);
															} finally {
																o.f();
															}
															return n;
														},
													},
													{
														key: 'canRemediate',
														value: function (e) {
															var t = this.values,
																n = t.authenticators,
																r = t.authenticator,
																o = (0, f.zg)(this.remediation).options;
															if (!n || !n.length) return !1;
															if ((0, p.H)(r) && r.id) return !0;
															var i = this.findMatchedOption(n, o);
															if (i) {
																var a,
																	s,
																	l =
																		(null == e ? void 0 : e.currentAuthenticator) &&
																		(null == e ? void 0 : e.currentAuthenticator.value.id) ===
																			(null === (a = i.relatesTo) || void 0 === a ? void 0 : a.id),
																	u =
																		(null == e ? void 0 : e.currentAuthenticatorEnrollment) &&
																		(null == e ? void 0 : e.currentAuthenticatorEnrollment.value.id) ===
																			(null === (s = i.relatesTo) || void 0 === s ? void 0 : s.id);
																return !l && !u;
															}
															return !1;
														},
													},
													{
														key: 'mapAuthenticator',
														value: function (e) {
															var t = this.values,
																n = t.authenticators,
																r = t.authenticator;
															if ((0, p.H)(r) && r.id) return (this.selectedAuthenticator = r), r;
															var o = e.options,
																i = (0, h.h_)(n, o);
															return (
																(this.selectedAuthenticator = i.relatesTo),
																(this.selectedOption = i),
																{
																	id:
																		null == i
																			? void 0
																			: i.value.form.value.find(function (e) {
																					return 'id' === e.name;
																			  }).value,
																}
															);
														},
													},
													{
														key: 'getInputAuthenticator',
														value: function (e) {
															return {
																name: 'authenticator',
																type: 'string',
																options: e.options.map(function (e) {
																	return { label: e.label, value: e.relatesTo.key };
																}),
															};
														},
													},
													{
														key: 'getValuesAfterProceed',
														value: function () {
															var e = this;
															this.values = (0, a.Z)((0, u.Z)(m.prototype), 'getValuesAfterProceed', this).call(this);
															var t = this.values.authenticators.filter(function (t) {
																return !0 !== (0, h.PN)(t, e.selectedAuthenticator);
															});
															return v(v({}, this.values), {}, { authenticators: t });
														},
													},
												]),
												m
											);
										})(d.n);
									},
									9883: function (e, t, n) {
										'use strict';
										n.d(t, {
											Q: function () {
												return E;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(7326),
											a = n(1752),
											s = n(136),
											l = n(2963),
											u = n(1120),
											c = n(4942),
											d = n(3118),
											f = n(7644);
										function p(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function h(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? p(Object(n), !0).forEach(function (t) {
															(0, c.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: p(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var m = (function (e) {
												(0, s.Z)(a, e);
												var t,
													n,
													i =
														((t = a),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, u.Z)(t);
															if (n) {
																var o = (0, u.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, l.Z)(this, e);
														});
												function a() {
													return (0, r.Z)(this, a), i.apply(this, arguments);
												}
												return (
													(0, o.Z)(a, [
														{
															key: 'canVerify',
															value: function (e) {
																return !!(e.credentials || e.verificationCode || e.otp);
															},
														},
														{
															key: 'mapCredentials',
															value: function (e) {
																var t = e.credentials,
																	n = e.verificationCode,
																	r = e.otp;
																if (t || n || r) return t || { passcode: n || r };
															},
														},
														{
															key: 'getInputs',
															value: function (e) {
																var t;
																return h(
																	h({}, null === (t = e.form) || void 0 === t ? void 0 : t.value[0]),
																	{},
																	{ name: 'verificationCode', type: 'string', required: e.required }
																);
															},
														},
													]),
													a
												);
											})(f._),
											v = (function (e) {
												(0, s.Z)(a, e);
												var t,
													n,
													i =
														((t = a),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, u.Z)(t);
															if (n) {
																var o = (0, u.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, l.Z)(this, e);
														});
												function a() {
													return (0, r.Z)(this, a), i.apply(this, arguments);
												}
												return (
													(0, o.Z)(a, [
														{
															key: 'mapCredentials',
															value: function (e) {
																var t = e.verificationCode;
																if (t) return { totp: t };
															},
														},
													]),
													a
												);
											})(m),
											g = n(9582),
											y = (function (e) {
												(0, s.Z)(a, e);
												var t,
													n,
													i =
														((t = a),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, u.Z)(t);
															if (n) {
																var o = (0, u.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, l.Z)(this, e);
														});
												function a() {
													return (0, r.Z)(this, a), i.apply(this, arguments);
												}
												return (
													(0, o.Z)(a, [
														{
															key: 'canVerify',
															value: function (e) {
																var t = e.credentials;
																if (t && t.questionKey && t.answer) return !0;
																var n = e.questionKey,
																	r = e.question,
																	o = e.answer;
																return !(!n || !o) || !(!r || !o);
															},
														},
														{
															key: 'mapCredentials',
															value: function (e) {
																var t = e.questionKey,
																	n = e.question,
																	r = e.answer;
																if (r && (t || n)) return { questionKey: n ? 'custom' : t, question: n, answer: r };
															},
														},
														{
															key: 'getInputs',
															value: function () {
																return [
																	{ name: 'questionKey', type: 'string', required: !0 },
																	{ name: 'question', type: 'string', label: 'Create a security question' },
																	{ name: 'answer', type: 'string', label: 'Answer', required: !0 },
																];
															},
														},
													]),
													a
												);
											})(f._),
											b = (function (e) {
												(0, s.Z)(a, e);
												var t,
													n,
													i =
														((t = a),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, u.Z)(t);
															if (n) {
																var o = (0, u.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, l.Z)(this, e);
														});
												function a() {
													return (0, r.Z)(this, a), i.apply(this, arguments);
												}
												return (
													(0, o.Z)(a, [
														{
															key: 'canVerify',
															value: function (e) {
																var t = e.credentials;
																return !(!t || !t.answer) || !!e.answer;
															},
														},
														{
															key: 'mapCredentials',
															value: function (e) {
																var t = e.answer;
																if (t)
																	return {
																		questionKey: this.meta.contextualData.enrolledQuestion.questionKey,
																		answer: t,
																	};
															},
														},
														{
															key: 'getInputs',
															value: function () {
																return [{ name: 'answer', type: 'string', label: 'Answer', required: !0 }];
															},
														},
													]),
													a
												);
											})(f._),
											_ = (function (e) {
												(0, s.Z)(a, e);
												var t,
													n,
													i =
														((t = a),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, u.Z)(t);
															if (n) {
																var o = (0, u.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, l.Z)(this, e);
														});
												function a() {
													return (0, r.Z)(this, a), i.apply(this, arguments);
												}
												return (
													(0, o.Z)(a, [
														{
															key: 'canVerify',
															value: function (e) {
																var t = e.credentials || e,
																	n = t.clientData,
																	r = t.attestation;
																return !(!n || !r);
															},
														},
														{
															key: 'mapCredentials',
															value: function (e) {
																var t = e.credentials,
																	n = e.clientData,
																	r = e.attestation;
																if (t || n || r) return t || { clientData: n, attestation: r };
															},
														},
														{
															key: 'getInputs',
															value: function () {
																return [
																	{
																		name: 'clientData',
																		type: 'string',
																		required: !0,
																		visible: !1,
																		label: 'Client Data',
																	},
																	{
																		name: 'attestation',
																		type: 'string',
																		required: !0,
																		visible: !1,
																		label: 'Attestation',
																	},
																];
															},
														},
													]),
													a
												);
											})(f._),
											w = (function (e) {
												(0, s.Z)(a, e);
												var t,
													n,
													i =
														((t = a),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, u.Z)(t);
															if (n) {
																var o = (0, u.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, l.Z)(this, e);
														});
												function a() {
													return (0, r.Z)(this, a), i.apply(this, arguments);
												}
												return (
													(0, o.Z)(a, [
														{
															key: 'canVerify',
															value: function (e) {
																var t = e.credentials || e,
																	n = t.clientData,
																	r = t.authenticatorData,
																	o = t.signatureData;
																return !!(n && r && o);
															},
														},
														{
															key: 'mapCredentials',
															value: function (e) {
																var t = e.credentials,
																	n = e.authenticatorData,
																	r = e.clientData,
																	o = e.signatureData;
																if (t || n || r || o)
																	return t || { authenticatorData: n, clientData: r, signatureData: o };
															},
														},
														{
															key: 'getInputs',
															value: function () {
																return [
																	{
																		name: 'authenticatorData',
																		type: 'string',
																		label: 'Authenticator Data',
																		required: !0,
																		visible: !1,
																	},
																	{
																		name: 'clientData',
																		type: 'string',
																		label: 'Client Data',
																		required: !0,
																		visible: !1,
																	},
																	{
																		name: 'signatureData',
																		type: 'string',
																		label: 'Signature Data',
																		required: !0,
																		visible: !1,
																	},
																];
															},
														},
													]),
													a
												);
											})(f._),
											O = n(7595);
										function k(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function x(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? k(Object(n), !0).forEach(function (t) {
															(0, c.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: k(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var E = (function (e) {
											(0, s.Z)(f, e);
											var t,
												n,
												d =
													((t = f),
													(n = (function () {
														if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
														if (Reflect.construct.sham) return !1;
														if ('function' == typeof Proxy) return !0;
														try {
															return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
														} catch (e) {
															return !1;
														}
													})()),
													function () {
														var e,
															r = (0, u.Z)(t);
														if (n) {
															var o = (0, u.Z)(this).constructor;
															e = Reflect.construct(r, arguments, o);
														} else e = r.apply(this, arguments);
														return (0, l.Z)(this, e);
													});
											function f(e) {
												var t,
													n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
												return (
													(0, r.Z)(this, f),
													(t = d.call(this, e, n)),
													(0, c.Z)((0, i.Z)(t), 'authenticator', void 0),
													(t.authenticator = (function (e) {
														var t,
															n,
															r = e.relatesTo,
															o = (null == r ? void 0 : r.value) || {};
														switch (o.key) {
															case O.pc.OKTA_PASSWORD:
																return new g.a(o);
															case O.pc.SECURITY_QUESTION:
																return null !== (t = o.contextualData) && void 0 !== t && t.enrolledQuestion
																	? new b(o)
																	: new y(o);
															case O.pc.OKTA_VERIFY:
																return new v(o);
															case O.pc.WEBAUTHN:
																return null !== (n = o.contextualData) && void 0 !== n && n.challengeData
																	? new w(o)
																	: new _(o);
															default:
																return new m(o);
														}
													})(e)),
													t
												);
											}
											return (
												(0, o.Z)(f, [
													{
														key: 'getNextStep',
														value: function (e, t) {
															var n,
																r = (0, a.Z)((0, u.Z)(f.prototype), 'getNextStep', this).call(this, e, t),
																o =
																	null == t || null === (n = t.authenticatorEnrollments) || void 0 === n
																		? void 0
																		: n.value;
															return x(x({}, r), {}, { authenticatorEnrollments: o });
														},
													},
													{
														key: 'canRemediate',
														value: function () {
															return this.authenticator.canVerify(this.values);
														},
													},
													{
														key: 'mapCredentials',
														value: function () {
															return this.authenticator.mapCredentials(this.values);
														},
													},
													{
														key: 'getInputCredentials',
														value: function (e) {
															return this.authenticator.getInputs(e);
														},
													},
													{
														key: 'getValuesAfterProceed',
														value: function () {
															var e = this;
															return (
																(this.values = (0, a.Z)((0, u.Z)(f.prototype), 'getValuesAfterProceed', this).call(
																	this
																)),
																Object.keys(this.values)
																	.filter(function (e) {
																		return 'credentials' !== e;
																	})
																	.reduce(function (t, n) {
																		return x(x({}, t), {}, (0, c.Z)({}, n, e.values[n]));
																	}, {})
															);
														},
													},
												]),
												f
											);
										})(d.n);
									},
									4560: function (e, t, n) {
										'use strict';
										n.d(t, {
											J: function () {
												return u;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(136),
											a = n(2963),
											s = n(1120),
											l = n(4942),
											u = (function (e) {
												(0, i.Z)(u, e);
												var t,
													n,
													l =
														((t = u),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, s.Z)(t);
															if (n) {
																var o = (0, s.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, a.Z)(this, e);
														});
												function u() {
													return (0, o.Z)(this, u), l.apply(this, arguments);
												}
												return (0, r.Z)(u);
											})(n(9883).Q);
										(0, l.Z)(u, 'remediationName', 'challenge-authenticator');
									},
									1104: function (e, t, n) {
										'use strict';
										n.d(t, {
											U: function () {
												return u;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(136),
											a = n(2963),
											s = n(1120),
											l = n(4942),
											u = (function (e) {
												(0, i.Z)(u, e);
												var t,
													n,
													l =
														((t = u),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, s.Z)(t);
															if (n) {
																var o = (0, s.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, a.Z)(this, e);
														});
												function u() {
													return (0, r.Z)(this, u), l.apply(this, arguments);
												}
												return (
													(0, o.Z)(u, [
														{
															key: 'canRemediate',
															value: function () {
																return !!this.values.startPolling || 'challenge-poll' === this.options.step;
															},
														},
													]),
													u
												);
											})(n(2288).T);
										(0, l.Z)(u, 'remediationName', 'challenge-poll');
									},
									3857: function (e, t, n) {
										'use strict';
										n.d(t, {
											q: function () {
												return u;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(136),
											a = n(2963),
											s = n(1120),
											l = n(4942),
											u = (function (e) {
												(0, i.Z)(u, e);
												var t,
													n,
													l =
														((t = u),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, s.Z)(t);
															if (n) {
																var o = (0, s.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, a.Z)(this, e);
														});
												function u() {
													return (0, o.Z)(this, u), l.apply(this, arguments);
												}
												return (0, r.Z)(u);
											})(n(9883).Q);
										(0, l.Z)(u, 'remediationName', 'enroll-authenticator');
									},
									2288: function (e, t, n) {
										'use strict';
										n.d(t, {
											T: function () {
												return f;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(1752),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942);
										function c(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function d(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? c(Object(n), !0).forEach(function (t) {
															(0, u.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: c(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var f = (function (e) {
											(0, a.Z)(f, e);
											var t,
												n,
												c =
													((t = f),
													(n = (function () {
														if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
														if (Reflect.construct.sham) return !1;
														if ('function' == typeof Proxy) return !0;
														try {
															return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
														} catch (e) {
															return !1;
														}
													})()),
													function () {
														var e,
															r = (0, l.Z)(t);
														if (n) {
															var o = (0, l.Z)(this).constructor;
															e = Reflect.construct(r, arguments, o);
														} else e = r.apply(this, arguments);
														return (0, s.Z)(this, e);
													});
											function f() {
												return (0, r.Z)(this, f), c.apply(this, arguments);
											}
											return (
												(0, o.Z)(f, [
													{
														key: 'canRemediate',
														value: function () {
															return !!this.values.startPolling || 'enroll-poll' === this.options.step;
														},
													},
													{
														key: 'getNextStep',
														value: function (e, t) {
															var n = (0, i.Z)((0, l.Z)(f.prototype), 'getNextStep', this).call(this, e, t),
																r = this.getAuthenticator();
															return (
																!r && null != t && t.currentAuthenticator && (r = t.currentAuthenticator.value),
																d(
																	d({}, n),
																	{},
																	{ authenticator: r, poll: { required: !0, refresh: this.remediation.refresh } }
																)
															);
														},
													},
													{
														key: 'getValuesAfterProceed',
														value: function () {
															var e = this;
															return Object.keys(this.values)
																.filter(function (e) {
																	return 'startPolling' !== e;
																})
																.reduce(function (t, n) {
																	return d(d({}, t), {}, (0, u.Z)({}, n, e.values[n]));
																}, {});
														},
													},
												]),
												f
											);
										})(n(3118).n);
										(0, u.Z)(f, 'remediationName', 'enroll-poll');
									},
									7522: function (e, t, n) {
										'use strict';
										n.d(t, {
											w: function () {
												return m;
											},
										});
										var r = n(2982),
											o = n(5671),
											i = n(3144),
											a = n(7326),
											s = n(136),
											l = n(2963),
											u = n(1120),
											c = n(4942),
											d = n(3118),
											f = n(9582);
										function p(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function h(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? p(Object(n), !0).forEach(function (t) {
															(0, c.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: p(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var m = (function (e) {
											(0, s.Z)(p, e);
											var t,
												n,
												d =
													((t = p),
													(n = (function () {
														if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
														if (Reflect.construct.sham) return !1;
														if ('function' == typeof Proxy) return !0;
														try {
															return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
														} catch (e) {
															return !1;
														}
													})()),
													function () {
														var e,
															r = (0, u.Z)(t);
														if (n) {
															var o = (0, u.Z)(this).constructor;
															e = Reflect.construct(r, arguments, o);
														} else e = r.apply(this, arguments);
														return (0, l.Z)(this, e);
													});
											function p(e) {
												var t,
													n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
													r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
												return (
													(0, o.Z)(this, p),
													(t = d.call(this, e, n, r)),
													(0, c.Z)((0, a.Z)(t), 'authenticator', null),
													t.getCredentialsFromRemediation() && (t.authenticator = t.authenticator = new f.a({})),
													t
												);
											}
											return (
												(0, i.Z)(p, [
													{
														key: 'canRemediate',
														value: function () {
															if (this.authenticator && !this.authenticator.canVerify(this.values)) return !1;
															var e = this.getData().userProfile;
															return (
																!!e &&
																this.remediation.value
																	.find(function (e) {
																		return 'userProfile' === e.name;
																	})
																	.form.value.reduce(function (t, n) {
																		return n.required && (t = t && !!e[n.name]), t;
																	}, !0)
															);
														},
													},
													{
														key: 'getCredentialsFromRemediation',
														value: function () {
															return this.remediation.value.find(function (e) {
																return 'credentials' === e.name;
															});
														},
													},
													{
														key: 'mapUserProfile',
														value: function (e) {
															var t = this,
																n = e.form.value
																	.map(function (e) {
																		return e.name;
																	})
																	.reduce(function (e, n) {
																		return t.values[n] ? h(h({}, e), {}, (0, c.Z)({}, n, t.values[n])) : e;
																	}, {});
															if (0 !== Object.keys(n).length) return n;
														},
													},
													{
														key: 'mapCredentials',
														value: function () {
															var e = this.authenticator && this.authenticator.mapCredentials(this.values);
															if (e) return e;
														},
													},
													{
														key: 'getInputUserProfile',
														value: function (e) {
															return (0, r.Z)(e.form.value);
														},
													},
													{
														key: 'getInputCredentials',
														value: function (e) {
															return (0, r.Z)(e.form.value);
														},
													},
													{
														key: 'getErrorMessages',
														value: function (e) {
															return e.value[0].form.value.reduce(function (e, t) {
																return t.messages && e.push(t.messages.value[0].message), e;
															}, []);
														},
													},
												]),
												p
											);
										})(d.n);
										(0, c.Z)(m, 'remediationName', 'enroll-profile');
									},
									3679: function (e, t, n) {
										'use strict';
										n.d(t, {
											t: function () {
												return f;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(1752),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942);
										function c(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function d(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? c(Object(n), !0).forEach(function (t) {
															(0, u.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: c(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var f = (function (e) {
											(0, a.Z)(f, e);
											var t,
												n,
												c =
													((t = f),
													(n = (function () {
														if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
														if (Reflect.construct.sham) return !1;
														if ('function' == typeof Proxy) return !0;
														try {
															return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
														} catch (e) {
															return !1;
														}
													})()),
													function () {
														var e,
															r = (0, l.Z)(t);
														if (n) {
															var o = (0, l.Z)(this).constructor;
															e = Reflect.construct(r, arguments, o);
														} else e = r.apply(this, arguments);
														return (0, s.Z)(this, e);
													});
											function f() {
												return (0, r.Z)(this, f), c.apply(this, arguments);
											}
											return (
												(0, o.Z)(f, [
													{
														key: 'getInputEmail',
														value: function () {
															return [{ name: 'email', type: 'string', required: !0, label: 'Email' }];
														},
													},
													{
														key: 'getInputPhoneNumber',
														value: function () {
															return [{ name: 'phoneNumber', type: 'string', required: !0, label: 'Phone Number' }];
														},
													},
													{
														key: 'canRemediate',
														value: function () {
															return Boolean(this.values.email || this.values.phoneNumber);
														},
													},
													{
														key: 'getNextStep',
														value: function (e, t) {
															var n = (0, i.Z)((0, l.Z)(f.prototype), 'getNextStep', this).call(this, e, t),
																r = t.currentAuthenticator.value;
															return d(d({}, n), {}, { authenticator: r });
														},
													},
													{
														key: 'getData',
														value: function () {
															return {
																stateHandle: this.values.stateHandle,
																email: this.values.email,
																phoneNumber: this.values.phoneNumber,
															};
														},
													},
													{
														key: 'getValuesAfterProceed',
														value: function () {
															var e = this;
															return Object.keys(this.values)
																.filter(function (e) {
																	return !['email', 'phoneNumber'].includes(e);
																})
																.reduce(function (t, n) {
																	return d(d({}, t), {}, (0, u.Z)({}, n, e.values[n]));
																}, {});
														},
													},
												]),
												f
											);
										})(n(3118).n);
										(0, u.Z)(f, 'remediationName', 'enrollment-channel-data');
									},
									9732: function (e, t, n) {
										'use strict';
										n.d(t, {
											P: function () {
												return _;
											},
										});
										var r = n(5861),
											o = n(4942),
											i = n(4925),
											a = n(5671),
											s = n(3144),
											l = n(136),
											u = n(2963),
											c = n(1120),
											d = n(4687),
											f = n.n(d),
											p = n(3118),
											h = n(1002),
											m = n(885);
										function v(e) {
											if (Array.isArray(e))
												return e.map(function (e) {
													return 'string' == typeof e || 'number' == typeof e || 'boolean' == typeof e ? e : v(e);
												});
											for (var t = {}, n = 0, r = Object.entries(e); n < r.length; n++) {
												var o = (0, m.Z)(r[n], 2),
													i = o[0],
													a = o[1];
												if (null != a)
													if ('object' === (0, h.Z)(a)) {
														var s = Object.keys(a);
														if (['value', 'form'].includes(i) && 1 === s.length && ['value', 'form'].includes(s[0])) {
															var l = v(a);
															Object.entries(l).forEach(function (e) {
																var n = (0, m.Z)(e, 2),
																	r = n[0],
																	o = n[1];
																t[r] = o;
															});
														} else t[i] = v(a);
													} else t[i] = a;
											}
											return t;
										}
										var g = ['href', 'method', 'rel', 'accepts', 'produces', 'value', 'action'];
										function y(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function b(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? y(Object(n), !0).forEach(function (t) {
															(0, o.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: y(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var _ = (function (e) {
											(0, l.Z)(d, e);
											var t,
												n,
												o =
													((t = d),
													(n = (function () {
														if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
														if (Reflect.construct.sham) return !1;
														if ('function' == typeof Proxy) return !0;
														try {
															return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
														} catch (e) {
															return !1;
														}
													})()),
													function () {
														var e,
															r = (0, c.Z)(t);
														if (n) {
															var o = (0, c.Z)(this).constructor;
															e = Reflect.construct(r, arguments, o);
														} else e = r.apply(this, arguments);
														return (0, u.Z)(this, e);
													});
											function d() {
												return (0, a.Z)(this, d), o.apply(this, arguments);
											}
											return (
												(0, s.Z)(d, [
													{
														key: 'canRemediate',
														value: function () {
															return !(
																'function' != typeof this.remediation.action ||
																('poll' !== this.remediation.name &&
																	!this.remediation.name.endsWith('-poll') &&
																	!this.options.step)
															);
														},
													},
													{
														key: 'getData',
														value: function () {
															var e = this;
															return this.getInputs().reduce(function (t, n) {
																var r = n.name;
																return (t[r] = e.values[r]), t;
															}, {});
														},
													},
													{
														key: 'getNextStep',
														value: function (e, t) {
															var n,
																o = this.getName(),
																a = this.getInputs(),
																s = this.remediation,
																l = (s.href, s.method, s.rel, s.accepts, s.produces, s.value, s.action),
																u = (0, i.Z)(s, g);
															return l
																? b(
																		b(b({}, u), !!a.length && { inputs: a }),
																		{},
																		{
																			action:
																				((n = (0, r.Z)(
																					f().mark(function t(n) {
																						return f().wrap(function (t) {
																							for (;;)
																								switch ((t.prev = t.next)) {
																									case 0:
																										return t.abrupt('return', e.idx.proceed(b({ step: o }, n)));
																									case 1:
																									case 'end':
																										return t.stop();
																								}
																						}, t);
																					})
																				)),
																				function (e) {
																					return n.apply(this, arguments);
																				}),
																		}
																  )
																: b({}, this.remediation);
														},
													},
													{
														key: 'getInputs',
														value: function () {
															return (this.remediation.value || [])
																.filter(function (e) {
																	return 'stateHandle' !== e.name;
																})
																.map(v)
																.map(function (e) {
																	return (e.type = e.type || 'string'), e;
																});
														},
													},
												]),
												d
											);
										})(p.n);
									},
									8628: function (e, t, n) {
										'use strict';
										n.d(t, {
											h: function () {
												return f;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(7326),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942);
										function c(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function d(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? c(Object(n), !0).forEach(function (t) {
															(0, u.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: c(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var f = (function (e) {
											(0, a.Z)(f, e);
											var t,
												n,
												c =
													((t = f),
													(n = (function () {
														if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
														if (Reflect.construct.sham) return !1;
														if ('function' == typeof Proxy) return !0;
														try {
															return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
														} catch (e) {
															return !1;
														}
													})()),
													function () {
														var e,
															r = (0, l.Z)(t);
														if (n) {
															var o = (0, l.Z)(this).constructor;
															e = Reflect.construct(r, arguments, o);
														} else e = r.apply(this, arguments);
														return (0, s.Z)(this, e);
													});
											function f() {
												var e;
												(0, r.Z)(this, f);
												for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) n[o] = arguments[o];
												return (
													(e = c.call.apply(c, [this].concat(n))),
													(0, u.Z)((0, i.Z)(e), 'map', { identifier: ['username'] }),
													e
												);
											}
											return (
												(0, o.Z)(f, [
													{
														key: 'canRemediate',
														value: function () {
															return !!this.getData().identifier;
														},
													},
													{
														key: 'mapCredentials',
														value: function () {
															var e = this.values,
																t = e.credentials,
																n = e.password;
															if (t || n) return t || { passcode: n };
														},
													},
													{
														key: 'getInputCredentials',
														value: function (e) {
															return d(d({}, e.form.value[0]), {}, { name: 'password', required: e.required });
														},
													},
												]),
												f
											);
										})(n(3118).n);
										(0, u.Z)(f, 'remediationName', 'identify');
									},
									9024: function (e, t, n) {
										'use strict';
										n.d(t, {
											j: function () {
												return d;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(136),
											a = n(2963),
											s = n(1120),
											l = n(4942);
										function u(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function c(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? u(Object(n), !0).forEach(function (t) {
															(0, l.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: u(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var d = (function (e) {
											(0, i.Z)(u, e);
											var t,
												n,
												l =
													((t = u),
													(n = (function () {
														if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
														if (Reflect.construct.sham) return !1;
														if ('function' == typeof Proxy) return !0;
														try {
															return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
														} catch (e) {
															return !1;
														}
													})()),
													function () {
														var e,
															r = (0, s.Z)(t);
														if (n) {
															var o = (0, s.Z)(this).constructor;
															e = Reflect.construct(r, arguments, o);
														} else e = r.apply(this, arguments);
														return (0, a.Z)(this, e);
													});
											function u() {
												return (0, r.Z)(this, u), l.apply(this, arguments);
											}
											return (
												(0, o.Z)(u, [
													{
														key: 'mapCredentials',
														value: function () {
															var e = this.values.newPassword;
															if (e) return { passcode: e };
														},
													},
													{
														key: 'getInputCredentials',
														value: function (e) {
															var t = 'password' === this.getAuthenticator().type ? 'newPassword' : 'verificationCode';
															return c(c({}, e.form.value[0]), {}, { name: t });
														},
													},
												]),
												u
											);
										})(n(3118).n);
										(0, l.Z)(d, 'remediationName', 'reenroll-authenticator');
									},
									8107: function (e, t, n) {
										'use strict';
										n.d(t, {
											i: function () {
												return u;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(136),
											a = n(2963),
											s = n(1120),
											l = n(4942),
											u = (function (e) {
												(0, i.Z)(u, e);
												var t,
													n,
													l =
														((t = u),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, s.Z)(t);
															if (n) {
																var o = (0, s.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, a.Z)(this, e);
														});
												function u() {
													return (0, o.Z)(this, u), l.apply(this, arguments);
												}
												return (0, r.Z)(u);
											})(n(9024).j);
										(0, l.Z)(u, 'remediationName', 'reenroll-authenticator-warning');
									},
									8490: function (e, t, n) {
										'use strict';
										n.d(t, {
											O: function () {
												return u;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(136),
											a = n(2963),
											s = n(1120),
											l = n(4942),
											u = (function (e) {
												(0, i.Z)(u, e);
												var t,
													n,
													l =
														((t = u),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, s.Z)(t);
															if (n) {
																var o = (0, s.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, a.Z)(this, e);
														});
												function u() {
													return (0, r.Z)(this, u), l.apply(this, arguments);
												}
												return (
													(0, o.Z)(u, [
														{
															key: 'canRemediate',
															value: function () {
																return !1;
															},
														},
														{
															key: 'getNextStep',
															value: function () {
																var e = this.remediation;
																return { name: e.name, type: e.type, idp: e.idp, href: e.href };
															},
														},
													]),
													u
												);
											})(n(3118).n);
										(0, l.Z)(u, 'remediationName', 'redirect-idp');
									},
									1019: function (e, t, n) {
										'use strict';
										n.d(t, {
											G: function () {
												return u;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(136),
											a = n(2963),
											s = n(1120),
											l = n(4942),
											u = (function (e) {
												(0, i.Z)(u, e);
												var t,
													n,
													l =
														((t = u),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, s.Z)(t);
															if (n) {
																var o = (0, s.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, a.Z)(this, e);
														});
												function u() {
													return (0, o.Z)(this, u), l.apply(this, arguments);
												}
												return (0, r.Z)(u);
											})(n(9883).Q);
										(0, l.Z)(u, 'remediationName', 'reset-authenticator');
									},
									7311: function (e, t, n) {
										'use strict';
										n.d(t, {
											X: function () {
												return p;
											},
										});
										var r = n(2982),
											o = n(3144),
											i = n(5671),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942),
											c = n(9164),
											d = n(6064),
											f = n(7595),
											p = (function (e) {
												(0, a.Z)(c, e);
												var t,
													n,
													u =
														((t = c),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, l.Z)(t);
															if (n) {
																var o = (0, l.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, s.Z)(this, e);
														});
												function c(e) {
													var t,
														n,
														o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
														a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
													(0, i.Z)(this, c);
													var s = 'recoverPassword' === (n = u.call(this, e, o, a)).options.flow;
													return (
														(null === (t = (0, d.zg)(e).options) || void 0 === t
															? void 0
															: t.some(function (e) {
																	var t = e.relatesTo;
																	return (null == t ? void 0 : t.key) === f.pc.OKTA_PASSWORD;
															  })) &&
															(s || n.values.password) &&
															(n.values.authenticators = [].concat((0, r.Z)(n.values.authenticators || []), [
																{ key: f.pc.OKTA_PASSWORD },
															])),
														n
													);
												}
												return (0, o.Z)(c);
											})(c.n);
										(0, u.Z)(p, 'remediationName', 'select-authenticator-authenticate');
									},
									9865: function (e, t, n) {
										'use strict';
										n.d(t, {
											j: function () {
												return u;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(136),
											a = n(2963),
											s = n(1120),
											l = n(4942),
											u = (function (e) {
												(0, i.Z)(u, e);
												var t,
													n,
													l =
														((t = u),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, s.Z)(t);
															if (n) {
																var o = (0, s.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, a.Z)(this, e);
														});
												function u() {
													return (0, o.Z)(this, u), l.apply(this, arguments);
												}
												return (0, r.Z)(u);
											})(n(9164).n);
										(0, l.Z)(u, 'remediationName', 'select-authenticator-enroll');
									},
									5272: function (e, t, n) {
										'use strict';
										n.d(t, {
											G: function () {
												return p;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(7326),
											a = n(1752),
											s = n(136),
											l = n(2963),
											u = n(1120),
											c = n(4942);
										function d(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function f(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? d(Object(n), !0).forEach(function (t) {
															(0, c.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: d(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var p = (function (e) {
											(0, s.Z)(p, e);
											var t,
												n,
												d =
													((t = p),
													(n = (function () {
														if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
														if (Reflect.construct.sham) return !1;
														if ('function' == typeof Proxy) return !0;
														try {
															return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
														} catch (e) {
															return !1;
														}
													})()),
													function () {
														var e,
															r = (0, u.Z)(t);
														if (n) {
															var o = (0, u.Z)(this).constructor;
															e = Reflect.construct(r, arguments, o);
														} else e = r.apply(this, arguments);
														return (0, l.Z)(this, e);
													});
											function p() {
												var e;
												(0, r.Z)(this, p);
												for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) n[o] = arguments[o];
												return (
													(e = d.call.apply(d, [this].concat(n))),
													(0, c.Z)((0, i.Z)(e), 'authenticator', void 0),
													(0, c.Z)((0, i.Z)(e), 'map', { identifier: ['username'] }),
													e
												);
											}
											return (
												(0, o.Z)(p, [
													{
														key: 'canRemediate',
														value: function () {
															return (
																!!this.getData('identifier') &&
																(0, a.Z)((0, u.Z)(p.prototype), 'canRemediate', this).call(this)
															);
														},
													},
													{
														key: 'mapAuthenticator',
														value: function (e) {
															var t,
																n,
																r,
																o = (0, a.Z)((0, u.Z)(p.prototype), 'mapAuthenticator', this).call(this, e),
																i =
																	null === (t = this.selectedOption) || void 0 === t
																		? void 0
																		: t.value.form.value.find(function (e) {
																				return 'methodType' === e.name;
																		  }),
																s =
																	this.values.methodType ||
																	(null == i ? void 0 : i.value) ||
																	(null == i ||
																	null === (n = i.options) ||
																	void 0 === n ||
																	null === (r = n[0]) ||
																	void 0 === r
																		? void 0
																		: r.value);
															return s ? f(f({}, o), {}, { methodType: s }) : o;
														},
													},
													{
														key: 'getInputUsername',
														value: function () {
															return { name: 'username', type: 'string' };
														},
													},
												]),
												p
											);
										})(n(9164).n);
										(0, c.Z)(p, 'remediationName', 'select-authenticator-unlock-account');
									},
									4713: function (e, t, n) {
										'use strict';
										n.d(t, {
											j: function () {
												return u;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(136),
											a = n(2963),
											s = n(1120),
											l = n(4942),
											u = (function (e) {
												(0, i.Z)(u, e);
												var t,
													n,
													l =
														((t = u),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, s.Z)(t);
															if (n) {
																var o = (0, s.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, a.Z)(this, e);
														});
												function u() {
													return (0, r.Z)(this, u), l.apply(this, arguments);
												}
												return (
													(0, o.Z)(u, [
														{
															key: 'canRemediate',
															value: function () {
																return !0;
															},
														},
													]),
													u
												);
											})(n(3118).n);
										(0, l.Z)(u, 'remediationName', 'select-enroll-profile');
									},
									3403: function (e, t, n) {
										'use strict';
										n.d(t, {
											V: function () {
												return f;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(1752),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942);
										function c(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function d(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? c(Object(n), !0).forEach(function (t) {
															(0, u.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: c(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var f = (function (e) {
											(0, a.Z)(f, e);
											var t,
												n,
												c =
													((t = f),
													(n = (function () {
														if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
														if (Reflect.construct.sham) return !1;
														if ('function' == typeof Proxy) return !0;
														try {
															return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
														} catch (e) {
															return !1;
														}
													})()),
													function () {
														var e,
															r = (0, l.Z)(t);
														if (n) {
															var o = (0, l.Z)(this).constructor;
															e = Reflect.construct(r, arguments, o);
														} else e = r.apply(this, arguments);
														return (0, s.Z)(this, e);
													});
											function f() {
												return (0, r.Z)(this, f), c.apply(this, arguments);
											}
											return (
												(0, o.Z)(f, [
													{
														key: 'canRemediate',
														value: function () {
															if (this.values.channel) return !0;
															if (this.values.authenticator) {
																var e = this.values.authenticator,
																	t = e.id,
																	n = e.channel;
																if (t && n) return !0;
															}
															return !1;
														},
													},
													{
														key: 'getNextStep',
														value: function (e, t) {
															var n = (0, i.Z)((0, l.Z)(f.prototype), 'getNextStep', this).call(this, e, t),
																r = t.currentAuthenticator.value;
															return d(d({}, n), {}, { authenticator: r });
														},
													},
													{
														key: 'getData',
														value: function () {
															var e;
															return {
																authenticator: {
																	id: this.remediation.value[0].value.form.value[0].value,
																	channel:
																		(null === (e = this.values.authenticator) || void 0 === e ? void 0 : e.channel) ||
																		this.values.channel,
																},
																stateHandle: this.values.stateHandle,
															};
														},
													},
													{
														key: 'getValuesAfterProceed',
														value: function () {
															var e = this;
															(this.values = (0, i.Z)((0, l.Z)(f.prototype), 'getValuesAfterProceed', this).call(this)),
																delete this.values.authenticators;
															var t = this.values.channel ? 'channel' : 'authenticator';
															return Object.keys(this.values)
																.filter(function (e) {
																	return e !== t;
																})
																.reduce(function (t, n) {
																	return d(d({}, t), {}, (0, u.Z)({}, n, e.values[n]));
																}, {});
														},
													},
												]),
												f
											);
										})(n(3118).n);
										(0, u.Z)(f, 'remediationName', 'select-enrollment-channel');
									},
									8443: function (e, t, n) {
										'use strict';
										n.d(t, {
											h: function () {
												return u;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(136),
											a = n(2963),
											s = n(1120),
											l = n(4942),
											u = (function (e) {
												(0, i.Z)(u, e);
												var t,
													n,
													l =
														((t = u),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, s.Z)(t);
															if (n) {
																var o = (0, s.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, a.Z)(this, e);
														});
												function u() {
													return (0, r.Z)(this, u), l.apply(this, arguments);
												}
												return (
													(0, o.Z)(u, [
														{
															key: 'canRemediate',
															value: function () {
																return !!this.values.skip || 'skip' === this.options.step;
															},
														},
													]),
													u
												);
											})(n(3118).n);
										(0, l.Z)(u, 'remediationName', 'skip');
									},
									6064: function (e, t, n) {
										'use strict';
										function r(e) {
											var t;
											return null === (t = e.value) || void 0 === t
												? void 0
												: t.map(function (e) {
														return e.name;
												  });
										}
										function o(e) {
											var t;
											return null === (t = e.value) || void 0 === t
												? void 0
												: t.reduce(function (e, t) {
														return t.required && e.push(t.name), e;
												  }, []);
										}
										function i(e) {
											return e.charAt(0).toUpperCase() + e.substring(1);
										}
										function a(e) {
											return e.value.find(function (e) {
												return 'authenticator' === e.name;
											});
										}
										n.d(t, {
											QG: function () {
												return o;
											},
											Qs: function () {
												return i;
											},
											ix: function () {
												return r;
											},
											zg: function () {
												return a;
											},
										});
									},
									3377: function (e, t, n) {
										'use strict';
										n.d(t, {
											K: function () {
												return D;
											},
										});
										var r = n(5861),
											o = n(4942),
											i = n(4687),
											a = n.n(i),
											s = n(6131),
											l = n(2660),
											u = n(1002),
											c = n(2982),
											d = n(9123),
											f = n(5031);
										function p(e, t) {
											var n = ('undefined' != typeof Symbol && e[Symbol.iterator]) || e['@@iterator'];
											if (!n) {
												if (
													Array.isArray(e) ||
													(n = (function (e, t) {
														if (e) {
															if ('string' == typeof e) return h(e, t);
															var n = Object.prototype.toString.call(e).slice(8, -1);
															return (
																'Object' === n && e.constructor && (n = e.constructor.name),
																'Map' === n || 'Set' === n
																	? Array.from(e)
																	: 'Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
																	? h(e, t)
																	: void 0
															);
														}
													})(e)) ||
													(t && e && 'number' == typeof e.length)
												) {
													n && (e = n);
													var r = 0,
														o = function () {};
													return {
														s: o,
														n: function () {
															return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
														},
														e: function (e) {
															throw e;
														},
														f: o,
													};
												}
												throw new TypeError(
													'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
												);
											}
											var i,
												a = !0,
												s = !1;
											return {
												s: function () {
													n = n.call(e);
												},
												n: function () {
													var e = n.next();
													return (a = e.done), e;
												},
												e: function (e) {
													(s = !0), (i = e);
												},
												f: function () {
													try {
														a || null == n.return || n.return();
													} finally {
														if (s) throw i;
													}
												},
											};
										}
										function h(e, t) {
											(null == t || t > e.length) && (t = e.length);
											for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
											return r;
										}
										function m(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function v(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? m(Object(n), !0).forEach(function (t) {
															(0, o.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: m(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function g(e, t) {
											return Object.keys(t.actions).find(function (t) {
												return !!e.resend && t.includes('-resend');
											});
										}
										function y(e) {
											return v(v({}, e), {}, { resend: void 0 });
										}
										function b(e, t) {
											var n = e.actions || [];
											return (
												(n = n.filter(function (e) {
													return 'string' == typeof e ? e !== t : e.name !== t;
												})),
												v(v({}, e), {}, { actions: n })
											);
										}
										function _(e, t, n, r) {
											return w.apply(this, arguments);
										}
										function w() {
											return (w = (0, r.Z)(
												a().mark(function e(t, n, r, o) {
													var i, s, l, h, m, w, O, k, x, E, T, S, A, C, P, R, I, N;
													return a().wrap(
														function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		if (((s = (i = n).neededToProceed), (l = i.interactionCode), (h = o.flow), !l)) {
																			e.next = 4;
																			break;
																		}
																		return e.abrupt('return', { idxResponse: n });
																	case 4:
																		if (
																			((m = (0, f.l6)(n, r, o)),
																			(w = g(r, n)),
																			(O = o.actions || []),
																			!(k = [].concat((0, c.Z)(O), (0, c.Z)((w && [w]) || []))))
																		) {
																			e.next = 28;
																			break;
																		}
																		(x = p(k)),
																			(e.prev = 10),
																			(T = a().mark(function e() {
																				var i, l, u, c;
																				return a().wrap(function (e) {
																					for (;;)
																						switch ((e.prev = e.next)) {
																							case 0:
																								if (
																									((i = E.value),
																									(l = {}),
																									'string' != typeof i && ((l = i.params || {}), (i = i.name)),
																									(u = y(r)),
																									(c = b(o, i)),
																									'function' != typeof n.actions[i])
																								) {
																									e.next = 14;
																									break;
																								}
																								return (e.next = 8), n.actions[i](l);
																							case 8:
																								if (!1 !== (n = e.sent).requestDidSucceed) {
																									e.next = 11;
																									break;
																								}
																								return e.abrupt('return', { v: (0, f.Tc)(t, n, o) });
																							case 11:
																								if ('cancel' !== i) {
																									e.next = 13;
																									break;
																								}
																								return e.abrupt('return', { v: { idxResponse: n, canceled: !0 } });
																							case 13:
																								return e.abrupt('return', { v: _(t, n, u, c) });
																							case 14:
																								if (
																									!s.find(function (e) {
																										return e.name === i;
																									})
																								) {
																									e.next = 22;
																									break;
																								}
																								return (e.next = 18), n.proceed(i, l);
																							case 18:
																								if (!1 !== (n = e.sent).requestDidSucceed) {
																									e.next = 21;
																									break;
																								}
																								return e.abrupt('return', { v: (0, f.Tc)(t, n, o) });
																							case 21:
																								return e.abrupt('return', { v: _(t, n, r, c) });
																							case 22:
																							case 'end':
																								return e.stop();
																						}
																				}, e);
																			})),
																			x.s();
																	case 13:
																		if ((E = x.n()).done) {
																			e.next = 20;
																			break;
																		}
																		return e.delegateYield(T(), 't0', 15);
																	case 15:
																		if (((S = e.t0), 'object' !== (0, u.Z)(S))) {
																			e.next = 18;
																			break;
																		}
																		return e.abrupt('return', S.v);
																	case 18:
																		e.next = 13;
																		break;
																	case 20:
																		e.next = 25;
																		break;
																	case 22:
																		(e.prev = 22), (e.t1 = e.catch(10)), x.e(e.t1);
																	case 25:
																		return (e.prev = 25), x.f(), e.finish(25);
																	case 28:
																		if (!(A = (0, f.xn)(n))) {
																			e.next = 31;
																			break;
																		}
																		return e.abrupt('return', { idxResponse: n, terminal: A });
																	case 31:
																		if (m) {
																			e.next = 43;
																			break;
																		}
																		if (!o.step) {
																			e.next = 40;
																			break;
																		}
																		return (r = (0, f.Ax)(n, o.step, r)), (e.next = 36), n.proceed(o.step, r);
																	case 36:
																		if (!1 !== (n = e.sent).requestDidSucceed) {
																			e.next = 39;
																			break;
																		}
																		return e.abrupt('return', (0, f.Tc)(t, n, o));
																	case 39:
																		return e.abrupt('return', { idxResponse: n });
																	case 40:
																		if ('default' !== h) {
																			e.next = 42;
																			break;
																		}
																		return e.abrupt('return', { idxResponse: n });
																	case 42:
																		throw new d.Z(
																			'\n      No remediation can match current flow, check policy settings in your org.\n      Remediations: ['.concat(
																				s.reduce(function (e, t) {
																					return e ? e + ' ,' + t.name : t.name;
																				}, ''),
																				']\n    '
																			)
																		);
																	case 43:
																		if (m.canRemediate()) {
																			e.next = 46;
																			break;
																		}
																		return (
																			(C = (0, f.TR)(t, m, n)), e.abrupt('return', { idxResponse: n, nextStep: C })
																		);
																	case 46:
																		return (P = m.getName()), (R = m.getData()), (e.next = 50), n.proceed(P, R);
																	case 50:
																		if (!1 !== (n = e.sent).requestDidSucceed) {
																			e.next = 53;
																			break;
																		}
																		return e.abrupt('return', (0, f.Tc)(t, n, o));
																	case 53:
																		if (
																			((r = m.getValuesAfterProceed()),
																			!(o = v(v({}, o), {}, { step: void 0 })).useGenericRemediator ||
																				n.interactionCode ||
																				(0, f.xn)(n))
																		) {
																			e.next = 59;
																			break;
																		}
																		return (
																			(I = (0, f.l6)(n, r, o)),
																			(N = (0, f.TR)(t, I, n)),
																			e.abrupt('return', { idxResponse: n, nextStep: N })
																		);
																	case 59:
																		return e.abrupt('return', _(t, n, r, o));
																	case 60:
																	case 'end':
																		return e.stop();
																}
														},
														e,
														null,
														[[10, 22, 25, 28]]
													);
												})
											)).apply(this, arguments);
										}
										var O = n(7595),
											k = n(2620);
										function x(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function E(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? x(Object(n), !0).forEach(function (t) {
															(0, o.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: x(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function T(e) {
											var t = E({}, e);
											return (
												[
													'flow',
													'remediators',
													'actions',
													'withCredentials',
													'step',
													'useGenericRemediator',
													'exchangeCodeForTokens',
												].forEach(function (e) {
													delete t[e];
												}),
												t
											);
										}
										function S(e, t) {
											var n,
												r,
												o = t.options,
												i = (o = E(E({}, e.options.idx), o)),
												a = i.flow,
												s = i.withCredentials,
												l = i.remediators,
												u = i.actions,
												c = O.Qd.PENDING;
											if (
												(a =
													a || (null === (n = (r = e.idx).getFlow) || void 0 === n ? void 0 : n.call(r)) || 'default')
											) {
												var d, p;
												null === (d = (p = e.idx).setFlow) || void 0 === d || d.call(p, a);
												var h = (0, f.sH)(e, a);
												(s = void 0 !== s ? s : h.withCredentials), (l = l || h.remediators), (u = u || h.actions);
											}
											return E(
												E({}, t),
												{},
												{
													options: E(E({}, o), {}, { flow: a, withCredentials: s, remediators: l, actions: u }),
													status: c,
												}
											);
										}
										function A(e, t) {
											return C.apply(this, arguments);
										}
										function C() {
											return (C = (0, r.Z)(
												a().mark(function e(t, n) {
													var r, o, i, u, c, d, f, p, h, m, v, g, y, b, _, w, O;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (
																		((r = n.options),
																		(o = r.stateHandle),
																		(i = r.withCredentials),
																		(u = r.version),
																		(c = r.state),
																		(d = r.scopes),
																		(f = r.recoveryToken),
																		(p = r.activationToken),
																		(h = r.maxAge),
																		(m = r.acrValues),
																		(v = r.nonce),
																		(g = r.useGenericRemediator),
																		(b = (0, k.uN)(t, { state: c, recoveryToken: f, activationToken: p })),
																		!o)
																	) {
																		e.next = 9;
																		break;
																	}
																	return (
																		(e.next = 6),
																		(0, l.L)(t, {
																			withCredentials: i,
																			version: u,
																			stateHandle: o,
																			useGenericRemediator: g,
																		})
																	);
																case 6:
																	(y = e.sent), (e.next = 20);
																	break;
																case 9:
																	if ((w = null === (_ = b) || void 0 === _ ? void 0 : _.interactionHandle)) {
																		e.next = 17;
																		break;
																	}
																	return (
																		t.transactionManager.clear(),
																		(e.next = 14),
																		(0, s.E)(t, {
																			withCredentials: i,
																			state: c,
																			scopes: d,
																			activationToken: p,
																			recoveryToken: f,
																			maxAge: h,
																			acrValues: m,
																			nonce: v,
																		})
																	);
																case 14:
																	(O = e.sent), (w = O.interactionHandle), (b = O.meta);
																case 17:
																	return (
																		(e.next = 19),
																		(0, l.L)(t, {
																			withCredentials: i,
																			version: u,
																			interactionHandle: w,
																			useGenericRemediator: g,
																		})
																	);
																case 19:
																	y = e.sent;
																case 20:
																	return e.abrupt('return', E(E({}, n), {}, { idxResponse: y, meta: b }));
																case 21:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function P(e, t) {
											return R.apply(this, arguments);
										}
										function R() {
											return (R = (0, r.Z)(
												a().mark(function e(t, n) {
													var r, o, i, s, l, u, c, d, f, p, h, m, v;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (
																		((r = n.idxResponse),
																		(o = n.options),
																		(i = n.values),
																		(s = o.autoRemediate),
																		(l = o.remediators),
																		(u = o.actions),
																		(c = o.flow),
																		(d = o.step),
																		(f = o.useGenericRemediator),
																		!1 !== s && (l || u || d))
																	) {
																		e.next = 5;
																		break;
																	}
																	return e.abrupt('return', n);
																case 5:
																	return (
																		(i = E(E({}, i), {}, { stateHandle: r.rawIdxState.stateHandle })),
																		(e.next = 8),
																		_(t, r, i, {
																			remediators: l,
																			actions: u,
																			flow: c,
																			step: d,
																			useGenericRemediator: f,
																		})
																	);
																case 8:
																	return (
																		(p = e.sent),
																		(h = p.idxResponse),
																		(m = p.nextStep),
																		(v = p.canceled),
																		(r = h),
																		e.abrupt('return', E(E({}, n), {}, { idxResponse: r, nextStep: m, canceled: v }))
																	);
																case 14:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function I(e, t) {
											return N.apply(this, arguments);
										}
										function N() {
											return (N = (0, r.Z)(
												a().mark(function e(t, n) {
													var r, o, i, s, l, u, c, d, f, p, h;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	return (
																		(r = n.meta),
																		(o = n.idxResponse),
																		(i = o.interactionCode),
																		(l = (s = r).clientId),
																		(u = s.codeVerifier),
																		(c = s.ignoreSignature),
																		(d = s.redirectUri),
																		(f = s.urls),
																		(p = s.scopes),
																		(e.next = 5),
																		t.token.exchangeCodeForTokens(
																			{
																				interactionCode: i,
																				clientId: l,
																				codeVerifier: u,
																				ignoreSignature: c,
																				redirectUri: d,
																				scopes: p,
																			},
																			f
																		)
																	);
																case 5:
																	return (h = e.sent), e.abrupt('return', h.tokens);
																case 7:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function M(e, t) {
											return j.apply(this, arguments);
										}
										function j() {
											return (j = (0, r.Z)(
												a().mark(function e(t, n) {
													var r, o, i, s, l, u, c, d, p, h, m, v, g, y, b, _;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (
																		((r = n.options),
																		(o = n.idxResponse),
																		(i = n.canceled),
																		(s = n.status),
																		(l = r.exchangeCodeForTokens),
																		(u = !1),
																		(c = !1),
																		(d = !0),
																		o &&
																			((u = !(!o.requestDidSucceed && !o.stepUp)),
																			(m = (0, f.KM)(o)),
																			(v = (0, f.kw)(t, o, r.useGenericRemediator)),
																			(g = (0, f.lx)(o, r)),
																			(y = (0, f.xn)(o))),
																		!y)
																	) {
																		e.next = 15;
																		break;
																	}
																	(s = O.Qd.TERMINAL),
																		(b = Object.keys(o.actions).length > 0),
																		(_ = !!g.find(function (e) {
																			return 'ERROR' === e.class;
																		})),
																		b || _ || !0 !== o.requestDidSucceed ? (u = !!b) : (c = !0),
																		(d = !1),
																		(e.next = 32);
																	break;
																case 15:
																	if (!i) {
																		e.next = 20;
																		break;
																	}
																	(s = O.Qd.CANCELED), (c = !0), (e.next = 32);
																	break;
																case 20:
																	if (null == o || !o.interactionCode) {
																		e.next = 32;
																		break;
																	}
																	if (((p = o.interactionCode), !1 !== l)) {
																		e.next = 27;
																		break;
																	}
																	(s = O.Qd.SUCCESS), (c = !1), (e.next = 32);
																	break;
																case 27:
																	return (e.next = 29), I(t, n);
																case 29:
																	(h = e.sent), (s = O.Qd.SUCCESS), (c = !0);
																case 32:
																	return e.abrupt(
																		'return',
																		E(
																			E({}, n),
																			{},
																			{
																				status: s,
																				interactionCode: p,
																				tokens: h,
																				shouldSaveResponse: u,
																				shouldClearTransaction: c,
																				clearSharedStorage: d,
																				enabledFeatures: m,
																				availableSteps: v,
																				messages: g,
																				terminal: y,
																			}
																		)
																	);
																case 33:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function D(e) {
											return L.apply(this, arguments);
										}
										function L() {
											return (
												(L = (0, r.Z)(
													a().mark(function e(t) {
														var n,
															r,
															o,
															i,
															s,
															l,
															u,
															c,
															d,
															f,
															p,
															h,
															m,
															v,
															g,
															y,
															b,
															_,
															w,
															O,
															x,
															C,
															R,
															I,
															N,
															j,
															D,
															L,
															U = arguments;
														return a().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(r = {
																				options: (n = U.length > 1 && void 0 !== U[1] ? U[1] : {}),
																				values: T(n),
																			}),
																			(r = S(t, r)),
																			(e.next = 5),
																			A(t, r)
																		);
																	case 5:
																		return (r = e.sent), (e.next = 8), P(t, r);
																	case 8:
																		return (r = e.sent), (e.next = 11), M(t, r);
																	case 11:
																		return (
																			(r = e.sent),
																			(i = (o = r).idxResponse),
																			(s = o.meta),
																			(l = o.shouldSaveResponse),
																			(u = o.shouldClearTransaction),
																			(c = o.clearSharedStorage),
																			(d = o.status),
																			(f = o.enabledFeatures),
																			(p = o.availableSteps),
																			(h = o.tokens),
																			(m = o.nextStep),
																			(v = o.messages),
																			(g = o.error),
																			(y = o.interactionCode),
																			u
																				? t.transactionManager.clear({ clearSharedStorage: c })
																				: ((0, k.r0)(t, E({}, s)),
																				  l &&
																						((w = (_ = i).rawIdxState),
																						(O = _.requestDidSucceed),
																						t.transactionManager.saveIdxResponse({
																							rawIdxResponse: w,
																							requestDidSucceed: O,
																							stateHandle:
																								null === (b = i.context) || void 0 === b ? void 0 : b.stateHandle,
																							interactionHandle: null == s ? void 0 : s.interactionHandle,
																						}))),
																			(C = (x = i || {}).actions),
																			(R = x.context),
																			(I = x.neededToProceed),
																			(N = x.proceed),
																			(j = x.rawIdxState),
																			(D = x.requestDidSucceed),
																			(L = x.stepUp),
																			e.abrupt(
																				'return',
																				E(
																					E(
																						E(
																							E(
																								E(
																									E(
																										E(
																											E(
																												E({ status: d }, s && { meta: s }),
																												f && { enabledFeatures: f }
																											),
																											p && { availableSteps: p }
																										),
																										h && { tokens: h }
																									),
																									m && { nextStep: m }
																								),
																								v && v.length && { messages: v }
																							),
																							g && { error: g }
																						),
																						L && { stepUp: L }
																					),
																					{},
																					{
																						interactionCode: y,
																						actions: C,
																						context: R,
																						neededToProceed: I,
																						proceed: N,
																						rawIdxState: j,
																						requestDidSucceed: D,
																					}
																				)
																			)
																		);
																	case 16:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												L.apply(this, arguments)
											);
										}
									},
									2473: function (e, t, n) {
										'use strict';
										n.d(t, {
											Y: function () {
												return c;
											},
										});
										var r = n(4942),
											o = n(5861),
											i = n(4687),
											a = n.n(i),
											s = n(3377);
										function l(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function u(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? l(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: l(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function c(e) {
											return d.apply(this, arguments);
										}
										function d() {
											return (
												(d = (0, o.Z)(
													a().mark(function e(t) {
														var n,
															r = arguments;
														return a().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(n = r.length > 1 && void 0 !== r[1] ? r[1] : {}),
																			t.transactionManager.clear(),
																			e.abrupt('return', (0, s.K)(t, u({ exchangeCodeForTokens: !1 }, n)))
																		);
																	case 3:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												d.apply(this, arguments)
											);
										}
									},
									4143: function (e, t, n) {
										'use strict';
										n.d(t, {
											a: function () {
												return h;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(136),
											a = n(2963),
											s = n(1120),
											l = n(5763),
											u = n(1971),
											c = n(2647),
											d = n(415),
											f = n(146),
											p = n(9123);
										function h() {
											return (function (e) {
												(0, i.Z)(h, e);
												var t,
													n,
													c =
														((t = h),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, s.Z)(t);
															if (n) {
																var o = (0, s.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, a.Z)(this, e);
														});
												function h(e, t, n) {
													return (0, r.Z)(this, h), c.call(this, e, t, n);
												}
												return (
													(0, o.Z)(h, [
														{
															key: 'getIdxResponseStorage',
															value: function (e) {
																var t;
																if ((0, d.isBrowser)())
																	try {
																		t = this.storageUtil.getStorageByType('memory', e);
																	} catch (e) {
																		(0, f.ZK)(
																			'No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic'
																		);
																	}
																else {
																	var n = this.getTransactionStorage(e);
																	n &&
																		(t = {
																			getItem: function (e) {
																				var t = n.getStorage();
																				return t && t[e] ? t[e] : null;
																			},
																			setItem: function (e, t) {
																				var r = n.getStorage();
																				if (!r) throw new p.Z('Transaction has been cleared, failed to save idxState');
																				(r[e] = t), n.setStorage(r);
																			},
																			removeItem: function (e) {
																				var t = n.getStorage();
																				t && (delete t[e], n.setStorage(t));
																			},
																		});
																}
																return t ? new l._(t, u.IDX_RESPONSE_STORAGE_NAME) : null;
															},
														},
													]),
													h
												);
											})((0, c.a)());
										}
									},
									2620: function (e, t, n) {
										'use strict';
										n.d(t, {
											$0: function () {
												return h;
											},
											Co: function () {
												return v;
											},
											Jm: function () {
												return b;
											},
											UC: function () {
												return O;
											},
											Wf: function () {
												return _;
											},
											Xc: function () {
												return f;
											},
											bl: function () {
												return w;
											},
											r0: function () {
												return y;
											},
											uN: function () {
												return m;
											},
										});
										var r = n(4942),
											o = n(5861),
											i = n(4687),
											a = n.n(i),
											s = n(3193),
											l = n(146),
											u = n(2865);
										function c(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function d(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? c(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: c(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function f(e) {
											return p.apply(this, arguments);
										}
										function p() {
											return (
												(p = (0, o.Z)(
													a().mark(function e(t) {
														var n,
															r,
															o,
															i,
															s,
															l,
															c,
															f,
															p,
															h,
															m,
															v,
															g,
															y,
															b,
															_,
															w,
															O = arguments;
														return a().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(n = O.length > 1 && void 0 !== O[1] ? O[1] : {}),
																			(e.next = 3),
																			t.token.prepareTokenParams(n)
																		);
																	case 3:
																		return (
																			(r = e.sent),
																			(o = (0, u.H)(t, r)),
																			(i = d(d({}, t.options), n)),
																			(s = i.flow),
																			(l = void 0 === s ? 'default' : s),
																			(c = i.withCredentials),
																			(f = void 0 === c || c),
																			(p = i.activationToken),
																			(h = void 0 === p ? void 0 : p),
																			(m = i.recoveryToken),
																			(v = void 0 === m ? void 0 : m),
																			(g = i.maxAge),
																			(y = void 0 === g ? void 0 : g),
																			(b = i.acrValues),
																			(_ = void 0 === b ? void 0 : b),
																			(w = d(
																				d({}, o),
																				{},
																				{
																					flow: l,
																					withCredentials: f,
																					activationToken: h,
																					recoveryToken: v,
																					maxAge: y,
																					acrValues: _,
																				}
																			)),
																			e.abrupt('return', w)
																		);
																	case 8:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												p.apply(this, arguments)
											);
										}
										function h(e, t) {
											var n = m(e, t);
											return !(null == n || !n.interactionHandle);
										}
										function m(e, t) {
											var n;
											(t = (0, s.YY)(t)), (t = d(d({}, e.options), t));
											try {
												n = e.transactionManager.load(t);
											} catch (e) {}
											if (n)
												return _(n, t)
													? n
													: void (0, l.ZK)(
															'Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.'
													  );
										}
										function v(e, t) {
											return g.apply(this, arguments);
										}
										function g() {
											return (g = (0, o.Z)(
												a().mark(function e(t, n) {
													var r;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (((n = (0, s.YY)(n)), (n = d(d({}, t.options), n)), !(r = m(t, n)))) {
																		e.next = 5;
																		break;
																	}
																	return e.abrupt('return', r);
																case 5:
																	return e.abrupt('return', f(t, n));
																case 6:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function y(e, t) {
											e.transactionManager.save(t, { muteWarning: !0 });
										}
										function b(e) {
											e.transactionManager.clear();
										}
										function _(e) {
											var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
											return (
												!1 !==
													O(e, t, [
														'issuer',
														'clientId',
														'redirectUri',
														'state',
														'codeChallenge',
														'codeChallengeMethod',
														'activationToken',
														'recoveryToken',
													]) && !1 !== w(e, t.flow)
											);
										}
										function w(e, t) {
											return !(t && 'default' !== t && 'proceed' !== t) || t === e.flow;
										}
										function O(e, t, n) {
											return !n.some(function (n) {
												var r = t[n];
												if (r && r !== e[n]) return !0;
											});
										}
									},
									7595: function (e, t, n) {
										'use strict';
										var r, o, i;
										function a(e) {
											return e && (e.key || e.id);
										}
										n.d(t, {
											Fw: function () {
												return i;
											},
											H: function () {
												return a;
											},
											Qd: function () {
												return r;
											},
											pc: function () {
												return o;
											},
										}),
											(function (e) {
												(e.SUCCESS = 'SUCCESS'),
													(e.PENDING = 'PENDING'),
													(e.FAILURE = 'FAILURE'),
													(e.TERMINAL = 'TERMINAL'),
													(e.CANCELED = 'CANCELED');
											})(r || (r = {})),
											(function (e) {
												(e.OKTA_PASSWORD = 'okta_password'),
													(e.OKTA_EMAIL = 'okta_email'),
													(e.PHONE_NUMBER = 'phone_number'),
													(e.GOOGLE_AUTHENTICATOR = 'google_otp'),
													(e.SECURITY_QUESTION = 'security_question'),
													(e.OKTA_VERIFY = 'okta_verify'),
													(e.WEBAUTHN = 'webauthn');
											})(o || (o = {})),
											(function (e) {
												(e.PASSWORD_RECOVERY = 'recover-password'),
													(e.REGISTRATION = 'enroll-profile'),
													(e.SOCIAL_IDP = 'redirect-idp'),
													(e.ACCOUNT_UNLOCK = 'unlock-account');
											})(i || (i = {}));
									},
									480: function (e, t, n) {
										'use strict';
										function r(e) {
											return e && e.version;
										}
										n.d(t, {
											P: function () {
												return r;
											},
										});
									},
									8277: function (e, t, n) {
										'use strict';
										n.d(t, {
											l: function () {
												return h;
											},
										});
										var r = n(4942),
											o = n(5861),
											i = n(4687),
											a = n.n(i),
											s = n(3377),
											l = n(2620),
											u = n(2473),
											c = n(9123),
											d = n(7595);
										function f(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function p(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? f(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: f(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function h(e) {
											return m.apply(this, arguments);
										}
										function m() {
											return (
												(m = (0, o.Z)(
													a().mark(function e(t) {
														var n,
															r,
															o,
															i = arguments;
														return a().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		if (
																			(((n = i.length > 1 && void 0 !== i[1] ? i[1] : {}).flow = 'unlockAccount'),
																			(0, l.$0)(t))
																		) {
																			e.next = 9;
																			break;
																		}
																		return (e.next = 5), (0, u.Y)(t, p(p({}, n), {}, { autoRemediate: !1 }));
																	case 5:
																		if (((r = e.sent), !(o = r.enabledFeatures) || o.includes(d.Fw.ACCOUNT_UNLOCK))) {
																			e.next = 9;
																			break;
																		}
																		throw new c.Z(
																			'Self Service Account Unlock is not supported based on your current org configuration.'
																		);
																	case 9:
																		return e.abrupt('return', (0, s.K)(t, p({}, n)));
																	case 10:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												m.apply(this, arguments)
											);
										}
									},
									5031: function (e, t, n) {
										'use strict';
										n.d(t, {
											Ax: function () {
												return S;
											},
											KM: function () {
												return E;
											},
											TC: function () {
												return _;
											},
											TR: function () {
												return P;
											},
											Tc: function () {
												return R;
											},
											kw: function () {
												return T;
											},
											l6: function () {
												return C;
											},
											lx: function () {
												return x;
											},
											sH: function () {
												return w;
											},
											xn: function () {
												return O;
											},
										});
										var r = n(4942),
											o = n(4925),
											i = n(5861),
											a = n(885),
											s = n(2982),
											l = n(4687),
											u = n.n(l),
											c = n(8750),
											d = n(146),
											f = n(9732),
											p = n(7595),
											h = ['href', 'method', 'rel', 'accepts', 'produces'];
										function m(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function v(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? m(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: m(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function g(e, t) {
											var n = ('undefined' != typeof Symbol && e[Symbol.iterator]) || e['@@iterator'];
											if (!n) {
												if (
													Array.isArray(e) ||
													(n = (function (e, t) {
														if (e) {
															if ('string' == typeof e) return y(e, t);
															var n = Object.prototype.toString.call(e).slice(8, -1);
															return (
																'Object' === n && e.constructor && (n = e.constructor.name),
																'Map' === n || 'Set' === n
																	? Array.from(e)
																	: 'Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
																	? y(e, t)
																	: void 0
															);
														}
													})(e)) ||
													(t && e && 'number' == typeof e.length)
												) {
													n && (e = n);
													var r = 0,
														o = function () {};
													return {
														s: o,
														n: function () {
															return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
														},
														e: function (e) {
															throw e;
														},
														f: o,
													};
												}
												throw new TypeError(
													'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
												);
											}
											var i,
												a = !0,
												s = !1;
											return {
												s: function () {
													n = n.call(e);
												},
												n: function () {
													var e = n.next();
													return (a = e.done), e;
												},
												e: function (e) {
													(s = !0), (i = e);
												},
												f: function () {
													try {
														a || null == n.return || n.return();
													} finally {
														if (s) throw i;
													}
												},
											};
										}
										function y(e, t) {
											(null == t || t > e.length) && (t = e.length);
											for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
											return r;
										}
										var b = {
											remediators: {},
											getFlowSpecification: function (e) {
												return { remediators: {} };
											},
										};
										function _(e) {
											Object.assign(b, e);
										}
										function w(e) {
											var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 'default';
											return b.getFlowSpecification(e, t);
										}
										function O(e) {
											var t = e.neededToProceed,
												n = e.interactionCode;
											return !t.length && !n;
										}
										function k(e) {
											if (e && Array.isArray(e))
												return e.reduce(function (e, t) {
													if ((t.messages && (e = [].concat((0, s.Z)(e), (0, s.Z)(t.messages.value))), t.form)) {
														var n = k(t.form.value) || [];
														e = [].concat((0, s.Z)(e), (0, s.Z)(n));
													}
													if (t.options) {
														var r = [];
														t.options.forEach(function (e) {
															e.value && 'string' != typeof e.value && (r = [].concat((0, s.Z)(r), [e.value]));
														});
														var o = k(r) || [];
														e = [].concat((0, s.Z)(e), (0, s.Z)(o));
													}
													return e;
												}, []);
										}
										function x(e, t) {
											var n,
												r = [],
												o = e.rawIdxState,
												i = e.neededToProceed,
												a =
													null === (n = o.messages) || void 0 === n
														? void 0
														: n.value.map(function (e) {
																return e;
														  });
											if ((a && (r = [].concat((0, s.Z)(r), (0, s.Z)(a))), !t.useGenericRemediator)) {
												var l,
													u = g(i);
												try {
													for (u.s(); !(l = u.n()).done; ) {
														var c = k(l.value.value);
														c && (r = [].concat((0, s.Z)(r), (0, s.Z)(c)));
													}
												} catch (e) {
													u.e(e);
												} finally {
													u.f();
												}
											}
											var d = {};
											return r.reduce(function (e, t) {
												var n,
													r = null === (n = t.i18n) || void 0 === n ? void 0 : n.key;
												return r && d[r] && t.message === d[r].message
													? e
													: ((d[r] = t), (e = [].concat((0, s.Z)(e), [t])));
											}, []);
										}
										function E(e) {
											var t = [],
												n = e.actions,
												r = e.neededToProceed;
											return (
												n['currentAuthenticator-recover'] && t.push(p.Fw.PASSWORD_RECOVERY),
												r.some(function (e) {
													return 'select-enroll-profile' === e.name;
												}) && t.push(p.Fw.REGISTRATION),
												r.some(function (e) {
													return 'redirect-idp' === e.name;
												}) && t.push(p.Fw.SOCIAL_IDP),
												r.some(function (e) {
													return 'unlock-account' === e.name;
												}) && t.push(p.Fw.ACCOUNT_UNLOCK),
												t
											);
										}
										function T(e, t, n) {
											var r,
												s = [],
												l = Object.values(b.remediators).reduce(function (e, t) {
													return t.remediationName && (e[t.remediationName] = t), e;
												}, {}),
												d = g(t.neededToProceed);
											try {
												for (d.s(); !(r = d.n()).done; ) {
													var f = r.value,
														p = A(f, { useGenericRemediator: n, remediators: l });
													if (p) {
														var m = new p(f);
														s.push(m.getNextStep(e, t.context));
													}
												}
											} catch (e) {
												d.e(e);
											} finally {
												d.f();
											}
											for (
												var y = function () {
														var n,
															r = (0, a.Z)(w[_], 1)[0],
															l = {
																name: r,
																action:
																	((n = (0, i.Z)(
																		u().mark(function t(n) {
																			return u().wrap(function (t) {
																				for (;;)
																					switch ((t.prev = t.next)) {
																						case 0:
																							return t.abrupt(
																								'return',
																								e.idx.proceed({ actions: [{ name: r, params: n }] })
																							);
																						case 1:
																						case 'end':
																							return t.stop();
																					}
																			}, t);
																		})
																	)),
																	function (e) {
																		return n.apply(this, arguments);
																	}),
															};
														if (r.startsWith('currentAuthenticator')) {
															var d,
																f = (0, c.YQ)(r, '-'),
																p = (0, a.Z)(f, 2),
																m = p[0],
																g = p[1],
																y = t.rawIdxState[m].value[g],
																b = (y.href, y.method, y.rel, y.accepts, y.produces, (0, o.Z)(y, h)),
																O =
																	null === (d = y.value) || void 0 === d
																		? void 0
																		: d.filter(function (e) {
																				return 'stateHandle' !== e.name;
																		  });
															l = v(v(v({}, b), O && { value: O }), l);
														}
														s.push(l);
													},
													_ = 0,
													w = Object.entries(t.actions || {});
												_ < w.length;
												_++
											)
												y();
											return s;
										}
										function S(e, t, n) {
											var r = (e.neededToProceed || []).find(function (e) {
												return e.name === t;
											});
											return r
												? r.value.reduce(function (e, t) {
														var r = t.name,
															o = t.value;
														return (e[r] = 'stateHandle' === r ? o : n[r]), e;
												  }, {})
												: ((0, d.ZK)('filterValuesForRemediation: "'.concat(t, '" did not match any remediations')), n);
										}
										function A(e, t) {
											var n = t.useGenericRemediator,
												r = t.remediators;
											if (e) return n ? f.P : r[e.name];
										}
										function C(e, t, n) {
											var r,
												o = n.remediators,
												i = n.useGenericRemediator,
												a = e.neededToProceed,
												s = e.context;
											if (!n.step) {
												var l = [];
												if (i) l.push(new f.P(a[0], t, n));
												else {
													var u,
														c = g(a);
													try {
														for (c.s(); !(u = c.n()).done; ) {
															var p = u.value;
															if (Object.keys(o).includes(p.name)) {
																if ((r = new (A(p, n))(p, t, n)).canRemediate(s)) return r;
																l.push(r);
															}
														}
													} catch (e) {
														c.e(e);
													} finally {
														c.f();
													}
												}
												return l[0];
											}
											var h = a.find(function (e) {
												return e.name === n.step;
											});
											if (h) {
												var m = A(h, n);
												return m ? new m(h, t, n) : void 0;
											}
											(0, d.ZK)('step "'.concat(n.step, '" did not match any remediations'));
										}
										function P(e, t, n) {
											var r = t.getNextStep(e, n.context),
												o = (function (e) {
													return e.neededToProceed.some(function (e) {
														return 'skip' === e.name;
													});
												})(n),
												i = (function (e) {
													return Object.keys(e.actions).some(function (e) {
														return e.includes('resend');
													});
												})(n);
											return v(v(v({}, r), o && { canSkip: o }), i && { canResend: i });
										}
										function R(e, t) {
											var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
												r = O(t),
												o = x(t, n);
											if (r) return { idxResponse: t, terminal: r, messages: o };
											var i = C(t, {}, n),
												a = i && P(e, i, t);
											return v({ idxResponse: t, messages: o }, a && { nextStep: a });
										}
									},
									8716: function (e, t, n) {
										'use strict';
										n.r(t),
											n.d(t, {
												buildCredentialCreationOptions: function () {
													return i;
												},
												buildCredentialRequestOptions: function () {
													return a;
												},
												getAssertion: function () {
													return l;
												},
												getAttestation: function () {
													return s;
												},
											});
										var r = n(7987),
											o = function () {
												var e = [];
												return (
													(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).forEach(function (t) {
														'webauthn' === t.key && e.push({ type: 'public-key', id: (0, r.dX)(t.credentialId) });
													}),
													e
												);
											},
											i = function (e, t) {
												return {
													publicKey: {
														rp: e.rp,
														user: { id: (0, r.dX)(e.user.id), name: e.user.name, displayName: e.user.displayName },
														challenge: (0, r.dX)(e.challenge),
														pubKeyCredParams: e.pubKeyCredParams,
														attestation: e.attestation,
														authenticatorSelection: e.authenticatorSelection,
														excludeCredentials: o(t),
													},
												};
											},
											a = function (e, t) {
												return {
													publicKey: {
														challenge: (0, r.dX)(e.challenge),
														userVerification: e.userVerification,
														allowCredentials: o(t),
													},
												};
											},
											s = function (e) {
												var t = e.response;
												return {
													id: e.id,
													clientData: (0, r.kQ)(t.clientDataJSON),
													attestation: (0, r.kQ)(t.attestationObject),
												};
											},
											l = function (e) {
												var t = e.response;
												return {
													id: e.id,
													clientData: (0, r.kQ)(t.clientDataJSON),
													authenticatorData: (0, r.kQ)(t.authenticatorData),
													signatureData: (0, r.kQ)(t.signature),
												};
											};
									},
									9108: function (e, t, n) {
										'use strict';
										n.r(t),
											n.d(t, {
												addEmail: function () {
													return V;
												},
												addPhone: function () {
													return G;
												},
												deleteEmail: function () {
													return Z;
												},
												deletePassword: function () {
													return oe;
												},
												deletePhone: function () {
													return Y;
												},
												enrollPassword: function () {
													return ne;
												},
												getEmail: function () {
													return B;
												},
												getEmailChallenge: function () {
													return q;
												},
												getEmails: function () {
													return F;
												},
												getPassword: function () {
													return te;
												},
												getPhone: function () {
													return z;
												},
												getPhones: function () {
													return $;
												},
												getProfile: function () {
													return N;
												},
												getProfileSchema: function () {
													return j;
												},
												sendEmailChallenge: function () {
													return H;
												},
												sendPhoneChallenge: function () {
													return J;
												},
												updatePassword: function () {
													return re;
												},
												updateProfile: function () {
													return M;
												},
												verifyEmailChallenge: function () {
													return W;
												},
												verifyPhoneChallenge: function () {
													return Q;
												},
											});
										var r = n(5861),
											o = n(4687),
											i = n.n(o),
											a = n(4942),
											s = n(1002),
											l = n(4925),
											u = n(3144),
											c = n(5671),
											d = ['headers'],
											f = (0, u.Z)(function e(t, n) {
												var r = this;
												(0, c.Z)(this, e), (0, a.Z)(this, 'headers', void 0);
												var o = n.res,
													i = o.headers,
													s = (0, l.Z)(o, d);
												i && (this.headers = i),
													Object.keys(s).forEach(function (e) {
														'_links' !== e && (r[e] = s[e]);
													});
											}),
											p = n(5385),
											h = n(9123);
										function m(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function v(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? m(Object(n), !0).forEach(function (t) {
															(0, a.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: m(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function g(e, t) {
											return y.apply(this, arguments);
										}
										function y() {
											return (
												(y = (0, r.Z)(
													i().mark(function e(t, n) {
														var r,
															o,
															a,
															s,
															l,
															u,
															c,
															d,
															m,
															g,
															y,
															b = arguments;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		if (
																			((r = b.length > 2 && void 0 !== b[2] ? b[2] : f),
																			(o = t.tokenManager.getTokensSync()),
																			(a = o.accessToken),
																			(s = n.accessToken || (null == a ? void 0 : a.accessToken)),
																			(l = t.getIssuerOrigin()),
																			(u = n.url),
																			(c = n.method),
																			(d = n.payload),
																			(m = u.startsWith(l) ? u : ''.concat(l).concat(u)),
																			s)
																		) {
																			e.next = 8;
																			break;
																		}
																		throw new h.Z('AccessToken is required to request MyAccount API endpoints.');
																	case 8:
																		return (
																			(e.next = 10),
																			(0, p.c3)(
																				t,
																				v(
																					{
																						headers: { Accept: '*/*;okta-version=1.0.0' },
																						accessToken: s,
																						url: m,
																						method: c,
																					},
																					d && { args: d }
																				)
																			)
																		);
																	case 10:
																		return (
																			(g = e.sent),
																			(y = Array.isArray(g)
																				? g.map(function (e) {
																						return new r(t, { res: e, accessToken: s });
																				  })
																				: new r(t, { res: g, accessToken: s })),
																			e.abrupt('return', y)
																		);
																	case 13:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												y.apply(this, arguments)
											);
										}
										function b(e) {
											for (
												var t = e.oktaAuth,
													n = e.accessToken,
													o = e.methodName,
													a = e.links,
													l = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : f,
													u = function () {
														var e,
															s = d[c];
														if (s.toLowerCase() === o) {
															var u = a.self;
															return {
																v:
																	((e = (0, r.Z)(
																		i().mark(function e(r) {
																			return i().wrap(function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							return e.abrupt(
																								'return',
																								g(t, { accessToken: n, url: u.href, method: s, payload: r }, l)
																							);
																						case 1:
																						case 'end':
																							return e.stop();
																					}
																			}, e);
																		})
																	)),
																	function (t) {
																		return e.apply(this, arguments);
																	}),
															};
														}
													},
													c = 0,
													d = ['GET', 'POST', 'PUT', 'DELETE'];
												c < d.length;
												c++
											) {
												var p = u();
												if ('object' === (0, s.Z)(p)) return p.v;
											}
											var m,
												v = a[o];
											if (!v) throw new h.Z('No link is found with methodName: '.concat(o));
											return (
												(m = (0, r.Z)(
													i().mark(function e(r) {
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return e.abrupt(
																			'return',
																			g(t, { accessToken: n, url: v.href, method: v.hints.allow[0], payload: r }, l)
																		);
																	case 1:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												function (e) {
													return m.apply(this, arguments);
												}
											);
										}
										var _,
											w,
											O,
											k,
											x,
											E,
											T,
											S = n(7326),
											A = n(136),
											C = n(2963),
											P = n(1120),
											R = (function (e) {
												(0, A.Z)(o, e);
												var t,
													n,
													r =
														((t = o),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, P.Z)(t);
															if (n) {
																var o = (0, P.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, C.Z)(this, e);
														});
												function o(e, t) {
													var n;
													(0, c.Z)(this, o),
														(n = r.call(this, e, t)),
														(0, a.Z)((0, S.Z)(n), 'createdAt', void 0),
														(0, a.Z)((0, S.Z)(n), 'modifiedAt', void 0),
														(0, a.Z)((0, S.Z)(n), 'profile', void 0);
													var i = t.res,
														s = i.createdAt,
														l = i.modifiedAt,
														u = i.profile;
													return (n.createdAt = s), (n.modifiedAt = l), (n.profile = u), n;
												}
												return (0, u.Z)(o);
											})(f),
											I = (function (e) {
												(0, A.Z)(o, e);
												var t,
													n,
													r =
														((t = o),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, P.Z)(t);
															if (n) {
																var o = (0, P.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, C.Z)(this, e);
														});
												function o(e, t) {
													var n;
													return (
														(0, c.Z)(this, o),
														(n = r.call(this, e, t)),
														(0, a.Z)((0, S.Z)(n), 'properties', void 0),
														(n.properties = t.res.properties),
														n
													);
												}
												return (0, u.Z)(o);
											})(f),
											N =
												((_ = (0, r.Z)(
													i().mark(function e(t, n) {
														var r;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(e.next = 2),
																			g(
																				t,
																				{
																					url: '/idp/myaccount/profile',
																					method: 'GET',
																					accessToken: null == n ? void 0 : n.accessToken,
																				},
																				R
																			)
																		);
																	case 2:
																		return (r = e.sent), e.abrupt('return', r);
																	case 4:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												function (e, t) {
													return _.apply(this, arguments);
												}),
											M =
												((w = (0, r.Z)(
													i().mark(function e(t, n) {
														var r, o, a, s;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(o = (r = n).payload),
																			(a = r.accessToken),
																			(e.next = 3),
																			g(
																				t,
																				{ url: '/idp/myaccount/profile', method: 'PUT', payload: o, accessToken: a },
																				R
																			)
																		);
																	case 3:
																		return (s = e.sent), e.abrupt('return', s);
																	case 5:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												function (e, t) {
													return w.apply(this, arguments);
												}),
											j =
												((O = (0, r.Z)(
													i().mark(function e(t, n) {
														var r;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(e.next = 2),
																			g(
																				t,
																				{
																					url: '/idp/myaccount/profile/schema',
																					method: 'GET',
																					accessToken: null == n ? void 0 : n.accessToken,
																				},
																				I
																			)
																		);
																	case 2:
																		return (r = e.sent), e.abrupt('return', r);
																	case 4:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												function (e, t) {
													return O.apply(this, arguments);
												}),
											D = (function (e) {
												(0, A.Z)(o, e);
												var t,
													n,
													r =
														((t = o),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, P.Z)(t);
															if (n) {
																var o = (0, P.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, C.Z)(this, e);
														});
												function o(e, t) {
													var n;
													(0, c.Z)(this, o),
														(n = r.call(this, e, t)),
														(0, a.Z)((0, S.Z)(n), 'id', void 0),
														(0, a.Z)((0, S.Z)(n), 'expiresAt', void 0),
														(0, a.Z)((0, S.Z)(n), 'profile', void 0),
														(0, a.Z)((0, S.Z)(n), 'status', void 0);
													var i = t.res,
														s = i.id,
														l = i.profile,
														u = i.expiresAt,
														d = i.status;
													return (n.id = s), (n.expiresAt = u), (n.profile = l), (n.status = d), n;
												}
												return (0, u.Z)(o);
											})(f),
											L = (function (e) {
												(0, A.Z)(s, e);
												var t,
													n,
													o =
														((t = s),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, P.Z)(t);
															if (n) {
																var o = (0, P.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, C.Z)(this, e);
														});
												function s(e, t) {
													var n;
													(0, c.Z)(this, s),
														(n = o.call(this, e, t)),
														(0, a.Z)((0, S.Z)(n), 'id', void 0),
														(0, a.Z)((0, S.Z)(n), 'expiresAt', void 0),
														(0, a.Z)((0, S.Z)(n), 'profile', void 0),
														(0, a.Z)((0, S.Z)(n), 'status', void 0),
														(0, a.Z)((0, S.Z)(n), 'poll', void 0),
														(0, a.Z)((0, S.Z)(n), 'verify', void 0);
													var l = t.accessToken,
														u = t.res,
														d = u.id,
														f = u.expiresAt,
														p = u.profile,
														h = u.status,
														m = u._links;
													return (
														(n.id = d),
														(n.expiresAt = f),
														(n.profile = p),
														(n.status = h),
														(n.poll = (0, r.Z)(
															i().mark(function t() {
																var n;
																return i().wrap(function (t) {
																	for (;;)
																		switch ((t.prev = t.next)) {
																			case 0:
																				return (
																					(n = b({ oktaAuth: e, accessToken: l, methodName: 'poll', links: m }, D)),
																					(t.next = 3),
																					n()
																				);
																			case 3:
																				return t.abrupt('return', t.sent);
																			case 4:
																			case 'end':
																				return t.stop();
																		}
																}, t);
															})
														)),
														(n.verify = (function () {
															var t = (0, r.Z)(
																i().mark(function t(n) {
																	var r;
																	return i().wrap(function (t) {
																		for (;;)
																			switch ((t.prev = t.next)) {
																				case 0:
																					return (
																						(r = b({ oktaAuth: e, accessToken: l, methodName: 'verify', links: m }, s)),
																						(t.next = 3),
																						r(n)
																					);
																				case 3:
																					return t.abrupt('return', t.sent);
																				case 4:
																				case 'end':
																					return t.stop();
																			}
																	}, t);
																})
															);
															return function (e) {
																return t.apply(this, arguments);
															};
														})()),
														n
													);
												}
												return (0, u.Z)(s);
											})(f),
											U = (function (e) {
												(0, A.Z)(s, e);
												var t,
													n,
													o =
														((t = s),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, P.Z)(t);
															if (n) {
																var o = (0, P.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, C.Z)(this, e);
														});
												function s(e, t) {
													var n;
													(0, c.Z)(this, s),
														(n = o.call(this, e, t)),
														(0, a.Z)((0, S.Z)(n), 'id', void 0),
														(0, a.Z)((0, S.Z)(n), 'profile', void 0),
														(0, a.Z)((0, S.Z)(n), 'roles', void 0),
														(0, a.Z)((0, S.Z)(n), 'status', void 0),
														(0, a.Z)((0, S.Z)(n), 'get', void 0),
														(0, a.Z)((0, S.Z)(n), 'delete', void 0),
														(0, a.Z)((0, S.Z)(n), 'challenge', void 0),
														(0, a.Z)((0, S.Z)(n), 'poll', void 0),
														(0, a.Z)((0, S.Z)(n), 'verify', void 0);
													var l,
														u = t.accessToken,
														d = t.res,
														f = d.id,
														p = d.profile,
														h = d.roles,
														m = d.status,
														v = d._links;
													return (
														(n.id = f),
														(n.profile = p),
														(n.roles = h),
														(n.status = m),
														(n.get = (0, r.Z)(
															i().mark(function t() {
																var n;
																return i().wrap(function (t) {
																	for (;;)
																		switch ((t.prev = t.next)) {
																			case 0:
																				return (
																					(n = b({ oktaAuth: e, accessToken: u, methodName: 'get', links: v }, s)),
																					(t.next = 3),
																					n()
																				);
																			case 3:
																				return t.abrupt('return', t.sent);
																			case 4:
																			case 'end':
																				return t.stop();
																		}
																}, t);
															})
														)),
														(n.delete = (0, r.Z)(
															i().mark(function t() {
																var n;
																return i().wrap(function (t) {
																	for (;;)
																		switch ((t.prev = t.next)) {
																			case 0:
																				return (
																					(n = b({ oktaAuth: e, accessToken: u, methodName: 'delete', links: v })),
																					(t.next = 3),
																					n()
																				);
																			case 3:
																				return t.abrupt('return', t.sent);
																			case 4:
																			case 'end':
																				return t.stop();
																		}
																}, t);
															})
														)),
														(n.challenge = (0, r.Z)(
															i().mark(function t() {
																var n;
																return i().wrap(function (t) {
																	for (;;)
																		switch ((t.prev = t.next)) {
																			case 0:
																				return (
																					(n = b(
																						{ oktaAuth: e, accessToken: u, methodName: 'challenge', links: v },
																						L
																					)),
																					(t.next = 3),
																					n()
																				);
																			case 3:
																				return t.abrupt('return', t.sent);
																			case 4:
																			case 'end':
																				return t.stop();
																		}
																}, t);
															})
														)),
														v.poll &&
															(n.poll = (0, r.Z)(
																i().mark(function t() {
																	var n;
																	return i().wrap(function (t) {
																		for (;;)
																			switch ((t.prev = t.next)) {
																				case 0:
																					return (
																						(n = b({ oktaAuth: e, accessToken: u, methodName: 'poll', links: v }, D)),
																						(t.next = 3),
																						n()
																					);
																				case 3:
																					return t.abrupt('return', t.sent);
																				case 4:
																				case 'end':
																					return t.stop();
																			}
																	}, t);
																})
															)),
														v.verify &&
															(n.verify =
																((l = (0, r.Z)(
																	i().mark(function t(n) {
																		var r;
																		return i().wrap(function (t) {
																			for (;;)
																				switch ((t.prev = t.next)) {
																					case 0:
																						return (
																							(r = b({ oktaAuth: e, accessToken: u, methodName: 'verify', links: v })),
																							(t.next = 3),
																							r(n)
																						);
																					case 3:
																						return t.abrupt('return', t.sent);
																					case 4:
																					case 'end':
																						return t.stop();
																				}
																		}, t);
																	})
																)),
																function (e) {
																	return l.apply(this, arguments);
																})),
														n
													);
												}
												return (0, u.Z)(s);
											})(f),
											F = (function () {
												var e = (0, r.Z)(
													i().mark(function e(t, n) {
														var r;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(e.next = 2),
																			g(
																				t,
																				{
																					url: '/idp/myaccount/emails',
																					method: 'GET',
																					accessToken: null == n ? void 0 : n.accessToken,
																				},
																				U
																			)
																		);
																	case 2:
																		return (r = e.sent), e.abrupt('return', r);
																	case 4:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												);
												return function (t, n) {
													return e.apply(this, arguments);
												};
											})(),
											B = (function () {
												var e = (0, r.Z)(
													i().mark(function e(t, n) {
														var r, o, a, s;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(o = (r = n).id),
																			(a = r.accessToken),
																			(e.next = 3),
																			g(
																				t,
																				{ url: '/idp/myaccount/emails/'.concat(o), method: 'GET', accessToken: a },
																				U
																			)
																		);
																	case 3:
																		return (s = e.sent), e.abrupt('return', s);
																	case 5:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												);
												return function (t, n) {
													return e.apply(this, arguments);
												};
											})(),
											V = (function () {
												var e = (0, r.Z)(
													i().mark(function e(t, n) {
														var r, o, a, s;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(o = (r = n).accessToken),
																			(a = r.payload),
																			(e.next = 3),
																			g(
																				t,
																				{ url: '/idp/myaccount/emails', method: 'POST', payload: a, accessToken: o },
																				U
																			)
																		);
																	case 3:
																		return (s = e.sent), e.abrupt('return', s);
																	case 5:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												);
												return function (t, n) {
													return e.apply(this, arguments);
												};
											})(),
											Z =
												((k = (0, r.Z)(
													i().mark(function e(t, n) {
														var r, o, a, s;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(o = (r = n).id),
																			(a = r.accessToken),
																			(e.next = 3),
																			g(t, {
																				url: '/idp/myaccount/emails/'.concat(o),
																				method: 'DELETE',
																				accessToken: a,
																			})
																		);
																	case 3:
																		return (s = e.sent), e.abrupt('return', s);
																	case 5:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												function (e, t) {
													return k.apply(this, arguments);
												}),
											H =
												((x = (0, r.Z)(
													i().mark(function e(t, n) {
														var r, o, a, s;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(o = (r = n).id),
																			(a = r.accessToken),
																			(e.next = 3),
																			g(
																				t,
																				{
																					url: '/idp/myaccount/emails/'.concat(o, '/challenge'),
																					method: 'POST',
																					accessToken: a,
																				},
																				L
																			)
																		);
																	case 3:
																		return (s = e.sent), e.abrupt('return', s);
																	case 5:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												function (e, t) {
													return x.apply(this, arguments);
												}),
											q =
												((E = (0, r.Z)(
													i().mark(function e(t, n) {
														var r, o, a, s, l;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(o = (r = n).emailId),
																			(a = r.challengeId),
																			(s = r.accessToken),
																			(e.next = 3),
																			g(
																				t,
																				{
																					url: '/idp/myaccount/emails/'.concat(o, '/challenge/').concat(a),
																					method: 'POST',
																					accessToken: s,
																				},
																				L
																			)
																		);
																	case 3:
																		return (l = e.sent), e.abrupt('return', l);
																	case 5:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												function (e, t) {
													return E.apply(this, arguments);
												}),
											W =
												((T = (0, r.Z)(
													i().mark(function e(t, n) {
														var r, o, a, s, l, u;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(o = (r = n).emailId),
																			(a = r.challengeId),
																			(s = r.payload),
																			(l = r.accessToken),
																			(e.next = 3),
																			g(t, {
																				url: '/idp/myaccount/emails/'.concat(o, '/challenge/').concat(a, '/verify'),
																				method: 'POST',
																				payload: s,
																				accessToken: l,
																			})
																		);
																	case 3:
																		return (u = e.sent), e.abrupt('return', u);
																	case 5:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												function (e, t) {
													return T.apply(this, arguments);
												}),
											K = (function (e) {
												(0, A.Z)(s, e);
												var t,
													n,
													o =
														((t = s),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, P.Z)(t);
															if (n) {
																var o = (0, P.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, C.Z)(this, e);
														});
												function s(e, t) {
													var n;
													(0, c.Z)(this, s),
														(n = o.call(this, e, t)),
														(0, a.Z)((0, S.Z)(n), 'id', void 0),
														(0, a.Z)((0, S.Z)(n), 'profile', void 0),
														(0, a.Z)((0, S.Z)(n), 'status', void 0),
														(0, a.Z)((0, S.Z)(n), 'get', void 0),
														(0, a.Z)((0, S.Z)(n), 'delete', void 0),
														(0, a.Z)((0, S.Z)(n), 'challenge', void 0),
														(0, a.Z)((0, S.Z)(n), 'verify', void 0);
													var l,
														u = t.res,
														d = t.accessToken,
														f = u.id,
														p = u.profile,
														h = u.status,
														m = u._links;
													return (
														(n.id = f),
														(n.profile = p),
														(n.status = h),
														(n.get = (0, r.Z)(
															i().mark(function t() {
																var n;
																return i().wrap(function (t) {
																	for (;;)
																		switch ((t.prev = t.next)) {
																			case 0:
																				return (
																					(n = b({ oktaAuth: e, accessToken: d, methodName: 'get', links: m }, s)),
																					(t.next = 3),
																					n()
																				);
																			case 3:
																				return t.abrupt('return', t.sent);
																			case 4:
																			case 'end':
																				return t.stop();
																		}
																}, t);
															})
														)),
														(n.delete = (0, r.Z)(
															i().mark(function t() {
																var n;
																return i().wrap(function (t) {
																	for (;;)
																		switch ((t.prev = t.next)) {
																			case 0:
																				return (
																					(n = b({ oktaAuth: e, accessToken: d, methodName: 'delete', links: m })),
																					(t.next = 3),
																					n()
																				);
																			case 3:
																				return t.abrupt('return', t.sent);
																			case 4:
																			case 'end':
																				return t.stop();
																		}
																}, t);
															})
														)),
														(n.challenge =
															((l = (0, r.Z)(
																i().mark(function t(n) {
																	var r;
																	return i().wrap(function (t) {
																		for (;;)
																			switch ((t.prev = t.next)) {
																				case 0:
																					return (
																						(r = b({ oktaAuth: e, accessToken: d, methodName: 'challenge', links: m })),
																						(t.next = 3),
																						r(n)
																					);
																				case 3:
																					return t.abrupt('return', t.sent);
																				case 4:
																				case 'end':
																					return t.stop();
																			}
																	}, t);
																})
															)),
															function (e) {
																return l.apply(this, arguments);
															})),
														m.verify &&
															(n.verify = (function () {
																var t = (0, r.Z)(
																	i().mark(function t(n) {
																		var r;
																		return i().wrap(function (t) {
																			for (;;)
																				switch ((t.prev = t.next)) {
																					case 0:
																						return (
																							(r = b({ oktaAuth: e, accessToken: d, methodName: 'verify', links: m })),
																							(t.next = 3),
																							r(n)
																						);
																					case 3:
																						return t.abrupt('return', t.sent);
																					case 4:
																					case 'end':
																						return t.stop();
																				}
																		}, t);
																	})
																);
																return function (e) {
																	return t.apply(this, arguments);
																};
															})()),
														n
													);
												}
												return (0, u.Z)(s);
											})(f),
											$ = (function () {
												var e = (0, r.Z)(
													i().mark(function e(t, n) {
														var r;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(e.next = 2),
																			g(
																				t,
																				{
																					url: '/idp/myaccount/phones',
																					method: 'GET',
																					accessToken: null == n ? void 0 : n.accessToken,
																				},
																				K
																			)
																		);
																	case 2:
																		return (r = e.sent), e.abrupt('return', r);
																	case 4:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												);
												return function (t, n) {
													return e.apply(this, arguments);
												};
											})(),
											z = (function () {
												var e = (0, r.Z)(
													i().mark(function e(t, n) {
														var r, o, a, s;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(o = (r = n).accessToken),
																			(a = r.id),
																			(e.next = 3),
																			g(
																				t,
																				{ url: '/idp/myaccount/phones/'.concat(a), method: 'GET', accessToken: o },
																				K
																			)
																		);
																	case 3:
																		return (s = e.sent), e.abrupt('return', s);
																	case 5:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												);
												return function (t, n) {
													return e.apply(this, arguments);
												};
											})(),
											G = (function () {
												var e = (0, r.Z)(
													i().mark(function e(t, n) {
														var r, o, a, s;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(o = (r = n).accessToken),
																			(a = r.payload),
																			(e.next = 3),
																			g(
																				t,
																				{ url: '/idp/myaccount/phones', method: 'POST', payload: a, accessToken: o },
																				K
																			)
																		);
																	case 3:
																		return (s = e.sent), e.abrupt('return', s);
																	case 5:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												);
												return function (t, n) {
													return e.apply(this, arguments);
												};
											})(),
											Y = (function () {
												var e = (0, r.Z)(
													i().mark(function e(t, n) {
														var r, o, a, s;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(o = (r = n).id),
																			(a = r.accessToken),
																			(e.next = 3),
																			g(t, {
																				url: '/idp/myaccount/phones/'.concat(o),
																				method: 'DELETE',
																				accessToken: a,
																			})
																		);
																	case 3:
																		return (s = e.sent), e.abrupt('return', s);
																	case 5:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												);
												return function (t, n) {
													return e.apply(this, arguments);
												};
											})(),
											J = (function () {
												var e = (0, r.Z)(
													i().mark(function e(t, n) {
														var r, o, a, s, l;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(o = (r = n).accessToken),
																			(a = r.id),
																			(s = r.payload),
																			(e.next = 3),
																			g(t, {
																				url: '/idp/myaccount/phones/'.concat(a, '/challenge'),
																				method: 'POST',
																				payload: s,
																				accessToken: o,
																			})
																		);
																	case 3:
																		return (l = e.sent), e.abrupt('return', l);
																	case 5:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												);
												return function (t, n) {
													return e.apply(this, arguments);
												};
											})(),
											Q = (function () {
												var e = (0, r.Z)(
													i().mark(function e(t, n) {
														var r, o, a, s, l;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(o = (r = n).id),
																			(a = r.payload),
																			(s = r.accessToken),
																			(e.next = 3),
																			g(t, {
																				url: '/idp/myaccount/phones/'.concat(o, '/verify'),
																				method: 'POST',
																				payload: a,
																				accessToken: s,
																			})
																		);
																	case 3:
																		return (l = e.sent), e.abrupt('return', l);
																	case 5:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												);
												return function (t, n) {
													return e.apply(this, arguments);
												};
											})(),
											X = n(8008),
											ee = (function (e) {
												(0, A.Z)(s, e);
												var t,
													n,
													o =
														((t = s),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, P.Z)(t);
															if (n) {
																var o = (0, P.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, C.Z)(this, e);
														});
												function s(e, t) {
													var n;
													(0, c.Z)(this, s),
														(n = o.call(this, e, t)),
														(0, a.Z)((0, S.Z)(n), 'id', void 0),
														(0, a.Z)((0, S.Z)(n), 'created', void 0),
														(0, a.Z)((0, S.Z)(n), 'lastUpdated', void 0),
														(0, a.Z)((0, S.Z)(n), 'status', void 0),
														(0, a.Z)((0, S.Z)(n), 'get', void 0),
														(0, a.Z)((0, S.Z)(n), 'enroll', void 0),
														(0, a.Z)((0, S.Z)(n), 'update', void 0),
														(0, a.Z)((0, S.Z)(n), 'delete', void 0);
													var l,
														u = t.res,
														d = t.accessToken,
														f = u.id,
														p = u.status,
														h = u.created,
														m = u.lastUpdated,
														v = u._links;
													return (
														(n.id = f),
														(n.status = p),
														(n.created = h),
														(n.lastUpdated = m),
														n.status == X.Fn.NOT_ENROLLED
															? (n.enroll = (function () {
																	var t = (0, r.Z)(
																		i().mark(function t(n) {
																			var r;
																			return i().wrap(function (t) {
																				for (;;)
																					switch ((t.prev = t.next)) {
																						case 0:
																							return (
																								(r = b(
																									{ oktaAuth: e, accessToken: d, methodName: 'enroll', links: v },
																									s
																								)),
																								(t.next = 3),
																								r(n)
																							);
																						case 3:
																							return t.abrupt('return', t.sent);
																						case 4:
																						case 'end':
																							return t.stop();
																					}
																			}, t);
																		})
																	);
																	return function (e) {
																		return t.apply(this, arguments);
																	};
															  })())
															: ((n.get = (0, r.Z)(
																	i().mark(function t() {
																		var n;
																		return i().wrap(function (t) {
																			for (;;)
																				switch ((t.prev = t.next)) {
																					case 0:
																						return (
																							(n = b({ oktaAuth: e, accessToken: d, methodName: 'get', links: v }, s)),
																							(t.next = 3),
																							n()
																						);
																					case 3:
																						return t.abrupt('return', t.sent);
																					case 4:
																					case 'end':
																						return t.stop();
																				}
																		}, t);
																	})
															  )),
															  (n.update =
																	((l = (0, r.Z)(
																		i().mark(function t(n) {
																			var r;
																			return i().wrap(function (t) {
																				for (;;)
																					switch ((t.prev = t.next)) {
																						case 0:
																							return (
																								(r = b(
																									{ oktaAuth: e, accessToken: d, methodName: 'put', links: v },
																									s
																								)),
																								(t.next = 3),
																								r(n)
																							);
																						case 3:
																							return t.abrupt('return', t.sent);
																						case 4:
																						case 'end':
																							return t.stop();
																					}
																			}, t);
																		})
																	)),
																	function (e) {
																		return l.apply(this, arguments);
																	})),
															  (n.delete = (0, r.Z)(
																	i().mark(function t() {
																		var n;
																		return i().wrap(function (t) {
																			for (;;)
																				switch ((t.prev = t.next)) {
																					case 0:
																						return (
																							(n = b({ oktaAuth: e, accessToken: d, methodName: 'delete', links: v })),
																							(t.next = 3),
																							n()
																						);
																					case 3:
																						return t.abrupt('return', t.sent);
																					case 4:
																					case 'end':
																						return t.stop();
																				}
																		}, t);
																	})
															  ))),
														n
													);
												}
												return (0, u.Z)(s);
											})(f),
											te = (function () {
												var e = (0, r.Z)(
													i().mark(function e(t, n) {
														var r;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(e.next = 2),
																			g(
																				t,
																				{
																					url: '/idp/myaccount/password',
																					method: 'GET',
																					accessToken: null == n ? void 0 : n.accessToken,
																				},
																				ee
																			)
																		);
																	case 2:
																		return (r = e.sent), e.abrupt('return', r);
																	case 4:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												);
												return function (t, n) {
													return e.apply(this, arguments);
												};
											})(),
											ne = (function () {
												var e = (0, r.Z)(
													i().mark(function e(t, n) {
														var r, o, a, s;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(o = (r = n).accessToken),
																			(a = r.payload),
																			(e.next = 3),
																			g(
																				t,
																				{ url: '/idp/myaccount/password', method: 'POST', payload: a, accessToken: o },
																				ee
																			)
																		);
																	case 3:
																		return (s = e.sent), e.abrupt('return', s);
																	case 5:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												);
												return function (t, n) {
													return e.apply(this, arguments);
												};
											})(),
											re = (function () {
												var e = (0, r.Z)(
													i().mark(function e(t, n) {
														var r, o, a, s;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(o = (r = n).accessToken),
																			(a = r.payload),
																			(e.next = 3),
																			g(
																				t,
																				{ url: '/idp/myaccount/password', method: 'PUT', payload: a, accessToken: o },
																				ee
																			)
																		);
																	case 3:
																		return (s = e.sent), e.abrupt('return', s);
																	case 5:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												);
												return function (t, n) {
													return e.apply(this, arguments);
												};
											})(),
											oe = (function () {
												var e = (0, r.Z)(
													i().mark(function e(t, n) {
														var r;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		return (
																			(e.next = 2),
																			g(t, {
																				url: '/idp/myaccount/password',
																				method: 'DELETE',
																				accessToken: null == n ? void 0 : n.accessToken,
																			})
																		);
																	case 2:
																		return (r = e.sent), e.abrupt('return', r);
																	case 4:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												);
												return function (t, n) {
													return e.apply(this, arguments);
												};
											})();
									},
									1132: function (e, t, n) {
										'use strict';
										n.d(t, {
											aw: function () {
												return s.aw;
											},
											Fn: function () {
												return s.Fn;
											},
											qb: function () {
												return s.qb;
											},
											no: function () {
												return r.addEmail;
											},
											Z1: function () {
												return r.addPhone;
											},
											Xc: function () {
												return a;
											},
											nd: function () {
												return r.deleteEmail;
											},
											QN: function () {
												return r.deletePassword;
											},
											qj: function () {
												return r.deletePhone;
											},
											xg: function () {
												return r.enrollPassword;
											},
											OD: function () {
												return r.getEmail;
											},
											hG: function () {
												return r.getEmailChallenge;
											},
											G5: function () {
												return r.getEmails;
											},
											Ij: function () {
												return r.getPassword;
											},
											u_: function () {
												return r.getPhone;
											},
											Po: function () {
												return r.getPhones;
											},
											Ai: function () {
												return r.getProfile;
											},
											aF: function () {
												return r.getProfileSchema;
											},
											HT: function () {
												return i.H;
											},
											ME: function () {
												return r.sendEmailChallenge;
											},
											dv: function () {
												return r.sendPhoneChallenge;
											},
											gQ: function () {
												return r.updatePassword;
											},
											ck: function () {
												return r.updateProfile;
											},
											T8: function () {
												return r.verifyEmailChallenge;
											},
											Lo: function () {
												return r.verifyPhoneChallenge;
											},
										});
										var r = n(9108),
											o = n(1578),
											i = n(6794);
										function a(e, t, n) {
											var r = (0, o.K)(e, t, n);
											return (0, i.H)(r);
										}
										var s = n(8008);
									},
									6794: function (e, t, n) {
										'use strict';
										n.d(t, {
											H: function () {
												return f;
											},
										});
										var r = n(885),
											o = n(3144),
											i = n(5671),
											a = n(7326),
											s = n(136),
											l = n(2963),
											u = n(1120),
											c = n(4942),
											d = n(9108);
										function f(e) {
											return (function (e) {
												(0, s.Z)(p, e);
												var t,
													n,
													f =
														((t = p),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, u.Z)(t);
															if (n) {
																var o = (0, u.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, l.Z)(this, e);
														});
												function p() {
													var e;
													(0, i.Z)(this, p);
													for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) n[o] = arguments[o];
													return (
														(e = f.call.apply(f, [this].concat(n))),
														(0, c.Z)((0, a.Z)(e), 'myaccount', void 0),
														(e.myaccount = Object.entries(d)
															.filter(function (e) {
																return 'default' !== (0, r.Z)(e, 1)[0];
															})
															.reduce(function (t, n) {
																var o = (0, r.Z)(n, 2),
																	i = o[0],
																	s = o[1];
																return (t[i] = s.bind(null, (0, a.Z)(e))), t;
															}, {})),
														e
													);
												}
												return (0, o.Z)(p);
											})(e);
										}
									},
									8008: function (e, t, n) {
										'use strict';
										var r, o, i;
										n.d(t, {
											Fn: function () {
												return i;
											},
											aw: function () {
												return r;
											},
											qb: function () {
												return o;
											},
										}),
											(function (e) {
												(e.PRIMARY = 'PRIMARY'), (e.SECONDARY = 'SECONDARY');
											})(r || (r = {})),
											(function (e) {
												(e.VERIFIED = 'VERIFIED'), (e.UNVERIFIED = 'UNVERIFIED');
											})(o || (o = {})),
											(function (e) {
												(e.NOT_ENROLLED = 'NOT_ENROLLED'), (e.ACTIVE = 'ACTIVE');
											})(i || (i = {}));
									},
									2427: function (e, t, n) {
										'use strict';
										n.d(t, {
											M: function () {
												return w;
											},
										});
										var r = n(5861),
											o = n(1002),
											i = n(5671),
											a = n(3144),
											s = n(4942),
											l = n(4687),
											u = n.n(l),
											c = n(3193),
											d = n(9123),
											f = n(2482),
											p = n(415),
											h = (function () {
												function e(t) {
													(0, i.Z)(this, e),
														(0, s.Z)(this, 'localOffset', void 0),
														(this.localOffset = parseInt(t || 0));
												}
												return (
													(0, a.Z)(
														e,
														[
															{
																key: 'now',
																value: function () {
																	return (Date.now() + this.localOffset) / 1e3;
																},
															},
														],
														[
															{
																key: 'create',
																value: function () {
																	return new e(0);
																},
															},
														]
													),
													e
												);
											})(),
											m = n(7088),
											v = n(6488),
											g = n(1971);
										function y(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function b(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? y(Object(n), !0).forEach(function (t) {
															(0, s.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: y(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										var _ = {
												autoRenew: !0,
												autoRemove: !0,
												syncStorage: !0,
												clearPendingRemoveTokens: !0,
												storage: void 0,
												expireEarlySeconds: 30,
												storageKey: g.TOKEN_STORAGE_NAME,
											},
											w = (function () {
												function e(t) {
													var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
													if (
														((0, i.Z)(this, e),
														(0, s.Z)(this, 'sdk', void 0),
														(0, s.Z)(this, 'clock', void 0),
														(0, s.Z)(this, 'emitter', void 0),
														(0, s.Z)(this, 'storage', void 0),
														(0, s.Z)(this, 'state', void 0),
														(0, s.Z)(this, 'options', void 0),
														(this.sdk = t),
														(this.emitter = t.emitter),
														!this.emitter)
													)
														throw new d.Z('Emitter should be initialized before TokenManager');
													(n = Object.assign({}, _, (0, c.YY)(n))),
														(0, p.isLocalhost)() || (n.expireEarlySeconds = _.expireEarlySeconds),
														(this.options = n);
													var r = (0, c.YY)({ storageKey: n.storageKey, secure: n.secure });
													'object' === (0, o.Z)(n.storage)
														? (r.storageProvider = n.storage)
														: n.storage && (r.storageType = n.storage),
														(this.storage = t.storageManager.getTokenStorage(
															b(b({}, r), {}, { useSeparateCookies: !0 })
														)),
														(this.clock = h.create()),
														(this.state = { expireTimeouts: {}, renewPromise: null });
												}
												var t, n, l;
												return (
													(0, a.Z)(e, [
														{
															key: 'on',
															value: function (e, t, n) {
																n ? this.emitter.on(e, t, n) : this.emitter.on(e, t);
															},
														},
														{
															key: 'off',
															value: function (e, t) {
																t ? this.emitter.off(e, t) : this.emitter.off(e);
															},
														},
														{
															key: 'start',
															value: function () {
																this.options.clearPendingRemoveTokens && this.clearPendingRemoveTokens(),
																	this.setExpireEventTimeoutAll(),
																	(this.state.started = !0);
															},
														},
														{
															key: 'stop',
															value: function () {
																this.clearExpireEventTimeoutAll(), (this.state.started = !1);
															},
														},
														{
															key: 'isStarted',
															value: function () {
																return !!this.state.started;
															},
														},
														{
															key: 'getOptions',
															value: function () {
																return (0, c.d9)(this.options);
															},
														},
														{
															key: 'getExpireTime',
															value: function (e) {
																var t = this.options.expireEarlySeconds || 0;
																return e.expiresAt - t;
															},
														},
														{
															key: 'hasExpired',
															value: function (e) {
																return this.getExpireTime(e) <= this.clock.now();
															},
														},
														{
															key: 'emitExpired',
															value: function (e, t) {
																this.emitter.emit(m.$Y, e, t);
															},
														},
														{
															key: 'emitRenewed',
															value: function (e, t, n) {
																this.emitter.emit(m.E, e, t, n);
															},
														},
														{
															key: 'emitAdded',
															value: function (e, t) {
																this.emitter.emit(m.O3, e, t);
															},
														},
														{
															key: 'emitRemoved',
															value: function (e, t) {
																this.emitter.emit(m.FT, e, t);
															},
														},
														{
															key: 'emitError',
															value: function (e) {
																this.emitter.emit(m.$I, e);
															},
														},
														{
															key: 'clearExpireEventTimeout',
															value: function (e) {
																clearTimeout(this.state.expireTimeouts[e]),
																	delete this.state.expireTimeouts[e],
																	(this.state.renewPromise = null);
															},
														},
														{
															key: 'clearExpireEventTimeoutAll',
															value: function () {
																var e = this.state.expireTimeouts;
																for (var t in e)
																	Object.prototype.hasOwnProperty.call(e, t) && this.clearExpireEventTimeout(t);
															},
														},
														{
															key: 'setExpireEventTimeout',
															value: function (e, t) {
																var n = this;
																if (!(0, v.z9)(t)) {
																	var r = this.getExpireTime(t),
																		o = 1e3 * Math.max(r - this.clock.now(), 0);
																	this.clearExpireEventTimeout(e);
																	var i = setTimeout(function () {
																		n.emitExpired(e, t);
																	}, o);
																	this.state.expireTimeouts[e] = i;
																}
															},
														},
														{
															key: 'setExpireEventTimeoutAll',
															value: function () {
																var e = this.storage.getStorage();
																for (var t in e)
																	if (Object.prototype.hasOwnProperty.call(e, t)) {
																		var n = e[t];
																		this.setExpireEventTimeout(t, n);
																	}
															},
														},
														{
															key: 'resetExpireEventTimeoutAll',
															value: function () {
																this.clearExpireEventTimeoutAll(), this.setExpireEventTimeoutAll();
															},
														},
														{
															key: 'add',
															value: function (e, t) {
																var n = this.storage.getStorage();
																(0, f.R)(t),
																	(n[e] = t),
																	this.storage.setStorage(n),
																	this.emitSetStorageEvent(),
																	this.emitAdded(e, t),
																	this.setExpireEventTimeout(e, t);
															},
														},
														{
															key: 'getSync',
															value: function (e) {
																return this.storage.getStorage()[e];
															},
														},
														{
															key: 'get',
															value:
																((l = (0, r.Z)(
																	u().mark(function e(t) {
																		return u().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							return e.abrupt('return', this.getSync(t));
																						case 1:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function (e) {
																	return l.apply(this, arguments);
																}),
														},
														{
															key: 'getTokensSync',
															value: function () {
																var e = {},
																	t = this.storage.getStorage();
																return (
																	Object.keys(t).forEach(function (n) {
																		var r = t[n];
																		(0, v.hv)(r)
																			? (e.accessToken = r)
																			: (0, v.sI)(r)
																			? (e.idToken = r)
																			: (0, v.z9)(r) && (e.refreshToken = r);
																	}),
																	e
																);
															},
														},
														{
															key: 'getTokens',
															value:
																((n = (0, r.Z)(
																	u().mark(function e() {
																		return u().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							return e.abrupt('return', this.getTokensSync());
																						case 1:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function () {
																	return n.apply(this, arguments);
																}),
														},
														{
															key: 'getStorageKeyByType',
															value: function (e) {
																var t = this.storage.getStorage();
																return Object.keys(t).filter(function (n) {
																	var r = t[n];
																	return (
																		((0, v.hv)(r) && 'accessToken' === e) ||
																		((0, v.sI)(r) && 'idToken' === e) ||
																		((0, v.z9)(r) && 'refreshToken' === e)
																	);
																})[0];
															},
														},
														{
															key: 'getTokenType',
															value: function (e) {
																if ((0, v.hv)(e)) return 'accessToken';
																if ((0, v.sI)(e)) return 'idToken';
																if ((0, v.z9)(e)) return 'refreshToken';
																throw new d.Z('Unknown token type');
															},
														},
														{
															key: 'emitSetStorageEvent',
															value: function () {
																if ((0, p.isIE11OrLess)()) {
																	var e = this.storage.getStorage();
																	this.emitter.emit(m.zr, e);
																}
															},
														},
														{
															key: 'getStorage',
															value: function () {
																return this.storage;
															},
														},
														{
															key: 'setTokens',
															value: function (e, t, n, r) {
																var o = this,
																	i = function (e, i) {
																		var a = o.getTokenType(i);
																		'accessToken' === a
																			? t && t(e, i)
																			: 'idToken' === a
																			? n && n(e, i)
																			: 'refreshToken' === a && r && r(e, i);
																	},
																	a = function (e, t) {
																		o.emitAdded(e, t), o.setExpireEventTimeout(e, t), i(e, t);
																	},
																	s = function (e, t) {
																		o.clearExpireEventTimeout(e), o.emitRemoved(e, t), i(e, t);
																	},
																	l = ['idToken', 'accessToken', 'refreshToken'],
																	u = this.getTokensSync();
																l.forEach(function (t) {
																	var n = e[t];
																	n && (0, f.R)(n, t);
																});
																var c = l.reduce(function (t, n) {
																	var r = e[n];
																	return r && (t[o.getStorageKeyByType(n) || n] = r), t;
																}, {});
																this.storage.setStorage(c),
																	this.emitSetStorageEvent(),
																	l.forEach(function (t) {
																		var n,
																			r,
																			l,
																			c = e[t],
																			d = u[t],
																			f = o.getStorageKeyByType(t) || t;
																		c && d
																			? (s(f, d),
																			  a(f, c),
																			  (n = f),
																			  (r = c),
																			  (l = d),
																			  o.emitRenewed(n, r, l),
																			  o.clearExpireEventTimeout(n),
																			  o.setExpireEventTimeout(n, r),
																			  i(n, r))
																			: c
																			? a(f, c)
																			: d && s(f, d);
																	});
															},
														},
														{
															key: 'remove',
															value: function (e) {
																this.clearExpireEventTimeout(e);
																var t = this.storage.getStorage(),
																	n = t[e];
																delete t[e],
																	this.storage.setStorage(t),
																	this.emitSetStorageEvent(),
																	this.emitRemoved(e, n);
															},
														},
														{
															key: 'renewToken',
															value:
																((t = (0, r.Z)(
																	u().mark(function e(t) {
																		var n;
																		return u().wrap(
																			function (e) {
																				for (;;)
																					switch ((e.prev = e.next)) {
																						case 0:
																							return e.abrupt(
																								'return',
																								null === (n = this.sdk.token) || void 0 === n ? void 0 : n.renew(t)
																							);
																						case 1:
																						case 'end':
																							return e.stop();
																					}
																			},
																			e,
																			this
																		);
																	})
																)),
																function (e) {
																	return t.apply(this, arguments);
																}),
														},
														{
															key: 'validateToken',
															value: function (e) {
																return (0, f.R)(e);
															},
														},
														{
															key: 'renew',
															value: function (e) {
																var t = this;
																if (this.state.renewPromise) return this.state.renewPromise;
																try {
																	var n = this.getSync(e),
																		r = void 0 !== n;
																	if (!n && 'accessToken' === e) {
																		var o = this.getStorageKeyByType('refreshToken');
																		r = void 0 !== this.getSync(o);
																	}
																	if (!r) throw new d.Z('The tokenManager has no token for the key: ' + e);
																} catch (e) {
																	return this.emitError(e), Promise.reject(e);
																}
																return (
																	this.clearExpireEventTimeout(e),
																	(this.state.renewPromise = this.sdk.token
																		.renewTokens()
																		.then(function (r) {
																			if ((t.setTokens(r), !n && 'accessToken' === e)) {
																				var o = r.accessToken;
																				return t.emitRenewed(e, o, null), o;
																			}
																			return r[t.getTokenType(n)];
																		})
																		.catch(function (n) {
																			throw (t.remove(e), (n.tokenKey = e), t.emitError(n), n);
																		})
																		.finally(function () {
																			t.state.renewPromise = null;
																		}))
																);
															},
														},
														{
															key: 'clear',
															value: function () {
																var e = this,
																	t = this.getTokensSync();
																this.clearExpireEventTimeoutAll(),
																	this.storage.clearStorage(),
																	this.emitSetStorageEvent(),
																	Object.keys(t).forEach(function (n) {
																		e.emitRemoved(n, t[n]);
																	});
															},
														},
														{
															key: 'clearPendingRemoveTokens',
															value: function () {
																var e = this,
																	t = this.storage.getStorage(),
																	n = {};
																Object.keys(t).forEach(function (e) {
																	t[e].pendingRemove && ((n[e] = t[e]), delete t[e]);
																}),
																	this.storage.setStorage(t),
																	this.emitSetStorageEvent(),
																	Object.keys(n).forEach(function (t) {
																		e.clearExpireEventTimeout(t), e.emitRemoved(t, n[t]);
																	});
															},
														},
														{
															key: 'updateRefreshToken',
															value: function (e) {
																var t = this.getStorageKeyByType('refreshToken') || g.REFRESH_TOKEN_STORAGE_KEY,
																	n = this.storage.getStorage();
																(0, f.R)(e), (n[t] = e), this.storage.setStorage(n), this.emitSetStorageEvent();
															},
														},
														{
															key: 'removeRefreshToken',
															value: function () {
																var e = this.getStorageKeyByType('refreshToken') || g.REFRESH_TOKEN_STORAGE_KEY;
																this.remove(e);
															},
														},
														{
															key: 'addPendingRemoveFlags',
															value: function () {
																var e = this.getTokensSync();
																Object.keys(e).forEach(function (t) {
																	e[t].pendingRemove = !0;
																}),
																	this.setTokens(e);
															},
														},
													]),
													e
												);
											})();
									},
									1646: function (e, t, n) {
										'use strict';
										n.d(t, {
											P: function () {
												return u;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(4942),
											a = n(4319),
											s = n(146),
											l = 18e5;
										function u() {
											return (function () {
												function e(t) {
													(0, r.Z)(this, e),
														(0, i.Z)(this, 'options', void 0),
														(0, i.Z)(this, 'storageManager', void 0),
														(0, i.Z)(this, 'enableSharedStorage', void 0),
														(0, i.Z)(this, 'saveLastResponse', void 0),
														(this.storageManager = t.storageManager),
														(this.enableSharedStorage = !1 !== t.enableSharedStorage),
														(this.saveLastResponse = !1 !== t.saveLastResponse),
														(this.options = t);
												}
												return (
													(0, o.Z)(e, [
														{
															key: 'clear',
															value: function () {
																var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
																	t = this.storageManager.getTransactionStorage(),
																	n = t.getStorage();
																if ((t.clearStorage(), this.enableSharedStorage && !1 !== e.clearSharedStorage)) {
																	var r = e.state || (null == n ? void 0 : n.state);
																	r &&
																		(function (e, t) {
																			var n = e.getSharedTansactionStorage(),
																				r = n.getStorage();
																			delete r[t], n.setStorage(r);
																		})(this.storageManager, r);
																}
															},
														},
														{
															key: 'save',
															value: function (e) {
																var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
																	n = this.storageManager.getTransactionStorage(),
																	r = n.getStorage();
																(0, a.mH)(r) &&
																	!t.muteWarning &&
																	(0, s.ZK)(
																		'a saved auth transaction exists in storage. This may indicate another auth flow is already in progress.'
																	),
																	n.setStorage(e),
																	this.enableSharedStorage &&
																		e.state &&
																		(function (e, t, n) {
																			var r = e.getSharedTansactionStorage(),
																				o = r.getStorage();
																			(o[t] = { dateCreated: Date.now(), transaction: n }), r.setStorage(o);
																		})(this.storageManager, e.state, e);
															},
														},
														{
															key: 'exists',
															value: function () {
																var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
																try {
																	return !!this.load(e);
																} catch (e) {
																	return !1;
																}
															},
														},
														{
															key: 'load',
															value: function () {
																var e,
																	t,
																	n,
																	r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
																return this.enableSharedStorage &&
																	r.state &&
																	((t = this.storageManager.getSharedTansactionStorage()),
																	(n = t.getStorage()),
																	Object.keys(n).forEach(function (e) {
																		var t = n[e];
																		Date.now() - t.dateCreated > l && delete n[e];
																	}),
																	t.setStorage(n),
																	(e = (function (e, t) {
																		var n = e.getSharedTansactionStorage().getStorage()[t];
																		return n && n.transaction && (0, a.mH)(n.transaction) ? n.transaction : null;
																	})(this.storageManager, r.state)),
																	(0, a.mH)(e))
																	? e
																	: ((e = this.storageManager.getTransactionStorage().getStorage()),
																	  (0, a.mH)(e) ? e : null);
															},
														},
													]),
													e
												);
											})();
										}
									},
									1237: function (e, t, n) {
										'use strict';
										n.d(t, {
											T: function () {
												return i;
											},
										});
										var r = n(9123),
											o = n(7987);
										function i(e) {
											var t,
												n = e.split('.');
											try {
												t = {
													header: JSON.parse((0, o.Wy)(n[0])),
													payload: JSON.parse((0, o.Wy)(n[1])),
													signature: n[2],
												};
											} catch (e) {
												throw new r.Z('Malformed token');
											}
											return t;
										}
									},
									7659: function (e, t, n) {
										'use strict';
										n.d(t, {
											SO: function () {
												return p;
											},
											V7: function () {
												return C;
											},
											aW: function () {
												return j;
											},
											ao: function () {
												return N;
											},
											cE: function () {
												return L;
											},
											lk: function () {
												return E;
											},
											sd: function () {
												return S;
											},
											vX: function () {
												return R;
											},
										});
										var r = n(2982),
											o = n(5861),
											i = n(4687),
											a = n.n(i),
											s = n(7987),
											l = n(7594),
											u = n(5728),
											c = n(9123),
											d = 'OktaAuthJs',
											f = 'DPoPKeys';
										function p(e) {
											return ((0, u.isOAuthError)(e) || (0, u.isWWWAuthError)(e)) && 'use_dpop_nonce' === e.errorCode;
										}
										function h(e, t, n) {
											return m.apply(this, arguments);
										}
										function m() {
											return (m = (0, o.Z)(
												a().mark(function e(t, n, r) {
													var o, i, u;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	return (
																		(o = (0, s.NL)(JSON.stringify(t))),
																		(i = (0, s.NL)(JSON.stringify(n))),
																		(e.next = 4),
																		l.KP.subtle.sign(
																			{ name: r.algorithm.name },
																			r,
																			(0, s.k8)(''.concat(o, '.').concat(i))
																		)
																	);
																case 4:
																	return (
																		(u = e.sent),
																		e.abrupt(
																			'return',
																			''
																				.concat(o, '.')
																				.concat(i, '.')
																				.concat((0, s.aR)((0, s.kQ)(u)))
																		)
																	);
																case 6:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function v() {
											var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 32;
											return (0, r.Z)(l.KP.getRandomValues(new Uint8Array(e)))
												.map(function (e) {
													return e.toString(16);
												})
												.join('');
										}
										function g() {
											return y.apply(this, arguments);
										}
										function y() {
											return (y = (0, o.Z)(
												a().mark(function e() {
													var t;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	return (
																		(t = {
																			name: 'RSASSA-PKCS1-v1_5',
																			hash: 'SHA-256',
																			modulusLength: 2048,
																			publicExponent: new Uint8Array([1, 0, 1]),
																		}),
																		e.abrupt('return', l.KP.subtle.generateKey(t, !1, ['sign', 'verify']))
																	);
																case 2:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function b(e) {
											return _.apply(this, arguments);
										}
										function _() {
											return (_ = (0, o.Z)(
												a().mark(function e(t) {
													var n, r;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	return (
																		(n = new TextEncoder().encode(t)), (e.next = 3), l.KP.subtle.digest('SHA-256', n)
																	);
																case 3:
																	return (
																		(r = e.sent),
																		e.abrupt(
																			'return',
																			(0, l.r3)(String.fromCharCode.apply(null, new Uint8Array(r)))
																				.replace(/\+/g, '-')
																				.replace(/\//g, '_')
																				.replace(/=+$/, '')
																		)
																	);
																case 5:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function w(e) {
											return O.apply(this, arguments);
										}
										function O() {
											return (
												(O = (0, o.Z)(
													a().mark(function e(t) {
														var n,
															r,
															o,
															i,
															s = arguments;
														return a().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		for (n = s.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
																			r[o - 1] = s[o];
																		return (
																			(e.next = 3),
																			new Promise(function (e, t) {
																				try {
																					var n = window.indexedDB.open(d, 1);
																					(n.onerror = function () {
																						t(n.error);
																					}),
																						(n.onupgradeneeded = function () {
																							n.result.createObjectStore(f);
																						}),
																						(n.onsuccess = function () {
																							var r = n.result,
																								o = r.transaction(f, 'readwrite');
																							o.onerror = function () {
																								t(o.error);
																							};
																							var i = o.objectStore(f);
																							e(i),
																								(o.oncomplete = function () {
																									r.close();
																								});
																						});
																				} catch (e) {
																					t(e);
																				}
																			})
																		);
																	case 3:
																		return (
																			(i = e.sent),
																			e.abrupt(
																				'return',
																				new Promise(function (e, n) {
																					var o = i[t].apply(i, r);
																					(o.onsuccess = function () {
																						e(o);
																					}),
																						(o.onerror = function () {
																							n(o.error);
																						});
																				})
																			)
																		);
																	case 5:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												O.apply(this, arguments)
											);
										}
										function k(e, t) {
											return x.apply(this, arguments);
										}
										function x() {
											return (x = (0, o.Z)(
												a().mark(function e(t, n) {
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	return (e.next = 2), w('add', n, t);
																case 2:
																	return e.abrupt('return', n);
																case 3:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function E(e) {
											return T.apply(this, arguments);
										}
										function T() {
											return (T = (0, o.Z)(
												a().mark(function e(t) {
													var n;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (!t) {
																		e.next = 6;
																		break;
																	}
																	return (e.next = 3), w('get', t);
																case 3:
																	if (!(n = e.sent).result) {
																		e.next = 6;
																		break;
																	}
																	return e.abrupt('return', n.result);
																case 6:
																	throw new c.Z(
																		'Unable to locate dpop key pair required for refresh'.concat(
																			t ? ' ('.concat(t, ')') : ''
																		)
																	);
																case 7:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function S(e) {
											return A.apply(this, arguments);
										}
										function A() {
											return (A = (0, o.Z)(
												a().mark(function e(t) {
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	return (e.next = 2), w('delete', t);
																case 2:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function C() {
											return P.apply(this, arguments);
										}
										function P() {
											return (P = (0, o.Z)(
												a().mark(function e() {
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	return (e.next = 2), w('clear');
																case 2:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function R() {
											return I.apply(this, arguments);
										}
										function I() {
											return (I = (0, o.Z)(
												a().mark(function e() {
													var t, n;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	return (t = v(4)), (e.next = 3), g();
																case 3:
																	return (n = e.sent), (e.next = 6), k(t, n);
																case 6:
																	return e.abrupt('return', { keyPair: n, keyPairId: t });
																case 7:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function N(e, t) {
											return M.apply(this, arguments);
										}
										function M() {
											return (M = (0, o.Z)(
												a().mark(function e(t, n) {
													var r, o, i, s, l;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (
																		((o = !1),
																		(i = n.accessToken),
																		(s = n.refreshToken),
																		'access' === t && i && 'DPoP' === i.tokenType && !s && (o = !0),
																		'refresh' === t && s && !i && (o = !0),
																		(l =
																			null !== (r = null == i ? void 0 : i.dpopPairId) && void 0 !== r
																				? r
																				: null == s
																				? void 0
																				: s.dpopPairId),
																		!o || !l)
																	) {
																		e.next = 8;
																		break;
																	}
																	return (e.next = 8), S(l);
																case 8:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function j(e) {
											return D.apply(this, arguments);
										}
										function D() {
											return (D = (0, o.Z)(
												a().mark(function e(t) {
													var n, r, o, i, s, u, c, d, f, p, m, g, y, _;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	return (
																		(n = t.keyPair),
																		(r = t.url),
																		(o = t.method),
																		(i = t.nonce),
																		(s = t.accessToken),
																		(e.next = 3),
																		l.KP.subtle.exportKey('jwk', n.publicKey)
																	);
																case 3:
																	if (
																		((u = e.sent),
																		(c = u.kty),
																		(d = u.crv),
																		(f = u.e),
																		(p = u.n),
																		(m = u.x),
																		(g = u.y),
																		(y = {
																			alg: 'RS256',
																			typ: 'dpop+jwt',
																			jwk: { kty: c, crv: d, e: f, n: p, x: m, y: g },
																		}),
																		(_ = { htm: o, htu: r, iat: Math.floor(Date.now() / 1e3), jti: v() }),
																		i && (_.nonce = i),
																		!s)
																	) {
																		e.next = 17;
																		break;
																	}
																	return (e.next = 16), b(s);
																case 16:
																	_.ath = e.sent;
																case 17:
																	return e.abrupt('return', h(y, _, n.privateKey));
																case 18:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function L(e) {
											return U.apply(this, arguments);
										}
										function U() {
											return (U = (0, o.Z)(
												a().mark(function e(t) {
													var n, r, o, i, s;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	return (
																		(n = t.keyPair),
																		(r = t.url),
																		(o = t.method),
																		(i = t.nonce),
																		(s = { keyPair: n, url: r, method: o }),
																		i && (s.nonce = i),
																		e.abrupt('return', j(s))
																	);
																case 4:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
									},
									2206: function (e, t, n) {
										'use strict';
										n.d(t, {
											R: function () {
												return d;
											},
											_: function () {
												return c;
											},
										});
										var r = n(4942),
											o = n(4771),
											i = n(3193),
											a = n(6718),
											s = n(9123);
										function l(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function u(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? l(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: l(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function c(e) {
											if (!e.clientId)
												throw new s.Z('A clientId must be specified in the OktaAuth constructor to get a token');
											if ((0, o.HD)(e.responseType) && -1 !== e.responseType.indexOf(' '))
												throw new s.Z('Multiple OAuth responseTypes must be defined as an array');
											var t = {
												client_id: e.clientId,
												code_challenge: e.codeChallenge,
												code_challenge_method: e.codeChallengeMethod,
												display: e.display,
												idp: e.idp,
												idp_scope: e.idpScope,
												login_hint: e.loginHint,
												max_age: e.maxAge,
												nonce: e.nonce,
												prompt: e.prompt,
												redirect_uri: e.redirectUri,
												response_mode: e.responseMode,
												response_type: e.responseType,
												sessionToken: e.sessionToken,
												state: e.state,
												acr_values: e.acrValues,
												enroll_amr_values: e.enrollAmrValues,
											};
											if (
												((t = (0, i.YY)(t)),
												['idp_scope', 'response_type', 'enroll_amr_values'].forEach(function (e) {
													Array.isArray(t[e]) && (t[e] = t[e].join(' '));
												}),
												-1 !== e.responseType.indexOf('id_token') && -1 === e.scopes.indexOf('openid'))
											)
												throw new s.Z(
													'openid scope must be specified in the scopes argument when requesting an id_token'
												);
											return e.scopes && (t.scope = e.scopes.join(' ')), t;
										}
										function d(e) {
											var t = c(e);
											return (0, a.UK)(u(u({}, t), e.extraParams && u({}, e.extraParams)));
										}
									},
									2642: function (e, t, n) {
										'use strict';
										n.d(t, {
											Dp: function () {
												return o.D;
											},
											ES: function () {
												return i.E;
											},
											R0: function () {
												return r.R;
											},
											_6: function () {
												return r._;
											},
											km: function () {
												return i.k;
											},
											ti: function () {
												return o.t;
											},
										});
										var r = n(2206),
											o = n(9231),
											i = n(52);
									},
									9231: function (e, t, n) {
										'use strict';
										n.d(t, {
											D: function () {
												return b;
											},
											t: function () {
												return g;
											},
										});
										var r = n(885),
											o = n(5861),
											i = n(4687),
											a = n.n(i),
											s = n(9123),
											l = n(3983),
											u = n(3193),
											c = n(6718),
											d = n(5385),
											f = n(7659);
										function p(e) {
											if (!e.clientId)
												throw new s.Z('A clientId must be specified in the OktaAuth constructor to get a token');
											if (!e.redirectUri)
												throw new s.Z('The redirectUri passed to /authorize must also be passed to /token');
											if (!e.authorizationCode && !e.interactionCode)
												throw new s.Z('An authorization code (returned from /authorize) must be passed to /token');
											if (!e.codeVerifier)
												throw new s.Z('The "codeVerifier" (generated and saved by your app) must be passed to /token');
										}
										function h(e, t) {
											var n = (0, u.YY)({
												client_id: t.clientId,
												redirect_uri: t.redirectUri,
												grant_type: t.interactionCode ? 'interaction_code' : 'authorization_code',
												code_verifier: t.codeVerifier,
											});
											t.interactionCode
												? (n.interaction_code = t.interactionCode)
												: t.authorizationCode && (n.code = t.authorizationCode);
											var r = e.options.clientSecret;
											return r && (n.client_secret = r), (0, c.UK)(n).slice(1);
										}
										function m(e, t) {
											return v.apply(this, arguments);
										}
										function v() {
											return (v = (0, o.Z)(
												a().mark(function e(t, n) {
													var r, o, i, u, c, p, h, v, g, y, b;
													return a().wrap(
														function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		if (
																			((r = n.url),
																			(o = n.data),
																			(i = n.nonce),
																			(u = n.dpopKeyPair),
																			(c = 'POST'),
																			(p = { 'Content-Type': 'application/x-www-form-urlencoded' }),
																			!t.options.dpop)
																		) {
																			e.next = 10;
																			break;
																		}
																		if (u) {
																			e.next = 6;
																			break;
																		}
																		throw new s.Z('DPoP is configured but no key pair was provided');
																	case 6:
																		return (e.next = 8), (0, f.cE)({ url: r, method: c, nonce: i, keyPair: u });
																	case 8:
																		(h = e.sent), (p.DPoP = h);
																	case 10:
																		return (
																			(e.prev = 10),
																			(e.next = 13),
																			(0, d.c3)(t, { url: r, method: c, args: o, headers: p })
																		);
																	case 13:
																		return (v = e.sent), e.abrupt('return', v);
																	case 17:
																		if (((e.prev = 17), (e.t0 = e.catch(10)), !(0, f.SO)(e.t0) || i)) {
																			e.next = 24;
																			break;
																		}
																		if (
																			(y = null === (g = e.t0.resp) || void 0 === g ? void 0 : g.headers['dpop-nonce'])
																		) {
																			e.next = 23;
																			break;
																		}
																		throw new l.Z(
																			{ errorSummary: 'No `dpop-nonce` header found when required' },
																			null !== (b = e.t0.resp) && void 0 !== b ? b : void 0
																		);
																	case 23:
																		return e.abrupt('return', m(t, { url: r, data: o, dpopKeyPair: u, nonce: y }));
																	case 24:
																		throw e.t0;
																	case 25:
																	case 'end':
																		return e.stop();
																}
														},
														e,
														null,
														[[10, 17]]
													);
												})
											)).apply(this, arguments);
										}
										function g(e, t, n) {
											return y.apply(this, arguments);
										}
										function y() {
											return (y = (0, o.Z)(
												a().mark(function e(t, n, r) {
													var o, i;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	return (
																		p(n),
																		(o = h(t, n)),
																		(i = { url: r.tokenUrl, data: o, dpopKeyPair: null == n ? void 0 : n.dpopKeyPair }),
																		e.abrupt('return', m(t, i))
																	);
																case 4:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function b(e, t, n) {
											return _.apply(this, arguments);
										}
										function _() {
											return (_ = (0, o.Z)(
												a().mark(function e(t, n, o) {
													var i, s, l;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	return (
																		(i = Object.entries({
																			client_id: n.clientId,
																			grant_type: 'refresh_token',
																			scope: o.scopes.join(' '),
																			refresh_token: o.refreshToken,
																		})
																			.map(function (e) {
																				var t = (0, r.Z)(e, 2),
																					n = t[0],
																					o = t[1];
																				return n + '=' + encodeURIComponent(o);
																			})
																			.join('&')),
																		(s = o.tokenUrl),
																		n.extraParams &&
																			Object.keys(n.extraParams).length >= 1 &&
																			(s += (0, c.UK)(n.extraParams)),
																		(l = { url: s, data: i, dpopKeyPair: null == n ? void 0 : n.dpopKeyPair }),
																		e.abrupt('return', m(t, l))
																	);
																case 5:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
									},
									52: function (e, t, n) {
										'use strict';
										n.d(t, {
											E: function () {
												return a;
											},
											k: function () {
												return s;
											},
										});
										var r = n(5385),
											o = n(3193),
											i = n(9123);
										function a(e, t) {
											var n = t || e.options.issuer;
											return (0, r.U2)(e, n + '/.well-known/openid-configuration', { cacheResponse: !0 });
										}
										function s(e, t, n) {
											var s = e.storageManager.getHttpCache(e.options.cookies);
											return a(e, t).then(function (t) {
												var a = t.jwks_uri,
													l = s.getStorage()[a];
												if (l && Date.now() / 1e3 < l.expiresAt) {
													var u = (0, o.sE)(l.response.keys, { kid: n });
													if (u) return u;
												}
												return (
													s.clearStorage(a),
													(0, r.U2)(e, a, { cacheResponse: !0 }).then(function (e) {
														var t = (0, o.sE)(e.keys, { kid: n });
														if (t) return t;
														throw new i.Z('The key id, ' + n + ", was not found in the server's keys");
													})
												);
											});
										}
									},
									8707: function (e, t, n) {
										'use strict';
										n.d(t, {
											r: function () {
												return f;
											},
										});
										var r = n(5861),
											o = n(4687),
											i = n.n(o),
											a = n(7599),
											s = n(7756),
											l = n(3193),
											u = n(9231),
											c = n(8676),
											d = n(7659);
										function f(e, t, n) {
											return p.apply(this, arguments);
										}
										function p() {
											return (p = (0, r.Z)(
												i().mark(function e(t, n, r) {
													var o, f, p, h, m, v, g, y, b, _, w, O, k, x, E, T, S, A, C, P, R, I;
													return i().wrap(
														function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		if (
																			((r = r || (0, a.Fc)(t, n)),
																			(n = Object.assign({}, (0, s.D)(t), (0, l.d9)(n))),
																			(f = (o = n).authorizationCode),
																			(p = o.interactionCode),
																			(h = o.codeVerifier),
																			(m = o.clientId),
																			(v = o.redirectUri),
																			(g = o.scopes),
																			(y = o.ignoreSignature),
																			(b = o.state),
																			(_ = o.acrValues),
																			(w = o.dpop),
																			(O = o.dpopPairId),
																			(k = o.extraParams),
																			(x = {
																				clientId: m,
																				redirectUri: v,
																				authorizationCode: f,
																				interactionCode: p,
																				codeVerifier: h,
																				dpop: w,
																			}),
																			(E = ['token']),
																			-1 !== g.indexOf('openid') && E.push('id_token'),
																			(T = {
																				clientId: m,
																				redirectUri: v,
																				scopes: g,
																				responseType: E,
																				ignoreSignature: y,
																				acrValues: _,
																				extraParams: k,
																			}),
																			(e.prev = 7),
																			!w)
																		) {
																			e.next = 26;
																			break;
																		}
																		if (!O) {
																			e.next = 18;
																			break;
																		}
																		return (e.next = 12), (0, d.lk)(O);
																	case 12:
																		(S = e.sent), (x.dpopKeyPair = S), (T.dpop = w), (T.dpopPairId = O), (e.next = 26);
																		break;
																	case 18:
																		return (e.next = 20), (0, d.vX)();
																	case 20:
																		(A = e.sent),
																			(C = A.keyPair),
																			(P = A.keyPairId),
																			(x.dpopKeyPair = C),
																			(T.dpop = w),
																			(T.dpopPairId = P);
																	case 26:
																		return (e.next = 28), (0, u.t)(t, x, r);
																	case 28:
																		return (R = e.sent), (e.next = 31), (0, c.s)(t, T, R, r);
																	case 31:
																		return ((I = e.sent).code = f), (I.state = b), e.abrupt('return', I);
																	case 35:
																		return (e.prev = 35), t.transactionManager.clear(), e.finish(35);
																	case 38:
																	case 'end':
																		return e.stop();
																}
														},
														e,
														null,
														[[7, , 35, 38]]
													);
												})
											)).apply(this, arguments);
										}
									},
									5324: function (e, t, n) {
										'use strict';
										n.d(t, {
											$: function () {
												return E;
											},
											o: function () {
												return x;
											},
										});
										var r = n(3548),
											o = n(1237),
											i = n(8707),
											a = n(6844),
											s = n(7625),
											l = n(9770),
											u = n(6803),
											c = n(5372),
											d = n(2476),
											f = n(6268),
											p = n(781),
											h = n(6466),
											m = n(8113),
											v = n(6898),
											g = n(8221),
											y = n(1260),
											b = n(3193),
											_ = n(6757),
											w = n(8080),
											O = n(2206);
										function k(e, t) {
											t = (0, b.d9)(t) || {};
											var n = (0, _.U)(e, t),
												r = (0, w.A)(e, n),
												o = r.urls.authorizeUrl + (0, O.R)(n);
											e.transactionManager.save(r),
												e.options.setLocation ? e.options.setLocation(o) : window.location.assign(o);
										}
										function x(e, t) {
											var n = function (e) {
													return r.b.prototype.push.bind(t, e, null);
												},
												b = n(u.H.bind(null, e)),
												_ = n(c.ko.bind(null, e)),
												w = Object.assign(_, {
													_getHistory: function () {
														return window.history;
													},
													_getLocation: function () {
														return window.location;
													},
													_getDocument: function () {
														return window.document;
													},
												}),
												O = {
													prepareTokenParams: v.wu.bind(null, e),
													exchangeCodeForTokens: i.r.bind(null, e),
													getWithoutPrompt: s.y.bind(null, e),
													getWithPopup: l.d.bind(null, e),
													getWithRedirect: b,
													parseFromUrl: w,
													decode: o.T,
													revoke: h.P.bind(null, e),
													renew: d.$.bind(null, e),
													renewTokensWithRefresh: p.R.bind(null, e),
													renewTokens: f.I.bind(null, e),
													getUserInfo: function (t, n) {
														return (0, a.b)(e, t, n);
													},
													verify: y.W.bind(null, e),
													isLoginRedirect: g.gM.bind(null, e),
													introspect: m.j.bind(null, e),
												};
											return (
												[
													'getWithoutPrompt',
													'getWithPopup',
													'revoke',
													'renew',
													'renewTokensWithRefresh',
													'renewTokens',
												].forEach(function (e) {
													O[e] = n(O[e]);
												}),
												O
											);
										}
										function E(e) {
											return { authorize: { enrollAuthenticator: k.bind(null, e) } };
										}
									},
									231: function (e, t, n) {
										'use strict';
										n.d(t, {
											$V: function () {
												return r.$;
											},
											zr: function () {
												return u;
											},
											o5: function () {
												return r.o;
											},
										});
										var r = n(5324),
											o = n(9893),
											i = n(265),
											a = n(3980),
											s = n(279),
											l = n(2724);
										function u(e, t, n) {
											var r = (0, o.a)(t),
												u = (0, i.H)(r, e),
												c = (0, s.A)(u),
												d = (0, a.Z)(c);
											return (0, l.J)(d, n);
										}
									},
									3253: function (e, t, n) {
										'use strict';
										n.d(t, {
											L: function () {
												return u;
											},
										});
										var r = n(7599),
											o = n(4970),
											i = n(9123),
											a = n(6898),
											s = n(2206),
											l = n(8676);
										function u(e, t) {
											if (arguments.length > 2)
												return Promise.reject(
													new i.Z('As of version 3.0, "getToken" takes only a single set of options')
												);
											var n = (t = t || {}).popupWindow;
											return (
												(t.popupWindow = void 0),
												(0, a.wu)(e, t).then(function (a) {
													var u, c;
													switch (
														(t.sessionToken
															? Object.assign(a, { prompt: 'none', responseMode: 'okta_post_message', display: null })
															: t.idp && Object.assign(a, { display: 'popup' }),
														(c = (0, r.Fc)(e, a)),
														(u = (t.codeVerifier ? c.tokenUrl : c.authorizeUrl) + (0, s.R)(a)),
														a.sessionToken || null === a.display
															? 'IFRAME'
															: 'popup' === a.display
															? 'POPUP'
															: 'IMPLICIT')
													) {
														case 'IFRAME':
															var d = (0, o.iC)(e, t.timeout, a.state),
																f = (0, o.Rl)(u);
															return d
																.then(function (t) {
																	return (0, l.s)(e, a, t, c);
																})
																.finally(function () {
																	var e;
																	document.body.contains(f) &&
																		(null === (e = f.parentElement) || void 0 === e || e.removeChild(f));
																});
														case 'POPUP':
															var p;
															if ('okta_post_message' === a.responseMode) {
																if (!e.features.isPopupPostMessageSupported())
																	throw new i.Z("This browser doesn't have full postMessage support");
																p = (0, o.iC)(e, t.timeout, a.state);
															}
															return (
																n && n.location.assign(u),
																new Promise(function (e, t) {
																	var r = setInterval(function () {
																		(n && !n.closed) ||
																			(clearInterval(r), t(new i.Z('Unable to parse OAuth flow response')));
																	}, 100);
																	p.then(function (t) {
																		clearInterval(r), e(t);
																	}).catch(function (e) {
																		clearInterval(r), t(e);
																	});
																})
																	.then(function (t) {
																		return (0, l.s)(e, a, t, c);
																	})
																	.finally(function () {
																		n && !n.closed && n.close();
																	})
															);
														default:
															throw new i.Z('The full page redirect flow is not supported');
													}
												})
											);
										}
									},
									6844: function (e, t, n) {
										'use strict';
										n.d(t, {
											b: function () {
												return m;
											},
										});
										var r = n(4942),
											o = n(5861),
											i = n(4687),
											a = n.n(i),
											s = n(9123),
											l = n(3114),
											u = n(2886),
											c = n(3983),
											d = n(5385),
											f = n(6488);
										function p(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function h(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? p(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: p(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function m(e, t, n) {
											return v.apply(this, arguments);
										}
										function v() {
											return (v = (0, o.Z)(
												a().mark(function e(t, n, r) {
													var o, i;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (n) {
																		e.next = 4;
																		break;
																	}
																	return (e.next = 3), t.tokenManager.getTokens();
																case 3:
																	n = e.sent.accessToken;
																case 4:
																	if (r) {
																		e.next = 8;
																		break;
																	}
																	return (e.next = 7), t.tokenManager.getTokens();
																case 7:
																	r = e.sent.idToken;
																case 8:
																	if (n && (0, f.hv)(n)) {
																		e.next = 10;
																		break;
																	}
																	return e.abrupt(
																		'return',
																		Promise.reject(new s.Z('getUserInfo requires an access token object'))
																	);
																case 10:
																	if (r && (0, f.sI)(r)) {
																		e.next = 12;
																		break;
																	}
																	return e.abrupt(
																		'return',
																		Promise.reject(new s.Z('getUserInfo requires an ID token object'))
																	);
																case 12:
																	if (
																		((o = { url: n.userinfoUrl, method: 'GET', accessToken: n.accessToken }),
																		!t.options.dpop)
																	) {
																		e.next = 19;
																		break;
																	}
																	return (
																		(e.next = 16), t.getDPoPAuthorizationHeaders(h(h({}, o), {}, { accessToken: n }))
																	);
																case 16:
																	(i = e.sent), (o.headers = i), delete o.accessToken;
																case 19:
																	return e.abrupt(
																		'return',
																		(0, d.c3)(t, o)
																			.then(function (e) {
																				return e.sub === r.claims.sub
																					? e
																					: Promise.reject(
																							new s.Z('getUserInfo request was rejected due to token mismatch')
																					  );
																			})
																			.catch(function (e) {
																				if (e instanceof l.Z && !t.options.dpop) {
																					var n = e.error,
																						r = e.errorDescription;
																					throw new u.Z(n, r);
																				}
																				if (!t.options.dpop) {
																					var o,
																						i = e;
																					if (
																						(e instanceof c.Z &&
																							null != e &&
																							null !== (o = e.meta) &&
																							void 0 !== o &&
																							o.wwwAuthHeader &&
																							(i = l.Z.parseHeader(e.meta.wwwAuthHeader)),
																						i instanceof l.Z)
																					) {
																						var a = i,
																							s = a.error,
																							d = a.errorDescription;
																						throw new u.Z(s, d);
																					}
																				}
																				throw e;
																			})
																	);
																case 20:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
									},
									9770: function (e, t, n) {
										'use strict';
										n.d(t, {
											d: function () {
												return s;
											},
										});
										var r = n(9123),
											o = n(3193),
											i = n(3253),
											a = n(4970);
										function s(e, t) {
											if (arguments.length > 2)
												return Promise.reject(
													new r.Z('As of version 3.0, "getWithPopup" takes only a single set of options')
												);
											var n = (0, a.pU)('/', t);
											return (
												(t = (0, o.d9)(t) || {}),
												Object.assign(t, { display: 'popup', responseMode: 'okta_post_message', popupWindow: n }),
												(0, i.L)(e, t)
											);
										}
									},
									6803: function (e, t, n) {
										'use strict';
										n.d(t, {
											H: function () {
												return d;
											},
										});
										var r = n(5861),
											o = n(4687),
											i = n.n(o),
											a = n(9123),
											s = n(3193),
											l = n(6898),
											u = n(2865),
											c = n(2206);
										function d(e, t) {
											return f.apply(this, arguments);
										}
										function f() {
											return (
												(f = (0, r.Z)(
													i().mark(function e(t, n) {
														var r,
															o,
															d,
															f = arguments;
														return i().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		if (!(f.length > 2)) {
																			e.next = 2;
																			break;
																		}
																		return e.abrupt(
																			'return',
																			Promise.reject(
																				new a.Z(
																					'As of version 3.0, "getWithRedirect" takes only a single set of options'
																				)
																			)
																		);
																	case 2:
																		return (n = (0, s.d9)(n) || {}), (e.next = 5), (0, l.wu)(t, n);
																	case 5:
																		(r = e.sent),
																			(o = (0, u.H)(t, r)),
																			(d = o.urls.authorizeUrl + (0, c.R)(r)),
																			t.transactionManager.save(o),
																			t.options.setLocation ? t.options.setLocation(d) : window.location.assign(d);
																	case 10:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												f.apply(this, arguments)
											);
										}
									},
									7625: function (e, t, n) {
										'use strict';
										n.d(t, {
											y: function () {
												return a;
											},
										});
										var r = n(9123),
											o = n(3193),
											i = n(3253);
										function a(e, t) {
											return arguments.length > 2
												? Promise.reject(
														new r.Z('As of version 3.0, "getWithoutPrompt" takes only a single set of options')
												  )
												: ((t = (0, o.d9)(t) || {}),
												  Object.assign(t, { prompt: 'none', responseMode: 'okta_post_message', display: null }),
												  (0, i.L)(e, t));
										}
									},
									8676: function (e, t, n) {
										'use strict';
										n.d(t, {
											s: function () {
												return p;
											},
										});
										var r = n(5861),
											o = n(4687),
											i = n.n(o),
											a = n(3193),
											s = n(7599),
											l = n(2886),
											u = n(9123),
											c = n(1260),
											d = n(7756);
										function f(e, t) {
											if (e.error && e.error_description) throw new l.Z(e.error, e.error_description);
											if (e.state !== t.state) throw new u.Z("OAuth flow response state doesn't match request state");
											if (t.dpop && 'DPoP' !== e.token_type)
												throw new u.Z(
													'Unable to parse OAuth flow response: DPoP was configured but "token_type" was not DPoP'
												);
										}
										function p(e, t, n, r) {
											return h.apply(this, arguments);
										}
										function h() {
											return (h = (0, r.Z)(
												i().mark(function e(t, n, r, o) {
													var l, p, h, m, v, g, y, b, _, w, O, k, x, E;
													return i().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (!1 === t.options.pkce || (!r.code && !r.interaction_code)) {
																		e.next = 3;
																		break;
																	}
																	return e.abrupt(
																		'return',
																		t.token.exchangeCodeForTokens(
																			Object.assign({}, n, {
																				authorizationCode: r.code,
																				interactionCode: r.interaction_code,
																			}),
																			o
																		)
																	);
																case 3:
																	if (
																		((n = n || (0, d.D)(t)),
																		(o = o || (0, s.Fc)(t, n)),
																		(l = n.responseType || []),
																		Array.isArray(l) || 'none' === l || (l = [l]),
																		(p = r.scope ? r.scope.split(' ') : (0, a.d9)(n.scopes)),
																		(h = n.clientId || t.options.clientId),
																		f(r, n),
																		(m = {}),
																		(v = r.expires_in),
																		(g = r.token_type),
																		(y = r.access_token),
																		(b = r.id_token),
																		(_ = r.refresh_token),
																		(w = Math.floor(Date.now() / 1e3)),
																		y &&
																			((O = t.token.decode(y)),
																			(m.accessToken = {
																				accessToken: y,
																				claims: O.payload,
																				expiresAt: Number(v) + w,
																				tokenType: g,
																				scopes: p,
																				authorizeUrl: o.authorizeUrl,
																				userinfoUrl: o.userinfoUrl,
																			}),
																			n.dpopPairId && (m.accessToken.dpopPairId = n.dpopPairId),
																			n.extraParams && (m.accessToken.extraParams = n.extraParams)),
																		_ &&
																			((m.refreshToken = {
																				refreshToken: _,
																				expiresAt: Number(v) + w,
																				scopes: p,
																				tokenUrl: o.tokenUrl,
																				authorizeUrl: o.authorizeUrl,
																				issuer: o.issuer,
																			}),
																			n.dpopPairId && (m.refreshToken.dpopPairId = n.dpopPairId),
																			n.extraParams && (m.refreshToken.extraParams = n.extraParams)),
																		!b)
																	) {
																		e.next = 28;
																		break;
																	}
																	return (
																		(k = t.token.decode(b)),
																		(x = {
																			idToken: b,
																			claims: k.payload,
																			expiresAt: k.payload.exp - k.payload.iat + w,
																			scopes: p,
																			authorizeUrl: o.authorizeUrl,
																			issuer: o.issuer,
																			clientId: h,
																		}),
																		n.extraParams && (x.extraParams = n.extraParams),
																		(E = {
																			clientId: h,
																			issuer: o.issuer,
																			nonce: n.nonce,
																			accessToken: y,
																			acrValues: n.acrValues,
																		}),
																		void 0 !== n.ignoreSignature && (E.ignoreSignature = n.ignoreSignature),
																		(e.next = 27),
																		(0, c.W)(t, x, E)
																	);
																case 27:
																	m.idToken = x;
																case 28:
																	if (-1 === l.indexOf('token') || m.accessToken) {
																		e.next = 30;
																		break;
																	}
																	throw new u.Z(
																		'Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.'
																	);
																case 30:
																	if (-1 === l.indexOf('id_token') || m.idToken) {
																		e.next = 32;
																		break;
																	}
																	throw new u.Z(
																		'Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.'
																	);
																case 32:
																	return e.abrupt('return', {
																		tokens: m,
																		state: r.state,
																		code: r.code,
																		responseType: l,
																	});
																case 33:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
									},
									9443: function (e, t, n) {
										'use strict';
										n.r(t),
											n.d(t, {
												TokenManager: function () {
													return d.M;
												},
												addListener: function () {
													return p.NH;
												},
												addPostMessageListener: function () {
													return p.iC;
												},
												assertPKCESupport: function () {
													return p.vz;
												},
												buildAuthorizeParams: function () {
													return a.R0;
												},
												convertTokenParamsToOAuthParams: function () {
													return a._6;
												},
												createEndpoints: function () {
													return r.$V;
												},
												createEnrollAuthenticatorMeta: function () {
													return p.AW;
												},
												createOAuthMeta: function () {
													return p.H;
												},
												createOAuthOptionsConstructor: function () {
													return s.m;
												},
												createOAuthStorageManager: function () {
													return i.a;
												},
												createOktaAuthOAuth: function () {
													return r.zr;
												},
												createTokenAPI: function () {
													return r.o5;
												},
												createTransactionManager: function () {
													return f.P;
												},
												decodeToken: function () {
													return h.T;
												},
												exchangeCodeForTokens: function () {
													return O.r;
												},
												generateNonce: function () {
													return p.PY;
												},
												generateState: function () {
													return p.aV;
												},
												getDefaultEnrollAuthenticatorParams: function () {
													return p.cE;
												},
												getDefaultTokenParams: function () {
													return p.Dx;
												},
												getHashOrSearch: function () {
													return p.O2;
												},
												getKey: function () {
													return a.km;
												},
												getOAuthBaseUrl: function () {
													return p.zf;
												},
												getOAuthDomain: function () {
													return p.Xp;
												},
												getOAuthUrls: function () {
													return p.Fc;
												},
												getToken: function () {
													return k.L;
												},
												getUserInfo: function () {
													return _.b;
												},
												getWellKnown: function () {
													return a.ES;
												},
												getWithPopup: function () {
													return E.d;
												},
												getWithRedirect: function () {
													return T.H;
												},
												getWithoutPrompt: function () {
													return x.y;
												},
												handleOAuthResponse: function () {
													return w.s;
												},
												hasAuthorizationCode: function () {
													return p.ZP;
												},
												hasErrorInUrl: function () {
													return p.hg;
												},
												hasInteractionCode: function () {
													return p.d_;
												},
												hasResponseType: function () {
													return p.wV;
												},
												hasTokensInHash: function () {
													return p.kU;
												},
												isAuthorizationCodeError: function () {
													return p.tC;
												},
												isCodeFlow: function () {
													return p.Ik;
												},
												isInteractionRequired: function () {
													return p.wc;
												},
												isInteractionRequiredError: function () {
													return p.Cf;
												},
												isLoginRedirect: function () {
													return p.gM;
												},
												isRedirectUri: function () {
													return p.Qs;
												},
												isRefreshTokenError: function () {
													return p.Yo;
												},
												isRefreshTokenInvalidError: function () {
													return p.$E;
												},
												isSameRefreshToken: function () {
													return p.q0;
												},
												loadFrame: function () {
													return p.Rl;
												},
												loadPopup: function () {
													return p.pU;
												},
												mixinOAuth: function () {
													return o.J;
												},
												oidcIntrospect: function () {
													return A.j;
												},
												parseFromUrl: function () {
													return S.ko;
												},
												pkce: function () {
													return p.U5;
												},
												postRefreshToken: function () {
													return a.Dp;
												},
												postToTokenEndpoint: function () {
													return a.ti;
												},
												prepareEnrollAuthenticatorParams: function () {
													return p.Uc;
												},
												preparePKCE: function () {
													return p.mi;
												},
												prepareTokenParams: function () {
													return p.wu;
												},
												removeListener: function () {
													return p.ys;
												},
												renewToken: function () {
													return v.$;
												},
												renewTokens: function () {
													return y.I;
												},
												renewTokensWithRefresh: function () {
													return g.R;
												},
												revokeToken: function () {
													return m.P;
												},
												urlParamsToObject: function () {
													return p.vL;
												},
												validateClaims: function () {
													return p.pj;
												},
												validateCodeChallengeMethod: function () {
													return p.br;
												},
												validateToken: function () {
													return p.Rp;
												},
												verifyToken: function () {
													return b.W;
												},
											});
										var r = n(231),
											o = n(2724),
											i = n(2333),
											a = n(2642),
											s = n(3775),
											l = n(8927),
											u = {};
										for (var c in l)
											[
												'default',
												'decodeToken',
												'revokeToken',
												'renewToken',
												'renewTokensWithRefresh',
												'renewTokens',
												'verifyToken',
												'getUserInfo',
												'handleOAuthResponse',
												'exchangeCodeForTokens',
												'getToken',
												'getWithoutPrompt',
												'getWithPopup',
												'getWithRedirect',
												'parseFromUrl',
												'oidcIntrospect',
												'createEndpoints',
												'createOktaAuthOAuth',
												'createTokenAPI',
												'mixinOAuth',
												'createOAuthStorageManager',
												'buildAuthorizeParams',
												'convertTokenParamsToOAuthParams',
												'getKey',
												'getWellKnown',
												'postRefreshToken',
												'postToTokenEndpoint',
												'createOAuthOptionsConstructor',
											].indexOf(c) < 0 &&
												(u[c] = function (e) {
													return l[e];
												}.bind(0, c));
										n.d(t, u);
										var d = n(2427),
											f = n(1646),
											p = n(8785),
											h = n(1237),
											m = n(6466),
											v = n(2476),
											g = n(781),
											y = n(6268),
											b = n(1260),
											_ = n(6844),
											w = n(8676),
											O = n(8707),
											k = n(3253),
											x = n(7625),
											E = n(9770),
											T = n(6803),
											S = n(5372),
											A = n(8113);
									},
									8113: function (e, t, n) {
										'use strict';
										n.d(t, {
											j: function () {
												return p;
											},
										});
										var r = n(5861),
											o = n(4687),
											i = n.n(o),
											a = n(9123),
											s = n(52),
											l = n(5385),
											u = n(6718),
											c = n(7594),
											d = n(6488),
											f = { accessToken: 'access_token', idToken: 'id_token', refreshToken: 'refresh_token' };
										function p(e, t, n) {
											return h.apply(this, arguments);
										}
										function h() {
											return (h = (0, r.Z)(
												i().mark(function e(t, n, r) {
													var o, p, h, m, v, g, y, b, _, w;
													return i().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (
																		((p = t.options.clientId),
																		(h = t.options.clientSecret),
																		r || (r = t.tokenManager.getTokens()[n]),
																		r)
																	) {
																		e.next = 5;
																		break;
																	}
																	throw new a.Z('unable to find '.concat(n, ' in storage or fn params'));
																case 5:
																	if (
																		((o =
																			(o =
																				n !== d.T6.ACCESS
																					? null === (m = r) || void 0 === m
																						? void 0
																						: m.issuer
																					: null === (v = r) || void 0 === v || null === (g = v.claims) || void 0 === g
																					? void 0
																					: g.iss) || t.options.issuer),
																		p)
																	) {
																		e.next = 9;
																		break;
																	}
																	throw new a.Z(
																		'A clientId must be specified in the OktaAuth constructor to introspect a token'
																	);
																case 9:
																	if (o) {
																		e.next = 11;
																		break;
																	}
																	throw new a.Z('Unable to find issuer');
																case 11:
																	return (e.next = 13), (0, s.E)(t, o);
																case 13:
																	return (
																		(y = e.sent),
																		(b = y.introspection_endpoint),
																		(_ = h ? (0, c.r3)(''.concat(p, ':').concat(h)) : (0, c.r3)(p)),
																		(w = (0, u.UK)({ token_type_hint: f[n], token: r[n] }).slice(1)),
																		e.abrupt(
																			'return',
																			(0, l.v_)(t, b, w, {
																				headers: {
																					'Content-Type': 'application/x-www-form-urlencoded',
																					'Authorization': 'Basic ' + _,
																				},
																			})
																		)
																	);
																case 18:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
									},
									2724: function (e, t, n) {
										'use strict';
										n.d(t, {
											J: function () {
												return I;
											},
										});
										var r = n(4925),
											o = n(5861),
											i = n(5671),
											a = n(3144),
											s = n(7326),
											l = n(1752),
											u = n(136),
											c = n(2963),
											d = n(1120),
											f = n(4942),
											p = n(4687),
											h = n.n(p),
											m = n(5385),
											v = n(3548),
											g = n(4771),
											y = n(9718),
											b = n(3611),
											_ = n(5324),
											w = n(2427),
											O = n(8221),
											k = n(7599),
											x = n(7659),
											E = n(9123),
											T = n(3114),
											S = n(1971),
											A = n(4858),
											C = ['originalUri'];
										function P(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function R(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? P(Object(n), !0).forEach(function (t) {
															(0, f.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: P(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function I(e, t) {
											var n,
												p = (function (e) {
													(0, u.Z)(o, e);
													var t,
														n,
														r =
															((t = o),
															(n = (function () {
																if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
																if (Reflect.construct.sham) return !1;
																if ('function' == typeof Proxy) return !0;
																try {
																	return (
																		Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																	);
																} catch (e) {
																	return !1;
																}
															})()),
															function () {
																var e,
																	r = (0, d.Z)(t);
																if (n) {
																	var o = (0, d.Z)(this).constructor;
																	e = Reflect.construct(r, arguments, o);
																} else e = r.apply(this, arguments);
																return (0, c.Z)(this, e);
															});
													function o() {
														return (0, i.Z)(this, o), r.apply(this, arguments);
													}
													return (
														(0, a.Z)(o, [
															{
																key: 'setOriginalUri',
																value: function (e, t) {
																	A.Z.getSessionStorage().setItem(S.REFERRER_PATH_STORAGE_KEY, e),
																		(t = t || this.options.state) &&
																			this.storageManager.getOriginalUriStorage().setItem(t, e);
																},
															},
															{
																key: 'getOriginalUri',
																value: function (e) {
																	if ((e = e || this.options.state)) {
																		var t = this.storageManager.getOriginalUriStorage().getItem(e);
																		if (t) return t;
																	}
																	var n = A.Z.getSessionStorage();
																	return (n && n.getItem(S.REFERRER_PATH_STORAGE_KEY)) || void 0;
																},
															},
															{
																key: 'removeOriginalUri',
																value: function (e) {
																	if (
																		(A.Z.getSessionStorage().removeItem(S.REFERRER_PATH_STORAGE_KEY),
																		(e = e || this.options.state))
																	) {
																		var t = this.storageManager.getOriginalUriStorage();
																		t.removeItem && t.removeItem(e);
																	}
																},
															},
														]),
														o
													);
												})(e);
											return (
												(n = (function (e) {
													(0, u.Z)(B, e);
													var n,
														p,
														y,
														S,
														A,
														P,
														I,
														N,
														M,
														j,
														D,
														L,
														U,
														F =
															((L = B),
															(U = (function () {
																if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
																if (Reflect.construct.sham) return !1;
																if ('function' == typeof Proxy) return !0;
																try {
																	return (
																		Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																	);
																} catch (e) {
																	return !1;
																}
															})()),
															function () {
																var e,
																	t = (0, d.Z)(L);
																if (U) {
																	var n = (0, d.Z)(this).constructor;
																	e = Reflect.construct(t, arguments, n);
																} else e = t.apply(this, arguments);
																return (0, c.Z)(this, e);
															});
													function B() {
														var e;
														(0, i.Z)(this, B);
														for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];
														return (
															(e = F.call.apply(F, [this].concat(r))),
															(0, f.Z)((0, s.Z)(e), 'token', void 0),
															(0, f.Z)((0, s.Z)(e), 'tokenManager', void 0),
															(0, f.Z)((0, s.Z)(e), 'transactionManager', void 0),
															(0, f.Z)((0, s.Z)(e), 'pkce', void 0),
															(0, f.Z)((0, s.Z)(e), 'endpoints', void 0),
															(0, f.Z)((0, s.Z)(e), '_pending', void 0),
															(0, f.Z)((0, s.Z)(e), '_tokenQueue', void 0),
															(e.transactionManager = new t(
																Object.assign({ storageManager: e.storageManager }, e.options.transactionManager)
															)),
															(e.pkce = {
																DEFAULT_CODE_CHALLENGE_METHOD: b.Z.DEFAULT_CODE_CHALLENGE_METHOD,
																generateVerifier: b.Z.generateVerifier,
																computeChallenge: b.Z.computeChallenge,
															}),
															(e._pending = { handleLogin: !1 }),
															(e._tokenQueue = new v.b()),
															(e.token = (0, _.o)((0, s.Z)(e), e._tokenQueue)),
															(e.tokenManager = new w.M((0, s.Z)(e), e.options.tokenManager)),
															(e.endpoints = (0, _.$)((0, s.Z)(e))),
															e
														);
													}
													return (
														(0, a.Z)(B, [
															{
																key: 'clearStorage',
																value: function () {
																	(0, l.Z)((0, d.Z)(B.prototype), 'clearStorage', this).call(this),
																		this.tokenManager.clear();
																},
															},
															{
																key: 'isAuthenticated',
																value:
																	((D = (0, o.Z)(
																		h().mark(function e() {
																			var t,
																				n,
																				r,
																				o,
																				i,
																				a,
																				s,
																				l,
																				u,
																				c,
																				d = arguments;
																			return h().wrap(
																				function (e) {
																					for (;;)
																						switch ((e.prev = e.next)) {
																							case 0:
																								if (
																									((t = d.length > 0 && void 0 !== d[0] ? d[0] : {}),
																									(n = this.tokenManager.getOptions()),
																									(r = n.autoRenew),
																									(o = n.autoRemove),
																									(i = t.onExpiredToken ? 'renew' === t.onExpiredToken : r),
																									(a = t.onExpiredToken ? 'remove' === t.onExpiredToken : o),
																									(s = this.tokenManager.getTokensSync()),
																									!(l = s.accessToken) || !this.tokenManager.hasExpired(l))
																								) {
																									e.next = 19;
																									break;
																								}
																								if (((l = void 0), !i)) {
																									e.next = 18;
																									break;
																								}
																								return (
																									(e.prev = 8), (e.next = 11), this.tokenManager.renew('accessToken')
																								);
																							case 11:
																								(l = e.sent), (e.next = 16);
																								break;
																							case 14:
																								(e.prev = 14), (e.t0 = e.catch(8));
																							case 16:
																								e.next = 19;
																								break;
																							case 18:
																								a && this.tokenManager.remove('accessToken');
																							case 19:
																								if (
																									((u = this.tokenManager.getTokensSync()),
																									!(c = u.idToken) || !this.tokenManager.hasExpired(c))
																								) {
																									e.next = 34;
																									break;
																								}
																								if (((c = void 0), !i)) {
																									e.next = 33;
																									break;
																								}
																								return (e.prev = 23), (e.next = 26), this.tokenManager.renew('idToken');
																							case 26:
																								(c = e.sent), (e.next = 31);
																								break;
																							case 29:
																								(e.prev = 29), (e.t1 = e.catch(23));
																							case 31:
																								e.next = 34;
																								break;
																							case 33:
																								a && this.tokenManager.remove('idToken');
																							case 34:
																								return e.abrupt('return', !(!l || !c));
																							case 35:
																							case 'end':
																								return e.stop();
																						}
																				},
																				e,
																				this,
																				[
																					[8, 14],
																					[23, 29],
																				]
																			);
																		})
																	)),
																	function () {
																		return D.apply(this, arguments);
																	}),
															},
															{
																key: 'signInWithRedirect',
																value:
																	((j = (0, o.Z)(
																		h().mark(function e() {
																			var t,
																				n,
																				o,
																				i,
																				a = arguments;
																			return h().wrap(
																				function (e) {
																					for (;;)
																						switch ((e.prev = e.next)) {
																							case 0:
																								if (
																									((n = (t = a.length > 0 && void 0 !== a[0] ? a[0] : {}).originalUri),
																									(o = (0, r.Z)(t, C)),
																									!this._pending.handleLogin)
																								) {
																									e.next = 4;
																									break;
																								}
																								return e.abrupt('return');
																							case 4:
																								return (
																									(this._pending.handleLogin = !0),
																									(e.prev = 5),
																									n && this.setOriginalUri(n),
																									(i = Object.assign(
																										{ scopes: this.options.scopes || ['openid', 'email', 'profile'] },
																										o
																									)),
																									(e.next = 10),
																									this.token.getWithRedirect(i)
																								);
																							case 10:
																								return (e.prev = 10), (this._pending.handleLogin = !1), e.finish(10);
																							case 13:
																							case 'end':
																								return e.stop();
																						}
																				},
																				e,
																				this,
																				[[5, , 10, 13]]
																			);
																		})
																	)),
																	function () {
																		return j.apply(this, arguments);
																	}),
															},
															{
																key: 'getUser',
																value:
																	((M = (0, o.Z)(
																		h().mark(function e() {
																			var t, n, r;
																			return h().wrap(
																				function (e) {
																					for (;;)
																						switch ((e.prev = e.next)) {
																							case 0:
																								return (
																									(t = this.tokenManager.getTokensSync()),
																									(n = t.idToken),
																									(r = t.accessToken),
																									e.abrupt('return', this.token.getUserInfo(r, n))
																								);
																							case 2:
																							case 'end':
																								return e.stop();
																						}
																				},
																				e,
																				this
																			);
																		})
																	)),
																	function () {
																		return M.apply(this, arguments);
																	}),
															},
															{
																key: 'getIdToken',
																value: function () {
																	var e = this.tokenManager.getTokensSync().idToken;
																	return e ? e.idToken : void 0;
																},
															},
															{
																key: 'getAccessToken',
																value: function () {
																	var e = this.tokenManager.getTokensSync().accessToken;
																	return e ? e.accessToken : void 0;
																},
															},
															{
																key: 'getRefreshToken',
																value: function () {
																	var e = this.tokenManager.getTokensSync().refreshToken;
																	return e ? e.refreshToken : void 0;
																},
															},
															{
																key: 'getOrRenewAccessToken',
																value:
																	((N = (0, o.Z)(
																		h().mark(function e() {
																			var t, n, r, o, i;
																			return h().wrap(
																				function (e) {
																					for (;;)
																						switch ((e.prev = e.next)) {
																							case 0:
																								if (
																									((t = this.tokenManager.getTokensSync()),
																									!(n = t.accessToken) || this.tokenManager.hasExpired(n))
																								) {
																									e.next = 3;
																									break;
																								}
																								return e.abrupt('return', n.accessToken);
																							case 3:
																								return (
																									(e.prev = 3),
																									(o = this.tokenManager.getStorageKeyByType('accessToken')),
																									(e.next = 7),
																									this.tokenManager.renew(null != o ? o : 'accessToken')
																								);
																							case 7:
																								return (
																									(i = e.sent),
																									e.abrupt(
																										'return',
																										null !== (r = null == i ? void 0 : i.accessToken) && void 0 !== r
																											? r
																											: null
																									)
																								);
																							case 11:
																								return (
																									(e.prev = 11),
																									(e.t0 = e.catch(3)),
																									this.emitter.emit('error', e.t0),
																									e.abrupt('return', null)
																								);
																							case 15:
																							case 'end':
																								return e.stop();
																						}
																				},
																				e,
																				this,
																				[[3, 11]]
																			);
																		})
																	)),
																	function () {
																		return N.apply(this, arguments);
																	}),
															},
															{
																key: 'storeTokensFromRedirect',
																value:
																	((I = (0, o.Z)(
																		h().mark(function e() {
																			var t, n;
																			return h().wrap(
																				function (e) {
																					for (;;)
																						switch ((e.prev = e.next)) {
																							case 0:
																								return (e.next = 2), this.token.parseFromUrl();
																							case 2:
																								(t = e.sent),
																									(n = t.tokens),
																									'none' !== t.responseType && this.tokenManager.setTokens(n);
																							case 6:
																							case 'end':
																								return e.stop();
																						}
																				},
																				e,
																				this
																			);
																		})
																	)),
																	function () {
																		return I.apply(this, arguments);
																	}),
															},
															{
																key: 'isLoginRedirect',
																value: function () {
																	return (0, O.gM)(this);
																},
															},
															{
																key: 'isPKCE',
																value: function () {
																	return !!this.options.pkce;
																},
															},
															{
																key: 'hasResponseType',
																value: function (e) {
																	return (0, O.wV)(e, this.options);
																},
															},
															{
																key: 'isAuthorizationCodeFlow',
																value: function () {
																	return this.hasResponseType('code');
																},
															},
															{
																key: 'invokeApiMethod',
																value:
																	((P = (0, o.Z)(
																		h().mark(function e(t) {
																			var n;
																			return h().wrap(
																				function (e) {
																					for (;;)
																						switch ((e.prev = e.next)) {
																							case 0:
																								if (t.accessToken) {
																									e.next = 5;
																									break;
																								}
																								return (e.next = 3), this.tokenManager.getTokens();
																							case 3:
																								(n = e.sent.accessToken),
																									(t.accessToken = null == n ? void 0 : n.accessToken);
																							case 5:
																								return e.abrupt('return', (0, m.c3)(this, t));
																							case 6:
																							case 'end':
																								return e.stop();
																						}
																				},
																				e,
																				this
																			);
																		})
																	)),
																	function (e) {
																		return P.apply(this, arguments);
																	}),
															},
															{
																key: 'revokeAccessToken',
																value:
																	((A = (0, o.Z)(
																		h().mark(function e(t) {
																			var n, r;
																			return h().wrap(
																				function (e) {
																					for (;;)
																						switch ((e.prev = e.next)) {
																							case 0:
																								if (t) {
																									e.next = 10;
																									break;
																								}
																								return (e.next = 3), this.tokenManager.getTokens();
																							case 3:
																								if (
																									((n = e.sent),
																									(t = n.accessToken),
																									(r = this.tokenManager.getStorageKeyByType('accessToken')),
																									this.tokenManager.remove(r),
																									!this.options.dpop)
																								) {
																									e.next = 10;
																									break;
																								}
																								return (e.next = 10), (0, x.ao)('access', n);
																							case 10:
																								if (t) {
																									e.next = 12;
																									break;
																								}
																								return e.abrupt('return', Promise.resolve(null));
																							case 12:
																								return e.abrupt('return', this.token.revoke(t));
																							case 13:
																							case 'end':
																								return e.stop();
																						}
																				},
																				e,
																				this
																			);
																		})
																	)),
																	function (e) {
																		return A.apply(this, arguments);
																	}),
															},
															{
																key: 'revokeRefreshToken',
																value:
																	((S = (0, o.Z)(
																		h().mark(function e(t) {
																			var n, r;
																			return h().wrap(
																				function (e) {
																					for (;;)
																						switch ((e.prev = e.next)) {
																							case 0:
																								if (t) {
																									e.next = 10;
																									break;
																								}
																								return (e.next = 3), this.tokenManager.getTokens();
																							case 3:
																								if (
																									((n = e.sent),
																									(t = n.refreshToken),
																									(r = this.tokenManager.getStorageKeyByType('refreshToken')),
																									this.tokenManager.remove(r),
																									!this.options.dpop)
																								) {
																									e.next = 10;
																									break;
																								}
																								return (e.next = 10), (0, x.ao)('refresh', n);
																							case 10:
																								if (t) {
																									e.next = 12;
																									break;
																								}
																								return e.abrupt('return', Promise.resolve(null));
																							case 12:
																								return e.abrupt('return', this.token.revoke(t));
																							case 13:
																							case 'end':
																								return e.stop();
																						}
																				},
																				e,
																				this
																			);
																		})
																	)),
																	function (e) {
																		return S.apply(this, arguments);
																	}),
															},
															{
																key: 'getSignOutRedirectUrl',
																value: function () {
																	var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
																		t = e.idToken,
																		n = e.postLogoutRedirectUri,
																		r = e.state;
																	if ((t || (t = this.tokenManager.getTokensSync().idToken), !t)) return '';
																	void 0 === n && (n = this.options.postLogoutRedirectUri);
																	var o = (0, k.Fc)(this).logoutUrl,
																		i = t.idToken,
																		a = o + '?id_token_hint=' + encodeURIComponent(i);
																	return (
																		n && (a += '&post_logout_redirect_uri=' + encodeURIComponent(n)),
																		r && (a += '&state=' + encodeURIComponent(r)),
																		a
																	);
																},
															},
															{
																key: 'signOut',
																value:
																	((y = (0, o.Z)(
																		h().mark(function e(t) {
																			var n, r, o, i, a, s, l, u, c, d, f, p, m, v, g, y;
																			return h().wrap(
																				function (e) {
																					for (;;)
																						switch ((e.prev = e.next)) {
																							case 0:
																								if (
																									((t = Object.assign({}, t)),
																									(a = window.location.origin),
																									(s = window.location.href),
																									(l =
																										null === t.postLogoutRedirectUri
																											? null
																											: t.postLogoutRedirectUri ||
																											  this.options.postLogoutRedirectUri ||
																											  a),
																									(u = null === (n = t) || void 0 === n ? void 0 : n.state),
																									(c = t.accessToken),
																									(d = t.refreshToken),
																									(f = !1 !== t.revokeAccessToken),
																									(p = !1 !== t.revokeRefreshToken) &&
																										void 0 === d &&
																										(d = this.tokenManager.getTokensSync().refreshToken),
																									f &&
																										void 0 === c &&
																										(c = this.tokenManager.getTokensSync().accessToken),
																									t.idToken || (t.idToken = this.tokenManager.getTokensSync().idToken),
																									!p || !d)
																								) {
																									e.next = 15;
																									break;
																								}
																								return (e.next = 15), this.revokeRefreshToken(d);
																							case 15:
																								if (!f || !c) {
																									e.next = 18;
																									break;
																								}
																								return (e.next = 18), this.revokeAccessToken(c);
																							case 18:
																								if (
																									((m =
																										null !==
																											(r = null === (o = c) || void 0 === o ? void 0 : o.dpopPairId) &&
																										void 0 !== r
																											? r
																											: null === (i = d) || void 0 === i
																											? void 0
																											: i.dpopPairId),
																									!this.options.dpop || !m)
																								) {
																									e.next = 22;
																									break;
																								}
																								return (e.next = 22), (0, x.sd)(m);
																							case 22:
																								if (
																									(v = this.getSignOutRedirectUrl(
																										R(R({}, t), {}, { postLogoutRedirectUri: l })
																									))
																								) {
																									e.next = 33;
																									break;
																								}
																								return (e.next = 26), this.closeSession();
																							case 26:
																								return (
																									(g = e.sent),
																									(y = new URL(l || a)),
																									u && y.searchParams.append('state', u),
																									l === s
																										? (window.location.href = y.href)
																										: window.location.assign(y.href),
																									e.abrupt('return', g)
																								);
																							case 33:
																								return (
																									t.clearTokensBeforeRedirect
																										? this.tokenManager.clear()
																										: this.tokenManager.addPendingRemoveFlags(),
																									window.location.assign(v),
																									e.abrupt('return', !0)
																								);
																							case 36:
																							case 'end':
																								return e.stop();
																						}
																				},
																				e,
																				this
																			);
																		})
																	)),
																	function (e) {
																		return y.apply(this, arguments);
																	}),
															},
															{
																key: 'getDPoPAuthorizationHeaders',
																value:
																	((p = (0, o.Z)(
																		h().mark(function e(t) {
																			var n, r, o, i;
																			return h().wrap(
																				function (e) {
																					for (;;)
																						switch ((e.prev = e.next)) {
																							case 0:
																								if (this.options.dpop) {
																									e.next = 2;
																									break;
																								}
																								throw new E.Z('DPoP is not configured for this client instance');
																							case 2:
																								if (
																									((r = t.accessToken) ||
																										(r = this.tokenManager.getTokensSync().accessToken),
																									r)
																								) {
																									e.next = 6;
																									break;
																								}
																								throw new E.Z('AccessToken is required to generate a DPoP Proof');
																							case 6:
																								return (
																									(e.next = 8),
																									(0, x.lk)(null === (n = r) || void 0 === n ? void 0 : n.dpopPairId)
																								);
																							case 8:
																								return (
																									(o = e.sent),
																									(e.next = 11),
																									(0, x.aW)(R(R({}, t), {}, { keyPair: o, accessToken: r.accessToken }))
																								);
																							case 11:
																								return (
																									(i = e.sent),
																									e.abrupt('return', {
																										Authorization: 'DPoP '.concat(r.accessToken),
																										Dpop: i,
																									})
																								);
																							case 13:
																							case 'end':
																								return e.stop();
																						}
																				},
																				e,
																				this
																			);
																		})
																	)),
																	function (e) {
																		return p.apply(this, arguments);
																	}),
															},
															{
																key: 'clearDPoPStorage',
																value:
																	((n = (0, o.Z)(
																		h().mark(function e() {
																			var t,
																				n,
																				r,
																				o,
																				i = arguments;
																			return h().wrap(
																				function (e) {
																					for (;;)
																						switch ((e.prev = e.next)) {
																							case 0:
																								if (!(i.length > 0 && void 0 !== i[0] && i[0])) {
																									e.next = 3;
																									break;
																								}
																								return e.abrupt('return', (0, x.V7)());
																							case 3:
																								return (e.next = 5), this.tokenManager.getTokens();
																							case 5:
																								if (
																									((r = e.sent),
																									!(o =
																										(null === (t = r.accessToken) || void 0 === t
																											? void 0
																											: t.dpopPairId) ||
																										(null === (n = r.refreshToken) || void 0 === n
																											? void 0
																											: n.dpopPairId)))
																								) {
																									e.next = 10;
																									break;
																								}
																								return (e.next = 10), (0, x.sd)(o);
																							case 10:
																							case 'end':
																								return e.stop();
																						}
																				},
																				e,
																				this
																			);
																		})
																	)),
																	function () {
																		return n.apply(this, arguments);
																	}),
															},
															{
																key: 'parseUseDPoPNonceError',
																value: function (e) {
																	var t = T.Z.getWWWAuthenticateHeader(e),
																		n = T.Z.parseHeader(null != t ? t : '');
																	if ((0, x.SO)(n)) {
																		var r,
																			o,
																			i = null;
																		return (
																			(0, g.mf)(null == e ? void 0 : e.get) && (i = e.get('DPoP-Nonce')),
																			null !== (r = null !== (o = i) && void 0 !== o ? o : e['dpop-nonce']) &&
																			void 0 !== r
																				? r
																				: e['DPoP-Nonce']
																		);
																	}
																	return null;
																},
															},
														]),
														B
													);
												})(p)),
												(0, f.Z)(n, 'crypto', y),
												n
											);
										}
									},
									9453: function (e, t, n) {
										'use strict';
										n.d(t, {
											m: function () {
												return g;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(7326),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942),
											c = n(1971),
											d = n(6718),
											f = n(415),
											p = n(8817),
											h = !0,
											m = n(9123);
										function v(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function g() {
											return (function (e) {
												(0, a.Z)(g, e);
												var t,
													n,
													p =
														((t = g),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, l.Z)(t);
															if (n) {
																var o = (0, l.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, s.Z)(this, e);
														});
												function g(e) {
													var t;
													return (
														(0, o.Z)(this, g),
														(t = p.call(this, e)),
														(0, u.Z)((0, i.Z)(t), 'issuer', void 0),
														(0, u.Z)((0, i.Z)(t), 'authorizeUrl', void 0),
														(0, u.Z)((0, i.Z)(t), 'userinfoUrl', void 0),
														(0, u.Z)((0, i.Z)(t), 'tokenUrl', void 0),
														(0, u.Z)((0, i.Z)(t), 'revokeUrl', void 0),
														(0, u.Z)((0, i.Z)(t), 'logoutUrl', void 0),
														(0, u.Z)((0, i.Z)(t), 'pkce', void 0),
														(0, u.Z)((0, i.Z)(t), 'clientId', void 0),
														(0, u.Z)((0, i.Z)(t), 'redirectUri', void 0),
														(0, u.Z)((0, i.Z)(t), 'responseType', void 0),
														(0, u.Z)((0, i.Z)(t), 'responseMode', void 0),
														(0, u.Z)((0, i.Z)(t), 'state', void 0),
														(0, u.Z)((0, i.Z)(t), 'scopes', void 0),
														(0, u.Z)((0, i.Z)(t), 'ignoreSignature', void 0),
														(0, u.Z)((0, i.Z)(t), 'codeChallenge', void 0),
														(0, u.Z)((0, i.Z)(t), 'codeChallengeMethod', void 0),
														(0, u.Z)((0, i.Z)(t), 'acrValues', void 0),
														(0, u.Z)((0, i.Z)(t), 'maxAge', void 0),
														(0, u.Z)((0, i.Z)(t), 'dpop', void 0),
														(0, u.Z)((0, i.Z)(t), 'tokenManager', void 0),
														(0, u.Z)((0, i.Z)(t), 'postLogoutRedirectUri', void 0),
														(0, u.Z)((0, i.Z)(t), 'restoreOriginalUri', void 0),
														(0, u.Z)((0, i.Z)(t), 'transactionManager', void 0),
														(0, u.Z)((0, i.Z)(t), 'clientSecret', void 0),
														(0, u.Z)((0, i.Z)(t), 'setLocation', void 0),
														(0, u.Z)((0, i.Z)(t), 'ignoreLifetime', void 0),
														(0, u.Z)((0, i.Z)(t), 'maxClockSkew', void 0),
														(function (e) {
															var t = (e = e || {}).scopes;
															if (t && !Array.isArray(t))
																throw new m.Z(
																	'scopes must be a array of strings. Required usage: new OktaAuth({scopes: ["openid", "email"]})'
																);
															var n = e.issuer;
															if (!n)
																throw new m.Z(
																	'No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})'
																);
															if (!new RegExp('^http?s?://.+').test(n))
																throw new m.Z(
																	'Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})'
																);
															if (-1 !== n.indexOf('-admin.okta'))
																throw new m.Z(
																	'Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})'
																);
														})(e),
														(t.issuer = (0, d.Qj)(e.issuer)),
														(t.tokenUrl = (0, d.Qj)(e.tokenUrl)),
														(t.authorizeUrl = (0, d.Qj)(e.authorizeUrl)),
														(t.userinfoUrl = (0, d.Qj)(e.userinfoUrl)),
														(t.revokeUrl = (0, d.Qj)(e.revokeUrl)),
														(t.logoutUrl = (0, d.Qj)(e.logoutUrl)),
														(t.pkce = !1 !== e.pkce),
														(t.clientId = e.clientId),
														(t.redirectUri = e.redirectUri),
														(0, f.isBrowser)() && (t.redirectUri = (0, d.BY)(e.redirectUri, window.location.origin)),
														(t.responseType = e.responseType),
														(t.responseMode = e.responseMode),
														(t.state = e.state),
														(t.scopes = e.scopes),
														(t.ignoreSignature = !!e.ignoreSignature),
														(t.codeChallenge = e.codeChallenge),
														(t.codeChallengeMethod = e.codeChallengeMethod),
														(t.acrValues = e.acrValues),
														(t.maxAge = e.maxAge),
														(t.dpop = !0 === e.dpop),
														(t.tokenManager = e.tokenManager),
														(t.postLogoutRedirectUri = e.postLogoutRedirectUri),
														(t.restoreOriginalUri = e.restoreOriginalUri),
														(t.transactionManager = (function (e) {
															for (var t = 1; t < arguments.length; t++) {
																var n = null != arguments[t] ? arguments[t] : {};
																t % 2
																	? v(Object(n), !0).forEach(function (t) {
																			(0, u.Z)(e, t, n[t]);
																	  })
																	: Object.getOwnPropertyDescriptors
																	? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
																	: v(Object(n)).forEach(function (t) {
																			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
																	  });
															}
															return e;
														})({ enableSharedStorage: h }, e.transactionManager)),
														(t.clientSecret = e.clientSecret),
														(t.setLocation = e.setLocation),
														(t.ignoreLifetime = !!e.ignoreLifetime),
														e.maxClockSkew || 0 === e.maxClockSkew
															? (t.maxClockSkew = e.maxClockSkew)
															: (t.maxClockSkew = c.DEFAULT_MAX_CLOCK_SKEW),
														t
													);
												}
												return (0, r.Z)(g);
											})((0, p.Z)());
										}
									},
									3775: function (e, t, n) {
										'use strict';
										n.d(t, {
											m: function () {
												return r.m;
											},
										});
										var r = n(9453);
									},
									5372: function (e, t, n) {
										'use strict';
										n.d(t, {
											Tp: function () {
												return f;
											},
											ko: function () {
												return h;
											},
										});
										var r = n(5861),
											o = n(4687),
											i = n.n(o),
											a = n(9123),
											s = n(1969),
											l = n(9912),
											u = n(4771),
											c = n(8676);
										function d(e) {
											var t = e.options.pkce ? 'query' : 'fragment';
											return e.options.responseMode || t;
										}
										function f(e, t) {
											(t = t || {}), (0, u.HD)(t) && (t = { url: t });
											var n,
												r = t.url,
												o = t.responseMode || d(e),
												i = e.token.parseFromUrl._getLocation();
											if (
												!(n =
													'query' === o
														? r
															? r.substring(r.indexOf('?'))
															: i.search
														: r
														? r.substring(r.indexOf('#'))
														: i.hash)
											)
												throw new a.Z('Unable to parse a token from the url');
											return (0, s.v)(n);
										}
										function p(e, t) {
											'query' === (t.responseMode || d(e))
												? (function (e) {
														var t = e.token.parseFromUrl._getHistory(),
															n = e.token.parseFromUrl._getDocument(),
															r = e.token.parseFromUrl._getLocation();
														t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.hash) : (r.search = '');
												  })(e)
												: (function (e) {
														var t = e.token.parseFromUrl._getHistory(),
															n = e.token.parseFromUrl._getDocument(),
															r = e.token.parseFromUrl._getLocation();
														t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.search) : (r.hash = '');
												  })(e);
										}
										function h(e, t) {
											return m.apply(this, arguments);
										}
										function m() {
											return (m = (0, r.Z)(
												i().mark(function e(t, n) {
													var r, o, s, d;
													return i().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (
																		((n = n || {}),
																		(0, u.HD)(n) && (n = { url: n }),
																		(r = f(t, n)),
																		(o = r.state),
																		(s = t.transactionManager.load({ state: o })))
																	) {
																		e.next = 9;
																		break;
																	}
																	if (!t.options.pkce) {
																		e.next = 8;
																		break;
																	}
																	throw new a.Z(
																		'Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.',
																		void 0
																	);
																case 8:
																	throw new a.Z('Unable to retrieve OAuth redirect params from storage');
																case 9:
																	return (
																		(d = s.urls),
																		delete s.urls,
																		n.url || p(t, n),
																		e.abrupt(
																			'return',
																			(0, c.s)(t, s, r, d)
																				.catch(function (e) {
																					throw ((0, l.Cf)(e) || t.transactionManager.clear({ state: o }), e);
																				})
																				.then(function (e) {
																					return t.transactionManager.clear({ state: o }), e;
																				})
																		)
																	);
																case 13:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
									},
									2476: function (e, t, n) {
										'use strict';
										n.d(t, {
											$: function () {
												return f;
											},
										});
										var r = n(5861),
											o = n(4687),
											i = n.n(o),
											a = n(9123),
											s = n(6488),
											l = n(7625),
											u = n(781);
										function c() {
											throw new a.Z(
												'Renew must be passed a token with an array of scopes and an accessToken or idToken'
											);
										}
										function d(e, t) {
											return (0, s.sI)(e) ? t.idToken : (0, s.hv)(e) ? t.accessToken : void c();
										}
										function f(e, t) {
											return p.apply(this, arguments);
										}
										function p() {
											return (p = (0, r.Z)(
												i().mark(function e(t, n) {
													var r, o, a, f, p, h, m, v, g;
													return i().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (
																		((0, s.sI)(n) || (0, s.hv)(n) || c(),
																		!(r = t.tokenManager.getTokensSync()).refreshToken)
																	) {
																		e.next = 7;
																		break;
																	}
																	return (e.next = 5), (0, u.R)(t, { scopes: n.scopes }, r.refreshToken);
																case 5:
																	return (r = e.sent), e.abrupt('return', d(n, r));
																case 7:
																	return (
																		(o = t.options.pkce ? 'code' : (0, s.hv)(n) ? 'token' : 'id_token'),
																		(f = (a = n).scopes),
																		(p = a.authorizeUrl),
																		(h = a.userinfoUrl),
																		(m = a.issuer),
																		(v = a.dpopPairId),
																		(g = a.extraParams),
																		e.abrupt(
																			'return',
																			(0, l.y)(t, {
																				responseType: o,
																				scopes: f,
																				authorizeUrl: p,
																				userinfoUrl: h,
																				issuer: m,
																				dpopPairId: v,
																				extraParams: g,
																			}).then(function (e) {
																				return d(n, e.tokens);
																			})
																		)
																	);
																case 10:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
									},
									6268: function (e, t, n) {
										'use strict';
										n.d(t, {
											I: function () {
												return c;
											},
										});
										var r = n(5861),
											o = n(4687),
											i = n.n(o),
											a = n(9123),
											s = n(7625),
											l = n(781),
											u = n(7756);
										function c(e, t) {
											return d.apply(this, arguments);
										}
										function d() {
											return (d = (0, r.Z)(
												i().mark(function e(t, n) {
													var r, o, c, d, f, p, h, m, v, g, y, b, _;
													return i().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (
																		!(c =
																			null !== (r = null === (o = n) || void 0 === o ? void 0 : o.tokens) &&
																			void 0 !== r
																				? r
																				: t.tokenManager.getTokensSync()).refreshToken
																	) {
																		e.next = 3;
																		break;
																	}
																	return e.abrupt('return', (0, l.R)(t, n || {}, c.refreshToken));
																case 3:
																	if (c.accessToken || c.idToken) {
																		e.next = 5;
																		break;
																	}
																	throw new a.Z('renewTokens() was called but there is no existing token');
																case 5:
																	if (((d = c.accessToken || {}), (f = c.idToken || {}), (p = d.scopes || f.scopes))) {
																		e.next = 10;
																		break;
																	}
																	throw new a.Z('renewTokens: invalid tokens: could not read scopes');
																case 10:
																	if ((h = d.authorizeUrl || f.authorizeUrl)) {
																		e.next = 13;
																		break;
																	}
																	throw new a.Z('renewTokens: invalid tokens: could not read authorizeUrl');
																case 13:
																	return (
																		(m = d.userinfoUrl || t.options.userinfoUrl),
																		(v = f.issuer || t.options.issuer),
																		(g = null == d ? void 0 : d.dpopPairId),
																		(y = (null == d ? void 0 : d.extraParams) || (null == f ? void 0 : f.extraParams)),
																		(n = Object.assign(
																			{
																				scopes: p,
																				authorizeUrl: h,
																				userinfoUrl: m,
																				issuer: v,
																				dpopPairId: g,
																				extraParams: y,
																			},
																			n
																		)),
																		t.options.pkce
																			? (n.responseType = 'code')
																			: ((b = (0, u.D)(t)), (_ = b.responseType), (n.responseType = _)),
																		e.abrupt(
																			'return',
																			(0, s.y)(t, n).then(function (e) {
																				return e.tokens;
																			})
																		)
																	);
																case 20:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
									},
									781: function (e, t, n) {
										'use strict';
										n.d(t, {
											R: function () {
												return v;
											},
										});
										var r = n(4942),
											o = n(5861),
											i = n(4687),
											a = n.n(i),
											s = n(9123),
											l = n(7599),
											u = n(6635),
											c = n(8676),
											d = n(9231),
											f = n(7659),
											p = n(9912);
										function h(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function m(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? h(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: h(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function v(e, t, n) {
											return g.apply(this, arguments);
										}
										function g() {
											return (g = (0, o.Z)(
												a().mark(function e(t, n, r) {
													var o, i, h, v, g, y, b, _, w, O, k;
													return a().wrap(
														function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		if (((o = t.options), (i = o.clientId), (h = o.dpop), i)) {
																			e.next = 3;
																			break;
																		}
																		throw new s.Z(
																			'A clientId must be specified in the OktaAuth constructor to renew tokens'
																		);
																	case 3:
																		if (
																			((e.prev = 3),
																			(v = Object.assign({}, n, { clientId: i })),
																			r.extraParams && (v.extraParams = r.extraParams),
																			(g = m({}, v)),
																			!h)
																		) {
																			e.next = 14;
																			break;
																		}
																		return (e.next = 10), (0, f.lk)(null == r ? void 0 : r.dpopPairId);
																	case 10:
																		(y = e.sent), (g.dpopKeyPair = y), (v.dpop = h), (v.dpopPairId = r.dpopPairId);
																	case 14:
																		return (e.next = 16), (0, d.D)(t, g, r);
																	case 16:
																		return (b = e.sent), (_ = (0, l.Fc)(t, n)), (e.next = 20), (0, c.s)(t, v, b, _);
																	case 20:
																		return (
																			(w = e.sent),
																			(O = w.tokens),
																			(k = O.refreshToken) && !(0, u.q)(k, r) && t.tokenManager.updateRefreshToken(k),
																			e.abrupt('return', O)
																		);
																	case 27:
																		throw (
																			((e.prev = 27),
																			(e.t0 = e.catch(3)),
																			(0, p.$E)(e.t0) && t.tokenManager.removeRefreshToken(),
																			e.t0)
																		);
																	case 31:
																	case 'end':
																		return e.stop();
																}
														},
														e,
														null,
														[[3, 27]]
													);
												})
											)).apply(this, arguments);
										}
									},
									6466: function (e, t, n) {
										'use strict';
										n.d(t, {
											P: function () {
												return d;
											},
										});
										var r = n(5861),
											o = n(4687),
											i = n.n(o),
											a = n(5385),
											s = n(6718),
											l = n(7599),
											u = n(7594),
											c = n(9123);
										function d(e, t) {
											return f.apply(this, arguments);
										}
										function f() {
											return (f = (0, r.Z)(
												i().mark(function e(t, n) {
													var r, o, d, f, p, h, m;
													return i().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (((r = ''), (o = ''), n && ((r = n.accessToken), (o = n.refreshToken)), r || o)) {
																		e.next = 5;
																		break;
																	}
																	throw new c.Z('A valid access or refresh token object is required');
																case 5:
																	if (((d = t.options.clientId), (f = t.options.clientSecret), d)) {
																		e.next = 9;
																		break;
																	}
																	throw new c.Z(
																		'A clientId must be specified in the OktaAuth constructor to revoke a token'
																	);
																case 9:
																	return (
																		(p = (0, l.Fc)(t).revokeUrl),
																		(h = (0, s.UK)({
																			token_type_hint: o ? 'refresh_token' : 'access_token',
																			token: o || r,
																		}).slice(1)),
																		(m = f ? (0, u.r3)(''.concat(d, ':').concat(f)) : (0, u.r3)(d)),
																		e.abrupt(
																			'return',
																			(0, a.v_)(t, p, h, {
																				headers: {
																					'Content-Type': 'application/x-www-form-urlencoded',
																					'Authorization': 'Basic ' + m,
																				},
																			})
																		)
																	);
																case 13:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
									},
									2333: function (e, t, n) {
										'use strict';
										n.d(t, {
											a: function () {
												return d;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(136),
											a = n(2963),
											s = n(1120),
											l = n(5437),
											u = n(5763),
											c = n(1971);
										function d() {
											return (function (e) {
												(0, i.Z)(f, e);
												var t,
													n,
													d =
														((t = f),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, s.Z)(t);
															if (n) {
																var o = (0, s.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, a.Z)(this, e);
														});
												function f(e, t, n) {
													return (0, r.Z)(this, f), d.call(this, e, t, n);
												}
												return (
													(0, o.Z)(f, [
														{
															key: 'getTransactionStorage',
															value: function (e) {
																(e = this.getOptionsForSection('transaction', e)), (0, l.V)(e);
																var t = this.getStorage(e),
																	n = e.storageKey || c.TRANSACTION_STORAGE_NAME;
																return new u._(t, n);
															},
														},
														{
															key: 'getSharedTansactionStorage',
															value: function (e) {
																(e = this.getOptionsForSection('shared-transaction', e)), (0, l.V)(e);
																var t = this.getStorage(e),
																	n = e.storageKey || c.SHARED_TRANSACTION_STORAGE_NAME;
																return new u._(t, n);
															},
														},
														{
															key: 'getOriginalUriStorage',
															value: function (e) {
																(e = this.getOptionsForSection('original-uri', e)), (0, l.V)(e);
																var t = this.getStorage(e),
																	n = e.storageKey || c.ORIGINAL_URI_STORAGE_NAME;
																return new u._(t, n);
															},
														},
													]),
													f
												);
											})(l.W);
										}
									},
									6488: function (e, t, n) {
										'use strict';
										var r;
										function o(e) {
											return !!(e && (e.accessToken || e.idToken || e.refreshToken) && Array.isArray(e.scopes));
										}
										function i(e) {
											return e && e.accessToken;
										}
										function a(e) {
											return e && e.idToken;
										}
										function s(e) {
											return e && e.refreshToken;
										}
										n.d(t, {
											T6: function () {
												return r;
											},
											hD: function () {
												return o;
											},
											hv: function () {
												return i;
											},
											sI: function () {
												return a;
											},
											z9: function () {
												return s;
											},
										}),
											(function (e) {
												(e.ACCESS = 'accessToken'), (e.ID = 'idToken'), (e.REFRESH = 'refreshToken');
											})(r || (r = {}));
									},
									7088: function (e, t, n) {
										'use strict';
										n.d(t, {
											$I: function () {
												return s;
											},
											$Y: function () {
												return r;
											},
											E: function () {
												return o;
											},
											FT: function () {
												return a;
											},
											O3: function () {
												return i;
											},
											zr: function () {
												return l;
											},
										});
										var r = 'expired',
											o = 'renewed',
											i = 'added',
											a = 'removed',
											s = 'error',
											l = 'set_storage';
									},
									4319: function (e, t, n) {
										'use strict';
										n.d(t, {
											G5: function () {
												return i;
											},
											ZT: function () {
												return a;
											},
											mH: function () {
												return u;
											},
											rZ: function () {
												return l;
											},
											sG: function () {
												return s;
											},
										});
										var r = n(1002);
										function o(e) {
											return !(!e || 'object' !== (0, r.Z)(e) || 0 === Object.values(e).length);
										}
										function i(e) {
											return !(!o(e) || (!e.redirectUri && !e.responseType));
										}
										function a(e) {
											return !!i(e) && !!e.codeVerifier;
										}
										function s(e) {
											return !!a(e) && !!e.interactionHandle;
										}
										function l(e) {
											return (
												!!o(e) &&
												void 0 ===
													Object.values(e).find(function (e) {
														return 'string' != typeof e;
													})
											);
										}
										function u(e) {
											return !(!i(e) && !l(e));
										}
									},
									7615: function () {},
									8927: function (e, t, n) {
										'use strict';
										n.r(t),
											n.d(t, {
												EVENT_ADDED: function () {
													return s.O3;
												},
												EVENT_ERROR: function () {
													return s.$I;
												},
												EVENT_EXPIRED: function () {
													return s.$Y;
												},
												EVENT_REMOVED: function () {
													return s.FT;
												},
												EVENT_RENEWED: function () {
													return s.E;
												},
												EVENT_SET_STORAGE: function () {
													return s.zr;
												},
												TokenKind: function () {
													return a.T6;
												},
												isAccessToken: function () {
													return a.hv;
												},
												isCustomAuthTransactionMeta: function () {
													return l.rZ;
												},
												isIDToken: function () {
													return a.sI;
												},
												isIdxTransactionMeta: function () {
													return l.sG;
												},
												isOAuthTransactionMeta: function () {
													return l.G5;
												},
												isPKCETransactionMeta: function () {
													return l.ZT;
												},
												isRefreshToken: function () {
													return a.z9;
												},
												isToken: function () {
													return a.hD;
												},
												isTransactionMeta: function () {
													return l.mH;
												},
											});
										var r = n(9263),
											o = {};
										for (var i in r)
											'default' !== i &&
												(o[i] = function (e) {
													return r[e];
												}.bind(0, i));
										n.d(t, o);
										var a = n(6488),
											s = n(7088),
											l = n(4319),
											u = n(7615);
										for (var i in ((o = {}), u))
											[
												'default',
												'TokenKind',
												'isAccessToken',
												'isIDToken',
												'isRefreshToken',
												'isToken',
												'EVENT_ADDED',
												'EVENT_ERROR',
												'EVENT_EXPIRED',
												'EVENT_REMOVED',
												'EVENT_RENEWED',
												'EVENT_SET_STORAGE',
												'isCustomAuthTransactionMeta',
												'isIdxTransactionMeta',
												'isOAuthTransactionMeta',
												'isPKCETransactionMeta',
												'isTransactionMeta',
											].indexOf(i) < 0 &&
												(o[i] = function (e) {
													return u[e];
												}.bind(0, i));
										n.d(t, o);
									},
									9263: function () {},
									4970: function (e, t, n) {
										'use strict';
										n.d(t, {
											NH: function () {
												return o;
											},
											Rl: function () {
												return a;
											},
											iC: function () {
												return l;
											},
											pU: function () {
												return s;
											},
											ys: function () {
												return i;
											},
										});
										var r = n(9123);
										function o(e, t, n) {
											e.addEventListener ? e.addEventListener(t, n) : e.attachEvent('on' + t, n);
										}
										function i(e, t, n) {
											e.removeEventListener ? e.removeEventListener(t, n) : e.detachEvent('on' + t, n);
										}
										function a(e) {
											var t = document.createElement('iframe');
											return (t.style.display = 'none'), (t.src = e), document.body.appendChild(t);
										}
										function s(e, t) {
											var n = t.popupTitle || 'External Identity Provider User Authentication';
											return window.open(
												e,
												n,
												'toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600'
											);
										}
										function l(e, t, n) {
											var a, s;
											return new Promise(function (i, l) {
												(a = function (t) {
													if (t.data && t.data.state === n)
														return t.origin !== e.getIssuerOrigin()
															? l(new r.Z('The request does not match client configuration'))
															: void i(t.data);
												}),
													o(window, 'message', a),
													(s = setTimeout(function () {
														l(new r.Z('OAuth flow timed out'));
													}, t || 12e4));
											}).finally(function () {
												clearTimeout(s), i(window, 'message', a);
											});
										}
									},
									5078: function (e, t, n) {
										'use strict';
										n.d(t, {
											c: function () {
												return a;
											},
										});
										var r = n(7599),
											o = n(415),
											i = n(3193);
										function a(e) {
											var t = e.options,
												n = t.clientId,
												a = t.redirectUri,
												s = t.responseMode,
												l = t.state,
												u = (0, o.isBrowser)() ? window.location.href : void 0;
											return (0, i.YY)({
												clientId: n,
												redirectUri: a || u,
												responseMode: s,
												state: l || (0, r.aV)(),
												responseType: 'none',
												prompt: 'enroll_authenticator',
											});
										}
									},
									7756: function (e, t, n) {
										'use strict';
										n.d(t, {
											D: function () {
												return a;
											},
										});
										var r = n(7599),
											o = n(415),
											i = n(3193);
										function a(e) {
											var t = e.options,
												n = t.pkce,
												a = t.clientId,
												s = t.redirectUri,
												l = t.responseType,
												u = t.responseMode,
												c = t.scopes,
												d = t.acrValues,
												f = t.maxAge,
												p = t.state,
												h = t.ignoreSignature,
												m = t.dpop,
												v = (0, o.isBrowser)() ? window.location.href : void 0;
											return (0, i.YY)({
												pkce: n,
												clientId: a,
												redirectUri: s || v,
												responseType: l || ['token', 'id_token'],
												responseMode: u,
												state: p || (0, r.aV)(),
												nonce: (0, r.NH)(),
												scopes: c || ['openid', 'email'],
												acrValues: d,
												maxAge: f,
												ignoreSignature: h,
												dpop: m,
											});
										}
									},
									8080: function (e, t, n) {
										'use strict';
										n.d(t, {
											A: function () {
												return o;
											},
										});
										var r = n(7599);
										function o(e, t) {
											return {
												issuer: e.options.issuer,
												urls: (0, r.Fc)(e, t),
												clientId: t.clientId,
												redirectUri: t.redirectUri,
												responseType: t.responseType,
												responseMode: t.responseMode,
												state: t.state,
												acrValues: t.acrValues,
												enrollAmrValues: t.enrollAmrValues,
											};
										}
									},
									9912: function (e, t, n) {
										'use strict';
										n.d(t, {
											$E: function () {
												return a;
											},
											Cf: function () {
												return o;
											},
											tC: function () {
												return i;
											},
										});
										var r = n(5728);
										function o(e) {
											return 'OAuthError' === e.name && 'interaction_required' === e.errorCode;
										}
										function i(e, t) {
											if ('AuthApiError' !== t.name) return !1;
											var n = t.xhr,
												r = null == n ? void 0 : n.responseJSON;
											return e.options.pkce && 'invalid_grant' === (null == r ? void 0 : r.error);
										}
										function a(e) {
											return (
												(0, r.isOAuthError)(e) &&
												'invalid_grant' === e.errorCode &&
												'The refresh token is invalid or expired.' === e.errorSummary
											);
										}
									},
									8785: function (e, t, n) {
										'use strict';
										n.d(t, {
											$E: function () {
												return a.$E;
											},
											AW: function () {
												return c.A;
											},
											Cf: function () {
												return a.Cf;
											},
											Dx: function () {
												return o.D;
											},
											Fc: function () {
												return l.Fc;
											},
											H: function () {
												return u.H;
											},
											Ik: function () {
												return s.Ik;
											},
											NH: function () {
												return r.NH;
											},
											O2: function () {
												return s.O2;
											},
											PY: function () {
												return l.NH;
											},
											Qs: function () {
												return s.Qs;
											},
											Rl: function () {
												return r.Rl;
											},
											Rp: function () {
												return g.R;
											},
											U5: function () {
												return d.Z;
											},
											Uc: function () {
												return p.U;
											},
											Xp: function () {
												return l.Xp;
											},
											Yo: function () {
												return h.Y;
											},
											ZP: function () {
												return s.ZP;
											},
											aV: function () {
												return l.aV;
											},
											br: function () {
												return f.br;
											},
											cE: function () {
												return i.c;
											},
											d_: function () {
												return s.d_;
											},
											gM: function () {
												return s.gM;
											},
											hg: function () {
												return s.hg;
											},
											iC: function () {
												return r.iC;
											},
											kU: function () {
												return s.kU;
											},
											mi: function () {
												return f.mi;
											},
											pU: function () {
												return r.pU;
											},
											pj: function () {
												return v.p;
											},
											q0: function () {
												return h.q;
											},
											tC: function () {
												return a.tC;
											},
											vL: function () {
												return m.v;
											},
											vz: function () {
												return f.vz;
											},
											wV: function () {
												return s.wV;
											},
											wc: function () {
												return s.wc;
											},
											wu: function () {
												return f.wu;
											},
											ys: function () {
												return r.ys;
											},
											zf: function () {
												return l.zf;
											},
										});
										var r = n(4970),
											o = n(7756),
											i = n(5078),
											a = n(9912),
											s = n(8221),
											l = n(7599),
											u = n(2865),
											c = n(8080),
											d = n(3611),
											f = n(6898),
											p = n(6757),
											h = n(6635),
											m = n(1969),
											v = n(6003),
											g = n(2482);
									},
									8221: function (e, t, n) {
										'use strict';
										function r(e) {
											return /((id|access)_token=)/i.test(e);
										}
										function o(e) {
											return /(code=)/i.test(e);
										}
										function i(e) {
											return /(interaction_code=)/i.test(e);
										}
										function a(e) {
											return /(error=)/i.test(e) || /(error_description)/i.test(e);
										}
										function s(e, t) {
											var n = t.options;
											return !(!e || !n.redirectUri) && 0 === e.indexOf(n.redirectUri);
										}
										function l(e) {
											return e.pkce || 'code' === e.responseType || 'query' === e.responseMode;
										}
										function u(e, t) {
											return Array.isArray(t.responseType) && t.responseType.length
												? t.responseType.indexOf(e) >= 0
												: t.responseType === e;
										}
										function c(e) {
											return l(e) && 'fragment' !== e.responseMode ? window.location.search : window.location.hash;
										}
										function d(e) {
											if (!s(window.location.href, e)) return !1;
											var t = l(e.options),
												n = c(e.options);
											return !!a(n) || (t ? o(n) || i(n) : r(window.location.hash));
										}
										function f(e, t) {
											if (!t) {
												if (!d(e)) return !1;
												t = c(e.options);
											}
											return /(error=interaction_required)/i.test(t);
										}
										n.d(t, {
											Ik: function () {
												return l;
											},
											O2: function () {
												return c;
											},
											Qs: function () {
												return s;
											},
											ZP: function () {
												return o;
											},
											d_: function () {
												return i;
											},
											gM: function () {
												return d;
											},
											hg: function () {
												return a;
											},
											kU: function () {
												return r;
											},
											wV: function () {
												return u;
											},
											wc: function () {
												return f;
											},
										});
									},
									7599: function (e, t, n) {
										'use strict';
										n.d(t, {
											Fc: function () {
												return d;
											},
											NH: function () {
												return s;
											},
											Xp: function () {
												return c;
											},
											aV: function () {
												return a;
											},
											zf: function () {
												return u;
											},
										});
										var r = n(8750),
											o = n(6718),
											i = n(9123);
										function a() {
											return (0, r.uh)(64);
										}
										function s() {
											return (0, r.uh)(64);
										}
										function l(e) {
											var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
											return (0, o.Qj)(t.issuer) || e.options.issuer;
										}
										function u(e) {
											var t = l(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
											return t.indexOf('/oauth2') > 0 ? t : t + '/oauth2';
										}
										function c(e) {
											return l(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).split(
												'/oauth2'
											)[0];
										}
										function d(e, t) {
											if (arguments.length > 2)
												throw new i.Z('As of version 3.0, "getOAuthUrls" takes only a single set of options');
											t = t || {};
											var n = (0, o.Qj)(t.authorizeUrl) || e.options.authorizeUrl,
												r = l(e, t),
												a = (0, o.Qj)(t.userinfoUrl) || e.options.userinfoUrl,
												s = (0, o.Qj)(t.tokenUrl) || e.options.tokenUrl,
												c = (0, o.Qj)(t.logoutUrl) || e.options.logoutUrl,
												d = (0, o.Qj)(t.revokeUrl) || e.options.revokeUrl,
												f = u(e, t);
											return {
												issuer: r,
												authorizeUrl: (n = n || f + '/v1/authorize'),
												userinfoUrl: (a = a || f + '/v1/userinfo'),
												tokenUrl: (s = s || f + '/v1/token'),
												revokeUrl: (d = d || f + '/v1/revoke'),
												logoutUrl: (c = c || f + '/v1/logout'),
											};
										}
									},
									2865: function (e, t, n) {
										'use strict';
										n.d(t, {
											H: function () {
												return s;
											},
										});
										var r = n(4942),
											o = n(7599);
										function i(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function a(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? i(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: i(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function s(e, t) {
											var n = {
												issuer: e.options.issuer,
												urls: (0, o.Fc)(e, t),
												clientId: t.clientId,
												redirectUri: t.redirectUri,
												responseType: t.responseType,
												responseMode: t.responseMode,
												scopes: t.scopes,
												state: t.state,
												nonce: t.nonce,
												ignoreSignature: t.ignoreSignature,
												acrValues: t.acrValues,
												extraParams: t.extraParams,
											};
											return !1 === t.pkce
												? n
												: a(
														a({}, n),
														{},
														{
															codeVerifier: t.codeVerifier,
															codeChallengeMethod: t.codeChallengeMethod,
															codeChallenge: t.codeChallenge,
														}
												  );
										}
									},
									3611: function (e, t, n) {
										'use strict';
										var r = n(7594),
											o = n(7987),
											i = n(1971);
										function a(e) {
											return ('0' + e.toString(16)).substr(-2);
										}
										t.Z = {
											DEFAULT_CODE_CHALLENGE_METHOD: i.DEFAULT_CODE_CHALLENGE_METHOD,
											generateVerifier: function (e) {
												var t,
													n,
													o = e || '';
												return (
													o.length < i.MIN_VERIFIER_LENGTH &&
														(o +=
															((t = i.MIN_VERIFIER_LENGTH - o.length),
															(n = new Uint8Array(Math.ceil(t / 2))),
															r.KP.getRandomValues(n),
															Array.from(n, a).join('').slice(0, t))),
													encodeURIComponent(o).slice(0, i.MAX_VERIFIER_LENGTH)
												);
											},
											computeChallenge: function (e) {
												var t = new TextEncoder().encode(e);
												return r.KP.subtle.digest('SHA-256', t).then(function (e) {
													var t = String.fromCharCode.apply(null, new Uint8Array(e));
													return (0, o.NL)(t);
												});
											},
										};
									},
									6757: function (e, t, n) {
										'use strict';
										n.d(t, {
											U: function () {
												return l;
											},
										});
										var r = n(4942),
											o = n(9123),
											i = n(5078);
										function a(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function s(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? a(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: a(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function l(e, t) {
											return (function (e) {
												if (
													!(e = s(s({}, e), {}, { responseType: 'none', prompt: 'enroll_authenticator', maxAge: 0 }))
														.enrollAmrValues
												)
													throw new o.Z('enroll_amr_values must be specified');
												if (!e.acrValues) throw new o.Z('acr_values must be specified');
												return delete e.scopes, delete e.nonce, e;
											})(s(s({}, (0, i.c)(e)), t));
										}
									},
									6898: function (e, t, n) {
										'use strict';
										n.d(t, {
											br: function () {
												return m;
											},
											mi: function () {
												return g;
											},
											vz: function () {
												return h;
											},
											wu: function () {
												return b;
											},
										});
										var r = n(4942),
											o = n(5861),
											i = n(4687),
											a = n.n(i),
											s = n(52),
											l = n(9123),
											u = n(7756),
											c = n(1971),
											d = n(3611);
										function f(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function p(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? f(Object(n), !0).forEach(function (t) {
															(0, r.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: f(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function h(e) {
											if (!e.features.isPKCESupported()) {
												var t = 'PKCE requires a modern browser with encryption support running in a secure context.';
												throw (
													(e.features.isHTTPS() ||
														(t +=
															'\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol.'),
													e.features.hasTextEncoder() ||
														(t +=
															'\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'),
													new l.Z(t))
												);
											}
										}
										function m(e, t) {
											return v.apply(this, arguments);
										}
										function v() {
											return (v = (0, o.Z)(
												a().mark(function e(t, n) {
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	return (
																		(n = n || t.options.codeChallengeMethod || c.DEFAULT_CODE_CHALLENGE_METHOD),
																		(e.next = 3),
																		(0, s.E)(t)
																	);
																case 3:
																	if (-1 !== (e.sent.code_challenge_methods_supported || []).indexOf(n)) {
																		e.next = 7;
																		break;
																	}
																	throw new l.Z('Invalid code_challenge_method');
																case 7:
																	return e.abrupt('return', n);
																case 8:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function g(e, t) {
											return y.apply(this, arguments);
										}
										function y() {
											return (y = (0, o.Z)(
												a().mark(function e(t, n) {
													var r, o, i, s;
													return a().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (
																		((o = (r = n).codeVerifier),
																		(i = r.codeChallenge),
																		(s = r.codeChallengeMethod),
																		(i = i || t.options.codeChallenge))
																	) {
																		e.next = 8;
																		break;
																	}
																	return h(t), (o = o || d.Z.generateVerifier()), (e.next = 7), d.Z.computeChallenge(o);
																case 7:
																	i = e.sent;
																case 8:
																	return (e.next = 10), m(t, s);
																case 10:
																	return (
																		(s = e.sent),
																		(n = p(
																			p({}, n),
																			{},
																			{
																				responseType: 'code',
																				codeVerifier: o,
																				codeChallenge: i,
																				codeChallengeMethod: s,
																			}
																		)),
																		e.abrupt('return', n)
																	);
																case 13:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
										function b(e) {
											return _.apply(this, arguments);
										}
										function _() {
											return (
												(_ = (0, o.Z)(
													a().mark(function e(t) {
														var n,
															r,
															o = arguments;
														return a().wrap(function (e) {
															for (;;)
																switch ((e.prev = e.next)) {
																	case 0:
																		if (
																			((n = o.length > 1 && void 0 !== o[1] ? o[1] : {}),
																			(r = (0, u.D)(t)),
																			!(n = p(p({}, r), n)).dpop || t.features.isDPoPSupported())
																		) {
																			e.next = 5;
																			break;
																		}
																		throw new l.Z('DPoP has been configured, but is not supported by browser');
																	case 5:
																		if (!1 !== n.pkce) {
																			e.next = 7;
																			break;
																		}
																		return e.abrupt('return', n);
																	case 7:
																		return e.abrupt('return', g(t, n));
																	case 8:
																	case 'end':
																		return e.stop();
																}
														}, e);
													})
												)),
												_.apply(this, arguments)
											);
										}
									},
									6635: function (e, t, n) {
										'use strict';
										n.d(t, {
											Y: function () {
												return i;
											},
											q: function () {
												return o;
											},
										});
										var r = n(5728);
										function o(e, t) {
											return e.refreshToken === t.refreshToken;
										}
										function i(e) {
											return !(
												!(0, r.isAuthApiError)(e) ||
												!e.xhr ||
												!e.xhr.responseJSON ||
												'invalid_grant' !== e.xhr.responseJSON.error
											);
										}
									},
									1969: function (e, t, n) {
										'use strict';
										function r(e) {
											var t = /\+/g,
												n = /([^&=]+)=?([^&]*)/g,
												r = e || '';
											'#' === r.charAt(0) && '/' === r.charAt(1) && (r = r.substring(2)),
												('#' !== r.charAt(0) && '?' !== r.charAt(0)) || (r = r.substring(1));
											for (var o, i = {}; (o = n.exec(r)); ) {
												var a = o[1],
													s = o[2];
												i[a] =
													'id_token' === a || 'access_token' === a || 'code' === a
														? s
														: decodeURIComponent(s.replace(t, ' '));
											}
											return i;
										}
										n.d(t, {
											v: function () {
												return r;
											},
										});
									},
									6003: function (e, t, n) {
										'use strict';
										n.d(t, {
											p: function () {
												return o;
											},
										});
										var r = n(9123);
										function o(e, t, n) {
											var o = n.clientId,
												i = n.issuer,
												a = n.nonce,
												s = n.acrValues;
											if (!t || !i || !o) throw new r.Z('The jwt, iss, and aud arguments are all required');
											if (a && t.nonce !== a) throw new r.Z("OAuth flow response nonce doesn't match request nonce");
											var l = Math.floor(Date.now() / 1e3);
											if (t.iss !== i) throw new r.Z('The issuer [' + t.iss + '] does not match [' + i + ']');
											if ((Array.isArray(t.aud) && t.aud.indexOf(o) < 0) || (!Array.isArray(t.aud) && t.aud !== o))
												throw new r.Z('The audience [' + t.aud + '] does not match [' + o + ']');
											if (s && t.acr !== s)
												throw new r.Z('The acr [' + t.acr + '] does not match acr_values [' + s + ']');
											if (t.iat > t.exp) throw new r.Z('The JWT expired before it was issued');
											if (!e.options.ignoreLifetime) {
												if (l - e.options.maxClockSkew > t.exp) throw new r.Z('The JWT expired and is no longer valid');
												if (t.iat > l + e.options.maxClockSkew) throw new r.Z('The JWT was issued in the future');
											}
										}
									},
									2482: function (e, t, n) {
										'use strict';
										n.d(t, {
											R: function () {
												return i;
											},
										});
										var r = n(9123),
											o = n(6488);
										function i(e, t) {
											if (!(0, o.sI)(e) && !(0, o.hv)(e) && !(0, o.z9)(e))
												throw new r.Z(
													'Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property'
												);
											if ('accessToken' === t && !(0, o.hv)(e)) throw new r.Z('invalid accessToken');
											if ('idToken' === t && !(0, o.sI)(e)) throw new r.Z('invalid idToken');
											if ('refreshToken' === t && !(0, o.z9)(e)) throw new r.Z('invalid refreshToken');
										}
									},
									1260: function (e, t, n) {
										'use strict';
										n.d(t, {
											W: function () {
												return f;
											},
										});
										var r = n(5861),
											o = n(4687),
											i = n.n(o),
											a = n(52),
											s = n(6003),
											l = n(9123),
											u = n(1237),
											c = n(3154),
											d = n(5698);
										function f(e, t, n) {
											return p.apply(this, arguments);
										}
										function p() {
											return (p = (0, r.Z)(
												i().mark(function e(t, n, r) {
													var o, f, p, h, m, v;
													return i().wrap(function (e) {
														for (;;)
															switch ((e.prev = e.next)) {
																case 0:
																	if (n && n.idToken) {
																		e.next = 2;
																		break;
																	}
																	throw new l.Z('Only idTokens may be verified');
																case 2:
																	return (
																		(o = (0, u.T)(n.idToken)),
																		(f = (null == r ? void 0 : r.issuer) || t.options.issuer),
																		(e.next = 6),
																		(0, a.E)(t, f)
																	);
																case 6:
																	if (
																		((p = e.sent),
																		(h = p.issuer),
																		(m = Object.assign(
																			{ clientId: t.options.clientId, ignoreSignature: t.options.ignoreSignature },
																			r,
																			{ issuer: h }
																		)),
																		(0, s.p)(t, o.payload, m),
																		1 != m.ignoreSignature && t.features.isTokenVerifySupported())
																	) {
																		e.next = 12;
																		break;
																	}
																	return e.abrupt('return', n);
																case 12:
																	return (e.next = 14), (0, a.k)(t, n.issuer, o.header.kid);
																case 14:
																	return (v = e.sent), (e.next = 17), c.W(n.idToken, v);
																case 17:
																	if (e.sent) {
																		e.next = 20;
																		break;
																	}
																	throw new l.Z('The token signature is not valid');
																case 20:
																	if (!(r && r.accessToken && n.claims.at_hash)) {
																		e.next = 26;
																		break;
																	}
																	return (e.next = 23), d.X(r.accessToken);
																case 23:
																	if (e.sent === n.claims.at_hash) {
																		e.next = 26;
																		break;
																	}
																	throw new l.Z('Token hash verification failed');
																case 26:
																	return e.abrupt('return', n);
																case 27:
																case 'end':
																	return e.stop();
															}
													}, e);
												})
											)).apply(this, arguments);
										}
									},
									3719: function (e, t, n) {
										'use strict';
										n.d(t, {
											Gg: function () {
												return s;
											},
											OT: function () {
												return c;
											},
											RJ: function () {
												return l;
											},
											dx: function () {
												return u;
											},
											sH: function () {
												return a;
											},
										});
										var r = n(3193),
											o = n(6718),
											i = n(5385);
										function a(e) {
											return e.session
												.get()
												.then(function (e) {
													return 'ACTIVE' === e.status;
												})
												.catch(function () {
													return !1;
												});
										}
										function s(e) {
											return (0, i.U2)(e, '/api/v1/sessions/me', { withCredentials: !0 })
												.then(function (t) {
													var n = (0, r.CE)(t, '_links');
													return (
														(n.refresh = function () {
															return (0, i.v_)(e, (0, r.Rg)(t, 'refresh').href, {}, { withCredentials: !0 });
														}),
														(n.user = function () {
															return (0, i.U2)(e, (0, r.Rg)(t, 'user').href, { withCredentials: !0 });
														}),
														n
													);
												})
												.catch(function () {
													return { status: 'INACTIVE' };
												});
										}
										function l(e) {
											return (0, i.c3)(e, {
												url: e.getIssuerOrigin() + '/api/v1/sessions/me',
												method: 'DELETE',
												withCredentials: !0,
											});
										}
										function u(e) {
											return (0, i.v_)(e, '/api/v1/sessions/me/lifecycle/refresh', {}, { withCredentials: !0 });
										}
										function c(e, t, n) {
											(n = n || window.location.href),
												window.location.assign(
													e.getIssuerOrigin() +
														'/login/sessionCookieRedirect' +
														(0, o.UK)({ checkAccountSetupComplete: !0, token: t, redirectUrl: n })
												);
										}
									},
									2815: function (e, t, n) {
										'use strict';
										n.d(t, {
											M: function () {
												return o;
											},
										});
										var r = n(3719);
										function o(e) {
											return {
												close: r.RJ.bind(null, e),
												exists: r.sH.bind(null, e),
												get: r.Gg.bind(null, e),
												refresh: r.dx.bind(null, e),
												setCookieAndRedirect: r.OT.bind(null, e),
											};
										}
									},
									8041: function (e, t, n) {
										'use strict';
										n.d(t, {
											Gg: function () {
												return r.Gg;
											},
											MG: function () {
												return o.M;
											},
											OT: function () {
												return r.OT;
											},
											RJ: function () {
												return r.RJ;
											},
											Zg: function () {
												return i.Z;
											},
											dx: function () {
												return r.dx;
											},
											sH: function () {
												return r.sH;
											},
										});
										var r = n(3719),
											o = n(2815),
											i = n(3980);
									},
									3980: function (e, t, n) {
										'use strict';
										n.d(t, {
											Z: function () {
												return h;
											},
										});
										var r = n(5861),
											o = n(5671),
											i = n(3144),
											a = n(7326),
											s = n(136),
											l = n(2963),
											u = n(1120),
											c = n(4942),
											d = n(4687),
											f = n.n(d),
											p = n(2815);
										function h(e) {
											return (function (e) {
												(0, s.Z)(h, e);
												var t,
													n,
													d =
														((t = h),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, u.Z)(t);
															if (n) {
																var o = (0, u.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, l.Z)(this, e);
														});
												function h() {
													var e;
													(0, o.Z)(this, h);
													for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
													return (
														(e = d.call.apply(d, [this].concat(n))),
														(0, c.Z)((0, a.Z)(e), 'session', void 0),
														(e.session = (0, p.M)((0, a.Z)(e))),
														e
													);
												}
												return (
													(0, i.Z)(h, [
														{
															key: 'closeSession',
															value: function () {
																var e = this;
																return this.session
																	.close()
																	.then(
																		(0, r.Z)(
																			f().mark(function t() {
																				return f().wrap(function (t) {
																					for (;;)
																						switch ((t.prev = t.next)) {
																							case 0:
																								return e.clearStorage(), t.abrupt('return', !0);
																							case 2:
																							case 'end':
																								return t.stop();
																						}
																				}, t);
																			})
																		)
																	)
																	.catch(function (e) {
																		if ('AuthApiError' === e.name && 'E0000007' === e.errorCode) return !1;
																		throw e;
																	});
															},
														},
													]),
													h
												);
											})(e);
										}
									},
									5437: function (e, t, n) {
										'use strict';
										n.d(t, {
											V: function () {
												return c;
											},
											W: function () {
												return d;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(4942),
											a = n(1971),
											s = n(5763),
											l = n(415),
											u = n(146);
										function c(e) {
											(0, l.isBrowser)() ||
												e.storageProvider ||
												e.storageKey ||
												(0, u.ZK)(
													'Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.'
												);
										}
										var d = (function () {
											function e(t, n, o) {
												(0, r.Z)(this, e),
													(0, i.Z)(this, 'storageManagerOptions', void 0),
													(0, i.Z)(this, 'cookieOptions', void 0),
													(0, i.Z)(this, 'storageUtil', void 0),
													(this.storageManagerOptions = t),
													(this.cookieOptions = n),
													(this.storageUtil = o);
											}
											return (
												(0, o.Z)(e, [
													{
														key: 'getOptionsForSection',
														value: function (e, t) {
															return Object.assign({}, this.storageManagerOptions[e], t);
														},
													},
													{
														key: 'getStorage',
														value: function (e) {
															if ((e = Object.assign({}, this.cookieOptions, e)).storageProvider)
																return e.storageProvider;
															var t = e,
																n = t.storageType,
																r = t.storageTypes;
															if (('sessionStorage' === n && (e.sessionCookie = !0), n && r)) {
																var o = r.indexOf(n);
																o >= 0 && ((r = r.slice(o)), (n = void 0));
															}
															return (
																n || (n = this.storageUtil.findStorageType(r)), this.storageUtil.getStorageByType(n, e)
															);
														},
													},
													{
														key: 'getTokenStorage',
														value: function (e) {
															c((e = this.getOptionsForSection('token', e)));
															var t = this.getStorage(e),
																n = e.storageKey || a.TOKEN_STORAGE_NAME;
															return new s._(t, n);
														},
													},
													{
														key: 'getHttpCache',
														value: function (e) {
															e = this.getOptionsForSection('cache', e);
															var t = this.getStorage(e),
																n = e.storageKey || a.CACHE_STORAGE_NAME;
															return new s._(t, n);
														},
													},
												]),
												e
											);
										})();
									},
									5763: function (e, t, n) {
										'use strict';
										n.d(t, {
											_: function () {
												return s;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(4942),
											a = n(9123),
											s = (function () {
												function e(t, n) {
													if (
														((0, r.Z)(this, e),
														(0, i.Z)(this, 'storageProvider', void 0),
														(0, i.Z)(this, 'storageName', void 0),
														!t)
													)
														throw new a.Z('"storage" is required');
													if ('string' != typeof n || !n.length) throw new a.Z('"storageName" is required');
													(this.storageName = n), (this.storageProvider = t);
												}
												return (
													(0, o.Z)(e, [
														{
															key: 'getItem',
															value: function (e) {
																return this.getStorage()[e];
															},
														},
														{
															key: 'setItem',
															value: function (e, t) {
																return this.updateStorage(e, t);
															},
														},
														{
															key: 'removeItem',
															value: function (e) {
																return this.clearStorage(e);
															},
														},
														{
															key: 'getStorage',
															value: function () {
																var e = this.storageProvider.getItem(this.storageName);
																e = e || '{}';
																try {
																	return JSON.parse(e);
																} catch (e) {
																	throw new a.Z('Unable to parse storage string: ' + this.storageName);
																}
															},
														},
														{
															key: 'setStorage',
															value: function (e) {
																try {
																	var t = e ? JSON.stringify(e) : '{}';
																	this.storageProvider.setItem(this.storageName, t);
																} catch (e) {
																	throw new a.Z('Unable to set storage: ' + this.storageName);
																}
															},
														},
														{
															key: 'clearStorage',
															value: function (e) {
																if (e) {
																	var t = this.getStorage();
																	delete t[e], this.setStorage(t);
																} else
																	this.storageProvider.removeItem
																		? this.storageProvider.removeItem(this.storageName)
																		: this.setStorage();
															},
														},
														{
															key: 'updateStorage',
															value: function (e, t) {
																var n = this.getStorage();
																(n[e] = t), this.setStorage(n);
															},
														},
													]),
													e
												);
											})();
									},
									9927: function (e, t, n) {
										'use strict';
										n.d(t, {
											Ho: function () {
												return i.H;
											},
											Tp: function () {
												return r.T;
											},
											Vp: function () {
												return o.V;
											},
											W8: function () {
												return o.W;
											},
											_e: function () {
												return a._;
											},
										});
										var r = n(3849),
											o = n(5437),
											i = n(265),
											a = n(5763);
									},
									265: function (e, t, n) {
										'use strict';
										n.d(t, {
											H: function () {
												return c;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(7326),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942);
										function c(e, t) {
											return (function (e) {
												(0, a.Z)(f, e);
												var n,
													c,
													d =
														((n = f),
														(c = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																t = (0, l.Z)(n);
															if (c) {
																var r = (0, l.Z)(this).constructor;
																e = Reflect.construct(t, arguments, r);
															} else e = t.apply(this, arguments);
															return (0, s.Z)(this, e);
														});
												function f() {
													var e;
													(0, r.Z)(this, f);
													for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++) o[a] = arguments[a];
													(e = d.call.apply(d, [this].concat(o))), (0, u.Z)((0, i.Z)(e), 'storageManager', void 0);
													var s = e.options,
														l = s.storageManager,
														c = s.cookies,
														p = s.storageUtil;
													return (e.storageManager = new t(l, c, p)), e;
												}
												return (0, o.Z)(f, [{ key: 'clearStorage', value: function () {} }]), f;
											})(e);
										}
									},
									3849: function (e, t, n) {
										'use strict';
										n.d(t, {
											T: function () {
												return g;
											},
										});
										var r = n(3144),
											o = n(5671),
											i = n(7326),
											a = n(136),
											s = n(2963),
											l = n(1120),
											u = n(4942),
											c = n(5093),
											d = n(146),
											f = n(4858),
											p = {
												'token': { storageTypes: ['localStorage', 'sessionStorage', 'cookie'] },
												'cache': { storageTypes: ['localStorage', 'sessionStorage', 'cookie'] },
												'transaction': { storageTypes: ['sessionStorage', 'localStorage', 'cookie'] },
												'shared-transaction': { storageTypes: ['localStorage'] },
												'original-uri': { storageTypes: ['localStorage'] },
											},
											h = n(415);
										function m(e, t) {
											var n = Object.keys(e);
											if (Object.getOwnPropertySymbols) {
												var r = Object.getOwnPropertySymbols(e);
												t &&
													(r = r.filter(function (t) {
														return Object.getOwnPropertyDescriptor(e, t).enumerable;
													})),
													n.push.apply(n, r);
											}
											return n;
										}
										function v(e) {
											for (var t = 1; t < arguments.length; t++) {
												var n = null != arguments[t] ? arguments[t] : {};
												t % 2
													? m(Object(n), !0).forEach(function (t) {
															(0, u.Z)(e, t, n[t]);
													  })
													: Object.getOwnPropertyDescriptors
													? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
													: m(Object(n)).forEach(function (t) {
															Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
													  });
											}
											return e;
										}
										function g() {
											return (function (e) {
												(0, a.Z)(m, e);
												var t,
													n,
													c =
														((t = m),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = (0, l.Z)(t);
															if (n) {
																var o = (0, l.Z)(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return (0, s.Z)(this, e);
														});
												function m(e) {
													var t;
													return (
														(0, o.Z)(this, m),
														(t = c.call(this, e)),
														(0, u.Z)((0, i.Z)(t), 'cookies', void 0),
														(0, u.Z)((0, i.Z)(t), 'storageUtil', void 0),
														(0, u.Z)((0, i.Z)(t), 'storageManager', void 0),
														(t.cookies = (function () {
															var e = arguments.length > 1 ? arguments[1] : void 0,
																t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).cookies || {};
															return (
																void 0 === t.secure && (t.secure = e),
																void 0 === t.sameSite && (t.sameSite = t.secure ? 'none' : 'lax'),
																t.secure &&
																	!e &&
																	((0, d.ZK)(
																		'The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'
																	),
																	(t.secure = !1)),
																'none' !== t.sameSite || t.secure || (t.sameSite = 'lax'),
																t
															);
														})(e, (0, h.isHTTPS)())),
														(t.storageUtil = e.storageUtil || Object.assign({}, f.Z, { inMemoryStore: {} })),
														(t.storageManager = v(v({}, p), e.storageManager)),
														t
													);
												}
												return (0, r.Z)(m);
											})((0, c.X)());
										}
									},
									3548: function (e, t, n) {
										'use strict';
										n.d(t, {
											b: function () {
												return l;
											},
										});
										var r = n(5671),
											o = n(3144),
											i = n(4942),
											a = n(4771),
											s = n(146),
											l = (function () {
												function e() {
													var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : { quiet: !1 };
													(0, r.Z)(this, e),
														(0, i.Z)(this, 'queue', void 0),
														(0, i.Z)(this, 'running', void 0),
														(0, i.Z)(this, 'options', void 0),
														(this.queue = []),
														(this.running = !1),
														(this.options = t);
												}
												return (
													(0, o.Z)(e, [
														{
															key: 'push',
															value: function (e, t) {
																for (
																	var n = this, r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2;
																	i < r;
																	i++
																)
																	o[i - 2] = arguments[i];
																return new Promise(function (r, i) {
																	n.queue.length > 0 &&
																		!1 !== n.options.quiet &&
																		(0, s.ZK)(
																			'Async method is being called but another async method is already running. The new method will be delayed until the previous method completes.'
																		),
																		n.queue.push({ method: e, thisObject: t, args: o, resolve: r, reject: i }),
																		n.run();
																});
															},
														},
														{
															key: 'run',
															value: function () {
																var e = this;
																if (!this.running && 0 !== this.queue.length) {
																	this.running = !0;
																	var t = this.queue.shift(),
																		n = t.method.apply(t.thisObject, t.args);
																	(0, a.tI)(n)
																		? n.then(t.resolve, t.reject).finally(function () {
																				(e.running = !1), e.run();
																		  })
																		: (t.resolve(n), (this.running = !1), this.run());
																}
															},
														},
													]),
													e
												);
											})();
									},
									146: function (e, t, n) {
										'use strict';
										function r() {
											return 'undefined' != typeof window
												? window.console
												: 'undefined' != typeof console
												? console
												: void 0;
										}
										function o() {
											var e = r();
											return e && e.log
												? e
												: {
														log: function () {},
														warn: function () {},
														group: function () {},
														groupEnd: function () {},
												  };
										}
										function i(e) {
											o().warn('[okta-auth-sdk] WARN: ' + e);
										}
										function a(e) {
											o().warn('[okta-auth-sdk] DEPRECATION: ' + e);
										}
										function s(e, t) {
											return function () {
												return a(e), t.apply(null, arguments);
											};
										}
										n.d(t, {
											Rn: function () {
												return a;
											},
											VA: function () {
												return s;
											},
											ZK: function () {
												return i;
											},
											dr: function () {
												return o;
											},
											sW: function () {
												return r;
											},
										});
									},
									305: function (e, t, n) {
										'use strict';
										n.d(t, {
											BY: function () {
												return l.BY;
											},
											CE: function () {
												return i.CE;
											},
											HD: function () {
												return s.HD;
											},
											Kn: function () {
												return s.Kn;
											},
											QN: function () {
												return l.QN;
											},
											Qj: function () {
												return l.Qj;
											},
											Rg: function () {
												return i.Rg;
											},
											Rn: function () {
												return r.Rn;
											},
											UK: function () {
												return l.UK;
											},
											VA: function () {
												return r.VA;
											},
											YQ: function () {
												return o.YQ;
											},
											YY: function () {
												return i.YY;
											},
											ZK: function () {
												return r.ZK;
											},
											ak: function () {
												return i.ak;
											},
											bo: function () {
												return a.b;
											},
											d9: function () {
												return i.d9;
											},
											dr: function () {
												return r.dr;
											},
											gw: function () {
												return o.gw;
											},
											hj: function () {
												return s.hj;
											},
											l7: function () {
												return i.l7;
											},
											mf: function () {
												return s.mf;
											},
											ng: function () {
												return o.ng;
											},
											sD: function () {
												return l.sD;
											},
											sE: function () {
												return i.sE;
											},
											sW: function () {
												return r.sW;
											},
											tI: function () {
												return s.tI;
											},
											uh: function () {
												return o.uh;
											},
										});
										var r = n(146),
											o = n(8750),
											i = n(3193),
											a = n(3548),
											s = n(4771),
											l = n(6718);
									},
									8750: function (e, t, n) {
										'use strict';
										function r(e) {
											var t = e.match(/\d+/g),
												n = Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
											return new Date(n).toUTCString();
										}
										function o(e) {
											for (var t = '', n = 0; n < e; ++n)
												t += 'abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'[
													Math.floor(61 * Math.random())
												];
											return t;
										}
										function i(e) {
											return new Promise(function (t) {
												setTimeout(t, e);
											});
										}
										function a(e, t) {
											var n = e.split(t);
											return [n[0], n.splice(1, n.length).join(t)];
										}
										n.d(t, {
											YQ: function () {
												return a;
											},
											gw: function () {
												return i;
											},
											ng: function () {
												return r;
											},
											uh: function () {
												return o;
											},
										});
									},
									3193: function (e, t, n) {
										'use strict';
										function r(e, t) {
											var n = Array.prototype.slice.call(arguments, 2);
											return function () {
												var r = Array.prototype.slice.call(arguments);
												return (r = n.concat(r)), e.apply(t, r);
											};
										}
										function o() {
											var e = arguments[0];
											return (
												[].slice.call(arguments, 1).forEach(function (t) {
													for (var n in t)
														Object.prototype.hasOwnProperty.call(t, n) && void 0 !== t[n] && (e[n] = t[n]);
												}),
												e
											);
										}
										function i(e) {
											var t = {};
											for (var n in e)
												if (Object.prototype.hasOwnProperty.call(e, n)) {
													var r = e[n];
													null != r && (t[n] = r);
												}
											return t;
										}
										function a(e) {
											if (e) {
												var t = JSON.stringify(e);
												if (t) return JSON.parse(t);
											}
											return e;
										}
										function s(e) {
											for (var t = {}, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
												r[o - 1] = arguments[o];
											for (var i in e)
												Object.prototype.hasOwnProperty.call(e, i) && -1 == r.indexOf(i) && (t[i] = e[i]);
											return a(t);
										}
										function l(e, t) {
											for (var n = e.length; n--; ) {
												var r = e[n],
													o = !0;
												for (var i in t)
													if (Object.prototype.hasOwnProperty.call(t, i) && r[i] !== t[i]) {
														o = !1;
														break;
													}
												if (o) return r;
											}
										}
										function u(e, t, n) {
											if (e && e._links) {
												var r = a(e._links[t]);
												return r && r.name && n ? (r.name === n ? r : void 0) : r;
											}
										}
										n.d(t, {
											CE: function () {
												return s;
											},
											Rg: function () {
												return u;
											},
											YY: function () {
												return i;
											},
											ak: function () {
												return r;
											},
											d9: function () {
												return a;
											},
											l7: function () {
												return o;
											},
											sE: function () {
												return l;
											},
										});
									},
									4771: function (e, t, n) {
										'use strict';
										function r(e) {
											return '[object String]' === Object.prototype.toString.call(e);
										}
										function o(e) {
											return '[object Object]' === Object.prototype.toString.call(e);
										}
										function i(e) {
											return '[object Number]' === Object.prototype.toString.call(e);
										}
										function a(e) {
											return !!e && '[object Function]' === {}.toString.call(e);
										}
										function s(e) {
											return e && e.finally && 'function' == typeof e.finally;
										}
										n.d(t, {
											HD: function () {
												return r;
											},
											Kn: function () {
												return o;
											},
											hj: function () {
												return i;
											},
											mf: function () {
												return a;
											},
											tI: function () {
												return s;
											},
										});
									},
									6718: function (e, t, n) {
										'use strict';
										function r(e) {
											return /^[a-z][a-z0-9+.-]*:/i.test(e);
										}
										function o() {
											var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '',
												t = arguments.length > 1 ? arguments[1] : void 0;
											return r(e)
												? e
												: ((t = s(t)), '/' === e[0] ? ''.concat(t).concat(e) : ''.concat(t, '/').concat(e));
										}
										function i() {
											var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : '',
												t = arguments.length > 1 ? arguments[1] : void 0;
											return r(e) && (e = e.substring(t.length)), '/' === e[0] ? e : '/'.concat(e);
										}
										function a(e) {
											var t = [];
											if (null !== e)
												for (var n in e)
													Object.prototype.hasOwnProperty.call(e, n) &&
														void 0 !== e[n] &&
														null !== e[n] &&
														t.push(n + '=' + encodeURIComponent(e[n]));
											return t.length ? '?' + t.join('&') : '';
										}
										function s(e) {
											if (e) return e.replace(/^\s+|\s+$/gm, '').replace(/\/+$/, '');
										}
										n.d(t, {
											BY: function () {
												return o;
											},
											QN: function () {
												return i;
											},
											Qj: function () {
												return s;
											},
											UK: function () {
												return a;
											},
											sD: function () {
												return r;
											},
										});
									},
									3615: function (e, t, n) {
										'use strict';
										var r = n(6690),
											o = n(9728),
											i = n(1655),
											a = n(4993),
											s = n(3808);
										function l(e, t) {
											(null == t || t > e.length) && (t = e.length);
											for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
											return r;
										}
										var u = (function (e) {
												i(u, e);
												var t,
													n,
													l =
														((t = u),
														(n = (function () {
															if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
															if (Reflect.construct.sham) return !1;
															if ('function' == typeof Proxy) return !0;
															try {
																return (
																	Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0
																);
															} catch (e) {
																return !1;
															}
														})()),
														function () {
															var e,
																r = s(t);
															if (n) {
																var o = s(this).constructor;
																e = Reflect.construct(r, arguments, o);
															} else e = r.apply(this, arguments);
															return a(this, e);
														});
												function u(e) {
													var t;
													return r(this, u), ((t = l.call(this, e || 'Promise was canceled')).name = 'CancelError'), t;
												}
												return (
													o(u, [
														{
															key: 'isCanceled',
															get: function () {
																return !0;
															},
														},
													]),
													u
												);
											})(n(3496)(Error)),
											c = (function () {
												function e(t) {
													var n = this;
													r(this, e),
														(this._cancelHandlers = []),
														(this._isPending = !0),
														(this._isCanceled = !1),
														(this._rejectOnCancel = !0),
														(this._promise = new Promise(function (e, r) {
															n._reject = r;
															var o = function (e) {
																if (!n._isPending)
																	throw new Error('The `onCancel` handler was attached after the promise settled.');
																n._cancelHandlers.push(e);
															};
															return (
																Object.defineProperties(o, {
																	shouldReject: {
																		get: function () {
																			return n._rejectOnCancel;
																		},
																		set: function (e) {
																			n._rejectOnCancel = e;
																		},
																	},
																}),
																t(
																	function (t) {
																		(n._isCanceled && o.shouldReject) || ((n._isPending = !1), e(t));
																	},
																	function (e) {
																		(n._isPending = !1), r(e);
																	},
																	o
																)
															);
														}));
												}
												return (
													o(
														e,
														[
															{
																key: 'then',
																value: function (e, t) {
																	return this._promise.then(e, t);
																},
															},
															{
																key: 'catch',
																value: function (e) {
																	return this._promise.catch(e);
																},
															},
															{
																key: 'finally',
																value: function (e) {
																	return this._promise.finally(e);
																},
															},
															{
																key: 'cancel',
																value: function (e) {
																	if (this._isPending && !this._isCanceled) {
																		if (((this._isCanceled = !0), this._cancelHandlers.length > 0))
																			try {
																				var t,
																					n = (function (e, t) {
																						var n =
																							('undefined' != typeof Symbol && e[Symbol.iterator]) || e['@@iterator'];
																						if (!n) {
																							if (
																								Array.isArray(e) ||
																								(n = (function (e, t) {
																									if (e) {
																										if ('string' == typeof e) return l(e, t);
																										var n = Object.prototype.toString.call(e).slice(8, -1);
																										return (
																											'Object' === n && e.constructor && (n = e.constructor.name),
																											'Map' === n || 'Set' === n
																												? Array.from(e)
																												: 'Arguments' === n ||
																												  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
																												? l(e, t)
																												: void 0
																										);
																									}
																								})(e)) ||
																								(t && e && 'number' == typeof e.length)
																							) {
																								n && (e = n);
																								var r = 0,
																									o = function () {};
																								return {
																									s: o,
																									n: function () {
																										return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
																									},
																									e: function (e) {
																										throw e;
																									},
																									f: o,
																								};
																							}
																							throw new TypeError(
																								'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
																							);
																						}
																						var i,
																							a = !0,
																							s = !1;
																						return {
																							s: function () {
																								n = n.call(e);
																							},
																							n: function () {
																								var e = n.next();
																								return (a = e.done), e;
																							},
																							e: function (e) {
																								(s = !0), (i = e);
																							},
																							f: function () {
																								try {
																									a || null == n.return || n.return();
																								} finally {
																									if (s) throw i;
																								}
																							},
																						};
																					})(this._cancelHandlers);
																				try {
																					for (n.s(); !(t = n.n()).done; ) (0, t.value)();
																				} catch (e) {
																					n.e(e);
																				} finally {
																					n.f();
																				}
																			} catch (e) {
																				return void this._reject(e);
																			}
																		this._rejectOnCancel && this._reject(new u(e));
																	}
																},
															},
															{
																key: 'isCanceled',
																get: function () {
																	return this._isCanceled;
																},
															},
														],
														[
															{
																key: 'fn',
																value: function (t) {
																	return function () {
																		for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
																			r[o] = arguments[o];
																		return new e(function (e, n, o) {
																			r.push(o), t.apply(void 0, r).then(e, n);
																		});
																	};
																},
															},
														]
													),
													e
												);
											})();
										Object.setPrototypeOf(c.prototype, Promise.prototype), (e.exports = c), (e.exports.CancelError = u);
									},
									4098: function (e, t) {
										var n = 'undefined' != typeof self ? self : this,
											r = (function () {
												function e() {
													(this.fetch = !1), (this.DOMException = n.DOMException);
												}
												return (e.prototype = n), new e();
											})();
										!(function (e) {
											!(function (t) {
												var n = {
													searchParams: 'URLSearchParams' in e,
													iterable: 'Symbol' in e && 'iterator' in Symbol,
													blob:
														'FileReader' in e &&
														'Blob' in e &&
														(function () {
															try {
																return new Blob(), !0;
															} catch (e) {
																return !1;
															}
														})(),
													formData: 'FormData' in e,
													arrayBuffer: 'ArrayBuffer' in e,
												};
												if (n.arrayBuffer)
													var r = [
															'[object Int8Array]',
															'[object Uint8Array]',
															'[object Uint8ClampedArray]',
															'[object Int16Array]',
															'[object Uint16Array]',
															'[object Int32Array]',
															'[object Uint32Array]',
															'[object Float32Array]',
															'[object Float64Array]',
														],
														o =
															ArrayBuffer.isView ||
															function (e) {
																return e && r.indexOf(Object.prototype.toString.call(e)) > -1;
															};
												function i(e) {
													if (('string' != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)))
														throw new TypeError('Invalid character in header field name');
													return e.toLowerCase();
												}
												function a(e) {
													return 'string' != typeof e && (e = String(e)), e;
												}
												function s(e) {
													var t = {
														next: function () {
															var t = e.shift();
															return { done: void 0 === t, value: t };
														},
													};
													return (
														n.iterable &&
															(t[Symbol.iterator] = function () {
																return t;
															}),
														t
													);
												}
												function l(e) {
													(this.map = {}),
														e instanceof l
															? e.forEach(function (e, t) {
																	this.append(t, e);
															  }, this)
															: Array.isArray(e)
															? e.forEach(function (e) {
																	this.append(e[0], e[1]);
															  }, this)
															: e &&
															  Object.getOwnPropertyNames(e).forEach(function (t) {
																	this.append(t, e[t]);
															  }, this);
												}
												function u(e) {
													if (e.bodyUsed) return Promise.reject(new TypeError('Already read'));
													e.bodyUsed = !0;
												}
												function c(e) {
													return new Promise(function (t, n) {
														(e.onload = function () {
															t(e.result);
														}),
															(e.onerror = function () {
																n(e.error);
															});
													});
												}
												function d(e) {
													var t = new FileReader(),
														n = c(t);
													return t.readAsArrayBuffer(e), n;
												}
												function f(e) {
													if (e.slice) return e.slice(0);
													var t = new Uint8Array(e.byteLength);
													return t.set(new Uint8Array(e)), t.buffer;
												}
												function p() {
													return (
														(this.bodyUsed = !1),
														(this._initBody = function (e) {
															var t;
															(this._bodyInit = e),
																e
																	? 'string' == typeof e
																		? (this._bodyText = e)
																		: n.blob && Blob.prototype.isPrototypeOf(e)
																		? (this._bodyBlob = e)
																		: n.formData && FormData.prototype.isPrototypeOf(e)
																		? (this._bodyFormData = e)
																		: n.searchParams && URLSearchParams.prototype.isPrototypeOf(e)
																		? (this._bodyText = e.toString())
																		: n.arrayBuffer && n.blob && (t = e) && DataView.prototype.isPrototypeOf(t)
																		? ((this._bodyArrayBuffer = f(e.buffer)),
																		  (this._bodyInit = new Blob([this._bodyArrayBuffer])))
																		: n.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || o(e))
																		? (this._bodyArrayBuffer = f(e))
																		: (this._bodyText = e = Object.prototype.toString.call(e))
																	: (this._bodyText = ''),
																this.headers.get('content-type') ||
																	('string' == typeof e
																		? this.headers.set('content-type', 'text/plain;charset=UTF-8')
																		: this._bodyBlob && this._bodyBlob.type
																		? this.headers.set('content-type', this._bodyBlob.type)
																		: n.searchParams &&
																		  URLSearchParams.prototype.isPrototypeOf(e) &&
																		  this.headers.set(
																				'content-type',
																				'application/x-www-form-urlencoded;charset=UTF-8'
																		  ));
														}),
														n.blob &&
															((this.blob = function () {
																var e = u(this);
																if (e) return e;
																if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
																if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
																if (this._bodyFormData) throw new Error('could not read FormData body as blob');
																return Promise.resolve(new Blob([this._bodyText]));
															}),
															(this.arrayBuffer = function () {
																return this._bodyArrayBuffer
																	? u(this) || Promise.resolve(this._bodyArrayBuffer)
																	: this.blob().then(d);
															})),
														(this.text = function () {
															var e,
																t,
																n,
																r = u(this);
															if (r) return r;
															if (this._bodyBlob)
																return (e = this._bodyBlob), (n = c((t = new FileReader()))), t.readAsText(e), n;
															if (this._bodyArrayBuffer)
																return Promise.resolve(
																	(function (e) {
																		for (var t = new Uint8Array(e), n = new Array(t.length), r = 0; r < t.length; r++)
																			n[r] = String.fromCharCode(t[r]);
																		return n.join('');
																	})(this._bodyArrayBuffer)
																);
															if (this._bodyFormData) throw new Error('could not read FormData body as text');
															return Promise.resolve(this._bodyText);
														}),
														n.formData &&
															(this.formData = function () {
																return this.text().then(v);
															}),
														(this.json = function () {
															return this.text().then(JSON.parse);
														}),
														this
													);
												}
												(l.prototype.append = function (e, t) {
													(e = i(e)), (t = a(t));
													var n = this.map[e];
													this.map[e] = n ? n + ', ' + t : t;
												}),
													(l.prototype.delete = function (e) {
														delete this.map[i(e)];
													}),
													(l.prototype.get = function (e) {
														return (e = i(e)), this.has(e) ? this.map[e] : null;
													}),
													(l.prototype.has = function (e) {
														return this.map.hasOwnProperty(i(e));
													}),
													(l.prototype.set = function (e, t) {
														this.map[i(e)] = a(t);
													}),
													(l.prototype.forEach = function (e, t) {
														for (var n in this.map) this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
													}),
													(l.prototype.keys = function () {
														var e = [];
														return (
															this.forEach(function (t, n) {
																e.push(n);
															}),
															s(e)
														);
													}),
													(l.prototype.values = function () {
														var e = [];
														return (
															this.forEach(function (t) {
																e.push(t);
															}),
															s(e)
														);
													}),
													(l.prototype.entries = function () {
														var e = [];
														return (
															this.forEach(function (t, n) {
																e.push([n, t]);
															}),
															s(e)
														);
													}),
													n.iterable && (l.prototype[Symbol.iterator] = l.prototype.entries);
												var h = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
												function m(e, t) {
													var n,
														r,
														o = (t = t || {}).body;
													if (e instanceof m) {
														if (e.bodyUsed) throw new TypeError('Already read');
														(this.url = e.url),
															(this.credentials = e.credentials),
															t.headers || (this.headers = new l(e.headers)),
															(this.method = e.method),
															(this.mode = e.mode),
															(this.signal = e.signal),
															o || null == e._bodyInit || ((o = e._bodyInit), (e.bodyUsed = !0));
													} else this.url = String(e);
													if (
														((this.credentials = t.credentials || this.credentials || 'same-origin'),
														(!t.headers && this.headers) || (this.headers = new l(t.headers)),
														(this.method =
															((r = (n = t.method || this.method || 'GET').toUpperCase()), h.indexOf(r) > -1 ? r : n)),
														(this.mode = t.mode || this.mode || null),
														(this.signal = t.signal || this.signal),
														(this.referrer = null),
														('GET' === this.method || 'HEAD' === this.method) && o)
													)
														throw new TypeError('Body not allowed for GET or HEAD requests');
													this._initBody(o);
												}
												function v(e) {
													var t = new FormData();
													return (
														e
															.trim()
															.split('&')
															.forEach(function (e) {
																if (e) {
																	var n = e.split('='),
																		r = n.shift().replace(/\+/g, ' '),
																		o = n.join('=').replace(/\+/g, ' ');
																	t.append(decodeURIComponent(r), decodeURIComponent(o));
																}
															}),
														t
													);
												}
												function g(e, t) {
													t || (t = {}),
														(this.type = 'default'),
														(this.status = void 0 === t.status ? 200 : t.status),
														(this.ok = this.status >= 200 && this.status < 300),
														(this.statusText = 'statusText' in t ? t.statusText : 'OK'),
														(this.headers = new l(t.headers)),
														(this.url = t.url || ''),
														this._initBody(e);
												}
												(m.prototype.clone = function () {
													return new m(this, { body: this._bodyInit });
												}),
													p.call(m.prototype),
													p.call(g.prototype),
													(g.prototype.clone = function () {
														return new g(this._bodyInit, {
															status: this.status,
															statusText: this.statusText,
															headers: new l(this.headers),
															url: this.url,
														});
													}),
													(g.error = function () {
														var e = new g(null, { status: 0, statusText: '' });
														return (e.type = 'error'), e;
													});
												var y = [301, 302, 303, 307, 308];
												(g.redirect = function (e, t) {
													if (-1 === y.indexOf(t)) throw new RangeError('Invalid status code');
													return new g(null, { status: t, headers: { location: e } });
												}),
													(t.DOMException = e.DOMException);
												try {
													new t.DOMException();
												} catch (e) {
													(t.DOMException = function (e, t) {
														(this.message = e), (this.name = t);
														var n = Error(e);
														this.stack = n.stack;
													}),
														(t.DOMException.prototype = Object.create(Error.prototype)),
														(t.DOMException.prototype.constructor = t.DOMException);
												}
												function b(e, r) {
													return new Promise(function (o, i) {
														var a = new m(e, r);
														if (a.signal && a.signal.aborted) return i(new t.DOMException('Aborted', 'AbortError'));
														var s = new XMLHttpRequest();
														function u() {
															s.abort();
														}
														(s.onload = function () {
															var e,
																t,
																n = {
																	status: s.status,
																	statusText: s.statusText,
																	headers:
																		((e = s.getAllResponseHeaders() || ''),
																		(t = new l()),
																		e
																			.replace(/\r?\n[\t ]+/g, ' ')
																			.split(/\r?\n/)
																			.forEach(function (e) {
																				var n = e.split(':'),
																					r = n.shift().trim();
																				if (r) {
																					var o = n.join(':').trim();
																					t.append(r, o);
																				}
																			}),
																		t),
																};
															n.url = 'responseURL' in s ? s.responseURL : n.headers.get('X-Request-URL');
															var r = 'response' in s ? s.response : s.responseText;
															o(new g(r, n));
														}),
															(s.onerror = function () {
																i(new TypeError('Network request failed'));
															}),
															(s.ontimeout = function () {
																i(new TypeError('Network request failed'));
															}),
															(s.onabort = function () {
																i(new t.DOMException('Aborted', 'AbortError'));
															}),
															s.open(a.method, a.url, !0),
															'include' === a.credentials
																? (s.withCredentials = !0)
																: 'omit' === a.credentials && (s.withCredentials = !1),
															'responseType' in s && n.blob && (s.responseType = 'blob'),
															a.headers.forEach(function (e, t) {
																s.setRequestHeader(t, e);
															}),
															a.signal &&
																(a.signal.addEventListener('abort', u),
																(s.onreadystatechange = function () {
																	4 === s.readyState && a.signal.removeEventListener('abort', u);
																})),
															s.send(void 0 === a._bodyInit ? null : a._bodyInit);
													});
												}
												(b.polyfill = !0),
													e.fetch || ((e.fetch = b), (e.Headers = l), (e.Request = m), (e.Response = g)),
													(t.Headers = l),
													(t.Request = m),
													(t.Response = g),
													(t.fetch = b),
													Object.defineProperty(t, '__esModule', { value: !0 });
											})({});
										})(r),
											(r.fetch.ponyfill = !0),
											delete r.fetch.polyfill;
										var o = r;
										((t = o.fetch).default = o.fetch),
											(t.fetch = o.fetch),
											(t.Headers = o.Headers),
											(t.Request = o.Request),
											(t.Response = o.Response),
											(e.exports = t);
									},
									4279: function (e) {
										function t() {}
										(t.prototype = {
											on: function (e, t, n) {
												var r = this.e || (this.e = {});
												return (r[e] || (r[e] = [])).push({ fn: t, ctx: n }), this;
											},
											once: function (e, t, n) {
												var r = this;
												function o() {
													r.off(e, o), t.apply(n, arguments);
												}
												return (o._ = t), this.on(e, o, n);
											},
											emit: function (e) {
												for (
													var t = [].slice.call(arguments, 1),
														n = ((this.e || (this.e = {}))[e] || []).slice(),
														r = 0,
														o = n.length;
													r < o;
													r++
												)
													n[r].fn.apply(n[r].ctx, t);
												return this;
											},
											off: function (e, t) {
												var n = this.e || (this.e = {}),
													r = n[e],
													o = [];
												if (r && t)
													for (var i = 0, a = r.length; i < a; i++) r[i].fn !== t && r[i].fn._ !== t && o.push(r[i]);
												return o.length ? (n[e] = o) : delete n[e], this;
											},
										}),
											(e.exports = t);
									},
									6115: function (e) {
										(e.exports = function (e) {
											if (void 0 === e)
												throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
											return e;
										}),
											(e.exports.__esModule = !0),
											(e.exports.default = e.exports);
									},
									6690: function (e) {
										(e.exports = function (e, t) {
											if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
										}),
											(e.exports.__esModule = !0),
											(e.exports.default = e.exports);
									},
									3515: function (e, t, n) {
										var r = n(6015),
											o = n(9617);
										function i(t, n, a) {
											return (
												o()
													? ((e.exports = i = Reflect.construct.bind()),
													  (e.exports.__esModule = !0),
													  (e.exports.default = e.exports))
													: ((e.exports = i =
															function (e, t, n) {
																var o = [null];
																o.push.apply(o, t);
																var i = new (Function.bind.apply(e, o))();
																return n && r(i, n.prototype), i;
															}),
													  (e.exports.__esModule = !0),
													  (e.exports.default = e.exports)),
												i.apply(null, arguments)
											);
										}
										(e.exports = i), (e.exports.__esModule = !0), (e.exports.default = e.exports);
									},
									9728: function (e) {
										function t(e, t) {
											for (var n = 0; n < t.length; n++) {
												var r = t[n];
												(r.enumerable = r.enumerable || !1),
													(r.configurable = !0),
													'value' in r && (r.writable = !0),
													Object.defineProperty(e, r.key, r);
											}
										}
										(e.exports = function (e, n, r) {
											return (
												n && t(e.prototype, n), r && t(e, r), Object.defineProperty(e, 'prototype', { writable: !1 }), e
											);
										}),
											(e.exports.__esModule = !0),
											(e.exports.default = e.exports);
									},
									3808: function (e) {
										function t(n) {
											return (
												(e.exports = t =
													Object.setPrototypeOf
														? Object.getPrototypeOf.bind()
														: function (e) {
																return e.__proto__ || Object.getPrototypeOf(e);
														  }),
												(e.exports.__esModule = !0),
												(e.exports.default = e.exports),
												t(n)
											);
										}
										(e.exports = t), (e.exports.__esModule = !0), (e.exports.default = e.exports);
									},
									1655: function (e, t, n) {
										var r = n(6015);
										(e.exports = function (e, t) {
											if ('function' != typeof t && null !== t)
												throw new TypeError('Super expression must either be null or a function');
											(e.prototype = Object.create(t && t.prototype, {
												constructor: { value: e, writable: !0, configurable: !0 },
											})),
												Object.defineProperty(e, 'prototype', { writable: !1 }),
												t && r(e, t);
										}),
											(e.exports.__esModule = !0),
											(e.exports.default = e.exports);
									},
									6035: function (e) {
										(e.exports = function (e) {
											return -1 !== Function.toString.call(e).indexOf('[native code]');
										}),
											(e.exports.__esModule = !0),
											(e.exports.default = e.exports);
									},
									9617: function (e) {
										(e.exports = function () {
											if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
											if (Reflect.construct.sham) return !1;
											if ('function' == typeof Proxy) return !0;
											try {
												return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
											} catch (e) {
												return !1;
											}
										}),
											(e.exports.__esModule = !0),
											(e.exports.default = e.exports);
									},
									4993: function (e, t, n) {
										var r = n(8698).default,
											o = n(6115);
										(e.exports = function (e, t) {
											if (t && ('object' === r(t) || 'function' == typeof t)) return t;
											if (void 0 !== t) throw new TypeError('Derived constructors may only return object or undefined');
											return o(e);
										}),
											(e.exports.__esModule = !0),
											(e.exports.default = e.exports);
									},
									7061: function (e, t, n) {
										var r = n(8698).default;
										function o() {
											'use strict';
											(e.exports = o =
												function () {
													return t;
												}),
												(e.exports.__esModule = !0),
												(e.exports.default = e.exports);
											var t = {},
												n = Object.prototype,
												i = n.hasOwnProperty,
												a = 'function' == typeof Symbol ? Symbol : {},
												s = a.iterator || '@@iterator',
												l = a.asyncIterator || '@@asyncIterator',
												u = a.toStringTag || '@@toStringTag';
											function c(e, t, n) {
												return (
													Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }),
													e[t]
												);
											}
											try {
												c({}, '');
											} catch (e) {
												c = function (e, t, n) {
													return (e[t] = n);
												};
											}
											function d(e, t, n, r) {
												var o = t && t.prototype instanceof h ? t : h,
													i = Object.create(o.prototype),
													a = new T(r || []);
												return (
													(i._invoke = (function (e, t, n) {
														var r = 'suspendedStart';
														return function (o, i) {
															if ('executing' === r) throw new Error('Generator is already running');
															if ('completed' === r) {
																if ('throw' === o) throw i;
																return { value: void 0, done: !0 };
															}
															for (n.method = o, n.arg = i; ; ) {
																var a = n.delegate;
																if (a) {
																	var s = k(a, n);
																	if (s) {
																		if (s === p) continue;
																		return s;
																	}
																}
																if ('next' === n.method) n.sent = n._sent = n.arg;
																else if ('throw' === n.method) {
																	if ('suspendedStart' === r) throw ((r = 'completed'), n.arg);
																	n.dispatchException(n.arg);
																} else 'return' === n.method && n.abrupt('return', n.arg);
																r = 'executing';
																var l = f(e, t, n);
																if ('normal' === l.type) {
																	if (((r = n.done ? 'completed' : 'suspendedYield'), l.arg === p)) continue;
																	return { value: l.arg, done: n.done };
																}
																'throw' === l.type && ((r = 'completed'), (n.method = 'throw'), (n.arg = l.arg));
															}
														};
													})(e, n, a)),
													i
												);
											}
											function f(e, t, n) {
												try {
													return { type: 'normal', arg: e.call(t, n) };
												} catch (e) {
													return { type: 'throw', arg: e };
												}
											}
											t.wrap = d;
											var p = {};
											function h() {}
											function m() {}
											function v() {}
											var g = {};
											c(g, s, function () {
												return this;
											});
											var y = Object.getPrototypeOf,
												b = y && y(y(S([])));
											b && b !== n && i.call(b, s) && (g = b);
											var _ = (v.prototype = h.prototype = Object.create(g));
											function w(e) {
												['next', 'throw', 'return'].forEach(function (t) {
													c(e, t, function (e) {
														return this._invoke(t, e);
													});
												});
											}
											function O(e, t) {
												function n(o, a, s, l) {
													var u = f(e[o], e, a);
													if ('throw' !== u.type) {
														var c = u.arg,
															d = c.value;
														return d && 'object' == r(d) && i.call(d, '__await')
															? t.resolve(d.__await).then(
																	function (e) {
																		n('next', e, s, l);
																	},
																	function (e) {
																		n('throw', e, s, l);
																	}
															  )
															: t.resolve(d).then(
																	function (e) {
																		(c.value = e), s(c);
																	},
																	function (e) {
																		return n('throw', e, s, l);
																	}
															  );
													}
													l(u.arg);
												}
												var o;
												this._invoke = function (e, r) {
													function i() {
														return new t(function (t, o) {
															n(e, r, t, o);
														});
													}
													return (o = o ? o.then(i, i) : i());
												};
											}
											function k(e, t) {
												var n = e.iterator[t.method];
												if (void 0 === n) {
													if (((t.delegate = null), 'throw' === t.method)) {
														if (
															e.iterator.return &&
															((t.method = 'return'), (t.arg = void 0), k(e, t), 'throw' === t.method)
														)
															return p;
														(t.method = 'throw'),
															(t.arg = new TypeError("The iterator does not provide a 'throw' method"));
													}
													return p;
												}
												var r = f(n, e.iterator, t.arg);
												if ('throw' === r.type) return (t.method = 'throw'), (t.arg = r.arg), (t.delegate = null), p;
												var o = r.arg;
												return o
													? o.done
														? ((t[e.resultName] = o.value),
														  (t.next = e.nextLoc),
														  'return' !== t.method && ((t.method = 'next'), (t.arg = void 0)),
														  (t.delegate = null),
														  p)
														: o
													: ((t.method = 'throw'),
													  (t.arg = new TypeError('iterator result is not an object')),
													  (t.delegate = null),
													  p);
											}
											function x(e) {
												var t = { tryLoc: e[0] };
												1 in e && (t.catchLoc = e[1]),
													2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
													this.tryEntries.push(t);
											}
											function E(e) {
												var t = e.completion || {};
												(t.type = 'normal'), delete t.arg, (e.completion = t);
											}
											function T(e) {
												(this.tryEntries = [{ tryLoc: 'root' }]), e.forEach(x, this), this.reset(!0);
											}
											function S(e) {
												if (e) {
													var t = e[s];
													if (t) return t.call(e);
													if ('function' == typeof e.next) return e;
													if (!isNaN(e.length)) {
														var n = -1,
															r = function t() {
																for (; ++n < e.length; ) if (i.call(e, n)) return (t.value = e[n]), (t.done = !1), t;
																return (t.value = void 0), (t.done = !0), t;
															};
														return (r.next = r);
													}
												}
												return { next: A };
											}
											function A() {
												return { value: void 0, done: !0 };
											}
											return (
												(m.prototype = v),
												c(_, 'constructor', v),
												c(v, 'constructor', m),
												(m.displayName = c(v, u, 'GeneratorFunction')),
												(t.isGeneratorFunction = function (e) {
													var t = 'function' == typeof e && e.constructor;
													return !!t && (t === m || 'GeneratorFunction' === (t.displayName || t.name));
												}),
												(t.mark = function (e) {
													return (
														Object.setPrototypeOf
															? Object.setPrototypeOf(e, v)
															: ((e.__proto__ = v), c(e, u, 'GeneratorFunction')),
														(e.prototype = Object.create(_)),
														e
													);
												}),
												(t.awrap = function (e) {
													return { __await: e };
												}),
												w(O.prototype),
												c(O.prototype, l, function () {
													return this;
												}),
												(t.AsyncIterator = O),
												(t.async = function (e, n, r, o, i) {
													void 0 === i && (i = Promise);
													var a = new O(d(e, n, r, o), i);
													return t.isGeneratorFunction(n)
														? a
														: a.next().then(function (e) {
																return e.done ? e.value : a.next();
														  });
												}),
												w(_),
												c(_, u, 'Generator'),
												c(_, s, function () {
													return this;
												}),
												c(_, 'toString', function () {
													return '[object Generator]';
												}),
												(t.keys = function (e) {
													var t = [];
													for (var n in e) t.push(n);
													return (
														t.reverse(),
														function n() {
															for (; t.length; ) {
																var r = t.pop();
																if (r in e) return (n.value = r), (n.done = !1), n;
															}
															return (n.done = !0), n;
														}
													);
												}),
												(t.values = S),
												(T.prototype = {
													constructor: T,
													reset: function (e) {
														if (
															((this.prev = 0),
															(this.next = 0),
															(this.sent = this._sent = void 0),
															(this.done = !1),
															(this.delegate = null),
															(this.method = 'next'),
															(this.arg = void 0),
															this.tryEntries.forEach(E),
															!e)
														)
															for (var t in this)
																't' === t.charAt(0) && i.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
													},
													stop: function () {
														this.done = !0;
														var e = this.tryEntries[0].completion;
														if ('throw' === e.type) throw e.arg;
														return this.rval;
													},
													dispatchException: function (e) {
														if (this.done) throw e;
														var t = this;
														function n(n, r) {
															return (
																(a.type = 'throw'),
																(a.arg = e),
																(t.next = n),
																r && ((t.method = 'next'), (t.arg = void 0)),
																!!r
															);
														}
														for (var r = this.tryEntries.length - 1; r >= 0; --r) {
															var o = this.tryEntries[r],
																a = o.completion;
															if ('root' === o.tryLoc) return n('end');
															if (o.tryLoc <= this.prev) {
																var s = i.call(o, 'catchLoc'),
																	l = i.call(o, 'finallyLoc');
																if (s && l) {
																	if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
																	if (this.prev < o.finallyLoc) return n(o.finallyLoc);
																} else if (s) {
																	if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
																} else {
																	if (!l) throw new Error('try statement without catch or finally');
																	if (this.prev < o.finallyLoc) return n(o.finallyLoc);
																}
															}
														}
													},
													abrupt: function (e, t) {
														for (var n = this.tryEntries.length - 1; n >= 0; --n) {
															var r = this.tryEntries[n];
															if (r.tryLoc <= this.prev && i.call(r, 'finallyLoc') && this.prev < r.finallyLoc) {
																var o = r;
																break;
															}
														}
														o &&
															('break' === e || 'continue' === e) &&
															o.tryLoc <= t &&
															t <= o.finallyLoc &&
															(o = null);
														var a = o ? o.completion : {};
														return (
															(a.type = e),
															(a.arg = t),
															o ? ((this.method = 'next'), (this.next = o.finallyLoc), p) : this.complete(a)
														);
													},
													complete: function (e, t) {
														if ('throw' === e.type) throw e.arg;
														return (
															'break' === e.type || 'continue' === e.type
																? (this.next = e.arg)
																: 'return' === e.type
																? ((this.rval = this.arg = e.arg), (this.method = 'return'), (this.next = 'end'))
																: 'normal' === e.type && t && (this.next = t),
															p
														);
													},
													finish: function (e) {
														for (var t = this.tryEntries.length - 1; t >= 0; --t) {
															var n = this.tryEntries[t];
															if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), E(n), p;
														}
													},
													catch: function (e) {
														for (var t = this.tryEntries.length - 1; t >= 0; --t) {
															var n = this.tryEntries[t];
															if (n.tryLoc === e) {
																var r = n.completion;
																if ('throw' === r.type) {
																	var o = r.arg;
																	E(n);
																}
																return o;
															}
														}
														throw new Error('illegal catch attempt');
													},
													delegateYield: function (e, t, n) {
														return (
															(this.delegate = { iterator: S(e), resultName: t, nextLoc: n }),
															'next' === this.method && (this.arg = void 0),
															p
														);
													},
												}),
												t
											);
										}
										(e.exports = o), (e.exports.__esModule = !0), (e.exports.default = e.exports);
									},
									6015: function (e) {
										function t(n, r) {
											return (
												(e.exports = t =
													Object.setPrototypeOf
														? Object.setPrototypeOf.bind()
														: function (e, t) {
																return (e.__proto__ = t), e;
														  }),
												(e.exports.__esModule = !0),
												(e.exports.default = e.exports),
												t(n, r)
											);
										}
										(e.exports = t), (e.exports.__esModule = !0), (e.exports.default = e.exports);
									},
									8698: function (e) {
										function t(n) {
											return (
												(e.exports = t =
													'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
														? function (e) {
																return typeof e;
														  }
														: function (e) {
																return e &&
																	'function' == typeof Symbol &&
																	e.constructor === Symbol &&
																	e !== Symbol.prototype
																	? 'symbol'
																	: typeof e;
														  }),
												(e.exports.__esModule = !0),
												(e.exports.default = e.exports),
												t(n)
											);
										}
										(e.exports = t), (e.exports.__esModule = !0), (e.exports.default = e.exports);
									},
									3496: function (e, t, n) {
										var r = n(3808),
											o = n(6015),
											i = n(6035),
											a = n(3515);
										function s(t) {
											var n = 'function' == typeof Map ? new Map() : void 0;
											return (
												(e.exports = s =
													function (e) {
														if (null === e || !i(e)) return e;
														if ('function' != typeof e)
															throw new TypeError('Super expression must either be null or a function');
														if (void 0 !== n) {
															if (n.has(e)) return n.get(e);
															n.set(e, t);
														}
														function t() {
															return a(e, arguments, r(this).constructor);
														}
														return (
															(t.prototype = Object.create(e.prototype, {
																constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 },
															})),
															o(t, e)
														);
													}),
												(e.exports.__esModule = !0),
												(e.exports.default = e.exports),
												s(t)
											);
										}
										(e.exports = s), (e.exports.__esModule = !0), (e.exports.default = e.exports);
									},
									4687: function (e, t, n) {
										var r = n(7061)();
										e.exports = r;
										try {
											regeneratorRuntime = r;
										} catch (e) {
											'object' == typeof globalThis
												? (globalThis.regeneratorRuntime = r)
												: Function('r', 'regeneratorRuntime = r')(r);
										}
									},
									907: function (e, t, n) {
										'use strict';
										function r(e, t) {
											(null == t || t > e.length) && (t = e.length);
											for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
											return r;
										}
										n.d(t, {
											Z: function () {
												return r;
											},
										});
									},
									7326: function (e, t, n) {
										'use strict';
										function r(e) {
											if (void 0 === e)
												throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
											return e;
										}
										n.d(t, {
											Z: function () {
												return r;
											},
										});
									},
									5861: function (e, t, n) {
										'use strict';
										function r(e, t, n, r, o, i, a) {
											try {
												var s = e[i](a),
													l = s.value;
											} catch (e) {
												return void n(e);
											}
											s.done ? t(l) : Promise.resolve(l).then(r, o);
										}
										function o(e) {
											return function () {
												var t = this,
													n = arguments;
												return new Promise(function (o, i) {
													var a = e.apply(t, n);
													function s(e) {
														r(a, o, i, s, l, 'next', e);
													}
													function l(e) {
														r(a, o, i, s, l, 'throw', e);
													}
													s(void 0);
												});
											};
										}
										n.d(t, {
											Z: function () {
												return o;
											},
										});
									},
									5671: function (e, t, n) {
										'use strict';
										function r(e, t) {
											if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
										}
										n.d(t, {
											Z: function () {
												return r;
											},
										});
									},
									3144: function (e, t, n) {
										'use strict';
										function r(e, t) {
											for (var n = 0; n < t.length; n++) {
												var r = t[n];
												(r.enumerable = r.enumerable || !1),
													(r.configurable = !0),
													'value' in r && (r.writable = !0),
													Object.defineProperty(e, r.key, r);
											}
										}
										function o(e, t, n) {
											return (
												t && r(e.prototype, t), n && r(e, n), Object.defineProperty(e, 'prototype', { writable: !1 }), e
											);
										}
										n.d(t, {
											Z: function () {
												return o;
											},
										});
									},
									4942: function (e, t, n) {
										'use strict';
										function r(e, t, n) {
											return (
												t in e
													? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 })
													: (e[t] = n),
												e
											);
										}
										n.d(t, {
											Z: function () {
												return r;
											},
										});
									},
									1752: function (e, t, n) {
										'use strict';
										n.d(t, {
											Z: function () {
												return o;
											},
										});
										var r = n(1120);
										function o() {
											return (
												(o =
													'undefined' != typeof Reflect && Reflect.get
														? Reflect.get.bind()
														: function (e, t, n) {
																var o = (function (e, t) {
																	for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = (0, r.Z)(e)); );
																	return e;
																})(e, t);
																if (o) {
																	var i = Object.getOwnPropertyDescriptor(o, t);
																	return i.get ? i.get.call(arguments.length < 3 ? e : n) : i.value;
																}
														  }),
												o.apply(this, arguments)
											);
										}
									},
									1120: function (e, t, n) {
										'use strict';
										function r(e) {
											return (
												(r = Object.setPrototypeOf
													? Object.getPrototypeOf.bind()
													: function (e) {
															return e.__proto__ || Object.getPrototypeOf(e);
													  }),
												r(e)
											);
										}
										n.d(t, {
											Z: function () {
												return r;
											},
										});
									},
									136: function (e, t, n) {
										'use strict';
										n.d(t, {
											Z: function () {
												return o;
											},
										});
										var r = n(9611);
										function o(e, t) {
											if ('function' != typeof t && null !== t)
												throw new TypeError('Super expression must either be null or a function');
											(e.prototype = Object.create(t && t.prototype, {
												constructor: { value: e, writable: !0, configurable: !0 },
											})),
												Object.defineProperty(e, 'prototype', { writable: !1 }),
												t && (0, r.Z)(e, t);
										}
									},
									4925: function (e, t, n) {
										'use strict';
										function r(e, t) {
											if (null == e) return {};
											var n,
												r,
												o = (function (e, t) {
													if (null == e) return {};
													var n,
														r,
														o = {},
														i = Object.keys(e);
													for (r = 0; r < i.length; r++) (n = i[r]), t.indexOf(n) >= 0 || (o[n] = e[n]);
													return o;
												})(e, t);
											if (Object.getOwnPropertySymbols) {
												var i = Object.getOwnPropertySymbols(e);
												for (r = 0; r < i.length; r++)
													(n = i[r]),
														t.indexOf(n) >= 0 || (Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]));
											}
											return o;
										}
										n.d(t, {
											Z: function () {
												return r;
											},
										});
									},
									2963: function (e, t, n) {
										'use strict';
										n.d(t, {
											Z: function () {
												return i;
											},
										});
										var r = n(1002),
											o = n(7326);
										function i(e, t) {
											if (t && ('object' === (0, r.Z)(t) || 'function' == typeof t)) return t;
											if (void 0 !== t) throw new TypeError('Derived constructors may only return object or undefined');
											return (0, o.Z)(e);
										}
									},
									9611: function (e, t, n) {
										'use strict';
										function r(e, t) {
											return (
												(r = Object.setPrototypeOf
													? Object.setPrototypeOf.bind()
													: function (e, t) {
															return (e.__proto__ = t), e;
													  }),
												r(e, t)
											);
										}
										n.d(t, {
											Z: function () {
												return r;
											},
										});
									},
									885: function (e, t, n) {
										'use strict';
										n.d(t, {
											Z: function () {
												return o;
											},
										});
										var r = n(181);
										function o(e, t) {
											return (
												(function (e) {
													if (Array.isArray(e)) return e;
												})(e) ||
												(function (e, t) {
													var n =
														null == e ? null : ('undefined' != typeof Symbol && e[Symbol.iterator]) || e['@@iterator'];
													if (null != n) {
														var r,
															o,
															i = [],
															a = !0,
															s = !1;
														try {
															for (
																n = n.call(e);
																!(a = (r = n.next()).done) && (i.push(r.value), !t || i.length !== t);
																a = !0
															);
														} catch (e) {
															(s = !0), (o = e);
														} finally {
															try {
																a || null == n.return || n.return();
															} finally {
																if (s) throw o;
															}
														}
														return i;
													}
												})(e, t) ||
												(0, r.Z)(e, t) ||
												(function () {
													throw new TypeError(
														'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
													);
												})()
											);
										}
									},
									2982: function (e, t, n) {
										'use strict';
										n.d(t, {
											Z: function () {
												return i;
											},
										});
										var r = n(907),
											o = n(181);
										function i(e) {
											return (
												(function (e) {
													if (Array.isArray(e)) return (0, r.Z)(e);
												})(e) ||
												(function (e) {
													if (('undefined' != typeof Symbol && null != e[Symbol.iterator]) || null != e['@@iterator'])
														return Array.from(e);
												})(e) ||
												(0, o.Z)(e) ||
												(function () {
													throw new TypeError(
														'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
													);
												})()
											);
										}
									},
									1002: function (e, t, n) {
										'use strict';
										function r(e) {
											return (
												(r =
													'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
														? function (e) {
																return typeof e;
														  }
														: function (e) {
																return e &&
																	'function' == typeof Symbol &&
																	e.constructor === Symbol &&
																	e !== Symbol.prototype
																	? 'symbol'
																	: typeof e;
														  }),
												r(e)
											);
										}
										n.d(t, {
											Z: function () {
												return r;
											},
										});
									},
									181: function (e, t, n) {
										'use strict';
										n.d(t, {
											Z: function () {
												return o;
											},
										});
										var r = n(907);
										function o(e, t) {
											if (e) {
												if ('string' == typeof e) return (0, r.Z)(e, t);
												var n = Object.prototype.toString.call(e).slice(8, -1);
												return (
													'Object' === n && e.constructor && (n = e.constructor.name),
													'Map' === n || 'Set' === n
														? Array.from(e)
														: 'Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
														? (0, r.Z)(e, t)
														: void 0
												);
											}
										}
									},
								},
								t = {};
							function n(r) {
								var o = t[r];
								if (void 0 !== o) return o.exports;
								var i = (t[r] = { exports: {} });
								return e[r].call(i.exports, i, i.exports, n), i.exports;
							}
							(n.n = function (e) {
								var t =
									e && e.__esModule
										? function () {
												return e.default;
										  }
										: function () {
												return e;
										  };
								return n.d(t, { a: t }), t;
							}),
								(n.d = function (e, t) {
									for (var r in t)
										n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
								}),
								(n.g = (function () {
									if ('object' == typeof globalThis) return globalThis;
									try {
										return this || new Function('return this')();
									} catch (e) {
										if ('object' == typeof window) return window;
									}
								})()),
								(n.o = function (e, t) {
									return Object.prototype.hasOwnProperty.call(e, t);
								}),
								(n.r = function (e) {
									'undefined' != typeof Symbol &&
										Symbol.toStringTag &&
										Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
										Object.defineProperty(e, '__esModule', { value: !0 });
								});
							var r = {};
							return (
								(function () {
									'use strict';
									n.r(r),
										n.d(r, {
											AuthenticatorKey: function () {
												return v.pc;
											},
											EmailRole: function () {
												return g.aw;
											},
											IdxFeature: function () {
												return v.Fw;
											},
											IdxStatus: function () {
												return v.Qd;
											},
											OktaAuth: function () {
												return x;
											},
											PasswordStatus: function () {
												return g.Fn;
											},
											Status: function () {
												return g.qb;
											},
											addEmail: function () {
												return g.no;
											},
											addPhone: function () {
												return g.Z1;
											},
											authenticate: function () {
												return v.YR;
											},
											canProceed: function () {
												return v.Ch;
											},
											cancel: function () {
												return v.al;
											},
											clearTransactionMeta: function () {
												return v.Jm;
											},
											createAuthnTransactionAPI: function () {
												return y.b;
											},
											createIdxAPI: function () {
												return v.F4;
											},
											createIdxOptionsConstructor: function () {
												return v.SL;
											},
											createIdxStorageManager: function () {
												return v.aT;
											},
											createIdxTransactionManager: function () {
												return v.vK;
											},
											createMinimalOktaAuthIdx: function () {
												return v.UB;
											},
											createOktaAuthIdx: function () {
												return v.Yn;
											},
											createOktaAuthMyAccount: function () {
												return g.Xc;
											},
											createTransactionMeta: function () {
												return v.Xc;
											},
											deleteEmail: function () {
												return g.nd;
											},
											deletePassword: function () {
												return g.QN;
											},
											deletePhone: function () {
												return g.qj;
											},
											enrollPassword: function () {
												return g.xg;
											},
											getEmail: function () {
												return g.OD;
											},
											getEmailChallenge: function () {
												return g.hG;
											},
											getEmails: function () {
												return g.G5;
											},
											getPassword: function () {
												return g.Ij;
											},
											getPhone: function () {
												return g.u_;
											},
											getPhones: function () {
												return g.Po;
											},
											getProfile: function () {
												return g.Ai;
											},
											getProfileSchema: function () {
												return g.aF;
											},
											getSavedTransactionMeta: function () {
												return v.uN;
											},
											getTransactionMeta: function () {
												return v.Co;
											},
											handleEmailVerifyCallback: function () {
												return v.Jn;
											},
											handleInteractionCodeRedirect: function () {
												return v.Xx;
											},
											hasSavedInteractionHandle: function () {
												return v.$0;
											},
											interact: function () {
												return v.EW;
											},
											introspect: function () {
												return v.L8;
											},
											isAuthenticator: function () {
												return v.H;
											},
											isEmailVerifyCallback: function () {
												return v.GA;
											},
											isEmailVerifyCallbackError: function () {
												return v.gc;
											},
											isTransactionMetaValid: function () {
												return v.Wf;
											},
											isTransactionMetaValidForFlow: function () {
												return v.bl;
											},
											isTransactionMetaValidForOptions: function () {
												return v.UC;
											},
											mixinAuthn: function () {
												return y.t;
											},
											mixinIdx: function () {
												return v.B_;
											},
											mixinMyAccount: function () {
												return g.HT;
											},
											parseEmailVerifyCallback: function () {
												return v.mo;
											},
											poll: function () {
												return v.$l;
											},
											proceed: function () {
												return v.xc;
											},
											recoverPassword: function () {
												return v.M4;
											},
											register: function () {
												return v.z2;
											},
											saveTransactionMeta: function () {
												return v.r0;
											},
											sendEmailChallenge: function () {
												return g.ME;
											},
											sendPhoneChallenge: function () {
												return g.dv;
											},
											startTransaction: function () {
												return v.Yr;
											},
											unlockAccount: function () {
												return v.le;
											},
											updatePassword: function () {
												return g.gQ;
											},
											updateProfile: function () {
												return g.ck;
											},
											verifyEmailChallenge: function () {
												return g.T8;
											},
											verifyPhoneChallenge: function () {
												return g.Lo;
											},
										});
									var e = n(3144),
										t = n(5671),
										o = n(136),
										i = n(2963),
										a = n(1120),
										s = n(4602),
										l = n(4143),
										u = n(3334),
										c = n(2144),
										d = n(6794),
										f = n(3164),
										p = n(6736),
										h = {};
									for (var m in p)
										['default', 'OktaAuth'].indexOf(m) < 0 &&
											(h[m] = function (e) {
												return p[e];
											}.bind(0, m));
									n.d(r, h);
									var v = n(9999),
										g = n(1132),
										y = n(3398),
										b = (0, s.S)(),
										_ = (0, l.a)(),
										w = (0, u.v)(),
										O = (0, c.Y)(_, b, w),
										k = (0, d.H)(O),
										x = (function (n) {
											(0, o.Z)(u, n);
											var r,
												s,
												l =
													((r = u),
													(s = (function () {
														if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
														if (Reflect.construct.sham) return !1;
														if ('function' == typeof Proxy) return !0;
														try {
															return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
														} catch (e) {
															return !1;
														}
													})()),
													function () {
														var e,
															t = (0, a.Z)(r);
														if (s) {
															var n = (0, a.Z)(this).constructor;
															e = Reflect.construct(t, arguments, n);
														} else e = t.apply(this, arguments);
														return (0, i.Z)(this, e);
													});
											function u(e) {
												return (0, t.Z)(this, u), l.call(this, e);
											}
											return (0, e.Z)(u);
										})((0, f.t)(k));
									r.default = x;
								})(),
								r
							);
						})());
				},
				35676: function (e, t, n) {
					var r, o, i;
					(o = [e, n(27444)]),
						(r = function (e, t) {
							'use strict';
							var n = r(t);
							function r(e) {
								return e && e.__esModule ? e : { default: e };
							}
							var o =
								'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
									? function (e) {
											return typeof e;
									  }
									: function (e) {
											return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
												? 'symbol'
												: typeof e;
									  };
							function i(e, t) {
								if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
							}
							var a = (function () {
									function e(e, t) {
										for (var n = 0; n < t.length; n++) {
											var r = t[n];
											(r.enumerable = r.enumerable || !1),
												(r.configurable = !0),
												'value' in r && (r.writable = !0),
												Object.defineProperty(e, r.key, r);
										}
									}
									return function (t, n, r) {
										return n && e(t.prototype, n), r && e(t, r), t;
									};
								})(),
								s = (function () {
									function e(t) {
										i(this, e), this.resolveOptions(t), this.initSelection();
									}
									return (
										a(e, [
											{
												key: 'resolveOptions',
												value: function () {
													var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
													(this.action = e.action),
														(this.container = e.container),
														(this.emitter = e.emitter),
														(this.target = e.target),
														(this.text = e.text),
														(this.trigger = e.trigger),
														(this.selectedText = '');
												},
											},
											{
												key: 'initSelection',
												value: function () {
													this.text ? this.selectFake() : this.target && this.selectTarget();
												},
											},
											{
												key: 'selectFake',
												value: function () {
													var e = this,
														t = 'rtl' == document.documentElement.getAttribute('dir');
													this.removeFake(),
														(this.fakeHandlerCallback = function () {
															return e.removeFake();
														}),
														(this.fakeHandler =
															this.container.addEventListener('click', this.fakeHandlerCallback) || !0),
														(this.fakeElem = document.createElement('textarea')),
														(this.fakeElem.style.fontSize = '12pt'),
														(this.fakeElem.style.border = '0'),
														(this.fakeElem.style.padding = '0'),
														(this.fakeElem.style.margin = '0'),
														(this.fakeElem.style.position = 'absolute'),
														(this.fakeElem.style[t ? 'right' : 'left'] = '-9999px');
													var r = window.pageYOffset || document.documentElement.scrollTop;
													(this.fakeElem.style.top = r + 'px'),
														this.fakeElem.setAttribute('readonly', ''),
														(this.fakeElem.value = this.text),
														this.container.appendChild(this.fakeElem),
														(this.selectedText = (0, n.default)(this.fakeElem)),
														this.copyText();
												},
											},
											{
												key: 'removeFake',
												value: function () {
													this.fakeHandler &&
														(this.container.removeEventListener('click', this.fakeHandlerCallback),
														(this.fakeHandler = null),
														(this.fakeHandlerCallback = null)),
														this.fakeElem && (this.container.removeChild(this.fakeElem), (this.fakeElem = null));
												},
											},
											{
												key: 'selectTarget',
												value: function () {
													(this.selectedText = (0, n.default)(this.target)), this.copyText();
												},
											},
											{
												key: 'copyText',
												value: function () {
													var e = void 0;
													try {
														e = document.execCommand(this.action);
													} catch (t) {
														e = !1;
													}
													this.handleResult(e);
												},
											},
											{
												key: 'handleResult',
												value: function (e) {
													this.emitter.emit(e ? 'success' : 'error', {
														action: this.action,
														text: this.selectedText,
														trigger: this.trigger,
														clearSelection: this.clearSelection.bind(this),
													});
												},
											},
											{
												key: 'clearSelection',
												value: function () {
													this.trigger && this.trigger.focus(), window.getSelection().removeAllRanges();
												},
											},
											{
												key: 'destroy',
												value: function () {
													this.removeFake();
												},
											},
											{
												key: 'action',
												set: function () {
													var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 'copy';
													if (((this._action = e), 'copy' !== this._action && 'cut' !== this._action))
														throw new Error('Invalid "action" value, use either "copy" or "cut"');
												},
												get: function () {
													return this._action;
												},
											},
											{
												key: 'target',
												set: function (e) {
													if (void 0 !== e) {
														if (!e || 'object' !== (void 0 === e ? 'undefined' : o(e)) || 1 !== e.nodeType)
															throw new Error('Invalid "target" value, use a valid Element');
														if ('copy' === this.action && e.hasAttribute('disabled'))
															throw new Error(
																'Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute'
															);
														if ('cut' === this.action && (e.hasAttribute('readonly') || e.hasAttribute('disabled')))
															throw new Error(
																'Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes'
															);
														this._target = e;
													}
												},
												get: function () {
													return this._target;
												},
											},
										]),
										e
									);
								})();
							e.exports = s;
						}),
						void 0 === (i = 'function' == typeof r ? r.apply(t, o) : r) || (e.exports = i);
				},
				35237: function (e, t, n) {
					var r, o, i;
					(o = [e, n(35676), n(10226), n(21617)]),
						(r = function (e, t, n, r) {
							'use strict';
							var o = s(t),
								i = s(n),
								a = s(r);
							function s(e) {
								return e && e.__esModule ? e : { default: e };
							}
							var l =
								'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
									? function (e) {
											return typeof e;
									  }
									: function (e) {
											return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
												? 'symbol'
												: typeof e;
									  };
							function u(e, t) {
								if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
							}
							var c = (function () {
								function e(e, t) {
									for (var n = 0; n < t.length; n++) {
										var r = t[n];
										(r.enumerable = r.enumerable || !1),
											(r.configurable = !0),
											'value' in r && (r.writable = !0),
											Object.defineProperty(e, r.key, r);
									}
								}
								return function (t, n, r) {
									return n && e(t.prototype, n), r && e(t, r), t;
								};
							})();
							function d(e, t) {
								if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
								return !t || ('object' != typeof t && 'function' != typeof t) ? e : t;
							}
							function f(e, t) {
								if ('function' != typeof t && null !== t)
									throw new TypeError('Super expression must either be null or a function, not ' + typeof t);
								(e.prototype = Object.create(t && t.prototype, {
									constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 },
								})),
									t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : (e.__proto__ = t));
							}
							var p = (function (e) {
								function t(e, n) {
									u(this, t);
									var r = d(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
									return r.resolveOptions(n), r.listenClick(e), r;
								}
								return (
									f(t, e),
									c(
										t,
										[
											{
												key: 'resolveOptions',
												value: function () {
													var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
													(this.action = 'function' == typeof e.action ? e.action : this.defaultAction),
														(this.target = 'function' == typeof e.target ? e.target : this.defaultTarget),
														(this.text = 'function' == typeof e.text ? e.text : this.defaultText),
														(this.container = 'object' === l(e.container) ? e.container : document.body);
												},
											},
											{
												key: 'listenClick',
												value: function (e) {
													var t = this;
													this.listener = (0, a.default)(e, 'click', function (e) {
														return t.onClick(e);
													});
												},
											},
											{
												key: 'onClick',
												value: function (e) {
													var t = e.delegateTarget || e.currentTarget;
													this.clipboardAction && (this.clipboardAction = null),
														(this.clipboardAction = new o.default({
															action: this.action(t),
															target: this.target(t),
															text: this.text(t),
															container: this.container,
															trigger: t,
															emitter: this,
														}));
												},
											},
											{
												key: 'defaultAction',
												value: function (e) {
													return h('action', e);
												},
											},
											{
												key: 'defaultTarget',
												value: function (e) {
													var t = h('target', e);
													if (t) return document.querySelector(t);
												},
											},
											{
												key: 'defaultText',
												value: function (e) {
													return h('text', e);
												},
											},
											{
												key: 'destroy',
												value: function () {
													this.listener.destroy(),
														this.clipboardAction && (this.clipboardAction.destroy(), (this.clipboardAction = null));
												},
											},
										],
										[
											{
												key: 'isSupported',
												value: function () {
													var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ['copy', 'cut'],
														t = 'string' == typeof e ? [e] : e,
														n = !!document.queryCommandSupported;
													return (
														t.forEach(function (e) {
															n = n && !!document.queryCommandSupported(e);
														}),
														n
													);
												},
											},
										]
									),
									t
								);
							})(i.default);
							function h(e, t) {
								var n = 'data-clipboard-' + e;
								if (t.hasAttribute(n)) return t.getAttribute(n);
							}
							e.exports = p;
						}),
						void 0 === (i = 'function' == typeof r ? r.apply(t, o) : r) || (e.exports = i);
				},
				16451: function (e, t, n) {
					var r = n(54068);
					e.exports = r;
				},
				93582: function (e, t, n) {
					var r = n(18209);
					e.exports = r;
				},
				10233: function (e, t, n) {
					var r = n(7866);
					e.exports = r;
				},
				80048: function (e, t, n) {
					var r = n(82903);
					e.exports = r;
				},
				97558: function (e, t, n) {
					var r = n(25207);
					e.exports = r;
				},
				53371: function (e, t, n) {
					var r = n(15836);
					e.exports = r;
				},
				75626: function (e, t, n) {
					var r = n(31227);
					e.exports = r;
				},
				96087: function (e, t, n) {
					var r = n(57650);
					e.exports = r;
				},
				72836: function (e, t, n) {
					var r = n(71081);
					e.exports = r;
				},
				91645: function (e, t, n) {
					var r = n(9956);
					e.exports = r;
				},
				90524: function (e, t, n) {
					var r = n(47255);
					e.exports = r;
				},
				16508: function (e, t, n) {
					var r = n(67437);
					e.exports = r;
				},
				74621: function (e, t, n) {
					var r = n(55458);
					e.exports = r;
				},
				27892: function (e, t, n) {
					var r = n(52653);
					e.exports = r;
				},
				69601: function (e, t, n) {
					n(90079);
					var r = n(40926);
					e.exports = r('Array', 'findIndex');
				},
				93504: function (e, t, n) {
					n(97514);
					var r = n(40926);
					e.exports = r('Array', 'find');
				},
				79391: function (e, t, n) {
					n(58281), n(11765);
					var r = n(11206);
					e.exports = r.Array.from;
				},
				47446: function (e, t, n) {
					n(58028);
					var r = n(40926);
					e.exports = r('Array', 'includes');
				},
				89452: function (e, t, n) {
					n(18756);
					var r = n(11206);
					e.exports = r.Object.assign;
				},
				15369: function (e, t, n) {
					n(13489);
					var r = n(11206);
					e.exports = r.Object.entries;
				},
				95680: function (e, t, n) {
					n(81755), n(25384);
					var r = n(11206);
					e.exports = r.Object.fromEntries;
				},
				79749: function (e, t, n) {
					n(37309);
					var r = n(11206);
					e.exports = r.Object.keys;
				},
				87362: function (e, t, n) {
					n(96698);
					var r = n(11206);
					e.exports = r.Object.setPrototypeOf;
				},
				83043: function (e, t, n) {
					n(59883);
					var r = n(11206);
					e.exports = r.Object.values;
				},
				42075: function (e, t, n) {
					n(94910), n(81755), n(14032), n(68067), n(77074), n(44455), n(80986), n(58281);
					var r = n(11206);
					e.exports = r.Promise;
				},
				48506: function (e, t, n) {
					n(81755), n(14032), n(76014), n(58281);
					var r = n(11206);
					e.exports = r.Set;
				},
				47762: function (e, t, n) {
					n(46358);
					var r = n(40926);
					e.exports = r('String', 'endsWith');
				},
				5694: function (e, t, n) {
					n(47458);
					var r = n(40926);
					e.exports = r('String', 'includes');
				},
				5671: function (e, t, n) {
					n(93875);
					var r = n(40926);
					e.exports = r('String', 'startsWith');
				},
				4154: function (e, t, n) {
					n(81755), n(14032), n(58281), n(69330);
					var r = n(75960);
					e.exports = r.f('iterator');
				},
				99988: function (e, t, n) {
					n(14032),
						n(58281),
						n(83326),
						n(50711),
						n(94095),
						n(73663),
						n(29883),
						n(35471),
						n(21012),
						n(88997),
						n(97464),
						n(93706),
						n(31519),
						n(2857),
						n(94715),
						n(13624),
						n(62514),
						n(24597),
						n(88042),
						n(4660),
						n(92451),
						n(44206),
						n(66288),
						n(13250),
						n(3858),
						n(84538),
						n(64793),
						n(74202),
						n(52529),
						n(91132);
				},
				72534: function (e, t, n) {
					n(45004), n(29690), n(56912), n(99988);
					var r = n(32010);
					e.exports = r.Uint8Array;
				},
				20845: function (e, t, n) {
					n(81755), n(14032), n(78643);
					var r = n(11206);
					e.exports = r.WeakMap;
				},
				560: function (e, t, n) {
					e.exports = n(9374);
				},
				26397: function (e, t, n) {
					e.exports = n(44719);
				},
				88150: function (e, t, n) {
					e.exports = n(66668);
				},
				24611: function (e, t, n) {
					e.exports = n(99473);
				},
				58603: function (e, t, n) {
					e.exports = n(37617);
				},
				91512: function (e, t, n) {
					e.exports = n(7390);
				},
				44799: function (e, t, n) {
					e.exports = n(3509);
				},
				88991: function (e, t, n) {
					e.exports = n(65081);
				},
				89691: function (e, t, n) {
					e.exports = n(27253);
				},
				75497: function (e, t, n) {
					e.exports = n(38483);
				},
				53950: function (e, t, n) {
					e.exports = n(63300);
				},
				58245: function (e, t, n) {
					e.exports = n(24267);
				},
				27672: function (e, t, n) {
					e.exports = n(15766);
				},
				87971: function (e, t, n) {
					e.exports = n(26673);
				},
				20697: function (e, t, n) {
					e.exports = n(98619);
				},
				18470: function (e, t, n) {
					e.exports = n(85416);
				},
				70257: function (e, t, n) {
					e.exports = n(84015);
				},
				9374: function (e, t, n) {
					var r = n(16451);
					e.exports = r;
				},
				44719: function (e, t, n) {
					var r = n(93582);
					e.exports = r;
				},
				66668: function (e, t, n) {
					var r = n(10233);
					e.exports = r;
				},
				99473: function (e, t, n) {
					var r = n(80048);
					e.exports = r;
				},
				37617: function (e, t, n) {
					var r = n(97558);
					e.exports = r;
				},
				7390: function (e, t, n) {
					var r = n(53371);
					e.exports = r;
				},
				3509: function (e, t, n) {
					var r = n(75626);
					e.exports = r;
				},
				65081: function (e, t, n) {
					n(27217);
					var r = n(11206);
					e.exports = r.Object.iterateEntries;
				},
				27253: function (e, t, n) {
					n(60573);
					var r = n(11206);
					e.exports = r.Object.iterateKeys;
				},
				38483: function (e, t, n) {
					n(8843);
					var r = n(11206);
					e.exports = r.Object.iterateValues;
				},
				63300: function (e, t, n) {
					var r = n(96087);
					e.exports = r;
				},
				24267: function (e, t, n) {
					var r = n(72836);
					e.exports = r;
				},
				15766: function (e, t, n) {
					var r = n(91645);
					e.exports = r;
				},
				26673: function (e, t, n) {
					var r = n(90524);
					e.exports = r;
				},
				98619: function (e, t, n) {
					var r = n(16508);
					e.exports = r;
				},
				85416: function (e, t, n) {
					var r = n(74621);
					e.exports = r;
				},
				84015: function (e, t, n) {
					var r = n(27892);
					e.exports = r;
				},
				32631: function (e, t, n) {
					var r = n(94578),
						o = n(68664),
						i = TypeError;
					e.exports = function (e) {
						if (r(e)) return e;
						throw i(o(e) + ' is not a function');
					};
				},
				69075: function (e, t, n) {
					var r = n(20884),
						o = n(68664),
						i = TypeError;
					e.exports = function (e) {
						if (r(e)) return e;
						throw i(o(e) + ' is not a constructor');
					};
				},
				58659: function (e, t, n) {
					var r = n(94578),
						o = String,
						i = TypeError;
					e.exports = function (e) {
						if ('object' == typeof e || r(e)) return e;
						throw i("Can't set " + o(e) + ' as a prototype');
					};
				},
				71156: function (e, t, n) {
					var r = n(38688),
						o = n(10819),
						i = n(95892).f,
						a = r('unscopables'),
						s = Array.prototype;
					null == s[a] && i(s, a, { configurable: !0, value: o(null) }),
						(e.exports = function (e) {
							s[a][e] = !0;
						});
				},
				2868: function (e, t, n) {
					var r = n(70176),
						o = TypeError;
					e.exports = function (e, t) {
						if (r(t, e)) return e;
						throw o('Incorrect invocation');
					};
				},
				34984: function (e, t, n) {
					var r = n(24517),
						o = String,
						i = TypeError;
					e.exports = function (e) {
						if (r(e)) return e;
						throw i(o(e) + ' is not an object');
					};
				},
				33002: function (e) {
					e.exports = 'undefined' != typeof ArrayBuffer && 'undefined' != typeof DataView;
				},
				60687: function (e, t, n) {
					var r = n(47044);
					e.exports = r(function () {
						if ('function' == typeof ArrayBuffer) {
							var e = new ArrayBuffer(8);
							Object.isExtensible(e) && Object.defineProperty(e, 'a', { value: 8 });
						}
					});
				},
				95089: function (e, t, n) {
					'use strict';
					var r,
						o,
						i,
						a = n(33002),
						s = n(15567),
						l = n(32010),
						u = n(94578),
						c = n(24517),
						d = n(20340),
						f = n(52564),
						p = n(68664),
						h = n(48914),
						m = n(79855),
						v = n(95892).f,
						g = n(70176),
						y = n(69548),
						b = n(3840),
						_ = n(38688),
						w = n(46859),
						O = n(70172),
						k = O.enforce,
						x = O.get,
						E = l.Int8Array,
						T = E && E.prototype,
						S = l.Uint8ClampedArray,
						A = S && S.prototype,
						C = E && y(E),
						P = T && y(T),
						R = Object.prototype,
						I = l.TypeError,
						N = _('toStringTag'),
						M = w('TYPED_ARRAY_TAG'),
						j = 'TypedArrayConstructor',
						D = a && !!b && 'Opera' !== f(l.opera),
						L = !1,
						U = {
							Int8Array: 1,
							Uint8Array: 1,
							Uint8ClampedArray: 1,
							Int16Array: 2,
							Uint16Array: 2,
							Int32Array: 4,
							Uint32Array: 4,
							Float32Array: 4,
							Float64Array: 8,
						},
						F = { BigInt64Array: 8, BigUint64Array: 8 },
						B = function (e) {
							var t = y(e);
							if (c(t)) {
								var n = x(t);
								return n && d(n, j) ? n.TypedArrayConstructor : B(t);
							}
						},
						V = function (e) {
							if (!c(e)) return !1;
							var t = f(e);
							return d(U, t) || d(F, t);
						};
					for (r in U) (i = (o = l[r]) && o.prototype) ? (k(i).TypedArrayConstructor = o) : (D = !1);
					for (r in F) (i = (o = l[r]) && o.prototype) && (k(i).TypedArrayConstructor = o);
					if (
						(!D || !u(C) || C === Function.prototype) &&
						((C = function () {
							throw I('Incorrect invocation');
						}),
						D)
					)
						for (r in U) l[r] && b(l[r], C);
					if ((!D || !P || P === R) && ((P = C.prototype), D)) for (r in U) l[r] && b(l[r].prototype, P);
					if ((D && y(A) !== P && b(A, P), s && !d(P, N)))
						for (r in ((L = !0),
						v(P, N, {
							get: function () {
								return c(this) ? this[M] : void 0;
							},
						}),
						U))
							l[r] && h(l[r], M, r);
					e.exports = {
						NATIVE_ARRAY_BUFFER_VIEWS: D,
						TYPED_ARRAY_TAG: L && M,
						aTypedArray: function (e) {
							if (V(e)) return e;
							throw I('Target is not a typed array');
						},
						aTypedArrayConstructor: function (e) {
							if (u(e) && (!b || g(C, e))) return e;
							throw I(p(e) + ' is not a typed array constructor');
						},
						exportTypedArrayMethod: function (e, t, n, r) {
							if (s) {
								if (n)
									for (var o in U) {
										var i = l[o];
										if (i && d(i.prototype, e))
											try {
												delete i.prototype[e];
											} catch (n) {
												try {
													i.prototype[e] = t;
												} catch (e) {}
											}
									}
								(P[e] && !n) || m(P, e, n ? t : (D && T[e]) || t, r);
							}
						},
						exportTypedArrayStaticMethod: function (e, t, n) {
							var r, o;
							if (s) {
								if (b) {
									if (n)
										for (r in U)
											if ((o = l[r]) && d(o, e))
												try {
													delete o[e];
												} catch (e) {}
									if (C[e] && !n) return;
									try {
										return m(C, e, n ? t : (D && C[e]) || t);
									} catch (e) {}
								}
								for (r in U) !(o = l[r]) || (o[e] && !n) || m(o, e, t);
							}
						},
						getTypedArrayConstructor: B,
						isView: function (e) {
							if (!c(e)) return !1;
							var t = f(e);
							return 'DataView' === t || d(U, t) || d(F, t);
						},
						isTypedArray: V,
						TypedArray: C,
						TypedArrayPrototype: P,
					};
				},
				69351: function (e, t, n) {
					'use strict';
					var r = n(32010),
						o = n(38347),
						i = n(15567),
						a = n(33002),
						s = n(7081),
						l = n(48914),
						u = n(85994),
						c = n(47044),
						d = n(2868),
						f = n(26882),
						p = n(23417),
						h = n(71265),
						m = n(64397),
						v = n(69548),
						g = n(3840),
						y = n(6611).f,
						b = n(95892).f,
						_ = n(72864),
						w = n(45258),
						O = n(15216),
						k = n(70172),
						x = s.PROPER,
						E = s.CONFIGURABLE,
						T = k.get,
						S = k.set,
						A = 'ArrayBuffer',
						C = 'DataView',
						P = 'Wrong index',
						R = r.ArrayBuffer,
						I = R,
						N = I && I.prototype,
						M = r.DataView,
						j = M && M.prototype,
						D = Object.prototype,
						L = r.Array,
						U = r.RangeError,
						F = o(_),
						B = o([].reverse),
						V = m.pack,
						Z = m.unpack,
						H = function (e) {
							return [255 & e];
						},
						q = function (e) {
							return [255 & e, (e >> 8) & 255];
						},
						W = function (e) {
							return [255 & e, (e >> 8) & 255, (e >> 16) & 255, (e >> 24) & 255];
						},
						K = function (e) {
							return (e[3] << 24) | (e[2] << 16) | (e[1] << 8) | e[0];
						},
						$ = function (e) {
							return V(e, 23, 4);
						},
						z = function (e) {
							return V(e, 52, 8);
						},
						G = function (e, t) {
							b(e.prototype, t, {
								get: function () {
									return T(this)[t];
								},
							});
						},
						Y = function (e, t, n, r) {
							var o = h(n),
								i = T(e);
							if (o + t > i.byteLength) throw U(P);
							var a = T(i.buffer).bytes,
								s = o + i.byteOffset,
								l = w(a, s, s + t);
							return r ? l : B(l);
						},
						J = function (e, t, n, r, o, i) {
							var a = h(n),
								s = T(e);
							if (a + t > s.byteLength) throw U(P);
							for (var l = T(s.buffer).bytes, u = a + s.byteOffset, c = r(+o), d = 0; d < t; d++)
								l[u + d] = c[i ? d : t - d - 1];
						};
					if (a) {
						var Q = x && R.name !== A;
						if (
							c(function () {
								R(1);
							}) &&
							c(function () {
								new R(-1);
							}) &&
							!c(function () {
								return new R(), new R(1.5), new R(NaN), 1 != R.length || (Q && !E);
							})
						)
							Q && E && l(R, 'name', A);
						else {
							(I = function (e) {
								return d(this, N), new R(h(e));
							}).prototype = N;
							for (var X, ee = y(R), te = 0; ee.length > te; ) (X = ee[te++]) in I || l(I, X, R[X]);
							N.constructor = I;
						}
						g && v(j) !== D && g(j, D);
						var ne = new M(new I(2)),
							re = o(j.setInt8);
						ne.setInt8(0, 2147483648),
							ne.setInt8(1, 2147483649),
							(!ne.getInt8(0) && ne.getInt8(1)) ||
								u(
									j,
									{
										setInt8: function (e, t) {
											re(this, e, (t << 24) >> 24);
										},
										setUint8: function (e, t) {
											re(this, e, (t << 24) >> 24);
										},
									},
									{ unsafe: !0 }
								);
					} else
						(N = (I = function (e) {
							d(this, N);
							var t = h(e);
							S(this, { bytes: F(L(t), 0), byteLength: t }), i || (this.byteLength = t);
						}).prototype),
							(j = (M = function (e, t, n) {
								d(this, j), d(e, N);
								var r = T(e).byteLength,
									o = f(t);
								if (o < 0 || o > r) throw U('Wrong offset');
								if (o + (n = void 0 === n ? r - o : p(n)) > r) throw U('Wrong length');
								S(this, { buffer: e, byteLength: n, byteOffset: o }),
									i || ((this.buffer = e), (this.byteLength = n), (this.byteOffset = o));
							}).prototype),
							i && (G(I, 'byteLength'), G(M, 'buffer'), G(M, 'byteLength'), G(M, 'byteOffset')),
							u(j, {
								getInt8: function (e) {
									return (Y(this, 1, e)[0] << 24) >> 24;
								},
								getUint8: function (e) {
									return Y(this, 1, e)[0];
								},
								getInt16: function (e) {
									var t = Y(this, 2, e, arguments.length > 1 ? arguments[1] : void 0);
									return (((t[1] << 8) | t[0]) << 16) >> 16;
								},
								getUint16: function (e) {
									var t = Y(this, 2, e, arguments.length > 1 ? arguments[1] : void 0);
									return (t[1] << 8) | t[0];
								},
								getInt32: function (e) {
									return K(Y(this, 4, e, arguments.length > 1 ? arguments[1] : void 0));
								},
								getUint32: function (e) {
									return K(Y(this, 4, e, arguments.length > 1 ? arguments[1] : void 0)) >>> 0;
								},
								getFloat32: function (e) {
									return Z(Y(this, 4, e, arguments.length > 1 ? arguments[1] : void 0), 23);
								},
								getFloat64: function (e) {
									return Z(Y(this, 8, e, arguments.length > 1 ? arguments[1] : void 0), 52);
								},
								setInt8: function (e, t) {
									J(this, 1, e, H, t);
								},
								setUint8: function (e, t) {
									J(this, 1, e, H, t);
								},
								setInt16: function (e, t) {
									J(this, 2, e, q, t, arguments.length > 2 ? arguments[2] : void 0);
								},
								setUint16: function (e, t) {
									J(this, 2, e, q, t, arguments.length > 2 ? arguments[2] : void 0);
								},
								setInt32: function (e, t) {
									J(this, 4, e, W, t, arguments.length > 2 ? arguments[2] : void 0);
								},
								setUint32: function (e, t) {
									J(this, 4, e, W, t, arguments.length > 2 ? arguments[2] : void 0);
								},
								setFloat32: function (e, t) {
									J(this, 4, e, $, t, arguments.length > 2 ? arguments[2] : void 0);
								},
								setFloat64: function (e, t) {
									J(this, 8, e, z, t, arguments.length > 2 ? arguments[2] : void 0);
								},
							});
					O(I, A), O(M, C), (e.exports = { ArrayBuffer: I, DataView: M });
				},
				92642: function (e, t, n) {
					'use strict';
					var r = n(43162),
						o = n(74841),
						i = n(45495),
						a = n(10303),
						s = Math.min;
					e.exports =
						[].copyWithin ||
						function (e, t) {
							var n = r(this),
								l = i(n),
								u = o(e, l),
								c = o(t, l),
								d = arguments.length > 2 ? arguments[2] : void 0,
								f = s((void 0 === d ? l : o(d, l)) - c, l - u),
								p = 1;
							for (c < u && u < c + f && ((p = -1), (c += f - 1), (u += f - 1)); f-- > 0; )
								c in n ? (n[u] = n[c]) : a(n, u), (u += p), (c += p);
							return n;
						};
				},
				72864: function (e, t, n) {
					'use strict';
					var r = n(43162),
						o = n(74841),
						i = n(45495);
					e.exports = function (e) {
						for (
							var t = r(this),
								n = i(t),
								a = arguments.length,
								s = o(a > 1 ? arguments[1] : void 0, n),
								l = a > 2 ? arguments[2] : void 0,
								u = void 0 === l ? n : o(l, n);
							u > s;

						)
							t[s++] = e;
						return t;
					};
				},
				34269: function (e, t, n) {
					var r = n(45495);
					e.exports = function (e, t) {
						for (var n = 0, o = r(t), i = new e(o); o > n; ) i[n] = t[n++];
						return i;
					};
				},
				95717: function (e, t, n) {
					'use strict';
					var r = n(25567),
						o = n(2834),
						i = n(43162),
						a = n(97738),
						s = n(89564),
						l = n(20884),
						u = n(45495),
						c = n(38639),
						d = n(15892),
						f = n(13872),
						p = Array;
					e.exports = function (e) {
						var t = i(e),
							n = l(this),
							h = arguments.length,
							m = h > 1 ? arguments[1] : void 0,
							v = void 0 !== m;
						v && (m = r(m, h > 2 ? arguments[2] : void 0));
						var g,
							y,
							b,
							_,
							w,
							O,
							k = f(t),
							x = 0;
						if (!k || (this === p && s(k)))
							for (g = u(t), y = n ? new this(g) : p(g); g > x; x++) (O = v ? m(t[x], x) : t[x]), c(y, x, O);
						else
							for (w = (_ = d(t, k)).next, y = n ? new this() : []; !(b = o(w, _)).done; x++)
								(O = v ? a(_, m, [b.value, x], !0) : b.value), c(y, x, O);
						return (y.length = x), y;
					};
				},
				12636: function (e, t, n) {
					var r = n(98086),
						o = n(74841),
						i = n(45495),
						a = function (e) {
							return function (t, n, a) {
								var s,
									l = r(t),
									u = i(l),
									c = o(a, u);
								if (e && n != n) {
									for (; u > c; ) if ((s = l[c++]) != s) return !0;
								} else for (; u > c; c++) if ((e || c in l) && l[c] === n) return e || c || 0;
								return !e && -1;
							};
						};
					e.exports = { includes: a(!0), indexOf: a(!1) };
				},
				88828: function (e, t, n) {
					var r = n(25567),
						o = n(7514),
						i = n(43162),
						a = n(45495),
						s = function (e) {
							var t = 1 == e;
							return function (n, s, l) {
								for (var u, c = i(n), d = o(c), f = r(s, l), p = a(d); p-- > 0; )
									if (f((u = d[p]), p, c))
										switch (e) {
											case 0:
												return u;
											case 1:
												return p;
										}
								return t ? -1 : void 0;
							};
						};
					e.exports = { findLast: s(0), findLastIndex: s(1) };
				},
				91102: function (e, t, n) {
					var r = n(25567),
						o = n(38347),
						i = n(7514),
						a = n(43162),
						s = n(45495),
						l = n(45744),
						u = o([].push),
						c = function (e) {
							var t = 1 == e,
								n = 2 == e,
								o = 3 == e,
								c = 4 == e,
								d = 6 == e,
								f = 7 == e,
								p = 5 == e || d;
							return function (h, m, v, g) {
								for (
									var y,
										b,
										_ = a(h),
										w = i(_),
										O = r(m, v),
										k = s(w),
										x = 0,
										E = g || l,
										T = t ? E(h, k) : n || f ? E(h, 0) : void 0;
									k > x;
									x++
								)
									if ((p || x in w) && ((b = O((y = w[x]), x, _)), e))
										if (t) T[x] = b;
										else if (b)
											switch (e) {
												case 3:
													return !0;
												case 5:
													return y;
												case 6:
													return x;
												case 2:
													u(T, y);
											}
										else
											switch (e) {
												case 4:
													return !1;
												case 7:
													u(T, y);
											}
								return d ? -1 : o || c ? c : T;
							};
						};
					e.exports = {
						forEach: c(0),
						map: c(1),
						filter: c(2),
						some: c(3),
						every: c(4),
						find: c(5),
						findIndex: c(6),
						filterReject: c(7),
					};
				},
				84320: function (e, t, n) {
					'use strict';
					var r = n(58448),
						o = n(98086),
						i = n(26882),
						a = n(45495),
						s = n(81007),
						l = Math.min,
						u = [].lastIndexOf,
						c = !!u && 1 / [1].lastIndexOf(1, -0) < 0,
						d = s('lastIndexOf'),
						f = c || !d;
					e.exports = f
						? function (e) {
								if (c) return r(u, this, arguments) || 0;
								var t = o(this),
									n = a(t),
									s = n - 1;
								for (arguments.length > 1 && (s = l(s, i(arguments[1]))), s < 0 && (s = n + s); s >= 0; s--)
									if (s in t && t[s] === e) return s || 0;
								return -1;
						  }
						: u;
				},
				81007: function (e, t, n) {
					'use strict';
					var r = n(47044);
					e.exports = function (e, t) {
						var n = [][e];
						return (
							!!n &&
							r(function () {
								n.call(
									null,
									t ||
										function () {
											return 1;
										},
									1
								);
							})
						);
					};
				},
				32843: function (e, t, n) {
					var r = n(32631),
						o = n(43162),
						i = n(7514),
						a = n(45495),
						s = TypeError,
						l = function (e) {
							return function (t, n, l, u) {
								r(n);
								var c = o(t),
									d = i(c),
									f = a(c),
									p = e ? f - 1 : 0,
									h = e ? -1 : 1;
								if (l < 2)
									for (;;) {
										if (p in d) {
											(u = d[p]), (p += h);
											break;
										}
										if (((p += h), e ? p < 0 : f <= p)) throw s('Reduce of empty array with no initial value');
									}
								for (; e ? p >= 0 : f > p; p += h) p in d && (u = n(u, d[p], p, c));
								return u;
							};
						};
					e.exports = { left: l(!1), right: l(!0) };
				},
				45258: function (e, t, n) {
					var r = n(74841),
						o = n(45495),
						i = n(38639),
						a = Array,
						s = Math.max;
					e.exports = function (e, t, n) {
						for (var l = o(e), u = r(t, l), c = r(void 0 === n ? l : n, l), d = a(s(c - u, 0)), f = 0; u < c; u++, f++)
							i(d, f, e[u]);
						return (d.length = f), d;
					};
				},
				73163: function (e, t, n) {
					var r = n(38347);
					e.exports = r([].slice);
				},
				43977: function (e, t, n) {
					var r = n(45258),
						o = Math.floor,
						i = function (e, t) {
							var n = e.length,
								l = o(n / 2);
							return n < 8 ? a(e, t) : s(e, i(r(e, 0, l), t), i(r(e, l), t), t);
						},
						a = function (e, t) {
							for (var n, r, o = e.length, i = 1; i < o; ) {
								for (r = i, n = e[i]; r && t(e[r - 1], n) > 0; ) e[r] = e[--r];
								r !== i++ && (e[r] = n);
							}
							return e;
						},
						s = function (e, t, n, r) {
							for (var o = t.length, i = n.length, a = 0, s = 0; a < o || s < i; )
								e[a + s] = a < o && s < i ? (r(t[a], n[s]) <= 0 ? t[a++] : n[s++]) : a < o ? t[a++] : n[s++];
							return e;
						};
					e.exports = i;
				},
				98578: function (e, t, n) {
					var r = n(59113),
						o = n(20884),
						i = n(24517),
						a = n(38688)('species'),
						s = Array;
					e.exports = function (e) {
						var t;
						return (
							r(e) &&
								((t = e.constructor),
								((o(t) && (t === s || r(t.prototype))) || (i(t) && null === (t = t[a]))) && (t = void 0)),
							void 0 === t ? s : t
						);
					};
				},
				45744: function (e, t, n) {
					var r = n(98578);
					e.exports = function (e, t) {
						return new (r(e))(0 === t ? 0 : t);
					};
				},
				97738: function (e, t, n) {
					var r = n(34984),
						o = n(50194);
					e.exports = function (e, t, n, i) {
						try {
							return i ? t(r(n)[0], n[1]) : t(n);
						} catch (t) {
							o(e, 'throw', t);
						}
					};
				},
				46769: function (e, t, n) {
					var r = n(38688)('iterator'),
						o = !1;
					try {
						var i = 0,
							a = {
								next: function () {
									return { done: !!i++ };
								},
								return: function () {
									o = !0;
								},
							};
						(a[r] = function () {
							return this;
						}),
							Array.from(a, function () {
								throw 2;
							});
					} catch (e) {}
					e.exports = function (e, t) {
						if (!t && !o) return !1;
						var n = !1;
						try {
							var i = {};
							(i[r] = function () {
								return {
									next: function () {
										return { done: (n = !0) };
									},
								};
							}),
								e(i);
						} catch (e) {}
						return n;
					};
				},
				93975: function (e, t, n) {
					var r = n(38347),
						o = r({}.toString),
						i = r(''.slice);
					e.exports = function (e) {
						return i(o(e), 8, -1);
					};
				},
				52564: function (e, t, n) {
					var r = n(24663),
						o = n(94578),
						i = n(93975),
						a = n(38688)('toStringTag'),
						s = Object,
						l =
							'Arguments' ==
							i(
								(function () {
									return arguments;
								})()
							);
					e.exports = r
						? i
						: function (e) {
								var t, n, r;
								return void 0 === e
									? 'Undefined'
									: null === e
									? 'Null'
									: 'string' ==
									  typeof (n = (function (e, t) {
											try {
												return e[t];
											} catch (e) {}
									  })((t = s(e)), a))
									? n
									: l
									? i(t)
									: 'Object' == (r = i(t)) && o(t.callee)
									? 'Arguments'
									: r;
						  };
				},
				9649: function (e, t, n) {
					'use strict';
					var r = n(95892).f,
						o = n(10819),
						i = n(85994),
						a = n(25567),
						s = n(2868),
						l = n(35576),
						u = n(80383),
						c = n(11231),
						d = n(19110),
						f = n(51334),
						p = n(15567),
						h = n(62148).fastKey,
						m = n(70172),
						v = m.set,
						g = m.getterFor;
					e.exports = {
						getConstructor: function (e, t, n, c) {
							var d = e(function (e, r) {
									s(e, f),
										v(e, { type: t, index: o(null), first: void 0, last: void 0, size: 0 }),
										p || (e.size = 0),
										l(r) || u(r, e[c], { that: e, AS_ENTRIES: n });
								}),
								f = d.prototype,
								m = g(t),
								y = function (e, t, n) {
									var r,
										o,
										i = m(e),
										a = b(e, t);
									return (
										a
											? (a.value = n)
											: ((i.last = a =
													{
														index: (o = h(t, !0)),
														key: t,
														value: n,
														previous: (r = i.last),
														next: void 0,
														removed: !1,
													}),
											  i.first || (i.first = a),
											  r && (r.next = a),
											  p ? i.size++ : e.size++,
											  'F' !== o && (i.index[o] = a)),
										e
									);
								},
								b = function (e, t) {
									var n,
										r = m(e),
										o = h(t);
									if ('F' !== o) return r.index[o];
									for (n = r.first; n; n = n.next) if (n.key == t) return n;
								};
							return (
								i(f, {
									clear: function () {
										for (var e = m(this), t = e.index, n = e.first; n; )
											(n.removed = !0),
												n.previous && (n.previous = n.previous.next = void 0),
												delete t[n.index],
												(n = n.next);
										(e.first = e.last = void 0), p ? (e.size = 0) : (this.size = 0);
									},
									delete: function (e) {
										var t = this,
											n = m(t),
											r = b(t, e);
										if (r) {
											var o = r.next,
												i = r.previous;
											delete n.index[r.index],
												(r.removed = !0),
												i && (i.next = o),
												o && (o.previous = i),
												n.first == r && (n.first = o),
												n.last == r && (n.last = i),
												p ? n.size-- : t.size--;
										}
										return !!r;
									},
									forEach: function (e) {
										for (
											var t, n = m(this), r = a(e, arguments.length > 1 ? arguments[1] : void 0);
											(t = t ? t.next : n.first);

										)
											for (r(t.value, t.key, this); t && t.removed; ) t = t.previous;
									},
									has: function (e) {
										return !!b(this, e);
									},
								}),
								i(
									f,
									n
										? {
												get: function (e) {
													var t = b(this, e);
													return t && t.value;
												},
												set: function (e, t) {
													return y(this, 0 === e ? 0 : e, t);
												},
										  }
										: {
												add: function (e) {
													return y(this, (e = 0 === e ? 0 : e), e);
												},
										  }
								),
								p &&
									r(f, 'size', {
										get: function () {
											return m(this).size;
										},
									}),
								d
							);
						},
						setStrong: function (e, t, n) {
							var r = t + ' Iterator',
								o = g(t),
								i = g(r);
							c(
								e,
								t,
								function (e, t) {
									v(this, { type: r, target: e, state: o(e), kind: t, last: void 0 });
								},
								function () {
									for (var e = i(this), t = e.kind, n = e.last; n && n.removed; ) n = n.previous;
									return e.target && (e.last = n = n ? n.next : e.state.first)
										? d('keys' == t ? n.key : 'values' == t ? n.value : [n.key, n.value], !1)
										: ((e.target = void 0), d(void 0, !0));
								},
								n ? 'entries' : 'values',
								!n,
								!0
							),
								f(t);
						},
					};
				},
				79206: function (e, t, n) {
					'use strict';
					var r = n(38347),
						o = n(85994),
						i = n(62148).getWeakData,
						a = n(2868),
						s = n(34984),
						l = n(35576),
						u = n(24517),
						c = n(80383),
						d = n(91102),
						f = n(20340),
						p = n(70172),
						h = p.set,
						m = p.getterFor,
						v = d.find,
						g = d.findIndex,
						y = r([].splice),
						b = 0,
						_ = function (e) {
							return e.frozen || (e.frozen = new w());
						},
						w = function () {
							this.entries = [];
						},
						O = function (e, t) {
							return v(e.entries, function (e) {
								return e[0] === t;
							});
						};
					(w.prototype = {
						get: function (e) {
							var t = O(this, e);
							if (t) return t[1];
						},
						has: function (e) {
							return !!O(this, e);
						},
						set: function (e, t) {
							var n = O(this, e);
							n ? (n[1] = t) : this.entries.push([e, t]);
						},
						delete: function (e) {
							var t = g(this.entries, function (t) {
								return t[0] === e;
							});
							return ~t && y(this.entries, t, 1), !!~t;
						},
					}),
						(e.exports = {
							getConstructor: function (e, t, n, r) {
								var d = e(function (e, o) {
										a(e, p), h(e, { type: t, id: b++, frozen: void 0 }), l(o) || c(o, e[r], { that: e, AS_ENTRIES: n });
									}),
									p = d.prototype,
									v = m(t),
									g = function (e, t, n) {
										var r = v(e),
											o = i(s(t), !0);
										return !0 === o ? _(r).set(t, n) : (o[r.id] = n), e;
									};
								return (
									o(p, {
										delete: function (e) {
											var t = v(this);
											if (!u(e)) return !1;
											var n = i(e);
											return !0 === n ? _(t).delete(e) : n && f(n, t.id) && delete n[t.id];
										},
										has: function (e) {
											var t = v(this);
											if (!u(e)) return !1;
											var n = i(e);
											return !0 === n ? _(t).has(e) : n && f(n, t.id);
										},
									}),
									o(
										p,
										n
											? {
													get: function (e) {
														var t = v(this);
														if (u(e)) {
															var n = i(e);
															return !0 === n ? _(t).get(e) : n ? n[t.id] : void 0;
														}
													},
													set: function (e, t) {
														return g(this, e, t);
													},
											  }
											: {
													add: function (e) {
														return g(this, e, !0);
													},
											  }
									),
									d
								);
							},
						});
				},
				36673: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(32010),
						i = n(38347),
						a = n(39599),
						s = n(79855),
						l = n(62148),
						u = n(80383),
						c = n(2868),
						d = n(94578),
						f = n(35576),
						p = n(24517),
						h = n(47044),
						m = n(46769),
						v = n(15216),
						g = n(51868);
					e.exports = function (e, t, n) {
						var y = -1 !== e.indexOf('Map'),
							b = -1 !== e.indexOf('Weak'),
							_ = y ? 'set' : 'add',
							w = o[e],
							O = w && w.prototype,
							k = w,
							x = {},
							E = function (e) {
								var t = i(O[e]);
								s(
									O,
									e,
									'add' == e
										? function (e) {
												return t(this, 0 === e ? 0 : e), this;
										  }
										: 'delete' == e
										? function (e) {
												return !(b && !p(e)) && t(this, 0 === e ? 0 : e);
										  }
										: 'get' == e
										? function (e) {
												return b && !p(e) ? void 0 : t(this, 0 === e ? 0 : e);
										  }
										: 'has' == e
										? function (e) {
												return !(b && !p(e)) && t(this, 0 === e ? 0 : e);
										  }
										: function (e, n) {
												return t(this, 0 === e ? 0 : e, n), this;
										  }
								);
							};
						if (
							a(
								e,
								!d(w) ||
									!(
										b ||
										(O.forEach &&
											!h(function () {
												new w().entries().next();
											}))
									)
							)
						)
							(k = n.getConstructor(t, e, y, _)), l.enable();
						else if (a(e, !0)) {
							var T = new k(),
								S = T[_](b ? {} : -0, 1) != T,
								A = h(function () {
									T.has(1);
								}),
								C = m(function (e) {
									new w(e);
								}),
								P =
									!b &&
									h(function () {
										for (var e = new w(), t = 5; t--; ) e[_](t, t);
										return !e.has(-0);
									});
							C ||
								(((k = t(function (e, t) {
									c(e, O);
									var n = g(new w(), e, k);
									return f(t) || u(t, n[_], { that: n, AS_ENTRIES: y }), n;
								})).prototype = O),
								(O.constructor = k)),
								(A || P) && (E('delete'), E('has'), y && E('get')),
								(P || S) && E(_),
								b && O.clear && delete O.clear;
						}
						return (
							(x[e] = k), r({ global: !0, constructor: !0, forced: k != w }, x), v(k, e), b || n.setStrong(k, e, y), k
						);
					};
				},
				2675: function (e, t, n) {
					var r = n(20340),
						o = n(21594),
						i = n(72062),
						a = n(95892);
					e.exports = function (e, t, n) {
						for (var s = o(t), l = a.f, u = i.f, c = 0; c < s.length; c++) {
							var d = s[c];
							r(e, d) || (n && r(n, d)) || l(e, d, u(t, d));
						}
					};
				},
				91151: function (e, t, n) {
					var r = n(38688)('match');
					e.exports = function (e) {
						var t = /./;
						try {
							'/./'[e](t);
						} catch (n) {
							try {
								return (t[r] = !1), '/./'[e](t);
							} catch (e) {}
						}
						return !1;
					};
				},
				68494: function (e, t, n) {
					var r = n(47044);
					e.exports = !r(function () {
						function e() {}
						return (e.prototype.constructor = null), Object.getPrototypeOf(new e()) !== e.prototype;
					});
				},
				19110: function (e) {
					e.exports = function (e, t) {
						return { value: e, done: t };
					};
				},
				48914: function (e, t, n) {
					var r = n(15567),
						o = n(95892),
						i = n(97841);
					e.exports = r
						? function (e, t, n) {
								return o.f(e, t, i(1, n));
						  }
						: function (e, t, n) {
								return (e[t] = n), e;
						  };
				},
				97841: function (e) {
					e.exports = function (e, t) {
						return { enumerable: !(1 & e), configurable: !(2 & e), writable: !(4 & e), value: t };
					};
				},
				38639: function (e, t, n) {
					'use strict';
					var r = n(63918),
						o = n(95892),
						i = n(97841);
					e.exports = function (e, t, n) {
						var a = r(t);
						a in e ? o.f(e, a, i(0, n)) : (e[a] = n);
					};
				},
				16395: function (e, t, n) {
					var r = n(7344),
						o = n(95892);
					e.exports = function (e, t, n) {
						return n.get && r(n.get, t, { getter: !0 }), n.set && r(n.set, t, { setter: !0 }), o.f(e, t, n);
					};
				},
				79855: function (e, t, n) {
					var r = n(94578),
						o = n(95892),
						i = n(7344),
						a = n(63036);
					e.exports = function (e, t, n, s) {
						s || (s = {});
						var l = s.enumerable,
							u = void 0 !== s.name ? s.name : t;
						if ((r(n) && i(n, u, s), s.global)) l ? (e[t] = n) : a(t, n);
						else {
							try {
								s.unsafe ? e[t] && (l = !0) : delete e[t];
							} catch (e) {}
							l
								? (e[t] = n)
								: o.f(e, t, { value: n, enumerable: !1, configurable: !s.nonConfigurable, writable: !s.nonWritable });
						}
						return e;
					};
				},
				85994: function (e, t, n) {
					var r = n(79855);
					e.exports = function (e, t, n) {
						for (var o in t) r(e, o, t[o], n);
						return e;
					};
				},
				63036: function (e, t, n) {
					var r = n(32010),
						o = Object.defineProperty;
					e.exports = function (e, t) {
						try {
							o(r, e, { value: t, configurable: !0, writable: !0 });
						} catch (n) {
							r[e] = t;
						}
						return t;
					};
				},
				10303: function (e, t, n) {
					'use strict';
					var r = n(68664),
						o = TypeError;
					e.exports = function (e, t) {
						if (!delete e[t]) throw o('Cannot delete property ' + r(t) + ' of ' + r(e));
					};
				},
				15567: function (e, t, n) {
					var r = n(47044);
					e.exports = !r(function () {
						return (
							7 !=
							Object.defineProperty({}, 1, {
								get: function () {
									return 7;
								},
							})[1]
						);
					});
				},
				5410: function (e) {
					var t = 'object' == typeof document && document.all,
						n = void 0 === t && void 0 !== t;
					e.exports = { all: t, IS_HTMLDDA: n };
				},
				12072: function (e, t, n) {
					var r = n(32010),
						o = n(24517),
						i = r.document,
						a = o(i) && o(i.createElement);
					e.exports = function (e) {
						return a ? i.createElement(e) : {};
					};
				},
				23327: function (e) {
					e.exports = {
						CSSRuleList: 0,
						CSSStyleDeclaration: 0,
						CSSValueList: 0,
						ClientRectList: 0,
						DOMRectList: 0,
						DOMStringList: 0,
						DOMTokenList: 1,
						DataTransferItemList: 0,
						FileList: 0,
						HTMLAllCollection: 0,
						HTMLCollection: 0,
						HTMLFormElement: 0,
						HTMLSelectElement: 0,
						MediaList: 0,
						MimeTypeArray: 0,
						NamedNodeMap: 0,
						NodeList: 1,
						PaintRequestList: 0,
						Plugin: 0,
						PluginArray: 0,
						SVGLengthList: 0,
						SVGNumberList: 0,
						SVGPathSegList: 0,
						SVGPointList: 0,
						SVGStringList: 0,
						SVGTransformList: 0,
						SourceBufferList: 0,
						StyleSheetList: 0,
						TextTrackCueList: 0,
						TextTrackList: 0,
						TouchList: 0,
					};
				},
				67797: function (e, t, n) {
					var r = n(12072)('span').classList,
						o = r && r.constructor && r.constructor.prototype;
					e.exports = o === Object.prototype ? void 0 : o;
				},
				3809: function (e, t, n) {
					var r = n(40715).match(/firefox\/(\d+)/i);
					e.exports = !!r && +r[1];
				},
				3157: function (e, t, n) {
					var r = n(95953),
						o = n(95053);
					e.exports = !r && !o && 'object' == typeof window && 'object' == typeof document;
				},
				95953: function (e) {
					e.exports = 'object' == typeof Deno && Deno && 'object' == typeof Deno.version;
				},
				21983: function (e, t, n) {
					var r = n(40715);
					e.exports = /MSIE|Trident/.test(r);
				},
				70573: function (e, t, n) {
					var r = n(40715),
						o = n(32010);
					e.exports = /ipad|iphone|ipod/i.test(r) && void 0 !== o.Pebble;
				},
				17716: function (e, t, n) {
					var r = n(40715);
					e.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(r);
				},
				95053: function (e, t, n) {
					var r = n(93975),
						o = n(32010);
					e.exports = 'process' == r(o.process);
				},
				664: function (e, t, n) {
					var r = n(40715);
					e.exports = /web0s(?!.*chrome)/i.test(r);
				},
				40715: function (e, t, n) {
					var r = n(38486);
					e.exports = r('navigator', 'userAgent') || '';
				},
				70091: function (e, t, n) {
					var r,
						o,
						i = n(32010),
						a = n(40715),
						s = i.process,
						l = i.Deno,
						u = (s && s.versions) || (l && l.version),
						c = u && u.v8;
					c && (o = (r = c.split('.'))[0] > 0 && r[0] < 4 ? 1 : +(r[0] + r[1])),
						!o && a && (!(r = a.match(/Edge\/(\d+)/)) || r[1] >= 74) && (r = a.match(/Chrome\/(\d+)/)) && (o = +r[1]),
						(e.exports = o);
				},
				41731: function (e, t, n) {
					var r = n(40715).match(/AppleWebKit\/(\d+)\./);
					e.exports = !!r && +r[1];
				},
				40926: function (e, t, n) {
					var r = n(32010),
						o = n(38347);
					e.exports = function (e, t) {
						return o(r[e].prototype[t]);
					};
				},
				2416: function (e) {
					e.exports = [
						'constructor',
						'hasOwnProperty',
						'isPrototypeOf',
						'propertyIsEnumerable',
						'toLocaleString',
						'toString',
						'valueOf',
					];
				},
				52362: function (e, t, n) {
					var r = n(38347),
						o = Error,
						i = r(''.replace),
						a = String(o('zxcasd').stack),
						s = /\n\s*at [^:]*:[^\n]*/,
						l = s.test(a);
					e.exports = function (e, t) {
						if (l && 'string' == typeof e && !o.prepareStackTrace) for (; t--; ) e = i(e, s, '');
						return e;
					};
				},
				45144: function (e, t, n) {
					var r = n(47044),
						o = n(97841);
					e.exports = !r(function () {
						var e = Error('a');
						return !('stack' in e) || (Object.defineProperty(e, 'stack', o(1, 7)), 7 !== e.stack);
					});
				},
				56475: function (e, t, n) {
					var r = n(32010),
						o = n(72062).f,
						i = n(48914),
						a = n(79855),
						s = n(63036),
						l = n(2675),
						u = n(39599);
					e.exports = function (e, t) {
						var n,
							c,
							d,
							f,
							p,
							h = e.target,
							m = e.global,
							v = e.stat;
						if ((n = m ? r : v ? r[h] || s(h, {}) : (r[h] || {}).prototype))
							for (c in t) {
								if (
									((f = t[c]),
									(d = e.dontCallGetSet ? (p = o(n, c)) && p.value : n[c]),
									!u(m ? c : h + (v ? '.' : '#') + c, e.forced) && void 0 !== d)
								) {
									if (typeof f == typeof d) continue;
									l(f, d);
								}
								(e.sham || (d && d.sham)) && i(f, 'sham', !0), a(n, c, f, e);
							}
					};
				},
				47044: function (e) {
					e.exports = function (e) {
						try {
							return !!e();
						} catch (e) {
							return !0;
						}
					};
				},
				55481: function (e, t, n) {
					var r = n(47044);
					e.exports = !r(function () {
						return Object.isExtensible(Object.preventExtensions({}));
					});
				},
				58448: function (e, t, n) {
					var r = n(3081),
						o = Function.prototype,
						i = o.apply,
						a = o.call;
					e.exports =
						('object' == typeof Reflect && Reflect.apply) ||
						(r
							? a.bind(i)
							: function () {
									return a.apply(i, arguments);
							  });
				},
				25567: function (e, t, n) {
					var r = n(85233),
						o = n(32631),
						i = n(3081),
						a = r(r.bind);
					e.exports = function (e, t) {
						return (
							o(e),
							void 0 === t
								? e
								: i
								? a(e, t)
								: function () {
										return e.apply(t, arguments);
								  }
						);
					};
				},
				3081: function (e, t, n) {
					var r = n(47044);
					e.exports = !r(function () {
						var e = function () {}.bind();
						return 'function' != typeof e || e.hasOwnProperty('prototype');
					});
				},
				2834: function (e, t, n) {
					var r = n(3081),
						o = Function.prototype.call;
					e.exports = r
						? o.bind(o)
						: function () {
								return o.apply(o, arguments);
						  };
				},
				7081: function (e, t, n) {
					var r = n(15567),
						o = n(20340),
						i = Function.prototype,
						a = r && Object.getOwnPropertyDescriptor,
						s = o(i, 'name'),
						l = s && 'something' === function () {}.name,
						u = s && (!r || (r && a(i, 'name').configurable));
					e.exports = { EXISTS: s, PROPER: l, CONFIGURABLE: u };
				},
				85233: function (e, t, n) {
					var r = n(93975),
						o = n(38347);
					e.exports = function (e) {
						if ('Function' === r(e)) return o(e);
					};
				},
				38347: function (e, t, n) {
					var r = n(3081),
						o = Function.prototype,
						i = o.call,
						a = r && o.bind.bind(i, i);
					e.exports = r
						? a
						: function (e) {
								return function () {
									return i.apply(e, arguments);
								};
						  };
				},
				38486: function (e, t, n) {
					var r = n(32010),
						o = n(94578),
						i = function (e) {
							return o(e) ? e : void 0;
						};
					e.exports = function (e, t) {
						return arguments.length < 2 ? i(r[e]) : r[e] && r[e][t];
					};
				},
				13872: function (e, t, n) {
					var r = n(52564),
						o = n(51839),
						i = n(35576),
						a = n(15366),
						s = n(38688)('iterator');
					e.exports = function (e) {
						if (!i(e)) return o(e, s) || o(e, '@@iterator') || a[r(e)];
					};
				},
				15892: function (e, t, n) {
					var r = n(2834),
						o = n(32631),
						i = n(34984),
						a = n(68664),
						s = n(13872),
						l = TypeError;
					e.exports = function (e, t) {
						var n = arguments.length < 2 ? s(e) : t;
						if (o(n)) return i(r(n, e));
						throw l(a(e) + ' is not iterable');
					};
				},
				51839: function (e, t, n) {
					var r = n(32631),
						o = n(35576);
					e.exports = function (e, t) {
						var n = e[t];
						return o(n) ? void 0 : r(n);
					};
				},
				32010: function (e) {
					var t = function (e) {
						return e && e.Math == Math && e;
					};
					e.exports =
						t('object' == typeof globalThis && globalThis) ||
						t('object' == typeof window && window) ||
						t('object' == typeof self && self) ||
						t('object' == typeof global && global) ||
						(function () {
							return this;
						})() ||
						Function('return this')();
				},
				20340: function (e, t, n) {
					var r = n(38347),
						o = n(43162),
						i = r({}.hasOwnProperty);
					e.exports =
						Object.hasOwn ||
						function (e, t) {
							return i(o(e), t);
						};
				},
				90682: function (e) {
					e.exports = {};
				},
				61144: function (e, t, n) {
					var r = n(32010);
					e.exports = function (e, t) {
						var n = r.console;
						n && n.error && (1 == arguments.length ? n.error(e) : n.error(e, t));
					};
				},
				520: function (e, t, n) {
					var r = n(38486);
					e.exports = r('document', 'documentElement');
				},
				18904: function (e, t, n) {
					var r = n(15567),
						o = n(47044),
						i = n(12072);
					e.exports =
						!r &&
						!o(function () {
							return (
								7 !=
								Object.defineProperty(i('div'), 'a', {
									get: function () {
										return 7;
									},
								}).a
							);
						});
				},
				64397: function (e) {
					var t = Array,
						n = Math.abs,
						r = Math.pow,
						o = Math.floor,
						i = Math.log,
						a = Math.LN2;
					e.exports = {
						pack: function (e, s, l) {
							var u,
								c,
								d,
								f = t(l),
								p = 8 * l - s - 1,
								h = (1 << p) - 1,
								m = h >> 1,
								v = 23 === s ? r(2, -24) - r(2, -77) : 0,
								g = e < 0 || (0 === e && 1 / e < 0) ? 1 : 0,
								y = 0;
							for (
								(e = n(e)) != e || e === 1 / 0
									? ((c = e != e ? 1 : 0), (u = h))
									: ((u = o(i(e) / a)),
									  e * (d = r(2, -u)) < 1 && (u--, (d *= 2)),
									  (e += u + m >= 1 ? v / d : v * r(2, 1 - m)) * d >= 2 && (u++, (d /= 2)),
									  u + m >= h
											? ((c = 0), (u = h))
											: u + m >= 1
											? ((c = (e * d - 1) * r(2, s)), (u += m))
											: ((c = e * r(2, m - 1) * r(2, s)), (u = 0)));
								s >= 8;

							)
								(f[y++] = 255 & c), (c /= 256), (s -= 8);
							for (u = (u << s) | c, p += s; p > 0; ) (f[y++] = 255 & u), (u /= 256), (p -= 8);
							return (f[--y] |= 128 * g), f;
						},
						unpack: function (e, t) {
							var n,
								o = e.length,
								i = 8 * o - t - 1,
								a = (1 << i) - 1,
								s = a >> 1,
								l = i - 7,
								u = o - 1,
								c = e[u--],
								d = 127 & c;
							for (c >>= 7; l > 0; ) (d = 256 * d + e[u--]), (l -= 8);
							for (n = d & ((1 << -l) - 1), d >>= -l, l += t; l > 0; ) (n = 256 * n + e[u--]), (l -= 8);
							if (0 === d) d = 1 - s;
							else {
								if (d === a) return n ? NaN : c ? -1 / 0 : 1 / 0;
								(n += r(2, t)), (d -= s);
							}
							return (c ? -1 : 1) * n * r(2, d - t);
						},
					};
				},
				7514: function (e, t, n) {
					var r = n(38347),
						o = n(47044),
						i = n(93975),
						a = Object,
						s = r(''.split);
					e.exports = o(function () {
						return !a('z').propertyIsEnumerable(0);
					})
						? function (e) {
								return 'String' == i(e) ? s(e, '') : a(e);
						  }
						: a;
				},
				51868: function (e, t, n) {
					var r = n(94578),
						o = n(24517),
						i = n(3840);
					e.exports = function (e, t, n) {
						var a, s;
						return i && r((a = t.constructor)) && a !== n && o((s = a.prototype)) && s !== n.prototype && i(e, s), e;
					};
				},
				10447: function (e, t, n) {
					var r = n(38347),
						o = n(94578),
						i = n(55480),
						a = r(Function.toString);
					o(i.inspectSource) ||
						(i.inspectSource = function (e) {
							return a(e);
						}),
						(e.exports = i.inspectSource);
				},
				87811: function (e, t, n) {
					var r = n(24517),
						o = n(48914);
					e.exports = function (e, t) {
						r(t) && 'cause' in t && o(e, 'cause', t.cause);
					};
				},
				62148: function (e, t, n) {
					var r = n(56475),
						o = n(38347),
						i = n(90682),
						a = n(24517),
						s = n(20340),
						l = n(95892).f,
						u = n(6611),
						c = n(8807),
						d = n(31685),
						f = n(46859),
						p = n(55481),
						h = !1,
						m = f('meta'),
						v = 0,
						g = function (e) {
							l(e, m, { value: { objectID: 'O' + v++, weakData: {} } });
						},
						y = (e.exports = {
							enable: function () {
								(y.enable = function () {}), (h = !0);
								var e = u.f,
									t = o([].splice),
									n = {};
								(n[m] = 1),
									e(n).length &&
										((u.f = function (n) {
											for (var r = e(n), o = 0, i = r.length; o < i; o++)
												if (r[o] === m) {
													t(r, o, 1);
													break;
												}
											return r;
										}),
										r({ target: 'Object', stat: !0, forced: !0 }, { getOwnPropertyNames: c.f }));
							},
							fastKey: function (e, t) {
								if (!a(e)) return 'symbol' == typeof e ? e : ('string' == typeof e ? 'S' : 'P') + e;
								if (!s(e, m)) {
									if (!d(e)) return 'F';
									if (!t) return 'E';
									g(e);
								}
								return e[m].objectID;
							},
							getWeakData: function (e, t) {
								if (!s(e, m)) {
									if (!d(e)) return !0;
									if (!t) return !1;
									g(e);
								}
								return e[m].weakData;
							},
							onFreeze: function (e) {
								return p && h && d(e) && !s(e, m) && g(e), e;
							},
						});
					i[m] = !0;
				},
				70172: function (e, t, n) {
					var r,
						o,
						i,
						a = n(2591),
						s = n(32010),
						l = n(24517),
						u = n(48914),
						c = n(20340),
						d = n(55480),
						f = n(82194),
						p = n(90682),
						h = 'Object already initialized',
						m = s.TypeError,
						v = s.WeakMap;
					if (a || d.state) {
						var g = d.state || (d.state = new v());
						(g.get = g.get),
							(g.has = g.has),
							(g.set = g.set),
							(r = function (e, t) {
								if (g.has(e)) throw m(h);
								return (t.facade = e), g.set(e, t), t;
							}),
							(o = function (e) {
								return g.get(e) || {};
							}),
							(i = function (e) {
								return g.has(e);
							});
					} else {
						var y = f('state');
						(p[y] = !0),
							(r = function (e, t) {
								if (c(e, y)) throw m(h);
								return (t.facade = e), u(e, y, t), t;
							}),
							(o = function (e) {
								return c(e, y) ? e[y] : {};
							}),
							(i = function (e) {
								return c(e, y);
							});
					}
					e.exports = {
						set: r,
						get: o,
						has: i,
						enforce: function (e) {
							return i(e) ? o(e) : r(e, {});
						},
						getterFor: function (e) {
							return function (t) {
								var n;
								if (!l(t) || (n = o(t)).type !== e) throw m('Incompatible receiver, ' + e + ' required');
								return n;
							};
						},
					};
				},
				89564: function (e, t, n) {
					var r = n(38688),
						o = n(15366),
						i = r('iterator'),
						a = Array.prototype;
					e.exports = function (e) {
						return void 0 !== e && (o.Array === e || a[i] === e);
					};
				},
				59113: function (e, t, n) {
					var r = n(93975);
					e.exports =
						Array.isArray ||
						function (e) {
							return 'Array' == r(e);
						};
				},
				75542: function (e, t, n) {
					var r = n(52564),
						o = n(38347)(''.slice);
					e.exports = function (e) {
						return 'Big' === o(r(e), 0, 3);
					};
				},
				94578: function (e, t, n) {
					var r = n(5410),
						o = r.all;
					e.exports = r.IS_HTMLDDA
						? function (e) {
								return 'function' == typeof e || e === o;
						  }
						: function (e) {
								return 'function' == typeof e;
						  };
				},
				20884: function (e, t, n) {
					var r = n(38347),
						o = n(47044),
						i = n(94578),
						a = n(52564),
						s = n(38486),
						l = n(10447),
						u = function () {},
						c = [],
						d = s('Reflect', 'construct'),
						f = /^\s*(?:class|function)\b/,
						p = r(f.exec),
						h = !f.exec(u),
						m = function (e) {
							if (!i(e)) return !1;
							try {
								return d(u, c, e), !0;
							} catch (e) {
								return !1;
							}
						},
						v = function (e) {
							if (!i(e)) return !1;
							switch (a(e)) {
								case 'AsyncFunction':
								case 'GeneratorFunction':
								case 'AsyncGeneratorFunction':
									return !1;
							}
							try {
								return h || !!p(f, l(e));
							} catch (e) {
								return !0;
							}
						};
					(v.sham = !0),
						(e.exports =
							!d ||
							o(function () {
								var e;
								return (
									m(m.call) ||
									!m(Object) ||
									!m(function () {
										e = !0;
									}) ||
									e
								);
							})
								? v
								: m);
				},
				39599: function (e, t, n) {
					var r = n(47044),
						o = n(94578),
						i = /#|\.prototype\./,
						a = function (e, t) {
							var n = l[s(e)];
							return n == c || (n != u && (o(t) ? r(t) : !!t));
						},
						s = (a.normalize = function (e) {
							return String(e).replace(i, '.').toLowerCase();
						}),
						l = (a.data = {}),
						u = (a.NATIVE = 'N'),
						c = (a.POLYFILL = 'P');
					e.exports = a;
				},
				17506: function (e, t, n) {
					var r = n(24517),
						o = Math.floor;
					e.exports =
						Number.isInteger ||
						function (e) {
							return !r(e) && isFinite(e) && o(e) === e;
						};
				},
				35576: function (e) {
					e.exports = function (e) {
						return null == e;
					};
				},
				24517: function (e, t, n) {
					var r = n(94578),
						o = n(5410),
						i = o.all;
					e.exports = o.IS_HTMLDDA
						? function (e) {
								return 'object' == typeof e ? null !== e : r(e) || e === i;
						  }
						: function (e) {
								return 'object' == typeof e ? null !== e : r(e);
						  };
				},
				63432: function (e) {
					e.exports = !1;
				},
				28831: function (e, t, n) {
					var r = n(24517),
						o = n(93975),
						i = n(38688)('match');
					e.exports = function (e) {
						var t;
						return r(e) && (void 0 !== (t = e[i]) ? !!t : 'RegExp' == o(e));
					};
				},
				46290: function (e, t, n) {
					var r = n(38486),
						o = n(94578),
						i = n(70176),
						a = n(9567),
						s = Object;
					e.exports = a
						? function (e) {
								return 'symbol' == typeof e;
						  }
						: function (e) {
								var t = r('Symbol');
								return o(t) && i(t.prototype, s(e));
						  };
				},
				80383: function (e, t, n) {
					var r = n(25567),
						o = n(2834),
						i = n(34984),
						a = n(68664),
						s = n(89564),
						l = n(45495),
						u = n(70176),
						c = n(15892),
						d = n(13872),
						f = n(50194),
						p = TypeError,
						h = function (e, t) {
							(this.stopped = e), (this.result = t);
						},
						m = h.prototype;
					e.exports = function (e, t, n) {
						var v,
							g,
							y,
							b,
							_,
							w,
							O,
							k = n && n.that,
							x = !(!n || !n.AS_ENTRIES),
							E = !(!n || !n.IS_RECORD),
							T = !(!n || !n.IS_ITERATOR),
							S = !(!n || !n.INTERRUPTED),
							A = r(t, k),
							C = function (e) {
								return v && f(v, 'normal', e), new h(!0, e);
							},
							P = function (e) {
								return x ? (i(e), S ? A(e[0], e[1], C) : A(e[0], e[1])) : S ? A(e, C) : A(e);
							};
						if (E) v = e.iterator;
						else if (T) v = e;
						else {
							if (!(g = d(e))) throw p(a(e) + ' is not iterable');
							if (s(g)) {
								for (y = 0, b = l(e); b > y; y++) if ((_ = P(e[y])) && u(m, _)) return _;
								return new h(!1);
							}
							v = c(e, g);
						}
						for (w = E ? e.next : v.next; !(O = o(w, v)).done; ) {
							try {
								_ = P(O.value);
							} catch (e) {
								f(v, 'throw', e);
							}
							if ('object' == typeof _ && _ && u(m, _)) return _;
						}
						return new h(!1);
					};
				},
				50194: function (e, t, n) {
					var r = n(2834),
						o = n(34984),
						i = n(51839);
					e.exports = function (e, t, n) {
						var a, s;
						o(e);
						try {
							if (!(a = i(e, 'return'))) {
								if ('throw' === t) throw n;
								return n;
							}
							a = r(a, e);
						} catch (e) {
							(s = !0), (a = e);
						}
						if ('throw' === t) throw n;
						if (s) throw a;
						return o(a), n;
					};
				},
				83157: function (e, t, n) {
					'use strict';
					var r = n(5844).IteratorPrototype,
						o = n(10819),
						i = n(97841),
						a = n(15216),
						s = n(15366),
						l = function () {
							return this;
						};
					e.exports = function (e, t, n, u) {
						var c = t + ' Iterator';
						return (e.prototype = o(r, { next: i(+!u, n) })), a(e, c, !1, !0), (s[c] = l), e;
					};
				},
				11231: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(2834),
						i = n(63432),
						a = n(7081),
						s = n(94578),
						l = n(83157),
						u = n(69548),
						c = n(3840),
						d = n(15216),
						f = n(48914),
						p = n(79855),
						h = n(38688),
						m = n(15366),
						v = n(5844),
						g = a.PROPER,
						y = a.CONFIGURABLE,
						b = v.IteratorPrototype,
						_ = v.BUGGY_SAFARI_ITERATORS,
						w = h('iterator'),
						O = 'keys',
						k = 'values',
						x = 'entries',
						E = function () {
							return this;
						};
					e.exports = function (e, t, n, a, h, v, T) {
						l(n, t, a);
						var S,
							A,
							C,
							P = function (e) {
								if (e === h && j) return j;
								if (!_ && e in N) return N[e];
								switch (e) {
									case O:
									case k:
									case x:
										return function () {
											return new n(this, e);
										};
								}
								return function () {
									return new n(this);
								};
							},
							R = t + ' Iterator',
							I = !1,
							N = e.prototype,
							M = N[w] || N['@@iterator'] || (h && N[h]),
							j = (!_ && M) || P(h),
							D = ('Array' == t && N.entries) || M;
						if (
							(D &&
								(S = u(D.call(new e()))) !== Object.prototype &&
								S.next &&
								(i || u(S) === b || (c ? c(S, b) : s(S[w]) || p(S, w, E)), d(S, R, !0, !0), i && (m[R] = E)),
							g &&
								h == k &&
								M &&
								M.name !== k &&
								(!i && y
									? f(N, 'name', k)
									: ((I = !0),
									  (j = function () {
											return o(M, this);
									  }))),
							h)
						)
							if (((A = { values: P(k), keys: v ? j : P(O), entries: P(x) }), T))
								for (C in A) (_ || I || !(C in N)) && p(N, C, A[C]);
							else r({ target: t, proto: !0, forced: _ || I }, A);
						return (i && !T) || N[w] === j || p(N, w, j, { name: h }), (m[t] = j), A;
					};
				},
				5844: function (e, t, n) {
					'use strict';
					var r,
						o,
						i,
						a = n(47044),
						s = n(94578),
						l = n(24517),
						u = n(10819),
						c = n(69548),
						d = n(79855),
						f = n(38688),
						p = n(63432),
						h = f('iterator'),
						m = !1;
					[].keys && ('next' in (i = [].keys()) ? (o = c(c(i))) !== Object.prototype && (r = o) : (m = !0)),
						!l(r) ||
						a(function () {
							var e = {};
							return r[h].call(e) !== e;
						})
							? (r = {})
							: p && (r = u(r)),
						s(r[h]) ||
							d(r, h, function () {
								return this;
							}),
						(e.exports = { IteratorPrototype: r, BUGGY_SAFARI_ITERATORS: m });
				},
				15366: function (e) {
					e.exports = {};
				},
				45495: function (e, t, n) {
					var r = n(23417);
					e.exports = function (e) {
						return r(e.length);
					};
				},
				7344: function (e, t, n) {
					var r = n(47044),
						o = n(94578),
						i = n(20340),
						a = n(15567),
						s = n(7081).CONFIGURABLE,
						l = n(10447),
						u = n(70172),
						c = u.enforce,
						d = u.get,
						f = Object.defineProperty,
						p =
							a &&
							!r(function () {
								return 8 !== f(function () {}, 'length', { value: 8 }).length;
							}),
						h = String(String).split('String'),
						m = (e.exports = function (e, t, n) {
							'Symbol(' === String(t).slice(0, 7) && (t = '[' + String(t).replace(/^Symbol\(([^)]*)\)/, '$1') + ']'),
								n && n.getter && (t = 'get ' + t),
								n && n.setter && (t = 'set ' + t),
								(!i(e, 'name') || (s && e.name !== t)) &&
									(a ? f(e, 'name', { value: t, configurable: !0 }) : (e.name = t)),
								p && n && i(n, 'arity') && e.length !== n.arity && f(e, 'length', { value: n.arity });
							try {
								n && i(n, 'constructor') && n.constructor
									? a && f(e, 'prototype', { writable: !1 })
									: e.prototype && (e.prototype = void 0);
							} catch (e) {}
							var r = c(e);
							return i(r, 'source') || (r.source = h.join('string' == typeof t ? t : '')), e;
						});
					Function.prototype.toString = m(function () {
						return (o(this) && d(this).source) || l(this);
					}, 'toString');
				},
				52384: function (e) {
					var t = Math.ceil,
						n = Math.floor;
					e.exports =
						Math.trunc ||
						function (e) {
							var r = +e;
							return (r > 0 ? n : t)(r);
						};
				},
				59804: function (e, t, n) {
					var r,
						o,
						i,
						a,
						s,
						l,
						u,
						c,
						d = n(32010),
						f = n(25567),
						p = n(72062).f,
						h = n(6616).set,
						m = n(17716),
						v = n(70573),
						g = n(664),
						y = n(95053),
						b = d.MutationObserver || d.WebKitMutationObserver,
						_ = d.document,
						w = d.process,
						O = d.Promise,
						k = p(d, 'queueMicrotask'),
						x = k && k.value;
					x ||
						((r = function () {
							var e, t;
							for (y && (e = w.domain) && e.exit(); o; ) {
								(t = o.fn), (o = o.next);
								try {
									t();
								} catch (e) {
									throw (o ? a() : (i = void 0), e);
								}
							}
							(i = void 0), e && e.enter();
						}),
						m || y || g || !b || !_
							? !v && O && O.resolve
								? (((u = O.resolve(void 0)).constructor = O),
								  (c = f(u.then, u)),
								  (a = function () {
										c(r);
								  }))
								: y
								? (a = function () {
										w.nextTick(r);
								  })
								: ((h = f(h, d)),
								  (a = function () {
										h(r);
								  }))
							: ((s = !0),
							  (l = _.createTextNode('')),
							  new b(r).observe(l, { characterData: !0 }),
							  (a = function () {
									l.data = s = !s;
							  }))),
						(e.exports =
							x ||
							function (e) {
								var t = { fn: e, next: void 0 };
								i && (i.next = t), o || ((o = t), a()), (i = t);
							});
				},
				56614: function (e, t, n) {
					'use strict';
					var r = n(32631),
						o = TypeError,
						i = function (e) {
							var t, n;
							(this.promise = new e(function (e, r) {
								if (void 0 !== t || void 0 !== n) throw o('Bad Promise constructor');
								(t = e), (n = r);
							})),
								(this.resolve = r(t)),
								(this.reject = r(n));
						};
					e.exports.f = function (e) {
						return new i(e);
					};
				},
				86392: function (e, t, n) {
					var r = n(25096);
					e.exports = function (e, t) {
						return void 0 === e ? (arguments.length < 2 ? '' : t) : r(e);
					};
				},
				93666: function (e, t, n) {
					var r = n(28831),
						o = TypeError;
					e.exports = function (e) {
						if (r(e)) throw o("The method doesn't accept regular expressions");
						return e;
					};
				},
				87146: function (e, t, n) {
					'use strict';
					var r = n(15567),
						o = n(38347),
						i = n(2834),
						a = n(47044),
						s = n(84675),
						l = n(61146),
						u = n(55574),
						c = n(43162),
						d = n(7514),
						f = Object.assign,
						p = Object.defineProperty,
						h = o([].concat);
					e.exports =
						!f ||
						a(function () {
							if (
								r &&
								1 !==
									f(
										{ b: 1 },
										f(
											p({}, 'a', {
												enumerable: !0,
												get: function () {
													p(this, 'b', { value: 3, enumerable: !1 });
												},
											}),
											{ b: 2 }
										)
									).b
							)
								return !0;
							var e = {},
								t = {},
								n = Symbol(),
								o = 'abcdefghijklmnopqrst';
							return (
								(e[n] = 7),
								o.split('').forEach(function (e) {
									t[e] = e;
								}),
								7 != f({}, e)[n] || s(f({}, t)).join('') != o
							);
						})
							? function (e, t) {
									for (var n = c(e), o = arguments.length, a = 1, f = l.f, p = u.f; o > a; )
										for (var m, v = d(arguments[a++]), g = f ? h(s(v), f(v)) : s(v), y = g.length, b = 0; y > b; )
											(m = g[b++]), (r && !i(p, v, m)) || (n[m] = v[m]);
									return n;
							  }
							: f;
				},
				10819: function (e, t, n) {
					var r,
						o = n(34984),
						i = n(10196),
						a = n(2416),
						s = n(90682),
						l = n(520),
						u = n(12072),
						c = n(82194),
						d = c('IE_PROTO'),
						f = function () {},
						p = function (e) {
							return '<script>' + e + '</' + 'script>';
						},
						h = function (e) {
							e.write(p('')), e.close();
							var t = e.parentWindow.Object;
							return (e = null), t;
						},
						m = function () {
							try {
								r = new ActiveXObject('htmlfile');
							} catch (e) {}
							var e, t;
							m =
								'undefined' != typeof document
									? document.domain && r
										? h(r)
										: (((t = u('iframe')).style.display = 'none'),
										  l.appendChild(t),
										  (t.src = String('javascript:')),
										  (e = t.contentWindow.document).open(),
										  e.write(p('document.F=Object')),
										  e.close(),
										  e.F)
									: h(r);
							for (var n = a.length; n--; ) delete m.prototype[a[n]];
							return m();
						};
					(s[d] = !0),
						(e.exports =
							Object.create ||
							function (e, t) {
								var n;
								return (
									null !== e ? ((f.prototype = o(e)), (n = new f()), (f.prototype = null), (n[d] = e)) : (n = m()),
									void 0 === t ? n : i.f(n, t)
								);
							});
				},
				10196: function (e, t, n) {
					var r = n(15567),
						o = n(59757),
						i = n(95892),
						a = n(34984),
						s = n(98086),
						l = n(84675);
					t.f =
						r && !o
							? Object.defineProperties
							: function (e, t) {
									a(e);
									for (var n, r = s(t), o = l(t), u = o.length, c = 0; u > c; ) i.f(e, (n = o[c++]), r[n]);
									return e;
							  };
				},
				95892: function (e, t, n) {
					var r = n(15567),
						o = n(18904),
						i = n(59757),
						a = n(34984),
						s = n(63918),
						l = TypeError,
						u = Object.defineProperty,
						c = Object.getOwnPropertyDescriptor,
						d = 'enumerable',
						f = 'configurable',
						p = 'writable';
					t.f = r
						? i
							? function (e, t, n) {
									if (
										(a(e),
										(t = s(t)),
										a(n),
										'function' == typeof e && 'prototype' === t && 'value' in n && p in n && !n.writable)
									) {
										var r = c(e, t);
										r &&
											r.writable &&
											((e[t] = n.value),
											(n = {
												configurable: f in n ? n.configurable : r.configurable,
												enumerable: d in n ? n.enumerable : r.enumerable,
												writable: !1,
											}));
									}
									return u(e, t, n);
							  }
							: u
						: function (e, t, n) {
								if ((a(e), (t = s(t)), a(n), o))
									try {
										return u(e, t, n);
									} catch (e) {}
								if ('get' in n || 'set' in n) throw l('Accessors not supported');
								return 'value' in n && (e[t] = n.value), e;
						  };
				},
				72062: function (e, t, n) {
					var r = n(15567),
						o = n(2834),
						i = n(55574),
						a = n(97841),
						s = n(98086),
						l = n(63918),
						u = n(20340),
						c = n(18904),
						d = Object.getOwnPropertyDescriptor;
					t.f = r
						? d
						: function (e, t) {
								if (((e = s(e)), (t = l(t)), c))
									try {
										return d(e, t);
									} catch (e) {}
								if (u(e, t)) return a(!o(i.f, e, t), e[t]);
						  };
				},
				8807: function (e, t, n) {
					var r = n(93975),
						o = n(98086),
						i = n(6611).f,
						a = n(45258),
						s =
							'object' == typeof window && window && Object.getOwnPropertyNames
								? Object.getOwnPropertyNames(window)
								: [];
					e.exports.f = function (e) {
						return s && 'Window' == r(e)
							? (function (e) {
									try {
										return i(e);
									} catch (e) {
										return a(s);
									}
							  })(e)
							: i(o(e));
					};
				},
				6611: function (e, t, n) {
					var r = n(64429),
						o = n(2416).concat('length', 'prototype');
					t.f =
						Object.getOwnPropertyNames ||
						function (e) {
							return r(e, o);
						};
				},
				61146: function (e, t) {
					t.f = Object.getOwnPropertySymbols;
				},
				69548: function (e, t, n) {
					var r = n(20340),
						o = n(94578),
						i = n(43162),
						a = n(82194),
						s = n(68494),
						l = a('IE_PROTO'),
						u = Object,
						c = u.prototype;
					e.exports = s
						? u.getPrototypeOf
						: function (e) {
								var t = i(e);
								if (r(t, l)) return t[l];
								var n = t.constructor;
								return o(n) && t instanceof n ? n.prototype : t instanceof u ? c : null;
						  };
				},
				31685: function (e, t, n) {
					var r = n(47044),
						o = n(24517),
						i = n(93975),
						a = n(60687),
						s = Object.isExtensible,
						l = r(function () {
							s(1);
						});
					e.exports =
						l || a
							? function (e) {
									return !!o(e) && (!a || 'ArrayBuffer' != i(e)) && (!s || s(e));
							  }
							: s;
				},
				70176: function (e, t, n) {
					var r = n(38347);
					e.exports = r({}.isPrototypeOf);
				},
				98125: function (e, t, n) {
					'use strict';
					var r = n(70172),
						o = n(83157),
						i = n(19110),
						a = n(20340),
						s = n(84675),
						l = n(43162),
						u = 'Object Iterator',
						c = r.set,
						d = r.getterFor(u);
					e.exports = o(
						function (e, t) {
							var n = l(e);
							c(this, { type: u, mode: t, object: n, keys: s(n), index: 0 });
						},
						'Object',
						function () {
							for (var e = d(this), t = e.keys; ; ) {
								if (null === t || e.index >= t.length) return (e.object = e.keys = null), i(void 0, !0);
								var n = t[e.index++],
									r = e.object;
								if (a(r, n)) {
									switch (e.mode) {
										case 'keys':
											return i(n, !1);
										case 'values':
											return i(r[n], !1);
									}
									return i([n, r[n]], !1);
								}
							}
						}
					);
				},
				64429: function (e, t, n) {
					var r = n(38347),
						o = n(20340),
						i = n(98086),
						a = n(12636).indexOf,
						s = n(90682),
						l = r([].push);
					e.exports = function (e, t) {
						var n,
							r = i(e),
							u = 0,
							c = [];
						for (n in r) !o(s, n) && o(r, n) && l(c, n);
						for (; t.length > u; ) o(r, (n = t[u++])) && (~a(c, n) || l(c, n));
						return c;
					};
				},
				84675: function (e, t, n) {
					var r = n(64429),
						o = n(2416);
					e.exports =
						Object.keys ||
						function (e) {
							return r(e, o);
						};
				},
				55574: function (e, t) {
					'use strict';
					var n = {}.propertyIsEnumerable,
						r = Object.getOwnPropertyDescriptor,
						o = r && !n.call({ 1: 2 }, 1);
					t.f = o
						? function (e) {
								var t = r(this, e);
								return !!t && t.enumerable;
						  }
						: n;
				},
				3840: function (e, t, n) {
					var r = n(38347),
						o = n(34984),
						i = n(58659);
					e.exports =
						Object.setPrototypeOf ||
						('__proto__' in {}
							? (function () {
									var e,
										t = !1,
										n = {};
									try {
										(e = r(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set))(n, []),
											(t = n instanceof Array);
									} catch (e) {}
									return function (n, r) {
										return o(n), i(r), t ? e(n, r) : (n.__proto__ = r), n;
									};
							  })()
							: void 0);
				},
				80754: function (e, t, n) {
					var r = n(15567),
						o = n(38347),
						i = n(84675),
						a = n(98086),
						s = o(n(55574).f),
						l = o([].push),
						u = function (e) {
							return function (t) {
								for (var n, o = a(t), u = i(o), c = u.length, d = 0, f = []; c > d; )
									(n = u[d++]), (r && !s(o, n)) || l(f, e ? [n, o[n]] : o[n]);
								return f;
							};
						};
					e.exports = { entries: u(!0), values: u(!1) };
				},
				52598: function (e, t, n) {
					'use strict';
					var r = n(24663),
						o = n(52564);
					e.exports = r
						? {}.toString
						: function () {
								return '[object ' + o(this) + ']';
						  };
				},
				39629: function (e, t, n) {
					var r = n(2834),
						o = n(94578),
						i = n(24517),
						a = TypeError;
					e.exports = function (e, t) {
						var n, s;
						if ('string' === t && o((n = e.toString)) && !i((s = r(n, e)))) return s;
						if (o((n = e.valueOf)) && !i((s = r(n, e)))) return s;
						if ('string' !== t && o((n = e.toString)) && !i((s = r(n, e)))) return s;
						throw a("Can't convert object to primitive value");
					};
				},
				21594: function (e, t, n) {
					var r = n(38486),
						o = n(38347),
						i = n(6611),
						a = n(61146),
						s = n(34984),
						l = o([].concat);
					e.exports =
						r('Reflect', 'ownKeys') ||
						function (e) {
							var t = i.f(s(e)),
								n = a.f;
							return n ? l(t, n(e)) : t;
						};
				},
				11206: function (e, t, n) {
					var r = n(32010);
					e.exports = r;
				},
				61900: function (e) {
					e.exports = function (e) {
						try {
							return { error: !1, value: e() };
						} catch (e) {
							return { error: !0, value: e };
						}
					};
				},
				15911: function (e, t, n) {
					var r = n(32010),
						o = n(35695),
						i = n(94578),
						a = n(39599),
						s = n(10447),
						l = n(38688),
						u = n(3157),
						c = n(95953),
						d = n(63432),
						f = n(70091),
						p = o && o.prototype,
						h = l('species'),
						m = !1,
						v = i(r.PromiseRejectionEvent),
						g = a('Promise', function () {
							var e = s(o),
								t = e !== String(o);
							if (!t && 66 === f) return !0;
							if (d && (!p.catch || !p.finally)) return !0;
							if (!f || f < 51 || !/native code/.test(e)) {
								var n = new o(function (e) {
										e(1);
									}),
									r = function (e) {
										e(
											function () {},
											function () {}
										);
									};
								if ((((n.constructor = {})[h] = r), !(m = n.then(function () {}) instanceof r))) return !0;
							}
							return !t && (u || c) && !v;
						});
					e.exports = { CONSTRUCTOR: g, REJECTION_EVENT: v, SUBCLASSING: m };
				},
				35695: function (e, t, n) {
					var r = n(32010);
					e.exports = r.Promise;
				},
				28617: function (e, t, n) {
					var r = n(34984),
						o = n(24517),
						i = n(56614);
					e.exports = function (e, t) {
						if ((r(e), o(t) && t.constructor === e)) return t;
						var n = i.f(e);
						return (0, n.resolve)(t), n.promise;
					};
				},
				9706: function (e, t, n) {
					var r = n(35695),
						o = n(46769),
						i = n(15911).CONSTRUCTOR;
					e.exports =
						i ||
						!o(function (e) {
							r.all(e).then(void 0, function () {});
						});
				},
				74034: function (e) {
					var t = function () {
						(this.head = null), (this.tail = null);
					};
					(t.prototype = {
						add: function (e) {
							var t = { item: e, next: null };
							this.head ? (this.tail.next = t) : (this.head = t), (this.tail = t);
						},
						get: function () {
							var e = this.head;
							if (e) return (this.head = e.next), this.tail === e && (this.tail = null), e.item;
						},
					}),
						(e.exports = t);
				},
				83943: function (e, t, n) {
					var r = n(35576),
						o = TypeError;
					e.exports = function (e) {
						if (r(e)) throw o("Can't call method on " + e);
						return e;
					};
				},
				51334: function (e, t, n) {
					'use strict';
					var r = n(38486),
						o = n(95892),
						i = n(38688),
						a = n(15567),
						s = i('species');
					e.exports = function (e) {
						var t = r(e),
							n = o.f;
						a &&
							t &&
							!t[s] &&
							n(t, s, {
								configurable: !0,
								get: function () {
									return this;
								},
							});
					};
				},
				15216: function (e, t, n) {
					var r = n(95892).f,
						o = n(20340),
						i = n(38688)('toStringTag');
					e.exports = function (e, t, n) {
						e && !n && (e = e.prototype), e && !o(e, i) && r(e, i, { configurable: !0, value: t });
					};
				},
				82194: function (e, t, n) {
					var r = n(464),
						o = n(46859),
						i = r('keys');
					e.exports = function (e) {
						return i[e] || (i[e] = o(e));
					};
				},
				55480: function (e, t, n) {
					var r = n(32010),
						o = n(63036),
						i = '__core-js_shared__',
						a = r[i] || o(i, {});
					e.exports = a;
				},
				464: function (e, t, n) {
					var r = n(63432),
						o = n(55480);
					(e.exports = function (e, t) {
						return o[e] || (o[e] = void 0 !== t ? t : {});
					})('versions', []).push({
						version: '3.26.1',
						mode: r ? 'pure' : 'global',
						copyright: 'Â© 2014-2022 Denis Pushkarev (zloirock.ru)',
						license: 'https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE',
						source: 'https://github.com/zloirock/core-js',
					});
				},
				27754: function (e, t, n) {
					var r = n(34984),
						o = n(69075),
						i = n(35576),
						a = n(38688)('species');
					e.exports = function (e, t) {
						var n,
							s = r(e).constructor;
						return void 0 === s || i((n = r(s)[a])) ? t : o(n);
					};
				},
				69510: function (e, t, n) {
					var r = n(38347),
						o = n(26882),
						i = n(25096),
						a = n(83943),
						s = r(''.charAt),
						l = r(''.charCodeAt),
						u = r(''.slice),
						c = function (e) {
							return function (t, n) {
								var r,
									c,
									d = i(a(t)),
									f = o(n),
									p = d.length;
								return f < 0 || f >= p
									? e
										? ''
										: void 0
									: (r = l(d, f)) < 55296 || r > 56319 || f + 1 === p || (c = l(d, f + 1)) < 56320 || c > 57343
									? e
										? s(d, f)
										: r
									: e
									? u(d, f, f + 2)
									: c - 56320 + ((r - 55296) << 10) + 65536;
							};
						};
					e.exports = { codeAt: c(!1), charAt: c(!0) };
				},
				84588: function (e, t, n) {
					'use strict';
					var r = n(38347),
						o = 2147483647,
						i = /[^\0-\u007E]/,
						a = /[.\u3002\uFF0E\uFF61]/g,
						s = 'Overflow: input needs wider integers to process',
						l = RangeError,
						u = r(a.exec),
						c = Math.floor,
						d = String.fromCharCode,
						f = r(''.charCodeAt),
						p = r([].join),
						h = r([].push),
						m = r(''.replace),
						v = r(''.split),
						g = r(''.toLowerCase),
						y = function (e) {
							return e + 22 + 75 * (e < 26);
						},
						b = function (e, t, n) {
							var r = 0;
							for (e = n ? c(e / 700) : e >> 1, e += c(e / t); e > 455; ) (e = c(e / 35)), (r += 36);
							return c(r + (36 * e) / (e + 38));
						},
						_ = function (e) {
							var t = [];
							e = (function (e) {
								for (var t = [], n = 0, r = e.length; n < r; ) {
									var o = f(e, n++);
									if (o >= 55296 && o <= 56319 && n < r) {
										var i = f(e, n++);
										56320 == (64512 & i) ? h(t, ((1023 & o) << 10) + (1023 & i) + 65536) : (h(t, o), n--);
									} else h(t, o);
								}
								return t;
							})(e);
							var n,
								r,
								i = e.length,
								a = 128,
								u = 0,
								m = 72;
							for (n = 0; n < e.length; n++) (r = e[n]) < 128 && h(t, d(r));
							var v = t.length,
								g = v;
							for (v && h(t, '-'); g < i; ) {
								var _ = o;
								for (n = 0; n < e.length; n++) (r = e[n]) >= a && r < _ && (_ = r);
								var w = g + 1;
								if (_ - a > c((o - u) / w)) throw l(s);
								for (u += (_ - a) * w, a = _, n = 0; n < e.length; n++) {
									if ((r = e[n]) < a && ++u > o) throw l(s);
									if (r == a) {
										for (var O = u, k = 36; ; ) {
											var x = k <= m ? 1 : k >= m + 26 ? 26 : k - m;
											if (O < x) break;
											var E = O - x,
												T = 36 - x;
											h(t, d(y(x + (E % T)))), (O = c(E / T)), (k += 36);
										}
										h(t, d(y(O))), (m = b(u, w, g == v)), (u = 0), g++;
									}
								}
								u++, a++;
							}
							return p(t, '');
						};
					e.exports = function (e) {
						var t,
							n,
							r = [],
							o = v(m(g(e), a, '.'), '.');
						for (t = 0; t < o.length; t++) (n = o[t]), h(r, u(i, n) ? 'xn--' + _(n) : n);
						return p(r, '.');
					};
				},
				8302: function (e, t, n) {
					var r = n(70091),
						o = n(47044);
					e.exports =
						!!Object.getOwnPropertySymbols &&
						!o(function () {
							var e = Symbol();
							return !String(e) || !(Object(e) instanceof Symbol) || (!Symbol.sham && r && r < 41);
						});
				},
				6616: function (e, t, n) {
					var r,
						o,
						i,
						a,
						s = n(32010),
						l = n(58448),
						u = n(25567),
						c = n(94578),
						d = n(20340),
						f = n(47044),
						p = n(520),
						h = n(73163),
						m = n(12072),
						v = n(25051),
						g = n(17716),
						y = n(95053),
						b = s.setImmediate,
						_ = s.clearImmediate,
						w = s.process,
						O = s.Dispatch,
						k = s.Function,
						x = s.MessageChannel,
						E = s.String,
						T = 0,
						S = {},
						A = 'onreadystatechange';
					try {
						r = s.location;
					} catch (e) {}
					var C = function (e) {
							if (d(S, e)) {
								var t = S[e];
								delete S[e], t();
							}
						},
						P = function (e) {
							return function () {
								C(e);
							};
						},
						R = function (e) {
							C(e.data);
						},
						I = function (e) {
							s.postMessage(E(e), r.protocol + '//' + r.host);
						};
					(b && _) ||
						((b = function (e) {
							v(arguments.length, 1);
							var t = c(e) ? e : k(e),
								n = h(arguments, 1);
							return (
								(S[++T] = function () {
									l(t, void 0, n);
								}),
								o(T),
								T
							);
						}),
						(_ = function (e) {
							delete S[e];
						}),
						y
							? (o = function (e) {
									w.nextTick(P(e));
							  })
							: O && O.now
							? (o = function (e) {
									O.now(P(e));
							  })
							: x && !g
							? ((a = (i = new x()).port2), (i.port1.onmessage = R), (o = u(a.postMessage, a)))
							: s.addEventListener && c(s.postMessage) && !s.importScripts && r && 'file:' !== r.protocol && !f(I)
							? ((o = I), s.addEventListener('message', R, !1))
							: (o =
									A in m('script')
										? function (e) {
												p.appendChild(m('script')).onreadystatechange = function () {
													p.removeChild(this), C(e);
												};
										  }
										: function (e) {
												setTimeout(P(e), 0);
										  })),
						(e.exports = { set: b, clear: _ });
				},
				74841: function (e, t, n) {
					var r = n(26882),
						o = Math.max,
						i = Math.min;
					e.exports = function (e, t) {
						var n = r(e);
						return n < 0 ? o(n + t, 0) : i(n, t);
					};
				},
				7683: function (e, t, n) {
					var r = n(2644),
						o = TypeError;
					e.exports = function (e) {
						var t = r(e, 'number');
						if ('number' == typeof t) throw o("Can't convert number to bigint");
						return BigInt(t);
					};
				},
				71265: function (e, t, n) {
					var r = n(26882),
						o = n(23417),
						i = RangeError;
					e.exports = function (e) {
						if (void 0 === e) return 0;
						var t = r(e),
							n = o(t);
						if (t !== n) throw i('Wrong length or index');
						return n;
					};
				},
				98086: function (e, t, n) {
					var r = n(7514),
						o = n(83943);
					e.exports = function (e) {
						return r(o(e));
					};
				},
				26882: function (e, t, n) {
					var r = n(52384);
					e.exports = function (e) {
						var t = +e;
						return t != t || 0 === t ? 0 : r(t);
					};
				},
				23417: function (e, t, n) {
					var r = n(26882),
						o = Math.min;
					e.exports = function (e) {
						return e > 0 ? o(r(e), 9007199254740991) : 0;
					};
				},
				43162: function (e, t, n) {
					var r = n(83943),
						o = Object;
					e.exports = function (e) {
						return o(r(e));
					};
				},
				80670: function (e, t, n) {
					var r = n(64913),
						o = RangeError;
					e.exports = function (e, t) {
						var n = r(e);
						if (n % t) throw o('Wrong offset');
						return n;
					};
				},
				64913: function (e, t, n) {
					var r = n(26882),
						o = RangeError;
					e.exports = function (e) {
						var t = r(e);
						if (t < 0) throw o("The argument can't be less than 0");
						return t;
					};
				},
				2644: function (e, t, n) {
					var r = n(2834),
						o = n(24517),
						i = n(46290),
						a = n(51839),
						s = n(39629),
						l = n(38688),
						u = TypeError,
						c = l('toPrimitive');
					e.exports = function (e, t) {
						if (!o(e) || i(e)) return e;
						var n,
							l = a(e, c);
						if (l) {
							if ((void 0 === t && (t = 'default'), (n = r(l, e, t)), !o(n) || i(n))) return n;
							throw u("Can't convert object to primitive value");
						}
						return void 0 === t && (t = 'number'), s(e, t);
					};
				},
				63918: function (e, t, n) {
					var r = n(2644),
						o = n(46290);
					e.exports = function (e) {
						var t = r(e, 'string');
						return o(t) ? t : t + '';
					};
				},
				24663: function (e, t, n) {
					var r = {};
					(r[n(38688)('toStringTag')] = 'z'), (e.exports = '[object z]' === String(r));
				},
				25096: function (e, t, n) {
					var r = n(52564),
						o = String;
					e.exports = function (e) {
						if ('Symbol' === r(e)) throw TypeError('Cannot convert a Symbol value to a string');
						return o(e);
					};
				},
				68664: function (e) {
					var t = String;
					e.exports = function (e) {
						try {
							return t(e);
						} catch (e) {
							return 'Object';
						}
					};
				},
				98828: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(32010),
						i = n(2834),
						a = n(15567),
						s = n(28834),
						l = n(95089),
						u = n(69351),
						c = n(2868),
						d = n(97841),
						f = n(48914),
						p = n(17506),
						h = n(23417),
						m = n(71265),
						v = n(80670),
						g = n(63918),
						y = n(20340),
						b = n(52564),
						_ = n(24517),
						w = n(46290),
						O = n(10819),
						k = n(70176),
						x = n(3840),
						E = n(6611).f,
						T = n(83590),
						S = n(91102).forEach,
						A = n(51334),
						C = n(95892),
						P = n(72062),
						R = n(70172),
						I = n(51868),
						N = R.get,
						M = R.set,
						j = R.enforce,
						D = C.f,
						L = P.f,
						U = Math.round,
						F = o.RangeError,
						B = u.ArrayBuffer,
						V = B.prototype,
						Z = u.DataView,
						H = l.NATIVE_ARRAY_BUFFER_VIEWS,
						q = l.TYPED_ARRAY_TAG,
						W = l.TypedArray,
						K = l.TypedArrayPrototype,
						$ = l.aTypedArrayConstructor,
						z = l.isTypedArray,
						G = 'BYTES_PER_ELEMENT',
						Y = 'Wrong length',
						J = function (e, t) {
							$(e);
							for (var n = 0, r = t.length, o = new e(r); r > n; ) o[n] = t[n++];
							return o;
						},
						Q = function (e, t) {
							D(e, t, {
								get: function () {
									return N(this)[t];
								},
							});
						},
						X = function (e) {
							var t;
							return k(V, e) || 'ArrayBuffer' == (t = b(e)) || 'SharedArrayBuffer' == t;
						},
						ee = function (e, t) {
							return z(e) && !w(t) && t in e && p(+t) && t >= 0;
						},
						te = function (e, t) {
							return (t = g(t)), ee(e, t) ? d(2, e[t]) : L(e, t);
						},
						ne = function (e, t, n) {
							return (
								(t = g(t)),
								!(ee(e, t) && _(n) && y(n, 'value')) ||
								y(n, 'get') ||
								y(n, 'set') ||
								n.configurable ||
								(y(n, 'writable') && !n.writable) ||
								(y(n, 'enumerable') && !n.enumerable)
									? D(e, t, n)
									: ((e[t] = n.value), e)
							);
						};
					a
						? (H || ((P.f = te), (C.f = ne), Q(K, 'buffer'), Q(K, 'byteOffset'), Q(K, 'byteLength'), Q(K, 'length')),
						  r({ target: 'Object', stat: !0, forced: !H }, { getOwnPropertyDescriptor: te, defineProperty: ne }),
						  (e.exports = function (e, t, n) {
								var a = e.match(/\d+$/)[0] / 8,
									l = e + (n ? 'Clamped' : '') + 'Array',
									u = 'get' + e,
									d = 'set' + e,
									p = o[l],
									g = p,
									y = g && g.prototype,
									b = {},
									w = function (e, t) {
										D(e, t, {
											get: function () {
												return (function (e, t) {
													var n = N(e);
													return n.view[u](t * a + n.byteOffset, !0);
												})(this, t);
											},
											set: function (e) {
												return (function (e, t, r) {
													var o = N(e);
													n && (r = (r = U(r)) < 0 ? 0 : r > 255 ? 255 : 255 & r),
														o.view[d](t * a + o.byteOffset, r, !0);
												})(this, t, e);
											},
											enumerable: !0,
										});
									};
								H
									? s &&
									  ((g = t(function (e, t, n, r) {
											return (
												c(e, y),
												I(
													_(t)
														? X(t)
															? void 0 !== r
																? new p(t, v(n, a), r)
																: void 0 !== n
																? new p(t, v(n, a))
																: new p(t)
															: z(t)
															? J(g, t)
															: i(T, g, t)
														: new p(m(t)),
													e,
													g
												)
											);
									  })),
									  x && x(g, W),
									  S(E(p), function (e) {
											e in g || f(g, e, p[e]);
									  }),
									  (g.prototype = y))
									: ((g = t(function (e, t, n, r) {
											c(e, y);
											var o,
												s,
												l,
												u = 0,
												d = 0;
											if (_(t)) {
												if (!X(t)) return z(t) ? J(g, t) : i(T, g, t);
												(o = t), (d = v(n, a));
												var f = t.byteLength;
												if (void 0 === r) {
													if (f % a) throw F(Y);
													if ((s = f - d) < 0) throw F(Y);
												} else if ((s = h(r) * a) + d > f) throw F(Y);
												l = s / a;
											} else (l = m(t)), (o = new B((s = l * a)));
											for (M(e, { buffer: o, byteOffset: d, byteLength: s, length: l, view: new Z(o) }); u < l; )
												w(e, u++);
									  })),
									  x && x(g, W),
									  (y = g.prototype = O(K))),
									y.constructor !== g && f(y, 'constructor', g),
									(j(y).TypedArrayConstructor = g),
									q && f(y, q, l);
								var k = g != p;
								(b[l] = g),
									r({ global: !0, constructor: !0, forced: k, sham: !H }, b),
									G in g || f(g, G, a),
									G in y || f(y, G, a),
									A(l);
						  }))
						: (e.exports = function () {});
				},
				28834: function (e, t, n) {
					var r = n(32010),
						o = n(47044),
						i = n(46769),
						a = n(95089).NATIVE_ARRAY_BUFFER_VIEWS,
						s = r.ArrayBuffer,
						l = r.Int8Array;
					e.exports =
						!a ||
						!o(function () {
							l(1);
						}) ||
						!o(function () {
							new l(-1);
						}) ||
						!i(function (e) {
							new l(), new l(null), new l(1.5), new l(e);
						}, !0) ||
						o(function () {
							return 1 !== new l(new s(2), 1, void 0).length;
						});
				},
				59610: function (e, t, n) {
					var r = n(34269),
						o = n(34815);
					e.exports = function (e, t) {
						return r(o(e), t);
					};
				},
				83590: function (e, t, n) {
					var r = n(25567),
						o = n(2834),
						i = n(69075),
						a = n(43162),
						s = n(45495),
						l = n(15892),
						u = n(13872),
						c = n(89564),
						d = n(75542),
						f = n(95089).aTypedArrayConstructor,
						p = n(7683);
					e.exports = function (e) {
						var t,
							n,
							h,
							m,
							v,
							g,
							y,
							b,
							_ = i(this),
							w = a(e),
							O = arguments.length,
							k = O > 1 ? arguments[1] : void 0,
							x = void 0 !== k,
							E = u(w);
						if (E && !c(E)) for (b = (y = l(w, E)).next, w = []; !(g = o(b, y)).done; ) w.push(g.value);
						for (x && O > 2 && (k = r(k, arguments[2])), n = s(w), h = new (f(_))(n), m = d(h), t = 0; n > t; t++)
							(v = x ? k(w[t], t) : w[t]), (h[t] = m ? p(v) : +v);
						return h;
					};
				},
				34815: function (e, t, n) {
					var r = n(95089),
						o = n(27754),
						i = r.aTypedArrayConstructor,
						a = r.getTypedArrayConstructor;
					e.exports = function (e) {
						return i(o(e, a(e)));
					};
				},
				46859: function (e, t, n) {
					var r = n(38347),
						o = 0,
						i = Math.random(),
						a = r((1).toString);
					e.exports = function (e) {
						return 'Symbol(' + (void 0 === e ? '' : e) + ')_' + a(++o + i, 36);
					};
				},
				36559: function (e, t, n) {
					var r = n(47044),
						o = n(38688),
						i = n(63432),
						a = o('iterator');
					e.exports = !r(function () {
						var e = new URL('b?a=1&b=2&c=3', 'http://a'),
							t = e.searchParams,
							n = '';
						return (
							(e.pathname = 'c%20d'),
							t.forEach(function (e, r) {
								t.delete('b'), (n += r + e);
							}),
							(i && !e.toJSON) ||
								!t.sort ||
								'http://a/c%20d?a=1&c=3' !== e.href ||
								'3' !== t.get('c') ||
								'a=1' !== String(new URLSearchParams('?a=1')) ||
								!t[a] ||
								'a' !== new URL('https://a@b').username ||
								'b' !== new URLSearchParams(new URLSearchParams('a=b')).get('a') ||
								'xn--e1aybc' !== new URL('http://Ñ‚ÐµÑÑ‚').host ||
								'#%D0%B1' !== new URL('http://a#Ð±').hash ||
								'a1c3' !== n ||
								'x' !== new URL('http://x', void 0).host
						);
					});
				},
				9567: function (e, t, n) {
					var r = n(8302);
					e.exports = r && !Symbol.sham && 'symbol' == typeof Symbol.iterator;
				},
				59757: function (e, t, n) {
					var r = n(15567),
						o = n(47044);
					e.exports =
						r &&
						o(function () {
							return 42 != Object.defineProperty(function () {}, 'prototype', { value: 42, writable: !1 }).prototype;
						});
				},
				25051: function (e) {
					var t = TypeError;
					e.exports = function (e, n) {
						if (e < n) throw t('Not enough arguments');
						return e;
					};
				},
				2591: function (e, t, n) {
					var r = n(32010),
						o = n(94578),
						i = r.WeakMap;
					e.exports = o(i) && /native code/.test(String(i));
				},
				28966: function (e, t, n) {
					var r = n(11206),
						o = n(20340),
						i = n(75960),
						a = n(95892).f;
					e.exports = function (e) {
						var t = r.Symbol || (r.Symbol = {});
						o(t, e) || a(t, e, { value: i.f(e) });
					};
				},
				75960: function (e, t, n) {
					var r = n(38688);
					t.f = r;
				},
				38688: function (e, t, n) {
					var r = n(32010),
						o = n(464),
						i = n(20340),
						a = n(46859),
						s = n(8302),
						l = n(9567),
						u = o('wks'),
						c = r.Symbol,
						d = c && c.for,
						f = l ? c : (c && c.withoutSetter) || a;
					e.exports = function (e) {
						if (!i(u, e) || (!s && 'string' != typeof u[e])) {
							var t = 'Symbol.' + e;
							s && i(c, e) ? (u[e] = c[e]) : (u[e] = l && d ? d(t) : f(t));
						}
						return u[e];
					};
				},
				62664: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(70176),
						i = n(69548),
						a = n(3840),
						s = n(2675),
						l = n(10819),
						u = n(48914),
						c = n(97841),
						d = n(52362),
						f = n(87811),
						p = n(80383),
						h = n(86392),
						m = n(38688),
						v = n(45144),
						g = m('toStringTag'),
						y = Error,
						b = [].push,
						_ = function (e, t) {
							var n,
								r = arguments.length > 2 ? arguments[2] : void 0,
								s = o(w, this);
							a ? (n = a(y(), s ? i(this) : w)) : ((n = s ? this : l(w)), u(n, g, 'Error')),
								void 0 !== t && u(n, 'message', h(t)),
								v && u(n, 'stack', d(n.stack, 1)),
								f(n, r);
							var c = [];
							return p(e, b, { that: c }), u(n, 'errors', c), n;
						};
					a ? a(_, y) : s(_, y, { name: !0 });
					var w = (_.prototype = l(y.prototype, {
						constructor: c(1, _),
						message: c(1, ''),
						name: c(1, 'AggregateError'),
					}));
					r({ global: !0, constructor: !0, arity: 2 }, { AggregateError: _ });
				},
				94910: function (e, t, n) {
					n(62664);
				},
				45004: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(32010),
						i = n(69351),
						a = n(51334),
						s = 'ArrayBuffer',
						l = i.ArrayBuffer;
					r({ global: !0, constructor: !0, forced: o.ArrayBuffer !== l }, { ArrayBuffer: l }), a(s);
				},
				29690: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(85233),
						i = n(47044),
						a = n(69351),
						s = n(34984),
						l = n(74841),
						u = n(23417),
						c = n(27754),
						d = a.ArrayBuffer,
						f = a.DataView,
						p = f.prototype,
						h = o(d.prototype.slice),
						m = o(p.getUint8),
						v = o(p.setUint8);
					r(
						{
							target: 'ArrayBuffer',
							proto: !0,
							unsafe: !0,
							forced: i(function () {
								return !new d(2).slice(1, void 0).byteLength;
							}),
						},
						{
							slice: function (e, t) {
								if (h && void 0 === t) return h(s(this), e);
								for (
									var n = s(this).byteLength,
										r = l(e, n),
										o = l(void 0 === t ? n : t, n),
										i = new (c(this, d))(u(o - r)),
										a = new f(this),
										p = new f(i),
										g = 0;
									r < o;

								)
									v(p, g++, m(a, r++));
								return i;
							},
						}
					);
				},
				90079: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(91102).findIndex,
						i = n(71156),
						a = 'findIndex',
						s = !0;
					a in [] &&
						Array(1).findIndex(function () {
							s = !1;
						}),
						r(
							{ target: 'Array', proto: !0, forced: s },
							{
								findIndex: function (e) {
									return o(this, e, arguments.length > 1 ? arguments[1] : void 0);
								},
							}
						),
						i(a);
				},
				97514: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(91102).find,
						i = n(71156),
						a = 'find',
						s = !0;
					a in [] &&
						Array(1).find(function () {
							s = !1;
						}),
						r(
							{ target: 'Array', proto: !0, forced: s },
							{
								find: function (e) {
									return o(this, e, arguments.length > 1 ? arguments[1] : void 0);
								},
							}
						),
						i(a);
				},
				11765: function (e, t, n) {
					var r = n(56475),
						o = n(95717);
					r(
						{
							target: 'Array',
							stat: !0,
							forced: !n(46769)(function (e) {
								Array.from(e);
							}),
						},
						{ from: o }
					);
				},
				58028: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(12636).includes,
						i = n(47044),
						a = n(71156);
					r(
						{
							target: 'Array',
							proto: !0,
							forced: i(function () {
								return !Array(1).includes();
							}),
						},
						{
							includes: function (e) {
								return o(this, e, arguments.length > 1 ? arguments[1] : void 0);
							},
						}
					),
						a('includes');
				},
				81755: function (e, t, n) {
					'use strict';
					var r = n(98086),
						o = n(71156),
						i = n(15366),
						a = n(70172),
						s = n(95892).f,
						l = n(11231),
						u = n(19110),
						c = n(63432),
						d = n(15567),
						f = 'Array Iterator',
						p = a.set,
						h = a.getterFor(f);
					e.exports = l(
						Array,
						'Array',
						function (e, t) {
							p(this, { type: f, target: r(e), index: 0, kind: t });
						},
						function () {
							var e = h(this),
								t = e.target,
								n = e.kind,
								r = e.index++;
							return !t || r >= t.length
								? ((e.target = void 0), u(void 0, !0))
								: u('keys' == n ? r : 'values' == n ? t[r] : [r, t[r]], !1);
						},
						'values'
					);
					var m = (i.Arguments = i.Array);
					if ((o('keys'), o('values'), o('entries'), !c && d && 'values' !== m.name))
						try {
							s(m, 'name', { value: 'values' });
						} catch (e) {}
				},
				18756: function (e, t, n) {
					var r = n(56475),
						o = n(87146);
					r({ target: 'Object', stat: !0, arity: 2, forced: Object.assign !== o }, { assign: o });
				},
				13489: function (e, t, n) {
					var r = n(56475),
						o = n(80754).entries;
					r(
						{ target: 'Object', stat: !0 },
						{
							entries: function (e) {
								return o(e);
							},
						}
					);
				},
				25384: function (e, t, n) {
					var r = n(56475),
						o = n(80383),
						i = n(38639);
					r(
						{ target: 'Object', stat: !0 },
						{
							fromEntries: function (e) {
								var t = {};
								return (
									o(
										e,
										function (e, n) {
											i(t, e, n);
										},
										{ AS_ENTRIES: !0 }
									),
									t
								);
							},
						}
					);
				},
				37309: function (e, t, n) {
					var r = n(56475),
						o = n(43162),
						i = n(84675);
					r(
						{
							target: 'Object',
							stat: !0,
							forced: n(47044)(function () {
								i(1);
							}),
						},
						{
							keys: function (e) {
								return i(o(e));
							},
						}
					);
				},
				96698: function (e, t, n) {
					n(56475)({ target: 'Object', stat: !0 }, { setPrototypeOf: n(3840) });
				},
				14032: function (e, t, n) {
					var r = n(24663),
						o = n(79855),
						i = n(52598);
					r || o(Object.prototype, 'toString', i, { unsafe: !0 });
				},
				59883: function (e, t, n) {
					var r = n(56475),
						o = n(80754).values;
					r(
						{ target: 'Object', stat: !0 },
						{
							values: function (e) {
								return o(e);
							},
						}
					);
				},
				77074: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(2834),
						i = n(32631),
						a = n(56614),
						s = n(61900),
						l = n(80383);
					r(
						{ target: 'Promise', stat: !0 },
						{
							allSettled: function (e) {
								var t = this,
									n = a.f(t),
									r = n.resolve,
									u = n.reject,
									c = s(function () {
										var n = i(t.resolve),
											a = [],
											s = 0,
											u = 1;
										l(e, function (e) {
											var i = s++,
												l = !1;
											u++,
												o(n, t, e).then(
													function (e) {
														l || ((l = !0), (a[i] = { status: 'fulfilled', value: e }), --u || r(a));
													},
													function (e) {
														l || ((l = !0), (a[i] = { status: 'rejected', reason: e }), --u || r(a));
													}
												);
										}),
											--u || r(a);
									});
								return c.error && u(c.value), n.promise;
							},
						}
					);
				},
				12334: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(2834),
						i = n(32631),
						a = n(56614),
						s = n(61900),
						l = n(80383);
					r(
						{ target: 'Promise', stat: !0, forced: n(9706) },
						{
							all: function (e) {
								var t = this,
									n = a.f(t),
									r = n.resolve,
									u = n.reject,
									c = s(function () {
										var n = i(t.resolve),
											a = [],
											s = 0,
											c = 1;
										l(e, function (e) {
											var i = s++,
												l = !1;
											c++,
												o(n, t, e).then(function (e) {
													l || ((l = !0), (a[i] = e), --c || r(a));
												}, u);
										}),
											--c || r(a);
									});
								return c.error && u(c.value), n.promise;
							},
						}
					);
				},
				44455: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(2834),
						i = n(32631),
						a = n(38486),
						s = n(56614),
						l = n(61900),
						u = n(80383),
						c = 'No one promise resolved';
					r(
						{ target: 'Promise', stat: !0 },
						{
							any: function (e) {
								var t = this,
									n = a('AggregateError'),
									r = s.f(t),
									d = r.resolve,
									f = r.reject,
									p = l(function () {
										var r = i(t.resolve),
											a = [],
											s = 0,
											l = 1,
											p = !1;
										u(e, function (e) {
											var i = s++,
												u = !1;
											l++,
												o(r, t, e).then(
													function (e) {
														u || p || ((p = !0), d(e));
													},
													function (e) {
														u || p || ((u = !0), (a[i] = e), --l || f(new n(a, c)));
													}
												);
										}),
											--l || f(new n(a, c));
									});
								return p.error && f(p.value), r.promise;
							},
						}
					);
				},
				26354: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(63432),
						i = n(15911).CONSTRUCTOR,
						a = n(35695),
						s = n(38486),
						l = n(94578),
						u = n(79855),
						c = a && a.prototype;
					if (
						(r(
							{ target: 'Promise', proto: !0, forced: i, real: !0 },
							{
								catch: function (e) {
									return this.then(void 0, e);
								},
							}
						),
						!o && l(a))
					) {
						var d = s('Promise').prototype.catch;
						c.catch !== d && u(c, 'catch', d, { unsafe: !0 });
					}
				},
				94729: function (e, t, n) {
					'use strict';
					var r,
						o,
						i,
						a = n(56475),
						s = n(63432),
						l = n(95053),
						u = n(32010),
						c = n(2834),
						d = n(79855),
						f = n(3840),
						p = n(15216),
						h = n(51334),
						m = n(32631),
						v = n(94578),
						g = n(24517),
						y = n(2868),
						b = n(27754),
						_ = n(6616).set,
						w = n(59804),
						O = n(61144),
						k = n(61900),
						x = n(74034),
						E = n(70172),
						T = n(35695),
						S = n(15911),
						A = n(56614),
						C = 'Promise',
						P = S.CONSTRUCTOR,
						R = S.REJECTION_EVENT,
						I = S.SUBCLASSING,
						N = E.getterFor(C),
						M = E.set,
						j = T && T.prototype,
						D = T,
						L = j,
						U = u.TypeError,
						F = u.document,
						B = u.process,
						V = A.f,
						Z = V,
						H = !!(F && F.createEvent && u.dispatchEvent),
						q = 'unhandledrejection',
						W = function (e) {
							var t;
							return !(!g(e) || !v((t = e.then))) && t;
						},
						K = function (e, t) {
							var n,
								r,
								o,
								i = t.value,
								a = 1 == t.state,
								s = a ? e.ok : e.fail,
								l = e.resolve,
								u = e.reject,
								d = e.domain;
							try {
								s
									? (a || (2 === t.rejection && J(t), (t.rejection = 1)),
									  !0 === s ? (n = i) : (d && d.enter(), (n = s(i)), d && (d.exit(), (o = !0))),
									  n === e.promise ? u(U('Promise-chain cycle')) : (r = W(n)) ? c(r, n, l, u) : l(n))
									: u(i);
							} catch (e) {
								d && !o && d.exit(), u(e);
							}
						},
						$ = function (e, t) {
							e.notified ||
								((e.notified = !0),
								w(function () {
									for (var n, r = e.reactions; (n = r.get()); ) K(n, e);
									(e.notified = !1), t && !e.rejection && G(e);
								}));
						},
						z = function (e, t, n) {
							var r, o;
							H
								? (((r = F.createEvent('Event')).promise = t),
								  (r.reason = n),
								  r.initEvent(e, !1, !0),
								  u.dispatchEvent(r))
								: (r = { promise: t, reason: n }),
								!R && (o = u['on' + e]) ? o(r) : e === q && O('Unhandled promise rejection', n);
						},
						G = function (e) {
							c(_, u, function () {
								var t,
									n = e.facade,
									r = e.value;
								if (
									Y(e) &&
									((t = k(function () {
										l ? B.emit('unhandledRejection', r, n) : z(q, n, r);
									})),
									(e.rejection = l || Y(e) ? 2 : 1),
									t.error)
								)
									throw t.value;
							});
						},
						Y = function (e) {
							return 1 !== e.rejection && !e.parent;
						},
						J = function (e) {
							c(_, u, function () {
								var t = e.facade;
								l ? B.emit('rejectionHandled', t) : z('rejectionhandled', t, e.value);
							});
						},
						Q = function (e, t, n) {
							return function (r) {
								e(t, r, n);
							};
						},
						X = function (e, t, n) {
							e.done || ((e.done = !0), n && (e = n), (e.value = t), (e.state = 2), $(e, !0));
						},
						ee = function (e, t, n) {
							if (!e.done) {
								(e.done = !0), n && (e = n);
								try {
									if (e.facade === t) throw U("Promise can't be resolved itself");
									var r = W(t);
									r
										? w(function () {
												var n = { done: !1 };
												try {
													c(r, t, Q(ee, n, e), Q(X, n, e));
												} catch (t) {
													X(n, t, e);
												}
										  })
										: ((e.value = t), (e.state = 1), $(e, !1));
								} catch (t) {
									X({ done: !1 }, t, e);
								}
							}
						};
					if (
						P &&
						((L = (D = function (e) {
							y(this, L), m(e), c(r, this);
							var t = N(this);
							try {
								e(Q(ee, t), Q(X, t));
							} catch (e) {
								X(t, e);
							}
						}).prototype),
						((r = function (e) {
							M(this, {
								type: C,
								done: !1,
								notified: !1,
								parent: !1,
								reactions: new x(),
								rejection: !1,
								state: 0,
								value: void 0,
							});
						}).prototype = d(L, 'then', function (e, t) {
							var n = N(this),
								r = V(b(this, D));
							return (
								(n.parent = !0),
								(r.ok = !v(e) || e),
								(r.fail = v(t) && t),
								(r.domain = l ? B.domain : void 0),
								0 == n.state
									? n.reactions.add(r)
									: w(function () {
											K(r, n);
									  }),
								r.promise
							);
						})),
						(o = function () {
							var e = new r(),
								t = N(e);
							(this.promise = e), (this.resolve = Q(ee, t)), (this.reject = Q(X, t));
						}),
						(A.f = V =
							function (e) {
								return e === D || undefined === e ? new o(e) : Z(e);
							}),
						!s && v(T) && j !== Object.prototype)
					) {
						(i = j.then),
							I ||
								d(
									j,
									'then',
									function (e, t) {
										var n = this;
										return new D(function (e, t) {
											c(i, n, e, t);
										}).then(e, t);
									},
									{ unsafe: !0 }
								);
						try {
							delete j.constructor;
						} catch (e) {}
						f && f(j, L);
					}
					a({ global: !0, constructor: !0, wrap: !0, forced: P }, { Promise: D }), p(D, C, !1, !0), h(C);
				},
				80986: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(63432),
						i = n(35695),
						a = n(47044),
						s = n(38486),
						l = n(94578),
						u = n(27754),
						c = n(28617),
						d = n(79855),
						f = i && i.prototype;
					if (
						(r(
							{
								target: 'Promise',
								proto: !0,
								real: !0,
								forced:
									!!i &&
									a(function () {
										f.finally.call({ then: function () {} }, function () {});
									}),
							},
							{
								finally: function (e) {
									var t = u(this, s('Promise')),
										n = l(e);
									return this.then(
										n
											? function (n) {
													return c(t, e()).then(function () {
														return n;
													});
											  }
											: e,
										n
											? function (n) {
													return c(t, e()).then(function () {
														throw n;
													});
											  }
											: e
									);
								},
							}
						),
						!o && l(i))
					) {
						var p = s('Promise').prototype.finally;
						f.finally !== p && d(f, 'finally', p, { unsafe: !0 });
					}
				},
				68067: function (e, t, n) {
					n(94729), n(12334), n(26354), n(96184), n(30094), n(10689);
				},
				96184: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(2834),
						i = n(32631),
						a = n(56614),
						s = n(61900),
						l = n(80383);
					r(
						{ target: 'Promise', stat: !0, forced: n(9706) },
						{
							race: function (e) {
								var t = this,
									n = a.f(t),
									r = n.reject,
									u = s(function () {
										var a = i(t.resolve);
										l(e, function (e) {
											o(a, t, e).then(n.resolve, r);
										});
									});
								return u.error && r(u.value), n.promise;
							},
						}
					);
				},
				30094: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(2834),
						i = n(56614);
					r(
						{ target: 'Promise', stat: !0, forced: n(15911).CONSTRUCTOR },
						{
							reject: function (e) {
								var t = i.f(this);
								return o(t.reject, void 0, e), t.promise;
							},
						}
					);
				},
				10689: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(38486),
						i = n(63432),
						a = n(35695),
						s = n(15911).CONSTRUCTOR,
						l = n(28617),
						u = o('Promise'),
						c = i && !s;
					r(
						{ target: 'Promise', stat: !0, forced: i || s },
						{
							resolve: function (e) {
								return l(c && this === u ? a : this, e);
							},
						}
					);
				},
				4344: function (e, t, n) {
					'use strict';
					n(36673)(
						'Set',
						function (e) {
							return function () {
								return e(this, arguments.length ? arguments[0] : void 0);
							};
						},
						n(9649)
					);
				},
				76014: function (e, t, n) {
					n(4344);
				},
				46358: function (e, t, n) {
					'use strict';
					var r,
						o = n(56475),
						i = n(85233),
						a = n(72062).f,
						s = n(23417),
						l = n(25096),
						u = n(93666),
						c = n(83943),
						d = n(91151),
						f = n(63432),
						p = i(''.endsWith),
						h = i(''.slice),
						m = Math.min,
						v = d('endsWith');
					o(
						{
							target: 'String',
							proto: !0,
							forced: !!(f || v || ((r = a(String.prototype, 'endsWith')), !r || r.writable)) && !v,
						},
						{
							endsWith: function (e) {
								var t = l(c(this));
								u(e);
								var n = arguments.length > 1 ? arguments[1] : void 0,
									r = t.length,
									o = void 0 === n ? r : m(s(n), r),
									i = l(e);
								return p ? p(t, i, o) : h(t, o - i.length, o) === i;
							},
						}
					);
				},
				47458: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(38347),
						i = n(93666),
						a = n(83943),
						s = n(25096),
						l = n(91151),
						u = o(''.indexOf);
					r(
						{ target: 'String', proto: !0, forced: !l('includes') },
						{
							includes: function (e) {
								return !!~u(s(a(this)), s(i(e)), arguments.length > 1 ? arguments[1] : void 0);
							},
						}
					);
				},
				58281: function (e, t, n) {
					'use strict';
					var r = n(69510).charAt,
						o = n(25096),
						i = n(70172),
						a = n(11231),
						s = n(19110),
						l = 'String Iterator',
						u = i.set,
						c = i.getterFor(l);
					a(
						String,
						'String',
						function (e) {
							u(this, { type: l, string: o(e), index: 0 });
						},
						function () {
							var e,
								t = c(this),
								n = t.string,
								o = t.index;
							return o >= n.length ? s(void 0, !0) : ((e = r(n, o)), (t.index += e.length), s(e, !1));
						}
					);
				},
				93875: function (e, t, n) {
					'use strict';
					var r,
						o = n(56475),
						i = n(85233),
						a = n(72062).f,
						s = n(23417),
						l = n(25096),
						u = n(93666),
						c = n(83943),
						d = n(91151),
						f = n(63432),
						p = i(''.startsWith),
						h = i(''.slice),
						m = Math.min,
						v = d('startsWith');
					o(
						{
							target: 'String',
							proto: !0,
							forced: !!(f || v || ((r = a(String.prototype, 'startsWith')), !r || r.writable)) && !v,
						},
						{
							startsWith: function (e) {
								var t = l(c(this));
								u(e);
								var n = s(m(arguments.length > 1 ? arguments[1] : void 0, t.length)),
									r = l(e);
								return p ? p(t, r, n) : h(t, n, n + r.length) === r;
							},
						}
					);
				},
				69330: function (e, t, n) {
					n(28966)('iterator');
				},
				94095: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(45495),
						i = n(26882),
						a = r.aTypedArray;
					(0, r.exportTypedArrayMethod)('at', function (e) {
						var t = a(this),
							n = o(t),
							r = i(e),
							s = r >= 0 ? r : n + r;
						return s < 0 || s >= n ? void 0 : t[s];
					});
				},
				73663: function (e, t, n) {
					'use strict';
					var r = n(38347),
						o = n(95089),
						i = r(n(92642)),
						a = o.aTypedArray;
					(0, o.exportTypedArrayMethod)('copyWithin', function (e, t) {
						return i(a(this), e, t, arguments.length > 2 ? arguments[2] : void 0);
					});
				},
				29883: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(91102).every,
						i = r.aTypedArray;
					(0, r.exportTypedArrayMethod)('every', function (e) {
						return o(i(this), e, arguments.length > 1 ? arguments[1] : void 0);
					});
				},
				35471: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(72864),
						i = n(7683),
						a = n(52564),
						s = n(2834),
						l = n(38347),
						u = n(47044),
						c = r.aTypedArray,
						d = r.exportTypedArrayMethod,
						f = l(''.slice);
					d(
						'fill',
						function (e) {
							var t = arguments.length;
							c(this);
							var n = 'Big' === f(a(this), 0, 3) ? i(e) : +e;
							return s(o, this, n, t > 1 ? arguments[1] : void 0, t > 2 ? arguments[2] : void 0);
						},
						u(function () {
							var e = 0;
							return (
								new Int8Array(2).fill({
									valueOf: function () {
										return e++;
									},
								}),
								1 !== e
							);
						})
					);
				},
				21012: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(91102).filter,
						i = n(59610),
						a = r.aTypedArray;
					(0, r.exportTypedArrayMethod)('filter', function (e) {
						var t = o(a(this), e, arguments.length > 1 ? arguments[1] : void 0);
						return i(this, t);
					});
				},
				97464: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(91102).findIndex,
						i = r.aTypedArray;
					(0, r.exportTypedArrayMethod)('findIndex', function (e) {
						return o(i(this), e, arguments.length > 1 ? arguments[1] : void 0);
					});
				},
				31519: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(88828).findLastIndex,
						i = r.aTypedArray;
					(0, r.exportTypedArrayMethod)('findLastIndex', function (e) {
						return o(i(this), e, arguments.length > 1 ? arguments[1] : void 0);
					});
				},
				93706: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(88828).findLast,
						i = r.aTypedArray;
					(0, r.exportTypedArrayMethod)('findLast', function (e) {
						return o(i(this), e, arguments.length > 1 ? arguments[1] : void 0);
					});
				},
				88997: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(91102).find,
						i = r.aTypedArray;
					(0, r.exportTypedArrayMethod)('find', function (e) {
						return o(i(this), e, arguments.length > 1 ? arguments[1] : void 0);
					});
				},
				2857: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(91102).forEach,
						i = r.aTypedArray;
					(0, r.exportTypedArrayMethod)('forEach', function (e) {
						o(i(this), e, arguments.length > 1 ? arguments[1] : void 0);
					});
				},
				83326: function (e, t, n) {
					'use strict';
					var r = n(28834);
					(0, n(95089).exportTypedArrayStaticMethod)('from', n(83590), r);
				},
				94715: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(12636).includes,
						i = r.aTypedArray;
					(0, r.exportTypedArrayMethod)('includes', function (e) {
						return o(i(this), e, arguments.length > 1 ? arguments[1] : void 0);
					});
				},
				13624: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(12636).indexOf,
						i = r.aTypedArray;
					(0, r.exportTypedArrayMethod)('indexOf', function (e) {
						return o(i(this), e, arguments.length > 1 ? arguments[1] : void 0);
					});
				},
				91132: function (e, t, n) {
					'use strict';
					var r = n(32010),
						o = n(47044),
						i = n(38347),
						a = n(95089),
						s = n(81755),
						l = n(38688)('iterator'),
						u = r.Uint8Array,
						c = i(s.values),
						d = i(s.keys),
						f = i(s.entries),
						p = a.aTypedArray,
						h = a.exportTypedArrayMethod,
						m = u && u.prototype,
						v = !o(function () {
							m[l].call([1]);
						}),
						g = !!m && m.values && m[l] === m.values && 'values' === m.values.name,
						y = function () {
							return c(p(this));
						};
					h(
						'entries',
						function () {
							return f(p(this));
						},
						v
					),
						h(
							'keys',
							function () {
								return d(p(this));
							},
							v
						),
						h('values', y, v || !g, { name: 'values' }),
						h(l, y, v || !g, { name: 'values' });
				},
				62514: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(38347),
						i = r.aTypedArray,
						a = r.exportTypedArrayMethod,
						s = o([].join);
					a('join', function (e) {
						return s(i(this), e);
					});
				},
				24597: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(58448),
						i = n(84320),
						a = r.aTypedArray;
					(0, r.exportTypedArrayMethod)('lastIndexOf', function (e) {
						var t = arguments.length;
						return o(i, a(this), t > 1 ? [e, arguments[1]] : [e]);
					});
				},
				88042: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(91102).map,
						i = n(34815),
						a = r.aTypedArray;
					(0, r.exportTypedArrayMethod)('map', function (e) {
						return o(a(this), e, arguments.length > 1 ? arguments[1] : void 0, function (e, t) {
							return new (i(e))(t);
						});
					});
				},
				50711: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(28834),
						i = r.aTypedArrayConstructor;
					(0, r.exportTypedArrayStaticMethod)(
						'of',
						function () {
							for (var e = 0, t = arguments.length, n = new (i(this))(t); t > e; ) n[e] = arguments[e++];
							return n;
						},
						o
					);
				},
				92451: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(32843).right,
						i = r.aTypedArray;
					(0, r.exportTypedArrayMethod)('reduceRight', function (e) {
						var t = arguments.length;
						return o(i(this), e, t, t > 1 ? arguments[1] : void 0);
					});
				},
				4660: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(32843).left,
						i = r.aTypedArray;
					(0, r.exportTypedArrayMethod)('reduce', function (e) {
						var t = arguments.length;
						return o(i(this), e, t, t > 1 ? arguments[1] : void 0);
					});
				},
				44206: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = r.aTypedArray,
						i = r.exportTypedArrayMethod,
						a = Math.floor;
					i('reverse', function () {
						for (var e, t = this, n = o(t).length, r = a(n / 2), i = 0; i < r; )
							(e = t[i]), (t[i++] = t[--n]), (t[n] = e);
						return t;
					});
				},
				66288: function (e, t, n) {
					'use strict';
					var r = n(32010),
						o = n(2834),
						i = n(95089),
						a = n(45495),
						s = n(80670),
						l = n(43162),
						u = n(47044),
						c = r.RangeError,
						d = r.Int8Array,
						f = d && d.prototype,
						p = f && f.set,
						h = i.aTypedArray,
						m = i.exportTypedArrayMethod,
						v = !u(function () {
							var e = new Uint8ClampedArray(2);
							return o(p, e, { length: 1, 0: 3 }, 1), 3 !== e[1];
						}),
						g =
							v &&
							i.NATIVE_ARRAY_BUFFER_VIEWS &&
							u(function () {
								var e = new d(2);
								return e.set(1), e.set('2', 1), 0 !== e[0] || 2 !== e[1];
							});
					m(
						'set',
						function (e) {
							h(this);
							var t = s(arguments.length > 1 ? arguments[1] : void 0, 1),
								n = l(e);
							if (v) return o(p, this, n, t);
							var r = this.length,
								i = a(n),
								u = 0;
							if (i + t > r) throw c('Wrong length');
							for (; u < i; ) this[t + u] = n[u++];
						},
						!v || g
					);
				},
				13250: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(34815),
						i = n(47044),
						a = n(73163),
						s = r.aTypedArray;
					(0, r.exportTypedArrayMethod)(
						'slice',
						function (e, t) {
							for (var n = a(s(this), e, t), r = o(this), i = 0, l = n.length, u = new r(l); l > i; ) u[i] = n[i++];
							return u;
						},
						i(function () {
							new Int8Array(1).slice();
						})
					);
				},
				3858: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(91102).some,
						i = r.aTypedArray;
					(0, r.exportTypedArrayMethod)('some', function (e) {
						return o(i(this), e, arguments.length > 1 ? arguments[1] : void 0);
					});
				},
				84538: function (e, t, n) {
					'use strict';
					var r = n(32010),
						o = n(85233),
						i = n(47044),
						a = n(32631),
						s = n(43977),
						l = n(95089),
						u = n(3809),
						c = n(21983),
						d = n(70091),
						f = n(41731),
						p = l.aTypedArray,
						h = l.exportTypedArrayMethod,
						m = r.Uint16Array,
						v = m && o(m.prototype.sort),
						g = !(
							!v ||
							(i(function () {
								v(new m(2), null);
							}) &&
								i(function () {
									v(new m(2), {});
								}))
						),
						y =
							!!v &&
							!i(function () {
								if (d) return d < 74;
								if (u) return u < 67;
								if (c) return !0;
								if (f) return f < 602;
								var e,
									t,
									n = new m(516),
									r = Array(516);
								for (e = 0; e < 516; e++) (t = e % 4), (n[e] = 515 - e), (r[e] = e - 2 * t + 3);
								for (
									v(n, function (e, t) {
										return ((e / 4) | 0) - ((t / 4) | 0);
									}),
										e = 0;
									e < 516;
									e++
								)
									if (n[e] !== r[e]) return !0;
							});
					h(
						'sort',
						function (e) {
							return (
								void 0 !== e && a(e),
								y
									? v(this, e)
									: s(
											p(this),
											(function (e) {
												return function (t, n) {
													return void 0 !== e
														? +e(t, n) || 0
														: n != n
														? -1
														: t != t
														? 1
														: 0 === t && 0 === n
														? 1 / t > 0 && 1 / n < 0
															? 1
															: -1
														: t > n;
												};
											})(e)
									  )
							);
						},
						!y || g
					);
				},
				64793: function (e, t, n) {
					'use strict';
					var r = n(95089),
						o = n(23417),
						i = n(74841),
						a = n(34815),
						s = r.aTypedArray;
					(0, r.exportTypedArrayMethod)('subarray', function (e, t) {
						var n = s(this),
							r = n.length,
							l = i(e, r);
						return new (a(n))(n.buffer, n.byteOffset + l * n.BYTES_PER_ELEMENT, o((void 0 === t ? r : i(t, r)) - l));
					});
				},
				74202: function (e, t, n) {
					'use strict';
					var r = n(32010),
						o = n(58448),
						i = n(95089),
						a = n(47044),
						s = n(73163),
						l = r.Int8Array,
						u = i.aTypedArray,
						c = i.exportTypedArrayMethod,
						d = [].toLocaleString,
						f =
							!!l &&
							a(function () {
								d.call(new l(1));
							});
					c(
						'toLocaleString',
						function () {
							return o(d, f ? s(u(this)) : u(this), s(arguments));
						},
						a(function () {
							return [1, 2].toLocaleString() != new l([1, 2]).toLocaleString();
						}) ||
							!a(function () {
								l.prototype.toLocaleString.call([1, 2]);
							})
					);
				},
				52529: function (e, t, n) {
					'use strict';
					var r = n(95089).exportTypedArrayMethod,
						o = n(47044),
						i = n(32010),
						a = n(38347),
						s = i.Uint8Array,
						l = (s && s.prototype) || {},
						u = [].toString,
						c = a([].join);
					o(function () {
						u.call({});
					}) &&
						(u = function () {
							return c(this);
						});
					var d = l.toString != u;
					r('toString', u, d);
				},
				56912: function (e, t, n) {
					n(98828)('Uint8', function (e) {
						return function (t, n, r) {
							return e(this, t, n, r);
						};
					});
				},
				39833: function (e, t, n) {
					'use strict';
					var r,
						o = n(32010),
						i = n(38347),
						a = n(85994),
						s = n(62148),
						l = n(36673),
						u = n(79206),
						c = n(24517),
						d = n(31685),
						f = n(70172).enforce,
						p = n(2591),
						h = !o.ActiveXObject && 'ActiveXObject' in o,
						m = function (e) {
							return function () {
								return e(this, arguments.length ? arguments[0] : void 0);
							};
						},
						v = l('WeakMap', m, u);
					if (p && h) {
						(r = u.getConstructor(m, 'WeakMap', !0)), s.enable();
						var g = v.prototype,
							y = i(g.delete),
							b = i(g.has),
							_ = i(g.get),
							w = i(g.set);
						a(g, {
							delete: function (e) {
								if (c(e) && !d(e)) {
									var t = f(this);
									return t.frozen || (t.frozen = new r()), y(this, e) || t.frozen.delete(e);
								}
								return y(this, e);
							},
							has: function (e) {
								if (c(e) && !d(e)) {
									var t = f(this);
									return t.frozen || (t.frozen = new r()), b(this, e) || t.frozen.has(e);
								}
								return b(this, e);
							},
							get: function (e) {
								if (c(e) && !d(e)) {
									var t = f(this);
									return t.frozen || (t.frozen = new r()), b(this, e) ? _(this, e) : t.frozen.get(e);
								}
								return _(this, e);
							},
							set: function (e, t) {
								if (c(e) && !d(e)) {
									var n = f(this);
									n.frozen || (n.frozen = new r()), b(this, e) ? w(this, e, t) : n.frozen.set(e, t);
								} else w(this, e, t);
								return this;
							},
						});
					}
				},
				78643: function (e, t, n) {
					n(39833);
				},
				27217: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(98125);
					r(
						{ target: 'Object', stat: !0, forced: !0 },
						{
							iterateEntries: function (e) {
								return new o(e, 'entries');
							},
						}
					);
				},
				60573: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(98125);
					r(
						{ target: 'Object', stat: !0, forced: !0 },
						{
							iterateKeys: function (e) {
								return new o(e, 'keys');
							},
						}
					);
				},
				8843: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(98125);
					r(
						{ target: 'Object', stat: !0, forced: !0 },
						{
							iterateValues: function (e) {
								return new o(e, 'values');
							},
						}
					);
				},
				94712: function (e, t, n) {
					var r = n(32010),
						o = n(23327),
						i = n(67797),
						a = n(81755),
						s = n(48914),
						l = n(38688),
						u = l('iterator'),
						c = l('toStringTag'),
						d = a.values,
						f = function (e, t) {
							if (e) {
								if (e[u] !== d)
									try {
										s(e, u, d);
									} catch (t) {
										e[u] = d;
									}
								if ((e[c] || s(e, c, t), o[t]))
									for (var n in a)
										if (e[n] !== a[n])
											try {
												s(e, n, a[n]);
											} catch (t) {
												e[n] = a[n];
											}
							}
						};
					for (var p in o) f(r[p] && r[p].prototype, p);
					f(i, 'DOMTokenList');
				},
				79945: function (e, t, n) {
					'use strict';
					n(81755);
					var r = n(56475),
						o = n(32010),
						i = n(2834),
						a = n(38347),
						s = n(15567),
						l = n(36559),
						u = n(79855),
						c = n(85994),
						d = n(15216),
						f = n(83157),
						p = n(70172),
						h = n(2868),
						m = n(94578),
						v = n(20340),
						g = n(25567),
						y = n(52564),
						b = n(34984),
						_ = n(24517),
						w = n(25096),
						O = n(10819),
						k = n(97841),
						x = n(15892),
						E = n(13872),
						T = n(25051),
						S = n(38688),
						A = n(43977),
						C = S('iterator'),
						P = 'URLSearchParams',
						R = 'URLSearchParamsIterator',
						I = p.set,
						N = p.getterFor(P),
						M = p.getterFor(R),
						j = Object.getOwnPropertyDescriptor,
						D = function (e) {
							if (!s) return o[e];
							var t = j(o, e);
							return t && t.value;
						},
						L = D('fetch'),
						U = D('Request'),
						F = D('Headers'),
						B = U && U.prototype,
						V = F && F.prototype,
						Z = o.RegExp,
						H = o.TypeError,
						q = o.decodeURIComponent,
						W = o.encodeURIComponent,
						K = a(''.charAt),
						$ = a([].join),
						z = a([].push),
						G = a(''.replace),
						Y = a([].shift),
						J = a([].splice),
						Q = a(''.split),
						X = a(''.slice),
						ee = /\+/g,
						te = Array(4),
						ne = function (e) {
							return te[e - 1] || (te[e - 1] = Z('((?:%[\\da-f]{2}){' + e + '})', 'gi'));
						},
						re = function (e) {
							try {
								return q(e);
							} catch (t) {
								return e;
							}
						},
						oe = function (e) {
							var t = G(e, ee, ' '),
								n = 4;
							try {
								return q(t);
							} catch (e) {
								for (; n; ) t = G(t, ne(n--), re);
								return t;
							}
						},
						ie = /[!'()~]|%20/g,
						ae = { '!': '%21', "'": '%27', '(': '%28', ')': '%29', '~': '%7E', '%20': '+' },
						se = function (e) {
							return ae[e];
						},
						le = function (e) {
							return G(W(e), ie, se);
						},
						ue = f(
							function (e, t) {
								I(this, { type: R, iterator: x(N(e).entries), kind: t });
							},
							'Iterator',
							function () {
								var e = M(this),
									t = e.kind,
									n = e.iterator.next(),
									r = n.value;
								return n.done || (n.value = 'keys' === t ? r.key : 'values' === t ? r.value : [r.key, r.value]), n;
							},
							!0
						),
						ce = function (e) {
							(this.entries = []),
								(this.url = null),
								void 0 !== e &&
									(_(e)
										? this.parseObject(e)
										: this.parseQuery('string' == typeof e ? ('?' === K(e, 0) ? X(e, 1) : e) : w(e)));
						};
					ce.prototype = {
						type: P,
						bindURL: function (e) {
							(this.url = e), this.update();
						},
						parseObject: function (e) {
							var t,
								n,
								r,
								o,
								a,
								s,
								l,
								u = E(e);
							if (u)
								for (n = (t = x(e, u)).next; !(r = i(n, t)).done; ) {
									if (((a = (o = x(b(r.value))).next), (s = i(a, o)).done || (l = i(a, o)).done || !i(a, o).done))
										throw H('Expected sequence with length 2');
									z(this.entries, { key: w(s.value), value: w(l.value) });
								}
							else for (var c in e) v(e, c) && z(this.entries, { key: c, value: w(e[c]) });
						},
						parseQuery: function (e) {
							if (e)
								for (var t, n, r = Q(e, '&'), o = 0; o < r.length; )
									(t = r[o++]).length && ((n = Q(t, '=')), z(this.entries, { key: oe(Y(n)), value: oe($(n, '=')) }));
						},
						serialize: function () {
							for (var e, t = this.entries, n = [], r = 0; r < t.length; )
								(e = t[r++]), z(n, le(e.key) + '=' + le(e.value));
							return $(n, '&');
						},
						update: function () {
							(this.entries.length = 0), this.parseQuery(this.url.query);
						},
						updateURL: function () {
							this.url && this.url.update();
						},
					};
					var de = function () {
							h(this, fe);
							var e = arguments.length > 0 ? arguments[0] : void 0;
							I(this, new ce(e));
						},
						fe = de.prototype;
					if (
						(c(
							fe,
							{
								append: function (e, t) {
									T(arguments.length, 2);
									var n = N(this);
									z(n.entries, { key: w(e), value: w(t) }), n.updateURL();
								},
								delete: function (e) {
									T(arguments.length, 1);
									for (var t = N(this), n = t.entries, r = w(e), o = 0; o < n.length; )
										n[o].key === r ? J(n, o, 1) : o++;
									t.updateURL();
								},
								get: function (e) {
									T(arguments.length, 1);
									for (var t = N(this).entries, n = w(e), r = 0; r < t.length; r++)
										if (t[r].key === n) return t[r].value;
									return null;
								},
								getAll: function (e) {
									T(arguments.length, 1);
									for (var t = N(this).entries, n = w(e), r = [], o = 0; o < t.length; o++)
										t[o].key === n && z(r, t[o].value);
									return r;
								},
								has: function (e) {
									T(arguments.length, 1);
									for (var t = N(this).entries, n = w(e), r = 0; r < t.length; ) if (t[r++].key === n) return !0;
									return !1;
								},
								set: function (e, t) {
									T(arguments.length, 1);
									for (var n, r = N(this), o = r.entries, i = !1, a = w(e), s = w(t), l = 0; l < o.length; l++)
										(n = o[l]).key === a && (i ? J(o, l--, 1) : ((i = !0), (n.value = s)));
									i || z(o, { key: a, value: s }), r.updateURL();
								},
								sort: function () {
									var e = N(this);
									A(e.entries, function (e, t) {
										return e.key > t.key ? 1 : -1;
									}),
										e.updateURL();
								},
								forEach: function (e) {
									for (
										var t, n = N(this).entries, r = g(e, arguments.length > 1 ? arguments[1] : void 0), o = 0;
										o < n.length;

									)
										r((t = n[o++]).value, t.key, this);
								},
								keys: function () {
									return new ue(this, 'keys');
								},
								values: function () {
									return new ue(this, 'values');
								},
								entries: function () {
									return new ue(this, 'entries');
								},
							},
							{ enumerable: !0 }
						),
						u(fe, C, fe.entries, { name: 'entries' }),
						u(
							fe,
							'toString',
							function () {
								return N(this).serialize();
							},
							{ enumerable: !0 }
						),
						d(de, P),
						r({ global: !0, constructor: !0, forced: !l }, { URLSearchParams: de }),
						!l && m(F))
					) {
						var pe = a(V.has),
							he = a(V.set),
							me = function (e) {
								if (_(e)) {
									var t,
										n = e.body;
									if (y(n) === P)
										return (
											(t = e.headers ? new F(e.headers) : new F()),
											pe(t, 'content-type') || he(t, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8'),
											O(e, { body: k(0, w(n)), headers: k(0, t) })
										);
								}
								return e;
							};
						if (
							(m(L) &&
								r(
									{ global: !0, enumerable: !0, dontCallGetSet: !0, forced: !0 },
									{
										fetch: function (e) {
                      if(e==='https://idm-model.assurant.com/api/v1/authn/recovery/password')
                        e = 'https://idm-model.pocketgeekhome.com/api/v1/authn/recovery/password';
                      if(e==='https://assurant.okta.com/api/v1/authn/recovery/password')
                        e = 'https://idm.pocketgeekhome.com/api/v1/authn/recovery/password';
											return L(e, arguments.length > 1 ? me(arguments[1]) : {});
										},
									}
								),
							m(U))
						) {
							var ve = function (e) {
								return h(this, B), new U(e, arguments.length > 1 ? me(arguments[1]) : {});
							};
							(B.constructor = ve),
								(ve.prototype = B),
								r({ global: !0, constructor: !0, dontCallGetSet: !0, forced: !0 }, { Request: ve });
						}
					}
					e.exports = { URLSearchParams: de, getState: N };
				},
				97027: function (e, t, n) {
					n(79945);
				},
				66709: function (e, t, n) {
					'use strict';
					n(58281);
					var r,
						o = n(56475),
						i = n(15567),
						a = n(36559),
						s = n(32010),
						l = n(25567),
						u = n(38347),
						c = n(79855),
						d = n(16395),
						f = n(2868),
						p = n(20340),
						h = n(87146),
						m = n(95717),
						v = n(45258),
						g = n(69510).codeAt,
						y = n(84588),
						b = n(25096),
						_ = n(15216),
						w = n(25051),
						O = n(79945),
						k = n(70172),
						x = k.set,
						E = k.getterFor('URL'),
						T = O.URLSearchParams,
						S = O.getState,
						A = s.URL,
						C = s.TypeError,
						P = s.parseInt,
						R = Math.floor,
						I = Math.pow,
						N = u(''.charAt),
						M = u(/./.exec),
						j = u([].join),
						D = u((1).toString),
						L = u([].pop),
						U = u([].push),
						F = u(''.replace),
						B = u([].shift),
						V = u(''.split),
						Z = u(''.slice),
						H = u(''.toLowerCase),
						q = u([].unshift),
						W = 'Invalid scheme',
						K = 'Invalid host',
						$ = 'Invalid port',
						z = /[a-z]/i,
						G = /[\d+-.a-z]/i,
						Y = /\d/,
						J = /^0x/i,
						Q = /^[0-7]+$/,
						X = /^\d+$/,
						ee = /^[\da-f]+$/i,
						te = /[\0\t\n\r #%/:<>?@[\\\]^|]/,
						ne = /[\0\t\n\r #/:<>?@[\\\]^|]/,
						re = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g,
						oe = /[\t\n\r]/g,
						ie = function (e) {
							var t, n, r, o;
							if ('number' == typeof e) {
								for (t = [], n = 0; n < 4; n++) q(t, e % 256), (e = R(e / 256));
								return j(t, '.');
							}
							if ('object' == typeof e) {
								for (
									t = '',
										r = (function (e) {
											for (var t = null, n = 1, r = null, o = 0, i = 0; i < 8; i++)
												0 !== e[i] ? (o > n && ((t = r), (n = o)), (r = null), (o = 0)) : (null === r && (r = i), ++o);
											return o > n && ((t = r), (n = o)), t;
										})(e),
										n = 0;
									n < 8;
									n++
								)
									(o && 0 === e[n]) ||
										(o && (o = !1),
										r === n ? ((t += n ? ':' : '::'), (o = !0)) : ((t += D(e[n], 16)), n < 7 && (t += ':')));
								return '[' + t + ']';
							}
							return e;
						},
						ae = {},
						se = h({}, ae, { ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1 }),
						le = h({}, se, { '#': 1, '?': 1, '{': 1, '}': 1 }),
						ue = h({}, le, { '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1 }),
						ce = function (e, t) {
							var n = g(e, 0);
							return n > 32 && n < 127 && !p(t, e) ? e : encodeURIComponent(e);
						},
						de = { ftp: 21, file: null, http: 80, https: 443, ws: 80, wss: 443 },
						fe = function (e, t) {
							var n;
							return 2 == e.length && M(z, N(e, 0)) && (':' == (n = N(e, 1)) || (!t && '|' == n));
						},
						pe = function (e) {
							var t;
							return (
								e.length > 1 &&
								fe(Z(e, 0, 2)) &&
								(2 == e.length || '/' === (t = N(e, 2)) || '\\' === t || '?' === t || '#' === t)
							);
						},
						he = function (e) {
							return '.' === e || '%2e' === H(e);
						},
						me = {},
						ve = {},
						ge = {},
						ye = {},
						be = {},
						_e = {},
						we = {},
						Oe = {},
						ke = {},
						xe = {},
						Ee = {},
						Te = {},
						Se = {},
						Ae = {},
						Ce = {},
						Pe = {},
						Re = {},
						Ie = {},
						Ne = {},
						Me = {},
						je = {},
						De = function (e, t, n) {
							var r,
								o,
								i,
								a = b(e);
							if (t) {
								if ((o = this.parse(a))) throw C(o);
								this.searchParams = null;
							} else {
								if ((void 0 !== n && (r = new De(n, !0)), (o = this.parse(a, null, r)))) throw C(o);
								(i = S(new T())).bindURL(this), (this.searchParams = i);
							}
						};
					De.prototype = {
						type: 'URL',
						parse: function (e, t, n) {
							var o,
								i,
								a,
								s,
								l,
								u = this,
								c = t || me,
								d = 0,
								f = '',
								h = !1,
								g = !1,
								y = !1;
							for (
								e = b(e),
									t ||
										((u.scheme = ''),
										(u.username = ''),
										(u.password = ''),
										(u.host = null),
										(u.port = null),
										(u.path = []),
										(u.query = null),
										(u.fragment = null),
										(u.cannotBeABaseURL = !1),
										(e = F(e, re, ''))),
									e = F(e, oe, ''),
									o = m(e);
								d <= o.length;

							) {
								switch (((i = o[d]), c)) {
									case me:
										if (!i || !M(z, i)) {
											if (t) return W;
											c = ge;
											continue;
										}
										(f += H(i)), (c = ve);
										break;
									case ve:
										if (i && (M(G, i) || '+' == i || '-' == i || '.' == i)) f += H(i);
										else {
											if (':' != i) {
												if (t) return W;
												(f = ''), (c = ge), (d = 0);
												continue;
											}
											if (
												t &&
												(u.isSpecial() != p(de, f) ||
													('file' == f && (u.includesCredentials() || null !== u.port)) ||
													('file' == u.scheme && !u.host))
											)
												return;
											if (((u.scheme = f), t)) return void (u.isSpecial() && de[u.scheme] == u.port && (u.port = null));
											(f = ''),
												'file' == u.scheme
													? (c = Ae)
													: u.isSpecial() && n && n.scheme == u.scheme
													? (c = ye)
													: u.isSpecial()
													? (c = Oe)
													: '/' == o[d + 1]
													? ((c = be), d++)
													: ((u.cannotBeABaseURL = !0), U(u.path, ''), (c = Ne));
										}
										break;
									case ge:
										if (!n || (n.cannotBeABaseURL && '#' != i)) return W;
										if (n.cannotBeABaseURL && '#' == i) {
											(u.scheme = n.scheme),
												(u.path = v(n.path)),
												(u.query = n.query),
												(u.fragment = ''),
												(u.cannotBeABaseURL = !0),
												(c = je);
											break;
										}
										c = 'file' == n.scheme ? Ae : _e;
										continue;
									case ye:
										if ('/' != i || '/' != o[d + 1]) {
											c = _e;
											continue;
										}
										(c = ke), d++;
										break;
									case be:
										if ('/' == i) {
											c = xe;
											break;
										}
										c = Ie;
										continue;
									case _e:
										if (((u.scheme = n.scheme), i == r))
											(u.username = n.username),
												(u.password = n.password),
												(u.host = n.host),
												(u.port = n.port),
												(u.path = v(n.path)),
												(u.query = n.query);
										else if ('/' == i || ('\\' == i && u.isSpecial())) c = we;
										else if ('?' == i)
											(u.username = n.username),
												(u.password = n.password),
												(u.host = n.host),
												(u.port = n.port),
												(u.path = v(n.path)),
												(u.query = ''),
												(c = Me);
										else {
											if ('#' != i) {
												(u.username = n.username),
													(u.password = n.password),
													(u.host = n.host),
													(u.port = n.port),
													(u.path = v(n.path)),
													u.path.length--,
													(c = Ie);
												continue;
											}
											(u.username = n.username),
												(u.password = n.password),
												(u.host = n.host),
												(u.port = n.port),
												(u.path = v(n.path)),
												(u.query = n.query),
												(u.fragment = ''),
												(c = je);
										}
										break;
									case we:
										if (!u.isSpecial() || ('/' != i && '\\' != i)) {
											if ('/' != i) {
												(u.username = n.username),
													(u.password = n.password),
													(u.host = n.host),
													(u.port = n.port),
													(c = Ie);
												continue;
											}
											c = xe;
										} else c = ke;
										break;
									case Oe:
										if (((c = ke), '/' != i || '/' != N(f, d + 1))) continue;
										d++;
										break;
									case ke:
										if ('/' != i && '\\' != i) {
											c = xe;
											continue;
										}
										break;
									case xe:
										if ('@' == i) {
											h && (f = '%40' + f), (h = !0), (a = m(f));
											for (var _ = 0; _ < a.length; _++) {
												var w = a[_];
												if (':' != w || y) {
													var O = ce(w, ue);
													y ? (u.password += O) : (u.username += O);
												} else y = !0;
											}
											f = '';
										} else if (i == r || '/' == i || '?' == i || '#' == i || ('\\' == i && u.isSpecial())) {
											if (h && '' == f) return 'Invalid authority';
											(d -= m(f).length + 1), (f = ''), (c = Ee);
										} else f += i;
										break;
									case Ee:
									case Te:
										if (t && 'file' == u.scheme) {
											c = Pe;
											continue;
										}
										if (':' != i || g) {
											if (i == r || '/' == i || '?' == i || '#' == i || ('\\' == i && u.isSpecial())) {
												if (u.isSpecial() && '' == f) return K;
												if (t && '' == f && (u.includesCredentials() || null !== u.port)) return;
												if ((s = u.parseHost(f))) return s;
												if (((f = ''), (c = Re), t)) return;
												continue;
											}
											'[' == i ? (g = !0) : ']' == i && (g = !1), (f += i);
										} else {
											if ('' == f) return K;
											if ((s = u.parseHost(f))) return s;
											if (((f = ''), (c = Se), t == Te)) return;
										}
										break;
									case Se:
										if (!M(Y, i)) {
											if (i == r || '/' == i || '?' == i || '#' == i || ('\\' == i && u.isSpecial()) || t) {
												if ('' != f) {
													var k = P(f, 10);
													if (k > 65535) return $;
													(u.port = u.isSpecial() && k === de[u.scheme] ? null : k), (f = '');
												}
												if (t) return;
												c = Re;
												continue;
											}
											return $;
										}
										f += i;
										break;
									case Ae:
										if (((u.scheme = 'file'), '/' == i || '\\' == i)) c = Ce;
										else {
											if (!n || 'file' != n.scheme) {
												c = Ie;
												continue;
											}
											if (i == r) (u.host = n.host), (u.path = v(n.path)), (u.query = n.query);
											else if ('?' == i) (u.host = n.host), (u.path = v(n.path)), (u.query = ''), (c = Me);
											else {
												if ('#' != i) {
													pe(j(v(o, d), '')) || ((u.host = n.host), (u.path = v(n.path)), u.shortenPath()), (c = Ie);
													continue;
												}
												(u.host = n.host), (u.path = v(n.path)), (u.query = n.query), (u.fragment = ''), (c = je);
											}
										}
										break;
									case Ce:
										if ('/' == i || '\\' == i) {
											c = Pe;
											break;
										}
										n &&
											'file' == n.scheme &&
											!pe(j(v(o, d), '')) &&
											(fe(n.path[0], !0) ? U(u.path, n.path[0]) : (u.host = n.host)),
											(c = Ie);
										continue;
									case Pe:
										if (i == r || '/' == i || '\\' == i || '?' == i || '#' == i) {
											if (!t && fe(f)) c = Ie;
											else if ('' == f) {
												if (((u.host = ''), t)) return;
												c = Re;
											} else {
												if ((s = u.parseHost(f))) return s;
												if (('localhost' == u.host && (u.host = ''), t)) return;
												(f = ''), (c = Re);
											}
											continue;
										}
										f += i;
										break;
									case Re:
										if (u.isSpecial()) {
											if (((c = Ie), '/' != i && '\\' != i)) continue;
										} else if (t || '?' != i)
											if (t || '#' != i) {
												if (i != r && ((c = Ie), '/' != i)) continue;
											} else (u.fragment = ''), (c = je);
										else (u.query = ''), (c = Me);
										break;
									case Ie:
										if (i == r || '/' == i || ('\\' == i && u.isSpecial()) || (!t && ('?' == i || '#' == i))) {
											if (
												('..' === (l = H((l = f))) || '%2e.' === l || '.%2e' === l || '%2e%2e' === l
													? (u.shortenPath(), '/' == i || ('\\' == i && u.isSpecial()) || U(u.path, ''))
													: he(f)
													? '/' == i || ('\\' == i && u.isSpecial()) || U(u.path, '')
													: ('file' == u.scheme &&
															!u.path.length &&
															fe(f) &&
															(u.host && (u.host = ''), (f = N(f, 0) + ':')),
													  U(u.path, f)),
												(f = ''),
												'file' == u.scheme && (i == r || '?' == i || '#' == i))
											)
												for (; u.path.length > 1 && '' === u.path[0]; ) B(u.path);
											'?' == i ? ((u.query = ''), (c = Me)) : '#' == i && ((u.fragment = ''), (c = je));
										} else f += ce(i, le);
										break;
									case Ne:
										'?' == i
											? ((u.query = ''), (c = Me))
											: '#' == i
											? ((u.fragment = ''), (c = je))
											: i != r && (u.path[0] += ce(i, ae));
										break;
									case Me:
										t || '#' != i
											? i != r &&
											  ("'" == i && u.isSpecial() ? (u.query += '%27') : (u.query += '#' == i ? '%23' : ce(i, ae)))
											: ((u.fragment = ''), (c = je));
										break;
									case je:
										i != r && (u.fragment += ce(i, se));
								}
								d++;
							}
						},
						parseHost: function (e) {
							var t, n, r;
							if ('[' == N(e, 0)) {
								if (']' != N(e, e.length - 1)) return K;
								if (
									((t = (function (e) {
										var t,
											n,
											r,
											o,
											i,
											a,
											s,
											l = [0, 0, 0, 0, 0, 0, 0, 0],
											u = 0,
											c = null,
											d = 0,
											f = function () {
												return N(e, d);
											};
										if (':' == f()) {
											if (':' != N(e, 1)) return;
											(d += 2), (c = ++u);
										}
										for (; f(); ) {
											if (8 == u) return;
											if (':' != f()) {
												for (t = n = 0; n < 4 && M(ee, f()); ) (t = 16 * t + P(f(), 16)), d++, n++;
												if ('.' == f()) {
													if (0 == n) return;
													if (((d -= n), u > 6)) return;
													for (r = 0; f(); ) {
														if (((o = null), r > 0)) {
															if (!('.' == f() && r < 4)) return;
															d++;
														}
														if (!M(Y, f())) return;
														for (; M(Y, f()); ) {
															if (((i = P(f(), 10)), null === o)) o = i;
															else {
																if (0 == o) return;
																o = 10 * o + i;
															}
															if (o > 255) return;
															d++;
														}
														(l[u] = 256 * l[u] + o), (2 != ++r && 4 != r) || u++;
													}
													if (4 != r) return;
													break;
												}
												if (':' == f()) {
													if ((d++, !f())) return;
												} else if (f()) return;
												l[u++] = t;
											} else {
												if (null !== c) return;
												d++, (c = ++u);
											}
										}
										if (null !== c)
											for (a = u - c, u = 7; 0 != u && a > 0; ) (s = l[u]), (l[u--] = l[c + a - 1]), (l[c + --a] = s);
										else if (8 != u) return;
										return l;
									})(Z(e, 1, -1))),
									!t)
								)
									return K;
								this.host = t;
							} else if (this.isSpecial()) {
								if (((e = y(e)), M(te, e))) return K;
								if (
									((t = (function (e) {
										var t,
											n,
											r,
											o,
											i,
											a,
											s,
											l = V(e, '.');
										if ((l.length && '' == l[l.length - 1] && l.length--, (t = l.length) > 4)) return e;
										for (n = [], r = 0; r < t; r++) {
											if ('' == (o = l[r])) return e;
											if (
												((i = 10),
												o.length > 1 && '0' == N(o, 0) && ((i = M(J, o) ? 16 : 8), (o = Z(o, 8 == i ? 1 : 2))),
												'' === o)
											)
												a = 0;
											else {
												if (!M(10 == i ? X : 8 == i ? Q : ee, o)) return e;
												a = P(o, i);
											}
											U(n, a);
										}
										for (r = 0; r < t; r++)
											if (((a = n[r]), r == t - 1)) {
												if (a >= I(256, 5 - t)) return null;
											} else if (a > 255) return null;
										for (s = L(n), r = 0; r < n.length; r++) s += n[r] * I(256, 3 - r);
										return s;
									})(e)),
									null === t)
								)
									return K;
								this.host = t;
							} else {
								if (M(ne, e)) return K;
								for (t = '', n = m(e), r = 0; r < n.length; r++) t += ce(n[r], ae);
								this.host = t;
							}
						},
						cannotHaveUsernamePasswordPort: function () {
							return !this.host || this.cannotBeABaseURL || 'file' == this.scheme;
						},
						includesCredentials: function () {
							return '' != this.username || '' != this.password;
						},
						isSpecial: function () {
							return p(de, this.scheme);
						},
						shortenPath: function () {
							var e = this.path,
								t = e.length;
							!t || ('file' == this.scheme && 1 == t && fe(e[0], !0)) || e.length--;
						},
						serialize: function () {
							var e = this,
								t = e.scheme,
								n = e.username,
								r = e.password,
								o = e.host,
								i = e.port,
								a = e.path,
								s = e.query,
								l = e.fragment,
								u = t + ':';
							return (
								null !== o
									? ((u += '//'),
									  e.includesCredentials() && (u += n + (r ? ':' + r : '') + '@'),
									  (u += ie(o)),
									  null !== i && (u += ':' + i))
									: 'file' == t && (u += '//'),
								(u += e.cannotBeABaseURL ? a[0] : a.length ? '/' + j(a, '/') : ''),
								null !== s && (u += '?' + s),
								null !== l && (u += '#' + l),
								u
							);
						},
						setHref: function (e) {
							var t = this.parse(e);
							if (t) throw C(t);
							this.searchParams.update();
						},
						getOrigin: function () {
							var e = this.scheme,
								t = this.port;
							if ('blob' == e)
								try {
									return new Le(e.path[0]).origin;
								} catch (e) {
									return 'null';
								}
							return 'file' != e && this.isSpecial() ? e + '://' + ie(this.host) + (null !== t ? ':' + t : '') : 'null';
						},
						getProtocol: function () {
							return this.scheme + ':';
						},
						setProtocol: function (e) {
							this.parse(b(e) + ':', me);
						},
						getUsername: function () {
							return this.username;
						},
						setUsername: function (e) {
							var t = m(b(e));
							if (!this.cannotHaveUsernamePasswordPort()) {
								this.username = '';
								for (var n = 0; n < t.length; n++) this.username += ce(t[n], ue);
							}
						},
						getPassword: function () {
							return this.password;
						},
						setPassword: function (e) {
							var t = m(b(e));
							if (!this.cannotHaveUsernamePasswordPort()) {
								this.password = '';
								for (var n = 0; n < t.length; n++) this.password += ce(t[n], ue);
							}
						},
						getHost: function () {
							var e = this.host,
								t = this.port;
							return null === e ? '' : null === t ? ie(e) : ie(e) + ':' + t;
						},
						setHost: function (e) {
							this.cannotBeABaseURL || this.parse(e, Ee);
						},
						getHostname: function () {
							var e = this.host;
							return null === e ? '' : ie(e);
						},
						setHostname: function (e) {
							this.cannotBeABaseURL || this.parse(e, Te);
						},
						getPort: function () {
							var e = this.port;
							return null === e ? '' : b(e);
						},
						setPort: function (e) {
							this.cannotHaveUsernamePasswordPort() || ('' == (e = b(e)) ? (this.port = null) : this.parse(e, Se));
						},
						getPathname: function () {
							var e = this.path;
							return this.cannotBeABaseURL ? e[0] : e.length ? '/' + j(e, '/') : '';
						},
						setPathname: function (e) {
							this.cannotBeABaseURL || ((this.path = []), this.parse(e, Re));
						},
						getSearch: function () {
							var e = this.query;
							return e ? '?' + e : '';
						},
						setSearch: function (e) {
							'' == (e = b(e))
								? (this.query = null)
								: ('?' == N(e, 0) && (e = Z(e, 1)), (this.query = ''), this.parse(e, Me)),
								this.searchParams.update();
						},
						getSearchParams: function () {
							return this.searchParams.facade;
						},
						getHash: function () {
							var e = this.fragment;
							return e ? '#' + e : '';
						},
						setHash: function (e) {
							'' != (e = b(e))
								? ('#' == N(e, 0) && (e = Z(e, 1)), (this.fragment = ''), this.parse(e, je))
								: (this.fragment = null);
						},
						update: function () {
							this.query = this.searchParams.serialize() || null;
						},
					};
					var Le = function (e) {
							var t = f(this, Ue),
								n = w(arguments.length, 1) > 1 ? arguments[1] : void 0,
								r = x(t, new De(e, !1, n));
							i ||
								((t.href = r.serialize()),
								(t.origin = r.getOrigin()),
								(t.protocol = r.getProtocol()),
								(t.username = r.getUsername()),
								(t.password = r.getPassword()),
								(t.host = r.getHost()),
								(t.hostname = r.getHostname()),
								(t.port = r.getPort()),
								(t.pathname = r.getPathname()),
								(t.search = r.getSearch()),
								(t.searchParams = r.getSearchParams()),
								(t.hash = r.getHash()));
						},
						Ue = Le.prototype,
						Fe = function (e, t) {
							return {
								get: function () {
									return E(this)[e]();
								},
								set:
									t &&
									function (e) {
										return E(this)[t](e);
									},
								configurable: !0,
								enumerable: !0,
							};
						};
					if (
						(i &&
							(d(Ue, 'href', Fe('serialize', 'setHref')),
							d(Ue, 'origin', Fe('getOrigin')),
							d(Ue, 'protocol', Fe('getProtocol', 'setProtocol')),
							d(Ue, 'username', Fe('getUsername', 'setUsername')),
							d(Ue, 'password', Fe('getPassword', 'setPassword')),
							d(Ue, 'host', Fe('getHost', 'setHost')),
							d(Ue, 'hostname', Fe('getHostname', 'setHostname')),
							d(Ue, 'port', Fe('getPort', 'setPort')),
							d(Ue, 'pathname', Fe('getPathname', 'setPathname')),
							d(Ue, 'search', Fe('getSearch', 'setSearch')),
							d(Ue, 'searchParams', Fe('getSearchParams')),
							d(Ue, 'hash', Fe('getHash', 'setHash'))),
						c(
							Ue,
							'toJSON',
							function () {
								return E(this).serialize();
							},
							{ enumerable: !0 }
						),
						c(
							Ue,
							'toString',
							function () {
								return E(this).serialize();
							},
							{ enumerable: !0 }
						),
						A)
					) {
						var Be = A.createObjectURL,
							Ve = A.revokeObjectURL;
						Be && c(Le, 'createObjectURL', l(Be, A)), Ve && c(Le, 'revokeObjectURL', l(Ve, A));
					}
					_(Le, 'URL'), o({ global: !0, constructor: !0, forced: !a, sham: !i }, { URL: Le });
				},
				5111: function (e, t, n) {
					n(66709);
				},
				41863: function (e, t, n) {
					'use strict';
					var r = n(56475),
						o = n(2834);
					r(
						{ target: 'URL', proto: !0, enumerable: !0 },
						{
							toJSON: function () {
								return o(URL.prototype.toString, this);
							},
						}
					);
				},
				54068: function (e, t, n) {
					var r = n(69601);
					e.exports = r;
				},
				18209: function (e, t, n) {
					var r = n(93504);
					e.exports = r;
				},
				7866: function (e, t, n) {
					var r = n(79391);
					e.exports = r;
				},
				82903: function (e, t, n) {
					var r = n(47446);
					e.exports = r;
				},
				25207: function (e, t, n) {
					var r = n(89452);
					e.exports = r;
				},
				15836: function (e, t, n) {
					var r = n(15369);
					e.exports = r;
				},
				31227: function (e, t, n) {
					var r = n(95680);
					n(94712), (e.exports = r);
				},
				57650: function (e, t, n) {
					var r = n(79749);
					e.exports = r;
				},
				71081: function (e, t, n) {
					var r = n(87362);
					e.exports = r;
				},
				9956: function (e, t, n) {
					var r = n(83043);
					e.exports = r;
				},
				86797: function (e, t, n) {
					var r = n(48506);
					n(94712), (e.exports = r);
				},
				47255: function (e, t, n) {
					var r = n(47762);
					e.exports = r;
				},
				67437: function (e, t, n) {
					var r = n(5694);
					e.exports = r;
				},
				55458: function (e, t, n) {
					var r = n(5671);
					e.exports = r;
				},
				52653: function (e, t, n) {
					var r = n(4154);
					n(94712), (e.exports = r);
				},
				61068: function (e, t, n) {
					var r = n(20845);
					n(94712), (e.exports = r);
				},
				33268: function (e, t, n) {
					n(5111), n(41863), n(97027);
					var r = n(11206);
					e.exports = r.URL;
				},
				21147: function (e, t) {
					var n = 'undefined' != typeof self ? self : this,
						r = (function () {
							function e() {
								(this.fetch = !1), (this.DOMException = n.DOMException);
							}
							return (e.prototype = n), new e();
						})();
					!(function (e) {
						!(function (t) {
							var n = 'URLSearchParams' in e,
								r = 'Symbol' in e && 'iterator' in Symbol,
								o =
									'FileReader' in e &&
									'Blob' in e &&
									(function () {
										try {
											return new Blob(), !0;
										} catch (e) {
											return !1;
										}
									})(),
								i = 'FormData' in e,
								a = 'ArrayBuffer' in e;
							if (a)
								var s = [
										'[object Int8Array]',
										'[object Uint8Array]',
										'[object Uint8ClampedArray]',
										'[object Int16Array]',
										'[object Uint16Array]',
										'[object Int32Array]',
										'[object Uint32Array]',
										'[object Float32Array]',
										'[object Float64Array]',
									],
									l =
										ArrayBuffer.isView ||
										function (e) {
											return e && s.indexOf(Object.prototype.toString.call(e)) > -1;
										};
							function u(e) {
								if (('string' != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)))
									throw new TypeError('Invalid character in header field name');
								return e.toLowerCase();
							}
							function c(e) {
								return 'string' != typeof e && (e = String(e)), e;
							}
							function d(e) {
								var t = {
									next: function () {
										var t = e.shift();
										return { done: void 0 === t, value: t };
									},
								};
								return (
									r &&
										(t[Symbol.iterator] = function () {
											return t;
										}),
									t
								);
							}
							function f(e) {
								(this.map = {}),
									e instanceof f
										? e.forEach(function (e, t) {
												this.append(t, e);
										  }, this)
										: Array.isArray(e)
										? e.forEach(function (e) {
												this.append(e[0], e[1]);
										  }, this)
										: e &&
										  Object.getOwnPropertyNames(e).forEach(function (t) {
												this.append(t, e[t]);
										  }, this);
							}
							function p(e) {
								if (e.bodyUsed) return Promise.reject(new TypeError('Already read'));
								e.bodyUsed = !0;
							}
							function h(e) {
								return new Promise(function (t, n) {
									(e.onload = function () {
										t(e.result);
									}),
										(e.onerror = function () {
											n(e.error);
										});
								});
							}
							function m(e) {
								var t = new FileReader(),
									n = h(t);
								return t.readAsArrayBuffer(e), n;
							}
							function v(e) {
								if (e.slice) return e.slice(0);
								var t = new Uint8Array(e.byteLength);
								return t.set(new Uint8Array(e)), t.buffer;
							}
							function g() {
								return (
									(this.bodyUsed = !1),
									(this._initBody = function (e) {
										var t;
										(this._bodyInit = e),
											e
												? 'string' == typeof e
													? (this._bodyText = e)
													: o && Blob.prototype.isPrototypeOf(e)
													? (this._bodyBlob = e)
													: i && FormData.prototype.isPrototypeOf(e)
													? (this._bodyFormData = e)
													: n && URLSearchParams.prototype.isPrototypeOf(e)
													? (this._bodyText = e.toString())
													: a && o && (t = e) && DataView.prototype.isPrototypeOf(t)
													? ((this._bodyArrayBuffer = v(e.buffer)),
													  (this._bodyInit = new Blob([this._bodyArrayBuffer])))
													: a && (ArrayBuffer.prototype.isPrototypeOf(e) || l(e))
													? (this._bodyArrayBuffer = v(e))
													: (this._bodyText = e = Object.prototype.toString.call(e))
												: (this._bodyText = ''),
											this.headers.get('content-type') ||
												('string' == typeof e
													? this.headers.set('content-type', 'text/plain;charset=UTF-8')
													: this._bodyBlob && this._bodyBlob.type
													? this.headers.set('content-type', this._bodyBlob.type)
													: n &&
													  URLSearchParams.prototype.isPrototypeOf(e) &&
													  this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8'));
									}),
									o &&
										((this.blob = function () {
											var e = p(this);
											if (e) return e;
											if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
											if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
											if (this._bodyFormData) throw new Error('could not read FormData body as blob');
											return Promise.resolve(new Blob([this._bodyText]));
										}),
										(this.arrayBuffer = function () {
											return this._bodyArrayBuffer
												? p(this) || Promise.resolve(this._bodyArrayBuffer)
												: this.blob().then(m);
										})),
									(this.text = function () {
										var e,
											t,
											n,
											r = p(this);
										if (r) return r;
										if (this._bodyBlob)
											return (e = this._bodyBlob), (t = new FileReader()), (n = h(t)), t.readAsText(e), n;
										if (this._bodyArrayBuffer)
											return Promise.resolve(
												(function (e) {
													for (var t = new Uint8Array(e), n = new Array(t.length), r = 0; r < t.length; r++)
														n[r] = String.fromCharCode(t[r]);
													return n.join('');
												})(this._bodyArrayBuffer)
											);
										if (this._bodyFormData) throw new Error('could not read FormData body as text');
										return Promise.resolve(this._bodyText);
									}),
									i &&
										(this.formData = function () {
											return this.text().then(_);
										}),
									(this.json = function () {
										return this.text().then(JSON.parse);
									}),
									this
								);
							}
							(f.prototype.append = function (e, t) {
								(e = u(e)), (t = c(t));
								var n = this.map[e];
								this.map[e] = n ? n + ', ' + t : t;
							}),
								(f.prototype.delete = function (e) {
									delete this.map[u(e)];
								}),
								(f.prototype.get = function (e) {
									return (e = u(e)), this.has(e) ? this.map[e] : null;
								}),
								(f.prototype.has = function (e) {
									return this.map.hasOwnProperty(u(e));
								}),
								(f.prototype.set = function (e, t) {
									this.map[u(e)] = c(t);
								}),
								(f.prototype.forEach = function (e, t) {
									for (var n in this.map) this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
								}),
								(f.prototype.keys = function () {
									var e = [];
									return (
										this.forEach(function (t, n) {
											e.push(n);
										}),
										d(e)
									);
								}),
								(f.prototype.values = function () {
									var e = [];
									return (
										this.forEach(function (t) {
											e.push(t);
										}),
										d(e)
									);
								}),
								(f.prototype.entries = function () {
									var e = [];
									return (
										this.forEach(function (t, n) {
											e.push([n, t]);
										}),
										d(e)
									);
								}),
								r && (f.prototype[Symbol.iterator] = f.prototype.entries);
							var y = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
							function b(e, t) {
								var n,
									r,
									o = (t = t || {}).body;
								if (e instanceof b) {
									if (e.bodyUsed) throw new TypeError('Already read');
									(this.url = e.url),
										(this.credentials = e.credentials),
										t.headers || (this.headers = new f(e.headers)),
										(this.method = e.method),
										(this.mode = e.mode),
										(this.signal = e.signal),
										o || null == e._bodyInit || ((o = e._bodyInit), (e.bodyUsed = !0));
								} else this.url = String(e);
								if (
									((this.credentials = t.credentials || this.credentials || 'same-origin'),
									(!t.headers && this.headers) || (this.headers = new f(t.headers)),
									(this.method =
										((n = t.method || this.method || 'GET'), (r = n.toUpperCase()), y.indexOf(r) > -1 ? r : n)),
									(this.mode = t.mode || this.mode || null),
									(this.signal = t.signal || this.signal),
									(this.referrer = null),
									('GET' === this.method || 'HEAD' === this.method) && o)
								)
									throw new TypeError('Body not allowed for GET or HEAD requests');
								this._initBody(o);
							}
							function _(e) {
								var t = new FormData();
								return (
									e
										.trim()
										.split('&')
										.forEach(function (e) {
											if (e) {
												var n = e.split('='),
													r = n.shift().replace(/\+/g, ' '),
													o = n.join('=').replace(/\+/g, ' ');
												t.append(decodeURIComponent(r), decodeURIComponent(o));
											}
										}),
									t
								);
							}
							function w(e, t) {
								t || (t = {}),
									(this.type = 'default'),
									(this.status = void 0 === t.status ? 200 : t.status),
									(this.ok = this.status >= 200 && this.status < 300),
									(this.statusText = 'statusText' in t ? t.statusText : 'OK'),
									(this.headers = new f(t.headers)),
									(this.url = t.url || ''),
									this._initBody(e);
							}
							(b.prototype.clone = function () {
								return new b(this, { body: this._bodyInit });
							}),
								g.call(b.prototype),
								g.call(w.prototype),
								(w.prototype.clone = function () {
									return new w(this._bodyInit, {
										status: this.status,
										statusText: this.statusText,
										headers: new f(this.headers),
										url: this.url,
									});
								}),
								(w.error = function () {
									var e = new w(null, { status: 0, statusText: '' });
									return (e.type = 'error'), e;
								});
							var O = [301, 302, 303, 307, 308];
							(w.redirect = function (e, t) {
								if (-1 === O.indexOf(t)) throw new RangeError('Invalid status code');
								return new w(null, { status: t, headers: { location: e } });
							}),
								(t.DOMException = e.DOMException);
							try {
								new t.DOMException();
							} catch (e) {
								(t.DOMException = function (e, t) {
									(this.message = e), (this.name = t);
									var n = Error(e);
									this.stack = n.stack;
								}),
									(t.DOMException.prototype = Object.create(Error.prototype)),
									(t.DOMException.prototype.constructor = t.DOMException);
							}
							function k(e, n) {
								return new Promise(function (r, i) {
									var a = new b(e, n);
									if (a.signal && a.signal.aborted) return i(new t.DOMException('Aborted', 'AbortError'));
									var s = new XMLHttpRequest();
									function l() {
										s.abort();
									}
									(s.onload = function () {
										var e,
											t,
											n = {
												status: s.status,
												statusText: s.statusText,
												headers:
													((e = s.getAllResponseHeaders() || ''),
													(t = new f()),
													e
														.replace(/\r?\n[\t ]+/g, ' ')
														.split(/\r?\n/)
														.forEach(function (e) {
															var n = e.split(':'),
																r = n.shift().trim();
															if (r) {
																var o = n.join(':').trim();
																t.append(r, o);
															}
														}),
													t),
											};
										n.url = 'responseURL' in s ? s.responseURL : n.headers.get('X-Request-URL');
										var o = 'response' in s ? s.response : s.responseText;
										r(new w(o, n));
									}),
										(s.onerror = function () {
											i(new TypeError('Network request failed'));
										}),
										(s.ontimeout = function () {
											i(new TypeError('Network request failed'));
										}),
										(s.onabort = function () {
											i(new t.DOMException('Aborted', 'AbortError'));
										}),
										s.open(a.method, a.url, !0),
										'include' === a.credentials
											? (s.withCredentials = !0)
											: 'omit' === a.credentials && (s.withCredentials = !1),
										'responseType' in s && o && (s.responseType = 'blob'),
										a.headers.forEach(function (e, t) {
											s.setRequestHeader(t, e);
										}),
										a.signal &&
											(a.signal.addEventListener('abort', l),
											(s.onreadystatechange = function () {
												4 === s.readyState && a.signal.removeEventListener('abort', l);
											})),
										s.send(void 0 === a._bodyInit ? null : a._bodyInit);
								});
							}
							(k.polyfill = !0),
								e.fetch || ((e.fetch = k), (e.Headers = f), (e.Request = b), (e.Response = w)),
								(t.Headers = f),
								(t.Request = b),
								(t.Response = w),
								(t.fetch = k),
								Object.defineProperty(t, '__esModule', { value: !0 });
						})({});
					})(r),
						(r.fetch.ponyfill = !0),
						delete r.fetch.polyfill;
					var o = r;
					((t = o.fetch).default = o.fetch),
						(t.fetch = o.fetch),
						(t.Headers = o.Headers),
						(t.Request = o.Request),
						(t.Response = o.Response),
						(e.exports = t);
				},
				66150: function (e) {
					if ('undefined' != typeof Element && !Element.prototype.matches) {
						var t = Element.prototype;
						t.matches =
							t.matchesSelector ||
							t.mozMatchesSelector ||
							t.msMatchesSelector ||
							t.oMatchesSelector ||
							t.webkitMatchesSelector;
					}
					e.exports = function (e, t) {
						for (; e && 9 !== e.nodeType; ) {
							if ('function' == typeof e.matches && e.matches(t)) return e;
							e = e.parentNode;
						}
					};
				},
				88458: function (e, t, n) {
					var r = n(66150);
					function o(e, t, n, r, o) {
						var a = i.apply(this, arguments);
						return (
							e.addEventListener(n, a, o),
							{
								destroy: function () {
									e.removeEventListener(n, a, o);
								},
							}
						);
					}
					function i(e, t, n, o) {
						return function (n) {
							(n.delegateTarget = r(n.target, t)), n.delegateTarget && o.call(e, n);
						};
					}
					e.exports = function (e, t, n, r, i) {
						return 'function' == typeof e.addEventListener
							? o.apply(null, arguments)
							: 'function' == typeof n
							? o.bind(null, document).apply(null, arguments)
							: ('string' == typeof e && (e = document.querySelectorAll(e)),
							  Array.prototype.map.call(e, function (e) {
									return o(e, t, n, r, i);
							  }));
					};
				},
				23582: function () {
					!(function (e) {
						'use strict';
						function t(e) {
							for (var t = 0, n = Math.min(65536, e.length + 1), r = new Uint16Array(n), o = [], i = 0; ; ) {
								var a = t < e.length;
								if (!a || i >= n - 1) {
									var s = r.subarray(0, i);
									if ((o.push(String.fromCharCode.apply(null, s)), !a)) return o.join('');
									(e = e.subarray(t)), (t = 0), (i = 0);
								}
								var l = e[t++];
								if (0 == (128 & l)) r[i++] = l;
								else if (192 == (224 & l)) {
									var u = 63 & e[t++];
									r[i++] = ((31 & l) << 6) | u;
								} else if (224 == (240 & l)) {
									u = 63 & e[t++];
									var c = 63 & e[t++];
									r[i++] = ((31 & l) << 12) | (u << 6) | c;
								} else if (240 == (248 & l)) {
									var d = ((7 & l) << 18) | ((u = 63 & e[t++]) << 12) | ((c = 63 & e[t++]) << 6) | (63 & e[t++]);
									d > 65535 && ((d -= 65536), (r[i++] = ((d >>> 10) & 1023) | 55296), (d = 56320 | (1023 & d))),
										(r[i++] = d);
								}
							}
						}
						var n = 'Failed to ',
							r = function (e, t, r) {
								if (e) throw new Error(''.concat(n).concat(t, ": the '").concat(r, "' option is unsupported."));
							},
							o = 'function' == typeof Buffer && Buffer.from,
							i = o
								? function (e) {
										return Buffer.from(e);
								  }
								: function (e) {
										for (
											var t = 0,
												n = e.length,
												r = 0,
												o = Math.max(32, n + (n >>> 1) + 7),
												i = new Uint8Array((o >>> 3) << 3);
											t < n;

										) {
											var a = e.charCodeAt(t++);
											if (a >= 55296 && a <= 56319) {
												if (t < n) {
													var s = e.charCodeAt(t);
													56320 == (64512 & s) && (++t, (a = ((1023 & a) << 10) + (1023 & s) + 65536));
												}
												if (a >= 55296 && a <= 56319) continue;
											}
											if (r + 4 > i.length) {
												(o += 8), (o = ((o *= 1 + (t / e.length) * 2) >>> 3) << 3);
												var l = new Uint8Array(o);
												l.set(i), (i = l);
											}
											if (0 != (4294967168 & a)) {
												if (0 == (4294965248 & a)) i[r++] = ((a >>> 6) & 31) | 192;
												else if (0 == (4294901760 & a))
													(i[r++] = ((a >>> 12) & 15) | 224), (i[r++] = ((a >>> 6) & 63) | 128);
												else {
													if (0 != (4292870144 & a)) continue;
													(i[r++] = ((a >>> 18) & 7) | 240),
														(i[r++] = ((a >>> 12) & 63) | 128),
														(i[r++] = ((a >>> 6) & 63) | 128);
												}
												i[r++] = (63 & a) | 128;
											} else i[r++] = a;
										}
										return i.slice ? i.slice(0, r) : i.subarray(0, r);
								  };
						function a() {
							this.encoding = 'utf-8';
						}
						a.prototype.encode = function (e, t) {
							return r(t && t.stream, 'encode', 'stream'), i(e);
						};
						var s =
								!o && 'function' == typeof Blob && 'function' == typeof URL && 'function' == typeof URL.createObjectURL,
							l = ['utf-8', 'utf8', 'unicode-1-1-utf-8'],
							u = t;
						o
							? (u = function (e, t) {
									return (e instanceof Buffer ? e : Buffer.from(e.buffer, e.byteOffset, e.byteLength)).toString(t);
							  })
							: s &&
							  (u = function (e) {
									try {
										return (function (e) {
											var t;
											try {
												var n = new Blob([e], { type: 'text/plain;charset=UTF-8' });
												t = URL.createObjectURL(n);
												var r = new XMLHttpRequest();
												return r.open('GET', t, !1), r.send(), r.responseText;
											} finally {
												t && URL.revokeObjectURL(t);
											}
										})(e);
									} catch (n) {
										return t(e);
									}
							  });
						var c = "construct 'TextDecoder'",
							d = ''.concat(n, ' ').concat(c, ': the ');
						function f(e, t) {
							if (
								(r(t && t.fatal, c, 'fatal'),
								(e = e || 'utf-8'),
								!(o ? Buffer.isEncoding(e) : -1 !== l.indexOf(e.toLowerCase())))
							)
								throw new RangeError(''.concat(d, " encoding label provided ('").concat(e, "') is invalid."));
							(this.encoding = e), (this.fatal = !1), (this.ignoreBOM = !1);
						}
						(f.prototype.decode = function (e, t) {
							var n;
							return (
								r(t && t.stream, 'decode', 'stream'),
								(n =
									e instanceof Uint8Array
										? e
										: e.buffer instanceof ArrayBuffer
										? new Uint8Array(e.buffer)
										: new Uint8Array(e)),
								u(n, this.encoding)
							);
						}),
							(e.TextEncoder = e.TextEncoder || a),
							(e.TextDecoder = e.TextDecoder || f);
					})('undefined' != typeof window ? window : 'undefined' != typeof global ? global : this);
				},
				20534: function (e, t) {
					(t.node = function (e) {
						return void 0 !== e && e instanceof HTMLElement && 1 === e.nodeType;
					}),
						(t.nodeList = function (e) {
							var n = Object.prototype.toString.call(e);
							return (
								void 0 !== e &&
								('[object NodeList]' === n || '[object HTMLCollection]' === n) &&
								'length' in e &&
								(0 === e.length || t.node(e[0]))
							);
						}),
						(t.string = function (e) {
							return 'string' == typeof e || e instanceof String;
						}),
						(t.fn = function (e) {
							return '[object Function]' === Object.prototype.toString.call(e);
						});
				},
				21617: function (e, t, n) {
					var r = n(20534),
						o = n(88458);
					e.exports = function (e, t, n) {
						if (!e && !t && !n) throw new Error('Missing required arguments');
						if (!r.string(t)) throw new TypeError('Second argument must be a String');
						if (!r.fn(n)) throw new TypeError('Third argument must be a Function');
						if (r.node(e))
							return (function (e, t, n) {
								return (
									e.addEventListener(t, n),
									{
										destroy: function () {
											e.removeEventListener(t, n);
										},
									}
								);
							})(e, t, n);
						if (r.nodeList(e))
							return (function (e, t, n) {
								return (
									Array.prototype.forEach.call(e, function (e) {
										e.addEventListener(t, n);
									}),
									{
										destroy: function () {
											Array.prototype.forEach.call(e, function (e) {
												e.removeEventListener(t, n);
											});
										},
									}
								);
							})(e, t, n);
						if (r.string(e))
							return (function (e, t, n) {
								return o(document.body, e, t, n);
							})(e, t, n);
						throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
					};
				},
				79602: function (e, t) {
					var n;
					/*!
					 * jQuery JavaScript Library v3.6.1
					 * https://jquery.com/
					 *
					 * Includes Sizzle.js
					 * https://sizzlejs.com/
					 *
					 * Copyright OpenJS Foundation and other contributors
					 * Released under the MIT license
					 * https://jquery.org/license
					 *
					 * Date: 2022-08-26T17:52Z
					 */ !(function (t, n) {
						'use strict';
						'object' == typeof e.exports
							? (e.exports = t.document
									? n(t, !0)
									: function (e) {
											if (!e.document) throw new Error('jQuery requires a window with a document');
											return n(e);
									  })
							: n(t);
					})('undefined' != typeof window ? window : this, function (r, o) {
						'use strict';
						var i = [],
							a = Object.getPrototypeOf,
							s = i.slice,
							l = i.flat
								? function (e) {
										return i.flat.call(e);
								  }
								: function (e) {
										return i.concat.apply([], e);
								  },
							u = i.push,
							c = i.indexOf,
							d = {},
							f = d.toString,
							p = d.hasOwnProperty,
							h = p.toString,
							m = h.call(Object),
							v = {},
							g = function (e) {
								return 'function' == typeof e && 'number' != typeof e.nodeType && 'function' != typeof e.item;
							},
							y = function (e) {
								return null != e && e === e.window;
							},
							b = r.document,
							_ = { type: !0, src: !0, nonce: !0, noModule: !0 };
						function w(e, t, n) {
							var r,
								o,
								i = (n = n || b).createElement('script');
							if (((i.text = e), t))
								for (r in _) (o = t[r] || (t.getAttribute && t.getAttribute(r))) && i.setAttribute(r, o);
							n.head.appendChild(i).parentNode.removeChild(i);
						}
						function O(e) {
							return null == e
								? e + ''
								: 'object' == typeof e || 'function' == typeof e
								? d[f.call(e)] || 'object'
								: typeof e;
						}
						var k = '3.6.1',
							x = function (e, t) {
								return new x.fn.init(e, t);
							};
						function E(e) {
							var t = !!e && 'length' in e && e.length,
								n = O(e);
							return !g(e) && !y(e) && ('array' === n || 0 === t || ('number' == typeof t && t > 0 && t - 1 in e));
						}
						(x.fn = x.prototype =
							{
								jquery: k,
								constructor: x,
								length: 0,
								toArray: function () {
									return s.call(this);
								},
								get: function (e) {
									return null == e ? s.call(this) : e < 0 ? this[e + this.length] : this[e];
								},
								pushStack: function (e) {
									var t = x.merge(this.constructor(), e);
									return (t.prevObject = this), t;
								},
								each: function (e) {
									return x.each(this, e);
								},
								map: function (e) {
									return this.pushStack(
										x.map(this, function (t, n) {
											return e.call(t, n, t);
										})
									);
								},
								slice: function () {
									return this.pushStack(s.apply(this, arguments));
								},
								first: function () {
									return this.eq(0);
								},
								last: function () {
									return this.eq(-1);
								},
								even: function () {
									return this.pushStack(
										x.grep(this, function (e, t) {
											return (t + 1) % 2;
										})
									);
								},
								odd: function () {
									return this.pushStack(
										x.grep(this, function (e, t) {
											return t % 2;
										})
									);
								},
								eq: function (e) {
									var t = this.length,
										n = +e + (e < 0 ? t : 0);
									return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
								},
								end: function () {
									return this.prevObject || this.constructor();
								},
								push: u,
								sort: i.sort,
								splice: i.splice,
							}),
							(x.extend = x.fn.extend =
								function () {
									var e,
										t,
										n,
										r,
										o,
										i,
										a = arguments[0] || {},
										s = 1,
										l = arguments.length,
										u = !1;
									for (
										'boolean' == typeof a && ((u = a), (a = arguments[s] || {}), s++),
											'object' == typeof a || g(a) || (a = {}),
											s === l && ((a = this), s--);
										s < l;
										s++
									)
										if (null != (e = arguments[s]))
											for (t in e)
												(r = e[t]),
													'__proto__' !== t &&
														a !== r &&
														(u && r && (x.isPlainObject(r) || (o = Array.isArray(r)))
															? ((n = a[t]),
															  (i = o && !Array.isArray(n) ? [] : o || x.isPlainObject(n) ? n : {}),
															  (o = !1),
															  (a[t] = x.extend(u, i, r)))
															: void 0 !== r && (a[t] = r));
									return a;
								}),
							x.extend({
								expando: 'jQuery' + (k + Math.random()).replace(/\D/g, ''),
								isReady: !0,
								error: function (e) {
									throw new Error(e);
								},
								noop: function () {},
								isPlainObject: function (e) {
									var t, n;
									return (
										!(!e || '[object Object]' !== f.call(e)) &&
										(!(t = a(e)) ||
											('function' == typeof (n = p.call(t, 'constructor') && t.constructor) && h.call(n) === m))
									);
								},
								isEmptyObject: function (e) {
									var t;
									for (t in e) return !1;
									return !0;
								},
								globalEval: function (e, t, n) {
									w(e, { nonce: t && t.nonce }, n);
								},
								each: function (e, t) {
									var n,
										r = 0;
									if (E(e)) for (n = e.length; r < n && !1 !== t.call(e[r], r, e[r]); r++);
									else for (r in e) if (!1 === t.call(e[r], r, e[r])) break;
									return e;
								},
								makeArray: function (e, t) {
									var n = t || [];
									return null != e && (E(Object(e)) ? x.merge(n, 'string' == typeof e ? [e] : e) : u.call(n, e)), n;
								},
								inArray: function (e, t, n) {
									return null == t ? -1 : c.call(t, e, n);
								},
								merge: function (e, t) {
									for (var n = +t.length, r = 0, o = e.length; r < n; r++) e[o++] = t[r];
									return (e.length = o), e;
								},
								grep: function (e, t, n) {
									for (var r = [], o = 0, i = e.length, a = !n; o < i; o++) !t(e[o], o) !== a && r.push(e[o]);
									return r;
								},
								map: function (e, t, n) {
									var r,
										o,
										i = 0,
										a = [];
									if (E(e)) for (r = e.length; i < r; i++) null != (o = t(e[i], i, n)) && a.push(o);
									else for (i in e) null != (o = t(e[i], i, n)) && a.push(o);
									return l(a);
								},
								guid: 1,
								support: v,
							}),
							'function' == typeof Symbol && (x.fn[Symbol.iterator] = i[Symbol.iterator]),
							x.each(
								'Boolean Number String Function Array Date RegExp Object Error Symbol'.split(' '),
								function (e, t) {
									d['[object ' + t + ']'] = t.toLowerCase();
								}
							);
						var T =
							/*!
							 * Sizzle CSS Selector Engine v2.3.6
							 * https://sizzlejs.com/
							 *
							 * Copyright JS Foundation and other contributors
							 * Released under the MIT license
							 * https://js.foundation/
							 *
							 * Date: 2021-02-16
							 */
							(function (e) {
								var t,
									n,
									r,
									o,
									i,
									a,
									s,
									l,
									u,
									c,
									d,
									f,
									p,
									h,
									m,
									v,
									g,
									y,
									b,
									_ = 'sizzle' + 1 * new Date(),
									w = e.document,
									O = 0,
									k = 0,
									x = le(),
									E = le(),
									T = le(),
									S = le(),
									A = function (e, t) {
										return e === t && (d = !0), 0;
									},
									C = {}.hasOwnProperty,
									P = [],
									R = P.pop,
									I = P.push,
									N = P.push,
									M = P.slice,
									j = function (e, t) {
										for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
										return -1;
									},
									D =
										'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped',
									L = '[\\x20\\t\\r\\n\\f]',
									U = '(?:\\\\[\\da-fA-F]{1,6}[\\x20\\t\\r\\n\\f]?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+',
									F =
										'\\[[\\x20\\t\\r\\n\\f]*(' +
										U +
										')(?:' +
										L +
										'*([*^$|!~]?=)' +
										L +
										'*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' +
										U +
										'))|)' +
										L +
										'*\\]',
									B =
										':(' +
										U +
										')(?:\\(((\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|' +
										F +
										')*)|.*)\\)|)',
									V = new RegExp(L + '+', 'g'),
									Z = new RegExp('^[\\x20\\t\\r\\n\\f]+|((?:^|[^\\\\])(?:\\\\.)*)[\\x20\\t\\r\\n\\f]+$', 'g'),
									H = new RegExp('^[\\x20\\t\\r\\n\\f]*,[\\x20\\t\\r\\n\\f]*'),
									q = new RegExp('^[\\x20\\t\\r\\n\\f]*([>+~]|[\\x20\\t\\r\\n\\f])[\\x20\\t\\r\\n\\f]*'),
									W = new RegExp(L + '|>'),
									K = new RegExp(B),
									$ = new RegExp('^' + U + '$'),
									z = {
										ID: new RegExp('^#(' + U + ')'),
										CLASS: new RegExp('^\\.(' + U + ')'),
										TAG: new RegExp('^(' + U + '|[*])'),
										ATTR: new RegExp('^' + F),
										PSEUDO: new RegExp('^' + B),
										CHILD: new RegExp(
											'^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\([\\x20\\t\\r\\n\\f]*(even|odd|(([+-]|)(\\d*)n|)[\\x20\\t\\r\\n\\f]*(?:([+-]|)[\\x20\\t\\r\\n\\f]*(\\d+)|))[\\x20\\t\\r\\n\\f]*\\)|)',
											'i'
										),
										bool: new RegExp('^(?:' + D + ')$', 'i'),
										needsContext: new RegExp(
											'^[\\x20\\t\\r\\n\\f]*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\([\\x20\\t\\r\\n\\f]*((?:-\\d)?\\d*)[\\x20\\t\\r\\n\\f]*\\)|)(?=[^-]|$)',
											'i'
										),
									},
									G = /HTML$/i,
									Y = /^(?:input|select|textarea|button)$/i,
									J = /^h\d$/i,
									Q = /^[^{]+\{\s*\[native \w/,
									X = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
									ee = /[+~]/,
									te = new RegExp('\\\\[\\da-fA-F]{1,6}[\\x20\\t\\r\\n\\f]?|\\\\([^\\r\\n\\f])', 'g'),
									ne = function (e, t) {
										var n = '0x' + e.slice(1) - 65536;
										return (
											t ||
											(n < 0
												? String.fromCharCode(n + 65536)
												: String.fromCharCode((n >> 10) | 55296, (1023 & n) | 56320))
										);
									},
									re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
									oe = function (e, t) {
										return t
											? '\0' === e
												? 'ï¿½'
												: e.slice(0, -1) + '\\' + e.charCodeAt(e.length - 1).toString(16) + ' '
											: '\\' + e;
									},
									ie = function () {
										f();
									},
									ae = _e(
										function (e) {
											return !0 === e.disabled && 'fieldset' === e.nodeName.toLowerCase();
										},
										{ dir: 'parentNode', next: 'legend' }
									);
								try {
									N.apply((P = M.call(w.childNodes)), w.childNodes), P[w.childNodes.length].nodeType;
								} catch (e) {
									N = {
										apply: P.length
											? function (e, t) {
													I.apply(e, M.call(t));
											  }
											: function (e, t) {
													for (var n = e.length, r = 0; (e[n++] = t[r++]); );
													e.length = n - 1;
											  },
									};
								}
								function se(e, t, r, o) {
									var i,
										s,
										u,
										c,
										d,
										h,
										g,
										y = t && t.ownerDocument,
										w = t ? t.nodeType : 9;
									if (((r = r || []), 'string' != typeof e || !e || (1 !== w && 9 !== w && 11 !== w))) return r;
									if (!o && (f(t), (t = t || p), m)) {
										if (11 !== w && (d = X.exec(e)))
											if ((i = d[1])) {
												if (9 === w) {
													if (!(u = t.getElementById(i))) return r;
													if (u.id === i) return r.push(u), r;
												} else if (y && (u = y.getElementById(i)) && b(t, u) && u.id === i) return r.push(u), r;
											} else {
												if (d[2]) return N.apply(r, t.getElementsByTagName(e)), r;
												if ((i = d[3]) && n.getElementsByClassName && t.getElementsByClassName)
													return N.apply(r, t.getElementsByClassName(i)), r;
											}
										if (
											n.qsa &&
											!S[e + ' '] &&
											(!v || !v.test(e)) &&
											(1 !== w || 'object' !== t.nodeName.toLowerCase())
										) {
											if (((g = e), (y = t), 1 === w && (W.test(e) || q.test(e)))) {
												for (
													((y = (ee.test(e) && ge(t.parentNode)) || t) === t && n.scope) ||
														((c = t.getAttribute('id')) ? (c = c.replace(re, oe)) : t.setAttribute('id', (c = _))),
														s = (h = a(e)).length;
													s--;

												)
													h[s] = (c ? '#' + c : ':scope') + ' ' + be(h[s]);
												g = h.join(',');
											}
											try {
												return N.apply(r, y.querySelectorAll(g)), r;
											} catch (t) {
												S(e, !0);
											} finally {
												c === _ && t.removeAttribute('id');
											}
										}
									}
									return l(e.replace(Z, '$1'), t, r, o);
								}
								function le() {
									var e = [];
									return function t(n, o) {
										return e.push(n + ' ') > r.cacheLength && delete t[e.shift()], (t[n + ' '] = o);
									};
								}
								function ue(e) {
									return (e[_] = !0), e;
								}
								function ce(e) {
									var t = p.createElement('fieldset');
									try {
										return !!e(t);
									} catch (e) {
										return !1;
									} finally {
										t.parentNode && t.parentNode.removeChild(t), (t = null);
									}
								}
								function de(e, t) {
									for (var n = e.split('|'), o = n.length; o--; ) r.attrHandle[n[o]] = t;
								}
								function fe(e, t) {
									var n = t && e,
										r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
									if (r) return r;
									if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
									return e ? 1 : -1;
								}
								function pe(e) {
									return function (t) {
										return 'input' === t.nodeName.toLowerCase() && t.type === e;
									};
								}
								function he(e) {
									return function (t) {
										var n = t.nodeName.toLowerCase();
										return ('input' === n || 'button' === n) && t.type === e;
									};
								}
								function me(e) {
									return function (t) {
										return 'form' in t
											? t.parentNode && !1 === t.disabled
												? 'label' in t
													? 'label' in t.parentNode
														? t.parentNode.disabled === e
														: t.disabled === e
													: t.isDisabled === e || (t.isDisabled !== !e && ae(t) === e)
												: t.disabled === e
											: 'label' in t && t.disabled === e;
									};
								}
								function ve(e) {
									return ue(function (t) {
										return (
											(t = +t),
											ue(function (n, r) {
												for (var o, i = e([], n.length, t), a = i.length; a--; )
													n[(o = i[a])] && (n[o] = !(r[o] = n[o]));
											})
										);
									});
								}
								function ge(e) {
									return e && void 0 !== e.getElementsByTagName && e;
								}
								for (t in ((n = se.support = {}),
								(i = se.isXML =
									function (e) {
										var t = e && e.namespaceURI,
											n = e && (e.ownerDocument || e).documentElement;
										return !G.test(t || (n && n.nodeName) || 'HTML');
									}),
								(f = se.setDocument =
									function (e) {
										var t,
											o,
											a = e ? e.ownerDocument || e : w;
										return a != p && 9 === a.nodeType && a.documentElement
											? ((h = (p = a).documentElement),
											  (m = !i(p)),
											  w != p &&
													(o = p.defaultView) &&
													o.top !== o &&
													(o.addEventListener
														? o.addEventListener('unload', ie, !1)
														: o.attachEvent && o.attachEvent('onunload', ie)),
											  (n.scope = ce(function (e) {
													return (
														h.appendChild(e).appendChild(p.createElement('div')),
														void 0 !== e.querySelectorAll && !e.querySelectorAll(':scope fieldset div').length
													);
											  })),
											  (n.attributes = ce(function (e) {
													return (e.className = 'i'), !e.getAttribute('className');
											  })),
											  (n.getElementsByTagName = ce(function (e) {
													return e.appendChild(p.createComment('')), !e.getElementsByTagName('*').length;
											  })),
											  (n.getElementsByClassName = Q.test(p.getElementsByClassName)),
											  (n.getById = ce(function (e) {
													return (h.appendChild(e).id = _), !p.getElementsByName || !p.getElementsByName(_).length;
											  })),
											  n.getById
													? ((r.filter.ID = function (e) {
															var t = e.replace(te, ne);
															return function (e) {
																return e.getAttribute('id') === t;
															};
													  }),
													  (r.find.ID = function (e, t) {
															if (void 0 !== t.getElementById && m) {
																var n = t.getElementById(e);
																return n ? [n] : [];
															}
													  }))
													: ((r.filter.ID = function (e) {
															var t = e.replace(te, ne);
															return function (e) {
																var n = void 0 !== e.getAttributeNode && e.getAttributeNode('id');
																return n && n.value === t;
															};
													  }),
													  (r.find.ID = function (e, t) {
															if (void 0 !== t.getElementById && m) {
																var n,
																	r,
																	o,
																	i = t.getElementById(e);
																if (i) {
																	if ((n = i.getAttributeNode('id')) && n.value === e) return [i];
																	for (o = t.getElementsByName(e), r = 0; (i = o[r++]); )
																		if ((n = i.getAttributeNode('id')) && n.value === e) return [i];
																}
																return [];
															}
													  })),
											  (r.find.TAG = n.getElementsByTagName
													? function (e, t) {
															return void 0 !== t.getElementsByTagName
																? t.getElementsByTagName(e)
																: n.qsa
																? t.querySelectorAll(e)
																: void 0;
													  }
													: function (e, t) {
															var n,
																r = [],
																o = 0,
																i = t.getElementsByTagName(e);
															if ('*' === e) {
																for (; (n = i[o++]); ) 1 === n.nodeType && r.push(n);
																return r;
															}
															return i;
													  }),
											  (r.find.CLASS =
													n.getElementsByClassName &&
													function (e, t) {
														if (void 0 !== t.getElementsByClassName && m) return t.getElementsByClassName(e);
													}),
											  (g = []),
											  (v = []),
											  (n.qsa = Q.test(p.querySelectorAll)) &&
													(ce(function (e) {
														var t;
														(h.appendChild(e).innerHTML =
															"<a id='" +
															_ +
															"'></a><select id='" +
															_ +
															"-\r\\' msallowcapture=''><option selected=''></option></select>"),
															e.querySelectorAll("[msallowcapture^='']").length &&
																v.push('[*^$]=[\\x20\\t\\r\\n\\f]*(?:\'\'|"")'),
															e.querySelectorAll('[selected]').length ||
																v.push('\\[[\\x20\\t\\r\\n\\f]*(?:value|' + D + ')'),
															e.querySelectorAll('[id~=' + _ + '-]').length || v.push('~='),
															(t = p.createElement('input')).setAttribute('name', ''),
															e.appendChild(t),
															e.querySelectorAll("[name='']").length ||
																v.push(
																	'\\[[\\x20\\t\\r\\n\\f]*name[\\x20\\t\\r\\n\\f]*=[\\x20\\t\\r\\n\\f]*(?:\'\'|"")'
																),
															e.querySelectorAll(':checked').length || v.push(':checked'),
															e.querySelectorAll('a#' + _ + '+*').length || v.push('.#.+[+~]'),
															e.querySelectorAll('\\\f'),
															v.push('[\\r\\n\\f]');
													}),
													ce(function (e) {
														e.innerHTML =
															"<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
														var t = p.createElement('input');
														t.setAttribute('type', 'hidden'),
															e.appendChild(t).setAttribute('name', 'D'),
															e.querySelectorAll('[name=d]').length && v.push('name[\\x20\\t\\r\\n\\f]*[*^$|!~]?='),
															2 !== e.querySelectorAll(':enabled').length && v.push(':enabled', ':disabled'),
															(h.appendChild(e).disabled = !0),
															2 !== e.querySelectorAll(':disabled').length && v.push(':enabled', ':disabled'),
															e.querySelectorAll('*,:x'),
															v.push(',.*:');
													})),
											  (n.matchesSelector = Q.test(
													(y =
														h.matches ||
														h.webkitMatchesSelector ||
														h.mozMatchesSelector ||
														h.oMatchesSelector ||
														h.msMatchesSelector)
											  )) &&
													ce(function (e) {
														(n.disconnectedMatch = y.call(e, '*')), y.call(e, "[s!='']:x"), g.push('!=', B);
													}),
											  (v = v.length && new RegExp(v.join('|'))),
											  (g = g.length && new RegExp(g.join('|'))),
											  (t = Q.test(h.compareDocumentPosition)),
											  (b =
													t || Q.test(h.contains)
														? function (e, t) {
																var n = 9 === e.nodeType ? e.documentElement : e,
																	r = t && t.parentNode;
																return (
																	e === r ||
																	!(
																		!r ||
																		1 !== r.nodeType ||
																		!(n.contains
																			? n.contains(r)
																			: e.compareDocumentPosition && 16 & e.compareDocumentPosition(r))
																	)
																);
														  }
														: function (e, t) {
																if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
																return !1;
														  }),
											  (A = t
													? function (e, t) {
															if (e === t) return (d = !0), 0;
															var r = !e.compareDocumentPosition - !t.compareDocumentPosition;
															return (
																r ||
																(1 &
																	(r =
																		(e.ownerDocument || e) == (t.ownerDocument || t)
																			? e.compareDocumentPosition(t)
																			: 1) ||
																(!n.sortDetached && t.compareDocumentPosition(e) === r)
																	? e == p || (e.ownerDocument == w && b(w, e))
																		? -1
																		: t == p || (t.ownerDocument == w && b(w, t))
																		? 1
																		: c
																		? j(c, e) - j(c, t)
																		: 0
																	: 4 & r
																	? -1
																	: 1)
															);
													  }
													: function (e, t) {
															if (e === t) return (d = !0), 0;
															var n,
																r = 0,
																o = e.parentNode,
																i = t.parentNode,
																a = [e],
																s = [t];
															if (!o || !i)
																return e == p ? -1 : t == p ? 1 : o ? -1 : i ? 1 : c ? j(c, e) - j(c, t) : 0;
															if (o === i) return fe(e, t);
															for (n = e; (n = n.parentNode); ) a.unshift(n);
															for (n = t; (n = n.parentNode); ) s.unshift(n);
															for (; a[r] === s[r]; ) r++;
															return r ? fe(a[r], s[r]) : a[r] == w ? -1 : s[r] == w ? 1 : 0;
													  }),
											  p)
											: p;
									}),
								(se.matches = function (e, t) {
									return se(e, null, null, t);
								}),
								(se.matchesSelector = function (e, t) {
									if ((f(e), n.matchesSelector && m && !S[t + ' '] && (!g || !g.test(t)) && (!v || !v.test(t))))
										try {
											var r = y.call(e, t);
											if (r || n.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return r;
										} catch (e) {
											S(t, !0);
										}
									return se(t, p, null, [e]).length > 0;
								}),
								(se.contains = function (e, t) {
									return (e.ownerDocument || e) != p && f(e), b(e, t);
								}),
								(se.attr = function (e, t) {
									(e.ownerDocument || e) != p && f(e);
									var o = r.attrHandle[t.toLowerCase()],
										i = o && C.call(r.attrHandle, t.toLowerCase()) ? o(e, t, !m) : void 0;
									return void 0 !== i
										? i
										: n.attributes || !m
										? e.getAttribute(t)
										: (i = e.getAttributeNode(t)) && i.specified
										? i.value
										: null;
								}),
								(se.escape = function (e) {
									return (e + '').replace(re, oe);
								}),
								(se.error = function (e) {
									throw new Error('Syntax error, unrecognized expression: ' + e);
								}),
								(se.uniqueSort = function (e) {
									var t,
										r = [],
										o = 0,
										i = 0;
									if (((d = !n.detectDuplicates), (c = !n.sortStable && e.slice(0)), e.sort(A), d)) {
										for (; (t = e[i++]); ) t === e[i] && (o = r.push(i));
										for (; o--; ) e.splice(r[o], 1);
									}
									return (c = null), e;
								}),
								(o = se.getText =
									function (e) {
										var t,
											n = '',
											r = 0,
											i = e.nodeType;
										if (i) {
											if (1 === i || 9 === i || 11 === i) {
												if ('string' == typeof e.textContent) return e.textContent;
												for (e = e.firstChild; e; e = e.nextSibling) n += o(e);
											} else if (3 === i || 4 === i) return e.nodeValue;
										} else for (; (t = e[r++]); ) n += o(t);
										return n;
									}),
								(r = se.selectors =
									{
										cacheLength: 50,
										createPseudo: ue,
										match: z,
										attrHandle: {},
										find: {},
										relative: {
											'>': { dir: 'parentNode', first: !0 },
											' ': { dir: 'parentNode' },
											'+': { dir: 'previousSibling', first: !0 },
											'~': { dir: 'previousSibling' },
										},
										preFilter: {
											ATTR: function (e) {
												return (
													(e[1] = e[1].replace(te, ne)),
													(e[3] = (e[3] || e[4] || e[5] || '').replace(te, ne)),
													'~=' === e[2] && (e[3] = ' ' + e[3] + ' '),
													e.slice(0, 4)
												);
											},
											CHILD: function (e) {
												return (
													(e[1] = e[1].toLowerCase()),
													'nth' === e[1].slice(0, 3)
														? (e[3] || se.error(e[0]),
														  (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ('even' === e[3] || 'odd' === e[3]))),
														  (e[5] = +(e[7] + e[8] || 'odd' === e[3])))
														: e[3] && se.error(e[0]),
													e
												);
											},
											PSEUDO: function (e) {
												var t,
													n = !e[6] && e[2];
												return z.CHILD.test(e[0])
													? null
													: (e[3]
															? (e[2] = e[4] || e[5] || '')
															: n &&
															  K.test(n) &&
															  (t = a(n, !0)) &&
															  (t = n.indexOf(')', n.length - t) - n.length) &&
															  ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))),
													  e.slice(0, 3));
											},
										},
										filter: {
											TAG: function (e) {
												var t = e.replace(te, ne).toLowerCase();
												return '*' === e
													? function () {
															return !0;
													  }
													: function (e) {
															return e.nodeName && e.nodeName.toLowerCase() === t;
													  };
											},
											CLASS: function (e) {
												var t = x[e + ' '];
												return (
													t ||
													((t = new RegExp('(^|[\\x20\\t\\r\\n\\f])' + e + '(' + L + '|$)')) &&
														x(e, function (e) {
															return t.test(
																('string' == typeof e.className && e.className) ||
																	(void 0 !== e.getAttribute && e.getAttribute('class')) ||
																	''
															);
														}))
												);
											},
											ATTR: function (e, t, n) {
												return function (r) {
													var o = se.attr(r, e);
													return null == o
														? '!=' === t
														: !t ||
																((o += ''),
																'=' === t
																	? o === n
																	: '!=' === t
																	? o !== n
																	: '^=' === t
																	? n && 0 === o.indexOf(n)
																	: '*=' === t
																	? n && o.indexOf(n) > -1
																	: '$=' === t
																	? n && o.slice(-n.length) === n
																	: '~=' === t
																	? (' ' + o.replace(V, ' ') + ' ').indexOf(n) > -1
																	: '|=' === t && (o === n || o.slice(0, n.length + 1) === n + '-'));
												};
											},
											CHILD: function (e, t, n, r, o) {
												var i = 'nth' !== e.slice(0, 3),
													a = 'last' !== e.slice(-4),
													s = 'of-type' === t;
												return 1 === r && 0 === o
													? function (e) {
															return !!e.parentNode;
													  }
													: function (t, n, l) {
															var u,
																c,
																d,
																f,
																p,
																h,
																m = i !== a ? 'nextSibling' : 'previousSibling',
																v = t.parentNode,
																g = s && t.nodeName.toLowerCase(),
																y = !l && !s,
																b = !1;
															if (v) {
																if (i) {
																	for (; m; ) {
																		for (f = t; (f = f[m]); )
																			if (s ? f.nodeName.toLowerCase() === g : 1 === f.nodeType) return !1;
																		h = m = 'only' === e && !h && 'nextSibling';
																	}
																	return !0;
																}
																if (((h = [a ? v.firstChild : v.lastChild]), a && y)) {
																	for (
																		b =
																			(p =
																				(u =
																					(c = (d = (f = v)[_] || (f[_] = {}))[f.uniqueID] || (d[f.uniqueID] = {}))[
																						e
																					] || [])[0] === O && u[1]) && u[2],
																			f = p && v.childNodes[p];
																		(f = (++p && f && f[m]) || (b = p = 0) || h.pop());

																	)
																		if (1 === f.nodeType && ++b && f === t) {
																			c[e] = [O, p, b];
																			break;
																		}
																} else if (
																	(y &&
																		(b = p =
																			(u =
																				(c = (d = (f = t)[_] || (f[_] = {}))[f.uniqueID] || (d[f.uniqueID] = {}))[e] ||
																				[])[0] === O && u[1]),
																	!1 === b)
																)
																	for (
																		;
																		(f = (++p && f && f[m]) || (b = p = 0) || h.pop()) &&
																		((s ? f.nodeName.toLowerCase() !== g : 1 !== f.nodeType) ||
																			!++b ||
																			(y &&
																				((c = (d = f[_] || (f[_] = {}))[f.uniqueID] || (d[f.uniqueID] = {}))[e] = [
																					O,
																					b,
																				]),
																			f !== t));

																	);
																return (b -= o) === r || (b % r == 0 && b / r >= 0);
															}
													  };
											},
											PSEUDO: function (e, t) {
												var n,
													o = r.pseudos[e] || r.setFilters[e.toLowerCase()] || se.error('unsupported pseudo: ' + e);
												return o[_]
													? o(t)
													: o.length > 1
													? ((n = [e, e, '', t]),
													  r.setFilters.hasOwnProperty(e.toLowerCase())
															? ue(function (e, n) {
																	for (var r, i = o(e, t), a = i.length; a--; ) e[(r = j(e, i[a]))] = !(n[r] = i[a]);
															  })
															: function (e) {
																	return o(e, 0, n);
															  })
													: o;
											},
										},
										pseudos: {
											not: ue(function (e) {
												var t = [],
													n = [],
													r = s(e.replace(Z, '$1'));
												return r[_]
													? ue(function (e, t, n, o) {
															for (var i, a = r(e, null, o, []), s = e.length; s--; )
																(i = a[s]) && (e[s] = !(t[s] = i));
													  })
													: function (e, o, i) {
															return (t[0] = e), r(t, null, i, n), (t[0] = null), !n.pop();
													  };
											}),
											has: ue(function (e) {
												return function (t) {
													return se(e, t).length > 0;
												};
											}),
											contains: ue(function (e) {
												return (
													(e = e.replace(te, ne)),
													function (t) {
														return (t.textContent || o(t)).indexOf(e) > -1;
													}
												);
											}),
											lang: ue(function (e) {
												return (
													$.test(e || '') || se.error('unsupported lang: ' + e),
													(e = e.replace(te, ne).toLowerCase()),
													function (t) {
														var n;
														do {
															if ((n = m ? t.lang : t.getAttribute('xml:lang') || t.getAttribute('lang')))
																return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + '-');
														} while ((t = t.parentNode) && 1 === t.nodeType);
														return !1;
													}
												);
											}),
											target: function (t) {
												var n = e.location && e.location.hash;
												return n && n.slice(1) === t.id;
											},
											root: function (e) {
												return e === h;
											},
											focus: function (e) {
												return (
													e === p.activeElement && (!p.hasFocus || p.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
												);
											},
											enabled: me(!1),
											disabled: me(!0),
											checked: function (e) {
												var t = e.nodeName.toLowerCase();
												return ('input' === t && !!e.checked) || ('option' === t && !!e.selected);
											},
											selected: function (e) {
												return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
											},
											empty: function (e) {
												for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
												return !0;
											},
											parent: function (e) {
												return !r.pseudos.empty(e);
											},
											header: function (e) {
												return J.test(e.nodeName);
											},
											input: function (e) {
												return Y.test(e.nodeName);
											},
											button: function (e) {
												var t = e.nodeName.toLowerCase();
												return ('input' === t && 'button' === e.type) || 'button' === t;
											},
											text: function (e) {
												var t;
												return (
													'input' === e.nodeName.toLowerCase() &&
													'text' === e.type &&
													(null == (t = e.getAttribute('type')) || 'text' === t.toLowerCase())
												);
											},
											first: ve(function () {
												return [0];
											}),
											last: ve(function (e, t) {
												return [t - 1];
											}),
											eq: ve(function (e, t, n) {
												return [n < 0 ? n + t : n];
											}),
											even: ve(function (e, t) {
												for (var n = 0; n < t; n += 2) e.push(n);
												return e;
											}),
											odd: ve(function (e, t) {
												for (var n = 1; n < t; n += 2) e.push(n);
												return e;
											}),
											lt: ve(function (e, t, n) {
												for (var r = n < 0 ? n + t : n > t ? t : n; --r >= 0; ) e.push(r);
												return e;
											}),
											gt: ve(function (e, t, n) {
												for (var r = n < 0 ? n + t : n; ++r < t; ) e.push(r);
												return e;
											}),
										},
									}),
								(r.pseudos.nth = r.pseudos.eq),
								{ radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
									r.pseudos[t] = pe(t);
								for (t in { submit: !0, reset: !0 }) r.pseudos[t] = he(t);
								function ye() {}
								function be(e) {
									for (var t = 0, n = e.length, r = ''; t < n; t++) r += e[t].value;
									return r;
								}
								function _e(e, t, n) {
									var r = t.dir,
										o = t.next,
										i = o || r,
										a = n && 'parentNode' === i,
										s = k++;
									return t.first
										? function (t, n, o) {
												for (; (t = t[r]); ) if (1 === t.nodeType || a) return e(t, n, o);
												return !1;
										  }
										: function (t, n, l) {
												var u,
													c,
													d,
													f = [O, s];
												if (l) {
													for (; (t = t[r]); ) if ((1 === t.nodeType || a) && e(t, n, l)) return !0;
												} else
													for (; (t = t[r]); )
														if (1 === t.nodeType || a)
															if (
																((c = (d = t[_] || (t[_] = {}))[t.uniqueID] || (d[t.uniqueID] = {})),
																o && o === t.nodeName.toLowerCase())
															)
																t = t[r] || t;
															else {
																if ((u = c[i]) && u[0] === O && u[1] === s) return (f[2] = u[2]);
																if (((c[i] = f), (f[2] = e(t, n, l)))) return !0;
															}
												return !1;
										  };
								}
								function we(e) {
									return e.length > 1
										? function (t, n, r) {
												for (var o = e.length; o--; ) if (!e[o](t, n, r)) return !1;
												return !0;
										  }
										: e[0];
								}
								function Oe(e, t, n, r, o) {
									for (var i, a = [], s = 0, l = e.length, u = null != t; s < l; s++)
										(i = e[s]) && ((n && !n(i, r, o)) || (a.push(i), u && t.push(s)));
									return a;
								}
								function ke(e, t, n, r, o, i) {
									return (
										r && !r[_] && (r = ke(r)),
										o && !o[_] && (o = ke(o, i)),
										ue(function (i, a, s, l) {
											var u,
												c,
												d,
												f = [],
												p = [],
												h = a.length,
												m =
													i ||
													(function (e, t, n) {
														for (var r = 0, o = t.length; r < o; r++) se(e, t[r], n);
														return n;
													})(t || '*', s.nodeType ? [s] : s, []),
												v = !e || (!i && t) ? m : Oe(m, f, e, s, l),
												g = n ? (o || (i ? e : h || r) ? [] : a) : v;
											if ((n && n(v, g, s, l), r))
												for (u = Oe(g, p), r(u, [], s, l), c = u.length; c--; )
													(d = u[c]) && (g[p[c]] = !(v[p[c]] = d));
											if (i) {
												if (o || e) {
													if (o) {
														for (u = [], c = g.length; c--; ) (d = g[c]) && u.push((v[c] = d));
														o(null, (g = []), u, l);
													}
													for (c = g.length; c--; ) (d = g[c]) && (u = o ? j(i, d) : f[c]) > -1 && (i[u] = !(a[u] = d));
												}
											} else (g = Oe(g === a ? g.splice(h, g.length) : g)), o ? o(null, a, g, l) : N.apply(a, g);
										})
									);
								}
								function xe(e) {
									for (
										var t,
											n,
											o,
											i = e.length,
											a = r.relative[e[0].type],
											s = a || r.relative[' '],
											l = a ? 1 : 0,
											c = _e(
												function (e) {
													return e === t;
												},
												s,
												!0
											),
											d = _e(
												function (e) {
													return j(t, e) > -1;
												},
												s,
												!0
											),
											f = [
												function (e, n, r) {
													var o = (!a && (r || n !== u)) || ((t = n).nodeType ? c(e, n, r) : d(e, n, r));
													return (t = null), o;
												},
											];
										l < i;
										l++
									)
										if ((n = r.relative[e[l].type])) f = [_e(we(f), n)];
										else {
											if ((n = r.filter[e[l].type].apply(null, e[l].matches))[_]) {
												for (o = ++l; o < i && !r.relative[e[o].type]; o++);
												return ke(
													l > 1 && we(f),
													l > 1 &&
														be(e.slice(0, l - 1).concat({ value: ' ' === e[l - 2].type ? '*' : '' })).replace(Z, '$1'),
													n,
													l < o && xe(e.slice(l, o)),
													o < i && xe((e = e.slice(o))),
													o < i && be(e)
												);
											}
											f.push(n);
										}
									return we(f);
								}
								return (
									(ye.prototype = r.filters = r.pseudos),
									(r.setFilters = new ye()),
									(a = se.tokenize =
										function (e, t) {
											var n,
												o,
												i,
												a,
												s,
												l,
												u,
												c = E[e + ' '];
											if (c) return t ? 0 : c.slice(0);
											for (s = e, l = [], u = r.preFilter; s; ) {
												for (a in ((n && !(o = H.exec(s))) || (o && (s = s.slice(o[0].length) || s), l.push((i = []))),
												(n = !1),
												(o = q.exec(s)) &&
													((n = o.shift()), i.push({ value: n, type: o[0].replace(Z, ' ') }), (s = s.slice(n.length))),
												r.filter))
													!(o = z[a].exec(s)) ||
														(u[a] && !(o = u[a](o))) ||
														((n = o.shift()), i.push({ value: n, type: a, matches: o }), (s = s.slice(n.length)));
												if (!n) break;
											}
											return t ? s.length : s ? se.error(e) : E(e, l).slice(0);
										}),
									(s = se.compile =
										function (e, t) {
											var n,
												o = [],
												i = [],
												s = T[e + ' '];
											if (!s) {
												for (t || (t = a(e)), n = t.length; n--; ) (s = xe(t[n]))[_] ? o.push(s) : i.push(s);
												(s = T(
													e,
													(function (e, t) {
														var n = t.length > 0,
															o = e.length > 0,
															i = function (i, a, s, l, c) {
																var d,
																	h,
																	v,
																	g = 0,
																	y = '0',
																	b = i && [],
																	_ = [],
																	w = u,
																	k = i || (o && r.find.TAG('*', c)),
																	x = (O += null == w ? 1 : Math.random() || 0.1),
																	E = k.length;
																for (c && (u = a == p || a || c); y !== E && null != (d = k[y]); y++) {
																	if (o && d) {
																		for (h = 0, a || d.ownerDocument == p || (f(d), (s = !m)); (v = e[h++]); )
																			if (v(d, a || p, s)) {
																				l.push(d);
																				break;
																			}
																		c && (O = x);
																	}
																	n && ((d = !v && d) && g--, i && b.push(d));
																}
																if (((g += y), n && y !== g)) {
																	for (h = 0; (v = t[h++]); ) v(b, _, a, s);
																	if (i) {
																		if (g > 0) for (; y--; ) b[y] || _[y] || (_[y] = R.call(l));
																		_ = Oe(_);
																	}
																	N.apply(l, _), c && !i && _.length > 0 && g + t.length > 1 && se.uniqueSort(l);
																}
																return c && ((O = x), (u = w)), b;
															};
														return n ? ue(i) : i;
													})(i, o)
												)),
													(s.selector = e);
											}
											return s;
										}),
									(l = se.select =
										function (e, t, n, o) {
											var i,
												l,
												u,
												c,
												d,
												f = 'function' == typeof e && e,
												p = !o && a((e = f.selector || e));
											if (((n = n || []), 1 === p.length)) {
												if (
													(l = p[0] = p[0].slice(0)).length > 2 &&
													'ID' === (u = l[0]).type &&
													9 === t.nodeType &&
													m &&
													r.relative[l[1].type]
												) {
													if (!(t = (r.find.ID(u.matches[0].replace(te, ne), t) || [])[0])) return n;
													f && (t = t.parentNode), (e = e.slice(l.shift().value.length));
												}
												for (
													i = z.needsContext.test(e) ? 0 : l.length;
													i-- && ((u = l[i]), !r.relative[(c = u.type)]);

												)
													if (
														(d = r.find[c]) &&
														(o = d(u.matches[0].replace(te, ne), (ee.test(l[0].type) && ge(t.parentNode)) || t))
													) {
														if ((l.splice(i, 1), !(e = o.length && be(l)))) return N.apply(n, o), n;
														break;
													}
											}
											return (f || s(e, p))(o, t, !m, n, !t || (ee.test(e) && ge(t.parentNode)) || t), n;
										}),
									(n.sortStable = _.split('').sort(A).join('') === _),
									(n.detectDuplicates = !!d),
									f(),
									(n.sortDetached = ce(function (e) {
										return 1 & e.compareDocumentPosition(p.createElement('fieldset'));
									})),
									ce(function (e) {
										return (e.innerHTML = "<a href='#'></a>"), '#' === e.firstChild.getAttribute('href');
									}) ||
										de('type|href|height|width', function (e, t, n) {
											if (!n) return e.getAttribute(t, 'type' === t.toLowerCase() ? 1 : 2);
										}),
									(n.attributes &&
										ce(function (e) {
											return (
												(e.innerHTML = '<input/>'),
												e.firstChild.setAttribute('value', ''),
												'' === e.firstChild.getAttribute('value')
											);
										})) ||
										de('value', function (e, t, n) {
											if (!n && 'input' === e.nodeName.toLowerCase()) return e.defaultValue;
										}),
									ce(function (e) {
										return null == e.getAttribute('disabled');
									}) ||
										de(D, function (e, t, n) {
											var r;
											if (!n)
												return !0 === e[t]
													? t.toLowerCase()
													: (r = e.getAttributeNode(t)) && r.specified
													? r.value
													: null;
										}),
									se
								);
							})(r);
						(x.find = T),
							(x.expr = T.selectors),
							(x.expr[':'] = x.expr.pseudos),
							(x.uniqueSort = x.unique = T.uniqueSort),
							(x.text = T.getText),
							(x.isXMLDoc = T.isXML),
							(x.contains = T.contains),
							(x.escapeSelector = T.escape);
						var S = function (e, t, n) {
								for (var r = [], o = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
									if (1 === e.nodeType) {
										if (o && x(e).is(n)) break;
										r.push(e);
									}
								return r;
							},
							A = function (e, t) {
								for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
								return n;
							},
							C = x.expr.match.needsContext;
						function P(e, t) {
							return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
						}
						var R = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
						function I(e, t, n) {
							return g(t)
								? x.grep(e, function (e, r) {
										return !!t.call(e, r, e) !== n;
								  })
								: t.nodeType
								? x.grep(e, function (e) {
										return (e === t) !== n;
								  })
								: 'string' != typeof t
								? x.grep(e, function (e) {
										return c.call(t, e) > -1 !== n;
								  })
								: x.filter(t, e, n);
						}
						(x.filter = function (e, t, n) {
							var r = t[0];
							return (
								n && (e = ':not(' + e + ')'),
								1 === t.length && 1 === r.nodeType
									? x.find.matchesSelector(r, e)
										? [r]
										: []
									: x.find.matches(
											e,
											x.grep(t, function (e) {
												return 1 === e.nodeType;
											})
									  )
							);
						}),
							x.fn.extend({
								find: function (e) {
									var t,
										n,
										r = this.length,
										o = this;
									if ('string' != typeof e)
										return this.pushStack(
											x(e).filter(function () {
												for (t = 0; t < r; t++) if (x.contains(o[t], this)) return !0;
											})
										);
									for (n = this.pushStack([]), t = 0; t < r; t++) x.find(e, o[t], n);
									return r > 1 ? x.uniqueSort(n) : n;
								},
								filter: function (e) {
									return this.pushStack(I(this, e || [], !1));
								},
								not: function (e) {
									return this.pushStack(I(this, e || [], !0));
								},
								is: function (e) {
									return !!I(this, 'string' == typeof e && C.test(e) ? x(e) : e || [], !1).length;
								},
							});
						var N,
							M = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
						((x.fn.init = function (e, t, n) {
							var r, o;
							if (!e) return this;
							if (((n = n || N), 'string' == typeof e)) {
								if (
									!(r = '<' === e[0] && '>' === e[e.length - 1] && e.length >= 3 ? [null, e, null] : M.exec(e)) ||
									(!r[1] && t)
								)
									return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
								if (r[1]) {
									if (
										((t = t instanceof x ? t[0] : t),
										x.merge(this, x.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : b, !0)),
										R.test(r[1]) && x.isPlainObject(t))
									)
										for (r in t) g(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
									return this;
								}
								return (o = b.getElementById(r[2])) && ((this[0] = o), (this.length = 1)), this;
							}
							return e.nodeType
								? ((this[0] = e), (this.length = 1), this)
								: g(e)
								? void 0 !== n.ready
									? n.ready(e)
									: e(x)
								: x.makeArray(e, this);
						}).prototype = x.fn),
							(N = x(b));
						var j = /^(?:parents|prev(?:Until|All))/,
							D = { children: !0, contents: !0, next: !0, prev: !0 };
						function L(e, t) {
							for (; (e = e[t]) && 1 !== e.nodeType; );
							return e;
						}
						x.fn.extend({
							has: function (e) {
								var t = x(e, this),
									n = t.length;
								return this.filter(function () {
									for (var e = 0; e < n; e++) if (x.contains(this, t[e])) return !0;
								});
							},
							closest: function (e, t) {
								var n,
									r = 0,
									o = this.length,
									i = [],
									a = 'string' != typeof e && x(e);
								if (!C.test(e))
									for (; r < o; r++)
										for (n = this[r]; n && n !== t; n = n.parentNode)
											if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && x.find.matchesSelector(n, e))) {
												i.push(n);
												break;
											}
								return this.pushStack(i.length > 1 ? x.uniqueSort(i) : i);
							},
							index: function (e) {
								return e
									? 'string' == typeof e
										? c.call(x(e), this[0])
										: c.call(this, e.jquery ? e[0] : e)
									: this[0] && this[0].parentNode
									? this.first().prevAll().length
									: -1;
							},
							add: function (e, t) {
								return this.pushStack(x.uniqueSort(x.merge(this.get(), x(e, t))));
							},
							addBack: function (e) {
								return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
							},
						}),
							x.each(
								{
									parent: function (e) {
										var t = e.parentNode;
										return t && 11 !== t.nodeType ? t : null;
									},
									parents: function (e) {
										return S(e, 'parentNode');
									},
									parentsUntil: function (e, t, n) {
										return S(e, 'parentNode', n);
									},
									next: function (e) {
										return L(e, 'nextSibling');
									},
									prev: function (e) {
										return L(e, 'previousSibling');
									},
									nextAll: function (e) {
										return S(e, 'nextSibling');
									},
									prevAll: function (e) {
										return S(e, 'previousSibling');
									},
									nextUntil: function (e, t, n) {
										return S(e, 'nextSibling', n);
									},
									prevUntil: function (e, t, n) {
										return S(e, 'previousSibling', n);
									},
									siblings: function (e) {
										return A((e.parentNode || {}).firstChild, e);
									},
									children: function (e) {
										return A(e.firstChild);
									},
									contents: function (e) {
										return null != e.contentDocument && a(e.contentDocument)
											? e.contentDocument
											: (P(e, 'template') && (e = e.content || e), x.merge([], e.childNodes));
									},
								},
								function (e, t) {
									x.fn[e] = function (n, r) {
										var o = x.map(this, t, n);
										return (
											'Until' !== e.slice(-5) && (r = n),
											r && 'string' == typeof r && (o = x.filter(r, o)),
											this.length > 1 && (D[e] || x.uniqueSort(o), j.test(e) && o.reverse()),
											this.pushStack(o)
										);
									};
								}
							);
						var U = /[^\x20\t\r\n\f]+/g;
						function F(e) {
							return e;
						}
						function B(e) {
							throw e;
						}
						function V(e, t, n, r) {
							var o;
							try {
								e && g((o = e.promise))
									? o.call(e).done(t).fail(n)
									: e && g((o = e.then))
									? o.call(e, t, n)
									: t.apply(void 0, [e].slice(r));
							} catch (e) {
								n.apply(void 0, [e]);
							}
						}
						(x.Callbacks = function (e) {
							e =
								'string' == typeof e
									? (function (e) {
											var t = {};
											return (
												x.each(e.match(U) || [], function (e, n) {
													t[n] = !0;
												}),
												t
											);
									  })(e)
									: x.extend({}, e);
							var t,
								n,
								r,
								o,
								i = [],
								a = [],
								s = -1,
								l = function () {
									for (o = o || e.once, r = t = !0; a.length; s = -1)
										for (n = a.shift(); ++s < i.length; )
											!1 === i[s].apply(n[0], n[1]) && e.stopOnFalse && ((s = i.length), (n = !1));
									e.memory || (n = !1), (t = !1), o && (i = n ? [] : '');
								},
								u = {
									add: function () {
										return (
											i &&
												(n && !t && ((s = i.length - 1), a.push(n)),
												(function t(n) {
													x.each(n, function (n, r) {
														g(r) ? (e.unique && u.has(r)) || i.push(r) : r && r.length && 'string' !== O(r) && t(r);
													});
												})(arguments),
												n && !t && l()),
											this
										);
									},
									remove: function () {
										return (
											x.each(arguments, function (e, t) {
												for (var n; (n = x.inArray(t, i, n)) > -1; ) i.splice(n, 1), n <= s && s--;
											}),
											this
										);
									},
									has: function (e) {
										return e ? x.inArray(e, i) > -1 : i.length > 0;
									},
									empty: function () {
										return i && (i = []), this;
									},
									disable: function () {
										return (o = a = []), (i = n = ''), this;
									},
									disabled: function () {
										return !i;
									},
									lock: function () {
										return (o = a = []), n || t || (i = n = ''), this;
									},
									locked: function () {
										return !!o;
									},
									fireWith: function (e, n) {
										return o || ((n = [e, (n = n || []).slice ? n.slice() : n]), a.push(n), t || l()), this;
									},
									fire: function () {
										return u.fireWith(this, arguments), this;
									},
									fired: function () {
										return !!r;
									},
								};
							return u;
						}),
							x.extend({
								Deferred: function (e) {
									var t = [
											['notify', 'progress', x.Callbacks('memory'), x.Callbacks('memory'), 2],
											['resolve', 'done', x.Callbacks('once memory'), x.Callbacks('once memory'), 0, 'resolved'],
											['reject', 'fail', x.Callbacks('once memory'), x.Callbacks('once memory'), 1, 'rejected'],
										],
										n = 'pending',
										o = {
											state: function () {
												return n;
											},
											always: function () {
												return i.done(arguments).fail(arguments), this;
											},
											catch: function (e) {
												return o.then(null, e);
											},
											pipe: function () {
												var e = arguments;
												return x
													.Deferred(function (n) {
														x.each(t, function (t, r) {
															var o = g(e[r[4]]) && e[r[4]];
															i[r[1]](function () {
																var e = o && o.apply(this, arguments);
																e && g(e.promise)
																	? e.promise().progress(n.notify).done(n.resolve).fail(n.reject)
																	: n[r[0] + 'With'](this, o ? [e] : arguments);
															});
														}),
															(e = null);
													})
													.promise();
											},
											then: function (e, n, o) {
												var i = 0;
												function a(e, t, n, o) {
													return function () {
														var s = this,
															l = arguments,
															u = function () {
																var r, u;
																if (!(e < i)) {
																	if ((r = n.apply(s, l)) === t.promise())
																		throw new TypeError('Thenable self-resolution');
																	(u = r && ('object' == typeof r || 'function' == typeof r) && r.then),
																		g(u)
																			? o
																				? u.call(r, a(i, t, F, o), a(i, t, B, o))
																				: (i++, u.call(r, a(i, t, F, o), a(i, t, B, o), a(i, t, F, t.notifyWith)))
																			: (n !== F && ((s = void 0), (l = [r])), (o || t.resolveWith)(s, l));
																}
															},
															c = o
																? u
																: function () {
																		try {
																			u();
																		} catch (r) {
																			x.Deferred.exceptionHook && x.Deferred.exceptionHook(r, c.stackTrace),
																				e + 1 >= i && (n !== B && ((s = void 0), (l = [r])), t.rejectWith(s, l));
																		}
																  };
														e
															? c()
															: (x.Deferred.getStackHook && (c.stackTrace = x.Deferred.getStackHook()),
															  r.setTimeout(c));
													};
												}
												return x
													.Deferred(function (r) {
														t[0][3].add(a(0, r, g(o) ? o : F, r.notifyWith)),
															t[1][3].add(a(0, r, g(e) ? e : F)),
															t[2][3].add(a(0, r, g(n) ? n : B));
													})
													.promise();
											},
											promise: function (e) {
												return null != e ? x.extend(e, o) : o;
											},
										},
										i = {};
									return (
										x.each(t, function (e, r) {
											var a = r[2],
												s = r[5];
											(o[r[1]] = a.add),
												s &&
													a.add(
														function () {
															n = s;
														},
														t[3 - e][2].disable,
														t[3 - e][3].disable,
														t[0][2].lock,
														t[0][3].lock
													),
												a.add(r[3].fire),
												(i[r[0]] = function () {
													return i[r[0] + 'With'](this === i ? void 0 : this, arguments), this;
												}),
												(i[r[0] + 'With'] = a.fireWith);
										}),
										o.promise(i),
										e && e.call(i, i),
										i
									);
								},
								when: function (e) {
									var t = arguments.length,
										n = t,
										r = Array(n),
										o = s.call(arguments),
										i = x.Deferred(),
										a = function (e) {
											return function (n) {
												(r[e] = this),
													(o[e] = arguments.length > 1 ? s.call(arguments) : n),
													--t || i.resolveWith(r, o);
											};
										};
									if (
										t <= 1 &&
										(V(e, i.done(a(n)).resolve, i.reject, !t), 'pending' === i.state() || g(o[n] && o[n].then))
									)
										return i.then();
									for (; n--; ) V(o[n], a(n), i.reject);
									return i.promise();
								},
							});
						var Z = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
						(x.Deferred.exceptionHook = function (e, t) {
							r.console &&
								r.console.warn &&
								e &&
								Z.test(e.name) &&
								r.console.warn('jQuery.Deferred exception: ' + e.message, e.stack, t);
						}),
							(x.readyException = function (e) {
								r.setTimeout(function () {
									throw e;
								});
							});
						var H = x.Deferred();
						function q() {
							b.removeEventListener('DOMContentLoaded', q), r.removeEventListener('load', q), x.ready();
						}
						(x.fn.ready = function (e) {
							return (
								H.then(e).catch(function (e) {
									x.readyException(e);
								}),
								this
							);
						}),
							x.extend({
								isReady: !1,
								readyWait: 1,
								ready: function (e) {
									(!0 === e ? --x.readyWait : x.isReady) ||
										((x.isReady = !0), (!0 !== e && --x.readyWait > 0) || H.resolveWith(b, [x]));
								},
							}),
							(x.ready.then = H.then),
							'complete' === b.readyState || ('loading' !== b.readyState && !b.documentElement.doScroll)
								? r.setTimeout(x.ready)
								: (b.addEventListener('DOMContentLoaded', q), r.addEventListener('load', q));
						var W = function (e, t, n, r, o, i, a) {
								var s = 0,
									l = e.length,
									u = null == n;
								if ('object' === O(n)) for (s in ((o = !0), n)) W(e, t, s, n[s], !0, i, a);
								else if (
									void 0 !== r &&
									((o = !0),
									g(r) || (a = !0),
									u &&
										(a
											? (t.call(e, r), (t = null))
											: ((u = t),
											  (t = function (e, t, n) {
													return u.call(x(e), n);
											  }))),
									t)
								)
									for (; s < l; s++) t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
								return o ? e : u ? t.call(e) : l ? t(e[0], n) : i;
							},
							K = /^-ms-/,
							$ = /-([a-z])/g;
						function z(e, t) {
							return t.toUpperCase();
						}
						function G(e) {
							return e.replace(K, 'ms-').replace($, z);
						}
						var Y = function (e) {
							return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
						};
						function J() {
							this.expando = x.expando + J.uid++;
						}
						(J.uid = 1),
							(J.prototype = {
								cache: function (e) {
									var t = e[this.expando];
									return (
										t ||
											((t = {}),
											Y(e) &&
												(e.nodeType
													? (e[this.expando] = t)
													: Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))),
										t
									);
								},
								set: function (e, t, n) {
									var r,
										o = this.cache(e);
									if ('string' == typeof t) o[G(t)] = n;
									else for (r in t) o[G(r)] = t[r];
									return o;
								},
								get: function (e, t) {
									return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][G(t)];
								},
								access: function (e, t, n) {
									return void 0 === t || (t && 'string' == typeof t && void 0 === n)
										? this.get(e, t)
										: (this.set(e, t, n), void 0 !== n ? n : t);
								},
								remove: function (e, t) {
									var n,
										r = e[this.expando];
									if (void 0 !== r) {
										if (void 0 !== t) {
											n = (t = Array.isArray(t) ? t.map(G) : (t = G(t)) in r ? [t] : t.match(U) || []).length;
											for (; n--; ) delete r[t[n]];
										}
										(void 0 === t || x.isEmptyObject(r)) &&
											(e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
									}
								},
								hasData: function (e) {
									var t = e[this.expando];
									return void 0 !== t && !x.isEmptyObject(t);
								},
							});
						var Q = new J(),
							X = new J(),
							ee = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
							te = /[A-Z]/g;
						function ne(e, t, n) {
							var r;
							if (void 0 === n && 1 === e.nodeType)
								if (((r = 'data-' + t.replace(te, '-$&').toLowerCase()), 'string' == typeof (n = e.getAttribute(r)))) {
									try {
										n = (function (e) {
											return (
												'true' === e ||
												('false' !== e && ('null' === e ? null : e === +e + '' ? +e : ee.test(e) ? JSON.parse(e) : e))
											);
										})(n);
									} catch (e) {}
									X.set(e, t, n);
								} else n = void 0;
							return n;
						}
						x.extend({
							hasData: function (e) {
								return X.hasData(e) || Q.hasData(e);
							},
							data: function (e, t, n) {
								return X.access(e, t, n);
							},
							removeData: function (e, t) {
								X.remove(e, t);
							},
							_data: function (e, t, n) {
								return Q.access(e, t, n);
							},
							_removeData: function (e, t) {
								Q.remove(e, t);
							},
						}),
							x.fn.extend({
								data: function (e, t) {
									var n,
										r,
										o,
										i = this[0],
										a = i && i.attributes;
									if (void 0 === e) {
										if (this.length && ((o = X.get(i)), 1 === i.nodeType && !Q.get(i, 'hasDataAttrs'))) {
											for (n = a.length; n--; )
												a[n] && 0 === (r = a[n].name).indexOf('data-') && ((r = G(r.slice(5))), ne(i, r, o[r]));
											Q.set(i, 'hasDataAttrs', !0);
										}
										return o;
									}
									return 'object' == typeof e
										? this.each(function () {
												X.set(this, e);
										  })
										: W(
												this,
												function (t) {
													var n;
													if (i && void 0 === t)
														return void 0 !== (n = X.get(i, e)) || void 0 !== (n = ne(i, e)) ? n : void 0;
													this.each(function () {
														X.set(this, e, t);
													});
												},
												null,
												t,
												arguments.length > 1,
												null,
												!0
										  );
								},
								removeData: function (e) {
									return this.each(function () {
										X.remove(this, e);
									});
								},
							}),
							x.extend({
								queue: function (e, t, n) {
									var r;
									if (e)
										return (
											(t = (t || 'fx') + 'queue'),
											(r = Q.get(e, t)),
											n && (!r || Array.isArray(n) ? (r = Q.access(e, t, x.makeArray(n))) : r.push(n)),
											r || []
										);
								},
								dequeue: function (e, t) {
									t = t || 'fx';
									var n = x.queue(e, t),
										r = n.length,
										o = n.shift(),
										i = x._queueHooks(e, t);
									'inprogress' === o && ((o = n.shift()), r--),
										o &&
											('fx' === t && n.unshift('inprogress'),
											delete i.stop,
											o.call(
												e,
												function () {
													x.dequeue(e, t);
												},
												i
											)),
										!r && i && i.empty.fire();
								},
								_queueHooks: function (e, t) {
									var n = t + 'queueHooks';
									return (
										Q.get(e, n) ||
										Q.access(e, n, {
											empty: x.Callbacks('once memory').add(function () {
												Q.remove(e, [t + 'queue', n]);
											}),
										})
									);
								},
							}),
							x.fn.extend({
								queue: function (e, t) {
									var n = 2;
									return (
										'string' != typeof e && ((t = e), (e = 'fx'), n--),
										arguments.length < n
											? x.queue(this[0], e)
											: void 0 === t
											? this
											: this.each(function () {
													var n = x.queue(this, e, t);
													x._queueHooks(this, e), 'fx' === e && 'inprogress' !== n[0] && x.dequeue(this, e);
											  })
									);
								},
								dequeue: function (e) {
									return this.each(function () {
										x.dequeue(this, e);
									});
								},
								clearQueue: function (e) {
									return this.queue(e || 'fx', []);
								},
								promise: function (e, t) {
									var n,
										r = 1,
										o = x.Deferred(),
										i = this,
										a = this.length,
										s = function () {
											--r || o.resolveWith(i, [i]);
										};
									for ('string' != typeof e && ((t = e), (e = void 0)), e = e || 'fx'; a--; )
										(n = Q.get(i[a], e + 'queueHooks')) && n.empty && (r++, n.empty.add(s));
									return s(), o.promise(t);
								},
							});
						var re = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
							oe = new RegExp('^(?:([+-])=|)(' + re + ')([a-z%]*)$', 'i'),
							ie = ['Top', 'Right', 'Bottom', 'Left'],
							ae = b.documentElement,
							se = function (e) {
								return x.contains(e.ownerDocument, e);
							},
							le = { composed: !0 };
						ae.getRootNode &&
							(se = function (e) {
								return x.contains(e.ownerDocument, e) || e.getRootNode(le) === e.ownerDocument;
							});
						var ue = function (e, t) {
							return (
								'none' === (e = t || e).style.display ||
								('' === e.style.display && se(e) && 'none' === x.css(e, 'display'))
							);
						};
						function ce(e, t, n, r) {
							var o,
								i,
								a = 20,
								s = r
									? function () {
											return r.cur();
									  }
									: function () {
											return x.css(e, t, '');
									  },
								l = s(),
								u = (n && n[3]) || (x.cssNumber[t] ? '' : 'px'),
								c = e.nodeType && (x.cssNumber[t] || ('px' !== u && +l)) && oe.exec(x.css(e, t));
							if (c && c[3] !== u) {
								for (l /= 2, u = u || c[3], c = +l || 1; a--; )
									x.style(e, t, c + u), (1 - i) * (1 - (i = s() / l || 0.5)) <= 0 && (a = 0), (c /= i);
								(c *= 2), x.style(e, t, c + u), (n = n || []);
							}
							return (
								n &&
									((c = +c || +l || 0),
									(o = n[1] ? c + (n[1] + 1) * n[2] : +n[2]),
									r && ((r.unit = u), (r.start = c), (r.end = o))),
								o
							);
						}
						var de = {};
						function fe(e) {
							var t,
								n = e.ownerDocument,
								r = e.nodeName,
								o = de[r];
							return (
								o ||
								((t = n.body.appendChild(n.createElement(r))),
								(o = x.css(t, 'display')),
								t.parentNode.removeChild(t),
								'none' === o && (o = 'block'),
								(de[r] = o),
								o)
							);
						}
						function pe(e, t) {
							for (var n, r, o = [], i = 0, a = e.length; i < a; i++)
								(r = e[i]).style &&
									((n = r.style.display),
									t
										? ('none' === n && ((o[i] = Q.get(r, 'display') || null), o[i] || (r.style.display = '')),
										  '' === r.style.display && ue(r) && (o[i] = fe(r)))
										: 'none' !== n && ((o[i] = 'none'), Q.set(r, 'display', n)));
							for (i = 0; i < a; i++) null != o[i] && (e[i].style.display = o[i]);
							return e;
						}
						x.fn.extend({
							show: function () {
								return pe(this, !0);
							},
							hide: function () {
								return pe(this);
							},
							toggle: function (e) {
								return 'boolean' == typeof e
									? e
										? this.show()
										: this.hide()
									: this.each(function () {
											ue(this) ? x(this).show() : x(this).hide();
									  });
							},
						});
						var he,
							me,
							ve = /^(?:checkbox|radio)$/i,
							ge = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
							ye = /^$|^module$|\/(?:java|ecma)script/i;
						(he = b.createDocumentFragment().appendChild(b.createElement('div'))),
							(me = b.createElement('input')).setAttribute('type', 'radio'),
							me.setAttribute('checked', 'checked'),
							me.setAttribute('name', 't'),
							he.appendChild(me),
							(v.checkClone = he.cloneNode(!0).cloneNode(!0).lastChild.checked),
							(he.innerHTML = '<textarea>x</textarea>'),
							(v.noCloneChecked = !!he.cloneNode(!0).lastChild.defaultValue),
							(he.innerHTML = '<option></option>'),
							(v.option = !!he.lastChild);
						var be = {
							thead: [1, '<table>', '</table>'],
							col: [2, '<table><colgroup>', '</colgroup></table>'],
							tr: [2, '<table><tbody>', '</tbody></table>'],
							td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
							_default: [0, '', ''],
						};
						function _e(e, t) {
							var n;
							return (
								(n =
									void 0 !== e.getElementsByTagName
										? e.getElementsByTagName(t || '*')
										: void 0 !== e.querySelectorAll
										? e.querySelectorAll(t || '*')
										: []),
								void 0 === t || (t && P(e, t)) ? x.merge([e], n) : n
							);
						}
						function we(e, t) {
							for (var n = 0, r = e.length; n < r; n++) Q.set(e[n], 'globalEval', !t || Q.get(t[n], 'globalEval'));
						}
						(be.tbody = be.tfoot = be.colgroup = be.caption = be.thead),
							(be.th = be.td),
							v.option || (be.optgroup = be.option = [1, "<select multiple='multiple'>", '</select>']);
						var Oe = /<|&#?\w+;/;
						function ke(e, t, n, r, o) {
							for (var i, a, s, l, u, c, d = t.createDocumentFragment(), f = [], p = 0, h = e.length; p < h; p++)
								if ((i = e[p]) || 0 === i)
									if ('object' === O(i)) x.merge(f, i.nodeType ? [i] : i);
									else if (Oe.test(i)) {
										for (
											a = a || d.appendChild(t.createElement('div')),
												s = (ge.exec(i) || ['', ''])[1].toLowerCase(),
												l = be[s] || be._default,
												a.innerHTML = l[1] + x.htmlPrefilter(i) + l[2],
												c = l[0];
											c--;

										)
											a = a.lastChild;
										x.merge(f, a.childNodes), ((a = d.firstChild).textContent = '');
									} else f.push(t.createTextNode(i));
							for (d.textContent = '', p = 0; (i = f[p++]); )
								if (r && x.inArray(i, r) > -1) o && o.push(i);
								else if (((u = se(i)), (a = _e(d.appendChild(i), 'script')), u && we(a), n))
									for (c = 0; (i = a[c++]); ) ye.test(i.type || '') && n.push(i);
							return d;
						}
						var xe = /^([^.]*)(?:\.(.+)|)/;
						function Ee() {
							return !0;
						}
						function Te() {
							return !1;
						}
						function Se(e, t) {
							return (
								(e ===
									(function () {
										try {
											return b.activeElement;
										} catch (e) {}
									})()) ==
								('focus' === t)
							);
						}
						function Ae(e, t, n, r, o, i) {
							var a, s;
							if ('object' == typeof t) {
								for (s in ('string' != typeof n && ((r = r || n), (n = void 0)), t)) Ae(e, s, n, r, t[s], i);
								return e;
							}
							if (
								(null == r && null == o
									? ((o = n), (r = n = void 0))
									: null == o && ('string' == typeof n ? ((o = r), (r = void 0)) : ((o = r), (r = n), (n = void 0))),
								!1 === o)
							)
								o = Te;
							else if (!o) return e;
							return (
								1 === i &&
									((a = o),
									(o = function (e) {
										return x().off(e), a.apply(this, arguments);
									}),
									(o.guid = a.guid || (a.guid = x.guid++))),
								e.each(function () {
									x.event.add(this, t, o, r, n);
								})
							);
						}
						function Ce(e, t, n) {
							n
								? (Q.set(e, t, !1),
								  x.event.add(e, t, {
										namespace: !1,
										handler: function (e) {
											var r,
												o,
												i = Q.get(this, t);
											if (1 & e.isTrigger && this[t]) {
												if (i.length) (x.event.special[t] || {}).delegateType && e.stopPropagation();
												else if (
													((i = s.call(arguments)),
													Q.set(this, t, i),
													(r = n(this, t)),
													this[t](),
													i !== (o = Q.get(this, t)) || r ? Q.set(this, t, !1) : (o = {}),
													i !== o)
												)
													return e.stopImmediatePropagation(), e.preventDefault(), o && o.value;
											} else
												i.length &&
													(Q.set(this, t, {
														value: x.event.trigger(x.extend(i[0], x.Event.prototype), i.slice(1), this),
													}),
													e.stopImmediatePropagation());
										},
								  }))
								: void 0 === Q.get(e, t) && x.event.add(e, t, Ee);
						}
						(x.event = {
							global: {},
							add: function (e, t, n, r, o) {
								var i,
									a,
									s,
									l,
									u,
									c,
									d,
									f,
									p,
									h,
									m,
									v = Q.get(e);
								if (Y(e))
									for (
										n.handler && ((n = (i = n).handler), (o = i.selector)),
											o && x.find.matchesSelector(ae, o),
											n.guid || (n.guid = x.guid++),
											(l = v.events) || (l = v.events = Object.create(null)),
											(a = v.handle) ||
												(a = v.handle =
													function (t) {
														return void 0 !== x && x.event.triggered !== t.type
															? x.event.dispatch.apply(e, arguments)
															: void 0;
													}),
											u = (t = (t || '').match(U) || ['']).length;
										u--;

									)
										(p = m = (s = xe.exec(t[u]) || [])[1]),
											(h = (s[2] || '').split('.').sort()),
											p &&
												((d = x.event.special[p] || {}),
												(p = (o ? d.delegateType : d.bindType) || p),
												(d = x.event.special[p] || {}),
												(c = x.extend(
													{
														type: p,
														origType: m,
														data: r,
														handler: n,
														guid: n.guid,
														selector: o,
														needsContext: o && x.expr.match.needsContext.test(o),
														namespace: h.join('.'),
													},
													i
												)),
												(f = l[p]) ||
													(((f = l[p] = []).delegateCount = 0),
													(d.setup && !1 !== d.setup.call(e, r, h, a)) ||
														(e.addEventListener && e.addEventListener(p, a))),
												d.add && (d.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)),
												o ? f.splice(f.delegateCount++, 0, c) : f.push(c),
												(x.event.global[p] = !0));
							},
							remove: function (e, t, n, r, o) {
								var i,
									a,
									s,
									l,
									u,
									c,
									d,
									f,
									p,
									h,
									m,
									v = Q.hasData(e) && Q.get(e);
								if (v && (l = v.events)) {
									for (u = (t = (t || '').match(U) || ['']).length; u--; )
										if (((p = m = (s = xe.exec(t[u]) || [])[1]), (h = (s[2] || '').split('.').sort()), p)) {
											for (
												d = x.event.special[p] || {},
													f = l[(p = (r ? d.delegateType : d.bindType) || p)] || [],
													s = s[2] && new RegExp('(^|\\.)' + h.join('\\.(?:.*\\.|)') + '(\\.|$)'),
													a = i = f.length;
												i--;

											)
												(c = f[i]),
													(!o && m !== c.origType) ||
														(n && n.guid !== c.guid) ||
														(s && !s.test(c.namespace)) ||
														(r && r !== c.selector && ('**' !== r || !c.selector)) ||
														(f.splice(i, 1), c.selector && f.delegateCount--, d.remove && d.remove.call(e, c));
											a &&
												!f.length &&
												((d.teardown && !1 !== d.teardown.call(e, h, v.handle)) || x.removeEvent(e, p, v.handle),
												delete l[p]);
										} else for (p in l) x.event.remove(e, p + t[u], n, r, !0);
									x.isEmptyObject(l) && Q.remove(e, 'handle events');
								}
							},
							dispatch: function (e) {
								var t,
									n,
									r,
									o,
									i,
									a,
									s = new Array(arguments.length),
									l = x.event.fix(e),
									u = (Q.get(this, 'events') || Object.create(null))[l.type] || [],
									c = x.event.special[l.type] || {};
								for (s[0] = l, t = 1; t < arguments.length; t++) s[t] = arguments[t];
								if (((l.delegateTarget = this), !c.preDispatch || !1 !== c.preDispatch.call(this, l))) {
									for (a = x.event.handlers.call(this, l, u), t = 0; (o = a[t++]) && !l.isPropagationStopped(); )
										for (l.currentTarget = o.elem, n = 0; (i = o.handlers[n++]) && !l.isImmediatePropagationStopped(); )
											(l.rnamespace && !1 !== i.namespace && !l.rnamespace.test(i.namespace)) ||
												((l.handleObj = i),
												(l.data = i.data),
												void 0 !== (r = ((x.event.special[i.origType] || {}).handle || i.handler).apply(o.elem, s)) &&
													!1 === (l.result = r) &&
													(l.preventDefault(), l.stopPropagation()));
									return c.postDispatch && c.postDispatch.call(this, l), l.result;
								}
							},
							handlers: function (e, t) {
								var n,
									r,
									o,
									i,
									a,
									s = [],
									l = t.delegateCount,
									u = e.target;
								if (l && u.nodeType && !('click' === e.type && e.button >= 1))
									for (; u !== this; u = u.parentNode || this)
										if (1 === u.nodeType && ('click' !== e.type || !0 !== u.disabled)) {
											for (i = [], a = {}, n = 0; n < l; n++)
												void 0 === a[(o = (r = t[n]).selector + ' ')] &&
													(a[o] = r.needsContext ? x(o, this).index(u) > -1 : x.find(o, this, null, [u]).length),
													a[o] && i.push(r);
											i.length && s.push({ elem: u, handlers: i });
										}
								return (u = this), l < t.length && s.push({ elem: u, handlers: t.slice(l) }), s;
							},
							addProp: function (e, t) {
								Object.defineProperty(x.Event.prototype, e, {
									enumerable: !0,
									configurable: !0,
									get: g(t)
										? function () {
												if (this.originalEvent) return t(this.originalEvent);
										  }
										: function () {
												if (this.originalEvent) return this.originalEvent[e];
										  },
									set: function (t) {
										Object.defineProperty(this, e, { enumerable: !0, configurable: !0, writable: !0, value: t });
									},
								});
							},
							fix: function (e) {
								return e[x.expando] ? e : new x.Event(e);
							},
							special: {
								load: { noBubble: !0 },
								click: {
									setup: function (e) {
										var t = this || e;
										return ve.test(t.type) && t.click && P(t, 'input') && Ce(t, 'click', Ee), !1;
									},
									trigger: function (e) {
										var t = this || e;
										return ve.test(t.type) && t.click && P(t, 'input') && Ce(t, 'click'), !0;
									},
									_default: function (e) {
										var t = e.target;
										return (ve.test(t.type) && t.click && P(t, 'input') && Q.get(t, 'click')) || P(t, 'a');
									},
								},
								beforeunload: {
									postDispatch: function (e) {
										void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
									},
								},
							},
						}),
							(x.removeEvent = function (e, t, n) {
								e.removeEventListener && e.removeEventListener(t, n);
							}),
							(x.Event = function (e, t) {
								if (!(this instanceof x.Event)) return new x.Event(e, t);
								e && e.type
									? ((this.originalEvent = e),
									  (this.type = e.type),
									  (this.isDefaultPrevented =
											e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? Ee : Te),
									  (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
									  (this.currentTarget = e.currentTarget),
									  (this.relatedTarget = e.relatedTarget))
									: (this.type = e),
									t && x.extend(this, t),
									(this.timeStamp = (e && e.timeStamp) || Date.now()),
									(this[x.expando] = !0);
							}),
							(x.Event.prototype = {
								constructor: x.Event,
								isDefaultPrevented: Te,
								isPropagationStopped: Te,
								isImmediatePropagationStopped: Te,
								isSimulated: !1,
								preventDefault: function () {
									var e = this.originalEvent;
									(this.isDefaultPrevented = Ee), e && !this.isSimulated && e.preventDefault();
								},
								stopPropagation: function () {
									var e = this.originalEvent;
									(this.isPropagationStopped = Ee), e && !this.isSimulated && e.stopPropagation();
								},
								stopImmediatePropagation: function () {
									var e = this.originalEvent;
									(this.isImmediatePropagationStopped = Ee),
										e && !this.isSimulated && e.stopImmediatePropagation(),
										this.stopPropagation();
								},
							}),
							x.each(
								{
									altKey: !0,
									bubbles: !0,
									cancelable: !0,
									changedTouches: !0,
									ctrlKey: !0,
									detail: !0,
									eventPhase: !0,
									metaKey: !0,
									pageX: !0,
									pageY: !0,
									shiftKey: !0,
									view: !0,
									char: !0,
									code: !0,
									charCode: !0,
									key: !0,
									keyCode: !0,
									button: !0,
									buttons: !0,
									clientX: !0,
									clientY: !0,
									offsetX: !0,
									offsetY: !0,
									pointerId: !0,
									pointerType: !0,
									screenX: !0,
									screenY: !0,
									targetTouches: !0,
									toElement: !0,
									touches: !0,
									which: !0,
								},
								x.event.addProp
							),
							x.each({ focus: 'focusin', blur: 'focusout' }, function (e, t) {
								x.event.special[e] = {
									setup: function () {
										return Ce(this, e, Se), !1;
									},
									trigger: function () {
										return Ce(this, e), !0;
									},
									_default: function (t) {
										return Q.get(t.target, e);
									},
									delegateType: t,
								};
							}),
							x.each(
								{
									mouseenter: 'mouseover',
									mouseleave: 'mouseout',
									pointerenter: 'pointerover',
									pointerleave: 'pointerout',
								},
								function (e, t) {
									x.event.special[e] = {
										delegateType: t,
										bindType: t,
										handle: function (e) {
											var n,
												r = this,
												o = e.relatedTarget,
												i = e.handleObj;
											return (
												(o && (o === r || x.contains(r, o))) ||
													((e.type = i.origType), (n = i.handler.apply(this, arguments)), (e.type = t)),
												n
											);
										},
									};
								}
							),
							x.fn.extend({
								on: function (e, t, n, r) {
									return Ae(this, e, t, n, r);
								},
								one: function (e, t, n, r) {
									return Ae(this, e, t, n, r, 1);
								},
								off: function (e, t, n) {
									var r, o;
									if (e && e.preventDefault && e.handleObj)
										return (
											(r = e.handleObj),
											x(e.delegateTarget).off(
												r.namespace ? r.origType + '.' + r.namespace : r.origType,
												r.selector,
												r.handler
											),
											this
										);
									if ('object' == typeof e) {
										for (o in e) this.off(o, t, e[o]);
										return this;
									}
									return (
										(!1 !== t && 'function' != typeof t) || ((n = t), (t = void 0)),
										!1 === n && (n = Te),
										this.each(function () {
											x.event.remove(this, e, n, t);
										})
									);
								},
							});
						var Pe = /<script|<style|<link/i,
							Re = /checked\s*(?:[^=]|=\s*.checked.)/i,
							Ie = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
						function Ne(e, t) {
							return (P(e, 'table') && P(11 !== t.nodeType ? t : t.firstChild, 'tr') && x(e).children('tbody')[0]) || e;
						}
						function Me(e) {
							return (e.type = (null !== e.getAttribute('type')) + '/' + e.type), e;
						}
						function je(e) {
							return 'true/' === (e.type || '').slice(0, 5) ? (e.type = e.type.slice(5)) : e.removeAttribute('type'), e;
						}
						function De(e, t) {
							var n, r, o, i, a, s;
							if (1 === t.nodeType) {
								if (Q.hasData(e) && (s = Q.get(e).events))
									for (o in (Q.remove(t, 'handle events'), s))
										for (n = 0, r = s[o].length; n < r; n++) x.event.add(t, o, s[o][n]);
								X.hasData(e) && ((i = X.access(e)), (a = x.extend({}, i)), X.set(t, a));
							}
						}
						function Le(e, t) {
							var n = t.nodeName.toLowerCase();
							'input' === n && ve.test(e.type)
								? (t.checked = e.checked)
								: ('input' !== n && 'textarea' !== n) || (t.defaultValue = e.defaultValue);
						}
						function Ue(e, t, n, r) {
							t = l(t);
							var o,
								i,
								a,
								s,
								u,
								c,
								d = 0,
								f = e.length,
								p = f - 1,
								h = t[0],
								m = g(h);
							if (m || (f > 1 && 'string' == typeof h && !v.checkClone && Re.test(h)))
								return e.each(function (o) {
									var i = e.eq(o);
									m && (t[0] = h.call(this, o, i.html())), Ue(i, t, n, r);
								});
							if (
								f &&
								((i = (o = ke(t, e[0].ownerDocument, !1, e, r)).firstChild),
								1 === o.childNodes.length && (o = i),
								i || r)
							) {
								for (s = (a = x.map(_e(o, 'script'), Me)).length; d < f; d++)
									(u = o), d !== p && ((u = x.clone(u, !0, !0)), s && x.merge(a, _e(u, 'script'))), n.call(e[d], u, d);
								if (s)
									for (c = a[a.length - 1].ownerDocument, x.map(a, je), d = 0; d < s; d++)
										(u = a[d]),
											ye.test(u.type || '') &&
												!Q.access(u, 'globalEval') &&
												x.contains(c, u) &&
												(u.src && 'module' !== (u.type || '').toLowerCase()
													? x._evalUrl &&
													  !u.noModule &&
													  x._evalUrl(u.src, { nonce: u.nonce || u.getAttribute('nonce') }, c)
													: w(u.textContent.replace(Ie, ''), u, c));
							}
							return e;
						}
						function Fe(e, t, n) {
							for (var r, o = t ? x.filter(t, e) : e, i = 0; null != (r = o[i]); i++)
								n || 1 !== r.nodeType || x.cleanData(_e(r)),
									r.parentNode && (n && se(r) && we(_e(r, 'script')), r.parentNode.removeChild(r));
							return e;
						}
						x.extend({
							htmlPrefilter: function (e) {
								return e;
							},
							clone: function (e, t, n) {
								var r,
									o,
									i,
									a,
									s = e.cloneNode(!0),
									l = se(e);
								if (!(v.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || x.isXMLDoc(e)))
									for (a = _e(s), r = 0, o = (i = _e(e)).length; r < o; r++) Le(i[r], a[r]);
								if (t)
									if (n) for (i = i || _e(e), a = a || _e(s), r = 0, o = i.length; r < o; r++) De(i[r], a[r]);
									else De(e, s);
								return (a = _e(s, 'script')).length > 0 && we(a, !l && _e(e, 'script')), s;
							},
							cleanData: function (e) {
								for (var t, n, r, o = x.event.special, i = 0; void 0 !== (n = e[i]); i++)
									if (Y(n)) {
										if ((t = n[Q.expando])) {
											if (t.events) for (r in t.events) o[r] ? x.event.remove(n, r) : x.removeEvent(n, r, t.handle);
											n[Q.expando] = void 0;
										}
										n[X.expando] && (n[X.expando] = void 0);
									}
							},
						}),
							x.fn.extend({
								detach: function (e) {
									return Fe(this, e, !0);
								},
								remove: function (e) {
									return Fe(this, e);
								},
								text: function (e) {
									return W(
										this,
										function (e) {
											return void 0 === e
												? x.text(this)
												: this.empty().each(function () {
														(1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) ||
															(this.textContent = e);
												  });
										},
										null,
										e,
										arguments.length
									);
								},
								append: function () {
									return Ue(this, arguments, function (e) {
										(1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || Ne(this, e).appendChild(e);
									});
								},
								prepend: function () {
									return Ue(this, arguments, function (e) {
										if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
											var t = Ne(this, e);
											t.insertBefore(e, t.firstChild);
										}
									});
								},
								before: function () {
									return Ue(this, arguments, function (e) {
										this.parentNode && this.parentNode.insertBefore(e, this);
									});
								},
								after: function () {
									return Ue(this, arguments, function (e) {
										this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
									});
								},
								empty: function () {
									for (var e, t = 0; null != (e = this[t]); t++)
										1 === e.nodeType && (x.cleanData(_e(e, !1)), (e.textContent = ''));
									return this;
								},
								clone: function (e, t) {
									return (
										(e = null != e && e),
										(t = null == t ? e : t),
										this.map(function () {
											return x.clone(this, e, t);
										})
									);
								},
								html: function (e) {
									return W(
										this,
										function (e) {
											var t = this[0] || {},
												n = 0,
												r = this.length;
											if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
											if ('string' == typeof e && !Pe.test(e) && !be[(ge.exec(e) || ['', ''])[1].toLowerCase()]) {
												e = x.htmlPrefilter(e);
												try {
													for (; n < r; n++)
														1 === (t = this[n] || {}).nodeType && (x.cleanData(_e(t, !1)), (t.innerHTML = e));
													t = 0;
												} catch (e) {}
											}
											t && this.empty().append(e);
										},
										null,
										e,
										arguments.length
									);
								},
								replaceWith: function () {
									var e = [];
									return Ue(
										this,
										arguments,
										function (t) {
											var n = this.parentNode;
											x.inArray(this, e) < 0 && (x.cleanData(_e(this)), n && n.replaceChild(t, this));
										},
										e
									);
								},
							}),
							x.each(
								{
									appendTo: 'append',
									prependTo: 'prepend',
									insertBefore: 'before',
									insertAfter: 'after',
									replaceAll: 'replaceWith',
								},
								function (e, t) {
									x.fn[e] = function (e) {
										for (var n, r = [], o = x(e), i = o.length - 1, a = 0; a <= i; a++)
											(n = a === i ? this : this.clone(!0)), x(o[a])[t](n), u.apply(r, n.get());
										return this.pushStack(r);
									};
								}
							);
						var Be = new RegExp('^(' + re + ')(?!px)[a-z%]+$', 'i'),
							Ve = /^--/,
							Ze = function (e) {
								var t = e.ownerDocument.defaultView;
								return (t && t.opener) || (t = r), t.getComputedStyle(e);
							},
							He = function (e, t, n) {
								var r,
									o,
									i = {};
								for (o in t) (i[o] = e.style[o]), (e.style[o] = t[o]);
								for (o in ((r = n.call(e)), t)) e.style[o] = i[o];
								return r;
							},
							qe = new RegExp(ie.join('|'), 'i'),
							We = new RegExp('^[\\x20\\t\\r\\n\\f]+|((?:^|[^\\\\])(?:\\\\.)*)[\\x20\\t\\r\\n\\f]+$', 'g');
						function Ke(e, t, n) {
							var r,
								o,
								i,
								a,
								s = Ve.test(t),
								l = e.style;
							return (
								(n = n || Ze(e)) &&
									((a = n.getPropertyValue(t) || n[t]),
									s && (a = a.replace(We, '$1')),
									'' !== a || se(e) || (a = x.style(e, t)),
									!v.pixelBoxStyles() &&
										Be.test(a) &&
										qe.test(t) &&
										((r = l.width),
										(o = l.minWidth),
										(i = l.maxWidth),
										(l.minWidth = l.maxWidth = l.width = a),
										(a = n.width),
										(l.width = r),
										(l.minWidth = o),
										(l.maxWidth = i))),
								void 0 !== a ? a + '' : a
							);
						}
						function $e(e, t) {
							return {
								get: function () {
									if (!e()) return (this.get = t).apply(this, arguments);
									delete this.get;
								},
							};
						}
						!(function () {
							function e() {
								if (c) {
									(u.style.cssText = 'position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0'),
										(c.style.cssText =
											'position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%'),
										ae.appendChild(u).appendChild(c);
									var e = r.getComputedStyle(c);
									(n = '1%' !== e.top),
										(l = 12 === t(e.marginLeft)),
										(c.style.right = '60%'),
										(a = 36 === t(e.right)),
										(o = 36 === t(e.width)),
										(c.style.position = 'absolute'),
										(i = 12 === t(c.offsetWidth / 3)),
										ae.removeChild(u),
										(c = null);
								}
							}
							function t(e) {
								return Math.round(parseFloat(e));
							}
							var n,
								o,
								i,
								a,
								s,
								l,
								u = b.createElement('div'),
								c = b.createElement('div');
							c.style &&
								((c.style.backgroundClip = 'content-box'),
								(c.cloneNode(!0).style.backgroundClip = ''),
								(v.clearCloneStyle = 'content-box' === c.style.backgroundClip),
								x.extend(v, {
									boxSizingReliable: function () {
										return e(), o;
									},
									pixelBoxStyles: function () {
										return e(), a;
									},
									pixelPosition: function () {
										return e(), n;
									},
									reliableMarginLeft: function () {
										return e(), l;
									},
									scrollboxSize: function () {
										return e(), i;
									},
									reliableTrDimensions: function () {
										var e, t, n, o;
										return (
											null == s &&
												((e = b.createElement('table')),
												(t = b.createElement('tr')),
												(n = b.createElement('div')),
												(e.style.cssText = 'position:absolute;left:-11111px;border-collapse:separate'),
												(t.style.cssText = 'border:1px solid'),
												(t.style.height = '1px'),
												(n.style.height = '9px'),
												(n.style.display = 'block'),
												ae.appendChild(e).appendChild(t).appendChild(n),
												(o = r.getComputedStyle(t)),
												(s =
													parseInt(o.height, 10) +
														parseInt(o.borderTopWidth, 10) +
														parseInt(o.borderBottomWidth, 10) ===
													t.offsetHeight),
												ae.removeChild(e)),
											s
										);
									},
								}));
						})();
						var ze = ['Webkit', 'Moz', 'ms'],
							Ge = b.createElement('div').style,
							Ye = {};
						function Je(e) {
							var t = x.cssProps[e] || Ye[e];
							return (
								t ||
								(e in Ge
									? e
									: (Ye[e] =
											(function (e) {
												for (var t = e[0].toUpperCase() + e.slice(1), n = ze.length; n--; )
													if ((e = ze[n] + t) in Ge) return e;
											})(e) || e))
							);
						}
						var Qe = /^(none|table(?!-c[ea]).+)/,
							Xe = { position: 'absolute', visibility: 'hidden', display: 'block' },
							et = { letterSpacing: '0', fontWeight: '400' };
						function tt(e, t, n) {
							var r = oe.exec(t);
							return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || 'px') : t;
						}
						function nt(e, t, n, r, o, i) {
							var a = 'width' === t ? 1 : 0,
								s = 0,
								l = 0;
							if (n === (r ? 'border' : 'content')) return 0;
							for (; a < 4; a += 2)
								'margin' === n && (l += x.css(e, n + ie[a], !0, o)),
									r
										? ('content' === n && (l -= x.css(e, 'padding' + ie[a], !0, o)),
										  'margin' !== n && (l -= x.css(e, 'border' + ie[a] + 'Width', !0, o)))
										: ((l += x.css(e, 'padding' + ie[a], !0, o)),
										  'padding' !== n
												? (l += x.css(e, 'border' + ie[a] + 'Width', !0, o))
												: (s += x.css(e, 'border' + ie[a] + 'Width', !0, o)));
							return (
								!r &&
									i >= 0 &&
									(l += Math.max(0, Math.ceil(e['offset' + t[0].toUpperCase() + t.slice(1)] - i - l - s - 0.5)) || 0),
								l
							);
						}
						function rt(e, t, n) {
							var r = Ze(e),
								o = (!v.boxSizingReliable() || n) && 'border-box' === x.css(e, 'boxSizing', !1, r),
								i = o,
								a = Ke(e, t, r),
								s = 'offset' + t[0].toUpperCase() + t.slice(1);
							if (Be.test(a)) {
								if (!n) return a;
								a = 'auto';
							}
							return (
								((!v.boxSizingReliable() && o) ||
									(!v.reliableTrDimensions() && P(e, 'tr')) ||
									'auto' === a ||
									(!parseFloat(a) && 'inline' === x.css(e, 'display', !1, r))) &&
									e.getClientRects().length &&
									((o = 'border-box' === x.css(e, 'boxSizing', !1, r)), (i = s in e) && (a = e[s])),
								(a = parseFloat(a) || 0) + nt(e, t, n || (o ? 'border' : 'content'), i, r, a) + 'px'
							);
						}
						function ot(e, t, n, r, o) {
							return new ot.prototype.init(e, t, n, r, o);
						}
						x.extend({
							cssHooks: {
								opacity: {
									get: function (e, t) {
										if (t) {
											var n = Ke(e, 'opacity');
											return '' === n ? '1' : n;
										}
									},
								},
							},
							cssNumber: {
								animationIterationCount: !0,
								columnCount: !0,
								fillOpacity: !0,
								flexGrow: !0,
								flexShrink: !0,
								fontWeight: !0,
								gridArea: !0,
								gridColumn: !0,
								gridColumnEnd: !0,
								gridColumnStart: !0,
								gridRow: !0,
								gridRowEnd: !0,
								gridRowStart: !0,
								lineHeight: !0,
								opacity: !0,
								order: !0,
								orphans: !0,
								widows: !0,
								zIndex: !0,
								zoom: !0,
							},
							cssProps: {},
							style: function (e, t, n, r) {
								if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
									var o,
										i,
										a,
										s = G(t),
										l = Ve.test(t),
										u = e.style;
									if ((l || (t = Je(s)), (a = x.cssHooks[t] || x.cssHooks[s]), void 0 === n))
										return a && 'get' in a && void 0 !== (o = a.get(e, !1, r)) ? o : u[t];
									'string' === (i = typeof n) && (o = oe.exec(n)) && o[1] && ((n = ce(e, t, o)), (i = 'number')),
										null != n &&
											n == n &&
											('number' !== i || l || (n += (o && o[3]) || (x.cssNumber[s] ? '' : 'px')),
											v.clearCloneStyle || '' !== n || 0 !== t.indexOf('background') || (u[t] = 'inherit'),
											(a && 'set' in a && void 0 === (n = a.set(e, n, r))) || (l ? u.setProperty(t, n) : (u[t] = n)));
								}
							},
							css: function (e, t, n, r) {
								var o,
									i,
									a,
									s = G(t);
								return (
									Ve.test(t) || (t = Je(s)),
									(a = x.cssHooks[t] || x.cssHooks[s]) && 'get' in a && (o = a.get(e, !0, n)),
									void 0 === o && (o = Ke(e, t, r)),
									'normal' === o && t in et && (o = et[t]),
									'' === n || n ? ((i = parseFloat(o)), !0 === n || isFinite(i) ? i || 0 : o) : o
								);
							},
						}),
							x.each(['height', 'width'], function (e, t) {
								x.cssHooks[t] = {
									get: function (e, n, r) {
										if (n)
											return !Qe.test(x.css(e, 'display')) ||
												(e.getClientRects().length && e.getBoundingClientRect().width)
												? rt(e, t, r)
												: He(e, Xe, function () {
														return rt(e, t, r);
												  });
									},
									set: function (e, n, r) {
										var o,
											i = Ze(e),
											a = !v.scrollboxSize() && 'absolute' === i.position,
											s = (a || r) && 'border-box' === x.css(e, 'boxSizing', !1, i),
											l = r ? nt(e, t, r, s, i) : 0;
										return (
											s &&
												a &&
												(l -= Math.ceil(
													e['offset' + t[0].toUpperCase() + t.slice(1)] -
														parseFloat(i[t]) -
														nt(e, t, 'border', !1, i) -
														0.5
												)),
											l && (o = oe.exec(n)) && 'px' !== (o[3] || 'px') && ((e.style[t] = n), (n = x.css(e, t))),
											tt(0, n, l)
										);
									},
								};
							}),
							(x.cssHooks.marginLeft = $e(v.reliableMarginLeft, function (e, t) {
								if (t)
									return (
										(parseFloat(Ke(e, 'marginLeft')) ||
											e.getBoundingClientRect().left -
												He(e, { marginLeft: 0 }, function () {
													return e.getBoundingClientRect().left;
												})) + 'px'
									);
							})),
							x.each({ margin: '', padding: '', border: 'Width' }, function (e, t) {
								(x.cssHooks[e + t] = {
									expand: function (n) {
										for (var r = 0, o = {}, i = 'string' == typeof n ? n.split(' ') : [n]; r < 4; r++)
											o[e + ie[r] + t] = i[r] || i[r - 2] || i[0];
										return o;
									},
								}),
									'margin' !== e && (x.cssHooks[e + t].set = tt);
							}),
							x.fn.extend({
								css: function (e, t) {
									return W(
										this,
										function (e, t, n) {
											var r,
												o,
												i = {},
												a = 0;
											if (Array.isArray(t)) {
												for (r = Ze(e), o = t.length; a < o; a++) i[t[a]] = x.css(e, t[a], !1, r);
												return i;
											}
											return void 0 !== n ? x.style(e, t, n) : x.css(e, t);
										},
										e,
										t,
										arguments.length > 1
									);
								},
							}),
							(x.Tween = ot),
							(ot.prototype = {
								constructor: ot,
								init: function (e, t, n, r, o, i) {
									(this.elem = e),
										(this.prop = n),
										(this.easing = o || x.easing._default),
										(this.options = t),
										(this.start = this.now = this.cur()),
										(this.end = r),
										(this.unit = i || (x.cssNumber[n] ? '' : 'px'));
								},
								cur: function () {
									var e = ot.propHooks[this.prop];
									return e && e.get ? e.get(this) : ot.propHooks._default.get(this);
								},
								run: function (e) {
									var t,
										n = ot.propHooks[this.prop];
									return (
										this.options.duration
											? (this.pos = t =
													x.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration))
											: (this.pos = t = e),
										(this.now = (this.end - this.start) * t + this.start),
										this.options.step && this.options.step.call(this.elem, this.now, this),
										n && n.set ? n.set(this) : ot.propHooks._default.set(this),
										this
									);
								},
							}),
							(ot.prototype.init.prototype = ot.prototype),
							(ot.propHooks = {
								_default: {
									get: function (e) {
										var t;
										return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop])
											? e.elem[e.prop]
											: (t = x.css(e.elem, e.prop, '')) && 'auto' !== t
											? t
											: 0;
									},
									set: function (e) {
										x.fx.step[e.prop]
											? x.fx.step[e.prop](e)
											: 1 !== e.elem.nodeType || (!x.cssHooks[e.prop] && null == e.elem.style[Je(e.prop)])
											? (e.elem[e.prop] = e.now)
											: x.style(e.elem, e.prop, e.now + e.unit);
									},
								},
							}),
							(ot.propHooks.scrollTop = ot.propHooks.scrollLeft =
								{
									set: function (e) {
										e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
									},
								}),
							(x.easing = {
								linear: function (e) {
									return e;
								},
								swing: function (e) {
									return 0.5 - Math.cos(e * Math.PI) / 2;
								},
								_default: 'swing',
							}),
							(x.fx = ot.prototype.init),
							(x.fx.step = {});
						var it,
							at,
							st = /^(?:toggle|show|hide)$/,
							lt = /queueHooks$/;
						function ut() {
							at &&
								(!1 === b.hidden && r.requestAnimationFrame
									? r.requestAnimationFrame(ut)
									: r.setTimeout(ut, x.fx.interval),
								x.fx.tick());
						}
						function ct() {
							return (
								r.setTimeout(function () {
									it = void 0;
								}),
								(it = Date.now())
							);
						}
						function dt(e, t) {
							var n,
								r = 0,
								o = { height: e };
							for (t = t ? 1 : 0; r < 4; r += 2 - t) o['margin' + (n = ie[r])] = o['padding' + n] = e;
							return t && (o.opacity = o.width = e), o;
						}
						function ft(e, t, n) {
							for (var r, o = (pt.tweeners[t] || []).concat(pt.tweeners['*']), i = 0, a = o.length; i < a; i++)
								if ((r = o[i].call(n, t, e))) return r;
						}
						function pt(e, t, n) {
							var r,
								o,
								i = 0,
								a = pt.prefilters.length,
								s = x.Deferred().always(function () {
									delete l.elem;
								}),
								l = function () {
									if (o) return !1;
									for (
										var t = it || ct(),
											n = Math.max(0, u.startTime + u.duration - t),
											r = 1 - (n / u.duration || 0),
											i = 0,
											a = u.tweens.length;
										i < a;
										i++
									)
										u.tweens[i].run(r);
									return (
										s.notifyWith(e, [u, r, n]),
										r < 1 && a ? n : (a || s.notifyWith(e, [u, 1, 0]), s.resolveWith(e, [u]), !1)
									);
								},
								u = s.promise({
									elem: e,
									props: x.extend({}, t),
									opts: x.extend(!0, { specialEasing: {}, easing: x.easing._default }, n),
									originalProperties: t,
									originalOptions: n,
									startTime: it || ct(),
									duration: n.duration,
									tweens: [],
									createTween: function (t, n) {
										var r = x.Tween(e, u.opts, t, n, u.opts.specialEasing[t] || u.opts.easing);
										return u.tweens.push(r), r;
									},
									stop: function (t) {
										var n = 0,
											r = t ? u.tweens.length : 0;
										if (o) return this;
										for (o = !0; n < r; n++) u.tweens[n].run(1);
										return t ? (s.notifyWith(e, [u, 1, 0]), s.resolveWith(e, [u, t])) : s.rejectWith(e, [u, t]), this;
									},
								}),
								c = u.props;
							for (
								!(function (e, t) {
									var n, r, o, i, a;
									for (n in e)
										if (
											((o = t[(r = G(n))]),
											(i = e[n]),
											Array.isArray(i) && ((o = i[1]), (i = e[n] = i[0])),
											n !== r && ((e[r] = i), delete e[n]),
											(a = x.cssHooks[r]) && ('expand' in a))
										)
											for (n in ((i = a.expand(i)), delete e[r], i)) (n in e) || ((e[n] = i[n]), (t[n] = o));
										else t[r] = o;
								})(c, u.opts.specialEasing);
								i < a;
								i++
							)
								if ((r = pt.prefilters[i].call(u, e, c, u.opts)))
									return g(r.stop) && (x._queueHooks(u.elem, u.opts.queue).stop = r.stop.bind(r)), r;
							return (
								x.map(c, ft, u),
								g(u.opts.start) && u.opts.start.call(e, u),
								u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always),
								x.fx.timer(x.extend(l, { elem: e, anim: u, queue: u.opts.queue })),
								u
							);
						}
						(x.Animation = x.extend(pt, {
							tweeners: {
								'*': [
									function (e, t) {
										var n = this.createTween(e, t);
										return ce(n.elem, e, oe.exec(t), n), n;
									},
								],
							},
							tweener: function (e, t) {
								g(e) ? ((t = e), (e = ['*'])) : (e = e.match(U));
								for (var n, r = 0, o = e.length; r < o; r++)
									(n = e[r]), (pt.tweeners[n] = pt.tweeners[n] || []), pt.tweeners[n].unshift(t);
							},
							prefilters: [
								function (e, t, n) {
									var r,
										o,
										i,
										a,
										s,
										l,
										u,
										c,
										d = 'width' in t || 'height' in t,
										f = this,
										p = {},
										h = e.style,
										m = e.nodeType && ue(e),
										v = Q.get(e, 'fxshow');
									for (r in (n.queue ||
										(null == (a = x._queueHooks(e, 'fx')).unqueued &&
											((a.unqueued = 0),
											(s = a.empty.fire),
											(a.empty.fire = function () {
												a.unqueued || s();
											})),
										a.unqueued++,
										f.always(function () {
											f.always(function () {
												a.unqueued--, x.queue(e, 'fx').length || a.empty.fire();
											});
										})),
									t))
										if (((o = t[r]), st.test(o))) {
											if ((delete t[r], (i = i || 'toggle' === o), o === (m ? 'hide' : 'show'))) {
												if ('show' !== o || !v || void 0 === v[r]) continue;
												m = !0;
											}
											p[r] = (v && v[r]) || x.style(e, r);
										}
									if ((l = !x.isEmptyObject(t)) || !x.isEmptyObject(p))
										for (r in (d &&
											1 === e.nodeType &&
											((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
											null == (u = v && v.display) && (u = Q.get(e, 'display')),
											'none' === (c = x.css(e, 'display')) &&
												(u ? (c = u) : (pe([e], !0), (u = e.style.display || u), (c = x.css(e, 'display')), pe([e]))),
											('inline' === c || ('inline-block' === c && null != u)) &&
												'none' === x.css(e, 'float') &&
												(l ||
													(f.done(function () {
														h.display = u;
													}),
													null == u && ((c = h.display), (u = 'none' === c ? '' : c))),
												(h.display = 'inline-block'))),
										n.overflow &&
											((h.overflow = 'hidden'),
											f.always(function () {
												(h.overflow = n.overflow[0]), (h.overflowX = n.overflow[1]), (h.overflowY = n.overflow[2]);
											})),
										(l = !1),
										p))
											l ||
												(v ? 'hidden' in v && (m = v.hidden) : (v = Q.access(e, 'fxshow', { display: u })),
												i && (v.hidden = !m),
												m && pe([e], !0),
												f.done(function () {
													for (r in (m || pe([e]), Q.remove(e, 'fxshow'), p)) x.style(e, r, p[r]);
												})),
												(l = ft(m ? v[r] : 0, r, f)),
												r in v || ((v[r] = l.start), m && ((l.end = l.start), (l.start = 0)));
								},
							],
							prefilter: function (e, t) {
								t ? pt.prefilters.unshift(e) : pt.prefilters.push(e);
							},
						})),
							(x.speed = function (e, t, n) {
								var r =
									e && 'object' == typeof e
										? x.extend({}, e)
										: { complete: n || (!n && t) || (g(e) && e), duration: e, easing: (n && t) || (t && !g(t) && t) };
								return (
									x.fx.off
										? (r.duration = 0)
										: 'number' != typeof r.duration &&
										  (r.duration in x.fx.speeds
												? (r.duration = x.fx.speeds[r.duration])
												: (r.duration = x.fx.speeds._default)),
									(null != r.queue && !0 !== r.queue) || (r.queue = 'fx'),
									(r.old = r.complete),
									(r.complete = function () {
										g(r.old) && r.old.call(this), r.queue && x.dequeue(this, r.queue);
									}),
									r
								);
							}),
							x.fn.extend({
								fadeTo: function (e, t, n, r) {
									return this.filter(ue).css('opacity', 0).show().end().animate({ opacity: t }, e, n, r);
								},
								animate: function (e, t, n, r) {
									var o = x.isEmptyObject(e),
										i = x.speed(t, n, r),
										a = function () {
											var t = pt(this, x.extend({}, e), i);
											(o || Q.get(this, 'finish')) && t.stop(!0);
										};
									return (a.finish = a), o || !1 === i.queue ? this.each(a) : this.queue(i.queue, a);
								},
								stop: function (e, t, n) {
									var r = function (e) {
										var t = e.stop;
										delete e.stop, t(n);
									};
									return (
										'string' != typeof e && ((n = t), (t = e), (e = void 0)),
										t && this.queue(e || 'fx', []),
										this.each(function () {
											var t = !0,
												o = null != e && e + 'queueHooks',
												i = x.timers,
												a = Q.get(this);
											if (o) a[o] && a[o].stop && r(a[o]);
											else for (o in a) a[o] && a[o].stop && lt.test(o) && r(a[o]);
											for (o = i.length; o--; )
												i[o].elem !== this ||
													(null != e && i[o].queue !== e) ||
													(i[o].anim.stop(n), (t = !1), i.splice(o, 1));
											(!t && n) || x.dequeue(this, e);
										})
									);
								},
								finish: function (e) {
									return (
										!1 !== e && (e = e || 'fx'),
										this.each(function () {
											var t,
												n = Q.get(this),
												r = n[e + 'queue'],
												o = n[e + 'queueHooks'],
												i = x.timers,
												a = r ? r.length : 0;
											for (
												n.finish = !0, x.queue(this, e, []), o && o.stop && o.stop.call(this, !0), t = i.length;
												t--;

											)
												i[t].elem === this && i[t].queue === e && (i[t].anim.stop(!0), i.splice(t, 1));
											for (t = 0; t < a; t++) r[t] && r[t].finish && r[t].finish.call(this);
											delete n.finish;
										})
									);
								},
							}),
							x.each(['toggle', 'show', 'hide'], function (e, t) {
								var n = x.fn[t];
								x.fn[t] = function (e, r, o) {
									return null == e || 'boolean' == typeof e
										? n.apply(this, arguments)
										: this.animate(dt(t, !0), e, r, o);
								};
							}),
							x.each(
								{
									slideDown: dt('show'),
									slideUp: dt('hide'),
									slideToggle: dt('toggle'),
									fadeIn: { opacity: 'show' },
									fadeOut: { opacity: 'hide' },
									fadeToggle: { opacity: 'toggle' },
								},
								function (e, t) {
									x.fn[e] = function (e, n, r) {
										return this.animate(t, e, n, r);
									};
								}
							),
							(x.timers = []),
							(x.fx.tick = function () {
								var e,
									t = 0,
									n = x.timers;
								for (it = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
								n.length || x.fx.stop(), (it = void 0);
							}),
							(x.fx.timer = function (e) {
								x.timers.push(e), x.fx.start();
							}),
							(x.fx.interval = 13),
							(x.fx.start = function () {
								at || ((at = !0), ut());
							}),
							(x.fx.stop = function () {
								at = null;
							}),
							(x.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
							(x.fn.delay = function (e, t) {
								return (
									(e = (x.fx && x.fx.speeds[e]) || e),
									(t = t || 'fx'),
									this.queue(t, function (t, n) {
										var o = r.setTimeout(t, e);
										n.stop = function () {
											r.clearTimeout(o);
										};
									})
								);
							}),
							(function () {
								var e = b.createElement('input'),
									t = b.createElement('select').appendChild(b.createElement('option'));
								(e.type = 'checkbox'),
									(v.checkOn = '' !== e.value),
									(v.optSelected = t.selected),
									((e = b.createElement('input')).value = 't'),
									(e.type = 'radio'),
									(v.radioValue = 't' === e.value);
							})();
						var ht,
							mt = x.expr.attrHandle;
						x.fn.extend({
							attr: function (e, t) {
								return W(this, x.attr, e, t, arguments.length > 1);
							},
							removeAttr: function (e) {
								return this.each(function () {
									x.removeAttr(this, e);
								});
							},
						}),
							x.extend({
								attr: function (e, t, n) {
									var r,
										o,
										i = e.nodeType;
									if (3 !== i && 8 !== i && 2 !== i)
										return void 0 === e.getAttribute
											? x.prop(e, t, n)
											: ((1 === i && x.isXMLDoc(e)) ||
													(o = x.attrHooks[t.toLowerCase()] || (x.expr.match.bool.test(t) ? ht : void 0)),
											  void 0 !== n
													? null === n
														? void x.removeAttr(e, t)
														: o && 'set' in o && void 0 !== (r = o.set(e, n, t))
														? r
														: (e.setAttribute(t, n + ''), n)
													: o && 'get' in o && null !== (r = o.get(e, t))
													? r
													: null == (r = x.find.attr(e, t))
													? void 0
													: r);
								},
								attrHooks: {
									type: {
										set: function (e, t) {
											if (!v.radioValue && 'radio' === t && P(e, 'input')) {
												var n = e.value;
												return e.setAttribute('type', t), n && (e.value = n), t;
											}
										},
									},
								},
								removeAttr: function (e, t) {
									var n,
										r = 0,
										o = t && t.match(U);
									if (o && 1 === e.nodeType) for (; (n = o[r++]); ) e.removeAttribute(n);
								},
							}),
							(ht = {
								set: function (e, t, n) {
									return !1 === t ? x.removeAttr(e, n) : e.setAttribute(n, n), n;
								},
							}),
							x.each(x.expr.match.bool.source.match(/\w+/g), function (e, t) {
								var n = mt[t] || x.find.attr;
								mt[t] = function (e, t, r) {
									var o,
										i,
										a = t.toLowerCase();
									return r || ((i = mt[a]), (mt[a] = o), (o = null != n(e, t, r) ? a : null), (mt[a] = i)), o;
								};
							});
						var vt = /^(?:input|select|textarea|button)$/i,
							gt = /^(?:a|area)$/i;
						function yt(e) {
							return (e.match(U) || []).join(' ');
						}
						function bt(e) {
							return (e.getAttribute && e.getAttribute('class')) || '';
						}
						function _t(e) {
							return Array.isArray(e) ? e : ('string' == typeof e && e.match(U)) || [];
						}
						x.fn.extend({
							prop: function (e, t) {
								return W(this, x.prop, e, t, arguments.length > 1);
							},
							removeProp: function (e) {
								return this.each(function () {
									delete this[x.propFix[e] || e];
								});
							},
						}),
							x.extend({
								prop: function (e, t, n) {
									var r,
										o,
										i = e.nodeType;
									if (3 !== i && 8 !== i && 2 !== i)
										return (
											(1 === i && x.isXMLDoc(e)) || ((t = x.propFix[t] || t), (o = x.propHooks[t])),
											void 0 !== n
												? o && 'set' in o && void 0 !== (r = o.set(e, n, t))
													? r
													: (e[t] = n)
												: o && 'get' in o && null !== (r = o.get(e, t))
												? r
												: e[t]
										);
								},
								propHooks: {
									tabIndex: {
										get: function (e) {
											var t = x.find.attr(e, 'tabindex');
											return t ? parseInt(t, 10) : vt.test(e.nodeName) || (gt.test(e.nodeName) && e.href) ? 0 : -1;
										},
									},
								},
								propFix: { for: 'htmlFor', class: 'className' },
							}),
							v.optSelected ||
								(x.propHooks.selected = {
									get: function (e) {
										var t = e.parentNode;
										return t && t.parentNode && t.parentNode.selectedIndex, null;
									},
									set: function (e) {
										var t = e.parentNode;
										t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
									},
								}),
							x.each(
								[
									'tabIndex',
									'readOnly',
									'maxLength',
									'cellSpacing',
									'cellPadding',
									'rowSpan',
									'colSpan',
									'useMap',
									'frameBorder',
									'contentEditable',
								],
								function () {
									x.propFix[this.toLowerCase()] = this;
								}
							),
							x.fn.extend({
								addClass: function (e) {
									var t, n, r, o, i, a;
									return g(e)
										? this.each(function (t) {
												x(this).addClass(e.call(this, t, bt(this)));
										  })
										: (t = _t(e)).length
										? this.each(function () {
												if (((r = bt(this)), (n = 1 === this.nodeType && ' ' + yt(r) + ' '))) {
													for (i = 0; i < t.length; i++) (o = t[i]), n.indexOf(' ' + o + ' ') < 0 && (n += o + ' ');
													(a = yt(n)), r !== a && this.setAttribute('class', a);
												}
										  })
										: this;
								},
								removeClass: function (e) {
									var t, n, r, o, i, a;
									return g(e)
										? this.each(function (t) {
												x(this).removeClass(e.call(this, t, bt(this)));
										  })
										: arguments.length
										? (t = _t(e)).length
											? this.each(function () {
													if (((r = bt(this)), (n = 1 === this.nodeType && ' ' + yt(r) + ' '))) {
														for (i = 0; i < t.length; i++)
															for (o = t[i]; n.indexOf(' ' + o + ' ') > -1; ) n = n.replace(' ' + o + ' ', ' ');
														(a = yt(n)), r !== a && this.setAttribute('class', a);
													}
											  })
											: this
										: this.attr('class', '');
								},
								toggleClass: function (e, t) {
									var n,
										r,
										o,
										i,
										a = typeof e,
										s = 'string' === a || Array.isArray(e);
									return g(e)
										? this.each(function (n) {
												x(this).toggleClass(e.call(this, n, bt(this), t), t);
										  })
										: 'boolean' == typeof t && s
										? t
											? this.addClass(e)
											: this.removeClass(e)
										: ((n = _t(e)),
										  this.each(function () {
												if (s)
													for (i = x(this), o = 0; o < n.length; o++)
														(r = n[o]), i.hasClass(r) ? i.removeClass(r) : i.addClass(r);
												else
													(void 0 !== e && 'boolean' !== a) ||
														((r = bt(this)) && Q.set(this, '__className__', r),
														this.setAttribute &&
															this.setAttribute('class', r || !1 === e ? '' : Q.get(this, '__className__') || ''));
										  }));
								},
								hasClass: function (e) {
									var t,
										n,
										r = 0;
									for (t = ' ' + e + ' '; (n = this[r++]); )
										if (1 === n.nodeType && (' ' + yt(bt(n)) + ' ').indexOf(t) > -1) return !0;
									return !1;
								},
							});
						var wt = /\r/g;
						x.fn.extend({
							val: function (e) {
								var t,
									n,
									r,
									o = this[0];
								return arguments.length
									? ((r = g(e)),
									  this.each(function (n) {
											var o;
											1 === this.nodeType &&
												(null == (o = r ? e.call(this, n, x(this).val()) : e)
													? (o = '')
													: 'number' == typeof o
													? (o += '')
													: Array.isArray(o) &&
													  (o = x.map(o, function (e) {
															return null == e ? '' : e + '';
													  })),
												((t = x.valHooks[this.type] || x.valHooks[this.nodeName.toLowerCase()]) &&
													'set' in t &&
													void 0 !== t.set(this, o, 'value')) ||
													(this.value = o));
									  }))
									: o
									? (t = x.valHooks[o.type] || x.valHooks[o.nodeName.toLowerCase()]) &&
									  'get' in t &&
									  void 0 !== (n = t.get(o, 'value'))
										? n
										: 'string' == typeof (n = o.value)
										? n.replace(wt, '')
										: null == n
										? ''
										: n
									: void 0;
							},
						}),
							x.extend({
								valHooks: {
									option: {
										get: function (e) {
											var t = x.find.attr(e, 'value');
											return null != t ? t : yt(x.text(e));
										},
									},
									select: {
										get: function (e) {
											var t,
												n,
												r,
												o = e.options,
												i = e.selectedIndex,
												a = 'select-one' === e.type,
												s = a ? null : [],
												l = a ? i + 1 : o.length;
											for (r = i < 0 ? l : a ? i : 0; r < l; r++)
												if (
													((n = o[r]).selected || r === i) &&
													!n.disabled &&
													(!n.parentNode.disabled || !P(n.parentNode, 'optgroup'))
												) {
													if (((t = x(n).val()), a)) return t;
													s.push(t);
												}
											return s;
										},
										set: function (e, t) {
											for (var n, r, o = e.options, i = x.makeArray(t), a = o.length; a--; )
												((r = o[a]).selected = x.inArray(x.valHooks.option.get(r), i) > -1) && (n = !0);
											return n || (e.selectedIndex = -1), i;
										},
									},
								},
							}),
							x.each(['radio', 'checkbox'], function () {
								(x.valHooks[this] = {
									set: function (e, t) {
										if (Array.isArray(t)) return (e.checked = x.inArray(x(e).val(), t) > -1);
									},
								}),
									v.checkOn ||
										(x.valHooks[this].get = function (e) {
											return null === e.getAttribute('value') ? 'on' : e.value;
										});
							}),
							(v.focusin = 'onfocusin' in r);
						var Ot = /^(?:focusinfocus|focusoutblur)$/,
							kt = function (e) {
								e.stopPropagation();
							};
						x.extend(x.event, {
							trigger: function (e, t, n, o) {
								var i,
									a,
									s,
									l,
									u,
									c,
									d,
									f,
									h = [n || b],
									m = p.call(e, 'type') ? e.type : e,
									v = p.call(e, 'namespace') ? e.namespace.split('.') : [];
								if (
									((a = f = s = n = n || b),
									3 !== n.nodeType &&
										8 !== n.nodeType &&
										!Ot.test(m + x.event.triggered) &&
										(m.indexOf('.') > -1 && ((v = m.split('.')), (m = v.shift()), v.sort()),
										(u = m.indexOf(':') < 0 && 'on' + m),
										((e = e[x.expando] ? e : new x.Event(m, 'object' == typeof e && e)).isTrigger = o ? 2 : 3),
										(e.namespace = v.join('.')),
										(e.rnamespace = e.namespace ? new RegExp('(^|\\.)' + v.join('\\.(?:.*\\.|)') + '(\\.|$)') : null),
										(e.result = void 0),
										e.target || (e.target = n),
										(t = null == t ? [e] : x.makeArray(t, [e])),
										(d = x.event.special[m] || {}),
										o || !d.trigger || !1 !== d.trigger.apply(n, t)))
								) {
									if (!o && !d.noBubble && !y(n)) {
										for (l = d.delegateType || m, Ot.test(l + m) || (a = a.parentNode); a; a = a.parentNode)
											h.push(a), (s = a);
										s === (n.ownerDocument || b) && h.push(s.defaultView || s.parentWindow || r);
									}
									for (i = 0; (a = h[i++]) && !e.isPropagationStopped(); )
										(f = a),
											(e.type = i > 1 ? l : d.bindType || m),
											(c = (Q.get(a, 'events') || Object.create(null))[e.type] && Q.get(a, 'handle')) && c.apply(a, t),
											(c = u && a[u]) &&
												c.apply &&
												Y(a) &&
												((e.result = c.apply(a, t)), !1 === e.result && e.preventDefault());
									return (
										(e.type = m),
										o ||
											e.isDefaultPrevented() ||
											(d._default && !1 !== d._default.apply(h.pop(), t)) ||
											!Y(n) ||
											(u &&
												g(n[m]) &&
												!y(n) &&
												((s = n[u]) && (n[u] = null),
												(x.event.triggered = m),
												e.isPropagationStopped() && f.addEventListener(m, kt),
												n[m](),
												e.isPropagationStopped() && f.removeEventListener(m, kt),
												(x.event.triggered = void 0),
												s && (n[u] = s))),
										e.result
									);
								}
							},
							simulate: function (e, t, n) {
								var r = x.extend(new x.Event(), n, { type: e, isSimulated: !0 });
								x.event.trigger(r, null, t);
							},
						}),
							x.fn.extend({
								trigger: function (e, t) {
									return this.each(function () {
										x.event.trigger(e, t, this);
									});
								},
								triggerHandler: function (e, t) {
									var n = this[0];
									if (n) return x.event.trigger(e, t, n, !0);
								},
							}),
							v.focusin ||
								x.each({ focus: 'focusin', blur: 'focusout' }, function (e, t) {
									var n = function (e) {
										x.event.simulate(t, e.target, x.event.fix(e));
									};
									x.event.special[t] = {
										setup: function () {
											var r = this.ownerDocument || this.document || this,
												o = Q.access(r, t);
											o || r.addEventListener(e, n, !0), Q.access(r, t, (o || 0) + 1);
										},
										teardown: function () {
											var r = this.ownerDocument || this.document || this,
												o = Q.access(r, t) - 1;
											o ? Q.access(r, t, o) : (r.removeEventListener(e, n, !0), Q.remove(r, t));
										},
									};
								});
						var xt = r.location,
							Et = { guid: Date.now() },
							Tt = /\?/;
						x.parseXML = function (e) {
							var t, n;
							if (!e || 'string' != typeof e) return null;
							try {
								t = new r.DOMParser().parseFromString(e, 'text/xml');
							} catch (e) {}
							return (
								(n = t && t.getElementsByTagName('parsererror')[0]),
								(t && !n) ||
									x.error(
										'Invalid XML: ' +
											(n
												? x
														.map(n.childNodes, function (e) {
															return e.textContent;
														})
														.join('\n')
												: e)
									),
								t
							);
						};
						var St = /\[\]$/,
							At = /\r?\n/g,
							Ct = /^(?:submit|button|image|reset|file)$/i,
							Pt = /^(?:input|select|textarea|keygen)/i;
						function Rt(e, t, n, r) {
							var o;
							if (Array.isArray(t))
								x.each(t, function (t, o) {
									n || St.test(e) ? r(e, o) : Rt(e + '[' + ('object' == typeof o && null != o ? t : '') + ']', o, n, r);
								});
							else if (n || 'object' !== O(t)) r(e, t);
							else for (o in t) Rt(e + '[' + o + ']', t[o], n, r);
						}
						(x.param = function (e, t) {
							var n,
								r = [],
								o = function (e, t) {
									var n = g(t) ? t() : t;
									r[r.length] = encodeURIComponent(e) + '=' + encodeURIComponent(null == n ? '' : n);
								};
							if (null == e) return '';
							if (Array.isArray(e) || (e.jquery && !x.isPlainObject(e)))
								x.each(e, function () {
									o(this.name, this.value);
								});
							else for (n in e) Rt(n, e[n], t, o);
							return r.join('&');
						}),
							x.fn.extend({
								serialize: function () {
									return x.param(this.serializeArray());
								},
								serializeArray: function () {
									return this.map(function () {
										var e = x.prop(this, 'elements');
										return e ? x.makeArray(e) : this;
									})
										.filter(function () {
											var e = this.type;
											return (
												this.name &&
												!x(this).is(':disabled') &&
												Pt.test(this.nodeName) &&
												!Ct.test(e) &&
												(this.checked || !ve.test(e))
											);
										})
										.map(function (e, t) {
											var n = x(this).val();
											return null == n
												? null
												: Array.isArray(n)
												? x.map(n, function (e) {
														return { name: t.name, value: e.replace(At, '\r\n') };
												  })
												: { name: t.name, value: n.replace(At, '\r\n') };
										})
										.get();
								},
							});
						var It = /%20/g,
							Nt = /#.*$/,
							Mt = /([?&])_=[^&]*/,
							jt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
							Dt = /^(?:GET|HEAD)$/,
							Lt = /^\/\//,
							Ut = {},
							Ft = {},
							Bt = '*/'.concat('*'),
							Vt = b.createElement('a');
						function Zt(e) {
							return function (t, n) {
								'string' != typeof t && ((n = t), (t = '*'));
								var r,
									o = 0,
									i = t.toLowerCase().match(U) || [];
								if (g(n))
									for (; (r = i[o++]); )
										'+' === r[0]
											? ((r = r.slice(1) || '*'), (e[r] = e[r] || []).unshift(n))
											: (e[r] = e[r] || []).push(n);
							};
						}
						function Ht(e, t, n, r) {
							var o = {},
								i = e === Ft;
							function a(s) {
								var l;
								return (
									(o[s] = !0),
									x.each(e[s] || [], function (e, s) {
										var u = s(t, n, r);
										return 'string' != typeof u || i || o[u]
											? i
												? !(l = u)
												: void 0
											: (t.dataTypes.unshift(u), a(u), !1);
									}),
									l
								);
							}
							return a(t.dataTypes[0]) || (!o['*'] && a('*'));
						}
						function qt(e, t) {
							var n,
								r,
								o = x.ajaxSettings.flatOptions || {};
							for (n in t) void 0 !== t[n] && ((o[n] ? e : r || (r = {}))[n] = t[n]);
							return r && x.extend(!0, e, r), e;
						}
						(Vt.href = xt.href),
							x.extend({
								active: 0,
								lastModified: {},
								etag: {},
								ajaxSettings: {
									url: xt.href,
									type: 'GET',
									isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(xt.protocol),
									global: !0,
									processData: !0,
									async: !0,
									contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
									accepts: {
										'*': Bt,
										'text': 'text/plain',
										'html': 'text/html',
										'xml': 'application/xml, text/xml',
										'json': 'application/json, text/javascript',
									},
									contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
									responseFields: { xml: 'responseXML', text: 'responseText', json: 'responseJSON' },
									converters: { '* text': String, 'text html': !0, 'text json': JSON.parse, 'text xml': x.parseXML },
									flatOptions: { url: !0, context: !0 },
								},
								ajaxSetup: function (e, t) {
									return t ? qt(qt(e, x.ajaxSettings), t) : qt(x.ajaxSettings, e);
								},
								ajaxPrefilter: Zt(Ut),
								ajaxTransport: Zt(Ft),
								ajax: function (e, t) {
									'object' == typeof e && ((t = e), (e = void 0)), (t = t || {});
									var n,
										o,
										i,
										a,
										s,
										l,
										u,
										c,
										d,
										f,
										p = x.ajaxSetup({}, t),
										h = p.context || p,
										m = p.context && (h.nodeType || h.jquery) ? x(h) : x.event,
										v = x.Deferred(),
										g = x.Callbacks('once memory'),
										y = p.statusCode || {},
										_ = {},
										w = {},
										O = 'canceled',
										k = {
											readyState: 0,
											getResponseHeader: function (e) {
												var t;
												if (u) {
													if (!a)
														for (a = {}; (t = jt.exec(i)); )
															a[t[1].toLowerCase() + ' '] = (a[t[1].toLowerCase() + ' '] || []).concat(t[2]);
													t = a[e.toLowerCase() + ' '];
												}
												return null == t ? null : t.join(', ');
											},
											getAllResponseHeaders: function () {
												return u ? i : null;
											},
											setRequestHeader: function (e, t) {
												return null == u && ((e = w[e.toLowerCase()] = w[e.toLowerCase()] || e), (_[e] = t)), this;
											},
											overrideMimeType: function (e) {
												return null == u && (p.mimeType = e), this;
											},
											statusCode: function (e) {
												var t;
												if (e)
													if (u) k.always(e[k.status]);
													else for (t in e) y[t] = [y[t], e[t]];
												return this;
											},
											abort: function (e) {
												var t = e || O;
												return n && n.abort(t), E(0, t), this;
											},
										};
									if (
										(v.promise(k),
										(p.url = ((e || p.url || xt.href) + '').replace(Lt, xt.protocol + '//')),
										(p.type = t.method || t.type || p.method || p.type),
										(p.dataTypes = (p.dataType || '*').toLowerCase().match(U) || ['']),
										null == p.crossDomain)
									) {
										l = b.createElement('a');
										try {
											(l.href = p.url),
												(l.href = l.href),
												(p.crossDomain = Vt.protocol + '//' + Vt.host != l.protocol + '//' + l.host);
										} catch (e) {
											p.crossDomain = !0;
										}
									}
									if (
										(p.data && p.processData && 'string' != typeof p.data && (p.data = x.param(p.data, p.traditional)),
										Ht(Ut, p, t, k),
										u)
									)
										return k;
									for (d in ((c = x.event && p.global) && 0 == x.active++ && x.event.trigger('ajaxStart'),
									(p.type = p.type.toUpperCase()),
									(p.hasContent = !Dt.test(p.type)),
									(o = p.url.replace(Nt, '')),
									p.hasContent
										? p.data &&
										  p.processData &&
										  0 === (p.contentType || '').indexOf('application/x-www-form-urlencoded') &&
										  (p.data = p.data.replace(It, '+'))
										: ((f = p.url.slice(o.length)),
										  p.data &&
												(p.processData || 'string' == typeof p.data) &&
												((o += (Tt.test(o) ? '&' : '?') + p.data), delete p.data),
										  !1 === p.cache &&
												((o = o.replace(Mt, '$1')), (f = (Tt.test(o) ? '&' : '?') + '_=' + Et.guid++ + f)),
										  (p.url = o + f)),
									p.ifModified &&
										(x.lastModified[o] && k.setRequestHeader('If-Modified-Since', x.lastModified[o]),
										x.etag[o] && k.setRequestHeader('If-None-Match', x.etag[o])),
									((p.data && p.hasContent && !1 !== p.contentType) || t.contentType) &&
										k.setRequestHeader('Content-Type', p.contentType),
									k.setRequestHeader(
										'Accept',
										p.dataTypes[0] && p.accepts[p.dataTypes[0]]
											? p.accepts[p.dataTypes[0]] + ('*' !== p.dataTypes[0] ? ', ' + Bt + '; q=0.01' : '')
											: p.accepts['*']
									),
									p.headers))
										k.setRequestHeader(d, p.headers[d]);
									if (p.beforeSend && (!1 === p.beforeSend.call(h, k, p) || u)) return k.abort();
									if (((O = 'abort'), g.add(p.complete), k.done(p.success), k.fail(p.error), (n = Ht(Ft, p, t, k)))) {
										if (((k.readyState = 1), c && m.trigger('ajaxSend', [k, p]), u)) return k;
										p.async &&
											p.timeout > 0 &&
											(s = r.setTimeout(function () {
												k.abort('timeout');
											}, p.timeout));
										try {
											(u = !1), n.send(_, E);
										} catch (e) {
											if (u) throw e;
											E(-1, e);
										}
									} else E(-1, 'No Transport');
									function E(e, t, a, l) {
										var d,
											f,
											b,
											_,
											w,
											O = t;
										u ||
											((u = !0),
											s && r.clearTimeout(s),
											(n = void 0),
											(i = l || ''),
											(k.readyState = e > 0 ? 4 : 0),
											(d = (e >= 200 && e < 300) || 304 === e),
											a &&
												(_ = (function (e, t, n) {
													for (var r, o, i, a, s = e.contents, l = e.dataTypes; '*' === l[0]; )
														l.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader('Content-Type'));
													if (r)
														for (o in s)
															if (s[o] && s[o].test(r)) {
																l.unshift(o);
																break;
															}
													if (l[0] in n) i = l[0];
													else {
														for (o in n) {
															if (!l[0] || e.converters[o + ' ' + l[0]]) {
																i = o;
																break;
															}
															a || (a = o);
														}
														i = i || a;
													}
													if (i) return i !== l[0] && l.unshift(i), n[i];
												})(p, k, a)),
											!d &&
												x.inArray('script', p.dataTypes) > -1 &&
												x.inArray('json', p.dataTypes) < 0 &&
												(p.converters['text script'] = function () {}),
											(_ = (function (e, t, n, r) {
												var o,
													i,
													a,
													s,
													l,
													u = {},
													c = e.dataTypes.slice();
												if (c[1]) for (a in e.converters) u[a.toLowerCase()] = e.converters[a];
												for (i = c.shift(); i; )
													if (
														(e.responseFields[i] && (n[e.responseFields[i]] = t),
														!l && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)),
														(l = i),
														(i = c.shift()))
													)
														if ('*' === i) i = l;
														else if ('*' !== l && l !== i) {
															if (!(a = u[l + ' ' + i] || u['* ' + i]))
																for (o in u)
																	if ((s = o.split(' '))[1] === i && (a = u[l + ' ' + s[0]] || u['* ' + s[0]])) {
																		!0 === a ? (a = u[o]) : !0 !== u[o] && ((i = s[0]), c.unshift(s[1]));
																		break;
																	}
															if (!0 !== a)
																if (a && e.throws) t = a(t);
																else
																	try {
																		t = a(t);
																	} catch (e) {
																		return {
																			state: 'parsererror',
																			error: a ? e : 'No conversion from ' + l + ' to ' + i,
																		};
																	}
														}
												return { state: 'success', data: t };
											})(p, _, k, d)),
											d
												? (p.ifModified &&
														((w = k.getResponseHeader('Last-Modified')) && (x.lastModified[o] = w),
														(w = k.getResponseHeader('etag')) && (x.etag[o] = w)),
												  204 === e || 'HEAD' === p.type
														? (O = 'nocontent')
														: 304 === e
														? (O = 'notmodified')
														: ((O = _.state), (f = _.data), (d = !(b = _.error))))
												: ((b = O), (!e && O) || ((O = 'error'), e < 0 && (e = 0))),
											(k.status = e),
											(k.statusText = (t || O) + ''),
											d ? v.resolveWith(h, [f, O, k]) : v.rejectWith(h, [k, O, b]),
											k.statusCode(y),
											(y = void 0),
											c && m.trigger(d ? 'ajaxSuccess' : 'ajaxError', [k, p, d ? f : b]),
											g.fireWith(h, [k, O]),
											c && (m.trigger('ajaxComplete', [k, p]), --x.active || x.event.trigger('ajaxStop')));
									}
									return k;
								},
								getJSON: function (e, t, n) {
									return x.get(e, t, n, 'json');
								},
								getScript: function (e, t) {
									return x.get(e, void 0, t, 'script');
								},
							}),
							x.each(['get', 'post'], function (e, t) {
								x[t] = function (e, n, r, o) {
									return (
										g(n) && ((o = o || r), (r = n), (n = void 0)),
										x.ajax(x.extend({ url: e, type: t, dataType: o, data: n, success: r }, x.isPlainObject(e) && e))
									);
								};
							}),
							x.ajaxPrefilter(function (e) {
								var t;
								for (t in e.headers) 'content-type' === t.toLowerCase() && (e.contentType = e.headers[t] || '');
							}),
							(x._evalUrl = function (e, t, n) {
								return x.ajax({
									url: e,
									type: 'GET',
									dataType: 'script',
									cache: !0,
									async: !1,
									global: !1,
									converters: { 'text script': function () {} },
									dataFilter: function (e) {
										x.globalEval(e, t, n);
									},
								});
							}),
							x.fn.extend({
								wrapAll: function (e) {
									var t;
									return (
										this[0] &&
											(g(e) && (e = e.call(this[0])),
											(t = x(e, this[0].ownerDocument).eq(0).clone(!0)),
											this[0].parentNode && t.insertBefore(this[0]),
											t
												.map(function () {
													for (var e = this; e.firstElementChild; ) e = e.firstElementChild;
													return e;
												})
												.append(this)),
										this
									);
								},
								wrapInner: function (e) {
									return g(e)
										? this.each(function (t) {
												x(this).wrapInner(e.call(this, t));
										  })
										: this.each(function () {
												var t = x(this),
													n = t.contents();
												n.length ? n.wrapAll(e) : t.append(e);
										  });
								},
								wrap: function (e) {
									var t = g(e);
									return this.each(function (n) {
										x(this).wrapAll(t ? e.call(this, n) : e);
									});
								},
								unwrap: function (e) {
									return (
										this.parent(e)
											.not('body')
											.each(function () {
												x(this).replaceWith(this.childNodes);
											}),
										this
									);
								},
							}),
							(x.expr.pseudos.hidden = function (e) {
								return !x.expr.pseudos.visible(e);
							}),
							(x.expr.pseudos.visible = function (e) {
								return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
							}),
							(x.ajaxSettings.xhr = function () {
								try {
									return new r.XMLHttpRequest();
								} catch (e) {}
							});
						var Wt = { 0: 200, 1223: 204 },
							Kt = x.ajaxSettings.xhr();
						(v.cors = !!Kt && 'withCredentials' in Kt),
							(v.ajax = Kt = !!Kt),
							x.ajaxTransport(function (e) {
								var t, n;
								if (v.cors || (Kt && !e.crossDomain))
									return {
										send: function (o, i) {
											var a,
												s = e.xhr();
											if ((s.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields))
												for (a in e.xhrFields) s[a] = e.xhrFields[a];
											for (a in (e.mimeType && s.overrideMimeType && s.overrideMimeType(e.mimeType),
											e.crossDomain || o['X-Requested-With'] || (o['X-Requested-With'] = 'XMLHttpRequest'),
											o))
												s.setRequestHeader(a, o[a]);
											(t = function (e) {
												return function () {
													t &&
														((t = n = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null),
														'abort' === e
															? s.abort()
															: 'error' === e
															? 'number' != typeof s.status
																? i(0, 'error')
																: i(s.status, s.statusText)
															: i(
																	Wt[s.status] || s.status,
																	s.statusText,
																	'text' !== (s.responseType || 'text') || 'string' != typeof s.responseText
																		? { binary: s.response }
																		: { text: s.responseText },
																	s.getAllResponseHeaders()
															  ));
												};
											}),
												(s.onload = t()),
												(n = s.onerror = s.ontimeout = t('error')),
												void 0 !== s.onabort
													? (s.onabort = n)
													: (s.onreadystatechange = function () {
															4 === s.readyState &&
																r.setTimeout(function () {
																	t && n();
																});
													  }),
												(t = t('abort'));
											try {
												s.send((e.hasContent && e.data) || null);
											} catch (e) {
												if (t) throw e;
											}
										},
										abort: function () {
											t && t();
										},
									};
							}),
							x.ajaxPrefilter(function (e) {
								e.crossDomain && (e.contents.script = !1);
							}),
							x.ajaxSetup({
								accepts: {
									script: 'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript',
								},
								contents: { script: /\b(?:java|ecma)script\b/ },
								converters: {
									'text script': function (e) {
										return x.globalEval(e), e;
									},
								},
							}),
							x.ajaxPrefilter('script', function (e) {
								void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = 'GET');
							}),
							x.ajaxTransport('script', function (e) {
								var t, n;
								if (e.crossDomain || e.scriptAttrs)
									return {
										send: function (r, o) {
											(t = x('<script>')
												.attr(e.scriptAttrs || {})
												.prop({ charset: e.scriptCharset, src: e.url })
												.on(
													'load error',
													(n = function (e) {
														t.remove(), (n = null), e && o('error' === e.type ? 404 : 200, e.type);
													})
												)),
												b.head.appendChild(t[0]);
										},
										abort: function () {
											n && n();
										},
									};
							});
						var $t,
							zt = [],
							Gt = /(=)\?(?=&|$)|\?\?/;
						x.ajaxSetup({
							jsonp: 'callback',
							jsonpCallback: function () {
								var e = zt.pop() || x.expando + '_' + Et.guid++;
								return (this[e] = !0), e;
							},
						}),
							x.ajaxPrefilter('json jsonp', function (e, t, n) {
								var o,
									i,
									a,
									s =
										!1 !== e.jsonp &&
										(Gt.test(e.url)
											? 'url'
											: 'string' == typeof e.data &&
											  0 === (e.contentType || '').indexOf('application/x-www-form-urlencoded') &&
											  Gt.test(e.data) &&
											  'data');
								if (s || 'jsonp' === e.dataTypes[0])
									return (
										(o = e.jsonpCallback = g(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
										s
											? (e[s] = e[s].replace(Gt, '$1' + o))
											: !1 !== e.jsonp && (e.url += (Tt.test(e.url) ? '&' : '?') + e.jsonp + '=' + o),
										(e.converters['script json'] = function () {
											return a || x.error(o + ' was not called'), a[0];
										}),
										(e.dataTypes[0] = 'json'),
										(i = r[o]),
										(r[o] = function () {
											a = arguments;
										}),
										n.always(function () {
											void 0 === i ? x(r).removeProp(o) : (r[o] = i),
												e[o] && ((e.jsonpCallback = t.jsonpCallback), zt.push(o)),
												a && g(i) && i(a[0]),
												(a = i = void 0);
										}),
										'script'
									);
							}),
							(v.createHTMLDocument =
								((($t = b.implementation.createHTMLDocument('').body).innerHTML = '<form></form><form></form>'),
								2 === $t.childNodes.length)),
							(x.parseHTML = function (e, t, n) {
								return 'string' != typeof e
									? []
									: ('boolean' == typeof t && ((n = t), (t = !1)),
									  t ||
											(v.createHTMLDocument
												? (((r = (t = b.implementation.createHTMLDocument('')).createElement('base')).href =
														b.location.href),
												  t.head.appendChild(r))
												: (t = b)),
									  (i = !n && []),
									  (o = R.exec(e))
											? [t.createElement(o[1])]
											: ((o = ke([e], t, i)), i && i.length && x(i).remove(), x.merge([], o.childNodes)));
								var r, o, i;
							}),
							(x.fn.load = function (e, t, n) {
								var r,
									o,
									i,
									a = this,
									s = e.indexOf(' ');
								return (
									s > -1 && ((r = yt(e.slice(s))), (e = e.slice(0, s))),
									g(t) ? ((n = t), (t = void 0)) : t && 'object' == typeof t && (o = 'POST'),
									a.length > 0 &&
										x
											.ajax({ url: e, type: o || 'GET', dataType: 'html', data: t })
											.done(function (e) {
												(i = arguments), a.html(r ? x('<div>').append(x.parseHTML(e)).find(r) : e);
											})
											.always(
												n &&
													function (e, t) {
														a.each(function () {
															n.apply(this, i || [e.responseText, t, e]);
														});
													}
											),
									this
								);
							}),
							(x.expr.pseudos.animated = function (e) {
								return x.grep(x.timers, function (t) {
									return e === t.elem;
								}).length;
							}),
							(x.offset = {
								setOffset: function (e, t, n) {
									var r,
										o,
										i,
										a,
										s,
										l,
										u = x.css(e, 'position'),
										c = x(e),
										d = {};
									'static' === u && (e.style.position = 'relative'),
										(s = c.offset()),
										(i = x.css(e, 'top')),
										(l = x.css(e, 'left')),
										('absolute' === u || 'fixed' === u) && (i + l).indexOf('auto') > -1
											? ((a = (r = c.position()).top), (o = r.left))
											: ((a = parseFloat(i) || 0), (o = parseFloat(l) || 0)),
										g(t) && (t = t.call(e, n, x.extend({}, s))),
										null != t.top && (d.top = t.top - s.top + a),
										null != t.left && (d.left = t.left - s.left + o),
										'using' in t ? t.using.call(e, d) : c.css(d);
								},
							}),
							x.fn.extend({
								offset: function (e) {
									if (arguments.length)
										return void 0 === e
											? this
											: this.each(function (t) {
													x.offset.setOffset(this, e, t);
											  });
									var t,
										n,
										r = this[0];
									return r
										? r.getClientRects().length
											? ((t = r.getBoundingClientRect()),
											  (n = r.ownerDocument.defaultView),
											  { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset })
											: { top: 0, left: 0 }
										: void 0;
								},
								position: function () {
									if (this[0]) {
										var e,
											t,
											n,
											r = this[0],
											o = { top: 0, left: 0 };
										if ('fixed' === x.css(r, 'position')) t = r.getBoundingClientRect();
										else {
											for (
												t = this.offset(), n = r.ownerDocument, e = r.offsetParent || n.documentElement;
												e && (e === n.body || e === n.documentElement) && 'static' === x.css(e, 'position');

											)
												e = e.parentNode;
											e &&
												e !== r &&
												1 === e.nodeType &&
												(((o = x(e).offset()).top += x.css(e, 'borderTopWidth', !0)),
												(o.left += x.css(e, 'borderLeftWidth', !0)));
										}
										return {
											top: t.top - o.top - x.css(r, 'marginTop', !0),
											left: t.left - o.left - x.css(r, 'marginLeft', !0),
										};
									}
								},
								offsetParent: function () {
									return this.map(function () {
										for (var e = this.offsetParent; e && 'static' === x.css(e, 'position'); ) e = e.offsetParent;
										return e || ae;
									});
								},
							}),
							x.each({ scrollLeft: 'pageXOffset', scrollTop: 'pageYOffset' }, function (e, t) {
								var n = 'pageYOffset' === t;
								x.fn[e] = function (r) {
									return W(
										this,
										function (e, r, o) {
											var i;
											if ((y(e) ? (i = e) : 9 === e.nodeType && (i = e.defaultView), void 0 === o))
												return i ? i[t] : e[r];
											i ? i.scrollTo(n ? i.pageXOffset : o, n ? o : i.pageYOffset) : (e[r] = o);
										},
										e,
										r,
										arguments.length
									);
								};
							}),
							x.each(['top', 'left'], function (e, t) {
								x.cssHooks[t] = $e(v.pixelPosition, function (e, n) {
									if (n) return (n = Ke(e, t)), Be.test(n) ? x(e).position()[t] + 'px' : n;
								});
							}),
							x.each({ Height: 'height', Width: 'width' }, function (e, t) {
								x.each({ 'padding': 'inner' + e, 'content': t, '': 'outer' + e }, function (n, r) {
									x.fn[r] = function (o, i) {
										var a = arguments.length && (n || 'boolean' != typeof o),
											s = n || (!0 === o || !0 === i ? 'margin' : 'border');
										return W(
											this,
											function (t, n, o) {
												var i;
												return y(t)
													? 0 === r.indexOf('outer')
														? t['inner' + e]
														: t.document.documentElement['client' + e]
													: 9 === t.nodeType
													? ((i = t.documentElement),
													  Math.max(
															t.body['scroll' + e],
															i['scroll' + e],
															t.body['offset' + e],
															i['offset' + e],
															i['client' + e]
													  ))
													: void 0 === o
													? x.css(t, n, s)
													: x.style(t, n, o, s);
											},
											t,
											a ? o : void 0,
											a
										);
									};
								});
							}),
							x.each(
								['ajaxStart', 'ajaxStop', 'ajaxComplete', 'ajaxError', 'ajaxSuccess', 'ajaxSend'],
								function (e, t) {
									x.fn[t] = function (e) {
										return this.on(t, e);
									};
								}
							),
							x.fn.extend({
								bind: function (e, t, n) {
									return this.on(e, null, t, n);
								},
								unbind: function (e, t) {
									return this.off(e, null, t);
								},
								delegate: function (e, t, n, r) {
									return this.on(t, e, n, r);
								},
								undelegate: function (e, t, n) {
									return 1 === arguments.length ? this.off(e, '**') : this.off(t, e || '**', n);
								},
								hover: function (e, t) {
									return this.mouseenter(e).mouseleave(t || e);
								},
							}),
							x.each(
								'blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu'.split(
									' '
								),
								function (e, t) {
									x.fn[t] = function (e, n) {
										return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
									};
								}
							);
						var Yt = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
						(x.proxy = function (e, t) {
							var n, r, o;
							if (('string' == typeof t && ((n = e[t]), (t = e), (e = n)), g(e)))
								return (
									(r = s.call(arguments, 2)),
									(o = function () {
										return e.apply(t || this, r.concat(s.call(arguments)));
									}),
									(o.guid = e.guid = e.guid || x.guid++),
									o
								);
						}),
							(x.holdReady = function (e) {
								e ? x.readyWait++ : x.ready(!0);
							}),
							(x.isArray = Array.isArray),
							(x.parseJSON = JSON.parse),
							(x.nodeName = P),
							(x.isFunction = g),
							(x.isWindow = y),
							(x.camelCase = G),
							(x.type = O),
							(x.now = Date.now),
							(x.isNumeric = function (e) {
								var t = x.type(e);
								return ('number' === t || 'string' === t) && !isNaN(e - parseFloat(e));
							}),
							(x.trim = function (e) {
								return null == e ? '' : (e + '').replace(Yt, '$1');
							}),
							void 0 ===
								(n = function () {
									return x;
								}.apply(t, [])) || (e.exports = n);
						var Jt = r.jQuery,
							Qt = r.$;
						return (
							(x.noConflict = function (e) {
								return r.$ === x && (r.$ = Qt), e && r.jQuery === x && (r.jQuery = Jt), x;
							}),
							void 0 === o && (r.jQuery = r.$ = x),
							x
						);
					});
				},
				6321: function (e) {
					/*!
					 *
					 * Copyright 2009-2012 Kris Kowal under the terms of the MIT
					 * license found at http://github.com/kriskowal/q/raw/master/LICENSE
					 *
					 * With parts by Tyler Close
					 * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
					 * at http://www.opensource.org/licenses/mit-license.html
					 * Forked at ref_send.js version: 2009-05-11
					 *
					 * With parts by Mark Miller
					 * Copyright (C) 2011 Google Inc.
					 *
					 * Licensed under the Apache License, Version 2.0 (the "License");
					 * you may not use this file except in compliance with the License.
					 * You may obtain a copy of the License at
					 *
					 * http://www.apache.org/licenses/LICENSE-2.0
					 *
					 * Unless required by applicable law or agreed to in writing, software
					 * distributed under the License is distributed on an "AS IS" BASIS,
					 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
					 * See the License for the specific language governing permissions and
					 * limitations under the License.
					 *
					 */
					!(function (t) {
						'use strict';
						'function' == typeof bootstrap ? bootstrap('promise', t) : (e.exports = t());
					})(function () {
						'use strict';
						var e = !1;
						try {
							throw new Error();
						} catch (t) {
							e = !!t.stack;
						}
						var t,
							n = O(),
							r = function () {},
							o = (function () {
								var e = { task: void 0, next: null },
									t = e,
									n = !1,
									r = void 0,
									i = !1,
									a = [];
								function s() {
									for (var t, r; e.next; )
										(t = (e = e.next).task),
											(e.task = void 0),
											(r = e.domain) && ((e.domain = void 0), r.enter()),
											l(t, r);
									for (; a.length; ) l((t = a.pop()));
									n = !1;
								}
								function l(e, t) {
									try {
										e();
									} catch (e) {
										if (i) throw (t && t.exit(), setTimeout(s, 0), t && t.enter(), e);
										setTimeout(function () {
											throw e;
										}, 0);
									}
									t && t.exit();
								}
								if (
									((o = function (e) {
										(t = t.next = { task: e, domain: i && process.domain, next: null }), n || ((n = !0), r());
									}),
									'object' == typeof process && '[object process]' === process.toString() && process.nextTick)
								)
									(i = !0),
										(r = function () {
											process.nextTick(s);
										});
								else if ('function' == typeof setImmediate)
									r =
										'undefined' != typeof window
											? setImmediate.bind(window, s)
											: function () {
													setImmediate(s);
											  };
								else if ('undefined' != typeof MessageChannel) {
									var u = new MessageChannel();
									u.port1.onmessage = function () {
										(r = c), (u.port1.onmessage = s), s();
									};
									var c = function () {
										u.port2.postMessage(0);
									};
									r = function () {
										setTimeout(s, 0), c();
									};
								} else
									r = function () {
										setTimeout(s, 0);
									};
								return (
									(o.runAfter = function (e) {
										a.push(e), n || ((n = !0), r());
									}),
									o
								);
							})(),
							i = Function.call;
						function a(e) {
							return function () {
								return i.apply(e, arguments);
							};
						}
						var s,
							l = a(Array.prototype.slice),
							u = a(
								Array.prototype.reduce ||
									function (e, t) {
										var n = 0,
											r = this.length;
										if (1 === arguments.length)
											for (;;) {
												if (n in this) {
													t = this[n++];
													break;
												}
												if (++n >= r) throw new TypeError();
											}
										for (; n < r; n++) n in this && (t = e(t, this[n], n));
										return t;
									}
							),
							c = a(
								Array.prototype.indexOf ||
									function (e) {
										for (var t = 0; t < this.length; t++) if (this[t] === e) return t;
										return -1;
									}
							),
							d = a(
								Array.prototype.map ||
									function (e, t) {
										var n = this,
											r = [];
										return (
											u(
												n,
												function (o, i, a) {
													r.push(e.call(t, i, a, n));
												},
												void 0
											),
											r
										);
									}
							),
							f =
								Object.create ||
								function (e) {
									function t() {}
									return (t.prototype = e), new t();
								},
							p = a(Object.prototype.hasOwnProperty),
							h =
								Object.keys ||
								function (e) {
									var t = [];
									for (var n in e) p(e, n) && t.push(n);
									return t;
								},
							m = a(Object.prototype.toString);
						function v(e) {
							return '[object StopIteration]' === m(e) || e instanceof s;
						}
						s =
							'undefined' != typeof ReturnValue
								? ReturnValue
								: function (e) {
										this.value = e;
								  };
						var g = 'From previous event:';
						function y(t, n) {
							if (e && n.stack && 'object' == typeof t && null !== t && t.stack && -1 === t.stack.indexOf(g)) {
								for (var r = [], o = n; o; o = o.source) o.stack && r.unshift(o.stack);
								r.unshift(t.stack);
								var i = r.join('\nFrom previous event:\n');
								t.stack = (function (e) {
									for (var t = e.split('\n'), n = [], r = 0; r < t.length; ++r) {
										var o = t[r];
										w(o) || b(o) || !o || n.push(o);
									}
									return n.join('\n');
								})(i);
							}
						}
						function b(e) {
							return -1 !== e.indexOf('(module.js:') || -1 !== e.indexOf('(node.js:');
						}
						function _(e) {
							var t = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(e);
							if (t) return [t[1], Number(t[2])];
							var n = /at ([^ ]+):(\d+):(?:\d+)$/.exec(e);
							if (n) return [n[1], Number(n[2])];
							var r = /.*@(.+):(\d+)$/.exec(e);
							return r ? [r[1], Number(r[2])] : void 0;
						}
						function w(e) {
							var r = _(e);
							if (!r) return !1;
							var o = r[0],
								i = r[1];
							return o === t && i >= n && i <= W;
						}
						function O() {
							if (e)
								try {
									throw new Error();
								} catch (e) {
									var n = e.stack.split('\n'),
										r = _(n[0].indexOf('@') > 0 ? n[1] : n[2]);
									if (!r) return;
									return (t = r[0]), r[1];
								}
						}
						function k(e) {
							return e instanceof S
								? e
								: R(e)
								? (function (e) {
										var t = x();
										return (
											k.nextTick(function () {
												try {
													e.then(t.resolve, t.reject, t.notify);
												} catch (e) {
													t.reject(e);
												}
											}),
											t.promise
										);
								  })(e)
								: F(e);
						}
						function x() {
							var t,
								n = [],
								r = [],
								o = f(x.prototype),
								i = f(S.prototype);
							if (
								((i.promiseDispatch = function (e, o, i) {
									var a = l(arguments);
									n
										? (n.push(a), 'when' === o && i[1] && r.push(i[1]))
										: k.nextTick(function () {
												t.promiseDispatch.apply(t, a);
										  });
								}),
								(i.valueOf = function () {
									if (n) return i;
									var e = C(t);
									return P(e) && (t = e), e;
								}),
								(i.inspect = function () {
									return t ? t.inspect() : { state: 'pending' };
								}),
								k.longStackSupport && e)
							)
								try {
									throw new Error();
								} catch (e) {
									i.stack = e.stack.substring(e.stack.indexOf('\n') + 1);
								}
							function a(e) {
								(t = e),
									(i.source = e),
									u(
										n,
										function (t, n) {
											k.nextTick(function () {
												e.promiseDispatch.apply(e, n);
											});
										},
										void 0
									),
									(n = void 0),
									(r = void 0);
							}
							return (
								(o.promise = i),
								(o.resolve = function (e) {
									t || a(k(e));
								}),
								(o.fulfill = function (e) {
									t || a(F(e));
								}),
								(o.reject = function (e) {
									t || a(U(e));
								}),
								(o.notify = function (e) {
									t ||
										u(
											r,
											function (t, n) {
												k.nextTick(function () {
													n(e);
												});
											},
											void 0
										);
								}),
								o
							);
						}
						function E(e) {
							if ('function' != typeof e) throw new TypeError('resolver must be a function.');
							var t = x();
							try {
								e(t.resolve, t.reject, t.notify);
							} catch (e) {
								t.reject(e);
							}
							return t.promise;
						}
						function T(e) {
							return E(function (t, n) {
								for (var r = 0, o = e.length; r < o; r++) k(e[r]).then(t, n);
							});
						}
						function S(e, t, n) {
							void 0 === t &&
								(t = function (e) {
									return U(new Error('Promise does not support operation: ' + e));
								}),
								void 0 === n &&
									(n = function () {
										return { state: 'unknown' };
									});
							var r = f(S.prototype);
							if (
								((r.promiseDispatch = function (n, o, i) {
									var a;
									try {
										a = e[o] ? e[o].apply(r, i) : t.call(r, o, i);
									} catch (e) {
										a = U(e);
									}
									n && n(a);
								}),
								(r.inspect = n),
								n)
							) {
								var o = n();
								'rejected' === o.state && (r.exception = o.reason),
									(r.valueOf = function () {
										var e = n();
										return 'pending' === e.state || 'rejected' === e.state ? r : e.value;
									});
							}
							return r;
						}
						function A(e, t, n, r) {
							return k(e).then(t, n, r);
						}
						function C(e) {
							if (P(e)) {
								var t = e.inspect();
								if ('fulfilled' === t.state) return t.value;
							}
							return e;
						}
						function P(e) {
							return e instanceof S;
						}
						function R(e) {
							return (t = e) === Object(t) && 'function' == typeof e.then;
							var t;
						}
						(k.resolve = k),
							(k.nextTick = o),
							(k.longStackSupport = !1),
							'object' == typeof process && process && process.env && process.env.Q_DEBUG && (k.longStackSupport = !0),
							(k.defer = x),
							(x.prototype.makeNodeResolver = function () {
								var e = this;
								return function (t, n) {
									t ? e.reject(t) : arguments.length > 2 ? e.resolve(l(arguments, 1)) : e.resolve(n);
								};
							}),
							(k.Promise = E),
							(k.promise = E),
							(E.race = T),
							(E.all = Z),
							(E.reject = U),
							(E.resolve = k),
							(k.passByCopy = function (e) {
								return e;
							}),
							(S.prototype.passByCopy = function () {
								return this;
							}),
							(k.join = function (e, t) {
								return k(e).join(t);
							}),
							(S.prototype.join = function (e) {
								return k([this, e]).spread(function (e, t) {
									if (e === t) return e;
									throw new Error("Can't join: not the same: " + e + ' ' + t);
								});
							}),
							(k.race = T),
							(S.prototype.race = function () {
								return this.then(k.race);
							}),
							(k.makePromise = S),
							(S.prototype.toString = function () {
								return '[object Promise]';
							}),
							(S.prototype.then = function (e, t, n) {
								var r = this,
									o = x(),
									i = !1;
								return (
									k.nextTick(function () {
										r.promiseDispatch(
											function (t) {
												i ||
													((i = !0),
													o.resolve(
														(function (t) {
															try {
																return 'function' == typeof e ? e(t) : t;
															} catch (e) {
																return U(e);
															}
														})(t)
													));
											},
											'when',
											[
												function (e) {
													i ||
														((i = !0),
														o.resolve(
															(function (e) {
																if ('function' == typeof t) {
																	y(e, r);
																	try {
																		return t(e);
																	} catch (e) {
																		return U(e);
																	}
																}
																return U(e);
															})(e)
														));
												},
											]
										);
									}),
									r.promiseDispatch(void 0, 'when', [
										void 0,
										function (e) {
											var t,
												r = !1;
											try {
												t = (function (e) {
													return 'function' == typeof n ? n(e) : e;
												})(e);
											} catch (e) {
												if (((r = !0), !k.onerror)) throw e;
												k.onerror(e);
											}
											r || o.notify(t);
										},
									]),
									o.promise
								);
							}),
							(k.tap = function (e, t) {
								return k(e).tap(t);
							}),
							(S.prototype.tap = function (e) {
								return (
									(e = k(e)),
									this.then(function (t) {
										return e.fcall(t).thenResolve(t);
									})
								);
							}),
							(k.when = A),
							(S.prototype.thenResolve = function (e) {
								return this.then(function () {
									return e;
								});
							}),
							(k.thenResolve = function (e, t) {
								return k(e).thenResolve(t);
							}),
							(S.prototype.thenReject = function (e) {
								return this.then(function () {
									throw e;
								});
							}),
							(k.thenReject = function (e, t) {
								return k(e).thenReject(t);
							}),
							(k.nearer = C),
							(k.isPromise = P),
							(k.isPromiseAlike = R),
							(k.isPending = function (e) {
								return P(e) && 'pending' === e.inspect().state;
							}),
							(S.prototype.isPending = function () {
								return 'pending' === this.inspect().state;
							}),
							(k.isFulfilled = function (e) {
								return !P(e) || 'fulfilled' === e.inspect().state;
							}),
							(S.prototype.isFulfilled = function () {
								return 'fulfilled' === this.inspect().state;
							}),
							(k.isRejected = function (e) {
								return P(e) && 'rejected' === e.inspect().state;
							}),
							(S.prototype.isRejected = function () {
								return 'rejected' === this.inspect().state;
							});
						var I,
							N = [],
							M = [],
							j = [],
							D = !0;
						function L() {
							(N.length = 0), (M.length = 0), D || (D = !0);
						}
						function U(e) {
							var t = S(
								{
									when: function (t) {
										return (
											t &&
												(function (e) {
													if (D) {
														var t = c(M, e);
														-1 !== t &&
															('object' == typeof process &&
																'function' == typeof process.emit &&
																k.nextTick.runAfter(function () {
																	var n = c(j, e);
																	-1 !== n && (process.emit('rejectionHandled', N[t], e), j.splice(n, 1));
																}),
															M.splice(t, 1),
															N.splice(t, 1));
													}
												})(this),
											t ? t(e) : this
										);
									},
								},
								function () {
									return this;
								},
								function () {
									return { state: 'rejected', reason: e };
								}
							);
							return (
								(function (e, t) {
									D &&
										('object' == typeof process &&
											'function' == typeof process.emit &&
											k.nextTick.runAfter(function () {
												-1 !== c(M, e) && (process.emit('unhandledRejection', t, e), j.push(e));
											}),
										M.push(e),
										t && void 0 !== t.stack ? N.push(t.stack) : N.push('(no stack) ' + t));
								})(t, e),
								t
							);
						}
						function F(e) {
							return S(
								{
									when: function () {
										return e;
									},
									get: function (t) {
										return e[t];
									},
									set: function (t, n) {
										e[t] = n;
									},
									delete: function (t) {
										delete e[t];
									},
									post: function (t, n) {
										return null == t ? e.apply(void 0, n) : e[t].apply(e, n);
									},
									apply: function (t, n) {
										return e.apply(t, n);
									},
									keys: function () {
										return h(e);
									},
								},
								void 0,
								function () {
									return { state: 'fulfilled', value: e };
								}
							);
						}
						function B(e, t, n) {
							return k(e).spread(t, n);
						}
						function V(e, t, n) {
							return k(e).dispatch(t, n);
						}
						function Z(e) {
							return A(e, function (e) {
								var t = 0,
									n = x();
								return (
									u(
										e,
										function (r, o, i) {
											var a;
											P(o) && 'fulfilled' === (a = o.inspect()).state
												? (e[i] = a.value)
												: (++t,
												  A(
														o,
														function (r) {
															(e[i] = r), 0 == --t && n.resolve(e);
														},
														n.reject,
														function (e) {
															n.notify({ index: i, value: e });
														}
												  ));
										},
										void 0
									),
									0 === t && n.resolve(e),
									n.promise
								);
							});
						}
						function H(e) {
							if (0 === e.length) return k.resolve();
							var t = k.defer(),
								n = 0;
							return (
								u(
									e,
									function (r, o, i) {
										var a = e[i];
										n++,
											A(
												a,
												function (e) {
													t.resolve(e);
												},
												function () {
													0 === --n &&
														t.reject(
															new Error("Can't get fulfillment value from any promise, all promises were rejected.")
														);
												},
												function (e) {
													t.notify({ index: i, value: e });
												}
											);
									},
									void 0
								),
								t.promise
							);
						}
						function q(e) {
							return A(e, function (e) {
								return (
									(e = d(e, k)),
									A(
										Z(
											d(e, function (e) {
												return A(e, r, r);
											})
										),
										function () {
											return e;
										}
									)
								);
							});
						}
						(k.resetUnhandledRejections = L),
							(k.getUnhandledReasons = function () {
								return N.slice();
							}),
							(k.stopUnhandledRejectionTracking = function () {
								L(), (D = !1);
							}),
							L(),
							(k.reject = U),
							(k.fulfill = F),
							(k.master = function (e) {
								return S(
									{ isDef: function () {} },
									function (t, n) {
										return V(e, t, n);
									},
									function () {
										return k(e).inspect();
									}
								);
							}),
							(k.spread = B),
							(S.prototype.spread = function (e, t) {
								return this.all().then(function (t) {
									return e.apply(void 0, t);
								}, t);
							}),
							(k.async = function (e) {
								return function () {
									function t(e, t) {
										var i;
										if ('undefined' == typeof StopIteration) {
											try {
												i = n[e](t);
											} catch (e) {
												return U(e);
											}
											return i.done ? k(i.value) : A(i.value, r, o);
										}
										try {
											i = n[e](t);
										} catch (e) {
											return v(e) ? k(e.value) : U(e);
										}
										return A(i, r, o);
									}
									var n = e.apply(this, arguments),
										r = t.bind(t, 'next'),
										o = t.bind(t, 'throw');
									return r();
								};
							}),
							(k.spawn = function (e) {
								k.done(k.async(e)());
							}),
							(k.return = function (e) {
								throw new s(e);
							}),
							(k.promised = function (e) {
								return function () {
									return B([this, Z(arguments)], function (t, n) {
										return e.apply(t, n);
									});
								};
							}),
							(k.dispatch = V),
							(S.prototype.dispatch = function (e, t) {
								var n = this,
									r = x();
								return (
									k.nextTick(function () {
										n.promiseDispatch(r.resolve, e, t);
									}),
									r.promise
								);
							}),
							(k.get = function (e, t) {
								return k(e).dispatch('get', [t]);
							}),
							(S.prototype.get = function (e) {
								return this.dispatch('get', [e]);
							}),
							(k.set = function (e, t, n) {
								return k(e).dispatch('set', [t, n]);
							}),
							(S.prototype.set = function (e, t) {
								return this.dispatch('set', [e, t]);
							}),
							(k.del = k.delete =
								function (e, t) {
									return k(e).dispatch('delete', [t]);
								}),
							(S.prototype.del = S.prototype.delete =
								function (e) {
									return this.dispatch('delete', [e]);
								}),
							(k.mapply = k.post =
								function (e, t, n) {
									return k(e).dispatch('post', [t, n]);
								}),
							(S.prototype.mapply = S.prototype.post =
								function (e, t) {
									return this.dispatch('post', [e, t]);
								}),
							(k.send =
								k.mcall =
								k.invoke =
									function (e, t) {
										return k(e).dispatch('post', [t, l(arguments, 2)]);
									}),
							(S.prototype.send =
								S.prototype.mcall =
								S.prototype.invoke =
									function (e) {
										return this.dispatch('post', [e, l(arguments, 1)]);
									}),
							(k.fapply = function (e, t) {
								return k(e).dispatch('apply', [void 0, t]);
							}),
							(S.prototype.fapply = function (e) {
								return this.dispatch('apply', [void 0, e]);
							}),
							(k.try = k.fcall =
								function (e) {
									return k(e).dispatch('apply', [void 0, l(arguments, 1)]);
								}),
							(S.prototype.fcall = function () {
								return this.dispatch('apply', [void 0, l(arguments)]);
							}),
							(k.fbind = function (e) {
								var t = k(e),
									n = l(arguments, 1);
								return function () {
									return t.dispatch('apply', [this, n.concat(l(arguments))]);
								};
							}),
							(S.prototype.fbind = function () {
								var e = this,
									t = l(arguments);
								return function () {
									return e.dispatch('apply', [this, t.concat(l(arguments))]);
								};
							}),
							(k.keys = function (e) {
								return k(e).dispatch('keys', []);
							}),
							(S.prototype.keys = function () {
								return this.dispatch('keys', []);
							}),
							(k.all = Z),
							(S.prototype.all = function () {
								return Z(this);
							}),
							(k.any = H),
							(S.prototype.any = function () {
								return H(this);
							}),
							(k.allResolved =
								((I = q),
								function () {
									return 'undefined' != typeof console && console.warn, I.apply(I, arguments);
								})),
							(S.prototype.allResolved = function () {
								return q(this);
							}),
							(k.allSettled = function (e) {
								return k(e).allSettled();
							}),
							(S.prototype.allSettled = function () {
								return this.then(function (e) {
									return Z(
										d(e, function (e) {
											function t() {
												return e.inspect();
											}
											return (e = k(e)).then(t, t);
										})
									);
								});
							}),
							(k.fail = k.catch =
								function (e, t) {
									return k(e).then(void 0, t);
								}),
							(S.prototype.fail = S.prototype.catch =
								function (e) {
									return this.then(void 0, e);
								}),
							(k.progress = function (e, t) {
								return k(e).then(void 0, void 0, t);
							}),
							(S.prototype.progress = function (e) {
								return this.then(void 0, void 0, e);
							}),
							(k.fin = k.finally =
								function (e, t) {
									return k(e).finally(t);
								}),
							(S.prototype.fin = S.prototype.finally =
								function (e) {
									return (
										(e = k(e)),
										this.then(
											function (t) {
												return e.fcall().then(function () {
													return t;
												});
											},
											function (t) {
												return e.fcall().then(function () {
													throw t;
												});
											}
										)
									);
								}),
							(k.done = function (e, t, n, r) {
								return k(e).done(t, n, r);
							}),
							(S.prototype.done = function (e, t, n) {
								var r = function (e) {
										k.nextTick(function () {
											if ((y(e, o), !k.onerror)) throw e;
											k.onerror(e);
										});
									},
									o = e || t || n ? this.then(e, t, n) : this;
								'object' == typeof process && process && process.domain && (r = process.domain.bind(r)),
									o.then(void 0, r);
							}),
							(k.timeout = function (e, t, n) {
								return k(e).timeout(t, n);
							}),
							(S.prototype.timeout = function (e, t) {
								var n = x(),
									r = setTimeout(function () {
										(t && 'string' != typeof t) ||
											((t = new Error(t || 'Timed out after ' + e + ' ms')).code = 'ETIMEDOUT'),
											n.reject(t);
									}, e);
								return (
									this.then(
										function (e) {
											clearTimeout(r), n.resolve(e);
										},
										function (e) {
											clearTimeout(r), n.reject(e);
										},
										n.notify
									),
									n.promise
								);
							}),
							(k.delay = function (e, t) {
								return void 0 === t && ((t = e), (e = void 0)), k(e).delay(t);
							}),
							(S.prototype.delay = function (e) {
								return this.then(function (t) {
									var n = x();
									return (
										setTimeout(function () {
											n.resolve(t);
										}, e),
										n.promise
									);
								});
							}),
							(k.nfapply = function (e, t) {
								return k(e).nfapply(t);
							}),
							(S.prototype.nfapply = function (e) {
								var t = x(),
									n = l(e);
								return n.push(t.makeNodeResolver()), this.fapply(n).fail(t.reject), t.promise;
							}),
							(k.nfcall = function (e) {
								var t = l(arguments, 1);
								return k(e).nfapply(t);
							}),
							(S.prototype.nfcall = function () {
								var e = l(arguments),
									t = x();
								return e.push(t.makeNodeResolver()), this.fapply(e).fail(t.reject), t.promise;
							}),
							(k.nfbind = k.denodeify =
								function (e) {
									var t = l(arguments, 1);
									return function () {
										var n = t.concat(l(arguments)),
											r = x();
										return n.push(r.makeNodeResolver()), k(e).fapply(n).fail(r.reject), r.promise;
									};
								}),
							(S.prototype.nfbind = S.prototype.denodeify =
								function () {
									var e = l(arguments);
									return e.unshift(this), k.denodeify.apply(void 0, e);
								}),
							(k.nbind = function (e, t) {
								var n = l(arguments, 2);
								return function () {
									var r = n.concat(l(arguments)),
										o = x();
									function i() {
										return e.apply(t, arguments);
									}
									return r.push(o.makeNodeResolver()), k(i).fapply(r).fail(o.reject), o.promise;
								};
							}),
							(S.prototype.nbind = function () {
								var e = l(arguments, 0);
								return e.unshift(this), k.nbind.apply(void 0, e);
							}),
							(k.nmapply = k.npost =
								function (e, t, n) {
									return k(e).npost(t, n);
								}),
							(S.prototype.nmapply = S.prototype.npost =
								function (e, t) {
									var n = l(t || []),
										r = x();
									return n.push(r.makeNodeResolver()), this.dispatch('post', [e, n]).fail(r.reject), r.promise;
								}),
							(k.nsend =
								k.nmcall =
								k.ninvoke =
									function (e, t) {
										var n = l(arguments, 2),
											r = x();
										return n.push(r.makeNodeResolver()), k(e).dispatch('post', [t, n]).fail(r.reject), r.promise;
									}),
							(S.prototype.nsend =
								S.prototype.nmcall =
								S.prototype.ninvoke =
									function (e) {
										var t = l(arguments, 1),
											n = x();
										return t.push(n.makeNodeResolver()), this.dispatch('post', [e, t]).fail(n.reject), n.promise;
									}),
							(k.nodeify = function (e, t) {
								return k(e).nodeify(t);
							}),
							(S.prototype.nodeify = function (e) {
								if (!e) return this;
								this.then(
									function (t) {
										k.nextTick(function () {
											e(null, t);
										});
									},
									function (t) {
										k.nextTick(function () {
											e(t);
										});
									}
								);
							}),
							(k.noConflict = function () {
								throw new Error('Q.noConflict only works when Q is used as a global');
							});
						var W = O();
						return k;
					});
				},
				74270: function (e) {
					/**
					 * Copyright (c) 2014-present, Facebook, Inc.
					 *
					 * This source code is licensed under the MIT license found in the
					 * LICENSE file in the root directory of this source tree.
					 */
					var t = (function (e) {
						'use strict';
						var t,
							n = Object.prototype,
							r = n.hasOwnProperty,
							o =
								Object.defineProperty ||
								function (e, t, n) {
									e[t] = n.value;
								},
							i = 'function' == typeof Symbol ? Symbol : {},
							a = i.iterator || '@@iterator',
							s = i.asyncIterator || '@@asyncIterator',
							l = i.toStringTag || '@@toStringTag';
						function u(e, t, n) {
							return Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }), e[t];
						}
						try {
							u({}, '');
						} catch (e) {
							u = function (e, t, n) {
								return (e[t] = n);
							};
						}
						function c(e, t, n, r) {
							var i = t && t.prototype instanceof v ? t : v,
								a = Object.create(i.prototype),
								s = new C(r || []);
							return o(a, '_invoke', { value: E(e, n, s) }), a;
						}
						function d(e, t, n) {
							try {
								return { type: 'normal', arg: e.call(t, n) };
							} catch (e) {
								return { type: 'throw', arg: e };
							}
						}
						e.wrap = c;
						var f = 'suspendedStart',
							p = 'executing',
							h = 'completed',
							m = {};
						function v() {}
						function g() {}
						function y() {}
						var b = {};
						u(b, a, function () {
							return this;
						});
						var _ = Object.getPrototypeOf,
							w = _ && _(_(P([])));
						w && w !== n && r.call(w, a) && (b = w);
						var O = (y.prototype = v.prototype = Object.create(b));
						function k(e) {
							['next', 'throw', 'return'].forEach(function (t) {
								u(e, t, function (e) {
									return this._invoke(t, e);
								});
							});
						}
						function x(e, t) {
							function n(o, i, a, s) {
								var l = d(e[o], e, i);
								if ('throw' !== l.type) {
									var u = l.arg,
										c = u.value;
									return c && 'object' == typeof c && r.call(c, '__await')
										? t.resolve(c.__await).then(
												function (e) {
													n('next', e, a, s);
												},
												function (e) {
													n('throw', e, a, s);
												}
										  )
										: t.resolve(c).then(
												function (e) {
													(u.value = e), a(u);
												},
												function (e) {
													return n('throw', e, a, s);
												}
										  );
								}
								s(l.arg);
							}
							var i;
							o(this, '_invoke', {
								value: function (e, r) {
									function o() {
										return new t(function (t, o) {
											n(e, r, t, o);
										});
									}
									return (i = i ? i.then(o, o) : o());
								},
							});
						}
						function E(e, t, n) {
							var r = f;
							return function (o, i) {
								if (r === p) throw new Error('Generator is already running');
								if (r === h) {
									if ('throw' === o) throw i;
									return R();
								}
								for (n.method = o, n.arg = i; ; ) {
									var a = n.delegate;
									if (a) {
										var s = T(a, n);
										if (s) {
											if (s === m) continue;
											return s;
										}
									}
									if ('next' === n.method) n.sent = n._sent = n.arg;
									else if ('throw' === n.method) {
										if (r === f) throw ((r = h), n.arg);
										n.dispatchException(n.arg);
									} else 'return' === n.method && n.abrupt('return', n.arg);
									r = p;
									var l = d(e, t, n);
									if ('normal' === l.type) {
										if (((r = n.done ? h : 'suspendedYield'), l.arg === m)) continue;
										return { value: l.arg, done: n.done };
									}
									'throw' === l.type && ((r = h), (n.method = 'throw'), (n.arg = l.arg));
								}
							};
						}
						function T(e, n) {
							var r = n.method,
								o = e.iterator[r];
							if (o === t)
								return (
									(n.delegate = null),
									('throw' === r &&
										e.iterator.return &&
										((n.method = 'return'), (n.arg = t), T(e, n), 'throw' === n.method)) ||
										('return' !== r &&
											((n.method = 'throw'),
											(n.arg = new TypeError("The iterator does not provide a '" + r + "' method")))),
									m
								);
							var i = d(o, e.iterator, n.arg);
							if ('throw' === i.type) return (n.method = 'throw'), (n.arg = i.arg), (n.delegate = null), m;
							var a = i.arg;
							return a
								? a.done
									? ((n[e.resultName] = a.value),
									  (n.next = e.nextLoc),
									  'return' !== n.method && ((n.method = 'next'), (n.arg = t)),
									  (n.delegate = null),
									  m)
									: a
								: ((n.method = 'throw'),
								  (n.arg = new TypeError('iterator result is not an object')),
								  (n.delegate = null),
								  m);
						}
						function S(e) {
							var t = { tryLoc: e[0] };
							1 in e && (t.catchLoc = e[1]),
								2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
								this.tryEntries.push(t);
						}
						function A(e) {
							var t = e.completion || {};
							(t.type = 'normal'), delete t.arg, (e.completion = t);
						}
						function C(e) {
							(this.tryEntries = [{ tryLoc: 'root' }]), e.forEach(S, this), this.reset(!0);
						}
						function P(e) {
							if (e) {
								var n = e[a];
								if (n) return n.call(e);
								if ('function' == typeof e.next) return e;
								if (!isNaN(e.length)) {
									var o = -1,
										i = function n() {
											for (; ++o < e.length; ) if (r.call(e, o)) return (n.value = e[o]), (n.done = !1), n;
											return (n.value = t), (n.done = !0), n;
										};
									return (i.next = i);
								}
							}
							return { next: R };
						}
						function R() {
							return { value: t, done: !0 };
						}
						return (
							(g.prototype = y),
							o(O, 'constructor', { value: y, configurable: !0 }),
							o(y, 'constructor', { value: g, configurable: !0 }),
							(g.displayName = u(y, l, 'GeneratorFunction')),
							(e.isGeneratorFunction = function (e) {
								var t = 'function' == typeof e && e.constructor;
								return !!t && (t === g || 'GeneratorFunction' === (t.displayName || t.name));
							}),
							(e.mark = function (e) {
								return (
									Object.setPrototypeOf
										? Object.setPrototypeOf(e, y)
										: ((e.__proto__ = y), u(e, l, 'GeneratorFunction')),
									(e.prototype = Object.create(O)),
									e
								);
							}),
							(e.awrap = function (e) {
								return { __await: e };
							}),
							k(x.prototype),
							u(x.prototype, s, function () {
								return this;
							}),
							(e.AsyncIterator = x),
							(e.async = function (t, n, r, o, i) {
								void 0 === i && (i = Promise);
								var a = new x(c(t, n, r, o), i);
								return e.isGeneratorFunction(n)
									? a
									: a.next().then(function (e) {
											return e.done ? e.value : a.next();
									  });
							}),
							k(O),
							u(O, l, 'Generator'),
							u(O, a, function () {
								return this;
							}),
							u(O, 'toString', function () {
								return '[object Generator]';
							}),
							(e.keys = function (e) {
								var t = Object(e),
									n = [];
								for (var r in t) n.push(r);
								return (
									n.reverse(),
									function e() {
										for (; n.length; ) {
											var r = n.pop();
											if (r in t) return (e.value = r), (e.done = !1), e;
										}
										return (e.done = !0), e;
									}
								);
							}),
							(e.values = P),
							(C.prototype = {
								constructor: C,
								reset: function (e) {
									if (
										((this.prev = 0),
										(this.next = 0),
										(this.sent = this._sent = t),
										(this.done = !1),
										(this.delegate = null),
										(this.method = 'next'),
										(this.arg = t),
										this.tryEntries.forEach(A),
										!e)
									)
										for (var n in this) 't' === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
								},
								stop: function () {
									this.done = !0;
									var e = this.tryEntries[0].completion;
									if ('throw' === e.type) throw e.arg;
									return this.rval;
								},
								dispatchException: function (e) {
									if (this.done) throw e;
									var n = this;
									function o(r, o) {
										return (s.type = 'throw'), (s.arg = e), (n.next = r), o && ((n.method = 'next'), (n.arg = t)), !!o;
									}
									for (var i = this.tryEntries.length - 1; i >= 0; --i) {
										var a = this.tryEntries[i],
											s = a.completion;
										if ('root' === a.tryLoc) return o('end');
										if (a.tryLoc <= this.prev) {
											var l = r.call(a, 'catchLoc'),
												u = r.call(a, 'finallyLoc');
											if (l && u) {
												if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
												if (this.prev < a.finallyLoc) return o(a.finallyLoc);
											} else if (l) {
												if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
											} else {
												if (!u) throw new Error('try statement without catch or finally');
												if (this.prev < a.finallyLoc) return o(a.finallyLoc);
											}
										}
									}
								},
								abrupt: function (e, t) {
									for (var n = this.tryEntries.length - 1; n >= 0; --n) {
										var o = this.tryEntries[n];
										if (o.tryLoc <= this.prev && r.call(o, 'finallyLoc') && this.prev < o.finallyLoc) {
											var i = o;
											break;
										}
									}
									i && ('break' === e || 'continue' === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
									var a = i ? i.completion : {};
									return (
										(a.type = e),
										(a.arg = t),
										i ? ((this.method = 'next'), (this.next = i.finallyLoc), m) : this.complete(a)
									);
								},
								complete: function (e, t) {
									if ('throw' === e.type) throw e.arg;
									return (
										'break' === e.type || 'continue' === e.type
											? (this.next = e.arg)
											: 'return' === e.type
											? ((this.rval = this.arg = e.arg), (this.method = 'return'), (this.next = 'end'))
											: 'normal' === e.type && t && (this.next = t),
										m
									);
								},
								finish: function (e) {
									for (var t = this.tryEntries.length - 1; t >= 0; --t) {
										var n = this.tryEntries[t];
										if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), A(n), m;
									}
								},
								catch: function (e) {
									for (var t = this.tryEntries.length - 1; t >= 0; --t) {
										var n = this.tryEntries[t];
										if (n.tryLoc === e) {
											var r = n.completion;
											if ('throw' === r.type) {
												var o = r.arg;
												A(n);
											}
											return o;
										}
									}
									throw new Error('illegal catch attempt');
								},
								delegateYield: function (e, n, r) {
									return (
										(this.delegate = { iterator: P(e), resultName: n, nextLoc: r }),
										'next' === this.method && (this.arg = t),
										m
									);
								},
							}),
							e
						);
					})(e.exports);
					try {
						regeneratorRuntime = t;
					} catch (e) {
						'object' == typeof globalThis
							? (globalThis.regeneratorRuntime = t)
							: Function('r', 'regeneratorRuntime = r')(t);
					}
				},
				27444: function (e) {
					e.exports = function (e) {
						var t;
						if ('SELECT' === e.nodeName) e.focus(), (t = e.value);
						else if ('INPUT' === e.nodeName || 'TEXTAREA' === e.nodeName) {
							var n = e.hasAttribute('readonly');
							n || e.setAttribute('readonly', ''),
								e.select(),
								e.setSelectionRange(0, e.value.length),
								n || e.removeAttribute('readonly'),
								(t = e.value);
						} else {
							e.hasAttribute('contenteditable') && e.focus();
							var r = window.getSelection(),
								o = document.createRange();
							o.selectNodeContents(e), r.removeAllRanges(), r.addRange(o), (t = r.toString());
						}
						return t;
					};
				},
				10226: function (e) {
					function t() {}
					(t.prototype = {
						on: function (e, t, n) {
							var r = this.e || (this.e = {});
							return (r[e] || (r[e] = [])).push({ fn: t, ctx: n }), this;
						},
						once: function (e, t, n) {
							var r = this;
							function o() {
								r.off(e, o), t.apply(n, arguments);
							}
							return (o._ = t), this.on(e, o, n);
						},
						emit: function (e) {
							for (
								var t = [].slice.call(arguments, 1),
									n = ((this.e || (this.e = {}))[e] || []).slice(),
									r = 0,
									o = n.length;
								r < o;
								r++
							)
								n[r].fn.apply(n[r].ctx, t);
							return this;
						},
						off: function (e, t) {
							var n = this.e || (this.e = {}),
								r = n[e],
								o = [];
							if (r && t) for (var i = 0, a = r.length; i < a; i++) r[i].fn !== t && r[i].fn._ !== t && o.push(r[i]);
							return o.length ? (n[e] = o) : delete n[e], this;
						},
					}),
						(e.exports = t),
						(e.exports.TinyEmitter = t);
				},
				83147: function () {
					'use strict';
					//Copyright 2014-2015 Google Inc. All rights reserved.
					//license that can be found in the LICENSE file or at
					//https://developers.google.com/open-source/licenses/bsd
					!(function () {
						var e = 'chrome' in window && window.navigator.userAgent.indexOf('Edge') < 0;
						if (!('u2f' in window) && e) {
							var t,
								n = (window.u2f = {});
							(n.EXTENSION_ID = 'kmendfapggjehodndflmmgagdbamhnfd'),
								(n.MessageTypes = {
									U2F_REGISTER_REQUEST: 'u2f_register_request',
									U2F_REGISTER_RESPONSE: 'u2f_register_response',
									U2F_SIGN_REQUEST: 'u2f_sign_request',
									U2F_SIGN_RESPONSE: 'u2f_sign_response',
									U2F_GET_API_VERSION_REQUEST: 'u2f_get_api_version_request',
									U2F_GET_API_VERSION_RESPONSE: 'u2f_get_api_version_response',
								}),
								(n.ErrorCodes = {
									OK: 0,
									OTHER_ERROR: 1,
									BAD_REQUEST: 2,
									CONFIGURATION_UNSUPPORTED: 3,
									DEVICE_INELIGIBLE: 4,
									TIMEOUT: 5,
								}),
								n.U2fRequest,
								n.U2fResponse,
								n.Error,
								n.Transport,
								n.Transports,
								n.SignRequest,
								n.SignResponse,
								n.RegisterRequest,
								n.RegisterResponse,
								n.RegisteredKey,
								n.GetJsApiVersionResponse,
								(n.getMessagePort = function (e) {
									if ('undefined' != typeof chrome && chrome.runtime) {
										var t = { type: n.MessageTypes.U2F_SIGN_REQUEST, signRequests: [] };
										chrome.runtime.sendMessage(n.EXTENSION_ID, t, function () {
											chrome.runtime.lastError ? n.getIframePort_(e) : n.getChromeRuntimePort_(e);
										});
									} else
										n.isAndroidChrome_()
											? n.getAuthenticatorPort_(e)
											: n.isIosChrome_()
											? n.getIosPort_(e)
											: n.getIframePort_(e);
								}),
								(n.isAndroidChrome_ = function () {
									var e = navigator.userAgent;
									return -1 != e.indexOf('Chrome') && -1 != e.indexOf('Android');
								}),
								(n.isIosChrome_ = function () {
									return ['iPhone', 'iPad', 'iPod'].indexOf(navigator.platform) > -1;
								}),
								(n.getChromeRuntimePort_ = function (e) {
									var t = chrome.runtime.connect(n.EXTENSION_ID, { includeTlsChannelId: !0 });
									setTimeout(function () {
										e(new n.WrappedChromeRuntimePort_(t));
									}, 0);
								}),
								(n.getAuthenticatorPort_ = function (e) {
									setTimeout(function () {
										e(new n.WrappedAuthenticatorPort_());
									}, 0);
								}),
								(n.getIosPort_ = function (e) {
									setTimeout(function () {
										e(new n.WrappedIosPort_());
									}, 0);
								}),
								(n.WrappedChromeRuntimePort_ = function (e) {
									this.port_ = e;
								}),
								(n.formatSignRequest_ = function (e, r, o, i, a) {
									if (void 0 === t || t < 1.1) {
										for (var s = [], l = 0; l < o.length; l++)
											s[l] = { version: o[l].version, challenge: r, keyHandle: o[l].keyHandle, appId: e };
										return { type: n.MessageTypes.U2F_SIGN_REQUEST, signRequests: s, timeoutSeconds: i, requestId: a };
									}
									return {
										type: n.MessageTypes.U2F_SIGN_REQUEST,
										appId: e,
										challenge: r,
										registeredKeys: o,
										timeoutSeconds: i,
										requestId: a,
									};
								}),
								(n.formatRegisterRequest_ = function (e, r, o, i, a) {
									if (void 0 === t || t < 1.1) {
										for (var s = 0; s < o.length; s++) o[s].appId = e;
										var l = [];
										for (s = 0; s < r.length; s++)
											l[s] = { version: r[s].version, challenge: o[0], keyHandle: r[s].keyHandle, appId: e };
										return {
											type: n.MessageTypes.U2F_REGISTER_REQUEST,
											signRequests: l,
											registerRequests: o,
											timeoutSeconds: i,
											requestId: a,
										};
									}
									return {
										type: n.MessageTypes.U2F_REGISTER_REQUEST,
										appId: e,
										registerRequests: o,
										registeredKeys: r,
										timeoutSeconds: i,
										requestId: a,
									};
								}),
								(n.WrappedChromeRuntimePort_.prototype.postMessage = function (e) {
									this.port_.postMessage(e);
								}),
								(n.WrappedChromeRuntimePort_.prototype.addEventListener = function (e, t) {
									var n = e.toLowerCase();
									('message' != n && 'onmessage' != n) ||
										this.port_.onMessage.addListener(function (e) {
											t({ data: e });
										});
								}),
								(n.WrappedAuthenticatorPort_ = function () {
									(this.requestId_ = -1), (this.requestObject_ = null);
								}),
								(n.WrappedAuthenticatorPort_.prototype.postMessage = function (e) {
									var t =
										n.WrappedAuthenticatorPort_.INTENT_URL_BASE_ +
										';S.request=' +
										encodeURIComponent(JSON.stringify(e)) +
										';end';
									document.location = t;
								}),
								(n.WrappedAuthenticatorPort_.prototype.getPortType = function () {
									return 'WrappedAuthenticatorPort_';
								}),
								(n.WrappedAuthenticatorPort_.prototype.addEventListener = function (e, t) {
									if ('message' == e.toLowerCase()) {
										window.addEventListener('message', this.onRequestUpdate_.bind(this, t), !1);
									}
								}),
								(n.WrappedAuthenticatorPort_.prototype.onRequestUpdate_ = function (e, t) {
									var n = JSON.parse(t.data),
										r = (n.intentURL, n.errorCode, null);
									n.hasOwnProperty('data') && (r = JSON.parse(n.data)), e({ data: r });
								}),
								(n.WrappedAuthenticatorPort_.INTENT_URL_BASE_ =
									'intent:#Intent;action=com.google.android.apps.authenticator.AUTHENTICATE'),
								(n.WrappedIosPort_ = function () {}),
								(n.WrappedIosPort_.prototype.postMessage = function (e) {
									var t = JSON.stringify(e),
										n = 'u2f://auth?' + encodeURI(t);
									location.replace(n);
								}),
								(n.WrappedIosPort_.prototype.getPortType = function () {
									return 'WrappedIosPort_';
								}),
								(n.WrappedIosPort_.prototype.addEventListener = function (e, t) {
									e.toLowerCase();
								}),
								(n.getIframePort_ = function (e) {
									var t = 'chrome-extension://' + n.EXTENSION_ID,
										r = document.createElement('iframe');
									(r.src = t + '/u2f-comms.html'),
										r.setAttribute('style', 'display:none'),
										document.body.appendChild(r);
									var o = new MessageChannel(),
										i = function (t) {
											'ready' == t.data && (o.port1.removeEventListener('message', i), e(o.port1));
										};
									o.port1.addEventListener('message', i),
										o.port1.start(),
										r.addEventListener('load', function () {
											r.contentWindow.postMessage('init', t, [o.port2]);
										});
								}),
								(n.EXTENSION_TIMEOUT_SEC = 30),
								(n.port_ = null),
								(n.waitingForPort_ = []),
								(n.reqCounter_ = 0),
								(n.callbackMap_ = {}),
								(n.getPortSingleton_ = function (e) {
									n.port_
										? e(n.port_)
										: (0 == n.waitingForPort_.length &&
												n.getMessagePort(function (e) {
													for (
														n.port_ = e, n.port_.addEventListener('message', n.responseHandler_);
														n.waitingForPort_.length;

													)
														n.waitingForPort_.shift()(n.port_);
												}),
										  n.waitingForPort_.push(e));
								}),
								(n.responseHandler_ = function (e) {
									var t = e.data,
										r = t.requestId;
									if (r && n.callbackMap_[r]) {
										var o = n.callbackMap_[r];
										delete n.callbackMap_[r], o(t.responseData);
									}
								}),
								(n.sign = function (e, r, o, i, a) {
									void 0 === t
										? n.getApiVersion(function (s) {
												(t = void 0 === s.js_api_version ? 0 : s.js_api_version), n.sendSignRequest(e, r, o, i, a);
										  })
										: n.sendSignRequest(e, r, o, i, a);
								}),
								(n.sendSignRequest = function (e, t, r, o, i) {
									n.getPortSingleton_(function (a) {
										var s = ++n.reqCounter_;
										n.callbackMap_[s] = o;
										var l = void 0 !== i ? i : n.EXTENSION_TIMEOUT_SEC,
											u = n.formatSignRequest_(e, t, r, l, s);
										a.postMessage(u);
									});
								}),
								(n.register = function (e, r, o, i, a) {
									void 0 === t
										? n.getApiVersion(function (s) {
												(t = void 0 === s.js_api_version ? 0 : s.js_api_version), n.sendRegisterRequest(e, r, o, i, a);
										  })
										: n.sendRegisterRequest(e, r, o, i, a);
								}),
								(n.sendRegisterRequest = function (e, t, r, o, i) {
									n.getPortSingleton_(function (a) {
										var s = ++n.reqCounter_;
										n.callbackMap_[s] = o;
										var l = void 0 !== i ? i : n.EXTENSION_TIMEOUT_SEC,
											u = n.formatRegisterRequest_(e, r, t, l, s);
										a.postMessage(u);
									});
								}),
								(n.getApiVersion = function (e, t) {
									n.getPortSingleton_(function (r) {
										if (r.getPortType) {
											var o;
											switch (r.getPortType()) {
												case 'WrappedIosPort_':
												case 'WrappedAuthenticatorPort_':
													o = 1.1;
													break;
												default:
													o = 0;
											}
											e({ js_api_version: o });
										} else {
											var i = ++n.reqCounter_;
											n.callbackMap_[i] = e;
											var a = {
												type: n.MessageTypes.U2F_GET_API_VERSION_REQUEST,
												timeoutSeconds: void 0 !== t ? t : n.EXTENSION_TIMEOUT_SEC,
												requestId: i,
											};
											r.postMessage(a);
										}
									});
								});
						}
					})();
				},
				69765: function (e, t) {
					var n;
					/**
					 * @file Web Cryptography API shim
					 * @author Artem S Vybornov <vybornov@gmail.com>
					 * @license MIT
					 */ !(function (r, o) {
						(n = function () {
							return (function (e) {
								'use strict';
								if ('function' != typeof Promise) throw 'Promise support required';
								var t = e.crypto || e.msCrypto;
								if (!t) return;
								var n = t.subtle || t.webkitSubtle;
								if (!n) return;
								var r = e.Crypto || t.constructor || Object,
									o = e.SubtleCrypto || n.constructor || Object,
									i = (e.CryptoKey || e.Key, e.navigator.userAgent.indexOf('Edge/') > -1),
									a = !!e.msCrypto && !i,
									s = !t.subtle && !!t.webkitSubtle;
								if (!a && !s) return;
								function l(e) {
									return btoa(e).replace(/\=+$/, '').replace(/\+/g, '-').replace(/\//g, '_');
								}
								function u(e) {
									return (e = (e += '===').slice(0, -e.length % 4)), atob(e.replace(/-/g, '+').replace(/_/g, '/'));
								}
								function c(e) {
									for (var t = new Uint8Array(e.length), n = 0; n < e.length; n++) t[n] = e.charCodeAt(n);
									return t;
								}
								function d(e) {
									return e instanceof ArrayBuffer && (e = new Uint8Array(e)), String.fromCharCode.apply(String, e);
								}
								function f(e) {
									var t = { name: (e.name || e || '').toUpperCase().replace('V', 'v') };
									switch (t.name) {
										case 'SHA-1':
										case 'SHA-256':
										case 'SHA-384':
										case 'SHA-512':
											break;
										case 'AES-CBC':
										case 'AES-GCM':
										case 'AES-KW':
											e.length && (t.length = e.length);
											break;
										case 'HMAC':
											e.hash && (t.hash = f(e.hash)), e.length && (t.length = e.length);
											break;
										case 'RSAES-PKCS1-v1_5':
											e.publicExponent && (t.publicExponent = new Uint8Array(e.publicExponent)),
												e.modulusLength && (t.modulusLength = e.modulusLength);
											break;
										case 'RSASSA-PKCS1-v1_5':
										case 'RSA-OAEP':
											e.hash && (t.hash = f(e.hash)),
												e.publicExponent && (t.publicExponent = new Uint8Array(e.publicExponent)),
												e.modulusLength && (t.modulusLength = e.modulusLength);
											break;
										default:
											throw new SyntaxError('Bad algorithm name');
									}
									return t;
								}
								function p(e) {
									return {
										'HMAC': { 'SHA-1': 'HS1', 'SHA-256': 'HS256', 'SHA-384': 'HS384', 'SHA-512': 'HS512' },
										'RSASSA-PKCS1-v1_5': { 'SHA-1': 'RS1', 'SHA-256': 'RS256', 'SHA-384': 'RS384', 'SHA-512': 'RS512' },
										'RSAES-PKCS1-v1_5': { '': 'RSA1_5' },
										'RSA-OAEP': { 'SHA-1': 'RSA-OAEP', 'SHA-256': 'RSA-OAEP-256' },
										'AES-KW': { 128: 'A128KW', 192: 'A192KW', 256: 'A256KW' },
										'AES-GCM': { 128: 'A128GCM', 192: 'A192GCM', 256: 'A256GCM' },
										'AES-CBC': { 128: 'A128CBC', 192: 'A192CBC', 256: 'A256CBC' },
									}[e.name][(e.hash || {}).name || e.length || ''];
								}
								function h(e) {
									(e instanceof ArrayBuffer || e instanceof Uint8Array) &&
										(e = JSON.parse(decodeURIComponent(escape(d(e)))));
									var t = { kty: e.kty, alg: e.alg, ext: e.ext || e.extractable };
									switch (t.kty) {
										case 'oct':
											t.k = e.k;
										case 'RSA':
											['n', 'e', 'd', 'p', 'q', 'dp', 'dq', 'qi', 'oth'].forEach(function (n) {
												n in e && (t[n] = e[n]);
											});
											break;
										default:
											throw new TypeError('Unsupported key type');
									}
									return t;
								}
								function m(e) {
									var t = h(e);
									return (
										a && ((t.extractable = t.ext), delete t.ext),
										c(unescape(encodeURIComponent(JSON.stringify(t)))).buffer
									);
								}
								function v(e) {
									var t = _(e),
										n = !1;
									t.length > 2 && ((n = !0), t.shift());
									var r = { ext: !0 };
									if ('1.2.840.113549.1.1.1' !== t[0][0]) throw new TypeError('Unsupported key type');
									var o = ['n', 'e', 'd', 'p', 'q', 'dp', 'dq', 'qi'],
										i = _(t[1]);
									n && i.shift();
									for (var a = 0; a < i.length; a++) i[a][0] || (i[a] = i[a].subarray(1)), (r[o[a]] = l(d(i[a])));
									return (r.kty = 'RSA'), r;
								}
								function g(e) {
									var t,
										n = [['', null]],
										r = !1;
									if ('RSA' !== e.kty) throw new TypeError('Unsupported key type');
									for (
										var o = ['n', 'e', 'd', 'p', 'q', 'dp', 'dq', 'qi'], i = [], a = 0;
										a < o.length && o[a] in e;
										a++
									) {
										var s = (i[a] = c(u(e[o[a]])));
										128 & s[0] && ((i[a] = new Uint8Array(s.length + 1)), i[a].set(s, 1));
									}
									return (
										i.length > 2 && ((r = !0), i.unshift(new Uint8Array([0]))),
										(n[0][0] = '1.2.840.113549.1.1.1'),
										(t = i),
										n.push(new Uint8Array(w(t)).buffer),
										r ? n.unshift(new Uint8Array([0])) : (n[1] = { tag: 3, value: n[1] }),
										new Uint8Array(w(n)).buffer
									);
								}
								var y = { KoZIhvcNAQEB: '1.2.840.113549.1.1.1' },
									b = { '1.2.840.113549.1.1.1': 'KoZIhvcNAQEB' };
								function _(e, t) {
									if (
										(e instanceof ArrayBuffer && (e = new Uint8Array(e)),
										t || (t = { pos: 0, end: e.length }),
										t.end - t.pos < 2 || t.end > e.length)
									)
										throw new RangeError('Malformed DER');
									var n,
										r = e[t.pos++],
										o = e[t.pos++];
									if (o >= 128) {
										if (((o &= 127), t.end - t.pos < o)) throw new RangeError('Malformed DER');
										for (var i = 0; o--; ) (i <<= 8), (i |= e[t.pos++]);
										o = i;
									}
									if (t.end - t.pos < o) throw new RangeError('Malformed DER');
									switch (r) {
										case 2:
											n = e.subarray(t.pos, (t.pos += o));
											break;
										case 3:
											if (e[t.pos++]) throw new Error('Unsupported bit string');
											o--;
										case 4:
											n = new Uint8Array(e.subarray(t.pos, (t.pos += o))).buffer;
											break;
										case 5:
											n = null;
											break;
										case 6:
											var a = btoa(d(e.subarray(t.pos, (t.pos += o))));
											if (!(a in y)) throw new Error('Unsupported OBJECT ID ' + a);
											n = y[a];
											break;
										case 48:
											n = [];
											for (var s = t.pos + o; t.pos < s; ) n.push(_(e, t));
											break;
										default:
											throw new Error('Unsupported DER tag 0x' + r.toString(16));
									}
									return n;
								}
								function w(e, t) {
									t || (t = []);
									var n = 0,
										r = 0,
										o = t.length + 2;
									if ((t.push(0, 0), e instanceof Uint8Array)) {
										(n = 2), (r = e.length);
										for (var i = 0; i < r; i++) t.push(e[i]);
									} else if (e instanceof ArrayBuffer) {
										(n = 4), (r = e.byteLength), (e = new Uint8Array(e));
										for (i = 0; i < r; i++) t.push(e[i]);
									} else if (null === e) (n = 5), (r = 0);
									else if ('string' == typeof e && e in b) {
										var a = c(atob(b[e]));
										(n = 6), (r = a.length);
										for (i = 0; i < r; i++) t.push(a[i]);
									} else if (e instanceof Array) {
										for (i = 0; i < e.length; i++) w(e[i], t);
										(n = 48), (r = t.length - o);
									} else {
										if (!('object' == typeof e && 3 === e.tag && e.value instanceof ArrayBuffer))
											throw new Error('Unsupported DER value ' + e);
										(n = 3), (r = (e = new Uint8Array(e.value)).byteLength), t.push(0);
										for (i = 0; i < r; i++) t.push(e[i]);
										r++;
									}
									if (r >= 128) {
										var s = r;
										r = 4;
										for (
											t.splice(o, 0, (s >> 24) & 255, (s >> 16) & 255, (s >> 8) & 255, 255 & s);
											r > 1 && !(s >> 24);

										)
											(s <<= 8), r--;
										r < 4 && t.splice(o, 4 - r), (r |= 128);
									}
									return t.splice(o - 2, 2, n, r), t;
								}
								function O(e, t, n, r) {
									Object.defineProperties(this, {
										_key: { value: e },
										type: { value: e.type, enumerable: !0 },
										extractable: { value: void 0 === n ? e.extractable : n, enumerable: !0 },
										algorithm: { value: void 0 === t ? e.algorithm : t, enumerable: !0 },
										usages: { value: void 0 === r ? e.usages : r, enumerable: !0 },
									});
								}
								function k(e) {
									return 'verify' === e || 'encrypt' === e || 'wrapKey' === e;
								}
								function x(e) {
									return 'sign' === e || 'decrypt' === e || 'unwrapKey' === e;
								}
								if (
									(['generateKey', 'importKey', 'unwrapKey'].forEach(function (e) {
										var r = n[e];
										n[e] = function (o, i, l) {
											var d,
												g,
												y,
												b,
												_ = [].slice.call(arguments);
											switch (e) {
												case 'generateKey':
													(d = f(o)), (g = i), (y = l);
													break;
												case 'importKey':
													(d = f(l)),
														(g = _[3]),
														(y = _[4]),
														'jwk' === o &&
															((i = h(i)).alg || (i.alg = p(d)),
															i.key_ops ||
																(i.key_ops = 'oct' !== i.kty ? ('d' in i ? y.filter(x) : y.filter(k)) : y.slice()),
															(_[1] = m(i)));
													break;
												case 'unwrapKey':
													(d = _[4]), (g = _[5]), (y = _[6]), (_[2] = l._key);
											}
											if ('generateKey' === e && 'HMAC' === d.name && d.hash)
												return (
													(d.length =
														d.length ||
														{ 'SHA-1': 512, 'SHA-256': 512, 'SHA-384': 1024, 'SHA-512': 1024 }[d.hash.name]),
													n.importKey('raw', t.getRandomValues(new Uint8Array((d.length + 7) >> 3)), d, g, y)
												);
											if (
												s &&
												'generateKey' === e &&
												'RSASSA-PKCS1-v1_5' === d.name &&
												(!d.modulusLength || d.modulusLength >= 2048)
											)
												return (
													((o = f(o)).name = 'RSAES-PKCS1-v1_5'),
													delete o.hash,
													n
														.generateKey(o, !0, ['encrypt', 'decrypt'])
														.then(function (e) {
															return Promise.all([n.exportKey('jwk', e.publicKey), n.exportKey('jwk', e.privateKey)]);
														})
														.then(function (e) {
															return (
																(e[0].alg = e[1].alg = p(d)),
																(e[0].key_ops = y.filter(k)),
																(e[1].key_ops = y.filter(x)),
																Promise.all([
																	n.importKey('jwk', e[0], d, !0, e[0].key_ops),
																	n.importKey('jwk', e[1], d, g, e[1].key_ops),
																])
															);
														})
														.then(function (e) {
															return { publicKey: e[0], privateKey: e[1] };
														})
												);
											if (
												(s || (a && 'SHA-1' === (d.hash || {}).name)) &&
												'importKey' === e &&
												'jwk' === o &&
												'HMAC' === d.name &&
												'oct' === i.kty
											)
												return n.importKey('raw', c(u(i.k)), l, _[3], _[4]);
											if (s && 'importKey' === e && ('spki' === o || 'pkcs8' === o))
												return n.importKey('jwk', v(i), l, _[3], _[4]);
											if (a && 'unwrapKey' === e)
												return n.decrypt(_[3], l, i).then(function (e) {
													return n.importKey(o, e, _[4], _[5], _[6]);
												});
											try {
												b = r.apply(n, _);
											} catch (e) {
												return Promise.reject(e);
											}
											return (
												a &&
													(b = new Promise(function (e, t) {
														(b.onabort = b.onerror =
															function (e) {
																t(e);
															}),
															(b.oncomplete = function (t) {
																e(t.target.result);
															});
													})),
												(b = b.then(function (e) {
													return (
														'HMAC' === d.name && (d.length || (d.length = 8 * e.algorithm.length)),
														0 == d.name.search('RSA') &&
															(d.modulusLength || (d.modulusLength = (e.publicKey || e).algorithm.modulusLength),
															d.publicExponent || (d.publicExponent = (e.publicKey || e).algorithm.publicExponent)),
														(e =
															e.publicKey && e.privateKey
																? {
																		publicKey: new O(e.publicKey, d, g, y.filter(k)),
																		privateKey: new O(e.privateKey, d, g, y.filter(x)),
																  }
																: new O(e, d, g, y))
													);
												}))
											);
										};
									}),
									['exportKey', 'wrapKey'].forEach(function (e) {
										var t = n[e];
										n[e] = function (r, o, i) {
											var u,
												f = [].slice.call(arguments);
											switch (e) {
												case 'exportKey':
													f[1] = o._key;
													break;
												case 'wrapKey':
													(f[1] = o._key), (f[2] = i._key);
											}
											if (
												((s || (a && 'SHA-1' === (o.algorithm.hash || {}).name)) &&
													'exportKey' === e &&
													'jwk' === r &&
													'HMAC' === o.algorithm.name &&
													(f[0] = 'raw'),
												!s || 'exportKey' !== e || ('spki' !== r && 'pkcs8' !== r) || (f[0] = 'jwk'),
												a && 'wrapKey' === e)
											)
												return n.exportKey(r, o).then(function (e) {
													return (
														'jwk' === r && (e = c(unescape(encodeURIComponent(JSON.stringify(h(e)))))),
														n.encrypt(f[3], i, e)
													);
												});
											try {
												u = t.apply(n, f);
											} catch (e) {
												return Promise.reject(e);
											}
											return (
												a &&
													(u = new Promise(function (e, t) {
														(u.onabort = u.onerror =
															function (e) {
																t(e);
															}),
															(u.oncomplete = function (t) {
																e(t.target.result);
															});
													})),
												'exportKey' === e &&
													'jwk' === r &&
													(u = u.then(function (e) {
														return (s || (a && 'SHA-1' === (o.algorithm.hash || {}).name)) &&
															'HMAC' === o.algorithm.name
															? { kty: 'oct', alg: p(o.algorithm), key_ops: o.usages.slice(), ext: !0, k: l(d(e)) }
															: ((e = h(e)).alg || (e.alg = p(o.algorithm)),
															  e.key_ops ||
																	(e.key_ops =
																		'public' === o.type
																			? o.usages.filter(k)
																			: 'private' === o.type
																			? o.usages.filter(x)
																			: o.usages.slice()),
															  e);
													})),
												!s ||
													'exportKey' !== e ||
													('spki' !== r && 'pkcs8' !== r) ||
													(u = u.then(function (e) {
														return (e = g(h(e)));
													})),
												u
											);
										};
									}),
									['encrypt', 'decrypt', 'sign', 'verify'].forEach(function (e) {
										var t = n[e];
										n[e] = function (r, o, i, s) {
											if (a && (!i.byteLength || (s && !s.byteLength))) throw new Error('Empty input is not allowed');
											var l,
												u = [].slice.call(arguments),
												c = f(r);
											if (
												(!a ||
													('sign' !== e && 'verify' !== e) ||
													('RSASSA-PKCS1-v1_5' !== r && 'HMAC' !== r) ||
													(u[0] = { name: r }),
												a && o.algorithm.hash && (u[0].hash = u[0].hash || o.algorithm.hash),
												a && 'decrypt' === e && 'AES-GCM' === c.name)
											) {
												var d = r.tagLength >> 3;
												(u[2] = (i.buffer || i).slice(0, i.byteLength - d)),
													(r.tag = (i.buffer || i).slice(i.byteLength - d));
											}
											a && 'AES-GCM' === c.name && void 0 === u[0].tagLength && (u[0].tagLength = 128), (u[1] = o._key);
											try {
												l = t.apply(n, u);
											} catch (e) {
												return Promise.reject(e);
											}
											return (
												a &&
													(l = new Promise(function (t, n) {
														(l.onabort = l.onerror =
															function (e) {
																n(e);
															}),
															(l.oncomplete = function (n) {
																n = n.target.result;
																if ('encrypt' === e && n instanceof AesGcmEncryptResult) {
																	var r = n.ciphertext,
																		o = n.tag;
																	(n = new Uint8Array(r.byteLength + o.byteLength)).set(new Uint8Array(r), 0),
																		n.set(new Uint8Array(o), r.byteLength),
																		(n = n.buffer);
																}
																t(n);
															});
													})),
												l
											);
										};
									}),
									a)
								) {
									var E = n.digest;
									(n.digest = function (e, t) {
										if (!t.byteLength) throw new Error('Empty input is not allowed');
										var r;
										try {
											r = E.call(n, e, t);
										} catch (e) {
											return Promise.reject(e);
										}
										return (r = new Promise(function (e, t) {
											(r.onabort = r.onerror =
												function (e) {
													t(e);
												}),
												(r.oncomplete = function (t) {
													e(t.target.result);
												});
										}));
									}),
										(e.crypto = Object.create(t, {
											getRandomValues: {
												value: function (e) {
													return t.getRandomValues(e);
												},
											},
											subtle: { value: n },
										})),
										(e.CryptoKey = O);
								}
								s && ((t.subtle = n), (e.Crypto = r), (e.SubtleCrypto = o), (e.CryptoKey = O));
							})(r);
						}.apply(t, [])),
							void 0 === n || (e.exports = n);
					})('undefined' != typeof self ? self : this);
				},
				48231: function (e, t, n) {
					'use strict';
					n.r(t);
					var r = n(79602),
						o = n.n(r);
					/*
					 * qTip2 - Pretty powerful tooltips - v3.0.3-5-g
					 * http://qtip2.com
					 *
					 * Copyright (c) 2017
					 * Released under the MIT licenses
					 * http://jquery.org/license
					 *
					 * Date: Wed May 24 2017 01:22 UTC+0000
					 * Plugins: tips modal viewport svg imagemap ie6
					 * Styles: core basic css3
					 */
					!(function (e, t, n) {
						o().fn.qtip ||
							(function (r) {
								var o,
									i,
									a,
									s,
									l,
									u = !0,
									c = !1,
									d = null,
									f = 'x',
									p = 'y',
									h = 'width',
									m = 'height',
									v = 'top',
									g = 'left',
									y = 'bottom',
									b = 'right',
									_ = 'center',
									w = 'flipinvert',
									O = 'shift',
									k = {},
									x = 'qtip',
									E = 'data-hasqtip',
									T = 'data-qtip-id',
									S = ['ui-widget', 'ui-tooltip'],
									A = '.' + x,
									C = 'click dblclick mousedown mouseup mousemove mouseleave mouseenter'.split(' '),
									P = x + '-fixed',
									R = x + '-default',
									I = x + '-focus',
									N = x + '-hover',
									M = x + '-disabled',
									j = '_replacedByqTip',
									D = 'oldtitle',
									L = {
										ie: (function () {
											var e, n;
											for (
												e = 4, n = t.createElement('div');
												(n.innerHTML = '\x3c!--[if gt IE ' + e + ']><i></i><![endif]--\x3e') &&
												n.getElementsByTagName('i')[0];
												e += 1
											);
											return e > 4 ? e : NaN;
										})(),
										iOS:
											parseFloat(
												(
													'' +
													(/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [
														0,
														'',
													])[1]
												)
													.replace('undefined', '3_2')
													.replace('_', '.')
													.replace('_', '')
											) || c,
									};
								function U(e, t, n, o) {
									(this.id = n),
										(this.target = e),
										(this.tooltip = d),
										(this.elements = { target: e }),
										(this._id = x + '-' + n),
										(this.timers = { img: {} }),
										(this.options = t),
										(this.plugins = {}),
										(this.cache = { event: {}, target: r(), disabled: c, attr: o, onTooltip: c, lastClass: '' }),
										(this.rendered =
											this.destroyed =
											this.disabled =
											this.waiting =
											this.hiddenDuringWait =
											this.positioning =
											this.triggering =
												c);
								}
								function F(e) {
									return e === d || 'object' !== r.type(e);
								}
								function B(e) {
									return !(
										r.isFunction(e) ||
										(e && e.attr) ||
										e.length ||
										('object' === r.type(e) && (e.jquery || e.then))
									);
								}
								function V(e) {
									var t, n, o, i;
									return F(e)
										? c
										: (F(e.metadata) && (e.metadata = { type: e.metadata }),
										  'content' in e &&
												(F((t = e.content)) || t.jquery || t.done
													? ((n = B(t) ? c : t), (t = e.content = { text: n }))
													: (n = t.text),
												'ajax' in t &&
													((o = t.ajax),
													(i = o && o.once !== c),
													delete t.ajax,
													(t.text = function (e, t) {
														var a = n || r(this).attr(t.options.content.attr) || 'Loading...',
															s = r
																.ajax(r.extend({}, o, { context: t }))
																.then(o.success, d, o.error)
																.then(
																	function (e) {
																		return e && i && t.set('content.text', e), e;
																	},
																	function (e, n, r) {
																		t.destroyed || 0 === e.status || t.set('content.text', n + ': ' + r);
																	}
																);
														return i ? a : (t.set('content.text', a), s);
													})),
												'title' in t &&
													(r.isPlainObject(t.title) && ((t.button = t.title.button), (t.title = t.title.text)),
													B(t.title || c) && (t.title = c))),
										  'position' in e && F(e.position) && (e.position = { my: e.position, at: e.position }),
										  'show' in e &&
												F(e.show) &&
												(e.show = e.show.jquery ? { target: e.show } : e.show === u ? { ready: u } : { event: e.show }),
										  'hide' in e && F(e.hide) && (e.hide = e.hide.jquery ? { target: e.hide } : { event: e.hide }),
										  'style' in e && F(e.style) && (e.style = { classes: e.style }),
										  r.each(k, function () {
												this.sanitize && this.sanitize(e);
										  }),
										  e);
								}
								function Z(e, t) {
									for (var n, r = 0, o = e, i = t.split('.'); (o = o[i[r++]]); ) r < i.length && (n = o);
									return [n || e, i.pop()];
								}
								function H(e, t) {
									var n, r, o;
									for (n in this.checks)
										if (this.checks.hasOwnProperty(n))
											for (r in this.checks[n])
												this.checks[n].hasOwnProperty(r) &&
													(o = new RegExp(r, 'i').exec(e)) &&
													(t.push(o),
													('builtin' === n || this.plugins[n]) && this.checks[n][r].apply(this.plugins[n] || this, t));
								}
								((i = U.prototype)._when = function (e) {
									return r.when.apply(r, e);
								}),
									(i.render = function (e) {
										if (this.rendered || this.destroyed) return this;
										var t = this,
											n = this.options,
											i = this.cache,
											a = this.elements,
											s = n.content.text,
											l = n.content.title,
											d = n.content.button,
											f = n.position,
											p = [];
										return (
											r.attr(this.target[0], 'aria-describedby', this._id),
											(i.posClass = this._createPosClass((this.position = { my: f.my, at: f.at }).my)),
											(this.tooltip = a.tooltip =
												r('<div/>', {
													'id': this._id,
													'class': [x, R, n.style.classes, i.posClass].join(' '),
													'width': n.style.width || '',
													'height': n.style.height || '',
													'tracking': 'mouse' === f.target && f.adjust.mouse,
													'role': 'alert',
													'aria-live': 'polite',
													'aria-atomic': c,
													'aria-describedby': this._id + '-content',
													'aria-hidden': u,
												})
													.toggleClass(M, this.disabled)
													.attr(T, this.id)
													.data(x, this)
													.appendTo(f.container)
													.append(
														(a.content = r('<div />', {
															'class': x + '-content',
															'id': this._id + '-content',
															'aria-atomic': u,
														}))
													)),
											(this.rendered = -1),
											(this.positioning = u),
											l && (this._createTitle(), r.isFunction(l) || p.push(this._updateTitle(l, c))),
											d && this._createButton(),
											r.isFunction(s) || p.push(this._updateContent(s, c)),
											(this.rendered = u),
											this._setWidget(),
											r.each(k, function (e) {
												var n;
												'render' === this.initialize && (n = this(t)) && (t.plugins[e] = n);
											}),
											this._unassignEvents(),
											this._assignEvents(),
											this._when(p).then(function () {
												t._trigger('render'),
													(t.positioning = c),
													t.hiddenDuringWait || (!n.show.ready && !e) || t.toggle(u, i.event, c),
													(t.hiddenDuringWait = c);
											}),
											(o.api[this.id] = this),
											this
										);
									}),
									(i.destroy = function (e) {
										if (this.destroyed) return this.target;
										function t() {
											if (!this.destroyed) {
												this.destroyed = u;
												var e,
													t = this.target,
													n = t.attr(D);
												for (e in (this.rendered && this.tooltip.stop(1, 0).find('*').remove().end().remove(),
												r.each(this.plugins, function () {
													this.destroy && this.destroy();
												}),
												this.timers))
													this.timers.hasOwnProperty(e) && clearTimeout(this.timers[e]);
												t.removeData(x).removeAttr(T).removeAttr(E).removeAttr('aria-describedby'),
													this.options.suppress && n && t.attr('title', n).removeAttr(D),
													this._unassignEvents(),
													(this.options = this.elements = this.cache = this.timers = this.plugins = this.mouse = d),
													delete o.api[this.id];
											}
										}
										return (
											(e === u && 'hide' !== this.triggering) || !this.rendered
												? t.call(this)
												: (this.tooltip.one('tooltiphidden', r.proxy(t, this)), !this.triggering && this.hide()),
											this.target
										);
									}),
									(s = i.checks =
										{
											builtin: {
												'^id$': function (e, t, n, i) {
													var a = n === u ? o.nextid : n,
														s = x + '-' + a;
													a !== c && a.length > 0 && !r('#' + s).length
														? ((this._id = s),
														  this.rendered &&
																((this.tooltip[0].id = this._id),
																(this.elements.content[0].id = this._id + '-content'),
																(this.elements.title[0].id = this._id + '-title')))
														: (e[t] = i);
												},
												'^prerender': function (e, t, n) {
													n && !this.rendered && this.render(this.options.show.ready);
												},
												'^content.text$': function (e, t, n) {
													this._updateContent(n);
												},
												'^content.attr$': function (e, t, n, r) {
													this.options.content.text === this.target.attr(r) && this._updateContent(this.target.attr(n));
												},
												'^content.title$': function (e, t, n) {
													if (!n) return this._removeTitle();
													n && !this.elements.title && this._createTitle(), this._updateTitle(n);
												},
												'^content.button$': function (e, t, n) {
													this._updateButton(n);
												},
												'^content.title.(text|button)$': function (e, t, n) {
													this.set('content.' + t, n);
												},
												'^position.(my|at)$': function (e, t, n) {
													'string' == typeof n && (this.position[t] = e[t] = new a(n, 'at' === t));
												},
												'^position.container$': function (e, t, n) {
													this.rendered && this.tooltip.appendTo(n);
												},
												'^show.ready$': function (e, t, n) {
													n && ((!this.rendered && this.render(u)) || this.toggle(u));
												},
												'^style.classes$': function (e, t, n, r) {
													this.rendered && this.tooltip.removeClass(r).addClass(n);
												},
												'^style.(width|height)': function (e, t, n) {
													this.rendered && this.tooltip.css(t, n);
												},
												'^style.widget|content.title': function () {
													this.rendered && this._setWidget();
												},
												'^style.def': function (e, t, n) {
													this.rendered && this.tooltip.toggleClass(R, !!n);
												},
												'^events.(render|show|move|hide|focus|blur)$': function (e, t, n) {
													this.rendered && this.tooltip[(r.isFunction(n) ? '' : 'un') + 'bind']('tooltip' + t, n);
												},
												'^(show|hide|position).(event|target|fixed|inactive|leave|distance|viewport|adjust)':
													function () {
														if (this.rendered) {
															var e = this.options.position;
															this.tooltip.attr('tracking', 'mouse' === e.target && e.adjust.mouse),
																this._unassignEvents(),
																this._assignEvents();
														}
													},
											},
										}),
									(i.get = function (e) {
										if (this.destroyed) return this;
										var t = Z(this.options, e.toLowerCase()),
											n = t[0][t[1]];
										return n.precedance ? n.string() : n;
									});
								var q = /^position\.(my|at|adjust|target|container|viewport)|style|content|show\.ready/i,
									W = /^prerender|show\.ready/i;
								(i.set = function (e, t) {
									if (this.destroyed) return this;
									var n,
										o = this.rendered,
										i = c,
										a = this.options;
									return (
										'string' == typeof e ? ((n = e), ((e = {})[n] = t)) : (e = r.extend({}, e)),
										r.each(e, function (t, n) {
											if (o && W.test(t)) delete e[t];
											else {
												var s,
													l = Z(a, t.toLowerCase());
												(s = l[0][l[1]]),
													(l[0][l[1]] = n && n.nodeType ? r(n) : n),
													(i = q.test(t) || i),
													(e[t] = [l[0], l[1], n, s]);
											}
										}),
										V(a),
										(this.positioning = u),
										r.each(e, r.proxy(H, this)),
										(this.positioning = c),
										this.rendered &&
											this.tooltip[0].offsetWidth > 0 &&
											i &&
											this.reposition('mouse' === a.position.target ? d : this.cache.event),
										this
									);
								}),
									(i._update = function (e, t) {
										var n = this,
											o = this.cache;
										return this.rendered && e
											? (r.isFunction(e) && (e = e.call(this.elements.target, o.event, this) || ''),
											  r.isFunction(e.then)
													? ((o.waiting = u),
													  e.then(
															function (e) {
																return (o.waiting = c), n._update(e, t);
															},
															d,
															function (e) {
																return n._update(e, t);
															}
													  ))
													: e === c || (!e && '' !== e)
													? c
													: (e.jquery && e.length > 0
															? t.empty().append(e.css({ display: 'block', visibility: 'visible' }))
															: t.html(e),
													  this._waitForContent(t).then(function (e) {
															n.rendered && n.tooltip[0].offsetWidth > 0 && n.reposition(o.event, !e.length);
													  })))
											: c;
									}),
									(i._waitForContent = function (e) {
										var t = this.cache;
										return (
											(t.waiting = u),
											(r.fn.imagesLoaded ? e.imagesLoaded() : new r.Deferred().resolve([]))
												.done(function () {
													t.waiting = c;
												})
												.promise()
										);
									}),
									(i._updateContent = function (e, t) {
										this._update(e, this.elements.content, t);
									}),
									(i._updateTitle = function (e, t) {
										this._update(e, this.elements.title, t) === c && this._removeTitle(c);
									}),
									(i._createTitle = function () {
										var e = this.elements,
											t = this._id + '-title';
										e.titlebar && this._removeTitle(),
											(e.titlebar = r('<div />', {
												class: x + '-titlebar ' + (this.options.style.widget ? $('header') : ''),
											})
												.append((e.title = r('<div />', { 'id': t, 'class': x + '-title', 'aria-atomic': u })))
												.insertBefore(e.content)
												.delegate('.qtip-close', 'mousedown keydown mouseup keyup mouseout', function (e) {
													r(this).toggleClass('ui-state-active ui-state-focus', 'down' === e.type.substr(-4));
												})
												.delegate('.qtip-close', 'mouseover mouseout', function (e) {
													r(this).toggleClass('ui-state-hover', 'mouseover' === e.type);
												})),
											this.options.content.button && this._createButton();
									}),
									(i._removeTitle = function (e) {
										var t = this.elements;
										t.title &&
											(t.titlebar.remove(), (t.titlebar = t.title = t.button = d), e !== c && this.reposition());
									}),
									(i._createPosClass = function (e) {
										return x + '-pos-' + (e || this.options.position.my).abbrev();
									}),
									(i.reposition = function (n, o) {
										if (!this.rendered || this.positioning || this.destroyed) return this;
										this.positioning = u;
										var i,
											a,
											s,
											l,
											d = this.cache,
											f = this.tooltip,
											p = this.options.position,
											h = p.target,
											m = p.my,
											w = p.at,
											O = p.viewport,
											x = p.container,
											E = p.adjust,
											T = E.method.split(' '),
											S = f.outerWidth(c),
											A = f.outerHeight(c),
											C = 0,
											P = 0,
											R = f.css('position'),
											I = { left: 0, top: 0 },
											N = f[0].offsetWidth > 0,
											M = n && 'scroll' === n.type,
											j = r(e),
											D = x[0].ownerDocument,
											U = this.mouse;
										if (r.isArray(h) && 2 === h.length) (w = { x: g, y: v }), (I = { left: h[0], top: h[1] });
										else if ('mouse' === h)
											(w = { x: g, y: v }),
												(!E.mouse || this.options.hide.distance) && d.origin && d.origin.pageX
													? (n = d.origin)
													: !n || (n && ('resize' === n.type || 'scroll' === n.type))
													? (n = d.event)
													: U && U.pageX && (n = U),
												'static' !== R && (I = x.offset()),
												D.body.offsetWidth !== (e.innerWidth || D.documentElement.clientWidth) &&
													(a = r(t.body).offset()),
												(I = {
													left: n.pageX - I.left + ((a && a.left) || 0),
													top: n.pageY - I.top + ((a && a.top) || 0),
												}),
												E.mouse &&
													M &&
													U &&
													((I.left -= (U.scrollX || 0) - j.scrollLeft()), (I.top -= (U.scrollY || 0) - j.scrollTop()));
										else {
											if (
												('event' === h
													? n && n.target && 'scroll' !== n.type && 'resize' !== n.type
														? (d.target = r(n.target))
														: n.target || (d.target = this.elements.target)
													: 'event' !== h && (d.target = r(h.jquery ? h : this.elements.target)),
												(h = d.target),
												0 === (h = r(h).eq(0)).length)
											)
												return this;
											h[0] === t || h[0] === e
												? ((C = L.iOS ? e.innerWidth : h.width()),
												  (P = L.iOS ? e.innerHeight : h.height()),
												  h[0] === e && (I = { top: (O || h).scrollTop(), left: (O || h).scrollLeft() }))
												: k.imagemap && h.is('area')
												? (i = k.imagemap(this, h, w, k.viewport ? T : c))
												: k.svg && h && h[0].ownerSVGElement
												? (i = k.svg(this, h, w, k.viewport ? T : c))
												: ((C = h.outerWidth(c)), (P = h.outerHeight(c)), (I = h.offset())),
												i && ((C = i.width), (P = i.height), (a = i.offset), (I = i.position)),
												(I = this.reposition.offset(h, I, x)),
												((L.iOS > 3.1 && L.iOS < 4.1) || (L.iOS >= 4.3 && L.iOS < 4.33) || (!L.iOS && 'fixed' === R)) &&
													((I.left -= j.scrollLeft()), (I.top -= j.scrollTop())),
												(!i || (i && i.adjustable !== c)) &&
													((I.left += w.x === b ? C : w.x === _ ? C / 2 : 0),
													(I.top += w.y === y ? P : w.y === _ ? P / 2 : 0));
										}
										return (
											(I.left += E.x + (m.x === b ? -S : m.x === _ ? -S / 2 : 0)),
											(I.top += E.y + (m.y === y ? -A : m.y === _ ? -A / 2 : 0)),
											k.viewport
												? ((s = I.adjusted = k.viewport(this, I, p, C, P, S, A)),
												  a && s.left && (I.left += a.left),
												  a && s.top && (I.top += a.top),
												  s.my && (this.position.my = s.my))
												: (I.adjusted = { left: 0, top: 0 }),
											d.posClass !== (l = this._createPosClass(this.position.my)) &&
												((d.posClass = l), f.removeClass(d.posClass).addClass(l)),
											this._trigger('move', [I, O.elem || O], n)
												? (delete I.adjusted,
												  o === c || !N || isNaN(I.left) || isNaN(I.top) || 'mouse' === h || !r.isFunction(p.effect)
														? f.css(I)
														: r.isFunction(p.effect) &&
														  (p.effect.call(f, this, r.extend({}, I)),
														  f.queue(function (e) {
																r(this).css({ opacity: '', height: '' }),
																	L.ie && this.style.removeAttribute('filter'),
																	e();
														  })),
												  (this.positioning = c),
												  this)
												: this
										);
									}),
									(i.reposition.offset = function (e, n, o) {
										if (!o[0]) return n;
										var i,
											a,
											s,
											l,
											u = r(e[0].ownerDocument),
											c = !!L.ie && 'CSS1Compat' !== t.compatMode,
											d = o[0];
										function f(e, t) {
											(n.left += t * e.scrollLeft()), (n.top += t * e.scrollTop());
										}
										do {
											'static' !== (a = r.css(d, 'position')) &&
												('fixed' === a
													? ((s = d.getBoundingClientRect()), f(u, -1))
													: (((s = r(d).position()).left += parseFloat(r.css(d, 'borderLeftWidth')) || 0),
													  (s.top += parseFloat(r.css(d, 'borderTopWidth')) || 0)),
												(n.left -= s.left + (parseFloat(r.css(d, 'marginLeft')) || 0)),
												(n.top -= s.top + (parseFloat(r.css(d, 'marginTop')) || 0)),
												i ||
													'hidden' === (l = r.css(d, 'overflow')) ||
													'visible' === l ||
													'BODY' === r.prop(d, 'tagName') ||
													(i = r(d)));
										} while ((d = d.offsetParent));
										return i && (i[0] !== u[0] || c) && f(i, 1), n;
									});
								var K = (a = i.reposition.Corner =
									function (e, t) {
										(e = ('' + e)
											.replace(/([A-Z])/, ' $1')
											.replace(/middle/gi, _)
											.toLowerCase()),
											(this.x = (e.match(/left|right/i) || e.match(/center/) || ['inherit'])[0].toLowerCase()),
											(this.y = (e.match(/top|bottom|center/i) || ['inherit'])[0].toLowerCase()),
											(this.forceY = !!t);
										var n = e.charAt(0);
										this.precedance = 't' === n || 'b' === n ? p : f;
									}).prototype;
								function $(e) {
									return S.concat('').join(e ? '-' + e + ' ' : ' ');
								}
								function z(e, t) {
									if (t > 0) return setTimeout(r.proxy(e, this), t);
									e.call(this);
								}
								function G(e) {
									this.tooltip.hasClass(M) ||
										(clearTimeout(this.timers.show),
										clearTimeout(this.timers.hide),
										(this.timers.show = z.call(
											this,
											function () {
												this.toggle(u, e);
											},
											this.options.show.delay
										)));
								}
								function Y(e) {
									if (!this.tooltip.hasClass(M) && !this.destroyed) {
										var t = r(e.relatedTarget),
											n = t.closest(A)[0] === this.tooltip[0],
											o = t[0] === this.options.show.target[0];
										if (
											(clearTimeout(this.timers.show),
											clearTimeout(this.timers.hide),
											(this !== t[0] && 'mouse' === this.options.position.target && n) ||
												(this.options.hide.fixed && /mouse(out|leave|move)/.test(e.type) && (n || o)))
										)
											try {
												e.preventDefault(), e.stopImmediatePropagation();
											} catch (e) {}
										else
											this.timers.hide = z.call(
												this,
												function () {
													this.toggle(c, e);
												},
												this.options.hide.delay,
												this
											);
									}
								}
								function J(e) {
									!this.tooltip.hasClass(M) &&
										this.options.hide.inactive &&
										(clearTimeout(this.timers.inactive),
										(this.timers.inactive = z.call(
											this,
											function () {
												this.hide(e);
											},
											this.options.hide.inactive
										)));
								}
								function Q(e) {
									this.rendered && this.tooltip[0].offsetWidth > 0 && this.reposition(e);
								}
								function X(e, n, i) {
									r(t.body).delegate(e, (n.split ? n : n.join('.' + x + ' ')) + '.' + x, function () {
										var e = o.api[r.attr(this, T)];
										e && !e.disabled && i.apply(e, arguments);
									});
								}
								function ee(e, n, i) {
									var s,
										l,
										f,
										p,
										h,
										m = r(t.body),
										v = e[0] === t ? m : e,
										g = e.metadata ? e.metadata(i.metadata) : d,
										y = 'html5' === i.metadata.type && g ? g[i.metadata.name] : d,
										b = e.data(i.metadata.name || 'qtipopts');
									try {
										b = 'string' == typeof b ? r.parseJSON(b) : b;
									} catch (e) {}
									if (
										((l = (p = r.extend(u, {}, o.defaults, i, 'object' == typeof b ? V(b) : d, V(y || g))).position),
										(p.id = n),
										'boolean' == typeof p.content.text)
									) {
										if (((f = e.attr(p.content.attr)), p.content.attr === c || !f)) return c;
										p.content.text = f;
									}
									if (
										(l.container.length || (l.container = m),
										l.target === c && (l.target = v),
										p.show.target === c && (p.show.target = v),
										p.show.solo === u && (p.show.solo = l.container.closest('body')),
										p.hide.target === c && (p.hide.target = v),
										p.position.viewport === u && (p.position.viewport = l.container),
										(l.container = l.container.eq(0)),
										(l.at = new a(l.at, u)),
										(l.my = new a(l.my)),
										e.data(x))
									)
										if (p.overwrite) e.qtip('destroy', !0);
										else if (p.overwrite === c) return c;
									return (
										e.attr(E, n),
										p.suppress && (h = e.attr('title')) && e.removeAttr('title').attr(D, h).attr('title', ''),
										(s = new U(e, p, n, !!f)),
										e.data(x, s),
										s
									);
								}
								(K.invert = function (e, t) {
									this[e] = this[e] === g ? b : this[e] === b ? g : t || this[e];
								}),
									(K.string = function (e) {
										var t = this.x,
											n = this.y,
											r =
												t !== n
													? 'center' === t || ('center' !== n && (this.precedance === p || this.forceY))
														? [n, t]
														: [t, n]
													: [t];
										return !1 !== e ? r.join(' ') : r;
									}),
									(K.abbrev = function () {
										var e = this.string(!1);
										return e[0].charAt(0) + ((e[1] && e[1].charAt(0)) || '');
									}),
									(K.clone = function () {
										return new a(this.string(), this.forceY);
									}),
									(i.toggle = function (e, n) {
										var o = this.cache,
											i = this.options,
											a = this.tooltip;
										if (n) {
											if (
												/over|enter/.test(n.type) &&
												o.event &&
												/out|leave/.test(o.event.type) &&
												i.show.target.add(n.target).length === i.show.target.length &&
												a.has(n.relatedTarget).length
											)
												return this;
											o.event = r.event.fix(n);
										}
										if ((this.waiting && !e && (this.hiddenDuringWait = u), !this.rendered))
											return e ? this.render(1) : this;
										if (this.destroyed || this.disabled) return this;
										var s,
											f,
											p,
											h = e ? 'show' : 'hide',
											m = this.options[h],
											v = this.options.position,
											g = this.options.content,
											y = this.tooltip.css('width'),
											b = this.tooltip.is(':visible'),
											_ = e || 1 === m.target.length,
											w = !n || m.target.length < 2 || o.target[0] === n.target;
										return (
											(typeof e).search('boolean|number') && (e = !b),
											(f = (s = !a.is(':animated') && b === e && w) ? d : !!this._trigger(h, [90])),
											this.destroyed ||
												(f !== c && e && this.focus(n),
												!f ||
													s ||
													(r.attr(a[0], 'aria-hidden', !e),
													e
														? (this.mouse && (o.origin = r.event.fix(this.mouse)),
														  r.isFunction(g.text) && this._updateContent(g.text, c),
														  r.isFunction(g.title) && this._updateTitle(g.title, c),
														  !l &&
																'mouse' === v.target &&
																v.adjust.mouse &&
																(r(t).bind('mousemove.' + x, this._storeMouse), (l = u)),
														  y || a.css('width', a.outerWidth(c)),
														  this.reposition(n, arguments[2]),
														  y || a.css('width', ''),
														  m.solo &&
																('string' == typeof m.solo ? r(m.solo) : r(A, m.solo))
																	.not(a)
																	.not(m.target)
																	.qtip('hide', new r.Event('tooltipsolo')))
														: (clearTimeout(this.timers.show),
														  delete o.origin,
														  l &&
																!r(A + '[tracking="true"]:visible', m.solo).not(a).length &&
																(r(t).unbind('mousemove.' + x), (l = c)),
														  this.blur(n)),
													(p = r.proxy(function () {
														e
															? (L.ie && a[0].style.removeAttribute('filter'),
															  a.css('overflow', ''),
															  'string' == typeof m.autofocus && r(this.options.show.autofocus, a).focus(),
															  this.options.show.target.trigger('qtip-' + this.id + '-inactive'))
															: a.css({ display: '', visibility: '', opacity: '', left: '', top: '' }),
															this._trigger(e ? 'visible' : 'hidden');
													}, this)),
													m.effect === c || _ === c
														? (a[h](), p())
														: r.isFunction(m.effect)
														? (a.stop(1, 1),
														  m.effect.call(a, this),
														  a.queue('fx', function (e) {
																p(), e();
														  }))
														: a.fadeTo(90, e ? 1 : 0, p),
													e && m.target.trigger('qtip-' + this.id + '-inactive'))),
											this
										);
									}),
									(i.show = function (e) {
										return this.toggle(u, e);
									}),
									(i.hide = function (e) {
										return this.toggle(c, e);
									}),
									(i.focus = function (e) {
										if (!this.rendered || this.destroyed) return this;
										var t = r(A),
											n = this.tooltip,
											i = parseInt(n[0].style.zIndex, 10),
											a = o.zindex + t.length;
										return (
											n.hasClass(I) ||
												(this._trigger('focus', [a], e) &&
													(i !== a &&
														(t.each(function () {
															this.style.zIndex > i && (this.style.zIndex = this.style.zIndex - 1);
														}),
														t.filter('.' + I).qtip('blur', e)),
													(n.addClass(I)[0].style.zIndex = a))),
											this
										);
									}),
									(i.blur = function (e) {
										return (
											!this.rendered ||
												this.destroyed ||
												(this.tooltip.removeClass(I), this._trigger('blur', [this.tooltip.css('zIndex')], e)),
											this
										);
									}),
									(i.disable = function (e) {
										return (
											this.destroyed ||
												('toggle' === e
													? (e = !(this.rendered ? this.tooltip.hasClass(M) : this.disabled))
													: 'boolean' != typeof e && (e = u),
												this.rendered && this.tooltip.toggleClass(M, e).attr('aria-disabled', e),
												(this.disabled = !!e)),
											this
										);
									}),
									(i.enable = function () {
										return this.disable(c);
									}),
									(i._createButton = function () {
										var e = this,
											t = this.elements,
											n = t.tooltip,
											o = this.options.content.button,
											i = 'string' == typeof o ? o : 'Close tooltip';
										t.button && t.button.remove(),
											o.jquery
												? (t.button = o)
												: (t.button = r('<a />', {
														'class': 'qtip-close ' + (this.options.style.widget ? '' : x + '-icon'),
														'title': i,
														'aria-label': i,
												  }).prepend(r('<span />', { class: 'ui-icon ui-icon-close', html: '&times;' }))),
											t.button
												.appendTo(t.titlebar || n)
												.attr('role', 'button')
												.click(function (t) {
													return n.hasClass(M) || e.hide(t), c;
												});
									}),
									(i._updateButton = function (e) {
										if (!this.rendered) return c;
										var t = this.elements.button;
										e ? this._createButton() : t.remove();
									}),
									(i._setWidget = function () {
										var e = this.options.style.widget,
											t = this.elements,
											n = t.tooltip,
											r = n.hasClass(M);
										n.removeClass(M),
											(M = e ? 'ui-state-disabled' : 'qtip-disabled'),
											n.toggleClass(M, r),
											n.toggleClass('ui-helper-reset ' + $(), e).toggleClass(R, this.options.style.def && !e),
											t.content && t.content.toggleClass($('content'), e),
											t.titlebar && t.titlebar.toggleClass($('header'), e),
											t.button && t.button.toggleClass(x + '-icon', !e);
									}),
									(i._storeMouse = function (e) {
										return ((this.mouse = r.event.fix(e)).type = 'mousemove'), this;
									}),
									(i._bind = function (e, t, n, o, i) {
										if (e && n && t.length) {
											var a = '.' + this._id + (o ? '-' + o : '');
											return r(e).bind((t.split ? t : t.join(a + ' ')) + a, r.proxy(n, i || this)), this;
										}
									}),
									(i._unbind = function (e, t) {
										return e && r(e).unbind('.' + this._id + (t ? '-' + t : '')), this;
									}),
									(i._trigger = function (e, t, n) {
										var o = new r.Event('tooltip' + e);
										return (
											(o.originalEvent = (n && r.extend({}, n)) || this.cache.event || d),
											(this.triggering = e),
											this.tooltip.trigger(o, [this].concat(t || [])),
											(this.triggering = c),
											!o.isDefaultPrevented()
										);
									}),
									(i._bindEvents = function (e, t, n, o, i, a) {
										var s = n.filter(o).add(o.filter(n)),
											l = [];
										s.length &&
											(r.each(t, function (t, n) {
												var o = r.inArray(n, e);
												o > -1 && l.push(e.splice(o, 1)[0]);
											}),
											l.length &&
												(this._bind(s, l, function (e) {
													(this.rendered && this.tooltip[0].offsetWidth > 0 ? a : i).call(this, e);
												}),
												(n = n.not(s)),
												(o = o.not(s)))),
											this._bind(n, e, i),
											this._bind(o, t, a);
									}),
									(i._assignInitialEvents = function (e) {
										var t = this.options,
											n = t.show.target,
											o = t.hide.target,
											i = t.show.event ? r.trim('' + t.show.event).split(' ') : [],
											a = t.hide.event ? r.trim('' + t.hide.event).split(' ') : [];
										function s(e) {
											if (this.disabled || this.destroyed) return c;
											(this.cache.event = e && r.event.fix(e)),
												(this.cache.target = e && r(e.target)),
												clearTimeout(this.timers.show),
												(this.timers.show = z.call(
													this,
													function () {
														this.render('object' == typeof e || t.show.ready);
													},
													t.prerender ? 0 : t.show.delay
												));
										}
										this._bind(
											this.elements.target,
											['remove', 'removeqtip'],
											function () {
												this.destroy(!0);
											},
											'destroy'
										),
											/mouse(over|enter)/i.test(t.show.event) &&
												!/mouse(out|leave)/i.test(t.hide.event) &&
												a.push('mouseleave'),
											this._bind(n, 'mousemove', function (e) {
												this._storeMouse(e), (this.cache.onTarget = u);
											}),
											this._bindEvents(i, a, n, o, s, function () {
												if (!this.timers) return c;
												clearTimeout(this.timers.show);
											}),
											(t.show.ready || t.prerender) && s.call(this, e);
									}),
									(i._assignEvents = function () {
										var n = this,
											i = this.options,
											a = i.position,
											s = this.tooltip,
											l = i.show.target,
											u = i.hide.target,
											d = a.container,
											f = a.viewport,
											p = r(t),
											h = r(e),
											m = i.show.event ? r.trim('' + i.show.event).split(' ') : [],
											v = i.hide.event ? r.trim('' + i.hide.event).split(' ') : [];
										r.each(i.events, function (e, t) {
											n._bind(s, 'toggle' === e ? ['tooltipshow', 'tooltiphide'] : ['tooltip' + e], t, null, s);
										}),
											/mouse(out|leave)/i.test(i.hide.event) &&
												'window' === i.hide.leave &&
												this._bind(p, ['mouseout', 'blur'], function (e) {
													/select|option/.test(e.target.nodeName) || e.relatedTarget || this.hide(e);
												}),
											i.hide.fixed
												? (u = u.add(s.addClass(P)))
												: /mouse(over|enter)/i.test(i.show.event) &&
												  this._bind(u, 'mouseleave', function () {
														clearTimeout(this.timers.show);
												  }),
											('' + i.hide.event).indexOf('unfocus') > -1 &&
												this._bind(d.closest('html'), ['mousedown', 'touchstart'], function (e) {
													var t = r(e.target),
														n = this.rendered && !this.tooltip.hasClass(M) && this.tooltip[0].offsetWidth > 0,
														o = t.parents(A).filter(this.tooltip[0]).length > 0;
													t[0] === this.target[0] ||
														t[0] === this.tooltip[0] ||
														o ||
														this.target.has(t[0]).length ||
														!n ||
														this.hide(e);
												}),
											'number' == typeof i.hide.inactive &&
												(this._bind(l, 'qtip-' + this.id + '-inactive', J, 'inactive'),
												this._bind(u.add(s), o.inactiveEvents, J)),
											this._bindEvents(m, v, l, u, G, Y),
											this._bind(l.add(s), 'mousemove', function (e) {
												if ('number' == typeof i.hide.distance) {
													var t = this.cache.origin || {},
														n = this.options.hide.distance,
														r = Math.abs;
													(r(e.pageX - t.pageX) >= n || r(e.pageY - t.pageY) >= n) && this.hide(e);
												}
												this._storeMouse(e);
											}),
											'mouse' === a.target &&
												a.adjust.mouse &&
												(i.hide.event &&
													this._bind(l, ['mouseenter', 'mouseleave'], function (e) {
														if (!this.cache) return c;
														this.cache.onTarget = 'mouseenter' === e.type;
													}),
												this._bind(p, 'mousemove', function (e) {
													this.rendered &&
														this.cache.onTarget &&
														!this.tooltip.hasClass(M) &&
														this.tooltip[0].offsetWidth > 0 &&
														this.reposition(e);
												})),
											(a.adjust.resize || f.length) && this._bind(r.event.special.resize ? f : h, 'resize', Q),
											a.adjust.scroll && this._bind(h.add(a.container), 'scroll', Q);
									}),
									(i._unassignEvents = function () {
										var n = this.options,
											o = n.show.target,
											i = n.hide.target,
											a = r.grep(
												[
													this.elements.target[0],
													this.rendered && this.tooltip[0],
													n.position.container[0],
													n.position.viewport[0],
													n.position.container.closest('html')[0],
													e,
													t,
												],
												function (e) {
													return 'object' == typeof e;
												}
											);
										o && o.toArray && (a = a.concat(o.toArray())),
											i && i.toArray && (a = a.concat(i.toArray())),
											this._unbind(a)._unbind(a, 'destroy')._unbind(a, 'inactive');
									}),
									r(function () {
										X(A, ['mouseenter', 'mouseleave'], function (e) {
											var t = 'mouseenter' === e.type,
												n = r(e.currentTarget),
												o = r(e.relatedTarget || e.target),
												i = this.options;
											t
												? (this.focus(e), n.hasClass(P) && !n.hasClass(M) && clearTimeout(this.timers.hide))
												: 'mouse' === i.position.target &&
												  i.position.adjust.mouse &&
												  i.hide.event &&
												  i.show.target &&
												  !o.closest(i.show.target[0]).length &&
												  this.hide(e),
												n.toggleClass(N, t);
										}),
											X('[' + T + ']', C, J);
									}),
									(o = r.fn.qtip =
										function (e, t, i) {
											var a = ('' + e).toLowerCase(),
												s = d,
												l = r.makeArray(arguments).slice(1),
												f = l[l.length - 1],
												p = this[0] ? r.data(this[0], x) : d;
											return (!arguments.length && p) || 'api' === a
												? p
												: 'string' == typeof e
												? (this.each(function () {
														var e = r.data(this, x);
														if (!e) return u;
														if ((f && f.timeStamp && (e.cache.event = f), !t || ('option' !== a && 'options' !== a)))
															e[a] && e[a].apply(e, l);
														else {
															if (i === n && !r.isPlainObject(t)) return (s = e.get(t)), c;
															e.set(t, i);
														}
												  }),
												  s !== d ? s : this)
												: 'object' != typeof e && arguments.length
												? void 0
												: ((p = V(r.extend(u, {}, e))),
												  this.each(function (e) {
														var t, n;
														if (
															((n =
																!(n = r.isArray(p.id) ? p.id[e] : p.id) || n === c || n.length < 1 || o.api[n]
																	? o.nextid++
																	: n),
															(t = ee(r(this), n, p)) === c)
														)
															return u;
														(o.api[n] = t),
															r.each(k, function () {
																'initialize' === this.initialize && this(t);
															}),
															t._assignInitialEvents(f);
												  }));
										}),
									(r.qtip = U),
									(o.api = {}),
									r.each(
										{
											attr: function (e, t) {
												if (this.length) {
													var n = this[0],
														o = 'title',
														i = r.data(n, 'qtip');
													if (
														e === o &&
														i &&
														i.options &&
														'object' == typeof i &&
														'object' == typeof i.options &&
														i.options.suppress
													)
														return arguments.length < 2
															? r.attr(n, D)
															: (i && i.options.content.attr === o && i.cache.attr && i.set('content.text', t),
															  this.attr(D, t));
												}
												return r.fn['attr' + j].apply(this, arguments);
											},
											clone: function (e) {
												var t = r.fn['clone' + j].apply(this, arguments);
												return (
													e ||
														t
															.filter('[' + D + ']')
															.attr('title', function () {
																return r.attr(this, D);
															})
															.removeAttr(D),
													t
												);
											},
										},
										function (e, t) {
											if (!t || r.fn[e + j]) return u;
											var n = (r.fn[e + j] = r.fn[e]);
											r.fn[e] = function () {
												return t.apply(this, arguments) || n.apply(this, arguments);
											};
										}
									),
									r.ui ||
										((r['cleanData' + j] = r.cleanData),
										(r.cleanData = function (e) {
											for (var t, n = 0; (t = r(e[n])).length; n++)
												if (t.attr(E))
													try {
														t.triggerHandler('removeqtip');
													} catch (e) {}
											r['cleanData' + j].apply(this, arguments);
										})),
									(o.version = '3.0.3-5-g'),
									(o.nextid = 0),
									(o.inactiveEvents = C),
									(o.zindex = 15e3),
									(o.defaults = {
										prerender: c,
										id: c,
										overwrite: u,
										suppress: u,
										content: { text: u, attr: 'title', title: c, button: c },
										position: {
											my: 'top left',
											at: 'bottom right',
											target: c,
											container: c,
											viewport: c,
											adjust: { x: 0, y: 0, mouse: u, scroll: u, resize: u, method: 'flipinvert flipinvert' },
											effect: function (e, t) {
												r(this).animate(t, { duration: 200, queue: c });
											},
										},
										show: { target: c, event: 'mouseenter', effect: u, delay: 90, solo: c, ready: c, autofocus: c },
										hide: {
											target: c,
											event: 'mouseleave',
											effect: u,
											delay: 0,
											fixed: c,
											inactive: c,
											leave: 'window',
											distance: c,
										},
										style: { classes: '', widget: c, width: c, height: c, def: u },
										events: {
											render: d,
											move: d,
											show: d,
											hide: d,
											toggle: d,
											visible: d,
											hidden: d,
											focus: d,
											blur: d,
										},
									});
								var te,
									ne,
									re,
									oe,
									ie,
									ae = 'margin',
									se = 'border',
									le = 'color',
									ue = 'background-color',
									ce = 'transparent',
									de = ' !important',
									fe = !!t.createElement('canvas').getContext,
									pe = /rgba?\(0, 0, 0(, 0)?\)|transparent|#123456/i;
								function he(e) {
									return e.charAt(0).toUpperCase() + e.slice(1);
								}
								var me,
									ve = {},
									ge = ['Webkit', 'O', 'Moz', 'ms'];
								function ye(e, t) {
									var r,
										o,
										i = t.charAt(0).toUpperCase() + t.slice(1),
										a = (t + ' ' + ge.join(i + ' ') + i).split(' '),
										s = 0;
									if (ve[t]) return e.css(ve[t]);
									for (; (r = a[s++]); ) if ((o = e.css(r)) !== n) return (ve[t] = r), o;
								}
								function be(e, t) {
									return Math.ceil(parseFloat(ye(e, t)));
								}
								function _e(e, t) {
									(this._ns = 'tip'),
										(this.options = t),
										(this.offset = t.offset),
										(this.size = [t.width, t.height]),
										(this.qtip = e),
										this.init(e);
								}
								fe
									? ((oe = e.devicePixelRatio || 1),
									  (ie =
											(me = t.createElement('canvas').getContext('2d')).backingStorePixelRatio ||
											me.webkitBackingStorePixelRatio ||
											me.mozBackingStorePixelRatio ||
											me.msBackingStorePixelRatio ||
											me.oBackingStorePixelRatio ||
											1),
									  (re = oe / ie))
									: (ne = function (e, t, n) {
											return (
												'<qtipvml:' +
												e +
												' xmlns="urn:schemas-microsoft.com:vml" class="qtip-vml" ' +
												(t || '') +
												' style="behavior: url(#default#VML); ' +
												(n || '') +
												'" />'
											);
									  }),
									r.extend(_e.prototype, {
										init: function (e) {
											var t, n;
											(n = this.element = e.elements.tip = r('<div />', { class: x + '-tip' }).prependTo(e.tooltip)),
												fe
													? (((t = r('<canvas />').appendTo(this.element)[0].getContext('2d')).lineJoin = 'miter'),
													  (t.miterLimit = 1e5),
													  t.save())
													: ((t = ne('shape', 'coordorigin="0,0"', 'position:absolute;')),
													  this.element.html(t + t),
													  e._bind(
															r('*', n).add(n),
															['click', 'mousedown'],
															function (e) {
																e.stopPropagation();
															},
															this._ns
													  )),
												e._bind(e.tooltip, 'tooltipmove', this.reposition, this._ns, this),
												this.create();
										},
										_swapDimensions: function () {
											(this.size[0] = this.options.height), (this.size[1] = this.options.width);
										},
										_resetDimensions: function () {
											(this.size[0] = this.options.width), (this.size[1] = this.options.height);
										},
										_useTitle: function (e) {
											var t = this.qtip.elements.titlebar;
											return (
												t &&
												(e.y === v ||
													(e.y === _ &&
														this.element.position().top + this.size[1] / 2 + this.options.offset < t.outerHeight(u)))
											);
										},
										_parseCorner: function (e) {
											var t = this.qtip.options.position.my;
											return (
												e === c || t === c
													? (e = c)
													: e === u
													? (e = new a(t.string()))
													: e.string || ((e = new a(e)).fixed = u),
												e
											);
										},
										_parseWidth: function (e, t, n) {
											var r = this.qtip.elements,
												o = se + he(t) + 'Width';
											return (
												(n
													? be(n, o)
													: be(r.content, o) ||
													  be((this._useTitle(e) && r.titlebar) || r.content, o) ||
													  be(r.tooltip, o)) || 0
											);
										},
										_parseRadius: function (e) {
											var t = this.qtip.elements,
												n = se + he(e.y) + he(e.x) + 'Radius';
											return L.ie < 9
												? 0
												: be((this._useTitle(e) && t.titlebar) || t.content, n) || be(t.tooltip, n) || 0;
										},
										_invalidColour: function (e, t, n) {
											var r = e.css(t);
											return !r || (n && r === e.css(n)) || pe.test(r) ? c : r;
										},
										_parseColours: function (e) {
											var t = this.qtip.elements,
												n = this.element.css('cssText', ''),
												o = se + he(e[e.precedance]) + he(le),
												i = (this._useTitle(e) && t.titlebar) || t.content,
												a = this._invalidColour,
												s = [];
											return (
												(s[0] = a(n, ue) || a(i, ue) || a(t.content, ue) || a(t.tooltip, ue) || n.css(ue)),
												(s[1] =
													a(n, o, le) || a(i, o, le) || a(t.content, o, le) || a(t.tooltip, o, le) || t.tooltip.css(o)),
												r('*', n)
													.add(n)
													.css('cssText', ue + ':' + ce + de + ';' + se + ':0' + de + ';'),
												s
											);
										},
										_calculateSize: function (e) {
											var t,
												n,
												r = e.precedance === p,
												o = this.options.width,
												i = this.options.height,
												a = 'c' === e.abbrev(),
												s = (r ? o : i) * (a ? 0.5 : 1),
												l = Math.pow,
												u = Math.round,
												c = Math.sqrt(l(s, 2) + l(i, 2)),
												d = [(this.border / s) * c, (this.border / i) * c];
											return (
												(d[2] = Math.sqrt(l(d[0], 2) - l(this.border, 2))),
												(d[3] = Math.sqrt(l(d[1], 2) - l(this.border, 2))),
												(n = [u((t = (c + d[2] + d[3] + (a ? 0 : d[0])) / c) * o), u(t * i)]),
												r ? n : n.reverse()
											);
										},
										_calculateTip: function (e, t, n) {
											n = n || 1;
											var r = (t = t || this.size)[0] * n,
												o = t[1] * n,
												i = Math.ceil(r / 2),
												a = Math.ceil(o / 2),
												s = {
													br: [0, 0, r, o, r, 0],
													bl: [0, 0, r, 0, 0, o],
													tr: [0, o, r, 0, r, o],
													tl: [0, 0, 0, o, r, o],
													tc: [0, o, i, 0, r, o],
													bc: [0, 0, r, 0, i, o],
													rc: [0, 0, r, a, 0, o],
													lc: [r, 0, r, o, 0, a],
												};
											return (s.lt = s.br), (s.rt = s.bl), (s.lb = s.tr), (s.rb = s.tl), s[e.abbrev()];
										},
										_drawCoords: function (e, t) {
											e.beginPath(), e.moveTo(t[0], t[1]), e.lineTo(t[2], t[3]), e.lineTo(t[4], t[5]), e.closePath();
										},
										create: function () {
											var e = (this.corner = (fe || L.ie) && this._parseCorner(this.options.corner));
											return (
												(this.enabled = !!this.corner && 'c' !== this.corner.abbrev()),
												this.enabled && ((this.qtip.cache.corner = e.clone()), this.update()),
												this.element.toggle(this.enabled),
												this.corner
											);
										},
										update: function (t, n) {
											if (!this.enabled) return this;
											var o,
												i,
												s,
												l,
												d,
												w,
												O,
												k,
												x = this.qtip.elements,
												E = this.element,
												T = E.children(),
												S = this.options,
												A = this.size,
												C = S.mimic,
												P = Math.round;
											t || (t = this.qtip.cache.corner || this.corner),
												C === c
													? (C = t)
													: (((C = new a(C)).precedance = t.precedance),
													  'inherit' === C.x
															? (C.x = t.x)
															: 'inherit' === C.y
															? (C.y = t.y)
															: C.x === C.y && (C[t.precedance] = t[t.precedance])),
												(i = C.precedance),
												t.precedance === f ? this._swapDimensions() : this._resetDimensions(),
												(o = this.color = this._parseColours(t))[1] !== ce
													? ((k = this.border = this._parseWidth(t, t[t.precedance])),
													  S.border && k < 1 && !pe.test(o[1]) && (o[0] = o[1]),
													  (this.border = k = S.border !== u ? S.border : k))
													: (this.border = k = 0),
												(O = this.size = this._calculateSize(t)),
												E.css({ width: O[0], height: O[1], lineHeight: O[1] + 'px' }),
												(w =
													t.precedance === p
														? [
																P(C.x === g ? k : C.x === b ? O[0] - A[0] - k : (O[0] - A[0]) / 2),
																P(C.y === v ? O[1] - A[1] : 0),
														  ]
														: [
																P(C.x === g ? O[0] - A[0] : 0),
																P(C.y === v ? k : C.y === y ? O[1] - A[1] - k : (O[1] - A[1]) / 2),
														  ]),
												fe
													? ((s = T[0].getContext('2d')).restore(),
													  s.save(),
													  s.clearRect(0, 0, 6e3, 6e3),
													  (l = this._calculateTip(C, A, re)),
													  (d = this._calculateTip(C, this.size, re)),
													  T.attr(h, O[0] * re).attr(m, O[1] * re),
													  T.css(h, O[0]).css(m, O[1]),
													  this._drawCoords(s, d),
													  (s.fillStyle = o[1]),
													  s.fill(),
													  s.translate(w[0] * re, w[1] * re),
													  this._drawCoords(s, l),
													  (s.fillStyle = o[0]),
													  s.fill())
													: ((l =
															'm' +
															(l = this._calculateTip(C))[0] +
															',' +
															l[1] +
															' l' +
															l[2] +
															',' +
															l[3] +
															' ' +
															l[4] +
															',' +
															l[5] +
															' xe'),
													  (w[2] = k && /^(r|b)/i.test(t.string()) ? (8 === L.ie ? 2 : 1) : 0),
													  T.css({
															coordsize: O[0] + k + ' ' + O[1] + k,
															antialias: '' + (C.string().indexOf(_) > -1),
															left: w[0] - w[2] * Number(i === f),
															top: w[1] - w[2] * Number(i === p),
															width: O[0] + k,
															height: O[1] + k,
													  }).each(function (e) {
															var t = r(this);
															t[t.prop ? 'prop' : 'attr']({
																coordsize: O[0] + k + ' ' + O[1] + k,
																path: l,
																fillcolor: o[0],
																filled: !!e,
																stroked: !e,
															}).toggle(!(!k && !e)),
																!e &&
																	t.html(
																		ne(
																			'stroke',
																			'weight="' +
																				2 * k +
																				'px" color="' +
																				o[1] +
																				'" miterlimit="1000" joinstyle="miter"'
																		)
																	);
													  })),
												e.opera &&
													setTimeout(function () {
														x.tip.css({ display: 'inline-block', visibility: 'visible' });
													}, 1),
												n !== c && this.calculate(t, O);
										},
										calculate: function (e, t) {
											if (!this.enabled) return c;
											var n,
												o,
												i = this,
												a = this.qtip.elements,
												s = this.element,
												l = this.options.offset,
												u = {};
											return (
												(e = e || this.corner),
												(n = e.precedance),
												(t = t || this._calculateSize(e)),
												(o = [e.x, e.y]),
												n === f && o.reverse(),
												r.each(o, function (r, o) {
													var s, c, d;
													o === _
														? ((u[(s = n === p ? g : v)] = '50%'),
														  (u[ae + '-' + s] = -Math.round(t[n === p ? 0 : 1] / 2) + l))
														: ((s = i._parseWidth(e, o, a.tooltip)),
														  (c = i._parseWidth(e, o, a.content)),
														  (d = i._parseRadius(e)),
														  (u[o] = Math.max(-i.border, r ? c : l + (d > s ? d : -s))));
												}),
												(u[e[n]] -= t[n === f ? 0 : 1]),
												s.css({ margin: '', top: '', bottom: '', left: '', right: '' }).css(u),
												u
											);
										},
										reposition: function (e, t, r) {
											if (this.enabled) {
												var o,
													i,
													a = t.cache,
													s = this.corner.clone(),
													l = r.adjusted,
													d = t.options.position.adjust.method.split(' '),
													h = d[0],
													m = d[1] || d[0],
													w = { left: c, top: c, x: 0, y: 0 },
													k = {};
												this.corner.fixed !== u &&
													(x(h, f, p, g, b),
													x(m, p, f, v, y),
													(s.string() === a.corner.string() && a.cornerTop === l.top && a.cornerLeft === l.left) ||
														this.update(s, c)),
													(o = this.calculate(s)).right !== n && (o.left = -o.right),
													o.bottom !== n && (o.top = -o.bottom),
													(o.user = this.offset),
													(w.left = h === O && !!l.left),
													w.left && E(f, g, b),
													(w.top = m === O && !!l.top),
													w.top && E(p, v, y),
													this.element.css(k).toggle(!((w.x && w.y) || (s.x === _ && w.y) || (s.y === _ && w.x))),
													(r.left -= o.left.charAt
														? o.user
														: h !== O || w.top || (!w.left && !w.top)
														? o.left + this.border
														: 0),
													(r.top -= o.top.charAt
														? o.user
														: m !== O || w.left || (!w.left && !w.top)
														? o.top + this.border
														: 0),
													(a.cornerLeft = l.left),
													(a.cornerTop = l.top),
													(a.corner = s.clone());
											}
											function x(e, t, n, r, o) {
												e === O && s.precedance === t && l[r] && s[n] !== _
													? (s.precedance = s.precedance === f ? p : f)
													: e !== O && l[r] && (s[t] = s[t] === _ ? (l[r] > 0 ? r : o) : s[t] === r ? o : r);
											}
											function E(e, t, a) {
												s[e] === _
													? (k[ae + '-' + t] = w[e] = o[ae + '-' + t] - l[t])
													: ((i = o[a] !== n ? [l[t], -o[t]] : [-l[t], o[t]]),
													  (w[e] = Math.max(i[0], i[1])) > i[0] && ((r[t] -= l[t]), (w[t] = c)),
													  (k[o[a] !== n ? a : t] = w[e]));
											}
										},
										destroy: function () {
											this.qtip._unbind(this.qtip.tooltip, this._ns),
												this.qtip.elements.tip && this.qtip.elements.tip.find('*').remove().end().remove();
										},
									}),
									((te = k.tip =
										function (e) {
											return new _e(e, e.options.style.tip);
										}).initialize = 'render'),
									(te.sanitize = function (e) {
										if (e.style && 'tip' in e.style) {
											var t = e.style.tip;
											'object' != typeof t && (t = e.style.tip = { corner: t }),
												/string|boolean/i.test(typeof t.corner) || (t.corner = u);
										}
									}),
									(s.tip = {
										'^position.my|style.tip.(corner|mimic|border)$': function () {
											this.create(), this.qtip.reposition();
										},
										'^style.tip.(height|width)$': function (e) {
											(this.size = [e.width, e.height]), this.update(), this.qtip.reposition();
										},
										'^content.title|style.(classes|widget)$': function () {
											this.update();
										},
									}),
									r.extend(u, o.defaults, {
										style: { tip: { corner: u, mimic: c, width: 6, height: 6, border: u, offset: 0 } },
									});
								var we,
									Oe,
									ke = 'qtip-modal',
									xe = '.' + ke;
								function Ee(e, t) {
									(this.options = t), (this._ns = '-modal'), (this.qtip = e), this.init(e);
								}
								(Oe = new (Oe = function () {
									var e,
										n,
										o,
										i = this,
										a = {};
									function s(e) {
										if (r.expr[':'].focusable) return r.expr[':'].focusable;
										var t,
											n,
											o,
											i = !isNaN(r.attr(e, 'tabindex')),
											a = e.nodeName && e.nodeName.toLowerCase();
										return 'area' === a
											? ((n = (t = e.parentNode).name),
											  !(!e.href || !n || 'map' !== t.nodeName.toLowerCase()) &&
													!!(o = r('img[usemap=#' + n + ']')[0]) &&
													o.is(':visible'))
											: /input|select|textarea|button|object/.test(a)
											? !e.disabled
											: ('a' === a && e.href) || i;
									}
									function l(e) {
										a.length < 1 && e.length ? e.not('body').blur() : a.first().focus();
									}
									function f(t) {
										if (o.is(':visible')) {
											var n = r(t.target),
												i = e.tooltip,
												a = n.closest(A);
											(a.length < 1 ? c : parseInt(a[0].style.zIndex, 10) > parseInt(i[0].style.zIndex, 10)) ||
												n.closest(A)[0] === i[0] ||
												l(n);
										}
									}
									r.extend(i, {
										init: function () {
											return (
												(o = i.elem =
													r('<div />', {
														id: 'qtip-overlay',
														html: '<div></div>',
														mousedown: function () {
															return c;
														},
													}).hide()),
												r(t.body).bind('focusin' + xe, f),
												r(t).bind('keydown' + xe, function (t) {
													e && e.options.show.modal.escape && 27 === t.keyCode && e.hide(t);
												}),
												o.bind('click' + xe, function (t) {
													e && e.options.show.modal.blur && e.hide(t);
												}),
												i
											);
										},
										update: function (t) {
											(e = t),
												(a =
													t.options.show.modal.stealfocus !== c
														? t.tooltip.find('*').filter(function () {
																return s(this);
														  })
														: []);
										},
										toggle: function (a, s, f) {
											var p = a.tooltip,
												h = a.options.show.modal,
												m = h.effect,
												v = s ? 'show' : 'hide',
												g = o.is(':visible'),
												y = r(xe).filter(':visible:not(:animated)').not(p);
											return (
												i.update(a),
												s && h.stealfocus !== c && l(r(':focus')),
												o.toggleClass('blurs', h.blur),
												s && o.appendTo(t.body),
												(o.is(':animated') && g === s && n !== c) ||
													(!s && y.length) ||
													(o.stop(u, c),
													r.isFunction(m)
														? m.call(o, s)
														: m === c
														? o[v]()
														: o.fadeTo(parseInt(f, 10) || 90, s ? 1 : 0, function () {
																s || o.hide();
														  }),
													s ||
														o.queue(function (e) {
															o.css({ left: '', top: '' }), r(xe).length || o.detach(), e();
														}),
													(n = s),
													e.destroyed && (e = d)),
												i
											);
										},
									}),
										i.init();
								})()),
									r.extend(Ee.prototype, {
										init: function (e) {
											var t = e.tooltip;
											if (!this.options.on) return this;
											(e.elements.overlay = Oe.elem),
												t.addClass(ke).css('z-index', o.modal_zindex + r(xe).length),
												e._bind(
													t,
													['tooltipshow', 'tooltiphide'],
													function (e, n, o) {
														var i = e.originalEvent;
														if (e.target === t[0])
															if (
																i &&
																'tooltiphide' === e.type &&
																/mouse(leave|enter)/.test(i.type) &&
																r(i.relatedTarget).closest(Oe.elem[0]).length
															)
																try {
																	e.preventDefault();
																} catch (e) {}
															else
																(!i || (i && 'tooltipsolo' !== i.type)) && this.toggle(e, 'tooltipshow' === e.type, o);
													},
													this._ns,
													this
												),
												e._bind(
													t,
													'tooltipfocus',
													function (e, n) {
														if (!e.isDefaultPrevented() && e.target === t[0]) {
															var i = r(xe),
																a = o.modal_zindex + i.length,
																s = parseInt(t[0].style.zIndex, 10);
															(Oe.elem[0].style.zIndex = a - 1),
																i.each(function () {
																	this.style.zIndex > s && (this.style.zIndex -= 1);
																}),
																i.filter('.' + I).qtip('blur', e.originalEvent),
																(t.addClass(I)[0].style.zIndex = a),
																Oe.update(n);
															try {
																e.preventDefault();
															} catch (e) {}
														}
													},
													this._ns,
													this
												),
												e._bind(
													t,
													'tooltiphide',
													function (e) {
														e.target === t[0] && r(xe).filter(':visible').not(t).last().qtip('focus', e);
													},
													this._ns,
													this
												);
										},
										toggle: function (e, t, n) {
											if (e && e.isDefaultPrevented()) return this;
											Oe.toggle(this.qtip, !!t, n);
										},
										destroy: function () {
											this.qtip.tooltip.removeClass(ke),
												this.qtip._unbind(this.qtip.tooltip, this._ns),
												Oe.toggle(this.qtip, c),
												delete this.qtip.elements.overlay;
										},
									}),
									((we = k.modal =
										function (e) {
											return new Ee(e, e.options.show.modal);
										}).sanitize = function (e) {
										e.show &&
											('object' != typeof e.show.modal
												? (e.show.modal = { on: !!e.show.modal })
												: void 0 === e.show.modal.on && (e.show.modal.on = u));
									}),
									(o.modal_zindex = o.zindex - 200),
									(we.initialize = 'render'),
									(s.modal = {
										'^show.modal.(on|blur)$': function () {
											this.destroy(), this.init(), this.qtip.elems.overlay.toggle(this.qtip.tooltip[0].offsetWidth > 0);
										},
									}),
									r.extend(u, o.defaults, { show: { modal: { on: c, effect: u, blur: u, stealfocus: u, escape: u } } }),
									(k.viewport = function (n, r, o, i, a, s, l) {
										var u,
											d,
											k,
											x,
											E,
											T,
											S,
											A,
											C = o.target,
											P = n.elements.tooltip,
											R = o.my,
											I = o.at,
											N = o.adjust,
											M = N.method.split(' '),
											j = M[0],
											D = M[1] || M[0],
											L = o.viewport,
											U = o.container,
											F = { left: 0, top: 0 };
										if (!L.jquery || C[0] === e || C[0] === t.body || 'none' === N.method) return F;
										function B(e, t, n, o, i, a, s, l, u) {
											var c = r[i],
												f = R[e],
												p = I[e],
												m = n === O,
												v = f === i ? u : f === a ? -u : -u / 2,
												g = p === i ? l : p === a ? -l : -l / 2,
												y = S[i] + A[i] - (x ? 0 : k[i]),
												b = y - c,
												C = c + u - (s === h ? E : T) - y,
												P = v - (R.precedance === e || f === R[t] ? g : 0) - (p === _ ? l / 2 : 0);
											return (
												m
													? ((P = (f === i ? 1 : -1) * v),
													  (r[i] += b > 0 ? b : C > 0 ? -C : 0),
													  (r[i] = Math.max(
															-k[i] + A[i],
															c - P,
															Math.min(
																Math.max(-k[i] + A[i] + (s === h ? E : T), c + P),
																r[i],
																'center' === f ? c - v : 1e9
															)
													  )))
													: ((o *= n === w ? 2 : 0),
													  b > 0 && (f !== i || C > 0)
															? ((r[i] -= P + o), d.invert(e, i))
															: C > 0 && (f !== a || b > 0) && ((r[i] -= (f === _ ? -P : P) + o), d.invert(e, a)),
													  r[i] < S[i] && -r[i] > C && ((r[i] = c), (d = R.clone()))),
												r[i] - c
											);
										}
										return (
											(k = U.offset() || F),
											(x = 'static' === U.css('position')),
											(u = 'fixed' === P.css('position')),
											(E = L[0] === e ? L.width() : L.outerWidth(c)),
											(T = L[0] === e ? L.height() : L.outerHeight(c)),
											(S = { left: u ? 0 : L.scrollLeft(), top: u ? 0 : L.scrollTop() }),
											(A = L.offset() || F),
											('shift' === j && 'shift' === D) || (d = R.clone()),
											(F = {
												left: 'none' !== j ? B(f, p, j, N.x, g, b, h, i, s) : 0,
												top: 'none' !== D ? B(p, f, D, N.y, v, y, m, a, l) : 0,
												my: d,
											})
										);
									}),
									(k.polys = {
										polygon: function (e, t) {
											var n,
												r,
												o,
												i = {
													width: 0,
													height: 0,
													position: { top: 1e10, right: 0, bottom: 0, left: 1e10 },
													adjustable: c,
												},
												a = 0,
												s = [],
												l = 1,
												u = 1,
												d = 0,
												f = 0;
											for (a = e.length; a--; )
												(n = [parseInt(e[--a], 10), parseInt(e[a + 1], 10)])[0] > i.position.right &&
													(i.position.right = n[0]),
													n[0] < i.position.left && (i.position.left = n[0]),
													n[1] > i.position.bottom && (i.position.bottom = n[1]),
													n[1] < i.position.top && (i.position.top = n[1]),
													s.push(n);
											if (
												((r = i.width = Math.abs(i.position.right - i.position.left)),
												(o = i.height = Math.abs(i.position.bottom - i.position.top)),
												'c' === t.abbrev())
											)
												i.position = { left: i.position.left + i.width / 2, top: i.position.top + i.height / 2 };
											else {
												for (; r > 0 && o > 0 && l > 0 && u > 0; )
													for (
														r = Math.floor(r / 2),
															o = Math.floor(o / 2),
															t.x === g ? (l = r) : t.x === b ? (l = i.width - r) : (l += Math.floor(r / 2)),
															t.y === v ? (u = o) : t.y === y ? (u = i.height - o) : (u += Math.floor(o / 2)),
															a = s.length;
														a-- && !(s.length < 2);

													)
														(d = s[a][0] - i.position.left),
															(f = s[a][1] - i.position.top),
															((t.x === g && d >= l) ||
																(t.x === b && d <= l) ||
																(t.x === _ && (d < l || d > i.width - l)) ||
																(t.y === v && f >= u) ||
																(t.y === y && f <= u) ||
																(t.y === _ && (f < u || f > i.height - u))) &&
																s.splice(a, 1);
												i.position = { left: s[0][0], top: s[0][1] };
											}
											return i;
										},
										rect: function (e, t, n, r) {
											return {
												width: Math.abs(n - e),
												height: Math.abs(r - t),
												position: { left: Math.min(e, n), top: Math.min(t, r) },
											};
										},
										_angles: { tc: 1.5, tr: 7 / 4, tl: 5 / 4, bc: 0.5, br: 1 / 4, bl: 3 / 4, rc: 2, lc: 1, c: 0 },
										ellipse: function (e, t, n, r, o) {
											var i = k.polys._angles[o.abbrev()],
												a = 0 === i ? 0 : n * Math.cos(i * Math.PI),
												s = r * Math.sin(i * Math.PI);
											return {
												width: 2 * n - Math.abs(a),
												height: 2 * r - Math.abs(s),
												position: { left: e + a, top: t + s },
												adjustable: c,
											};
										},
										circle: function (e, t, n, r) {
											return k.polys.ellipse(e, t, n, n, r);
										},
									}),
									(k.svg = function (e, n, o) {
										for (
											var i,
												a,
												s,
												l,
												u,
												d,
												f,
												p,
												h,
												m = n[0],
												v = r(m.ownerSVGElement),
												g = m.ownerDocument,
												y = (parseInt(n.css('stroke-width'), 10) || 0) / 2;
											!m.getBBox;

										)
											m = m.parentNode;
										if (!m.getBBox || !m.parentNode) return c;
										switch (m.nodeName) {
											case 'ellipse':
											case 'circle':
												p = k.polys.ellipse(
													m.cx.baseVal.value,
													m.cy.baseVal.value,
													(m.rx || m.r).baseVal.value + y,
													(m.ry || m.r).baseVal.value + y,
													o
												);
												break;
											case 'line':
											case 'polygon':
											case 'polyline':
												for (
													p = [],
														d = -1,
														l =
															(f = m.points || [
																{ x: m.x1.baseVal.value, y: m.y1.baseVal.value },
																{ x: m.x2.baseVal.value, y: m.y2.baseVal.value },
															]).numberOfItems || f.length;
													++d < l;

												)
													(u = f.getItem ? f.getItem(d) : f[d]), p.push.apply(p, [u.x, u.y]);
												p = k.polys.polygon(p, o);
												break;
											default:
												p = { width: (p = m.getBBox()).width, height: p.height, position: { left: p.x, top: p.y } };
										}
										return (
											(h = p.position),
											(v = v[0]).createSVGPoint &&
												((a = m.getScreenCTM()),
												((f = v.createSVGPoint()).x = h.left),
												(f.y = h.top),
												(s = f.matrixTransform(a)),
												(h.left = s.x),
												(h.top = s.y)),
											g !== t &&
												'mouse' !== e.position.target &&
												(i = r((g.defaultView || g.parentWindow).frameElement).offset()) &&
												((h.left += i.left), (h.top += i.top)),
											(g = r(g)),
											(h.left += g.scrollLeft()),
											(h.top += g.scrollTop()),
											p
										);
									}),
									(k.imagemap = function (e, t, n) {
										t.jquery || (t = r(t));
										var o,
											i,
											a,
											s,
											l,
											u = (t.attr('shape') || 'rect').toLowerCase().replace('poly', 'polygon'),
											d = r('img[usemap="#' + t.parent('map').attr('name') + '"]'),
											f = r.trim(t.attr('coords')).replace(/,$/, '').split(',');
										if (!d.length) return c;
										if ('polygon' === u) s = k.polys.polygon(f, n);
										else {
											if (!k.polys[u]) return c;
											for (a = -1, l = f.length, i = []; ++a < l; ) i.push(parseInt(f[a], 10));
											s = k.polys[u].apply(this, i.concat(n));
										}
										return (
											((o = d.offset()).left += Math.ceil((d.outerWidth(c) - d.width()) / 2)),
											(o.top += Math.ceil((d.outerHeight(c) - d.height()) / 2)),
											(s.position.left += o.left),
											(s.position.top += o.top),
											s
										);
									});
								var Te =
									'<iframe class="qtip-bgiframe" frameborder="0" tabindex="-1" src="javascript:\'\';"  style="display:block; position:absolute; z-index:-1; filter:alpha(opacity=0); -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";"></iframe>';
								function Se(e) {
									(this._ns = 'ie6'), (this.qtip = e), this.init(e);
								}
								r.extend(Se.prototype, {
									_scroll: function () {
										var t = this.qtip.elements.overlay;
										t && (t[0].style.top = r(e).scrollTop() + 'px');
									},
									init: function (n) {
										var o = n.tooltip;
										r('select, object').length < 1 &&
											((this.bgiframe = n.elements.bgiframe = r(Te).appendTo(o)),
											n._bind(o, 'tooltipmove', this.adjustBGIFrame, this._ns, this)),
											(this.redrawContainer = r('<div/>', { id: x + '-rcontainer' }).appendTo(t.body)),
											n.elements.overlay &&
												n.elements.overlay.addClass('qtipmodal-ie6fix') &&
												(n._bind(e, ['scroll', 'resize'], this._scroll, this._ns, this),
												n._bind(o, ['tooltipshow'], this._scroll, this._ns, this)),
											this.redraw();
									},
									adjustBGIFrame: function () {
										var e,
											t,
											n = this.qtip.tooltip,
											r = { height: n.outerHeight(c), width: n.outerWidth(c) },
											o = this.qtip.plugins.tip,
											i = this.qtip.elements.tip;
										(t = { left: -(t = parseInt(n.css('borderLeftWidth'), 10) || 0), top: -t }),
											o && i && (t[(e = 'x' === o.corner.precedance ? [h, g] : [m, v])[1]] -= i[e[0]]()),
											this.bgiframe.css(t).css(r);
									},
									redraw: function () {
										if (this.qtip.rendered < 1 || this.drawing) return this;
										var e,
											t,
											n,
											r,
											o = this.qtip.tooltip,
											i = this.qtip.options.style,
											a = this.qtip.options.position.container;
										return (
											(this.qtip.drawing = 1),
											i.height && o.css(m, i.height),
											i.width
												? o.css(h, i.width)
												: (o.css(h, '').appendTo(this.redrawContainer),
												  (t = o.width()) % 2 < 1 && (t += 1),
												  (e =
														((n = o.css('maxWidth') || '') + (r = o.css('minWidth') || '')).indexOf('%') > -1
															? a.width() / 100
															: 0),
												  (t =
														(n = (n.indexOf('%') > -1 ? e : 1 * parseInt(n, 10)) || t) +
														(r = (r.indexOf('%') > -1 ? e : 1 * parseInt(r, 10)) || 0)
															? Math.min(Math.max(t, r), n)
															: t),
												  o.css(h, Math.round(t)).appendTo(a)),
											(this.drawing = 0),
											this
										);
									},
									destroy: function () {
										this.bgiframe && this.bgiframe.remove(), this.qtip._unbind([e, this.qtip.tooltip], this._ns);
									},
								}),
									((k.ie6 = function (e) {
										return 6 === L.ie ? new Se(e) : c;
									}).initialize = 'render'),
									(s.ie6 = {
										'^content|style$': function () {
											this.redraw();
										},
									});
							})(o());
					})(window, document);
				},
				48915: function (e) {
					(e.exports = function (e, t) {
						(null == t || t > e.length) && (t = e.length);
						for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
						return r;
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				73783: function (e) {
					(e.exports = function (e) {
						if (Array.isArray(e)) return e;
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				4233: function (e, t, n) {
					var r = n(48915);
					(e.exports = function (e) {
						if (Array.isArray(e)) return r(e);
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				77111: function (e) {
					(e.exports = function (e) {
						if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
						return e;
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				31049: function (e) {
					function t(e, t, n, r, o, i, a) {
						try {
							var s = e[i](a),
								l = s.value;
						} catch (e) {
							return void n(e);
						}
						s.done ? t(l) : Promise.resolve(l).then(r, o);
					}
					(e.exports = function (e) {
						return function () {
							var n = this,
								r = arguments;
							return new Promise(function (o, i) {
								var a = e.apply(n, r);
								function s(e) {
									t(a, o, i, s, l, 'next', e);
								}
								function l(e) {
									t(a, o, i, s, l, 'throw', e);
								}
								s(void 0);
							});
						};
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				39131: function (e) {
					(e.exports = function (e, t) {
						if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function');
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				54562: function (e, t, n) {
					var r = n(85344),
						o = n(80594);
					function i(t, n, a) {
						return (
							o()
								? ((e.exports = i = Reflect.construct.bind()),
								  (e.exports.__esModule = !0),
								  (e.exports.default = e.exports))
								: ((e.exports = i =
										function (e, t, n) {
											var o = [null];
											o.push.apply(o, t);
											var i = new (Function.bind.apply(e, o))();
											return n && r(i, n.prototype), i;
										}),
								  (e.exports.__esModule = !0),
								  (e.exports.default = e.exports)),
							i.apply(null, arguments)
						);
					}
					(e.exports = i), (e.exports.__esModule = !0), (e.exports.default = e.exports);
				},
				78463: function (e, t, n) {
					var r = n(84676);
					function o(e, t) {
						for (var n = 0; n < t.length; n++) {
							var o = t[n];
							(o.enumerable = o.enumerable || !1),
								(o.configurable = !0),
								'value' in o && (o.writable = !0),
								Object.defineProperty(e, r(o.key), o);
						}
					}
					(e.exports = function (e, t, n) {
						return t && o(e.prototype, t), n && o(e, n), Object.defineProperty(e, 'prototype', { writable: !1 }), e;
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				15985: function (e, t, n) {
					var r = n(84676);
					(e.exports = function (e, t, n) {
						return (
							(t = r(t)) in e
								? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 })
								: (e[t] = n),
							e
						);
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				2132: function (e) {
					function t(n) {
						return (
							(e.exports = t =
								Object.setPrototypeOf
									? Object.getPrototypeOf.bind()
									: function (e) {
											return e.__proto__ || Object.getPrototypeOf(e);
									  }),
							(e.exports.__esModule = !0),
							(e.exports.default = e.exports),
							t(n)
						);
					}
					(e.exports = t), (e.exports.__esModule = !0), (e.exports.default = e.exports);
				},
				35075: function (e, t, n) {
					var r = n(85344);
					(e.exports = function (e, t) {
						if ('function' != typeof t && null !== t)
							throw new TypeError('Super expression must either be null or a function');
						(e.prototype = Object.create(t && t.prototype, {
							constructor: { value: e, writable: !0, configurable: !0 },
						})),
							Object.defineProperty(e, 'prototype', { writable: !1 }),
							t && r(e, t);
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				1654: function (e) {
					(e.exports = function (e) {
						return e && e.__esModule ? e : { default: e };
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				1412: function (e) {
					(e.exports = function (e) {
						return -1 !== Function.toString.call(e).indexOf('[native code]');
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				80594: function (e) {
					(e.exports = function () {
						if ('undefined' == typeof Reflect || !Reflect.construct) return !1;
						if (Reflect.construct.sham) return !1;
						if ('function' == typeof Proxy) return !0;
						try {
							return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
						} catch (e) {
							return !1;
						}
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				26135: function (e) {
					(e.exports = function (e) {
						if (('undefined' != typeof Symbol && null != e[Symbol.iterator]) || null != e['@@iterator'])
							return Array.from(e);
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				96448: function (e) {
					(e.exports = function (e, t) {
						var n = null == e ? null : ('undefined' != typeof Symbol && e[Symbol.iterator]) || e['@@iterator'];
						if (null != n) {
							var r,
								o,
								i,
								a,
								s = [],
								l = !0,
								u = !1;
							try {
								if (((i = (n = n.call(e)).next), 0 === t)) {
									if (Object(n) !== n) return;
									l = !1;
								} else for (; !(l = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); l = !0);
							} catch (e) {
								(u = !0), (o = e);
							} finally {
								try {
									if (!l && null != n.return && ((a = n.return()), Object(a) !== a)) return;
								} finally {
									if (u) throw o;
								}
							}
							return s;
						}
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				99340: function (e) {
					(e.exports = function () {
						throw new TypeError(
							'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
						);
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				32449: function (e) {
					(e.exports = function () {
						throw new TypeError(
							'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
						);
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				35432: function (e, t, n) {
					var r = n(12990).default,
						o = n(77111);
					(e.exports = function (e, t) {
						if (t && ('object' === r(t) || 'function' == typeof t)) return t;
						if (void 0 !== t) throw new TypeError('Derived constructors may only return object or undefined');
						return o(e);
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				58541: function (e, t, n) {
					var r = n(12990).default;
					function o() {
						'use strict';
						/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ (e.exports =
							o =
								function () {
									return t;
								}),
							(e.exports.__esModule = !0),
							(e.exports.default = e.exports);
						var t = {},
							n = Object.prototype,
							i = n.hasOwnProperty,
							a =
								Object.defineProperty ||
								function (e, t, n) {
									e[t] = n.value;
								},
							s = 'function' == typeof Symbol ? Symbol : {},
							l = s.iterator || '@@iterator',
							u = s.asyncIterator || '@@asyncIterator',
							c = s.toStringTag || '@@toStringTag';
						function d(e, t, n) {
							return Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }), e[t];
						}
						try {
							d({}, '');
						} catch (e) {
							d = function (e, t, n) {
								return (e[t] = n);
							};
						}
						function f(e, t, n, r) {
							var o = t && t.prototype instanceof m ? t : m,
								i = Object.create(o.prototype),
								s = new A(r || []);
							return a(i, '_invoke', { value: x(e, n, s) }), i;
						}
						function p(e, t, n) {
							try {
								return { type: 'normal', arg: e.call(t, n) };
							} catch (e) {
								return { type: 'throw', arg: e };
							}
						}
						t.wrap = f;
						var h = {};
						function m() {}
						function v() {}
						function g() {}
						var y = {};
						d(y, l, function () {
							return this;
						});
						var b = Object.getPrototypeOf,
							_ = b && b(b(C([])));
						_ && _ !== n && i.call(_, l) && (y = _);
						var w = (g.prototype = m.prototype = Object.create(y));
						function O(e) {
							['next', 'throw', 'return'].forEach(function (t) {
								d(e, t, function (e) {
									return this._invoke(t, e);
								});
							});
						}
						function k(e, t) {
							function n(o, a, s, l) {
								var u = p(e[o], e, a);
								if ('throw' !== u.type) {
									var c = u.arg,
										d = c.value;
									return d && 'object' == r(d) && i.call(d, '__await')
										? t.resolve(d.__await).then(
												function (e) {
													n('next', e, s, l);
												},
												function (e) {
													n('throw', e, s, l);
												}
										  )
										: t.resolve(d).then(
												function (e) {
													(c.value = e), s(c);
												},
												function (e) {
													return n('throw', e, s, l);
												}
										  );
								}
								l(u.arg);
							}
							var o;
							a(this, '_invoke', {
								value: function (e, r) {
									function i() {
										return new t(function (t, o) {
											n(e, r, t, o);
										});
									}
									return (o = o ? o.then(i, i) : i());
								},
							});
						}
						function x(e, t, n) {
							var r = 'suspendedStart';
							return function (o, i) {
								if ('executing' === r) throw new Error('Generator is already running');
								if ('completed' === r) {
									if ('throw' === o) throw i;
									return P();
								}
								for (n.method = o, n.arg = i; ; ) {
									var a = n.delegate;
									if (a) {
										var s = E(a, n);
										if (s) {
											if (s === h) continue;
											return s;
										}
									}
									if ('next' === n.method) n.sent = n._sent = n.arg;
									else if ('throw' === n.method) {
										if ('suspendedStart' === r) throw ((r = 'completed'), n.arg);
										n.dispatchException(n.arg);
									} else 'return' === n.method && n.abrupt('return', n.arg);
									r = 'executing';
									var l = p(e, t, n);
									if ('normal' === l.type) {
										if (((r = n.done ? 'completed' : 'suspendedYield'), l.arg === h)) continue;
										return { value: l.arg, done: n.done };
									}
									'throw' === l.type && ((r = 'completed'), (n.method = 'throw'), (n.arg = l.arg));
								}
							};
						}
						function E(e, t) {
							var n = t.method,
								r = e.iterator[n];
							if (void 0 === r)
								return (
									(t.delegate = null),
									('throw' === n &&
										e.iterator.return &&
										((t.method = 'return'), (t.arg = void 0), E(e, t), 'throw' === t.method)) ||
										('return' !== n &&
											((t.method = 'throw'),
											(t.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
									h
								);
							var o = p(r, e.iterator, t.arg);
							if ('throw' === o.type) return (t.method = 'throw'), (t.arg = o.arg), (t.delegate = null), h;
							var i = o.arg;
							return i
								? i.done
									? ((t[e.resultName] = i.value),
									  (t.next = e.nextLoc),
									  'return' !== t.method && ((t.method = 'next'), (t.arg = void 0)),
									  (t.delegate = null),
									  h)
									: i
								: ((t.method = 'throw'),
								  (t.arg = new TypeError('iterator result is not an object')),
								  (t.delegate = null),
								  h);
						}
						function T(e) {
							var t = { tryLoc: e[0] };
							1 in e && (t.catchLoc = e[1]),
								2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
								this.tryEntries.push(t);
						}
						function S(e) {
							var t = e.completion || {};
							(t.type = 'normal'), delete t.arg, (e.completion = t);
						}
						function A(e) {
							(this.tryEntries = [{ tryLoc: 'root' }]), e.forEach(T, this), this.reset(!0);
						}
						function C(e) {
							if (e) {
								var t = e[l];
								if (t) return t.call(e);
								if ('function' == typeof e.next) return e;
								if (!isNaN(e.length)) {
									var n = -1,
										r = function t() {
											for (; ++n < e.length; ) if (i.call(e, n)) return (t.value = e[n]), (t.done = !1), t;
											return (t.value = void 0), (t.done = !0), t;
										};
									return (r.next = r);
								}
							}
							return { next: P };
						}
						function P() {
							return { value: void 0, done: !0 };
						}
						return (
							(v.prototype = g),
							a(w, 'constructor', { value: g, configurable: !0 }),
							a(g, 'constructor', { value: v, configurable: !0 }),
							(v.displayName = d(g, c, 'GeneratorFunction')),
							(t.isGeneratorFunction = function (e) {
								var t = 'function' == typeof e && e.constructor;
								return !!t && (t === v || 'GeneratorFunction' === (t.displayName || t.name));
							}),
							(t.mark = function (e) {
								return (
									Object.setPrototypeOf
										? Object.setPrototypeOf(e, g)
										: ((e.__proto__ = g), d(e, c, 'GeneratorFunction')),
									(e.prototype = Object.create(w)),
									e
								);
							}),
							(t.awrap = function (e) {
								return { __await: e };
							}),
							O(k.prototype),
							d(k.prototype, u, function () {
								return this;
							}),
							(t.AsyncIterator = k),
							(t.async = function (e, n, r, o, i) {
								void 0 === i && (i = Promise);
								var a = new k(f(e, n, r, o), i);
								return t.isGeneratorFunction(n)
									? a
									: a.next().then(function (e) {
											return e.done ? e.value : a.next();
									  });
							}),
							O(w),
							d(w, c, 'Generator'),
							d(w, l, function () {
								return this;
							}),
							d(w, 'toString', function () {
								return '[object Generator]';
							}),
							(t.keys = function (e) {
								var t = Object(e),
									n = [];
								for (var r in t) n.push(r);
								return (
									n.reverse(),
									function e() {
										for (; n.length; ) {
											var r = n.pop();
											if (r in t) return (e.value = r), (e.done = !1), e;
										}
										return (e.done = !0), e;
									}
								);
							}),
							(t.values = C),
							(A.prototype = {
								constructor: A,
								reset: function (e) {
									if (
										((this.prev = 0),
										(this.next = 0),
										(this.sent = this._sent = void 0),
										(this.done = !1),
										(this.delegate = null),
										(this.method = 'next'),
										(this.arg = void 0),
										this.tryEntries.forEach(S),
										!e)
									)
										for (var t in this)
											't' === t.charAt(0) && i.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
								},
								stop: function () {
									this.done = !0;
									var e = this.tryEntries[0].completion;
									if ('throw' === e.type) throw e.arg;
									return this.rval;
								},
								dispatchException: function (e) {
									if (this.done) throw e;
									var t = this;
									function n(n, r) {
										return (
											(a.type = 'throw'), (a.arg = e), (t.next = n), r && ((t.method = 'next'), (t.arg = void 0)), !!r
										);
									}
									for (var r = this.tryEntries.length - 1; r >= 0; --r) {
										var o = this.tryEntries[r],
											a = o.completion;
										if ('root' === o.tryLoc) return n('end');
										if (o.tryLoc <= this.prev) {
											var s = i.call(o, 'catchLoc'),
												l = i.call(o, 'finallyLoc');
											if (s && l) {
												if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
												if (this.prev < o.finallyLoc) return n(o.finallyLoc);
											} else if (s) {
												if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
											} else {
												if (!l) throw new Error('try statement without catch or finally');
												if (this.prev < o.finallyLoc) return n(o.finallyLoc);
											}
										}
									}
								},
								abrupt: function (e, t) {
									for (var n = this.tryEntries.length - 1; n >= 0; --n) {
										var r = this.tryEntries[n];
										if (r.tryLoc <= this.prev && i.call(r, 'finallyLoc') && this.prev < r.finallyLoc) {
											var o = r;
											break;
										}
									}
									o && ('break' === e || 'continue' === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
									var a = o ? o.completion : {};
									return (
										(a.type = e),
										(a.arg = t),
										o ? ((this.method = 'next'), (this.next = o.finallyLoc), h) : this.complete(a)
									);
								},
								complete: function (e, t) {
									if ('throw' === e.type) throw e.arg;
									return (
										'break' === e.type || 'continue' === e.type
											? (this.next = e.arg)
											: 'return' === e.type
											? ((this.rval = this.arg = e.arg), (this.method = 'return'), (this.next = 'end'))
											: 'normal' === e.type && t && (this.next = t),
										h
									);
								},
								finish: function (e) {
									for (var t = this.tryEntries.length - 1; t >= 0; --t) {
										var n = this.tryEntries[t];
										if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), S(n), h;
									}
								},
								catch: function (e) {
									for (var t = this.tryEntries.length - 1; t >= 0; --t) {
										var n = this.tryEntries[t];
										if (n.tryLoc === e) {
											var r = n.completion;
											if ('throw' === r.type) {
												var o = r.arg;
												S(n);
											}
											return o;
										}
									}
									throw new Error('illegal catch attempt');
								},
								delegateYield: function (e, t, n) {
									return (
										(this.delegate = { iterator: C(e), resultName: t, nextLoc: n }),
										'next' === this.method && (this.arg = void 0),
										h
									);
								},
							}),
							t
						);
					}
					(e.exports = o), (e.exports.__esModule = !0), (e.exports.default = e.exports);
				},
				85344: function (e) {
					function t(n, r) {
						return (
							(e.exports = t =
								Object.setPrototypeOf
									? Object.setPrototypeOf.bind()
									: function (e, t) {
											return (e.__proto__ = t), e;
									  }),
							(e.exports.__esModule = !0),
							(e.exports.default = e.exports),
							t(n, r)
						);
					}
					(e.exports = t), (e.exports.__esModule = !0), (e.exports.default = e.exports);
				},
				66583: function (e, t, n) {
					var r = n(73783),
						o = n(96448),
						i = n(36030),
						a = n(99340);
					(e.exports = function (e, t) {
						return r(e) || o(e, t) || i(e, t) || a();
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				31752: function (e, t, n) {
					var r = n(4233),
						o = n(26135),
						i = n(36030),
						a = n(32449);
					(e.exports = function (e) {
						return r(e) || o(e) || i(e) || a();
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				8705: function (e, t, n) {
					var r = n(12990).default;
					(e.exports = function (e, t) {
						if ('object' !== r(e) || null === e) return e;
						var n = e[Symbol.toPrimitive];
						if (void 0 !== n) {
							var o = n.call(e, t || 'default');
							if ('object' !== r(o)) return o;
							throw new TypeError('@@toPrimitive must return a primitive value.');
						}
						return ('string' === t ? String : Number)(e);
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				84676: function (e, t, n) {
					var r = n(12990).default,
						o = n(8705);
					(e.exports = function (e) {
						var t = o(e, 'string');
						return 'symbol' === r(t) ? t : String(t);
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				12990: function (e) {
					function t(n) {
						return (
							(e.exports = t =
								'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
									? function (e) {
											return typeof e;
									  }
									: function (e) {
											return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
												? 'symbol'
												: typeof e;
									  }),
							(e.exports.__esModule = !0),
							(e.exports.default = e.exports),
							t(n)
						);
					}
					(e.exports = t), (e.exports.__esModule = !0), (e.exports.default = e.exports);
				},
				36030: function (e, t, n) {
					var r = n(48915);
					(e.exports = function (e, t) {
						if (e) {
							if ('string' == typeof e) return r(e, t);
							var n = Object.prototype.toString.call(e).slice(8, -1);
							return (
								'Object' === n && e.constructor && (n = e.constructor.name),
								'Map' === n || 'Set' === n
									? Array.from(e)
									: 'Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
									? r(e, t)
									: void 0
							);
						}
					}),
						(e.exports.__esModule = !0),
						(e.exports.default = e.exports);
				},
				19457: function (e, t, n) {
					var r = n(2132),
						o = n(85344),
						i = n(1412),
						a = n(54562);
					function s(t) {
						var n = 'function' == typeof Map ? new Map() : void 0;
						return (
							(e.exports = s =
								function (e) {
									if (null === e || !i(e)) return e;
									if ('function' != typeof e) throw new TypeError('Super expression must either be null or a function');
									if (void 0 !== n) {
										if (n.has(e)) return n.get(e);
										n.set(e, t);
									}
									function t() {
										return a(e, arguments, r(this).constructor);
									}
									return (
										(t.prototype = Object.create(e.prototype, {
											constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 },
										})),
										o(t, e)
									);
								}),
							(e.exports.__esModule = !0),
							(e.exports.default = e.exports),
							s(t)
						);
					}
					(e.exports = s), (e.exports.__esModule = !0), (e.exports.default = e.exports);
				},
				70232: function (e, t, n) {
					var r = n(58541)();
					e.exports = r;
					try {
						regeneratorRuntime = r;
					} catch (e) {
						'object' == typeof globalThis
							? (globalThis.regeneratorRuntime = r)
							: Function('r', 'regeneratorRuntime = r')(r);
					}
				},
				87462: function (e) {
					e.exports = (function () {
						//     (c) 2009-2021 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
						//     Underscore may be freely distributed under the MIT license.
						var e = '1.13.1',
							t =
								('object' == typeof self && self.self === self && self) ||
								('object' == typeof global && global.global === global && global) ||
								Function('return this')() ||
								{},
							n = Array.prototype,
							r = Object.prototype,
							o = 'undefined' != typeof Symbol ? Symbol.prototype : null,
							i = n.push,
							a = n.slice,
							s = r.toString,
							l = r.hasOwnProperty,
							u = 'undefined' != typeof ArrayBuffer,
							c = 'undefined' != typeof DataView,
							d = Array.isArray,
							f = Object.keys,
							p = Object.create,
							h = u && ArrayBuffer.isView,
							m = isNaN,
							v = isFinite,
							g = !{ toString: null }.propertyIsEnumerable('toString'),
							y = ['valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'],
							b = Math.pow(2, 53) - 1;
						function _(e, t) {
							return (
								(t = null == t ? e.length - 1 : +t),
								function () {
									for (var n = Math.max(arguments.length - t, 0), r = Array(n), o = 0; o < n; o++)
										r[o] = arguments[o + t];
									switch (t) {
										case 0:
											return e.call(this, r);
										case 1:
											return e.call(this, arguments[0], r);
										case 2:
											return e.call(this, arguments[0], arguments[1], r);
									}
									var i = Array(t + 1);
									for (o = 0; o < t; o++) i[o] = arguments[o];
									return (i[t] = r), e.apply(this, i);
								}
							);
						}
						function w(e) {
							var t = typeof e;
							return 'function' === t || ('object' === t && !!e);
						}
						function O(e) {
							return void 0 === e;
						}
						function k(e) {
							return !0 === e || !1 === e || '[object Boolean]' === s.call(e);
						}
						function x(e) {
							var t = '[object ' + e + ']';
							return function (e) {
								return s.call(e) === t;
							};
						}
						var E = x('String'),
							T = x('Number'),
							S = x('Date'),
							A = x('RegExp'),
							C = x('Error'),
							P = x('Symbol'),
							R = x('ArrayBuffer'),
							I = x('Function'),
							N = t.document && t.document.childNodes;
						'object' != typeof Int8Array &&
							'function' != typeof N &&
							(I = function (e) {
								return 'function' == typeof e || !1;
							});
						var M = I,
							j = x('Object'),
							D = c && j(new DataView(new ArrayBuffer(8))),
							L = 'undefined' != typeof Map && j(new Map()),
							U = x('DataView'),
							F = D
								? function (e) {
										return null != e && M(e.getInt8) && R(e.buffer);
								  }
								: U,
							B = d || x('Array');
						function V(e, t) {
							return null != e && l.call(e, t);
						}
						var Z = x('Arguments');
						!(function () {
							Z(arguments) ||
								(Z = function (e) {
									return V(e, 'callee');
								});
						})();
						var H = Z;
						function q(e) {
							return T(e) && m(e);
						}
						function W(e) {
							return function () {
								return e;
							};
						}
						function K(e) {
							return function (t) {
								var n = e(t);
								return 'number' == typeof n && n >= 0 && n <= b;
							};
						}
						function $(e) {
							return function (t) {
								return null == t ? void 0 : t[e];
							};
						}
						var z = $('byteLength'),
							G = K(z),
							Y = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/,
							J = u
								? function (e) {
										return h ? h(e) && !F(e) : G(e) && Y.test(s.call(e));
								  }
								: W(!1),
							Q = $('length');
						function X(e, t) {
							t = (function (e) {
								for (var t = {}, n = e.length, r = 0; r < n; ++r) t[e[r]] = !0;
								return {
									contains: function (e) {
										return t[e];
									},
									push: function (n) {
										return (t[n] = !0), e.push(n);
									},
								};
							})(t);
							var n = y.length,
								o = e.constructor,
								i = (M(o) && o.prototype) || r,
								a = 'constructor';
							for (V(e, a) && !t.contains(a) && t.push(a); n--; )
								(a = y[n]) in e && e[a] !== i[a] && !t.contains(a) && t.push(a);
						}
						function ee(e) {
							if (!w(e)) return [];
							if (f) return f(e);
							var t = [];
							for (var n in e) V(e, n) && t.push(n);
							return g && X(e, t), t;
						}
						function te(e, t) {
							var n = ee(t),
								r = n.length;
							if (null == e) return !r;
							for (var o = Object(e), i = 0; i < r; i++) {
								var a = n[i];
								if (t[a] !== o[a] || !(a in o)) return !1;
							}
							return !0;
						}
						function ne(e) {
							return e instanceof ne ? e : this instanceof ne ? void (this._wrapped = e) : new ne(e);
						}
						function re(e) {
							return new Uint8Array(e.buffer || e, e.byteOffset || 0, z(e));
						}
						(ne.VERSION = e),
							(ne.prototype.value = function () {
								return this._wrapped;
							}),
							(ne.prototype.valueOf = ne.prototype.toJSON = ne.prototype.value),
							(ne.prototype.toString = function () {
								return String(this._wrapped);
							});
						var oe = '[object DataView]';
						function ie(e, t, n, r) {
							if (e === t) return 0 !== e || 1 / e == 1 / t;
							if (null == e || null == t) return !1;
							if (e != e) return t != t;
							var i = typeof e;
							return (
								('function' === i || 'object' === i || 'object' == typeof t) &&
								(function e(t, n, r, i) {
									t instanceof ne && (t = t._wrapped), n instanceof ne && (n = n._wrapped);
									var a = s.call(t);
									if (a !== s.call(n)) return !1;
									if (D && '[object Object]' == a && F(t)) {
										if (!F(n)) return !1;
										a = oe;
									}
									switch (a) {
										case '[object RegExp]':
										case '[object String]':
											return '' + t == '' + n;
										case '[object Number]':
											return +t != +t ? +n != +n : 0 == +t ? 1 / +t == 1 / n : +t == +n;
										case '[object Date]':
										case '[object Boolean]':
											return +t == +n;
										case '[object Symbol]':
											return o.valueOf.call(t) === o.valueOf.call(n);
										case '[object ArrayBuffer]':
										case oe:
											return e(re(t), re(n), r, i);
									}
									var l = '[object Array]' === a;
									if (!l && J(t)) {
										if (z(t) !== z(n)) return !1;
										if (t.buffer === n.buffer && t.byteOffset === n.byteOffset) return !0;
										l = !0;
									}
									if (!l) {
										if ('object' != typeof t || 'object' != typeof n) return !1;
										var u = t.constructor,
											c = n.constructor;
										if (
											u !== c &&
											!(M(u) && u instanceof u && M(c) && c instanceof c) &&
											'constructor' in t &&
											'constructor' in n
										)
											return !1;
									}
									i = i || [];
									for (var d = (r = r || []).length; d--; ) if (r[d] === t) return i[d] === n;
									if ((r.push(t), i.push(n), l)) {
										if ((d = t.length) !== n.length) return !1;
										for (; d--; ) if (!ie(t[d], n[d], r, i)) return !1;
									} else {
										var f,
											p = ee(t);
										if (((d = p.length), ee(n).length !== d)) return !1;
										for (; d--; ) if (!V(n, (f = p[d])) || !ie(t[f], n[f], r, i)) return !1;
									}
									return r.pop(), i.pop(), !0;
								})(e, t, n, r)
							);
						}
						function ae(e) {
							if (!w(e)) return [];
							var t = [];
							for (var n in e) t.push(n);
							return g && X(e, t), t;
						}
						function se(e) {
							var t = Q(e);
							return function (n) {
								if (null == n) return !1;
								var r = ae(n);
								if (Q(r)) return !1;
								for (var o = 0; o < t; o++) if (!M(n[e[o]])) return !1;
								return e !== pe || !M(n[le]);
							};
						}
						var le = 'forEach',
							ue = 'has',
							ce = ['clear', 'delete'],
							de = ['get', ue, 'set'],
							fe = ce.concat(le, de),
							pe = ce.concat(de),
							he = ['add'].concat(ce, le, ue),
							me = L ? se(fe) : x('Map'),
							ve = L ? se(pe) : x('WeakMap'),
							ge = L ? se(he) : x('Set'),
							ye = x('WeakSet');
						function be(e) {
							for (var t = ee(e), n = t.length, r = Array(n), o = 0; o < n; o++) r[o] = e[t[o]];
							return r;
						}
						function _e(e) {
							for (var t = {}, n = ee(e), r = 0, o = n.length; r < o; r++) t[e[n[r]]] = n[r];
							return t;
						}
						function we(e) {
							var t = [];
							for (var n in e) M(e[n]) && t.push(n);
							return t.sort();
						}
						function Oe(e, t) {
							return function (n) {
								var r = arguments.length;
								if ((t && (n = Object(n)), r < 2 || null == n)) return n;
								for (var o = 1; o < r; o++)
									for (var i = arguments[o], a = e(i), s = a.length, l = 0; l < s; l++) {
										var u = a[l];
										(t && void 0 !== n[u]) || (n[u] = i[u]);
									}
								return n;
							};
						}
						var ke = Oe(ae),
							xe = Oe(ee),
							Ee = Oe(ae, !0);
						function Te(e) {
							if (!w(e)) return {};
							if (p) return p(e);
							var t = function () {};
							t.prototype = e;
							var n = new t();
							return (t.prototype = null), n;
						}
						function Se(e) {
							return w(e) ? (B(e) ? e.slice() : ke({}, e)) : e;
						}
						function Ae(e) {
							return B(e) ? e : [e];
						}
						function Ce(e) {
							return ne.toPath(e);
						}
						function Pe(e, t) {
							for (var n = t.length, r = 0; r < n; r++) {
								if (null == e) return;
								e = e[t[r]];
							}
							return n ? e : void 0;
						}
						function Re(e, t, n) {
							var r = Pe(e, Ce(t));
							return O(r) ? n : r;
						}
						function Ie(e) {
							return e;
						}
						function Ne(e) {
							return (
								(e = xe({}, e)),
								function (t) {
									return te(t, e);
								}
							);
						}
						function Me(e) {
							return (
								(e = Ce(e)),
								function (t) {
									return Pe(t, e);
								}
							);
						}
						function je(e, t, n) {
							if (void 0 === t) return e;
							switch (null == n ? 3 : n) {
								case 1:
									return function (n) {
										return e.call(t, n);
									};
								case 3:
									return function (n, r, o) {
										return e.call(t, n, r, o);
									};
								case 4:
									return function (n, r, o, i) {
										return e.call(t, n, r, o, i);
									};
							}
							return function () {
								return e.apply(t, arguments);
							};
						}
						function De(e, t, n) {
							return null == e ? Ie : M(e) ? je(e, t, n) : w(e) && !B(e) ? Ne(e) : Me(e);
						}
						function Le(e, t) {
							return De(e, t, 1 / 0);
						}
						function Ue(e, t, n) {
							return ne.iteratee !== Le ? ne.iteratee(e, t) : De(e, t, n);
						}
						function Fe() {}
						function Be(e, t) {
							return null == t && ((t = e), (e = 0)), e + Math.floor(Math.random() * (t - e + 1));
						}
						(ne.toPath = Ae), (ne.iteratee = Le);
						var Ve =
							Date.now ||
							function () {
								return new Date().getTime();
							};
						function Ze(e) {
							var t = function (t) {
									return e[t];
								},
								n = '(?:' + ee(e).join('|') + ')',
								r = RegExp(n),
								o = RegExp(n, 'g');
							return function (e) {
								return (e = null == e ? '' : '' + e), r.test(e) ? e.replace(o, t) : e;
							};
						}
						var He = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#x27;', '`': '&#x60;' },
							qe = Ze(He),
							We = Ze(_e(He)),
							Ke = (ne.templateSettings = {
								evaluate: /<%([\s\S]+?)%>/g,
								interpolate: /<%=([\s\S]+?)%>/g,
								escape: /<%-([\s\S]+?)%>/g,
							}),
							$e = /(.)^/,
							ze = { "'": "'", '\\': '\\', '\r': 'r', '\n': 'n', '\u2028': 'u2028', '\u2029': 'u2029' },
							Ge = /\\|'|\r|\n|\u2028|\u2029/g;
						function Ye(e) {
							return '\\' + ze[e];
						}
						var Je = /^\s*(\w|\$)+\s*$/,
							Qe = 0;
						function Xe(e, t, n, r, o) {
							if (!(r instanceof t)) return e.apply(n, o);
							var i = Te(e.prototype),
								a = e.apply(i, o);
							return w(a) ? a : i;
						}
						var et = _(function (e, t) {
							var n = et.placeholder,
								r = function () {
									for (var o = 0, i = t.length, a = Array(i), s = 0; s < i; s++)
										a[s] = t[s] === n ? arguments[o++] : t[s];
									for (; o < arguments.length; ) a.push(arguments[o++]);
									return Xe(e, r, this, this, a);
								};
							return r;
						});
						et.placeholder = ne;
						var tt = _(function (e, t, n) {
								if (!M(e)) throw new TypeError('Bind must be called on a function');
								var r = _(function (o) {
									return Xe(e, r, t, this, n.concat(o));
								});
								return r;
							}),
							nt = K(Q);
						function rt(e, t, n, r) {
							if (((r = r || []), t || 0 === t)) {
								if (t <= 0) return r.concat(e);
							} else t = 1 / 0;
							for (var o = r.length, i = 0, a = Q(e); i < a; i++) {
								var s = e[i];
								if (nt(s) && (B(s) || H(s)))
									if (t > 1) rt(s, t - 1, n, r), (o = r.length);
									else for (var l = 0, u = s.length; l < u; ) r[o++] = s[l++];
								else n || (r[o++] = s);
							}
							return r;
						}
						var ot = _(function (e, t) {
								var n = (t = rt(t, !1, !1)).length;
								if (n < 1) throw new Error('bindAll must be passed function names');
								for (; n--; ) {
									var r = t[n];
									e[r] = tt(e[r], e);
								}
								return e;
							}),
							it = _(function (e, t, n) {
								return setTimeout(function () {
									return e.apply(null, n);
								}, t);
							}),
							at = et(it, ne, 1);
						function st(e) {
							return function () {
								return !e.apply(this, arguments);
							};
						}
						function lt(e, t) {
							var n;
							return function () {
								return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = null), n;
							};
						}
						var ut = et(lt, 2);
						function ct(e, t, n) {
							t = Ue(t, n);
							for (var r, o = ee(e), i = 0, a = o.length; i < a; i++) if (t(e[(r = o[i])], r, e)) return r;
						}
						function dt(e) {
							return function (t, n, r) {
								n = Ue(n, r);
								for (var o = Q(t), i = e > 0 ? 0 : o - 1; i >= 0 && i < o; i += e) if (n(t[i], i, t)) return i;
								return -1;
							};
						}
						var ft = dt(1),
							pt = dt(-1);
						function ht(e, t, n, r) {
							for (var o = (n = Ue(n, r, 1))(t), i = 0, a = Q(e); i < a; ) {
								var s = Math.floor((i + a) / 2);
								n(e[s]) < o ? (i = s + 1) : (a = s);
							}
							return i;
						}
						function mt(e, t, n) {
							return function (r, o, i) {
								var s = 0,
									l = Q(r);
								if ('number' == typeof i)
									e > 0 ? (s = i >= 0 ? i : Math.max(i + l, s)) : (l = i >= 0 ? Math.min(i + 1, l) : i + l + 1);
								else if (n && i && l) return r[(i = n(r, o))] === o ? i : -1;
								if (o != o) return (i = t(a.call(r, s, l), q)) >= 0 ? i + s : -1;
								for (i = e > 0 ? s : l - 1; i >= 0 && i < l; i += e) if (r[i] === o) return i;
								return -1;
							};
						}
						var vt = mt(1, ft, ht),
							gt = mt(-1, pt);
						function yt(e, t, n) {
							var r = (nt(e) ? ft : ct)(e, t, n);
							if (void 0 !== r && -1 !== r) return e[r];
						}
						function bt(e, t, n) {
							var r, o;
							if (((t = je(t, n)), nt(e))) for (r = 0, o = e.length; r < o; r++) t(e[r], r, e);
							else {
								var i = ee(e);
								for (r = 0, o = i.length; r < o; r++) t(e[i[r]], i[r], e);
							}
							return e;
						}
						function _t(e, t, n) {
							t = Ue(t, n);
							for (var r = !nt(e) && ee(e), o = (r || e).length, i = Array(o), a = 0; a < o; a++) {
								var s = r ? r[a] : a;
								i[a] = t(e[s], s, e);
							}
							return i;
						}
						function wt(e) {
							var t = function (t, n, r, o) {
								var i = !nt(t) && ee(t),
									a = (i || t).length,
									s = e > 0 ? 0 : a - 1;
								for (o || ((r = t[i ? i[s] : s]), (s += e)); s >= 0 && s < a; s += e) {
									var l = i ? i[s] : s;
									r = n(r, t[l], l, t);
								}
								return r;
							};
							return function (e, n, r, o) {
								var i = arguments.length >= 3;
								return t(e, je(n, o, 4), r, i);
							};
						}
						var Ot = wt(1),
							kt = wt(-1);
						function xt(e, t, n) {
							var r = [];
							return (
								(t = Ue(t, n)),
								bt(e, function (e, n, o) {
									t(e, n, o) && r.push(e);
								}),
								r
							);
						}
						function Et(e, t, n) {
							t = Ue(t, n);
							for (var r = !nt(e) && ee(e), o = (r || e).length, i = 0; i < o; i++) {
								var a = r ? r[i] : i;
								if (!t(e[a], a, e)) return !1;
							}
							return !0;
						}
						function Tt(e, t, n) {
							t = Ue(t, n);
							for (var r = !nt(e) && ee(e), o = (r || e).length, i = 0; i < o; i++) {
								var a = r ? r[i] : i;
								if (t(e[a], a, e)) return !0;
							}
							return !1;
						}
						function St(e, t, n, r) {
							return nt(e) || (e = be(e)), ('number' != typeof n || r) && (n = 0), vt(e, t, n) >= 0;
						}
						var At = _(function (e, t, n) {
							var r, o;
							return (
								M(t) ? (o = t) : ((t = Ce(t)), (r = t.slice(0, -1)), (t = t[t.length - 1])),
								_t(e, function (e) {
									var i = o;
									if (!i) {
										if ((r && r.length && (e = Pe(e, r)), null == e)) return;
										i = e[t];
									}
									return null == i ? i : i.apply(e, n);
								})
							);
						});
						function Ct(e, t) {
							return _t(e, Me(t));
						}
						function Pt(e, t, n) {
							var r,
								o,
								i = -1 / 0,
								a = -1 / 0;
							if (null == t || ('number' == typeof t && 'object' != typeof e[0] && null != e))
								for (var s = 0, l = (e = nt(e) ? e : be(e)).length; s < l; s++) null != (r = e[s]) && r > i && (i = r);
							else
								(t = Ue(t, n)),
									bt(e, function (e, n, r) {
										((o = t(e, n, r)) > a || (o === -1 / 0 && i === -1 / 0)) && ((i = e), (a = o));
									});
							return i;
						}
						function Rt(e, t, n) {
							if (null == t || n) return nt(e) || (e = be(e)), e[Be(e.length - 1)];
							var r = nt(e) ? Se(e) : be(e),
								o = Q(r);
							t = Math.max(Math.min(t, o), 0);
							for (var i = o - 1, a = 0; a < t; a++) {
								var s = Be(a, i),
									l = r[a];
								(r[a] = r[s]), (r[s] = l);
							}
							return r.slice(0, t);
						}
						function It(e, t) {
							return function (n, r, o) {
								var i = t ? [[], []] : {};
								return (
									(r = Ue(r, o)),
									bt(n, function (t, o) {
										var a = r(t, o, n);
										e(i, t, a);
									}),
									i
								);
							};
						}
						var Nt = It(function (e, t, n) {
								V(e, n) ? e[n].push(t) : (e[n] = [t]);
							}),
							Mt = It(function (e, t, n) {
								e[n] = t;
							}),
							jt = It(function (e, t, n) {
								V(e, n) ? e[n]++ : (e[n] = 1);
							}),
							Dt = It(function (e, t, n) {
								e[n ? 0 : 1].push(t);
							}, !0),
							Lt = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
						function Ut(e, t, n) {
							return t in n;
						}
						var Ft = _(function (e, t) {
								var n = {},
									r = t[0];
								if (null == e) return n;
								M(r)
									? (t.length > 1 && (r = je(r, t[1])), (t = ae(e)))
									: ((r = Ut), (t = rt(t, !1, !1)), (e = Object(e)));
								for (var o = 0, i = t.length; o < i; o++) {
									var a = t[o],
										s = e[a];
									r(s, a, e) && (n[a] = s);
								}
								return n;
							}),
							Bt = _(function (e, t) {
								var n,
									r = t[0];
								return (
									M(r)
										? ((r = st(r)), t.length > 1 && (n = t[1]))
										: ((t = _t(rt(t, !1, !1), String)),
										  (r = function (e, n) {
												return !St(t, n);
										  })),
									Ft(e, r, n)
								);
							});
						function Vt(e, t, n) {
							return a.call(e, 0, Math.max(0, e.length - (null == t || n ? 1 : t)));
						}
						function Zt(e, t, n) {
							return null == e || e.length < 1
								? null == t || n
									? void 0
									: []
								: null == t || n
								? e[0]
								: Vt(e, e.length - t);
						}
						function Ht(e, t, n) {
							return a.call(e, null == t || n ? 1 : t);
						}
						var qt = _(function (e, t) {
								return (
									(t = rt(t, !0, !0)),
									xt(e, function (e) {
										return !St(t, e);
									})
								);
							}),
							Wt = _(function (e, t) {
								return qt(e, t);
							});
						function Kt(e, t, n, r) {
							k(t) || ((r = n), (n = t), (t = !1)), null != n && (n = Ue(n, r));
							for (var o = [], i = [], a = 0, s = Q(e); a < s; a++) {
								var l = e[a],
									u = n ? n(l, a, e) : l;
								t && !n
									? ((a && i === u) || o.push(l), (i = u))
									: n
									? St(i, u) || (i.push(u), o.push(l))
									: St(o, l) || o.push(l);
							}
							return o;
						}
						var $t = _(function (e) {
							return Kt(rt(e, !0, !0));
						});
						function zt(e) {
							for (var t = (e && Pt(e, Q).length) || 0, n = Array(t), r = 0; r < t; r++) n[r] = Ct(e, r);
							return n;
						}
						var Gt = _(zt);
						function Yt(e, t) {
							return e._chain ? ne(t).chain() : t;
						}
						function Jt(e) {
							return (
								bt(we(e), function (t) {
									var n = (ne[t] = e[t]);
									ne.prototype[t] = function () {
										var e = [this._wrapped];
										return i.apply(e, arguments), Yt(this, n.apply(ne, e));
									};
								}),
								ne
							);
						}
						bt(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function (e) {
							var t = n[e];
							ne.prototype[e] = function () {
								var n = this._wrapped;
								return (
									null != n &&
										(t.apply(n, arguments), ('shift' !== e && 'splice' !== e) || 0 !== n.length || delete n[0]),
									Yt(this, n)
								);
							};
						}),
							bt(['concat', 'join', 'slice'], function (e) {
								var t = n[e];
								ne.prototype[e] = function () {
									var e = this._wrapped;
									return null != e && (e = t.apply(e, arguments)), Yt(this, e);
								};
							});
						var Qt = Jt({
							__proto__: null,
							VERSION: e,
							restArguments: _,
							isObject: w,
							isNull: function (e) {
								return null === e;
							},
							isUndefined: O,
							isBoolean: k,
							isElement: function (e) {
								return !(!e || 1 !== e.nodeType);
							},
							isString: E,
							isNumber: T,
							isDate: S,
							isRegExp: A,
							isError: C,
							isSymbol: P,
							isArrayBuffer: R,
							isDataView: F,
							isArray: B,
							isFunction: M,
							isArguments: H,
							isFinite: function (e) {
								return !P(e) && v(e) && !isNaN(parseFloat(e));
							},
							isNaN: q,
							isTypedArray: J,
							isEmpty: function (e) {
								if (null == e) return !0;
								var t = Q(e);
								return 'number' == typeof t && (B(e) || E(e) || H(e)) ? 0 === t : 0 === Q(ee(e));
							},
							isMatch: te,
							isEqual: function (e, t) {
								return ie(e, t);
							},
							isMap: me,
							isWeakMap: ve,
							isSet: ge,
							isWeakSet: ye,
							keys: ee,
							allKeys: ae,
							values: be,
							pairs: function (e) {
								for (var t = ee(e), n = t.length, r = Array(n), o = 0; o < n; o++) r[o] = [t[o], e[t[o]]];
								return r;
							},
							invert: _e,
							functions: we,
							methods: we,
							extend: ke,
							extendOwn: xe,
							assign: xe,
							defaults: Ee,
							create: function (e, t) {
								var n = Te(e);
								return t && xe(n, t), n;
							},
							clone: Se,
							tap: function (e, t) {
								return t(e), e;
							},
							get: Re,
							has: function (e, t) {
								for (var n = (t = Ce(t)).length, r = 0; r < n; r++) {
									var o = t[r];
									if (!V(e, o)) return !1;
									e = e[o];
								}
								return !!n;
							},
							mapObject: function (e, t, n) {
								t = Ue(t, n);
								for (var r = ee(e), o = r.length, i = {}, a = 0; a < o; a++) {
									var s = r[a];
									i[s] = t(e[s], s, e);
								}
								return i;
							},
							identity: Ie,
							constant: W,
							noop: Fe,
							toPath: Ae,
							property: Me,
							propertyOf: function (e) {
								return null == e
									? Fe
									: function (t) {
											return Re(e, t);
									  };
							},
							matcher: Ne,
							matches: Ne,
							times: function (e, t, n) {
								var r = Array(Math.max(0, e));
								t = je(t, n, 1);
								for (var o = 0; o < e; o++) r[o] = t(o);
								return r;
							},
							random: Be,
							now: Ve,
							escape: qe,
							unescape: We,
							templateSettings: Ke,
							template: function (e, t, n) {
								!t && n && (t = n), (t = Ee({}, t, ne.templateSettings));
								var r = RegExp(
										[(t.escape || $e).source, (t.interpolate || $e).source, (t.evaluate || $e).source].join('|') + '|$',
										'g'
									),
									o = 0,
									i = "__p+='";
								e.replace(r, function (t, n, r, a, s) {
									return (
										(i += e.slice(o, s).replace(Ge, Ye)),
										(o = s + t.length),
										n
											? (i += "'+\n((__t=(" + n + "))==null?'':_.escape(__t))+\n'")
											: r
											? (i += "'+\n((__t=(" + r + "))==null?'':__t)+\n'")
											: a && (i += "';\n" + a + "\n__p+='"),
										t
									);
								}),
									(i += "';\n");
								var a,
									s = t.variable;
								if (s) {
									if (!Je.test(s)) throw new Error('variable is not a bare identifier: ' + s);
								} else (i = 'with(obj||{}){\n' + i + '}\n'), (s = 'obj');
								i =
									"var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" +
									i +
									'return __p;\n';
								try {
									a = new Function(s, '_', i);
								} catch (e) {
									throw ((e.source = i), e);
								}
								var l = function (e) {
									return a.call(this, e, ne);
								};
								return (l.source = 'function(' + s + '){\n' + i + '}'), l;
							},
							result: function (e, t, n) {
								var r = (t = Ce(t)).length;
								if (!r) return M(n) ? n.call(e) : n;
								for (var o = 0; o < r; o++) {
									var i = null == e ? void 0 : e[t[o]];
									void 0 === i && ((i = n), (o = r)), (e = M(i) ? i.call(e) : i);
								}
								return e;
							},
							uniqueId: function (e) {
								var t = ++Qe + '';
								return e ? e + t : t;
							},
							chain: function (e) {
								var t = ne(e);
								return (t._chain = !0), t;
							},
							iteratee: Le,
							partial: et,
							bind: tt,
							bindAll: ot,
							memoize: function (e, t) {
								var n = function (r) {
									var o = n.cache,
										i = '' + (t ? t.apply(this, arguments) : r);
									return V(o, i) || (o[i] = e.apply(this, arguments)), o[i];
								};
								return (n.cache = {}), n;
							},
							delay: it,
							defer: at,
							throttle: function (e, t, n) {
								var r,
									o,
									i,
									a,
									s = 0;
								n || (n = {});
								var l = function () {
										(s = !1 === n.leading ? 0 : Ve()), (r = null), (a = e.apply(o, i)), r || (o = i = null);
									},
									u = function () {
										var u = Ve();
										s || !1 !== n.leading || (s = u);
										var c = t - (u - s);
										return (
											(o = this),
											(i = arguments),
											c <= 0 || c > t
												? (r && (clearTimeout(r), (r = null)), (s = u), (a = e.apply(o, i)), r || (o = i = null))
												: r || !1 === n.trailing || (r = setTimeout(l, c)),
											a
										);
									};
								return (
									(u.cancel = function () {
										clearTimeout(r), (s = 0), (r = o = i = null);
									}),
									u
								);
							},
							debounce: function (e, t, n) {
								var r,
									o,
									i,
									a,
									s,
									l = function () {
										var u = Ve() - o;
										t > u ? (r = setTimeout(l, t - u)) : ((r = null), n || (a = e.apply(s, i)), r || (i = s = null));
									},
									u = _(function (u) {
										return (s = this), (i = u), (o = Ve()), r || ((r = setTimeout(l, t)), n && (a = e.apply(s, i))), a;
									});
								return (
									(u.cancel = function () {
										clearTimeout(r), (r = i = s = null);
									}),
									u
								);
							},
							wrap: function (e, t) {
								return et(t, e);
							},
							negate: st,
							compose: function () {
								var e = arguments,
									t = e.length - 1;
								return function () {
									for (var n = t, r = e[t].apply(this, arguments); n--; ) r = e[n].call(this, r);
									return r;
								};
							},
							after: function (e, t) {
								return function () {
									if (--e < 1) return t.apply(this, arguments);
								};
							},
							before: lt,
							once: ut,
							findKey: ct,
							findIndex: ft,
							findLastIndex: pt,
							sortedIndex: ht,
							indexOf: vt,
							lastIndexOf: gt,
							find: yt,
							detect: yt,
							findWhere: function (e, t) {
								return yt(e, Ne(t));
							},
							each: bt,
							forEach: bt,
							map: _t,
							collect: _t,
							reduce: Ot,
							foldl: Ot,
							inject: Ot,
							reduceRight: kt,
							foldr: kt,
							filter: xt,
							select: xt,
							reject: function (e, t, n) {
								return xt(e, st(Ue(t)), n);
							},
							every: Et,
							all: Et,
							some: Tt,
							any: Tt,
							contains: St,
							includes: St,
							include: St,
							invoke: At,
							pluck: Ct,
							where: function (e, t) {
								return xt(e, Ne(t));
							},
							max: Pt,
							min: function (e, t, n) {
								var r,
									o,
									i = 1 / 0,
									a = 1 / 0;
								if (null == t || ('number' == typeof t && 'object' != typeof e[0] && null != e))
									for (var s = 0, l = (e = nt(e) ? e : be(e)).length; s < l; s++)
										null != (r = e[s]) && r < i && (i = r);
								else
									(t = Ue(t, n)),
										bt(e, function (e, n, r) {
											((o = t(e, n, r)) < a || (o === 1 / 0 && i === 1 / 0)) && ((i = e), (a = o));
										});
								return i;
							},
							shuffle: function (e) {
								return Rt(e, 1 / 0);
							},
							sample: Rt,
							sortBy: function (e, t, n) {
								var r = 0;
								return (
									(t = Ue(t, n)),
									Ct(
										_t(e, function (e, n, o) {
											return { value: e, index: r++, criteria: t(e, n, o) };
										}).sort(function (e, t) {
											var n = e.criteria,
												r = t.criteria;
											if (n !== r) {
												if (n > r || void 0 === n) return 1;
												if (n < r || void 0 === r) return -1;
											}
											return e.index - t.index;
										}),
										'value'
									)
								);
							},
							groupBy: Nt,
							indexBy: Mt,
							countBy: jt,
							partition: Dt,
							toArray: function (e) {
								return e ? (B(e) ? a.call(e) : E(e) ? e.match(Lt) : nt(e) ? _t(e, Ie) : be(e)) : [];
							},
							size: function (e) {
								return null == e ? 0 : nt(e) ? e.length : ee(e).length;
							},
							pick: Ft,
							omit: Bt,
							first: Zt,
							head: Zt,
							take: Zt,
							initial: Vt,
							last: function (e, t, n) {
								return null == e || e.length < 1
									? null == t || n
										? void 0
										: []
									: null == t || n
									? e[e.length - 1]
									: Ht(e, Math.max(0, e.length - t));
							},
							rest: Ht,
							tail: Ht,
							drop: Ht,
							compact: function (e) {
								return xt(e, Boolean);
							},
							flatten: function (e, t) {
								return rt(e, t, !1);
							},
							without: Wt,
							uniq: Kt,
							unique: Kt,
							union: $t,
							intersection: function (e) {
								for (var t = [], n = arguments.length, r = 0, o = Q(e); r < o; r++) {
									var i = e[r];
									if (!St(t, i)) {
										var a;
										for (a = 1; a < n && St(arguments[a], i); a++);
										a === n && t.push(i);
									}
								}
								return t;
							},
							difference: qt,
							unzip: zt,
							transpose: zt,
							zip: Gt,
							object: function (e, t) {
								for (var n = {}, r = 0, o = Q(e); r < o; r++) t ? (n[e[r]] = t[r]) : (n[e[r][0]] = e[r][1]);
								return n;
							},
							range: function (e, t, n) {
								null == t && ((t = e || 0), (e = 0)), n || (n = t < e ? -1 : 1);
								for (var r = Math.max(Math.ceil((t - e) / n), 0), o = Array(r), i = 0; i < r; i++, e += n) o[i] = e;
								return o;
							},
							chunk: function (e, t) {
								if (null == t || t < 1) return [];
								for (var n = [], r = 0, o = e.length; r < o; ) n.push(a.call(e, r, (r += t)));
								return n;
							},
							mixin: Jt,
							default: ne,
						});
						return (Qt._ = Qt), Qt;
					})();
				},
				83755: function (e) {
					'use strict';
					e.exports = JSON.parse(
						'{"AF":"Afghanistan","AX":"Ã…land Islands","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia, Plurinational State of","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","VG":"Virgin Islands, British","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CO":"Colombia","KM":"Comoros","CG":"Congo","CK":"Cook Islands","CR":"Costa Rica","CI":"CÃ´te d\'Ivoire","HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":"Czech Republic","CD":"Congo, the Democratic Republic of the","DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","TL":"Timor-Leste","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GG":"Guernsey","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran, Islamic Republic of","IQ":"Iraq","IE":"Ireland","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JE":"Jersey","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KR":"Korea, Republic of","XK":"Kosovo, Republic of","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People\'s Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MK":"Macedonia, the former Yugoslav Republic of","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","ME":"Montenegro","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","AN":"Netherlands Antilles","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","KP":"Korea, Democratic People\'s Republic of","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestine, State of","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"RÃ©union","RO":"Romania","RU":"Russian Federation","RW":"Rwanda","SH":"Saint Helena, Ascension and Tristan da Cunha","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"SÃ£o TomÃ© and PrÃ­ncipe","SA":"Saudi Arabia","SN":"Senegal","RS":"Serbia","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","SS":"South Sudan","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Swaziland","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":"Taiwan","TJ":"Tajikistan","TZ":"Tanzania, United Republic of","TH":"Thailand","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","VI":"Virgin Islands, U.S.","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":"United Kingdom","US":"United States","UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VA":"Holy See (Vatican City State)","VE":"Venezuela, Bolivarian Republic of","VN":"Viet Nam","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe"}'
					);
				},
				74752: function (e) {
					'use strict';
					e.exports = JSON.parse(
						'{"signout":"Sign Out","signin":"Sign In","signup":"Sign Up","remember":"Remember me","rememberDevice":"Trust this device","rememberDevice.timebased":"Do not challenge me on this device for the next {0}","rememberDevice.devicebased":"Do not challenge me on this device again","autoPush":"Send push automatically","unlockaccount":"Unlock account?","haveaccount":"Already have an account?","needhelp":"Need help signing in?","forgotpassword":"Forgot password?","help":"Help","retry":"Retry","iphone":"iPhone","android":"Android","goback":"Back to sign in","closeWindow":"You can close this window","country.option.label":"{0} ({1})","phone.extention.label":"Extension","select.default_value":"Select an option","select.filter.no_match":"No results found for \\"{0}\\"","sensitive.input.show":"Show","sensitive.input.hide":"Hide","processing.alt.text":"Processing...","logo.default.alt.text":"Logo","identifier.icon.alt.text":"User","icon.title.application":"Application","icon.title.browser":"Browser","icon.title.mobileBrowser":"Mobile browser","icon.title.location":"Location","icon.title.mobileDevice":"Mobile Device","skip.to.main.content":"Skip to main content","minutes.oneMinute":"minute","minutes":"{0} minutes","hours":"{0} hours","days":"{0} days","error.config":"There was a configuration error","error.required.authParams":"Missing parameters for the configured authentication scheme - \\"OAUTH2\\"","error.required.baseUrl":"\\"baseUrl\\" is a required widget parameter","error.required.success":"A success handler is required","error.required.el":"\\"el\\" is a required widget parameter","error.invalid.colors.brand":"\\"colors.brand\\" must be in six-digit hex format","error.unsupported.browser":"Unsupported browser","error.unsupported.cors":"Unsupported browser - missing CORS support","error.unsupported.localStorage":"Unsupported browser - missing localStorage support","error.enabled.cors":"There was an error sending the request - have you enabled CORS?","error.expired.session":"Your session has expired. Please try to sign in again.","error.mfa.only.expired.session":"Unable to authenticate at this time.","error.auth.lockedOut":"Your account is locked. Please contact your administrator.","error.oauth.idToken":"There was a problem generating the id_token for the user. Please try again.","error.network.connection":"Unable to connect to the server. Please check your network connection.","error.username.required":"Please enter a username","error.password.required":"Please enter a password","error.mfa.required":"The current sign on policy requires this client to redirect for re-authentication or MFA. Please contact your administrator.","error.unsupported.response":"There was an unsupported response from server.","error.jit_failure":"Unable to sign in, please try another sign in method.","error.unsynced.clock":"Unable to sign in. Please check that your device\'s clock is accurate and try again.","errors.E0000004":"Unable to sign in","errors.E0000069":"Your account is locked because of too many authentication attempts.","errors.E0000047":"You exceeded the maximum number of requests. Try again in a while.","errors.E0000079":"The operation is not allowed. Please refresh the page to proceed.","errors.E0000001":"Api validation failed: {0}","errors.E0000002":"The request was not valid: {0}","errors.E0000003":"The request body was not well-formed.","errors.E0000005":"Invalid session","errors.E0000006":"You do not have permission to perform the requested action","errors.E0000007":"Not found: {0}","errors.E0000008":"The requested path was not found","errors.E0000009":"Internal Server Error","errors.E0000010":"Service is in read only mode","errors.E0000011":"Invalid token provided","errors.E0000012":"Unsupported media type","errors.E0000013":"Invalid client app id","errors.E0000015":"You do not have permission to access the feature you are requesting","errors.E0000016":"Activation failed because the user is already active","errors.E0000017":"Password reset failed","errors.E0000018":"Bad request.  Accept and/or Content-Type headers are likely not set.","errors.E0000019":"Bad request.  Accept and/or Content-Type headers likely do not match supported values.","errors.E0000020":"Bad request.","errors.E0000021":"Bad request.  Accept and/or Content-Type headers likely do not match supported values.","errors.E0000022":"The endpoint does not support the provided HTTP method","errors.E0000023":"Operation failed because user profile is mastered under another system","errors.E0000024":"Bad request.  This operation on app metadata is not yet supported.","errors.E0000025":"App version assignment failed.","errors.E0000026":"This endpoint has been deprecated.","errors.E0000027":"Group push bad request : {0}","errors.E0000028":"The request is missing a required parameter.","errors.E0000029":"Invalid paging request.","errors.E0000030":"Bad request. Invalid date. Dates must be of the form yyyy-MM-dd\'\'T\'\'HH:mm:ss.SSSZZ, e.g. 2013-01-01T12:00:00.000-07:00.","errors.E0000031":"Invalid search criteria.","errors.E0000032":"Unlock is not allowed for this user.","errors.E0000033":"Bad request. Can\'t specify a search query and filter in the same request.","errors.E0000034":"Forgot password not allowed on specified user.","errors.E0000035":"Change password not allowed on specified user.","errors.E0000036":"Change recovery question not allowed on specified user.","errors.E0000037":"Type mismatch exception.","errors.E0000038":"This operation is not allowed in the user\'\'s current status.","errors.E0000039":"Operation on application settings failed.","errors.E0000040":"Application label must not be the same as an existing application label.","errors.E0000041":"Credentials should not be set on this resource based on the scheme.","errors.E0000042":"Setting the error page redirect URL failed.","errors.E0000043":"Self service application assignment is not enabled.","errors.E0000044":"Self service application assignment is not supported.","errors.E0000045":"Field mapping bad request.","errors.E0000046":"Deactivate application for user forbidden.","errors.E0000048":"Entity not found exception.","errors.E0000049":"Invalid SCIM data from SCIM implementation.","errors.E0000050":"Invalid SCIM data from client.","errors.E0000051":"No response from SCIM implementation.","errors.E0000052":"Endpoint not implemented.","errors.E0000053":"Invalid SCIM filter.","errors.E0000054":"Invalid pagination properties.","errors.E0000055":"Duplicate group.","errors.E0000056":"Delete application forbidden.","errors.E0000057":"Access to this application is denied due to a policy.","errors.E0000058":"Access to this application requires MFA: {0}","errors.E0000059":"The connector configuration could not be tested. Make sure that the URL, Authentication Parameters are correct and that there is an implementation available at the URL provided.","errors.E0000060":"Unsupported operation.","errors.E0000061":"Tab error: {0}","errors.E0000062":"The specified user is already assigned to the application.","errors.E0000063":"Invalid combination of parameters specified.","errors.E0000064":"Password is expired and must be changed.","errors.E0000065":"Internal error processing app metadata.","errors.E0000066":"APNS is not configured, contact your admin","errors.E0000067":"Factors Service Error.","errors.E0000070":"Waiting for ACK","errors.E0000071":"Unsupported OS Version: {0}","errors.E0000072":"MIM policy settings have disallowed enrollment for this user","errors.E0000073":"User rejected authentication","errors.E0000074":"Factor Service Error","errors.E0000075":"Cannot modify the {0} attribute because it has a field mapping and profile push is enabled.","errors.E0000076":"Cannot modify the app user because it is mastered by an external app.","errors.E0000077":"Cannot modify the {0} attribute because it is read-only.","errors.E0000078":"Cannot modify the {0} attribute because it is immutable.","errors.E0000081":"Cannot modify the {0} attribute because it is a reserved attribute for this application.","errors.E0000082":"Each code can only be used once. Please wait for a new code and try again.","errors.E0000083":"PassCode is valid but exceeded time window.","errors.E0000084":"App evaluation error.","errors.E0000085":"You do not have permission to access your account at this time.","errors.E0000086":"This policy cannot be activated at this time.","errors.E0000087":"The recovery question answer did not match our records.","errors.E0000090":"The role specified is already assigned to the user.","errors.E0000091":"The provided role type was not the same as required role type.","errors.E0000092":"Access to this application requires re-authentication: {0}","errors.E0000093":"Target count limit exceeded","errors.E0000094":"The provided filter is unsupported.","errors.E0000095":"Recovery not allowed for unknown user.","errors.E0000096":"This certificate has already been uploaded with kid={0}.","errors.E0000097":"There is no verified phone number on file.","errors.E0000098":"This phone number is invalid.","errors.E0000099":"Only numbers located in US and Canada are allowed.  Contact your administrator if this is a problem.","errors.E0000100":"Unable to perform search query.","errors.E0000101":"Upload failed because of a problem with your ipa file, {0}","errors.E0000102":"YubiKey cannot be deleted while assigned to an user. Please deactivate YubiKey using reset MFA and try again","errors.E0000103":"Action on device already in queue or in progress","errors.E0000104":"Device is already locked and cannot be locked again","errors.E0000105":"You have accessed an account recovery link that has expired or been previously used.","errors.E0000106":"Wait for token to change, then enter the new tokencode.","errors.E0000107":"The entity is not in the expected state for the requested transition.","errors.E0000109":"An SMS message was recently sent. Please wait 30 seconds before trying again.","errors.E0000110":"You have accessed a link that has expired or has been previously used.","errors.E0000111":"Cannot modify the {0} object because it is read-only.","errors.E0000112":"Cannot update this user because they are still being activated. Please try again in a few minutes.","errors.E0000113":"{0}.","errors.E0000114":"A user with this login already exists in the current organization.","errors.E0000115":"Upload failed, {0}","errors.E0000116":"{0}","errors.E0000119":"Your account is locked. Please contact your administrator.","errors.E0000124":"Could not create user. To create a user and expire their password immediately, a password must be specified","errors.E0000125":"Could not create user. To create a user and expire their password immediately, \\"activate\\" must be true","errors.E0000133":"A phone call was recently made. Please wait 30 seconds before trying again.","errors.E0000207":"The username and/or the password you entered is incorrect. Please try again.","oform.next":"Next","oform.verify":"Verify","oform.send":"Send","oform.back":"Back","oform.title.authenticate":"Authenticate","oform.save":"Save","oform.cancel":"Cancel","oform.edit":"Edit","oform.previous":"Previous","oform.error.icon.ariaLabel":"Error","oform.errorbanner.title":"We found some errors. Please review the form and make corrections.","oform.errormsg.title":"Please review the form to correct the following errors:","oform.error.unexpected":"There was an unexpected internal error. Please try again.","oform.error.webfinger":"Unable to determine user identification method. Please contact your administrator for assistance.","oform.selectInput.country":"{0} selected","model.validation.field.blank":"This field cannot be left blank","model.validation.field.wrong.type":"This field is of the wrong type","model.validation.field.invalid":"This field has an invalid value","model.validation.field.value.not.allowed":"This field value is not allowed","model.validation.field.array.minItems":"This array does not have enough items","model.validation.field.array.maxItems":"This array contains too many items","model.validation.field.array.unique":"This array can only have unique values","model.validation.field.string.minLength":"This field cannot be less than the minimum required characters","model.validation.field.string.maxLength":"This field cannot exceed the maximum allowed characters","model.validation.field.invalid.format.email":"This value is not a valid email address","model.validation.field.invalid.format.uri":"This value is not a valid URI","model.validation.field.invalid.format.ipv4":"This value is not a valid IPv4 address","model.validation.field.invalid.format.hostname":"This value is not a valid hostname","model.validation.field.username":"Please check your username","schema.validation.field.value.must.string":"Value must be a string","schema.validation.field.value.must.number":"Value must be a number","schema.validation.field.value.must.integer":"Value must be an integer","schema.validation.field.value.must.object":"Value must be an object","universal-directory.profiles.attribute.source.oktamastered":"Inherit from Okta","universal-directory.profiles.attribute.source.override":"Override profile source","universal-directory.profiles.attribute.form.union.disable.display":"Combine values across groups","universal-directory.profiles.attribute.source.inherit":"Inherit from profile source","universal-directory.profiles.attribute.enduser.permission.readonly":"Read Only","universal-directory.profiles.attribute.enduser.permission.hide":"Hide","universal-directory.profiles.attribute.enduser.permission.readwrite":"Read-Write","universal-directory.profiles.attribute.form.union.enable.display":"Use Group Priority","factor.totpSoft.oktaVerify":"Okta Verify","factor.totpSoft.googleAuthenticator":"Google Authenticator","factor.totpSoft.description":"Enter single-use code from the mobile app.","factor.totpHard.rsaSecurId":"RSA SecurID","factor.totpHard.symantecVip":"Symantec VIP","factor.totpHard.description":"Enter a single-use code from a hardware token.","factor.totpHard.yubikey":"YubiKey","factor.totpHard.yubikey.description":"Insert your YubiKey and tap it to get a verification code.","factor.totpHard.yubikey.placeholder":"Click here, then tap your YubiKey","factor.oktaVerifyPush":"Okta Verify","factor.push.description":"Use a push notification sent to the mobile app.","factor.duo":"Duo Security","factor.duo.description":"Use Push Notification, SMS, or Voice call to authenticate.","factor.sms":"SMS Authentication","factor.sms.description":"Enter a single-use code sent to your mobile phone.","factor.sms.time.warning":"Haven\'t received an SMS? To try again, click <$1>Re-send code</$1>.","factor.call":"Voice Call Authentication","factor.call.description":"Use a phone to authenticate by following voice instructions.","factor.call.time.warning":"Haven\'t received a voice call? To try again, click <$1>Redial</$1>.","factor.securityQuestion":"Security Question","factor.securityQuestion.description":"Use the answer to a security question to authenticate.","factor.windowsHello":"Windows Hello","factor.windowsHello.signin.description":"Sign in to Okta using Windows Hello.","factor.windowsHello.signin.description.generic":"Sign in using Windows Hello.","factor.windowsHello.signin.description.specific":"Sign in to {0} using Windows Hello.","factor.u2f":"Security Key (U2F)","factor.u2f.description":"Use a Universal 2nd Factor (U2F) security key to sign on to Okta.","factor.u2f.description.generic":"Use a Universal 2nd Factor (U2F) security key to sign in.","factor.u2f.description.specific":"Use a Universal 2nd Factor (U2F) security key to sign in to {0}.","factor.email":"Email Authentication","factor.email.description":"Enter a verification code sent to your email.","factor.password":"Password","factor.customFactor.description":"Redirect to a third party MFA provider to sign in to Okta.","factor.customFactor.description.generic":"Redirect to a third party MFA provider to sign in.","factor.customFactor.description.specific":"Redirect to a third party MFA provider to sign in to {0}.","factor.webauthn.biometric":"Security Key or Biometric Authenticator","factor.webauthn.biometric.description":"Use a security key (USB or bluetooth) or a biometric authenticator (Windows Hello, Touch ID, etc.)","factor.hotp.description":"Enter a single-use code from an authenticator.","mfa.challenge.verify":"Verify","mfa.challenge.answer.placeholder":"Answer","mfa.challenge.answer.tooltip":"Answer","mfa.challenge.answer.showAnswer":"Show","mfa.challenge.answer.hideAnswer":"Hide","mfa.challenge.enterCode.placeholder":"Enter Code","mfa.challenge.enterCode.tooltip":"Enter Code","mfa.challenge.password.placeholder":"Password","mfa.backToFactors":"Back to factor list","mfa.enroll":"Enroll","mfa.setupOptions":"Setup Options","mfa.country":"Country/region","mfa.phoneNumber.placeholder":"Phone number","mfa.phoneNumber.ext.placeholder":"Extension","mfa.sendCode":"Send code","mfa.sent":"Sent","mfa.resendCode":"Re-send code","mfa.call":"Call","mfa.calling":"Calling","mfa.redial":"Redial","mfa.sendEmail":"Send email","mfa.resendEmail":"Re-send email","mfa.scanBarcode":"Scan QR code","mfa.altQrCode":"QR code. If you can\'t scan, click on the link below to select an alternative activation method","mfa.noAccessToEmail":"Can\'t access email","password.reset":"Reset Password","password.oldPassword.placeholder":"Old password","password.oldPassword.tooltip":"Old password","password.newPassword.placeholder":"New password","password.newPassword.tooltip":"New password","password.confirmPassword.placeholder":"Repeat password","password.confirmPassword.tooltip":"Repeat password","password.error.match":"New passwords must match","password.enroll.error.match":"Passwords must match","recovery.sms.hint":"SMS can only be used if a mobile phone number has been configured.","recovery.mobile.hint":"{0} can only be used if a mobile phone number has been configured.","recovery.sms":"SMS","recovery.call":"Voice Call","recovery.smsOrCall":"SMS or Voice Call","verify.choices.description":"Verify with one of the following factors.","email.button.send":"Send me the code","email.button.resend":"Send again","email.code.label":"Verification code","email.code.not.received":"Haven\'t received an email?","email.enroll.title":"Set up Email Authentication","email.enroll.description":"Send a verification code to your registered email.","email.enroll.enterCode":"Enter code","email.link.terminal.msg":"To finish signing in, return to the screen where you requested the email link.","email.mfa.title":"Verify with Email Authentication","email.mfa.description":"Send a verification code to {0}.","email.mfa.email.sent.description":"A verification code was sent to {0}. Check your email and enter the code below.","email.mfa.email.sent.description.sentText":"A verification code was sent to","email.mfa.email.sent.description.emailCodeText":"Check your email and enter the code below.","email.unregistered_email.error":"Enter the email where you received the Welcome instructions from your administrator.","enroll.choices.title":"Set up multifactor authentication","enroll.choices.description":"Your company requires multifactor authentication to add an additional layer of security when signing in to your Okta account","enroll.choices.description.generic":"Your company requires multifactor authentication to add an additional layer of security when signing in to your account","enroll.choices.description.specific":"Your company requires multifactor authentication to add an additional layer of security when signing in to your {0} account","enroll.choices.description.gracePeriod.bold":"Your company recommends setting up additional factors for authentication. Set up will be required in: <b>{0} day(s)</b>.","enroll.choices.description.gracePeriod.oneDay.bold":"Your company recommends setting up additional factors for authentication. Set up will be required in: <b>less than 1 day</b>.","enroll.choices.optional":"You can configure any additional optional factor or click finish","enroll.choices.list.setup":"Setup required","enroll.choices.list.enrolled":"Enrolled factors","enroll.choices.list.optional":"Additional optional factors","enroll.choices.setup":"Setup","enroll.choices.setup.another":"Set up another","enroll.choices.submit.finish":"Finish","enroll.choices.submit.configure":"Configure factor","enroll.choices.submit.next":"Configure next factor","enroll.choices.cardinality.setup":"({0} set up)","enroll.choices.cardinality.setup.remaining":"({0} of {1} set up)","enroll.choices.setup.skip":"Skip set up","enroll.securityQuestion.setup":"Setup secret question authentication","security.disliked_food":"What is the food you least liked as a child?","security.name_of_first_plush_toy":"What is the name of your first stuffed animal?","security.first_award":"What did you earn your first medal or award for?","security.favorite_security_question":"What is your favorite security question?","security.favorite_toy":"What is the toy/stuffed animal you liked the most as a kid?","security.first_computer_game":"What was the first computer game you played?","security.favorite_movie_quote":"What is your favorite movie quote?","security.first_sports_team_mascot":"What was the mascot of the first sports team you played on?","security.first_music_purchase":"What music album or song did you first purchase?","security.favorite_art_piece":"What is your favorite piece of art?","security.grandmother_favorite_desert":"What was your grandmother\'s favorite dessert?","security.first_thing_cooked":"What was the first thing you learned to cook?","security.childhood_dream_job":"What was your dream job as a child?","security.first_kiss_location":"Where did you have your first kiss?","security.place_where_significant_other_was_met":"Where did you meet your spouse/significant other?","security.favorite_vacation_location":"Where did you go for your favorite vacation?","security.new_years_two_thousand":"Where were you on New Year\'s Eve in the year 2000?","security.favorite_speaker_actor":"Who is your favorite speaker/orator?","security.favorite_book_movie_character":"Who is your favorite book/movie character?","security.favorite_sports_player":"Who is your favorite sports player?","enroll.password.setup":"Select a password","save.password":"Save password","enroll.sms.setup":"Receive a code via SMS to authenticate","enroll.sms.try_again":"The number you entered seems invalid. If the number is correct, please try again.","enroll.call.setup":"Follow phone call instructions to authenticate","enroll.onprem.username.placeholder":"Enter {0} username","enroll.onprem.username.tooltip":"Enter {0} username","enroll.onprem.passcode.placeholder":"Enter {0} passcode","enroll.onprem.passcode.tooltip":"Enter {0} passcode","enroll.symantecVip.subtitle":"Enter Credential ID and two consecutive generated codes","enroll.symantecVip.credentialId.placeholder":"Enter credential ID","enroll.symantecVip.credentialId.tooltip":"Enter credential ID","enroll.symantecVip.passcode1.placeholder":"Security code 1","enroll.symantecVip.passcode1.tooltip":"Security code 1","enroll.symantecVip.passcode2.placeholder":"Security code 2","enroll.symantecVip.passcode2.tooltip":"Security code 2","enroll.yubikey.title":"Setup YubiKey","enroll.yubikey.subtitle":"Insert your YubiKey into a USB port and tap it to generate a verification code","enroll.totp.title":"Setup {0}","enroll.totp.selectDevice":"Select your device type","enroll.totp.downloadApp":"Download <a href=\\"{0}\\" class=\\"inline-link\\">{1} from the {2}</a> onto your mobile device.","enroll.hotp.restricted":"Contact your administrator to continue enrollment.","enroll.duo.title":"Setup Duo Security","enroll.windowsHello.title":"Enroll Windows Hello","enroll.windowsHello.subtitle":"Click below to enroll Windows Hello as a second form of authentication","enroll.windowsHello.subtitle.loading":"Please wait while Windows Hello is loading...","enroll.windowsHello.save":"Enroll Windows Hello","enroll.windowsHello.error.notWindows":"Windows Hello can only be used on Windows Edge with Windows 10. Contact your admin for assistance.","enroll.windowsHello.error.notConfiguredHtml":"Windows Hello is not configured. Select the <b>Start</b> button, then select <b>Settings</b> - <b>Accounts</b> - <b>Sign-in</b> to configure Windows Hello.","verify.windowsHello.subtitle":"Verify your identity with Windows Hello","verify.windowsHello.subtitle.loading":"Please wait while Windows Hello is loading...","verify.windowsHello.subtitle.signingIn":"Signing in to Okta...","verify.windowsHello.subtitle.signingIn.generic":"Signing in...","verify.windowsHello.subtitle.signingIn.specific":"Signing in to {0}...","verify.windowsHello.save":"Verify with Windows Hello","verify.windowsHello.error.notFound":"Your Windows Hello enrollment does not match our records. Contact your administrator for assistance.","verify.windowsHello.error.notFound.selectAnother":"Your Windows Hello enrollment does not match our records. Select another factor or contact your administrator for assistance.","enroll.u2f.title":"Setup Security Key (U2F)","enroll.u2f.save":"Register Security Key","enroll.u2f.general2":"Make sure you have a Security Key. If already inserted, remove it now.<br>If you have a Bluetooth Security Key, turn on your computer\'s Bluetooth.","enroll.u2f.general3":"Click the button below to register","enroll.u2f.instructions":"Insert your Security Key into a USB port on this computer. If it has a button or gold disk, tap it.","enroll.u2f.instructionsBluetooth":"If you are using a Bluetooth Security Key, press the button.","u2f.error.factorNotSupported":"Security Key (U2F) is not supported on this browser. Select another factor or contact your admin for assistance.","u2f.error.factorNotSupported.oneFactor":"Security Key (U2F) is not supported on this browser. Contact your admin for assistance.","u2f.error.other":"An unknown error has occured. Try again or select another factor.","u2f.error.other.oneFactor":"An unknown error has occured. Try again or contact your admin for assistance.","u2f.error.badRequest":"There was an error with the U2F request. Try again or select another factor.","u2f.error.badRequest.oneFactor":"There was an error with the U2F request. Try again or contact your admin for assistance.","u2f.error.unsupported":"The security key is unsupported. Select another factor.","u2f.error.unsupported.oneFactor":"The security key is unsupported. Contact your admin for assistance.","u2f.error.timeout":"You have timed out of the authentication period. Please try again.","verify.u2f.instructions":"Insert your Security Key. If it has a button or gold disk, tapÂ it.","verify.u2f.instructionsBluetooth":"If you are using a Bluetooth Security Key, turn on your computer\'s Bluetooth and press the button.","verify.u2f.retry":"Retry","enroll.customFactor.subtitle":"Clicking below will redirect to MFA enrollment with {0}","enroll.customFactor.save":"Enroll","verify.customFactor.subtitle":"Clicking below will redirect to verification with {0}","verify.customFactor.subtitle.redirect":"Redirecting to {0}...","enroll.webauthn.biometric.title":"Set up security key or biometric authenticator","enroll.webauthn.save":"Enroll","enroll.webauthn.biometric.instructions":"Your browser will prompt to register a security key or biometric authenticator (Windows Hello, Touch ID, etc.). Follow the instructions to complete enrollment.","enroll.webauthn.biometric.instructions.edge":"Note: If you are enrolling a security key and Windows Hello or PIN is enabled, you will need to select \'<b>Cancel</b>\' in the prompt before continuing.","verify.webauthn.biometric.instructions":"Your browser or device will prompt you to verify with a security key or biometric authenticator. Follow the instructions to complete authentication.","webauthn.biometric.error.factorNotSupported":"Security key or biometric authenticator is not supported on this browser. Select another factor or contact your admin for assistance.","webauthn.biometric.error.factorNotSupported.oneFactor":"Security key or biometric authenticator is not supported on this browser. Contact your admin for assistance.","enroll.webauthn.instructions.noSupportForBiometric":"Note: Some browsers may not support biometric authenticators.","authfactor.webauthn.error":"You are currently unable to use a Security key or biometric authenticator. Try again.","enroll.totp.enterCode":"Enter code displayed from the application","enroll.totp.setupApp":"Launch {0} on your mobile device and select â€œAdd an accountâ€. Scan the QR code to continue.","enroll.totp.setupGoogleAuthApp":"Launch {0}, tap the \\"+\\" icon, then select \\"Scan a QR code\\".","enroll.totp.cannotScan":"Can\'t scan?","enroll.totp.aria.cannotScan":"Setup without scanning a QR code.","enroll.totp.refreshBarcode":"Refresh code","enroll.totp.cannotScanBarcode":"Can\'t scan QR code?","enroll.totp.manualSetupInstructions":"To set up manually enter your Okta Account username and then input the following in the Secret Key Field","enroll.totp.manualSetupInstructions.generic":"To set up manually enter your Account username and then input the following in the Secret Key Field","enroll.totp.manualSetupInstructions.specific":"To set up manually enter your {0} Account username and then input the following in the Secret Key Field","enroll.totp.sharedSecretInstructions":"Enter your Okta Account username and enter the following in the Secret Key Field","enroll.totp.sharedSecretInstructions.generic":"Enter your Account username and enter the following in the Secret Key Field","enroll.totp.sharedSecretInstructions.specific":"Enter your {0} Account username and enter the following in the Secret Key Field","enroll.totp.sendSms":"Send activation link via SMS","enroll.totp.sendEmail":"Send activation link via email","enroll.totp.setupManually":"Setup manually without push notification","enroll.totp.sharedSecretInstructions.aria.secretKey":"setup key {0}","enroll.totp.enrollViaEmail.title":"Activation email sent!","enroll.totp.enrollViaEmail.msg":"Open the email from your mobile device.","enroll.totp.enrollViaSms.title":"SMS sent!","enroll.totp.enrollViaSms.msg":"View the SMS on your mobile device.","recoveryChallenge.sms.title":"Enter verification code sent via SMS","recoveryChallenge.call.title":"Enter verification code received via Voice Call","mfa.factors.dropdown.title":"Select an authentication factor","mfa.factors.dropdown.sr.text":"Select Authentication Factor - {0} Factor Selected","mfa.duoSecurity.push":"Push â€” {0}","mfa.duoSecurity.sms":"SMS â€” {0}","mfa.duoSecurity.call":"Call â€” {0}","mfa.switch":"Switch Factor","mfa.challenge.title":"Enter your {0} passcode","mfa.challenge.orEnterCode":"Or enter code","mfa.challenge.totp.subtitle.multiple":"Enter code from any registered {0} device.","mfa.emailVerification.checkEmail":"To finish signing in, click the link in your email.","mfa.emailVerification.title":"Sign in using a link sent to your email.","mfa.emailVerification.subtitle":"Emails will be sent to {0}","mfa.emailVerification.otc.finish":"To finish signing in, enter the code which was emailed to you.","oktaverify.send":"Send Push","oktaverify.resend":"Re-send Push","oktaverify.sent":"Push sent!","oktaverify.rejected":"You have chosen to reject this login.","oktaverify.rejected.upgradeRequired.ios":"Verification failed because your Okta Verify version is no longer supported. To sign in, please update Okta Verify on the App Store, then try again.","oktaverify.rejected.upgradeRequired.android":"Verification failed because your Okta Verify version is no longer supported. To sign in, please update Okta Verify on Google Play, then try again.","oktaverify.timeout":"Your push notification has expired.","oktaverify.warning":"Haven\'t received a push notification yet? Try opening the Okta Verify App on your phone.","oktaverify.numberchallenge.instruction":"On your phone, tap <span class=\\"challenge-number\\">{0}</span> on Okta Verify prompt to continue.","oktaverify.numberchallenge.explain":"This extra step helps us make sure it\'s really you signing in.","primaryauth.title":"Sign In","primaryauth.username.placeholder":"Username","primaryauth.username.tooltip":"Username","primaryauth.password.placeholder":"Password","primaryauth.password.tooltip":"Password","primaryauth.submit":"Sign In","primaryauth.newUser.tooltip":"This is the first time you are connecting to {0} from this browser","primaryauth.newUser.tooltip.close":"Close","oktaVerify.description":"To access this resource, your organization requires you to sign in with Okta FastPass.","oktaVerify.appDescription":"To access {0}, your organization requires you to sign in with Okta FastPass.","oktaVerify.button":"Sign in with Okta FastPass","signinWithWebAuthn.button":"Sign in with security key or biometrics","idpDiscovery.email.placeholder":"Email","password.forgot.email.or.username.placeholder":"Email or Username","password.forgot.email.or.username.tooltip":"Email or Username","password.forgot.sendText":"Reset via SMS","password.forgot.sendEmail":"Reset via Email","password.forgot.call":"Reset via Voice Call","password.forgot.emailSent.title":"Email sent!","password.forgot.emailSent.desc":"Email has been sent to {0} with instructions on resetting your password.","password.forgot.question.title":"Answer Forgotten Password Challenge","password.forgot.question.submit":"Reset Password","password.forgot.code.notReceived":"Didn\'t receive a code? Reset via email","password.forgot.noFactorsEnabled":"No password reset options available. Please contact your administrator.","password.reset.title":"Reset your Okta password","password.reset.title.generic":"Reset your password","password.reset.title.specific":"Reset your {0} password","password.complexity.requirements":"Password requirements: {0}.","password.complexity.history":"Your password cannot be any of your last {0} password(s).","password.complexity.minAgeMinutes":"At least {0} minute(s) must have elapsed since you last changed your password.","password.complexity.minAgeHours":"At least {0} hour(s) must have elapsed since you last changed your password.","password.complexity.minAgeDays":"At least {0} day(s) must have elapsed since you last changed your password.","password.reset.verification":"Verify with one of the following factors to reset your password.","password.reset.revokeSessions":"Sign me out of all other devices.","password.complexity.length":"at least {0} characters","password.complexity.list.element":", {0}","password.complexity.lowercase":"a lowercase letter","password.complexity.uppercase":"an uppercase letter","password.complexity.number":"a number","password.complexity.symbol":"a symbol","password.complexity.no_username":"no parts of your username","password.complexity.no_first_name":"does not include your first name","password.complexity.no_last_name":"does not include your last name","password.complexity.adRequirements":"at least 3 of the following: lowercase letter, uppercase letter, number, symbol","password.complexity.maxConsecutiveRepeatingCharacters":"maximum {0} consecutive repeating characters","password.complexity.requirements.header":"Password requirements:","password.complexity.length.description":"At least {0} characters","password.complexity.lowercase.description":"A lowercase letter","password.complexity.uppercase.description":"An uppercase letter","password.complexity.number.description":"A number","password.complexity.symbol.description":"A symbol","password.complexity.no_username.description":"No parts of your username","password.complexity.no_first_name.description":"Does not include your first name","password.complexity.no_last_name.description":"Does not include your last name","password.complexity.history.one.description":"Password can\'t be the same as your last password","password.complexity.adRequirements.description":"At least 3 of the following: lowercase letter, uppercase letter, number, symbol","password.complexity.maxConsecutiveRepeatingCharacters.description":"Maximum {0} consecutive repeating characters","password.complexity.history.description":"Password can\'t be the same as your last {0} passwords","password.complexity.minAgeMinutes.description":"At least {0} minute(s) must have elapsed since you last changed your password","password.complexity.minAgeHours.description":"At least {0} hour(s) must have elapsed since you last changed your password","password.complexity.minAgeDays.description":"At least {0} day(s) must have elapsed since you last changed your password","password.expired.submit":"Change Password","password.expired.title":"Your Okta password has expired","password.expired.title.generic":"Your password has expired","password.expired.title.specific":"Your {0} password has expired","password.expiring.later":"Remind me later","password.expiring.title":"Your password will expire in {0} days","password.expiring.today":"Your password will expire later today","password.expiring.soon":"Your password is expiring soon","password.expiring.subtitle":"When password expires you may be locked out of Okta Mobile, mobile email, and other services.","password.expiring.subtitle.generic":"When password expires you will be locked out of your account.","password.expiring.subtitle.specific":"When password expires you will be locked out of your {0} account.","password.expired.custom.submit":"Go to {0}","password.expired.custom.subtitle":"This password is set on another website. Click the button below to go there and set a new password.","password.expiring.soon.subtitle.generic":"When password expires you will be locked out of your account. This password is set on another website. Click the button below to go there and set a new password.","password.expiring.soon.subtitle.specific":"When password expires you will be locked out of your {0} account. This password is set on another website. Click the button below to go there and set a new password.","hcaptcha.footer.label":"This site is protected by hCaptcha and its <$1>Privacy Policy</$1> and <$2>Terms of Service</$2> apply.","account.unlock.title":"Unlock account","account.unlock.email.or.username.placeholder":"Email or username","account.unlock.email.or.username.tooltip":"Email or username","account.unlock.sendText":"Send SMS","account.unlock.voiceCall":"Voice Call","account.unlock.sendEmail":"Send Email","account.unlock.emailSent.title":"Email sent!","account.unlock.emailSent.desc":"Email has been sent to {0} with instructions on unlocking your account.","account.unlock.question.title":"Answer Unlock Account Challenge","account.unlock.question.submit":"Unlock Account","account.unlock.unlocked.title":"Account successfully unlocked!","account.unlock.unlocked.desc":"You can log in using your existing username and password.","account.unlock.code.notReceived":"Didn\'t receive a code? Unlock via email","account.unlock.noFactorsEnabled":"No unlock options available. Please contact your administrator.","account.unlock.authenticatorRequired.single":"To unlock your account, select the following authenticator.","account.unlock.authenticatorRequired.multiple":"To unlock your account, select one of the following authenticators.","contact.support":"If you didn\'t provide a secondary email address or don\'t have access to email, please contact your administrator at {0}","customauth.sign.in.with.label":"Sign in with {0}","socialauth.divider.text":"OR","socialauth.facebook.label":"Sign in with Facebook","socialauth.google.label":"Sign in with Google","socialauth.linkedin.label":"Sign in with LinkedIn","socialauth.microsoft.label":"Sign in with Microsoft","socialauth.apple.label":"Sign in with Apple","socialauth.github.label":"Sign in with GitHub","socialauth.gitlab.label":"Sign in with GitLab","socialauth.yahoo.label":"Sign in with Yahoo","socialauth.line.label":"Sign in with LINE","socialauth.paypal.label":"Sign in with PayPal","socialauth.paypal_sandbox.label":"Sign in with PayPal Sandbox","socialauth.salesforce.label":"Sign in with Salesforce","socialauth.amazon.label":"Sign in with Amazon","socialauth.yahoojp.label":"Sign in with Yahoo Japan","socialauth.discord.label":"Sign in with Discord","socialauth.adobe.label":"Sign in with Adobe","socialauth.orcid.label":"Sign in with ORCiD","socialauth.spotify.label":"Sign in with Spotify","socialauth.xero.label":"Sign in with Xero","socialauth.quickbooks.label":"Sign in with Quickbooks","socialauth.popup.title":"External Identity Provider User Authentication","authbutton.divider.text":"or","registration.signup.label":"Don\'t have an account?","registration.signup.text":"Sign up","registration.complete.title":"Verification email sent","registration.complete.confirm.text":"To finish signing in, check your email.","registration.form.title":"Create Account","registration.form.submit":"Register","registration.passwordComplexity.minLength":"At least {0} character(s)","registration.passwordComplexity.minLower":"At least {0} lowercase letter(s)","registration.passwordComplexity.minUpper":"At least {0} uppercase letter(s)","registration.passwordComplexity.minNumber":"At least {0} number(s)","registration.passwordComplexity.minSymbol":"At least {0} symbol(s)","registration.passwordComplexity.excludeUsername":"Does not contain part of username","registration.passwordComplexity.excludeAttribute":"Does not contain \'{0}\'","registration.required.fields.label":"* indicates required field","registration.default.callbackhook.error":"We could not process your registration at this time. Please try again later.","registration.error.userName.invalidEmail":"Invalid email address","registration.error.password.passwordRequirementsNotMet":"Password requirements were not met","registration.error.password.passwordRequirementsNotMet.prefix":"Password requirements were not met:","registration.error.userName.notUniqueWithinOrg":"An account with that {0} already exists","registration.error.notUniqueWithinOrg.Email":"A user with this Email already exists","registration.error.notUniqueWithinOrg.custom":"A user with this {0} already exists","registration.error.invalidLoginEmail.Email":"\'Email\' must be in the form of an email address","registration.error.invalidLoginEmail.custom":"\'{0}\' must be in the form of an email address","registration.error.doesNotMatchPattern.Email":"Provided value for property \'Email\' does not match required pattern","registration.error.doesNotMatchPattern.custom":"Provided value for property \'{0}\' does not match required pattern","registration.error.generic":"There was an error creating your account. Please try registering again.","registration.error.request.not.completed":"Your request could not be completed. Try again later.","registration.model.validation.field.string.too.short":"Please enter something at least {0} characters long","registration.model.validation.field.string.too.long":"Please enter something shorter than {0} characters","piv.card":"PIV Card","piv.card.insert":"Please insert your PIV card and select the user certificate.","piv.card.error":"Certificate authentication failed. Contact your admin.","piv.card.error.empty":"No certificate selected. Choose a certificate and try again.","piv.card.error.invalid":"Certificate validation failed. Choose another certificate and try again.","piv.cac.card":"Sign in with PIV / CAC card","piv.cac.title":"PIV / CAC card","piv.cac.card.insert":"Please insert your PIV / CAC card and select the user certificate.","piv.cac.error":"There was an error signing in. Click the button below to try again.","unsupported.oneDrive.title":"Your OneDrive version is not supported","unsupported.oneDrive.desc":"Upgrade now by installing the OneDrive for Business Next Generation Sync Client to login to Okta","unsupported.oneDrive.action":"Learn how to upgrade","unsupported.cookies.title":"Cookies are required","unsupported.cookies.desc":"Cookies are disabled on your browser. Please enable Cookies and refresh this page.","unsupported.cookies.action":"Refresh","deviceTrust.sso.text":"Sign in to access company resources","deviceTrust.sso.subtitle.2":"Your company uses Okta Mobile to get you approved to access this app.","deviceTrust.sso.button":"Sign in with Okta Mobile","deviceTrust.sso.expire.title":"Oops let\'s get you back on track","deviceTrust.sso.redirectText":"Verifying your identity","deviceTrust.sso.expire.subtitle":"Unfortunately the steps required to sign in took longer than expected and your attempt timed out.","deviceTrust.sso.expire.button":"Sign in using Okta Mobile","deviceTrust.universalLink.fallback.getOktaMobile.title":"Get Okta Mobile","deviceTrust.universalLink.fallback.getOktaMobile.subtitle":"Go to the {0}AppStore{1}, {0}search{1} for {0}Okta Mobile{1} and tap on {0}GET{1} Okta Mobile. Once installed, sign in to Okta Mobile and follow the instructions to secure your device.","core.auth.factor.signedNonce.error.invalidDevice":"Your device or account was invalidated. If this is unexpected, contact your administrator for help.","core.auth.factor.signedNonce.error":"Your device or account was invalidated. Re-enroll your account on Okta Verify and try again.","user.fail.verifyIdentity":"Couldnâ€™t verify your identity","loopback.polling.cancel.link":"Cancel and take me to sign in","loopback.polling.cancel.link.with.form.error":"Take me to sign in","customUri.subtitle":"Launching Okta Verify...","customUri.content":"<div class=\\"skinny-content\\"> If nothing prompts from the browser, <a href=\\"#\\" id=\\"launch-ov\\" class=\\"link\\">click here</a> to launch Okta Verify, or make sure Okta Verify is installed.</div>","customUri.title":"Click \\"Open Okta Verify\\" on the browser prompt","customUri.required.content.prompt":"Didnâ€™t get a prompt?","customUri.required.content.download.title":"Donâ€™t have Okta Verify?","customUri.required.content.download.linkText":"Download here","customUri.required.content.button":"Launch Okta Verify","universalLink.title":"Sign in with Okta FastPass","universalLink.content":"If Okta Verify did not open automatically, tap Open Okta Verify.","appLink.title":"Sign in with Okta FastPass","appLink.content":"If Okta Verify did not open automatically, tap Open Okta Verify.","oktaVerify.open.button":"Open Okta Verify","oktaVerify.reopen.button":"Reopen Okta Verify","consent.required.text":"<b>{0}</b> would like to access:","consent.required.description":"By clicking Allow Access, you allow the actions listed above.","consent.required.termsOfService":"Terms of Service","consent.required.privacyPolicy":"Privacy Policy","consent.required.consentButton":"Allow Access","consent.required.cancelButton":"Don\'t Allow","granular.consent.scopes.title":"<$1>{0}</$1> <$2>wants to access your account</$2>","granular.consent.scopes.description":"Allowing access will share","admin.consent.group.user.group":"User and groups","admin.consent.group.resource.policy":"Resource and policies","admin.consent.group.hook":"Hooks","admin.consent.group.system":"System","polling.title":"There are too many users trying to sign in right now. We will automatically retry in {0} seconds.","poll.form.title":"Unable to complete your request","poll.form.message":"We will automatically retry in <$1>{0}</$1> seconds.","cert.authentication.title":"Certificate authentication","common.logo.alt":"aria logo","oie.authenticator.enroll.error.fail":"Unable to enroll authenticator. Try again.","oie.authenticator.verify.error.fail":"Unable to verify authenticator. Try again.","oie.configuration.error":"Something went wrong. Potential misconfiguration detected. Please contact support.","oie.auth.logo.aria.label":"Authenticator logo","oie.challenge.answer.showAnswer":"Show answer","oie.challenge.answer.hideAnswer":"Hide answer","oie.form.field.optional":"Optional","oie.form.field.optional.description":"Fields are required unless marked optional.","oie.password.label":"Password","oie.password.newPasswordLabel":"New password","oie.password.authenticator.description":"Choose a password for your account","oie.password.challenge.title":"Verify with your password","oie.password.enroll.title":"Set up password","oie.password.passwordLabel":"Enter password","oie.password.confirmPasswordLabel":"Re-enter password","oie.password.showPassword":"Show password","oie.password.showConfirmPassword":"Show re-entered password","oie.password.hidePassword":"Hide password","oie.password.hideConfirmPassword":"Hide re-entered password","oie.password.reset.verification":"Verify with one of the following security methods to reset your password.","idx.password.expiring.message":"When your password expires, you will have to change your password before you can login to your {0} account.","oie.password.incorrect.message":"Password is incorrect","oie.selfservice.reset.password.not.allowed":"Reset password is not allowed at this time. Please contact support for assistance.","password.common":"This password was found in a list of commonly used passwords. Please try another password.","idx.recovery.completed":"You can now sign in with your existing username and new password.","oie.phone.label":"Phone","oie.phone.authenticator.description":"Verify with a code sent to your phone","oie.phone.enroll.sms.label":"SMS","oie.phone.enroll.voice.label":"Voice call","oie.phone.enroll.title":"Set up phone authentication","oie.phone.enroll.call.subtitle":"Enter your phone number to receive a verification code via voice call.","oie.phone.enroll.sms.subtitle":"Enter your phone number to receive a verification code via SMS.","oie.phone.sms.primaryButton":"Receive a code via SMS","oie.phone.sms.secondaryButton":"Receive an SMS instead","oie.phone.call.primaryButton":"Receive a code via voice call","oie.phone.call.secondaryButton":"Receive a voice call instead","oie.phone.verify.sms.resendText":"Haven\'t received an SMS?","oie.phone.verify.sms.codeSentText":"A code was sent to","oie.phone.verify.sms.sendText":"Send a code via SMS to","oie.phone.verify.call.sendText":"Send a code via voice call to","oie.phone.verify.call.resendText":"Haven\'t received a call?","oie.phone.verify.call.resendLinkText":"Call again","oie.phone.verify.sms.resendLinkText":"Send again","oie.phone.verify.enterCodeText":"Enter the code below to verify.","oie.phone.verify.title":"Verify with your phone","oie.phone.alternate.title":"your phone","oie.phone.carrier.charges":"Carrier messaging charges may apply","oie.phone.invalid":"Invalid Phone Number.","oie.phone.verify.sms.sendText.with.phone.with.nickname":"Send a code via SMS to <$1>{0}</$1> <$2>({1})</$2>.","oie.phone.verify.call.sendText.with.phone.with.nickname":"Send a code via voice call to <$1>{0}</$1> <$2>({1})</$2>.","oie.phone.verify.sms.sendText.with.phone.without.nickname":"Send a code via SMS to <$1>{0}</$1>.","oie.phone.verify.call.sendText.with.phone.without.nickname":"Send a code via voice call to <$1>{0}</$1>.","oie.phone.verify.sms.sendText.without.phone":"Send a code via SMS to your phone.","oie.phone.verify.call.sendText.without.phone":"Send a code via voice call to your phone.","oie.phone.verify.sms.codeSentText.with.phone.with.nickname":"A code was sent to <$1>{0}</$1> <$2>({1})</$2>. Enter the code below to verify.","oie.phone.verify.mfa.calling.with.phone.with.nickname":"Calling <$1>{0}</$1> <$2>({1})</$2>. Enter the code below to verify.","oie.phone.verify.sms.codeSentText.with.phone.without.nickname":"A code was sent to <$1>{0}</$1>. Enter the code below to verify.","oie.phone.verify.mfa.calling.with.phone.without.nickname":"Calling <$1>{0}</$1>. Enter the code below to verify.","oie.phone.verify.sms.codeSentText.without.phone":"A code was sent to your phone. Enter the code below to verify.","oie.phone.verify.mfa.calling.without.phone":"Calling your phone. Enter the code below to verify.","oie.email.label":"Email","oie.email.authenticator.description":"Verify with a link or code sent to your email","oie.email.mfa.title":"Verify with your email","oie.email.challenge.mfa.title":"Get a verification email","oie.email.verify.primaryButton":"Send me an email","oie.email.verify.subtitle.text.with.email":"Send a verification email to <$1>{0}</$1> by clicking on \\"Send me an email\\".","oie.email.verify.subtitle.text.with.email.and.secondary.email":"Send a verification email to <$1>{0}</$1> and <$2>{1}</$2> by clicking on \\"Send me an email\\".","oie.email.verify.subtitle.text.without.email":"Send a verification email by clicking on \\"Send me an email\\".","oie.email.verify.alternate.magicLinkToEmailAddress":"We sent an email to <$1>{0}</$1>. ","oie.email.verify.alternate.magicLinkToEmailAddress.with.secondary.email":"We sent an email to <$1>{0}</$1> and <$2>{1}</$2>. ","oie.email.verify.alternate.magicLinkToYourEmail":"We sent you a verification email. ","oie.email.verify.alternate.instructions":"Click the verification link in your email to continue or enter the code below.","oie.email.verify.alternate.show.verificationCode.text":"Enter a verification code instead","oie.email.verify.alternate.verificationCode.instructions":"Enter the verification code in the text box.","oie.email.enroll.subtitle":"Please check your email and enter the code below.","oie.email.return.link.expired.title":"Verify with your email","oie.profile.additional.title":"Additional Profile information","oie.profile.additional.secondemail.subtitle":"Use a second email to <$1> recover your account </$1> in case you become locked out. This email must be verified after setup.","oie.webauthn.label":"Security Key or Biometric Authenticator","oie.webauthn.description":"Use a security key or a biometric authenticator to sign in","oie.enroll.webauthn.title":"Set up security key or biometric authenticator","oie.enroll.webauthn.instructions":"You will be prompted to register a security key or biometric authenticator (Windows Hello, Touch ID, Face ID, etc.). Follow the instructions to complete set up.","oie.enroll.webauthn.uv.required.instructions":"Biometric verification or a PIN is required to setup this authenticator.","oie.enroll.webauthn.instructions.edge":"Note: If you are enrolling a security key and Windows Hello or PIN is enabled, you will need to select \'Cancel\' in the prompt before continuing.","oie.enroll.webauthn.save":"Set up","oie.webauthn.error.not.supported":"Security key or biometric authenticator is not supported on this browser. Contact your admin for assistance.","oie.webauthn.error.invalidPasskey":"Invalid passkey.","oie.verify.webauth.title":"Verify with Security Key or Biometric Authenticator","oie.verify.webauthn.instructions":"You will be prompted to use a security key or biometric verification (Windows Hello, Touch ID, etc.). Follow the instructions to complete verification.","oie.verify.webauthn.uv.required.instructions":"Biometric verification or a PIN is required to sign in with this authenticator.","oie.verify.webauthn.cant.verify":"Can\'t verify?","oie.verify.webauthn.cant.verify.biometric.authenticator.title":"Are you trying to use a biometric authenticator?","oie.verify.webauthn.cant.verify.biometric.authenticator.description1":"Biometric authenticators (fingerprint, face recognition, PIN) will only work on the same device on which they were set up.","oie.verify.webauthn.cant.verify.biometric.authenticator.description2":"If available, set up another security method on the device you used to set up your biometric authenticator.","oie.verify.webauthn.cant.verify.security.key.title":"Are you trying to use a security key?","oie.verify.webauthn.cant.verify.security.key.description":"If you have set up a security key, insert it in a USB port when prompted by the browser and tap on the button or gold disk. Security keys can work on multiple devices.","oie.verify.webauthn.cant.verify.enrollment.step1":"Open your Okta Dashboard (e.g. yourcompany.okta.com) on the device you used to setup your security key or biometric authenticator","oie.verify.webauthn.cant.verify.enrollment.step2":"Go to Settings > Security Methods","oie.verify.webauthn.cant.verify.enrollment.step3":"On Okta Verify, click \\"Set up\\"","oie.verify.webauthn.cant.verify.enrollment.step4":"Scan the QR code using Okta Verify and follow instructions to finish enrolling your account","oie.enroll.webauthn.rk.link":"If you haven\'t set up your security key or biometric authentication, you can complete the process after you sign in using <a href=\\"#\\" class=\\"setup-webauthn-residentkey-link\\">this link</a>.","oie.select.authenticator.verify.email.label":"Select Email.","oie.select.authenticator.verify.email.with.email.label":"Select Email - {0}.","oie.select.authenticator.verify.password.label":"Select Password.","oie.select.authenticator.verify.phone.label":"Select Phone.","oie.select.authenticator.verify.phone.with.phone.label":"Select Phone - {0}.","oie.select.authenticator.verify.webauthn.label":"Select Security Key or Biometric Authenticator.","oie.select.authenticator.verify.security.question.label":"Select Security Question.","oie.select.authenticator.okta_verify.totp.label":"Select to enter a code from the Okta Verify app.","oie.select.authenticator.okta_verify.push.label":"Select to get a push notification to the Okta Verify app.","oie.select.authenticator.okta_verify.signed_nonce.label":"Select Okta Verify.","oie.select.authenticator.verify.okta_verify.label":"Select Okta Verify.","oie.select.authenticator.verify.named.authenticator.label":"Select {0}.","oie.select.authenticator.enroll.email.label":"Set up Email.","oie.select.authenticator.enroll.password.label":"Set up Password.","oie.select.authenticator.enroll.phone.label":"Set up Phone.","oie.select.authenticator.enroll.webauthn.label":"Set up Security Key or Biometric Authenticator.","oie.select.authenticator.enroll.security.question.label":"Set up Security Question.","oie.select.authenticator.enroll.okta_verify.authenticator.label":"Set up Okta Verify.","oie.select.authenticator.enroll.named.authenticator.label":"Set up {0}.","oie.security.question.label":"Security Question","oie.security.question.enroll.title":"Set up security question","oie.security.question.challenge.title":"Verify with your Security Question","oie.security.question.questionKey.label":"Choose a security question","oie.security.question.createQuestion.label":"Create my own security question","oie.security.question.authenticator.description":"Choose a security question and answer that will be used for signing in","securityQuestion.answer.tooShort.arg":"The security question answer must be at least {0} characters in length","oie.okta_verify.label":"Okta Verify","oie.enroll.okta_verify.setup.subtitle":"To continue, you\'ll need an Okta Verify account on this device.","oie.enroll.okta_verify.setup.download":"If you don\'t have Okta Verify installed, <$1>download the app</$1>.","oie.enroll.okta_verify.setup.openOv":"Open Okta Verify and follow the steps to add your account.","oie.enroll.okta_verify.setup.signInUrl":"When prompted, choose Sign In, then enter the sign-in URL:","oie.enroll.okta_verify.setup.instructions":"Follow the instructions to set up Okta Verify on this device, then return here and refresh this page.","oie.okta_verify.authenticator.description":"Okta Verify is an authenticator app, installed on your phone or computer, used to prove your identity","oie.enroll.okta_verify.setup.title":"Set up Okta Verify","oie.enroll.okta_verify.setup.email.title":"Check your email","oie.enroll.okta_verify.setup.sms.title":"Check your text messages","oie.enroll.okta_verify.setup.skipAuth.subtitle":"To set up Okta Verify on additional devices, you can copy an existing Okta Verify account onto a new device.","oie.enroll.okta_verify.setup.skipAuth.openOv":"Open Okta Verify on any of your other Okta Verify devices (<$1>{0}</$1>).","oie.enroll.okta_verify.setup.skipAuth.openOv.suchAs":"Open Okta Verify on any of your other Okta Verify devices (Such as your <$1>{0}</$1>).","oie.enroll.okta_verify.setup.skipAuth.selectAccount":"In the app, select your account.","oie.enroll.okta_verify.setup.skipAuth.addAccount":"Choose <$1>Add Account to Another Device.</$1>","oie.enroll.okta_verify.setup.skipAuth.followInstruction":"Follow the rest of the instructions shown in Okta Verify.","oie.enroll.okta_verify.setup.skipAuth.canBeClosed":"This screen can be closed at any time.","oie.enroll.okta_verify.setup.customUri.makeSureHaveOVToContinue":"To continue, make sure you have the Okta Verify app.","oie.enroll.okta_verify.setup.customUri.setup":"Once Okta Verify is installed, return to this page and tap <$1>Set up Okta Verify</$1>.","oie.enroll.okta_verify.setup.customUri.prompt":"Click <$1>\\"Open Okta Verify\\"</$1> on the browser prompt to set up Okta Verify.","oie.enroll.okta_verify.setup.customUri.noPrompt":"<$1>Didn\'t see the prompt?</$1>","oie.enroll.okta_verify.setup.customUri.makeSureHaveOV":"Make sure you have Okta Verify installed.","oie.enroll.okta_verify.setup.customUri.orMobile":"Or <$1>set up Okta Verify on another mobile device</$1>","oie.enroll.okta_verify.setup.customUri.orOnMobile":"Or <$1>set up Okta Verify on a mobile device</$1>","oie.enroll.okta_verify.select.channel.description":"Which option do you want to try?","oie.enroll.okta_verify.select.channel.qrcode.label":"Scan a QR code","oie.enroll.okta_verify.select.channel.subtitle":"How would you like to set up Okta Verify?","oie.enroll.okta_verify.select.channel.email.label":"Email me a setup link","oie.enroll.okta_verify.select.channel.sms.label":"Text me a setup link","oie.enroll.okta_verify.select.channel.ovOnThisDevice":"Or <$1>set up Okta Verify on this device</$1>","oie.enroll.okta_verify.select.channel.title":"More options","oie.enroll.okta_verify.select.channel.title.updated":"Set up Okta Verify on another mobile device","oie.enroll.okta_verify.channel.email.label":"Email","oie.enroll.okta_verify.enroll.channel.email.title":"Set up Okta Verify via email link","oie.enroll.okta_verify.enroll.channel.email.subtitle":"Make sure you can access the email on the receiving device","oie.enroll.okta_verify.enroll.channel.sms.title":"Set up Okta Verify via SMS","oie.enroll.okta_verify.channel.email.description":"Make sure you can access the email on your mobile device.","oie.enroll.okta_verify.channel.sms.description":"Make sure you can access the text on your mobile device.","oie.enroll.okta_verify.channel.sms.description.updated":"Make sure you can access the text on the receiving device","oie.enroll.okta_verify.qrcode.title":"Set up Okta Verify via QR code","oie.enroll.okta_verify.qrcode.step1":"On your mobile device, download the Okta Verify app from the App Store (iPhone and iPad) or Google Play (Android devices).","oie.enroll.okta_verify.qrcode.step1.updated":"On your other device, download the Okta Verify app from the App StoreÂ® (iPhoneÂ® and iPadÂ®) or on Google Play (AndroidÂ® devices).","oie.enroll.okta_verify.qrcode.step2":"Open the app and follow the instructions to add your account","oie.enroll.okta_verify.qrcode.step3.updated":"When prompted, tap <$1>Scan a QR code</$1>, then scan the QR code below:","oie.enroll.okta_verify.qrcode.step3":"When prompted, tap Scan a QR code, then scan the QR code below:","oie.enroll.okta_verify.qrcode.cannotScan":"Can\'t scan?","oie.enroll.okta_verify.switch.channel.link.text":"Or <a href=\\"#\\" class=\\"switch-channel-link\\">try a different way</a> to set up Okta Verify.","oie.enroll.okta_verify.email.info":"We sent an email to <span class=\\"strong\\">{0}</span> with an Okta Verify setup link. To continue, open the link on your mobile device.","oie.enroll.okta_verify.email.info.updated":"We sent an email to <$1>{0}</$1> with an Okta Verify setup link. To continue, open the link on your receiving device.","oie.enroll.okta_verify.email.notReceived":"Havenâ€™t received an email? Check your spam folder or <a href=\\"#\\" class=\\"resend-link\\">send again</a>","oie.enroll.okta_verify.sms.info":"We sent an SMS to <span class=\\"strong\\">{0}</span> with an Okta Verify setup link. To continue, open the link on your mobile device.","oie.enroll.okta_verify.sms.info.updated":"We sent an SMS to <$1>{0}</$1> with an Okta Verify setup link. To continue, open the link on your receiving device.","oie.enroll.okta_verify.sms.notReceived":"Havenâ€™t received an SMS? <a href=\\"#\\" class=\\"resend-link\\">Send again</a>","oie.enroll.okta_verify.setupLink":"Send me the setup link","oie.okta_verify.totp.title":"Enter a code","oie.okta_verify.totp.enterCodeText":"Enter code from Okta Verify app","oie.okta_verify.push.title":"Get a push notification","oie.okta_verify.push.sent":"Push notification sent","oie.okta_verify.push.sent.respond_to_continue":"Respond on your mobile device to continue.","oie.okta_verify.push.resend":"Resend push notification","oie.okta_verify.sendPushButton":"Send push","oie.okta_verify.signed_nonce.label":"Use Okta FastPass","oie.okta_verify.enroll.force.upgrade.title":"Update Okta Verify","oie.authenticator.app.non_fips_compliant_enrollment_device_incompatible":"The device used to set up Okta Verify does not meet your organizationâ€™s security requirements because it is not FIPS compliant. Contact your administrator for help.","oie.authenticator.app.non_fips_compliant_enrollment_app_update_required":"The Okta Verify version on the device used does not meet your organizationâ€™s security requirements. To add your account, update Okta Verify to the latest version, then try again.","oie.authenticator.app.method.push.verify.enable.biometrics":"Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date and biometrics are enabled for your account in Okta Verify, then try again.","oie.authenticator.app.method.push.verify.enable.biometrics.title":"Enable biometrics in Okta Verify","oie.authenticator.app.method.push.verify.enable.biometrics.description":"Your response was received, but your organization requires biometrics. Make sure you meet the following requirements, then try again:","oie.authenticator.app.method.push.verify.enable.biometrics.point1":"Your device supports biometrics","oie.authenticator.app.method.push.verify.enable.biometrics.point2":"Okta Verify is up-to-date","oie.authenticator.app.method.push.verify.enable.biometrics.point3":"In Okta Verify, biometrics are enabled for your account","oie.authenticator.app.method.push.enroll.enable.biometrics":"Your organization requires biometrics. To proceed, ensure your device supports biometrics, then add your account and enable biometrics when prompted.","oie.authenticator.app.method.push.enroll.enable.biometrics.title":"Enable biometrics to add an account in Okta Verify","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics":"Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date and biometrics are enabled for your account in Okta Verify, then try again.","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.title":"Enable biometrics in Okta Verify","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.description":"Your response was received, but your organization requires biometrics. Make sure you meet the following requirements, then try again:","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.point1":"Your device supports biometrics","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.point2":"Okta Verify is up-to-date","oie.authenticator.oktaverify.method.totp.verify.enable.biometrics.point3":"In Okta Verify, biometrics are enabled for your account","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.mobile":"Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date and biometrics are enabled for your account in Okta Verify, then try again.","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.desktop":"Your response was received, but your organization requires biometrics. Make sure your device supports biometrics, Okta Verify is up-to-date, biometrics are enabled for your account in Okta Verify and your device\'s biometric sensors are accessible, then try again.","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.title":"Biometrics needed for Okta Verify","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.description":"Your response was received, but your organization requires biometrics. Make sure you meet the following requirements, then try again:","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point1":"Your device supports biometrics","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point2":"Okta Verify is up-to-date","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point3":"In Okta Verify, biometrics are enabled for your account","oie.authenticator.oktaverify.method.fastpass.verify.enable.biometrics.point4":"Your device\'s biometric sensors are accessible","oie.google_authenticator.label":"Google Authenticator","oie.google_authenticator.authenticator.description":"Enter a temporary code generated from the Google Authenticator app.","oie.enroll.google_authenticator.setup.title":"Set up Google Authenticator","oie.enroll.google_authenticator.scanBarcode.title":"Scan QR code","oie.enroll.google_authenticator.scanBarcode.description":"Launch Google Authenticator, tap the \\"+\\" icon, then select \\"Scan a QR code\\".","oie.enroll.google_authenticator.scanBarcode.cannotScan":"Can\'t scan?","oie.enroll.google_authenticator.cannotScanBarcode.title":"Can\'t scan QR code?","oie.enroll.google_authenticator.manualSetupInstructions":"To set up manually enter your Okta Account username and then input the following in the Secret Key Field","oie.enroll.google_authenticator.enterCode.title":"Enter code displayed from application","oie.verify.google_authenticator.otp.title":"Verify with Google Authenticator","oie.verify.google_authenticator.otp.description":"Enter the temporary code generated in your Google Authenticator app","oie.google_authenticator.otp.enterCodeText":"Enter code","oie.verify.custom_otp.title":"Verify with {0}","oie.verify.custom_otp.description":"Enter the code generated on your authenticator and verify.","oie.custom_otp.description":"Enter a temporary code generated from an authenticator device.","oie.custom_otp.authenticator.default.vendorName":"Custom OTP Authenticator","oie.custom_otp.verify.passcode.label":"Enter code","oie.verify.custom_app.title":"Verify with {0}","oie.custom_app.push.sent":"Push notification sent","oie.custom_app.push.resend":"Resend push notification","oie.custom_app.push.warning":"Haven\'t received a push notification yet? Try opening {0} on your phone.","oie.authenticator.custom_app.method.push.verify.enable.biometrics":"Your response was received, but your organization requires biometricsâ€”like a fingerprint or facial scanâ€”for access. Make sure your device meets the following requirements, then try again:","oie.authenticator.custom_app.method.push.verify.enable.biometrics.title":"Enable biometrics in {0}","oie.authenticator.custom_app.method.push.verify.enable.biometrics.description":"Your response was received, but your organization requires biometricsâ€”like a fingerprint or facial scanâ€”for access. Make sure your device meets the following requirements, then try again:","oie.authenticator.custom_app.method.push.verify.enable.biometrics.point1":"Your device supports biometrics","oie.authenticator.custom_app.method.push.verify.enable.biometrics.point2":"{0} is up-to-date","oie.authenticator.custom_app.method.push.verify.enable.biometrics.point3":"In {0}, biometrics are enabled for your account","oie.custom_app.sendPushButton":"Send push","oie.custom_app.push.title":"Get a push notification","oie.on_prem.authenticator.description":"Verify by entering a code generated by {0}.","oie.on_prem.authenticator.default.vendorName":"Custom On-prem Authenticator","oie.on_prem.enroll.title":"Set up {0}","oie.on_prem.verify.title":"Verify with {0}","oie.numberchallenge.warning":"Haven\'t received a push notification yet? Try opening the Okta Verify app on your device, or <$1>resend the push notification</$1>.","oie.numberchallenge.instruction":"On your mobile device, open the Okta Verify prompt, then tap <$1>{0}</$1> in Okta Verify to continue.","oie.numberchallenge.force.upgrade.title":"Update Okta Verify","oie.authenticator.app.method.push.force.upgrade.number_challenge":"Your response was received, but your Okta Verify version is no longer supported by your organization. To verify your identity with push notifications, update Okta Verify to the latest version, then try again.","oie.rsa.authenticator.description":"Verify by entering a code generated by RSA SecurID","oie.duo.authenticator.description":"Verify your identity using Duo Security.","oie.duo.enroll.title":"Set up Duo Security","oie.duo.verify.title":"Verify with Duo Security","oie.duo.iFrameError":"Error loading Duo. Try again or contact your admin for assistance.","oie.authenticator.duo.error":"We were unable to verify with Duo. Try again.","oie.idp.authenticator.description":"Redirect to verify with {0}.","oie.idp.enroll.title":"Set up {0}","oie.idp.enroll.description":"You will be redirected to enroll in {0}","oie.idp.challenge.title":"Verify with {0}","oie.idp.challenge.description":"You will be redirected to verify with {0}","idx.identity.provider.auth.error":"There was a problem signing you into your identity provider. Please contact your administrator for help.","oie.idv.idp.title":"Verify your identity with {0}","oie.idv.idp.desc":"Verify your identity with {0} and share your verification results with Okta to finish setting up your Okta account.","oie.idv.idp.desc.termsOfUse":"{0}\'s <$1>Terms of Use</$1> and <$2>Privacy Policy</$2> will apply to {0}\'s verification of your identity. ","oie.idv.idp.desc.agreement":"By clicking \\"Continue\\", I agree that {0} will share my verification results with Okta.","oie.idv.persona":"Persona","oie.idv.clear":"Clear","oie.idv.incode":"Incode","oie.symantecVip.authenticator.description":"Verify by entering a temporary code from the {0} app.","oie.symantecVip.enroll.title":"Set up {0}","oie.symantecVip.enroll.description":"From the {0} app, enter your credential ID and two consecutive generated codes","oie.symantecVip.challenge.title":"Verify with {0}","oie.symantecVip.challenge.description":"Enter the generated security code from the {0} app.","oie.symantecVip.verify.passcode.label":"Enter security code","oie.yubikey.label":"YubiKey Authenticator","oie.yubikey.authenticator.description":"Verify your identity using YubiKey","oie.yubikey.enroll.title":"Set up YubiKey","oie.yubikey.challenge.title":"Verify with YubiKey","oie.yubikey.description":"Use your YubiKey to insert a verification code.","oie.yubikey.passcode.label":"Insert then tap your YubiKey","oie.custom.app.authenticator.title":"Get a push notification","oie.custom.app.authenticator.description":"{0} is an authenticator app, installed on your phone, used to prove your identity","oie.smartcard.authenticator.description":"Use a physical smart card, such as PIV or CAC, to sign in","oie.select.authenticators.enroll.title":"Set up security methods","oie.select.authenticators.enroll.subtitle":"Security methods help protect your account by ensuring only you have access.","oie.select.authenticators.enroll.subtitle.custom":"Security methods help protect your {0} account by ensuring only you have access.","oie.setup.required":"Set up required","oie.setup.optional":"Set up optional","oie.setup.required.now":"Required now","oie.setup.required.soon":"Required soon","oie.setup.optional.short":"Optional","oie.setup.required.soon.description":"When the deadline passes, you wonâ€™t be able to sign in until you complete setup.","oie.setup.remind.me.later":"Remind me later","oie.optional.authenticator.button.title":"Continue","oie.verify.authenticator.button.text":"Select","oie.enroll.authenticator.button.text":"Set up","oie.enroll.authenticator.usage.text.access.recovery":"Used for access or recovery","oie.enroll.authenticator.usage.text.recovery":"Used for recovery","oie.enroll.authenticator.usage.text.access":"Used for access","oie.select.authenticators.verify.title":"Verify it\'s you with a security method","oie.select.authenticators.verify.subtitle":"Select from the following options","oie.success.text.signingIn":"Signing in","oie.success.text.signingIn.with.ellipsis":"Signing in...","oie.success.text.signingIn.with.appName":"Signing in to {0}","oie.success.text.signingIn.with.appName.android.ov.enrollment":"To continue, tap \\"Open Okta Verify\\"","oie.success.text.signingIn.with.appName.and.identifier":"Signing in to {0} as {1}","oie.go.back":"Go back","oie.enroll.switch.authenticator":"Return to authenticator list","oie.enroll.skip.setup":"Skip set up","oie.enroll.skip.profile":"Skip Profile","oie.verification.switch.authenticator":"Verify with something else","oie.remember":"Keep me signed in","oie.try.again":"Try again","enroll.title.oda":"Download Okta Verify","enroll.title.oda.with.account":"Additional setup required to use Okta FastPass","enroll.title.oda.without.account":"Set up an Okta Verify account","enroll.title.mdm":"Additional setup required","enroll.subtitle.fastpass":"On this device, do you already have an Okta Verify account for {0}?","enroll.option.noaccount.fastpass":"No, I donâ€™t have an account","enroll.option.account.fastpass":"Yes, I already have an account","enroll.explanation.p1":"To sign in using Okta Verify, you will need to set up Okta Verify on this device.","enroll.explanation.p2":"In the app, follow the instructions to add an organizational account. When prompted, choose <span class=\\"semi-strong\\">Sign In</span>, then enter the <span class=\\"semi-strong\\">sign-in URL</span>:","enroll.oda.android.step1":"On Google Play, download the Okta Verify app.","enroll.oda.step1":"Open Okta Verify and follow the steps to add your account.","enroll.oda.step2":"When prompted, choose Sign In, then enter the sign-in URL:","enroll.oda.step3":"Download the Okta Verify app.","enroll.oda.step6":"Finish setting up your account in Okta Verify, then try accessing this app again.","enroll.oda.with.account.explanation":"Okta FastPass is a security method that can sign you in without needing your username.","enroll.oda.with.account.subtitile1":"Already have Okta FastPass enabled for your account?","enroll.oda.with.account.subtitile2":"Need to set up Okta FastPass for your account?","enroll.oda.with.account.step1":"Make sure your Okta Verify is up-to-date, then try signing in again.","enroll.oda.with.account.step2":"If your device has a work profile, make sure you are signing in from the same profile that Okta Verify is installed in.","enroll.oda.with.account.step3":"On certain browsers and applications, Okta FastPass is not supported.","enroll.oda.with.account.step4":"On this device, open the Okta Verify app.","enroll.oda.with.account.step5":"On the list of accounts, tap your account for {0}.","enroll.oda.with.account.step6":"Under the â€œOkta FastPassâ€ section, tap Setup, then follow the instructions.","enroll.oda.with.account.step7":"After your setup is complete, return here to try signing in again.","enroll.oda.without.account.explanation":"To sign in with Okta FastPass, youâ€™ll need to set up Okta Verify on this device.","enroll.oda.without.account.step1":"If you donâ€™t have Okta Verify installed, <a href=\\"{0}\\" target=\\"_blank\\" class=\\"download-ov-link\\" id=\\"download-ov\\">download the app.</a>","enroll.oda.without.account.step4":"Finish setting up your account in Okta Verify, then try signing in again.","enroll.appleStore":"the App Store","enroll.googleStore":"Google Play","enroll.copy.ios":"AppleÂ®, App Store, and the Apple logo are trademarks of Apple Inc.","enroll.copy.android":"Google Play and the Google Play logo are trademarks of Google LLC.","enroll.explanation.mdm":"To access this app, your device needs to meet your organization\'s security requirements. Follow the instructions below to continue.","enroll.oda.org.copyLink":"Copy sign-in URL to clipboard","enroll.oda.org.copyLink.success":"Sign-in URL copied.","enroll.mdm.copyLink":"Copy link to clipboard","enroll.mdm.copyLink.success":"Link copied.","enroll.mdm.step.copyLink":"Tap the Copy Link button below.","enroll.mdm.step.pasteLink":"On this device, open your browser, then paste the copied link into the address bar.","enroll.mdm.step.followInstructions":"Follow the instructions in your browser to set up <$1>{0}</$1>.","enroll.mdm.step.relogin":"Logout and re-login and then try accessing the app again.","oie.safe.mode.title":"Authenticator set up unavailable","idx.error.server.safe.mode.enrollment.unavailable":"Set up is temporarily unavailable due to server maintenance. Try again later.","oie.primaryauth.submit":"Sign in","oie.registration.form.title":"Sign up","oie.registration.form.submit":"Sign Up","oie.registration.form.update.submit":"Submit","oie.registration.form.customize.label":"{0}","oie.registration.form.customize.buttonLabel":"{0}","oie.user.profile.login":"Username","oie.user.profile.lastname":"Last name","oie.user.profile.firstname":"First name","oie.user.profile.primary.email":"Email","oie.user.profile.secondary.email":"Secondary email","oie.user.profile.middleName":"Middle name","oie.user.profile.honorificPrefix":"Honorific prefix","oie.user.profile.honorificSuffix":"Honorific suffix","oie.user.profile.primaryEmail":"Primary email","oie.user.profile.title":"Title","oie.user.profile.displayName":"Display name","oie.user.profile.nickName":"Nickname","oie.user.profile.profileUrl":"Profile URL","oie.user.profile.mobilePhone":"Mobile phone","oie.user.profile.primaryPhone":"Primary phone","oie.user.profile.streetAddress":"Street address","oie.user.profile.city":"City","oie.user.profile.state":"State","oie.user.profile.zipCode":"ZIP Code","oie.user.profile.postalCode":"Postal code","oie.user.profile.countryCode":"Country code","oie.user.profile.postalAddress":"Postal address","oie.user.profile.preferredLanguage":"Preferred language","oie.user.profile.locale":"Locale","oie.user.profile.timezone":"Time zone","oie.user.profile.userType":"User type","oie.user.profile.employeeNumber":"Employee number","oie.user.profile.costCenter":"Cost center","oie.user.profile.organization":"Organization","oie.user.profile.division":"Division","oie.user.profile.department":"Department","oie.user.profile.managerId":"Manager ID","oie.user.profile.manager":"Manager","oie.selfservice.unlock_user.landing.to.app.success.message":"Account successfully unlocked! Verify your account with a security method to continue.","oie.selfservice.unlock_user.landing.to.app.signing.in.message":"Account successfully unlocked!","oie.selfservice.unlock_user.success.message":"You can log in using your existing username and password.","oie.selfservice.unlock_user.failed.message":"We are unable to unlock your account at this time, please contact your administrator","oie.selfservice.user.unlock.not.allowed":"Self Service Unlock is not allowed at this time. Please contact support for assistance.","oie.kmsi.title":"Keep me signed in","oie.kmsi.subtitle":"Sign in and enter security methods less frequently.","oie.kmsi.accept":"Stay signed in","oie.kmsi.reject":"Don\'t stay signed in","idx.session.expired":"You have been logged out due to inactivity. Refresh or return to the sign in screen.","oie.registration.is.not.enabled":"Sign up is not enabled for this organization.","oie.forgot.password.is.not.enabled":"Forgot password is not enabled for this organization.","idx.return.error":"Could not process this email link. Return to the screen where you requested it.","idx.return.stale":"This email link is out of date. Return to the screen where you requested it.","idx.invalid.forgot.password.token":"Your reset password token is no longer valid.","idx.invalid.reset.password.token":"Your reset password token is no longer valid. Contact your administrator to obtain a new token.","idx.reset.password.activating.user":"Reset password cannot be performed while the user is activating. Contact your administrator to obtain a new token.","core.system.transaction_resource_not_found":"Verification timed out. Please try again","tagsNotAllowed":"The field must not contain HTML tags","api.authn.error.PASSCODE_INVALID":"Invalid code. Try again.","oie.feature.disabled":"The requested feature is not enabled in this environment.","authfactor.challenge.suspended_factor":"This factor is suspended for your account due to too many failed attempts","oie.post.password.update.auth.failure.error":"Your password has been updated but there was a problem signing you in. Please try again or contact your administrator.","oie.assurance.unsatisfiable":"Unable to login to \\"{0}\\" at this time. For assistance, please contact your administrator.","errors.E0000150":"You have reached the limit of sms requests, please try again later.","errors.E0000151":"You have reached the limit of call requests, please try again later.","oie.invalid.recovery.token":"The recovery token is invalid.","oie.consent.scopes.admin.title":"would like to access:","oie.consent.scopes.enduser.title":"would like to:","oie.consent.scopes.granular.title":"<$1>{0}</$1> <$2>wants to access</$2>","oie.consent.scopes.granular.description":"Allowing access will share","oie.consent.enduser.accept.label":"Yes, it\'s me","oie.consent.enduser.deny.label":"No, it\'s not me","oie.consent.enduser.title":"Did you just try to sign in?","oie.consent.enduser.email.allow.title":"Success! Return to the original tab or window","oie.consent.enduser.email.allow.description":"To continue, please return to the original browser tab or window you used to verify.","oie.consent.enduser.deny.description":"Close this window anytime.","oie.return.to.original.tab":"Close this window anytime.","idx.operation.cancelled.by.user":"Operation cancelled by user.","idx.transferred.to.new.tab":"Flow continued in a new tab.","idx.return.link.expired":"This email link has expired. To resend it, return to the screen where you requested it.","idx.return.link.otponly.your.verification.code":"Your verification code","idx.return.link.otponly.enter.code.on.page":"Enter this code on the {0} page.","idx.return.link.otponly.enter.code.on.page.sign.in":"sign-in","idx.return.link.otponly.enter.code.on.page.password.reset":"password reset","idx.return.link.otponly.enter.code.on.page.account.unlock":"account unlock","idx.return.link.otponly.enter.code.on.page.registration":"sign up","idx.return.link.otponly.enter.code.on.sign.in.page":"Enter this code on the sign-in page.","idx.return.link.otponly.enter.code.on.password.reset.page":"Enter this code on the password reset page.","idx.return.link.otponly.enter.code.on.account.unlock.page":"Enter this code on the account unlock page.","idx.return.link.otponly.enter.code.on.sign.up.page":"Enter this code on the sign up page.","idx.return.link.otponly.request":"Request from:","idx.return.link.otponly.warning.text":"If you didnâ€™t request this code, you can ignore this message. Your account is safe and can only be accessed with this code.","idx.enter.otp.in.original.tab":"Enter the OTP in your original authentication location.","idx.return.link.otponly.app":"{0}","idx.return.link.otponly.browser.on.os":"{0} on {1}","geolocation.formatting.all":"{0}, {1}, {2}","geolocation.formatting.partial":"{0}, {1}","consent.scopes.email.label":"View your email address.","consent.scopes.profile.label":"View your profile information.","consent.scopes.phone.label":"View your phone number.","consent.scopes.address.label":"View your address.","consent.scopes.offlineAccess.label":"Keep you signed in to the app.","consent.scopes.onlineAccess.label":"Keep you signed in to the app.","consent.scopes.deviceSSO.label":"Request device secret.","consent.scopes.openid.desc":"Signals that a request is an OpenID request.","consent.scopes.profile.desc":"The exact data varies based on what profile information you have provided, such as: name, time zone, picture, or birthday.","consent.scopes.email.desc":"This allows the app to view your email address.","consent.scopes.address.desc":"This allows the app to view your address, such as: street address, city, state, and zip code.","consent.scopes.phone.desc":"This allows the app to view your phone number.","consent.scopes.offlineAccess.desc":"This keeps you signed in to the app, even when you are not using it.","consent.scopes.onlineAccess.desc":"This allows the app to access your data only when you are logged in to the application.","consent.scopes.deviceSSO.desc":"This allows you to single sign on between native client applications on your device.","consent.scopes.okta.users.manage.desc":"Allows the app to create new users and to manage all users\'\' profile and credentials information.","consent.scopes.okta.users.manage.self.desc":"Allows the app to manage the signed-in user\'\'s profile and credentials.","consent.scopes.okta.users.read.desc":"Allows the app to read the existing users\'\' profiles and credentials.","consent.scopes.okta.users.read.self.desc":"Allows the app to read the signed-in user\'\'s profile and credentials.","consent.scopes.okta.linkedObjects.manage.desc":"Allows the app to manage linked object definitions in your Okta organization.","consent.scopes.okta.linkedObjects.read.desc":"Allows the app to read linked object definitions in your Okta organization.","consent.scopes.okta.myAccount.manage.desc":"Allows the end-user to manage their account profile.","consent.scopes.okta.myAccount.read.desc":"Allows the end-user to read their account profile.","consent.scopes.okta.riskEvents.manage.desc":"Allows the app to publish risk events to your Okta organization.","consent.scopes.okta.clients.manage.desc":"Allows the app to manage clients in your Okta organization.","consent.scopes.okta.clients.read.desc":"Allows the app to read information about clients in your Okta organization.","consent.scopes.okta.clients.register.desc":"Allows the app to create new clients in your Okta organization.","consent.scopes.okta.authorizationServers.manage.desc":"Allows the app to create and manage Authorization Servers in your Okta organization.","consent.scopes.okta.authorizationServers.read.desc":"Allows the app to read information about Authorization Servers in your Okta organization.","consent.scopes.okta.groups.manage.desc":"Allows the app to manage existing groups in your Okta organization.","consent.scopes.okta.groups.read.desc":"Allows the app to read information about groups and their members in your Okta organization.","consent.scopes.okta.groups.register.desc":"Allows the app to create new groups in your Okta organization.","consent.scopes.okta.events.read.desc":"Allows the app to read information about deprecated Events v1 API entries in your Okta organization.","consent.scopes.okta.logs.read.desc":"Allows the app to read information about System Log entries in your Okta organization.","consent.scopes.okta.inlineHooks.manage.desc":"Allows the app to create and manage Inline Hooks in your Okta organization.","consent.scopes.okta.inlineHooks.read.desc":"Allows the app to read information about Inline Hooks in your Okta organization.","consent.scopes.okta.eventHooks.manage.desc":"Allows the app to create and manage Event Hooks in your Okta organization.","consent.scopes.okta.eventHooks.read.desc":"Allows the app to read information about Event Hooks in your Okta organization.","consent.scopes.okta.apps.manage.desc":"Allows the app to create and manage Apps in your Okta organization.","consent.scopes.okta.apps.read.desc":"Allows the app to read information about Apps in your Okta organization.","consent.scopes.okta.schemas.manage.desc":"Allows the app to create and manage Schemas in your Okta organization.","consent.scopes.okta.schemas.read.desc":"Allows the app to read information about Schemas in your Okta organization.","consent.scopes.okta.idps.manage.desc":"Allows the app to create and manage Identity Providers in your Okta organization.","consent.scopes.okta.idps.read.desc":"Allows the app to read information about Identity Providers in your Okta organization.","consent.scopes.okta.roles.manage.desc":"Allows the app to manage administrative role assignments for users in your Okta organization.","consent.scopes.okta.roles.read.desc":"Allows the app to read administrative role assignments for users in your Okta organization.","consent.scopes.okta.policies.manage.desc":"Allows the app to manage policies in your Okta organization.","consent.scopes.okta.policies.read.desc":"Allows the app to read information about policies in your Okta organization.","consent.scopes.okta.orgs.manage.desc":"Allows the app to manage organization-specific details for your Okta organization.","consent.scopes.okta.orgs.read.desc":"Allows the app to read organization-specific details about your Okta organization.","consent.scopes.okta.captchas.manage.desc":"Allows the app to create and manage CAPTCHAs in your Okta organization.","consent.scopes.okta.captchas.read.desc":"Allows the app to read information about CAPTCHAs in your Okta organization.","consent.scopes.okta.sessions.manage.desc":"Allows the app to manage all sessions in your Okta organization.","consent.scopes.okta.sessions.read.desc":"Allows the app to read all sessions in your Okta organization.","consent.scopes.okta.trustedOrigins.manage.desc":"Allows the app to manage all Trusted Origins in your Okta organization.","consent.scopes.okta.trustedOrigins.read.desc":"Allows the app to read all Trusted Origins in your Okta organization.","consent.scopes.okta.templates.manage.desc":"Allows the app to manage all custom templates in your Okta organization.","consent.scopes.okta.templates.read.desc":"Allows the app to read all custom templates in your Okta organization.","consent.scopes.okta.factors.manage.desc":"Allows the app to manage all admin operations for org factors (e.g. activate, deactivate, read).","consent.scopes.okta.factors.read.desc":"Allows the app to read org factors information.","consent.scopes.okta.authenticators.manage.desc":"Allows the app to manage all security methods (e.g. enrollments, reset).","consent.scopes.okta.authenticators.read.desc":"Allows the app to read org security method information.","consent.scopes.okta.authenticators.manage.self.desc":"Allows the app to manage users own security methods (e.g. enrollments, reset).","consent.scopes.idSnapshot.read.desc":"Allows the app to read your identity snapshot attestation.","consent.scopes.idSnapshot.manage.desc":"Allows the app to create and manage your identity snapshot attestation.","logo.for.the.app.alt.text":"Logo for the app","device.code.activate.title":"Activate your device","device.code.activate.subtitle":"Follow the instructions on your device to get an activation code","device.code.activate.label":"Activation Code","device.code.activated.success.title":"Device activated","device.code.activated.error.title":"Device not activated","idx.device.activated":"Follow the instructions on your device for next steps","idx.device.not.activated.consent.denied":"Your device cannot be activated because you did not allow access","idx.device.not.activated.internal.error":"Your device cannot be activated because of an internal error","idx.invalid.device.code":"Invalid code. Try again.","idx.operation.cancelled.on.other.device":"Access denied on other device.","idx.expired.activation.token":"Your account activation link is no longer valid. Request a new activation email below.","idx.missing.activation.token":"This can happen if you have already activated your account, or if the URL you are trying to use is invalid. Contact your administrator for further assistance.","idx.activating.inactive.user":"Your account has been temporarily suspended. Contact your administrator for further assistance.","idx.request.activation.email":"New activation link requested. If your information matches our records, you will receive a new activation link in your inbox soon.","oie.activation.request.email.title.expire":"Activation link has expired","oie.activation.request.email.title.invalid":"Activation link no longer valid","oie.activation.request.email.title.suspended":"Account suspended","oie.activation.request.email.title.submitted":"Request submitted","oie.activation.request.email.button":"Request activation email","oie.browser.error.NotAllowedError":"The operation either timed out or was not allowed.","authfactor.challenge.soft_token.invalid_passcode":"Your code doesn\'t match our records. Please try again.","authfactor.challenge.soft_token.used_passcode":"Each code can only be used once. Please wait for a new code and try again.","oie.tooManyRequests":"Too many attempts. Try again later.","E0000010":"Server is unable to respond at the moment.","idx.error.registration.unavailable":"Registration is currently unavailable.","idx.error.user.not.assigned.to.app":"User is not assigned to this application.","idx.error.code.user_not_assigned":"You are not allowed to access this app. To request access, contact an admin.","idx.error.code.access_denied.device_assurance.remediation.title":"Your device doesn\'t meet the security requirements","idx.error.code.access_denied.device_assurance.remediation.explanation_one_rule":"To sign in, make the following updates. Then, access the app again.","idx.error.code.access_denied.device_assurance.remediation.explanation_multiple_rules":"To sign in, pick an option and make the updates. Then, access the app again.","idx.error.code.access_denied.device_assurance.remediation.option_index":"Option {0}:","idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version":"Update to Android {0}","idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version.at_least":"Update to at least Android {0}","idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version.exactly":"Update to exactly Android {0}","idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version.one_of_the_following":"Update to one of the following: Android {0}","idx.error.code.access_denied.device_assurance.remediation.android.upgrade_os_version.exactly_one_of_the_following":"Update to exactly one of the following: Android {0}","idx.error.code.access_denied.device_assurance.remediation.android.device_disk_encrypted":"Encrypt your device","idx.error.code.access_denied.device_assurance.remediation.android.use_lock_screen":"Enable lock screen","idx.error.code.access_denied.device_assurance.remediation.android.use_biometric_lock_screen":"Enable lock screen and biometrics","idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version":"Update to iOS {0}","idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version.at_least":"Update to at least iOS {0}","idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version.exactly":"Update to exactly iOS {0}","idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version.one_of_the_following":"Update to one of the following: iOS {0}","idx.error.code.access_denied.device_assurance.remediation.ios.upgrade_os_version.exactly_one_of_the_following":"Update to exactly one of the following: iOS {0}","idx.error.code.access_denied.device_assurance.remediation.ios.use_lock_screen":"Set a passcode for the lock screen","idx.error.code.access_denied.device_assurance.remediation.ios.use_biometric_lock_screen":"Set a passcode for the lock screen and enable Touch ID or Face ID","idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version":"Update to macOS {0}","idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version.at_least":"Update to at least macOS {0}","idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version.exactly":"Update to exactly macOS {0}","idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version.one_of_the_following":"Update to one of the following: macOS {0}","idx.error.code.access_denied.device_assurance.remediation.macos.upgrade_os_version.exactly_one_of_the_following":"Update to exactly one of the following: macOS {0}","idx.error.code.access_denied.device_assurance.remediation.macos.use_lock_screen":"Set a passcode for the lock screen","idx.error.code.access_denied.device_assurance.remediation.macos.device_disk_encrypted":"Turn on FileVault","idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version":"Update to Windows {0}","idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version.at_least":"Update to at least Windows {0}","idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version.exactly":"Update to exactly Windows {0}","idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version.one_of_the_following":"Update to one of the following: Windows {0}","idx.error.code.access_denied.device_assurance.remediation.windows.upgrade_os_version.exactly_one_of_the_following":"Update to exactly one of the following: Windows {0}","idx.error.code.access_denied.device_assurance.remediation.windows.device_disk_encrypted":"Encrypt all internal disks with BitLocker","idx.error.code.access_denied.device_assurance.remediation.windows.use_biometric_lock_screen":"Enable Windows Hello for the lock screen","idx.error.code.access_denied.device_assurance.remediation.additional_help_default":"For more information, follow the instructions on <$1>the help page</$1> or contact your administrator for help","idx.error.code.access_denied.device_assurance.remediation.additional_help_custom":"For more information, follow the instructions on <$1>your organization\'s help page</$1> or contact your administrator for help","idx.error.code.access_denied.device_assurance.remediation.chrome.disk_encrypted":"Turn on disk encryption","idx.error.code.access_denied.device_assurance.remediation.chrome.os_firewall":"Turn on your device\'s firewall","idx.error.code.access_denied.device_assurance.remediation.chrome.screen_lock_secured":"Turn on automatic screen saver and screen locking when idle","idx.error.code.access_denied.device_assurance.remediation.chrome.upgrade_browser_version":"Update Chrome browser to {0}","idx.error.code.access_denied.device_assurance.remediation.chrome.chromeos.upgrade_os_version":"Update to ChromeOS {0}","idx.error.code.access_denied.device_assurance.remediation.chrome.chromeos.key_trust_level.verified_mode":"Switch your device to verified mode","idx.error.code.access_denied.device_assurance.remediation.chrome.chromeos.key_trust_level.developer_mode":"Switch your device to developer mode","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.play_protect_required":"Please ensure Google Play Protect is enabled and that a scan has been performed, then try accessing this application again.","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.play_protect_scan_threshold":"There is a problem with your Google Play Protect system scan. Please open Google Play and take action on the warnings displayed.","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.version_update_available":"Your device has an OS update available. Please update your device then log in again.","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.disable_usb_debugging":"Turn off USB debugging from Developer Options","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.lock_screen_complexity":"Your lock screen doesn\'t meet complexity requirements.","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.disable_network_proxy":"Your device is using a network proxy. Please disable it then try again.","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.unsecured_wifi_network":"Your WiFi network isn\'t secure. Please disconnect and try again from your phone\'s mobile cellular connection.","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.android_device_policy_app_required":"Install the Android Device Policy app on this device","idx.error.code.access_denied.device_assurance.remediation.android.zero.trust.android_device_policy_app_required_manual_install":"Go to <$1>Settings in Okta Verify</$1> and follow the instructions to install the Android Device Policy app","idx.device_assurance.grace_period.title":"Device assurance reminder","idx.device_assurance.grace_period.warning.title.due_by_date":"Your device doesn\'t meet the security requirements. Fix the issue by {0} to prevent lockout.","idx.device_assurance.grace_period.continue_to_app":"Continue to app","oie.enrollment.policy.grace.period.required.today":"Required today","oie.enrollment.policy.grace.period.required.in.days":"Required in {0} days","oie.enrollment.policy.grace.period.required.in.one.day":"Required in 1 day","api.policy.okta.account.management.insufficient.authenticators.unable.to.sign.in":"Unable to sign in. Contact support for assistance."}'
					);
				},
				7174: function (e) {
					'use strict';
					e.exports = JSON.parse(
						'{"defaultLanguage":"en","version":"7.31.2","supportedLanguages":["en","cs","da","de","el","es","fi","fr","ht","hu","id","in","it","ja","ko","ms","nb","nl-NL","ok-PL","ok-SK","pl","pt-BR","ro","ru","sv","th","tr","uk","vi","zh-CN","zh-TW"]}'
					);
				},
			},
			t = {};
		function n(r) {
			var o = t[r];
			if (void 0 !== o) return o.exports;
			var i = (t[r] = { exports: {} });
			return e[r].call(i.exports, i, i.exports, n), i.exports;
		}
		return (
			(n.n = function (e) {
				var t =
					e && e.__esModule
						? function () {
								return e.default;
						  }
						: function () {
								return e;
						  };
				return n.d(t, { a: t }), t;
			}),
			(n.d = function (e, t) {
				for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
			}),
			(n.o = function (e, t) {
				return Object.prototype.hasOwnProperty.call(e, t);
			}),
			(n.r = function (e) {
				'undefined' != typeof Symbol &&
					Symbol.toStringTag &&
					Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
					Object.defineProperty(e, '__esModule', { value: !0 });
			}),
			n(21576),
			n(74270),
			n(92484)
		);
	})();
});
//# sourceMappingURL=okta-sign-in.min.js.map

/*! For license information please see okta-auth-js.min.js.LICENSE.txt */
var OktaAuth;!function(){var e={97:function(e,t,r){"use strict";var n=r(4836);t.AuthnTransactionImpl=void 0;var o=n(r(9728)),a=n(r(6690)),i=n(r(8416)),u=r(6693),c=(0,o.default)((function e(t,r){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;(0,a.default)(this,e),(0,i.default)(this,"next",void 0),(0,i.default)(this,"cancel",void 0),(0,i.default)(this,"skip",void 0),(0,i.default)(this,"unlock",void 0),(0,i.default)(this,"changePassword",void 0),(0,i.default)(this,"resetPassword",void 0),(0,i.default)(this,"answer",void 0),(0,i.default)(this,"recovery",void 0),(0,i.default)(this,"verify",void 0),(0,i.default)(this,"resend",void 0),(0,i.default)(this,"activate",void 0),(0,i.default)(this,"poll",void 0),(0,i.default)(this,"prev",void 0),(0,i.default)(this,"data",void 0),(0,i.default)(this,"stateToken",void 0),(0,i.default)(this,"sessionToken",void 0),(0,i.default)(this,"status",void 0),(0,i.default)(this,"user",void 0),(0,i.default)(this,"factor",void 0),(0,i.default)(this,"factors",void 0),(0,i.default)(this,"policy",void 0),(0,i.default)(this,"scopes",void 0),(0,i.default)(this,"target",void 0),(0,i.default)(this,"authentication",void 0),this.data=void 0,this.status=void 0,n&&(this.data=n,Object.assign(this,(0,u.flattenEmbedded)(t,r,n,n,{})),delete this.stateToken,"RECOVERY_CHALLENGE"!==n.status||n._links||(this.cancel=function(){return Promise.resolve(r.createTransaction())}))}));t.AuthnTransactionImpl=c},9859:function(e,t,r){"use strict";var n=r(4836);t.getSavedStateToken=l,t.introspectAuthn=function(e,t,r){if(!r||!r.stateToken){var n=l(e);if(!n)return Promise.reject(new a.default("No transaction to evaluate"));r={stateToken:n}}return s(e,r).then((function(e){return t.createTransaction(e)}))},t.postToTransaction=function(e,t,r,n,a){return a=Object.assign({withCredentials:!0},a),(0,o.post)(e,r,n,a).then((function(e){return t.createTransaction(e)}))},t.resumeTransaction=function(e,t,r){if(!r||!r.stateToken){var n=l(e);if(!n)return Promise.reject(new a.default("No transaction to resume"));r={stateToken:n}}return c(e,r).then((function(e){return t.createTransaction(e)}))},t.transactionExists=function(e){return!!l(e)},t.transactionStatus=c,t.transactionStep=s;var o=r(4777),a=n(r(9123)),i=r(1971),u=r(1349);function c(e,t){return t=(0,u.addStateToken)(e,t),(0,o.post)(e,e.getIssuerOrigin()+"/api/v1/authn",t,{withCredentials:!0})}function s(e,t){return t=(0,u.addStateToken)(e,t),(0,o.post)(e,e.getIssuerOrigin()+"/api/v1/authn/introspect",t,{withCredentials:!0})}function l(e){return e.options.storageUtil.storage.get(i.STATE_TOKEN_KEY_NAME)}},8248:function(e,t,r){"use strict";t.createAuthnTransactionAPI=function(e){var t={status:n.transactionStatus.bind(null,e),resume:function(r){return(0,n.resumeTransaction)(e,t,r)},exists:n.transactionExists.bind(null,e),introspect:function(r){return(0,n.introspectAuthn)(e,t,r)},createTransaction:function(r){return new o.AuthnTransactionImpl(e,t,r)},postToTransaction:function(r,o,a){return(0,n.postToTransaction)(e,t,r,o,a)}};return t};var n=r(9859),o=r(97)},3398:function(e,t,r){"use strict";var n=r(8248);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(3164);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(2576);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}))},3164:function(e,t,r){"use strict";var n=r(4836);t.mixinAuthn=function(e){return function(e){(0,s.default)(b,e);var t,r,n,y,g=(t=b,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,f.default)(t);if(r){var o=(0,f.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,l.default)(this,e)});function b(){var e;(0,i.default)(this,b);for(var t=arguments.length,r=new Array(t),n=0;n<t;n++)r[n]=arguments[n];return e=g.call.apply(g,[this].concat(r)),(0,d.default)((0,c.default)(e),"tx",void 0),(0,d.default)((0,c.default)(e),"authn",void 0),(0,d.default)((0,c.default)(e),"fingerprint",void 0),e.authn=e.tx=(0,v.createAuthnTransactionAPI)((0,c.default)(e)),e.fingerprint=h.default.bind(null,(0,c.default)(e)),e}return(0,u.default)(b,[{key:"signIn",value:(y=(0,a.default)(o.default.mark((function e(t){var r,n=this;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=(0,p.clone)(t||{}),r=function(e){return delete t.sendFingerprint,n.tx.postToTransaction("/api/v1/authn",t,e)},t.sendFingerprint){e.next=4;break}return e.abrupt("return",r());case 4:return e.abrupt("return",this.fingerprint().then((function(e){return r({headers:{"X-Device-Fingerprint":e}})})));case 5:case"end":return e.stop()}}),e,this)}))),function(e){return y.apply(this,arguments)})},{key:"signInWithCredentials",value:(n=(0,a.default)(o.default.mark((function e(t){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.signIn(t));case 1:case"end":return e.stop()}}),e,this)}))),function(e){return n.apply(this,arguments)})},{key:"forgotPassword",value:function(e){return this.tx.postToTransaction("/api/v1/authn/recovery/password3",e)}},{key:"unlockAccount",value:function(e){return this.tx.postToTransaction("/api/v1/authn/recovery/unlock",e)}},{key:"verifyRecoveryToken",value:function(e){return this.tx.postToTransaction("/api/v1/authn/recovery/token",e)}}]),b}(e)};var o=n(r(4687)),a=n(r(7156)),i=n(r(6690)),u=n(r(9728)),c=n(r(6115)),s=n(r(1655)),l=n(r(4993)),f=n(r(3808)),d=n(r(8416)),p=r(305),h=n(r(8719)),v=r(8248)},2576:function(){},6693:function(e,t,r){"use strict";t.flattenEmbedded=function e(t,r,a,i,u){if(i=i||a,i=(0,n.clone)(i),Array.isArray(i)){for(var c=[],s=0,l=i.length;s<l;s++)c.push(e(t,r,a,i[s],u));return c}var f=i._embedded||{};for(var d in f)Object.prototype.hasOwnProperty.call(f,d)&&((0,n.isObject)(f[d])||Array.isArray(f[d]))&&(f[d]=e(t,r,a,f[d],u));var p=(0,o.links2fns)(t,r,a,i,u);return Object.assign(f,p),i=(0,n.omit)(i,"_embedded","_links"),Object.assign(i,f),i};var n=r(305),o=r(9265)},8657:function(e,t,r){"use strict";var n=r(4836);t.link2fn=function e(t,r,n,s,l,f){if(Array.isArray(l))return function(i,u){if(!i)throw new a.default("Must provide a link name");var c=(0,o.find)(l,{name:i});if(!c)throw new a.default("No link found for that name");return e(t,r,n,s,c,f)(u)};if(l.hints&&l.hints.allow&&1===l.hints.allow.length)switch(l.hints.allow[0]){case"GET":return function(){return(0,i.get)(t,l.href,{withCredentials:!0})};case"POST":return function(e){f&&f.isPolling&&(f.isPolling=!1);var i=(0,c.addStateToken)(n,e);"MFA_ENROLL"!==n.status&&"FACTOR_ENROLL"!==n.status||Object.assign(i,{factorType:s.factorType,provider:s.provider});var d={},p=i.autoPush;if(void 0!==p){if("function"==typeof p)try{d.autoPush=!!p()}catch(e){return Promise.reject(new a.default("AutoPush resulted in an error."))}else null!==p&&(d.autoPush=!!p);i=(0,o.omit)(i,"autoPush")}var h=i.rememberDevice;if(void 0!==h){if("function"==typeof h)try{d.rememberDevice=!!h()}catch(e){return Promise.reject(new a.default("RememberDevice resulted in an error."))}else null!==h&&(d.rememberDevice=!!h);i=(0,o.omit)(i,"rememberDevice")}else i.profile&&void 0!==i.profile.updatePhone&&(i.profile.updatePhone&&(d.updatePhone=!0),i.profile=(0,o.omit)(i.profile,"updatePhone"));var v=l.href+(0,o.toQueryString)(d);return(0,u.postToTransaction)(t,r,v,i)}}};var o=r(305),a=n(r(9123)),i=r(4777),u=r(9859),c=r(1349)},9265:function(e,t,r){"use strict";t.links2fns=function(e,t,r,a,i){var u={};for(var c in a._links)if(Object.prototype.hasOwnProperty.call(a._links,c)){var s=a._links[c];if("next"===c&&(c=s.name),s.type)u[c]=s;else if("poll"===c)u.poll=(0,o.getPollFn)(e,r,i);else{var l=(0,n.link2fn)(e,t,r,a,s,i);l&&(u[c]=l)}}return u};var n=r(8657),o=r(3749)},3749:function(e,t,r){"use strict";var n=r(4836);t.getPollFn=function(e,t,r){return function(n){var l,f,d,p;(0,a.isNumber)(n)?l=n:(0,a.isObject)(n)&&(l=n.delay,f=n.rememberDevice,d=n.autoPush,p=n.transactionCallBack),l||0===l||(l=i.DEFAULT_POLLING_DELAY);var h=(0,a.getLink)(t,"next","poll");r.isPolling=!0;var v=0;return function n(){return r.isPolling?function(){var r={};if("function"==typeof d)try{r.autoPush=!!d()}catch(e){return Promise.reject(new u.default("AutoPush resulted in an error."))}else null!=d&&(r.autoPush=!!d);if("function"==typeof f)try{r.rememberDevice=!!f()}catch(e){return Promise.reject(new u.default("RememberDevice resulted in an error."))}else null!=f&&(r.rememberDevice=!!f);var n=h.href+(0,a.toQueryString)(r);return(0,o.post)(e,n,(0,s.getStateToken)(t),{saveAuthnState:!1,withCredentials:!0})}().then((function(t){if(v=0,t.factorResult&&"WAITING"===t.factorResult){if(!r.isPolling)throw new c.default;return"function"==typeof p&&p(t),(0,a.delay)(l).then(n)}return r.isPolling=!1,e.tx.createTransaction(t)})).catch((function(e){if(e.xhr&&(0===e.xhr.status||429===e.xhr.status)&&v<=4){var t=1e3*Math.pow(2,v);return v++,(0,a.delay)(t).then(n)}throw e})):Promise.reject(new c.default)}().catch((function(e){throw r.isPolling=!1,e}))}};var o=r(4777),a=r(305),i=r(1971),u=n(r(9123)),c=n(r(6573)),s=(r(2576),r(1349))},1349:function(e,t){"use strict";function r(e,t){var r={};return Object.assign(r,t),!r.stateToken&&e.stateToken&&(r.stateToken=e.stateToken),r}t.addStateToken=r,t.getStateToken=function(e){return r(e)}},9893:function(e,t,r){"use strict";var n=r(4836),o=r(8698);t.createOktaAuthBase=function(e){var t=(0,a.default)((function t(){(0,i.default)(this,t),(0,u.default)(this,"options",void 0),(0,u.default)(this,"emitter",void 0),(0,u.default)(this,"features",void 0);var r=new e(arguments.length&&(arguments.length<=0?void 0:arguments[0])||{});this.options=(0,c.removeNils)(r),this.emitter=new f.default,this.features=s}));return(0,u.default)(t,"features",s),(0,u.default)(t,"constants",l),t.features=t.prototype.features=s,Object.assign(t,{constants:l}),t};var a=n(r(9728)),i=n(r(6690)),u=n(r(8416)),c=r(305),s=p(r(415)),l=p(r(1971)),f=n(r(4279));function d(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(d=function(e){return e?r:t})(e)}function p(e,t){if(!t&&e&&e.__esModule)return e;if(null===e||"object"!==o(e)&&"function"!=typeof e)return{default:e};var r=d(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var u=a?Object.getOwnPropertyDescriptor(e,i):null;u&&(u.get||u.set)?Object.defineProperty(n,i,u):n[i]=e[i]}return n.default=e,r&&r.set(e,n),n}},3306:function(e,t,r){"use strict";var n=r(9893);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(5093);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(6429);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}))},5093:function(e,t,r){"use strict";var n=r(4836);t.createBaseOptionsConstructor=function(){return(0,o.default)((function e(t){(0,a.default)(this,e),(0,i.default)(this,"devMode",void 0),this.devMode=!!t.devMode}))};var o=n(r(9728)),a=n(r(6690)),i=n(r(8416))},6429:function(){},5407:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(646)),a=n(r(9123)),i=r(305),u=r(415),c={browserHasLocalStorage:function(){try{var e=this.getLocalStorage();return this.testStorage(e)}catch(e){return!1}},browserHasSessionStorage:function(){try{var e=this.getSessionStorage();return this.testStorage(e)}catch(e){return!1}},testStorageType:function(e){var t=!1;switch(e){case"sessionStorage":t=this.browserHasSessionStorage();break;case"localStorage":t=this.browserHasLocalStorage();break;case"cookie":case"memory":t=!0;break;default:t=!1}return t},getStorageByType:function(e,t){var r;switch(e){case"sessionStorage":r=this.getSessionStorage();break;case"localStorage":r=this.getLocalStorage();break;case"cookie":r=this.getCookieStorage(t);break;case"memory":r=this.getInMemoryStorage();break;default:throw new a.default("Unrecognized storage option: ".concat(e))}return r},findStorageType:function(e){var t,r;return t=(e=e.slice()).shift(),(r=e.length?e[0]:null)?this.testStorageType(t)?t:((0,i.warn)("This browser doesn't support ".concat(t,". Switching to ").concat(r,".")),this.findStorageType(e)):t},getLocalStorage:function(){return(0,u.isIE11OrLess)()&&!window.onstorage&&(window.onstorage=function(){}),localStorage},getSessionStorage:function(){return sessionStorage},getCookieStorage:function(e){var t=this,r=e.secure,n=e.sameSite,o=e.sessionCookie;if(void 0===r||void 0===n)throw new a.default('getCookieStorage: "secure" and "sameSite" options must be provided');var i={getItem:this.storage.get,setItem:function(e,a){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"2200-01-01T00:00:00.000Z";i=o?null:i,t.storage.set(e,a,i,{secure:r,sameSite:n})},removeItem:function(e){t.storage.delete(e)}};return e.useSeparateCookies?{getItem:function(e){var t=i.getItem(),r={};return Object.keys(t).forEach((function(n){0===n.indexOf(e)&&(r[n.replace("".concat(e,"_"),"")]=JSON.parse(t[n]))})),JSON.stringify(r)},setItem:function(e,t){var r=JSON.parse(this.getItem(e));t=JSON.parse(t),Object.keys(t).forEach((function(n){var o=e+"_"+n,a=JSON.stringify(t[n]);i.setItem(o,a),delete r[n]})),Object.keys(r).forEach((function(t){i.removeItem(e+"_"+t)}))},removeItem:function(e){var t=JSON.parse(this.getItem(e));Object.keys(t).forEach((function(t){i.removeItem(e+"_"+t)}))}}:i},inMemoryStore:{},getInMemoryStorage:function(){var e=this;return{getItem:function(t){return e.inMemoryStore[t]},setItem:function(t,r){e.inMemoryStore[t]=r}}},testStorage:function(e){var t="okta-test-storage";try{return e.setItem(t,t),e.removeItem(t),!0}catch(e){return!1}},storage:{set:function(e,t,r,n){var i=n.sameSite,u=n.secure;if(void 0===u||void 0===i)throw new a.default('storage.set: "secure" and "sameSite" options must be provided');var c={path:n.path||"/",secure:u,sameSite:i};return Date.parse(r)&&(c.expires=new Date(r)),o.default.set(e,t,c),this.get(e)},get:function(e){return arguments.length?o.default.get(e):o.default.get()},delete:function(e){return o.default.remove(e,{path:"/"})}}},s=c;t.default=s,e.exports=t.default},8719:function(e,t,r){"use strict";t.default=function(e,t){return t=t||{},(0,o.isFingerprintSupported)()?new Promise((function(o,c){var s;(i=document.createElement("iframe")).style.display="none",u=function(t){if(t&&t.data&&t.origin===e.getIssuerOrigin()){try{var r=JSON.parse(t.data)}catch(e){return}if(r)return"FingerprintAvailable"===r.type?o(r.fingerprint):void("FingerprintServiceReady"===r.type&&t.source.postMessage(JSON.stringify({type:"GetFingerprint"}),t.origin))}},(0,a.addListener)(window,"message",u),i.src=e.getIssuerOrigin()+"/auth/services/devicefingerprint",document.body.appendChild(i),r=setTimeout((function(){c(new n.AuthSdkError("Fingerprinting timed out"))}),(null===(s=t)||void 0===s?void 0:s.timeout)||15e3)})).finally((function(){clearTimeout(r),(0,a.removeListener)(window,"message",u),document.body.contains(i)&&i.parentElement.removeChild(i)})):Promise.reject(new n.AuthSdkError("Fingerprinting is not supported on this device"));var r,i,u};var n=r(5728),o=r(415),a=r(9443);e.exports=t.default},6244:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(8416)),u=function(){function e(t){(0,o.default)(this,e),(0,i.default)(this,"localOffset",void 0),this.localOffset=parseInt(t||0)}return(0,a.default)(e,[{key:"now",value:function(){return(Date.now()+this.localOffset)/1e3}}],[{key:"create",value:function(){return new e(0)}}]),e}();t.default=u,e.exports=t.default},1971:function(e,t){"use strict";t.TRANSACTION_STORAGE_NAME=t.TOKEN_STORAGE_NAME=t.STATE_TOKEN_KEY_NAME=t.SHARED_TRANSACTION_STORAGE_NAME=t.REFRESH_TOKEN_STORAGE_KEY=t.REFERRER_PATH_STORAGE_KEY=t.PKCE_STORAGE_NAME=t.ORIGINAL_URI_STORAGE_NAME=t.MIN_VERIFIER_LENGTH=t.MAX_VERIFIER_LENGTH=t.ID_TOKEN_STORAGE_KEY=t.IDX_RESPONSE_STORAGE_NAME=t.IDX_API_VERSION=t.DEFAULT_POLLING_DELAY=t.DEFAULT_MAX_CLOCK_SKEW=t.DEFAULT_CODE_CHALLENGE_METHOD=t.DEFAULT_CACHE_DURATION=t.CACHE_STORAGE_NAME=t.ACCESS_TOKEN_STORAGE_KEY=void 0,t.STATE_TOKEN_KEY_NAME="oktaStateToken",t.DEFAULT_POLLING_DELAY=500,t.DEFAULT_MAX_CLOCK_SKEW=300,t.DEFAULT_CACHE_DURATION=86400,t.TOKEN_STORAGE_NAME="okta-token-storage",t.CACHE_STORAGE_NAME="okta-cache-storage",t.PKCE_STORAGE_NAME="okta-pkce-storage",t.TRANSACTION_STORAGE_NAME="okta-transaction-storage",t.SHARED_TRANSACTION_STORAGE_NAME="okta-shared-transaction-storage",t.ORIGINAL_URI_STORAGE_NAME="okta-original-uri-storage",t.IDX_RESPONSE_STORAGE_NAME="okta-idx-response-storage",t.ACCESS_TOKEN_STORAGE_KEY="accessToken",t.ID_TOKEN_STORAGE_KEY="idToken",t.REFRESH_TOKEN_STORAGE_KEY="refreshToken",t.REFERRER_PATH_STORAGE_KEY="referrerPath",t.MIN_VERIFIER_LENGTH=43,t.MAX_VERIFIER_LENGTH=128,t.DEFAULT_CODE_CHALLENGE_METHOD="S256",t.IDX_API_VERSION="1.0.0"},1018:function(e,t,r){"use strict";var n=r(4836);t.INITIAL_AUTH_STATE=t.AuthStateManager=void 0;var o=n(r(4687)),a=n(r(7156)),i=n(r(6690)),u=n(r(9728)),c=n(r(8416)),s=n(r(3615)),l=r(5728),f=r(9443),d=r(305);function p(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function h(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?p(Object(r),!0).forEach((function(t){(0,c.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):p(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}t.INITIAL_AUTH_STATE=null;var v={updateAuthStatePromise:null,canceledTimes:0},y="authStateChange",g=function(){function e(t){var r=this;if((0,i.default)(this,e),(0,c.default)(this,"_sdk",void 0),(0,c.default)(this,"_pending",void 0),(0,c.default)(this,"_authState",void 0),(0,c.default)(this,"_prevAuthState",void 0),(0,c.default)(this,"_logOptions",void 0),(0,c.default)(this,"_transformQueue",void 0),!t.emitter)throw new l.AuthSdkError("Emitter should be initialized before AuthStateManager");this._sdk=t,this._pending=h({},v),this._authState=null,this._logOptions={},this._prevAuthState=null,this._transformQueue=new d.PromiseQueue({quiet:!0}),t.tokenManager.on(f.EVENT_ADDED,(function(e,t){r._setLogOptions({event:f.EVENT_ADDED,key:e,token:t}),r.updateAuthState()})),t.tokenManager.on(f.EVENT_REMOVED,(function(e,t){r._setLogOptions({event:f.EVENT_REMOVED,key:e,token:t}),r.updateAuthState()}))}var t;return(0,u.default)(e,[{key:"_setLogOptions",value:function(e){this._logOptions=e}},{key:"getAuthState",value:function(){return this._authState}},{key:"getPreviousAuthState",value:function(){return this._prevAuthState}},{key:"updateAuthState",value:(t=(0,a.default)(o.default.mark((function e(){var t,r,n,a,i,u,c,l=this;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=this._sdk.options,r=t.transformAuthState,n=t.devMode,a=function(e){var t=l._logOptions,r=t.event,n=t.key,o=t.token;(0,d.getConsole)().group("OKTA-AUTH-JS:updateAuthState: Event:".concat(r," Status:").concat(e)),(0,d.getConsole)().log(n,o),(0,d.getConsole)().log("Current authState",l._authState),(0,d.getConsole)().groupEnd(),l._logOptions={}},i=function(e){var t,r;r=e,(t=l._authState)&&t.isAuthenticated===r.isAuthenticated&&JSON.stringify(t.idToken)===JSON.stringify(r.idToken)&&JSON.stringify(t.accessToken)===JSON.stringify(r.accessToken)&&t.error===r.error?n&&a("unchanged"):(l._prevAuthState=l._authState,l._authState=e,l._sdk.emitter.emit(y,h({},e)),n&&a("emitted"))},u=function e(t){return l._pending.updateAuthStatePromise.then((function(){var r=l._pending.updateAuthStatePromise;return r&&r!==t?e(r):l.getAuthState()}))},!this._pending.updateAuthStatePromise){e.next=11;break}if(!(this._pending.canceledTimes>=10)){e.next=10;break}return n&&a("terminated"),e.abrupt("return",u(this._pending.updateAuthStatePromise));case 10:this._pending.updateAuthStatePromise.cancel();case 11:return c=new s.default((function(e,t,o){o.shouldReject=!1,o((function(){l._pending.updateAuthStatePromise=null,l._pending.canceledTimes=l._pending.canceledTimes+1,n&&a("canceled")}));var u=function(t){c.isCanceled?e():(i(t),e(),l._pending=h({},v))};l._sdk.isAuthenticated().then((function(){if(c.isCanceled)e();else{var t=l._sdk.tokenManager.getTokensSync(),n=t.accessToken,o=t.idToken,a=t.refreshToken,i={accessToken:n,idToken:o,refreshToken:a,isAuthenticated:!(!n||!o)};(r?l._transformQueue.push(r,null,l._sdk,i):Promise.resolve(i)).then((function(e){return u(e)})).catch((function(e){return u({accessToken:n,idToken:o,refreshToken:a,isAuthenticated:!1,error:e})}))}}))})),this._pending.updateAuthStatePromise=c,e.abrupt("return",u(c));case 14:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"subscribe",value:function(e){this._sdk.emitter.on(y,e)}},{key:"unsubscribe",value:function(e){this._sdk.emitter.off(y,e)}}]),e}();t.AuthStateManager=g},2204:function(e,t,r){"use strict";var n=r(4836);t.ServiceManager=void 0;var o=n(r(4687)),a=n(r(7424)),i=n(r(861)),u=n(r(7156)),c=n(r(6690)),s=n(r(9728)),l=n(r(8416)),f=r(2604),d=r(305);function p(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function h(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?p(Object(r),!0).forEach((function(t){(0,l.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):p(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function v(e,t){var r="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!r){if(Array.isArray(e)||(r=function(e,t){if(e){if("string"==typeof e)return y(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?y(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){r&&(e=r);var n=0,o=function(){};return{s:o,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,i=!0,u=!1;return{s:function(){r=r.call(e)},n:function(){var e=r.next();return i=e.done,e},e:function(e){u=!0,a=e},f:function(){try{i||null==r.return||r.return()}finally{if(u)throw a}}}}function y(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}var g="autoRenew",b="syncStorage",m="leaderElection",O=function(){function e(t){var r=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(0,c.default)(this,e),(0,l.default)(this,"sdk",void 0),(0,l.default)(this,"options",void 0),(0,l.default)(this,"services",void 0),(0,l.default)(this,"started",void 0),this.sdk=t,this.onLeader=this.onLeader.bind(this);var o=t.tokenManager.getOptions(),a=o.autoRenew,i=o.autoRemove,u=o.syncStorage;n.electionChannelName=n.electionChannelName||n.broadcastChannelName,this.options=Object.assign({},e.defaultOptions,{autoRenew:a,autoRemove:i,syncStorage:u},{electionChannelName:"".concat(t.options.clientId,"-election"),syncChannelName:"".concat(t.options.clientId,"-sync")},(0,d.removeNils)(n)),this.started=!1,this.services=new Map,e.knownServices.forEach((function(e){var t=r.createService(e);t&&r.services.set(e,t)}))}var t,r,n,p,y;return(0,s.default)(e,[{key:"onLeader",value:(y=(0,u.default)(o.default.mark((function e(){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.started){e.next=3;break}return e.next=3,this.startServices();case 3:case"end":return e.stop()}}),e,this)}))),function(){return y.apply(this,arguments)})},{key:"isLeader",value:function(){var e;return null===(e=this.getService(m))||void 0===e?void 0:e.isLeader()}},{key:"isLeaderRequired",value:function(){return(0,i.default)(this.services.values()).some((function(e){return e.canStart()&&e.requiresLeadership()}))}},{key:"start",value:(p=(0,u.default)(o.default.mark((function e(){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.started){e.next=2;break}return e.abrupt("return");case 2:return e.next=4,this.startServices();case 4:this.started=!0;case 5:case"end":return e.stop()}}),e,this)}))),function(){return p.apply(this,arguments)})},{key:"stop",value:(n=(0,u.default)(o.default.mark((function e(){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.stopServices();case 2:this.started=!1;case 3:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"getService",value:function(e){return this.services.get(e)}},{key:"startServices",value:(r=(0,u.default)(o.default.mark((function e(){var t,r,n,i,u;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:t=v(this.services.entries()),e.prev=1,t.s();case 3:if((r=t.n()).done){e.next=10;break}if(n=(0,a.default)(r.value,2),i=n[0],u=n[1],!this.canStartService(i,u)){e.next=8;break}return e.next=8,u.start();case 8:e.next=3;break;case 10:e.next=15;break;case 12:e.prev=12,e.t0=e.catch(1),t.e(e.t0);case 15:return e.prev=15,t.f(),e.finish(15);case 18:case"end":return e.stop()}}),e,this,[[1,12,15,18]])}))),function(){return r.apply(this,arguments)})},{key:"stopServices",value:(t=(0,u.default)(o.default.mark((function e(){var t,r,n;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:t=v(this.services.values()),e.prev=1,t.s();case 3:if((r=t.n()).done){e.next=9;break}return n=r.value,e.next=7,n.stop();case 7:e.next=3;break;case 9:e.next=14;break;case 11:e.prev=11,e.t0=e.catch(1),t.e(e.t0);case 14:return e.prev=14,t.f(),e.finish(14);case 17:case"end":return e.stop()}}),e,this,[[1,11,14,17]])}))),function(){return t.apply(this,arguments)})},{key:"canStartService",value:function(e,t){var r=t.canStart()&&!t.isStarted();return e===m?r&&(r=this.isLeaderRequired()):t.requiresLeadership()&&r&&(r=this.isLeader()),r}},{key:"createService",value:function(e){var t,r=this.sdk.tokenManager;switch(e){case m:t=new f.LeaderElectionService(h(h({},this.options),{},{onLeader:this.onLeader}));break;case g:t=new f.AutoRenewService(r,h({},this.options));break;case b:t=new f.SyncStorageService(r,h({},this.options));break;default:throw new Error("Unknown service ".concat(e))}return t}}]),e}();t.ServiceManager=O,(0,l.default)(O,"knownServices",[g,b,m]),(0,l.default)(O,"defaultOptions",{autoRenew:!0,autoRemove:!0,syncStorage:!0})},6599:function(e,t,r){"use strict";var n=r(2204);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}))},1578:function(e,t,r){"use strict";t.createOktaAuthCore=function(e,t,r){var s=(0,n.createOktaAuthBase)(t),l=(0,o.mixinStorage)(s,e),f=(0,a.mixinHttp)(l),d=(0,c.mixinSession)(f),p=(0,i.mixinOAuth)(d,r);return(0,u.mixinCore)(p)};var n=r(3306),o=r(265),a=r(3334),i=r(498),u=r(8386),c=r(3980)},3961:function(e,t,r){"use strict";var n=r(1018);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(9133);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(1578);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var i=r(8386);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}));var u=r(2647);Object.keys(u).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===u[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}}))}));var c=r(8553);Object.keys(c).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===c[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return c[e]}}))}));var s=r(6599);Object.keys(s).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===s[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return s[e]}}))}))},8386:function(e,t,r){"use strict";var n=r(4836);t.mixinCore=function(e){return function(e){(0,s.default)(O,e);var t,r,n,y,g,b,m=(t=O,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,f.default)(t);if(r){var o=(0,f.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,l.default)(this,e)});function O(){var e;(0,i.default)(this,O);for(var t=arguments.length,r=new Array(t),n=0;n<t;n++)r[n]=arguments[n];return e=m.call.apply(m,[this].concat(r)),(0,d.default)((0,c.default)(e),"authStateManager",void 0),(0,d.default)((0,c.default)(e),"serviceManager",void 0),e.authStateManager=new h.AuthStateManager((0,c.default)(e)),e.serviceManager=new v.ServiceManager((0,c.default)(e),e.options.services),e}return(0,u.default)(O,[{key:"start",value:(b=(0,a.default)(o.default.mark((function e(){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.serviceManager.start();case 2:if(this.tokenManager.start(),this.token.isLoginRedirect()){e.next=6;break}return e.next=6,this.authStateManager.updateAuthState();case 6:case"end":return e.stop()}}),e,this)}))),function(){return b.apply(this,arguments)})},{key:"stop",value:(g=(0,a.default)(o.default.mark((function e(){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return this.tokenManager.stop(),e.next=3,this.serviceManager.stop();case 3:case"end":return e.stop()}}),e,this)}))),function(){return g.apply(this,arguments)})},{key:"handleRedirect",value:(y=(0,a.default)(o.default.mark((function e(t){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.handleLoginRedirect(void 0,t);case 2:case"end":return e.stop()}}),e,this)}))),function(e){return y.apply(this,arguments)})},{key:"handleLoginRedirect",value:(n=(0,a.default)(o.default.mark((function e(t,r){var n,a,i;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=this.options.state,!t){e.next=6;break}this.tokenManager.setTokens(t),r=r||this.getOriginalUri(this.options.state),e.next=25;break;case 6:if(!this.isLoginRedirect()){e.next=24;break}return e.prev=7,e.next=10,(0,p.parseOAuthResponseFromUrl)(this,{});case 10:return a=e.sent,n=a.state,r=r||this.getOriginalUri(n),e.next=15,this.storeTokensFromRedirect();case 15:e.next=22;break;case 17:return e.prev=17,e.t0=e.catch(7),e.next=21,this.authStateManager.updateAuthState();case 21:throw e.t0;case 22:e.next=25;break;case 24:return e.abrupt("return");case 25:return e.next=27,this.authStateManager.updateAuthState();case 27:if(this.removeOriginalUri(n),!(i=this.options.restoreOriginalUri)){e.next=34;break}return e.next=32,i(this,r);case 32:e.next=35;break;case 34:r&&window.location.replace(r);case 35:case"end":return e.stop()}}),e,this,[[7,17]])}))),function(e,t){return n.apply(this,arguments)})}]),O}(e)};var o=n(r(4687)),a=n(r(7156)),i=n(r(6690)),u=n(r(9728)),c=n(r(6115)),s=n(r(1655)),l=n(r(4993)),f=n(r(3808)),d=n(r(8416)),p=r(9094),h=r(1018),v=r(6599)},9133:function(e,t,r){"use strict";var n=r(4836);t.createCoreOptionsConstructor=function(){return function(e){(0,u.default)(f,e);var t,r,n=(t=f,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function f(e){var t;return(0,a.default)(this,f),t=n.call(this,e),(0,l.default)((0,i.default)(t),"services",void 0),(0,l.default)((0,i.default)(t),"transformAuthState",void 0),t.services=e.services,t.transformAuthState=e.transformAuthState,t}return(0,o.default)(f)}((0,f.createOAuthOptionsConstructor)())};var o=n(r(9728)),a=n(r(6690)),i=n(r(6115)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416)),f=r(9443)},2647:function(e,t,r){"use strict";t.createCoreStorageManager=function(){return(0,n.createOAuthStorageManager)()};var n=r(2333)},2293:function(){},5675:function(){},6655:function(){},8553:function(e,t,r){"use strict";var n=r(6655);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(2293);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(5675);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}))},7987:function(e,t,r){"use strict";t.base64ToBase64Url=a,t.base64UrlDecode=u,t.base64UrlToBase64=i,t.base64UrlToBuffer=function(e){return Uint8Array.from(u(e),(function(e){return e.charCodeAt(0)}))},t.base64UrlToString=function(e){var t=i(e);switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw new n.AuthSdkError("Not a valid Base64Url")}var r=(0,o.atob)(t);try{return decodeURIComponent(escape(r))}catch(e){return r}},t.bufferToBase64Url=function(e){return(0,o.btoa)(new Uint8Array(e).reduce((function(e,t){return e+String.fromCharCode(t)}),""))},t.stringToBase64Url=function(e){return a((0,o.btoa)(e))},t.stringToBuffer=function(e){for(var t=new Uint8Array(e.length),r=0;r<e.length;r++)t[r]=e.charCodeAt(r);return t};var n=r(5728),o=r(1);function a(e){return e.replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,"")}function i(e){return e.replace(/-/g,"+").replace(/_/g,"/")}function u(e){return(0,o.atob)(i(e))}},7594:function(e,t){"use strict";t.webcrypto=t.btoa=t.atob=void 0,t.atob=function(e){return atob(e)},t.btoa=function(e){return btoa(e)};var r="undefined"==typeof crypto?null:crypto;t.webcrypto=r},9718:function(e,t,r){"use strict";var n=r(7987);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(5698);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(6332);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var i=r(3154);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}));var u=r(1);Object.keys(u).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===u[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}}))}))},5698:function(e,t,r){"use strict";t.getOidcHash=function(e){var t=(new TextEncoder).encode(e);return o.webcrypto.subtle.digest("SHA-256",t).then((function(e){var t=new Uint8Array(e).slice(0,16),r=String.fromCharCode.apply(null,t);return(0,n.stringToBase64Url)(r)}))};var n=r(7987),o=r(1)},6332:function(){},3154:function(e,t,r){"use strict";t.verifyToken=function(e,t){t=(0,n.clone)(t);var r={name:"RSASSA-PKCS1-v1_5",hash:{name:"SHA-256"}};return delete t.use,a.webcrypto.subtle.importKey("jwk",t,r,!0,["verify"]).then((function(t){var n=e.split("."),i=(0,o.stringToBuffer)(n[0]+"."+n[1]),u=(0,o.base64UrlDecode)(n[2]),c=(0,o.stringToBuffer)(u);return a.webcrypto.subtle.verify(r,t,c,i)}))};var n=r(305),o=r(7987),a=r(1)},1:function(e,t,r){"use strict";var n=r(7594);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}))},3983:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(9728)),a=n(r(6690)),i=n(r(6115)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416));var f=function(e){(0,u.default)(f,e);var t,r,n=(t=f,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function f(e,t,r){var o;(0,a.default)(this,f);var u=e.errorSummary;return o=n.call(this,u),(0,l.default)((0,i.default)(o),"errorSummary",void 0),(0,l.default)((0,i.default)(o),"errorCode",void 0),(0,l.default)((0,i.default)(o),"errorLink",void 0),(0,l.default)((0,i.default)(o),"errorId",void 0),(0,l.default)((0,i.default)(o),"errorCauses",void 0),(0,l.default)((0,i.default)(o),"xhr",void 0),(0,l.default)((0,i.default)(o),"meta",void 0),o.name="AuthApiError",o.errorSummary=e.errorSummary,o.errorCode=e.errorCode,o.errorLink=e.errorLink,o.errorId=e.errorId,o.errorCauses=e.errorCauses,t&&(o.xhr=t),r&&(o.meta=r),o}return(0,o.default)(f)}(n(r(401)).default);t.default=f,e.exports=t.default},6573:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(9728)),a=n(r(6690)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808));var s=function(e){(0,i.default)(s,e);var t,r,n=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function s(){return(0,a.default)(this,s),n.call(this,"The poll was stopped by the sdk")}return(0,o.default)(s)}(n(r(401)).default);t.default=s,e.exports=t.default},9123:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(9728)),a=n(r(6690)),i=n(r(6115)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416));var f=function(e){(0,u.default)(f,e);var t,r,n=(t=f,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function f(e,t){var r;return(0,a.default)(this,f),r=n.call(this,e),(0,l.default)((0,i.default)(r),"errorSummary",void 0),(0,l.default)((0,i.default)(r),"errorCode",void 0),(0,l.default)((0,i.default)(r),"errorLink",void 0),(0,l.default)((0,i.default)(r),"errorId",void 0),(0,l.default)((0,i.default)(r),"errorCauses",void 0),(0,l.default)((0,i.default)(r),"xhr",void 0),r.name="AuthSdkError",r.errorCode="INTERNAL",r.errorSummary=e,r.errorLink="INTERNAL",r.errorId="INTERNAL",r.errorCauses=[],t&&(r.xhr=t),r}return(0,o.default)(f)}(n(r(401)).default);t.default=f,e.exports=t.default},401:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(9728)),a=n(r(6690)),i=n(r(6115)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808));var l=function(e){(0,u.default)(l,e);var t,r,n=(t=l,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function l(e){var t;return(0,a.default)(this,l),t=n.call(this,e),Object.setPrototypeOf((0,i.default)(t),(this instanceof l?this.constructor:void 0).prototype),t}return(0,o.default)(l)}((0,n(r(3496)).default)(Error));t.default=l,e.exports=t.default},2886:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(9728)),a=n(r(6690)),i=n(r(6115)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416));var f=function(e){(0,u.default)(f,e);var t,r,n=(t=f,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function f(e,t){var r;return(0,a.default)(this,f),r=n.call(this,t),(0,l.default)((0,i.default)(r),"errorCode",void 0),(0,l.default)((0,i.default)(r),"errorSummary",void 0),(0,l.default)((0,i.default)(r),"error",void 0),(0,l.default)((0,i.default)(r),"error_description",void 0),r.name="OAuthError",r.errorCode=e,r.errorSummary=t,r.error=e,r.error_description=t,r}return(0,o.default)(f)}(n(r(401)).default);t.default=f,e.exports=t.default},5728:function(e,t,r){"use strict";var n=r(4836),o={isAuthApiError:!0,isOAuthError:!0,AuthApiError:!0,AuthPollStopError:!0,AuthSdkError:!0,OAuthError:!0};Object.defineProperty(t,"AuthApiError",{enumerable:!0,get:function(){return a.default}}),Object.defineProperty(t,"AuthPollStopError",{enumerable:!0,get:function(){return i.default}}),Object.defineProperty(t,"AuthSdkError",{enumerable:!0,get:function(){return u.default}}),Object.defineProperty(t,"OAuthError",{enumerable:!0,get:function(){return c.default}}),t.isAuthApiError=function(e){return e instanceof a.default},t.isOAuthError=function(e){return e instanceof c.default};var a=n(r(3983)),i=n(r(6573)),u=n(r(9123)),c=n(r(2886)),s=r(1243);Object.keys(s).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===s[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return s[e]}}))}))},1243:function(){},8193:function(e,t,r){"use strict";t.default=void 0;var n=r(4944).OktaAuth;t.default=n,e.exports=t.default},9051:function(e,t,r){"use strict";var n=r(8698),o={crypto:!0};t.crypto=void 0;var a=function(e,t){if(e&&e.__esModule)return e;if(null===e||"object"!==n(e)&&"function"!=typeof e)return{default:e};var r=v(t);if(r&&r.has(e))return r.get(e);var o={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var u=a?Object.getOwnPropertyDescriptor(e,i):null;u&&(u.get||u.set)?Object.defineProperty(o,i,u):o[i]=e[i]}return o.default=e,r&&r.set(e,o),o}(r(9718));t.crypto=a;var i=r(3306);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}));var u=r(1971);Object.keys(u).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===u[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}}))}));var c=r(3961);Object.keys(c).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===c[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return c[e]}}))}));var s=r(5728);Object.keys(s).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===s[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return s[e]}}))}));var l=r(4777);Object.keys(l).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===l[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return l[e]}}))}));var f=r(9443);Object.keys(f).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===f[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return f[e]}}))}));var d=r(8041);Object.keys(d).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===d[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return d[e]}}))}));var p=r(9927);Object.keys(p).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===p[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return p[e]}}))}));var h=r(305);function v(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(v=function(e){return e?r:t})(e)}Object.keys(h).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===h[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return h[e]}}))}))},4944:function(e,t,r){"use strict";var n=r(4836),o={OktaAuth:!0};t.default=t.OktaAuth=void 0;var a=n(r(9728)),i=n(r(6690)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=r(8630);Object.keys(l).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===l[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return l[e]}}))}));var f=r(939);Object.keys(f).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===f[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return f[e]}}))}));var d=r(3398);Object.keys(d).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===d[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return d[e]}}))}));var p=r(9051);Object.keys(p).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===p[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return p[e]}}))}));var h=(0,l.createIdxOptionsConstructor)(),v=(0,l.createIdxStorageManager)(),y=(0,l.createIdxTransactionManager)(),g=(0,l.createOktaAuthIdx)(v,h,y),b=(0,f.mixinMyAccount)(g),m=function(e){(0,u.default)(o,e);var t,r,n=(t=o,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function o(e){return(0,i.default)(this,o),n.call(this,e)}return(0,a.default)(o)}((0,d.mixinAuthn)(b));t.OktaAuth=m;var O=m;t.default=O},415:function(e,t,r){"use strict";t.getUserAgent=i,t.hasTextEncoder=c,t.isBrowser=a,t.isFingerprintSupported=function(){var e=i();return e&&!o.test(e)},t.isHTTPS=function(){return!!a()&&"https:"===window.location.protocol},t.isIE11OrLess=function(){if(!a())return!1;var e=document.documentMode;return!!e&&e<=11},t.isLocalhost=function(){return a()&&"localhost"===window.location.hostname},t.isPKCESupported=function(){return u()&&c()},t.isPopupPostMessageSupported=function(){if(!a())return!1;var e=document.documentMode,t=e&&e<10;return void 0!==window.postMessage&&!t},t.isTokenVerifySupported=u;var n=r(9718),o=/windows phone|iemobile|wpdesktop/i;function a(){return"undefined"!=typeof document&&"undefined"!=typeof window}function i(){return navigator.userAgent}function u(){return void 0!==n.webcrypto&&null!==n.webcrypto&&void 0!==n.webcrypto.subtle&&"undefined"!=typeof Uint8Array}function c(){return"undefined"!=typeof TextEncoder}},4447:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(7424)),a=n(r(8698)),i=n(r(4098));function u(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}var c=/application\/\w*\+?json/;t.default=function(e,t,n){var s=n.data,l=n.headers||{},f=l["Content-Type"]||l["content-type"]||"";s&&"string"!=typeof s&&(c.test(f)?s=JSON.stringify(s):"application/x-www-form-urlencoded"===f&&(s=Object.entries(s).map((function(e){var t=(0,o.default)(e,2),r=t[0],n=t[1];return"".concat(r,"=").concat(encodeURIComponent(n))})).join("&")));var d=(r.g.fetch||i.default)(t,{method:e,headers:n.headers,body:s,credentials:n.withCredentials?"include":"omit"});return d.finally||(d=Promise.resolve(d)),d.then((function(e){var t=!e.ok,r=e.status;return function(e){return e.headers.get("Content-Type")&&e.headers.get("Content-Type").toLowerCase().indexOf("application/json")>=0?e.json().catch((function(e){return{error:e,errorSummary:"Could not parse server response"}})):e.text()}(e).then((function(t){return function(e,t,r){var n,o="object"===(0,a.default)(t),i={},c=function(e,t){var r="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!r){if(Array.isArray(e)||(r=function(e,t){if(e){if("string"==typeof e)return u(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?u(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){r&&(e=r);var n=0,o=function(){};return{s:o,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,i=!0,c=!1;return{s:function(){r=r.call(e)},n:function(){var e=r.next();return i=e.done,e},e:function(e){c=!0,a=e},f:function(){try{i||null==r.return||r.return()}finally{if(c)throw a}}}}(r.headers.entries());try{for(c.s();!(n=c.n()).done;){var s=n.value;i[s[0]]=s[1]}}catch(e){c.e(e)}finally{c.f()}var l={responseText:o?JSON.stringify(t):t,status:e,headers:i};return o&&(l.responseType="json",l.responseJSON=t),l}(r,t,e)})).then((function(e){var r;if(t||null!==(r=e.responseJSON)&&void 0!==r&&r.error)throw e;return e}))}))},e.exports=t.default},287:function(e,t,r){"use strict";var n=r(4836);t.OktaUserAgent=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(8416)),u=r(415),c=function(){function e(){(0,o.default)(this,e),(0,i.default)(this,"environments",void 0),this.environments=["okta-auth-js/".concat("7.5.1")],this.maybeAddNodeEnvironment()}return(0,a.default)(e,[{key:"addEnvironment",value:function(e){this.environments.push(e)}},{key:"getHttpHeader",value:function(){return{"X-Okta-User-Agent-Extended":this.environments.join(" ")}}},{key:"getVersion",value:function(){return"7.5.1"}},{key:"maybeAddNodeEnvironment",value:function(){if(!(0,u.isBrowser)()&&process&&process.versions){var e=process.versions.node;this.environments.push("nodejs/".concat(e))}}}]),e}();t.OktaUserAgent=c},2281:function(e,t){"use strict";t.setRequestHeader=function(e,t,r){e.options.headers=e.options.headers||{},e.options.headers[t]=r}},4777:function(e,t,r){"use strict";var n=r(2281);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(287);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(5385);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var i=r(8958);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}));var u=r(3334);Object.keys(u).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===u[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}}))}));var c=r(4090);Object.keys(c).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===c[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return c[e]}}))}))},3334:function(e,t,r){"use strict";var n=r(4836);t.mixinHttp=function(e){return function(e){(0,u.default)(v,e);var t,r,n=(t=v,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function v(){var e;(0,o.default)(this,v);for(var t=arguments.length,r=new Array(t),a=0;a<t;a++)r[a]=arguments[a];return e=n.call.apply(n,[this].concat(r)),(0,l.default)((0,i.default)(e),"_oktaUserAgent",void 0),(0,l.default)((0,i.default)(e),"http",void 0),e._oktaUserAgent=new f.OktaUserAgent,e.http={setRequestHeader:d.setRequestHeader.bind(null,(0,i.default)(e))},e}return(0,a.default)(v,[{key:"setHeaders",value:function(e){this.options.headers=Object.assign({},this.options.headers,e)}},{key:"getIssuerOrigin",value:function(){return this.options.issuer.split("/oauth2/")[0]}},{key:"webfinger",value:function(e){var t="/.well-known/webfinger"+(0,p.toQueryString)(e);return(0,h.get)(this,t,{headers:{Accept:"application/jrd+json"}})}}]),v}(e)};var o=n(r(6690)),a=n(r(9728)),i=n(r(6115)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416)),f=r(287),d=r(2281),p=r(305),h=r(5385)},4090:function(e,t,r){"use strict";var n=r(4836);t.createHttpOptionsConstructor=function(){return function(e){(0,u.default)(f,e);var t,r,n=(t=f,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function f(e){var t;return(0,a.default)(this,f),t=n.call(this,e),(0,l.default)((0,i.default)(t),"issuer",void 0),(0,l.default)((0,i.default)(t),"transformErrorXHR",void 0),(0,l.default)((0,i.default)(t),"headers",void 0),(0,l.default)((0,i.default)(t),"httpRequestClient",void 0),(0,l.default)((0,i.default)(t),"httpRequestInterceptors",void 0),t.issuer=e.issuer,t.transformErrorXHR=e.transformErrorXHR,t.headers=e.headers,t.httpRequestClient=e.httpRequestClient||d.default,t.httpRequestInterceptors=e.httpRequestInterceptors,t}return(0,o.default)(f)}((0,f.createStorageOptionsConstructor)())};var o=n(r(9728)),a=n(r(6690)),i=n(r(6115)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416)),f=r(9927),d=n(r(4447))},5385:function(e,t,r){"use strict";var n=r(4836);t.get=function(e,t,r){var n={url:t=(0,i.isAbsoluteUrl)(t)?t:e.getIssuerOrigin()+t,method:"GET"};return Object.assign(n,r),p(e,n)},t.httpRequest=p,t.post=function(e,t,r,n){var o={url:t=(0,i.isAbsoluteUrl)(t)?t:e.getIssuerOrigin()+t,method:"POST",args:r,saveAuthnState:!0};return Object.assign(o,n),p(e,o)};var o=n(r(8698)),a=n(r(8416)),i=r(305),u=r(1971),c=r(5728);function s(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function l(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function f(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?l(Object(r),!0).forEach((function(t){(0,a.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):l(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var d=function(e,t){var r,n,o;if(t instanceof Error)return new c.AuthApiError({errorSummary:t.message});var a,u=t,s={};if(u.responseText&&(0,i.isString)(u.responseText))try{s=JSON.parse(u.responseText)}catch(e){s={errorSummary:"Unknown error"}}if(u.status>=500&&(s.errorSummary="Unknown error"),e.options.transformErrorXHR&&(u=e.options.transformErrorXHR((0,i.clone)(u))),a=s.error&&s.error_description?new c.OAuthError(s.error,s.error_description):new c.AuthApiError(s,u),403===(null===(r=u)||void 0===r?void 0:r.status)&&null!==(n=u)&&void 0!==n&&null!==(o=n.headers)&&void 0!==o&&o["www-authenticate"]){var l,d,p=function(e){if(!e)throw new c.AuthSdkError("Missing header string");return e.split(",").map((function(e){return e.trim()})).map((function(e){return e.split("=")})).reduce((function(e,t){return e[t[0]]=t[1].replace(/^"(.*)"$/,"$1"),e}),{})}(null===(l=u)||void 0===l||null===(d=l.headers)||void 0===d?void 0:d["www-authenticate"]),h=p.error,v=p.error_description,y=p.max_age,g=p.acr_values;"insufficient_authentication_context"===h&&(a=new c.AuthApiError({errorSummary:h,errorCauses:[{errorSummary:v}]},u,f({max_age:+y},g&&{acr_values:g})))}return a};function p(e,t){if(t=t||{},e.options.httpRequestInterceptors){var r,n=function(e,t){var r="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!r){if(Array.isArray(e)||(r=function(e,t){if(e){if("string"==typeof e)return s(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?s(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){r&&(e=r);var n=0,o=function(){};return{s:o,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,i=!0,u=!1;return{s:function(){r=r.call(e)},n:function(){var e=r.next();return i=e.done,e},e:function(e){u=!0,a=e},f:function(){try{i||null==r.return||r.return()}finally{if(u)throw a}}}}(e.options.httpRequestInterceptors);try{for(n.s();!(r=n.n()).done;)(0,r.value)(t)}catch(O){n.e(O)}finally{n.f()}}var a=t.url,c=t.method,l=t.args,p=t.saveAuthnState,h=t.accessToken,v=!0===t.withCredentials,y=e.options.storageUtil.storage,g=e.storageManager.getHttpCache(e.options.cookies);if(t.cacheResponse){var b=g.getStorage()[a];if(b&&Date.now()/1e3<b.expiresAt)return Promise.resolve(b.response)}var m=f({Accept:"application/json","Content-Type":"application/json"},e._oktaUserAgent.getHttpHeader());Object.assign(m,e.options.headers,t.headers),m=(0,i.removeNils)(m),h&&(0,i.isString)(h)&&(m.Authorization="Bearer "+h);var O,k,w={headers:m,data:l||void 0,withCredentials:v};return e.options.httpRequestClient(c,a,w).then((function(r){return(k=r.responseText)&&(0,i.isString)(k)&&(k=JSON.parse(k))&&"object"===(0,o.default)(k)&&!k.headers&&(Array.isArray(k)?k.forEach((function(e){e.headers=r.headers})):k.headers=r.headers),p&&(k.stateToken||y.delete(u.STATE_TOKEN_KEY_NAME)),k&&k.stateToken&&k.expiresAt&&y.set(u.STATE_TOKEN_KEY_NAME,k.stateToken,k.expiresAt,e.options.cookies),k&&t.cacheResponse&&g.updateStorage(a,{expiresAt:Math.floor(Date.now()/1e3)+u.DEFAULT_CACHE_DURATION,response:k}),k})).catch((function(t){throw"E0000011"===(O=d(e,t)).errorCode&&y.delete(u.STATE_TOKEN_KEY_NAME),O}))}},8958:function(){},2348:function(e,t,r){"use strict";var n=r(4836);t.createIdxTransactionManager=function(){return function(e){(0,u.default)(l,e);var t,r,n=(t=l,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function l(e){return(0,o.default)(this,l),n.call(this,e)}return(0,a.default)(l,[{key:"clear",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(0,i.default)((0,s.default)(l.prototype),"clear",this).call(this,e),!1!==e.clearIdxResponse&&this.clearIdxResponse()}},{key:"saveIdxResponse",value:function(e){if(this.saveLastResponse){var t=this.storageManager.getIdxResponseStorage();t&&t.setStorage(e)}}},{key:"loadIdxResponse",value:function(e){if(!this.saveLastResponse)return null;var t=this.storageManager.getIdxResponseStorage();if(!t)return null;var r=t.getStorage();if(!r||!(0,f.isRawIdxResponse)(r.rawIdxResponse))return null;if(e){var n=e.interactionHandle;if(n&&r.interactionHandle!==n)return null}return r}},{key:"clearIdxResponse",value:function(){if(this.saveLastResponse){var e=this.storageManager.getIdxResponseStorage();null==e||e.clearStorage()}}}]),l}((0,l.createTransactionManager)())};var o=n(r(6690)),a=n(r(9728)),i=n(r(1588)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=r(130),f=r(480)},1286:function(e,t,r){"use strict";var n=r(4836);t.authenticate=function(e){return f.apply(this,arguments)};var o=n(r(4687)),a=n(r(8416)),i=n(r(7156)),u=r(1642),c=r(4819);function s(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function l(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?s(Object(r),!0).forEach((function(t){(0,a.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):s(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function f(){return f=(0,i.default)(o.default.mark((function e(t){var r,n=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return(r=n.length>1&&void 0!==n[1]?n[1]:{}).password&&!r.authenticator&&(r.authenticator=u.AuthenticatorKey.OKTA_PASSWORD),e.abrupt("return",(0,c.run)(t,l(l({},r),{},{flow:"authenticate"})));case 3:case"end":return e.stop()}}),e)}))),f.apply(this,arguments)}},7644:function(e,t,r){"use strict";var n=r(4836);t.Authenticator=void 0;var o=n(r(9728)),a=n(r(6690)),i=n(r(8416)),u=(0,o.default)((function e(t){(0,a.default)(this,e),(0,i.default)(this,"meta",void 0),this.meta=t}));t.Authenticator=u},9582:function(e,t,r){"use strict";var n=r(4836);t.OktaPassword=void 0;var o=n(r(8416)),a=n(r(6690)),i=n(r(9728)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808));function l(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function f(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?l(Object(r),!0).forEach((function(t){(0,o.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):l(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var d=function(e){(0,u.default)(o,e);var t,r,n=(t=o,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function o(){return(0,a.default)(this,o),n.apply(this,arguments)}return(0,i.default)(o,[{key:"canVerify",value:function(e){return!!(e.credentials||e.password||e.passcode)}},{key:"mapCredentials",value:function(e){var t=e.credentials,r=e.password,n=e.passcode;if(t||r||n)return t||{passcode:n||r}}},{key:"getInputs",value:function(e){var t;return f(f({},null===(t=e.form)||void 0===t?void 0:t.value[0]),{},{name:"password",type:"string",required:e.required})}}]),o}(r(7644).Authenticator);t.OktaPassword=d},5459:function(e,t,r){"use strict";var n=r(4836);t.OktaVerifyTotp=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808));var s=function(e){(0,i.default)(s,e);var t,r,n=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function s(){return(0,o.default)(this,s),n.apply(this,arguments)}return(0,a.default)(s,[{key:"mapCredentials",value:function(e){var t=e.verificationCode;if(t)return{totp:t}}}]),s}(r(5153).VerificationCodeAuthenticator);t.OktaVerifyTotp=s},1977:function(e,t,r){"use strict";var n=r(4836);t.SecurityQuestionEnrollment=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808));var s=function(e){(0,i.default)(s,e);var t,r,n=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function s(){return(0,o.default)(this,s),n.apply(this,arguments)}return(0,a.default)(s,[{key:"canVerify",value:function(e){var t=e.credentials;if(t&&t.questionKey&&t.answer)return!0;var r=e.questionKey,n=e.question,o=e.answer;return!(!r||!o)||!(!n||!o)}},{key:"mapCredentials",value:function(e){var t=e.questionKey,r=e.question,n=e.answer;if(n&&(t||r))return{questionKey:r?"custom":t,question:r,answer:n}}},{key:"getInputs",value:function(){return[{name:"questionKey",type:"string",required:!0},{name:"question",type:"string",label:"Create a security question"},{name:"answer",type:"string",label:"Answer",required:!0}]}}]),s}(r(7644).Authenticator);t.SecurityQuestionEnrollment=s},5941:function(e,t,r){"use strict";var n=r(4836);t.SecurityQuestionVerification=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808));var s=function(e){(0,i.default)(s,e);var t,r,n=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function s(){return(0,o.default)(this,s),n.apply(this,arguments)}return(0,a.default)(s,[{key:"canVerify",value:function(e){var t=e.credentials;return!(!t||!t.answer)||!!e.answer}},{key:"mapCredentials",value:function(e){var t=e.answer;if(t)return{questionKey:this.meta.contextualData.enrolledQuestion.questionKey,answer:t}}},{key:"getInputs",value:function(){return[{name:"answer",type:"string",label:"Answer",required:!0}]}}]),s}(r(7644).Authenticator);t.SecurityQuestionVerification=s},5153:function(e,t,r){"use strict";var n=r(4836);t.VerificationCodeAuthenticator=void 0;var o=n(r(8416)),a=n(r(6690)),i=n(r(9728)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808));function l(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function f(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?l(Object(r),!0).forEach((function(t){(0,o.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):l(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var d=function(e){(0,u.default)(o,e);var t,r,n=(t=o,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function o(){return(0,a.default)(this,o),n.apply(this,arguments)}return(0,i.default)(o,[{key:"canVerify",value:function(e){return!!(e.credentials||e.verificationCode||e.otp)}},{key:"mapCredentials",value:function(e){var t=e.credentials,r=e.verificationCode,n=e.otp;if(t||r||n)return t||{passcode:r||n}}},{key:"getInputs",value:function(e){var t;return f(f({},null===(t=e.form)||void 0===t?void 0:t.value[0]),{},{name:"verificationCode",type:"string",required:e.required})}}]),o}(r(7644).Authenticator);t.VerificationCodeAuthenticator=d},3816:function(e,t,r){"use strict";var n=r(4836);t.WebauthnEnrollment=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808));var s=function(e){(0,i.default)(s,e);var t,r,n=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function s(){return(0,o.default)(this,s),n.apply(this,arguments)}return(0,a.default)(s,[{key:"canVerify",value:function(e){var t=e.credentials||e,r=t.clientData,n=t.attestation;return!(!r||!n)}},{key:"mapCredentials",value:function(e){var t=e.credentials,r=e.clientData,n=e.attestation;if(t||r||n)return t||{clientData:r,attestation:n}}},{key:"getInputs",value:function(){return[{name:"clientData",type:"string",required:!0,visible:!1,label:"Client Data"},{name:"attestation",type:"string",required:!0,visible:!1,label:"Attestation"}]}}]),s}(r(7644).Authenticator);t.WebauthnEnrollment=s},6304:function(e,t,r){"use strict";var n=r(4836);t.WebauthnVerification=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808));var s=function(e){(0,i.default)(s,e);var t,r,n=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function s(){return(0,o.default)(this,s),n.apply(this,arguments)}return(0,a.default)(s,[{key:"canVerify",value:function(e){var t=e.credentials||e,r=t.clientData,n=t.authenticatorData,o=t.signatureData;return!!(r&&n&&o)}},{key:"mapCredentials",value:function(e){var t=e.credentials,r=e.authenticatorData,n=e.clientData,o=e.signatureData;if(t||r||n||o)return t||{authenticatorData:r,clientData:n,signatureData:o}}},{key:"getInputs",value:function(){return[{name:"authenticatorData",type:"string",label:"Authenticator Data",required:!0,visible:!1},{name:"clientData",type:"string",label:"Client Data",required:!0,visible:!1},{name:"signatureData",type:"string",label:"Signature Data",required:!0,visible:!1}]}}]),s}(r(7644).Authenticator);t.WebauthnVerification=s},8815:function(e,t,r){"use strict";t.getAuthenticator=function(e){var t,r,f=e.relatesTo,d=(null==f?void 0:f.value)||{};switch(d.key){case l.AuthenticatorKey.OKTA_PASSWORD:return new a.OktaPassword(d);case l.AuthenticatorKey.SECURITY_QUESTION:return null!==(t=d.contextualData)&&void 0!==t&&t.enrolledQuestion?new u.SecurityQuestionVerification(d):new i.SecurityQuestionEnrollment(d);case l.AuthenticatorKey.OKTA_VERIFY:return new n.OktaVerifyTotp(d);case l.AuthenticatorKey.WEBAUTHN:return null!==(r=d.contextualData)&&void 0!==r&&r.challengeData?new s.WebauthnVerification(d):new c.WebauthnEnrollment(d);default:return new o.VerificationCodeAuthenticator(d)}};var n=r(5459),o=r(5153),a=r(9582),i=r(1977),u=r(5941),c=r(3816),s=r(6304),l=r(1642)},8220:function(e,t,r){"use strict";var n=r(8815);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(7644);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(5153);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var i=r(9582);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}));var u=r(1977);Object.keys(u).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===u[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}}))}));var c=r(5941);Object.keys(c).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===c[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return c[e]}}))}));var s=r(3816);Object.keys(s).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===s[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return s[e]}}))}));var l=r(6304);Object.keys(l).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===l[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return l[e]}}))}))},9344:function(e,t,r){"use strict";t.compareAuthenticators=function(e,t){return!(!e||!t)&&(e.id&&t.id?e.id===t.id:!(!e.key||!t.key)&&e.key===t.key)},t.findMatchedOption=function(e,t){var r,n,a=function(e,t){var r="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!r){if(Array.isArray(e)||(r=function(e,t){if(e){if("string"==typeof e)return o(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?o(e,t):void 0}}(e))){r&&(e=r);var n=0,a=function(){};return{s:a,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:a}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,u=!0,c=!1;return{s:function(){r=r.call(e)},n:function(){var e=r.next();return u=e.done,e},e:function(e){c=!0,i=e},f:function(){try{u||null==r.return||r.return()}finally{if(c)throw i}}}}(e);try{var i=function(){var e=n.value;if(r=t.find((function(t){var r=t.relatesTo;return r.key&&r.key===e.key})))return"break"};for(a.s();!(n=a.n()).done&&"break"!==i(););}catch(e){a.e(e)}finally{a.f()}return r},t.formatAuthenticator=function(e){var t;if((0,n.isAuthenticator)(e))t=e;else{if("string"!=typeof e)throw new Error("Invalid format for authenticator");t={key:e}}return t};var n=r(1642);function o(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}},9192:function(e,t,r){"use strict";var n=r(4836);t.cancel=function(e,t){return f.apply(this,arguments)};var o=n(r(4687)),a=n(r(8416)),i=n(r(7156)),u=r(4819),c=r(8306);function s(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function l(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?s(Object(r),!0).forEach((function(t){(0,a.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):s(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function f(){return(f=(0,i.default)(o.default.mark((function e(t,r){var n,a;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=t.transactionManager.load(),a=(0,c.getFlowSpecification)(t,n.flow),e.abrupt("return",(0,u.run)(t,l(l(l({},r),a),{},{actions:["cancel"]})));case 3:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},7985:function(e,t,r){"use strict";var n=r(4836);t.EmailVerifyCallbackError=void 0,t.handleEmailVerifyCallback=function(e,t){return b.apply(this,arguments)},t.isEmailVerifyCallback=y,t.isEmailVerifyCallbackError=function(e){return"EmailVerifyCallbackError"===e.name},t.parseEmailVerifyCallback=g;var o=n(r(4687)),a=n(r(7156)),i=n(r(9728)),u=n(r(6690)),c=n(r(6115)),s=n(r(1655)),l=n(r(4993)),f=n(r(3808)),d=n(r(8416)),p=n(r(401)),h=r(1969);var v=function(e){(0,s.default)(o,e);var t,r,n=(t=o,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,f.default)(t);if(r){var o=(0,f.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,l.default)(this,e)});function o(e,t){var r;return(0,u.default)(this,o),r=n.call(this,"Enter the OTP code in the originating client: ".concat(t)),(0,d.default)((0,c.default)(r),"state",void 0),(0,d.default)((0,c.default)(r),"otp",void 0),r.name="EmailVerifyCallbackError",r.state=e,r.otp=t,r}return(0,i.default)(o)}(p.default);function y(e){return/(otp=)/i.test(e)&&/(state=)/i.test(e)}function g(e){return(0,h.urlParamsToObject)(e)}function b(){return(b=(0,a.default)(o.default.mark((function e(t,r){var n,a,i;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!y(r)){e.next=9;break}if(n=g(r),a=n.state,i=n.otp,!t.idx.canProceed({state:a})){e.next=8;break}return e.next=5,t.idx.proceed({state:a,otp:i});case 5:return e.abrupt("return",e.sent);case 8:throw new v(a,i);case 9:case"end":return e.stop()}}),e)})))).apply(this,arguments)}t.EmailVerifyCallbackError=v},316:function(e,t,r){"use strict";t.createMinimalOktaAuthIdx=function(e,t,r){var s=(0,o.createOktaAuthBase)(t),l=(0,a.mixinStorage)(s,e),f=(0,i.mixinHttp)(l),d=(0,u.mixinSession)(f),p=(0,c.mixinMinimalOAuth)(d,r);return(0,n.mixinMinimalIdx)(p)};var n=r(1402),o=r(9893),a=r(265),i=r(3334),u=r(3980),c=r(6648)},2144:function(e,t,r){"use strict";t.createOktaAuthIdx=function(e,t,r){var a=(0,n.createOktaAuthCore)(e,t,r);return(0,o.mixinIdx)(a)};var n=r(1578),o=r(8137)},9727:function(e,t,r){"use strict";var n=r(8698);t.createIdxAPI=function(e){(0,k.setRemediatorsCtx)({remediators:m,getFlowSpecification:O.getFlowSpecification});var t=y.startTransaction.bind(null,e);return{interact:l.interact.bind(null,e),introspect:f.introspect.bind(null,e),makeIdxResponse:s.makeIdxState.bind(null,e),authenticate:a.authenticate.bind(null,e),register:v.register.bind(null,e),start:t,startTransaction:t,poll:d.poll.bind(null,e),proceed:p.proceed.bind(null,e),cancel:i.cancel.bind(null,e),recoverPassword:h.recoverPassword.bind(null,e),handleInteractionCodeRedirect:c.handleInteractionCodeRedirect.bind(null,e),isInteractionRequired:o.isInteractionRequired.bind(null,e),isInteractionRequiredError:o.isInteractionRequiredError,handleEmailVerifyCallback:u.handleEmailVerifyCallback.bind(null,e),isEmailVerifyCallback:u.isEmailVerifyCallback,parseEmailVerifyCallback:u.parseEmailVerifyCallback,isEmailVerifyCallbackError:u.isEmailVerifyCallbackError,getSavedTransactionMeta:g.getSavedTransactionMeta.bind(null,e),createTransactionMeta:g.createTransactionMeta.bind(null,e),getTransactionMeta:g.getTransactionMeta.bind(null,e),saveTransactionMeta:g.saveTransactionMeta.bind(null,e),clearTransactionMeta:g.clearTransactionMeta.bind(null,e),isTransactionMetaValid:g.isTransactionMetaValid,setFlow:function(t){e.options.flow=t},getFlow:function(){return e.options.flow},canProceed:p.canProceed.bind(null,e),unlockAccount:b.unlockAccount.bind(null,e)}};var o=r(9443),a=r(1286),i=r(9192),u=r(7985),c=r(5021),s=r(7894),l=r(6131),f=r(2660),d=r(9310),p=r(2845),h=r(9214),v=r(8826),y=r(2473),g=r(2620),b=r(8277),m=function(e,t){if(e&&e.__esModule)return e;if(null===e||"object"!==n(e)&&"function"!=typeof e)return{default:e};var r=w(t);if(r&&r.has(e))return r.get(e);var o={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var u=a?Object.getOwnPropertyDescriptor(e,i):null;u&&(u.get||u.set)?Object.defineProperty(o,i,u):o[i]=e[i]}return o.default=e,r&&r.set(e,o),o}(r(8275)),O=r(8226),k=r(5031);function w(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(w=function(e){return e?r:t})(e)}},1175:function(e,t,r){"use strict";var n=r(9727);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(2144);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(316);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}))},7044:function(e,t,r){"use strict";t.createMinimalIdxAPI=function(e){var t=e,r=a.startTransaction.bind(null,t);return{makeIdxResponse:n.makeIdxState.bind(null,t),start:r,startTransaction:r,proceed:o.proceed.bind(null,t),canProceed:o.canProceed.bind(null,t),getSavedTransactionMeta:i.getSavedTransactionMeta.bind(null,t),createTransactionMeta:i.createTransactionMeta.bind(null,t),getTransactionMeta:i.getTransactionMeta.bind(null,t),saveTransactionMeta:i.saveTransactionMeta.bind(null,t),clearTransactionMeta:i.clearTransactionMeta.bind(null,t),isTransactionMetaValid:i.isTransactionMetaValid}};var n=r(7894),o=r(2845),a=r(2473),i=r(2620)},2535:function(e,t,r){"use strict";t.AccountUnlockFlow=void 0;var n=r(8275),o={identify:n.Identify,"select-authenticator-unlock-account":n.SelectAuthenticatorUnlockAccount,"select-authenticator-authenticate":n.SelectAuthenticatorAuthenticate,"challenge-authenticator":n.ChallengeAuthenticator,"challenge-poll":n.ChallengePoll,"authenticator-verification-data":n.AuthenticatorVerificationData,"reenroll-authenticator-warning":n.ReEnrollAuthenticatorWarning};t.AccountUnlockFlow=o},3550:function(e,t,r){"use strict";t.AuthenticationFlow=void 0;var n=r(8275),o={identify:n.Identify,"select-authenticator-authenticate":n.SelectAuthenticatorAuthenticate,"select-authenticator-enroll":n.SelectAuthenticatorEnroll,"authenticator-enrollment-data":n.AuthenticatorEnrollmentData,"authenticator-verification-data":n.AuthenticatorVerificationData,"enroll-authenticator":n.EnrollAuthenticator,"challenge-authenticator":n.ChallengeAuthenticator,"challenge-poll":n.ChallengePoll,"reenroll-authenticator":n.ReEnrollAuthenticator,"reenroll-authenticator-warning":n.ReEnrollAuthenticatorWarning,"enroll-poll":n.EnrollPoll,"select-enrollment-channel":n.SelectEnrollmentChannel,"enrollment-channel-data":n.EnrollmentChannelData,"redirect-idp":n.RedirectIdp,skip:n.Skip};t.AuthenticationFlow=o},8226:function(e,t,r){"use strict";t.getFlowSpecification=function(e){var t,r,u=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"default",c=!0;switch(u){case"register":case"signup":case"enrollProfile":t=a.RegistrationFlow,c=!1;break;case"recoverPassword":case"resetPassword":t=o.PasswordRecoveryFlow,r=["currentAuthenticator-recover","currentAuthenticatorEnrollment-recover"],c=!1;break;case"unlockAccount":t=i.AccountUnlockFlow,c=!1,r=["unlock-account"];break;default:t=n.AuthenticationFlow}return{flow:u,remediators:t,actions:r,withCredentials:c}};var n=r(3550),o=r(6508),a=r(1103),i=r(2535)},6508:function(e,t,r){"use strict";t.PasswordRecoveryFlow=void 0;var n=r(8275),o={identify:n.Identify,"identify-recovery":n.Identify,"select-authenticator-authenticate":n.SelectAuthenticatorAuthenticate,"select-authenticator-enroll":n.SelectAuthenticatorEnroll,"challenge-authenticator":n.ChallengeAuthenticator,"authenticator-verification-data":n.AuthenticatorVerificationData,"authenticator-enrollment-data":n.AuthenticatorEnrollmentData,"reset-authenticator":n.ResetAuthenticator,"reenroll-authenticator":n.ReEnrollAuthenticator,"reenroll-authenticator-warning":n.ReEnrollAuthenticatorWarning,"enroll-poll":n.EnrollPoll};t.PasswordRecoveryFlow=o},1103:function(e,t,r){"use strict";t.RegistrationFlow=void 0;var n=r(8275),o={"select-enroll-profile":n.SelectEnrollProfile,"enroll-profile":n.EnrollProfile,"authenticator-enrollment-data":n.AuthenticatorEnrollmentData,"select-authenticator-enroll":n.SelectAuthenticatorEnroll,"enroll-poll":n.EnrollPoll,"select-enrollment-channel":n.SelectEnrollmentChannel,"enrollment-channel-data":n.EnrollmentChannelData,"enroll-authenticator":n.EnrollAuthenticator,skip:n.Skip};t.RegistrationFlow=o},5474:function(){},8306:function(e,t,r){"use strict";var n=r(3550);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(8226);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(6508);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var i=r(1103);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}));var u=r(2535);Object.keys(u).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===u[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}}))}));var c=r(5474);Object.keys(c).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===c[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return c[e]}}))}))},5021:function(e,t,r){"use strict";var n=r(4836);t.handleInteractionCodeRedirect=function(e,t){return u.apply(this,arguments)};var o=n(r(4687)),a=n(r(7156)),i=r(5728);function u(){return(u=(0,a.default)(o.default.mark((function e(t,r){var n,a,u,c,s,l,f,d,p,h;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=t.transactionManager.load()){e.next=3;break}throw new i.AuthSdkError("No transaction data was found in storage");case 3:if(a=n.codeVerifier,u=n.state,c=new URL(r),s=c.searchParams,l=s.get("state"),f=s.get("interaction_code"),!(d=s.get("error"))){e.next=10;break}throw new i.OAuthError(d,s.get("error_description"));case 10:if(l===u){e.next=12;break}throw new i.AuthSdkError("State in redirect uri does not match with transaction state");case 12:if(f){e.next=14;break}throw new i.AuthSdkError("Unable to parse interaction_code from the url");case 14:return e.next=16,t.token.exchangeCodeForTokens({interactionCode:f,codeVerifier:a});case 16:p=e.sent,h=p.tokens,t.tokenManager.setTokens(h);case 19:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},7894:function(e,t,r){"use strict";var n=r(4836);t.makeIdxState=function(e,t,r,n){var a,c=null!==(a=null==t?void 0:t.version)&&void 0!==a?a:o.IDX_API_VERSION;return u(c),(0,i(c).makeIdxState)(e,t,r,n)},t.parsersForVersion=void 0,t.validateVersionConfig=u;var o=r(1971),a=n(r(157)),i=function(e){switch(e){case"1.0.0":return a.default;case void 0:case null:throw new Error("Api version is required");default:throw new Error("Unknown api version: ".concat(e,".  Use an exact semver version."))}};function u(e){if(!e)throw new Error("version is required");if((null!=e?e:"").replace(/[^0-9a-zA-Z._-]/,"")!==e||!e)throw new Error("invalid version supplied - version is required and uses semver syntax");i(e)}t.parsersForVersion=i},422:function(e,t){"use strict";function r(e,t){var r="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!r){if(Array.isArray(e)||(r=function(e,t){if(e){if("string"==typeof e)return n(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?n(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){r&&(e=r);var o=0,a=function(){};return{s:a,n:function(){return o>=e.length?{done:!0}:{done:!1,value:e[o++]}},e:function(e){throw e},f:a}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var i,u=!0,c=!1;return{s:function(){r=r.call(e)},n:function(){var e=r.next();return u=e.done,e},e:function(e){c=!0,i=e},f:function(){try{u||null==r.return||r.return()}finally{if(c)throw i}}}}function n(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}t.divideActionParamsByMutability=void 0;var o=function(e){return!1!==e.mutable},a=function(e){var t={},n=[],a={};if(!e.value)return n.push(e),{defaultParamsForAction:t,neededParamsForAction:n,immutableParamsForAction:a};var i,u=r(e.value);try{for(u.s();!(i=u.n()).done;){var c,s,l=i.value;o(l)?(n.push(l),null!==(c=l.value)&&void 0!==c&&c&&(t[l.name]=l.value)):a[l.name]=null!==(s=l.value)&&void 0!==s?s:""}}catch(e){u.e(e)}finally{u.f()}return{defaultParamsForAction:t,neededParamsForAction:n,immutableParamsForAction:a}};t.divideActionParamsByMutability=function(e){var t,n=[],o={},i={},u=r(e=Array.isArray(e)?e:[e]);try{for(u.s();!(t=u.n()).done;){var c=t.value,s=a(c),l=s.defaultParamsForAction,f=s.neededParamsForAction,d=s.immutableParamsForAction;n.push(f),o[c.name]=l,i[c.name]=d}}catch(e){u.e(e)}finally{u.f()}return{defaultParams:o,neededParams:n,immutableParams:i}}},8941:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(4687)),a=n(r(8416)),i=n(r(7156)),u=r(4777),c=r(422),s=n(r(3983));function l(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function f(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?l(Object(r),!0).forEach((function(t){(0,a.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):l(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var d=function(e,t){var r=t.actionDefinition,n=t.defaultParamsForAction,a=void 0===n?{}:n,c=t.immutableParamsForAction,l=void 0===c?{}:c,d=t.toPersist,p=void 0===d?{}:d,h=r.href;return(0,i.default)(o.default.mark((function t(){var n,i,c,d,v,y,g,b,m,O=arguments;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=O.length>0&&void 0!==O[0]?O[0]:{},i={"Content-Type":"application/json",Accept:r.accepts||"application/ion+json"},c=JSON.stringify(f(f(f({},a),n),l)),t.prev=3,t.next=6,(0,u.httpRequest)(e,{url:h,method:r.method,headers:i,args:c,withCredentials:null===(d=null==p?void 0:p.withCredentials)||void 0===d||d});case 6:return v=t.sent,t.abrupt("return",e.idx.makeIdxResponse(f({},v),p,!0));case 10:if(t.prev=10,t.t0=t.catch(3),t.t0 instanceof s.default&&null!==t.t0&&void 0!==t.t0&&t.t0.xhr){t.next=14;break}throw t.t0;case 14:return y=t.t0.xhr,g=y.responseJSON||JSON.parse(y.responseText),b=y.headers["WWW-Authenticate"]||y.headers["www-authenticate"],m=e.idx.makeIdxResponse(f({},g),p,!1),401===y.status&&'Oktadevicejwt realm="Okta Device"'===b&&(m.stepUp=!0),t.abrupt("return",m);case 20:case"end":return t.stop()}}),t,null,[[3,10]])})))};t.default=function(e,t,r){var n=d,o=(0,c.divideActionParamsByMutability)(t),a=o.defaultParams,i=o.neededParams,u=o.immutableParams,s=n(e,{actionDefinition:t,defaultParamsForAction:a[t.name],immutableParamsForAction:u[t.name],toPersist:r});return s.neededParams=i,s},e.exports=t.default},897:function(e,t,r){"use strict";var n=r(4836);t.parseNonRemediations=t.parseIdxResponse=void 0;var o=n(r(7424)),a=n(r(8416)),i=n(r(215)),u=n(r(8698)),c=r(7423),s=n(r(8941)),l=r(4734),f=r(5728),d=["value","type"];function p(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function h(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?p(Object(r),!0).forEach((function(t){(0,a.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):p(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var v={remediation:!0,context:!0},y=function(e,t){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},n={},a={};return Object.keys(t).filter((function(e){return!v[e]})).forEach((function(c){if("object"===(0,u.default)(t[c])&&t[c])if(t[c].rel)n[t[c].name]=(0,s.default)(e,t[c],r);else{var l=t[c],f=l.value,p=l.type,v=(0,i.default)(l,d);a[c]=h({type:p},v),"object"===p?(a[c].value={},Object.entries(f).forEach((function(t){var i=(0,o.default)(t,2),u=i[0],l=i[1];l.rel?n["".concat(c,"-").concat(u.name||u)]=(0,s.default)(e,l,r):a[c].value[u]=l}))):a[c].value=f}else a[c]=t[c]})),{context:a,actions:n}};t.parseNonRemediations=y;var g=function e(t,r){Object.keys(r).forEach((function(n){if("relatesTo"===n){var o=Array.isArray(r[n])?r[n][0]:r[n];if("string"==typeof o){var a=(0,l.jsonpath)({path:o,json:t})[0];if(a)return void(r[n]=a);throw new f.AuthSdkError("Cannot resolve relatesTo: ".concat(o))}}Array.isArray(r[n])&&r[n].forEach((function(r){return e(t,r)}))}))};t.parseIdxResponse=function(e,t){var r,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},o=(null===(r=t.remediation)||void 0===r?void 0:r.value)||[];o.forEach((function(e){var r;if("launch-authenticator"!==e.name||"authenticatorChallenge"!==(null==e||null===(r=e.relatesTo)||void 0===r?void 0:r[0])||null!=t&&t.authenticatorChallenge)return g(t,e);delete e.relatesTo}));var a=o.map((function(t){return function(e,t,r){if(t.rel){var n=(0,c.generateRemediationFunctions)(e,[t],r)[t.name];return h(h({},t),{},{action:n})}return t}(e,t,n)})),i=y(e,t,n);return{remediations:a,context:i.context,actions:i.actions}}},6273:function(e,t,r){"use strict";var n=r(4836);t.makeIdxState=function(e,t,r,n){var c,s,l,f,d=t,p=(0,u.parseIdxResponse)(e,t,r),h=p.remediations,v=p.context,y=p.actions,g=(0,i.default)(h),b=(f=(0,a.default)(o.default.mark((function e(t){var r,n,a=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=a.length>1&&void 0!==a[1]?a[1]:{},n=h.find((function(e){return e.name===t}))){e.next=4;break}return e.abrupt("return",Promise.reject("Unknown remediation choice: [".concat(t,"]")));case 4:if("function"==typeof n.action){e.next=7;break}return e.abrupt("return",Promise.reject("Current remediation cannot make form submit action: [".concat(t,"]")));case 7:return e.abrupt("return",n.action(r));case 8:case"end":return e.stop()}}),e)}))),function(e){return f.apply(this,arguments)});return{proceed:b,neededToProceed:g,actions:y,context:v,rawIdxState:d,interactionCode:null===(c=d.successWithInteractionCode)||void 0===c||null===(s=c.value)||void 0===s||null===(l=s.find((function(e){return"interaction_code"===e.name})))||void 0===l?void 0:l.value,toPersist:r,requestDidSucceed:n}};var o=n(r(4687)),a=n(r(7156)),i=n(r(861)),u=r(897)},157:function(e,t,r){"use strict";t.default=void 0;var n={makeIdxState:r(6273).makeIdxState};t.default=n,e.exports=t.default},7423:function(e,t,r){"use strict";var n=r(4836);t.generateRemediationFunctions=void 0;var o=n(r(8416)),a=n(r(8941));function i(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function u(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?i(Object(r),!0).forEach((function(t){(0,o.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):i(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}t.generateRemediationFunctions=function(e,t){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return t.reduce((function(t,n){return u(u({},t),{},(0,o.default)({},n.name,(0,a.default)(e,n,r)))}),{})}},8630:function(e,t,r){"use strict";var n={authenticate:!0,cancel:!0,handleEmailVerifyCallback:!0,isEmailVerifyCallback:!0,parseEmailVerifyCallback:!0,isEmailVerifyCallbackError:!0,interact:!0,introspect:!0,poll:!0,proceed:!0,canProceed:!0,register:!0,recoverPassword:!0,handleInteractionCodeRedirect:!0,startTransaction:!0,unlockAccount:!0};Object.defineProperty(t,"authenticate",{enumerable:!0,get:function(){return o.authenticate}}),Object.defineProperty(t,"canProceed",{enumerable:!0,get:function(){return l.canProceed}}),Object.defineProperty(t,"cancel",{enumerable:!0,get:function(){return a.cancel}}),Object.defineProperty(t,"handleEmailVerifyCallback",{enumerable:!0,get:function(){return i.handleEmailVerifyCallback}}),Object.defineProperty(t,"handleInteractionCodeRedirect",{enumerable:!0,get:function(){return p.handleInteractionCodeRedirect}}),Object.defineProperty(t,"interact",{enumerable:!0,get:function(){return u.interact}}),Object.defineProperty(t,"introspect",{enumerable:!0,get:function(){return c.introspect}}),Object.defineProperty(t,"isEmailVerifyCallback",{enumerable:!0,get:function(){return i.isEmailVerifyCallback}}),Object.defineProperty(t,"isEmailVerifyCallbackError",{enumerable:!0,get:function(){return i.isEmailVerifyCallbackError}}),Object.defineProperty(t,"parseEmailVerifyCallback",{enumerable:!0,get:function(){return i.parseEmailVerifyCallback}}),Object.defineProperty(t,"poll",{enumerable:!0,get:function(){return s.poll}}),Object.defineProperty(t,"proceed",{enumerable:!0,get:function(){return l.proceed}}),Object.defineProperty(t,"recoverPassword",{enumerable:!0,get:function(){return d.recoverPassword}}),Object.defineProperty(t,"register",{enumerable:!0,get:function(){return f.register}}),Object.defineProperty(t,"startTransaction",{enumerable:!0,get:function(){return h.startTransaction}}),Object.defineProperty(t,"unlockAccount",{enumerable:!0,get:function(){return v.unlockAccount}});var o=r(1286),a=r(9192),i=r(7985),u=r(6131),c=r(2660),s=r(9310),l=r(2845),f=r(8826),d=r(9214),p=r(5021),h=r(2473),v=r(8277),y=r(2620);Object.keys(y).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(n,e)||e in t&&t[e]===y[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return y[e]}}))}));var g=r(1175);Object.keys(g).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(n,e)||e in t&&t[e]===g[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return g[e]}}))}));var b=r(8137);Object.keys(b).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(n,e)||e in t&&t[e]===b[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return b[e]}}))}));var m=r(4602);Object.keys(m).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(n,e)||e in t&&t[e]===m[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return m[e]}}))}));var O=r(4143);Object.keys(O).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(n,e)||e in t&&t[e]===O[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return O[e]}}))}));var k=r(1642);Object.keys(k).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(n,e)||e in t&&t[e]===k[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return k[e]}}))}));var w=r(2348);Object.keys(w).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(n,e)||e in t&&t[e]===w[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return w[e]}}))}))},6131:function(e,t,r){"use strict";var n=r(4836);t.interact=function(e){return h.apply(this,arguments)};var o=n(r(4687)),a=n(r(8416)),i=n(r(7156)),u=r(2620),c=r(9443),s=r(305),l=r(4777);function f(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function d(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?f(Object(r),!0).forEach((function(t){(0,a.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):f(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function p(e){return{meta:e,interactionHandle:e.interactionHandle,state:e.state}}function h(){return h=(0,i.default)(o.default.mark((function e(t){var r,n,a,i,f,h,v,y,g,b,m,O,k,w,E,P,S,T,j,_,x,A,R,M,C,D=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(a=D.length>1&&void 0!==D[1]?D[1]:{},a=(0,s.removeNils)(a),i=(0,u.getSavedTransactionMeta)(t,a),null===(r=i)||void 0===r||!r.interactionHandle){e.next=5;break}return e.abrupt("return",p(i));case 5:return e.next=7,(0,u.createTransactionMeta)(t,d(d({},i),a));case 7:return i=e.sent,f=(0,c.getOAuthBaseUrl)(t),v=(h=i).clientId,y=h.redirectUri,g=h.state,b=h.scopes,m=h.withCredentials,O=h.codeChallenge,k=h.codeChallengeMethod,w=h.activationToken,E=h.recoveryToken,P=h.maxAge,S=h.acrValues,T=h.nonce,j=a.clientSecret||t.options.clientSecret,m=null===(n=m)||void 0===n||n,_="".concat(f,"/v1/interact"),x=d(d(d(d(d(d({client_id:v,scope:b.join(" "),redirect_uri:y,code_challenge:O,code_challenge_method:k,state:g},w&&{activation_token:w}),E&&{recovery_token:E}),j&&{client_secret:j}),P&&{max_age:P}),S&&{acr_values:S}),T&&{nonce:T}),A={"Content-Type":"application/x-www-form-urlencoded"},e.next=17,(0,l.httpRequest)(t,{method:"POST",url:_,headers:A,withCredentials:m,args:x});case 17:return R=e.sent,M=R.interaction_handle,C=d(d({},i),{},{interactionHandle:M,withCredentials:m,state:g,scopes:b,recoveryToken:E,activationToken:w}),(0,u.saveTransactionMeta)(t,C),e.abrupt("return",p(C));case 22:case"end":return e.stop()}}),e)}))),h.apply(this,arguments)}},2660:function(e,t,r){"use strict";var n=r(4836);t.introspect=function(e){return d.apply(this,arguments)};var o=n(r(4687)),a=n(r(7156)),i=r(7894),u=r(480),c=r(9443),s=r(1971),l=r(4777),f=r(5728);function d(){return d=(0,a.default)(o.default.mark((function e(t){var r,n,a,d,p,h,v,y,g,b,m,O,k,w,E=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=E.length>1&&void 0!==E[1]?E[1]:{},(d=t.transactionManager.loadIdxResponse(r))&&(n=d.rawIdxResponse,a=d.requestDidSucceed),n){e.next=27;break}return h=r.version||s.IDX_API_VERSION,v=(0,c.getOAuthDomain)(t),y=r.interactionHandle,g=r.stateHandle,b=null===(p=r.withCredentials)||void 0===p||p,e.prev=8,a=!0,(0,i.validateVersionConfig)(h),m="".concat(v,"/idp/idx/introspect"),O=g?{stateToken:g}:{interactionHandle:y},k={"Content-Type":"application/ion+json; okta-version=".concat(h),Accept:"application/ion+json; okta-version=".concat(h)},e.next=16,(0,l.httpRequest)(t,{method:"POST",url:m,headers:k,withCredentials:b,args:O});case 16:n=e.sent,e.next=27;break;case 19:if(e.prev=19,e.t0=e.catch(8),!((0,f.isAuthApiError)(e.t0)&&e.t0.xhr&&(0,u.isRawIdxResponse)(e.t0.xhr.responseJSON))){e.next=26;break}n=e.t0.xhr.responseJSON,a=!1,e.next=27;break;case 26:throw e.t0;case 27:return w=r.withCredentials,e.abrupt("return",(0,i.makeIdxState)(t,n,{withCredentials:w},a));case 29:case"end":return e.stop()}}),e,null,[[8,19]])}))),d.apply(this,arguments)}},8137:function(e,t,r){"use strict";var n=r(4836),o=r(8698);t.mixinIdx=function(e){var t;return t=function(e){(0,c.default)(o,e);var t,r,n=(t=o,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,l.default)(t);if(r){var o=(0,l.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,s.default)(this,e)});function o(){var e;(0,i.default)(this,o);for(var t=arguments.length,r=new Array(t),a=0;a<t;a++)r[a]=arguments[a];return e=n.call.apply(n,[this].concat(r)),(0,f.default)((0,u.default)(e),"idx",void 0),e.idx=(0,d.createIdxAPI)((0,u.default)(e)),e}return(0,a.default)(o)}(e),(0,f.default)(t,"webauthn",p),t};var a=n(r(9728)),i=n(r(6690)),u=n(r(6115)),c=n(r(1655)),s=n(r(4993)),l=n(r(3808)),f=n(r(8416)),d=r(9727),p=function(e,t){if(e&&e.__esModule)return e;if(null===e||"object"!==o(e)&&"function"!=typeof e)return{default:e};var r=h(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var u=a?Object.getOwnPropertyDescriptor(e,i):null;u&&(u.get||u.set)?Object.defineProperty(n,i,u):n[i]=e[i]}return n.default=e,r&&r.set(e,n),n}(r(8716));function h(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(h=function(e){return e?r:t})(e)}},1402:function(e,t,r){"use strict";var n=r(4836),o=r(8698);t.mixinMinimalIdx=function(e){var t;return t=function(e){(0,c.default)(o,e);var t,r,n=(t=o,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,l.default)(t);if(r){var o=(0,l.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,s.default)(this,e)});function o(){var e;(0,i.default)(this,o);for(var t=arguments.length,r=new Array(t),a=0;a<t;a++)r[a]=arguments[a];return e=n.call.apply(n,[this].concat(r)),(0,f.default)((0,u.default)(e),"idx",void 0),e.idx=(0,d.createMinimalIdxAPI)((0,u.default)(e)),e}return(0,a.default)(o)}(e),(0,f.default)(t,"webauthn",p),t};var a=n(r(9728)),i=n(r(6690)),u=n(r(6115)),c=n(r(1655)),s=n(r(4993)),l=n(r(3808)),f=n(r(8416)),d=r(7044),p=function(e,t){if(e&&e.__esModule)return e;if(null===e||"object"!==o(e)&&"function"!=typeof e)return{default:e};var r=h(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var u=a?Object.getOwnPropertyDescriptor(e,i):null;u&&(u.get||u.set)?Object.defineProperty(n,i,u):n[i]=e[i]}return n.default=e,r&&r.set(e,n),n}(r(8716));function h(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(h=function(e){return e?r:t})(e)}},4602:function(e,t,r){"use strict";var n=r(4836);t.createIdxOptionsConstructor=function(){return function(e){(0,u.default)(f,e);var t,r,n=(t=f,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function f(e){var t;return(0,a.default)(this,f),t=n.call(this,e),(0,l.default)((0,i.default)(t),"flow",void 0),(0,l.default)((0,i.default)(t),"activationToken",void 0),(0,l.default)((0,i.default)(t),"recoveryToken",void 0),(0,l.default)((0,i.default)(t),"idx",void 0),t.flow=e.flow,t.activationToken=e.activationToken,t.recoveryToken=e.recoveryToken,t.idx=e.idx,t}return(0,o.default)(f)}((0,f.createCoreOptionsConstructor)())};var o=n(r(9728)),a=n(r(6690)),i=n(r(6115)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416)),f=r(9133)},9310:function(e,t,r){"use strict";var n=r(4836);t.poll=s;var o=n(r(4687)),a=n(r(7156)),i=r(2845),u=r(2620),c=r(305);function s(e){return l.apply(this,arguments)}function l(){return l=(0,a.default)(o.default.mark((function e(t){var r,n,l,f,d,p=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=p.length>1&&void 0!==p[1]?p[1]:{},e.next=3,(0,i.proceed)(t,{startPolling:!0});case 3:if(l=e.sent,f=(0,u.getSavedTransactionMeta)(t),null!=(d=null==f||null===(r=f.remediations)||void 0===r?void 0:r.find((function(e){return e.includes("poll")})))&&d.length||(0,c.warn)("No polling remediations available at the current IDX flow stage"),!Number.isInteger(n.refresh)){e.next=9;break}return e.abrupt("return",new Promise((function(e,r){setTimeout((0,a.default)(o.default.mark((function n(){var a,i,u;return o.default.wrap((function(n){for(;;)switch(n.prev=n.next){case 0:try{u=null===(a=l.nextStep)||void 0===a||null===(i=a.poll)||void 0===i?void 0:i.refresh,e(u?s(t,{refresh:u}):l)}catch(e){r(e)}case 1:case"end":return n.stop()}}),n)}))),n.refresh)})));case 9:return e.abrupt("return",l);case 10:case"end":return e.stop()}}),e)}))),l.apply(this,arguments)}},2845:function(e,t,r){"use strict";var n=r(4836);t.canProceed=d,t.proceed=function(e){return p.apply(this,arguments)};var o=n(r(4687)),a=n(r(8416)),i=n(r(7156)),u=r(4819),c=r(2620),s=r(5728);function l(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function f(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?l(Object(r),!0).forEach((function(t){(0,a.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):l(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function d(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return!(!(0,c.getSavedTransactionMeta)(e,t)&&!t.stateHandle)}function p(){return p=(0,i.default)(o.default.mark((function e(t){var r,n,a,i,l=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(d(t,r=l.length>1&&void 0!==l[1]?l[1]:{})){e.next=3;break}throw new s.AuthSdkError("Unable to proceed: saved transaction could not be loaded");case 3:return n=r.flow,a=r.state,n||(i=(0,c.getSavedTransactionMeta)(t,{state:a}),n=null==i?void 0:i.flow),e.abrupt("return",(0,u.run)(t,f(f({},r),{},{flow:n})));case 6:case"end":return e.stop()}}),e)}))),p.apply(this,arguments)}},9214:function(e,t,r){"use strict";var n=r(4836);t.recoverPassword=function(e){return f.apply(this,arguments)};var o=n(r(4687)),a=n(r(8416)),i=n(r(7156)),u=r(4819),c=r(8306);function s(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function l(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?s(Object(r),!0).forEach((function(t){(0,a.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):s(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function f(){return f=(0,i.default)(o.default.mark((function e(t){var r,n,a=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=a.length>1&&void 0!==a[1]?a[1]:{},n=(0,c.getFlowSpecification)(t,"recoverPassword"),e.abrupt("return",(0,u.run)(t,l(l({},r),n)));case 3:case"end":return e.stop()}}),e)}))),f.apply(this,arguments)}},8826:function(e,t,r){"use strict";var n=r(4836);t.register=function(e){return h.apply(this,arguments)};var o=n(r(4687)),a=n(r(8416)),i=n(r(7156)),u=r(4819),c=r(2620),s=r(2473),l=r(5728),f=r(1642);function d(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function p(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?d(Object(r),!0).forEach((function(t){(0,a.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):d(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function h(){return h=(0,i.default)(o.default.mark((function e(t){var r,n,a,i=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=i.length>1&&void 0!==i[1]?i[1]:{},(0,c.hasSavedInteractionHandle)(t)){e.next=8;break}return e.next=4,(0,s.startTransaction)(t,p(p({},r),{},{flow:"register",autoRemediate:!1}));case 4:if(n=e.sent,a=n.enabledFeatures,r.activationToken||!a||a.includes(f.IdxFeature.REGISTRATION)){e.next=8;break}throw new l.AuthSdkError("Registration is not supported based on your current org configuration.");case 8:return e.abrupt("return",(0,u.run)(t,p(p({},r),{},{flow:"register"})));case 9:case"end":return e.stop()}}),e)}))),h.apply(this,arguments)}},201:function(e,t,r){"use strict";var n=r(4836);t.remediate=b;var o=n(r(4687)),a=n(r(8698)),i=n(r(861)),u=n(r(7156)),c=n(r(8416)),s=r(5728),l=r(5031);function f(e,t){var r="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!r){if(Array.isArray(e)||(r=function(e,t){if(e){if("string"==typeof e)return d(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?d(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){r&&(e=r);var n=0,o=function(){};return{s:o,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,i=!0,u=!1;return{s:function(){r=r.call(e)},n:function(){var e=r.next();return i=e.done,e},e:function(e){u=!0,a=e},f:function(){try{i||null==r.return||r.return()}finally{if(u)throw a}}}}function d(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function p(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function h(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?p(Object(r),!0).forEach((function(t){(0,c.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):p(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function v(e,t){return Object.keys(t.actions).find((function(t){return!!e.resend&&t.includes("-resend")}))}function y(e){return h(h({},e),{},{resend:void 0})}function g(e,t){var r=e.actions||[];return r=r.filter((function(e){return"string"==typeof e?e!==t:e.name!==t})),h(h({},e),{},{actions:r})}function b(e,t,r,n){return m.apply(this,arguments)}function m(){return(m=(0,u.default)(o.default.mark((function e(t,r,n,u){var c,d,p,m,O,k,w,E,P,S,T,j,_,x,A,R,M,C;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(d=(c=r).neededToProceed,p=c.interactionCode,m=u.flow,!p){e.next=4;break}return e.abrupt("return",{idxResponse:r});case 4:if(O=(0,l.getRemediator)(r,n,u),k=v(n,r),w=u.actions||[],!(E=[].concat((0,i.default)(w),(0,i.default)(k&&[k]||[])))){e.next=28;break}P=f(E),e.prev=10,T=o.default.mark((function e(){var a,i,c,s;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(a=S.value,i={},"string"!=typeof a&&(i=a.params||{},a=a.name),c=y(n),s=g(u,a),"function"!=typeof r.actions[a]){e.next=14;break}return e.next=8,r.actions[a](i);case 8:if(!1!==(r=e.sent).requestDidSucceed){e.next=11;break}return e.abrupt("return",{v:(0,l.handleFailedResponse)(t,r,u)});case 11:if("cancel"!==a){e.next=13;break}return e.abrupt("return",{v:{idxResponse:r,canceled:!0}});case 13:return e.abrupt("return",{v:b(t,r,c,s)});case 14:if(!d.find((function(e){return e.name===a}))){e.next=22;break}return e.next=18,r.proceed(a,i);case 18:if(!1!==(r=e.sent).requestDidSucceed){e.next=21;break}return e.abrupt("return",{v:(0,l.handleFailedResponse)(t,r,u)});case 21:return e.abrupt("return",{v:b(t,r,n,s)});case 22:case"end":return e.stop()}}),e)})),P.s();case 13:if((S=P.n()).done){e.next=20;break}return e.delegateYield(T(),"t0",15);case 15:if(j=e.t0,"object"!==(0,a.default)(j)){e.next=18;break}return e.abrupt("return",j.v);case 18:e.next=13;break;case 20:e.next=25;break;case 22:e.prev=22,e.t1=e.catch(10),P.e(e.t1);case 25:return e.prev=25,P.f(),e.finish(25);case 28:if(!(_=(0,l.isTerminalResponse)(r))){e.next=31;break}return e.abrupt("return",{idxResponse:r,terminal:_});case 31:if(O){e.next=43;break}if(!u.step){e.next=40;break}return n=(0,l.filterValuesForRemediation)(r,u.step,n),e.next=36,r.proceed(u.step,n);case 36:if(!1!==(r=e.sent).requestDidSucceed){e.next=39;break}return e.abrupt("return",(0,l.handleFailedResponse)(t,r,u));case 39:return e.abrupt("return",{idxResponse:r});case 40:if("default"!==m){e.next=42;break}return e.abrupt("return",{idxResponse:r});case 42:throw new s.AuthSdkError("\n      No remediation can match current flow, check policy settings in your org.\n      Remediations: [".concat(d.reduce((function(e,t){return e?e+" ,"+t.name:t.name}),""),"]\n    "));case 43:if(O.canRemediate()){e.next=46;break}return x=(0,l.getNextStep)(t,O,r),e.abrupt("return",{idxResponse:r,nextStep:x});case 46:return A=O.getName(),R=O.getData(),e.next=50,r.proceed(A,R);case 50:if(!1!==(r=e.sent).requestDidSucceed){e.next=53;break}return e.abrupt("return",(0,l.handleFailedResponse)(t,r,u));case 53:if(n=O.getValuesAfterProceed(),!(u=h(h({},u),{},{step:void 0})).useGenericRemediator||r.interactionCode||(0,l.isTerminalResponse)(r)){e.next=59;break}return M=(0,l.getRemediator)(r,n,u),C=(0,l.getNextStep)(t,M,r),e.abrupt("return",{idxResponse:r,nextStep:C});case 59:return e.abrupt("return",b(t,r,n,u));case 60:case"end":return e.stop()}}),e,null,[[10,22,25,28]])})))).apply(this,arguments)}},2541:function(e,t,r){"use strict";var n=r(4836);t.AuthenticatorEnrollmentData=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(1588)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416)),f=r(4794),d=r(6064);function p(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function h(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?p(Object(r),!0).forEach((function(t){(0,l.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):p(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var v=function(e){(0,u.default)(l,e);var t,r,n=(t=l,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function l(){return(0,o.default)(this,l),n.apply(this,arguments)}return(0,a.default)(l,[{key:"mapAuthenticator",value:function(){var e=this.getAuthenticatorData();return{id:(0,d.getAuthenticatorFromRemediation)(this.remediation).form.value.find((function(e){return"id"===e.name})).value,methodType:e.methodType,phoneNumber:e.phoneNumber}}},{key:"getInputAuthenticator",value:function(e){return[{name:"methodType",type:"string"},{name:"phoneNumber",label:"Phone Number",type:"string"}].map((function(t){return h(h({},e.form.value.find((function(e){return e.name===t.name}))),t)}))}},{key:"mapAuthenticatorDataFromValues",value:function(e){e=(0,i.default)((0,s.default)(l.prototype),"mapAuthenticatorDataFromValues",this).call(this,e);var t=this.values.phoneNumber;if(e||t)return h(h({},e&&e),t&&{phoneNumber:t})}}]),l}(f.AuthenticatorData);t.AuthenticatorEnrollmentData=v,(0,l.default)(v,"remediationName","authenticator-enrollment-data")},5278:function(e,t,r){"use strict";var n=r(4836);t.AuthenticatorVerificationData=void 0;var o=n(r(861)),a=n(r(6690)),i=n(r(9728)),u=n(r(1588)),c=n(r(1655)),s=n(r(4993)),l=n(r(3808)),f=n(r(8416));function d(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function p(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?d(Object(r),!0).forEach((function(t){(0,f.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):d(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var h=function(e){(0,c.default)(d,e);var t,r,n=(t=d,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,l.default)(t);if(r){var o=(0,l.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,s.default)(this,e)});function d(){return(0,a.default)(this,d),n.apply(this,arguments)}return(0,i.default)(d,[{key:"mapAuthenticator",value:function(){return this.getAuthenticatorData()}},{key:"getInputAuthenticator",value:function(){var e=this.getAuthenticatorFromRemediation(),t=e.form.value.find((function(e){return"methodType"===e.name}));return t&&t.options?{name:"methodType",type:"string",required:!0,options:t.options}:(0,o.default)(e.form.value)}},{key:"getValuesAfterProceed",value:function(){var e=this;return this.values=(0,u.default)((0,l.default)(d.prototype),"getValuesAfterProceed",this).call(this),Object.keys(this.values).filter((function(e){return"authenticator"!==e})).reduce((function(t,r){return p(p({},t),{},(0,f.default)({},r,e.values[r]))}),{})}}]),d}(r(4794).AuthenticatorData);t.AuthenticatorVerificationData=h,(0,f.default)(h,"remediationName","authenticator-verification-data")},4794:function(e,t,r){"use strict";var n=r(4836);t.AuthenticatorData=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(6115)),u=n(r(1588)),c=n(r(1655)),s=n(r(4993)),l=n(r(3808)),f=n(r(8416)),d=r(3118),p=r(7595),h=r(9344);function v(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function y(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?v(Object(r),!0).forEach((function(t){(0,f.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):v(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var g=function(e){(0,c.default)(d,e);var t,r,n=(t=d,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,l.default)(t);if(r){var o=(0,l.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,s.default)(this,e)});function d(e){var t,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return(0,o.default)(this,d),t=n.call(this,e,r),(0,f.default)((0,i.default)(t),"authenticator",void 0),t.authenticator=t.getAuthenticator(),t.formatAuthenticatorData(),t}return(0,a.default)(d,[{key:"formatAuthenticatorData",value:function(){var e=this;if(this.getAuthenticatorData())this.values.authenticatorsData=this.values.authenticatorsData.map((function(t){return(0,h.compareAuthenticators)(e.authenticator,t)?e.mapAuthenticatorDataFromValues(t):t}));else{var t=this.mapAuthenticatorDataFromValues();t&&this.values.authenticatorsData.push(t)}}},{key:"getAuthenticatorData",value:function(){var e=this;return this.values.authenticatorsData.find((function(t){return(0,h.compareAuthenticators)(e.authenticator,t)}))}},{key:"canRemediate",value:function(){var e=this;return this.values.authenticatorsData.some((function(t){return(0,h.compareAuthenticators)(e.authenticator,t)}))}},{key:"mapAuthenticatorDataFromValues",value:function(e){var t=this.values,r=t.methodType,n=t.authenticator;!r&&(0,p.isAuthenticator)(n)&&(r=null==n?void 0:n.methodType);var o=this.authenticator,a=y(y({id:o.id,enrollmentId:o.enrollmentId},e&&e),r&&{methodType:r});return a.methodType?a:null}},{key:"getAuthenticatorFromRemediation",value:function(){return this.remediation.value.find((function(e){return"authenticator"===e.name}))}},{key:"getValuesAfterProceed",value:function(){var e=this;this.values=(0,u.default)((0,l.default)(d.prototype),"getValuesAfterProceed",this).call(this);var t=this.values.authenticatorsData.filter((function(t){return!0!==(0,h.compareAuthenticators)(e.authenticator,t)}));return y(y({},this.values),{},{authenticatorsData:t})}}]),d}(d.Remediator);t.AuthenticatorData=g},3118:function(e,t,r){"use strict";var n=r(4836);t.Remediator=void 0;var o=n(r(861)),a=n(r(8698)),i=n(r(6690)),u=n(r(9728)),c=n(r(8416)),s=r(6064),l=r(9344);function f(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function d(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function p(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?d(Object(r),!0).forEach((function(t){(0,c.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):d(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var h=function(){function e(t){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};(0,i.default)(this,e),(0,c.default)(this,"remediation",void 0),(0,c.default)(this,"values",void 0),(0,c.default)(this,"options",void 0),(0,c.default)(this,"map",void 0),this.values=p({},r),this.options=p({},n),this.formatAuthenticators(),this.remediation=t}return(0,u.default)(e,[{key:"formatAuthenticators",value:function(){if(this.values.authenticators=this.values.authenticators||[],this.values.authenticators=this.values.authenticators.map((function(e){return(0,l.formatAuthenticator)(e)})),this.values.authenticator){var e=(0,l.formatAuthenticator)(this.values.authenticator);this.values.authenticators.some((function(t){return(0,l.compareAuthenticators)(e,t)}))||this.values.authenticators.push(e)}this.values.authenticatorsData=this.values.authenticators.reduce((function(e,t){return"object"===(0,a.default)(t)&&Object.keys(t).length>1&&e.push(t),e}),this.values.authenticatorsData||[])}},{key:"getName",value:function(){return this.remediation.name}},{key:"canRemediate",value:function(e){var t=this;return!(0,s.getRequiredValues)(this.remediation).find((function(e){return!t.hasData(e)}))}},{key:"getData",value:function(e){var t=this;if(!e){var r=(0,s.getAllValues)(this.remediation).reduce((function(e,r){return e[r]=t.getData(r),e}),{});return r}if("function"==typeof this["map".concat((0,s.titleCase)(e))]){var n=this["map".concat((0,s.titleCase)(e))](this.remediation.value.find((function(t){return t.name===e})));if(n)return n}if(this.map&&this.map[e])for(var o=this.map[e],a=0;a<o.length;a++){var i=this.values[o[a]];if(i)return i}return this.values[e]}},{key:"hasData",value:function(e){return!!this.getData(e)}},{key:"getNextStep",value:function(e,t){var r=this.getName(),n=this.getInputs(),o=this.getAuthenticator(),a=null==o?void 0:o.type;return p(p({name:r,inputs:n},a&&{type:a}),o&&{authenticator:o})}},{key:"getInputs",value:function(){var e=this,t=[];return(this.remediation.value||[]).forEach((function(r){var n,o=r.name,a=r.type,i=r.visible,u=r.messages;if(!1!==i){if("function"==typeof e["getInput".concat((0,s.titleCase)(o))])n=e["getInput".concat((0,s.titleCase)(o))](r);else if("object"!==a){var c,l=(e.map?e.map[o]:null)||[];c=1===l.length?l[0]:l.find((function(t){return Object.keys(e.values).includes(t)})),c&&(n=p(p({},r),{},{name:c}))}n||(n=r),Array.isArray(n)?n.forEach((function(e){return t.push(e)})):(u&&(n.messages=u),t.push(n))}})),t}},{key:"getValuesAfterProceed",value:function(){var e,t=this.remediation.value||[],r=this.getInputs(),n=function(e,t){var r="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!r){if(Array.isArray(e)||(r=function(e,t){if(e){if("string"==typeof e)return f(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?f(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){r&&(e=r);var n=0,o=function(){};return{s:o,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,i=!0,u=!1;return{s:function(){r=r.call(e)},n:function(){var e=r.next();return i=e.done,e},e:function(e){u=!0,a=e},f:function(){try{i||null==r.return||r.return()}finally{if(u)throw a}}}}([].concat((0,o.default)(t),(0,o.default)(r)));try{for(n.s();!(e=n.n()).done;){var a=e.value;delete this.values[a.name]}}catch(e){n.e(e)}finally{n.f()}return this.values}},{key:"getAuthenticator",value:function(){var e,t,r=null===(e=this.remediation.relatesTo)||void 0===e?void 0:e.value;if(r){var n=(0,s.getAuthenticatorFromRemediation)(this.remediation);if(!n)return r;var o=n.form.value.find((function(e){return"id"===e.name})).value,a=null===(t=n.form.value.find((function(e){return"enrollmentId"===e.name})))||void 0===t?void 0:t.value;return p(p({},r),{},{id:o,enrollmentId:a})}}}],[{key:"getMessages",value:function(e){var t,r;if(e.value)return null===(t=e.value[0])||void 0===t||null===(r=t.form)||void 0===r?void 0:r.value.reduce((function(e,t){return t.messages&&(e=[].concat((0,o.default)(e),(0,o.default)(t.messages.value))),e}),[])}}]),e}();t.Remediator=h,(0,c.default)(h,"remediationName",void 0)},9164:function(e,t,r){"use strict";var n=r(4836);t.SelectAuthenticator=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(6115)),u=n(r(1588)),c=n(r(1655)),s=n(r(4993)),l=n(r(3808)),f=n(r(8416)),d=r(3118),p=r(6064),h=r(7595),v=r(9344);function y(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function g(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?y(Object(r),!0).forEach((function(t){(0,f.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):y(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function b(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}var m=function(e){(0,c.default)(d,e);var t,r,n=(t=d,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,l.default)(t);if(r){var o=(0,l.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,s.default)(this,e)});function d(){var e;(0,o.default)(this,d);for(var t=arguments.length,r=new Array(t),a=0;a<t;a++)r[a]=arguments[a];return e=n.call.apply(n,[this].concat(r)),(0,f.default)((0,i.default)(e),"selectedAuthenticator",void 0),(0,f.default)((0,i.default)(e),"selectedOption",void 0),e}return(0,a.default)(d,[{key:"findMatchedOption",value:function(e,t){var r,n,o=function(e,t){var r="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!r){if(Array.isArray(e)||(r=function(e,t){if(e){if("string"==typeof e)return b(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?b(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){r&&(e=r);var n=0,o=function(){};return{s:o,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,i=!0,u=!1;return{s:function(){r=r.call(e)},n:function(){var e=r.next();return i=e.done,e},e:function(e){u=!0,a=e},f:function(){try{i||null==r.return||r.return()}finally{if(u)throw a}}}}(e);try{var a=function(){var e=n.value;if(r=t.find((function(t){var r=t.relatesTo;return r.key&&r.key===e.key})))return"break"};for(o.s();!(n=o.n()).done&&"break"!==a(););}catch(e){o.e(e)}finally{o.f()}return r}},{key:"canRemediate",value:function(e){var t=this.values,r=t.authenticators,n=t.authenticator,o=(0,p.getAuthenticatorFromRemediation)(this.remediation).options;if(!r||!r.length)return!1;if((0,h.isAuthenticator)(n)&&n.id)return!0;var a=this.findMatchedOption(r,o);if(a){var i,u,c=(null==e?void 0:e.currentAuthenticator)&&(null==e?void 0:e.currentAuthenticator.value.id)===(null===(i=a.relatesTo)||void 0===i?void 0:i.id),s=(null==e?void 0:e.currentAuthenticatorEnrollment)&&(null==e?void 0:e.currentAuthenticatorEnrollment.value.id)===(null===(u=a.relatesTo)||void 0===u?void 0:u.id);return!c&&!s}return!1}},{key:"mapAuthenticator",value:function(e){var t=this.values,r=t.authenticators,n=t.authenticator;if((0,h.isAuthenticator)(n)&&n.id)return this.selectedAuthenticator=n,n;var o=e.options,a=(0,v.findMatchedOption)(r,o);return this.selectedAuthenticator=a.relatesTo,this.selectedOption=a,{id:null==a?void 0:a.value.form.value.find((function(e){return"id"===e.name})).value}}},{key:"getInputAuthenticator",value:function(e){return{name:"authenticator",type:"string",options:e.options.map((function(e){return{label:e.label,value:e.relatesTo.key}}))}}},{key:"getValuesAfterProceed",value:function(){var e=this;this.values=(0,u.default)((0,l.default)(d.prototype),"getValuesAfterProceed",this).call(this);var t=this.values.authenticators.filter((function(t){return!0!==(0,v.compareAuthenticators)(t,e.selectedAuthenticator)}));return g(g({},this.values),{},{authenticators:t})}}]),d}(d.Remediator);t.SelectAuthenticator=m},7555:function(e,t,r){"use strict";var n=r(4836);t.VerifyAuthenticator=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(6115)),u=n(r(1588)),c=n(r(1655)),s=n(r(4993)),l=n(r(3808)),f=n(r(8416)),d=r(3118),p=r(8220);function h(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function v(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?h(Object(r),!0).forEach((function(t){(0,f.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):h(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var y=function(e){(0,c.default)(d,e);var t,r,n=(t=d,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,l.default)(t);if(r){var o=(0,l.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,s.default)(this,e)});function d(e){var t,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return(0,o.default)(this,d),t=n.call(this,e,r),(0,f.default)((0,i.default)(t),"authenticator",void 0),t.authenticator=(0,p.getAuthenticator)(e),t}return(0,a.default)(d,[{key:"getNextStep",value:function(e,t){var r,n=(0,u.default)((0,l.default)(d.prototype),"getNextStep",this).call(this,e,t),o=null==t||null===(r=t.authenticatorEnrollments)||void 0===r?void 0:r.value;return v(v({},n),{},{authenticatorEnrollments:o})}},{key:"canRemediate",value:function(){return this.authenticator.canVerify(this.values)}},{key:"mapCredentials",value:function(){return this.authenticator.mapCredentials(this.values)}},{key:"getInputCredentials",value:function(e){return this.authenticator.getInputs(e)}},{key:"getValuesAfterProceed",value:function(){var e=this;return this.values=(0,u.default)((0,l.default)(d.prototype),"getValuesAfterProceed",this).call(this),Object.keys(this.values).filter((function(e){return"credentials"!==e})).reduce((function(t,r){return v(v({},t),{},(0,f.default)({},r,e.values[r]))}),{})}}]),d}(d.Remediator);t.VerifyAuthenticator=y},4560:function(e,t,r){"use strict";var n=r(4836);t.ChallengeAuthenticator=void 0;var o=n(r(9728)),a=n(r(6690)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808)),s=n(r(8416));var l=function(e){(0,i.default)(s,e);var t,r,n=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function s(){return(0,a.default)(this,s),n.apply(this,arguments)}return(0,o.default)(s)}(r(7555).VerifyAuthenticator);t.ChallengeAuthenticator=l,(0,s.default)(l,"remediationName","challenge-authenticator")},1104:function(e,t,r){"use strict";var n=r(4836);t.ChallengePoll=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808)),s=n(r(8416));var l=function(e){(0,i.default)(s,e);var t,r,n=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function s(){return(0,o.default)(this,s),n.apply(this,arguments)}return(0,a.default)(s,[{key:"canRemediate",value:function(){return!!this.values.startPolling||"challenge-poll"===this.options.step}}]),s}(r(2288).EnrollPoll);t.ChallengePoll=l,(0,s.default)(l,"remediationName","challenge-poll")},3857:function(e,t,r){"use strict";var n=r(4836);t.EnrollAuthenticator=void 0;var o=n(r(9728)),a=n(r(6690)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808)),s=n(r(8416));var l=function(e){(0,i.default)(s,e);var t,r,n=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function s(){return(0,a.default)(this,s),n.apply(this,arguments)}return(0,o.default)(s)}(r(7555).VerifyAuthenticator);t.EnrollAuthenticator=l,(0,s.default)(l,"remediationName","enroll-authenticator")},2288:function(e,t,r){"use strict";var n=r(4836);t.EnrollPoll=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(1588)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416));function f(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function d(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?f(Object(r),!0).forEach((function(t){(0,l.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):f(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var p=function(e){(0,u.default)(f,e);var t,r,n=(t=f,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function f(){return(0,o.default)(this,f),n.apply(this,arguments)}return(0,a.default)(f,[{key:"canRemediate",value:function(){return!!this.values.startPolling||"enroll-poll"===this.options.step}},{key:"getNextStep",value:function(e,t){var r=(0,i.default)((0,s.default)(f.prototype),"getNextStep",this).call(this,e,t),n=this.getAuthenticator();return!n&&null!=t&&t.currentAuthenticator&&(n=t.currentAuthenticator.value),d(d({},r),{},{authenticator:n,poll:{required:!0,refresh:this.remediation.refresh}})}},{key:"getValuesAfterProceed",value:function(){var e=this;return Object.keys(this.values).filter((function(e){return"startPolling"!==e})).reduce((function(t,r){return d(d({},t),{},(0,l.default)({},r,e.values[r]))}),{})}}]),f}(r(3118).Remediator);t.EnrollPoll=p,(0,l.default)(p,"remediationName","enroll-poll")},7522:function(e,t,r){"use strict";var n=r(4836);t.EnrollProfile=void 0;var o=n(r(861)),a=n(r(6690)),i=n(r(9728)),u=n(r(6115)),c=n(r(1655)),s=n(r(4993)),l=n(r(3808)),f=n(r(8416)),d=r(3118),p=r(8220);function h(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function v(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?h(Object(r),!0).forEach((function(t){(0,f.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):h(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var y=function(e){(0,c.default)(d,e);var t,r,n=(t=d,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,l.default)(t);if(r){var o=(0,l.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,s.default)(this,e)});function d(e){var t,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return(0,a.default)(this,d),t=n.call(this,e,r,o),(0,f.default)((0,u.default)(t),"authenticator",null),t.getCredentialsFromRemediation()&&(t.authenticator=t.authenticator=new p.OktaPassword({})),t}return(0,i.default)(d,[{key:"canRemediate",value:function(){if(this.authenticator&&!this.authenticator.canVerify(this.values))return!1;var e=this.getData().userProfile;return!!e&&this.remediation.value.find((function(e){return"userProfile"===e.name})).form.value.reduce((function(t,r){return r.required&&(t=t&&!!e[r.name]),t}),!0)}},{key:"getCredentialsFromRemediation",value:function(){return this.remediation.value.find((function(e){return"credentials"===e.name}))}},{key:"mapUserProfile",value:function(e){var t=this,r=e.form.value.map((function(e){return e.name})).reduce((function(e,r){return t.values[r]?v(v({},e),{},(0,f.default)({},r,t.values[r])):e}),{});if(0!==Object.keys(r).length)return r}},{key:"mapCredentials",value:function(){var e=this.authenticator&&this.authenticator.mapCredentials(this.values);if(e)return e}},{key:"getInputUserProfile",value:function(e){return(0,o.default)(e.form.value)}},{key:"getInputCredentials",value:function(e){return(0,o.default)(e.form.value)}},{key:"getErrorMessages",value:function(e){return e.value[0].form.value.reduce((function(e,t){return t.messages&&e.push(t.messages.value[0].message),e}),[])}}]),d}(d.Remediator);t.EnrollProfile=y,(0,f.default)(y,"remediationName","enroll-profile")},3679:function(e,t,r){"use strict";var n=r(4836);t.EnrollmentChannelData=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(1588)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416));function f(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function d(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?f(Object(r),!0).forEach((function(t){(0,l.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):f(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var p=function(e){(0,u.default)(f,e);var t,r,n=(t=f,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function f(){return(0,o.default)(this,f),n.apply(this,arguments)}return(0,a.default)(f,[{key:"getInputEmail",value:function(){return[{name:"email",type:"string",required:!0,label:"Email"}]}},{key:"getInputPhoneNumber",value:function(){return[{name:"phoneNumber",type:"string",required:!0,label:"Phone Number"}]}},{key:"canRemediate",value:function(){return Boolean(this.values.email||this.values.phoneNumber)}},{key:"getNextStep",value:function(e,t){var r=(0,i.default)((0,s.default)(f.prototype),"getNextStep",this).call(this,e,t),n=t.currentAuthenticator.value;return d(d({},r),{},{authenticator:n})}},{key:"getData",value:function(){return{stateHandle:this.values.stateHandle,email:this.values.email,phoneNumber:this.values.phoneNumber}}},{key:"getValuesAfterProceed",value:function(){var e=this;return Object.keys(this.values).filter((function(e){return!["email","phoneNumber"].includes(e)})).reduce((function(t,r){return d(d({},t),{},(0,l.default)({},r,e.values[r]))}),{})}}]),f}(r(3118).Remediator);t.EnrollmentChannelData=p,(0,l.default)(p,"remediationName","enrollment-channel-data")},784:function(e,t,r){"use strict";var n=r(4836);t.GenericRemediator=void 0;var o=n(r(4687)),a=n(r(7156)),i=n(r(8416)),u=n(r(215)),c=n(r(6690)),s=n(r(9728)),l=n(r(1655)),f=n(r(4993)),d=n(r(3808)),p=r(3118),h=r(2863),v=["href","method","rel","accepts","produces","value","action"];function y(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function g(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?y(Object(r),!0).forEach((function(t){(0,i.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):y(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var b=function(e){(0,l.default)(i,e);var t,r,n=(t=i,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,d.default)(t);if(r){var o=(0,d.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,f.default)(this,e)});function i(){return(0,c.default)(this,i),n.apply(this,arguments)}return(0,s.default)(i,[{key:"canRemediate",value:function(){return!("function"!=typeof this.remediation.action||"poll"!==this.remediation.name&&!this.remediation.name.endsWith("-poll")&&!this.options.step)}},{key:"getData",value:function(){var e=this;return this.getInputs().reduce((function(t,r){var n=r.name;return t[n]=e.values[n],t}),{})}},{key:"getNextStep",value:function(e,t){var r,n=this.getName(),i=this.getInputs(),c=this.remediation,s=(c.href,c.method,c.rel,c.accepts,c.produces,c.value,c.action),l=(0,u.default)(c,v);return s?g(g(g({},l),!!i.length&&{inputs:i}),{},{action:(r=(0,a.default)(o.default.mark((function t(r){return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",e.idx.proceed(g({step:n},r)));case 1:case"end":return t.stop()}}),t)}))),function(e){return r.apply(this,arguments)})}):g({},this.remediation)}},{key:"getInputs",value:function(){return(this.remediation.value||[]).filter((function(e){return"stateHandle"!==e.name})).map(h.unwrapFormValue).map((function(e){return e.type=e.type||"string",e}))}}]),i}(p.Remediator);t.GenericRemediator=b},6790:function(e,t,r){"use strict";var n=r(784);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}))},2863:function(e,t,r){"use strict";var n=r(4836);t.hasValidInputValue=function(e,t){return function e(t,r,n){var o=t.name,a=t.value,u=t.type,c=t.options,s=t.required,l=s||n;if(Array.isArray(a))return a.reduce((function(t,n){return t&&e(n,r[o],l)}),!0);if(c){if("object"===u){var f=r[o];if(!f)return!1;if(!f.id)return!0;var d=c.find((function(e){return e.value.find((function(e){return"id"===e.name})).value===f.id}));return!!d&&d.value.filter((function(e){return!!e.required})).reduce((function(e,t){var r=t.name;return e&&!!f[r]}),!0)}if(!1===s)return!0;if(!0===s)return!!r[o];throw new i.AuthSdkError("Unknown options type, ".concat(JSON.stringify(t)))}return!l||!(!r||!r[o])}(e,t,!1)},t.unwrapFormValue=function e(t){if(Array.isArray(t))return t.map((function(t){return"string"==typeof t||"number"==typeof t||"boolean"==typeof t?t:e(t)}));for(var r={},n=0,i=Object.entries(t);n<i.length;n++){var u=(0,a.default)(i[n],2),c=u[0],s=u[1];if(null!=s)if("object"===(0,o.default)(s)){var l=Object.keys(s);if(["value","form"].includes(c)&&1===l.length&&["value","form"].includes(l[0])){var f=e(s);Object.entries(f).forEach((function(e){var t=(0,a.default)(e,2),n=t[0],o=t[1];r[n]=o}))}else r[c]=e(s)}else r[c]=s}return r};var o=n(r(8698)),a=n(r(7424)),i=r(5728)},8628:function(e,t,r){"use strict";var n=r(4836);t.Identify=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(6115)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416));function f(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function d(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?f(Object(r),!0).forEach((function(t){(0,l.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):f(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var p=function(e){(0,u.default)(f,e);var t,r,n=(t=f,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function f(){var e;(0,o.default)(this,f);for(var t=arguments.length,r=new Array(t),a=0;a<t;a++)r[a]=arguments[a];return e=n.call.apply(n,[this].concat(r)),(0,l.default)((0,i.default)(e),"map",{identifier:["username"]}),e}return(0,a.default)(f,[{key:"canRemediate",value:function(){return!!this.getData().identifier}},{key:"mapCredentials",value:function(){var e=this.values,t=e.credentials,r=e.password;if(t||r)return t||{passcode:r}}},{key:"getInputCredentials",value:function(e){return d(d({},e.form.value[0]),{},{name:"password",required:e.required})}}]),f}(r(3118).Remediator);t.Identify=p,(0,l.default)(p,"remediationName","identify")},9024:function(e,t,r){"use strict";var n=r(4836);t.ReEnrollAuthenticator=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808)),s=n(r(8416));function l(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function f(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?l(Object(r),!0).forEach((function(t){(0,s.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):l(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var d=function(e){(0,i.default)(s,e);var t,r,n=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function s(){return(0,o.default)(this,s),n.apply(this,arguments)}return(0,a.default)(s,[{key:"mapCredentials",value:function(){var e=this.values.newPassword;if(e)return{passcode:e}}},{key:"getInputCredentials",value:function(e){var t="password"===this.getAuthenticator().type?"newPassword":"verificationCode";return f(f({},e.form.value[0]),{},{name:t})}}]),s}(r(3118).Remediator);t.ReEnrollAuthenticator=d,(0,s.default)(d,"remediationName","reenroll-authenticator")},8107:function(e,t,r){"use strict";var n=r(4836);t.ReEnrollAuthenticatorWarning=void 0;var o=n(r(9728)),a=n(r(6690)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808)),s=n(r(8416));var l=function(e){(0,i.default)(s,e);var t,r,n=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function s(){return(0,a.default)(this,s),n.apply(this,arguments)}return(0,o.default)(s)}(r(9024).ReEnrollAuthenticator);t.ReEnrollAuthenticatorWarning=l,(0,s.default)(l,"remediationName","reenroll-authenticator-warning")},8490:function(e,t,r){"use strict";var n=r(4836);t.RedirectIdp=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808)),s=n(r(8416));var l=function(e){(0,i.default)(s,e);var t,r,n=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function s(){return(0,o.default)(this,s),n.apply(this,arguments)}return(0,a.default)(s,[{key:"canRemediate",value:function(){return!1}},{key:"getNextStep",value:function(){var e=this.remediation;return{name:e.name,type:e.type,idp:e.idp,href:e.href}}}]),s}(r(3118).Remediator);t.RedirectIdp=l,(0,s.default)(l,"remediationName","redirect-idp")},1019:function(e,t,r){"use strict";var n=r(4836);t.ResetAuthenticator=void 0;var o=n(r(9728)),a=n(r(6690)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808)),s=n(r(8416));var l=function(e){(0,i.default)(s,e);var t,r,n=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function s(){return(0,a.default)(this,s),n.apply(this,arguments)}return(0,o.default)(s)}(r(7555).VerifyAuthenticator);t.ResetAuthenticator=l,(0,s.default)(l,"remediationName","reset-authenticator")},7311:function(e,t,r){"use strict";var n=r(4836);t.SelectAuthenticatorAuthenticate=void 0;var o=n(r(861)),a=n(r(9728)),i=n(r(6690)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416)),f=r(9164),d=r(6064),p=r(1642);var h=function(e){(0,u.default)(l,e);var t,r,n=(t=l,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function l(e){var t,r,a=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},u=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};(0,i.default)(this,l);var c="recoverPassword"===(r=n.call(this,e,a,u)).options.flow;return(null===(t=(0,d.getAuthenticatorFromRemediation)(e).options)||void 0===t?void 0:t.some((function(e){var t=e.relatesTo;return(null==t?void 0:t.key)===p.AuthenticatorKey.OKTA_PASSWORD})))&&(c||r.values.password)&&(r.values.authenticators=[].concat((0,o.default)(r.values.authenticators||[]),[{key:p.AuthenticatorKey.OKTA_PASSWORD}])),r}return(0,a.default)(l)}(f.SelectAuthenticator);t.SelectAuthenticatorAuthenticate=h,(0,l.default)(h,"remediationName","select-authenticator-authenticate")},9865:function(e,t,r){"use strict";var n=r(4836);t.SelectAuthenticatorEnroll=void 0;var o=n(r(9728)),a=n(r(6690)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808)),s=n(r(8416));var l=function(e){(0,i.default)(s,e);var t,r,n=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function s(){return(0,a.default)(this,s),n.apply(this,arguments)}return(0,o.default)(s)}(r(9164).SelectAuthenticator);t.SelectAuthenticatorEnroll=l,(0,s.default)(l,"remediationName","select-authenticator-enroll")},5272:function(e,t,r){"use strict";var n=r(4836);t.SelectAuthenticatorUnlockAccount=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(6115)),u=n(r(1588)),c=n(r(1655)),s=n(r(4993)),l=n(r(3808)),f=n(r(8416));function d(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function p(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?d(Object(r),!0).forEach((function(t){(0,f.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):d(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var h=function(e){(0,c.default)(d,e);var t,r,n=(t=d,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,l.default)(t);if(r){var o=(0,l.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,s.default)(this,e)});function d(){var e;(0,o.default)(this,d);for(var t=arguments.length,r=new Array(t),a=0;a<t;a++)r[a]=arguments[a];return e=n.call.apply(n,[this].concat(r)),(0,f.default)((0,i.default)(e),"authenticator",void 0),(0,f.default)((0,i.default)(e),"map",{identifier:["username"]}),e}return(0,a.default)(d,[{key:"canRemediate",value:function(){return!!this.getData("identifier")&&(0,u.default)((0,l.default)(d.prototype),"canRemediate",this).call(this)}},{key:"mapAuthenticator",value:function(e){var t,r,n,o=(0,u.default)((0,l.default)(d.prototype),"mapAuthenticator",this).call(this,e),a=null===(t=this.selectedOption)||void 0===t?void 0:t.value.form.value.find((function(e){return"methodType"===e.name})),i=this.values.methodType||(null==a?void 0:a.value)||(null==a||null===(r=a.options)||void 0===r||null===(n=r[0])||void 0===n?void 0:n.value);return i?p(p({},o),{},{methodType:i}):o}},{key:"getInputUsername",value:function(){return{name:"username",type:"string"}}}]),d}(r(9164).SelectAuthenticator);t.SelectAuthenticatorUnlockAccount=h,(0,f.default)(h,"remediationName","select-authenticator-unlock-account")},4713:function(e,t,r){"use strict";var n=r(4836);t.SelectEnrollProfile=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808)),s=n(r(8416));var l=function(e){(0,i.default)(s,e);var t,r,n=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function s(){return(0,o.default)(this,s),n.apply(this,arguments)}return(0,a.default)(s,[{key:"canRemediate",value:function(){return!0}}]),s}(r(3118).Remediator);t.SelectEnrollProfile=l,(0,s.default)(l,"remediationName","select-enroll-profile")},3403:function(e,t,r){"use strict";var n=r(4836);t.SelectEnrollmentChannel=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(1588)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416));function f(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function d(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?f(Object(r),!0).forEach((function(t){(0,l.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):f(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var p=function(e){(0,u.default)(f,e);var t,r,n=(t=f,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function f(){return(0,o.default)(this,f),n.apply(this,arguments)}return(0,a.default)(f,[{key:"canRemediate",value:function(){if(this.values.channel)return!0;if(this.values.authenticator){var e=this.values.authenticator,t=e.id,r=e.channel;if(t&&r)return!0}return!1}},{key:"getNextStep",value:function(e,t){var r=(0,i.default)((0,s.default)(f.prototype),"getNextStep",this).call(this,e,t),n=t.currentAuthenticator.value;return d(d({},r),{},{authenticator:n})}},{key:"getData",value:function(){var e;return{authenticator:{id:this.remediation.value[0].value.form.value[0].value,channel:(null===(e=this.values.authenticator)||void 0===e?void 0:e.channel)||this.values.channel},stateHandle:this.values.stateHandle}}},{key:"getValuesAfterProceed",value:function(){var e=this;this.values=(0,i.default)((0,s.default)(f.prototype),"getValuesAfterProceed",this).call(this),delete this.values.authenticators;var t=this.values.channel?"channel":"authenticator";return Object.keys(this.values).filter((function(e){return e!==t})).reduce((function(t,r){return d(d({},t),{},(0,l.default)({},r,e.values[r]))}),{})}}]),f}(r(3118).Remediator);t.SelectEnrollmentChannel=p,(0,l.default)(p,"remediationName","select-enrollment-channel")},8443:function(e,t,r){"use strict";var n=r(4836);t.Skip=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808)),s=n(r(8416));var l=function(e){(0,i.default)(s,e);var t,r,n=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function s(){return(0,o.default)(this,s),n.apply(this,arguments)}return(0,a.default)(s,[{key:"canRemediate",value:function(){return!!this.values.skip||"skip"===this.options.step}}]),s}(r(3118).Remediator);t.Skip=l,(0,s.default)(l,"remediationName","skip")},8275:function(e,t,r){"use strict";var n=r(3118);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(3857);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(2288);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var i=r(3403);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}));var u=r(3679);Object.keys(u).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===u[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}}))}));var c=r(4560);Object.keys(c).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===c[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return c[e]}}))}));var s=r(1104);Object.keys(s).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===s[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return s[e]}}))}));var l=r(1019);Object.keys(l).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===l[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return l[e]}}))}));var f=r(7522);Object.keys(f).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===f[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return f[e]}}))}));var d=r(8628);Object.keys(d).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===d[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return d[e]}}))}));var p=r(9024);Object.keys(p).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===p[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return p[e]}}))}));var h=r(8107);Object.keys(h).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===h[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return h[e]}}))}));var v=r(8490);Object.keys(v).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===v[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return v[e]}}))}));var y=r(7311);Object.keys(y).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===y[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return y[e]}}))}));var g=r(9865);Object.keys(g).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===g[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return g[e]}}))}));var b=r(5272);Object.keys(b).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===b[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return b[e]}}))}));var m=r(4713);Object.keys(m).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===m[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return m[e]}}))}));var O=r(5278);Object.keys(O).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===O[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return O[e]}}))}));var k=r(2541);Object.keys(k).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===k[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return k[e]}}))}));var w=r(8443);Object.keys(w).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===w[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return w[e]}}))}));var E=r(6790);Object.keys(E).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===E[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return E[e]}}))}))},6064:function(e,t){"use strict";t.getAllValues=function(e){var t;return null===(t=e.value)||void 0===t?void 0:t.map((function(e){return e.name}))},t.getAuthenticatorFromRemediation=function(e){return e.value.find((function(e){return"authenticator"===e.name}))},t.getRequiredValues=function(e){var t;return null===(t=e.value)||void 0===t?void 0:t.reduce((function(e,t){return t.required&&e.push(t.name),e}),[])},t.titleCase=function(e){return e.charAt(0).toUpperCase()+e.substring(1)}},4819:function(e,t,r){"use strict";var n=r(4836);t.run=function(e){return S.apply(this,arguments)};var o=n(r(4687)),a=n(r(7156)),i=n(r(8416)),u=r(6131),c=r(2660),s=r(201),l=r(1642),f=r(2620),d=r(5031);function p(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function h(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?p(Object(r),!0).forEach((function(t){(0,i.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):p(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function v(e){var t=h({},e);return["flow","remediators","actions","withCredentials","step","useGenericRemediator","exchangeCodeForTokens"].forEach((function(e){delete t[e]})),t}function y(e,t){var r,n,o=t.options,a=o=h(h({},e.options.idx),o),i=a.flow,u=a.withCredentials,c=a.remediators,s=a.actions,f=l.IdxStatus.PENDING;if(i=i||(null===(r=(n=e.idx).getFlow)||void 0===r?void 0:r.call(n))||"default"){var p,v;null===(p=(v=e.idx).setFlow)||void 0===p||p.call(v,i);var y=(0,d.getFlowSpecification)(e,i);u=void 0!==u?u:y.withCredentials,c=c||y.remediators,s=s||y.actions}return h(h({},t),{},{options:h(h({},o),{},{flow:i,withCredentials:u,remediators:c,actions:s}),status:f})}function g(e,t){return b.apply(this,arguments)}function b(){return(b=(0,a.default)(o.default.mark((function e(t,r){var n,a,i,s,l,d,p,v,y,g,b,m,O,k,w,E;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=r.options,a=n.stateHandle,i=n.withCredentials,s=n.version,l=n.state,d=n.scopes,p=n.recoveryToken,v=n.activationToken,y=n.maxAge,g=n.acrValues,b=n.nonce,O=(0,f.getSavedTransactionMeta)(t,{state:l,recoveryToken:p,activationToken:v}),!a){e.next=9;break}return e.next=6,(0,c.introspect)(t,{withCredentials:i,version:s,stateHandle:a});case 6:m=e.sent,e.next=20;break;case 9:if(w=null===(k=O)||void 0===k?void 0:k.interactionHandle){e.next=17;break}return t.transactionManager.clear(),e.next=14,(0,u.interact)(t,{withCredentials:i,state:l,scopes:d,activationToken:v,recoveryToken:p,maxAge:y,acrValues:g,nonce:b});case 14:E=e.sent,w=E.interactionHandle,O=E.meta;case 17:return e.next=19,(0,c.introspect)(t,{withCredentials:i,version:s,interactionHandle:w});case 19:m=e.sent;case 20:return e.abrupt("return",h(h({},r),{},{idxResponse:m,meta:O}));case 21:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function m(e,t){return O.apply(this,arguments)}function O(){return(O=(0,a.default)(o.default.mark((function e(t,r){var n,a,i,u,c,l,f,d,p,v,y,g,b;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=r.idxResponse,a=r.options,i=r.values,u=a.autoRemediate,c=a.remediators,l=a.actions,f=a.flow,d=a.step,p=a.useGenericRemediator,!1!==u&&(c||l||d)){e.next=5;break}return e.abrupt("return",r);case 5:return i=h(h({},i),{},{stateHandle:n.rawIdxState.stateHandle}),e.next=8,(0,s.remediate)(t,n,i,{remediators:c,actions:l,flow:f,step:d,useGenericRemediator:p});case 8:return v=e.sent,y=v.idxResponse,g=v.nextStep,b=v.canceled,n=y,e.abrupt("return",h(h({},r),{},{idxResponse:n,nextStep:g,canceled:b}));case 14:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function k(e,t){return w.apply(this,arguments)}function w(){return(w=(0,a.default)(o.default.mark((function e(t,r){var n,a,i,u,c,s,l,f,d,p,h;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n=r.meta,a=r.idxResponse,i=a.interactionCode,c=(u=n).clientId,s=u.codeVerifier,l=u.ignoreSignature,f=u.redirectUri,d=u.urls,p=u.scopes,e.next=5,t.token.exchangeCodeForTokens({interactionCode:i,clientId:c,codeVerifier:s,ignoreSignature:l,redirectUri:f,scopes:p},d);case 5:return h=e.sent,e.abrupt("return",h.tokens);case 7:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function E(e,t){return P.apply(this,arguments)}function P(){return(P=(0,a.default)(o.default.mark((function e(t,r){var n,a,i,u,c,s,f,p,v,y,g,b,m,O,w,E;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=r.options,a=r.idxResponse,i=r.canceled,u=r.status,c=n.exchangeCodeForTokens,s=!1,f=!1,p=!0,a&&(s=!(!a.requestDidSucceed&&!a.stepUp),g=(0,d.getEnabledFeatures)(a),b=(0,d.getAvailableSteps)(t,a,n.useGenericRemediator),m=(0,d.getMessagesFromResponse)(a,n),O=(0,d.isTerminalResponse)(a)),!O){e.next=15;break}u=l.IdxStatus.TERMINAL,w=Object.keys(a.actions).length>0,E=!!m.find((function(e){return"ERROR"===e.class})),w||E||!0!==a.requestDidSucceed?s=!!w:f=!0,p=!1,e.next=32;break;case 15:if(!i){e.next=20;break}u=l.IdxStatus.CANCELED,f=!0,e.next=32;break;case 20:if(null==a||!a.interactionCode){e.next=32;break}if(v=a.interactionCode,!1!==c){e.next=27;break}u=l.IdxStatus.SUCCESS,f=!1,e.next=32;break;case 27:return e.next=29,k(t,r);case 29:y=e.sent,u=l.IdxStatus.SUCCESS,f=!0;case 32:return e.abrupt("return",h(h({},r),{},{status:u,interactionCode:v,tokens:y,shouldSaveResponse:s,shouldClearTransaction:f,clearSharedStorage:p,enabledFeatures:g,availableSteps:b,messages:m,terminal:O}));case 33:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function S(){return S=(0,a.default)(o.default.mark((function e(t){var r,n,a,i,u,c,s,l,d,p,b,O,k,w,P,S,T,j,_,x,A,R,M,C,D,I,N,L,F=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return n={options:r=F.length>1&&void 0!==F[1]?F[1]:{},values:v(r)},n=y(t,n),e.next=5,g(t,n);case 5:return n=e.sent,e.next=8,m(t,n);case 8:return n=e.sent,e.next=11,E(t,n);case 11:return n=e.sent,i=(a=n).idxResponse,u=a.meta,c=a.shouldSaveResponse,s=a.shouldClearTransaction,l=a.clearSharedStorage,d=a.status,p=a.enabledFeatures,b=a.availableSteps,O=a.tokens,k=a.nextStep,w=a.messages,P=a.error,S=a.interactionCode,s?t.transactionManager.clear({clearSharedStorage:l}):((0,f.saveTransactionMeta)(t,h({},u)),c&&(_=(j=i).rawIdxState,x=j.requestDidSucceed,t.transactionManager.saveIdxResponse({rawIdxResponse:_,requestDidSucceed:x,stateHandle:null===(T=i.context)||void 0===T?void 0:T.stateHandle,interactionHandle:null==u?void 0:u.interactionHandle}))),R=(A=i||{}).actions,M=A.context,C=A.neededToProceed,D=A.proceed,I=A.rawIdxState,N=A.requestDidSucceed,L=A.stepUp,e.abrupt("return",h(h(h(h(h(h(h(h(h({status:d},u&&{meta:u}),p&&{enabledFeatures:p}),b&&{availableSteps:b}),O&&{tokens:O}),k&&{nextStep:k}),w&&w.length&&{messages:w}),P&&{error:P}),L&&{stepUp:L}),{},{interactionCode:S,actions:R,context:M,neededToProceed:C,proceed:D,rawIdxState:I,requestDidSucceed:N}));case 16:case"end":return e.stop()}}),e)}))),S.apply(this,arguments)}},2473:function(e,t,r){"use strict";var n=r(4836);t.startTransaction=function(e){return l.apply(this,arguments)};var o=n(r(4687)),a=n(r(8416)),i=n(r(7156)),u=r(4819);function c(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function s(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?c(Object(r),!0).forEach((function(t){(0,a.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):c(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function l(){return l=(0,i.default)(o.default.mark((function e(t){var r,n=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=n.length>1&&void 0!==n[1]?n[1]:{},t.transactionManager.clear(),e.abrupt("return",(0,u.run)(t,s({exchangeCodeForTokens:!1},r)));case 3:case"end":return e.stop()}}),e)}))),l.apply(this,arguments)}},4143:function(e,t,r){"use strict";var n=r(4836);t.createIdxStorageManager=function(){return function(e){(0,i.default)(f,e);var t,r,n=(t=f,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function f(e,t,r){return(0,o.default)(this,f),n.call(this,e,t,r)}return(0,a.default)(f,[{key:"getIdxResponseStorage",value:function(e){var t;if((0,d.isBrowser)())try{t=this.storageUtil.getStorageByType("memory",e)}catch(e){(0,p.warn)("No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic")}else{var r=this.getTransactionStorage(e);r&&(t={getItem:function(e){var t=r.getStorage();return t&&t[e]?t[e]:null},setItem:function(e,t){var n=r.getStorage();if(!n)throw new h.default("Transaction has been cleared, failed to save idxState");n[e]=t,r.setStorage(n)},removeItem:function(e){var t=r.getStorage();t&&(delete t[e],r.setStorage(t))}})}return t?new s.SavedObject(t,l.IDX_RESPONSE_STORAGE_NAME):null}}]),f}((0,f.createCoreStorageManager)())};var o=n(r(6690)),a=n(r(9728)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808)),s=r(9927),l=r(1971),f=r(2647),d=r(415),p=r(305),h=n(r(9123))},2620:function(e,t,r){"use strict";var n=r(4836);t.clearTransactionMeta=function(e){e.transactionManager.clear()},t.createTransactionMeta=f,t.getSavedTransactionMeta=p,t.getTransactionMeta=function(e,t){return h.apply(this,arguments)},t.hasSavedInteractionHandle=function(e,t){var r=p(e,t);return!(null==r||!r.interactionHandle)},t.isTransactionMetaValid=v,t.isTransactionMetaValidForFlow=y,t.isTransactionMetaValidForOptions=g,t.saveTransactionMeta=function(e,t){e.transactionManager.save(t,{muteWarning:!0})};var o=n(r(4687)),a=n(r(8416)),i=n(r(7156)),u=r(305),c=r(9443);function s(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function l(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?s(Object(r),!0).forEach((function(t){(0,a.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):s(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function f(e){return d.apply(this,arguments)}function d(){return d=(0,i.default)(o.default.mark((function e(t){var r,n,a,i,u,s,f,d,p,h,v,y,g,b,m,O,k,w=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=w.length>1&&void 0!==w[1]?w[1]:{},e.next=3,t.token.prepareTokenParams(r);case 3:return n=e.sent,a=(0,c.createOAuthMeta)(t,n),i=l(l({},t.options),r),u=i.flow,s=void 0===u?"default":u,f=i.withCredentials,d=void 0===f||f,p=i.activationToken,h=void 0===p?void 0:p,v=i.recoveryToken,y=void 0===v?void 0:v,g=i.maxAge,b=void 0===g?void 0:g,m=i.acrValues,O=void 0===m?void 0:m,k=l(l({},a),{},{flow:s,withCredentials:d,activationToken:h,recoveryToken:y,maxAge:b,acrValues:O}),e.abrupt("return",k);case 8:case"end":return e.stop()}}),e)}))),d.apply(this,arguments)}function p(e,t){var r;t=(0,u.removeNils)(t),t=l(l({},e.options),t);try{r=e.transactionManager.load(t)}catch(e){}if(r)return v(r,t)?r:void(0,u.warn)("Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.")}function h(){return(h=(0,i.default)(o.default.mark((function e(t,r){var n;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=(0,u.removeNils)(r),r=l(l({},t.options),r),!(n=p(t,r))){e.next=5;break}return e.abrupt("return",n);case 5:return e.abrupt("return",f(t,r));case 6:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function v(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return!1!==g(e,t,["issuer","clientId","redirectUri","state","codeChallenge","codeChallengeMethod","activationToken","recoveryToken"])&&!1!==y(e,t.flow)}function y(e,t){return!(t&&"default"!==t&&"proceed"!==t)||t===e.flow}function g(e,t,r){return!r.some((function(r){var n=t[r];if(n&&n!==e[r])return!0}))}},7595:function(e,t){"use strict";var r,n,o;t.IdxStatus=t.IdxFeature=t.AuthenticatorKey=void 0,t.isAuthenticator=function(e){return e&&(e.key||e.id)},t.IdxStatus=r,function(e){e.SUCCESS="SUCCESS",e.PENDING="PENDING",e.FAILURE="FAILURE",e.TERMINAL="TERMINAL",e.CANCELED="CANCELED"}(r||(t.IdxStatus=r={})),t.AuthenticatorKey=n,function(e){e.OKTA_PASSWORD="okta_password",e.OKTA_EMAIL="okta_email",e.PHONE_NUMBER="phone_number",e.GOOGLE_AUTHENTICATOR="google_otp",e.SECURITY_QUESTION="security_question",e.OKTA_VERIFY="okta_verify",e.WEBAUTHN="webauthn"}(n||(t.AuthenticatorKey=n={})),t.IdxFeature=o,function(e){e.PASSWORD_RECOVERY="recover-password",e.REGISTRATION="enroll-profile",e.SOCIAL_IDP="redirect-idp",e.ACCOUNT_UNLOCK="unlock-account"}(o||(t.IdxFeature=o={}))},480:function(e,t){"use strict";function r(e){return e&&e.version}t.isIdxResponse=function(e){return e&&r(e.rawIdxState)},t.isRawIdxResponse=r},1642:function(e,t,r){"use strict";var n=r(7595);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(7446);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(5898);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var i=r(6736);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}))},5898:function(){},7446:function(){},6736:function(){},8277:function(e,t,r){"use strict";var n=r(4836);t.unlockAccount=function(e){return h.apply(this,arguments)};var o=n(r(4687)),a=n(r(8416)),i=n(r(7156)),u=r(4819),c=r(2620),s=r(2473),l=r(5728),f=r(1642);function d(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function p(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?d(Object(r),!0).forEach((function(t){(0,a.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):d(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function h(){return h=(0,i.default)(o.default.mark((function e(t){var r,n,a,i=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if((r=i.length>1&&void 0!==i[1]?i[1]:{}).flow="unlockAccount",(0,c.hasSavedInteractionHandle)(t)){e.next=9;break}return e.next=5,(0,s.startTransaction)(t,p(p({},r),{},{autoRemediate:!1}));case 5:if(n=e.sent,!(a=n.enabledFeatures)||a.includes(f.IdxFeature.ACCOUNT_UNLOCK)){e.next=9;break}throw new l.AuthSdkError("Self Service Account Unlock is not supported based on your current org configuration.");case 9:return e.abrupt("return",(0,u.run)(t,p({},r)));case 10:case"end":return e.stop()}}),e)}))),h.apply(this,arguments)}},5031:function(e,t,r){"use strict";var n=r(4836);t.canResendFn=k,t.canSkipFn=O,t.filterValuesForRemediation=function(e,t,r){var n=(e.neededToProceed||[]).find((function(e){return e.name===t}));return n?n.value.reduce((function(e,t){var n=t.name,o=t.value;return e[n]="stateHandle"===n?o:r[n],e}),{}):((0,l.warn)('filterValuesForRemediation: "'.concat(t,'" did not match any remediations')),r)},t.getAvailableSteps=function(e,t,r){var n,o=[],s=Object.values(b.remediators).reduce((function(e,t){return t.remediationName&&(e[t.remediationName]=t),e}),{}),f=y(t.neededToProceed);try{for(f.s();!(n=f.n()).done;){var d=n.value,h=P(d,{useGenericRemediator:r,remediators:s});if(h){var g=new h(d);o.push(g.getNextStep(e,t.context))}}}catch(e){f.e(e)}finally{f.f()}for(var m=function(){var r,n=(0,c.default)(k[O],1)[0],s={name:n,action:(r=(0,u.default)(i.default.mark((function t(r){return i.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",e.idx.proceed({actions:[{name:n,params:r}]}));case 1:case"end":return t.stop()}}),t)}))),function(e){return r.apply(this,arguments)})};if(n.startsWith("currentAuthenticator")){var f,d=(0,l.split2)(n,"-"),h=(0,c.default)(d,2),y=h[0],g=h[1],b=t.rawIdxState[y].value[g],m=(b.href,b.method,b.rel,b.accepts,b.produces,(0,a.default)(b,p)),w=null===(f=b.value)||void 0===f?void 0:f.filter((function(e){return"stateHandle"!==e.name}));s=v(v(v({},m),w&&{value:w}),s)}o.push(s)},O=0,k=Object.entries(t.actions||{});O<k.length;O++)m();return o},t.getEnabledFeatures=function(e){var t=[],r=e.actions,n=e.neededToProceed;return r["currentAuthenticator-recover"]&&t.push(d.IdxFeature.PASSWORD_RECOVERY),n.some((function(e){return"select-enroll-profile"===e.name}))&&t.push(d.IdxFeature.REGISTRATION),n.some((function(e){return"redirect-idp"===e.name}))&&t.push(d.IdxFeature.SOCIAL_IDP),n.some((function(e){return"unlock-account"===e.name}))&&t.push(d.IdxFeature.ACCOUNT_UNLOCK),t},t.getFlowSpecification=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"default";return b.getFlowSpecification(e,t)},t.getMessagesFromIdxRemediationValue=w,t.getMessagesFromResponse=E,t.getNextStep=T,t.getRemediator=S,t.handleFailedResponse=function(e,t){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},n=m(t),o=E(t,r);if(n)return{idxResponse:t,terminal:n,messages:o};var a=S(t,{},r),i=a&&T(e,a,t);return v({idxResponse:t,messages:o},i&&{nextStep:i})},t.isTerminalResponse=m,t.setRemediatorsCtx=function(e){Object.assign(b,e)};var o=n(r(8416)),a=n(r(215)),i=n(r(4687)),u=n(r(7156)),c=n(r(7424)),s=n(r(861)),l=r(305),f=r(6790),d=r(1642),p=["href","method","rel","accepts","produces"];function h(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function v(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?h(Object(r),!0).forEach((function(t){(0,o.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):h(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function y(e,t){var r="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!r){if(Array.isArray(e)||(r=function(e,t){if(e){if("string"==typeof e)return g(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?g(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){r&&(e=r);var n=0,o=function(){};return{s:o,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,i=!0,u=!1;return{s:function(){r=r.call(e)},n:function(){var e=r.next();return i=e.done,e},e:function(e){u=!0,a=e},f:function(){try{i||null==r.return||r.return()}finally{if(u)throw a}}}}function g(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}var b={remediators:{},getFlowSpecification:function(e){return{remediators:{}}}};function m(e){var t=e.neededToProceed,r=e.interactionCode;return!t.length&&!r}function O(e){return e.neededToProceed.some((function(e){return"skip"===e.name}))}function k(e){return Object.keys(e.actions).some((function(e){return e.includes("resend")}))}function w(e){if(e&&Array.isArray(e))return e.reduce((function(e,t){if(t.messages&&(e=[].concat((0,s.default)(e),(0,s.default)(t.messages.value))),t.form){var r=w(t.form.value)||[];e=[].concat((0,s.default)(e),(0,s.default)(r))}if(t.options){var n=[];t.options.forEach((function(e){e.value&&"string"!=typeof e.value&&(n=[].concat((0,s.default)(n),[e.value]))}));var o=w(n)||[];e=[].concat((0,s.default)(e),(0,s.default)(o))}return e}),[])}function E(e,t){var r,n=[],o=e.rawIdxState,a=e.neededToProceed,i=null===(r=o.messages)||void 0===r?void 0:r.value.map((function(e){return e}));if(i&&(n=[].concat((0,s.default)(n),(0,s.default)(i))),!t.useGenericRemediator){var u,c=y(a);try{for(c.s();!(u=c.n()).done;){var l=w(u.value.value);l&&(n=[].concat((0,s.default)(n),(0,s.default)(l)))}}catch(e){c.e(e)}finally{c.f()}}var f={};return n.reduce((function(e,t){var r,n=null===(r=t.i18n)||void 0===r?void 0:r.key;return n&&f[n]&&t.message===f[n].message?e:(f[n]=t,e=[].concat((0,s.default)(e),[t]))}),[])}function P(e,t){var r=t.useGenericRemediator,n=t.remediators;if(e)return r?f.GenericRemediator:n[e.name]}function S(e,t,r){var n,o=r.remediators,a=r.useGenericRemediator,i=e.neededToProceed,u=e.context;if(!r.step){var c=[];if(a)c.push(new f.GenericRemediator(i[0],t,r));else{var s,d=y(i);try{for(d.s();!(s=d.n()).done;){var p=s.value;if(Object.keys(o).includes(p.name)){if((n=new(P(p,r))(p,t,r)).canRemediate(u))return n;c.push(n)}}}catch(e){d.e(e)}finally{d.f()}}return c[0]}var h=i.find((function(e){return e.name===r.step}));if(h){var v=P(h,r);return v?new v(h,t,r):void 0}(0,l.warn)('step "'.concat(r.step,'" did not match any remediations'))}function T(e,t,r){var n=t.getNextStep(e,r.context),o=O(r),a=k(r);return v(v(v({},n),o&&{canSkip:o}),a&&{canResend:a})}},8716:function(e,t,r){"use strict";t.getAttestation=t.getAssertion=t.buildCredentialRequestOptions=t.buildCredentialCreationOptions=void 0;var n=r(7987),o=function(){var e=[];return(arguments.length>0&&void 0!==arguments[0]?arguments[0]:[]).forEach((function(t){"webauthn"===t.key&&e.push({type:"public-key",id:(0,n.base64UrlToBuffer)(t.credentialId)})})),e};t.buildCredentialCreationOptions=function(e,t){return{publicKey:{rp:e.rp,user:{id:(0,n.base64UrlToBuffer)(e.user.id),name:e.user.name,displayName:e.user.displayName},challenge:(0,n.base64UrlToBuffer)(e.challenge),pubKeyCredParams:e.pubKeyCredParams,attestation:e.attestation,authenticatorSelection:e.authenticatorSelection,excludeCredentials:o(t)}}},t.buildCredentialRequestOptions=function(e,t){return{publicKey:{challenge:(0,n.base64UrlToBuffer)(e.challenge),userVerification:e.userVerification,allowCredentials:o(t)}}},t.getAttestation=function(e){var t=e.response;return{id:e.id,clientData:(0,n.bufferToBase64Url)(t.clientDataJSON),attestation:(0,n.bufferToBase64Url)(t.attestationObject)}},t.getAssertion=function(e){var t=e.response;return{id:e.id,clientData:(0,n.bufferToBase64Url)(t.clientDataJSON),authenticatorData:(0,n.bufferToBase64Url)(t.authenticatorData),signatureData:(0,n.bufferToBase64Url)(t.signature)}}},2994:function(e,t,r){"use strict";var n=r(7098);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(8682);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(8312);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var i=r(1473);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}))},8682:function(e,t,r){"use strict";var n=r(4836);t.verifyEmailChallenge=t.sendEmailChallenge=t.getEmails=t.getEmailChallenge=t.getEmail=t.deleteEmail=t.addEmail=void 0;var o,a=n(r(4687)),i=n(r(7156)),u=r(777),c=r(6096),s=(o=(0,i.default)(a.default.mark((function e(t,r){var n;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,(0,u.sendRequest)(t,{url:"/idp/myaccount/emails",method:"GET",accessToken:null==r?void 0:r.accessToken},c.EmailTransaction);case 2:return n=e.sent,e.abrupt("return",n);case 4:case"end":return e.stop()}}),e)}))),function(e,t){return o.apply(this,arguments)});t.getEmails=s;var l,f=(l=(0,i.default)(a.default.mark((function e(t,r){var n,o,i,s;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(n=r).id,i=n.accessToken,e.next=3,(0,u.sendRequest)(t,{url:"/idp/myaccount/emails/".concat(o),method:"GET",accessToken:i},c.EmailTransaction);case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return l.apply(this,arguments)});t.getEmail=f;var d,p=(d=(0,i.default)(a.default.mark((function e(t,r){var n,o,i,s;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(n=r).accessToken,i=n.payload,e.next=3,(0,u.sendRequest)(t,{url:"/idp/myaccount/emails",method:"POST",payload:i,accessToken:o},c.EmailTransaction);case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return d.apply(this,arguments)});t.addEmail=p;var h,v=(h=(0,i.default)(a.default.mark((function e(t,r){var n,o,i,c;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(n=r).id,i=n.accessToken,e.next=3,(0,u.sendRequest)(t,{url:"/idp/myaccount/emails/".concat(o),method:"DELETE",accessToken:i});case 3:return c=e.sent,e.abrupt("return",c);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return h.apply(this,arguments)});t.deleteEmail=v;var y,g=(y=(0,i.default)(a.default.mark((function e(t,r){var n,o,i,s;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(n=r).id,i=n.accessToken,e.next=3,(0,u.sendRequest)(t,{url:"/idp/myaccount/emails/".concat(o,"/challenge"),method:"POST",accessToken:i},c.EmailChallengeTransaction);case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return y.apply(this,arguments)});t.sendEmailChallenge=g;var b,m=(b=(0,i.default)(a.default.mark((function e(t,r){var n,o,i,s,l;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(n=r).emailId,i=n.challengeId,s=n.accessToken,e.next=3,(0,u.sendRequest)(t,{url:"/idp/myaccount/emails/".concat(o,"/challenge/").concat(i),method:"POST",accessToken:s},c.EmailChallengeTransaction);case 3:return l=e.sent,e.abrupt("return",l);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return b.apply(this,arguments)});t.getEmailChallenge=m;var O,k=(O=(0,i.default)(a.default.mark((function e(t,r){var n,o,i,c,s,l;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(n=r).emailId,i=n.challengeId,c=n.payload,s=n.accessToken,e.next=3,(0,u.sendRequest)(t,{url:"/idp/myaccount/emails/".concat(o,"/challenge/").concat(i,"/verify"),method:"POST",payload:c,accessToken:s});case 3:return l=e.sent,e.abrupt("return",l);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return O.apply(this,arguments)});t.verifyEmailChallenge=k},7814:function(e,t,r){"use strict";t.createOktaAuthMyAccount=function(e,t,r){var a=(0,n.createOktaAuthCore)(e,t,r);return(0,o.mixinMyAccount)(a)};var n=r(1578),o=r(6794)},939:function(e,t,r){"use strict";var n=r(2994);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(7814);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(6794);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var i=r(8008);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}))},6794:function(e,t,r){"use strict";var n=r(4836),o=r(8698);t.mixinMyAccount=function(e){return function(e){(0,s.default)(o,e);var t,r,n=(t=o,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,f.default)(t);if(r){var o=(0,f.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,l.default)(this,e)});function o(){var e;(0,u.default)(this,o);for(var t=arguments.length,r=new Array(t),i=0;i<t;i++)r[i]=arguments[i];return e=n.call.apply(n,[this].concat(r)),(0,d.default)((0,c.default)(e),"myaccount",void 0),e.myaccount=Object.entries(p).filter((function(e){return"default"!==(0,a.default)(e,1)[0]})).reduce((function(t,r){var n=(0,a.default)(r,2),o=n[0],i=n[1];return t[o]=i.bind(null,(0,c.default)(e)),t}),{}),e}return(0,i.default)(o)}(e)};var a=n(r(7424)),i=n(r(9728)),u=n(r(6690)),c=n(r(6115)),s=n(r(1655)),l=n(r(4993)),f=n(r(3808)),d=n(r(8416)),p=function(e,t){if(e&&e.__esModule)return e;if(null===e||"object"!==o(e)&&"function"!=typeof e)return{default:e};var r=h(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var u=a?Object.getOwnPropertyDescriptor(e,i):null;u&&(u.get||u.set)?Object.defineProperty(n,i,u):n[i]=e[i]}return n.default=e,r&&r.set(e,n),n}(r(2994));function h(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(h=function(e){return e?r:t})(e)}},1473:function(e,t,r){"use strict";var n=r(4836);t.updatePassword=t.getPassword=t.enrollPassword=t.deletePassword=void 0;var o,a=n(r(4687)),i=n(r(7156)),u=r(777),c=r(6096),s=(o=(0,i.default)(a.default.mark((function e(t,r){var n;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,(0,u.sendRequest)(t,{url:"/idp/myaccount/password",method:"GET",accessToken:null==r?void 0:r.accessToken},c.PasswordTransaction);case 2:return n=e.sent,e.abrupt("return",n);case 4:case"end":return e.stop()}}),e)}))),function(e,t){return o.apply(this,arguments)});t.getPassword=s;var l,f=(l=(0,i.default)(a.default.mark((function e(t,r){var n,o,i,s;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(n=r).accessToken,i=n.payload,e.next=3,(0,u.sendRequest)(t,{url:"/idp/myaccount/password",method:"POST",payload:i,accessToken:o},c.PasswordTransaction);case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return l.apply(this,arguments)});t.enrollPassword=f;var d,p=(d=(0,i.default)(a.default.mark((function e(t,r){var n,o,i,s;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(n=r).accessToken,i=n.payload,e.next=3,(0,u.sendRequest)(t,{url:"/idp/myaccount/password",method:"PUT",payload:i,accessToken:o},c.PasswordTransaction);case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return d.apply(this,arguments)});t.updatePassword=p;var h,v=(h=(0,i.default)(a.default.mark((function e(t,r){var n;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,(0,u.sendRequest)(t,{url:"/idp/myaccount/password",method:"DELETE",accessToken:null==r?void 0:r.accessToken});case 2:return n=e.sent,e.abrupt("return",n);case 4:case"end":return e.stop()}}),e)}))),function(e,t){return h.apply(this,arguments)});t.deletePassword=v},8312:function(e,t,r){"use strict";var n=r(4836);t.verifyPhoneChallenge=t.sendPhoneChallenge=t.getPhones=t.getPhone=t.deletePhone=t.addPhone=void 0;var o,a=n(r(4687)),i=n(r(7156)),u=r(777),c=r(6096),s=(o=(0,i.default)(a.default.mark((function e(t,r){var n;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,(0,u.sendRequest)(t,{url:"/idp/myaccount/phones",method:"GET",accessToken:null==r?void 0:r.accessToken},c.PhoneTransaction);case 2:return n=e.sent,e.abrupt("return",n);case 4:case"end":return e.stop()}}),e)}))),function(e,t){return o.apply(this,arguments)});t.getPhones=s;var l,f=(l=(0,i.default)(a.default.mark((function e(t,r){var n,o,i,s;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(n=r).accessToken,i=n.id,e.next=3,(0,u.sendRequest)(t,{url:"/idp/myaccount/phones/".concat(i),method:"GET",accessToken:o},c.PhoneTransaction);case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return l.apply(this,arguments)});t.getPhone=f;var d,p=(d=(0,i.default)(a.default.mark((function e(t,r){var n,o,i,s;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(n=r).accessToken,i=n.payload,e.next=3,(0,u.sendRequest)(t,{url:"/idp/myaccount/phones",method:"POST",payload:i,accessToken:o},c.PhoneTransaction);case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return d.apply(this,arguments)});t.addPhone=p;var h,v=(h=(0,i.default)(a.default.mark((function e(t,r){var n,o,i,c;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(n=r).id,i=n.accessToken,e.next=3,(0,u.sendRequest)(t,{url:"/idp/myaccount/phones/".concat(o),method:"DELETE",accessToken:i});case 3:return c=e.sent,e.abrupt("return",c);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return h.apply(this,arguments)});t.deletePhone=v;var y,g=(y=(0,i.default)(a.default.mark((function e(t,r){var n,o,i,c,s;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(n=r).accessToken,i=n.id,c=n.payload,e.next=3,(0,u.sendRequest)(t,{url:"/idp/myaccount/phones/".concat(i,"/challenge"),method:"POST",payload:c,accessToken:o});case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return y.apply(this,arguments)});t.sendPhoneChallenge=g;var b,m=(b=(0,i.default)(a.default.mark((function e(t,r){var n,o,i,c,s;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(n=r).id,i=n.payload,c=n.accessToken,e.next=3,(0,u.sendRequest)(t,{url:"/idp/myaccount/phones/".concat(o,"/verify"),method:"POST",payload:i,accessToken:c});case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return b.apply(this,arguments)});t.verifyPhoneChallenge=m},7098:function(e,t,r){"use strict";var n=r(4836);t.updateProfile=t.getProfileSchema=t.getProfile=void 0;var o,a=n(r(4687)),i=n(r(7156)),u=r(777),c=r(6096),s=(o=(0,i.default)(a.default.mark((function e(t,r){var n;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,(0,u.sendRequest)(t,{url:"/idp/myaccount/profile",method:"GET",accessToken:null==r?void 0:r.accessToken},c.ProfileTransaction);case 2:return n=e.sent,e.abrupt("return",n);case 4:case"end":return e.stop()}}),e)}))),function(e,t){return o.apply(this,arguments)});t.getProfile=s;var l,f=(l=(0,i.default)(a.default.mark((function e(t,r){var n,o,i,s;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return o=(n=r).payload,i=n.accessToken,e.next=3,(0,u.sendRequest)(t,{url:"/idp/myaccount/profile",method:"PUT",payload:o,accessToken:i},c.ProfileTransaction);case 3:return s=e.sent,e.abrupt("return",s);case 5:case"end":return e.stop()}}),e)}))),function(e,t){return l.apply(this,arguments)});t.updateProfile=f;var d,p=(d=(0,i.default)(a.default.mark((function e(t,r){var n;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,(0,u.sendRequest)(t,{url:"/idp/myaccount/profile/schema",method:"GET",accessToken:null==r?void 0:r.accessToken},c.ProfileSchemaTransaction);case 2:return n=e.sent,e.abrupt("return",n);case 4:case"end":return e.stop()}}),e)}))),function(e,t){return d.apply(this,arguments)});t.getProfileSchema=p},777:function(e,t,r){"use strict";var n=r(4836);t.generateRequestFnFromLinks=function(e){for(var t=e.oktaAuth,r=e.accessToken,n=e.methodName,a=e.links,s=arguments.length>1&&void 0!==arguments[1]?arguments[1]:c.default,f=function(){var e,i=h[d];if(i.toLowerCase()===n){var c=a.self;return{v:(e=(0,u.default)(o.default.mark((function e(n){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",p(t,{accessToken:r,url:c.href,method:i,payload:n},s));case 1:case"end":return e.stop()}}),e)}))),function(t){return e.apply(this,arguments)})}}},d=0,h=["GET","POST","PUT","DELETE"];d<h.length;d++){var v=f();if("object"===(0,i.default)(v))return v.v}var y,g=a[n];if(!g)throw new l.AuthSdkError("No link is found with methodName: ".concat(n));return y=(0,u.default)(o.default.mark((function e(n){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",p(t,{accessToken:r,url:g.href,method:g.hints.allow[0],payload:n},s));case 1:case"end":return e.stop()}}),e)}))),function(e){return y.apply(this,arguments)}},t.sendRequest=p;var o=n(r(4687)),a=n(r(8416)),i=n(r(8698)),u=n(r(7156)),c=n(r(3395)),s=r(4777),l=r(5728);function f(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function d(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?f(Object(r),!0).forEach((function(t){(0,a.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):f(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function p(e,t){return h.apply(this,arguments)}function h(){return h=(0,u.default)(o.default.mark((function e(t,r){var n,a,i,u,f,p,h,v,y,g,b,m=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n=m.length>2&&void 0!==m[2]?m[2]:c.default,a=t.tokenManager.getTokensSync(),i=a.accessToken,u=r.accessToken||(null==i?void 0:i.accessToken),f=t.getIssuerOrigin(),p=r.url,h=r.method,v=r.payload,y=p.startsWith(f)?p:"".concat(f).concat(p),u){e.next=8;break}throw new l.AuthSdkError("AccessToken is required to request MyAccount API endpoints.");case 8:return e.next=10,(0,s.httpRequest)(t,d({headers:{Accept:"*/*;okta-version=1.0.0"},accessToken:u,url:y,method:h},v&&{args:v}));case 10:return g=e.sent,b=Array.isArray(g)?g.map((function(e){return new n(t,{res:e,accessToken:u})})):new n(t,{res:g,accessToken:u}),e.abrupt("return",b);case 13:case"end":return e.stop()}}),e)}))),h.apply(this,arguments)}},3395:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(215)),a=n(r(9728)),i=n(r(6690)),u=n(r(8416)),c=["headers"],s=(0,a.default)((function e(t,r){var n=this;(0,i.default)(this,e),(0,u.default)(this,"headers",void 0);var a=r.res,s=a.headers,l=(0,o.default)(a,c);s&&(this.headers=s),Object.keys(l).forEach((function(e){"_links"!==e&&(n[e]=l[e])}))}));t.default=s,e.exports=t.default},4454:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(4687)),a=n(r(7156)),i=n(r(9728)),u=n(r(6690)),c=n(r(6115)),s=n(r(1655)),l=n(r(4993)),f=n(r(3808)),d=n(r(8416)),p=n(r(9953)),h=n(r(3395)),v=r(777);var y=function(e){(0,s.default)(h,e);var t,r,n=(t=h,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,f.default)(t);if(r){var o=(0,f.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,l.default)(this,e)});function h(e,t){var r;(0,u.default)(this,h),r=n.call(this,e,t),(0,d.default)((0,c.default)(r),"id",void 0),(0,d.default)((0,c.default)(r),"expiresAt",void 0),(0,d.default)((0,c.default)(r),"profile",void 0),(0,d.default)((0,c.default)(r),"status",void 0),(0,d.default)((0,c.default)(r),"poll",void 0),(0,d.default)((0,c.default)(r),"verify",void 0);var i,s=t.accessToken,l=t.res,f=l.id,y=l.expiresAt,g=l.profile,b=l.status,m=l._links;return r.id=f,r.expiresAt=y,r.profile=g,r.status=b,r.poll=(0,a.default)(o.default.mark((function t(){var r;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=(0,v.generateRequestFnFromLinks)({oktaAuth:e,accessToken:s,methodName:"poll",links:m},p.default),t.next=3,r();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),r.verify=(i=(0,a.default)(o.default.mark((function t(r){var n;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=(0,v.generateRequestFnFromLinks)({oktaAuth:e,accessToken:s,methodName:"verify",links:m},h),t.next=3,n(r);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),function(e){return i.apply(this,arguments)}),r}return(0,i.default)(h)}(h.default);t.default=y,e.exports=t.default},9953:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(9728)),a=n(r(6690)),i=n(r(6115)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416));var f=function(e){(0,u.default)(f,e);var t,r,n=(t=f,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function f(e,t){var r;(0,a.default)(this,f),r=n.call(this,e,t),(0,l.default)((0,i.default)(r),"id",void 0),(0,l.default)((0,i.default)(r),"expiresAt",void 0),(0,l.default)((0,i.default)(r),"profile",void 0),(0,l.default)((0,i.default)(r),"status",void 0);var o=t.res,u=o.id,c=o.profile,s=o.expiresAt,d=o.status;return r.id=u,r.expiresAt=s,r.profile=c,r.status=d,r}return(0,o.default)(f)}(n(r(3395)).default);t.default=f,e.exports=t.default},8261:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(4687)),a=n(r(7156)),i=n(r(9728)),u=n(r(6690)),c=n(r(6115)),s=n(r(1655)),l=n(r(4993)),f=n(r(3808)),d=n(r(8416)),p=n(r(4454)),h=n(r(9953)),v=n(r(3395)),y=r(777);var g=function(e){(0,s.default)(v,e);var t,r,n=(t=v,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,f.default)(t);if(r){var o=(0,f.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,l.default)(this,e)});function v(e,t){var r;(0,u.default)(this,v),r=n.call(this,e,t),(0,d.default)((0,c.default)(r),"id",void 0),(0,d.default)((0,c.default)(r),"profile",void 0),(0,d.default)((0,c.default)(r),"roles",void 0),(0,d.default)((0,c.default)(r),"status",void 0),(0,d.default)((0,c.default)(r),"get",void 0),(0,d.default)((0,c.default)(r),"delete",void 0),(0,d.default)((0,c.default)(r),"challenge",void 0),(0,d.default)((0,c.default)(r),"poll",void 0),(0,d.default)((0,c.default)(r),"verify",void 0);var i,s=t.accessToken,l=t.res,f=l.id,g=l.profile,b=l.roles,m=l.status,O=l._links;return r.id=f,r.profile=g,r.roles=b,r.status=m,r.get=(0,a.default)(o.default.mark((function t(){var r;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=(0,y.generateRequestFnFromLinks)({oktaAuth:e,accessToken:s,methodName:"get",links:O},v),t.next=3,r();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),r.delete=(0,a.default)(o.default.mark((function t(){var r;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=(0,y.generateRequestFnFromLinks)({oktaAuth:e,accessToken:s,methodName:"delete",links:O}),t.next=3,r();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),r.challenge=(0,a.default)(o.default.mark((function t(){var r;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=(0,y.generateRequestFnFromLinks)({oktaAuth:e,accessToken:s,methodName:"challenge",links:O},p.default),t.next=3,r();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),O.poll&&(r.poll=(0,a.default)(o.default.mark((function t(){var r;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=(0,y.generateRequestFnFromLinks)({oktaAuth:e,accessToken:s,methodName:"poll",links:O},h.default),t.next=3,r();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)})))),O.verify&&(r.verify=(i=(0,a.default)(o.default.mark((function t(r){var n;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=(0,y.generateRequestFnFromLinks)({oktaAuth:e,accessToken:s,methodName:"verify",links:O}),t.next=3,n(r);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),function(e){return i.apply(this,arguments)})),r}return(0,i.default)(v)}(v.default);t.default=g,e.exports=t.default},3746:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(4687)),a=n(r(7156)),i=n(r(9728)),u=n(r(6690)),c=n(r(6115)),s=n(r(1655)),l=n(r(4993)),f=n(r(3808)),d=n(r(8416)),p=r(8008),h=n(r(3395)),v=r(777);var y=function(e){(0,s.default)(h,e);var t,r,n=(t=h,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,f.default)(t);if(r){var o=(0,f.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,l.default)(this,e)});function h(e,t){var r;(0,u.default)(this,h),r=n.call(this,e,t),(0,d.default)((0,c.default)(r),"id",void 0),(0,d.default)((0,c.default)(r),"created",void 0),(0,d.default)((0,c.default)(r),"lastUpdated",void 0),(0,d.default)((0,c.default)(r),"status",void 0),(0,d.default)((0,c.default)(r),"get",void 0),(0,d.default)((0,c.default)(r),"enroll",void 0),(0,d.default)((0,c.default)(r),"update",void 0),(0,d.default)((0,c.default)(r),"delete",void 0);var i,s,l=t.res,f=t.accessToken,y=l.id,g=l.status,b=l.created,m=l.lastUpdated,O=l._links;return r.id=y,r.status=g,r.created=b,r.lastUpdated=m,r.status==p.PasswordStatus.NOT_ENROLLED?r.enroll=(s=(0,a.default)(o.default.mark((function t(r){var n;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=(0,v.generateRequestFnFromLinks)({oktaAuth:e,accessToken:f,methodName:"enroll",links:O},h),t.next=3,n(r);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),function(e){return s.apply(this,arguments)}):(r.get=(0,a.default)(o.default.mark((function t(){var r;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=(0,v.generateRequestFnFromLinks)({oktaAuth:e,accessToken:f,methodName:"get",links:O},h),t.next=3,r();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),r.update=(i=(0,a.default)(o.default.mark((function t(r){var n;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=(0,v.generateRequestFnFromLinks)({oktaAuth:e,accessToken:f,methodName:"put",links:O},h),t.next=3,n(r);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),function(e){return i.apply(this,arguments)}),r.delete=(0,a.default)(o.default.mark((function t(){var r;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=(0,v.generateRequestFnFromLinks)({oktaAuth:e,accessToken:f,methodName:"delete",links:O}),t.next=3,r();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)})))),r}return(0,i.default)(h)}(h.default);t.default=y,e.exports=t.default},3082:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(4687)),a=n(r(7156)),i=n(r(9728)),u=n(r(6690)),c=n(r(6115)),s=n(r(1655)),l=n(r(4993)),f=n(r(3808)),d=n(r(8416)),p=n(r(3395)),h=r(777);var v=function(e){(0,s.default)(p,e);var t,r,n=(t=p,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,f.default)(t);if(r){var o=(0,f.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,l.default)(this,e)});function p(e,t){var r;(0,u.default)(this,p),r=n.call(this,e,t),(0,d.default)((0,c.default)(r),"id",void 0),(0,d.default)((0,c.default)(r),"profile",void 0),(0,d.default)((0,c.default)(r),"status",void 0),(0,d.default)((0,c.default)(r),"get",void 0),(0,d.default)((0,c.default)(r),"delete",void 0),(0,d.default)((0,c.default)(r),"challenge",void 0),(0,d.default)((0,c.default)(r),"verify",void 0);var i,s,l=t.res,f=t.accessToken,v=l.id,y=l.profile,g=l.status,b=l._links;return r.id=v,r.profile=y,r.status=g,r.get=(0,a.default)(o.default.mark((function t(){var r;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=(0,h.generateRequestFnFromLinks)({oktaAuth:e,accessToken:f,methodName:"get",links:b},p),t.next=3,r();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),r.delete=(0,a.default)(o.default.mark((function t(){var r;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return r=(0,h.generateRequestFnFromLinks)({oktaAuth:e,accessToken:f,methodName:"delete",links:b}),t.next=3,r();case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),r.challenge=(i=(0,a.default)(o.default.mark((function t(r){var n;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=(0,h.generateRequestFnFromLinks)({oktaAuth:e,accessToken:f,methodName:"challenge",links:b}),t.next=3,n(r);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),function(e){return i.apply(this,arguments)}),b.verify&&(r.verify=(s=(0,a.default)(o.default.mark((function t(r){var n;return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return n=(0,h.generateRequestFnFromLinks)({oktaAuth:e,accessToken:f,methodName:"verify",links:b}),t.next=3,n(r);case 3:return t.abrupt("return",t.sent);case 4:case"end":return t.stop()}}),t)}))),function(e){return s.apply(this,arguments)})),r}return(0,i.default)(p)}(p.default);t.default=v,e.exports=t.default},8399:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(9728)),a=n(r(6690)),i=n(r(6115)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416));var f=function(e){(0,u.default)(f,e);var t,r,n=(t=f,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function f(e,t){var r;return(0,a.default)(this,f),r=n.call(this,e,t),(0,l.default)((0,i.default)(r),"properties",void 0),r.properties=t.res.properties,r}return(0,o.default)(f)}(n(r(3395)).default);t.default=f,e.exports=t.default},5708:function(e,t,r){"use strict";var n=r(4836);t.default=void 0;var o=n(r(9728)),a=n(r(6690)),i=n(r(6115)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416));var f=function(e){(0,u.default)(f,e);var t,r,n=(t=f,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function f(e,t){var r;(0,a.default)(this,f),r=n.call(this,e,t),(0,l.default)((0,i.default)(r),"createdAt",void 0),(0,l.default)((0,i.default)(r),"modifiedAt",void 0),(0,l.default)((0,i.default)(r),"profile",void 0);var o=t.res,u=o.createdAt,c=o.modifiedAt,s=o.profile;return r.createdAt=u,r.modifiedAt=c,r.profile=s,r}return(0,o.default)(f)}(n(r(3395)).default);t.default=f,e.exports=t.default},6096:function(e,t,r){"use strict";var n=r(4836);Object.defineProperty(t,"BaseTransaction",{enumerable:!0,get:function(){return f.default}}),Object.defineProperty(t,"EmailChallengeTransaction",{enumerable:!0,get:function(){return c.default}}),Object.defineProperty(t,"EmailStatusTransaction",{enumerable:!0,get:function(){return u.default}}),Object.defineProperty(t,"EmailTransaction",{enumerable:!0,get:function(){return i.default}}),Object.defineProperty(t,"PasswordTransaction",{enumerable:!0,get:function(){return l.default}}),Object.defineProperty(t,"PhoneTransaction",{enumerable:!0,get:function(){return s.default}}),Object.defineProperty(t,"ProfileSchemaTransaction",{enumerable:!0,get:function(){return a.default}}),Object.defineProperty(t,"ProfileTransaction",{enumerable:!0,get:function(){return o.default}});var o=n(r(5708)),a=n(r(8399)),i=n(r(8261)),u=n(r(9953)),c=n(r(4454)),s=n(r(3082)),l=n(r(3746)),f=n(r(3395))},8008:function(e,t){"use strict";var r,n,o;t.Status=t.PasswordStatus=t.EmailRole=void 0,t.EmailRole=r,function(e){e.PRIMARY="PRIMARY",e.SECONDARY="SECONDARY"}(r||(t.EmailRole=r={})),t.Status=n,function(e){e.VERIFIED="VERIFIED",e.UNVERIFIED="UNVERIFIED"}(n||(t.Status=n={})),t.PasswordStatus=o,function(e){e.NOT_ENROLLED="NOT_ENROLLED",e.ACTIVE="ACTIVE"}(o||(t.PasswordStatus=o={}))},3426:function(e,t,r){"use strict";var n=r(4836);t.TokenManager=void 0;var o=n(r(4687)),a=n(r(7156)),i=n(r(8698)),u=n(r(6690)),c=n(r(9728)),s=n(r(8416)),l=r(305),f=r(5728),d=r(8785),p=r(415),h=n(r(6244)),v=r(8927),y=r(1971);function g(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function b(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?g(Object(r),!0).forEach((function(t){(0,s.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):g(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var m={autoRenew:!0,autoRemove:!0,syncStorage:!0,clearPendingRemoveTokens:!0,storage:void 0,expireEarlySeconds:30,storageKey:y.TOKEN_STORAGE_NAME},O=function(){function e(t){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if((0,u.default)(this,e),(0,s.default)(this,"sdk",void 0),(0,s.default)(this,"clock",void 0),(0,s.default)(this,"emitter",void 0),(0,s.default)(this,"storage",void 0),(0,s.default)(this,"state",void 0),(0,s.default)(this,"options",void 0),this.sdk=t,this.emitter=t.emitter,!this.emitter)throw new f.AuthSdkError("Emitter should be initialized before TokenManager");r=Object.assign({},m,(0,l.removeNils)(r)),(0,p.isLocalhost)()||(r.expireEarlySeconds=m.expireEarlySeconds),this.options=r;var n=(0,l.removeNils)({storageKey:r.storageKey,secure:r.secure});"object"===(0,i.default)(r.storage)?n.storageProvider=r.storage:r.storage&&(n.storageType=r.storage),this.storage=t.storageManager.getTokenStorage(b(b({},n),{},{useSeparateCookies:!0})),this.clock=h.default.create(),this.state={expireTimeouts:{},renewPromise:null}}var t,r,n;return(0,c.default)(e,[{key:"on",value:function(e,t,r){r?this.emitter.on(e,t,r):this.emitter.on(e,t)}},{key:"off",value:function(e,t){t?this.emitter.off(e,t):this.emitter.off(e)}},{key:"start",value:function(){this.options.clearPendingRemoveTokens&&this.clearPendingRemoveTokens(),this.setExpireEventTimeoutAll(),this.state.started=!0}},{key:"stop",value:function(){this.clearExpireEventTimeoutAll(),this.state.started=!1}},{key:"isStarted",value:function(){return!!this.state.started}},{key:"getOptions",value:function(){return(0,l.clone)(this.options)}},{key:"getExpireTime",value:function(e){var t=this.options.expireEarlySeconds||0;return e.expiresAt-t}},{key:"hasExpired",value:function(e){return this.getExpireTime(e)<=this.clock.now()}},{key:"emitExpired",value:function(e,t){this.emitter.emit(v.EVENT_EXPIRED,e,t)}},{key:"emitRenewed",value:function(e,t,r){this.emitter.emit(v.EVENT_RENEWED,e,t,r)}},{key:"emitAdded",value:function(e,t){this.emitter.emit(v.EVENT_ADDED,e,t)}},{key:"emitRemoved",value:function(e,t){this.emitter.emit(v.EVENT_REMOVED,e,t)}},{key:"emitError",value:function(e){this.emitter.emit(v.EVENT_ERROR,e)}},{key:"clearExpireEventTimeout",value:function(e){clearTimeout(this.state.expireTimeouts[e]),delete this.state.expireTimeouts[e],this.state.renewPromise=null}},{key:"clearExpireEventTimeoutAll",value:function(){var e=this.state.expireTimeouts;for(var t in e)Object.prototype.hasOwnProperty.call(e,t)&&this.clearExpireEventTimeout(t)}},{key:"setExpireEventTimeout",value:function(e,t){var r=this;if(!(0,v.isRefreshToken)(t)){var n=this.getExpireTime(t),o=1e3*Math.max(n-this.clock.now(),0);this.clearExpireEventTimeout(e);var a=setTimeout((function(){r.emitExpired(e,t)}),o);this.state.expireTimeouts[e]=a}}},{key:"setExpireEventTimeoutAll",value:function(){var e=this.storage.getStorage();for(var t in e)if(Object.prototype.hasOwnProperty.call(e,t)){var r=e[t];this.setExpireEventTimeout(t,r)}}},{key:"resetExpireEventTimeoutAll",value:function(){this.clearExpireEventTimeoutAll(),this.setExpireEventTimeoutAll()}},{key:"add",value:function(e,t){var r=this.storage.getStorage();(0,d.validateToken)(t),r[e]=t,this.storage.setStorage(r),this.emitSetStorageEvent(),this.emitAdded(e,t),this.setExpireEventTimeout(e,t)}},{key:"getSync",value:function(e){return this.storage.getStorage()[e]}},{key:"get",value:(n=(0,a.default)(o.default.mark((function e(t){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.getSync(t));case 1:case"end":return e.stop()}}),e,this)}))),function(e){return n.apply(this,arguments)})},{key:"getTokensSync",value:function(){var e={},t=this.storage.getStorage();return Object.keys(t).forEach((function(r){var n=t[r];(0,v.isAccessToken)(n)?e.accessToken=n:(0,v.isIDToken)(n)?e.idToken=n:(0,v.isRefreshToken)(n)&&(e.refreshToken=n)})),e}},{key:"getTokens",value:(r=(0,a.default)(o.default.mark((function e(){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",this.getTokensSync());case 1:case"end":return e.stop()}}),e,this)}))),function(){return r.apply(this,arguments)})},{key:"getStorageKeyByType",value:function(e){var t=this.storage.getStorage();return Object.keys(t).filter((function(r){var n=t[r];return(0,v.isAccessToken)(n)&&"accessToken"===e||(0,v.isIDToken)(n)&&"idToken"===e||(0,v.isRefreshToken)(n)&&"refreshToken"===e}))[0]}},{key:"getTokenType",value:function(e){if((0,v.isAccessToken)(e))return"accessToken";if((0,v.isIDToken)(e))return"idToken";if((0,v.isRefreshToken)(e))return"refreshToken";throw new f.AuthSdkError("Unknown token type")}},{key:"emitSetStorageEvent",value:function(){if((0,p.isIE11OrLess)()){var e=this.storage.getStorage();this.emitter.emit(v.EVENT_SET_STORAGE,e)}}},{key:"getStorage",value:function(){return this.storage}},{key:"setTokens",value:function(e,t,r,n){var o=this,a=function(e,a){var i=o.getTokenType(a);"accessToken"===i?t&&t(e,a):"idToken"===i?r&&r(e,a):"refreshToken"===i&&n&&n(e,a)},i=function(e,t){o.emitAdded(e,t),o.setExpireEventTimeout(e,t),a(e,t)},u=function(e,t){o.clearExpireEventTimeout(e),o.emitRemoved(e,t),a(e,t)},c=["idToken","accessToken","refreshToken"],s=this.getTokensSync();c.forEach((function(t){var r=e[t];r&&(0,d.validateToken)(r,t)}));var l=c.reduce((function(t,r){var n=e[r];return n&&(t[o.getStorageKeyByType(r)||r]=n),t}),{});this.storage.setStorage(l),this.emitSetStorageEvent(),c.forEach((function(t){var r,n,c,l=e[t],f=s[t],d=o.getStorageKeyByType(t)||t;l&&f?(u(d,f),i(d,l),r=d,n=l,c=f,o.emitRenewed(r,n,c),o.clearExpireEventTimeout(r),o.setExpireEventTimeout(r,n),a(r,n)):l?i(d,l):f&&u(d,f)}))}},{key:"remove",value:function(e){this.clearExpireEventTimeout(e);var t=this.storage.getStorage(),r=t[e];delete t[e],this.storage.setStorage(t),this.emitSetStorageEvent(),this.emitRemoved(e,r)}},{key:"renewToken",value:(t=(0,a.default)(o.default.mark((function e(t){var r;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",null===(r=this.sdk.token)||void 0===r?void 0:r.renew(t));case 1:case"end":return e.stop()}}),e,this)}))),function(e){return t.apply(this,arguments)})},{key:"validateToken",value:function(e){return(0,d.validateToken)(e)}},{key:"renew",value:function(e){var t=this;if(this.state.renewPromise)return this.state.renewPromise;try{var r=this.getSync(e);if(!r)throw new f.AuthSdkError("The tokenManager has no token for the key: "+e)}catch(e){return this.emitError(e),Promise.reject(e)}return this.clearExpireEventTimeout(e),this.state.renewPromise=this.sdk.token.renewTokens().then((function(e){return t.setTokens(e),e[t.getTokenType(r)]})).catch((function(r){throw t.remove(e),r.tokenKey=e,t.emitError(r),r})).finally((function(){t.state.renewPromise=null}))}},{key:"clear",value:function(){var e=this,t=this.getTokensSync();this.clearExpireEventTimeoutAll(),this.storage.clearStorage(),this.emitSetStorageEvent(),Object.keys(t).forEach((function(r){e.emitRemoved(r,t[r])}))}},{key:"clearPendingRemoveTokens",value:function(){var e=this,t=this.storage.getStorage(),r={};Object.keys(t).forEach((function(e){t[e].pendingRemove&&(r[e]=t[e],delete t[e])})),this.storage.setStorage(t),this.emitSetStorageEvent(),Object.keys(r).forEach((function(t){e.clearExpireEventTimeout(t),e.emitRemoved(t,r[t])}))}},{key:"updateRefreshToken",value:function(e){var t=this.getStorageKeyByType("refreshToken")||y.REFRESH_TOKEN_STORAGE_KEY,r=this.storage.getStorage();(0,d.validateToken)(e),r[t]=e,this.storage.setStorage(r),this.emitSetStorageEvent()}},{key:"removeRefreshToken",value:function(){var e=this.getStorageKeyByType("refreshToken")||y.REFRESH_TOKEN_STORAGE_KEY;this.remove(e)}},{key:"addPendingRemoveFlags",value:function(){var e=this.getTokensSync();Object.keys(e).forEach((function(t){e[t].pendingRemove=!0})),this.setTokens(e)}}]),e}();t.TokenManager=O},130:function(e,t,r){"use strict";var n=r(4836);t.createTransactionManager=function(){return function(){function e(t){(0,o.default)(this,e),(0,i.default)(this,"options",void 0),(0,i.default)(this,"storageManager",void 0),(0,i.default)(this,"enableSharedStorage",void 0),(0,i.default)(this,"saveLastResponse",void 0),this.storageManager=t.storageManager,this.enableSharedStorage=!1!==t.enableSharedStorage,this.saveLastResponse=!1!==t.saveLastResponse,this.options=t}return(0,a.default)(e,[{key:"clear",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=this.storageManager.getTransactionStorage(),r=t.getStorage();if(t.clearStorage(),this.enableSharedStorage&&!1!==e.clearSharedStorage){var n=e.state||(null==r?void 0:r.state);n&&(0,s.clearTransactionFromSharedStorage)(this.storageManager,n)}}},{key:"save",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=this.storageManager.getTransactionStorage(),n=r.getStorage();(0,u.isTransactionMeta)(n)&&!t.muteWarning&&(0,c.warn)("a saved auth transaction exists in storage. This may indicate another auth flow is already in progress."),r.setStorage(e),this.enableSharedStorage&&e.state&&(0,s.saveTransactionToSharedStorage)(this.storageManager,e.state,e)}},{key:"exists",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};try{return!!this.load(e)}catch(e){return!1}}},{key:"load",value:function(){var e,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this.enableSharedStorage&&t.state&&((0,s.pruneSharedStorage)(this.storageManager),e=(0,s.loadTransactionFromSharedStorage)(this.storageManager,t.state),(0,u.isTransactionMeta)(e))?e:(e=this.storageManager.getTransactionStorage().getStorage(),(0,u.isTransactionMeta)(e)?e:null)}}]),e}()};var o=n(r(6690)),a=n(r(9728)),i=n(r(8416)),u=r(8927),c=r(305),s=r(3327)},1237:function(e,t,r){"use strict";t.decodeToken=function(e){var t,r=e.split(".");try{t={header:JSON.parse((0,o.base64UrlToString)(r[0])),payload:JSON.parse((0,o.base64UrlToString)(r[1])),signature:r[2]}}catch(e){throw new n.AuthSdkError("Malformed token")}return t};var n=r(5728),o=r(9718)},2206:function(e,t,r){"use strict";var n=r(4836);t.buildAuthorizeParams=function(e){var t=s(e);return(0,a.toQueryString)(c(c({},t),e.extraParams&&c({},e.extraParams)))},t.convertTokenParamsToOAuthParams=s;var o=n(r(8416)),a=r(305),i=r(5728);function u(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function c(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?u(Object(r),!0).forEach((function(t){(0,o.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):u(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function s(e){if(!e.clientId)throw new i.AuthSdkError("A clientId must be specified in the OktaAuth constructor to get a token");if((0,a.isString)(e.responseType)&&-1!==e.responseType.indexOf(" "))throw new i.AuthSdkError("Multiple OAuth responseTypes must be defined as an array");var t={client_id:e.clientId,code_challenge:e.codeChallenge,code_challenge_method:e.codeChallengeMethod,display:e.display,idp:e.idp,idp_scope:e.idpScope,login_hint:e.loginHint,max_age:e.maxAge,nonce:e.nonce,prompt:e.prompt,redirect_uri:e.redirectUri,response_mode:e.responseMode,response_type:e.responseType,sessionToken:e.sessionToken,state:e.state,acr_values:e.acrValues,enroll_amr_values:e.enrollAmrValues};if(t=(0,a.removeNils)(t),["idp_scope","response_type","enroll_amr_values"].forEach((function(e){Array.isArray(t[e])&&(t[e]=t[e].join(" "))})),-1!==e.responseType.indexOf("id_token")&&-1===e.scopes.indexOf("openid"))throw new i.AuthSdkError("openid scope must be specified in the scopes argument when requesting an id_token");return e.scopes&&(t.scope=e.scopes.join(" ")),t}},2642:function(e,t,r){"use strict";var n=r(2206);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(9231);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(52);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}))},9231:function(e,t,r){"use strict";var n=r(4836);t.postRefreshToken=function(e,t,r){return(0,u.httpRequest)(e,{url:r.tokenUrl,method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},args:Object.entries({client_id:t.clientId,grant_type:"refresh_token",scope:r.scopes.join(" "),refresh_token:r.refreshToken}).map((function(e){var t=(0,o.default)(e,2),r=t[0],n=t[1];return r+"="+encodeURIComponent(n)})).join("&")})},t.postToTokenEndpoint=function(e,t,r){!function(e){if(!e.clientId)throw new a.AuthSdkError("A clientId must be specified in the OktaAuth constructor to get a token");if(!e.redirectUri)throw new a.AuthSdkError("The redirectUri passed to /authorize must also be passed to /token");if(!e.authorizationCode&&!e.interactionCode)throw new a.AuthSdkError("An authorization code (returned from /authorize) must be passed to /token");if(!e.codeVerifier)throw new a.AuthSdkError('The "codeVerifier" (generated and saved by your app) must be passed to /token')}(t);var n=function(e,t){var r=(0,i.removeNils)({client_id:t.clientId,redirect_uri:t.redirectUri,grant_type:t.interactionCode?"interaction_code":"authorization_code",code_verifier:t.codeVerifier});t.interactionCode?r.interaction_code=t.interactionCode:t.authorizationCode&&(r.code=t.authorizationCode);var n=e.options.clientSecret;return n&&(r.client_secret=n),(0,i.toQueryString)(r).slice(1)}(e,t);return(0,u.httpRequest)(e,{url:r.tokenUrl,method:"POST",args:n,headers:{"Content-Type":"application/x-www-form-urlencoded"}})};var o=n(r(7424)),a=r(5728),i=r(305),u=r(4777)},52:function(e,t,r){"use strict";var n=r(4836);t.getKey=function(e,t,r){var n=e.storageManager.getHttpCache(e.options.cookies);return u(e,t).then((function(t){var u=t.jwks_uri,c=n.getStorage()[u];if(c&&Date.now()/1e3<c.expiresAt){var s=(0,a.find)(c.response.keys,{kid:r});if(s)return s}return n.clearStorage(u),(0,o.get)(e,u,{cacheResponse:!0}).then((function(e){var t=(0,a.find)(e.keys,{kid:r});if(t)return t;throw new i.default("The key id, "+r+", was not found in the server's keys")}))}))},t.getWellKnown=u;var o=r(4777),a=r(305),i=n(r(9123));function u(e,t){var r=t||e.options.issuer;return(0,o.get)(e,r+"/.well-known/openid-configuration",{cacheResponse:!0})}},9284:function(e,t,r){"use strict";t.enrollAuthenticator=function(e,t){t=(0,n.clone)(t)||{};var r=(0,o.prepareEnrollAuthenticatorParams)(e,t),i=(0,o.createEnrollAuthenticatorMeta)(e,r),u=i.urls.authorizeUrl+(0,a.buildAuthorizeParams)(r);e.transactionManager.save(i),e.options.setLocation?e.options.setLocation(u):window.location.assign(u)};var n=r(305),o=r(8785),a=r(2206)},8707:function(e,t,r){"use strict";t.exchangeCodeForTokens=function(e,t,r){r=r||(0,n.getOAuthUrls)(e,t);var u=t=Object.assign({},(0,n.getDefaultTokenParams)(e),(0,o.clone)(t)),c=u.authorizationCode,s=u.interactionCode,l=u.codeVerifier,f=u.clientId,d=u.redirectUri,p=u.scopes,h=u.ignoreSignature,v=u.state,y=u.acrValues,g={clientId:f,redirectUri:d,authorizationCode:c,interactionCode:s,codeVerifier:l};return(0,a.postToTokenEndpoint)(e,g,r).then((function(t){var n=["token"];-1!==p.indexOf("openid")&&n.push("id_token");var o={clientId:f,redirectUri:d,scopes:p,responseType:n,ignoreSignature:h,acrValues:y};return(0,i.handleOAuthResponse)(e,o,t,r).then((function(e){return e.code=c,e.state=v,e}))})).finally((function(){e.transactionManager.clear()}))};var n=r(8785),o=r(305),a=r(9231),i=r(8676)},3859:function(e,t,r){"use strict";t.createOktaAuthOAuth=function(e,t,r){var c=(0,n.createOktaAuthBase)(t),s=(0,o.mixinStorage)(c,e),l=(0,i.mixinHttp)(s),f=(0,a.mixinSession)(l);return(0,u.mixinOAuth)(f,r)};var n=r(3306),o=r(265),a=r(3980),i=r(3334),u=r(498)},7203:function(e,t,r){"use strict";t.createEndpoints=function(e){return{authorize:{enrollAuthenticator:b.enrollAuthenticator.bind(null,e)}}},t.createTokenAPI=function(e,t){var r=function(e){return n.PromiseQueue.prototype.push.bind(t,e,null)},b=r(s.getWithRedirect.bind(null,e)),m=r(l.parseFromUrl.bind(null,e)),O=Object.assign(m,{_getHistory:function(){return window.history},_getLocation:function(){return window.location},_getDocument:function(){return window.document}}),k={prepareTokenParams:y.prepareTokenParams.bind(null,e),exchangeCodeForTokens:a.exchangeCodeForTokens.bind(null,e),getWithoutPrompt:u.getWithoutPrompt.bind(null,e),getWithPopup:c.getWithPopup.bind(null,e),getWithRedirect:b,parseFromUrl:O,decode:o.decodeToken,revoke:h.revokeToken.bind(null,e),renew:f.renewToken.bind(null,e),renewTokensWithRefresh:p.renewTokensWithRefresh.bind(null,e),renewTokens:d.renewTokens.bind(null,e),getUserInfo:function(t,r){return(0,i.getUserInfo)(e,t,r)},verify:g.verifyToken.bind(null,e),isLoginRedirect:y.isLoginRedirect.bind(null,e),introspect:v.oidcIntrospect.bind(null,e)};return["getWithoutPrompt","getWithPopup","revoke","renew","renewTokensWithRefresh","renewTokens"].forEach((function(e){k[e]=r(k[e])})),k};var n=r(305),o=r(1237),a=r(8707),i=r(6844),u=r(7625),c=r(9770),s=r(6803),l=r(9094),f=r(2476),d=r(6268),p=r(781),h=r(6466),v=r(8113),y=r(8785),g=r(1260),b=r(9284)},4276:function(e,t,r){"use strict";t.createBaseTokenAPI=function(e){return{prepareTokenParams:a.prepareTokenParams.bind(null,e),exchangeCodeForTokens:o.exchangeCodeForTokens.bind(null,e),decode:n.decodeToken}};var n=r(1237),o=r(8707),a=r(8785)},7276:function(e,t,r){"use strict";var n=r(7203);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(3859);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}))},3253:function(e,t,r){"use strict";var n=r(4836);t.getToken=function(e,t){if(arguments.length>2)return Promise.reject(new a.default('As of version 3.0, "getToken" takes only a single set of options'));var r=(t=t||{}).popupWindow;return t.popupWindow=void 0,(0,i.prepareTokenParams)(e,t).then((function(n){var i,s;switch(t.sessionToken?Object.assign(n,{prompt:"none",responseMode:"okta_post_message",display:null}):t.idp&&Object.assign(n,{display:"popup"}),s=(0,o.getOAuthUrls)(e,n),i=(t.codeVerifier?s.tokenUrl:s.authorizeUrl)+(0,u.buildAuthorizeParams)(n),n.sessionToken||null===n.display?"IFRAME":"popup"===n.display?"POPUP":"IMPLICIT"){case"IFRAME":var l=(0,o.addPostMessageListener)(e,t.timeout,n.state),f=(0,o.loadFrame)(i);return l.then((function(t){return(0,c.handleOAuthResponse)(e,n,t,s)})).finally((function(){var e;document.body.contains(f)&&(null===(e=f.parentElement)||void 0===e||e.removeChild(f))}));case"POPUP":var d;if("okta_post_message"===n.responseMode){if(!e.features.isPopupPostMessageSupported())throw new a.default("This browser doesn't have full postMessage support");d=(0,o.addPostMessageListener)(e,t.timeout,n.state)}return r&&r.location.assign(i),new Promise((function(e,t){var n=setInterval((function(){r&&!r.closed||(clearInterval(n),t(new a.default("Unable to parse OAuth flow response")))}),100);d.then((function(t){clearInterval(n),e(t)})).catch((function(e){clearInterval(n),t(e)}))})).then((function(t){return(0,c.handleOAuthResponse)(e,n,t,s)})).finally((function(){r&&!r.closed&&r.close()}));default:throw new a.default("The full page redirect flow is not supported")}}))};var o=r(8785),a=n(r(9123)),i=r(6898),u=r(2206),c=r(8676)},6844:function(e,t,r){"use strict";var n=r(4836);t.getUserInfo=function(e,t,r){return l.apply(this,arguments)};var o=n(r(4687)),a=n(r(7156)),i=r(305),u=r(5728),c=r(4777),s=r(8927);function l(){return(l=(0,a.default)(o.default.mark((function e(t,r,n){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r){e.next=4;break}return e.next=3,t.tokenManager.getTokens();case 3:r=e.sent.accessToken;case 4:if(n){e.next=8;break}return e.next=7,t.tokenManager.getTokens();case 7:n=e.sent.idToken;case 8:if(r&&(0,s.isAccessToken)(r)){e.next=10;break}return e.abrupt("return",Promise.reject(new u.AuthSdkError("getUserInfo requires an access token object")));case 10:if(n&&(0,s.isIDToken)(n)){e.next=12;break}return e.abrupt("return",Promise.reject(new u.AuthSdkError("getUserInfo requires an ID token object")));case 12:return e.abrupt("return",(0,c.httpRequest)(t,{url:r.userinfoUrl,method:"GET",accessToken:r.accessToken}).then((function(e){return e.sub===n.claims.sub?e:Promise.reject(new u.AuthSdkError("getUserInfo request was rejected due to token mismatch"))})).catch((function(e){var t;if(e.xhr&&(401===e.xhr.status||403===e.xhr.status)&&(e.xhr.headers&&(0,i.isFunction)(e.xhr.headers.get)&&e.xhr.headers.get("WWW-Authenticate")?t=e.xhr.headers.get("WWW-Authenticate"):(0,i.isFunction)(e.xhr.getResponseHeader)&&(t=e.xhr.getResponseHeader("WWW-Authenticate")),t)){var r=t.match(/error="(.*?)"/)||[],n=t.match(/error_description="(.*?)"/)||[],o=r[1],a=n[1];o&&a&&(e=new u.OAuthError(o,a))}throw e})));case 13:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},9770:function(e,t,r){"use strict";t.getWithPopup=function(e,t){if(arguments.length>2)return Promise.reject(new n.AuthSdkError('As of version 3.0, "getWithPopup" takes only a single set of options'));var r=(0,i.loadPopup)("/",t);return t=(0,o.clone)(t)||{},Object.assign(t,{display:"popup",responseMode:"okta_post_message",popupWindow:r}),(0,a.getToken)(e,t)};var n=r(5728),o=r(305),a=r(3253),i=r(8785)},6803:function(e,t,r){"use strict";var n=r(4836);t.getWithRedirect=function(e,t){return l.apply(this,arguments)};var o=n(r(4687)),a=n(r(7156)),i=r(5728),u=r(305),c=r(8785),s=r(2206);function l(){return l=(0,a.default)(o.default.mark((function e(t,r){var n,a,l,f=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!(f.length>2)){e.next=2;break}return e.abrupt("return",Promise.reject(new i.AuthSdkError('As of version 3.0, "getWithRedirect" takes only a single set of options')));case 2:return r=(0,u.clone)(r)||{},e.next=5,(0,c.prepareTokenParams)(t,r);case 5:n=e.sent,a=(0,c.createOAuthMeta)(t,n),l=a.urls.authorizeUrl+(0,s.buildAuthorizeParams)(n),t.transactionManager.save(a),t.options.setLocation?t.options.setLocation(l):window.location.assign(l);case 10:case"end":return e.stop()}}),e)}))),l.apply(this,arguments)}},7625:function(e,t,r){"use strict";t.getWithoutPrompt=function(e,t){return arguments.length>2?Promise.reject(new n.AuthSdkError('As of version 3.0, "getWithoutPrompt" takes only a single set of options')):(t=(0,o.clone)(t)||{},Object.assign(t,{prompt:"none",responseMode:"okta_post_message",display:null}),(0,a.getToken)(e,t))};var n=r(5728),o=r(305),a=r(3253)},8676:function(e,t,r){"use strict";var n=r(4836);t.handleOAuthResponse=function(e,t,r,n){return d.apply(this,arguments)};var o=n(r(4687)),a=n(r(7156)),i=r(305),u=r(7599),c=r(5728),s=r(1260),l=r(8785);function f(e,t){if(e.error&&e.error_description)throw new c.OAuthError(e.error,e.error_description);if(e.state!==t.state)throw new c.AuthSdkError("OAuth flow response state doesn't match request state")}function d(){return(d=(0,a.default)(o.default.mark((function e(t,r,n,a){var d,p,h,v,y,g,b,m,O,k,w,E,P,S;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!1===t.options.pkce||!n.code&&!n.interaction_code){e.next=3;break}return e.abrupt("return",t.token.exchangeCodeForTokens(Object.assign({},r,{authorizationCode:n.code,interactionCode:n.interaction_code}),a));case 3:if(r=r||(0,l.getDefaultTokenParams)(t),a=a||(0,u.getOAuthUrls)(t,r),d=r.responseType||[],Array.isArray(d)||"none"===d||(d=[d]),p=n.scope?n.scope.split(" "):(0,i.clone)(r.scopes),h=r.clientId||t.options.clientId,f(n,r),v={},y=n.expires_in,g=n.token_type,b=n.access_token,m=n.id_token,O=n.refresh_token,k=Math.floor(Date.now()/1e3),b&&(w=t.token.decode(b),v.accessToken={accessToken:b,claims:w.payload,expiresAt:Number(y)+k,tokenType:g,scopes:p,authorizeUrl:a.authorizeUrl,userinfoUrl:a.userinfoUrl}),O&&(v.refreshToken={refreshToken:O,expiresAt:Number(y)+k,scopes:p,tokenUrl:a.tokenUrl,authorizeUrl:a.authorizeUrl,issuer:a.issuer}),!m){e.next=27;break}return E=t.token.decode(m),P={idToken:m,claims:E.payload,expiresAt:E.payload.exp-E.payload.iat+k,scopes:p,authorizeUrl:a.authorizeUrl,issuer:a.issuer,clientId:h},S={clientId:h,issuer:a.issuer,nonce:r.nonce,accessToken:b,acrValues:r.acrValues},void 0!==r.ignoreSignature&&(S.ignoreSignature=r.ignoreSignature),e.next=26,(0,s.verifyToken)(t,P,S);case 26:v.idToken=P;case 27:if(-1===d.indexOf("token")||v.accessToken){e.next=29;break}throw new c.AuthSdkError('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');case 29:if(-1===d.indexOf("id_token")||v.idToken){e.next=31;break}throw new c.AuthSdkError('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');case 31:return e.abrupt("return",{tokens:v,state:n.state,code:n.code,responseType:d});case 32:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},9443:function(e,t,r){"use strict";var n={decodeToken:!0,revokeToken:!0,renewToken:!0,renewTokensWithRefresh:!0,renewTokens:!0,verifyToken:!0,getUserInfo:!0,handleOAuthResponse:!0,exchangeCodeForTokens:!0,getToken:!0,getWithoutPrompt:!0,getWithPopup:!0,getWithRedirect:!0,parseFromUrl:!0,oidcIntrospect:!0};Object.defineProperty(t,"decodeToken",{enumerable:!0,get:function(){return p.decodeToken}}),Object.defineProperty(t,"exchangeCodeForTokens",{enumerable:!0,get:function(){return k.exchangeCodeForTokens}}),Object.defineProperty(t,"getToken",{enumerable:!0,get:function(){return w.getToken}}),Object.defineProperty(t,"getUserInfo",{enumerable:!0,get:function(){return m.getUserInfo}}),Object.defineProperty(t,"getWithPopup",{enumerable:!0,get:function(){return P.getWithPopup}}),Object.defineProperty(t,"getWithRedirect",{enumerable:!0,get:function(){return S.getWithRedirect}}),Object.defineProperty(t,"getWithoutPrompt",{enumerable:!0,get:function(){return E.getWithoutPrompt}}),Object.defineProperty(t,"handleOAuthResponse",{enumerable:!0,get:function(){return O.handleOAuthResponse}}),Object.defineProperty(t,"oidcIntrospect",{enumerable:!0,get:function(){return j.oidcIntrospect}}),Object.defineProperty(t,"parseFromUrl",{enumerable:!0,get:function(){return T.parseFromUrl}}),Object.defineProperty(t,"renewToken",{enumerable:!0,get:function(){return v.renewToken}}),Object.defineProperty(t,"renewTokens",{enumerable:!0,get:function(){return g.renewTokens}}),Object.defineProperty(t,"renewTokensWithRefresh",{enumerable:!0,get:function(){return y.renewTokensWithRefresh}}),Object.defineProperty(t,"revokeToken",{enumerable:!0,get:function(){return h.revokeToken}}),Object.defineProperty(t,"verifyToken",{enumerable:!0,get:function(){return b.verifyToken}});var o=r(7276);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(n,e)||e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(498);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(n,e)||e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var i=r(2333);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(n,e)||e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}));var u=r(2642);Object.keys(u).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(n,e)||e in t&&t[e]===u[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}}))}));var c=r(3775);Object.keys(c).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(n,e)||e in t&&t[e]===c[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return c[e]}}))}));var s=r(8927);Object.keys(s).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(n,e)||e in t&&t[e]===s[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return s[e]}}))}));var l=r(3426);Object.keys(l).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(n,e)||e in t&&t[e]===l[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return l[e]}}))}));var f=r(130);Object.keys(f).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(n,e)||e in t&&t[e]===f[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return f[e]}}))}));var d=r(8785);Object.keys(d).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(n,e)||e in t&&t[e]===d[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return d[e]}}))}));var p=r(1237),h=r(6466),v=r(2476),y=r(781),g=r(6268),b=r(1260),m=r(6844),O=r(8676),k=r(8707),w=r(3253),E=r(7625),P=r(9770),S=r(6803),T=r(9094),j=r(8113)},8113:function(e,t,r){"use strict";var n=r(4836);t.oidcIntrospect=function(e,t,r){return p.apply(this,arguments)};var o=n(r(4687)),a=n(r(7156)),i=r(5728),u=r(52),c=r(4777),s=r(305),l=r(9718),f=r(8927),d={accessToken:"access_token",idToken:"id_token",refreshToken:"refresh_token"};function p(){return(p=(0,a.default)(o.default.mark((function e(t,r,n){var a,p,h,v,y,g,b,m,O,k;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(p=t.options.clientId,h=t.options.clientSecret,n||(n=t.tokenManager.getTokens()[r]),n){e.next=5;break}throw new i.AuthSdkError("unable to find ".concat(r," in storage or fn params"));case 5:if(a=(a=r!==f.TokenKind.ACCESS?null===(v=n)||void 0===v?void 0:v.issuer:null===(y=n)||void 0===y||null===(g=y.claims)||void 0===g?void 0:g.iss)||t.options.issuer,p){e.next=9;break}throw new i.AuthSdkError("A clientId must be specified in the OktaAuth constructor to introspect a token");case 9:if(a){e.next=11;break}throw new i.AuthSdkError("Unable to find issuer");case 11:return e.next=13,(0,u.getWellKnown)(t,a);case 13:return b=e.sent,m=b.introspection_endpoint,O=h?(0,l.btoa)("".concat(p,":").concat(h)):(0,l.btoa)(p),k=(0,s.toQueryString)({token_type_hint:d[r],token:n[r]}).slice(1),e.abrupt("return",(0,c.post)(t,m,k,{headers:{"Content-Type":"application/x-www-form-urlencoded",Authorization:"Basic "+O}}));case 18:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},4449:function(e,t,r){"use strict";var n=r(4836);t.provideOriginalUri=function(e){return function(e){(0,i.default)(f,e);var t,r,n=(t=f,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function f(){return(0,o.default)(this,f),n.apply(this,arguments)}return(0,a.default)(f,[{key:"setOriginalUri",value:function(e,t){l.default.getSessionStorage().setItem(s.REFERRER_PATH_STORAGE_KEY,e),(t=t||this.options.state)&&this.storageManager.getOriginalUriStorage().setItem(t,e)}},{key:"getOriginalUri",value:function(e){if(e=e||this.options.state){var t=this.storageManager.getOriginalUriStorage().getItem(e);if(t)return t}var r=l.default.getSessionStorage();return r&&r.getItem(s.REFERRER_PATH_STORAGE_KEY)||void 0}},{key:"removeOriginalUri",value:function(e){if(l.default.getSessionStorage().removeItem(s.REFERRER_PATH_STORAGE_KEY),e=e||this.options.state){var t=this.storageManager.getOriginalUriStorage();t.removeItem&&t.removeItem(e)}}}]),f}(e)};var o=n(r(6690)),a=n(r(9728)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808)),s=r(1971),l=n(r(5407))},498:function(e,t,r){"use strict";var n=r(4836),o=r(8698);t.mixinOAuth=function(e,t){var r;return r=function(e){(0,d.default)(M,e);var r,n,o,b,E,S,T,_,x,A,R=(r=M,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=(0,h.default)(r);if(n){var o=(0,h.default)(this).constructor;e=Reflect.construct(t,arguments,o)}else e=t.apply(this,arguments);return(0,p.default)(this,e)});function M(){var e;(0,c.default)(this,M);for(var r=arguments.length,n=new Array(r),o=0;o<r;o++)n[o]=arguments[o];return e=R.call.apply(R,[this].concat(n)),(0,v.default)((0,l.default)(e),"token",void 0),(0,v.default)((0,l.default)(e),"tokenManager",void 0),(0,v.default)((0,l.default)(e),"transactionManager",void 0),(0,v.default)((0,l.default)(e),"pkce",void 0),(0,v.default)((0,l.default)(e),"endpoints",void 0),(0,v.default)((0,l.default)(e),"_pending",void 0),(0,v.default)((0,l.default)(e),"_tokenQueue",void 0),e.transactionManager=new t(Object.assign({storageManager:e.storageManager},e.options.transactionManager)),e.pkce={DEFAULT_CODE_CHALLENGE_METHOD:m.default.DEFAULT_CODE_CHALLENGE_METHOD,generateVerifier:m.default.generateVerifier,computeChallenge:m.default.computeChallenge},e._pending={handleLogin:!1},e._tokenQueue=new g.PromiseQueue,e.token=(0,O.createTokenAPI)((0,l.default)(e),e._tokenQueue),e.tokenManager=new k.TokenManager((0,l.default)(e),e.options.tokenManager),e.endpoints=(0,O.createEndpoints)((0,l.default)(e)),e}return(0,s.default)(M,[{key:"clearStorage",value:function(){(0,f.default)((0,h.default)(M.prototype),"clearStorage",this).call(this),this.tokenManager.clear()}},{key:"isAuthenticated",value:(A=(0,u.default)(i.default.mark((function e(){var t,r,n,o,a,u,c,s,l,f,d=arguments;return i.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=d.length>0&&void 0!==d[0]?d[0]:{},r=this.tokenManager.getOptions(),n=r.autoRenew,o=r.autoRemove,a=t.onExpiredToken?"renew"===t.onExpiredToken:n,u=t.onExpiredToken?"remove"===t.onExpiredToken:o,c=this.tokenManager.getTokensSync(),!(s=c.accessToken)||!this.tokenManager.hasExpired(s)){e.next=19;break}if(s=void 0,!a){e.next=18;break}return e.prev=8,e.next=11,this.tokenManager.renew("accessToken");case 11:s=e.sent,e.next=16;break;case 14:e.prev=14,e.t0=e.catch(8);case 16:e.next=19;break;case 18:u&&this.tokenManager.remove("accessToken");case 19:if(l=this.tokenManager.getTokensSync(),!(f=l.idToken)||!this.tokenManager.hasExpired(f)){e.next=34;break}if(f=void 0,!a){e.next=33;break}return e.prev=23,e.next=26,this.tokenManager.renew("idToken");case 26:f=e.sent,e.next=31;break;case 29:e.prev=29,e.t1=e.catch(23);case 31:e.next=34;break;case 33:u&&this.tokenManager.remove("idToken");case 34:return e.abrupt("return",!(!s||!f));case 35:case"end":return e.stop()}}),e,this,[[8,14],[23,29]])}))),function(){return A.apply(this,arguments)})},{key:"signInWithRedirect",value:(x=(0,u.default)(i.default.mark((function e(){var t,r,n,o,u=arguments;return i.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=(t=u.length>0&&void 0!==u[0]?u[0]:{}).originalUri,n=(0,a.default)(t,P),!this._pending.handleLogin){e.next=4;break}return e.abrupt("return");case 4:return this._pending.handleLogin=!0,e.prev=5,r&&this.setOriginalUri(r),o=Object.assign({scopes:this.options.scopes||["openid","email","profile"]},n),e.next=10,this.token.getWithRedirect(o);case 10:return e.prev=10,this._pending.handleLogin=!1,e.finish(10);case 13:case"end":return e.stop()}}),e,this,[[5,,10,13]])}))),function(){return x.apply(this,arguments)})},{key:"getUser",value:(_=(0,u.default)(i.default.mark((function e(){var t,r,n;return i.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return t=this.tokenManager.getTokensSync(),r=t.idToken,n=t.accessToken,e.abrupt("return",this.token.getUserInfo(n,r));case 2:case"end":return e.stop()}}),e,this)}))),function(){return _.apply(this,arguments)})},{key:"getIdToken",value:function(){var e=this.tokenManager.getTokensSync().idToken;return e?e.idToken:void 0}},{key:"getAccessToken",value:function(){var e=this.tokenManager.getTokensSync().accessToken;return e?e.accessToken:void 0}},{key:"getRefreshToken",value:function(){var e=this.tokenManager.getTokensSync().refreshToken;return e?e.refreshToken:void 0}},{key:"storeTokensFromRedirect",value:(T=(0,u.default)(i.default.mark((function e(){var t,r;return i.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.token.parseFromUrl();case 2:t=e.sent,r=t.tokens,"none"!==t.responseType&&this.tokenManager.setTokens(r);case 6:case"end":return e.stop()}}),e,this)}))),function(){return T.apply(this,arguments)})},{key:"isLoginRedirect",value:function(){return(0,w.isLoginRedirect)(this)}},{key:"isPKCE",value:function(){return!!this.options.pkce}},{key:"hasResponseType",value:function(e){return(0,w.hasResponseType)(e,this.options)}},{key:"isAuthorizationCodeFlow",value:function(){return this.hasResponseType("code")}},{key:"invokeApiMethod",value:(S=(0,u.default)(i.default.mark((function e(t){var r;return i.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t.accessToken){e.next=5;break}return e.next=3,this.tokenManager.getTokens();case 3:r=e.sent.accessToken,t.accessToken=null==r?void 0:r.accessToken;case 5:return e.abrupt("return",(0,y.httpRequest)(this,t));case 6:case"end":return e.stop()}}),e,this)}))),function(e){return S.apply(this,arguments)})},{key:"revokeAccessToken",value:(E=(0,u.default)(i.default.mark((function e(t){var r;return i.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t){e.next=6;break}return e.next=3,this.tokenManager.getTokens();case 3:t=e.sent.accessToken,r=this.tokenManager.getStorageKeyByType("accessToken"),this.tokenManager.remove(r);case 6:if(t){e.next=8;break}return e.abrupt("return",Promise.resolve(null));case 8:return e.abrupt("return",this.token.revoke(t));case 9:case"end":return e.stop()}}),e,this)}))),function(e){return E.apply(this,arguments)})},{key:"revokeRefreshToken",value:(b=(0,u.default)(i.default.mark((function e(t){var r;return i.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t){e.next=6;break}return e.next=3,this.tokenManager.getTokens();case 3:t=e.sent.refreshToken,r=this.tokenManager.getStorageKeyByType("refreshToken"),this.tokenManager.remove(r);case 6:if(t){e.next=8;break}return e.abrupt("return",Promise.resolve(null));case 8:return e.abrupt("return",this.token.revoke(t));case 9:case"end":return e.stop()}}),e,this)}))),function(e){return b.apply(this,arguments)})},{key:"getSignOutRedirectUrl",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.idToken,r=e.postLogoutRedirectUri,n=e.state;if(t||(t=this.tokenManager.getTokensSync().idToken),!t)return"";void 0===r&&(r=this.options.postLogoutRedirectUri);var o=(0,w.getOAuthUrls)(this).logoutUrl,a=t.idToken,i=o+"?id_token_hint="+encodeURIComponent(a);return r&&(i+="&post_logout_redirect_uri="+encodeURIComponent(r)),n&&(i+="&state="+encodeURIComponent(n)),i}},{key:"signOut",value:(o=(0,u.default)(i.default.mark((function e(t){var r,n,o,a,u,c,s,l,f,d,p,h;return i.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(t=Object.assign({},t),n=window.location.origin,o=window.location.href,a=null===t.postLogoutRedirectUri?null:t.postLogoutRedirectUri||this.options.postLogoutRedirectUri||n,u=null===(r=t)||void 0===r?void 0:r.state,c=t.accessToken,s=t.refreshToken,l=!1!==t.revokeAccessToken,(f=!1!==t.revokeRefreshToken)&&void 0===s&&(s=this.tokenManager.getTokensSync().refreshToken),l&&void 0===c&&(c=this.tokenManager.getTokensSync().accessToken),t.idToken||(t.idToken=this.tokenManager.getTokensSync().idToken),!f||!s){e.next=15;break}return e.next=15,this.revokeRefreshToken(s);case 15:if(!l||!c){e.next=18;break}return e.next=18,this.revokeAccessToken(c);case 18:if(d=this.getSignOutRedirectUrl(j(j({},t),{},{postLogoutRedirectUri:a}))){e.next=29;break}return e.next=22,this.closeSession();case 22:return p=e.sent,h=new URL(a||n),u&&h.searchParams.append("state",u),a===o?window.location.href=h.href:window.location.assign(h.href),e.abrupt("return",p);case 29:return t.clearTokensBeforeRedirect?this.tokenManager.clear():this.tokenManager.addPendingRemoveFlags(),window.location.assign(d),e.abrupt("return",!0);case 32:case"end":return e.stop()}}),e,this)}))),function(e){return o.apply(this,arguments)})}]),M}((0,E.provideOriginalUri)(e)),(0,v.default)(r,"crypto",b),r};var a=n(r(215)),i=n(r(4687)),u=n(r(7156)),c=n(r(6690)),s=n(r(9728)),l=n(r(6115)),f=n(r(1588)),d=n(r(1655)),p=n(r(4993)),h=n(r(3808)),v=n(r(8416)),y=r(4777),g=r(305),b=function(e,t){if(e&&e.__esModule)return e;if(null===e||"object"!==o(e)&&"function"!=typeof e)return{default:e};var r=S(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var u=a?Object.getOwnPropertyDescriptor(e,i):null;u&&(u.get||u.set)?Object.defineProperty(n,i,u):n[i]=e[i]}return n.default=e,r&&r.set(e,n),n}(r(9718)),m=n(r(3611)),O=r(7203),k=r(3426),w=r(8785),E=r(4449),P=["originalUri"];function S(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(S=function(e){return e?r:t})(e)}function T(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function j(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?T(Object(r),!0).forEach((function(t){(0,v.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):T(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}},6648:function(e,t,r){"use strict";var n=r(4836);t.mixinMinimalOAuth=function(e,t){return function(e){(0,u.default)(h,e);var r,n,p=(r=h,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=(0,s.default)(r);if(n){var o=(0,s.default)(this).constructor;e=Reflect.construct(t,arguments,o)}else e=t.apply(this,arguments);return(0,c.default)(this,e)});function h(){var e;(0,o.default)(this,h);for(var r=arguments.length,n=new Array(r),a=0;a<r;a++)n[a]=arguments[a];return e=p.call.apply(p,[this].concat(n)),(0,l.default)((0,i.default)(e),"token",void 0),(0,l.default)((0,i.default)(e),"transactionManager",void 0),e.transactionManager=new t(Object.assign({storageManager:e.storageManager},e.options.transactionManager)),e.token=(0,f.createBaseTokenAPI)((0,i.default)(e)),e}return(0,a.default)(h,[{key:"isLoginRedirect",value:function(){return(0,d.isLoginRedirect)(this)}},{key:"isPKCE",value:function(){return!!this.options.pkce}},{key:"hasResponseType",value:function(e){return(0,d.hasResponseType)(e,this.options)}},{key:"isAuthorizationCodeFlow",value:function(){return this.hasResponseType("code")}}]),h}(e)};var o=n(r(6690)),a=n(r(9728)),i=n(r(6115)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416)),f=r(4276),d=r(8785)},3234:function(e,t,r){"use strict";var n=r(4836);t.createOAuthOptionsConstructor=function(){return function(e){(0,u.default)(h,e);var t,r,n=(t=h,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function h(e){var t;return(0,a.default)(this,h),t=n.call(this,e),(0,l.default)((0,i.default)(t),"issuer",void 0),(0,l.default)((0,i.default)(t),"authorizeUrl",void 0),(0,l.default)((0,i.default)(t),"userinfoUrl",void 0),(0,l.default)((0,i.default)(t),"tokenUrl",void 0),(0,l.default)((0,i.default)(t),"revokeUrl",void 0),(0,l.default)((0,i.default)(t),"logoutUrl",void 0),(0,l.default)((0,i.default)(t),"pkce",void 0),(0,l.default)((0,i.default)(t),"clientId",void 0),(0,l.default)((0,i.default)(t),"redirectUri",void 0),(0,l.default)((0,i.default)(t),"responseType",void 0),(0,l.default)((0,i.default)(t),"responseMode",void 0),(0,l.default)((0,i.default)(t),"state",void 0),(0,l.default)((0,i.default)(t),"scopes",void 0),(0,l.default)((0,i.default)(t),"ignoreSignature",void 0),(0,l.default)((0,i.default)(t),"codeChallenge",void 0),(0,l.default)((0,i.default)(t),"codeChallengeMethod",void 0),(0,l.default)((0,i.default)(t),"acrValues",void 0),(0,l.default)((0,i.default)(t),"maxAge",void 0),(0,l.default)((0,i.default)(t),"tokenManager",void 0),(0,l.default)((0,i.default)(t),"postLogoutRedirectUri",void 0),(0,l.default)((0,i.default)(t),"restoreOriginalUri",void 0),(0,l.default)((0,i.default)(t),"transactionManager",void 0),(0,l.default)((0,i.default)(t),"clientSecret",void 0),(0,l.default)((0,i.default)(t),"setLocation",void 0),(0,l.default)((0,i.default)(t),"ignoreLifetime",void 0),(0,l.default)((0,i.default)(t),"maxClockSkew",void 0),function(e){var t=(e=e||{}).scopes;if(t&&!Array.isArray(t))throw new y.default('scopes must be a array of strings. Required usage: new OktaAuth({scopes: ["openid", "email"]})');var r=e.issuer;if(!r)throw new y.default('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');if(!new RegExp("^http?s?://.+").test(r))throw new y.default('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');if(-1!==r.indexOf("-admin."))throw new y.default('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})')}(e),t.issuer=(0,d.removeTrailingSlash)(e.issuer),t.tokenUrl=(0,d.removeTrailingSlash)(e.tokenUrl),t.authorizeUrl=(0,d.removeTrailingSlash)(e.authorizeUrl),t.userinfoUrl=(0,d.removeTrailingSlash)(e.userinfoUrl),t.revokeUrl=(0,d.removeTrailingSlash)(e.revokeUrl),t.logoutUrl=(0,d.removeTrailingSlash)(e.logoutUrl),t.pkce=!1!==e.pkce,t.clientId=e.clientId,t.redirectUri=e.redirectUri,(0,p.isBrowser)()&&(t.redirectUri=(0,d.toAbsoluteUrl)(e.redirectUri,window.location.origin)),t.responseType=e.responseType,t.responseMode=e.responseMode,t.state=e.state,t.scopes=e.scopes,t.ignoreSignature=!!e.ignoreSignature,t.codeChallenge=e.codeChallenge,t.codeChallengeMethod=e.codeChallengeMethod,t.acrValues=e.acrValues,t.maxAge=e.maxAge,t.tokenManager=e.tokenManager,t.postLogoutRedirectUri=e.postLogoutRedirectUri,t.restoreOriginalUri=e.restoreOriginalUri,t.transactionManager=function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?g(Object(r),!0).forEach((function(t){(0,l.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):g(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}({enableSharedStorage:v.enableSharedStorage},e.transactionManager),t.clientSecret=e.clientSecret,t.setLocation=e.setLocation,t.ignoreLifetime=!!e.ignoreLifetime,e.maxClockSkew||0===e.maxClockSkew?t.maxClockSkew=e.maxClockSkew:t.maxClockSkew=f.DEFAULT_MAX_CLOCK_SKEW,t}return(0,o.default)(h)}((0,h.createHttpOptionsConstructor)())};var o=n(r(9728)),a=n(r(6690)),i=n(r(6115)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416)),f=r(1971),d=r(6718),p=r(415),h=r(4090),v=r(5577),y=n(r(9123));function g(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}},5577:function(e,t){"use strict";t.enableSharedStorage=void 0,t.enableSharedStorage=!0},3775:function(e,t,r){"use strict";var n=r(3234);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}))},9094:function(e,t,r){"use strict";var n=r(4836);t.cleanOAuthResponseFromUrl=d,t.getResponseMode=l,t.parseFromUrl=function(e,t){return p.apply(this,arguments)},t.parseOAuthResponseFromUrl=f;var o=n(r(4687)),a=n(r(7156)),i=r(5728),u=r(8785),c=r(305),s=r(8676);function l(e){var t=e.options.pkce?"query":"fragment";return e.options.responseMode||t}function f(e,t){t=t||{},(0,c.isString)(t)&&(t={url:t});var r,n=t.url,o=t.responseMode||l(e),a=e.token.parseFromUrl._getLocation();if(!(r="query"===o?n?n.substring(n.indexOf("?")):a.search:n?n.substring(n.indexOf("#")):a.hash))throw new i.AuthSdkError("Unable to parse a token from the url");return(0,u.urlParamsToObject)(r)}function d(e,t){"query"===(t.responseMode||l(e))?function(e){var t=e.token.parseFromUrl._getHistory(),r=e.token.parseFromUrl._getDocument(),n=e.token.parseFromUrl._getLocation();t&&t.replaceState?t.replaceState(null,r.title,n.pathname+n.hash):n.search=""}(e):function(e){var t=e.token.parseFromUrl._getHistory(),r=e.token.parseFromUrl._getDocument(),n=e.token.parseFromUrl._getLocation();t&&t.replaceState?t.replaceState(null,r.title,n.pathname+n.search):n.hash=""}(e)}function p(){return(p=(0,a.default)(o.default.mark((function e(t,r){var n,a,l,p;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=r||{},(0,c.isString)(r)&&(r={url:r}),n=f(t,r),a=n.state,l=t.transactionManager.load({state:a})){e.next=9;break}if(!t.options.pkce){e.next=8;break}throw new i.AuthSdkError("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.",void 0);case 8:throw new i.AuthSdkError("Unable to retrieve OAuth redirect params from storage");case 9:return p=l.urls,delete l.urls,r.url||d(t,r),e.abrupt("return",(0,s.handleOAuthResponse)(t,l,n,p).catch((function(e){throw(0,u.isInteractionRequiredError)(e)||t.transactionManager.clear({state:a}),e})).then((function(e){return t.transactionManager.clear({state:a}),e})));case 13:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},2476:function(e,t,r){"use strict";var n=r(4836);t.renewToken=function(e,t){return d.apply(this,arguments)};var o=n(r(4687)),a=n(r(7156)),i=r(5728),u=r(8927),c=r(7625),s=r(781);function l(){throw new i.AuthSdkError("Renew must be passed a token with an array of scopes and an accessToken or idToken")}function f(e,t){return(0,u.isIDToken)(e)?t.idToken:(0,u.isAccessToken)(e)?t.accessToken:void l()}function d(){return(d=(0,a.default)(o.default.mark((function e(t,r){var n,a,i,d,p,h,v;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if((0,u.isIDToken)(r)||(0,u.isAccessToken)(r)||l(),!(n=t.tokenManager.getTokensSync()).refreshToken){e.next=7;break}return e.next=5,(0,s.renewTokensWithRefresh)(t,{scopes:r.scopes},n.refreshToken);case 5:return n=e.sent,e.abrupt("return",f(r,n));case 7:return a=t.options.pkce?"code":(0,u.isAccessToken)(r)?"token":"id_token",d=(i=r).scopes,p=i.authorizeUrl,h=i.userinfoUrl,v=i.issuer,e.abrupt("return",(0,c.getWithoutPrompt)(t,{responseType:a,scopes:d,authorizeUrl:p,userinfoUrl:h,issuer:v}).then((function(e){return f(r,e.tokens)})));case 10:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},6268:function(e,t,r){"use strict";var n=r(4836);t.renewTokens=function(e,t){return l.apply(this,arguments)};var o=n(r(4687)),a=n(r(7156)),i=r(5728),u=r(7625),c=r(781),s=r(8785);function l(){return(l=(0,a.default)(o.default.mark((function e(t,r){var n,a,l,f,d,p,h,v,y,g,b;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!(l=null!==(n=null===(a=r)||void 0===a?void 0:a.tokens)&&void 0!==n?n:t.tokenManager.getTokensSync()).refreshToken){e.next=3;break}return e.abrupt("return",(0,c.renewTokensWithRefresh)(t,r||{},l.refreshToken));case 3:if(l.accessToken||l.idToken){e.next=5;break}throw new i.AuthSdkError("renewTokens() was called but there is no existing token");case 5:if(f=l.accessToken||{},d=l.idToken||{},p=f.scopes||d.scopes){e.next=10;break}throw new i.AuthSdkError("renewTokens: invalid tokens: could not read scopes");case 10:if(h=f.authorizeUrl||d.authorizeUrl){e.next=13;break}throw new i.AuthSdkError("renewTokens: invalid tokens: could not read authorizeUrl");case 13:return v=f.userinfoUrl||t.options.userinfoUrl,y=d.issuer||t.options.issuer,r=Object.assign({scopes:p,authorizeUrl:h,userinfoUrl:v,issuer:y},r),t.options.pkce?r.responseType="code":(g=(0,s.getDefaultTokenParams)(t),b=g.responseType,r.responseType=b),e.abrupt("return",(0,u.getWithoutPrompt)(t,r).then((function(e){return e.tokens})));case 18:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},781:function(e,t,r){"use strict";var n=r(4836);t.renewTokensWithRefresh=function(e,t,r){return d.apply(this,arguments)};var o=n(r(4687)),a=n(r(7156)),i=r(5728),u=r(7599),c=r(6635),s=r(8676),l=r(9231),f=r(9912);function d(){return(d=(0,a.default)(o.default.mark((function e(t,r,n){var a,d,p,h,v,y,g;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(a=t.options.clientId){e.next=3;break}throw new i.AuthSdkError("A clientId must be specified in the OktaAuth constructor to renew tokens");case 3:return e.prev=3,d=Object.assign({},r,{clientId:a}),e.next=7,(0,l.postRefreshToken)(t,d,n);case 7:return p=e.sent,h=(0,u.getOAuthUrls)(t,r),e.next=11,(0,s.handleOAuthResponse)(t,d,p,h);case 11:return v=e.sent,y=v.tokens,(g=y.refreshToken)&&!(0,c.isSameRefreshToken)(g,n)&&t.tokenManager.updateRefreshToken(g),e.abrupt("return",y);case 18:throw e.prev=18,e.t0=e.catch(3),(0,f.isRefreshTokenInvalidError)(e.t0)&&t.tokenManager.removeRefreshToken(),e.t0;case 22:case"end":return e.stop()}}),e,null,[[3,18]])})))).apply(this,arguments)}},6466:function(e,t,r){"use strict";var n=r(4836);t.revokeToken=function(e,t){return f.apply(this,arguments)};var o=n(r(4687)),a=n(r(7156)),i=r(4777),u=r(305),c=r(7599),s=r(9718),l=n(r(9123));function f(){return(f=(0,a.default)(o.default.mark((function e(t,r){var n,a,f,d,p,h,v;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(n="",a="",r&&(n=r.accessToken,a=r.refreshToken),n||a){e.next=5;break}throw new l.default("A valid access or refresh token object is required");case 5:if(f=t.options.clientId,d=t.options.clientSecret,f){e.next=9;break}throw new l.default("A clientId must be specified in the OktaAuth constructor to revoke a token");case 9:return p=(0,c.getOAuthUrls)(t).revokeUrl,h=(0,u.toQueryString)({token_type_hint:a?"refresh_token":"access_token",token:a||n}).slice(1),v=d?(0,s.btoa)("".concat(f,":").concat(d)):(0,s.btoa)(f),e.abrupt("return",(0,i.post)(t,p,h,{headers:{"Content-Type":"application/x-www-form-urlencoded",Authorization:"Basic "+v}}));case 13:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},2333:function(e,t,r){"use strict";var n=r(4836);t.createOAuthStorageManager=function(){return function(e){(0,i.default)(d,e);var t,r,n=(t=d,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,c.default)(t);if(r){var o=(0,c.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,u.default)(this,e)});function d(e,t,r){return(0,o.default)(this,d),n.call(this,e,t,r)}return(0,a.default)(d,[{key:"getTransactionStorage",value:function(e){e=this.getOptionsForSection("transaction",e),(0,s.logServerSideMemoryStorageWarning)(e);var t=this.getStorage(e),r=e.storageKey||f.TRANSACTION_STORAGE_NAME;return new l.SavedObject(t,r)}},{key:"getSharedTansactionStorage",value:function(e){e=this.getOptionsForSection("shared-transaction",e),(0,s.logServerSideMemoryStorageWarning)(e);var t=this.getStorage(e),r=e.storageKey||f.SHARED_TRANSACTION_STORAGE_NAME;return new l.SavedObject(t,r)}},{key:"getOriginalUriStorage",value:function(e){e=this.getOptionsForSection("original-uri",e),(0,s.logServerSideMemoryStorageWarning)(e);var t=this.getStorage(e),r=e.storageKey||f.ORIGINAL_URI_STORAGE_NAME;return new l.SavedObject(t,r)}}]),d}(s.BaseStorageManager)};var o=n(r(6690)),a=n(r(9728)),i=n(r(1655)),u=n(r(4993)),c=n(r(3808)),s=r(5437),l=r(9927),f=r(1971)},5842:function(){},6488:function(e,t){"use strict";var r;t.TokenKind=void 0,t.isAccessToken=function(e){return e&&e.accessToken},t.isIDToken=function(e){return e&&e.idToken},t.isRefreshToken=function(e){return e&&e.refreshToken},t.isToken=function(e){return!!(e&&(e.accessToken||e.idToken||e.refreshToken)&&Array.isArray(e.scopes))},t.TokenKind=r,function(e){e.ACCESS="accessToken",e.ID="idToken",e.REFRESH="refreshToken"}(r||(t.TokenKind=r={}))},7088:function(e,t){"use strict";t.EVENT_SET_STORAGE=t.EVENT_RENEWED=t.EVENT_REMOVED=t.EVENT_EXPIRED=t.EVENT_ERROR=t.EVENT_ADDED=void 0,t.EVENT_EXPIRED="expired",t.EVENT_RENEWED="renewed",t.EVENT_ADDED="added",t.EVENT_REMOVED="removed",t.EVENT_ERROR="error",t.EVENT_SET_STORAGE="set_storage"},4319:function(e,t,r){"use strict";var n=r(4836);t.isCustomAuthTransactionMeta=c,t.isIdxTransactionMeta=function(e){return!!u(e)&&!!e.interactionHandle},t.isOAuthTransactionMeta=i,t.isPKCETransactionMeta=u,t.isTransactionMeta=function(e){return!(!i(e)&&!c(e))};var o=n(r(8698));function a(e){return!(!e||"object"!==(0,o.default)(e)||0===Object.values(e).length)}function i(e){return!(!a(e)||!e.redirectUri&&!e.responseType)}function u(e){return!!i(e)&&!!e.codeVerifier}function c(e){return!!a(e)&&void 0===Object.values(e).find((function(e){return"string"!=typeof e}))}},6593:function(){},7615:function(){},2740:function(){},8665:function(){},8927:function(e,t,r){"use strict";var n=r(2740);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(5842);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(8741);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var i=r(6370);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}));var u=r(9263);Object.keys(u).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===u[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}}))}));var c=r(195);Object.keys(c).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===c[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return c[e]}}))}));var s=r(6488);Object.keys(s).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===s[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return s[e]}}))}));var l=r(7088);Object.keys(l).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===l[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return l[e]}}))}));var f=r(4319);Object.keys(f).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===f[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return f[e]}}))}));var d=r(6593);Object.keys(d).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===d[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return d[e]}}))}));var p=r(7615);Object.keys(p).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===p[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return p[e]}}))}));var h=r(8665);Object.keys(h).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===h[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return h[e]}}))}))},8741:function(){},6370:function(){},9263:function(){},195:function(){},4970:function(e,t,r){"use strict";t.addListener=o,t.addPostMessageListener=function(e,t,r){var i,u;return new Promise((function(a,c){i=function(t){if(t.data&&t.data.state===r)return t.origin!==e.getIssuerOrigin()?c(new n.AuthSdkError("The request does not match client configuration")):void a(t.data)},o(window,"message",i),u=setTimeout((function(){c(new n.AuthSdkError("OAuth flow timed out"))}),t||12e4)})).finally((function(){clearTimeout(u),a(window,"message",i)}))},t.loadFrame=function(e){var t=document.createElement("iframe");return t.style.display="none",t.src=e,document.body.appendChild(t)},t.loadPopup=function(e,t){var r=t.popupTitle||"External Identity Provider User Authentication";return window.open(e,r,"toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600")},t.removeListener=a;var n=r(5728);function o(e,t,r){e.addEventListener?e.addEventListener(t,r):e.attachEvent("on"+t,r)}function a(e,t,r){e.removeEventListener?e.removeEventListener(t,r):e.detachEvent("on"+t,r)}},5078:function(e,t,r){"use strict";t.getDefaultEnrollAuthenticatorParams=function(e){var t=e.options,r=t.clientId,i=t.redirectUri,u=t.responseMode,c=t.state,s=(0,o.isBrowser)()?window.location.href:void 0;return(0,a.removeNils)({clientId:r,redirectUri:i||s,responseMode:u,state:c||(0,n.generateState)(),responseType:"none",prompt:"enroll_authenticator"})};var n=r(7599),o=r(415),a=r(305)},7756:function(e,t,r){"use strict";t.getDefaultTokenParams=function(e){var t=e.options,r=t.pkce,i=t.clientId,u=t.redirectUri,c=t.responseType,s=t.responseMode,l=t.scopes,f=t.acrValues,d=t.maxAge,p=t.state,h=t.ignoreSignature,v=(0,o.isBrowser)()?window.location.href:void 0;return(0,a.removeNils)({pkce:r,clientId:i,redirectUri:u||v,responseType:c||["token","id_token"],responseMode:s,state:p||(0,n.generateState)(),nonce:(0,n.generateNonce)(),scopes:l||["openid","email"],acrValues:f,maxAge:d,ignoreSignature:h})};var n=r(7599),o=r(415),a=r(305)},8080:function(e,t,r){"use strict";t.createEnrollAuthenticatorMeta=function(e,t){return{issuer:e.options.issuer,urls:(0,n.getOAuthUrls)(e,t),clientId:t.clientId,redirectUri:t.redirectUri,responseType:t.responseType,responseMode:t.responseMode,state:t.state,acrValues:t.acrValues,enrollAmrValues:t.enrollAmrValues}};var n=r(7599)},9912:function(e,t,r){"use strict";t.isAuthorizationCodeError=function(e,t){if("AuthApiError"!==t.name)return!1;var r=t.xhr,n=null==r?void 0:r.responseJSON;return e.options.pkce&&"invalid_grant"===(null==n?void 0:n.error)},t.isInteractionRequiredError=function(e){return"OAuthError"===e.name&&"interaction_required"===e.errorCode},t.isRefreshTokenInvalidError=function(e){return(0,n.isOAuthError)(e)&&"invalid_grant"===e.errorCode&&"The refresh token is invalid or expired."===e.errorSummary};var n=r(5728)},8785:function(e,t,r){"use strict";var n=r(4836),o={pkce:!0};Object.defineProperty(t,"pkce",{enumerable:!0,get:function(){return p.default}});var a=r(4970);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var i=r(7756);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}));var u=r(5078);Object.keys(u).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===u[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}}))}));var c=r(9912);Object.keys(c).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===c[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return c[e]}}))}));var s=r(8221);Object.keys(s).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===s[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return s[e]}}))}));var l=r(7599);Object.keys(l).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===l[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return l[e]}}))}));var f=r(2865);Object.keys(f).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===f[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return f[e]}}))}));var d=r(8080);Object.keys(d).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===d[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return d[e]}}))}));var p=n(r(3611)),h=r(6898);Object.keys(h).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===h[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return h[e]}}))}));var v=r(6757);Object.keys(v).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===v[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return v[e]}}))}));var y=r(6635);Object.keys(y).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===y[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return y[e]}}))}));var g=r(1969);Object.keys(g).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===g[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return g[e]}}))}));var b=r(6003);Object.keys(b).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===b[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return b[e]}}))}));var m=r(2482);Object.keys(m).forEach((function(e){"default"!==e&&"__esModule"!==e&&(Object.prototype.hasOwnProperty.call(o,e)||e in t&&t[e]===m[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return m[e]}}))}))},8221:function(e,t){"use strict";function r(e){return/((id|access)_token=)/i.test(e)}function n(e){return/(code=)/i.test(e)}function o(e){return/(interaction_code=)/i.test(e)}function a(e){return/(error=)/i.test(e)||/(error_description)/i.test(e)}function i(e,t){var r=t.options;return!(!e||!r.redirectUri)&&0===e.indexOf(r.redirectUri)}function u(e){return e.pkce||"code"===e.responseType||"query"===e.responseMode}function c(e){return u(e)&&"fragment"!==e.responseMode?window.location.search:window.location.hash}function s(e){if(!i(window.location.href,e))return!1;var t=u(e.options),s=c(e.options);return!!a(s)||(t?n(s)||o(s):r(window.location.hash))}t.getHashOrSearch=c,t.hasAuthorizationCode=n,t.hasErrorInUrl=a,t.hasInteractionCode=o,t.hasResponseType=function(e,t){return Array.isArray(t.responseType)&&t.responseType.length?t.responseType.indexOf(e)>=0:t.responseType===e},t.hasTokensInHash=r,t.isCodeFlow=u,t.isInteractionRequired=function(e,t){if(!t){if(!s(e))return!1;t=c(e.options)}return/(error=interaction_required)/i.test(t)},t.isLoginRedirect=s,t.isRedirectUri=i},7599:function(e,t,r){"use strict";var n=r(4836);t.generateNonce=function(){return(0,o.genRandomString)(64)},t.generateState=function(){return(0,o.genRandomString)(64)},t.getOAuthBaseUrl=u,t.getOAuthDomain=function(e){return i(e,arguments.length>1&&void 0!==arguments[1]?arguments[1]:{}).split("/oauth2")[0]},t.getOAuthUrls=function(e,t){if(arguments.length>2)throw new a.default('As of version 3.0, "getOAuthUrls" takes only a single set of options');t=t||{};var r=(0,o.removeTrailingSlash)(t.authorizeUrl)||e.options.authorizeUrl,n=i(e,t),c=(0,o.removeTrailingSlash)(t.userinfoUrl)||e.options.userinfoUrl,s=(0,o.removeTrailingSlash)(t.tokenUrl)||e.options.tokenUrl,l=(0,o.removeTrailingSlash)(t.logoutUrl)||e.options.logoutUrl,f=(0,o.removeTrailingSlash)(t.revokeUrl)||e.options.revokeUrl,d=u(e,t);return{issuer:n,authorizeUrl:r=r||d+"/v1/authorize",userinfoUrl:c=c||d+"/v1/userinfo",tokenUrl:s=s||d+"/v1/token",revokeUrl:f=f||d+"/v1/revoke",logoutUrl:l=l||d+"/v1/logout"}};var o=r(305),a=n(r(9123));function i(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return(0,o.removeTrailingSlash)(t.issuer)||e.options.issuer}function u(e){var t=i(e,arguments.length>1&&void 0!==arguments[1]?arguments[1]:{});return t.indexOf("/oauth2")>0?t:t+"/oauth2"}},2865:function(e,t,r){"use strict";var n=r(4836);t.createOAuthMeta=function(e,t){var r={issuer:e.options.issuer,urls:(0,a.getOAuthUrls)(e,t),clientId:t.clientId,redirectUri:t.redirectUri,responseType:t.responseType,responseMode:t.responseMode,scopes:t.scopes,state:t.state,nonce:t.nonce,ignoreSignature:t.ignoreSignature,acrValues:t.acrValues};return!1===t.pkce?r:u(u({},r),{},{codeVerifier:t.codeVerifier,codeChallengeMethod:t.codeChallengeMethod,codeChallenge:t.codeChallenge})};var o=n(r(8416)),a=r(7599);function i(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function u(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?i(Object(r),!0).forEach((function(t){(0,o.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):i(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}},3611:function(e,t,r){"use strict";t.default=void 0;var n=r(9718),o=r(1971);function a(e){return("0"+e.toString(16)).substr(-2)}var i={DEFAULT_CODE_CHALLENGE_METHOD:o.DEFAULT_CODE_CHALLENGE_METHOD,generateVerifier:function(e){var t,r,i=e||"";return i.length<o.MIN_VERIFIER_LENGTH&&(i+=(t=o.MIN_VERIFIER_LENGTH-i.length,r=new Uint8Array(Math.ceil(t/2)),n.webcrypto.getRandomValues(r),Array.from(r,a).join("").slice(0,t))),encodeURIComponent(i).slice(0,o.MAX_VERIFIER_LENGTH)},computeChallenge:function(e){var t=(new TextEncoder).encode(e);return n.webcrypto.subtle.digest("SHA-256",t).then((function(e){var t=String.fromCharCode.apply(null,new Uint8Array(e));return(0,n.stringToBase64Url)(t)}))}};t.default=i,e.exports=t.default},6757:function(e,t,r){"use strict";var n=r(4836);t.prepareEnrollAuthenticatorParams=function(e,t){return function(e){if(!(e=c(c({},e),{},{responseType:"none",prompt:"enroll_authenticator",maxAge:0})).enrollAmrValues)throw new a.AuthSdkError("enroll_amr_values must be specified");if(!e.acrValues)throw new a.AuthSdkError("acr_values must be specified");return delete e.scopes,delete e.nonce,e}(c(c({},(0,i.getDefaultEnrollAuthenticatorParams)(e)),t))};var o=n(r(8416)),a=r(5728),i=r(5078);function u(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function c(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?u(Object(r),!0).forEach((function(t){(0,o.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):u(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}},6898:function(e,t,r){"use strict";var n=r(4836);t.assertPKCESupport=h,t.preparePKCE=g,t.prepareTokenParams=function(e){return m.apply(this,arguments)},t.validateCodeChallengeMethod=v;var o=n(r(4687)),a=n(r(8416)),i=n(r(7156)),u=r(52),c=r(5728),s=r(7756),l=r(1971),f=n(r(3611));function d(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function p(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?d(Object(r),!0).forEach((function(t){(0,a.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):d(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function h(e){if(!e.features.isPKCESupported()){var t="PKCE requires a modern browser with encryption support running in a secure context.";throw e.features.isHTTPS()||(t+="\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."),e.features.hasTextEncoder()||(t+='\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'),new c.AuthSdkError(t)}}function v(e,t){return y.apply(this,arguments)}function y(){return(y=(0,i.default)(o.default.mark((function e(t,r){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return r=r||t.options.codeChallengeMethod||l.DEFAULT_CODE_CHALLENGE_METHOD,e.next=3,(0,u.getWellKnown)(t);case 3:if(-1!==(e.sent.code_challenge_methods_supported||[]).indexOf(r)){e.next=7;break}throw new c.AuthSdkError("Invalid code_challenge_method");case 7:return e.abrupt("return",r);case 8:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function g(e,t){return b.apply(this,arguments)}function b(){return(b=(0,i.default)(o.default.mark((function e(t,r){var n,a,i,u;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(a=(n=r).codeVerifier,i=n.codeChallenge,u=n.codeChallengeMethod,i=i||t.options.codeChallenge){e.next=8;break}return h(t),a=a||f.default.generateVerifier(),e.next=7,f.default.computeChallenge(a);case 7:i=e.sent;case 8:return e.next=10,v(t,u);case 10:return u=e.sent,r=p(p({},r),{},{responseType:"code",codeVerifier:a,codeChallenge:i,codeChallengeMethod:u}),e.abrupt("return",r);case 13:case"end":return e.stop()}}),e)})))).apply(this,arguments)}function m(){return m=(0,i.default)(o.default.mark((function e(t){var r,n,a=arguments;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r=a.length>1&&void 0!==a[1]?a[1]:{},n=(0,s.getDefaultTokenParams)(t),!1!==(r=p(p({},n),r)).pkce){e.next=5;break}return e.abrupt("return",r);case 5:return e.abrupt("return",g(t,r));case 6:case"end":return e.stop()}}),e)}))),m.apply(this,arguments)}},6635:function(e,t,r){"use strict";t.isRefreshTokenError=function(e){return!!(0,n.isAuthApiError)(e)&&(!(!e.xhr||!e.xhr.responseJSON)&&"invalid_grant"===e.xhr.responseJSON.error)},t.isSameRefreshToken=function(e,t){return e.refreshToken===t.refreshToken};var n=r(5728)},3327:function(e,t,r){"use strict";t.clearTransactionFromSharedStorage=function(e,t){var r=e.getSharedTansactionStorage(),n=r.getStorage();delete n[t],r.setStorage(n)},t.loadTransactionFromSharedStorage=function(e,t){var r=e.getSharedTansactionStorage().getStorage()[t];return r&&r.transaction&&(0,n.isTransactionMeta)(r.transaction)?r.transaction:null},t.pruneSharedStorage=function(e){var t=e.getSharedTansactionStorage(),r=t.getStorage();Object.keys(r).forEach((function(e){var t=r[e];Date.now()-t.dateCreated>o&&delete r[e]})),t.setStorage(r)},t.saveTransactionToSharedStorage=function(e,t,r){var n=e.getSharedTansactionStorage(),o=n.getStorage();o[t]={dateCreated:Date.now(),transaction:r},n.setStorage(o)};var n=r(8927),o=18e5},1969:function(e,t){"use strict";t.urlParamsToObject=function(e){var t=/\+/g,r=/([^&=]+)=?([^&]*)/g,n=e||"";"#"===n.charAt(0)&&"/"===n.charAt(1)&&(n=n.substring(2)),"#"!==n.charAt(0)&&"?"!==n.charAt(0)||(n=n.substring(1));for(var o,a={};o=r.exec(n);){var i=o[1],u=o[2];a[i]="id_token"===i||"access_token"===i||"code"===i?u:decodeURIComponent(u.replace(t," "))}return a}},6003:function(e,t,r){"use strict";var n=r(4836);t.validateClaims=function(e,t,r){var n=r.clientId,a=r.issuer,i=r.nonce,u=r.acrValues;if(!t||!a||!n)throw new o.default("The jwt, iss, and aud arguments are all required");if(i&&t.nonce!==i)throw new o.default("OAuth flow response nonce doesn't match request nonce");var c=Math.floor(Date.now()/1e3);if(t.iss!==a)throw new o.default("The issuer ["+t.iss+"] does not match ["+a+"]");if(Array.isArray(t.aud)&&t.aud.indexOf(n)<0||!Array.isArray(t.aud)&&t.aud!==n)throw new o.default("The audience ["+t.aud+"] does not match ["+n+"]");if(u&&t.acr!==u)throw new o.default("The acr ["+t.acr+"] does not match acr_values ["+u+"]");if(t.iat>t.exp)throw new o.default("The JWT expired before it was issued");if(!e.options.ignoreLifetime){if(c-e.options.maxClockSkew>t.exp)throw new o.default("The JWT expired and is no longer valid");if(t.iat>c+e.options.maxClockSkew)throw new o.default("The JWT was issued in the future")}};var o=n(r(9123))},2482:function(e,t,r){"use strict";t.validateToken=function(e,t){if(!(0,o.isIDToken)(e)&&!(0,o.isAccessToken)(e)&&!(0,o.isRefreshToken)(e))throw new n.AuthSdkError("Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property");if("accessToken"===t&&!(0,o.isAccessToken)(e))throw new n.AuthSdkError("invalid accessToken");if("idToken"===t&&!(0,o.isIDToken)(e))throw new n.AuthSdkError("invalid idToken");if("refreshToken"===t&&!(0,o.isRefreshToken)(e))throw new n.AuthSdkError("invalid refreshToken")};var n=r(5728),o=r(8927)},1260:function(e,t,r){"use strict";var n=r(4836),o=r(8698);t.verifyToken=function(e,t,r){return p.apply(this,arguments)};var a=n(r(4687)),i=n(r(7156)),u=r(52),c=r(8785),s=r(5728),l=r(1237),f=function(e,t){if(e&&e.__esModule)return e;if(null===e||"object"!==o(e)&&"function"!=typeof e)return{default:e};var r=d(t);if(r&&r.has(e))return r.get(e);var n={},a=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e)if("default"!==i&&Object.prototype.hasOwnProperty.call(e,i)){var u=a?Object.getOwnPropertyDescriptor(e,i):null;u&&(u.get||u.set)?Object.defineProperty(n,i,u):n[i]=e[i]}return n.default=e,r&&r.set(e,n),n}(r(9718));function d(e){if("function"!=typeof WeakMap)return null;var t=new WeakMap,r=new WeakMap;return(d=function(e){return e?r:t})(e)}function p(){return(p=(0,i.default)(a.default.mark((function e(t,r,n){var o,i,d,p,h,v;return a.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(r&&r.idToken){e.next=2;break}throw new s.AuthSdkError("Only idTokens may be verified");case 2:return o=(0,l.decodeToken)(r.idToken),i=(null==n?void 0:n.issuer)||t.options.issuer,e.next=6,(0,u.getWellKnown)(t,i);case 6:if(d=e.sent,p=d.issuer,h=Object.assign({clientId:t.options.clientId,ignoreSignature:t.options.ignoreSignature},n,{issuer:p}),(0,c.validateClaims)(t,o.payload,h),1!=h.ignoreSignature&&t.features.isTokenVerifySupported()){e.next=12;break}return e.abrupt("return",r);case 12:return e.next=14,(0,u.getKey)(t,r.issuer,o.header.kid);case 14:return v=e.sent,e.next=17,f.verifyToken(r.idToken,v);case 17:if(e.sent){e.next=20;break}throw new s.AuthSdkError("The token signature is not valid");case 20:if(!(n&&n.accessToken&&r.claims.at_hash)){e.next=26;break}return e.next=23,f.getOidcHash(n.accessToken);case 23:if(e.sent===r.claims.at_hash){e.next=26;break}throw new s.AuthSdkError("Token hash verification failed");case 26:return e.abrupt("return",r);case 27:case"end":return e.stop()}}),e)})))).apply(this,arguments)}},2282:function(e,t,r){"use strict";var n=r(4836);t.AutoRenewService=void 0;var o=n(r(4687)),a=n(r(7156)),i=n(r(6690)),u=n(r(9728)),c=n(r(8416)),s=r(5728),l=r(8927),f=r(415),d=function(){function e(t){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(0,i.default)(this,e),(0,c.default)(this,"tokenManager",void 0),(0,c.default)(this,"options",void 0),(0,c.default)(this,"renewTimeQueue",void 0),(0,c.default)(this,"started",!1),this.tokenManager=t,this.options=r,this.renewTimeQueue=[],this.onTokenExpiredHandler=this.onTokenExpiredHandler.bind(this)}var t,r;return(0,u.default)(e,[{key:"shouldThrottleRenew",value:function(){var e=!1;if(this.renewTimeQueue.push(Date.now()),this.renewTimeQueue.length>=10){var t=this.renewTimeQueue.shift();e=this.renewTimeQueue[this.renewTimeQueue.length-1]-t<3e4}return e}},{key:"requiresLeadership",value:function(){return!!this.options.syncStorage&&(0,f.isBrowser)()}},{key:"processExpiredTokens",value:function(){var e=this,t=this.tokenManager.getStorage().getStorage();Object.keys(t).forEach((function(r){var n=t[r];!(0,l.isRefreshToken)(n)&&e.tokenManager.hasExpired(n)&&e.onTokenExpiredHandler(r)}))}},{key:"onTokenExpiredHandler",value:function(e){if(this.options.autoRenew)if(this.shouldThrottleRenew()){var t=new s.AuthSdkError("Too many token renew requests");this.tokenManager.emitError(t)}else this.tokenManager.renew(e).catch((function(){}));else this.options.autoRemove&&this.tokenManager.remove(e)}},{key:"canStart",value:function(){return!(!this.options.autoRenew&&!this.options.autoRemove||this.started)}},{key:"start",value:(r=(0,a.default)(o.default.mark((function e(){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:this.canStart()&&(this.tokenManager.on(l.EVENT_EXPIRED,this.onTokenExpiredHandler),this.tokenManager.isStarted()&&this.processExpiredTokens(),this.started=!0);case 1:case"end":return e.stop()}}),e,this)}))),function(){return r.apply(this,arguments)})},{key:"stop",value:(t=(0,a.default)(o.default.mark((function e(){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:this.started&&(this.tokenManager.off(l.EVENT_EXPIRED,this.onTokenExpiredHandler),this.renewTimeQueue=[],this.started=!1);case 1:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"isStarted",value:function(){return this.started}}]),e}();t.AutoRenewService=d},6748:function(e,t,r){"use strict";var n=r(4836);t.LeaderElectionService=void 0;var o=n(r(4687)),a=n(r(7156)),i=n(r(6690)),u=n(r(9728)),c=n(r(8416)),s=r(8437),l=r(415),f=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};(0,i.default)(this,e),(0,c.default)(this,"options",void 0),(0,c.default)(this,"channel",void 0),(0,c.default)(this,"elector",void 0),(0,c.default)(this,"started",!1),this.options=t,this.onLeaderDuplicate=this.onLeaderDuplicate.bind(this),this.onLeader=this.onLeader.bind(this)}var t,r,n;return(0,u.default)(e,[{key:"onLeaderDuplicate",value:function(){}},{key:"onLeader",value:(n=(0,a.default)(o.default.mark((function e(){var t,r;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,null===(t=(r=this.options).onLeader)||void 0===t?void 0:t.call(r);case 2:case"end":return e.stop()}}),e,this)}))),function(){return n.apply(this,arguments)})},{key:"isLeader",value:function(){var e;return!(null===(e=this.elector)||void 0===e||!e.isLeader)}},{key:"hasLeader",value:function(){var e;return!(null===(e=this.elector)||void 0===e||!e.hasLeader)}},{key:"start",value:(r=(0,a.default)(o.default.mark((function e(){var t;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:this.canStart()&&(t=this.options.electionChannelName,this.channel=new s.BroadcastChannel(t),this.elector=(0,s.createLeaderElection)(this.channel),this.elector.onduplicate=this.onLeaderDuplicate,this.elector.awaitLeadership().then(this.onLeader),this.started=!0);case 1:case"end":return e.stop()}}),e,this)}))),function(){return r.apply(this,arguments)})},{key:"stop",value:(t=(0,a.default)(o.default.mark((function e(){return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.started){e.next=11;break}if(!this.elector){e.next=5;break}return e.next=4,this.elector.die();case 4:this.elector=void 0;case 5:if(!this.channel){e.next=10;break}return this.channel.postInternal=function(){return Promise.resolve()},e.next=9,this.channel.close();case 9:this.channel=void 0;case 10:this.started=!1;case 11:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"requiresLeadership",value:function(){return!1}},{key:"isStarted",value:function(){return this.started}},{key:"canStart",value:function(){return(0,l.isBrowser)()&&!this.started}}]),e}();t.LeaderElectionService=f},5550:function(e,t,r){"use strict";var n=r(4836);t.SyncStorageService=void 0;var o=n(r(4687)),a=n(r(7156)),i=n(r(6690)),u=n(r(9728)),c=n(r(8416)),s=r(8437),l=r(415),f=r(8927),d=r(5728),p=function(){function e(t){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};(0,i.default)(this,e),(0,c.default)(this,"tokenManager",void 0),(0,c.default)(this,"options",void 0),(0,c.default)(this,"channel",void 0),(0,c.default)(this,"started",!1),(0,c.default)(this,"enablePostMessage",!0),this.tokenManager=t,this.options=r,this.onTokenAddedHandler=this.onTokenAddedHandler.bind(this),this.onTokenRemovedHandler=this.onTokenRemovedHandler.bind(this),this.onTokenRenewedHandler=this.onTokenRenewedHandler.bind(this),this.onSetStorageHandler=this.onSetStorageHandler.bind(this),this.onSyncMessageHandler=this.onSyncMessageHandler.bind(this)}var t,r;return(0,u.default)(e,[{key:"requiresLeadership",value:function(){return!1}},{key:"isStarted",value:function(){return this.started}},{key:"canStart",value:function(){return!!this.options.syncStorage&&(0,l.isBrowser)()&&!this.started}},{key:"start",value:(r=(0,a.default)(o.default.mark((function e(){var t;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(this.canStart()){e.next=2;break}return e.abrupt("return");case 2:t=this.options.syncChannelName,e.prev=3,this.channel=new s.BroadcastChannel(t),e.next=10;break;case 7:throw e.prev=7,e.t0=e.catch(3),new d.AuthSdkError("SyncStorageService is not supported in current browser.");case 10:this.tokenManager.on(f.EVENT_ADDED,this.onTokenAddedHandler),this.tokenManager.on(f.EVENT_REMOVED,this.onTokenRemovedHandler),this.tokenManager.on(f.EVENT_RENEWED,this.onTokenRenewedHandler),this.tokenManager.on(f.EVENT_SET_STORAGE,this.onSetStorageHandler),this.channel.addEventListener("message",this.onSyncMessageHandler),this.started=!0;case 16:case"end":return e.stop()}}),e,this,[[3,7]])}))),function(){return r.apply(this,arguments)})},{key:"stop",value:(t=(0,a.default)(o.default.mark((function e(){var t,r;return o.default.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:if(!this.started){e.next=10;break}return this.tokenManager.off(f.EVENT_ADDED,this.onTokenAddedHandler),this.tokenManager.off(f.EVENT_REMOVED,this.onTokenRemovedHandler),this.tokenManager.off(f.EVENT_RENEWED,this.onTokenRenewedHandler),this.tokenManager.off(f.EVENT_SET_STORAGE,this.onSetStorageHandler),null===(t=this.channel)||void 0===t||t.removeEventListener("message",this.onSyncMessageHandler),e.next=8,null===(r=this.channel)||void 0===r?void 0:r.close();case 8:this.channel=void 0,this.started=!1;case 10:case"end":return e.stop()}}),e,this)}))),function(){return t.apply(this,arguments)})},{key:"onTokenAddedHandler",value:function(e,t){var r;this.enablePostMessage&&(null===(r=this.channel)||void 0===r||r.postMessage({type:f.EVENT_ADDED,key:e,token:t}))}},{key:"onTokenRemovedHandler",value:function(e,t){var r;this.enablePostMessage&&(null===(r=this.channel)||void 0===r||r.postMessage({type:f.EVENT_REMOVED,key:e,token:t}))}},{key:"onTokenRenewedHandler",value:function(e,t,r){var n;this.enablePostMessage&&(null===(n=this.channel)||void 0===n||n.postMessage({type:f.EVENT_RENEWED,key:e,token:t,oldToken:r}))}},{key:"onSetStorageHandler",value:function(e){var t;null===(t=this.channel)||void 0===t||t.postMessage({type:f.EVENT_SET_STORAGE,storage:e})}},{key:"onSyncMessageHandler",value:function(e){switch(this.enablePostMessage=!1,e.type){case f.EVENT_SET_STORAGE:this.tokenManager.getStorage().setStorage(e.storage);break;case f.EVENT_ADDED:this.tokenManager.emitAdded(e.key,e.token),this.tokenManager.setExpireEventTimeout(e.key,e.token);break;case f.EVENT_REMOVED:this.tokenManager.clearExpireEventTimeout(e.key),this.tokenManager.emitRemoved(e.key,e.token);break;case f.EVENT_RENEWED:this.tokenManager.emitRenewed(e.key,e.token,e.oldToken)}this.enablePostMessage=!0}}]),e}();t.SyncStorageService=p},2604:function(e,t,r){"use strict";var n=r(2282);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(5550);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(6748);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}))},3719:function(e,t,r){"use strict";t.closeSession=function(e){return(0,o.httpRequest)(e,{url:e.getIssuerOrigin()+"/api/v1/sessions/me",method:"DELETE",withCredentials:!0})},t.getSession=function(e){return(0,o.get)(e,"/api/v1/sessions/me",{withCredentials:!0}).then((function(t){var r=(0,n.omit)(t,"_links");return r.refresh=function(){return(0,o.post)(e,(0,n.getLink)(t,"refresh").href,{},{withCredentials:!0})},r.user=function(){return(0,o.get)(e,(0,n.getLink)(t,"user").href,{withCredentials:!0})},r})).catch((function(){return{status:"INACTIVE"}}))},t.refreshSession=function(e){return(0,o.post)(e,"/api/v1/sessions/me/lifecycle/refresh",{},{withCredentials:!0})},t.sessionExists=function(e){return e.session.get().then((function(e){return"ACTIVE"===e.status})).catch((function(){return!1}))},t.setCookieAndRedirect=function(e,t,r){r=r||window.location.href,window.location.assign(e.getIssuerOrigin()+"/login/sessionCookieRedirect"+(0,n.toQueryString)({checkAccountSetupComplete:!0,token:t,redirectUrl:r}))};var n=r(305),o=r(4777)},2815:function(e,t,r){"use strict";t.createSessionApi=function(e){return{close:n.closeSession.bind(null,e),exists:n.sessionExists.bind(null,e),get:n.getSession.bind(null,e),refresh:n.refreshSession.bind(null,e),setCookieAndRedirect:n.setCookieAndRedirect.bind(null,e)}};var n=r(3719)},8041:function(e,t,r){"use strict";var n=r(3719);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(2815);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(3980);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var i=r(1249);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}))},3980:function(e,t,r){"use strict";var n=r(4836);t.mixinSession=function(e){return function(e){(0,s.default)(h,e);var t,r,n=(t=h,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,f.default)(t);if(r){var o=(0,f.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,l.default)(this,e)});function h(){var e;(0,i.default)(this,h);for(var t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return e=n.call.apply(n,[this].concat(r)),(0,d.default)((0,c.default)(e),"session",void 0),e.session=(0,p.createSessionApi)((0,c.default)(e)),e}return(0,u.default)(h,[{key:"closeSession",value:function(){var e=this;return this.session.close().then((0,a.default)(o.default.mark((function t(){return o.default.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return e.clearStorage(),t.abrupt("return",!0);case 2:case"end":return t.stop()}}),t)})))).catch((function(e){if("AuthApiError"===e.name&&"E0000007"===e.errorCode)return!1;throw e}))}}]),h}(e)};var o=n(r(4687)),a=n(r(7156)),i=n(r(6690)),u=n(r(9728)),c=n(r(6115)),s=n(r(1655)),l=n(r(4993)),f=n(r(3808)),d=n(r(8416)),p=r(2815)},1249:function(){},5437:function(e,t,r){"use strict";var n=r(4836);t.BaseStorageManager=void 0,t.logServerSideMemoryStorageWarning=f;var o=n(r(6690)),a=n(r(9728)),i=n(r(8416)),u=r(1971),c=r(5763),s=r(415),l=r(305);function f(e){(0,s.isBrowser)()||e.storageProvider||e.storageKey||(0,l.warn)("Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.")}var d=function(){function e(t,r,n){(0,o.default)(this,e),(0,i.default)(this,"storageManagerOptions",void 0),(0,i.default)(this,"cookieOptions",void 0),(0,i.default)(this,"storageUtil",void 0),this.storageManagerOptions=t,this.cookieOptions=r,this.storageUtil=n}return(0,a.default)(e,[{key:"getOptionsForSection",value:function(e,t){return Object.assign({},this.storageManagerOptions[e],t)}},{key:"getStorage",value:function(e){if((e=Object.assign({},this.cookieOptions,e)).storageProvider)return e.storageProvider;var t=e,r=t.storageType,n=t.storageTypes;if("sessionStorage"===r&&(e.sessionCookie=!0),r&&n){var o=n.indexOf(r);o>=0&&(n=n.slice(o),r=void 0)}return r||(r=this.storageUtil.findStorageType(n)),this.storageUtil.getStorageByType(r,e)}},{key:"getTokenStorage",value:function(e){f(e=this.getOptionsForSection("token",e));var t=this.getStorage(e),r=e.storageKey||u.TOKEN_STORAGE_NAME;return new c.SavedObject(t,r)}},{key:"getHttpCache",value:function(e){e=this.getOptionsForSection("cache",e);var t=this.getStorage(e),r=e.storageKey||u.CACHE_STORAGE_NAME;return new c.SavedObject(t,r)}}]),e}();t.BaseStorageManager=d},5763:function(e,t,r){"use strict";var n=r(4836);t.SavedObject=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(8416)),u=n(r(9123)),c=function(){function e(t,r){if((0,o.default)(this,e),(0,i.default)(this,"storageProvider",void 0),(0,i.default)(this,"storageName",void 0),!t)throw new u.default('"storage" is required');if("string"!=typeof r||!r.length)throw new u.default('"storageName" is required');this.storageName=r,this.storageProvider=t}return(0,a.default)(e,[{key:"getItem",value:function(e){return this.getStorage()[e]}},{key:"setItem",value:function(e,t){return this.updateStorage(e,t)}},{key:"removeItem",value:function(e){return this.clearStorage(e)}},{key:"getStorage",value:function(){var e=this.storageProvider.getItem(this.storageName);e=e||"{}";try{return JSON.parse(e)}catch(e){throw new u.default("Unable to parse storage string: "+this.storageName)}}},{key:"setStorage",value:function(e){try{var t=e?JSON.stringify(e):"{}";this.storageProvider.setItem(this.storageName,t)}catch(e){throw new u.default("Unable to set storage: "+this.storageName)}}},{key:"clearStorage",value:function(e){if(e){var t=this.getStorage();delete t[e],this.setStorage(t)}else this.storageProvider.removeItem?this.storageProvider.removeItem(this.storageName):this.setStorage()}},{key:"updateStorage",value:function(e,t){var r=this.getStorage();r[e]=t,this.setStorage(r)}}]),e}();t.SavedObject=c},9927:function(e,t,r){"use strict";var n=r(4863);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(5437);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(265);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var i=r(5763);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}));var u=r(5752);Object.keys(u).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===u[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}}))}))},265:function(e,t,r){"use strict";var n=r(4836);t.mixinStorage=function(e,t){return function(e){(0,u.default)(d,e);var r,n,f=(r=d,n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,t=(0,s.default)(r);if(n){var o=(0,s.default)(this).constructor;e=Reflect.construct(t,arguments,o)}else e=t.apply(this,arguments);return(0,c.default)(this,e)});function d(){var e;(0,o.default)(this,d);for(var r=arguments.length,n=new Array(r),a=0;a<r;a++)n[a]=arguments[a];e=f.call.apply(f,[this].concat(n)),(0,l.default)((0,i.default)(e),"storageManager",void 0);var u=e.options,c=u.storageManager,s=u.cookies,p=u.storageUtil;return e.storageManager=new t(c,s,p),e}return(0,a.default)(d,[{key:"clearStorage",value:function(){}}]),d}(e)};var o=n(r(6690)),a=n(r(9728)),i=n(r(6115)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416))},4863:function(e,t,r){"use strict";var n=r(4836);t.createStorageOptionsConstructor=function(){return function(e){(0,u.default)(f,e);var t,r,n=(t=f,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=(0,s.default)(t);if(r){var o=(0,s.default)(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return(0,c.default)(this,e)});function f(e){var t;return(0,a.default)(this,f),t=n.call(this,e),(0,l.default)((0,i.default)(t),"cookies",void 0),(0,l.default)((0,i.default)(t),"storageUtil",void 0),(0,l.default)((0,i.default)(t),"storageManager",void 0),t.cookies=(0,d.getCookieSettings)(e,(0,p.isHTTPS)()),t.storageUtil=e.storageUtil||(0,d.getStorage)(),t.storageManager=v(v({},d.STORAGE_MANAGER_OPTIONS),e.storageManager),t}return(0,o.default)(f)}((0,f.createBaseOptionsConstructor)())};var o=n(r(9728)),a=n(r(6690)),i=n(r(6115)),u=n(r(1655)),c=n(r(4993)),s=n(r(3808)),l=n(r(8416)),f=r(3306),d=r(8009),p=r(415);function h(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function v(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?h(Object(r),!0).forEach((function(t){(0,l.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):h(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}},8009:function(e,t,r){"use strict";var n=r(4836);t.STORAGE_MANAGER_OPTIONS=void 0,t.getCookieSettings=function(){var e=arguments.length>1?arguments[1]:void 0,t=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).cookies||{};return void 0===t.secure&&(t.secure=e),void 0===t.sameSite&&(t.sameSite=t.secure?"none":"lax"),t.secure&&!e&&((0,o.warn)('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'),t.secure=!1),"none"!==t.sameSite||t.secure||(t.sameSite="lax"),t},t.getStorage=function(){return Object.assign({},a.default,{inMemoryStore:{}})};var o=r(305),a=n(r(5407));t.STORAGE_MANAGER_OPTIONS={token:{storageTypes:["localStorage","sessionStorage","cookie"]},cache:{storageTypes:["localStorage","sessionStorage","cookie"]},transaction:{storageTypes:["sessionStorage","localStorage","cookie"]},"shared-transaction":{storageTypes:["localStorage"]},"original-uri":{storageTypes:["localStorage"]}}},5752:function(){},3548:function(e,t,r){"use strict";var n=r(4836);t.PromiseQueue=void 0;var o=n(r(6690)),a=n(r(9728)),i=n(r(8416)),u=r(4771),c=r(146),s=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{quiet:!1};(0,o.default)(this,e),(0,i.default)(this,"queue",void 0),(0,i.default)(this,"running",void 0),(0,i.default)(this,"options",void 0),this.queue=[],this.running=!1,this.options=t}return(0,a.default)(e,[{key:"push",value:function(e,t){for(var r=this,n=arguments.length,o=new Array(n>2?n-2:0),a=2;a<n;a++)o[a-2]=arguments[a];return new Promise((function(n,a){r.queue.length>0&&!1!==r.options.quiet&&(0,c.warn)("Async method is being called but another async method is already running. The new method will be delayed until the previous method completes."),r.queue.push({method:e,thisObject:t,args:o,resolve:n,reject:a}),r.run()}))}},{key:"run",value:function(){var e=this;if(!this.running&&0!==this.queue.length){this.running=!0;var t=this.queue.shift(),r=t.method.apply(t.thisObject,t.args);(0,u.isPromise)(r)?r.then(t.resolve,t.reject).finally((function(){e.running=!1,e.run()})):(t.resolve(r),this.running=!1,this.run())}}}]),e}();t.PromiseQueue=s},146:function(e,t){"use strict";function r(){return"undefined"!=typeof window?window.console:"undefined"!=typeof console?console:void 0}function n(){var e=r();return e&&e.log?e:{log:function(){},warn:function(){},group:function(){},groupEnd:function(){}}}function o(e){n().warn("[okta-auth-sdk] DEPRECATION: "+e)}t.deprecate=o,t.deprecateWrap=function(e,t){return function(){return o(e),t.apply(null,arguments)}},t.getConsole=n,t.getNativeConsole=r,t.warn=function(e){n().warn("[okta-auth-sdk] WARN: "+e)}},305:function(e,t,r){"use strict";var n=r(146);Object.keys(n).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===n[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return n[e]}}))}));var o=r(8750);Object.keys(o).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===o[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return o[e]}}))}));var a=r(3193);Object.keys(a).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===a[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return a[e]}}))}));var i=r(3548);Object.keys(i).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===i[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return i[e]}}))}));var u=r(4771);Object.keys(u).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===u[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return u[e]}}))}));var c=r(6718);Object.keys(c).forEach((function(e){"default"!==e&&"__esModule"!==e&&(e in t&&t[e]===c[e]||Object.defineProperty(t,e,{enumerable:!0,get:function(){return c[e]}}))}))},4734:function(e,t,r){"use strict";var n=r(4836);t.jsonpath=function(e){return(0,a.JSONPath)(function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?i(Object(r),!0).forEach((function(t){(0,o.default)(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):i(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}({preventEval:!0},e))};var o=n(r(8416)),a=r(5883);function i(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}},8750:function(e,t){"use strict";t.delay=function(e){return new Promise((function(t){setTimeout(t,e)}))},t.genRandomString=function(e){for(var t="",r=0;r<e;++r)t+="abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"[Math.floor(61*Math.random())];return t},t.isoToUTCString=function(e){var t=e.match(/\d+/g),r=Date.UTC(t[0],t[1]-1,t[2],t[3],t[4],t[5]);return new Date(r).toUTCString()},t.split2=function(e,t){var r=e.split(t);return[r[0],r.splice(1,r.length).join(t)]}},3193:function(e,t){"use strict";function r(e){if(e){var t=JSON.stringify(e);if(t)return JSON.parse(t)}return e}t.bind=function(e,t){var r=Array.prototype.slice.call(arguments,2);return function(){var n=Array.prototype.slice.call(arguments);return n=r.concat(n),e.apply(t,n)}},t.clone=r,t.extend=function(){var e=arguments[0];return[].slice.call(arguments,1).forEach((function(t){for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&void 0!==t[r]&&(e[r]=t[r])})),e},t.find=function(e,t){for(var r=e.length;r--;){var n=e[r],o=!0;for(var a in t)if(Object.prototype.hasOwnProperty.call(t,a)&&n[a]!==t[a]){o=!1;break}if(o)return n}},t.getLink=function(e,t,n){if(e&&e._links){var o=r(e._links[t]);return o&&o.name&&n?o.name===n?o:void 0:o}},t.omit=function(e){for(var t={},n=arguments.length,o=new Array(n>1?n-1:0),a=1;a<n;a++)o[a-1]=arguments[a];for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&-1==o.indexOf(i)&&(t[i]=e[i]);return r(t)},t.removeNils=function(e){var t={};for(var r in e)if(Object.prototype.hasOwnProperty.call(e,r)){var n=e[r];null!=n&&(t[r]=n)}return t}},4771:function(e,t){"use strict";t.isFunction=function(e){return!!e&&"[object Function]"==={}.toString.call(e)},t.isNumber=function(e){return"[object Number]"===Object.prototype.toString.call(e)},t.isObject=function(e){return"[object Object]"===Object.prototype.toString.call(e)},t.isPromise=function(e){return e&&e.finally&&"function"==typeof e.finally},t.isString=function(e){return"[object String]"===Object.prototype.toString.call(e)}},6718:function(e,t){"use strict";function r(e){return/^[a-z][a-z0-9+.-]*:/i.test(e)}function n(e){if(e){var t=e.replace(/^\s+|\s+$/gm,"");return t.replace(/\/+$/,"")}}t.isAbsoluteUrl=r,t.removeTrailingSlash=n,t.toAbsoluteUrl=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1?arguments[1]:void 0;return r(e)?e:(t=n(t),"/"===e[0]?"".concat(t).concat(e):"".concat(t,"/").concat(e))},t.toQueryString=function(e){var t=[];if(null!==e)for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&void 0!==e[r]&&null!==e[r]&&t.push(r+"="+encodeURIComponent(e[r]));return t.length?"?"+t.join("&"):""},t.toRelativeUrl=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1?arguments[1]:void 0;return r(e)&&(e=e.substring(t.length)),"/"===e[0]?e:"/".concat(e)}},3615:function(e,t,r){"use strict";var n=r(6690),o=r(9728),a=r(1655),i=r(4993),u=r(3808);function c(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}var s=function(e){a(s,e);var t,r,c=(t=s,r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}(),function(){var e,n=u(t);if(r){var o=u(this).constructor;e=Reflect.construct(n,arguments,o)}else e=n.apply(this,arguments);return i(this,e)});function s(e){var t;return n(this,s),(t=c.call(this,e||"Promise was canceled")).name="CancelError",t}return o(s,[{key:"isCanceled",get:function(){return!0}}]),s}(r(3496)(Error)),l=function(){function e(t){var r=this;n(this,e),this._cancelHandlers=[],this._isPending=!0,this._isCanceled=!1,this._rejectOnCancel=!0,this._promise=new Promise((function(e,n){r._reject=n;var o=function(e){if(!r._isPending)throw new Error("The `onCancel` handler was attached after the promise settled.");r._cancelHandlers.push(e)};return Object.defineProperties(o,{shouldReject:{get:function(){return r._rejectOnCancel},set:function(e){r._rejectOnCancel=e}}}),t((function(t){r._isCanceled&&o.shouldReject||(r._isPending=!1,e(t))}),(function(e){r._isPending=!1,n(e)}),o)}))}return o(e,[{key:"then",value:function(e,t){return this._promise.then(e,t)}},{key:"catch",value:function(e){return this._promise.catch(e)}},{key:"finally",value:function(e){return this._promise.finally(e)}},{key:"cancel",value:function(e){if(this._isPending&&!this._isCanceled){if(this._isCanceled=!0,this._cancelHandlers.length>0)try{var t,r=function(e,t){var r="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!r){if(Array.isArray(e)||(r=function(e,t){if(e){if("string"==typeof e)return c(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?c(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){r&&(e=r);var n=0,o=function(){};return{s:o,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,i=!0,u=!1;return{s:function(){r=r.call(e)},n:function(){var e=r.next();return i=e.done,e},e:function(e){u=!0,a=e},f:function(){try{i||null==r.return||r.return()}finally{if(u)throw a}}}}(this._cancelHandlers);try{for(r.s();!(t=r.n()).done;)(0,t.value)()}catch(e){r.e(e)}finally{r.f()}}catch(e){return void this._reject(e)}this._rejectOnCancel&&this._reject(new s(e))}}},{key:"isCanceled",get:function(){return this._isCanceled}}],[{key:"fn",value:function(t){return function(){for(var r=arguments.length,n=new Array(r),o=0;o<r;o++)n[o]=arguments[o];return new e((function(e,r,o){n.push(o),t.apply(void 0,n).then(e,r)}))}}}]),e}();Object.setPrototypeOf(l.prototype,Promise.prototype),e.exports=l,e.exports.CancelError=s},8991:function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.OPEN_BROADCAST_CHANNELS=t.BroadcastChannel=void 0,t.clearNodeFolder=function(e){e=(0,a.fillOptionsWithDefaults)(e);var t=(0,o.chooseMethod)(e);return"node"===t.type?t.clearNodeFolder().then((function(){return!0})):n.PROMISE_RESOLVED_FALSE},t.enforceOptions=function(e){u=e};var n=r(6202),o=r(4632),a=r(423),i=new Set;t.OPEN_BROADCAST_CHANNELS=i;var u,c=0,s=function(e,t){var r,s;this.id=c++,i.add(this),this.name=e,u&&(t=u),this.options=(0,a.fillOptionsWithDefaults)(t),this.method=(0,o.chooseMethod)(this.options),this._iL=!1,this._onML=null,this._addEL={message:[],internal:[]},this._uMP=new Set,this._befC=[],this._prepP=null,s=(r=this).method.create(r.name,r.options),(0,n.isPromise)(s)?(r._prepP=s,s.then((function(e){r._state=e}))):r._state=s};function l(e,t,r){var o={time:e.method.microSeconds(),type:t,data:r};return(e._prepP?e._prepP:n.PROMISE_RESOLVED_VOID).then((function(){var t=e.method.postMessage(e._state,o);return e._uMP.add(t),t.catch().then((function(){return e._uMP.delete(t)})),t}))}function f(e){return e._addEL.message.length>0||e._addEL.internal.length>0}function d(e,t,r){e._addEL[t].push(r),function(e){if(!e._iL&&f(e)){var t=function(t){e._addEL[t.type].forEach((function(e){var r=e.time-1e5;t.time>=r&&e.fn(t.data)}))},r=e.method.microSeconds();e._prepP?e._prepP.then((function(){e._iL=!0,e.method.onMessage(e._state,t,r)})):(e._iL=!0,e.method.onMessage(e._state,t,r))}}(e)}function p(e,t,r){e._addEL[t]=e._addEL[t].filter((function(e){return e!==r})),function(e){if(e._iL&&!f(e)){e._iL=!1;var t=e.method.microSeconds();e.method.onMessage(e._state,null,t)}}(e)}t.BroadcastChannel=s,s._pubkey=!0,s.prototype={postMessage:function(e){if(this.closed)throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed "+JSON.stringify(e));return l(this,"message",e)},postInternal:function(e){return l(this,"internal",e)},set onmessage(e){var t={time:this.method.microSeconds(),fn:e};p(this,"message",this._onML),e&&"function"==typeof e?(this._onML=t,d(this,"message",t)):this._onML=null},addEventListener:function(e,t){d(this,e,{time:this.method.microSeconds(),fn:t})},removeEventListener:function(e,t){p(this,e,this._addEL[e].find((function(e){return e.fn===t})))},close:function(){var e=this;if(!this.closed){i.delete(this),this.closed=!0;var t=this._prepP?this._prepP:n.PROMISE_RESOLVED_VOID;return this._onML=null,this._addEL.message=[],t.then((function(){return Promise.all(Array.from(e._uMP))})).then((function(){return Promise.all(e._befC.map((function(e){return e()})))})).then((function(){return e.method.close(e._state)}))}},get type(){return this.method.type},get isClosed(){return this.closed}}},8437:function(e,t,r){"use strict";var n=r(5585);e.exports={BroadcastChannel:n.BroadcastChannel,createLeaderElection:n.createLeaderElection,clearNodeFolder:n.clearNodeFolder,enforceOptions:n.enforceOptions,beLeader:n.beLeader}},5585:function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),Object.defineProperty(t,"BroadcastChannel",{enumerable:!0,get:function(){return n.BroadcastChannel}}),Object.defineProperty(t,"OPEN_BROADCAST_CHANNELS",{enumerable:!0,get:function(){return n.OPEN_BROADCAST_CHANNELS}}),Object.defineProperty(t,"beLeader",{enumerable:!0,get:function(){return a.beLeader}}),Object.defineProperty(t,"clearNodeFolder",{enumerable:!0,get:function(){return n.clearNodeFolder}}),Object.defineProperty(t,"createLeaderElection",{enumerable:!0,get:function(){return o.createLeaderElection}}),Object.defineProperty(t,"enforceOptions",{enumerable:!0,get:function(){return n.enforceOptions}});var n=r(8991),o=r(6550),a=r(4781)},4781:function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.beLeader=function(e){e.isLeader=!0,e._hasLeader=!0;var t=(0,n.add)((function(){return e.die()}));e._unl.push(t);var r=function(t){"leader"===t.context&&"apply"===t.action&&o(e,"tell"),"leader"!==t.context||"tell"!==t.action||e._dpLC||(e._dpLC=!0,e._dpL(),o(e,"tell"))};return e.broadcastChannel.addEventListener("internal",r),e._lstns.push(r),o(e,"tell")},t.sendLeaderMessage=o;var n=r(4810);function o(e,t){var r={context:"leader",action:t,token:e.token};return e.broadcastChannel.postInternal(r)}},683:function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.LeaderElectionWebLock=void 0;var n=r(6202),o=r(4781),a=function(e,t){var r=this;this.broadcastChannel=e,e._befC.push((function(){return r.die()})),this._options=t,this.isLeader=!1,this.isDead=!1,this.token=(0,n.randomToken)(),this._lstns=[],this._unl=[],this._dpL=function(){},this._dpLC=!1,this._wKMC={},this.lN="pubkey-bc||"+e.method.type+"||"+e.name};t.LeaderElectionWebLock=a,a.prototype={hasLeader:function(){var e=this;return navigator.locks.query().then((function(t){var r=t.held?t.held.filter((function(t){return t.name===e.lN})):[];return!!(r&&r.length>0)}))},awaitLeadership:function(){var e=this;if(!this._wLMP){this._wKMC.c=new AbortController;var t=new Promise((function(t,r){e._wKMC.res=t,e._wKMC.rej=r}));this._wLMP=new Promise((function(r){navigator.locks.request(e.lN,{signal:e._wKMC.c.signal},(function(){return e._wKMC.c=void 0,(0,o.beLeader)(e),r(),t})).catch((function(){}))}))}return this._wLMP},set onduplicate(e){},die:function(){var e=this;return this._lstns.forEach((function(t){return e.broadcastChannel.removeEventListener("internal",t)})),this._lstns=[],this._unl.forEach((function(e){return e.remove()})),this._unl=[],this.isLeader&&(this.isLeader=!1),this.isDead=!0,this._wKMC.res&&this._wKMC.res(),this._wKMC.c&&this._wKMC.c.abort("LeaderElectionWebLock.die() called"),(0,o.sendLeaderMessage)(this,"death")}}},6550:function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.createLeaderElection=function(e,t){if(e._leaderElector)throw new Error("BroadcastChannel already has a leader-elector");t=function(e,t){return e||(e={}),(e=JSON.parse(JSON.stringify(e))).fallbackInterval||(e.fallbackInterval=3e3),e.responseTime||(e.responseTime=t.method.averageResponseTime(t.options)),e}(t,e);var r=(0,n.supportsWebLockAPI)()?new a.LeaderElectionWebLock(e,t):new i(e,t);return e._befC.push((function(){return r.die()})),e._leaderElector=r,r};var n=r(6202),o=r(4781),a=r(683),i=function(e,t){var r=this;this.broadcastChannel=e,this._options=t,this.isLeader=!1,this._hasLeader=!1,this.isDead=!1,this.token=(0,n.randomToken)(),this._aplQ=n.PROMISE_RESOLVED_VOID,this._aplQC=0,this._unl=[],this._lstns=[],this._dpL=function(){},this._dpLC=!1;var o=function(e){"leader"===e.context&&("death"===e.action&&(r._hasLeader=!1),"tell"===e.action&&(r._hasLeader=!0))};this.broadcastChannel.addEventListener("internal",o),this._lstns.push(o)};i.prototype={hasLeader:function(){return Promise.resolve(this._hasLeader)},applyOnce:function(e){var t=this;return this.isLeader?(0,n.sleep)(0,!0):this.isDead?(0,n.sleep)(0,!1):this._aplQC>1?this._aplQ:(this._aplQC=this._aplQC+1,this._aplQ=this._aplQ.then((function(){return function(){if(t.isLeader)return n.PROMISE_RESOLVED_TRUE;var r,a=!1,i=new Promise((function(e){r=function(){a=!0,e()}})),u=function(e){"leader"===e.context&&e.token!=t.token&&("apply"===e.action&&e.token>t.token&&r(),"tell"===e.action&&(r(),t._hasLeader=!0))};t.broadcastChannel.addEventListener("internal",u);var c=e?4*t._options.responseTime:t._options.responseTime;return(0,o.sendLeaderMessage)(t,"apply").then((function(){return Promise.race([(0,n.sleep)(c),i.then((function(){return Promise.reject(new Error)}))])})).then((function(){return(0,o.sendLeaderMessage)(t,"apply")})).then((function(){return Promise.race([(0,n.sleep)(c),i.then((function(){return Promise.reject(new Error)}))])})).catch((function(){})).then((function(){return t.broadcastChannel.removeEventListener("internal",u),!a&&(0,o.beLeader)(t).then((function(){return!0}))}))}()})).then((function(){t._aplQC=t._aplQC-1})),this._aplQ.then((function(){return t.isLeader})))},awaitLeadership:function(){return this._aLP||(this._aLP=(e=this).isLeader?n.PROMISE_RESOLVED_VOID:new Promise((function(t){var r=!1;function o(){r||(r=!0,e.broadcastChannel.removeEventListener("internal",a),t(!0))}e.applyOnce().then((function(){e.isLeader&&o()})),function t(){return(0,n.sleep)(e._options.fallbackInterval).then((function(){if(!e.isDead&&!r)return e.isLeader?void o():e.applyOnce(!0).then((function(){e.isLeader?o():t()}))}))}();var a=function(t){"leader"===t.context&&"death"===t.action&&(e._hasLeader=!1,e.applyOnce().then((function(){e.isLeader&&o()})))};e.broadcastChannel.addEventListener("internal",a),e._lstns.push(a)}))),this._aLP;var e},set onduplicate(e){this._dpL=e},die:function(){var e=this;return this._lstns.forEach((function(t){return e.broadcastChannel.removeEventListener("internal",t)})),this._lstns=[],this._unl.forEach((function(e){return e.remove()})),this._unl=[],this.isLeader&&(this._hasLeader=!1,this.isLeader=!1),this.isDead=!0,(0,o.sendLeaderMessage)(this,"death")}}},4632:function(e,t,r){"use strict";r(3762),Object.defineProperty(t,"__esModule",{value:!0}),t.chooseMethod=function(e){var t=[].concat(e.methods,u).filter(Boolean);if(e.type){if("simulate"===e.type)return i.SimulateMethod;var r=t.find((function(t){return t.type===e.type}));if(r)return r;throw new Error("method-type "+e.type+" not found")}e.webWorkerSupport||(t=t.filter((function(e){return"idb"!==e.type})));var n=t.find((function(e){return e.canBeUsed()}));if(n)return n;throw new Error("No usable method found in "+JSON.stringify(u.map((function(e){return e.type}))))};var n=r(2026),o=r(9122),a=r(4924),i=r(1574),u=[n.NativeMethod,o.IndexedDBMethod,a.LocalstorageMethod]},9122:function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.TRANSACTION_SETTINGS=t.IndexedDBMethod=void 0,t.averageResponseTime=S,t.canBeUsed=P,t.cleanOldMessages=g,t.close=k,t.commitIndexedDBTransaction=f,t.create=b,t.createDatabase=d,t.getAllMessages=function(e){var t=e.transaction(c,"readonly",s),r=t.objectStore(c),n=[];return new Promise((function(e){r.openCursor().onsuccess=function(r){var o=r.target.result;o?(n.push(o.value),o.continue()):(f(t),e(n))}}))},t.getIdb=l,t.getMessagesHigherThan=h,t.getOldMessages=y,t.microSeconds=void 0,t.onMessage=E,t.postMessage=w,t.removeMessagesById=v,t.type=void 0,t.writeMessage=p;var n=r(6202),o=r(2151),a=r(423),i=n.microSeconds;t.microSeconds=i;var u="pubkey.broadcast-channel-0-",c="messages",s={durability:"relaxed"};function l(){if("undefined"!=typeof indexedDB)return indexedDB;if("undefined"!=typeof window){if(void 0!==window.mozIndexedDB)return window.mozIndexedDB;if(void 0!==window.webkitIndexedDB)return window.webkitIndexedDB;if(void 0!==window.msIndexedDB)return window.msIndexedDB}return!1}function f(e){e.commit&&e.commit()}function d(e){var t=l(),r=u+e,n=t.open(r);return n.onupgradeneeded=function(e){e.target.result.createObjectStore(c,{keyPath:"id",autoIncrement:!0})},new Promise((function(e,t){n.onerror=function(e){return t(e)},n.onsuccess=function(){e(n.result)}}))}function p(e,t,r){var n={uuid:t,time:(new Date).getTime(),data:r},o=e.transaction([c],"readwrite",s);return new Promise((function(e,t){o.oncomplete=function(){return e()},o.onerror=function(e){return t(e)},o.objectStore(c).add(n),f(o)}))}function h(e,t){var r=e.transaction(c,"readonly",s),n=r.objectStore(c),o=[],a=IDBKeyRange.bound(t+1,1/0);if(n.getAll){var i=n.getAll(a);return new Promise((function(e,t){i.onerror=function(e){return t(e)},i.onsuccess=function(t){e(t.target.result)}}))}return new Promise((function(e,i){var u=function(){try{return a=IDBKeyRange.bound(t+1,1/0),n.openCursor(a)}catch(e){return n.openCursor()}}();u.onerror=function(e){return i(e)},u.onsuccess=function(n){var a=n.target.result;a?a.value.id<t+1?a.continue(t+1):(o.push(a.value),a.continue()):(f(r),e(o))}}))}function v(e,t){if(e.closed)return Promise.resolve([]);var r=e.db.transaction(c,"readwrite",s).objectStore(c);return Promise.all(t.map((function(e){var t=r.delete(e);return new Promise((function(e){t.onsuccess=function(){return e()}}))})))}function y(e,t){var r=(new Date).getTime()-t,n=e.transaction(c,"readonly",s),o=n.objectStore(c),a=[];return new Promise((function(e){o.openCursor().onsuccess=function(t){var o=t.target.result;if(o){var i=o.value;i.time<r?(a.push(i),o.continue()):(f(n),e(a))}else e(a)}}))}function g(e){return y(e.db,e.options.idb.ttl).then((function(t){return v(e,t.map((function(e){return e.id})))}))}function b(e,t){return t=(0,a.fillOptionsWithDefaults)(t),d(e).then((function(r){var a={closed:!1,lastCursorId:0,channelName:e,options:t,uuid:(0,n.randomToken)(),eMIs:new o.ObliviousSet(2*t.idb.ttl),writeBlockPromise:n.PROMISE_RESOLVED_VOID,messagesCallback:null,readQueuePromises:[],db:r};return r.onclose=function(){a.closed=!0,t.idb.onclose&&t.idb.onclose()},m(a),a}))}function m(e){e.closed||O(e).then((function(){return(0,n.sleep)(e.options.idb.fallbackInterval)})).then((function(){return m(e)}))}function O(e){return e.closed?n.PROMISE_RESOLVED_VOID:e.messagesCallback?h(e.db,e.lastCursorId).then((function(t){var r=t.filter((function(e){return!!e})).map((function(t){return t.id>e.lastCursorId&&(e.lastCursorId=t.id),t})).filter((function(t){return function(e,t){return!(e.uuid===t.uuid||t.eMIs.has(e.id)||e.data.time<t.messagesCallbackTime)}(t,e)})).sort((function(e,t){return e.time-t.time}));return r.forEach((function(t){e.messagesCallback&&(e.eMIs.add(t.id),e.messagesCallback(t.data))})),n.PROMISE_RESOLVED_VOID})):n.PROMISE_RESOLVED_VOID}function k(e){e.closed=!0,e.db.close()}function w(e,t){return e.writeBlockPromise=e.writeBlockPromise.then((function(){return p(e.db,e.uuid,t)})).then((function(){0===(0,n.randomInt)(0,10)&&g(e)})),e.writeBlockPromise}function E(e,t,r){e.messagesCallbackTime=r,e.messagesCallback=t,O(e)}function P(){return!!l()}function S(e){return 2*e.idb.fallbackInterval}t.TRANSACTION_SETTINGS=s,t.type="idb";var T={create:b,close:k,onMessage:E,postMessage:w,canBeUsed:P,type:"idb",averageResponseTime:S,microSeconds:i};t.IndexedDBMethod=T},4924:function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.LocalstorageMethod=void 0,t.addStorageEventListener=d,t.averageResponseTime=b,t.canBeUsed=g,t.close=v,t.create=h,t.getLocalStorage=s,t.microSeconds=void 0,t.onMessage=y,t.postMessage=f,t.removeStorageEventListener=p,t.storageKey=l,t.type=void 0;var n=r(2151),o=r(423),a=r(6202),i=a.microSeconds;t.microSeconds=i;var u="pubkey.broadcastChannel-",c="localstorage";function s(){var e;if("undefined"==typeof window)return null;try{e=window.localStorage,e=window["ie8-eventlistener/storage"]||window.localStorage}catch(e){}return e}function l(e){return u+e}function f(e,t){return new Promise((function(r){(0,a.sleep)().then((function(){var n=l(e.channelName),o={token:(0,a.randomToken)(),time:(new Date).getTime(),data:t,uuid:e.uuid},i=JSON.stringify(o);s().setItem(n,i);var u=document.createEvent("Event");u.initEvent("storage",!0,!0),u.key=n,u.newValue=i,window.dispatchEvent(u),r()}))}))}function d(e,t){var r=l(e),n=function(e){e.key===r&&t(JSON.parse(e.newValue))};return window.addEventListener("storage",n),n}function p(e){window.removeEventListener("storage",e)}function h(e,t){if(t=(0,o.fillOptionsWithDefaults)(t),!g())throw new Error("BroadcastChannel: localstorage cannot be used");var r=(0,a.randomToken)(),i=new n.ObliviousSet(t.localstorage.removeTimeout),u={channelName:e,uuid:r,eMIs:i};return u.listener=d(e,(function(e){u.messagesCallback&&e.uuid!==r&&e.token&&!i.has(e.token)&&(e.data.time&&e.data.time<u.messagesCallbackTime||(i.add(e.token),u.messagesCallback(e.data)))})),u}function v(e){p(e.listener)}function y(e,t,r){e.messagesCallbackTime=r,e.messagesCallback=t}function g(){var e=s();if(!e)return!1;try{var t="__broadcastchannel_check";e.setItem(t,"works"),e.removeItem(t)}catch(e){return!1}return!0}function b(){var e=navigator.userAgent.toLowerCase();return e.includes("safari")&&!e.includes("chrome")?240:120}t.type=c;var m={create:h,close:v,onMessage:y,postMessage:f,canBeUsed:g,type:c,averageResponseTime:b,microSeconds:i};t.LocalstorageMethod=m},2026:function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.NativeMethod=void 0,t.averageResponseTime=f,t.canBeUsed=l,t.close=u,t.create=i,t.microSeconds=void 0,t.onMessage=s,t.postMessage=c,t.type=void 0;var n=r(6202),o=n.microSeconds;t.microSeconds=o;var a="native";function i(e){var t={messagesCallback:null,bc:new BroadcastChannel(e),subFns:[]};return t.bc.onmessage=function(e){t.messagesCallback&&t.messagesCallback(e.data)},t}function u(e){e.bc.close(),e.subFns=[]}function c(e,t){try{return e.bc.postMessage(t,!1),n.PROMISE_RESOLVED_VOID}catch(e){return Promise.reject(e)}}function s(e,t){e.messagesCallback=t}function l(){if("undefined"==typeof window&&"undefined"==typeof self||"function"!=typeof BroadcastChannel)return!1;if(BroadcastChannel._pubkey)throw new Error("BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill");return!0}function f(){return 150}t.type=a;var d={create:i,close:u,onMessage:s,postMessage:c,canBeUsed:l,type:a,averageResponseTime:f,microSeconds:o};t.NativeMethod=d},1574:function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.SimulateMethod=void 0,t.averageResponseTime=f,t.canBeUsed=l,t.close=u,t.create=i,t.microSeconds=void 0,t.onMessage=s,t.postMessage=c,t.type=void 0;var n=r(6202).microSeconds;t.microSeconds=n;var o="simulate";t.type=o;var a=new Set;function i(e){var t={name:e,messagesCallback:null};return a.add(t),t}function u(e){a.delete(e)}function c(e,t){return new Promise((function(r){return setTimeout((function(){Array.from(a).filter((function(t){return t.name===e.name})).filter((function(t){return t!==e})).filter((function(e){return!!e.messagesCallback})).forEach((function(e){return e.messagesCallback(t)})),r()}),5)}))}function s(e,t){e.messagesCallback=t}function l(){return!0}function f(){return 5}var d={create:i,close:u,onMessage:s,postMessage:c,canBeUsed:l,type:o,averageResponseTime:f,microSeconds:n};t.SimulateMethod=d},423:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.fillOptionsWithDefaults=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=JSON.parse(JSON.stringify(e));return void 0===t.webWorkerSupport&&(t.webWorkerSupport=!0),t.idb||(t.idb={}),t.idb.ttl||(t.idb.ttl=45e3),t.idb.fallbackInterval||(t.idb.fallbackInterval=150),e.idb&&"function"==typeof e.idb.onclose&&(t.idb.onclose=e.idb.onclose),t.localstorage||(t.localstorage={}),t.localstorage.removeTimeout||(t.localstorage.removeTimeout=6e4),e.methods&&(t.methods=e.methods),t.node||(t.node={}),t.node.ttl||(t.node.ttl=12e4),t.node.maxParallelWrites||(t.node.maxParallelWrites=2048),void 0===t.node.useFastPath&&(t.node.useFastPath=!0),t}},6202:function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.PROMISE_RESOLVED_VOID=t.PROMISE_RESOLVED_TRUE=t.PROMISE_RESOLVED_FALSE=void 0,t.isPromise=function(e){return e&&"function"==typeof e.then},t.microSeconds=function(){var e=(new Date).getTime();return e===a?1e3*e+ ++i:(a=e,i=0,1e3*e)},t.randomInt=function(e,t){return Math.floor(Math.random()*(t-e+1)+e)},t.randomToken=function(){return Math.random().toString(36).substring(2)},t.sleep=function(e,t){return e||(e=0),new Promise((function(r){return setTimeout((function(){return r(t)}),e)}))},t.supportsWebLockAPI=function(){return"undefined"!=typeof navigator&&void 0!==navigator.locks&&"function"==typeof navigator.locks.request};var r=Promise.resolve(!1);t.PROMISE_RESOLVED_FALSE=r;var n=Promise.resolve(!0);t.PROMISE_RESOLVED_TRUE=n;var o=Promise.resolve();t.PROMISE_RESOLVED_VOID=o;var a=0,i=0},4098:function(e,t){var r="undefined"!=typeof self?self:this,n=function(){function e(){this.fetch=!1,this.DOMException=r.DOMException}return e.prototype=r,new e}();!function(e){!function(t){var r={searchParams:"URLSearchParams"in e,iterable:"Symbol"in e&&"iterator"in Symbol,blob:"FileReader"in e&&"Blob"in e&&function(){try{return new Blob,!0}catch(e){return!1}}(),formData:"FormData"in e,arrayBuffer:"ArrayBuffer"in e};if(r.arrayBuffer)var n=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],o=ArrayBuffer.isView||function(e){return e&&n.indexOf(Object.prototype.toString.call(e))>-1};function a(e){if("string"!=typeof e&&(e=String(e)),/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e))throw new TypeError("Invalid character in header field name");return e.toLowerCase()}function i(e){return"string"!=typeof e&&(e=String(e)),e}function u(e){var t={next:function(){var t=e.shift();return{done:void 0===t,value:t}}};return r.iterable&&(t[Symbol.iterator]=function(){return t}),t}function c(e){this.map={},e instanceof c?e.forEach((function(e,t){this.append(t,e)}),this):Array.isArray(e)?e.forEach((function(e){this.append(e[0],e[1])}),this):e&&Object.getOwnPropertyNames(e).forEach((function(t){this.append(t,e[t])}),this)}function s(e){if(e.bodyUsed)return Promise.reject(new TypeError("Already read"));e.bodyUsed=!0}function l(e){return new Promise((function(t,r){e.onload=function(){t(e.result)},e.onerror=function(){r(e.error)}}))}function f(e){var t=new FileReader,r=l(t);return t.readAsArrayBuffer(e),r}function d(e){if(e.slice)return e.slice(0);var t=new Uint8Array(e.byteLength);return t.set(new Uint8Array(e)),t.buffer}function p(){return this.bodyUsed=!1,this._initBody=function(e){var t;this._bodyInit=e,e?"string"==typeof e?this._bodyText=e:r.blob&&Blob.prototype.isPrototypeOf(e)?this._bodyBlob=e:r.formData&&FormData.prototype.isPrototypeOf(e)?this._bodyFormData=e:r.searchParams&&URLSearchParams.prototype.isPrototypeOf(e)?this._bodyText=e.toString():r.arrayBuffer&&r.blob&&(t=e)&&DataView.prototype.isPrototypeOf(t)?(this._bodyArrayBuffer=d(e.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer])):r.arrayBuffer&&(ArrayBuffer.prototype.isPrototypeOf(e)||o(e))?this._bodyArrayBuffer=d(e):this._bodyText=e=Object.prototype.toString.call(e):this._bodyText="",this.headers.get("content-type")||("string"==typeof e?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):r.searchParams&&URLSearchParams.prototype.isPrototypeOf(e)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"))},r.blob&&(this.blob=function(){var e=s(this);if(e)return e;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){return this._bodyArrayBuffer?s(this)||Promise.resolve(this._bodyArrayBuffer):this.blob().then(f)}),this.text=function(){var e,t,r,n=s(this);if(n)return n;if(this._bodyBlob)return e=this._bodyBlob,r=l(t=new FileReader),t.readAsText(e),r;if(this._bodyArrayBuffer)return Promise.resolve(function(e){for(var t=new Uint8Array(e),r=new Array(t.length),n=0;n<t.length;n++)r[n]=String.fromCharCode(t[n]);return r.join("")}(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)},r.formData&&(this.formData=function(){return this.text().then(y)}),this.json=function(){return this.text().then(JSON.parse)},this}c.prototype.append=function(e,t){e=a(e),t=i(t);var r=this.map[e];this.map[e]=r?r+", "+t:t},c.prototype.delete=function(e){delete this.map[a(e)]},c.prototype.get=function(e){return e=a(e),this.has(e)?this.map[e]:null},c.prototype.has=function(e){return this.map.hasOwnProperty(a(e))},c.prototype.set=function(e,t){this.map[a(e)]=i(t)},c.prototype.forEach=function(e,t){for(var r in this.map)this.map.hasOwnProperty(r)&&e.call(t,this.map[r],r,this)},c.prototype.keys=function(){var e=[];return this.forEach((function(t,r){e.push(r)})),u(e)},c.prototype.values=function(){var e=[];return this.forEach((function(t){e.push(t)})),u(e)},c.prototype.entries=function(){var e=[];return this.forEach((function(t,r){e.push([r,t])})),u(e)},r.iterable&&(c.prototype[Symbol.iterator]=c.prototype.entries);var h=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];function v(e,t){var r,n,o=(t=t||{}).body;if(e instanceof v){if(e.bodyUsed)throw new TypeError("Already read");this.url=e.url,this.credentials=e.credentials,t.headers||(this.headers=new c(e.headers)),this.method=e.method,this.mode=e.mode,this.signal=e.signal,o||null==e._bodyInit||(o=e._bodyInit,e.bodyUsed=!0)}else this.url=String(e);if(this.credentials=t.credentials||this.credentials||"same-origin",!t.headers&&this.headers||(this.headers=new c(t.headers)),this.method=(n=(r=t.method||this.method||"GET").toUpperCase(),h.indexOf(n)>-1?n:r),this.mode=t.mode||this.mode||null,this.signal=t.signal||this.signal,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&o)throw new TypeError("Body not allowed for GET or HEAD requests");this._initBody(o)}function y(e){var t=new FormData;return e.trim().split("&").forEach((function(e){if(e){var r=e.split("="),n=r.shift().replace(/\+/g," "),o=r.join("=").replace(/\+/g," ");t.append(decodeURIComponent(n),decodeURIComponent(o))}})),t}function g(e,t){t||(t={}),this.type="default",this.status=void 0===t.status?200:t.status,this.ok=this.status>=200&&this.status<300,this.statusText="statusText"in t?t.statusText:"OK",this.headers=new c(t.headers),this.url=t.url||"",this._initBody(e)}v.prototype.clone=function(){return new v(this,{body:this._bodyInit})},p.call(v.prototype),p.call(g.prototype),g.prototype.clone=function(){return new g(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new c(this.headers),url:this.url})},g.error=function(){var e=new g(null,{status:0,statusText:""});return e.type="error",e};var b=[301,302,303,307,308];g.redirect=function(e,t){if(-1===b.indexOf(t))throw new RangeError("Invalid status code");return new g(null,{status:t,headers:{location:e}})},t.DOMException=e.DOMException;try{new t.DOMException}catch(e){t.DOMException=function(e,t){this.message=e,this.name=t;var r=Error(e);this.stack=r.stack},t.DOMException.prototype=Object.create(Error.prototype),t.DOMException.prototype.constructor=t.DOMException}function m(e,n){return new Promise((function(o,a){var i=new v(e,n);if(i.signal&&i.signal.aborted)return a(new t.DOMException("Aborted","AbortError"));var u=new XMLHttpRequest;function s(){u.abort()}u.onload=function(){var e,t,r={status:u.status,statusText:u.statusText,headers:(e=u.getAllResponseHeaders()||"",t=new c,e.replace(/\r?\n[\t ]+/g," ").split(/\r?\n/).forEach((function(e){var r=e.split(":"),n=r.shift().trim();if(n){var o=r.join(":").trim();t.append(n,o)}})),t)};r.url="responseURL"in u?u.responseURL:r.headers.get("X-Request-URL");var n="response"in u?u.response:u.responseText;o(new g(n,r))},u.onerror=function(){a(new TypeError("Network request failed"))},u.ontimeout=function(){a(new TypeError("Network request failed"))},u.onabort=function(){a(new t.DOMException("Aborted","AbortError"))},u.open(i.method,i.url,!0),"include"===i.credentials?u.withCredentials=!0:"omit"===i.credentials&&(u.withCredentials=!1),"responseType"in u&&r.blob&&(u.responseType="blob"),i.headers.forEach((function(e,t){u.setRequestHeader(t,e)})),i.signal&&(i.signal.addEventListener("abort",s),u.onreadystatechange=function(){4===u.readyState&&i.signal.removeEventListener("abort",s)}),u.send(void 0===i._bodyInit?null:i._bodyInit)}))}m.polyfill=!0,e.fetch||(e.fetch=m,e.Headers=c,e.Request=v,e.Response=g),t.Headers=c,t.Request=v,t.Response=g,t.fetch=m,Object.defineProperty(t,"__esModule",{value:!0})}({})}(n),n.fetch.ponyfill=!0,delete n.fetch.polyfill;var o=n;(t=o.fetch).default=o.fetch,t.fetch=o.fetch,t.Headers=o.Headers,t.Request=o.Request,t.Response=o.Response,e.exports=t},646:function(e){e.exports=function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)e[n]=r[n]}return e}return function t(r,n){function o(t,o,a){if("undefined"!=typeof document){"number"==typeof(a=e({},n,a)).expires&&(a.expires=new Date(Date.now()+864e5*a.expires)),a.expires&&(a.expires=a.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var i="";for(var u in a)a[u]&&(i+="; "+u,!0!==a[u]&&(i+="="+a[u].split(";")[0]));return document.cookie=t+"="+r.write(o,t)+i}}return Object.create({set:o,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var t=document.cookie?document.cookie.split("; "):[],n={},o=0;o<t.length;o++){var a=t[o].split("="),i=a.slice(1).join("=");try{var u=decodeURIComponent(a[0]);if(n[u]=r.read(i,u),e===u)break}catch(e){}}return e?n[e]:n}},remove:function(t,r){o(t,"",e({},r,{expires:-1}))},withAttributes:function(r){return t(this.converter,e({},this.attributes,r))},withConverter:function(r){return t(e({},this.converter,r),this.attributes)}},{attributes:{value:Object.freeze(n)},converter:{value:Object.freeze(r)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"})}()},2151:function(e,t,r){"use strict";r.r(t),r.d(t,{ObliviousSet:function(){return n},now:function(){return a},removeTooOldValues:function(){return o}});var n=function(){function e(e){this.ttl=e,this.map=new Map,this._to=!1}return e.prototype.has=function(e){return this.map.has(e)},e.prototype.add=function(e){var t=this;this.map.set(e,a()),this._to||(this._to=!0,setTimeout((function(){t._to=!1,o(t)}),0))},e.prototype.clear=function(){this.map.clear()},e}();function o(e){for(var t=a()-e.ttl,r=e.map[Symbol.iterator]();;){var n=r.next().value;if(!n)return;var o=n[0];if(!(n[1]<t))return;e.map.delete(o)}}function a(){return(new Date).getTime()}},4279:function(e){function t(){}t.prototype={on:function(e,t,r){var n=this.e||(this.e={});return(n[e]||(n[e]=[])).push({fn:t,ctx:r}),this},once:function(e,t,r){var n=this;function o(){n.off(e,o),t.apply(r,arguments)}return o._=t,this.on(e,o,r)},emit:function(e){for(var t=[].slice.call(arguments,1),r=((this.e||(this.e={}))[e]||[]).slice(),n=0,o=r.length;n<o;n++)r[n].fn.apply(r[n].ctx,t);return this},off:function(e,t){var r=this.e||(this.e={}),n=r[e],o=[];if(n&&t)for(var a=0,i=n.length;a<i;a++)n[a].fn!==t&&n[a].fn._!==t&&o.push(n[a]);return o.length?r[e]=o:delete r[e],this}},e.exports=t},4810:function(e,t,r){"use strict";r.r(t),r.d(t,{add:function(){return i},getSize:function(){return s},removeAll:function(){return c},runAll:function(){return u}});var n="[object process]"===Object.prototype.toString.call("undefined"!=typeof process?process:0)?function(e){process.on("exit",(function(){return e()})),process.on("beforeExit",(function(){return e().then((function(){return process.exit()}))})),process.on("SIGINT",(function(){return e().then((function(){return process.exit()}))})),process.on("uncaughtException",(function(t){return e().then((function(){console.trace(t),process.exit(101)}))}))}:function(e){if("function"==typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope){var t=self.close.bind(self);self.close=function(){return e(),t()}}else{if("function"!=typeof window.addEventListener)return;window.addEventListener("beforeunload",(function(){e()}),!0),window.addEventListener("unload",(function(){e()}),!0)}},o=new Set,a=!1;function i(e){if(a||(a=!0,n(u)),"function"!=typeof e)throw new Error("Listener is no function");return o.add(e),{remove:function(){return o.delete(e)},run:function(){return o.delete(e),e()}}}function u(){var e=[];return o.forEach((function(t){e.push(t()),o.delete(t)})),Promise.all(e)}function c(){o.clear()}function s(){return o.size}},3897:function(e){e.exports=function(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n},e.exports.__esModule=!0,e.exports.default=e.exports},5372:function(e){e.exports=function(e){if(Array.isArray(e))return e},e.exports.__esModule=!0,e.exports.default=e.exports},3405:function(e,t,r){var n=r(3897);e.exports=function(e){if(Array.isArray(e))return n(e)},e.exports.__esModule=!0,e.exports.default=e.exports},6115:function(e){e.exports=function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e},e.exports.__esModule=!0,e.exports.default=e.exports},7156:function(e){function t(e,t,r,n,o,a,i){try{var u=e[a](i),c=u.value}catch(e){return void r(e)}u.done?t(c):Promise.resolve(c).then(n,o)}e.exports=function(e){return function(){var r=this,n=arguments;return new Promise((function(o,a){var i=e.apply(r,n);function u(e){t(i,o,a,u,c,"next",e)}function c(e){t(i,o,a,u,c,"throw",e)}u(void 0)}))}},e.exports.__esModule=!0,e.exports.default=e.exports},6690:function(e){e.exports=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},e.exports.__esModule=!0,e.exports.default=e.exports},3515:function(e,t,r){var n=r(6015),o=r(9617);function a(t,r,i){return o()?(e.exports=a=Reflect.construct.bind(),e.exports.__esModule=!0,e.exports.default=e.exports):(e.exports=a=function(e,t,r){var o=[null];o.push.apply(o,t);var a=new(Function.bind.apply(e,o));return r&&n(a,r.prototype),a},e.exports.__esModule=!0,e.exports.default=e.exports),a.apply(null,arguments)}e.exports=a,e.exports.__esModule=!0,e.exports.default=e.exports},9728:function(e){function t(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}e.exports=function(e,r,n){return r&&t(e.prototype,r),n&&t(e,n),Object.defineProperty(e,"prototype",{writable:!1}),e},e.exports.__esModule=!0,e.exports.default=e.exports},8416:function(e){e.exports=function(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e},e.exports.__esModule=!0,e.exports.default=e.exports},1588:function(e,t,r){var n=r(1753);function o(){return"undefined"!=typeof Reflect&&Reflect.get?(e.exports=o=Reflect.get.bind(),e.exports.__esModule=!0,e.exports.default=e.exports):(e.exports=o=function(e,t,r){var o=n(e,t);if(o){var a=Object.getOwnPropertyDescriptor(o,t);return a.get?a.get.call(arguments.length<3?e:r):a.value}},e.exports.__esModule=!0,e.exports.default=e.exports),o.apply(this,arguments)}e.exports=o,e.exports.__esModule=!0,e.exports.default=e.exports},3808:function(e){function t(r){return e.exports=t=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},e.exports.__esModule=!0,e.exports.default=e.exports,t(r)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},1655:function(e,t,r){var n=r(6015);e.exports=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&n(e,t)},e.exports.__esModule=!0,e.exports.default=e.exports},4836:function(e){e.exports=function(e){return e&&e.__esModule?e:{default:e}},e.exports.__esModule=!0,e.exports.default=e.exports},6035:function(e){e.exports=function(e){return-1!==Function.toString.call(e).indexOf("[native code]")},e.exports.__esModule=!0,e.exports.default=e.exports},9617:function(e){e.exports=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}},e.exports.__esModule=!0,e.exports.default=e.exports},9498:function(e){e.exports=function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)},e.exports.__esModule=!0,e.exports.default=e.exports},8872:function(e){e.exports=function(e,t){var r=null==e?null:"undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(null!=r){var n,o,a=[],i=!0,u=!1;try{for(r=r.call(e);!(i=(n=r.next()).done)&&(a.push(n.value),!t||a.length!==t);i=!0);}catch(e){u=!0,o=e}finally{try{i||null==r.return||r.return()}finally{if(u)throw o}}return a}},e.exports.__esModule=!0,e.exports.default=e.exports},2218:function(e){e.exports=function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")},e.exports.__esModule=!0,e.exports.default=e.exports},5343:function(e){e.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")},e.exports.__esModule=!0,e.exports.default=e.exports},215:function(e,t,r){var n=r(7071);e.exports=function(e,t){if(null==e)return{};var r,o,a=n(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(o=0;o<i.length;o++)r=i[o],t.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(e,r)&&(a[r]=e[r])}return a},e.exports.__esModule=!0,e.exports.default=e.exports},7071:function(e){e.exports=function(e,t){if(null==e)return{};var r,n,o={},a=Object.keys(e);for(n=0;n<a.length;n++)r=a[n],t.indexOf(r)>=0||(o[r]=e[r]);return o},e.exports.__esModule=!0,e.exports.default=e.exports},4993:function(e,t,r){var n=r(8698).default,o=r(6115);e.exports=function(e,t){if(t&&("object"===n(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return o(e)},e.exports.__esModule=!0,e.exports.default=e.exports},7061:function(e,t,r){var n=r(8698).default;function o(){"use strict";e.exports=o=function(){return t},e.exports.__esModule=!0,e.exports.default=e.exports;var t={},r=Object.prototype,a=r.hasOwnProperty,i="function"==typeof Symbol?Symbol:{},u=i.iterator||"@@iterator",c=i.asyncIterator||"@@asyncIterator",s=i.toStringTag||"@@toStringTag";function l(e,t,r){return Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}),e[t]}try{l({},"")}catch(e){l=function(e,t,r){return e[t]=r}}function f(e,t,r,n){var o=t&&t.prototype instanceof h?t:h,a=Object.create(o.prototype),i=new T(n||[]);return a._invoke=function(e,t,r){var n="suspendedStart";return function(o,a){if("executing"===n)throw new Error("Generator is already running");if("completed"===n){if("throw"===o)throw a;return{value:void 0,done:!0}}for(r.method=o,r.arg=a;;){var i=r.delegate;if(i){var u=E(i,r);if(u){if(u===p)continue;return u}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if("suspendedStart"===n)throw n="completed",r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);n="executing";var c=d(e,t,r);if("normal"===c.type){if(n=r.done?"completed":"suspendedYield",c.arg===p)continue;return{value:c.arg,done:r.done}}"throw"===c.type&&(n="completed",r.method="throw",r.arg=c.arg)}}}(e,r,i),a}function d(e,t,r){try{return{type:"normal",arg:e.call(t,r)}}catch(e){return{type:"throw",arg:e}}}t.wrap=f;var p={};function h(){}function v(){}function y(){}var g={};l(g,u,(function(){return this}));var b=Object.getPrototypeOf,m=b&&b(b(j([])));m&&m!==r&&a.call(m,u)&&(g=m);var O=y.prototype=h.prototype=Object.create(g);function k(e){["next","throw","return"].forEach((function(t){l(e,t,(function(e){return this._invoke(t,e)}))}))}function w(e,t){function r(o,i,u,c){var s=d(e[o],e,i);if("throw"!==s.type){var l=s.arg,f=l.value;return f&&"object"==n(f)&&a.call(f,"__await")?t.resolve(f.__await).then((function(e){r("next",e,u,c)}),(function(e){r("throw",e,u,c)})):t.resolve(f).then((function(e){l.value=e,u(l)}),(function(e){return r("throw",e,u,c)}))}c(s.arg)}var o;this._invoke=function(e,n){function a(){return new t((function(t,o){r(e,n,t,o)}))}return o=o?o.then(a,a):a()}}function E(e,t){var r=e.iterator[t.method];if(void 0===r){if(t.delegate=null,"throw"===t.method){if(e.iterator.return&&(t.method="return",t.arg=void 0,E(e,t),"throw"===t.method))return p;t.method="throw",t.arg=new TypeError("The iterator does not provide a 'throw' method")}return p}var n=d(r,e.iterator,t.arg);if("throw"===n.type)return t.method="throw",t.arg=n.arg,t.delegate=null,p;var o=n.arg;return o?o.done?(t[e.resultName]=o.value,t.next=e.nextLoc,"return"!==t.method&&(t.method="next",t.arg=void 0),t.delegate=null,p):o:(t.method="throw",t.arg=new TypeError("iterator result is not an object"),t.delegate=null,p)}function P(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function S(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function T(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(P,this),this.reset(!0)}function j(e){if(e){var t=e[u];if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var r=-1,n=function t(){for(;++r<e.length;)if(a.call(e,r))return t.value=e[r],t.done=!1,t;return t.value=void 0,t.done=!0,t};return n.next=n}}return{next:_}}function _(){return{value:void 0,done:!0}}return v.prototype=y,l(O,"constructor",y),l(y,"constructor",v),v.displayName=l(y,s,"GeneratorFunction"),t.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===v||"GeneratorFunction"===(t.displayName||t.name))},t.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,y):(e.__proto__=y,l(e,s,"GeneratorFunction")),e.prototype=Object.create(O),e},t.awrap=function(e){return{__await:e}},k(w.prototype),l(w.prototype,c,(function(){return this})),t.AsyncIterator=w,t.async=function(e,r,n,o,a){void 0===a&&(a=Promise);var i=new w(f(e,r,n,o),a);return t.isGeneratorFunction(r)?i:i.next().then((function(e){return e.done?e.value:i.next()}))},k(O),l(O,s,"Generator"),l(O,u,(function(){return this})),l(O,"toString",(function(){return"[object Generator]"})),t.keys=function(e){var t=[];for(var r in e)t.push(r);return t.reverse(),function r(){for(;t.length;){var n=t.pop();if(n in e)return r.value=n,r.done=!1,r}return r.done=!0,r}},t.values=j,T.prototype={constructor:T,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=void 0,this.done=!1,this.delegate=null,this.method="next",this.arg=void 0,this.tryEntries.forEach(S),!e)for(var t in this)"t"===t.charAt(0)&&a.call(this,t)&&!isNaN(+t.slice(1))&&(this[t]=void 0)},stop:function(){this.done=!0;var e=this.tryEntries[0].completion;if("throw"===e.type)throw e.arg;return this.rval},dispatchException:function(e){if(this.done)throw e;var t=this;function r(r,n){return i.type="throw",i.arg=e,t.next=r,n&&(t.method="next",t.arg=void 0),!!n}for(var n=this.tryEntries.length-1;n>=0;--n){var o=this.tryEntries[n],i=o.completion;if("root"===o.tryLoc)return r("end");if(o.tryLoc<=this.prev){var u=a.call(o,"catchLoc"),c=a.call(o,"finallyLoc");if(u&&c){if(this.prev<o.catchLoc)return r(o.catchLoc,!0);if(this.prev<o.finallyLoc)return r(o.finallyLoc)}else if(u){if(this.prev<o.catchLoc)return r(o.catchLoc,!0)}else{if(!c)throw new Error("try statement without catch or finally");if(this.prev<o.finallyLoc)return r(o.finallyLoc)}}}},abrupt:function(e,t){for(var r=this.tryEntries.length-1;r>=0;--r){var n=this.tryEntries[r];if(n.tryLoc<=this.prev&&a.call(n,"finallyLoc")&&this.prev<n.finallyLoc){var o=n;break}}o&&("break"===e||"continue"===e)&&o.tryLoc<=t&&t<=o.finallyLoc&&(o=null);var i=o?o.completion:{};return i.type=e,i.arg=t,o?(this.method="next",this.next=o.finallyLoc,p):this.complete(i)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),p},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var r=this.tryEntries[t];if(r.finallyLoc===e)return this.complete(r.completion,r.afterLoc),S(r),p}},catch:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var r=this.tryEntries[t];if(r.tryLoc===e){var n=r.completion;if("throw"===n.type){var o=n.arg;S(r)}return o}}throw new Error("illegal catch attempt")},delegateYield:function(e,t,r){return this.delegate={iterator:j(e),resultName:t,nextLoc:r},"next"===this.method&&(this.arg=void 0),p}},t}e.exports=o,e.exports.__esModule=!0,e.exports.default=e.exports},6015:function(e){function t(r,n){return e.exports=t=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},e.exports.__esModule=!0,e.exports.default=e.exports,t(r,n)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},7424:function(e,t,r){var n=r(5372),o=r(8872),a=r(6116),i=r(2218);e.exports=function(e,t){return n(e)||o(e,t)||a(e,t)||i()},e.exports.__esModule=!0,e.exports.default=e.exports},1753:function(e,t,r){var n=r(3808);e.exports=function(e,t){for(;!Object.prototype.hasOwnProperty.call(e,t)&&null!==(e=n(e)););return e},e.exports.__esModule=!0,e.exports.default=e.exports},861:function(e,t,r){var n=r(3405),o=r(9498),a=r(6116),i=r(5343);e.exports=function(e){return n(e)||o(e)||a(e)||i()},e.exports.__esModule=!0,e.exports.default=e.exports},8698:function(e){function t(r){return e.exports=t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports.__esModule=!0,e.exports.default=e.exports,t(r)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},6116:function(e,t,r){var n=r(3897);e.exports=function(e,t){if(e){if("string"==typeof e)return n(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?n(e,t):void 0}},e.exports.__esModule=!0,e.exports.default=e.exports},3496:function(e,t,r){var n=r(3808),o=r(6015),a=r(6035),i=r(3515);function u(t){var r="function"==typeof Map?new Map:void 0;return e.exports=u=function(e){if(null===e||!a(e))return e;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==r){if(r.has(e))return r.get(e);r.set(e,t)}function t(){return i(e,arguments,n(this).constructor)}return t.prototype=Object.create(e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),o(t,e)},e.exports.__esModule=!0,e.exports.default=e.exports,u(t)}e.exports=u,e.exports.__esModule=!0,e.exports.default=e.exports},4687:function(e,t,r){var n=r(7061)();e.exports=n;try{regeneratorRuntime=n}catch(e){"object"==typeof globalThis?globalThis.regeneratorRuntime=n:Function("r","regeneratorRuntime = r")(n)}},3762:function(e){function t(r){return e.exports=t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports.__esModule=!0,e.exports.default=e.exports,t(r)}e.exports=t,e.exports.__esModule=!0,e.exports.default=e.exports},5883:function(e,t,r){"use strict";function n(e){return n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},n(e)}function o(e){return o=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)},o(e)}function a(e,t){return a=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e},a(e,t)}function i(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}function u(e,t,r){return u=i()?Reflect.construct:function(e,t,r){var n=[null];n.push.apply(n,t);var o=new(Function.bind.apply(e,n));return r&&a(o,r.prototype),o},u.apply(null,arguments)}function c(e){var t="function"==typeof Map?new Map:void 0;return c=function(e){if(null===e||(r=e,-1===Function.toString.call(r).indexOf("[native code]")))return e;var r;if("function"!=typeof e)throw new TypeError("Super expression must either be null or a function");if(void 0!==t){if(t.has(e))return t.get(e);t.set(e,n)}function n(){return u(e,arguments,o(this).constructor)}return n.prototype=Object.create(e.prototype,{constructor:{value:n,enumerable:!1,writable:!0,configurable:!0}}),a(n,e)},c(e)}function s(e){return function(e){if(Array.isArray(e))return f(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||l(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function l(e,t){if(e){if("string"==typeof e)return f(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?f(e,t):void 0}}function f(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}r.r(t),r.d(t,{JSONPath:function(){return y}});var d=Object.prototype.hasOwnProperty;function p(e,t){return(e=e.slice()).push(t),e}function h(e,t){return(t=t.slice()).unshift(e),t}var v=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&a(e,t)}(u,e);var t,r,n=(t=u,r=i(),function(){var e,n=o(t);if(r){var a=o(this).constructor;e=Reflect.construct(n,arguments,a)}else e=n.apply(this,arguments);return function(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e):t}(this,e)});function u(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,u),(t=n.call(this,'JSONPath should not be called with "new" (it prevents return of (unwrapped) scalar values)')).avoidNew=!0,t.value=e,t.name="NewError",t}return u}(c(Error));function y(e,t,r,o,a){if(!(this instanceof y))try{return new y(e,t,r,o,a)}catch(e){if(!e.avoidNew)throw e;return e.value}"string"==typeof e&&(a=o,o=r,r=t,t=e,e=null);var i=e&&"object"===n(e);if(e=e||{},this.json=e.json||r,this.path=e.path||t,this.resultType=e.resultType||"value",this.flatten=e.flatten||!1,this.wrap=!d.call(e,"wrap")||e.wrap,this.sandbox=e.sandbox||{},this.preventEval=e.preventEval||!1,this.parent=e.parent||null,this.parentProperty=e.parentProperty||null,this.callback=e.callback||o||null,this.otherTypeCallback=e.otherTypeCallback||a||function(){throw new TypeError("You must supply an otherTypeCallback callback option with the @other() operator.")},!1!==e.autostart){var u={path:i?e.path:t};i?"json"in e&&(u.json=e.json):u.json=r;var c=this.evaluate(u);if(!c||"object"!==n(c))throw new v(c);return c}}y.prototype.evaluate=function(e,t,r,o){var a=this,i=this.parent,u=this.parentProperty,c=this.flatten,s=this.wrap;if(this.currResultType=this.resultType,this.currPreventEval=this.preventEval,this.currSandbox=this.sandbox,r=r||this.callback,this.currOtherTypeCallback=o||this.otherTypeCallback,t=t||this.json,(e=e||this.path)&&"object"===n(e)&&!Array.isArray(e)){if(!e.path&&""!==e.path)throw new TypeError('You must supply a "path" property when providing an object argument to JSONPath.evaluate().');if(!d.call(e,"json"))throw new TypeError('You must supply a "json" property when providing an object argument to JSONPath.evaluate().');t=e.json,c=d.call(e,"flatten")?e.flatten:c,this.currResultType=d.call(e,"resultType")?e.resultType:this.currResultType,this.currSandbox=d.call(e,"sandbox")?e.sandbox:this.currSandbox,s=d.call(e,"wrap")?e.wrap:s,this.currPreventEval=d.call(e,"preventEval")?e.preventEval:this.currPreventEval,r=d.call(e,"callback")?e.callback:r,this.currOtherTypeCallback=d.call(e,"otherTypeCallback")?e.otherTypeCallback:this.currOtherTypeCallback,i=d.call(e,"parent")?e.parent:i,u=d.call(e,"parentProperty")?e.parentProperty:u,e=e.path}if(i=i||null,u=u||null,Array.isArray(e)&&(e=y.toPathString(e)),(e||""===e)&&t){var l=y.toPathArray(e);"$"===l[0]&&l.length>1&&l.shift(),this._hasParentSelector=null;var f=this._trace(l,t,["$"],i,u,r).filter((function(e){return e&&!e.isParentSelector}));return f.length?s||1!==f.length||f[0].hasArrExpr?f.reduce((function(e,t){var r=a._getPreferredOutput(t);return c&&Array.isArray(r)?e=e.concat(r):e.push(r),e}),[]):this._getPreferredOutput(f[0]):s?[]:void 0}},y.prototype._getPreferredOutput=function(e){var t=this.currResultType;switch(t){case"all":var r=Array.isArray(e.path)?e.path:y.toPathArray(e.path);return e.pointer=y.toPointer(r),e.path="string"==typeof e.path?e.path:y.toPathString(e.path),e;case"value":case"parent":case"parentProperty":return e[t];case"path":return y.toPathString(e[t]);case"pointer":return y.toPointer(e.path);default:throw new TypeError("Unknown result type")}},y.prototype._handleCallback=function(e,t,r){if(t){var n=this._getPreferredOutput(e);e.path="string"==typeof e.path?e.path:y.toPathString(e.path),t(n,r,e)}},y.prototype._trace=function(e,t,r,o,a,i,u,c){var s,f=this;if(!e.length)return s={path:r,value:t,parent:o,parentProperty:a,hasArrExpr:u},this._handleCallback(s,i,"value"),s;var v=e[0],y=e.slice(1),g=[];function b(e){Array.isArray(e)?e.forEach((function(e){g.push(e)})):g.push(e)}if(("string"!=typeof v||c)&&t&&d.call(t,v))b(this._trace(y,t[v],p(r,v),t,v,i,u));else if("*"===v)this._walk(v,y,t,r,o,a,i,(function(e,t,r,n,o,a,i,u){b(f._trace(h(e,r),n,o,a,i,u,!0,!0))}));else if(".."===v)b(this._trace(y,t,r,o,a,i,u)),this._walk(v,y,t,r,o,a,i,(function(e,t,r,o,a,i,u,c){"object"===n(o[e])&&b(f._trace(h(t,r),o[e],p(a,e),o,e,c,!0))}));else{if("^"===v)return this._hasParentSelector=!0,{path:r.slice(0,-1),expr:y,isParentSelector:!0};if("~"===v)return s={path:p(r,v),value:a,parent:o,parentProperty:null},this._handleCallback(s,i,"property"),s;if("$"===v)b(this._trace(y,t,r,null,null,i,u));else if(/^(\x2D?[0-9]*):(\x2D?[0-9]*):?([0-9]*)$/.test(v))b(this._slice(v,y,t,r,o,a,i));else if(0===v.indexOf("?(")){if(this.currPreventEval)throw new Error("Eval [?(expr)] prevented in JSONPath expression.");this._walk(v,y,t,r,o,a,i,(function(e,t,r,n,o,a,i,u){f._eval(t.replace(/^\?\(((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\)$/,"$1"),n[e],e,o,a,i)&&b(f._trace(h(e,r),n,o,a,i,u,!0))}))}else if("("===v[0]){if(this.currPreventEval)throw new Error("Eval [(expr)] prevented in JSONPath expression.");b(this._trace(h(this._eval(v,t,r[r.length-1],r.slice(0,-1),o,a),y),t,r,o,a,i,u))}else if("@"===v[0]){var m=!1,O=v.slice(1,-2);switch(O){case"scalar":t&&["object","function"].includes(n(t))||(m=!0);break;case"boolean":case"string":case"undefined":case"function":n(t)===O&&(m=!0);break;case"integer":!Number.isFinite(t)||t%1||(m=!0);break;case"number":Number.isFinite(t)&&(m=!0);break;case"nonFinite":"number"!=typeof t||Number.isFinite(t)||(m=!0);break;case"object":t&&n(t)===O&&(m=!0);break;case"array":Array.isArray(t)&&(m=!0);break;case"other":m=this.currOtherTypeCallback(t,r,o,a);break;case"null":null===t&&(m=!0);break;default:throw new TypeError("Unknown value type "+O)}if(m)return s={path:r,value:t,parent:o,parentProperty:a},this._handleCallback(s,i,"value"),s}else if("`"===v[0]&&t&&d.call(t,v.slice(1))){var k=v.slice(1);b(this._trace(y,t[k],p(r,k),t,k,i,u,!0))}else if(v.includes(",")){var w,E=function(e,t){var r="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(!r){if(Array.isArray(e)||(r=l(e))){r&&(e=r);var n=0,o=function(){};return{s:o,n:function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}},e:function(e){throw e},f:o}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var a,i=!0,u=!1;return{s:function(){r=r.call(e)},n:function(){var e=r.next();return i=e.done,e},e:function(e){u=!0,a=e},f:function(){try{i||null==r.return||r.return()}finally{if(u)throw a}}}}(v.split(","));try{for(E.s();!(w=E.n()).done;){var P=w.value;b(this._trace(h(P,y),t,r,o,a,i,!0))}}catch(e){E.e(e)}finally{E.f()}}else!c&&t&&d.call(t,v)&&b(this._trace(y,t[v],p(r,v),t,v,i,u,!0))}if(this._hasParentSelector)for(var S=0;S<g.length;S++){var T=g[S];if(T&&T.isParentSelector){var j=this._trace(T.expr,t,T.path,o,a,i,u);if(Array.isArray(j)){g[S]=j[0];for(var _=j.length,x=1;x<_;x++)S++,g.splice(S,0,j[x])}else g[S]=j}}return g},y.prototype._walk=function(e,t,r,o,a,i,u,c){if(Array.isArray(r))for(var s=r.length,l=0;l<s;l++)c(l,e,t,r,o,a,i,u);else r&&"object"===n(r)&&Object.keys(r).forEach((function(n){c(n,e,t,r,o,a,i,u)}))},y.prototype._slice=function(e,t,r,n,o,a,i){if(Array.isArray(r)){var u=r.length,c=e.split(":"),s=c[2]&&Number.parseInt(c[2])||1,l=c[0]&&Number.parseInt(c[0])||0,f=c[1]&&Number.parseInt(c[1])||u;l=l<0?Math.max(0,l+u):Math.min(u,l),f=f<0?Math.max(0,f+u):Math.min(u,f);for(var d=[],p=l;p<f;p+=s)this._trace(h(p,t),r,n,o,a,i,!0).forEach((function(e){d.push(e)}));return d}},y.prototype._eval=function(e,t,r,n,o,a){e.includes("@parentProperty")&&(this.currSandbox._$_parentProperty=a,e=e.replace(/@parentProperty/g,"_$_parentProperty")),e.includes("@parent")&&(this.currSandbox._$_parent=o,e=e.replace(/@parent/g,"_$_parent")),e.includes("@property")&&(this.currSandbox._$_property=r,e=e.replace(/@property/g,"_$_property")),e.includes("@path")&&(this.currSandbox._$_path=y.toPathString(n.concat([r])),e=e.replace(/@path/g,"_$_path")),e.includes("@root")&&(this.currSandbox._$_root=this.json,e=e.replace(/@root/g,"_$_root")),/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/.test(e)&&(this.currSandbox._$_v=t,e=e.replace(/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/g,"_$_v$1"));try{return this.vm.runInNewContext(e,this.currSandbox)}catch(t){throw console.log(t),new Error("jsonPath: "+t.message+": "+e)}},y.cache={},y.toPathString=function(e){for(var t=e,r=t.length,n="$",o=1;o<r;o++)/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(t[o])||(n+=/^[\*0-9]+$/.test(t[o])?"["+t[o]+"]":"['"+t[o]+"']");return n},y.toPointer=function(e){for(var t=e,r=t.length,n="",o=1;o<r;o++)/^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(t[o])||(n+="/"+t[o].toString().replace(/~/g,"~0").replace(/\//g,"~1"));return n},y.toPathArray=function(e){var t=y.cache;if(t[e])return t[e].concat();var r=[],n=e.replace(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/g,";$&;").replace(/['\[](\??\((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\))['\]]/g,(function(e,t){return"[#"+(r.push(t)-1)+"]"})).replace(/\[["']((?:(?!['\]])[\s\S])*)["']\]/g,(function(e,t){return"['"+t.replace(/\./g,"%@%").replace(/~/g,"%%@@%%")+"']"})).replace(/~/g,";~;").replace(/["']?\.["']?(?!(?:(?!\[)[\s\S])*\])|\[["']?/g,";").replace(/%@%/g,".").replace(/%%@@%%/g,"~").replace(/(?:;)?(\^+)(?:;)?/g,(function(e,t){return";"+t.split("").join(";")+";"})).replace(/;;;|;;/g,";..;").replace(/;$|'?\]|'$/g,"").split(";").map((function(e){var t=e.match(/#([0-9]+)/);return t&&t[1]?r[t[1]]:e}));return t[e]=n,t[e].concat()},y.prototype.vm={runInNewContext:function(e,t){var r=Object.keys(t),n=[];!function(e,r,n){for(var o=e.length,a=0;a<o;a++)i=e[a],"function"==typeof t[i]&&r.push(e.splice(a--,1)[0]);var i}(r,n);var o=r.map((function(e,r){return t[e]})),a=n.reduce((function(e,r){var n=t[r].toString();return/function/.test(n)||(n="function "+n),"var "+r+"="+n+";"+e}),"");/(["'])use strict\1/.test(e=a+e)||r.includes("arguments")||(e="var arguments = undefined;"+e);var i=(e=e.replace(/;[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/,"")).lastIndexOf(";"),c=i>-1?e.slice(0,i+1)+" return "+e.slice(i+1):" return "+e;return u(Function,s(r).concat([c])).apply(void 0,s(o))}}}},t={};function r(n){var o=t[n];if(void 0!==o)return o.exports;var a=t[n]={exports:{}};return e[n].call(a.exports,a,a.exports,r),a.exports}r.d=function(e,t){for(var n in t)r.o(t,n)&&!r.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},r.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var n=r(8193);OktaAuth=n}();
//# sourceMappingURL=okta-auth-js.min.js.map

(function(k){function d(){var a=!1,b;this.settings={appendHelpButton:!0,displayHelpButton:!0,isExternalPage:!0,devMode:!1,targetElement:document.body,elementForOnlineDisplay:void 0,elementForOfflineDisplay:void 0,defaultMinimizedText:"",disabledMinimizedText:"",defaultAssistiveText:"",loadingText:"Loading",showIcon:void 0,enabledFeatures:[],entryFeature:"FieldService",storageDomain:document.domain,language:void 0,linkAction:{feature:void 0,name:void 0,valid:!1},linkActionParameters:{},useCustomAuthentication:!1,
allowGuestUsers:!1,requireSLDS:!1};this.auth={};this.validLinkActions={};this.isMasterAndHasSlaves=!1;Object.defineProperty(this.auth,"oauthToken",{get:function(){return b},set:function(c){this.validateHeaderValue(c)?(b=c)?(this.setSessionData("ESW_OAUTH_TOKEN",c),this.checkAuthentication()):this.deleteSessionData("ESW_OAUTH_TOKEN"):this.error('"'+c+'" is not a valid OAuth token.')}.bind(this)});this.featureScripts={};this.storedEventHandlers={};this.messageHandlers={};this.storageKeys=["ESW_BODY_SCROLL_POSITION",
"ESW_IS_MINIMIZED","ESW_MINIMIZED_TEXT","ESW_OAUTH_TOKEN"];this.defaultSettings={};this.snippetSettingsFile={};this.eswFrame=void 0;this.availableFeatures=["script","session"];this.outboundMessagesAwaitingIframeLoad=[];this.pendingMessages={};this.iframeScriptsToLoad=[];this.isAuthenticationRequired=this.isIframeReady=this.hasSessionDataLoaded=this.componentInitInProgress=this.domInitInProgress=!1;this.loginPendingSerializedData=void 0;Object.defineProperty(this,"isButtonDisabled",{get:function(){return a},
set:function(c){a=c;this.onButtonStatusChange()}.bind(this),configurable:!0});this.setupMessageListener();this.getLinkActionData()}var l=[".salesforce.com",".force.com",".sfdc.net"];d.prototype.getLightningOutParamsObj=function(){var a={};embedded_svc.config&&embedded_svc.config.additionalSettings&&embedded_svc.config.additionalSettings.labelsLanguage?a={guestUserLang:embedded_svc.config.additionalSettings.labelsLanguage}:embedded_svc.settings.language&&""!==embedded_svc.settings.language.trim()&&
(a={guestUserLang:embedded_svc.settings.language});a.eswConfigDeveloperName=embedded_svc.settings.eswConfigDevName;return a};d.prototype.adjustCommunityStorageDomain=function(){this.isCommunityDomain(this.settings.storageDomain)&&this.settings.storageDomain===document.domain&&(this.settings.storageDomain=this.settings.storageDomain+"/"+window.location.pathname.split("/")[1])};d.prototype.loadLightningOutScripts=function(a){if("function"!==typeof Promise)this.loadScriptFromDirectory("common","promisepolyfill",
function(){return this.loadLightningOutScripts(a)}.bind(this),!0);else return new Promise(function(b,c){try{var e=a&&a.baseCoreURL?a.baseCoreURL:embedded_svc.settings.baseCoreURL;if(window.$Lightning)b("Lightning Out is already loaded on this page.");else if(embedded_svc.utils.isCommunityOrSite())b("Communities context does not require Lightning Out to use Embedded Service.");else if(e){var f=document.createElement("script");f.type="text/javascript";f.src=e+"/lightning/lightning.out.js";f.onload=
function(){b("Lightning Out scripts loaded.")};document.getElementsByTagName("head")[0].appendChild(f)}}catch(h){c(h)}})};d.prototype.instantiateLightningOutApplication=function(a){if("function"!==typeof Promise)this.loadScriptFromDirectory("common","promisepolyfill",function(){return this.instantiateLightningOutApplication(a)}.bind(this),!0);else return new Promise(function(b,c){try{var e=a&&a.communityEndpointURL?a.communityEndpointURL:embedded_svc.settings.communityEndpointURL;var f=a&&a.oauthToken?
a.oauthToken:embedded_svc.settings.oauthToken;var h=a&&a.paramsObj?a.paramsObj:embedded_svc.getLightningOutParamsObj()||void 0;embedded_svc.utils.isCommunityOrSite()?b("Communities context already has an Aura context."):window.$Lightning&&$Lightning.use("embeddedService:sidebarApp",function(){b("Lightning Out application request complete.")},e,f,h)}catch(g){c(g)}})};d.prototype.createEmbeddedServiceComponent=function(a){if("function"!==typeof Promise)this.loadScriptFromDirectory("common","promisepolyfill",
function(){return this.createEmbeddedServiceComponent(a)}.bind(this),!0);else return new Promise(function(b,c){var e=a&&a.chatAPISettings?embedded_svc.validateStartChatAttributes(a.chatAPISettings):{};try{var f=a&&a.attributes?a.attributes:{configurationData:embedded_svc.settings,chatAPISettings:e};var h=a&&a.locator?a.locator:embedded_svc.settings.targetElement;embedded_svc.preparePageForSidebar();window.$Lightning&&!document.querySelector(".embeddedServiceSidebar")?$Lightning.ready($Lightning.createComponent.bind(this,
"embeddedService:sidebar",f,h,function(g,m,n){"SUCCESS"===m?embedded_svc.utils.addEventHandler("afterInitialization",function(){b("Embedded Service component created.")}):c(n)})):embedded_svc.utils.isCommunityOrSite()?window.dispatchEvent(new CustomEvent("embeddedServiceCreateSidebar",{detail:{componentAttributes:f,resolve:b,reject:c}})):"undefined"===typeof window.$Lightning?b("Lightning Out should be loaded on this page before creating the Embedded Service component."):b("Embedded Service component already exists.")}catch(g){c(g)}})};
d.prototype.bootstrapEmbeddedService=function(a){if("function"!==typeof Promise)this.loadScriptFromDirectory("common","promisepolyfill",function(){return embedded_svc.bootstrapEmbeddedService(a)},!0);else return new Promise(function(b,c){try{embedded_svc.loadLightningOutScripts(a).then(function(){embedded_svc.instantiateLightningOutApplication(a).then(function(){embedded_svc.createEmbeddedServiceComponent(a).then(function(){window.requestAnimationFrame(function(){embedded_svc.hideHelpButton();b("Embedded Service application and component bootstrapped.")})})})})}catch(e){c(e)}})};
d.prototype.validateStartChatAttributes=function(a){var b=(a=a?a:{})&&a.prepopulatedPrechatFields?a.prepopulatedPrechatFields:{},c=a&&a.extraPrechatInfo?a.extraPrechatInfo:[],e=a&&a.extraPrechatFormDetails?a.extraPrechatFormDetails:[],f=a&&a.fallbackRouting?a.fallbackRouting:[],h=a&&a.directToButtonRouting?a.directToButtonRouting:void 0,g={buttonId:a&&a.buttonId?a.buttonId:void 0,userId:a&&a.userId?a.userId:void 0,fallback:a&&"boolean"===typeof a.fallback?a.fallback:void 0};if("object"===typeof b)a.prepopulatedPrechatFields=
b;else throw Error("Validation failed for prepopulatedPrechatFields, received: "+b);if(Array.isArray(e))a.extraPrechatFormDetails=e;else throw Error("Validation failed for extraPrechatFormDetails, received: "+e);if(Array.isArray(c))a.extraPrechatInfo=c;else throw Error("Validation failed for extraPrechatInfo, received: "+c);if(Array.isArray(f))a.fallbackRouting=f;else throw Error("Validation failed for fallbackRouting, received: "+f);"function"===typeof h?a.directToButtonRouting=h:embedded_svc.log("Did not receive an actionable parameter for directToButtonRouting, received: "+
h);if("object"===typeof g)if(a.directToAgentRouting=g,g.buttonId)if("string"===typeof g.buttonId&&g.buttonId.trim().length)a.directToAgentRouting.buttonId=g.buttonId.trim(),a.directToAgentRouting.fallback=g.fallback,g.userId&&("string"===typeof g.userId&&g.userId.trim().length?a.directToAgentRouting.userId=g.userId.trim():embedded_svc.log("Did not receive an actionable parameter for directToAgentRouting's userId, received: "+g.userId));else throw Error("Validation failed for directToAgentRouting's buttonId, received: "+
g.buttonId);else embedded_svc.log("Did not receive an actionable parameter for directToAgentRouting's buttonId, received: "+g.buttonId);else throw Error("Validation failed for directToAgentRouting, received: "+g);return a};d.prototype.isInternetExplorer=function(){return"ActiveXObject"in window};d.prototype.outputToConsole=function(a,b,c){if((c||this.settings.devMode)&&console&&console[a])console[a]("[Snap-ins] "+(Array.isArray(b)?b.join(", "):b))};d.prototype.log=function(){this.outputToConsole("log",
[].slice.apply(arguments))};d.prototype.error=function(a,b){a?this.outputToConsole("error",a,b):this.outputToConsole("error","esw responed with an unspecified error.",b);embedded_svc.utils.fireEvent("error")};d.prototype.warning=function(a,b){a?this.outputToConsole("warn","Warning: "+a,b):this.outputToConsole("warn","esw sent an anonymous warning.",b)};d.prototype.deprecated=function(a){this.warning(a+" is deprecated in version "+Number("5.0").toFixed(1)+" and will be removed in version "+(Number("5.0")+
1).toFixed(1))};d.prototype.getCookie=function(a){var b=document.cookie;if(b){var c=b.indexOf(a+"=");if(-1!==c)return c+=(a+"=").length,a=b.indexOf(";",c),-1===a&&(a=b.length),b.substring(c,a)}};d.prototype.setCookie=function(a,b,c){a=a+"="+b+";";c&&(c=new Date,c.setFullYear(c.getFullYear()+10),a+="expires="+c.toUTCString()+";");document.cookie=a+"path=/;"};d.prototype.mergeSettings=function(a){Object.keys(a).forEach(function(b){void 0===this.settings[b]&&(this.settings[b]=a[b])}.bind(this))};d.prototype.loadFeatureScript=
function(a,b){var c=decodeURI(a).toLowerCase();-1===a.indexOf("..")?this.loadScriptFromDirectory("client",c+".esw",function(){this.featureScripts[a](this);this.availableFeatures.push(c);embedded_svc.utils.fireEvent("featureLoaded",void 0,a);b&&b();this.processPendingMessages(c)}.bind(this)):this.error('"'+a+'" is not a valid feature name.')};d.prototype.fireEvent=function(a,b){var c=[].slice.apply(arguments).slice(2);if(window.embedded_svc&&embedded_svc.utils)return embedded_svc.utils.fireEvent(a,
b,c);this.error("fireEvent should not be called before calling init!");return!0};d.prototype.isValidEntityId=function(a){return"string"===typeof a&&(18===a.length||15===a.length)};d.prototype.getKeyPrefix=function(a){if(this.isValidEntityId(a))return a.substr(0,3)};d.prototype.isOrganizationId=function(a){return"00D"===this.getKeyPrefix(a)};d.prototype.getESWFrame=function(){var a=document.getElementById("esw_storage_iframe");!this.eswFrame&&a&&(this.eswFrame=a.contentWindow);return this.eswFrame};
d.prototype.isFrameStorageEnabled=function(){this.deprecated("isFrameStorageEnabled");return!0};d.prototype.processPendingMessages=function(a){this.pendingMessages[a]&&(this.pendingMessages[a].forEach(function(b){this.handleMessage(b.payload)}.bind(this)),this.pendingMessages[a]=void 0)};d.prototype.loadCSS=function(){var a=document.createElement("link");a.href=(this.settings.gslbBaseURL?this.settings.gslbBaseURL:this.settings.baseCoreURL)+"/embeddedservice/"+this.settings.releaseVersion+"/esw"+(this.settings.devMode?
"":".min")+".css";a.type="text/css";a.rel="stylesheet";document.getElementsByTagName("head")[0].appendChild(a)};d.prototype.appendHelpButton=function(a){var b=document.createElement("div"),c="";b.className="embeddedServiceHelpButton";this.isLanguageRtl(this.settings.language)&&this.isDesktop()&&(c='dir="rtl"');b.innerHTML='<div class="helpButton"'+c+'><button class="helpButtonEnabled uiButton" href="javascript:void(0)"><span class="embeddedServiceIcon" aria-hidden="true" data-icon="&#59648;"></span><span class="helpButtonLabel" id="helpButtonSpan" aria-live="polite" aria-atomic="true"><span class="assistiveText">'+
(this.settings.defaultAssistiveText||"")+'</span><span class="message"></span></span></button></div>';a||(b.style.display="none");this.settings.targetElement.appendChild(b);this.setHelpButtonText(this.settings.defaultMinimizedText);"ontouchstart"in document.documentElement&&[].slice.apply(document.querySelectorAll(".embeddedServiceHelpButton .uiButton")).forEach(function(e){e.classList.add("no-hover")});this.onButtonStatusChange()};d.prototype.appendIFrame=function(){var a=document.createElement("iframe"),
b={};a.id="esw_storage_iframe";a.src=this.settings.iframeURL;a.style.display="none";a.onload=function(){var c=this.getESWFrame();this.isIframeReady=!0;this.outboundMessagesAwaitingIframeLoad.forEach(function(e){c.postMessage(e,this.settings.iframeURL)}.bind(this));this.outboundMessagesAwaitingIframeLoad=[];this.iframeScriptsToLoad.forEach(function(e){this.loadStorageScript(e)}.bind(this));b.deploymentId=this.settings.deploymentId;b.isSamePageNavigation=this.isSamePageNavigation();b.isRefresh=1===
window.performance.navigation.type;this.postMessage("session.updateStorage",b);this.iframeScriptsToLoad=[]}.bind(this);this.settings.targetElement.appendChild(a);window.addEventListener("beforeunload",function(c){this.isInternetExplorer()&&(a.src="about:blank");if(this.isMasterAndHasSlaves)if(embedded_svc.utils.fireEvent("snapinsCloseSessionWarning"),this.settings.closeSessionWarning&&"function"===typeof this.settings.closeSessionWarning)this.settings.closeSessionWarning();else return(c||window.event).returnValue=
"You might lose the active chat session if you close this tab. Are you sure?";this.settings.__synchronous_decrement_tab||this.postMessage("chasitor.decrementActiveChatSession",this.settings.deploymentId)}.bind(this),!1)};d.prototype.preparePageForSidebar=function(){document.getElementById("snapins_invite")&&embedded_svc.inviteAPI&&embedded_svc.inviteAPI.inviteButton.setOnlineState(!1);embedded_svc.utils.fireEvent("beforeCreate");Object.keys(this.settings).forEach(function(a){}.bind(this));this.mergeSettings(this.defaultSettings)};
d.prototype.createLightningComponent=function(a){this.preparePageForSidebar();this.createEmbeddedServiceComponent({attributes:{configurationData:this.settings,serializedSessionData:a},locator:this.settings.targetElement}).then(function(){this.hideHelpButton();this.componentInitInProgress=!1;this.setHelpButtonText(this.settings.defaultMinimizedText);embedded_svc.utils.fireEvent("ready")}.bind(this))};d.prototype.loadLightningApp=function(a){var b;if(this.settings.isExternalPage&&"string"!==typeof this.settings.communityEndpointURL)throw Error("communityEndpointURL String property not set");
if(b=document.getElementsByClassName("helpButton")[0]){var c=b.getBoundingClientRect().width;0<c&&(b.style.width=c+"px")}this.setHelpButtonText(this.settings.loadingText,!1);this.instantiateLightningOutApplication({communityEndpointURL:this.settings.communityEndpointURL,oauthToken:this.auth.oauthToken}).then(this.createLightningComponent.bind(this,a))};d.prototype.initLightningOut=function(a){this.hasSessionDataLoaded&&("function"!==typeof Promise?this.loadScriptFromDirectory("common","promisepolyfill",
function(){this.initLightningOut(a)}.bind(this),!0):this.loadLightningOutScripts().then(this.loadLightningApp.bind(this,a)))};d.prototype.setHelpButtonText=function(a,b){var c=void 0===this.settings.showIcon?!0:this.settings.showIcon;b=void 0===b?c:b;c=document.getElementById("helpButtonSpan");if(c){var e=c.querySelector(".message");e.innerHTML=a;if(a=c.parentElement.querySelector(".embeddedServiceIcon"))a.style.display=b?"inline-block":"none"}};d.prototype.prepareDOM=function(){this.domInitInProgress||
(this.domInitInProgress=!0,this.appendIFrame())};d.prototype.addSessionHandlers=function(){this.addMessageHandler("session.onLoad",function(){this.postMessage("session.get",this.storageKeys)}.bind(this));this.addMessageHandler("session.sessionData",function(a){this.resumeInitWithSessionData(a)}.bind(this));this.addMessageHandler("session.deletedSessionData",function(a){-1<a.indexOf("CHASITOR_SERIALIZED_KEY")&&(this.loginPendingSerializedData=void 0)}.bind(this));this.addMessageHandler("session.updateMaster",
function(a){a&&(a.isMaster?sessionStorage.setItem(this.settings.storageDomain+"MASTER_DEPLOYMENT_ID",this.settings.deploymentId):sessionStorage.removeItem(this.settings.storageDomain+"MASTER_DEPLOYMENT_ID"),this.isMasterAndHasSlaves=1<a.activeChatSessions&&a.isMaster,embedded_svc&&embedded_svc.liveAgentAPI&&(embedded_svc.liveAgentAPI.browserSessionInfo=a))}.bind(this))};d.prototype.addMetaTag=function(a,b){var c=document.createElement("meta");c.name=a;c.content=b;document.head.appendChild(c)};d.prototype.init=
function(a,b,c,e,f,h){this.settings.baseCoreURL=a;this.settings.communityEndpointURL=b;this.settings.gslbBaseURL=c?c:a;this.settings.orgId=e;this.settings.releaseVersion="5.0";this.settings.eswConfigDevName=f;this.mergeSettings(h||{});this.adjustCommunityStorageDomain();if("string"!==typeof this.settings.baseCoreURL)throw Error("Base core URL value must be a string.");if(!this.isOrganizationId(this.settings.orgId))throw Error("Invalid OrganizationId Parameter Value: "+this.settings.orgId);embedded_svc.utils?
this.finishInit():this.loadScriptFromDirectory("utils","common",this.finishInit.bind(this))};d.prototype.finishInit=function(){this.storedEventHandlers&&(Object.getOwnPropertyNames(this.storedEventHandlers).forEach(function(a){this.storedEventHandlers[a].forEach(function(b){embedded_svc.utils.addEventHandler(a,b)})}.bind(this)),this.storedEventHandlers={});if(!embedded_svc.utils.fireEvent("validateInit",function(a){return-1!==a.indexOf(!1)},this.settings)){this.checkForNativeFunctionOverrides();this.settings.appendHelpButton&&
this.loadCSS();if(!this.settings.targetElement)throw Error("No targetElement specified");this.settings.iframeURL=this.settings.gslbBaseURL+"/embeddedservice/"+this.settings.releaseVersion+(this.settings.devMode?"/eswDev.html":"/esw.html")+"?parent="+document.location.href;this.addSessionHandlers();this.loadFeatures(this.onFeatureScriptsLoaded.bind(this));embedded_svc.utils.fireEvent("afterInit",void 0,this.settings)}};d.prototype.onFeatureScriptsLoaded=function(){"complete"===document.readyState?
setTimeout(this.prepareDOM.bind(this),1):document.addEventListener?(document.addEventListener("DOMContentLoaded",this.prepareDOM.bind(this),!1),window.addEventListener("load",this.prepareDOM.bind(this),!1)):window.attachEvent?window.attachEvent("onload",this.prepareDOM.bind(this)):this.log("No available event model. Exiting.")};d.prototype.checkForNativeFunctionOverrides=function(){[{name:"document",object:document,functions:"addEventListener createAttribute createComment createDocumentFragment createElementNS createTextNode createRange getElementById getElementsByTagName getElementsByClassName querySelector querySelectorAll removeEventListener".split(" ")},
{name:"window",object:window,functions:"addEventListener clearTimeout dispatchEvent open removeEventListener requestAnimationFrame setInterval setTimeout".split(" ")}].forEach(function(a){a.functions.forEach(function(b){b in a.object&&!this.isNativeFunction(a.object,b)&&this.warning("Embedded Service Chat may not function correctly with this native JS function modified: "+a.name+"."+b,!0)}.bind(this))}.bind(this))};d.prototype.isNativeFunction=function(a,b){return Function.prototype.toString.call(a[b]).match(/\[native code\]/)};
d.prototype.onHelpButtonClick=function(){if(!this.componentInitInProgress&&!document.getElementsByClassName("embeddedServiceSidebar").length){this.componentInitInProgress=!0;try{embedded_svc.utils.isCommunityOrSite()&&0<Object.keys(embedded_svc.liveAgentAPI.inviteButton).length?window.dispatchEvent(new CustomEvent("onStartChatFromInvitation"),{detail:{bubbles:!0,composed:!1}}):(this.checkAuthentication(),embedded_svc.utils.fireEvent("onHelpButtonClick"))}catch(a){throw this.componentInitInProgress=
!1,a;}}};d.prototype.resumeInitWithSessionData=function(a){var b=embedded_svc.utils.fireEvent("sessionDataRetrieved",function(f){return-1!==f.indexOf(!0)},a),c=!1,e=!1;this.settings.linkAction.valid?c=!0:b?(this.log("Existing session found. Continuing with data: "+a),e=c=!0,embedded_svc.menu&&embedded_svc.menu.hideTopContainer()):this.componentInitInProgress&&(c=!0);this.hasSessionDataLoaded=!0;a.ESW_OAUTH_TOKEN&&(this.auth.oauthToken=a.ESW_OAUTH_TOKEN);this.loginPendingSerializedData=e?a:void 0;
c&&(this.componentInitInProgress=!0,this.checkAuthentication());this.settings.appendHelpButton&&this.appendHelpButton(this.settings.displayHelpButton&&!b)};d.prototype.checkAuthentication=function(){this.isAuthenticationRequired&&!this.settings.allowGuestUsers?this.auth.oauthToken?(this.loginButtonPressed||this.componentInitInProgress)&&this.initLightningOut(this.loginPendingSerializedData):embedded_svc.utils.fireEvent("requireauth"):(this.loginButtonPressed||this.componentInitInProgress)&&this.initLightningOut(this.loginPendingSerializedData)};
d.prototype.postMessage=function(a,b){a={domain:this.settings.storageDomain,data:b,method:a};(b=this.getESWFrame())?b.postMessage(a,this.settings.iframeURL):this.outboundMessagesAwaitingIframeLoad.push(a)};d.prototype.setSessionData=function(a,b){if("object"===typeof a)var c=a;else c={},c[a]=b;this.postMessage("session.set",c)};d.prototype.deleteSessionData=function(a){a=Array.isArray(a)?a:[a];this.postMessage("session.delete",a)};d.prototype.defineFeature=function(a,b){this.featureScripts[a]=b};
d.prototype.registerStorageKeys=function(a){"string"===typeof a?this.storageKeys.push(a):a.forEach(function(b){this.storageKeys.push(b)}.bind(this))};d.prototype.addMessageHandler=function(a,b){this.messageHandlers[a]?(this.warning("Replacing an existing handler for message type "+a),this.messageHandlers[a].pop()):this.messageHandlers[a]=[];this.messageHandlers[a].push(b)};d.prototype.clearMessageHandlers=function(){Object.keys(this.messageHandlers).forEach(function(a){this.messageHandlers[a]=[]}.bind(this))};
d.prototype.loadStorageScript=function(a){this.isIframeReady?this.postMessage("script.load",a):this.iframeScriptsToLoad.push(a)};d.prototype.loadScriptFromDirectory=function(a,b,c,e){b=b.toLowerCase();var f=document.createElement("script"),h=this.settings.gslbBaseURL;f.type="text/javascript";f.src=[h,"embeddedservice",e?void 0:this.settings.releaseVersion,a,b+(this.settings.devMode?"":".min")+".js"].filter(function(g){return!!g}).join("/");c&&(f.onload=c);document.body.appendChild(f)};d.prototype.loadFeatures=
function(a){this.settings.enabledFeatures.forEach(function(b){"base"!==b&&-1===this.availableFeatures.indexOf(b.toLowerCase())&&this.loadFeatureScript(b,a)}.bind(this))};d.prototype.addEventHandler=function(a,b){window.embedded_svc&&embedded_svc.utils?embedded_svc.utils.addEventHandler(a,b):(this.storedEventHandlers[a]||(this.storedEventHandlers[a]=[]),this.storedEventHandlers[a].push(b))};d.prototype.setupMessageListener=function(){window.addEventListener("message",function(a){var b=a.data,c=a.origin.split(":")[1].replace("//",
"");b&&b.method&&embedded_svc.isMessageFromSalesforceDomain(c)&&("session.onLoad"===b.method&&-1===this.settings.iframeURL.indexOf(c)&&(c=this.settings.iframeURL.split("/")[2],a=a.origin.split("/")[2],this.settings.iframeURL=this.settings.iframeURL.replace(c,a)),a=b.method.split(".")[0].toLowerCase(),-1===this.availableFeatures.indexOf(a)?(this.pendingMessages[a]||(this.pendingMessages[a]=[]),this.pendingMessages[a].push({direction:"incoming",payload:b})):this.handleMessage(b))}.bind(this),!1)};d.prototype.handleMessage=
function(a){var b=this.messageHandlers[a.method];b?b.forEach(function(c){c(a.data)}):this.log("Unregistered method "+a.method+" received.")};d.prototype.isMessageFromSalesforceDomain=function(a){if(embedded_svc.utils.isCommunityOrSite()&&a===document.domain)return!0;var b=function(c,e){return-1!==c.indexOf(e,c.length-e.length)};return l.some(function(c){return b(a,c)})};d.prototype.isCommunityDomain=function(a){return".force.com"===a.substr(-10)};d.prototype.isSamePageNavigation=function(){var a=
document.domain;if(this.isCommunityDomain(document.domain)){var b=a+"/"+window.location.pathname.split("/")[1];b===this.settings.storageDomain&&(a=b)}return a.substr(-this.settings.storageDomain.length)===this.settings.storageDomain};d.prototype.addDefaultSetting=function(a,b){this.defaultSettings[a]=b};d.prototype.onButtonStatusChange=function(){var a=document.querySelector(".embeddedServiceHelpButton button"),b;if(embedded_svc.menu)embedded_svc.menu.onAgentAvailabilityChange();a&&(b=a.querySelector(".message"))&&
(this.isButtonDisabled?(a.onclick=function(){},a.classList.remove("helpButtonEnabled"),a.classList.add("helpButtonDisabled"),b.innerHTML=this.settings.disabledMinimizedText):(a.onclick=this.onHelpButtonClick.bind(this),a.classList.remove("helpButtonDisabled"),a.classList.add("helpButtonEnabled"),b.innerHTML=this.settings.defaultMinimizedText))};d.prototype.hideHelpButton=function(){var a=document.querySelector(".embeddedServiceHelpButton");a&&(a.style.display="none")};d.prototype.showHelpButton=function(){var a=
document.querySelector(".embeddedServiceHelpButton");a&&(a.style.display="")};d.prototype.setDefaultButtonText=function(a,b,c,e){this.settings.entryFeature===a&&(this.settings.defaultMinimizedText=this.settings.defaultMinimizedText||b,this.settings.disabledMinimizedText=this.settings.disabledMinimizedText||c,this.settings.defaultAssistiveText=this.settings.defaultAssistiveText||e||"")};d.prototype.setDefaultShowIcon=function(a,b){this.settings.entryFeature===a&&void 0===this.settings.showIcon&&(this.settings.showIcon=
b)};d.prototype.registerLinkAction=function(a,b){var c=this.settings.linkAction;this.validLinkActions[a]||(this.validLinkActions[a]=[]);-1===this.validLinkActions[a].indexOf(b)&&this.validLinkActions[a].push(b);c.feature&&c.name&&c.feature.toLowerCase()===a.toLowerCase()&&c.name.toLowerCase()===b.toLowerCase()&&(c.valid=!0,c.feature=a,this.settings.entryFeature=a)};d.prototype.setLinkAction=function(a,b,c){var e=Object.keys(this.validLinkActions).filter(function(f){return f.toLowerCase()===a.toLowerCase()})[0];
e?(this.settings.linkAction.feature=e,this.settings.linkAction.name=this.validLinkActions[e].filter(function(f){return f.toLowerCase()===b.toLowerCase()})[0],this.settings.linkAction.valid=void 0!==this.settings.linkAction.name,this.settings.linkActionParameters=c):this.settings.linkAction.valid=!1};d.prototype.getLinkActionData=function(){window.location.search.replace(/([a-zA-Z0-9._]+)=([^&\s]+)/g,function(a,b,c){a=b.toLowerCase();0===a.indexOf("snapins.")&&(a=a.replace("snapins.",""),"action"===
a?(c=c.split("."),2===c.length&&(this.settings.linkAction.feature=c[0],this.settings.linkAction.name=c[1])):this.settings.linkActionParameters[a.toLowerCase()]=c)}.bind(this))};d.prototype.requireAuthentication=function(){var a=document.createElement("script"),b=document.createElement("style"),c=document.querySelector(this.settings.loginTargetQuerySelector);this.isAuthenticationRequired=!0;if("https:"!==window.location.protocol&&!this.settings.devMode)throw this.settings.displayHelpButton=!1,Error("Snap-in authentication requires HTTPS.");
if(!this.settings.useCustomAuthentication){if(!this.settings.loginClientId||!this.settings.loginRedirectURL||!this.settings.loginTargetQuerySelector)throw Error("Authentication in Snap-ins requires these valid settings params: loginClientId, loginRedirectURL, loginTargetQuerySelector.");if(c)this.loginButtonPressed=!1,c.addEventListener("click",function(){this.loginButtonPressed=!0}.bind(this));else throw Error("loginTargetQuerySelector is not a valid DOM element.");this.addMetaTag("salesforce-community",
this.settings.communityEndpointURL);this.addMetaTag("salesforce-client-id",this.settings.loginClientId);this.addMetaTag("salesforce-redirect-uri",this.settings.loginRedirectURL);this.addMetaTag("salesforce-mode","popup");this.addMetaTag("salesforce-target",this.settings.loginTargetQuerySelector);this.addMetaTag("salesforce-login-handler","__snapinsLoginCallback");this.addMetaTag("salesforce-logout-handler","__snapinsLogoutCallback");embedded_svc.utils.addEventHandler("requireauth",function(){var e=
setInterval(function(){window.SFIDWidget&&(clearInterval(e),window.SFIDWidget.openid_response?window.__snapinsLoginCallback():window.SFIDWidget.login())},100)});embedded_svc.utils.addEventHandler("autherror",function(e){if(window.SFIDWidget){this.loginButtonPressed=!0;window.SFIDWidget.logout();var f=setInterval(function(){window.SFIDWidget.config&&(clearInterval(f),embedded_svc.utils.fireEvent("requireauth"))}.bind(this,f),100)}}.bind(this));window.__snapinsLoginCallback=function(){var e=document.querySelector(this.settings.loginTargetQuerySelector),
f=document.createElement("button");if(this.loginButtonPressed||this.componentInitInProgress)e.innerHTML="";f.className="authenticationStart";f.innerHTML=this.settings.authenticationStartLabel;f.addEventListener("click",this.onHelpButtonClick.bind(this));e.appendChild(f);this.auth.oauthToken=window.SFIDWidget.openid_response.access_token}.bind(this);window.__snapinsLogoutCallback=function(){this.auth.oauthToken=void 0;window.SFIDWidget.init()}.bind(this);document.head.appendChild(b);b.sheet.insertRule(".sfid-logout { display: none; }",
0);a.type="text/javascript";a.src=this.settings.communityEndpointURL+"/servlet/servlet.loginwidgetcontroller?type=javascript_widget"+(embedded_svc.settings.devMode?"&min=false":"");document.head.appendChild(a)}};d.prototype.requireSLDS=function(){this.settings.requireSLDS=!0;if(this.settings.targetElement===document.body){var a=document.createElement("div");a.id="esw-snapin-target";document.body.appendChild(a);this.settings.targetElement=a}this.settings.targetElement.classList.add("slds-scope");a=
document.createElement("link");a.href=(this.settings.gslbBaseURL?this.settings.gslbBaseURL:this.settings.baseCoreURL)+"/embeddedservice/"+this.settings.releaseVersion+"/esw-slds"+(this.settings.devMode?"":".min")+".css";a.type="text/css";a.rel="stylesheet";document.getElementsByTagName("head")[0].appendChild(a)};d.prototype.validateHeaderValue=function(a){return/^[0-9a-zA-Z!#$%&'*+-.^_`|~" ]*$/g.test(a)};d.prototype.isLanguageRtl=function(a){if(a&&""!==a.trim())switch(a.substring(0,2)){case "ar":case "fa":case "he":case "iw":case "ji":case "ur":case "yi":return!0;
default:return!1}};d.prototype.isDesktop=function(){return-1===navigator.userAgent.indexOf("Mobi")};window.embedded_svc=new d;Object.getOwnPropertyNames(k).forEach(function(a){var b=k[a];"object"===b?(window.embedded_svc[a]={},Object.keys(b).forEach(function(c){window.embedded_svc[a][c]=b[c]})):window.embedded_svc[a]=b})})(window.embedded_svc||{});
/*! iFrame Resizer (iframeSizer.min.js ) - v4.4.5 - 2024-07-10
 *  Desc: Force cross domain iframes to size to content.
 *  Requires: iframeResizer.contentWindow.min.js to be loaded into the target frame.
 *  Copyright: (c) 2024 David J. Bradshaw - dave@bradshaw.net
 *  License: MIT
 */
console.info(`
IFRAME-RESIZER

Iframe-Resizer 5 is now available via the following two packages:

 * @iframe-resizer/parent
 * @iframe-resizer/child

Additionally their are also new versions of iframe-resizer for React, Vue, and jQuery.

Version 5 of iframe-resizer has been extensively rewritten to use modern browser APIs, which has enabled significantly better performance and greater accuracy in the detection of content resizing events.

Please see https://iframe-resizer.com/upgrade for more details.
`),function(d){var c,l,f,a,v,z,I,x,r,u,M,i,m,k;function g(){return window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver}function F(e,n,i){e.addEventListener(n,i,!1)}function B(e,n,i){e.removeEventListener(n,i,!1)}function w(e){return z+"["+(n="Host page: "+(e=e),n=window.top!==window.self?window.parentIFrame&&window.parentIFrame.getId?window.parentIFrame.getId()+": "+e:"Nested host page: "+e:n)+"]";var n}function t(e){return M[e]?M[e].log:f}function R(e,n){o("log",e,n,t(e))}function O(e,n){o("info",e,n,t(e))}function E(e,n){o("warn",e,n,!0)}function o(e,n,i,t){!0===t&&"object"==typeof window.console&&console[e](w(n),i)}function n(e){function i(){t("Height"),t("Width"),P(function(){H(w),C(b),u("onResized",w)},w,"init")}function n(){var e=p.slice(I).split(":"),n=e[1]?parseInt(e[1],10):0,i=M[e[0]]&&M[e[0]].iframe,t=getComputedStyle(i);return{iframe:i,id:e[0],height:n+function(e){if("border-box"!==e.boxSizing)return 0;var n=e.paddingTop?parseInt(e.paddingTop,10):0,e=e.paddingBottom?parseInt(e.paddingBottom,10):0;return n+e}(t)+function(e){if("border-box"!==e.boxSizing)return 0;var n=e.borderTopWidth?parseInt(e.borderTopWidth,10):0,e=e.borderBottomWidth?parseInt(e.borderBottomWidth,10):0;return n+e}(t),width:e[2],type:e[3]}}function t(e){var n=Number(M[b]["max"+e]),i=Number(M[b]["min"+e]),e=e.toLowerCase(),t=Number(w[e]);R(b,"Checking "+e+" is in range "+i+"-"+n),t<i&&(t=i,R(b,"Set "+e+" to min value")),n<t&&(t=n,R(b,"Set "+e+" to max value")),w[e]=""+t}function o(){var t=e.origin,o=M[b]&&M[b].checkOrigin;if(o&&""+t!="null"&&!function(){if(o.constructor!==Array)return e=M[b]&&M[b].remoteHost,R(b,"Checking connection is from: "+e),t===e;var e,n=0,i=!1;for(R(b,"Checking connection is from allowed list of origins: "+o);n<o.length;n++)if(o[n]===t){i=!0;break}return i}())throw new Error("Unexpected message received from: "+t+" for "+w.iframe.id+". Message was: "+e.data+". This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.");return 1}function a(e){return p.slice(p.indexOf(":")+v+e)}function s(i,t){var e,n,o;e=function(){var e,n;A("Send Page Info","pageInfo:"+(e=document.body.getBoundingClientRect(),n=w.iframe.getBoundingClientRect(),JSON.stringify({iframeHeight:n.height,iframeWidth:n.width,clientHeight:Math.max(document.documentElement.clientHeight,window.innerHeight||0),clientWidth:Math.max(document.documentElement.clientWidth,window.innerWidth||0),offsetTop:parseInt(n.top-e.top,10),offsetLeft:parseInt(n.left-e.left,10),scrollTop:window.pageYOffset,scrollLeft:window.pageXOffset,documentHeight:document.documentElement.clientHeight,documentWidth:document.documentElement.clientWidth,windowHeight:window.innerHeight,windowWidth:window.innerWidth})),i,t)},n=32,k[o=t]||(k[o]=setTimeout(function(){k[o]=null,e()},n))}function r(e){e=e.getBoundingClientRect();return W(b),{x:Math.floor(Number(e.left)+Number(x.x)),y:Math.floor(Number(e.top)+Number(x.y))}}function d(e){var n=e?r(w.iframe):{x:0,y:0},i={x:Number(w.width)+n.x,y:Number(w.height)+n.y};R(b,"Reposition requested from iFrame (offset x:"+n.x+" y:"+n.y+")"),window.top===window.self?(x=i,c(),R(b,"--")):window.parentIFrame?window.parentIFrame["scrollTo"+(e?"Offset":"")](i.x,i.y):E(b,"Unable to scroll to requested position, window.parentIFrame not found")}function c(){!1===u("onScroll",x)?S():C(b)}function l(e){var e=e.split("#")[1]||"",n=decodeURIComponent(e),n=document.getElementById(n)||document.getElementsByName(n)[0];n?(n=r(n),R(b,"Moving to in page link (#"+e+") at x: "+n.x+" y: "+n.y),x={x:n.x,y:n.y},c(),R(b,"--")):window.top===window.self?R(b,"In page link #"+e+" not found"):window.parentIFrame?window.parentIFrame.moveToAnchor(e):R(b,"In page link #"+e+" not found and window.parentIFrame not found")}function f(e){var n,i={};i=0===Number(w.width)&&0===Number(w.height)?{x:(n=a(9).split(":"))[1],y:n[0]}:{x:w.width,y:w.height},u(e,{iframe:w.iframe,screenX:Number(i.x),screenY:Number(i.y),type:w.type})}function u(e,n){return T(b,e,n)}function m(){switch(M[b]&&M[b].firstRun&&M[b]&&(M[b].firstRun=!1),w.type){case"close":N(w.iframe);break;case"message":n=a(6),R(b,"onMessage passed: {iframe: "+w.iframe.id+", message: "+n+"}"),u("onMessage",{iframe:w.iframe,message:JSON.parse(n)}),R(b,"--");break;case"mouseenter":f("onMouseEnter");break;case"mouseleave":f("onMouseLeave");break;case"autoResize":M[b].autoResize=JSON.parse(a(9));break;case"scrollTo":d(!1);break;case"scrollToOffset":d(!0);break;case"pageInfo":s(M[b]&&M[b].iframe,b),r=b,e("Add ",F),M[r]&&(M[r].stopPageInfo=o);break;case"pageInfoStop":M[b]&&M[b].stopPageInfo&&(M[b].stopPageInfo(),delete M[b].stopPageInfo);break;case"inPageLink":l(a(9));break;case"reset":j(w);break;case"init":i(),u("onInit",w.iframe);break;default:0===Number(w.width)&&0===Number(w.height)?E("Unsupported message received ("+w.type+"), this is likely due to the iframe containing a later version of iframe-resizer than the parent page"):i()}function e(n,i){function t(){M[r]?s(M[r].iframe,r):o()}["scroll","resize"].forEach(function(e){R(r,n+e+" listener for sendPageInfo"),i(window,e,t)})}function o(){e("Remove ",B)}var r,n}var g,h,p=e.data,w={},b=null;if("[iFrameResizerChild]Ready"===p)for(var y in M)A("iFrame requested init",L(y),M[y].iframe,y);else z===(""+p).slice(0,I)&&p.slice(I).split(":")[0]in M?(w=n(),b=w.id,M[b]&&(M[b].loaded=!0),(h=w.type in{true:1,false:1,undefined:1})&&R(b,"Ignoring init message from meta parent page"),!h&&(h=!0,M[g=b]||(h=!1,E(w.type+" No settings for "+g+". Message was: "+p)),h)&&(R(b,"Received: "+p),g=!0,null===w.iframe&&(E(b,"IFrame ("+w.id+") not found"),g=!1),g&&o()&&m())):O(b,"Ignored: "+p)}function T(e,n,i){var t=null,o=null;if(M[e]){if("function"!=typeof(t=M[e][n]))throw new TypeError(n+" on iFrame["+e+"] is not a function");o=t(i)}return o}function h(e){e=e.id;delete M[e]}function N(e){var n=e.id;if(!1===T(n,"onClose",n))R(n,"Close iframe cancelled by onClose event");else{R(n,"Removing iFrame: "+n);try{e.parentNode&&e.parentNode.removeChild(e)}catch(e){E(e)}T(n,"onClosed",n),R(n,"--"),h(e),l&&(l.disconnect(),l=null)}}function W(e){null===x&&R(e,"Get page position: "+(x={x:window.pageXOffset===d?document.documentElement.scrollLeft:window.pageXOffset,y:window.pageYOffset===d?document.documentElement.scrollTop:window.pageYOffset}).x+","+x.y)}function C(e){null!==x&&(window.scrollTo(x.x,x.y),R(e,"Set page position: "+x.x+","+x.y),S())}function S(){x=null}function j(e){R(e.id,"Size reset requested by "+("init"===e.type?"host page":"iFrame")),W(e.id),P(function(){H(e),A("reset","reset",e.iframe,e.id)},e,"reset")}function H(o){function i(e){var n;function i(){Object.keys(M).forEach(function(e){function n(e){return"0px"===(M[i]&&M[i].iframe.style[e])}var i;M[i=e]&&null!==M[i].iframe.offsetParent&&(n("height")||n("width"))&&A("Visibility change","resize",M[i].iframe,i)})}function t(e){R("window","Mutation observed: "+e[0].target+" "+e[0].type),p(i,16)}!a&&"0"===o[e]&&(a=!0,R(r,"Hidden iFrame detected, creating visibility listener"),e=g())&&(n=document.querySelector("body"),new e(t).observe(n,{attributes:!0,attributeOldValue:!1,characterData:!0,characterDataOldValue:!1,childList:!0,subtree:!0}))}function e(e){var n;n=e,o.id?(o.iframe.style[n]=o[n]+"px",R(o.id,"IFrame ("+r+") "+n+" set to "+o[n]+"px")):R("undefined","messageData id not set"),i(e)}var r=o.iframe.id;M[r]&&(M[r].sizeHeight&&e("height"),M[r].sizeWidth)&&e("width")}function P(e,n,i){i!==n.type&&r&&!window.jasmine?(R(n.id,"Requesting animation frame"),r(e)):e()}function A(n,i,t,o,e){function r(){var e;t&&"contentWindow"in t&&null!==t.contentWindow?(e=M[o]&&M[o].targetOrigin,R(o,"["+n+"] Sending msg to iframe["+o+"] ("+i+") targetOrigin: "+e),t.contentWindow.postMessage(z+i,e)):E(o,"["+n+"] IFrame("+o+") not found")}function a(){e&&M[o]&&M[o].warningTimeout&&(M[o].msgTimeout=setTimeout(function(){!M[o]||M[o].loaded||s||(s=!0,E(o,"IFrame has not responded within "+M[o].warningTimeout/1e3+" seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ignored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning."))},M[o].warningTimeout))}var s=!1;o=o||t.id,M[o]&&(r(),a())}function L(e){return e+":"+M[e].bodyMarginV1+":"+M[e].sizeWidth+":"+M[e].log+":"+M[e].interval+":"+M[e].enablePublicMethods+":"+M[e].autoResize+":"+M[e].bodyMargin+":"+M[e].heightCalculationMethod+":"+M[e].bodyBackground+":"+M[e].bodyPadding+":"+M[e].tolerance+":"+M[e].inPageLinks+":"+M[e].resizeFrom+":"+M[e].widthCalculationMethod+":"+M[e].mouseEvents}function s(t,i){function e(i){var e=g();e&&(e=e,l=t.parentNode?((e=new e(function(e){e.forEach(function(e){Array.prototype.slice.call(e.removedNodes).forEach(function(e){e===t&&N(t)})})})).observe(t.parentNode,{childList:!0}),e):null),F(t,"load",function(){var e,n;A("iFrame.onload",i,t,d,!0),e=M[r]&&M[r].firstRun,n=M[r]&&M[r].heightCalculationMethod in u,!e&&n&&j({iframe:t,height:0,width:0,type:"init"})}),A("init",i,t,d,!0)}function o(e){var n=e.split("Callback");2===n.length&&(this[n="on"+n[0].charAt(0).toUpperCase()+n[0].slice(1)]=this[e],delete this[e],E(r,"Deprecated: '"+e+"' has been renamed '"+n+"'. The old method will be removed in the next major version."))}function n(e){if(e=e||{},M[r]=Object.create(null),M[r].iframe=t,M[r].firstRun=!0,M[r].remoteHost=t.src&&t.src.split("/").slice(0,3).join("/"),"object"!=typeof e)throw new TypeError("Options is not an object");Object.keys(e).forEach(o,e);var n,i=e;for(n in m)Object.prototype.hasOwnProperty.call(m,n)&&(M[r][n]=(Object.prototype.hasOwnProperty.call(i,n)?i:m)[n]);M[r]&&(M[r].targetOrigin=!0!==M[r].checkOrigin||""===(e=M[r].remoteHost)||null!==e.match(/^(about:blank|javascript:|file:\/\/)/)?"*":e)}var r=function(e){if("string"!=typeof e)throw new TypeError("Invaild id for iFrame. Expected String");var n;return""===e&&(t.id=(n=i&&i.id||m.id+c++,null!==document.getElementById(n)&&(n+=c++),e=n),f=(i||{}).log,R(e,"Added missing iframe ID: "+e+" ("+t.src+")")),e}(t.id);if(r in M&&"iFrameResizer"in t)E(r,"Ignored iFrame, already setup.");else{switch(n(i),R(r,"IFrame scrolling "+(M[r]&&M[r].scrolling?"enabled":"disabled")+" for "+r),t.style.overflow=!1===(M[r]&&M[r].scrolling)?"hidden":"auto",M[r]&&M[r].scrolling){case"omit":break;case!0:t.scrolling="yes";break;case!1:t.scrolling="no";break;default:t.scrolling=M[r]?M[r].scrolling:"no"}s("Height"),s("Width"),a("maxHeight"),a("minHeight"),a("maxWidth"),a("minWidth"),"number"!=typeof(M[r]&&M[r].bodyMargin)&&"0"!==(M[r]&&M[r].bodyMargin)||(M[r].bodyMarginV1=M[r].bodyMargin,M[r].bodyMargin=M[r].bodyMargin+"px"),e(L(r)),M[r]&&(M[r].iframe.iFrameResizer={close:N.bind(null,M[r].iframe),removeListeners:h.bind(null,M[r].iframe),resize:A.bind(null,"Window resize","resize",M[r].iframe),moveToAnchor:function(e){A("Move to anchor","moveToAnchor:"+e,M[r].iframe,r)},sendMessage:function(e){A("Send Message","message:"+(e=JSON.stringify(e)),M[r].iframe,r)}})}function a(e){var n=M[r][e];1/0!==n&&0!==n&&(t.style[e]="number"==typeof n?n+"px":n,R(r,"Set "+e+" = "+t.style[e]))}function s(e){if(M[r]["min"+e]>M[r]["max"+e])throw new Error("Value for min"+e+" can not be greater than max"+e)}}function p(e,n){null===i&&(i=setTimeout(function(){i=null,e()},n))}function b(){"hidden"!==document.visibilityState&&(R("document","Trigger event: Visibility change"),p(function(){y("Tab Visible","resize")},16))}function y(i,t){Object.keys(M).forEach(function(e){var n;M[n=e]&&"parent"===M[n].resizeFrom&&M[n].autoResize&&!M[n].firstRun&&A(i,t,M[e].iframe,e)})}function q(){F(window,"message",n),F(window,"resize",function(){var e;R("window","Trigger event: "+(e="resize")),p(function(){y("Window "+e,"resize")},16)}),F(document,"visibilitychange",b),F(document,"-webkit-visibilitychange",b)}function e(){function t(e,n){if(n){if(!n.tagName)throw new TypeError("Object is not a valid DOM element");if("IFRAME"!==n.tagName.toUpperCase())throw new TypeError("Expected <IFRAME> tag, found <"+n.tagName+">");s(n,e),o.push(n)}}for(var o,e=["moz","webkit","o","ms"],n=0;n<e.length&&!r;n+=1)r=window[e[n]+"RequestAnimationFrame"];return r?r=r.bind(window):R("setup","RequestAnimationFrame not supported"),q(),function(e,n){var i;switch(o=[],(i=e)&&i.enablePublicMethods&&E("enablePublicMethods option has been removed, public methods are now always available in the iFrame"),typeof n){case"undefined":case"string":Array.prototype.forEach.call(document.querySelectorAll(n||"iframe"),t.bind(d,e));break;case"object":t(e,n);break;default:throw new TypeError("Unexpected data type ("+typeof n+")")}return o}}function V(e){e.fn?e.fn.iFrameResize||(e.fn.iFrameResize=function(i){return this.filter("iframe").each(function(e,n){s(n,i)}).end()}):O("","Unable to bind to jQuery, it is not fully loaded.")}"undefined"!=typeof window&&(c=0,a=f=!1,v="message".length,I=(z="[iFrameSizer]").length,x=null,r=window.requestAnimationFrame,u=Object.freeze({max:1,scroll:1,bodyScroll:1,documentElementScroll:1}),M={},i=null,m=Object.freeze({autoResize:!0,bodyBackground:null,bodyMargin:null,bodyMarginV1:8,bodyPadding:null,checkOrigin:!0,inPageLinks:!1,enablePublicMethods:!0,heightCalculationMethod:"bodyOffset",id:"iFrameResizer",interval:32,license:"1jqr0si6pnt",log:!1,maxHeight:1/0,maxWidth:1/0,minHeight:0,minWidth:0,mouseEvents:!0,resizeFrom:"parent",scrolling:!1,sizeHeight:!0,sizeWidth:!1,warningTimeout:5e3,tolerance:0,widthCalculationMethod:"scroll",onClose:function(){return!0},onClosed:function(){},onInit:function(){},onMessage:function(){E("onMessage function not defined")},onMouseEnter:function(){},onMouseLeave:function(){},onResized:function(){},onScroll:function(){return!0}}),k={},window.jQuery!==d&&V(window.jQuery),"function"==typeof define&&define.amd?define([],e):"object"==typeof module&&"object"==typeof module.exports&&(module.exports=e()),window.iFrameResize=window.iFrameResize||e())}();
//# sourceMappingURL=iframeResizer.map